export default{
  "data":[
  {
    "course_name": "Legal Environment of Business",
    "dept": "ACCT",
    "num": "215",
    "desc": "Prereq: Sophomore classification\nGeneral history, structure, and principles of the US legal system. The legal system, as an agency of social control and tool for resolving disputes. The court systems, Constitution, torts, crimes, intellectual property, contracts, property rights, employment law, basic business entity law, bankruptcy, administrative agencies, environmental law and agency law.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Accounting",
    "dept": "ACCT",
    "num": "284",
    "desc": "\nIntroduction to the basic concepts and procedures of financial accounting from a user perspective. The course examines the accounting cycle, business terminology, basic control procedures, and the preparation and evaluation of financial reports, with an emphasis on financial statement analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Managerial Accounting",
    "dept": "ACCT",
    "num": "285",
    "desc": "Prereq: ACCT 284\nUnderstanding of fixed and variable costs and their role in planning, control and performance evaluation.  Examination of alternative costing methods.  Making decisions by identifying and developing relevant information.  Development of spreadsheet skills.\n",
    "credits": "3"
  },
  {
    "course_name": "The Accounting Cycle",
    "dept": "ACCT",
    "num": "301",
    "desc": "Prereq: ACCT 284\nInteractive computer-based analysis of the accounting cycle including transactions and financial statements.  Preparation of journal entries and adjusting entries and completion of the closing process.\n",
    "credits": "1"
  },
  {
    "course_name": "Business Data Streams and Issues",
    "dept": "ACCT",
    "num": "315",
    "desc": "Prereq: COM S 113, MIS 301, ACCT 284\nIdentification of open data sources and other private data sources. Develop methods of data access, collection, and sharing; develop methods to validate and standardize data sources; develop methods to assess data worthiness (risk).\n",
    "credits": "3"
  },
  {
    "course_name": "Business Law",
    "dept": "ACCT",
    "num": "316",
    "desc": "Prereq: ACCT 215\nContinuation of 215. The Uniform Commercial Code as applied to sales contracts and negotiable instruments.  Property law, wills and estates, insurance, secured transactions, corporation law, partnership law and antitrust law.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Managerial Accounting",
    "dept": "ACCT",
    "num": "383",
    "desc": "Prereq: ACCT 285 or ACCT 501; and ACCT 301\nGeneration, communication and use of information to assist management with planning, control, and decision making in manufacturing and service organizations.  Includes cost concepts and relevance to decision situations, operational and capital budgeting, and performance evaluation.  Emphasis on developing effective teamwork skills as well as spreadsheet capabilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Accounting Information Systems and Analytics",
    "dept": "ACCT",
    "num": "384",
    "desc": "Prereq: ACCT 285 or ACCT 501; ACCT 301 and MIS 301\nConcepts and procedures underlying creating, sharing, reporting, storing, and analyzing accounting data.  Information technology internal controls and audit techniques.  Trends in accounting information systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Accounting I",
    "dept": "ACCT",
    "num": "386",
    "desc": "Prereq: ACCT 285 and ACCT 301\nThe conceptual framework of financial accounting. Communication of financial information on the income and retained earnings statements, statement of cash flows, and the balance sheet. Accounting concepts relating to current and operational assets of the firm.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Accounting II",
    "dept": "ACCT",
    "num": "387",
    "desc": "Prereq: Minimum of C- in ACCT 386\nFinancial accounting and reporting practices for business entities. Generally accepted accounting principles (GAAP) relative to firm liabilities, equity, income, taxes, employee benefits, leases, accounting changes and cash flows. Discussion of current issues in financial accounting.\n",
    "credits": "3"
  },
  {
    "course_name": "Application and Communication in Managerial Accounting",
    "dept": "ACCT",
    "num": "483",
    "desc": "Prereq: ACCT 383 or ACCT 581\nBusiness simulation focusing on generation and communication of information to assist management with financial decision-making. Emphasis on developing teamwork, written communication, data visualization, and oral presentation skills.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Accounting Information Systems",
    "dept": "ACCT",
    "num": "484",
    "desc": "Prereq: ACCT 384\nAdvanced accounting information systems concepts; database design and information retrieval, internal controls within computerized accounting information systems, financial reporting in an electronic environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Federal Income Tax",
    "dept": "ACCT",
    "num": "485",
    "desc": "Prereq: Minimum of C- in ACCT 386 or ACCT 501\nIntroduction to the fundamentals of federal income taxation and concepts applicable to all tax entities. Addresses issues related to the measurement and recognition of income, deductions, gains, and losses, taxation of property transactions, and basis / cost recovery concepts. Includes coverage of tax law policy objectives, tax implications of business and investment decisions, tax versus financial reporting treatment of common business transactions, and ethical issues related to tax compliance and planning.\n",
    "credits": "3"
  },
  {
    "course_name": "Volunteer Income Tax Assistance",
    "dept": "ACCT",
    "num": "487",
    "desc": "Prereq: ACCT 285 or ACCT 501\nIntroduction to and field work in the preparation of individual income tax returns (state and federal). Basic coverage of filing and residency status, taxable income, exemptions, deductions, and credits. Tax software usage and online filing.\n",
    "credits": "1"
  },
  {
    "course_name": "Governmental and Non-profit Institution Accounting",
    "dept": "ACCT",
    "num": "488",
    "desc": "Prereq: ACCT 386\nAccounting and financial reporting principles of local and state governments, including universities, schools, and hospitals.  In addition, accounting and financial reporting of non-profit organizations will be addressed.  Financial statements of local governmental units and the university are explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Corporate Social Responsibility Reporting",
    "dept": "ACCT",
    "num": "489",
    "desc": "Prereq: ACCT 386 or ACCT 501\nTheory and practice of social and environmental reporting, the role of the corporation in society, and the mechanisms by which society might hold corporations accountable for their actions.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ACCT",
    "num": "490",
    "desc": "Prereq: ACCT 285, senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Accounting Problems",
    "dept": "ACCT",
    "num": "495",
    "desc": "Prereq: ACCT 387\nAccounting for business combinations and affiliated companies, intercompany transactions, and consolidated financial statements; Partnership accounting;  Segment and Interim Reporting;  Multinational accounting.\n",
    "credits": "3"
  },
  {
    "course_name": "Accounting in the Global Economy",
    "dept": "ACCT",
    "num": "496",
    "desc": "Prereq: ACCT 386 or ACCT 501\nFinancial reporting issues in a global environment, including introduction to International Financial Reporting Standards (IFRS) and the potential for the use of IFRS in the U.S. Accounting and managerial issues faced by multinational corporations. Technical issues such as transfer pricing, inflation accounting and taxation will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Auditing",
    "dept": "ACCT",
    "num": "497",
    "desc": "Prereq: ACCT 384, ACCT 387 and STAT 326\nThe conceptual framework of auditing. Professional ethics. External reporting concepts. Audit methodology including risk analysis, internal control, procedures for gathering evidence and the role of statistical sampling in auditing.\n",
    "credits": "3"
  },
  {
    "course_name": "Capstone in Accounting",
    "dept": "ACCT",
    "num": "498",
    "desc": "Prereq: ACCT 383, ACCT 384, ACCT 387, credit or enrollment in ACCT 485.\nIntegrative studies in accounting. Development of critical thinking, ethical reasoning, professional research and teamwork skills. Written, visual, and oral communication with corporate stakeholders.\n",
    "credits": "2"
  },
  {
    "course_name": "Financial Accounting",
    "dept": "ACCT",
    "num": "501",
    "desc": "Prereq: Enrollment in MBA program or departmental permission\nA general introduction to financial accounting information. Topics covered include the use and analysis of financial information, the regulatory environment, the role of International Financial Reporting Standards (IFRS), and the use of the internet and electronic spreadsheets as a means of accessing and analyzing financial data.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Law",
    "dept": "ACCT",
    "num": "571",
    "desc": "Prereq: Enrollment in the MRED or instructor permission.\nFundamentals of real estate finance and development from a legal perspective and in a transactional setting. Topics include land acquisition and finance, choice of entity, tax aspects, management, disposition of real property, and recent legal developments. Legal responsibilities of owners, designers, and contractors are also examined by highlighting typical contractual relationships in place throughout the design and construction process.\n",
    "credits": "3"
  },
  {
    "course_name": "Accounting for Decision Making",
    "dept": "ACCT",
    "num": "581",
    "desc": "Prereq: ACCT 501 or equivalent\nDecision analysis applied to managerial accounting issues. Generation of information for management decision making and control. Responsibility accounting and non-recurring decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Corporate Governance and Top Management",
    "dept": "ACCT",
    "num": "582",
    "desc": "Prereq: MGMT 503 or permission\nDuties, structure, and functioning of top management teams and corporate boards of directors. CEO/board tenure and succession planning, top management compensation, board committee composition, assessment of CEO and board performance, theories of corporate governance, management of the corporate strategic agenda, governance codes, international governance, and chairman/CEO duality. Case studies and contemporary issues discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Application and Communication in Managerial Accounting",
    "dept": "ACCT",
    "num": "583",
    "desc": "Prereq: ACCT 383 or ACCT 581\nBusiness simulation focusing on generation and communication of information to assist management with financial decision-making. Emphasis on developing teamwork, written communication, data visualization, and oral presentation skills.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Accounting Information Systems",
    "dept": "ACCT",
    "num": "584",
    "desc": "Prereq: ACCT 384\nAdvanced accounting information systems concepts; database design and information retrieval, internal controls within computerized accounting information systems, financial reporting in an electronic environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Taxes and Business Strategy",
    "dept": "ACCT",
    "num": "585",
    "desc": "Prereq: ACCT 485\nIntegration of concepts from accounting, finance, and economics to determine how taxes affect business decisions. Provides students with a conceptual framework for thinking about business tax planning and applies it to various common business decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Federal Taxation",
    "dept": "ACCT",
    "num": "586",
    "desc": "Prereq: ACCT 485\nAdvanced coverage of federal taxation including issues related to the taxation of corporations, partnerships, estates and trusts, and their owners. Includes coverage of rules, concepts, background, and planning opportunities related to a number of common transactions involving these entities.\n",
    "credits": "3"
  },
  {
    "course_name": "Volunteer Income Tax Assistance",
    "dept": "ACCT",
    "num": "587",
    "desc": "Prereq: ACCT 285 or ACCT 501\nIntroduction to and field work in the preparation of individual income tax returns (state and federal). Basic coverage of filing and residency status, taxable income, exemptions, deductions, and credits. Tax software usage and online filing.\n",
    "credits": "1"
  },
  {
    "course_name": "Governmental and Non-profit Institution Accounting",
    "dept": "ACCT",
    "num": "588",
    "desc": "Prereq: ACCT 386\nAccounting and financial reporting principles of local and state governments, including universities, schools, and hospitals.  In addition, accounting and financial reporting of non-profit organizations will be addressed.  Financial statements of local governmental units and the university are explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Corporate Social Responsibility Reporting",
    "dept": "ACCT",
    "num": "589",
    "desc": "Prereq: ACCT 386 or ACCT 501\nTheory and practice of social and environmental reporting, the role of the corporation in society, and the mechanisms by which society might hold corporations accountable for their actions.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "ACCT",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nFor students wishing to do individual research in a particular area of accounting.\n",
    "credits": "1"
  },
  {
    "course_name": "Fraud Examination and Prevention",
    "dept": "ACCT",
    "num": "591",
    "desc": "Prereq: ACCT 497 or ACCT 501\nPrinciples and methodology of fraud detection and deterrence. Addresses the causes and elements of fraud, asset theft, corruption, financial statement mis-representation, internal controls for fraud prevention, investigative evidence gathering, and legal aspects of fraud.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Statement Analysis",
    "dept": "ACCT",
    "num": "592",
    "desc": "Prereq: ACCT 386 or ACCT 501\nPresentation and analysis of financial statement information from the point of view of the primary users of such data: owners and creditors. Topics include the financial reporting system, the primary financial statements, effects of accounting method choice on reported financial data, and firm valuation.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Valuation",
    "dept": "ACCT",
    "num": "594",
    "desc": "Prereq: ACCT 387 or ACCT 592\nUsing financial statement analysis to value the firm. Topics covered include assessing how well a firm's financial statements reflect the economic effects of its resource management strategies and constructing proforma financial information that will serve as inputs to valuation models.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Accounting Problems",
    "dept": "ACCT",
    "num": "595",
    "desc": "Prereq: ACCT 387\nAccounting for business combinations and affiliated companies, intercompany transactions, and consolidated financial statements; Partnership accounting;  Segment and Interim Reporting;  Multinational accounting.\n",
    "credits": "3"
  },
  {
    "course_name": "Accounting in the Global Economy",
    "dept": "ACCT",
    "num": "596",
    "desc": "Prereq: ACCT 386 or ACCT 501\nFinancial reporting issues in a global environment, including introduction to International Financial Reporting Standards (IFRS) and the potential for the use of IFRS in the U.S. Accounting and managerial issues faced by multinational corporations. Technical issues such as transfer pricing, inflation accounting and taxation will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Auditing and Assurance Services",
    "dept": "ACCT",
    "num": "597",
    "desc": "Prereq: ACCT 497\nA study of advanced auditing and assurance issues. Topics include auditor independence, audit risk analysis, internal control evaluation and reporting, fraud detection, data analytic applications in auditing, audit reporting, auditors' legal liability, and non-financial information assurance.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Accounting: Theory and Contemporary Issues",
    "dept": "ACCT",
    "num": "598",
    "desc": "Prereq: ACCT 386 or ACCT 501\nTheoretical discussion of the financial accounting and reporting environment. The usefulness of financial accounting information for decision making. Current financial accounting issues, the financial accounting standard setting process,  FASB Standards Codification, and the role of the SEC in financial reporting.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "ACCT",
    "num": "599",
    "desc": "Prereq: Admission to the Master of Accounting Program\nThis course prepares students to complete their creative component project option in the Master of Accounting degree.\n",
    "credits": "2"
  },
  {
    "course_name": "Advertising Principles",
    "dept": "ADVRT",
    "num": "230",
    "desc": "\nHistorical, social, economic and legal aspects of advertising. Evaluations of advertising research, media, strategy and appeals. Study of the creation of advertising.\n",
    "credits": "3"
  },
  {
    "course_name": "Research and Strategic Planning for Advertising and Public Relations",
    "dept": "ADVRT",
    "num": "301",
    "desc": "Prereq: ADVRT 230 or P R 220\nThe use of primary and secondary research for situations, organizations and the public.  Formation and development of strategic plans for public relations and advertising students.\n",
    "credits": "3"
  },
  {
    "course_name": "Advertising Creativity",
    "dept": "ADVRT",
    "num": "334",
    "desc": "Prereq: JL MC 110; Minimum of C+ in JL MC 201; ADVRT 301/P R 301\nDevelopment and execution of creative advertising materials. Copywriting, art direction and computer applications. Creative strategy development, execution and evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Advertising Media Planning",
    "dept": "ADVRT",
    "num": "335",
    "desc": "Prereq: ADVRT/P R 301\nConcepts of media planning and selection in the development, execution and evaluation of advertising campaigns. Characteristics and capabilities of the advertising media. Utilization of market segmentation, consumer buying and media audience databases.\n",
    "credits": "3"
  },
  {
    "course_name": "Advertising Account Management",
    "dept": "ADVRT",
    "num": "336",
    "desc": "Prereq: JL MC 110; Minimum of C+ in JL MC 201; ADVRT/P R 301\nFundamentals of account management with emphasis on leadership, sales techniques, relationship building, presentation skills, and strategic thinking. Includes aspects of agency communications, team building, client management, evaluating creative concepts and media plans, and developing strategic proposals and campaign recommendations.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Skills Development",
    "dept": "ADVRT",
    "num": "390",
    "desc": "Prereq: Minimum of C+ in JL MC 201; other vary by topic. Instructor permission for non-majors.\nCheck with Greenlee School for course availability.\n",
    "credits": "1"
  },
  {
    "course_name": "Advertising Campaigns",
    "dept": "ADVRT",
    "num": "434",
    "desc": "Prereq: Minimum of C+ in ADVRT 334 or ADVRT 336, and major status\nDevelopment of advertising campaigns for business and social institutions. Projects involve budgeting, media selection, market analysis, campaign strategy and creative execution.\n",
    "credits": "3"
  },
  {
    "course_name": "Advertising Competition",
    "dept": "ADVRT",
    "num": "435",
    "desc": "Prereq: Permission of instructor, Junior/senior standing strongly recommended\nPreparation of materials for regional and national competitions.\n",
    "credits": "1"
  },
  {
    "course_name": "Advertising Portfolio Practicum",
    "dept": "ADVRT",
    "num": "436",
    "desc": "Prereq: Minimum of C+ in ADVRT 334, non-majors with instructor permission\nAdvanced advertising writing and design. Emphasis on creative strategy, problem solving and execution of creative materials in print, broadcast and online media for a variety of clients.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Communication",
    "dept": "ADVRT",
    "num": "490",
    "desc": "Prereq: Junior classification and contract with supervising professor to register\nProjects during which students may study problems associated with a medium, a professional specialization, a philosophical or practical concern, a reportorial method or writing technique, or a special topic in their field. Credit is not given for working on student or professional media without an accompanying research component.\n  No more than 3 credits of ADVRT/JLMC/PR 490 may be used toward a degree in the Greenlee School.",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics in Communication",
    "dept": "ADVRT",
    "num": "497",
    "desc": "Prereq: Junior classification. See Schedule of Classes for possible pre-requisites.\nSeminars or one-time classes on topics of relevance to students in communication.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Media Internship",
    "dept": "ADVRT",
    "num": "499",
    "desc": "Prereq: JL MC majors: JLMC 110 and minimum of C+ in JL MC 202 or JL MC 206 or P R 321; ADVRT majors: JL MC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JLMC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nRequired of all Greenlee School majors. A 400-hour (for 3 credits) internship in the student's journalism and mass communication or advertising or public relations specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Media Internship: Required",
    "dept": "ADVRT",
    "num": "499A",
    "desc": "Prereq: JL MC majors: JLMC 110 and minimum of C+ in JL MC 302 or JL MC 306; ADVRT majors: JLMC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JLMC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nInitial, required internship. A 400-hour (for 3 credits) internship in the student's specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Professional Media Internship: Optional",
    "dept": "ADVRT",
    "num": "499B",
    "desc": "Prereq: JL MC majors: JLMC 110 and minimum of C+ in JL MC 302 or JL MC 306; ADVRT majors: JLMC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JLMC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nOptional internship in the student's specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Problems With Computer Applications Laboratory",
    "dept": "AER E",
    "num": "160",
    "desc": "Prereq: MATH 143 or satisfactory scores on mathematics placement examinations; credit or enrollment in MATH 165\nSolving aerospace engineering problems and presenting solutions through technical reports. Significant figures and estimation. SI units. Graphing and curve fitting. Introduction to aerospace engineering and engineering design. Spreadsheet programs. History of aerospace. Systems thinking. Team projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Engineering Problems With Computer Applications Laboratory: Honors",
    "dept": "AER E",
    "num": "160H",
    "desc": "Prereq: MATH 143 or satisfactory scores on mathematics placement examinations; credit or enrollment in MATH 165\nSolving aerospace engineering problems and presenting solutions through technical reports. Significant figures. SI units and estimation. Graphing and curve fitting. Introduction to aerospace engineering and engineering design. Spreadsheet programs. History of aerospace. Systems thinking. Team projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical, Graphical  and Laboratory Techniques for Aerospace Engineering",
    "dept": "AER E",
    "num": "161",
    "desc": "Prereq: Credit or enrollment in AER E 160 or equivalent course\nComputer-based problem solving using Matlab(R), with emphasis on numerical methods.  Introduction to solid modeling and aerospace design using SolidWorks.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical, Graphical and Laboratory Techniques for Aerospace Engineering: Honors",
    "dept": "AER E",
    "num": "161H",
    "desc": "Prereq: AER E 160 or equivalent course\nComputer-based problem solving using Matlab(R), with emphasis on numerical methods.  Introduction to solid modeling and aerospace design using SolidWorks.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Seminar",
    "dept": "AER E",
    "num": "192",
    "desc": "\nVectors, differentiation, integration, matrices, and systems of linear equations.\n",
    "credits": "R"
  },
  {
    "course_name": "Aerospace Seminar: Honors.",
    "dept": "AER E",
    "num": "192H",
    "desc": "\nVectors, differentiation, integration, matrices, and systems of linear equations.\n",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Performance and Design",
    "dept": "AER E",
    "num": "261",
    "desc": "Prereq: MATH 166, PHYS 221, credit or enrollment in AER E 161\nAerodynamics of the airplane, lift and drag, drag polar, propulsion characteristics of turbojets and piston props, level flight, range, endurance, climbing flight, turning flight, take-off and landing, design examples.\n",
    "credits": "3"
  },
  {
    "course_name": "Scientific Balloon Engineering and Operations",
    "dept": "AER E",
    "num": "265",
    "desc": "\nEngineering aspects of scientific balloon flights. Integration of science mission objectives with engineering requirements. Operations team certification. FAA and FCC regulations, communications, and command systems. Flight path prediction and control.\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Independent Study",
    "dept": "AER E",
    "num": "290",
    "desc": "Prereq: Sophomore classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Flight ground instruction",
    "dept": "AER E",
    "num": "290A",
    "desc": "Prereq: Sophomore classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: In-flight training",
    "dept": "AER E",
    "num": "290B",
    "desc": "Prereq: AER E 301\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Other",
    "dept": "AER E",
    "num": "290C",
    "desc": "Prereq: AER E 301\n",
    "credits": "1"
  },
  {
    "course_name": "Make to Innovate I",
    "dept": "AER E",
    "num": "294",
    "desc": "Prereq: Restricted to Freshman and Sophomore classifications, Instructor permission required.\nMultidisciplinary projects to engage students in the fundamentals of engineering, project management, systems engineering, teamwork, and oral and visual communication.  Students will define and attain their team objectives and milestones that are approved by the instructor.\n  Can only be used toward graduation in these cases. To make credit deficiencies in 100 or 200 level courses. No more than 2 credits of Aer E 294X can be used to make-up credit deficiencies in 100 or 200 level courses. Cannot be used in any category or technical electives in the Aer E curriculum",
    "credits": "1"
  },
  {
    "course_name": "Flight Experience",
    "dept": "AER E",
    "num": "301",
    "desc": "Prereq: Credit or enrollment in AER E 355\nTwo hours of in-flight training and necessary ground instruction. Course content prescribed by the Aerospace Engineering  Department. Ten hours of flight training certified in a pilot log book can be considered by the course instructor as evidence of satisfactory performance in the course.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Aerodynamics I: Incompressible Flow",
    "dept": "AER E",
    "num": "310",
    "desc": "Prereq: Grade of C- or better in AER E 261 and MATH 265\nIntroduction to fluid mechanics and aerodynamics. Fluid properties and kinematics. Conservation equations in differential and integral form. Bernoulli's equation. Basic potential flow concepts and solutions. Boundary layer concept.  Incompressible flow over airfoils and wings. Examples of numerical methods. Applications of multi-variable calculus to fluid mechanics and aerodynamics.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerodynamics II: Compressible Flow",
    "dept": "AER E",
    "num": "311",
    "desc": "Prereq: AER E 310, M E 231\nReview of thermodynamics, energy equation, compressible flow, and isentropic flow. Normal and oblique shocks. Mach waves and expansion fans. Applications to ducts and nozzles. Compressible airfoil and wing theory.  Introduction to advanced compressible flow topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Flight Structures Analysis",
    "dept": "AER E",
    "num": "321",
    "desc": "Prereq: E M 324, Credit or enrollment in MATH 266 or 267\nIntroduction to elasticity, airworthiness, and flight loads. Introduction to fatigue. Materials selection for flight applications. Thin walled cross-sections under bending, torsion, and shear loads using classical methods. Shear center. Column buckling. Matrix methods of structural analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Structures Laboratory",
    "dept": "AER E",
    "num": "322",
    "desc": "Prereq: Credit or enrollment in AER E 321\nDesign of experiments. Data analysis. Strain gage installation. Measurement of stiffness/strength of aluminum. Analysis/fabrication/testing of riveted joints. Shear/bending measurements inbeam sections. Analysis/measurement of strains in frames. Buckling of columns. Stress concentration. Vibration testing of beams and plates. Fabrication/testing of composites.\n",
    "credits": "2"
  },
  {
    "course_name": "Flight Control Systems I",
    "dept": "AER E",
    "num": "331",
    "desc": "Prereq: AER E 355\nLinear system analysis. Control system designs using root-locus and frequency response methods. Applications in flight control systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerodynamics and Propulsion Laboratory",
    "dept": "AER E",
    "num": "344",
    "desc": "Prereq: AER E 310; Coreq: AER E 311\nSimilitude and dimensional analysis. Measurement uncertainty analysis. Pressure and velocity measurement methods and instruments. Pressure distribution around a circular cylinder. Aerodynamic performance of low-speed airfoils. Airfoil wake flow; Boundary layer flow. Flow visualization techniques for supersonic flows and de Laval nozzles.\n",
    "credits": "3"
  },
  {
    "course_name": "Astrodynamics I",
    "dept": "AER E",
    "num": "351",
    "desc": "Prereq: E M 345\nIntroduction to astrodynamics.  Two-body Keplerian satellite and planetary motion.  Geocentric and extraterrestrial trajectories and applications.  Ballistic missiles.\n",
    "credits": "3"
  },
  {
    "course_name": "Aircraft Flight Dynamics and Control",
    "dept": "AER E",
    "num": "355",
    "desc": "Prereq: AER E 261, MATH 267, E M 345\nAircraft rigid body equations of motion, linearization, and modal analysis. Longitudinal and lateral-directional static and dynamic stability analysis. Flight handling characteristics analysis. Longitudinal and lateral-directional open loop response to aircraft control inputs. Aircraft flight handling qualities.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Techniques for Aerospace Design",
    "dept": "AER E",
    "num": "361",
    "desc": "Prereq: AER E 310, MATH 267, E M 324, E M 345\nAdvanced programming, workstation environment, and development of computational tools for aerospace analysis and design. Technical report writing.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Systems Integration",
    "dept": "AER E",
    "num": "362",
    "desc": "Prereq: Junior standing in Aerospace Engineering or permission of instructor\nEmphasis on impact of component interfaces in aerospace systems. Understand how changes in variables associated with individual components impact the performance of the aerospace system. Specific integration challenges include: capturing implicit disciplinary interactions (e.g. structures/aerodynamics, propulsion/aerodynamics, etc.), propagating tolerances through the system (i.e. uncertainty modeling), balancing component attributes in the system objective.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Wind Energy",
    "dept": "AER E",
    "num": "381",
    "desc": "Prereq: MATH 166, PHYS 221\nBasic introduction to the fundamentals of Wind Energy and Wind Energy conversion systems. Topics include but not limited to various types of wind energy conversion systems and the aerodynamics, blade and tower structural loads, kinematics of the blades and meteorology.\n",
    "credits": "3"
  },
  {
    "course_name": "Summer Internship",
    "dept": "AER E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "AER E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services.\nProfessional work period.  One semester per academic or calendar year.  Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Aerospace Vehicle Propulsion I",
    "dept": "AER E",
    "num": "411",
    "desc": "Prereq: AER E 311, AER E 344\nAtmospheric propulsion system performance and cycle analysis. Momentum theorem, thrust and propulsive efficiency. Thermodynamics of compressible flow with heat and work addition. Components and principles of turbojets and turbofans. Rocket engines and ramjet principles.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Vehicle Propulsion II",
    "dept": "AER E",
    "num": "412",
    "desc": "Prereq: AER E 311\nElectricity and magnetism. Plasma physics. Ion engine performance. Introduction to advanced electromagnetic propulsion systems. Energy sources and nuclear propulsion. Space mission requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Experimental Mechanics",
    "dept": "AER E",
    "num": "417",
    "desc": "Prereq: E M 324; MAT E 273\nIntroduction to fundamental concepts for force, displacement, stress and strain measurements for structures and materials applications.  Strain gage theory and application.  Full field deformation measurements with laser interferometry and digital image processing.  Advanced experimental concepts at the micro- and nano-scale regimes.  Selected laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Flight Structures",
    "dept": "AER E",
    "num": "421",
    "desc": "Prereq: AER E 321, MATH 266 or MATH 267\nAnalysis of indeterminate flight structures including finite element laboratory. Static analysis of complex structural components subject to thermal and aerodynamic loads. Analytical and finite element solutions for stresses and displacements of membrane, plane stress, plate structures. Buckling of beams, frames, and plate structures. Introduction to vibration of flight structures. Steady state and transient structural response using normal modal analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Vibrations and Aeroelasticity",
    "dept": "AER E",
    "num": "422",
    "desc": "Prereq: E M 324 or AER E 321\nVibration theory. Steady and unsteady flows. Mathematical foundations of aeroelasticity, static and dynamic aeroelasticity.  Linear unsteady aerodynamics, non-steady aerodynamics of lifting surfaces. Stall flutter. Aeroelastic problems in civil engineering structures. Aeroelastic problems of rotorcraft. Experimental aeroelasticity. Selected wind tunnel laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Composite Flight Structures",
    "dept": "AER E",
    "num": "423",
    "desc": "Prereq: E M 324; MAT E 273\nFabrication, testing and analysis of composite materials used in flight structures. Basic laminate theory of beams, plates and shells. Manufacturing and machining considerations of various types of composites. Testing of composites for material properties, strength and defects. Student projects required.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Aerospace Structures",
    "dept": "AER E",
    "num": "426",
    "desc": "Prereq: E M 324\nDetailed design and analysis of aerospace vehicle structures. Material selection, strength, durability and damage tolerance, and validation analysis. Design for manufacturability.\n",
    "credits": "3"
  },
  {
    "course_name": "Flight Control Systems II",
    "dept": "AER E",
    "num": "432",
    "desc": "Prereq: AER E 331\nAircraft lateral directional stability augmentation. Launch vehicle pitch control system design. Control of flexible vehicles. Satellite attitude control. Flight control designs based on state-space methods. Introduction to sample-data systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Spacecraft Dynamics and Control",
    "dept": "AER E",
    "num": "433",
    "desc": "Prereq: EM 345\nThree-dimensional rotational kinematics and attitude dynamics of a rigid body in space.  Stability analysis of a spinning spacecraft with or without energy dissipation.  Attitude dynamics and stability of a satellite in circular orbit.  Introduction to spacecraft attitude determination and control systems (ADCS).  Simulation of spacecraft attitude-dynamics and control problems of practical interest using MATLAB.\n",
    "credits": "3"
  },
  {
    "course_name": "V/STOL Aerodynamics and Performance",
    "dept": "AER E",
    "num": "442",
    "desc": "Prereq: AER E 261\nIntroduction to the aerodynamics, performance, stability, control and critical maneuvering characteristics of V/STOL vehicles. Topics include hovercrafts, jet flaps, ducted fans and thrust vectored engines.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Fluid Dynamics",
    "dept": "AER E",
    "num": "446",
    "desc": "Prereq: AER E 311, AER E 361 and proficiency in at least one programming  language\nIntroduction to computational fluid dynamics. Discretization, consistency, and stability. Explicit and implicit methods for ordinary and partial differential equations. Linearization techniques. Iterative and direct solution algorithms. Numerical methods for parabolic, elliptic and hyperbolic equations. Curvilinear coordinates and numerical grid generation. Applications to Euler, boundary-layer and Navier-Stokes equations.\n",
    "credits": "3"
  },
  {
    "course_name": "Fluid Dynamics of Turbomachinery",
    "dept": "AER E",
    "num": "448",
    "desc": "Prereq: AER E 311 or M E 335\nApplications of principles of fluid mechanics and thermodynamics in performance analysis and design of turbomachines. Conceptual and preliminary design of axial and radial flow compressors and turbines using velocity triangles and through-flow approaches.\n",
    "credits": "3"
  },
  {
    "course_name": "Astrodynamics II",
    "dept": "AER E",
    "num": "451",
    "desc": "Prereq: AER E 351\nOrbit determination and prediction using Gibb's and Gauss' methods. Advanced orbit maneuvers, triple-, and fixed-impulse; universal variables; Kepler's problem. Earth gravity field models and gravity harmonics, orbit perturbations, advanced dynamics, variational methods, relative orbital mechanics, and Clohessy-Wiltshire equations.\n",
    "credits": "3"
  },
  {
    "course_name": "Modern Design Methodology with Aerospace Applications",
    "dept": "AER E",
    "num": "461",
    "desc": "Prereq: AER E 361, AER E 311, AER E 321, AER E 322, AER E 344, AER E 351, AER E 355\nIntroduction to modern engineering design methodology. Computational constrained optimal design approach including selection of objective function, characterization of constraint system, materials and strength considerations, and sensitivity analyses.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Aerospace Systems",
    "dept": "AER E",
    "num": "462",
    "desc": "Prereq: AER E 461\nFundamental principles used in engineering design of aircraft, missile, and space systems. Preliminary design of aerospace vehicles. Engineering Ethics.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Multidisciplinary Design Optimization",
    "dept": "AER E",
    "num": "463",
    "desc": "Prereq: senior standing in College of Engineering or permission of instructor\nIntroduction to the theory and methods of Multidisciplinary Design Optimization (MDO), including system coupling, system sensitivity methods, decomposition methods, MDO formulations (such as multi-discipline feasible (MDF), individual discipline feasible (IDF) and all-at-once (AAO) approaches, and MDO search methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Spacecraft Systems",
    "dept": "AER E",
    "num": "464",
    "desc": "Prereq: AER E 351\nAn examination of spacecraft systems including attitude determination and control, power, thermal control, communications, propulsion, guidance, navigation, command and data handling, and mechanisms. Explanation of space and operational environments as they impact spacecraft design. Includes discussion of safety, reliability, quality, maintainability, testing, cost, legal, and logistics issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "AER E",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design II",
    "dept": "AER E",
    "num": "467",
    "desc": "Prereq: Student must be within two semesters of graduation or receive permission of instructor.\nBuild and test of a conceptual design. Detail design, manufacturability, test criteria and procedures. Application of design tools such as CAD and CAM and manufacturing techniques such as rapid prototyping. Development and testing of a full-scale prototype with appropriate documentation in the form of design journals, written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Large-Scale Complex Engineered Systems (LSCES)",
    "dept": "AER E",
    "num": "468",
    "desc": "Prereq: senior standing in College of Engineering or permission of AerE 468 instructor\nIntroduction to the theoretical foundation and methods associated with the design for large-scale complex engineered systems, including objective function formation, design reliability, value-driven design, product robustness, utility theory, economic factors for the formation of a value function and complexity science as a means of detecting unintended consequences in the product behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Ultrasonic Nondestructive Evaluation",
    "dept": "AER E",
    "num": "480",
    "desc": "Prereq: E M 324, MATH 266 or MATH 267, PHYS 222\nIntroduction to stress/strain, Hooke’s law, and elastic wave propagation in two dimensions in isotropic media. Ultrasonic plane-wave reflection and transmission; and simple straight-crested guided waves. Transducer construction, behavior, and performance. Simple signal analysis and discrete signal processing. The last few weeks of the course are devoted to case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Wind Energy: Technology and Design",
    "dept": "AER E",
    "num": "481",
    "desc": "Prereq: AER E 381 or senior classification in engineering or junior in engineering with a course in fluid mechanics\nAdvanced topics in wind energy, emphasis on current practices. Theoretical foundations for horizontal and vertical axis wind turbine. Design codes for energy conversion systems design, aerodynamic and structural load estimation, wind resource characterization wind farm design, optimization.\n",
    "credits": "3"
  },
  {
    "course_name": "Aeroacoustics",
    "dept": "AER E",
    "num": "483",
    "desc": "Prereq: AER E 311 or M E 335; and MATH 266 or MATH 267\nNoise metrics, Linear wave equation and its solution in 1-, 2-, and 3-D using Green's functions. Propagation of sound in free and confined spaces. Aerodynamic noise sources in engineering machines: aircraft engine noise, airfram noise, wind turbine noise, etc.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Engineering Independent Study",
    "dept": "AER E",
    "num": "490",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aero and/or Gas Dynamics",
    "dept": "AER E",
    "num": "490A",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Propulsion",
    "dept": "AER E",
    "num": "490B",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aerospace Structures",
    "dept": "AER E",
    "num": "490C",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Flight Dynamics",
    "dept": "AER E",
    "num": "490D",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Spacecraft Systems",
    "dept": "AER E",
    "num": "490E",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Flight Control Systems",
    "dept": "AER E",
    "num": "490F",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aeroelasticity",
    "dept": "AER E",
    "num": "490G",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Independent Study, Honors",
    "dept": "AER E",
    "num": "490H",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Design",
    "dept": "AER E",
    "num": "490I",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Non-destructive Evaluation",
    "dept": "AER E",
    "num": "490J",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Wind Engineering",
    "dept": "AER E",
    "num": "490K",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Multi-functional Ultra-light Structures",
    "dept": "AER E",
    "num": "490L",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Other",
    "dept": "AER E",
    "num": "490O",
    "desc": "Prereq: Junior or senior classification, approval of the department\n",
    "credits": "1"
  },
  {
    "course_name": "Senior Project",
    "dept": "AER E",
    "num": "499",
    "desc": "Prereq: Senior classification, credit or enrollment in AER E 491\nDevelopment of aerospace principles and concepts through individual research and projects. Written report.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Engineering Analysis",
    "dept": "AER E",
    "num": "501",
    "desc": "Prereq: MATH 267 or equivalent\nLinear ordinary differential equations with variable coefficients; hyperbolic, parabolic, and elliptic equations; tensors.\n  None",
    "credits": "3"
  },
  {
    "course_name": "Wind Energy System Design",
    "dept": "AER E",
    "num": "511",
    "desc": "Prereq: WESEP 501 and WESEP 502\nAdvanced design, control, and operation of wind plants. Topics include electromechanical energy conversion systems, aerodynamic and aeroelastic loads, optimal control of wind farms, life cycle management strategies, tall tower design, and prediction of component residual life.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Mechanics of Materials",
    "dept": "AER E",
    "num": "514",
    "desc": "Prereq: E M 324\nTheory of stress and strain, stress-strain relationships. Unsymmetrical bending, curved beams, shear center. Torsion of thin-walled noncircular sections. Equilibrium, compatibility equations. Airy stress functions. Membrane stresses in shells, thick-walled cylinders.\n",
    "credits": "3"
  },
  {
    "course_name": "Experimental Mechanics",
    "dept": "AER E",
    "num": "517",
    "desc": "Prereq: E M 324; MAT E 273\nIntroduction to fundamental concepts for force, displacement, stress and strain measurements for structures and materials applications.  Strain gage theory and application.  Full field deformation measurements with laser interferometry and digital image processing.  Advanced experimental concepts at the micro- and nano-scale regimes.  Selected laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Airframe Analysis",
    "dept": "AER E",
    "num": "521",
    "desc": "Prereq: AER E 421 or E M 424\nAnalysis of static stresses and deformation in continuous aircraft structures. Various analytical and approximate methods of analysis of isotropic and anisotropic plates and shells.\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Analysis of Composite Materials",
    "dept": "AER E",
    "num": "522",
    "desc": "Prereq: E M 324\nComposite constituent materials, micro-mechanics, laminate analysis, hygro-thermal analysis, composite failure, joining of composites, design of composite beams and plates, honeycomb core, manufacturing of composites, short fiber composites, and demonstration laboratory.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical Mesh Generation",
    "dept": "AER E",
    "num": "524",
    "desc": "Prereq: MATH 385, proficiency in programming\nIntroduction to modern mesh generation techniques. Structured and unstructured mesh methods, algebraic and PDE methods, elliptic and hyperbolic methods, variational methods, error analysis, Delaunay triangulation, data structures, geometric modeling with B-spline and NURBS surfaces, surface meshing.\n",
    "credits": "3"
  },
  {
    "course_name": "Finite Element Analysis",
    "dept": "AER E",
    "num": "525",
    "desc": "Prereq: E M 425, MATH 385\nVariational and weighted residual approach to finite element equations. Emphasis on two- and three-dimensional problems in solid mechanics. Isoparametric element formulation, higher order elements, numerical integration, imposition of constraints and penalty, convergence, and other more advanced topics. Use of two- and three-dimensional computer programs. Dynamic and vibrational problems, eigenvalues, and time integration. Introduction to geometric and material nonlinearities.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Aerospace Structures",
    "dept": "AER E",
    "num": "526",
    "desc": "Prereq: E M 324\nDetailed design and analysis of aerospace vehicle structures. Material selection, strength, durability and damage tolerance, and validation analysis. Design for manufacturability.\n",
    "credits": "3"
  },
  {
    "course_name": "Automatic Control of Flight Vehicles",
    "dept": "AER E",
    "num": "531",
    "desc": "Prereq: AER E 331\nApplications of classical and modern linear control theory to automatic control of flight vehicles. Spacecraft attitude control. Control of flexible vehicles. Linear-quadratic regulator design applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Compressible Fluid Flow",
    "dept": "AER E",
    "num": "532",
    "desc": "Prereq: AER E 310, 311 or equivalent\nThermodynamics of compressible flow. Viscous and inviscid compressible flow equations. One dimensional steady flow; isentropic flow, shocks, expansions. Multidimensional compressible flow aspects. Linear and nonlinear wave analysis and method of characteristics. Subsonic, transonic, supersonic and hypersonic flows.\n",
    "credits": "3"
  },
  {
    "course_name": "Incompressible Flow Aerodynamics",
    "dept": "AER E",
    "num": "541",
    "desc": "Prereq: AER E 310 or M E 335 or equivalent\nKinematics and dynamics of fluid flow. Derivation of the Navier-Stokes, Euler and potential flow equations. Introduction to generalized curvilinear coordinates. Ideal fluids. Two-dimensional and three-dimensional potential flow. Complex variable methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Experimental Flow Mechanics and Heat Transfer",
    "dept": "AER E",
    "num": "545",
    "desc": "Prereq: AER E 310 or M E 335 or E M 378\nSimilitude and dimensional analysis. Measurement uncertainty analysis; Fluid mechanical apparatus: wind tunnel and water tunnels. Various experimental techniques widely used for fluid mechanics, aerodynamics, heat transfer, and combustion studies: Pressure gauge and transducers; Pitot tube; hot wire anemometry; Shadowgraph and Schlieren Photography; laser Doppler velocimetry; particle image velocimetry (PIV); advanced PIV techniques (stereo PIV, 3-D PIV, Tomographic PIV, Holograph PIV and microscopic PIV); laser induced fluorescence; pressure sensitive painting, temperature sensitive painting; molecular tagging velocimetry; molecular tagging thermometry. Extensive applications and laboratory experiments will be included.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Fluid Mechanics and Heat Transfer I",
    "dept": "AER E",
    "num": "546",
    "desc": "Prereq: AER E 310 or M E 335, and programming experience\nBasic concepts of discretization, consistency, and stability. Explicit and implicit methods for ordinary differential equations. Methods for each type of partial differential equation.  Iterative solution methods; curvilinear grids. Students will program basic algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Fluid Mechanics and Heat Transfer II",
    "dept": "AER E",
    "num": "547",
    "desc": "Prereq: AER E 546 or equivalent\nApplication of computational methods to current problems in fluid mechanics and heat transfer. Methods for solving the Navier-Stokes and reduced equation sets such as the Euler, boundary layer, and parabolized forms of the conservation equations. Introduction to relevant aspects of grid generation and turbulence modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Orbital Mechanics",
    "dept": "AER E",
    "num": "551",
    "desc": "Prereq: AER E 351\nReview of 2-body problem. Orbital maneuvers. Relative motion in orbit. Orbit perturbation analysis. Gravity field expansions and effects on orbiters. 3-body problem with applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Guidance and Navigation of Aerospace Vehicles",
    "dept": "AER E",
    "num": "556",
    "desc": "Prereq: AER E 331\nPrinciples of guidance systems for spacecraft, launch vehicles, homing and ballistic missiles. Optimal guidance. Interplanetary transfer guidance with low thrust. Principles of inertial navigation. Theory and applications of the Global Positioning System. Celestial navigation procedures. Application of Kalman filtering to recursive navigation theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Multidisciplinary Design Optimization",
    "dept": "AER E",
    "num": "563",
    "desc": "Prereq: senior standing in College of Engineering or permission of instructor\nIntroduction to the theory and methods of Multidisciplinary Design Optimization (MDO), including system coupling, system sensitivity methods, decomposition methods, MDO formulations (such as multi-discipline feasible (MDF), individual discipline feasible (IDF) and all-at-once (AAO) approaches, and MDO search methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Fracture and Fatigue",
    "dept": "AER E",
    "num": "564",
    "desc": "Prereq: E M 324 and either MAT E 216 or MAT E 273 or MAT E 392. Undergraduates: Permission of instructor\nMaterials and mechanics approach to fracture and fatigue. Fracture mechanics, brittle and ductile fracture, fracture and fatigue characteristics, fracture of thin films and layered structures. Fracture and fatigue tests, mechanics and materials designed to avoid fracture or fatigue.\n",
    "credits": "3"
  },
  {
    "course_name": "Systems Engineering and Analysis",
    "dept": "AER E",
    "num": "565",
    "desc": "Prereq: Coursework in basic statistics\nIntroduction to organized multidisciplinary approach to designing and developing systems. Concepts, principles, and practice of systems engineering as applied to large integrated systems. Life-cycle costing, scheduling, risk management, functional analysis, conceptual and detail design, test evaluation, and systems engineering planning and organization.\n  Not available for degrees in industrial engineering",
    "credits": "3"
  },
  {
    "course_name": "Avionics Systems Engineering",
    "dept": "AER E",
    "num": "566",
    "desc": "Prereq: E E 565\nAvionics functions. Applications of systems engineering principles to avionics. Top-down design of avionics systems. Automated design tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Large-Scale Complex Engineered Systems (LSCES)",
    "dept": "AER E",
    "num": "568",
    "desc": "Prereq: senior standing in College of Engineering or permission of AerE 468 instructor\nIntroduction to the theoretical foundation and methods associated with the design for large-scale complex engineered systems, including objective function formation, design reliability, value-driven design, product robustness, utility theory, economic factors for the formation of a value function and complexity science as a means of detecting unintended consequences in the product behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Composite and Combined Materials",
    "dept": "AER E",
    "num": "569",
    "desc": "Prereq: E M 324\nMechanics of fiber-reinforced materials. Micromechanics of lamina. Macromechanical behavior of lamina and laminates. Strength and interlaminar stresses of laminates. Failure criteria. Stress analysis of laminates. Thermal moisture and residual stresses. Joints in composites.\n",
    "credits": "3"
  },
  {
    "course_name": "Wind Engineering",
    "dept": "AER E",
    "num": "570",
    "desc": "Prereq: E M 378, E M 345\nAtmospheric circulations, atmospheric boundary layer wind, bluff-body aerodynamics, aeroelastic phenomena, wind-tunnel and full-scale testing, wind-load code and standards, effect of tornado and thunderstorm winds, design applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Turbulence",
    "dept": "AER E",
    "num": "572",
    "desc": "Prereq: AER E 541 or M E 538\nQualitative features of turbulence. Statistical representation of turbulent velocity fields: averages, moments, correlations, length and time scales and the energy cascade. Averaged equations of motion, closure requirements, Reynolds averaged models. Homogeneous shear flows, free shear flows, boundary layers. Numerical simulation of turbulence: DNS, LES, DES.\n",
    "credits": "3"
  },
  {
    "course_name": "Random Signal Analysis and Kalman Filtering",
    "dept": "AER E",
    "num": "573",
    "desc": "Prereq: E E 324 or AER E 331 or M E 370 or M E 411 or MATH 341\nElementary notions of probability. Random processes. Autocorrelation and spectral functions. Estimation of spectrum from finite data. Response of linear systems to random inputs. Discrete and continuous Kalman filter theory and applications. Smoothing and prediction. Linearization of nonlinear dynamics.\n",
    "credits": "3"
  },
  {
    "course_name": "Optimal Control",
    "dept": "AER E",
    "num": "574",
    "desc": "Prereq: E E 577\nThe optimal control problem. Variational approach. Pontryagin's principle, Hamilton-Jacobi equation. Dynamic programming. Time-optimal, minimum fuel, minimum energy control systems. The regulator problem. Structures and properties of optimal controls.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Robust Control",
    "dept": "AER E",
    "num": "575",
    "desc": "Prereq: E E 577\nIntroduction to modern robust control. Model and signal uncertainty in control systems. Uncertainty description. Stability and performance robustness to uncertainty. Solutions to the H2, Hoo, and l1 control problems. Tools for robustness analysis and synthesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Feedback Control Systems",
    "dept": "AER E",
    "num": "576",
    "desc": "Prereq: E E 475 or AER E 432 or M E 411 or MATH 415; and MATH 267\nSampled data, discrete data, and the z-transform. Design of digital control systems using transform methods: root locus, frequency response and direct design methods. Design using state-space methods. Controllability, observability, pole placement, state estimators. Digital filters in control systems. Microcomputer implementation of digital filters. Finite wordlength effects. Linear quadratic optimal control in digital control systems. Simulation of digital control systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Linear Systems",
    "dept": "AER E",
    "num": "577",
    "desc": "Prereq: E E 324 or AER E 331 or MATH 415; and MATH 207\nLinear algebra review. Least square method and singular value decomposition. State space modeling of linear continuous-time systems. Solution of linear systems. Controllability and observability. Canonical description of linear equations. Stability of linear systems. State feedback and pole placements. Observer design for linear systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonlinear Systems",
    "dept": "AER E",
    "num": "578",
    "desc": "Prereq: E E 577\nLinear vs nonlinear systems. Phase plane analysis. Bifurcation and center manifold theory. Lyapunov stability. Absolute stability of   feedback systems. Input-output stability. Passivity theory and feedback linearization. Nonlinear control design techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Perturbation Methods",
    "dept": "AER E",
    "num": "581",
    "desc": "Prereq: MATH 267\nMathematical perturbation methods with applications to ordinary and partial differential equations. Perturbation expansions. Order of magnitude and gauge functions. Matched asymptotic expansions. Boundary layer problems. Multiple scales. Resonance and mode coupling. Solvability conditions for differential equations. Physical and engineering applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Aeroacoustics",
    "dept": "AER E",
    "num": "583",
    "desc": "Prereq: AER E 311 or M E 335; and MATH 266 or MATH 267\nNoise metrics, Linear wave equation and its solution in 1-, 2-, and 3-D using Green's functions. Propagation of sound in free and confined spaces. Aerodynamic noise sources in engineering machines: aircraft engine noise, airfram noise, wind turbine noise, etc.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Special Topics",
    "dept": "AER E",
    "num": "590",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aero and/or Gas Dynamics",
    "dept": "AER E",
    "num": "590A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Propulsion",
    "dept": "AER E",
    "num": "590B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aerospace Structures",
    "dept": "AER E",
    "num": "590C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Flight Dynamics",
    "dept": "AER E",
    "num": "590D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Spacecraft Systems",
    "dept": "AER E",
    "num": "590E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Flight Control Systems",
    "dept": "AER E",
    "num": "590F",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aeroelasticity",
    "dept": "AER E",
    "num": "590G",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Viscous Aerodynamics",
    "dept": "AER E",
    "num": "590H",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Design",
    "dept": "AER E",
    "num": "590I",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study:  Hypersonics",
    "dept": "AER E",
    "num": "590J",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Computational Aerodynamics",
    "dept": "AER E",
    "num": "590K",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Optimization",
    "dept": "AER E",
    "num": "590L",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Non Destructive Evaluation",
    "dept": "AER E",
    "num": "590M",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Wind Engineering",
    "dept": "AER E",
    "num": "590N",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Student Seminar Series",
    "dept": "AER E",
    "num": "591",
    "desc": "\nPresentation of professional topics by department graduate students. Development of presentation skills used in a professional conference setting involving question and answer format.\n",
    "credits": "R"
  },
  {
    "course_name": "Creative Component",
    "dept": "AER E",
    "num": "599",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Stability of Fluid Flow",
    "dept": "AER E",
    "num": "640",
    "desc": "Prereq: AerE 541\nTheoretical methods of stability analysis; linear analysis of exchange of stability and over stability; bifurcation of equilibria; most dangerous modes and pattern formation; shear flow stability theorems. Physical mechanisms. Tollmein-Schlichting waves, disintegration of capillary jets, Benard convection, Taylor-Couette flow, centrifugal instability, double diffusion.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Computational Fluid Dynamics",
    "dept": "AER E",
    "num": "647",
    "desc": "Prereq: AER E 547\nAn examination of current methods in computational fluid dynamics. Differencing strategies. Advanced solution algorithms for unstructured meshes.  Grid generation. Construction of higher-order CFD algorithms. Parallel computing. Current applications. Use of state of the art CFD codes.\n",
    "credits": "3"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Advanced Topics",
    "dept": "AER E",
    "num": "690",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aero and/or Gas Dynamics",
    "dept": "AER E",
    "num": "690A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Propulsion",
    "dept": "AER E",
    "num": "690B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aerospace Structures",
    "dept": "AER E",
    "num": "690C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Flight Dynamics",
    "dept": "AER E",
    "num": "690D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Spacecraft Systems",
    "dept": "AER E",
    "num": "690E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Flight Control Systems",
    "dept": "AER E",
    "num": "690F",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Aeroelasticity",
    "dept": "AER E",
    "num": "690G",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Viscous Aerodynamics",
    "dept": "AER E",
    "num": "690H",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Design",
    "dept": "AER E",
    "num": "690I",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Hypersonics",
    "dept": "AER E",
    "num": "690J",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Computational Aerodynamics",
    "dept": "AER E",
    "num": "690K",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Non Destructive Evaluation",
    "dept": "AER E",
    "num": "690L",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Aerospace Engineering Independent Study: Wind Engineering",
    "dept": "AER E",
    "num": "690M",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "AER E",
    "num": "697",
    "desc": "Prereq: Permission of DOGE (Director of Graduate Education), graduate classification\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "AER E",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to African American Studies",
    "dept": "AF AM",
    "num": "201",
    "desc": "\nAn interdisciplinary introduction to the study of African American culture. Includes history, the social sciences, literature, religion, and the arts, as well as conceptual frameworks for investigation and analysis of the African American experience.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Africa under Colonial Rule",
    "dept": "AF AM",
    "num": "311",
    "desc": "Prereq: 3 credits of 200-level HIST at Iowa State, and sophomore classification.\nDevelopment of Africa from imposition of colonial rule to independence, including processes of European domination, African reaction and resistance, emergence of nationalism, and dismantling of colonialism.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Peoples and Cultures of Africa.",
    "dept": "AF AM",
    "num": "325",
    "desc": "Prereq: 201 or 306 recommended.\nSurvey of diverse African culture areas across the continent and globally; local level description and analysis of individuals as members of African communities; regional, national and global scales of identification.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Ethnic and Race Relations",
    "dept": "AF AM",
    "num": "330",
    "desc": "Prereq: SOC 134\nAnalysis of ethnic and race relations, particularly in America; emphasis on the sociology and psychology of race and ethnic relations.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "African American Religious Experience",
    "dept": "AF AM",
    "num": "334",
    "desc": "Prereq: Prior course work in Religious Studies or African American Studies recommended\nExamination of African-American experience from the perspective of black religion with attention to political, economic, social, theological and artistic expressions, including music, that serve the life of African-American communities.”.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in African American Literature",
    "dept": "AF AM",
    "num": "347",
    "desc": "Prereq: ENGL 250\nLiterature by African Americans, which may include study of individual authors, movements, themes, genres.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women of Color in the U.S",
    "dept": "AF AM",
    "num": "350",
    "desc": "Prereq: 3 credits in WGS or AF AM\nEconomic, social, political and cultural roles of Women of Color in the U.S. Includes literary, philosophical, and artistic expressions. Myths and realities explored.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History of African Americans I",
    "dept": "AF AM",
    "num": "353",
    "desc": "Prereq: Sophomore classification\nExamines African roots of black culture and the African American experience in the United States from the colonial period through the Civil War. Topics include Atlantic Slave Trade, slavery and American identity, abolition, the emergence of Black Nationalism, and black participation in the Civil War.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History of African Americans II",
    "dept": "AF AM",
    "num": "354",
    "desc": "Prereq: Sophomore classification\nExplores African American political thought and political action from Reconstruction to the present. Topics include rise of Jim Crow segregation, urban migration, Garvey movement, Harlem Renaissance, Depression and world wars, Pan-Africanism, civil rights, Black Power, and black feminism.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in African American Culture",
    "dept": "AF AM",
    "num": "460",
    "desc": "\nIntensive study of a selected topic in African-American Studies in one or more disciplines. Selected readings of various authors, movements, eras, or genres. Primary and secondary source materials.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Civil Rights and Ethnic Power",
    "dept": "AF AM",
    "num": "473",
    "desc": "Prereq: Sophomore classification\nComparative history of the civil rights and ethnic power movements (African American, Chicano, American Indian, Puerto Rican, among others) in the U.S. from World War II to the present. Topics include institutional foundations, leadership, gender and racial dynamics, and the convergences and divergences of these differing ethnic struggles for rights.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "AF AM",
    "num": "490",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Learning Communities",
    "dept": "A B E",
    "num": "102",
    "desc": "\n8 week learning communities course focusing on student success, engineering, and department curriculum. Building community within the ABE Department.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Experiencing Agricultural and Biosystems Engineering",
    "dept": "A B E",
    "num": "110",
    "desc": "\nLaboratory-based, team-oriented experiences in a spectrum of topics common to the practice of agricultural and biosystems engineering. Report writing, co-ops, internships, careers, registration planning.\n",
    "credits": "1"
  },
  {
    "course_name": "Systematic Problem Solving and Computer Programming",
    "dept": "A B E",
    "num": "160",
    "desc": "Prereq: Credit or enrollment in MATH 143 or MATH 165\nEngineering approach to problem solution and presentation in the context of real world problems. Introduction to basic principles from statics, projectile motion, conservation of mass and energy and electricity and magnetism. Use of spreadsheet programs and computer programming language(s) to solve and present engineering problems.\n  Only one of ENGR 160, A B E 160, AER E 160, C E 160, CH E 160, CPR E 185, EE 185, IE 148, M E 160 and S E 185 may count towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Graphics and Introductory Design",
    "dept": "A B E",
    "num": "170",
    "desc": "\nApplications of multi-view drawings and dimensioning. Techniques for visualizing, analyzing, and communicating 3-D geometries. Application of the design process including written and oral reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Preparing for Workplace Seminar",
    "dept": "A B E",
    "num": "201",
    "desc": "Prereq: Prereq: Sophomore classification in AE, AST, BSE, or I TEC\n8 week course. Professionalism in the context of the engineering/technical workplace. Development and demonstration of key workplace competencies: teamwork, initiative, communication, and engineering/technical knowledge. Resumes; Cover Letters; Behavioral Based Interviewing; Industry Speakers; Preparation for internships experiences.\n",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Agricultural and Biosystems Engineering",
    "dept": "A B E",
    "num": "216",
    "desc": "Prereq: A B E 160 or permission of the instructor\nApplication of mathematics and engineering sciences to mass and energy balances in agricultural and biological systems. Emphasis is on solving engineering problems in the areas of heat and mass transfer, air and water vapor systems; animal production systems, grain systems; food systems, hydrologic systems, and bioprocessing.\n",
    "credits": "3"
  },
  {
    "course_name": "Project Management & Design in Agricultural and Biosystems Engineering",
    "dept": "A B E",
    "num": "218",
    "desc": "Prereq: A B E 216\nProject management - critical path, Gantt charts, resource allocations, basic project budgeting, and project management software. Engineering design approaches. Open-ended design projects to demonstrate the preceding principles through application of technical concepts taught in prerequisite coursework.\n",
    "credits": "2"
  },
  {
    "course_name": "Engineering Applications of Parametric Solid Modeling",
    "dept": "A B E",
    "num": "271",
    "desc": "Prereq: A B E 170 or TSM 116 or equivalent\n8 week-course. Creating, editing, and documenting part and assembly models using Solidworks.\n",
    "credits": "1"
  },
  {
    "course_name": "Parametric Solid Models, Drawings, and Assemblies Using Creo Parametric",
    "dept": "A B E",
    "num": "272",
    "desc": "Prereq: A B E 170 or TSM 116 or equivalent\n8 week-course. Applications of  Creo Parametric software. Create solid models of parts and assemblies. Utilize the solid models to create design documentation (standard drawing views, dimensions, and notes) and for the geometric analysis of parts and assemblies.\n",
    "credits": "1"
  },
  {
    "course_name": "CAD for Process Facilities and Land Use Planning",
    "dept": "A B E",
    "num": "273",
    "desc": "Prereq: ENGR 170 or TSM 116 or equivalent.\n8-week course. Application of 2-D AutoCAD software to create and interpret 2-D drawings and 3-D models of facilities. Topics include geometric construction, design documentation: (using views, dimension, notes), and AutoCAD specific features (i.e. Layers, Blocks, Standards, Styles).\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Numerical Methods for Agricultural and Biosystems Engineering",
    "dept": "A B E",
    "num": "316",
    "desc": "Prereq: A B E 160; MATH 266 or MATH 267\nComputer aided solution of agricultural engineering problems by use of numerical techniques and mathematical models. Systems analysis and optimization applicable to agricultural and biological systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Biorenewable Systems",
    "dept": "A B E",
    "num": "325",
    "desc": "Prereq: CHEM 163 or higher; MATH 140 or higher\nConverting biorenewable resources into bioenergy and biobased products. Biorenewable concepts as they relate to drivers of change, feedstock production, processes, products, co-products, economics, and transportation/logistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Functional Analysis of Soil, Crop, and Machine Systems",
    "dept": "A B E",
    "num": "340",
    "desc": "Prereq: A B E 216\nPrinciples of machine systems operation (tillage, crop establishment, harvesting and crop protection). Principles of soil and crop interactions with machine systems. Experimental and simulation techniques for testing and evaluation of agricultural field machinery for equipment performance, functional analysis and crop production management.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Tractor Power",
    "dept": "A B E",
    "num": "342",
    "desc": "Prereq: CH E 381 or M E 231\nThermodynamic principles and construction of tractor engines. Fuels, combustion, and lubrication. Kinematics and dynamics of tractor power applications; drawbar, power take-off and traction mechanisms.\n",
    "credits": "3"
  },
  {
    "course_name": "Agri-Industrial Applications of Electric Power and Electronics",
    "dept": "A B E",
    "num": "363",
    "desc": "Prereq: A B E 216\nSingle phase and three phase circuit design. Electrical safety. Electric motors and controls. Programmable logic controllers. Digital logic, instrumentation and sensors.\n",
    "credits": "4"
  },
  {
    "course_name": "Principles of Biological Systems Engineering",
    "dept": "A B E",
    "num": "380",
    "desc": "Prereq: A B E 316\nEngineering analysis of biological systems, through the study of mass, energy, and information transport. Quantification and modeling of biological interactions, biological activities and bioreactor operations. Includes hands-on laboratory experiences.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Engineering and International Development",
    "dept": "A B E",
    "num": "388",
    "desc": "Prereq: Junior classification in engineering\nMulti-disciplinary approach to sustainable engineering and international development, sustainable development, appropriate design and engineering, feasibility analysis, international aid, business development, philosophy and politics of technology, and ethics in engineering. Engineering-based projects from problem formulation through implementation. Interactions with partner community organizations or international partners such as nongovernment organizations (NGOs). Course readings, final project/design report.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Summer Internship",
    "dept": "A B E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "A B E",
    "num": "398",
    "desc": "Prereq: A B E 218 and permission of department and Engineering Career Services\nProfessional work period. One semester per academic or calendar year. Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Modeling, Simulation, and Controls for Agricultural and Biological Systems",
    "dept": "A B E",
    "num": "403",
    "desc": "Prereq: A B E 316, and A B E 363, and MATH 266 or MATH 267\nModeling dynamic systems with ordinary differential equations. Introduction to state variable methods of system analysis. Analysis of mechanical, electrical, and fluid power systems. Analytical and numerical solutions of differential equations. Introduction to classical control theory. Feedback and stability examined in the s domain. Frequency response as an analytical and experimental tool. MATLAB will be used throughout the course for modeling. Individual and/or group projects required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Instrumentation for Agricultural and Biosystems Engineering",
    "dept": "A B E",
    "num": "404",
    "desc": "Prereq: A B E 316 and A B E 363\nInterfacing techniques for computer-based data acquisition and control systems. Basic interfacing components including A/D and D/A conversion, signal filtering, multiplexing, and process control. Sensors and theory of operation applied to practical monitoring and control problems. Individual and group projects required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Systems Integration for Agricultural Machinery & Production Systems",
    "dept": "A B E",
    "num": "410",
    "desc": "\nSystem architecture and design of electronics used in agricultural machinery and production systems. Emphasis on information technology and systems integration for automated agriculture processes. Design of Controller Area Network (CAN BUS) communication systems and discussion of relevant standards (ISO 11783 and SAE J1939). Application of technologies for sensing, distribution control, and automation of agricultural machinery will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Fluid Power Engineering",
    "dept": "A B E",
    "num": "413",
    "desc": "Prereq: Credit or enrollment in E M 378 or M E 335, A B E 216 or M E 270\nProperties of hydraulic fluids. Performance parameters of fixed and variable displacement pumps and motors. Hydraulic circuits and systems. Hydrostatic transmissions. Characteristics of control valves. Analysis and design of hydraulic systems for power and control functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural & Biosystems Engineering Design I",
    "dept": "A B E",
    "num": "415",
    "desc": "Prereq: A B E 316 (majors only)\nIdentification of current design problems in ag & biosystems engineering. Development of alternate solutions using creativity and engineering analysis and synthesis techniques.\n",
    "credits": "2"
  },
  {
    "course_name": "Agricultural & Biosystems Engineering Design II",
    "dept": "A B E",
    "num": "416",
    "desc": "Prereq: A B E 415 (majors only)\nSelection of promising solutions to design problems identified in 415 for development by design teams. Presentation of designs through oral and written reports and prototypes.\n",
    "credits": "2"
  },
  {
    "course_name": "Fundamentals of Engineering Review",
    "dept": "A B E",
    "num": "418",
    "desc": "Prereq: senior classification.\n8 week course. Review of core concepts covered in the Fundamentals of Engineering examination with emphasis on statics, dynamics, fluid mechanics, heat transfer, electric circuits, and engineering economics. Open to all College of Engineering seniors, however focus is on the general exam, not discipline specific exams.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution",
    "dept": "A B E",
    "num": "424",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Air quality and effects of pollutants",
    "dept": "A B E",
    "num": "424A",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Climate change and causes",
    "dept": "A B E",
    "num": "424B",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Transportation Air Quality",
    "dept": "A B E",
    "num": "424C",
    "desc": "Prereq: C E 524A; PHYS 221 or CHEM 178; MATH 166 or 3 credits in statistics. Senior classification or above.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Off-gas treatment technology",
    "dept": "A B E",
    "num": "424D",
    "desc": "Prereq: C E 524A, C E 524B; Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Agricultural sources of pollution",
    "dept": "A B E",
    "num": "424E",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Design and Evaluation of Soil and Water Conservation Systems",
    "dept": "A B E",
    "num": "431",
    "desc": "Prereq: E M 378 or CH E 356\nHydrology and hydraulics in agricultural and urbanizing watersheds. Design and evaluation of systems for the conservation and quality preservation of soil and water resources. Use and analysis of hydrologic data in engineering design; relationship of topography, soils, crops, climate, and cultural practices in conservation and quality preservation of soil and water for agriculture. Small watershed hydrology, water movement and utilization in the soil-plant-atmosphere system, agricultural water management, best management practices, and agricultural water quality. Graduate students will prepare several research literature reviews on topics covered in the class in addition to the other assignments.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonpoint Source Pollution and Control",
    "dept": "A B E",
    "num": "432",
    "desc": "Prereq: A B E 431 or C E 372\nCharacteristics and courses of non-point source (NPS) pollution in agricultural and urban watersheds, computer modeling and NPS pollution for terrestrial and aquatic systems, strategies to control and manage NPS pollution of water bodies, total maximum daily loads (TMDLs) and integrated watershed management. Graduate students are required to review research papers and develop/deliver lecture models on assigned topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Evaluation of Soil and Water Monitoring Systems",
    "dept": "A B E",
    "num": "436",
    "desc": "Prereq: A B E 431\nDevelopment of monitoring systems that support effective planning, performance evaluation, modeling, or environmental impact assessment of soil-, water-, and waste-management systems.  Typical soil and water pollutants and physical, chemical, and biological characteristics that affect sample location and timing. Sample collection, documentation, chain-of-custody, and quality assurance procedures.  In addition to other assignments, graduate students will prepare several research literature reviews on topics covered in the class and develop monitoring plans.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Modeling and Policy",
    "dept": "A B E",
    "num": "437",
    "desc": "Prereq: CE 372 or equivalent\nA project-based course on watershed-scale models for improving water quality. Legislative and judicial basis of the Total Maximum Daily Load (TMDL) program; approaches to TMDL development; principles and techniques for implementation; stakeholder engagement strategies. Hands-on experiences with GIS-interfaced models, data sources, calibration/validation, statistical assessment of model results, and simulation using multiple tools. In addition to other assignments, graduate students will present case studies of TMDLs using different modeling tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Food and Bioprocess Engineering",
    "dept": "A B E",
    "num": "451",
    "desc": "Prereq: A B E 216 and credit or enrollment in M E 436 or CH E 357; or FS HN 351 and MATH 266 or MATH 267\nApplication of engineering principles and mathematical modeling to the quantitative analysis of food and bioprocessing systems. Physical/chemical characteristics of foods and biological systems, flow processes, thermal processes and separation processes. Term paper required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "A B E",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering for Grain Storage, Preservation, Handling, and Processing Systems",
    "dept": "A B E",
    "num": "469",
    "desc": "Prereq: A B E 216\nCereal grain and oilseed production, properties, and quality assessment. Design of storage systems, drying systems, material handling, and size reduction systems. Design of cereal grain processing systems, including dry milling, wet milling, flour milling, feed milling, and fermentation facilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Environmental Modification Systems for Animal Housing",
    "dept": "A B E",
    "num": "472",
    "desc": "Prereq: A B E 216, M E 231\nPrinciples and design of animal environmental control systems. Insulation, heat and mass transfer, fans, ventilation,  air distribution, heating and cooling equipment, and controls. Individual and group projects required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Design in Animal Production Systems Engineering",
    "dept": "A B E",
    "num": "475",
    "desc": "Prereq: A B E 271, A B E 272, or A B E 273; E M 324 and enrollment in APSE option of AE program.\nApplication of engineering fundamentals to the independent solution of an animal production systems engineering problem with well defined criteria and constraints in either environmental control, structural design, manure management, or air quality/mitigation.\n",
    "credits": "2"
  },
  {
    "course_name": "Wood Frame Structural Design",
    "dept": "A B E",
    "num": "478",
    "desc": "Prereq: M E 231, E M 324\nDesign of light-framed wood structures using LRFD and ASD design procedures. Includes analysis of wind, snow, dead, and live loads. Applications include animal housing and machine storage. Fasteners, laminated posts, truss design and use of National Design Specifications.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Analysis of Biological Systems",
    "dept": "A B E",
    "num": "480",
    "desc": "Prereq: A B E 380 or permission of the instructor\nSystems-level quantitative analysis of biological systems, including applications in foods, feeds, biofuels, bioenergy, and other biological systems. Introduction to economic analysis and life-cycle assessment of these systems at multiple production scales. Applying these tools to evaluate and improve cost and sustainability performance of these biological systems. Students enrolled in ABE 580 will be required to answer additional exam questions and report on two journal articles.\n",
    "credits": "3"
  },
  {
    "course_name": "A B E Independent Study",
    "dept": "A B E",
    "num": "490",
    "desc": "\nIndependent Study.\n",
    "credits": "1"
  },
  {
    "course_name": "A B E Independent Study: Animal Production Systems Engineering",
    "dept": "A B E",
    "num": "490A",
    "desc": "\nIndependent Study.\n",
    "credits": "1"
  },
  {
    "course_name": "A B E Independent Study: Biorenewable Resources",
    "dept": "A B E",
    "num": "490B",
    "desc": "\nIndependent study.\n",
    "credits": "1"
  },
  {
    "course_name": "A B E Independent Study: Environmental Bioprocessing Engineering",
    "dept": "A B E",
    "num": "490E",
    "desc": "\nIndependent study in environmental bioprocessing engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "A B E Independent Study: Food Engineering",
    "dept": "A B E",
    "num": "490F",
    "desc": "\nIndependent study in food engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "A B E Independent Study: General Topics in A B E",
    "dept": "A B E",
    "num": "490G",
    "desc": "\nIndependent study in general A B E topics.\n",
    "credits": "1"
  },
  {
    "course_name": "A B E Independent Study: Honors",
    "dept": "A B E",
    "num": "490H",
    "desc": "\nGuided instructing in agricultural and biosystems engineering for honors students.\n",
    "credits": "1"
  },
  {
    "course_name": "A B E Independent Study: Land & Water Resources Engineering",
    "dept": "A B E",
    "num": "490L",
    "desc": "\nGuided instruction in land and water resources engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "A B E Independent Study: Advanced Machinery Systems Engineering",
    "dept": "A B E",
    "num": "490M",
    "desc": "\nGuided instruction in advance machinery systems engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural and Biosystems Engineering Department Study Abroad Preparation or Follow-up",
    "dept": "A B E",
    "num": "495",
    "desc": "Prereq: Permission of instructor\nPreparation for, or follow-up of, study abroad experience (496). For preparation, course focuses on understanding the tour destination through readings, discussions, and research on topics such as the regional industries, climate, crops, culture, economics, food, geography, government, history, natural resources, and public policies. For follow-up, course focuses on presentations by students, report writing, and reflection. Students enrolled in this course intend to register for 496 the following term or have had taken 496 the previous term.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural and Biosystems Engineering Department Study Abroad",
    "dept": "A B E",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nTour and study at international sites relevant to disciplines of industrial technology, biological systems engineering, agricultural systems technology, and agricultural engineering. Location and duration of tours will vary. Trip expenses paid by students. Pre-trip preparation and/or post-trip reflection and reports arranged through 495.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Modeling, Simulation, and Controls for Agricultural and Biological Systems",
    "dept": "A B E",
    "num": "503",
    "desc": "Prereq: A B E 316, and A B E 363, and MATH 266 or MATH 267\nModeling dynamic systems with ordinary differential equations. Introduction to state variable methods of system analysis. Analysis of mechanical, electrical, and fluid power systems. Analytical and numerical solutions of differential equations. Introduction to classical control theory. Feedback and stability examined in the s domain. Frequency response as an analytical and experimental tool. MATLAB will be used throughout the course for modeling. Individual and/or group projects required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Instrumentation for Agricultural and Biosystems Engineering",
    "dept": "A B E",
    "num": "504",
    "desc": "Prereq: A B E 316 and A B E 363\nInterfacing techniques for computer-based data acquisition and control systems. Basic interfacing components including A/D and D/A conversion, signal filtering, multiplexing, and process control. Sensors and theory of operation applied to practical monitoring and control problems. Individual and group projects required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Computational Intelligence",
    "dept": "A B E",
    "num": "506",
    "desc": "Prereq: A B E 316 or equivalent, MATH 166, STAT 305\nApplications of biologically inspired computational intelligence tools for data mining, system modeling, and optimization for agricultural, biological and other engineered systems. Introduction to Artificial Neural Networks, Support Vector Machines, Fuzzy Logic, Genetic Algorithms, Bayesian and Decision Tree learning. Fundamental Machine Vision techniques will be introduced in the first part of course and be integrated into the lab exercises for learning different computational intelligence techniques. MATLAB will be used throughout the course for algorithm implementation.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Systems Integration for Agricultural Machinery & Production Systems",
    "dept": "A B E",
    "num": "510",
    "desc": "\nSystem architecture and design of electronics used in agricultural machinery and production systems. Emphasis on information technology and systems integration for automated agriculture processes. Design of Controller Area Network (CAN BUS) communication systems and discussion of relevant standards (ISO 11783 and SAE J1939). Application of technologies for sensing, distribution control, and automation of agricultural machinery will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioprocessing and Bioproducts",
    "dept": "A B E",
    "num": "511",
    "desc": "Prereq: A B E 216 or equivalent, MATH 160 or MATH 165, one of CHEM 167 or higher, BIOL 173 or BIOL 211 or higher or BRT 501, senior or graduate classification\nSustainability, cleaner production. Taxonomy, kinetics, metabolism, aerobic and anaerobic fermentation.  Biofuels, bioenergy and coproducts. Mass/energy balances, process integration, pretreatment, separation. Membrane reactors, bioelectrolysis, microbial fuel cells, nanotechnology, genetic engineering, mutagenesis.  Term paper for graduate level only.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Crop and Livestock Production Systems",
    "dept": "A B E",
    "num": "515",
    "desc": "Prereq: SUSAG 509\nMethods to maintain productivity and minimize the negative ecological effects of agricultural systems by understanding nutrient cycles, managing manure and crop residue, and utilizing multispecies interactions. Crop and livestock production within landscapes and watersheds is also considered. Course includes a significant field component, with student teams analyzing Iowa farms.\n",
    "credits": "3"
  },
  {
    "course_name": "Air Pollution",
    "dept": "A B E",
    "num": "524",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Air quality and effects of pollutants",
    "dept": "A B E",
    "num": "524A",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Climate change and causes",
    "dept": "A B E",
    "num": "524B",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Transportation Air Quality",
    "dept": "A B E",
    "num": "524C",
    "desc": "Prereq: C E 524A; PHYS 221 or CHEM 178; MATH 166 or 3 credits in statistics. Senior classification or above.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Off-gas treatment technology",
    "dept": "A B E",
    "num": "524D",
    "desc": "Prereq: C E 524A, C E 524B; Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Agricultural sources of pollution",
    "dept": "A B E",
    "num": "524E",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Design and Evaluation of Soil and Water Conservation Systems",
    "dept": "A B E",
    "num": "531",
    "desc": "Prereq: E M 378 or CH E 356\nHydrology and hydraulics in agricultural and urbanizing watersheds. Design and evaluation of systems for the conservation and quality preservation of soil and water resources. Use and analysis of hydrologic data in engineering design; relationship of topography, soils, crops, climate, and cultural practices in conservation and quality preservation of soil and water for agriculture. Small watershed hydrology, water movement and utilization in the soil-plant-atmosphere system, agricultural water management, best management practices, and agricultural water quality. Graduate students will prepare several research literature reviews on topics covered in the class in addition to the other assignments.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonpoint Source Pollution and Control",
    "dept": "A B E",
    "num": "532",
    "desc": "Prereq: A B E 431 or C E 372\nCharacteristics and courses of non-point source (NPS) pollution in agricultural and urban watersheds, computer modeling and NPS pollution for terrestrial and aquatic systems, strategies to control and manage NPS pollution of water bodies, total maximum daily loads (TMDLs) and integrated watershed management. Graduate students are required to review research papers and develop/deliver lecture models on assigned topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Erosion and Sediment Transport",
    "dept": "A B E",
    "num": "533",
    "desc": "Prereq: C E 372 or GEOL/ENSCI/MTEOR 402, MATH 166 or equivalent\nSoil erosion processes, soil loss equations and their application to conservation planning, sediment properties, initiation of sediment motion and over land flow, flow in alluvial channels and theory of sediment transport, channel stability, reservoir sedimentation, wind erosion, BMPs for controlling erosion.\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Evaluation of Soil and Water Monitoring Systems",
    "dept": "A B E",
    "num": "536",
    "desc": "Prereq: A B E 431\nDevelopment of monitoring systems that support effective planning, performance evaluation, modeling, or environmental impact assessment of soil-, water-, and waste-management systems.  Typical soil and water pollutants and physical, chemical, and biological characteristics that affect sample location and timing. Sample collection, documentation, chain-of-custody, and quality assurance procedures.  In addition to other assignments, graduate students will prepare several research literature reviews on topics covered in the class and develop monitoring plans.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Modeling and Policy",
    "dept": "A B E",
    "num": "537",
    "desc": "Prereq: CE 372 or equivalent\nA project-based course on watershed-scale models for improving water quality. Legislative and judicial basis of the Total Maximum Daily Load (TMDL) program; approaches to TMDL development; principles and techniques for implementation; stakeholder engagement strategies. Hands-on experiences with GIS-interfaced models, data sources, calibration/validation, statistical assessment of model results, and simulation using multiple tools. In addition to other assignments, graduate students will present case studies of TMDLs using different modeling tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Food and Bioprocess Engineering",
    "dept": "A B E",
    "num": "551",
    "desc": "Prereq: A B E 216 and credit or enrollment in M E 436 or CH E 357; or FS HN 351 and MATH 266 or MATH 267\nApplication of engineering principles and mathematical modeling to the quantitative analysis of food and bioprocessing systems. Physical/chemical characteristics of foods and biological systems, flow processes, thermal processes and separation processes. Term paper required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering for Grain Storage, Preservation, Handling, and Processing Systems",
    "dept": "A B E",
    "num": "569",
    "desc": "Prereq: A B E 216\nCereal grain and oilseed production, properties, and quality assessment. Design of storage systems, drying systems, material handling, and size reduction systems. Design of cereal grain processing systems, including dry milling, wet milling, flour milling, feed milling, and fermentation facilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Environmental Modification Systems for Animal Housing",
    "dept": "A B E",
    "num": "572",
    "desc": "Prereq: A B E 216, M E 231\nPrinciples and design of animal environmental control systems. Insulation, heat and mass transfer, fans, ventilation,  air distribution, heating and cooling equipment, and controls. Individual and group projects required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Wood Frame Structural Design",
    "dept": "A B E",
    "num": "578",
    "desc": "Prereq: M E 231, E M 324\nDesign of light-framed wood structures using LRFD and ASD design procedures. Includes analysis of wind, snow, dead, and live loads. Applications include animal housing and machine storage. Fasteners, laminated posts, truss design and use of National Design Specifications.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Analysis of Biological Systems",
    "dept": "A B E",
    "num": "580",
    "desc": "Prereq: A B E 380 or permission of the instructor\nSystems-level quantitative analysis of biological systems, including applications in foods, feeds, biofuels, bioenergy, and other biological systems. Introduction to economic analysis and life-cycle assessment of these systems at multiple production scales. Applying these tools to evaluate and improve cost and sustainability performance of these biological systems. Students enrolled in ABE 580 will be required to answer additional exam questions and report on two journal articles.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Agricultural & Biosystems Engineering",
    "dept": "A B E",
    "num": "590",
    "desc": "\nGuided instruction and self-study on special topics relevant to agricultural and biosystems engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Seminar",
    "dept": "A B E",
    "num": "601",
    "desc": "\nKeys to starting a successful graduate research project.  Effective literature review, formulating research questions, and setting goals.  Practicing effectively communicating research and science.  Effective strategies for scholarly writing, responding to feedback, peer-reviewing, successful publishing in journals, and curating scholarly output.\n",
    "credits": "1"
  },
  {
    "course_name": "Foundations of Sustainable Agriculture",
    "dept": "A B E",
    "num": "610",
    "desc": "Prereq: Graduate classification, permission of instructor\nHistorical, biophysical, socioeconomic, and ethical dimensions of agricultural sustainability. Strategies for evaluating existing and emerging agricultural systems in terms of the core concepts of sustainability and their theoretical contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "A B E",
    "num": "690",
    "desc": "\nAdvanced topics.\n",
    "credits": "arr"
  },
  {
    "course_name": "Teaching Practicum",
    "dept": "A B E",
    "num": "694",
    "desc": "Prereq: Graduate classification and permission of instructor\nGraduate student experience in the agricultural and biosystems engineering departmental teaching program.\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "A B E",
    "num": "697",
    "desc": "Prereq: Permission of department chair, graduate classification\nOne semester and one summer maximum per academic year professional work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "A B E",
    "num": "699",
    "desc": "\nResearch.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Biosystems Engineering",
    "dept": "A B E",
    "num": "699B",
    "desc": "\nGuided graduate research in biosystems engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Computer Aided Design",
    "dept": "A B E",
    "num": "699C",
    "desc": "\nGuided graduate research in computer-aided design.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Environmental Systems",
    "dept": "A B E",
    "num": "699E",
    "desc": "\nGuided graduate research in environmental systems.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Food Engineering",
    "dept": "A B E",
    "num": "699F",
    "desc": "\nGuided graduate research in food engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Occupational Safety",
    "dept": "A B E",
    "num": "699O",
    "desc": "\nGuided graduate research in occupational safety.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Power and Machinery Engineering",
    "dept": "A B E",
    "num": "699P",
    "desc": "\nGuided graduate research in power and machinery engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Structures",
    "dept": "A B E",
    "num": "699Q",
    "desc": "\nGuided graduate research in structures.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Process Engineering",
    "dept": "A B E",
    "num": "699R",
    "desc": "\nGuided graduate research in process engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Environment and Natural Resources",
    "dept": "A B E",
    "num": "699S",
    "desc": "\nGuided graduate research in environment and natural resources.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Waste Management",
    "dept": "A B E",
    "num": "699U",
    "desc": "\nGuided graduate research in waste management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Orientation",
    "dept": "AGEDS",
    "num": "110",
    "desc": "\nOrientation to the department. Careers in agriculture.\n",
    "credits": "1"
  },
  {
    "course_name": "Agriculture and Life Sciences Education (Fall only)",
    "dept": "AGEDS",
    "num": "110A",
    "desc": "\nOrientation to the department. Careers in agriculture.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural Studies (Fall only)",
    "dept": "AGEDS",
    "num": "110B",
    "desc": "\nOrientation to the department. Careers in agriculture.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural and Life Sciences exploration",
    "dept": "AGEDS",
    "num": "110C",
    "desc": "\nOrientation to the department. Careers in agriculture.\n",
    "credits": "1"
  },
  {
    "course_name": "Dean s Leadership Seminar",
    "dept": "AGEDS",
    "num": "111",
    "desc": "Prereq: Permission of the Associate Dean for Academic Programs, College of Agriculture and Life Sciences\nIntroduction to leadership in agriculture and the life sciences, problem solving applied to current case studies, global perspective required by leaders, and designing programs to respond to societal  needs in the agricultural and life sciences.\n",
    "credits": "1"
  },
  {
    "course_name": "Agriculture Biotechnology Colloquium",
    "dept": "AGEDS",
    "num": "112",
    "desc": "Prereq: Enrollment as an agricultural excellence scholar\nThe scientific basis of biological and social sciences in agriculture.\n",
    "credits": "1"
  },
  {
    "course_name": "Access to Success Seminar I",
    "dept": "AGEDS",
    "num": "113",
    "desc": "\nCourse provides career skills, learning strategies and social and academic integration techniques to student members of Step Forward Learning Community. Utilization of campus resources, encouragement of self-exploration, and development of academic skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Initial Field Experience in Agricultural Education",
    "dept": "AGEDS",
    "num": "116",
    "desc": "Prereq: AGEDS majors only.\nField experience in a formal education setting designed to explore teaching as a career through guided observation and interviews, reflection, and on-campus dialogue.\n",
    "credits": "1"
  },
  {
    "course_name": "Early Field Based Experience",
    "dept": "AGEDS",
    "num": "211",
    "desc": "Prereq: AGEDS 110\nForty hours on-site in an agricultural setting. Students will have an opportunity outside the classroom for career guidance, role modeling, and reflection on their observations that they can apply to their courses and other educational experiences.\n",
    "credits": "1"
  },
  {
    "course_name": "High School Agriculture Programs",
    "dept": "AGEDS",
    "num": "211A",
    "desc": "Prereq: AGEDS 110\nForty hours on-site in an agricultural setting. Students will have an opportunity outside the classroom for career guidance, role modeling, and reflection on their observations that they can apply to their courses and other educational experiences.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural Industries and Agencies",
    "dept": "AGEDS",
    "num": "211C",
    "desc": "Prereq: AGEDS 110\nForty hours on-site in an agricultural setting. Students will have an opportunity outside the classroom for career guidance, role modeling, and reflection on their observations that they can apply to their courses and other educational experiences.\n",
    "credits": "1"
  },
  {
    "course_name": "Career Seminar",
    "dept": "AGEDS",
    "num": "215",
    "desc": "Prereq: Sophomore classification\nOverview of career opportunities. Evaluation of interests and accomplishments and setting career goals. Development of job search and interviewing skills. Establishing networks of job contacts.\n",
    "credits": "1"
  },
  {
    "course_name": "Foundations of Agricultural Education Programs",
    "dept": "AGEDS",
    "num": "310",
    "desc": "\nHistorical development of agricultural education programs. Philosophic premises, program goals and objectives. Educational and social issues impacting the implementation of agricultural education programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Presentation and Sales Strategies for Agricultural Audiences",
    "dept": "AGEDS",
    "num": "311",
    "desc": "\nUtilizing instructional methods, techniques, and problem solving, presentation and sales strategies with agricultural audiences.\n",
    "credits": "3"
  },
  {
    "course_name": "Science With Practice",
    "dept": "AGEDS",
    "num": "312",
    "desc": "Prereq: College of Agriculture and Life Sciences majors only\nA planned learning experience wherein each student and faculty mentor develops a learning agreement that encompasses specific activities and expectations. Students are engaged in reflective activities that include journals, micro-reflections, formal presentations, and a comprehensive portfolio.\n",
    "credits": "3"
  },
  {
    "course_name": "Personal, Professional, and Entrepreneurial Leadership in Agriculture",
    "dept": "AGEDS",
    "num": "315",
    "desc": "\nLeadership principles and strategies to influence and motivate team members to achieve personal, professional, and entrepreneurial goals in production agriculture, agricultural education, and agricultural organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of Agriculture and Life Sciences Communication",
    "dept": "AGEDS",
    "num": "327",
    "desc": "Prereq: ENGL 250 or equivalent.\nDevelopment of written, oral, visual and electronic communications relevant to agriculture and life sciences. Students develop a set of communication skills applicable to agriculture and life science contexts and for various audiences.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Mechanics Applications",
    "dept": "AGEDS",
    "num": "388",
    "desc": "\nIntroduction to SMAW (Arc), GMAW (Mig), GTAW (Tig), Oxy-Fuel welding, Oxy-Fuel cutting, and Plasma cutting theories and applications. Emphasis will be on theoretical foundation of welding, safety, welding skill development, and management of equipment, and materials. Introduction to small engines and applications. Emphasis will be on theory of operating systems, maintenance, troubleshooting, failure analysis, and safety.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "AGEDS",
    "num": "398",
    "desc": "Prereq: Permission of the department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Planning Agriculture and Life Sciences Education Programs",
    "dept": "AGEDS",
    "num": "401",
    "desc": "Prereq: AGEDS 310\nResponsibilities of an agricultural education teacher, curriculum development, experiential learning opportunities including FFA and SAE, and assessment and maintenance of program quality.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Teaching in Agriculture and Life Sciences",
    "dept": "AGEDS",
    "num": "402",
    "desc": "Prereq: Concurrent enrollment in AGEDS 401\nTopics include: principles of teaching and learning, individualized and group methods, application of learning, instructional management, special populations, and evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Internship in Agricultural Education and Studies",
    "dept": "AGEDS",
    "num": "412",
    "desc": "Prereq: Junior classification in AGEDS and permission of instructor\nA supervised two to twelve week learning experience in an approved learning setting with application to educational, agricultural, communications and/or environmental practices and principles.\n",
    "credits": "2"
  },
  {
    "course_name": "Developing Agricultural Education Programs in Non-Formal Settings",
    "dept": "AGEDS",
    "num": "414",
    "desc": "\nBasic concepts in planning, conducting, and evaluating educational programs in non-formal settings. Includes programming for youth and adults in Extension, agricultural industry, and related agencies.\n",
    "credits": "2"
  },
  {
    "course_name": "Pre-Student Teaching Experience in Agricultural Education",
    "dept": "AGEDS",
    "num": "416",
    "desc": "Prereq: AGEDS 211, AGEDS 402 and admission to teacher education program\nA forty hour field-based experience in an approved secondary agricultural education program. Concurrent enrollment in 417 is required.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Teaching in Agriculture and Life Sciences",
    "dept": "AGEDS",
    "num": "417",
    "desc": "Prereq: AGEDS 211, AGEDS 402 and admission to teacher education program\nSupervised teaching in public schools.\n",
    "credits": "1"
  },
  {
    "course_name": "Farm Management and Operation",
    "dept": "AGEDS",
    "num": "450",
    "desc": "Prereq: ECON 235, ECON 230, junior classification\nParticipation in the management and operation of a diversified Iowa farm. The class is responsible for the plans, records, and decisions for buying and selling the farm's livestock, crops, and equipment. Special speakers on current topics. May be taken for credit 3 times at different times of the year with permission of the instructor.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Law",
    "dept": "AGEDS",
    "num": "451",
    "desc": "Prereq: Senior classification\nThe legal framework impinging upon decision-making by firms, families, and individuals, real and personal property, contracts, secured transactions, negotiable instruments, debtor-creditor relations, bankruptcy, farm income tax organization of firms, intergenerational property transfers, trusts and farm estate planning, civil and criminal liabilities, environmental law, federal and state regulatory powers.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology Transfer and the Role of Agricultural and Extension Education",
    "dept": "AGEDS",
    "num": "461",
    "desc": "\nImpact of agricultural and extension education processes on development and their role in the transfer of agricultural technology. Utilizing situational analysis techniques to analyze and solve problems in international agricultural education programs.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Agri-Marketing and Communications Competition",
    "dept": "AGEDS",
    "num": "475",
    "desc": "Prereq: Admission by invitation.\nSpecialized training in communication and agricultural marketing knowledge and skills in preparation for intercollegiate competition.\n  Maximum of 6 credits can be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Methods of Teaching Agricultural Mechanics",
    "dept": "AGEDS",
    "num": "488",
    "desc": "\nMethods and management techniques in agricultural mechanics laboratories. Emphasis will be on safety, mechanical skills development and management of students, facilities, equipment, and materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Agricultural Education and Studies",
    "dept": "AGEDS",
    "num": "490",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Philosophy, Curriculum, and Methods",
    "dept": "AGEDS",
    "num": "490A",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Leadership, Evaluation, and Administration",
    "dept": "AGEDS",
    "num": "490B",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Business, Industry, and Production Agriculture",
    "dept": "AGEDS",
    "num": "490C",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Extension and International Agriculture",
    "dept": "AGEDS",
    "num": "490D",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Instructional Technology",
    "dept": "AGEDS",
    "num": "490E",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Environmental Issues",
    "dept": "AGEDS",
    "num": "490F",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Entrepreneurship",
    "dept": "AGEDS",
    "num": "490G",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study in Agricultural Education and Studies, Honors",
    "dept": "AGEDS",
    "num": "490H",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Communications",
    "dept": "AGEDS",
    "num": "490I",
    "desc": "Prereq: Junior or senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural Travel Course",
    "dept": "AGEDS",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study agriculture and education related topics. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "International",
    "dept": "AGEDS",
    "num": "496A",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study agriculture and education related topics. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Domestic",
    "dept": "AGEDS",
    "num": "496B",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study agriculture and education related topics. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "AGEDS",
    "num": "499",
    "desc": "Prereq: Permission of instructor, adviser, and departmental chair\nResearch experience in agricultural education and studies with application to selected problems.\n",
    "credits": "arr"
  },
  {
    "course_name": "Planning Agriculture and Life Sciences Education Programs",
    "dept": "AGEDS",
    "num": "501",
    "desc": "Prereq: AGEDS 310\nResponsibilities of an agricultural education teacher, curriculum development, experiential learning opportunities including FFA and SAE, and assessment and maintenance of program quality.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Teaching in Agriculture and Life Sciences",
    "dept": "AGEDS",
    "num": "502",
    "desc": "Prereq: Concurrent enrollment in AGEDS 401\nTopics include: principles of teaching and learning, individualized and group methods, application of learning, instructional management, special populations, and evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Research in Agricultural Education",
    "dept": "AGEDS",
    "num": "510",
    "desc": "Prereq: Graduate classification\nDetermining your research focus; developing research problems and objectives; reviewing the literature and establishing a theoretical framework; establishing procedures for data collection and analysis; ethical issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Agricultural Presentation Practices",
    "dept": "AGEDS",
    "num": "511",
    "desc": "Prereq: Graduate Classification\nThe identification and use of key planning, delivery and evaluation of presentations using audience engagement techniques focused on research-based principles and field-based practices of professional presenters in agriculture and the life sciences.\n",
    "credits": "3"
  },
  {
    "course_name": "Student Teacher Education Practicum",
    "dept": "AGEDS",
    "num": "517",
    "desc": "Prereq: AGEDS 590B, AGEDS 501, AGEDS 502 Admission to the University Teacher Education program\nSupervised 5th-12th grade public and private schools teaching practicum for graduate students in Masters degree teacher certification program.\n  NA",
    "credits": "2"
  },
  {
    "course_name": "Instructional Methods for Adult and Higher Education in Agriculture and Natural Resources",
    "dept": "AGEDS",
    "num": "520",
    "desc": "Prereq: Graduate classification\nTheory and practice of adult education.  Teaching and learning in formal and non-formal instructional programs for adult learners.\n",
    "credits": "3"
  },
  {
    "course_name": "Program Development and Evaluation in Agricultural and Extension Education",
    "dept": "AGEDS",
    "num": "524",
    "desc": "Prereq: Graduate classification\nTheories and practice of program planning for nonformal education.  Addresses use of program logic modeling and considers critical theories of planning to address power and interests in program development, needs assessment, and evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Learning Theory in Agricultural Education",
    "dept": "AGEDS",
    "num": "533",
    "desc": "Prereq: Graduate classification\nIntroduction to a variety of theoretical perspectives of learning and how they may be used within the context of agricultural education.  Emphasis will be on the major domains of learning, developmental considerations, basic assumptions, concepts, and principles of various learning theories; understanding how each theoretical perspective may be used in both formal and non-formal educational settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Agricultural Education",
    "dept": "AGEDS",
    "num": "550",
    "desc": "Prereq: Graduate classification\nPhilosophical premises, ethical principles, historical development, contextual applications, and knowledge bases for agricultural education.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology Transfer and the Role of Agricultural and Extension Education",
    "dept": "AGEDS",
    "num": "561",
    "desc": "\nImpact of agricultural and extension education processes on development and their role in the transfer of agricultural technology. Utilizing situational analysis techniques to analyze and solve problems in international agricultural education programs.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Agricultural Education",
    "dept": "AGEDS",
    "num": "590",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Curriculum",
    "dept": "AGEDS",
    "num": "590A",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Methods",
    "dept": "AGEDS",
    "num": "590B",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Philosophy",
    "dept": "AGEDS",
    "num": "590C",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Evaluation",
    "dept": "AGEDS",
    "num": "590D",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Administration",
    "dept": "AGEDS",
    "num": "590E",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Leadership",
    "dept": "AGEDS",
    "num": "590F",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Guidance",
    "dept": "AGEDS",
    "num": "590G",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Instructional Technology",
    "dept": "AGEDS",
    "num": "590I",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Extension",
    "dept": "AGEDS",
    "num": "590J",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "International Agriculture",
    "dept": "AGEDS",
    "num": "590K",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Program Planning",
    "dept": "AGEDS",
    "num": "590L",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Agricultural Education",
    "dept": "AGEDS",
    "num": "593",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Curriculum",
    "dept": "AGEDS",
    "num": "593A",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Methods",
    "dept": "AGEDS",
    "num": "593B",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Evaluation",
    "dept": "AGEDS",
    "num": "593C",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Administration",
    "dept": "AGEDS",
    "num": "593D",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Leadership",
    "dept": "AGEDS",
    "num": "593E",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Extension",
    "dept": "AGEDS",
    "num": "593F",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Program Planning",
    "dept": "AGEDS",
    "num": "593G",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Instructional Technology",
    "dept": "AGEDS",
    "num": "593H",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Biotechnology Workshop",
    "dept": "AGEDS",
    "num": "593M",
    "desc": "Prereq: 12 credits in agricultural education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "AGEDS",
    "num": "599",
    "desc": "\nFor nonthesis masters degree programs.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Agricultural Education",
    "dept": "AGEDS",
    "num": "615",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Writing for publication",
    "dept": "AGEDS",
    "num": "615A",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Ethics",
    "dept": "AGEDS",
    "num": "615B",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Grant writing",
    "dept": "AGEDS",
    "num": "615C",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Career planning",
    "dept": "AGEDS",
    "num": "615D",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Contemporary issues",
    "dept": "AGEDS",
    "num": "615E",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Internship for Agricultural Educators",
    "dept": "AGEDS",
    "num": "617",
    "desc": "Prereq: Permission of instructor\nAnalysis of the roles and activities of professionals in agricultural education. Supervised professional field-based experience in public and private settings.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Leadership, Administration, Supervision and Management of Agricultural Education Programs",
    "dept": "AGEDS",
    "num": "625",
    "desc": "Prereq: Graduate classification\nPrinciples and best practices for leading, administering, supervising, and managing agricultural education programs.  Analyzing selected case studies that apply theory to practice in agricultural situations.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "AGEDS",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Leadership Experience",
    "dept": "AGRON",
    "num": "105",
    "desc": "\nA participatory experience in activities or completion of a course that enhances the development of leadership and group-dynamic skills. See adviser for departmental requirements.\n",
    "credits": "R"
  },
  {
    "course_name": "Professional Development in Agronomy: Orientation",
    "dept": "AGRON",
    "num": "110",
    "desc": "\nOrientation to college life, the profession of agronomy, and the agronomy curriculum.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Renewable Resources",
    "dept": "AGRON",
    "num": "120",
    "desc": "\nOverview of soil, water, plants, and animals as renewable natural resources in an ecosystem context. History and organization of resource management. Concepts of integrated resource management.\n",
    "credits": "3"
  },
  {
    "course_name": "Water Resources of the World",
    "dept": "AGRON",
    "num": "160",
    "desc": "\nStudy of the occurrence, history, development, and management of world water resources.  Basic hydrologic principles including climate, surface water, groundwater, and water quality.  Historical and current perspectives on water policy, use, and the role of water in society and the environment.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Agriculture in a Changing World",
    "dept": "AGRON",
    "num": "180",
    "desc": "\nA scientific investigation of the global distribution of climate, soils and agricultural production and consumption. Physical processes that connect natural resources to agriculture and the environment. How global change drives increasing demand for agricultural production.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Crop Science",
    "dept": "AGRON",
    "num": "181",
    "desc": "\nBasic structure and function of plants, origin and classification, growth and development. Fundamentals of photosynthesis, plant water use, plant nutrition and genetics that regulate plant growth, development and responses to the environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Soil Science",
    "dept": "AGRON",
    "num": "182",
    "desc": "Prereq: CHEM 163\nIntroduction to physical, chemical, and biological properties of soils; soil formation, classification and global distribution; soil health, soils and humanity and sustainable land management.\n",
    "credits": "3"
  },
  {
    "course_name": "Basic Skills for Agronomists",
    "dept": "AGRON",
    "num": "183",
    "desc": "\nDeveloping the skills that agronomists employ in their work with crops, soil, and the environment through activities involving tools and methodologies used by agronomists.  Enrollment is restricted to first-year students majoring in agronomy.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Weather and Climate",
    "dept": "AGRON",
    "num": "206",
    "desc": "\nBasic concepts in weather and climate, including atmospheric measurements, radiation, stability, precipitation, winds, fronts, forecasting, and severe weather. Applied topics include global warming, ozone depletion, world climates and weather safety.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Development in Agronomy: Career Planning",
    "dept": "AGRON",
    "num": "210",
    "desc": "Prereq: Sophomore classification\nCareer planning, résumé and cover letter preparation, and interviewing techniques. Career orientation through invited speakers.\n",
    "credits": "1"
  },
  {
    "course_name": "Weed Identification",
    "dept": "AGRON",
    "num": "217",
    "desc": "Prereq: BIOL 101 or equivalent\nHalf-semester course. Identification of important weeds of agricultural, horticultural and native ecosystems.  Principles of plant taxonomy and classification.  Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Organic Compounds in Plants and Soils",
    "dept": "AGRON",
    "num": "259",
    "desc": "Prereq: CHEM 163, BIOL 212, MATH 140, AGRON 182\nStructure, function, and transformations of organic compounds significant in plant and soil environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Field Exploration of Agronomy",
    "dept": "AGRON",
    "num": "279",
    "desc": "Prereq: AGRON 181 or equivalent and AGRON 182 or equivalent\nField-based investigation of Iowa’s agronomic systems.  Application of principles learned in introductory soils, crops and agronomy courses. For students majoring in Agronomy.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop Development, Production and Management",
    "dept": "AGRON",
    "num": "280",
    "desc": "Prereq: AGRON 181 or equivalent and AGRON 182 or equivalent\nOverview of crops and cropping systems in the context of global and US agriculture.  Focus on agronomic principles, constraints and opportunities as they apply to various locations in Iowa, the USA and the world.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop Physiology",
    "dept": "AGRON",
    "num": "281",
    "desc": "Prereq: AGRON 181 or equivalent\nScience governing plant growth and development in the context of cropping and genetic improvements.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil Conservation and Land Use",
    "dept": "AGRON",
    "num": "282",
    "desc": "Prereq: AGRON 182 or equivalent\nPrinciples of soil conservation and land use with emphasis on best management practices and use of soil maps and databases such as Web Soil Survey.\n",
    "credits": "3"
  },
  {
    "course_name": "Pesticide Application Certification",
    "dept": "AGRON",
    "num": "283",
    "desc": "\nCore background and specialty topics in agricultural, and horticultural pesticide applicator certification. Students can select certification categories and have the opportunity to obtain pesticide applicator certification at the completion of the course. Commercial pesticide applicator certification is emphasized.\n",
    "credits": "2"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "AGRON",
    "num": "298",
    "desc": "Prereq: Permission of faculty member or student's adviser, sophomore classification\nStudents register for this course in order to retain full-time status while on a professional work experience.  Students must register for this course prior to commencing each work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Professional Development in Agronomy: Work Experience",
    "dept": "AGRON",
    "num": "310",
    "desc": "\nProfessional work experience in agronomy. See adviser for departmental requirements.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Professional Internship in Agronomy",
    "dept": "AGRON",
    "num": "311",
    "desc": "Prereq: Permission of adviser\nA supervised learning experience in a professional setting related to crop production, plant breeding, soil science or environmental science. For students majoring in Agronomy.\n",
    "credits": "1"
  },
  {
    "course_name": "Crop Structure-Function Relationships",
    "dept": "AGRON",
    "num": "316",
    "desc": "Prereq: BIOL 212 recommended\nBasic principles concerning the growth, development, and production of crop communities in relation to their environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Weed Science",
    "dept": "AGRON",
    "num": "317",
    "desc": "\nBiology and ecology of weeds. Interactions between weeds and crops. Principles and practices of integrated weed management systems. Herbicide mechanisms, classification, and fate in plants and soils.\n",
    "credits": "3"
  },
  {
    "course_name": "Genetics, Agriculture and Biotechnology",
    "dept": "AGRON",
    "num": "320",
    "desc": "Prereq: BIOL 212\nTransmission and molecular genetics with an emphasis on applications in agriculture, the structure and expression of the gene, how genes behave in populations and how recombinant DNA technology can be used to improve agriculture.\n  Credit for graduation will not be allowed for more than one of the following: Gen 260, 313, 320 and Biol 313 and 313L.",
    "credits": "3"
  },
  {
    "course_name": "Crop and Seed Identification Laboratory",
    "dept": "AGRON",
    "num": "330",
    "desc": "Prereq: AGRON 181 or equivalent.\nIdentification, agronomic and binomial classification of crops, weeds, and diseases. Analysis of crop seed samples for contaminants of weed and other crop seeds.\n",
    "credits": "2"
  },
  {
    "course_name": "Intercollegiate Crops Team",
    "dept": "AGRON",
    "num": "331",
    "desc": "Prereq: Permission of instructor. AGRON 330 recommended\nIntensive training in preparation for intercollegiate competition in national crops contests.\n",
    "credits": "2"
  },
  {
    "course_name": "Forage Crop Management",
    "dept": "AGRON",
    "num": "334",
    "desc": "Prereq: AGRON 181 or equivalent\nProduction and management of forage crops; concepts applied to yield, quality, and stand persistence; systems of forage utilization including grazing, hay, and silage. Students enrolling for graduate credit will be expected to complete an additional class project.\n",
    "credits": "3"
  },
  {
    "course_name": "Seed Science and Technology",
    "dept": "AGRON",
    "num": "338",
    "desc": "Prereq: AGRON 181 (or equivalent) or HORT 221; BIOL 212\nSeed production, maturation, dormancy, vigor, deterioration, and related aspects of enhancement, conditioning, storage, and quality evaluation. Aspects of the seed industry and regulation of seed marketing.\n",
    "credits": "3"
  },
  {
    "course_name": "World Food Issues: Past and Present",
    "dept": "AGRON",
    "num": "342",
    "desc": "Prereq: Junior classification\nIssues associated with global agricultural and food systems including ethical, social, economic, environmental, and policy contexts. Investigation of various causes and consequences of overnutrition/undernutrition, poverty, hunger, access, and distribution.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "World Food Issues: Past and Present, Honors",
    "dept": "AGRON",
    "num": "342H",
    "desc": "Prereq: Junior classification\nIssues in the agricultural and food systems of the developed and developing world. Emphasis on economic, social, historical, ethical and environmental contexts. Causes and consequences of overnutrition/undernutrition, poverty, hunger and access/distribution. Explorations of current issues and ideas for the future. Team projects.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Turfgrass Establishment and Management",
    "dept": "AGRON",
    "num": "351",
    "desc": "Prereq: HORT 221 or AGRON 181 (or equivalent) or BIOL 211\nPrinciples and practices of turfgrass propagation, establishment, and management. Specialized practices relative to professional lawn care, golf courses, athletic fields, highway roadsides, and seed and sod production. The biology and control of turfgrass pests.\n",
    "credits": "3"
  },
  {
    "course_name": "Turfgrass Establishment and Management Laboratory",
    "dept": "AGRON",
    "num": "351L",
    "desc": "Prereq: Credit or enrollment in HORT 351\nThose enrolled in the horticulture curriculum are required to take 351L in conjunction with 351 except by permission of the instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Soils and Plant Growth",
    "dept": "AGRON",
    "num": "354",
    "desc": "Prereq: AGRON 182 or equivalent and BIOL 101\nEffects of chemical, physical, and biological properties of soils on plant growth, with emphasis on nutritive elements, pH, organic matter maintenance, and rooting development.\n",
    "credits": "3"
  },
  {
    "course_name": "Soils and Plant Growth Laboratory",
    "dept": "AGRON",
    "num": "354L",
    "desc": "Prereq: Agron or Hort major with credit or enrollment in AGRON 354\nLaboratory exercises in soil testing that assess a soil's ability to support nutritive requirements for plant growth.\n",
    "credits": "1"
  },
  {
    "course_name": "Environmental Soil Science",
    "dept": "AGRON",
    "num": "360",
    "desc": "Prereq: AGRON 182 (or equivalent) or ENSCI 250 or GEOL 201\nApplication of soil science to contemporary environmental problems; comparison of the impacts that different management strategies have on short- and long-term environmental quality and land development. Emphasis on participatory learning activities.\n",
    "credits": "3"
  },
  {
    "course_name": "Field Experience in Soil Description and Interpretation",
    "dept": "AGRON",
    "num": "370",
    "desc": "Prereq: AGRON 182 or equivalent and permission of instructor\nDescription and interpretation of soils in the field and laboratory, emphasizing hands-on experience. Evaluation of soil information for land use. Students may participate in intercollegiate judging contests.\n",
    "credits": "1"
  },
  {
    "course_name": "Agronomic Sciences in Theory and Practice",
    "dept": "AGRON",
    "num": "388",
    "desc": "Prereq: Junior or senior classification\nHow science works: Hypotheses, data integrity, classification, interpretations, ethics, and communications.\n",
    "credits": "1"
  },
  {
    "course_name": "Systems Analysis in Crop and Soil Management",
    "dept": "AGRON",
    "num": "392",
    "desc": "Prereq: AGRON 316 and AGRON 354\nManagement strategies at the level of the farm field. Emphasis will be on participatory learning activities.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "AGRON",
    "num": "398",
    "desc": "Prereq: Permission of faculty member or student's adviser; junior classification\nStudent register for this course in order to retain full-time status while on a professional work experience. The student must register for this course prior to commencing each work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Watershed Hydrology and Surficial Processes",
    "dept": "AGRON",
    "num": "402I",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nEffects of geomorphology, soils, and land use on transport of water and materials (nutrients, contaminates) in watersheds. Fieldwork will emphasize investigations of the Iowa Great Lakes watershed.\n",
    "credits": "4"
  },
  {
    "course_name": "Global Change",
    "dept": "AGRON",
    "num": "404",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nRecent changes in global biogeochemical cycles and climate; models of future changes in the climate system; impacts of global change on agriculture, water resources and human health; ethical issues of global environmental change.  Also offered online Alt. F, even-numbered years.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biophysics",
    "dept": "AGRON",
    "num": "405",
    "desc": "Prereq: MATH 165 and some exposure to computer programming (any language)\nThe movement of energy and mass among the soil, vegetation, and atmosphere.  The heat and water budget of humans, other animals, plants, and plant communities.  Relevance to weather and climate, the effect of climate change on organisms, and remote sensing.\n",
    "credits": "3"
  },
  {
    "course_name": "World Climates",
    "dept": "AGRON",
    "num": "406",
    "desc": "Prereq: AGRON 206/MTEOR 206\nDistribution and causes of different climates around the world. Effects of climate and climate variations on human activities including society, economy and agriculture. Current issues such as climate change and international efforts to assess and mitigate the consequences of a changing climate.  Semester project and in-class presentation required.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Mesoscale Meteorology",
    "dept": "AGRON",
    "num": "407",
    "desc": "Prereq: MATH 166 and MTEOR 443\nArritt, Gallus. Physical nature and practical consequences of mesoscale atmospheric phenomena. Mesoscale convective systems, fronts, terrain-forced circulations. Observation, analysis, and prediction of mesoscale atmospheric structure.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Development in Agronomy: Senior Forum",
    "dept": "AGRON",
    "num": "410",
    "desc": "Prereq: Senior classification, AGRON 210\nDevelopment of an appropriate content for professionalism. Topics include professional certification, ethics, and maintaining an active network of information sources and professional contacts in support of lifelong learning. Student interpretation, writings, presentations, and discussions.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Plant Breeding",
    "dept": "AGRON",
    "num": "421",
    "desc": "Prereq: GEN 320 or BIOL 313\nFundamental principles of plant breeding and cultivar development, breeding methods for self-pollinated, cross-pollinated and clonal crops.\n",
    "credits": "3"
  },
  {
    "course_name": "International Issues and Challenges in Sustainable Development",
    "dept": "AGRON",
    "num": "446",
    "desc": "Prereq: 3-credit biology course, Sophomore or higher classification, permission of Instructor\nInterdisciplinary study and analysis of agricultural systems, sustainable management, and impact on plants and animal biodiversity. International field experience in evaluating different agricultural systems and impact on biodiversity may be required. A program fee is charged to students for international study abroad.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Issues in Sustainable Agriculture",
    "dept": "AGRON",
    "num": "450",
    "desc": "\nAgricultural science as a human activity; contemporary agricultural issues from agroecological perspective. Comparative analysis of intended and actual consequences of development of industrial agricultural practices.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists",
    "dept": "AGRON",
    "num": "452",
    "desc": "Prereq: GEOL 100, GEOL 201 or equivalent\nIntroduction to geographic information systems (GIS) with particular emphasis on geoscientific data. Uses ESRI's ArcGIS Desktop Software and extension modules. Emphasizes typical GIS operations and analyses in the geosciences to prepare students for advanced GIS courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Soil and Water Chemistry",
    "dept": "AGRON",
    "num": "459",
    "desc": "Prereq: Two semesters of college-level chemistry, MATH 140, AGRON 182 (or equivalent) or AGRON 360; GEOL 100 and AGRON 354 recommended\nAn introduction to the chemical properties of soils, chemical reactions and transformations in soils and surface waters, and their impact on the environment. Topics include solution chemistry in soils and surface waters, solid-phase composition of soils, reactions at the solid-solution interface, and applications to contemporary environmental issues.\n",
    "credits": "4"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "AGRON",
    "num": "463",
    "desc": "Prereq: AGRON 182 (or equivalent) or AGRON 260\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use. Two weekend field trips.\n  Credit for one of AGRON 463 or AGRON 463I may be applied for graduation.",
    "credits": "3"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "AGRON",
    "num": "463I",
    "desc": "Prereq: AGRON 182 (or equivalent)\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use.\n  Credit for only Agron 563 or 563I may be applied for graduation.",
    "credits": "2"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships Laboratory",
    "dept": "AGRON",
    "num": "463L",
    "desc": "Prereq: Credit or enrollment in AGRON 463\nLaboratory exercise in soil formation with landscape relationships including pedon description with soil mapping.\n",
    "credits": "1"
  },
  {
    "course_name": "Soil Physics",
    "dept": "AGRON",
    "num": "477",
    "desc": "Prereq: AGRON 182 or equivalent and MATH 166 recommended\nThe physical soil system: the soil components and their physical interactions; transport processes involving water, air, and heat.\n",
    "credits": "3"
  },
  {
    "course_name": "Organic Agricultural Theory and Practice",
    "dept": "AGRON",
    "num": "484",
    "desc": "Prereq: 9 cr. in biological or physical sciences\nUnderstanding of the historical origins and ecological theories underpinning the practices involved in organic agriculture. Interdisciplinary examination of crop and livestock production and socio-economic processes and policies in organic agriculture from researcher and producer perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil and Environmental Microbiology",
    "dept": "AGRON",
    "num": "485",
    "desc": "Prereq: AGRON 182 or equivalent; MICRO 201 and MICRO 201L recommended\nThe living organisms in the soil and what they do. Emphasis on soil biota composition, the carbon cycle and bioremediation, soil-plant-microbial relationships, and environmental issues.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists II",
    "dept": "AGRON",
    "num": "488",
    "desc": "Prereq: GIS course, such as GEOL 452, CRP 451, CRP 452, NREM 345, NREM 446, AE 408 or equivalent\nGIS course with focus on the spatial analysis and modeling of raster data and triangulated irregular network (TIN) data. Uses ArcGIS and various extensions, such as Spatial Analyst, 3D Analyst, and ArcScene. Includes practical exercises during lectures, lab exercises, homework assignments, and (for GEOL 588) a class project.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "AGRON",
    "num": "490",
    "desc": "Prereq: Junior or senior classification with at least 8 credits in agronomy; permission of instructor in specialty area after consultation\nSelected studies in crops, soils, or agricultural meteorology according to the needs and interests of the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "AGRON",
    "num": "490E",
    "desc": "Prereq: Junior or senior classification with at least 8 credits in agronomy; permission of instructor in specialty area after consultation\nSelected studies in crops, soils, or agricultural meteorology according to the needs and interests of the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: General",
    "dept": "AGRON",
    "num": "490G",
    "desc": "Prereq: Junior or senior classification with at least 8 credits in agronomy; permission of instructor in specialty area after consultation\nSelected studies in crops, soils, or agricultural meteorology according to the needs and interests of the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "AGRON",
    "num": "490H",
    "desc": "Prereq: Junior or senior classification with at least 8 credits in agronomy; permission of instructor in specialty area after consultation\nSelected studies in crops, soils, or agricultural meteorology according to the needs and interests of the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Service Learning",
    "dept": "AGRON",
    "num": "490Z",
    "desc": "Prereq: Junior or senior classification with at least 8 credits in agronomy; permission of instructor in specialty area after consultation\nSelected studies in crops, soils, or agricultural meteorology according to the needs and interests of the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Seed Science Internship Experience",
    "dept": "AGRON",
    "num": "491",
    "desc": "Prereq: AGRON 338, advanced approval and participation of employer and instructor\nA professional work experience and creative project for seed science secondary majors. The project requires the prior approval and participation of the employer and instructor. The student must submit a written report.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Agronomy",
    "dept": "AGRON",
    "num": "493",
    "desc": "Prereq: Permission of instructor\nWorkshop experience in crops, soils, or agricultural meteorology.\n",
    "credits": "arr"
  },
  {
    "course_name": "Agricultural Travel Course",
    "dept": "AGRON",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Tour and study of production methods in major crop and livestock regions of the world. Influence of climate, economics, geography, soils, landscapes, markets, and other factors on crop and livestock production. Location and duration of tours will vary. Tour expenses paid by students. Check with department for current offerings.\n",
    "credits": "arr"
  },
  {
    "course_name": "International Tour",
    "dept": "AGRON",
    "num": "496A",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Tour and study of production methods in major crop and livestock regions of the world. Influence of climate, economics, geography, soils, landscapes, markets, and other factors on crop and livestock production. Location and duration of tours will vary. Tour expenses paid by students. Check with department for current offerings.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Domestic Tour",
    "dept": "AGRON",
    "num": "496B",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Tour and study of production methods in major crop and livestock regions of the world. Influence of climate, economics, geography, soils, landscapes, markets, and other factors on crop and livestock production. Location and duration of tours will vary. Tour expenses paid by students. Check with department for current offerings.\n",
    "credits": "arr"
  },
  {
    "course_name": "Agroecology Field Course",
    "dept": "AGRON",
    "num": "497",
    "desc": "Prereq: Jr. or Sr. classification with at least 8 credits in Agronomy\nA one-week intensive class, offered off-campus. Student will visit farms within the Midwest and analyze the sustainability of each farm.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "AGRON",
    "num": "498",
    "desc": "Prereq: Permission of faculty member or student's adviser; senior classification\nStudents register for this course in order to retain full-time status while on a professional work experience.  Students must register for this course prior to commencing each work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Orientation Seminar",
    "dept": "AGRON",
    "num": "500",
    "desc": "Prereq: International agronomy graduate students only\nAn introduction to Iowa and U.S. agriculture for international scholars in agronomic majors. Field trips when possible. Departmental role in the functioning of research, teaching, and extension in fulfilling the charge given the land-grant university.\n",
    "credits": "1"
  },
  {
    "course_name": "Crop Growth and Development",
    "dept": "AGRON",
    "num": "501",
    "desc": "Prereq: AGRON 181 or equivalent, MATH 140, CHEM 163, BIOL 101\nPhysiological processes in crop growth, development and yield: photosynthesis, respiration, water relations, mineral nutrition, assimilate partitioning, seedling vigor, light interception and canopy growth, root growth, reproduction and yield. Required course for the Master of Science in Agronomy degree program and Agronomy Graduate Certificate program.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemistry, Physics, and Biology of Soils",
    "dept": "AGRON",
    "num": "502",
    "desc": "Prereq: AGRON 181 or equivalent, AGRON 182 or equivalent, BIOL 101, CHEM 163, MATH 140\nSoil chemical, physical, and biological properties that control processes within the soil, their influence on plant/soil interactions, and soil classification. Basic concepts in soil science and their applications. Required course for the Master of Science in Agronomy degree program and Agronomy Graduate Certificate program.\n",
    "credits": "3"
  },
  {
    "course_name": "Climate and Crop Growth",
    "dept": "AGRON",
    "num": "503",
    "desc": "Prereq: AGRON 181 or equivalent and MATH 140\nApplied concepts in climate and agricultural meteorology with emphasis on the climate-agriculture relationship and the microclimate-agriculture interaction and crop risk management. Basic meteorological principles are also presented to support these applied concepts. Required course for the Master of Science in Agronomy degree program and Agronomy Graduate Certificate program.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Change",
    "dept": "AGRON",
    "num": "504",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nRecent changes in global biogeochemical cycles and climate; models of future changes in the climate system; impacts of global change on agriculture, water resources and human health; ethical issues of global environmental change.  Also offered online Alt. F, even-numbered years.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biophysics",
    "dept": "AGRON",
    "num": "505",
    "desc": "Prereq: MATH 165 and some exposure to computer programming (any language)\nThe movement of energy and mass among the soil, vegetation, and atmosphere.  The heat and water budget of humans, other animals, plants, and plant communities.  Relevance to weather and climate, the effect of climate change on organisms, and remote sensing.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop Genetics",
    "dept": "AGRON",
    "num": "506",
    "desc": "\nIntroduction to genetics of reproductive systems, recombination, segregation and linkage analysis, inbreeding, quantitative inheritance, fertility regulation, and polyploidy to prepare students for subsequent courses in crop improvement. Enrollment is restricted to off-campus MS in Plant Breeding students.\n",
    "credits": "3"
  },
  {
    "course_name": "Mesoscale Meteorology",
    "dept": "AGRON",
    "num": "507",
    "desc": "Prereq: MATH 166 and MTEOR 454\nThe physical nature and practical consequences of mesoscale atmospheric phenomena. Mesoscale convective systems, fronts, terrain-forced circulations. Observation, analysis, and prediction of mesoscale atmospheric structure. Semester project and in-class presentation required.\n",
    "credits": "3"
  },
  {
    "course_name": "Biophysical Crop Ecology",
    "dept": "AGRON",
    "num": "508",
    "desc": "\nThe physics behind how humans use plant photosynthesis to convert energy from the sun into useful products. Techniques for quantifying and predicting ecological interactions in the soil-plant-atmosphere continuum.\n",
    "credits": "3"
  },
  {
    "course_name": "Agroecosystems Analysis",
    "dept": "AGRON",
    "num": "509",
    "desc": "Prereq: Senior or above classification; permission of instructor\nExperiential, interdisciplinary examination of Midwestern agricultural and food systems, emphasizing both field visits and classroom activities. Focus on understanding multiple elements, perspectives (agronomic, economic, ecological, social, etc.), and scales of operation.\n",
    "credits": "4"
  },
  {
    "course_name": "Crop Improvement",
    "dept": "AGRON",
    "num": "510",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nA study of the basic principles and methods in the genetic improvement of crop plants. Methods used in manipulating genomes through the use of biotechnology. Methods of cultivar development.  Quantitative procedures for describing response to selection. Analysis of the relationship of reproductive characters and growth characteristics to response to selection.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop Improvement",
    "dept": "AGRON",
    "num": "511",
    "desc": "Prereq: AGRON 181 or equivalent, MATH 140, CHEM 163, BIOL 101\nBasic principles in the genetic improvement of crop plants. Methods of cultivar development in self-pollinated and cross-pollinated crop species. Required course for the Master of Science in agronomy degree program and agronomy graduate certificate program.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil-Plant Environment",
    "dept": "AGRON",
    "num": "512",
    "desc": "Prereq: AGRON 502. Recommended AGRON 501\nSoil properties and their impact on soil/plant relationships. Soil structure, aeration, moisture, and nutrients will be discussed in the context of soil fertility and environmental quality management. Required course for the Master of Science in agronomy degree program and agronomy graduate certificate program.\n",
    "credits": "3"
  },
  {
    "course_name": "Quantitative Methods for Agronomy",
    "dept": "AGRON",
    "num": "513",
    "desc": "Prereq: AGRON 181 or equivalent, MATH 140, STAT 104\nQuantitative methods for analyzing and interpreting agronomic information. Principles of experimental design, hypothesis testing, analysis of variance, regression, correlation, and graphical representation of data. Use of SAS and Excel for organization, analyzing, and presenting data. Required course for the Master of Science in Agronomy degree program.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Pest Management",
    "dept": "AGRON",
    "num": "514",
    "desc": "Prereq: AGRON 181 or equivalent, AGRON 501, MATH 140, CHEM 163, BIOL 101; AGRON 502 and AGRON 503 recommended\nPrinciples and practices of weed science, entomology, and plant pathology applied to crop production systems. Biology, ecology and principles of integrated crop pest management. Required course for the Master of Science in Agronomy degree program and Agronomy Graduate Certificate program.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Crop and Livestock Production Systems",
    "dept": "AGRON",
    "num": "515",
    "desc": "Prereq: SUSAG 509\nMethods to maintain productivity and minimize the negative ecological effects of agricultural systems by understanding nutrient cycles, managing manure and crop residue, and utilizing multispecies interactions. Crop and livestock production within landscapes and watersheds is also considered. Course includes a significant field component, with student teams analyzing Iowa farms.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop Physiology",
    "dept": "AGRON",
    "num": "516",
    "desc": "\nInvestigation of Molecular, whole plant, and plant community processes essential to biomass production and seed formation, and analysis of molecular approaches to overcome the limitations imposed on these processes by the environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Microwave Remote Sensing",
    "dept": "AGRON",
    "num": "518",
    "desc": "Prereq: MATH 265\nMicrowave remote sensing of Earth's surface and atmosphere using satellite-based or ground-based instruments. Specific examples include remote sensing of atmospheric temperature and water vapor, precipitation, ocean salinity, and soil moisture.\n",
    "credits": "3"
  },
  {
    "course_name": "Herbicide Physiology and Biochemistry",
    "dept": "AGRON",
    "num": "519",
    "desc": "Prereq: AGRON 316 (or equivalent) and AGRON 317\nHerbicide mechanisms of action, selectivity, uptake, and translocation. Specific sites of herbicide action as they affect plant physiology. Herbicide resistance in weeds and crops. Implications of herbicides on weed management.\n",
    "credits": "2"
  },
  {
    "course_name": "Plant Breeding Methods",
    "dept": "AGRON",
    "num": "520",
    "desc": "Prereq: AGRON 506\nBreeding methods used in the genetic improvement of self-pollinated, cross-pollinated and clonal crops.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Cultivar Development",
    "dept": "AGRON",
    "num": "521",
    "desc": "Prereq: AGRON 421 and STAT 401\nTheoretical and practical exploration of breeding methods to develop clonal, pureline, inbred and hybrid cultivars. Principles and strategies to set breeding objectives, parental selection and germplasm management, population development, generation advancements, multiple trait selection, experimental designs in breeding programs; seed production and certification. Introduce tools available to a breeder.\n",
    "credits": "3"
  },
  {
    "course_name": "Field Methods in Plant Breeding",
    "dept": "AGRON",
    "num": "522",
    "desc": "Prereq: AGRON 521\nField experience in planning and conducting plant breeding research for germplasm and cultivar development.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Molecular Plant Breeding",
    "dept": "AGRON",
    "num": "523",
    "desc": "Prereq: AGRON 421 or AGRON 521, GDCB 542A\nPlant breeding in the era of sequenced genomes and transformation. High throughout genomic technologies will be presented in relation to various applications in plant breeding.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Plant Molecular Genetics & Biotechnology",
    "dept": "AGRON",
    "num": "524",
    "desc": "Prereq: AGRON 506\nBasic principles and applied techniques used in the genetic improvement of crop plants. Discussion of structure and function of genes that control traits of value. Types of molecular markers, analysis of quantitatively inherited traits, genome mapping, analyses of databases.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop and Soil Modeling",
    "dept": "AGRON",
    "num": "525",
    "desc": "Prereq: MATH 165 or MATH 181 or equivalent; AGRON 316 or AGRON 354 or equivalent.\nUnderstanding basic crop physiology and soil processes through the use of mathematical and statistical approaches. Structure of crop models, dynamics and relationship among components such as leaf-level photosynthesis, canopy architecture, root dynamics and soil carbon and nitrogen pools.\n",
    "credits": "3"
  },
  {
    "course_name": "Field Plot Technique",
    "dept": "AGRON",
    "num": "526",
    "desc": "Prereq: STAT 401\nPlanning experiments for agricultural research, analysis of data, and concepts in data interpretation.\n",
    "credits": "4"
  },
  {
    "course_name": "Quantitative Genetics for Plant Breeding",
    "dept": "AGRON",
    "num": "528",
    "desc": "Prereq: AGRON 506 or AGRON 513\nAn introduction to the application of quantitative genetics to plant breeding programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecologically Based Pest Management Strategies",
    "dept": "AGRON",
    "num": "530",
    "desc": "\nDurable, least-toxic strategies for managing weeds, pathogens, and insect pests, with emphasis on underlying ecological processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop Ecology and Management",
    "dept": "AGRON",
    "num": "531",
    "desc": "Prereq: AGRON 501, AGRON 502, AGRON 503; AGRON 512 and AGRON 514 recommended\nEcological principles underlying crop production systems. Crop production in the context of management approaches, system resources and constraints, and interactions. Emphasis on the ecology of row and forage crops common to the Midwest. Required course for the Master of Science in Agronomy degree program.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil Management",
    "dept": "AGRON",
    "num": "532",
    "desc": "Prereq: AGRON 501, AGRON 503, AGRON 512. Recommended AGRON 513\nEvaluates the impact of various soil management practices on soil and water resources. Combines and applies basic information gained in AGRON 502 and AGRON 512. Emphasizes the agronomic, economic, and environmental effects of soil management strategies. Required course for the Master of Science in Agronomy degree program.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop Protection",
    "dept": "AGRON",
    "num": "533",
    "desc": "Prereq: AGRON 514\nIntegrated management systems for important crop pests. Cultural, biological and chemical management strategies applicable to major crops grown in the Midwest. Required course for the Master of Science in Agronomy degree program.\n",
    "credits": "3"
  },
  {
    "course_name": "Seed and Variety, Testing and Technology",
    "dept": "AGRON",
    "num": "534",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nThe components of seed quality and how they are assessed in the laboratory, including traits derived from modern biotechnology. The impact of new technologies on seed quality testing. Variety maintenance procedures and breeder seed. Variety identification: phenotype and grow-out trials, isozyme testing, and DNA marker testing. Procedures for evaluating varieties. The variance tests appropriate for fixed effects analysis of variance. Statistical inference and stratification for yield trials. Use of strip plot testing.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to the Seed Industry",
    "dept": "AGRON",
    "num": "535",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nAn analysis of the defining characteristics of the seed industry and introduction to the Master in Seed Technology and Business curriculum. The tasks of crop improvement and seed production will be analytically related to basic management functions and classifications of management activities. Management tasks and roles will be analyzed and related to the public policy issues that shape the seed industry. Current issues in the seed industry including ethical and economical approaches to biotechnology, intellectual property, and corporate responsibility will be discussed.\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Methods for Seed",
    "dept": "AGRON",
    "num": "536",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nQuantitative Methods for analyzing and interpreting agronomic and business information for the seed industry. Principles of experimental design and hypothesis testing, regression, correlation, analysis of variance, and graphical representation of data. Use of spreadsheets and statistical software for manipulating, analyzing and presenting data.\n",
    "credits": "2"
  },
  {
    "course_name": "Seed Physiology and the Environment",
    "dept": "AGRON",
    "num": "538",
    "desc": "Prereq: AGRON 316; CHEM 231 or CHEM 331\nPhysiological aspects of seed development, maturation, longevity, dormancy, and germination of agronomic and horticultural crops and their interactions with field and storage environments. Emphasis on current literature and advanced methodology.\n",
    "credits": "2"
  },
  {
    "course_name": "Seed Conditioning and Storage",
    "dept": "AGRON",
    "num": "539",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nThe technical operations which may be carried out on a seed lot from harvest until it is ready for marketing and use. The opportunities for quality improvement and the risks of deterioration which are present during that time. Analysis of the costs of and benefits of operations. Evaluation of equipment based on benefits to the customer and producer. Interpretation of the role of the conditioning plant and store as a focal points within the overall operations of a seed company.\n",
    "credits": "2"
  },
  {
    "course_name": "Applied Agricultural Meteorology",
    "dept": "AGRON",
    "num": "541",
    "desc": "Prereq: AGRON 206 or upper division Biological Science\nApplied concepts in agricultural meteorology. Basic concepts of weather and of crop/climate relationships influencing production, protection, yield and associated production risk factors. Self study sections are available to resident and to distant education students all semesters.\n  Credit for only one of Agron 503 or 541 may be applied toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Host-Pest Interactions",
    "dept": "AGRON",
    "num": "544",
    "desc": "Prereq: AGRON 501\nIncorporation of the principles of integrated pest management and crop protection. Management systems (biological, cultural, chemical) and strategies which practice principles of weed science, plant pathology, and entomology. Enrollment is restricted to off-campus students in Agronomy MS in Plant Breeding.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategies for Diversified Farming Systems",
    "dept": "AGRON",
    "num": "546",
    "desc": "Prereq: SUSAG 509\nProject-focused engagement in food and farming systems using tools and perspectives drawn from multiple disciplines. Includes a field component.\n",
    "credits": "3"
  },
  {
    "course_name": "Seed Production",
    "dept": "AGRON",
    "num": "547",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nSurvey of crop production; including management of soil fertility, planting dates, populations, weed control, and insect control. Analysis of the principles of seed multiplication and the key practices which are used to ensure high quality in the products. Field inspection procedures and production aspects that differ from other crop production. Foundation seed production. Analysis of the typical organization of field production tasks. Survey of the differences in seed production strategies between crops and the impact of these differences on seed production.\n",
    "credits": "2"
  },
  {
    "course_name": "Growth and Development of Perennial Grasses",
    "dept": "AGRON",
    "num": "551",
    "desc": "Prereq: Junior or senior or graduate classification or permission of instructor\nSelected topics on anatomy, morphology, and physiology relative to growth and development of perennial grasses. Emphasis on growth and development characteristics peculiar to grasses and variations of such characteristics under natural and managed conditions.\n",
    "credits": "2"
  },
  {
    "course_name": "GIS for Geoscientists",
    "dept": "AGRON",
    "num": "552",
    "desc": "Prereq: GEOL 100, GEOL 201 or equivalent\nIntroduction to geographic information systems (GIS) with particular emphasis on geoscientific data. Uses ESRI's ArcGIS Desktop Software and extension modules. Emphasizes typical GIS operations and analyses in the geosciences to prepare students for advanced GIS courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil-Plant Relationships",
    "dept": "AGRON",
    "num": "553",
    "desc": "Prereq: AGRON 354\nComposition and properties of soils in relation to the nutrition and growth of plants.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Soil Management",
    "dept": "AGRON",
    "num": "554",
    "desc": "Prereq: AGRON 354; MATH 165\nImplications of soil management on the soil environment and root activity. Effect of soil physical properties on soil erosion.\n",
    "credits": "2"
  },
  {
    "course_name": "Environmental Soil Mineralogy",
    "dept": "AGRON",
    "num": "555",
    "desc": "Prereq: AGRON 473, CHEM 178. Recommend: GEOL 311\nStructure and behavior of clay minerals, humic substances and biochar in soil environments, with emphasis on reactions and environmental implications.\n",
    "credits": "3"
  },
  {
    "course_name": "Agroecosystem Nutrient Cycles",
    "dept": "AGRON",
    "num": "556",
    "desc": "Prereq: 3 credits in chemistry and 6 credits in biology;  Recommended: ENSCI 382, ENSCI 553, or upper-level coursework in nutrient cycles\nMajor, biologically important agroecosystem nutrient cycles as linked to energy (carbon) and water. Effects of agricultural production and management on cycling within systems and transfer among system at local, regional and global scales will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory Methods in Soil Chemistry",
    "dept": "AGRON",
    "num": "558",
    "desc": "Prereq: AGRON 354 and CHEM 211\nExperimental and descriptive inorganic and organic analyses. Operational theory and principles of applicable instruments, including spectrophotometry, atomic and molecular absorption and emission spectroscopy, mass spectrometry, X-ray diffraction and fluorescence, gas and ion chromatography, and ion-selective electrodes.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Soil and Water Chemistry",
    "dept": "AGRON",
    "num": "559",
    "desc": "Prereq: Two semesters of college-level chemistry, MATH 140, AGRON 182 (or equivalent) or AGRON 360; GEOL 100 and AGRON 354 recommended\nAn introduction to the chemical properties of soils, chemical reactions and transformations in soils and surface waters, and their impact on the environment. Topics include solution chemistry in soils and surface waters, solid-phase composition of soils, reactions at the solid-solution interface, and applications to contemporary environmental issues.\n",
    "credits": "4"
  },
  {
    "course_name": "Population and Quantitative Genetics for Breeding",
    "dept": "AGRON",
    "num": "561",
    "desc": "Prereq: STAT 401\nPopulation and quantitative genetics for plant and animal genetics. Study of the genetic basis and analysis of variation in quantitative traits in domestic or experimental populations using phenotypic and molecular marker data, including estimation of heritability and other genetic parameters, linkage analysis and mapping of quantitative trait loci, and the impact of inbreeding, heterosis, and genotype-by-environment interaction.\n",
    "credits": "4"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "AGRON",
    "num": "563",
    "desc": "Prereq: AGRON 182 (or equivalent) or AGRON 260\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use. Two weekend field trips.\n  Credit for one of AGRON 463 or AGRON 463I may be applied for graduation.",
    "credits": "3"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "AGRON",
    "num": "563I",
    "desc": "Prereq: AGRON 182 (or equivalent)\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use.\n  Credit for only Agron 563 or 563I may be applied for graduation.",
    "credits": "2"
  },
  {
    "course_name": "Risk Assessment for Food, Agriculture and Veterinary Medicine",
    "dept": "AGRON",
    "num": "570",
    "desc": "Prereq: Statistics 300-level or higher.\nRisk assessment principles as applied to biological systems. Exposure and effects characterization in human and animal health and ecological risk assessment. Risk analysis frameworks and regulatory decision-making. Introduction to quantitative methods for risk assessment using epidemiological and distributional analysis. Uncertainty analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil Formation and Transformation",
    "dept": "AGRON",
    "num": "575",
    "desc": "Prereq: AGRON 463 or equivalent\nAdvanced study of soil formation, emphasizing relationships among soils, landscapes, environment, humans, and land use.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil Physics",
    "dept": "AGRON",
    "num": "577",
    "desc": "Prereq: AGRON 182 or equivalent and MATH 166 recommended\nThe physical soil system: the soil components and their physical interactions; transport processes involving water, air, and heat.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory Methods in Soil Physics",
    "dept": "AGRON",
    "num": "578",
    "desc": "Prereq: concurrent enrollment in AGRON 477 or AGRON 577\nMethods of measuring soil physical properties such as texture, density, and water content, and transport of heat, water, and gases.\n",
    "credits": "1"
  },
  {
    "course_name": "Organic Agricultural Theory and Practice",
    "dept": "AGRON",
    "num": "584",
    "desc": "Prereq: 9 cr. in biological or physical sciences\nUnderstanding of the historical origins and ecological theories underpinning the practices involved in organic agriculture. Interdisciplinary examination of crop and livestock production and socio-economic processes and policies in organic agriculture from researcher and producer perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil and Environmental Microbiology",
    "dept": "AGRON",
    "num": "585",
    "desc": "Prereq: AGRON 182 or equivalent; MICRO 201 and MICRO 201L recommended\nThe living organisms in the soil and what they do. Emphasis on soil biota composition, the carbon cycle and bioremediation, soil-plant-microbial relationships, and environmental issues.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists II",
    "dept": "AGRON",
    "num": "588",
    "desc": "Prereq: GIS course, such as GEOL 452, CRP 451, CRP 452, NREM 345, NREM 446, AE 408 or equivalent\nGIS course with focus on the spatial analysis and modeling of raster data and triangulated irregular network (TIN) data. Uses ArcGIS and various extensions, such as Spatial Analyst, 3D Analyst, and ArcScene. Includes practical exercises during lectures, lab exercises, homework assignments, and (for GEOL 588) a class project.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "AGRON",
    "num": "590",
    "desc": "Prereq: 15 credits in agronomy\nLiterature reviews and conferences on selected topics in crops, soils, or agricultural meteorology according to needs and interest of student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Agronomic Systems Analysis",
    "dept": "AGRON",
    "num": "591",
    "desc": "Prereq: AGRON 511, AGRON 513, AGRON 531, AGRON 532, AGRON 533\nAnalysis of cropping systems from a problem-solving perspective. Case studies will be used to develop the students' ability to solve agronomic problems. Required course for the Master of Science in Agronomy degree program.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Agronomy",
    "dept": "AGRON",
    "num": "592",
    "desc": "Prereq: AGRON 501, AGRON 503, AGRON 511, AGRON 512, AGRON 513, AGRON 514\nCritical analysis and discussion of agricultural practices, programs, and policies of current interest to the field of agronomy. Leadership skill development through consideration of technical, social, and ethical components underlying controversial topics. Enhancement of communication proficiency through debate and writing in order to define problems, articulate possible solutions, and propose appropriate courses of action. Required course for the Master of Science in agronomy degree program.\n",
    "credits": "3"
  },
  {
    "course_name": "Workshop in Agronomy",
    "dept": "AGRON",
    "num": "593",
    "desc": "Prereq: Graduate classification\n",
    "credits": "arr"
  },
  {
    "course_name": "Agronomy MS Practicum",
    "dept": "AGRON",
    "num": "594",
    "desc": "Prereq: AGRON 501, AGRON 502, AGRON 503, AGRON 514 (or current enrollment. Recommended: AGRON 511, AGRON 512, AGRON 513\nPractical field and laboratory experiences integrating coursework in climatology, crops, and soils. Includes lectures, labs and local agri-business tours.\n",
    "credits": "1"
  },
  {
    "course_name": "Seed Quality, Production, and Research Management",
    "dept": "AGRON",
    "num": "595",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nAdvanced survey of the organization, staff capabilities and management characteristics typical in seed production and crop improvement in seed enterprises. Analysis of the use of quality information in the management of seed operations and sales. Process management applications for seed.  Production planning for existing capacity.  Analysis of the manager's tasks in the annual cycle and how the tasks of these managers relate to the general categories of business management roles. Difference in management strategies used with different situations and groups of employees.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "AGRON",
    "num": "599",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Agricultural Meteorology",
    "dept": "AGRON",
    "num": "599A",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Crop Production and Physiology",
    "dept": "AGRON",
    "num": "599B",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Plant Breeding",
    "dept": "AGRON",
    "num": "599C",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Chemistry",
    "dept": "AGRON",
    "num": "599D",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Fertility",
    "dept": "AGRON",
    "num": "599E",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Management",
    "dept": "AGRON",
    "num": "599F",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Microbiology and Biochemistry",
    "dept": "AGRON",
    "num": "599G",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Morphology and Genesis",
    "dept": "AGRON",
    "num": "599H",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Physics",
    "dept": "AGRON",
    "num": "599I",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seed Science",
    "dept": "AGRON",
    "num": "599K",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Weed Science",
    "dept": "AGRON",
    "num": "599L",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Agronomy",
    "dept": "AGRON",
    "num": "599M",
    "desc": "Prereq: Nonthesis M.S. option only\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar",
    "dept": "AGRON",
    "num": "600",
    "desc": "\nReports and discussion of recent literature and research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Plant Breeding",
    "dept": "AGRON",
    "num": "600A",
    "desc": "\nInstruction and practice in giving scientific presentations related to the fields of plant breeding, genetics, or genomics, with an emphasis on effective communication and presentation techniques.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Soils",
    "dept": "AGRON",
    "num": "600B",
    "desc": "\nReports and discussion of recent literature and research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Crop Production and Physiology",
    "dept": "AGRON",
    "num": "600C",
    "desc": "\nReports and discussion of recent literature and research.\n",
    "credits": "1"
  },
  {
    "course_name": "Agronomic Science Presentations",
    "dept": "AGRON",
    "num": "601",
    "desc": "Prereq: graduate status in agronomic science, permission of instructor.\nExperience in critical communications in exchange of ideas through oral and poster presentations and scientific questioning/evaluation.\n",
    "credits": "2"
  },
  {
    "course_name": "Boundary-Layer Meteorology",
    "dept": "AGRON",
    "num": "605",
    "desc": "Prereq: MTEOR 443 or equivalent-level course in engineering fluids\nAtmospheric boundary-layer structure and dynamics. Diurnal and seasonal variations, turbulent fluxes and turbulence kinetic energy. Measurements and empirical relations for wind and temperature near the ground. Numerical simulation and applications to wind energy.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Sustainable Agriculture",
    "dept": "AGRON",
    "num": "610",
    "desc": "Prereq: Graduate classification, permission of instructor\nHistorical, biophysical, socioeconomic, and ethical dimensions of agricultural sustainability. Strategies for evaluating existing and emerging agricultural systems in terms of the core concepts of sustainability and their theoretical contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Plant Breeding",
    "dept": "AGRON",
    "num": "621",
    "desc": "Prereq: AGRON 521, AGRON 526, AGRON 561, GEN 410\nGenetics of breeding populations, means of genotypes and breeding populations, mapping quantitative trait loci, variation in breeding populations, genetic design, genotype by environment interaction, selection in breeding populations, recurrent selection, marker-assisted selection, best linear unbiased prediction, genome-wide association studies, genomic selection, heterosis and hybrid prediction, and multiple traits.\n",
    "credits": "3"
  },
  {
    "course_name": "Genetic Strategies in Plant Breeding",
    "dept": "AGRON",
    "num": "625",
    "desc": "Prereq: AGRON 521 and GDCB 510\nEvaluation of genetic, molecular, and cellular approaches to crop improvement; gene transfer methods. Application and role of basic plant biology in breeding programs and processes; genome structure and function, gene isolation, expression, regulation, and modification. Integration of molecular and cellular methods in breeding strategies; analysis of alternative breeding methods, regulatory and ethical issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Soil Fertility",
    "dept": "AGRON",
    "num": "655",
    "desc": "Prereq: AGRON 553\nEvaluation of soil fertility and fertilizers; theory and applications.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Soil Physics",
    "dept": "AGRON",
    "num": "677",
    "desc": "Prereq: AGRON 577 and MATH 266; COM S 207 recommended\nThe flow and distribution of water, chemicals, and heat in soils. Physical principles and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Soil Biochemistry",
    "dept": "AGRON",
    "num": "685",
    "desc": "Prereq: AGRON 585\nChemistry of soil organic matter and biochemical transformations brought about by microorganisms and enzymes in soils.\n",
    "credits": "2"
  },
  {
    "course_name": "Research Seminar",
    "dept": "AGRON",
    "num": "696",
    "desc": "\nResearch seminars by faculty and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Agronomy Teaching Practicum",
    "dept": "AGRON",
    "num": "698",
    "desc": "Prereq: Graduate classification in agronomy and permission of instructor\nGraduate student experience in the agronomy teaching program.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "AGRON",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Agricultural Meteorology",
    "dept": "AGRON",
    "num": "699A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Crop Production and Physiology",
    "dept": "AGRON",
    "num": "699B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Plant Breeding",
    "dept": "AGRON",
    "num": "699C",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Chemistry",
    "dept": "AGRON",
    "num": "699D",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Fertility",
    "dept": "AGRON",
    "num": "699E",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Management",
    "dept": "AGRON",
    "num": "699F",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Microbiology and Biochemistry",
    "dept": "AGRON",
    "num": "699G",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Morphology and Genesis",
    "dept": "AGRON",
    "num": "699H",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Soil Physics",
    "dept": "AGRON",
    "num": "699I",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Plant Physiology",
    "dept": "AGRON",
    "num": "699J",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Seed Science",
    "dept": "AGRON",
    "num": "699K",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Weed Science",
    "dept": "AGRON",
    "num": "699L",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Introductory Leadership Laboratory with Physical Training",
    "dept": "AFAS",
    "num": "103",
    "desc": "Prereq: Membership as a cadet in AFROTC\nInstruction for new cadets on Air Force customs and courtesies; drill and ceremonies, issuing military commands, studying the environment of an Air Force officer and learning about areas of opportunity available to commissioned officers while also using basic military training skills and instruction to develop confidence, leadership, and communication skills through physical fitness. Full participation in all events will be determined based on student's physical and medical eligibility.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Foundations of the United States Air Force",
    "dept": "AFAS",
    "num": "141",
    "desc": "\nBasic introduction to the United States Air Force and Air Force Reserve Officer Training Corps. Mission and organization of the Air Force, officership and professionalism, military customs and courtesies, Air Force officer opportunities, and communication skills.\n",
    "credits": "1"
  },
  {
    "course_name": "Foundations of the United States Air Force",
    "dept": "AFAS",
    "num": "142",
    "desc": "\nA continuation of 141. Topics include Air Force installations, Air Force core values, leadership and team building, further study of interpersonal communication, the Oath of Office and Commissioning.\n",
    "credits": "1"
  },
  {
    "course_name": "Basic Leadership Laboratory with Physical Training",
    "dept": "AFAS",
    "num": "203",
    "desc": "Prereq: Membership as a cadet in AFROTC\nInstruction and critique of cadets on Air Force customs and courtesies, drill and ceremonies, and issuing military commands in preparation for AFROTC summer Field Training while also using basic military training skills and instruction to develop confidence, leadership, and communication skills through physical fitness. Full participation in all events will be determined based on student's physical and medical eligibility.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Team and Leadership Fundamentals",
    "dept": "AFAS",
    "num": "251",
    "desc": "\nMeasuring character through self-assessment and its importance for leadership and team building.  The importance of listening and communication for mission accomplishment.  Leadership, team building, and problem solving skills in the context of Air Force core values.\n",
    "credits": "1"
  },
  {
    "course_name": "Team and Leadership Fundamentals II",
    "dept": "AFAS",
    "num": "252",
    "desc": "\nDefining leadership through the lens of human relations, conflict and stress management, and ethical decision making. The importance of leveraging diversity and collaborative relationships with negotiating and resiliency techniques in the context of Air Force core values.\n",
    "credits": "1"
  },
  {
    "course_name": "Intermediate Leadership Laboratory with Physical Training",
    "dept": "AFAS",
    "num": "303",
    "desc": "Prereq: Membership as a cadet in AFROTC\nMid-level management of leadership experience involving planning and controlling of most AFROTC military activities. Students will help senior leadership to prepare and present briefings and other oral and written communications; provide interviews, guidance, and information that will increase the understanding, motivation, and performance of other cadets; and use advanced military training skills and instruction to develop confidence, leadership, and communication skills through physical fitness. Full participation in all events will be determined based on student's physical and medical eligibility.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Air Force Leadership Studies I",
    "dept": "AFAS",
    "num": "341",
    "desc": "\nA look at the fundamental issues of leadership and management in the U.S Air Force; a large and diverse organization. It examines the theoretical aspects of leadership, management, communications, motivation and problem-solving while studying them against the backdrop of the U.S. Air Force. The course also conducts hands-on exercises to apply principles learned. While the curriculum is focused on the Air Force as an organization, the principles studied are applicable to most organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Air Force Leadership Studies II",
    "dept": "AFAS",
    "num": "342",
    "desc": "Prereq: AFAS 341\nA continuation of AFAS 341, that looks at the advanced issues of leadership and management in the U.S. Air Force; a large and diverse organization.  It examines the theoretical aspects of leadership, managment, communications, motivation and problem-solving while studying them against the backdrop of the U.S. Air Force.  The course also conducts hands-on exercises to apply principles learned.  While the curriculum is focused on the Air Force as an organization, the principles studied are applicable to most oranizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Leadership Laboratory with Physical Training",
    "dept": "AFAS",
    "num": "403",
    "desc": "Prereq: Membership as a cadet in AFROTC\nAdvanced leadership experience involving the planning and controlling of all upper-level AFROTC military activities. Students will prepare and present briefings and other oral and written communications; provide interviews, guidance, and information that will increase the understanding, motivation, and performance of other cadets; and use advanced military training skills and instruction to develop confidence, leadership, and communication skills through physical fitness. Full participation in all events will be determined based on student's physical and medical eligibility.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Preparation for Active Duty",
    "dept": "AFAS",
    "num": "441",
    "desc": "\nTraces the source of military authority and responsibilities from the U.S. Constitution through the DoD to an Air Force officer.  Examines the structure and capabilities of the other services and joint structures.  Addresses the supervisory duties of an Air Force officer associated with administrative actions and military law as force management tools.  Builds upon leadership and management skill learned in AFAS 341/342 and includes demonstrations of written and verbal communications processes.\n",
    "credits": "3"
  },
  {
    "course_name": "National Security Affairs",
    "dept": "AFAS",
    "num": "442",
    "desc": "\nExamines the national security process through review of the Department of Defense's statutory administrative and operational relationships as context for this course's regional studies component. Reviews functions of air and space power as outlined in Air Force doctrine and introduces the concept of joint operations. Integrates these concepts with regional studies to survey issues of interest to professional military officers and governmental leaders. Selectively reviews and discusses Africa, Latin America, South Asia, East Asia, Europe, Russia and the Middle East.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "American Indians in the Movies",
    "dept": "AM IN",
    "num": "205",
    "desc": "\nExamines the role of American Indians in the movie industry. Explores the development of American Indian characters and filmmaking, and the relevance for Native communities, through feature films and academic analysis. One focus is a comparison of non-Native and Native films in form, content, and message, and the changing character of Native representation in both.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to American Indian Studies",
    "dept": "AM IN",
    "num": "210",
    "desc": "\nIntroduction to the multidisciplinary aspects of American Indian Studies. Topics include the relevant events and ideas defining the contemporary American Indian experience, on and off reservation, in the United States. Sovereignty, identity, jurisdiction, taxes, economic development, education, and other issues are addressed.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "American Indians of Iowa",
    "dept": "AM IN",
    "num": "225",
    "desc": "\nCultures and histories of Native people who have called the present state of Iowa home; primary focus on the period between 1700 CE and the present; Native interactions with Spanish, French, British, and American people.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to American Indian Literature",
    "dept": "AM IN",
    "num": "240",
    "desc": "Prereq: Credit in or exemption from ENGL 150\nAppreciation of oral and written forms of American Indian literatures. Tropes and techniques in oral, visual and written texts. Focus on the role of American Indians in interdisciplinary approaches to modern social and environmental issues as expressed in literary works.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Topics in American Indian Studies",
    "dept": "AM IN",
    "num": "310",
    "desc": "Prereq: AM IN 210 recommended\nExamines contemporary issues and important topics affecting Native communities overall.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Federal Indian Law and Policy",
    "dept": "AM IN",
    "num": "311",
    "desc": "Prereq: AM IN 210 recommended\nExamines the impact of federal American Indian policies on Native communities, especially contemporary Indian Country and communities. Topics include sovereignty, recognition, the role of the Supreme Court, specific policies like allotment, and other relevant issues.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "American Indian Education",
    "dept": "AM IN",
    "num": "312",
    "desc": "Prereq: AM IN 210 recommended\nExamines current and historical issues in American Indian education. Topics include traditional education, changes to formal education, tribal colleges and universities, current school systems, and other relevant topics.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Native Land, Water, and Resources",
    "dept": "AM IN",
    "num": "313",
    "desc": "Prereq: AM IN 210 recommended\nExamines Native land rights, water rights, and natural resources. Topics may include Native relations to landscapes, cultural resources and infrastructure projects, land rights, water usage agreements, and resource policies as they apply to on- and off-reservation Native communities.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Archaeology of North America",
    "dept": "AM IN",
    "num": "315",
    "desc": "Prereq: ANTHR 202\nPrehistory and early history of North America as reconstructed from archaeological evidence; peopling of the New World; culture-  historical sequences of major culture areas; linkages of archaeological traditions with selected ethnohistorically known Native   American groups.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Great Plains Archaeology",
    "dept": "AM IN",
    "num": "320",
    "desc": "Prereq: ANTHR 202\nPrehistoric societies of the Great Plains region of North America, from initial occupation to European contact; emphasis on   sociocultural changes, continuities, and adaptations to changing environments using archaeological, ecological, ethnographic   information.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Peoples and Cultures of Native North America",
    "dept": "AM IN",
    "num": "322",
    "desc": "Prereq: ANTHR 201 or AM IN 210\nOrigin, distribution, and pre-contact life of the indigenous peoples of North America. Survey of culture areas; language families,   social and political systems, ecological and economic adaptations, religion and spirituality; impact of European contact;  cultural   resilience and revitalization in contemporary American Indian life.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America",
    "dept": "AM IN",
    "num": "332",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Gender and Family",
    "dept": "AM IN",
    "num": "332A",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Indigenous Ecologies and Geographies",
    "dept": "AM IN",
    "num": "332B",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Cultural and Political Movements",
    "dept": "AM IN",
    "num": "332C",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Regional Focus",
    "dept": "AM IN",
    "num": "332D",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "American Indian Literature",
    "dept": "AM IN",
    "num": "346",
    "desc": "Prereq: ENGL 250\nSurvey of literature by Native Americans from pre-Columbian tales and songs to contemporary novels and poetry.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Native American Architecture",
    "dept": "AM IN",
    "num": "426",
    "desc": "Prereq: Junior classification\nHistory, theory, and principles of Native American/American Indian architecture, landscape architecture and planning considering relationships to the culture, visual arts, site, and surroundings. Credit counts toward fulfillment History, Theory, Culture.\n  A maximum of 6 credits of ARCH 426 may be applied to degree program.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "AM IN",
    "num": "490",
    "desc": "Prereq: 6 credits in American Indian studies; permission of instructor and program director\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 6 credits in AM IN 490 may be counted toward graduation. If more than 3 credits in AM IN 490 are taken, they must be from different instructors.",
    "credits": "arr"
  },
  {
    "course_name": "American Sign Language I",
    "dept": "ASL",
    "num": "101",
    "desc": "\nIntroduction to American Sign Language (ASL). Development of expressive and receptive skills including vocabulary, grammar, usage, and cultural information. Note: Distinct from “Signed English”. ASL is a natural language with its own rules of grammar and usage.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "4"
  },
  {
    "course_name": "American Sign Language II",
    "dept": "ASL",
    "num": "102",
    "desc": "Prereq: ASL 101\nIntroduction to American Sign Language (ASL) II continues development of expressive and receptive skills introduced in American Sign Language I, including vocabulary, grammar, usage, and cultural information. Distinct from “Signed English”. ASL is a natural language with its own rules of grammar and usage.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "4"
  },
  {
    "course_name": "Introduction to the Deaf-World",
    "dept": "ASL",
    "num": "107",
    "desc": "\nNature and significance of the Deaf-World as a cultural and linguistic minority.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "Intermediate American Sign Language I",
    "dept": "ASL",
    "num": "201",
    "desc": "Prereq: ASL 102 or equivalent.\nDevelopment of fluency for intermediate conversational skills. Review of grammar and varying grammatical forms for both structured and unstructured social situations such as sharing opinions, discussing weekend activities, and exchanging views on current topics.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate American Sign Language II",
    "dept": "ASL",
    "num": "202",
    "desc": "Prereq: ASL 201 or equivalent.\nA continuation and further application of language principles learned in ASL 201, to deepen ability to actively engage in dialogue both in structured and unstructured social situations. Further fluency in intermediate conversational skills will be developed, particularly in the areas of sematic equivalence and dialogic/monologic register.\n",
    "credits": "4"
  },
  {
    "course_name": "Topics in Deaf Culture",
    "dept": "ASL",
    "num": "275",
    "desc": "\nFocus on contemporary topics in Deaf Culture, Communities, and History. Readings and discussion from a wide range of sources. Topics vary according to faculty interest.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "ASL Classifiers and Depiction",
    "dept": "ASL",
    "num": "305",
    "desc": "Prereq: ASL 201\nFocused analysis, documentation, discussion, and increased development of classifiers and depiction in ASL. Investigation in how these grammatical features are deliberately incorporated into conversational, presentational, scientific, and artistic language production.\n",
    "credits": "3"
  },
  {
    "course_name": "Deaf Peoples: Pre-World War II",
    "dept": "ASL",
    "num": "325",
    "desc": "Prereq: ASL 202 or instructor's permission.\nPerspectives on and treatment of deaf people as individuals and groups prior to World War II. Taught in American Sign Language.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ASL",
    "num": "490",
    "desc": "Prereq: 6 credits in ASL and permission of department chair\nDesigned to meet the needs of students in areas other than those in which courses are offered, or who desire to integrate a study of literature or language with special problems in major fields.\n  No more than 6 credits of ASL 490 may be counted towards graduation.",
    "credits": "1"
  },
  {
    "course_name": "Ecology",
    "dept": "A ECL",
    "num": "312",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, and BIOL 212L\nFundamental concepts and principles of ecology dealing with organisms, populations, communities, and ecosystems. Laboratory and field exercises examine ecological principles and methods as well as illustrate habitats.\n",
    "credits": "4"
  },
  {
    "course_name": "Ecology",
    "dept": "A ECL",
    "num": "312I",
    "desc": "\nAn introduction to the principles of ecology at the population, community and ecosystem level. Field studies of local lakes, wetlands and prairies are used to examine factors controlling distributions, interactions, and roles of plants and animals in native ecosystems.\n",
    "credits": "4"
  },
  {
    "course_name": "Fish Biology",
    "dept": "A ECL",
    "num": "321",
    "desc": "Prereq: A ECL 365\nBiology, ecology, and evolution of fishes.  Emphasis on structure, physiology, and behavior, including a focus on the conservation and management of fishes and their habitats.  Laboratory focus on fish morphology, survey methods, identification, distribution, habits, and habitats of fishes.\n",
    "credits": "3"
  },
  {
    "course_name": "Ornithology",
    "dept": "A ECL",
    "num": "326I",
    "desc": "\nThe biology, ecology, and behavior of birds with emphasis on field studies of local avifauna. Group projects stress techniques of population analysis and methodology for population studies.\n",
    "credits": "2"
  },
  {
    "course_name": "Fisheries Techniques",
    "dept": "A ECL",
    "num": "333",
    "desc": "Prereq: BIOL 212\nIntroduction to techniques used in the collection and interpretation of fish population data in the field and in the lab.  Course objectives include an understanding of population survey methodology and improving student critical thinking and teamwork skills. Laboratory focuses on field trips and hands-on sampling experience.\n",
    "credits": "2"
  },
  {
    "course_name": "Vertebrate Biology",
    "dept": "A ECL",
    "num": "365",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, BIOL 212L\nEvolution, biology, and classification of fish, amphibians, reptiles, birds, and mammals. Emphasis on a comparative analysis of the structure and function of organ systems. Laboratory exercises concentrate on morphology and identification of orders of vertebrates.\n",
    "credits": "4"
  },
  {
    "course_name": "Natural History of Iowa Vertebrates",
    "dept": "A ECL",
    "num": "366",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, BIOL 212L\nVertebrate fauna of Iowa, including fishes, amphibians, reptiles, birds, and mammals. Species identification, habitat requirements, community structure and assessment, conservation issues that include historical population changes and value of wild animals to the region's ecological and economic health.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecological Methods",
    "dept": "A ECL",
    "num": "371",
    "desc": "Prereq: A ECL 312; STAT 101 or STAT 104\nQuantitative techniques used in management of natural resources with emphasis on inventory and manipulation of habitat and animal populations.\n",
    "credits": "3"
  },
  {
    "course_name": "Intro to Aquatic Animal Medicine",
    "dept": "A ECL",
    "num": "401",
    "desc": "\n8 week course. Introductory course with focus on fin fish production, health and medicine. Course content will help define future roles for veterinarians, producers, and service providers.  Emphasis will be placed on anatomy, pathology, infectious diseases, nutrition, regulatory constraints in production, food safety, and current research. Field trip to aquaculture facility.\n",
    "credits": "1"
  },
  {
    "course_name": "Behavioral Ecology",
    "dept": "A ECL",
    "num": "404I",
    "desc": "Prereq: Two semesters of biology\nAnimal coloniality, courtship, territoriality, predator defense, habitat selection, foraging, mating systems, and parental care will be examined in the field in order to evaluate various ecological and evolutionary theories of animal behavior.\n",
    "credits": "4"
  },
  {
    "course_name": "Ecology of Freshwater Invertebrates, Plants, and Algae",
    "dept": "A ECL",
    "num": "415",
    "desc": "Prereq: A ECL 312\nIdentification, biology, and ecological requirements of freshwater invertebrates, plants and algae. Additional emphases on community sampling methods and analysis, and use of organisms as tools for aquatic ecosystem health assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Stream Ecology",
    "dept": "A ECL",
    "num": "418",
    "desc": "Prereq: A ECL 486\nBiological, chemical, physical, and geological processes that determine the structure and function of flowing water ecosystems. Current ecological theories as well as applications to stream management for water quality and fisheries.\n",
    "credits": "3"
  },
  {
    "course_name": "Vertebrate Ecology and Evolution",
    "dept": "A ECL",
    "num": "419I",
    "desc": "\nField and laboratory study of representative vertebrates of northwestern Iowa. Observations and experimentation emphasize ecological histories by integrating concepts of functional morphology, behavioral ecology, and evolutionary biology.\n",
    "credits": "4"
  },
  {
    "course_name": "Amphibians and Reptiles",
    "dept": "A ECL",
    "num": "420I",
    "desc": "Prereq: Two semesters of biology\nEcology, behavior, and conservation biology of amphibians and reptiles with emphasis on their anatomy and morphology; temperature and water regulation; locomotion; life history; reproduction; population and community ecology; and conservation.\n",
    "credits": "2"
  },
  {
    "course_name": "Aquatic Insects",
    "dept": "A ECL",
    "num": "425",
    "desc": "Prereq: BIOL 312 or equivalent\nMorphology, ecology, diversity, and significance of aquatic insects, with emphasis on the collection, curation and identification of taxa in local streams and lakes.\n",
    "credits": "3"
  },
  {
    "course_name": "Fishery Management",
    "dept": "A ECL",
    "num": "440",
    "desc": "Prereq: A ECL 312, A ECL 321, STAT 101 or STAT 104; credit or enrollment in A ECL 486\nBiological basis of fishery management, fishery problems, and management practices for freshwater, anadromous, and marine fisheries.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquaculture",
    "dept": "A ECL",
    "num": "442",
    "desc": "Prereq: BIOL 211 and BIOL 212.\nConcepts related to the culture of aquatic organisms including culture systems, water quality, nutrition, genetics, diseases, and marketing.\n",
    "credits": "3"
  },
  {
    "course_name": "Wildlife Ecology and Management",
    "dept": "A ECL",
    "num": "451",
    "desc": "Prereq: A ECL 371\nEcological theory and practice of wildlife management, including, population ecology, habitat management, and current issues in the field. Course involves a series of case studies addressing actual wildlife issues using field and quantitative methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Wildlife Disease",
    "dept": "A ECL",
    "num": "454",
    "desc": "Prereq: Junior standing and at least 10 credits in biological sciences at the 300+ level\nEcological and epidemiological aspects of diseases as they relate to wildlife populations. Topics to be covered include: major classes of disease; detection, description, monitoring, and management of disease; characteristics and interactions between disease agents and wildlife hosts; relationships among wildlife, domestic animal, and human health.\n",
    "credits": "3"
  },
  {
    "course_name": "International Wildlife Issues",
    "dept": "A ECL",
    "num": "455",
    "desc": "Prereq: A ECL 365, A ECL 312 or graduate standing; NREM 120\nBiological, political, social, and economic factors affecting the management of international wildlife resources.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Herpetology",
    "dept": "A ECL",
    "num": "457",
    "desc": "Prereq: BIOL 351 or BIOL 365\nBiology, ecology, and evolution of amphibians (salamanders, frogs, caecilians) and reptiles (lizards, snakes, tuatara, turtles, crocodilians).  Emphasis on structure, physiological adaptation to different environments, behavior, reproduction, roles of amphibians and reptiles in ecosystems, and conservation.  Laboratory focus on survey methods, identification, relationships, distribution, habits, and habitats of amphibians and reptiles.\n",
    "credits": "2"
  },
  {
    "course_name": "Herpetology Laboratory",
    "dept": "A ECL",
    "num": "457L",
    "desc": "Prereq: BIOL 351 or BIOL/A ECL 365; concurrent registration in BIOL 457 or A ECL 457\nLaboratory to accompany Biology/Animal Ecology 457. Focus on survey methods, identification, relationships, distribution, habits, and habitats of amphibians and reptiles.\n",
    "credits": "1"
  },
  {
    "course_name": "Ornithology",
    "dept": "A ECL",
    "num": "458",
    "desc": "Prereq: A ECL 365 or BIOL 351\nBiology, evolution, ecology and taxonomy of birds.  Emphasis on structure, physiology, behavior, communication, navigation, reproduction, and conservation.\n",
    "credits": "2"
  },
  {
    "course_name": "Ornithology Laboratory",
    "dept": "A ECL",
    "num": "458L",
    "desc": "Prereq: BIOL 351 or AECL/BIOL 365. Concurrent enrollment in AECL/BIOL 458 is required.\nLaboratory complements lecture topics with emphasis on external anatomy, identification and distribution of Midwest birds, and field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Mammalogy",
    "dept": "A ECL",
    "num": "459",
    "desc": "Prereq: BIOL 351 or A ECL 365\nBiology, ecology, and evolution of mammals.  Emphasis on structure, physiological adaptation to different environments, behavior, reproduction, roles of mammals in ecosystems, and conservation.\n",
    "credits": "2"
  },
  {
    "course_name": "Mammalogy Laboratory",
    "dept": "A ECL",
    "num": "459L",
    "desc": "Prereq: BIOL 351 or BIOL/AECL 365; concurrent enrollment in AECL 459 or BIOL 459 required.\nLaboratory focus on identification, survey methods, distribution, habits, and habitats of mammals. Several field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Introductory Conservation Biology",
    "dept": "A ECL",
    "num": "471",
    "desc": "Prereq: BIOL 312\nExamination of conservation issues from a population and community perspective.  The role of genetics, demography, and environment in determining population viability, habitat fragmentation, reserve design, biodiversity assessment, and restoration ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Marine Biology",
    "dept": "A ECL",
    "num": "480",
    "desc": "\nCourses taken at Gulf Coast Research Laboratory and other marine biological stations are transferred to Iowa State University under this number.\n",
    "credits": "1"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "A ECL",
    "num": "486",
    "desc": "Prereq: BIOL 312 or ENSCI 381 or ENSCI 402 or NREM 301\nStructure and function of aquatic ecosystems with application to fishery and pollution problems. Emphasis on lacustrine, riverine, and wetland ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology Laboratory",
    "dept": "A ECL",
    "num": "486L",
    "desc": "Prereq: Concurrent enrollment in BIOL 486\nField trips and laboratory exercises to accompany 486. Hands-on experience with aquatic research and monitoring techniques and concepts.\n",
    "credits": "1"
  },
  {
    "course_name": "Population Ecology",
    "dept": "A ECL",
    "num": "489",
    "desc": "Prereq: BIOL 312, STAT 101 or STAT 104, a course in calculus, or graduate standing\nConcepts and theories of population dynamics with emphasis on models of growth, predation, competition, and regulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecology of Freshwater Invertebrates, Plants, and Algae",
    "dept": "A ECL",
    "num": "515",
    "desc": "Prereq: A ECL 312\nIdentification, biology, and ecological requirements of freshwater invertebrates, plants and algae. Additional emphases on community sampling methods and analysis, and use of organisms as tools for aquatic ecosystem health assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Avian Ecology",
    "dept": "A ECL",
    "num": "516",
    "desc": "Prereq: A ECL 365, A ECL 312, or graduate standing\nCurrent topics and theories including avian breeding and foraging ecology, population biology, community structure, habitat selection, field methodologies, and data interpretation.\n",
    "credits": "3"
  },
  {
    "course_name": "Stream Ecology",
    "dept": "A ECL",
    "num": "518",
    "desc": "Prereq: A ECL 486\nBiological, chemical, physical, and geological processes that determine the structure and function of flowing water ecosystems. Current ecological theories as well as applications to stream management for water quality and fisheries.\n",
    "credits": "3"
  },
  {
    "course_name": "Fisheries Science",
    "dept": "A ECL",
    "num": "520",
    "desc": "Prereq: A ECL 312, A ECL 321\nConcepts, approaches, and techniques for assessment of recreational and commercial fisheries. Scope will range from individual fish to entire ecosystems, both freshwater and marine.\n",
    "credits": "3"
  },
  {
    "course_name": "Fish Ecology",
    "dept": "A ECL",
    "num": "523I",
    "desc": "\nBasic principles of fish interaction with the biotic and abiotic environment. Field methods, taxonomy, and biology of fish with emphasis on the fish fauna of northwestern Iowa.\n",
    "credits": "2"
  },
  {
    "course_name": "Aquatic Insects",
    "dept": "A ECL",
    "num": "525",
    "desc": "Prereq: BIOL 312 or equivalent\nMorphology, ecology, diversity, and significance of aquatic insects, with emphasis on the collection, curation and identification of taxa in local streams and lakes.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Field Ornithology",
    "dept": "A ECL",
    "num": "526I",
    "desc": "Prereq: Concurrent registration in IA LL 326I\nField study of birds of the upper Midwest; extended field trip to Minnesota and Wisconsin; individual or group project.\n",
    "credits": "2"
  },
  {
    "course_name": "Conservation Biology",
    "dept": "A ECL",
    "num": "531",
    "desc": "Prereq: BIOL 312; BIOL 313 or graduate standing\nExamination of conservation issues from a population and a community perspective. Population-level analysis will focus on the role of genetics, demography, and environment in determining population viability. Community perspectives will focus on topics such as habitat fragmentation, reserve design, biodiversity assessment, and restoration ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Conservation Biology",
    "dept": "A ECL",
    "num": "531I",
    "desc": "Prereq: IA LL 312I\nPopulation-and community-level examination of factors influencing the viability of plant and animal populations from both demographic and genetic perspectives; assessment of biodiversity; design and management of preserves.\n",
    "credits": "4"
  },
  {
    "course_name": "Restoration Ecology",
    "dept": "A ECL",
    "num": "535I",
    "desc": "Prereq: A course in ecology\nEcological principles for the restoration of native ecosystems; establishment (site preparation, selection of seed   mixes, planting techniques) and management (fire, mowing, weed control) of native vegetation; evaluation of restorations. Emphasis on the restoration of prairie and wetland vegetation.\n",
    "credits": "4"
  },
  {
    "course_name": "Fishery Management",
    "dept": "A ECL",
    "num": "540",
    "desc": "Prereq: A ECL 312, A ECL 321, STAT 101 or STAT 104; credit or enrollment in A ECL 486\nBiological basis of fishery management, fishery problems, and management practices for freshwater, anadromous, and marine fisheries.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquaculture",
    "dept": "A ECL",
    "num": "542",
    "desc": "Prereq: BIOL 211 and BIOL 212.\nConcepts related to the culture of aquatic organisms including culture systems, water quality, nutrition, genetics, diseases, and marketing.\n",
    "credits": "3"
  },
  {
    "course_name": "Behavioral Ecology",
    "dept": "A ECL",
    "num": "551",
    "desc": "Prereq: a course in ecology or animal behavior\nThe study of how an animal's behavior affects its ability to survive and reproduce in its environment. Course topics, such as foraging behavior, sexual selection, parental care, etc., represent the interface of ecology, evolution, and behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Wildlife Disease",
    "dept": "A ECL",
    "num": "554",
    "desc": "Prereq: Graduate classification\nEcological and epidemiological aspects of disease as they relate to wildlife populations. Topics to be covered include: major classes of disease; detection, description, monitoring, and management of disease; characteristics and interactions between disease agents and wildlife hosts; relationship among wildlife, domestic animal, and human health.\n",
    "credits": "3"
  },
  {
    "course_name": "Techniques for Biology Teaching",
    "dept": "A ECL",
    "num": "573",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching : Animal Biology",
    "dept": "A ECL",
    "num": "573A",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Limnology",
    "dept": "A ECL",
    "num": "573G",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Insect Ecology",
    "dept": "A ECL",
    "num": "573I",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Project WET",
    "dept": "A ECL",
    "num": "573W",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "A ECL",
    "num": "586",
    "desc": "Prereq: BIOL 312 or ENSCI 381 or ENSCI 402 or NREM 301\nStructure and function of aquatic ecosystems with application to fishery and pollution problems. Emphasis on lacustrine, riverine, and wetland ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology Laboratory",
    "dept": "A ECL",
    "num": "586L",
    "desc": "Prereq: Concurrent enrollment in BIOL 486\nField trips and laboratory exercises to accompany 486. Hands-on experience with aquatic research and monitoring techniques and concepts.\n",
    "credits": "1"
  },
  {
    "course_name": "Population Ecology",
    "dept": "A ECL",
    "num": "589",
    "desc": "Prereq: BIOL 312, STAT 101 or STAT 104, a course in calculus, or graduate standing\nConcepts and theories of population dynamics with emphasis on models of growth, predation, competition, and regulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Independent Study",
    "dept": "A ECL",
    "num": "590",
    "desc": "Prereq: Graduate classification and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Graduate Independent Study",
    "dept": "A ECL",
    "num": "590I",
    "desc": "Prereq: Graduate classification and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "A ECL",
    "num": "599",
    "desc": "Prereq: Nonthesis M.S. option only\n",
    "credits": "arr"
  },
  {
    "course_name": "Analysis of Populations",
    "dept": "A ECL",
    "num": "611",
    "desc": "Prereq: BIOL 312; STAT 401; a course in calculus\nQuantitative techniques for analyzing vertebrate population data to estimate parameters such as density and survival. Emphasis on statistical inference and computing.\n",
    "credits": "3"
  },
  {
    "course_name": "Animal Ecology Teaching Practicum",
    "dept": "A ECL",
    "num": "698",
    "desc": "Prereq: Graduate classification in animal ecology and permission of instructor\nGraduate student experience in the animal ecology teaching program.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "A ECL",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "A ECL",
    "num": "699I",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Working with Animals",
    "dept": "AN S",
    "num": "101",
    "desc": "\nA hands-on introductory course in skills for proper care and management of domestic animals. Husbandry skills including health observation, animal movement, identification, management procedures, and environmental assessment are covered.\n",
    "credits": "2"
  },
  {
    "course_name": "Orientation in Animal Science and ISU",
    "dept": "AN S",
    "num": "110",
    "desc": "\nOrientation to the university and Department of Animal Science. Challenges and opportunities available to the professional animal agriculturalist. Professional goal setting, portfolio development, and development of interpersonal skills in the context of pursuing a career in animal science.\n",
    "credits": "1"
  },
  {
    "course_name": "Survey of the Animal Industry",
    "dept": "AN S",
    "num": "114",
    "desc": "\nWays domestic animals serve the basic needs of humans for food, shelter, protection, fuel, and emotional well-being. Terminology, basic structures of the industries surrounding the production, care, and marketing of domestic animals in the U.S.\n",
    "credits": "2"
  },
  {
    "course_name": "Practicum in Safe Equine Handling and Welfare",
    "dept": "AN S",
    "num": "116",
    "desc": "\nDevelopment of best practices for safe horse handling and practical equine health care tasks.  Course will focus on equine welfare and human safety as well as provide training in necessary every day skills needed to own a horse or to work at a horse farm.  Certificate of Safe Equine Handling and Welfare available upon course completion. Offered on satisfactory - fail grading basis only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Livestock Handling, Safety and Welfare",
    "dept": "AN S",
    "num": "190",
    "desc": "Prereq: AN S 101\nUnderstanding of animal perception to develop best care practices involved in handing of livestock species (beef, sheep, swine, dairy, equine, poultry). Intensive development of skills associated with handling and moving healthy and compromised livestock in respect to human and animal welfare. Integration of scientific and theoretical knowledge of biosecurity and animal-human interactions as it related to livestock handling and movement.\n",
    "credits": "2"
  },
  {
    "course_name": "Marketing and Management of Livestock Events",
    "dept": "AN S",
    "num": "199",
    "desc": "Prereq: Credit or enrollment in AN S 101 or AN S 114\nManagement and coordination of livestock shows, sales and events, including program planning, staff and volunteer management, time management, publicity and promotion for fairs, shows, clinics, expos, and other events.\n  Offered on a satisfactory-fail basis only.  A maximum of two credits of AnS 199 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Marketing and Management of Livestock Events: Beef",
    "dept": "AN S",
    "num": "199A",
    "desc": "Prereq: Credit or enrollment in AN S 101 or AN S 114\nManagement and coordination of livestock shows, sales and events, including program planning, staff and volunteer management, time management, publicity and promotion for fairs, shows, clinics, expos, and other events.\n  Offered on a satisfactory-fail basis only.  A maximum of two credits of AnS 199 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Marketing and Management of Livestock Events: Horses",
    "dept": "AN S",
    "num": "199E",
    "desc": "Prereq: Credit or enrollment in AN S 101 or AN S 114\nManagement and coordination of livestock shows, sales and events, including program planning, staff and volunteer management, time management, publicity and promotion for fairs, shows, clinics, expos, and other events.\n  Offered on a satisfactory-fail basis only.  A maximum of two credits of AnS 199 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "The Art and Heritage of Livestock",
    "dept": "AN S",
    "num": "207",
    "desc": "\nUsing art as a venue to understand the legacy and heritage of livestock production and livestock’s contribution to civilization and society; livestock’s contributions to warfare, social class, industry, economies, etc.; history of the impact of livestock on painting, poetry, music, sculpture, advertising, pop culture, movies, religion and sports in society.\n",
    "credits": "3"
  },
  {
    "course_name": "Career Preparation in Animal Science",
    "dept": "AN S",
    "num": "210",
    "desc": "Prereq: Sophomore classification in An S\nLife skill development emphasized in the context of career preparation. Assist students with career goal clarification, interview skills, resume and cover letter preparation. Internship development, job shadowing, and exploration of career option.\n",
    "credits": "1"
  },
  {
    "course_name": "Issues Facing Animal Science",
    "dept": "AN S",
    "num": "211",
    "desc": "Prereq: AN S 114, sophomore classification\nOverview of the factors that define contemporary ethical and scientifically based issues facing animal agriculture. Life skill development (including interactive skills, communication ability, organization, information gathering, and leadership skills) emphasized in the context of issues study.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Domestic Animal Physiology",
    "dept": "AN S",
    "num": "214",
    "desc": "Prereq: BIOL 212, CHEM 163 or CHEM 177\nIntroduction to anatomy and physiology of the muscular, renal, skeletal, neural, mammary, cardiovascular, respiratory, immune, endocrine, reproductive, and digestive systems of domestic animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Domestic Animal Anatomy and Physiology Lab",
    "dept": "AN S",
    "num": "214L",
    "desc": "\nBasic anatomy of domestic animals.\n",
    "credits": "1"
  },
  {
    "course_name": "Equine Science",
    "dept": "AN S",
    "num": "216",
    "desc": "Prereq: AN S 101 or AN S 114; one course in biology\nIntroduction to contemporary concepts, and basic practices and decisions necessary when managing horses through stages of their lives.\n",
    "credits": "3"
  },
  {
    "course_name": "Equine Farm Practicum",
    "dept": "AN S",
    "num": "217",
    "desc": "Prereq: Credit or experience equivalent to AnS 116 and credit or concurrent enrollment in AN S 216.\nIntensified management of the equine farm. Provide students with experiential learning in all phases of horse production and management. Students assist with general farm management, horse health care, weekly farm management, and related topics.\n",
    "credits": "2"
  },
  {
    "course_name": "Poultry Science",
    "dept": "AN S",
    "num": "223",
    "desc": "Prereq: AN S 101, AN S 114\nIntroduction to modern production trends with a focus on broiler, layer, and turkey industries. Topics covered include breeds, handling, management, physiology, nutrition, genetics, health & disease, and products. Weekly labs meet off campus.\n",
    "credits": "3"
  },
  {
    "course_name": "Companion Animal Science",
    "dept": "AN S",
    "num": "224",
    "desc": "Prereq: Course in biology\nIntroduction of students to contemporary concepts, and basic practices and decisions necessary when caring for the companion animal through stages of its life.\n",
    "credits": "3"
  },
  {
    "course_name": "Swine Science",
    "dept": "AN S",
    "num": "225",
    "desc": "Prereq: AN S 101, AN S 114\nIntroduction to principles, practices and decisions necessary when raising swine through the vertically integrated production cycle.\n  Only AN S 280 and AN S 280L or AN S 225 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Beef Cattle Science",
    "dept": "AN S",
    "num": "226",
    "desc": "Prereq: AN S 101, AN S 114\nIntroduction to principles, practices and decisions necessary when raising beef cattle through the vertically integrated production cycle.\n",
    "credits": "3"
  },
  {
    "course_name": "Sheep Science",
    "dept": "AN S",
    "num": "229",
    "desc": "Prereq: AN S 101, AN S 114\nIntroduction to principles, practices and decisions necessary when raising sheep through their production cycle.\n",
    "credits": "3"
  },
  {
    "course_name": "Dairy Cattle Science",
    "dept": "AN S",
    "num": "235",
    "desc": "Prereq: AN S 101, AN S 114\nIntroduction to principles, practices and decisions necessary when raising dairy cattle through the vertically integrated production cycle.\n",
    "credits": "3"
  },
  {
    "course_name": "Foods of Animal Origin",
    "dept": "AN S",
    "num": "270",
    "desc": "Prereq: BIOL 212, CHEM 163 or CHEM 177\nPrinciples, practices and issues impacting the production, processing and preservation of safe, wholesome, nutritious, and palatable meat, dairy, and egg products. Product evaluation, classification, value, and utilization.\n",
    "credits": "2"
  },
  {
    "course_name": "Foods of Animal Origin Laboratory",
    "dept": "AN S",
    "num": "270L",
    "desc": "Prereq: Credit or current enrollment in AN S 270\nDetermination of composition and quality of meat, eggs and milk based on industry and USDA standards. Fundamentals of processing foods of animal orgin to add value, maintain quality and ensure safety.\n",
    "credits": "1"
  },
  {
    "course_name": "Basic Swine Science",
    "dept": "AN S",
    "num": "280",
    "desc": "Prereq: AN S 101 AN S 114\nBasic disciplines and concepts involved in swine production including; industry structure, trends and statistics; production phases and buildings; genetic improvement; reproduction; nutrition; health and biosecurity; nutrient management; marketing and meat quality and career opportunities in the swine industry.\n  Only AN S 280 and AN S 280L or AN S 225 may count toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Livestock Evaluation",
    "dept": "AN S",
    "num": "305",
    "desc": "Prereq: Junior classification; AN S 270L recommended\nFall semester leads to 475A or D. Breeding animal and market animal evaluation of beef, swine and sheep using contemporary techniques and tools. Communication and decision-making skills are practiced in the context of making selection decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Equine Evaluation",
    "dept": "AN S",
    "num": "306",
    "desc": "Prereq: sophomore classification or permission of instructor\nDetailed visual evaluation of conformation and performance of the equine athlete.  Decision-making skills are practiced in the context of making selection choices.  Development of written and oral communication skills as students defend their judgments.  Industry trends will be addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Exercise Physiology of Animals",
    "dept": "AN S",
    "num": "313",
    "desc": "Prereq: AN S 214, BIOL 211, one course in chemistry\nPhysiological adaptations to athletic training in canine and equine athletes. Topics of emphasis include exercise-related adaptations in metabolism, locomotion, the cardiovascular system, musculoskeletal system, and endocrine system.  The roles of nutrition and conditioning programs are assessed.\n",
    "credits": "2"
  },
  {
    "course_name": "Fundamentals of Equine Behavior and Training",
    "dept": "AN S",
    "num": "317",
    "desc": "\nModifying the behavior of the horse using systematic approaches to horse training emphasizing the psychology of training horses. Equipment and its use and preparation of horses for competition.\n  A maximum of 4 credits of An S 317 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Equine Behavior and Training: Young Horses at Halter",
    "dept": "AN S",
    "num": "317A",
    "desc": "\nModifying the behavior of the horse using systematic approaches to horse training emphasizing the psychology of training horses. Equipment and its use and preparation of horses for competition.\n  A maximum of 4 credits of An S 317 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Equine Behavior and Training: Yearlings",
    "dept": "AN S",
    "num": "317B",
    "desc": "Prereq: Permission of instructor\nModifying the behavior of the horse using systematic approaches to horse training emphasizing the psychology of training horses. Equipment and its use and preparation of horses for competition.\n  A maximum of 4 credits of An S 317 may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Equine Behavior and Training: Two-year olds and older",
    "dept": "AN S",
    "num": "317C",
    "desc": "\nModifying the behavior of the horse using systematic approaches to horse training emphasizing the psychology of training horses. Equipment and its use and preparation of horses for competition.\n  A maximum of 4 credits of An S 317 may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Animal Nutrition",
    "dept": "AN S",
    "num": "319",
    "desc": "Prereq: AN S 214, course in organic chemistry or biochemistry\nStructure and function of organic and inorganic nutrients.  Digestion, absorption, metabolism and utilization of nutrients for maintenance and productive functions. Essential nutritive requirements of domestic livestock, poultry, and companion animals.  Sources of nutrients, application of energy systems and concepts, and regulation of feed intake in animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Animal Feeds and Feeding",
    "dept": "AN S",
    "num": "320",
    "desc": "Prereq: AN S 319\nComposition, physical properties, and storage and processing of feedstuffs. Nutrient requirements of and diet formulation, and preparation systems for food and companion animal species at varying stages of age, activity or production. Manual and computer methodologies for diet formulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Processing for Companion Animals",
    "dept": "AN S",
    "num": "324",
    "desc": "Prereq: AN S 319, Junior Classification\nFood processing and nutrition for carnivorous companion animals. Topics covered include meat processing and meat preservation for companion animal diets, regulatory standards, cutting edge technologies for processing meat for companion animals, dietary needs of carnivorous companion animals, effect of different processing methods on safety and nutrient bioavailability.\n",
    "credits": "3"
  },
  {
    "course_name": "Domestic Animal Reproduction",
    "dept": "AN S",
    "num": "331",
    "desc": "Prereq: AN S 214 or BIOL 255 & 256 or BIOL 335 or B M S 329\nComparative anatomy, physiology, and endocrinology of domestic mammalian animal reproduction. Techniques for the control and manipulation of reproductive processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory Methods in Animal Reproduction",
    "dept": "AN S",
    "num": "332",
    "desc": "Prereq: Credit or enrollment in AN S 331\nReproductive anatomy with emphasis on the physiology of normal reproductive function; ways to control and improve reproduction; principles of semen collection and artificial insemination; pregnancy testing.\n",
    "credits": "1"
  },
  {
    "course_name": "Laboratory Methods in Animal Reproduction: Livestock,  Companion, and Laboratory Animals",
    "dept": "AN S",
    "num": "332A",
    "desc": "Prereq: Credit or enrollment in AN S 331.\nComparative reproductive anatomy with emphasis on the physiology of normal reproductive function; ways to control and improve reproduction; principles of semen collection and artificial insemination; pregnancy testing.\n",
    "credits": "1"
  },
  {
    "course_name": "Laboratory Methods in Animal Reproduction: Equine",
    "dept": "AN S",
    "num": "332E",
    "desc": "Prereq: Credit or enrollment in AN S 331.\nReproductive anatomy with emphasis on the physiology of normal reproductive function; breeding season management; ways to control and improve reproduction; semen collection, evaluation, and processing; artificial insemination; pregnancy testing; parturition in the mare, foal care.\n",
    "credits": "1"
  },
  {
    "course_name": "Embryo Transfer and Related Technologies",
    "dept": "AN S",
    "num": "333",
    "desc": "Prereq: AN S 331 or AN S 332\nApplication of embryo transfer and related technologies to genetic improvement of mammalian livestock. Techniques for control of female reproduction, embryo collection and transfer, embryo cryopreservation, and embryo manipulation. Gender selection. Economic and genetic aspects of embryo transfer.\n",
    "credits": "3"
  },
  {
    "course_name": "Embryo Transfer Laboratory",
    "dept": "AN S",
    "num": "334",
    "desc": "Prereq: Credit or concurrent enrollment in AN S 333; or AN S 332; permission of instructor\nSelected laboratory exercises related to embryo transfer such as synchronization of estrus, superovulation, detection of estrus, artificial insemination, embryo collection, embryo evaluation, microscopy, embryo cryopreservation, in vitro fertilization, embryo sexing, rectal palpation, and ultrasonography will be demonstrated and/or performed.\n",
    "credits": "1"
  },
  {
    "course_name": "Dairy Cattle Evaluation",
    "dept": "AN S",
    "num": "335",
    "desc": "Prereq: Sophomore classification\nEvaluation of breeding dairy replacement animals and lactating for dairy cows. Emphasis placed on familiarity with anatomical terms/structures, the use of comparative terminology, decision-making skills, and presentation of oral reasons. Trips to dairy cattle farms. Livestock handling. (Introduction and skills development course for AN S 475B.).\n",
    "credits": "3"
  },
  {
    "course_name": "Domestic Animal Behavior and Well-Being",
    "dept": "AN S",
    "num": "336",
    "desc": "Prereq: One course in physiology\nPrinciples of behavior relative to animal care, management and environmental design to ensure animal well-being. Examination of basic neural-endocrine mechanisms involved in the animal's response to its environment.  Awareness of animal protection, law and legislation.  Methods to objectively assess animal well-being.\n",
    "credits": "3"
  },
  {
    "course_name": "Lactation",
    "dept": "AN S",
    "num": "337",
    "desc": "Prereq: AN S 214\nThe structure, development and evolution of the mammary gland. Mammary metabolism, milk synthesis; neural and endocrine regulation of mammary function. Immune function and health of the mammary gland. Current events related to lactation.\n",
    "credits": "3"
  },
  {
    "course_name": "Growth and Development of Domestic Animals",
    "dept": "AN S",
    "num": "345",
    "desc": "Prereq: AN S 214; BIOL 313 or GEN 320\nBasic principles of animal growth and development covered at the tissue, cellular and molecular level.  Emphasis placed on skeletal muscle, adipose, bone, and immune system growth and development.  The effects of genetics, nutrition, and pharmaceuticals on growth.\n",
    "credits": "3"
  },
  {
    "course_name": "Genetic Improvement of Domestic Animals",
    "dept": "AN S",
    "num": "352",
    "desc": "Prereq: One course in statistics, BIOL 211, course in genetics\nPrinciples of qualitative and quantitative genetics applied to creating change in domestic animals. Impact of selection and mating schemes in achieving breeding program goals. Applications and impacts of biotechnological advancements in genetic manipulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Fresh Meats",
    "dept": "AN S",
    "num": "360",
    "desc": "Prereq: AN S 270; a course in organic or biochemistry\nImpact of muscle structure, composition, rigor mortis, inspection, fabrication, handling, packaging and cooking on the palatability, nutritional value, yields, market value, and safety of fresh meat.\n",
    "credits": "3"
  },
  {
    "course_name": "Swine Environment Management",
    "dept": "AN S",
    "num": "382",
    "desc": "Prereq: AN S 225 or 280 and 280L. Recommended TSM 210.\nResponse of swine to thermal environment, ventilation system design and analysis, heating and cooling systems, and examples of various designs for all phases of production. Troubleshooting ventilation systems and energy analysis of production units.\n",
    "credits": "1"
  },
  {
    "course_name": "Swine Manure and Nutrient Management",
    "dept": "AN S",
    "num": "383",
    "desc": "Prereq: AN S 225 or AN S 280 and An S 280L.\nFunction, application, and advantages and disadvantages of nutrient management systems. Manure production rates, manure handling systems, storage and manure management planning for land application and odor mitigation strategies.\n",
    "credits": "1"
  },
  {
    "course_name": "Swine Health and Biosecurity",
    "dept": "AN S",
    "num": "384",
    "desc": "Prereq: AN S 225 or AN S 280 and An S 280L. Recommended a course in microbiology.\nOverview of standard biosecurity protocols and identification of behavior and clinical signs of illness in pigs. Treatment administration and prevention methods. Introduction to immune system function and basic swine disease transmission.\n",
    "credits": "1"
  },
  {
    "course_name": "Animal Science Internship",
    "dept": "AN S",
    "num": "399",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Animal Science Internship: Graded Internship Experience",
    "dept": "AN S",
    "num": "399A",
    "desc": "Prereq: Permission of the instructor\nLearning experience focused on professional development for a career related to animal science. Journal, presentation, and scientific component.\n",
    "credits": "2"
  },
  {
    "course_name": "Animal Science Internship: Supervised Internship Experience",
    "dept": "AN S",
    "num": "399B",
    "desc": "Prereq: Permission of the instructor\nLearning experience focused on professional development for a career related to animal science. Journal, presentation, and scientific component.  This course is designed for those students who are completing a semester long internship located off campus.\n",
    "credits": "R"
  },
  {
    "course_name": "Addressing Issues in Animal Science",
    "dept": "AN S",
    "num": "411",
    "desc": "Prereq: Senior classification in An S\nLife skill development emphasized in the context of exploring one's perspective of the most pressing moral and scientific issues facing animal agriculture. Clarification and communication of personal conclusions in small and large group settings expected.\n",
    "credits": "1"
  },
  {
    "course_name": "Equine Systems Management",
    "dept": "AN S",
    "num": "415",
    "desc": "Prereq: AN S 216, AN S 319, AN S 320, AN S 331\nIdentification and development of financial and production goals in a horse business.  Scientific approach to make decisions in management of enterprises in the horse industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Animal Nutrition",
    "dept": "AN S",
    "num": "419",
    "desc": "Prereq: AN S 214, AN S 319\nDetailed consideration of digestion, metabolism, and assimilation of nutrients. Recent advances and developments in basic nutrition.\n",
    "credits": "2"
  },
  {
    "course_name": "Companion Animal Systems Management",
    "dept": "AN S",
    "num": "424",
    "desc": "Prereq: AN S 224, AN S 319, AN S 320, AN S 331, AN S 352\nDecisions facing the administrator of a companion animal enterprise. Financial and business goal identification, problem clarification, and resource allocation to manage the companion animal system.\n",
    "credits": "3"
  },
  {
    "course_name": "Swine Systems Management",
    "dept": "AN S",
    "num": "425",
    "desc": "Prereq: AN S 225, AN S 270, AN S 270L, AN S 319, AN S 320, AN S 331, AN S 352; ECON 230 or equivalent recommended\nDecisions facing the administrator of a swine enterprise. Financial and production goal identification, problem clarification, and resource allocation to manage the swine enterprise.\n",
    "credits": "3"
  },
  {
    "course_name": "Beef Feedlot Systems Management",
    "dept": "AN S",
    "num": "426",
    "desc": "Prereq: AN S 226, AN S 270, AN S 270L, AN S 320; recommended: ECON 230 or equivalent\nDecisions facing the administrator of a feedlot enterprise. Financial and production goal identification, problem clarification, and resource allocation to manage the beef enterprise.\n",
    "credits": "3"
  },
  {
    "course_name": "Sheep Systems Management",
    "dept": "AN S",
    "num": "429",
    "desc": "Prereq: AN S 229, AN S 319, AN S 320, AN S 331, AN S 352; AGRON 334 recommended; ECON 230 or equivalent recommended\nDecisions facing the administrator of a sheep enterprise. Financial and production goal identification, problem clarification, and resource allocation to manage the sheep enterprise.\n",
    "credits": "3"
  },
  {
    "course_name": "Dairy Systems Management",
    "dept": "AN S",
    "num": "434",
    "desc": "Prereq: AN S 235, AN S 319, AN S 331, AN S 320, AN S 337, AN S 352; ECON 230 or equivalent recommended\nThe scientific foundation of dairy cattle management.  The impact of dairy farm management practices on the biological processes of the cow. Integrates concepts from the disciplines of lactation, reproduction, nutrition, genetics, and animal health.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Dairy Farm Evaluation",
    "dept": "AN S",
    "num": "435",
    "desc": "Prereq: AN S S 434; ECON 230\nEvaluate nutrition, reproduction, milk quality, breeding, and related management practices of commercial dairy herds in a case study format.  Students will apply knowledge gained in the classroom to commercial dairy farm situations and develop skills in information gathering, decision making, problem solving, and interpersonal communications.\n",
    "credits": "3"
  },
  {
    "course_name": "International Animal Agriculture",
    "dept": "AN S",
    "num": "441",
    "desc": "Prereq: Two courses from AN S 223, AN S 225, AN S 226, AN S 229, AN S 235\nAn overview of animal agriculture with emphasis in developing countries. Historical, economic, environmental, and political considerations will be assessed and evaluated. Issues related to gender, resilience and sustainability for different production systems including alternative livestock species, will be investigated. The role of animal source foods in attainment of global food security will be discussed.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Processed Meats",
    "dept": "AN S",
    "num": "460",
    "desc": "Prereq: AN S 270\nPhysical, chemical and biological properties of meat important to processed meat product characteristics. Ingredients, technology and equipment used for cured meats, loaf products and fresh, cooked, dry and semi-dry sausage products.\n",
    "credits": "3"
  },
  {
    "course_name": "Intercollegiate Judging Training and Competition",
    "dept": "AN S",
    "num": "475",
    "desc": "Prereq: permission of instructor\nSpecialized training in evaluation and grading of livestock, livestock products, and livestock production management plans.\n  Maximum of 6 credits may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Judging Training and Competition: Meat Animals",
    "dept": "AN S",
    "num": "475A",
    "desc": "Prereq: permission of instructor\nSpecialized training in evaluation and grading of livestock.\n  Maximum of 6 credits may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Judging Training and Competition: Dairy Cattle",
    "dept": "AN S",
    "num": "475B",
    "desc": "Prereq: permission of instructor\nSpecialized training in evaluation and grading of dairy cattle, in particular heifers and lactating dairy cows.  Development and advancement of decision-making skills, comparative techniques, and presentation of oral reasons.\n  Maximum of 6 credits may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Judging Training and Competition: Meats",
    "dept": "AN S",
    "num": "475C",
    "desc": "Prereq: permission of instructor\nSpecialized training in evaluation and grading of livestock/meat products.\n  Maximum of 6 credits may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Judging Training and Competition: Meat Animal Evaluation",
    "dept": "AN S",
    "num": "475D",
    "desc": "Prereq: permission of instructor\nSpecialized training in evaluation and grading of livestock, livestock products, and livestock production management plans.\n  Maximum of 6 credits may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Judging Training and Competition: Horses",
    "dept": "AN S",
    "num": "475E",
    "desc": "Prereq: permission of instructor\nSpecialized training in evaluation of horses.  Emphasis placed on familiarity with anatomical terms/structures, the use of comparative terminology,  and decision making skills.\n  Maximum of 6 credits may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Judging Training and Competition: Management Systems",
    "dept": "AN S",
    "num": "475F",
    "desc": "Prereq: permission of instructor\nSpecialized training in evaluation of livestock/domesticated animal production management plans.\n  Maximum of 6 credits may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Animal Industry Leadership Fellows",
    "dept": "AN S",
    "num": "480",
    "desc": "Prereq: A.  AN S 226; permission of instructor  C.  AN S 225; permission of instructor\nStudents broaden their perspective of the livestock industry through site visits, case-study (Fellows) projects, and cooperative learning experiences that capitalize on interaction skills in the context of studying the structure of the U.S. livestock industry.  This for-credit offering represents the central academic focus of the Iowa State University Animal Industry Leadership Fellows Program.  Study is species specific, and enrollment is limited.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Animal Industry Leadership Fellows: Beef",
    "dept": "AN S",
    "num": "480A",
    "desc": "Prereq: AN S 226; permission of instructor\nStudents broaden their perspective of the livestock industry through site visits, case-study (Fellows) projects, and cooperative learning experiences that capitalize on interaction skills in the context of studying the structure of the U.S. livestock industry.  This for-credit offering represents the central academic focus of the Iowa State University Animal Industry Leadership Fellows Program.  Study is species specific, and enrollment is limited.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Animal Industry Leadership Fellows: Pork",
    "dept": "AN S",
    "num": "480C",
    "desc": "Prereq: AN S 225; permission of instructor\nStudents broaden their perspective of the livestock industry through site visits, case-study (Fellows) projects, and cooperative learning experiences that capitalize on interaction skills in the context of studying the structure of the U.S. livestock industry.  This for-credit offering represents the central academic focus of the Iowa State University Animal Industry Leadership Fellows Program.  Study is species specific, and enrollment is limited.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Animal Industry Leadership Fellows: Poultry",
    "dept": "AN S",
    "num": "480G",
    "desc": "Prereq: AN S 223; permission of instructor\nStudents broaden their perspective of the livestock industry through site visits, case-study (Fellows) projects, and cooperative learning experiences that capitalize on interaction skills in the context of studying the structure of the U.S. livestock industry. Central academic focus of the Iowa State University Animal Industry Leadership Fellows Program. Study is species specific, and enrollment is limited.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Issues in Food Safety",
    "dept": "AN S",
    "num": "489",
    "desc": "Prereq: Credit or enrollment in FS HN 101 or FS HN 272 or HSP M 233; FS HN 419 or FS HN 420; FS HN 403\nCapstone seminar for the food safety minor. Case discussions and independent projects about safety issues in the food system from a multidisciplinary perspective.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "AN S",
    "num": "490",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Animal Science",
    "dept": "AN S",
    "num": "490A",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Dairy Science",
    "dept": "AN S",
    "num": "490B",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Meat Science",
    "dept": "AN S",
    "num": "490C",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Companion Animal Science",
    "dept": "AN S",
    "num": "490D",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Equine Science",
    "dept": "AN S",
    "num": "490E",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Poultry Science",
    "dept": "AN S",
    "num": "490G",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "AN S",
    "num": "490H",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "AN S",
    "num": "490I",
    "desc": "Prereq: Permission of the instructor\nOpen to juniors and seniors in animal science and dairy science showing satisfactory preparation for problems chosen. Individual topic conference and preparation of report.\n  A maximum of 6 credits of An S 490 may be applied toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Animal Science",
    "dept": "AN S",
    "num": "493",
    "desc": "Prereq: Permission of instructor\nWorkshop in livestock production. Includes current concepts in breeding, nutrition, reproduction, meats, and technologies that impact the animal industry.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural Travel Course Preparation",
    "dept": "AN S",
    "num": "495",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Students enrolled in this course will also register for Agron 495 and intend to register in AGRON 496 and AN S 496 the following term. Topics will include the agricultural industries, climate, crops, culture, history, livestock, marketing, soils, and preparation for travel to locations to be visited. Information normally available 9 months before departure.\n",
    "credits": "R"
  },
  {
    "course_name": "Agricultural Travel Course",
    "dept": "AN S",
    "num": "496",
    "desc": "Prereq: Permission of instructor, 30 college credits\nLimited enrollment. Students enroll in both AN S 496 and AGRON 496. Tour and study of production methods in major crop and livestock regions of the world. Influence of climate, economics, geography, soils, landscapes, markets, and other factors on livestock and crop production. Locations and duration of tours will vary. Summer tour will usually visit a northern location and winter tour will usually visit a southern location. Information usually available 9 months before departure. Tour expenses paid by students.\n",
    "credits": "arr"
  },
  {
    "course_name": "Agricultural Travel Course: International Tour",
    "dept": "AN S",
    "num": "496A",
    "desc": "Prereq: Permission of instructor, 30 college credits\nLimited enrollment. Students enroll in both AN S 496 and AGRON 496. Tour and study of production methods in major crop and livestock regions of the world. Influence of climate, economics, geography, soils, landscapes, markets, and other factors on livestock and crop production. Locations and duration of tours will vary. Summer tour will usually visit a northern location and winter tour will usually visit a southern location. Information usually available 9 months before departure. Tour expenses paid by students.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Agricultural Travel Course: Domestic tour",
    "dept": "AN S",
    "num": "496B",
    "desc": "Prereq: Permission of instructor, 30 college credits\nLimited enrollment. Students enroll in both AN S 496 and AGRON 496. Tour and study of production methods in major crop and livestock regions of the world. Influence of climate, economics, geography, soils, landscapes, markets, and other factors on livestock and crop production. Locations and duration of tours will vary. Summer tour will usually visit a northern location and winter tour will usually visit a southern location. Information usually available 9 months before departure. Tour expenses paid by students.\n",
    "credits": "arr"
  },
  {
    "course_name": "Undergraduate Teaching Experiences in Animal Science",
    "dept": "AN S",
    "num": "497",
    "desc": "Prereq: Permission of instructor\nDevelopment of oral and written communication skills of technical concepts in animal science. Emphasis on organizational skills, conducting activities and interpersonal communication skills. Responsibilities in a class under direct supervision of a faculty member.\n  A maximum of 4 credits of An S 497 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Computer Techniques for Biological Research",
    "dept": "AN S",
    "num": "500",
    "desc": "\nIntroduction to UNIX and SAS for solving research problems, including organization of data files, transfer of files between workstations, developing models, and techniques for analysis of designed experiments. Introduction to matrix algebra for solving animal breeding problems using MATLAB and computer simulation.\n",
    "credits": "1"
  },
  {
    "course_name": "Computer Techniques for Biological Research: UNIX and SAS",
    "dept": "AN S",
    "num": "500A",
    "desc": "\nFirst half semester course. Introduction to UNIX and SAS for solving research problems, including organization of data files, transfer of files between workstations, developing models, and techniques for analysis of designed experiments. Introduction to matrix algebra for solving animal breeding problems using MATLAB and computer simulation.\n",
    "credits": "1"
  },
  {
    "course_name": "Computer Techniques for Biological Research: Problem solving using matrix algebra",
    "dept": "AN S",
    "num": "500B",
    "desc": "\nSecond half semester course. Introduction to UNIX and SAS for solving research problems, including organization of data files, transfer of files between workstations, developing models, and techniques for analysis of designed experiments. Introduction to matrix algebra for solving animal breeding problems using MATLAB and computer simulation.\n",
    "credits": "1"
  },
  {
    "course_name": "Survey of Animal Disciplines",
    "dept": "AN S",
    "num": "501",
    "desc": "\nRequired for Animal Science graduate students. Orientation to departmental and graduate school policies and procedures. Discussion of programs of research and outreach in Animal Science. Issues impacting the animal industry.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Animal Production",
    "dept": "AN S",
    "num": "503",
    "desc": "Prereq: Permission of instructor\nDiscussion and evaluation of current topics in animal production and management.\n",
    "credits": "1"
  },
  {
    "course_name": "Integrated Crop and Livestock Production Systems",
    "dept": "AN S",
    "num": "515",
    "desc": "Prereq: SUSAG 509\nMethods to maintain productivity and minimize the negative ecological effects of agricultural systems by understanding nutrient cycles, managing manure and crop residue, and utilizing multispecies interactions. Crop and livestock production within landscapes and watersheds is also considered. Course includes a significant field component, with student teams analyzing Iowa farms.\n",
    "credits": "3"
  },
  {
    "course_name": "Gut Microbiome: Implications for Health and Diseases",
    "dept": "AN S",
    "num": "517",
    "desc": "Prereq: Basic Knowledge in microbiology\nExplore current research on gut microbiome including modern tools used to study the gut microbiome. Examine the linkages between gut microbiome and health status, diseases, and manipulation of gut microbiome to improve health.\n",
    "credits": "3"
  },
  {
    "course_name": "Digestive Physiology and Metabolism of Non Ruminants",
    "dept": "AN S",
    "num": "518",
    "desc": "Prereq: AN S 419 or NUTRS 501\nDigestion and metabolism of nutrients. Nutritional requirements and current research and feeding programs for poultry and swine.\n",
    "credits": "3"
  },
  {
    "course_name": "Digestive Physiology and Metabolism of Ruminants",
    "dept": "AN S",
    "num": "520",
    "desc": "Prereq: AN S 419 or NUTRS 501\nDigestive physiology and nutrient metabolism in ruminant and preruminant animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Physiology and Endocrinology of Animal Reproduction",
    "dept": "AN S",
    "num": "533",
    "desc": "Prereq: General physiology course\nDevelopment of structure and function of the reproductive system. Physiologic and endocrine aspects including puberty, gametogenesis, estrous cycle, pregnancy, maternal recognition, fertilization and early embryonic development.\n",
    "credits": "2"
  },
  {
    "course_name": "Perinatology",
    "dept": "AN S",
    "num": "536",
    "desc": "Prereq: One course in physiology; one course in biochemistry\nRegulation of metabolism and development in the mammalian fetus and neonate is explored in a comparative manner.  Emphasis will be on the dynamic changes in these relationships occurring at birth.\n",
    "credits": "2"
  },
  {
    "course_name": "Topics in Animal Behavior, Welfare",
    "dept": "AN S",
    "num": "537",
    "desc": "Prereq: permission of instructor; M.S. or Ph.D. student\nEach semester, the students’ focus is on different topics related to animal behavior, animal welfare and contemporary issues related to animal behavior and welfare. Each topic is separate and distinct, and students may enroll in multiple topics. This is an on-line course only. Each topic may be taken only one time for credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Animal Behavior, Welfare: Animal Behavior",
    "dept": "AN S",
    "num": "537A",
    "desc": "Prereq: permission of instructor; M.S. or Ph.D. student\nEach semester, the students’ focus is on different topics related to animal behavior, animal welfare and contemporary issues related to animal behavior and welfare. Each topic is separate and distinct, and students may enroll in multiple topics. This is an on-line course only. Each topic may be taken only one time for credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Animal Behavior, Welfare: Contemporary Issues.",
    "dept": "AN S",
    "num": "537B",
    "desc": "Prereq: permission of instructor; M.S. or Ph.D. student\nEach semester, the students’ focus is on different topics related to animal behavior, animal welfare and contemporary issues related to animal behavior and welfare. Each topic is separate and distinct, and students may enroll in multiple topics. This is an on-line course only. Each topic may be taken only one time for credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Animal Behavior, Welfare: Animal Welfare",
    "dept": "AN S",
    "num": "537C",
    "desc": "Prereq: permission of instructor; M.S. or Ph.D. student\nEach semester, the students’ focus is on different topics related to animal behavior, animal welfare and contemporary issues related to animal behavior and welfare. Each topic is separate and distinct, and students may enroll in multiple topics. This is an on-line course only. Each topic may be taken only one time for credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Animal Behavior, Welfare: Immune and Stress",
    "dept": "AN S",
    "num": "537D",
    "desc": "Prereq: permission of instructor; M.S. or Ph.D. student\nEach semester, the students’ focus is on different topics related to animal behavior, animal welfare and contemporary issues related to animal behavior and welfare. Each topic is separate and distinct, and students may enroll in multiple topics. This is an on-line course only. Each topic may be taken only one time for credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Livestock Immunogenetics",
    "dept": "AN S",
    "num": "540",
    "desc": "Prereq: AN S 561 or MICRO 575 or V MPM 520\nBasic concepts and contemporary topics in genetic regulation of livestock immune response and disease resistance.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Vertebrate Physiology I",
    "dept": "AN S",
    "num": "549",
    "desc": "Prereq: recommended: an undergraduate physiology course and a biochemistry course\nOverview of mammalian physiology. Cell biology, endocrinology, cardiovascular, respiratory, immune, digestive, skeletal muscle and reproductive systems.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Vertebrate Physiology II",
    "dept": "AN S",
    "num": "552",
    "desc": "Prereq: BIOL 335; credit or enrollment in BBMB 404 or BBMB 420\nCardiovascular, renal, respiratory, and digestive physiology.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Topics in Genome Analysis",
    "dept": "AN S",
    "num": "556",
    "desc": "Prereq: BBMB 405 or GDCB 510\nIntroduction to principles and methodology of molecular genetics useful in analyzing and modifying large genomes.\n",
    "credits": "3"
  },
  {
    "course_name": "Processed Meats",
    "dept": "AN S",
    "num": "560",
    "desc": "Prereq: AN S 270\nPhysical, chemical and biological properties of meat important to processed meat product characteristics. Ingredients, technology and equipment used for cured meats, loaf products and fresh, cooked, dry and semi-dry sausage products.\n",
    "credits": "3"
  },
  {
    "course_name": "Population and Quantitative Genetics for Breeding",
    "dept": "AN S",
    "num": "561",
    "desc": "Prereq: STAT 401\nPopulation and quantitative genetics for plant and animal genetics. Study of the genetic basis and analysis of variation in quantitative traits in domestic or experimental populations using phenotypic and molecular marker data, including estimation of heritability and other genetic parameters, linkage analysis and mapping of quantitative trait loci, and the impact of inbreeding, heterosis, and genotype-by-environment interaction.\n",
    "credits": "4"
  },
  {
    "course_name": "Methodologies for Population/Quantitative Genetics",
    "dept": "AN S",
    "num": "562",
    "desc": "Prereq: AN S 561, STAT 402\nBasic theory for genetic analysis of animal breeding data. Course A (1st half semester) covers linear models, selection index methods, and basic theory for best linear unbiased prediction. Course B (2nd half semester) best linear unbiased prediction, including genetic groups, environmental adjustment, repeated records, multiple trait models, maternal effects models, and theory for maximum likelihood estimation of genetic parameters.\n",
    "credits": "2"
  },
  {
    "course_name": "Methodologies for Population/Quantitative Genetics: Linear Models and Genetic Prediction",
    "dept": "AN S",
    "num": "562A",
    "desc": "Prereq: AN S 561, STAT 402\nBasic theory for genetic analysis of animal breeding data. Course A (1st half semester) covers linear models, selection index methods, and basic theory for best linear unbiased prediction. Course B (2nd half semester) best linear unbiased prediction, including genetic groups, environmental adjustment, repeated records, multiple trait models, maternal effects models, and theory for maximum likelihood estimation of genetic parameters.\n",
    "credits": "2"
  },
  {
    "course_name": "Methodologies for Population/Quantitative Genetics: Advanced Genetic Prediction&Parameter Estimation",
    "dept": "AN S",
    "num": "562B",
    "desc": "Prereq: AN S 561, STAT 402\nBasic theory for genetic analysis of animal breeding data. Course A (1st half semester) covers linear models, selection index methods, and basic theory for best linear unbiased prediction. Course B (2nd half semester) best linear unbiased prediction, including genetic groups, environmental adjustment, repeated records, multiple trait models, maternal effects models, and theory for maximum likelihood estimation of genetic parameters.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Meat Science and Applied Muscle Biology",
    "dept": "AN S",
    "num": "570",
    "desc": "Prereq: AN S 460\nAnte and postmortem factors impacting composition, structure, and chemistry of red meat and poultry muscle/meat, the conversion of muscle to meat, and the sensory and nutritional attributes of fresh meats. Oral research reports and a research proposal.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Meat Processing Principles and Technology",
    "dept": "AN S",
    "num": "571",
    "desc": "Prereq: AN S 460 or AN S 570\nPhysical/chemical relationships during processing. Effects of modern technology, non-meat additives and preservation techniques on quality and safety of processed meat. Laboratory demonstration of principles and technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "AN S",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Animal Breeding",
    "dept": "AN S",
    "num": "590A",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Animal Nutrition",
    "dept": "AN S",
    "num": "590B",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Meat Animal Production",
    "dept": "AN S",
    "num": "590C",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Dairy Production",
    "dept": "AN S",
    "num": "590D",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Meat Science",
    "dept": "AN S",
    "num": "590E",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Physiology of Reproduction",
    "dept": "AN S",
    "num": "590F",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Muscle Biology",
    "dept": "AN S",
    "num": "590G",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Poultry Nutrition",
    "dept": "AN S",
    "num": "590H",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Poultry Products",
    "dept": "AN S",
    "num": "590I",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Experimental Surgery",
    "dept": "AN S",
    "num": "590J",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Professional Topics",
    "dept": "AN S",
    "num": "590K",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Teaching",
    "dept": "AN S",
    "num": "590L",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Molecular Biology",
    "dept": "AN S",
    "num": "590M",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Ethology",
    "dept": "AN S",
    "num": "590N",
    "desc": "Prereq: Permission of instructor\nSpecial topics in the animal sciences, offered on demand and may be conducted by guest professors.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "AN S",
    "num": "599",
    "desc": "Prereq: Nonthesis M.S\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Animal Breeding and Genetics",
    "dept": "AN S",
    "num": "599A",
    "desc": "Prereq: Nonthesis M.S\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Animal Nutrition",
    "dept": "AN S",
    "num": "599B",
    "desc": "Prereq: Nonthesis M.S\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Animal Physiology",
    "dept": "AN S",
    "num": "599C",
    "desc": "Prereq: Nonthesis M.S\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Animal Science",
    "dept": "AN S",
    "num": "599D",
    "desc": "Prereq: Nonthesis M.S\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Meat Science",
    "dept": "AN S",
    "num": "599E",
    "desc": "Prereq: Nonthesis M.S\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Animal Nutrition",
    "dept": "AN S",
    "num": "603",
    "desc": "Prereq: Permission of instructor\nDiscussion of current literature; preparation and submission of abstracts.\n",
    "credits": "1"
  },
  {
    "course_name": "Vitamins and Minerals",
    "dept": "AN S",
    "num": "618",
    "desc": "Prereq: Biochemistry, physiology, basic nutrition\nUnderstanding molecular aspects of vitamin and mineral metabolism and homeostasis in humans and animals.  An in-depth examination of the chemistry of vitamins and minerals, including genetic mutations, proteins involved in absorption and excretion, and their necessity in biological processes.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Nutrition and Metabolism - Protein",
    "dept": "AN S",
    "num": "619",
    "desc": "Prereq: BBMB 405\nDigestion, absorption, and intermediary metabolism of amino acids and protein. Regulation of protein synthesis and degradation. Integration of cellular biochemistry and physiology of mammalian protein metabolism.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Nutrition and Metabolism - Energy",
    "dept": "AN S",
    "num": "620",
    "desc": "Prereq: BBMB 405\nEnergy constituents of feedstuffs and energy needs of animals as related to cellular biochemistry and physiology. Interpretations of classical and current research.\n",
    "credits": "2"
  },
  {
    "course_name": "Seminar in Animal Reproduction",
    "dept": "AN S",
    "num": "633",
    "desc": "Prereq: Permission of instructor\nDiscussion of current literature and preparation of reports and seminars on selected topics concerning animal physiology.\n",
    "credits": "1"
  },
  {
    "course_name": "Animal Breeding Strategies",
    "dept": "AN S",
    "num": "652",
    "desc": "Prereq: AN S 561\nBasic concepts and methods for design and evaluation of genetic improvement programs for livestock. Topic A. (1st half semester) Prediction of response to selection, selection index theory, multiple trait selection, inbreeding, crossbreeding, and marker-assisted selection.  Topic B. (2nd half semester) Advanced concepts in design and evaluation of animal breeding programs, including modeling and optimization, derivation of economic values, gene-flow, and predicting rates of inbreeding.\n  Each topic may be taken only one time for academic credit.",
    "credits": "2"
  },
  {
    "course_name": "Animal Breeding Strategies: Breeding Goals and Response to Selection",
    "dept": "AN S",
    "num": "652A",
    "desc": "Prereq: AN S 561\nBasic concepts and methods for design and evaluation of genetic improvement programs for livestock. Topic A. (1st half semester) Prediction of response to selection, selection index theory, multiple trait selection, inbreeding, crossbreeding, and marker-assisted selection.  Topic B. (2nd half semester) Advanced concepts in design and evaluation of animal breeding programs, including modeling and optimization, derivation of economic values, gene-flow, and predicting rates of inbreeding.\n  Each topic may be taken only one time for academic credit.",
    "credits": "2"
  },
  {
    "course_name": "Animal Breeding Strategies: Design and Evaluation of Animal Breeding Programs",
    "dept": "AN S",
    "num": "652B",
    "desc": "Prereq: AN S 561\nBasic concepts and methods for design and evaluation of genetic improvement programs for livestock. Topic A. (1st half semester) Prediction of response to selection, selection index theory, multiple trait selection, inbreeding, crossbreeding, and marker-assisted selection.  Topic B. (2nd half semester) Advanced concepts in design and evaluation of animal breeding programs, including modeling and optimization, derivation of economic values, gene-flow, and predicting rates of inbreeding.\n  Each topic may be taken only one time for academic credit.",
    "credits": "2"
  },
  {
    "course_name": "Applied Animal Breeding Strategies",
    "dept": "AN S",
    "num": "653",
    "desc": "Prereq: AN S 561 recommended\nIndustrial applications of breeding systems, selection methods, and new genetic technologies. One or more field trips to an industry breeding company.\n",
    "credits": "2"
  },
  {
    "course_name": "Applied Animal Breeding Strategies: Swine and Poultry",
    "dept": "AN S",
    "num": "653A",
    "desc": "Prereq: AN S 561 recommended\nIndustrial applications of breeding systems, selection methods, and new genetic technologies. One or more field trips to an industry breeding company.\n",
    "credits": "2"
  },
  {
    "course_name": "Applied Animal Breeding Strategies: Beef and Dairy",
    "dept": "AN S",
    "num": "653B",
    "desc": "Prereq: AN S 561 recommended\nIndustrial applications of breeding systems, selection methods, and new genetic technologies. One or more field trips to an industry breeding company.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Computational Methods in Animal Breeding and Genetics",
    "dept": "AN S",
    "num": "655",
    "desc": "Prereq: AN S 500, AN S 562, COM S 207\nComputational methods and strategies for analysis of large data sets with animal breeding data for use in research and industry applications. Course A (1st half semester) Strategies for handling large sets and for prediction using best linear unbiased prediction using a formal language and utility programs. Course B (2nd half semester) Strategies for estimation of genetic parameters and for use of non-linear models for genetic analysis of categorical and survival type data.\n",
    "credits": "2"
  },
  {
    "course_name": "Computational Strategies for Predicting Breeding Values",
    "dept": "AN S",
    "num": "655A",
    "desc": "Prereq: AN S 500, AN S 562, COM S 207\nComputational methods and strategies for analysis of large data sets with animal breeding data for use in research and industry applications. Strategies for handling large sets and for prediction using best linear unbiased prediction using a formal language and utility programs.\n",
    "credits": "2"
  },
  {
    "course_name": "Computational Strategies for Genetic Parameter Estimation",
    "dept": "AN S",
    "num": "655B",
    "desc": "Prereq: AN S 500, AN S 562, COM S 207\nComputational methods and strategies for analysis of large data sets with animal breeding data for use in research and industry applications. Strategies for estimation of genetic parameters and for use of non-linear models for genetic analysis of categorical and survival type data.\n",
    "credits": "2"
  },
  {
    "course_name": "Statistical Methods for Mapping Quantitative Trait Loci",
    "dept": "AN S",
    "num": "656",
    "desc": "Prereq: AN S 562, STAT 447\nStatistical methods for mapping quantitative trait loci in out-bred populations. Methods based on modeling covariances between relatives. Likelihood based methods using half-sib and full-sib families and extended pedigrees. Bayesian methods applied.\n",
    "credits": "2"
  },
  {
    "course_name": "Seminar in Animal Breeding and Genetics",
    "dept": "AN S",
    "num": "658",
    "desc": "\nPresentation of current research related to animal breeding and genetics.\n",
    "credits": "1"
  },
  {
    "course_name": "Molecular Biology of Muscle",
    "dept": "AN S",
    "num": "670",
    "desc": "Prereq: BBMB 405, BBMB 420\nUltrastructure of muscle; chemistry, structure, function, and molecular biology of muscle proteins. Molecular aspects of muscle contraction, development and turnover. Cytoskeletal proteins and dynamics.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Meat Science",
    "dept": "AN S",
    "num": "684",
    "desc": "Prereq: Permission of instructor\nDiscussion and evaluation of current topics in research publications in meat science.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Muscle Biology",
    "dept": "AN S",
    "num": "685",
    "desc": "Prereq: Permission of instructor\nReports and discussion of recent literature and current investigations.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Animal Science",
    "dept": "AN S",
    "num": "695",
    "desc": "\nReports and discussion of current issues and research in animal science.  One credit is required for all M.S. degree candidates with graduate majors in the Department of Animal Science, and two credits are required for all Ph.D. candidates with graduate majors in the Department of Animal Science.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "AN S",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Animal Breeding",
    "dept": "AN S",
    "num": "699A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Animal Nutrition",
    "dept": "AN S",
    "num": "699B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Meat Animal Production",
    "dept": "AN S",
    "num": "699C",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Dairy Production",
    "dept": "AN S",
    "num": "699D",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Meat Science",
    "dept": "AN S",
    "num": "699E",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Physiology of Reproduction",
    "dept": "AN S",
    "num": "699F",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Muscle Biology",
    "dept": "AN S",
    "num": "699G",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Poultry Nutrition",
    "dept": "AN S",
    "num": "699H",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Poultry Products",
    "dept": "AN S",
    "num": "699I",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Animal Ethology",
    "dept": "AN S",
    "num": "699J",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to Cultural Anthropology",
    "dept": "ANTHR",
    "num": "201",
    "desc": "\nComparative study of culture as key to understanding human behaviors in different societies. Using a global, cross-cultural perspective, patterns of family life, economic and political activities, religious beliefs, and the ways in which cultures change are examined.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Biological Anthropology and Archaeology",
    "dept": "ANTHR",
    "num": "202",
    "desc": "\nHuman biological and cultural evolution; survey of the evidence from fossil primates, the human fossil record and the archaeological   record, as well as living primates; introduction to research methods in archaeology and biological anthropology.\n",
    "credits": "3"
  },
  {
    "course_name": "Globalization and Sustainability",
    "dept": "ANTHR",
    "num": "220",
    "desc": "\nAn introduction to understanding the key global issues in sustainability. Focuses on interconnected roles of energy, materials, human resources, economics, and technology in building and maintaining sustainable systems. Applications discussed will include challenges in both the developed and developing world and will examine the role of technology in a resource-constrained world.\n  Cannot be used for technical elective credit in any engineering department.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "American Indians of Iowa",
    "dept": "ANTHR",
    "num": "225",
    "desc": "\nCultures and histories of Native people who have called the present state of Iowa home; primary focus on the period between 1700 CE and the present; Native interactions with Spanish, French, British, and American people.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Globalization and the Human Condition",
    "dept": "ANTHR",
    "num": "230",
    "desc": "\nAn introduction to understanding key global issues in the contemporary world. Focuses on social relations, cultural practices and political-economic linkages among Africa, the Americas, Asia, Europe and the Pacific.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Primate Behavior",
    "dept": "ANTHR",
    "num": "250",
    "desc": "Prereq: ANTHR 202 and/or basic biology course recommended\nAn introduction to the Order Primates with a focus on their behavior.  Biological and social adaptations of monkeys, apes, and prosimians; basic evolutionary concepts, current trends and theories in the field of Primatology and issues related to primate conservation.\n",
    "credits": "3"
  },
  {
    "course_name": "Cultural Anthropology",
    "dept": "ANTHR",
    "num": "306",
    "desc": "Prereq: ANTHR 201\nSurvey of the major theoretical, methodological and empirical foundations of cultural anthropology.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Biological Anthropology",
    "dept": "ANTHR",
    "num": "307",
    "desc": "Prereq: ANTHR 202\nHuman evolution as known from fossil evidence, comparative primate studies, and genetic variations in living populations. Laboratory-tutorial sessions include study and discussion of human osteology, fossil hominids, simple Mendelian traits, and bio-ethics in applied biological anthropology.\n",
    "credits": "3"
  },
  {
    "course_name": "Archaeology",
    "dept": "ANTHR",
    "num": "308",
    "desc": "Prereq: ANTHR 202\nMethods and techniques for the recovery and interpretation of archaeological evidence, its role in reconstructing human behavior   and past environments. Laboratory sessions include experience in the interpretation of archaeological evidence, the use of   classification systems, and prehistoric technologies such as ceramics and stone tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Culture and Language",
    "dept": "ANTHR",
    "num": "309",
    "desc": "Prereq: ANTHR 201 recommended\nIntroduction to study of language, culture and society from an anthropological perspective. Focus on language and thought,   ethnography of speaking, discourse and narrative, writing and literacy, and media communication. Discussion of key theories and   methods of linguistic anthropology.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Kinship and Marriage  in a Global Perspective",
    "dept": "ANTHR",
    "num": "313",
    "desc": "Prereq: ANTHR 201 recommended\nComparative and historical overview of the family, marriage and kinship. Examination of cross-cultural differences in the   construction and functioning of family and kin relations; role of kinship in structuring individual and collective activities; current   critical and theoretical issues in kinship studies, especially integrating work on gender and sexuality.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Archaeology of North America",
    "dept": "ANTHR",
    "num": "315",
    "desc": "Prereq: ANTHR 202\nPrehistory and early history of North America as reconstructed from archaeological evidence; peopling of the New World; culture-  historical sequences of major culture areas; linkages of archaeological traditions with selected ethnohistorically known Native   American groups.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Skeletal Biology",
    "dept": "ANTHR",
    "num": "319",
    "desc": "Prereq: ANTHR 307 or college level biology\nComprehensive study of the skeletal anatomy, physiology, genetics, growth, development and population variation of the human skeleton. Applications to forensic anthropology, paleopathology and bioarchaeology are introduced.\n",
    "credits": "3"
  },
  {
    "course_name": "Great Plains Archaeology",
    "dept": "ANTHR",
    "num": "320",
    "desc": "Prereq: ANTHR 202\nPrehistoric societies of the Great Plains region of North America, from initial occupation to European contact; emphasis on   sociocultural changes, continuities, and adaptations to changing environments using archaeological, ecological, ethnographic   information.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "World Prehistory",
    "dept": "ANTHR",
    "num": "321",
    "desc": "Prereq: ANTHR 202 recommended\nAn introduction to archaeological sites from around the world including the Near East, Africa, Europe, Mesoamerica, and North and South America. Emphasis is on the interpretation of material cultural remains in reconstructing past societies.\n",
    "credits": "3"
  },
  {
    "course_name": "Peoples and Cultures of Native North America",
    "dept": "ANTHR",
    "num": "322",
    "desc": "Prereq: ANTHR 201 or AM IN 210\nOrigin, distribution, and pre-contact life of the indigenous peoples of North America. Survey of culture areas; language families,   social and political systems, ecological and economic adaptations, religion and spirituality; impact of European contact;  cultural   resilience and revitalization in contemporary American Indian life.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Latin American Anthropology",
    "dept": "ANTHR",
    "num": "323",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Violence and Memory",
    "dept": "ANTHR",
    "num": "323A",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Social movements and Democracy",
    "dept": "ANTHR",
    "num": "323B",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Race, Class and Gender",
    "dept": "ANTHR",
    "num": "323C",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Regional Focus",
    "dept": "ANTHR",
    "num": "323D",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Culture and Sport.",
    "dept": "ANTHR",
    "num": "323E",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Peoples and Cultures of Africa.",
    "dept": "ANTHR",
    "num": "325",
    "desc": "Prereq: 201 or 306 recommended.\nSurvey of diverse African culture areas across the continent and globally; local level description and analysis of individuals as members of African communities; regional, national and global scales of identification.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Archaeological Discovery and Analysis",
    "dept": "ANTHR",
    "num": "328",
    "desc": "Prereq: ANTHR 308\nIdentification, analysis, and interpretation of animal bones recovered from archaeological sites, emphasizing taphonomy, paleoecology, and faunal exploitation.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America",
    "dept": "ANTHR",
    "num": "332",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Gender and Family",
    "dept": "ANTHR",
    "num": "332A",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Indigenous Ecologies and Geographies",
    "dept": "ANTHR",
    "num": "332B",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Cultural and Political Movements",
    "dept": "ANTHR",
    "num": "332C",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Regional Focus",
    "dept": "ANTHR",
    "num": "332D",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Asian American Material Cultures",
    "dept": "ANTHR",
    "num": "333",
    "desc": "\nExamination of material objects made and used by Asian Americans with both historical and contemporary focuses; transnational and interdisciplinary lenses to interpret the material world; contemporary approaches to analysis of artifacts.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Global Development",
    "dept": "ANTHR",
    "num": "336",
    "desc": "Prereq: ANTHR 201 or ANTHR 306\nCross-cultural analysis of current development practices from an anthropological perspective; focus on international aid,   development institutions, agrarian reform, indigenous knowledge, humanitarianism and human rights; introduction to main theories   of political and economic anthropology.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Magic, Witchcraft, and Religion",
    "dept": "ANTHR",
    "num": "340",
    "desc": "Prereq: ANTHR 201 or ANTHR 306\nSurvey of global religious belief and practice from an anthropological perspective. Emphasis on myth and ritual, shamanism, magic,   witchcraft, beliefs in spirits, conceptions of the soul, mind and body relationships, and healing and therapeutic practices. Discussion   of religious response to dramatic political and social change; effects of globalization on religious practice.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "War and the Politics of Humanitarianism",
    "dept": "ANTHR",
    "num": "354",
    "desc": "Prereq: POL S 235, POL S 251, Anthr 210, or ANTHR 230\nHumanitarianism as a system of thought and a system of intervention in conflict and post-conflict situations. Role of humanitarian organizations and actors in addressing human suffering caused by conflict or war. Military action as a form of humanitarian intervention.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Classical Archaeology",
    "dept": "ANTHR",
    "num": "376",
    "desc": "\nChronological survey of the material culture of the ancient Graeco-Roman world and the role of archaeological context in understanding the varied aspects of ancient Greek or Roman culture. Among other topics, economy, architecture, arts and crafts, trade and exchange, religion and burial customs will be explored.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Classical Archeology: Bronze Age and Early Iron Age Greece",
    "dept": "ANTHR",
    "num": "376A",
    "desc": "\nBronze Age (Minoan and Mycenaean palatial cultures) and Early Iron Age Greece. (ca 3000-700 BCE). Chronological survey of the material culture of the ancient Greece-Roman world and the role of archaeological context in understanding the varied aspects of ancient Greek or Roman culture. Among other topics, economy, architecture, arts and crafts, trade and exchange, religion and burial customs will be explored.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Classical Archeology: Archaic through Hellenistic Greece (ca 700-30 BCE)",
    "dept": "ANTHR",
    "num": "376B",
    "desc": "\nChronological survey of the material culture of ancient Greece from ca. 700-30 BCE and the role of archaeological context in understanding the varied aspects of Greek culture during the Archaic, Classical, and Hellenistic periods. Among other topics, economy, architecture, arts and crafts, trade and exchange, religion and burial customs will be explored.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Classical Archaeology: Roman Archaeology (ca 1000 BCE-400 CE)",
    "dept": "ANTHR",
    "num": "376C",
    "desc": "\nChronological survey of the material culture of the ancient Roman world and the role of archaeological context in understanding the varied aspects of ancient Roman culture. Among other topics, economy, architecture, arts and crafts, trade and exchange, religion and burial customs will be explored.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Anthropology for Global Professionals",
    "dept": "ANTHR",
    "num": "411",
    "desc": "Prereq: ANTHR 201 or ANTHR 306\nTheory and methods for conducting ethnographic research in academic and non-academic settings; application of anthropological knowledge to contemporary cultural, political, economic, environmental and spatial issues; development of skills necessary for professional practice as an anthropologist.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Culture, Consumption and Modernity",
    "dept": "ANTHR",
    "num": "418",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nCross-cultural study of the impact of globalization, with an emphasis on economic consumption and the movement of goods, ideas, and peoples across cultural and national boundaries.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Cultural Anthropology",
    "dept": "ANTHR",
    "num": "419",
    "desc": "Prereq: ANTHR 306\nIn-depth study of current topics in cultural anthropology, such as recent theoretical trends, new methodologies, or new research on a specific region. Topics vary each time offered. Each section may be taken once for credit up to 9 credits.\n  No more than 9 credits of ANTHR 419 courses may be applied towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Cultural Anthropology: Theory",
    "dept": "ANTHR",
    "num": "419A",
    "desc": "Prereq: ANTHR 306\nIn-depth study of current topics in cultural anthropology, such as recent theoretical trends, new methodologies, or new research on a specific region. Topics vary each time offered.\n  No more than 9 credits of ANTHR 419 courses may be applied towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Cultural Anthropology: Methods",
    "dept": "ANTHR",
    "num": "419B",
    "desc": "Prereq: ANTHR 306\nIn-depth study of current topics in cultural anthropology, such as recent theoretical trends, new methodologies, or new research on a specific region. Topics vary each time offered.\n  No more than 9 credits of ANTHR 419 courses may be applied towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Cultural Anthropology: Regional Focus",
    "dept": "ANTHR",
    "num": "419C",
    "desc": "Prereq: ANTHR 306\nIn-depth study of current topics in cultural anthropology, such as recent theoretical trends, new methodologies, or new research on a specific region. Topics vary each time offered.\n  No more than 9 credits of ANTHR 419 courses may be applied towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Cultural Anthropology: Others",
    "dept": "ANTHR",
    "num": "419D",
    "desc": "Prereq: ANTHR 306\nIn-depth study of current topics in cultural anthropology, such as recent theoretical trends, new methodologies, or new research on a specific region. Topics vary each time offered.\n  No more than 9 credits of ANTHR 419 courses may be applied towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Forensic Anthropology",
    "dept": "ANTHR",
    "num": "424",
    "desc": "Prereq: ANTHR 202 or ANTHR 307; ANTHR 319 recommended\nComprehensive study of forensic anthropology, a specialized subfield of biological anthropology. Emphasis is placed on personal   identifications from extremely fragmentary, comingled, burnt, cremated and incomplete skeletal remains. All parameters of forensic   study are included as they pertain to anthropology, including human variation, taphonomy, entomology, archaeology, pathology,   epidemiology; genetics and the non-biological forensic disciplines. An appreciation for the wide range of medicolegal and bioethical   issues will also be gained.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Preparation in Anthropology",
    "dept": "ANTHR",
    "num": "425",
    "desc": "Prereq: Junior classification in anthropology or permission from the instructor\nInstruction and guidance in the development of professional skills needed for success in academic and non-academic   anthropological careers.  Topics will include strategies for internship and job searches, creating resumes and CVs, composing   personal statements and cover letters, and developing contacts and sources.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Field Archaeology",
    "dept": "ANTHR",
    "num": "427I",
    "desc": "\nNature of cultural and environmental evidence in archaeology and how they are used to model past human behavior and land use; emphasis on Iowa prehistory; basic reconnaissance surveying and excavation techniques.\n",
    "credits": "4"
  },
  {
    "course_name": "Topics in Archaeological Laboratory Methods and Techniques: Archaeological Field School",
    "dept": "ANTHR",
    "num": "429",
    "desc": "Prereq: ANTHR 202 or ANTHR 308\nSummer field school for training in archaeological reconnaissance and excavation techniques; documentation and interpretation of archaeological evidence.\n",
    "credits": "4"
  },
  {
    "course_name": "Ethnographic Methods",
    "dept": "ANTHR",
    "num": "431",
    "desc": "\nHands-on training in ethnographic field methods; students will carry out research projects in socio-cultural anthropology, learning   a variety of investigative research techniques commonly used in social sciences.\n",
    "credits": "3"
  },
  {
    "course_name": "Internship",
    "dept": "ANTHR",
    "num": "434",
    "desc": "Prereq: Junior or senior standing\nSupervised practice in government agencies, museums, and business organizations.\n  Offered on a satisfactory-fail basis only.  Not more than 6 credits of internship experience may count towards the major. No credits in Anthr 434 may be used to satisfy Anthropology core courses for majors or for the Anthropology minor.",
    "credits": "2"
  },
  {
    "course_name": "Internship: Archaeology",
    "dept": "ANTHR",
    "num": "434A",
    "desc": "Prereq: Junior or senior standing\nSupervised practice in government agencies, museums, and business organizations.\n  Offered on a satisfactory-fail basis only.  Not more than 6 credits of internship experience may count towards the major. No credits in Anthr 434 may be used to satisfy Anthropology core courses for majors or for the Anthropology minor.",
    "credits": "2"
  },
  {
    "course_name": "Internship: Cultural Anthropology",
    "dept": "ANTHR",
    "num": "434B",
    "desc": "Prereq: Junior or senior standing\nSupervised practice in government agencies, museums, and business organizations.\n  Offered on a satisfactory-fail basis only.  Not more than 6 credits of internship experience may count towards the major. No credits in Anthr 434 may be used to satisfy Anthropology core courses for majors or for the Anthropology minor.",
    "credits": "2"
  },
  {
    "course_name": "Internship: Biological Anthropology",
    "dept": "ANTHR",
    "num": "434C",
    "desc": "Prereq: Junior or senior standing\nSupervised practice in government agencies, museums, and business organizations.\n  Offered on a satisfactory-fail basis only.  Not more than 6 credits of internship experience may count towards the major. No credits in Anthr 434 may be used to satisfy Anthropology core courses for majors or for the Anthropology minor.",
    "credits": "2"
  },
  {
    "course_name": "Internship: Linguistic Anthropology",
    "dept": "ANTHR",
    "num": "434D",
    "desc": "Prereq: Junior or senior standing\nSupervised practice in government agencies, museums, and business organizations.\n  Offered on a satisfactory-fail basis only.  Not more than 6 credits of internship experience may count towards the major. No credits in Anthr 434 may be used to satisfy Anthropology core courses for majors or for the Anthropology minor.",
    "credits": "2"
  },
  {
    "course_name": "Primate Evolutionary Ecology and Behavior",
    "dept": "ANTHR",
    "num": "438",
    "desc": "Prereq: ANTHR 202 or ANTHR 307\nPrimate behavior and ecology in evolutionary perspective: biological and social adaptations of prosimians, monkeys, and apes. Introduction to the Order Primates, basic evolutionary concepts, and techniques of behavioral observation. Focus on theory and methods current in Primatology, including applied conservation biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Sex and Gender in Cross-cultural Perspective",
    "dept": "ANTHR",
    "num": "444",
    "desc": "Prereq: ANTHR 201; ANTHR 306 recommended\nCross-cultural examination of the social construction of genders out of the biological fact of sex. Emphasis on non-western societies. Topics, presented through examination of ethnographic data, will include the range of gender variation, status and roles, the institution of marriage, and symbols of gender valuation.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Biological Field School",
    "dept": "ANTHR",
    "num": "445",
    "desc": "Prereq: ANTHR 202 or BIOL 101\nSummer field school for training in behavioral and ecological methods for primatologists. Proposal, data collection and analyses, and presentation of research topic in primatology.\n",
    "credits": "4"
  },
  {
    "course_name": "Approaches in Anthropology",
    "dept": "ANTHR",
    "num": "450",
    "desc": "Prereq: ANTHR 306\nExamination of key approaches to anthropology and its interrelated sub-fields with a focus on major theoretical and analytical contributions.\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Anthropology",
    "dept": "ANTHR",
    "num": "451",
    "desc": "Prereq: ANTHR 201 or ANTHR 202 or ANTHR 308\nApplication of methods under actual laboratory and field conditions, including basic data management, synthesis, and analysis.\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Anthropology: Archaeology",
    "dept": "ANTHR",
    "num": "451A",
    "desc": "Prereq: ANTHR 201 or ANTHR 202 or ANTHR 308\nApplication of methods under actual laboratory and field conditions, including basic data management, synthesis, and analysis.\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Anthropology: Cultural Anthropology",
    "dept": "ANTHR",
    "num": "451B",
    "desc": "Prereq: ANTHR 201 or ANTHR 202 or ANTHR 308\nApplication of methods under actual laboratory and field conditions, including basic data management, synthesis, and analysis.\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Anthropology: Biological Anthropology",
    "dept": "ANTHR",
    "num": "451C",
    "desc": "Prereq: ANTHR 201 or ANTHR 202 or ANTHR 308\nApplication of methods under actual laboratory and field conditions, including basic data management, synthesis, and analysis.\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Anthropology: Linguistic Anthropology",
    "dept": "ANTHR",
    "num": "451D",
    "desc": "Prereq: ANTHR 201 or ANTHR 202 or ANTHR 308\nApplication of methods under actual laboratory and field conditions, including basic data management, synthesis, and analysis.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Biological Anthropology",
    "dept": "ANTHR",
    "num": "482",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Anthropology: Paleoanthropology",
    "dept": "ANTHR",
    "num": "482A",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Anthropology: Primate Cognition",
    "dept": "ANTHR",
    "num": "482B",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Anthropology: Primate Conservation",
    "dept": "ANTHR",
    "num": "482C",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Anthropology: Population Genetics and Human Evolution",
    "dept": "ANTHR",
    "num": "482D",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ANTHR",
    "num": "490",
    "desc": "Prereq: 9 credits in anthropology\n  No more than 9 credits of Anthr 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Archaeology",
    "dept": "ANTHR",
    "num": "490A",
    "desc": "Prereq: 9 credits in anthropology\n  No more than 9 credits of Anthr 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Cultural Anthropology",
    "dept": "ANTHR",
    "num": "490B",
    "desc": "Prereq: 9 credits in anthropology\n  No more than 9 credits of Anthr 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Biological Anthropology",
    "dept": "ANTHR",
    "num": "490C",
    "desc": "Prereq: 9 credits in anthropology\n  No more than 9 credits of Anthr 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Linguistic Anthropology",
    "dept": "ANTHR",
    "num": "490D",
    "desc": "Prereq: 9 credits in anthropology.\n  No more than 9 credits of Anthr 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "ANTHR",
    "num": "490H",
    "desc": "Prereq: 9 credits in anthropology\n  No more than 9 credits of Anthr 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Iowa Lakeside Laboratory",
    "dept": "ANTHR",
    "num": "490I",
    "desc": "Prereq: 8 credits in biology and permission of instructor\nResearch opportunities for undergraduate students in the biological sciences.\n  No more than 9 credits in Biol 490 may be counted toward graduation and of those, only 6 credits may be applied to the major.",
    "credits": "1"
  },
  {
    "course_name": "Biological Anthropology and Archaeology",
    "dept": "ANTHR",
    "num": "503",
    "desc": "Prereq: ANTHR 307 and ANTHR 308\nHistory of biological anthropology and archaeology, current developments and theoretical issues related to major events in human biocultural evolution and world prehistory.\n",
    "credits": "3"
  },
  {
    "course_name": "Agroecosystems Analysis",
    "dept": "ANTHR",
    "num": "509",
    "desc": "Prereq: Senior or above classification\nExperiential, interdisciplinary examination of Midwestern agricultural and food systems, emphasizing field visits, with some classroom activities.  Focus on understanding multiple elements, perspectives (agronomic, economic, ecologic, social, etc.) and scales of operation.\n",
    "credits": "3"
  },
  {
    "course_name": "Theoretical Dimensions of Cultural Anthropology",
    "dept": "ANTHR",
    "num": "510",
    "desc": "Prereq: 6 credits in anthropology\nSurvey of historical and current developments in topical and theoretical approaches to sociocultural anthropology. Examination and assessment of controversies; new research directions and theoretical approaches.\n",
    "credits": "3"
  },
  {
    "course_name": "Anthropology for Global Professionals",
    "dept": "ANTHR",
    "num": "511",
    "desc": "Prereq: ANTHR 201 or ANTHR 306\nTheory and methods for conducting ethnographic research in academic and non-academic settings; application of anthropological knowledge to contemporary cultural, political, economic, environmental and spatial issues; development of skills necessary for professional practice as an anthropologist.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Kinship and Marriage  in a Global Perspective",
    "dept": "ANTHR",
    "num": "513",
    "desc": "Prereq: ANTHR 201 recommended\nComparative and historical overview of the family, marriage and kinship. Examination of cross-cultural differences in the   construction and functioning of family and kin relations; role of kinship in structuring individual and collective activities; current   critical and theoretical issues in kinship studies, especially integrating work on gender and sexuality.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Archaeology of North America",
    "dept": "ANTHR",
    "num": "515",
    "desc": "Prereq: ANTHR 202\nPrehistory and early history of North America as reconstructed from archaeological evidence; peopling of the New World; culture-  historical sequences of major culture areas; linkages of archaeological traditions with selected ethnohistorically known Native   American groups.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Global Culture, Consumption and Modernity",
    "dept": "ANTHR",
    "num": "518",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nCross-cultural study of the impact of globalization, with an emphasis on economic consumption and the movement of goods, ideas, and peoples across cultural and national boundaries.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Skeletal Biology",
    "dept": "ANTHR",
    "num": "519",
    "desc": "Prereq: ANTHR 307 or college level biology\nComprehensive study of the skeletal anatomy, physiology, genetics, growth, development and population variation of the human skeleton. Applications to forensic anthropology, paleopathology and bioarchaeology are introduced.\n",
    "credits": "3"
  },
  {
    "course_name": "Great Plains Archaeology",
    "dept": "ANTHR",
    "num": "520",
    "desc": "Prereq: ANTHR 202\nPrehistoric societies of the Great Plains region of North America, from initial occupation to European contact; emphasis on   sociocultural changes, continuities, and adaptations to changing environments using archaeological, ecological, ethnographic   information.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "World Prehistory",
    "dept": "ANTHR",
    "num": "521",
    "desc": "Prereq: ANTHR 202 recommended\nAn introduction to archaeological sites from around the world including the Near East, Africa, Europe, Mesoamerica, and North and South America. Emphasis is on the interpretation of material cultural remains in reconstructing past societies.\n",
    "credits": "3"
  },
  {
    "course_name": "Peoples and Cultures of Native North America",
    "dept": "ANTHR",
    "num": "522",
    "desc": "Prereq: ANTHR 201 or AM IN 210\nOrigin, distribution, and pre-contact life of the indigenous peoples of North America. Survey of culture areas; language families,   social and political systems, ecological and economic adaptations, religion and spirituality; impact of European contact;  cultural   resilience and revitalization in contemporary American Indian life.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Latin American Anthropology",
    "dept": "ANTHR",
    "num": "523",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Violence and Memory",
    "dept": "ANTHR",
    "num": "523A",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Social movements and Democracy",
    "dept": "ANTHR",
    "num": "523B",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Race, Class and Gender",
    "dept": "ANTHR",
    "num": "523C",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Regional Focus",
    "dept": "ANTHR",
    "num": "523D",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Culture and Sport.",
    "dept": "ANTHR",
    "num": "523E",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Forensic Anthropology",
    "dept": "ANTHR",
    "num": "524",
    "desc": "Prereq: ANTHR 202 or ANTHR 307; ANTHR 319 recommended\nComprehensive study of forensic anthropology, a specialized subfield of biological anthropology. Emphasis is placed on personal   identifications from extremely fragmentary, comingled, burnt, cremated and incomplete skeletal remains. All parameters of forensic   study are included as they pertain to anthropology, including human variation, taphonomy, entomology, archaeology, pathology,   epidemiology; genetics and the non-biological forensic disciplines. An appreciation for the wide range of medicolegal and bioethical   issues will also be gained.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Archaeological Laboratory Methods and Techniques: Archaeological Field School",
    "dept": "ANTHR",
    "num": "529",
    "desc": "Prereq: ANTHR 202 or ANTHR 308\nSummer field school for training in archaeological reconnaissance and excavation techniques; documentation and interpretation of archaeological evidence.\n",
    "credits": "4"
  },
  {
    "course_name": "Ethnographic Methods",
    "dept": "ANTHR",
    "num": "531",
    "desc": "\nHands-on training in ethnographic field methods; students will carry out research projects in socio-cultural anthropology, learning   a variety of investigative research techniques commonly used in social sciences.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America",
    "dept": "ANTHR",
    "num": "532",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Gender and Family",
    "dept": "ANTHR",
    "num": "532A",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Indigenous Ecologies and Geographies",
    "dept": "ANTHR",
    "num": "532B",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Cultural and Political Movements",
    "dept": "ANTHR",
    "num": "532C",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Native North America: Regional Focus",
    "dept": "ANTHR",
    "num": "532D",
    "desc": "Prereq: ANTHR 201 or ANTHR 306; ANTHR 322 or AM IN 210 recommended\nExploration of key contemporary and historical issues in Native North America; discussion of current anthropological approaches to studying Native North America in a global context. Topics vary each time offered.\n  Only 9 credits of ANTHR/AM IN 332A, 332B, 332C, 332D may count toward graduation.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Global Development",
    "dept": "ANTHR",
    "num": "536",
    "desc": "Prereq: ANTHR 201 or ANTHR 306\nCross-cultural analysis of current development practices from an anthropological perspective; focus on international aid,   development institutions, agrarian reform, indigenous knowledge, humanitarianism and human rights; introduction to main theories   of political and economic anthropology.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Primate Evolutionary Ecology and Behavior",
    "dept": "ANTHR",
    "num": "538",
    "desc": "Prereq: ANTHR 202 or ANTHR 307\nPrimate behavior and ecology in evolutionary perspective: biological and social adaptations of prosimians, monkeys, and apes. Introduction to the Order Primates, basic evolutionary concepts, and techniques of behavioral observation. Focus on theory and methods current in Primatology, including applied conservation biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Magic, Witchcraft, and Religion",
    "dept": "ANTHR",
    "num": "540",
    "desc": "Prereq: ANTHR 201 or ANTHR 306\nSurvey of global religious belief and practice from an anthropological perspective. Emphasis on myth and ritual, shamanism, magic,   witchcraft, beliefs in spirits, conceptions of the soul, mind and body relationships, and healing and therapeutic practices. Discussion   of religious response to dramatic political and social change; effects of globalization on religious practice.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Forensic Sciences",
    "dept": "ANTHR",
    "num": "541",
    "desc": "Prereq: One 200-level science course or graduate classification\nSeminars by professional criminalists, research scientists, Certificate students, and educators. Emphasis on opportunities for   research and development, citizen involvement, and educational outreach related to forensic science. Weekly report required.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Research and Presentation in Forensic Science",
    "dept": "ANTHR",
    "num": "542",
    "desc": "Prereq: Enrollment in the Graduate Certificate in Forensic Sciences\nResearch topic approved by course instructor. Written and oral reports required. Oral report given in forensics seminar, Chem 540.\n",
    "credits": "1"
  },
  {
    "course_name": "Sex and Gender in Cross-cultural Perspective",
    "dept": "ANTHR",
    "num": "544",
    "desc": "Prereq: ANTHR 201; ANTHR 306 recommended\nCross-cultural examination of the social construction of genders out of the biological fact of sex. Emphasis on non-western societies. Topics, presented through examination of ethnographic data, will include the range of gender variation, status and roles, the institution of marriage, and symbols of gender valuation.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Biological Field School",
    "dept": "ANTHR",
    "num": "545",
    "desc": "Prereq: ANTHR 202 or BIOL 101\nSummer field school for training in behavioral and ecological methods for primatologists. Proposal, data collection and analyses, and presentation of research topic in primatology.\n",
    "credits": "4"
  },
  {
    "course_name": "Topics in Biological Anthropology",
    "dept": "ANTHR",
    "num": "582",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Anthropology: Paleoanthropology",
    "dept": "ANTHR",
    "num": "582A",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Anthropology: Primate Cognition",
    "dept": "ANTHR",
    "num": "582B",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Anthropology: Primate Conservation",
    "dept": "ANTHR",
    "num": "582C",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Biological Anthropology: Population Genetics and Human Evolution",
    "dept": "ANTHR",
    "num": "582D",
    "desc": "Prereq: ANTHR 307\nIn-depth study of current topics in biological anthropology, such as new fossil specimens, research on the evolution of cognition, the emergence of applied primatology, and the dynamic field of population genetics as each relates to the Order Primates.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Independent Study",
    "dept": "ANTHR",
    "num": "590",
    "desc": "Prereq: Graduate classification and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Graduate Independent Study",
    "dept": "ANTHR",
    "num": "590I",
    "desc": "Prereq: Graduate classification and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Orientation to Anthropology",
    "dept": "ANTHR",
    "num": "591",
    "desc": "Prereq: Admission to the Anthropology Graduate Program\nIntroduction to the Anthropology program, including the requirements for successful degree completion, department administrative procedures, ethics in anthropology and current trends in the four subfields of anthropology. Required of graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Foundations of Sustainable Agriculture",
    "dept": "ANTHR",
    "num": "610",
    "desc": "Prereq: Graduate classification, permission of instructor\nHistorical, biophysical, socioeconomic, and ethical dimensions of agricultural sustainability. Strategies for evaluating existing and emerging agricultural systems in terms of the core concepts of sustainability and their theoretical contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "ANTHR",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Iowa Lakeside Laboratory (Same as Ia LL 699I.)",
    "dept": "ANTHR",
    "num": "699I",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Orientation for AESHM",
    "dept": "AESHM",
    "num": "112",
    "desc": "Prereq: Concurrent enrollment with AESHM 113\nOrientation policies and procedures of university and college.  Guest speakers representing the university.  Some online lectures.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Development for AESHM",
    "dept": "AESHM",
    "num": "113",
    "desc": "\nCareer exploration, presentation and professional skills, teamwork and leadership, creativity, critical thinking, technology, and service learning components.  Orientation to policies and procedures of college, department, and program.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Development for AESHM: Event and Hospitality Management - Directions Learning Community",
    "dept": "AESHM",
    "num": "113E",
    "desc": "\nCareer exploration in Event Management and Hospitality Management, presentation and professional skills, teamwork and leadership, creativity, critical thinking, technology, and service learning components for first year students. Orientation to policies and procedures of College of Human Sciences; AESHM department; and Event Management and Hospitality Management programs.  Field Trip.\n",
    "credits": "2"
  },
  {
    "course_name": "Professional Development for AESHM: Common Threads Learning Community",
    "dept": "AESHM",
    "num": "113N",
    "desc": "\nCareer exploration in Apparel Merchandising and Design, presentation and professional skills, teamwork and leadership, creativity, critical thinking, technology, and service learning components for first year students. Orientation to policies and procedures of College of Human Sciences; and AESHM department and AMD programs.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience I",
    "dept": "AESHM",
    "num": "170",
    "desc": "Prereq: Adviser permission required; freshman classification or permission\nSupervised work experience with a cooperating firm or organization.\n  Offered on a satisfactory-fail basis only.  No more than 12 credits total from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience I: Hospitality",
    "dept": "AESHM",
    "num": "170D",
    "desc": "Prereq: Adviser permission required\nSupervised work experience with a cooperating firm or organization.\n  Offered on a satisfactory-fail basis only.  No more than 12 credits total from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience I: Event Management",
    "dept": "AESHM",
    "num": "170F",
    "desc": "Prereq: Adviser permission required\nSupervised work experience with a cooperating firm or organization.\n  Offered on a satisfactory-fail basis only.  No more than 12 credits total from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience I: Apparel",
    "dept": "AESHM",
    "num": "170N",
    "desc": "Prereq: Adviser permission required; freshman classification\nSupervised work experience with a cooperating firm or organization.\n  Offered on a satisfactory-fail basis only.  No more than 12 credits total from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Financial Applications for Retail and Hospitality Industries",
    "dept": "AESHM",
    "num": "175",
    "desc": "\nUsing an online delivery method, students will learn basic mathematical concepts, calculations and formulas commonly used in the apparel and hospitality industries. Emphasis on problem solving, critical/creative thinking, and mathematical interpretation of calculations and formulas used within the apparel and hospitality industries.\n",
    "credits": "2"
  },
  {
    "course_name": "Financial Applications for Retail and Hospitality Industries: Hospitality Management",
    "dept": "AESHM",
    "num": "175D",
    "desc": "\nUsing an online delivery method, students will learn basic mathematical concepts, calculations and formulas commonly used in the apparel and hospitality industries. Emphasis on problem solving, critical/creative thinking, and mathematical interpretation of calculations and formulas used within the hospitality industries.\n",
    "credits": "2"
  },
  {
    "course_name": "Financial Applications for Retail and Hospitality Industries: Retail Merchandising",
    "dept": "AESHM",
    "num": "175N",
    "desc": "\nUsing an online delivery method, students will learn basic mathematical concepts, calculations and formulas commonly used in the apparel and hospitality industries. Emphasis on problem solving, critical/creative thinking, and mathematical interpretation of calculations and formulas used within the apparel industries.\n",
    "credits": "2"
  },
  {
    "course_name": "First Year Student Field Study",
    "dept": "AESHM",
    "num": "180",
    "desc": "Prereq: Permission of instructor\nStudy of and tours of regional areas of interest to A M D, HSP M, or EVENT majors.  Trip to regional location under supervision of faculty member.  Locations vary; 2- to 3-day trip.  Journal entries and final report/analysis are required.  Cost associated with trip.\n",
    "credits": "1"
  },
  {
    "course_name": "First Year Student Field Study:  Hospitality and Event Management",
    "dept": "AESHM",
    "num": "180E",
    "desc": "Prereq: Permission of instructor\nStudy of and tours of regional areas of interest to majors in the HSP M and EVENT majors.  Trip to regional location under supervision of faculty member.  Locations vary, 2- to 3-day trip.  Journal entries and final report/analysis are required.  Cost associated with trip.\n",
    "credits": "1"
  },
  {
    "course_name": "First Year Student Field Study:  Apparel, Merchandising, and Design",
    "dept": "AESHM",
    "num": "180N",
    "desc": "Prereq: Permission of instructor\nStudy of and tours of regional areas of interest to A M D majors.  Trip to regional location under supervision of faculty member.  Locations vary; 2- to 3-day trip.  Journal entries and final report/analysis are required.  Cost associated with trip.\n",
    "credits": "1"
  },
  {
    "course_name": "Leadership Experiences and Development (LEAD)",
    "dept": "AESHM",
    "num": "211",
    "desc": "\nIntroduction to leadership behaviors.  Development and utilization of leadership behaviors to positively impact school life, community life, and work life.\n",
    "credits": "3"
  },
  {
    "course_name": "Transitions:  Pre-Professional Strategies and Career Explorations",
    "dept": "AESHM",
    "num": "213",
    "desc": "Prereq: Transfer student or change-of-major in A M D, EVENT, or HSP M majors\nFast track pre-professional development strategies, career exploration, and multi-dimensional academic and extracurricular palnning for students in transition including transfer and change of majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Transitions:  Pre-Professional Strategies and Career Explorations",
    "dept": "AESHM",
    "num": "213E",
    "desc": "Prereq: Transfer student or change-of-major in EVENT or HSP M majors\nFast track pre-professional development strategies, career exploration, and multi-dimensional academic and extracurricular palnning for students in transition including transfer and change of majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Transitions:  Pre-Professional Strategies and Career Explorations",
    "dept": "AESHM",
    "num": "213N",
    "desc": "Prereq: Transfer student or change of major in A M D major\nFast track pre-professional development strategies, career exploration, and multi-dimensional academic and extracurricular palnning for students in transition including transfer and change of majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Creativity on Demand",
    "dept": "AESHM",
    "num": "222",
    "desc": "\nLearn to use creativity strategies to solve everyday problems related to personal and professional lives.  Application of creative thinking techniques to view things from different perspectives; identify unique opportunities; and generate and evaluate original ideas.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Resource Management",
    "dept": "AESHM",
    "num": "238",
    "desc": "Prereq: A M D 275 or AESHM 270, or AESHM 287 or concurrent enrollment; sophomore classification\nPrinciples and practices of human resource management relevant to human science-related organizations.  Emphasis on the entry-level manager's role.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Work Experience II",
    "dept": "AESHM",
    "num": "270",
    "desc": "Prereq: Minimum 2.0 GPA; Adviser permission required; sophomore classification\nSupervised work experience with a cooperating firm or organization.\n  No more than 12 credits total from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience II: Hospitality",
    "dept": "AESHM",
    "num": "270D",
    "desc": "Prereq: Minimum 2.0 GPA; Adviser permission required; sophomore classification; 6 cr in AESHM or HSP M, credits in AESHM 170\nSupervised work experience with a cooperating firm or organization.\n  No more than 12 credits total from AESHM 170, AESHM 270, and 470 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience II: Event Management",
    "dept": "AESHM",
    "num": "270F",
    "desc": "Prereq: Minimum 2.0 GPA; Adviser permission required; 6 cr in AESHM, HSP M, or EVENT; employer location should be different than employer location used for AESHM 170 and 470.\nSupervised work experience with a cooperating firm or organization.\n  No more than 12 credits total from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience II: Apparel",
    "dept": "AESHM",
    "num": "270N",
    "desc": "Prereq: Minimum 2.0 GPA; Adviser permission required.  Sophomore AMD classification\nSupervised work experience with a cooperating firm or organization.\n  No more than 12 credits total from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Fashion Show Production and Promotion",
    "dept": "AESHM",
    "num": "272",
    "desc": "Prereq: Application and instructor permission, application form available from the AESHM Department office\nPlanning and production of fashion show including developing budgets, public relations, advertising, fund-raising, choreography, staging, lighting, and food.  Promotion of fashion show and similar events.\n  Maximum of 4 credits can be applied to graduation",
    "credits": "1"
  },
  {
    "course_name": "Orientation to U.S. Field Study",
    "dept": "AESHM",
    "num": "280",
    "desc": "\nOrientation to the field study location during the semester preceding the trip.\n",
    "credits": "R"
  },
  {
    "course_name": "Orientation to International Field Study",
    "dept": "AESHM",
    "num": "281",
    "desc": "\nOrientation to the field study location during the semester preceding the trip.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles of Management in Human Sciences",
    "dept": "AESHM",
    "num": "287",
    "desc": "\nIntroduction to management concepts and principles with application to human sciences-related businesses and organizations. Includes service quality management, professionalism, and social responsibility.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on Careers and Internships",
    "dept": "AESHM",
    "num": "311",
    "desc": "Prereq: AESHM 113; Sophomore classification. Good academic standing\nInternship and career planning, professional expectations and responsibilities. Résumé development, cover letters, interviewing techniques, and business etiquette.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar on Careers and Internships:  Event Management and Hospitality Management",
    "dept": "AESHM",
    "num": "311E",
    "desc": "Prereq: AESHM 113E; Sophomore classification.\nInternship and career planning, professional expectations and responsibilities.  Résumé development, business letters/professional correspondence, interviewing techniques, and business etiquette.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar on Careers and Internships:  Apparel, Merchandising, and Design",
    "dept": "AESHM",
    "num": "311N",
    "desc": "Prereq: AESHM 113N; Sophomore classification.\nInternship and career planning, professional expectations and responsibilities. Résumé development, cover letters, interviewing techniques, and business etiquette.\n",
    "credits": "1"
  },
  {
    "course_name": "Hospitality and Apparel Marketing Strategies",
    "dept": "AESHM",
    "num": "340",
    "desc": "Prereq: ECON 101\nApplication of marketing principles to the hospitality-, events-, and apparel-related industries.  Emphasis on the role of marketing in an organization's overall strategic planning.  Development and evaluation techniques available to hospitality, events, apparel, and related businesses, including advertising, sales promotion, packaging, and public relations.\n",
    "credits": "3"
  },
  {
    "course_name": "Aesthetics of Consumer Experience",
    "dept": "AESHM",
    "num": "342",
    "desc": "Prereq: Sophomore classification\nDesign principles, aesthetic concepts, and research applied to consumer experiences, with an emphasis on hospitality and retail environments and events.  Influence of individual differences and cultural patterns on aesthetic preferences.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "U.S. Field Study",
    "dept": "AESHM",
    "num": "380",
    "desc": "Prereq: 9 credits in A M D, AESHM, EVENT, and/or HSP M; sophomore classification; minimum 2.0 GPA.  Permission by application\nStudy and tours of areas of interest to majors in the AESHM Department. Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 280.\n",
    "credits": "1"
  },
  {
    "course_name": "U.S. Field Study:  Hospitality Management",
    "dept": "AESHM",
    "num": "380D",
    "desc": "Prereq: 9 credits in AESHM or HSP M; sophomore classification; minimum 2.0 GPA; AESHM 280 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Hospitality Management program.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 280.\n",
    "credits": "1"
  },
  {
    "course_name": "U.S. Field Study:  Event Management",
    "dept": "AESHM",
    "num": "380F",
    "desc": "Prereq: 9 credits in EVENT, AESHM, or HSP M; sophomore classification; minimum 2.0 GPA; AESHM 280 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the majors in the Event Management program.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 280.\n",
    "credits": "1"
  },
  {
    "course_name": "U.S. Field Study:  Apparel, Merchandising, and Design",
    "dept": "AESHM",
    "num": "380N",
    "desc": "Prereq: 9 credits in A M D or AESHM; sophomore classification; minimum 2.0 GPA; AESHM 280 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Apparel, Merchandising, and Design program.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 280.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Study",
    "dept": "AESHM",
    "num": "381",
    "desc": "Prereq: 9 credits in A M D, AESHM, EVENT, and/or HSP M; sophomore classification; minimum 2.0 GPA.  Permission by application\nStudy and tours of areas of interest to majors in the AESHM Department. Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 281.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Study:  Hospitality Management",
    "dept": "AESHM",
    "num": "381D",
    "desc": "Prereq: 9 credits in AESHM and/or HSP M; sophomore classification; minimum 2.0 GPA; AESHM 281 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Hospitality Management program.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 281.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Study:  Event Management",
    "dept": "AESHM",
    "num": "381F",
    "desc": "Prereq: 9 credits in AESHM, EVENT, and/or HSP M; sophomore classification; minimum 2.0 GPA; AESHM 281 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Event Management major.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 281.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Study:  Apparel, Merchandising, and Design",
    "dept": "AESHM",
    "num": "381N",
    "desc": "Prereq: 9 credits in A M D and/or AESHM; sophomore classification; minimum 2.0 GPA; AESHM 281 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Apparel, Merchandising, and Design major.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 281.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "AESHM",
    "num": "398",
    "desc": "Prereq: Permission of adviser; junior classification\nRequired of all cooperative education students seeking full-time status. Students register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Seminar on Current Issues",
    "dept": "AESHM",
    "num": "411",
    "desc": "Prereq: Permission of instructor.\nTrends, issues, research, and scholarship in apparel, events, and hospitality management.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar on Current Issues: Events and Hospitality",
    "dept": "AESHM",
    "num": "411E",
    "desc": "Prereq: senior classification in AESHM.\nTrends, issues, research, and scholarship in events and hospitality management.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar on Current Issues: Apparel",
    "dept": "AESHM",
    "num": "411N",
    "desc": "Prereq: AESHM 470N\nTrends, issues, research, and scholarship in apparel.\n",
    "credits": "1"
  },
  {
    "course_name": "Developing Global Leadership:  Maximizing Human Potential",
    "dept": "AESHM",
    "num": "421",
    "desc": "\nDevelopment of leadership in a global environment.  Focus on global concerns that impact on the well-being of individuals, families, and communities.  Strategies for working with individuals, families and communities in other countries and cultures.  Taking local action on global issues.  Participation in a service activity.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Professional Internship",
    "dept": "AESHM",
    "num": "470",
    "desc": "\nSupervised work experience with a cooperating firm or organization.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Professional Internship: Event Management",
    "dept": "AESHM",
    "num": "470F",
    "desc": "Prereq: AESHM 311, EVENT 271; employer/location should be different than employer/location used for AESHM 170 and 270\nSupervised work experience with a cooperating firm or organization.\n  No more than 12 credits from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Supervised Professional Internship: Apparel",
    "dept": "AESHM",
    "num": "470N",
    "desc": "Prereq: AESHM 311, 9 credits in A M D, and minimum 2.0 GPA; permission by application; junior or senior classification; employer/location should be different than employer/location for AESHM 170 and 270\nSupervised work experience with a cooperating firm or organization.\n  No more than 12 credits from AESHM 170, 270, and 470 may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Fashion Show Management",
    "dept": "AESHM",
    "num": "472",
    "desc": "Prereq: Permission of instructor\nProvide leadership and communicate direction for planning and production of fashion show, including developing budgets, publicity, advertising, fundraising, choreography, staging, lighting, and food.\n  Maximum of 5 credits can be applied to graduation",
    "credits": "2"
  },
  {
    "course_name": "Entrepreneurship in Human Sciences",
    "dept": "AESHM",
    "num": "474",
    "desc": "Prereq: A M D 275 or AESHM 287 or ACCT 284 or 3 cr in MKT or permission of instructor\nComprehensive approach to entrepreneurship including concepts of innovation, creativity, opportunity assessment, and business planning.  Focus on human sciences-related businesses: retail, service, hospitality, event, food-related, family-owned, rural, and community businesses. Interaction with entrepreneurs, market research, feasibility analysis, business proposals, and business/community outreach and consulting.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "AESHM",
    "num": "497",
    "desc": "Prereq: Permission of adviser; senior or graduate classification\nRequired of cooperative education students.  Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Quantitative Research Methods in Apparel and Hospitality",
    "dept": "AESHM",
    "num": "510",
    "desc": "Prereq: STAT 401 or equivalent; Graduate standing in the Department; Permission of instructor\nOverview of quantitative research methods in apparel and hospitality fields. Topics include types of quantitative research design, sampling design, measurement, validity issues, power and precision analysis, methods of data gathering and analysis techniques, and interpretation of statistical results.  Use of statistical packages.  Development of research plan.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar",
    "dept": "AESHM",
    "num": "511",
    "desc": "Prereq: 6 graduate credits in A M D, AESHM, or HSP M. Permission of instructor\nDiscussion of scholarship and current issues. Topics vary.\n",
    "credits": "1"
  },
  {
    "course_name": "Qualitative Research Methods in Apparel, Events, and Hospitality",
    "dept": "AESHM",
    "num": "512",
    "desc": "Prereq: Graduate status\nIntroduction to and hands-on experiences with a variety of qualitative research methods specific to apparel, events and hospitality research. Students will develop skills at research design, data, collection, analysis, and write-up for qualitative inquiry.\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum",
    "dept": "AESHM",
    "num": "570",
    "desc": "Prereq: 6 graduate credits in program area; permission of instructor\nSupervised experience related to career objective. Proposal must be approved semester before placement.\n",
    "credits": "1"
  },
  {
    "course_name": "Apparel Merchandising and Design",
    "dept": "AESHM",
    "num": "570A",
    "desc": "Prereq: 6 graduate credits in program area; permission of instructor\nSupervised experience related to career objective. Proposal must be approved semester before placement.\n",
    "credits": "1"
  },
  {
    "course_name": "Hospitality Management",
    "dept": "AESHM",
    "num": "570B",
    "desc": "Prereq: 6 graduate credits in program area; permission of instructor\nSupervised experience related to career objective. Proposal must be approved semester before placement.\n",
    "credits": "1"
  },
  {
    "course_name": "Entrepreneurship in Human Sciences",
    "dept": "AESHM",
    "num": "574",
    "desc": "Prereq: A M D 275 or AESHM 287 or ACCT 284 or 3 cr in MKT or permission of instructor\nComprehensive approach to entrepreneurship including concepts of innovation, creativity, opportunity assessment, and business planning. Focus on human sciences-related businesses: retail, service, hospitality, event, food-related, family-owned, rural, and community businesses. Interaction with entrepreneurs, market research, feasibility analysis, business proposals, and business/community outreach and consulting.\n",
    "credits": "3"
  },
  {
    "course_name": "U.S. Field Study",
    "dept": "AESHM",
    "num": "580",
    "desc": "Prereq: 9 credits in A M D, AESHM, EVENT, and/or HSP M; sophomore classification; minimum 2.0 GPA.  Permission by application\nStudy and tours of areas of interest to majors in the AESHM Department. Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 280.\n",
    "credits": "1"
  },
  {
    "course_name": "U.S. Field Study:  Hospitality Management",
    "dept": "AESHM",
    "num": "580D",
    "desc": "Prereq: 9 credits in AESHM or HSP M; sophomore classification; minimum 2.0 GPA; AESHM 280 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Hospitality Management program.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 280.\n",
    "credits": "1"
  },
  {
    "course_name": "U.S. Field Study:  Event Management",
    "dept": "AESHM",
    "num": "580F",
    "desc": "Prereq: 9 credits in EVENT, AESHM, or HSP M; sophomore classification; minimum 2.0 GPA; AESHM 280 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the majors in the Event Management program.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 280.\n",
    "credits": "1"
  },
  {
    "course_name": "U.S. Field Study:  Apparel, Merchandising, and Design",
    "dept": "AESHM",
    "num": "580N",
    "desc": "Prereq: 9 credits in A M D or AESHM; sophomore classification; minimum 2.0 GPA; AESHM 280 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Apparel, Merchandising, and Design program.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 280.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Study",
    "dept": "AESHM",
    "num": "581",
    "desc": "Prereq: 9 credits in A M D, AESHM, EVENT, and/or HSP M; sophomore classification; minimum 2.0 GPA.  Permission by application\nStudy and tours of areas of interest to majors in the AESHM Department. Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 281.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Study:  Hospitality Management",
    "dept": "AESHM",
    "num": "581D",
    "desc": "Prereq: 9 credits in AESHM and/or HSP M; sophomore classification; minimum 2.0 GPA; AESHM 281 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Hospitality Management program.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 281.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Study:  Event Management",
    "dept": "AESHM",
    "num": "581F",
    "desc": "Prereq: 9 credits in AESHM, EVENT, and/or HSP M; sophomore classification; minimum 2.0 GPA; AESHM 281 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Event Management major.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 281.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Study:  Apparel, Merchandising, and Design",
    "dept": "AESHM",
    "num": "581N",
    "desc": "Prereq: 9 credits in A M D and/or AESHM; sophomore classification; minimum 2.0 GPA; AESHM 281 or concurrent enrollment; permission by application\nStudy and tours of areas of interest to majors in the Apparel, Merchandising, and Design major.  Trip to location under supervision of faculty member. Locations and lengths of trip vary. Final projects, reports, journal entries, and analysis are required. May be combined with AESHM 281.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "AESHM",
    "num": "611",
    "desc": "Prereq: 6 graduate credits in AESHM, A M D, or HSP M. Permission of instructor\nScholarship and current issues. Topics vary.\n",
    "credits": "1"
  },
  {
    "course_name": "Teaching Practicum",
    "dept": "AESHM",
    "num": "670",
    "desc": "Prereq: 6 graduate credits in program area; permission of instructor\nSupervised experience in the university classroom. Proposal must be approved semester before placement.\n",
    "credits": "1"
  },
  {
    "course_name": "Teaching Practicum:  Apparel Merchandising and Design",
    "dept": "AESHM",
    "num": "670A",
    "desc": "Prereq: 6 graduate credits in program area; permission of instructor\nSupervised experience in the university classroom. Proposal must be approved semester before placement.\n",
    "credits": "1"
  },
  {
    "course_name": "Teaching Practicum:  Hospitality Management",
    "dept": "AESHM",
    "num": "670B",
    "desc": "Prereq: 6 graduate credits in program area; permission of instructor\nSupervised experience in the university classroom. Proposal must be approved semester before placement.\n",
    "credits": "1"
  },
  {
    "course_name": "Apparel Construction Techniques",
    "dept": "A M D",
    "num": "120",
    "desc": "\nAssemble components and completed garments with the use of basic sewing equipment. Learn basic construction techniques, applications and vocabulary. Students will need access to a home sewing machine, iron, computer and the internet. Not available for credit for A M D majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Apparel Assembly Processes",
    "dept": "A M D",
    "num": "121",
    "desc": "Prereq: A M D 204 concurrent recommended\nPrinciples of garment assembly. Use of mass production equipment and methods to analyze, develop and assemble garments.\n",
    "credits": "3"
  },
  {
    "course_name": "Fashion Products and Markets",
    "dept": "A M D",
    "num": "131",
    "desc": "\nFashion industry from concept to consumer. Focus on fashion-driven consumer goods. Development and prototyping of fashion products for a target market.\n",
    "credits": "3"
  },
  {
    "course_name": "Dress, Appearance, and Diversity in Society",
    "dept": "A M D",
    "num": "165",
    "desc": "\nExamination of diversity among consumers and introduction to forecasting trends in dress.  Introduction to social justice issues.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Apparel Design Studio",
    "dept": "A M D",
    "num": "178",
    "desc": "\nIntroduction to the elements and principles of design in fashion and apparel including skill development in fashion illustration, technical drawing, and fabric rendering using traditional media. Application of written and verbal presentations to communicate fashion and apparel design concepts and terminology. Fashion presentation and introduction to portfolio development.\n",
    "credits": "3"
  },
  {
    "course_name": "Textile Science",
    "dept": "A M D",
    "num": "204",
    "desc": "Prereq: A M D 131\nTextile fibers, yarns, fabrication, coloration, and finishes.  Quality and performance application to textile products.  Lab work included.\n",
    "credits": "4"
  },
  {
    "course_name": "Design Selective Advancement",
    "dept": "A M D",
    "num": "206",
    "desc": "Prereq: Completion or enrollment in A M D 121, A M D 131, A M D 178, and A M D 204 and enrollment in major\nProject review and skill assessment related to 2-dimensional and 3-dimensional visualization, apparel assembly, basic product knowledge, design problem solving, illustration, textiles.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Computer Applications in Digital Design and Management",
    "dept": "A M D",
    "num": "210",
    "desc": "Prereq: A M D 245 or concurrent; AESHM 113N\nApplications of skills in Photoshop, Illustrator, InDesign, Google Sketch-up, Excel, and website development.  Introduction to digital product design and line development.  Focus on elements and principles of design.  Introduction to digital portfolio development for design and merchandising.  In-class demonstrations and online lectures.\n",
    "credits": "3"
  },
  {
    "course_name": "Patternmaking I:  Drafting and Flat Pattern",
    "dept": "A M D",
    "num": "225",
    "desc": "Prereq: A M D 121, A M D 204, A M D 206.\nApplication of patternmaking tools and their functions, measurement techniques, pattern labeling, and patternmaking communication documents.  Sloper drafting and flat pattern manipulation methods for women's apparel.  Design and construction of original garments using drafted slopers and flat pattern manipulation methods to enable the analysis of fit.\n",
    "credits": "3"
  },
  {
    "course_name": "Product Development and Manufacturing",
    "dept": "A M D",
    "num": "231",
    "desc": "Prereq: A M D 204\nAnalysis of apparel product development, sourcing, and manufacturing processes.  Focus on materials and specifications relative to quality, performance, cost, and price.  Applications of software for PLM.\n",
    "credits": "4"
  },
  {
    "course_name": "Aesthetics and Brand Image",
    "dept": "A M D",
    "num": "245",
    "desc": "Prereq: A M D 131, A M D 165, A M D 204 or concurrent\nElements and principles of design. Analysis of sensory, expressive, and symbolic aspects that build brand image, with a focus on fashion products and promotional settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Museum Studies",
    "dept": "A M D",
    "num": "257",
    "desc": "Prereq: Sophomore standing\nOverview of museums including history, functions, and philosophy.  Collection and curatorial practices.  Funding and governance issues.  Hands-on object research and exhibit development.  Required field trip.\n",
    "credits": "3"
  },
  {
    "course_name": "Retail Merchandising",
    "dept": "A M D",
    "num": "275",
    "desc": "Prereq: 3 credits in Math\nPrinciples of merchandising as applied to retail-, service-, events-, and hospitality-related businesses.  Study of the planning, development, and presentation of apparel- and hospitality-related products, services, and experiences.  Industry and market research, planning of new offerings, and development of promotional and competitive strategies for various retail formats.\n",
    "credits": "3"
  },
  {
    "course_name": "Fashion Illustration",
    "dept": "A M D",
    "num": "278",
    "desc": "Prereq: A M D 178, A M D 210 or concurrent enrollment, A M D 245 or concurrent enrollment. Permission of instructor.\nDevelopment of fashion plates and focused apparel lines/collections.  Proficiency in drawing the fashion figure, technical drawings/flats, and apparel using a variety of media.  Continuation of fashion presentation and portfolio development.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "A M D",
    "num": "290",
    "desc": "Prereq: Freshmen or Sophomore Classification; Permission of instructor, adviser, and department chair.\nIndependent study on topics of special interest to the student, facilitated by approved faculty member.\n  Total number of A M D 290 and A M D 490 credits applied to graduation cannot exceed 9 credits.",
    "credits": "1"
  },
  {
    "course_name": "Quality Assurance of Textiles and Apparel",
    "dept": "A M D",
    "num": "305",
    "desc": "Prereq: A M D 231, one course in natural science (chemistry with lab preferred); STAT 101, STAT 226, or STAT 401\nPrinciples of product and materials evaluation and quality assurance. Developing specifications and using standard practices for evaluating materials, product characteristics, performance, and quality.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Aided Apparel Patternnmaking",
    "dept": "A M D",
    "num": "310",
    "desc": "Prereq: A M D 210, A M D 225; Permission of instructor.\nComputer-aided patternmaking technology used in pattern drafting, grading, marker making, and 3-D virtual prototyping.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Integrated Textile and Fashion Design",
    "dept": "A M D",
    "num": "321",
    "desc": "Prereq: A M D 210, A M D 278 or concurrent enrollment. Permission of instructor\nAnalysis and advanced use of computer-aided design software for textile and fashion design for various target markets.  Digital presentation and portfolio development.\n",
    "credits": "3"
  },
  {
    "course_name": "Patternmaking II:  Draping",
    "dept": "A M D",
    "num": "325",
    "desc": "Prereq: A M D 206, A M D 225; permission of instructor.\nPrinciples of patternmaking through basic draping techniques on industry standard body forms.  Apparel design through analysis of fit and design; problem solving and interaction of fabric characteristics with style features.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Seminar",
    "dept": "A M D",
    "num": "328",
    "desc": "Prereq: Vary with topic.\nFocus on artisanal textile, apparel, or surface and structural design techniques.  Design processes for specialty fabrics and markets.  Topics vary by term.\n",
    "credits": "arr"
  },
  {
    "course_name": "Digital Textile Printing for Apparel Design",
    "dept": "A M D",
    "num": "329",
    "desc": "Prereq: A M D 321; A M D 325 or concurrent\nOverview of the use of digital printing in the textile and apparel industry, color matching, repeat print patterns, engineered prints, and creation of apparel prototypes.\n",
    "credits": "3"
  },
  {
    "course_name": "History of European and North American Dress",
    "dept": "A M D",
    "num": "354",
    "desc": "Prereq: 3 credits from Hist or Art H\nSurvey of history of dress from ancient times up to the American Civil War; focus on European and North American dress. Emphasis on connection of dress to the social, cultural, environmental, and technological contexts of the Western world.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Twentieth Century Fashion",
    "dept": "A M D",
    "num": "356",
    "desc": "Prereq: 3 credits HIST or ART H; A M D 204 recommended.\nSurvey of major design and technological developments from the American Civil War through the 20th Century. Emphasis on fashion as a system of design and production, culture of consumption, fashion change, and trends in art, society, and culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Cultural Perspectives of Dress",
    "dept": "A M D",
    "num": "362",
    "desc": "Prereq: A M D 165 or 3 credits in anthropology, psychology, or sociology.\nAnalysis of multiple factors related to dress in selected societies, including technology, cultural identity, aesthetics, social organization, ritual, stability and change. Applications to fair trade and social responsibility.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Sourcing and Global Issues",
    "dept": "A M D",
    "num": "372",
    "desc": "Prereq: A M D 231, A M D 275; ECON 101 or ECON 102 recommended\nEvaluation of key issues facing textile and apparel industries in global markets considering ethical, economic, political, social, and professional implications.  Sourcing strategies in a global environment.  Corporate and consumer social responsibility and sustainability.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Merchandise Planning and Buying",
    "dept": "A M D",
    "num": "376",
    "desc": "Prereq: A M D 275; COM S 113; 3 credits from ACCT 284, MATH 104, MATH 105, MATH 140, MATH 150, or equivalent.\nCalculations and computer application in the planning and control of merchandise.  Emphasis on retail math as it pertains to assortment planning, the six-month buying plan process, and other buying concepts and strategies.  Online modules.\n",
    "credits": "4"
  },
  {
    "course_name": "Visual Presentation and Promotions",
    "dept": "A M D",
    "num": "377",
    "desc": "Prereq: A M D 245 or AESHM 342; AESHM 340 or MKT 340\nPrinciples of visual aspects of brand development and management; emphasis on branding, visual merchandising, design/layout of retail spaces.  Includes applications such as visual communication and documentation using Adobe Creative Suite(R), hands-on display projects, and brand case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Apparel, Merchandising, and Design Workshop",
    "dept": "A M D",
    "num": "393",
    "desc": "Prereq: A M D Junior or Senior Classification and Permission of Instructor.\nIntensive 2 to 8 week workshop exploration.  Topics vary each time offered.\n  Maximum of 6 credits applied to graduation.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Textile Science",
    "dept": "A M D",
    "num": "404",
    "desc": "Prereq: A M D 204, CHEM 163 and CHEM 163L or equivalent\nTheories and principles of textile science.  Textile product serviceability.  Effect of fiber structure on properties and performance.  New developments in textiles.\n",
    "credits": "3"
  },
  {
    "course_name": "Technical Design Processes",
    "dept": "A M D",
    "num": "415",
    "desc": "Prereq: A M D 225; A M D 231\nGarment development and analysis of fit, performance, quality, cost. Exploration of alternative materials, construction methods, grading; specifications and portfolio development.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Design Processes",
    "dept": "A M D",
    "num": "426",
    "desc": "Prereq: A M D 206, A M D 321, A M D 325 or concurrent\nExploration of the creative process and sources of inspiration with emphasis on wearable art; experimentation of advanced design problem solving, alternative materials, fabric manipulation, and pattern-making techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Apparel Production Management",
    "dept": "A M D",
    "num": "431",
    "desc": "Prereq: A M D 231; A M D 121 recommended; A M D 372 or concurrent.\nProcedures and experiences related to application and use of process controls: method analysis, work measurement, costing, pricing, and production planning. Resource management, technology applications, and quality assurance.\n",
    "credits": "3"
  },
  {
    "course_name": "Textile Conservation and Collection Management",
    "dept": "A M D",
    "num": "457",
    "desc": "Prereq: A M D 204\nCondition assessment, repair, and stabilization of textiles and apparel in museum collections.  Dry and aqueous cleaning.  Examination of storage and exhibition techniques, materials, and conditions.  Experience with cataloging and management practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Queer Fashions, Styles, and Bodies",
    "dept": "A M D",
    "num": "458",
    "desc": "Prereq: A M D 165; or 3 credits in Women's and Gender Studies or Sociology; or permission of instructor\nThis course focuses on analyzing the dressed and undressed body of individuals in the queer community in various cultural contexts with a focus on material culture.  We will disentangle concepts related to gender and sexuality and the changing definitions and representations of individuals who identify in the queer community focusing on appearance, fashion, and the body.  Historic and current representations of fashion, styles, and appearances will be analyzed and discussed.  Attention will be paid to how sexuality and gender intersect with and/or shape other identities including race, ability, body size, and class.  We will examine the complex structures, systems, and ideologies that uphold discrimination and unequal distribution of power and resources as related to the course material.  Attention will mostly be given to North American perspectives.  We will use material culture to explore how objects related to fashioning the body reveal stories about the owners and consumers.\n",
    "credits": "3"
  },
  {
    "course_name": "Consumer Studies in Apparel and Fashion Products",
    "dept": "A M D",
    "num": "467",
    "desc": "Prereq: A M D 165; AESHM 340 or MKT 340; STAT 101 or STAT 104 or STAT 226;\nApplication of concepts and theories from the social sciences to the study of consumer behavior related to dress, textile and apparel products, and retail experiences. Experience in conducting consumer research.\n",
    "credits": "3"
  },
  {
    "course_name": "Retail Information Analysis",
    "dept": "A M D",
    "num": "475",
    "desc": "Prereq: A M D 376\nEvaluation of information needed to make effective retail decisions.  Use of technology in analyzing and interpreting retail systems data.  Application of concepts related to forecasting, consumer demand, assortment planning, market research, data mining, database interface, pattern recognition, supply-chain/logistics management, retail technology applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Omni-Channel Retailing",
    "dept": "A M D",
    "num": "477",
    "desc": "Prereq: 3 credits in marketing or A M D 275 or AESHM 287\nA customer-centric view of marketing with a focus on the retailer-customer relationship and omni-channel strategies.  Analysis and evaluation of integrated retail applications and strategies using digital media, including store formats, e-commerce, catalog, mobile, crowdsourcing, and social media.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "A M D",
    "num": "490",
    "desc": "Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\nIndependent Study.\n  Maximum of 9 credits of both A M D 290 and A M D 490 can be applied toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Textile Science",
    "dept": "A M D",
    "num": "490A",
    "desc": "Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Historical, Cultural, and Museum Studies of Dress and Textiles",
    "dept": "A M D",
    "num": "490B",
    "desc": "Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Textile and Apparel Design",
    "dept": "A M D",
    "num": "490C",
    "desc": "Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Merchandising, Aesthetics, and Entrepreneurship",
    "dept": "A M D",
    "num": "490E",
    "desc": "Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Sociological, Psychological, and Consumer Behavioral Aspects of Dress",
    "dept": "A M D",
    "num": "490F",
    "desc": "Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "A M D",
    "num": "490H",
    "desc": "Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Product Development, Innovation, and Sourcing",
    "dept": "A M D",
    "num": "490J",
    "desc": "Prereq: 6 credits in A M D.   Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study:  Professional Practice",
    "dept": "A M D",
    "num": "490R",
    "desc": "Prereq: 6 credits in A M D.  Permission of the instructor, adviser, and department chair.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Production and Quality Assurance",
    "dept": "A M D",
    "num": "490S",
    "desc": "Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Fashion Show, Fashion Public Relations and Marketing",
    "dept": "A M D",
    "num": "490W",
    "desc": "Prereq: Prereq: 6 credits in A M D. Permission of the instructor, adviser, and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Senior Design Studio",
    "dept": "A M D",
    "num": "495",
    "desc": "Prereq: A M D 310, A M D 325 and A M D 329. Permission of instructor.\nCreation of an apparel line from target market research to prototypes through the use of manual techniques and CAD technologies.  The line is to be included in a professional portfolio and pieces submitted to a juried exhibition.\n",
    "credits": "3"
  },
  {
    "course_name": "Fashion Product Development and Prototyping",
    "dept": "A M D",
    "num": "496",
    "desc": "Prereq: A M D 231, A M D 245, A M D 275\nApplying consumer, aesthetic, and quantitative trend information to develop value-added fashion products and product lines with merchandising/promotion campaigns for diverse target markets. Multi-function team projects. Development of a prototype and presentation to industry representatives.\n",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "A M D",
    "num": "499",
    "desc": "Prereq: Senior classification, 15 credits in A M D. Permission of instructor, adviser, and department chair\nResearch experience in textiles and clothing with application to a selected problem.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Textile Science",
    "dept": "A M D",
    "num": "504",
    "desc": "Prereq: A M D 204, CHEM 163 and CHEM 163L or equivalent\nTheories and principles of textile science.  Textile product serviceability.  Effect of fiber structure on properties and performance.  New developments in textiles.\n",
    "credits": "3"
  },
  {
    "course_name": "Quality Assurance of Textiles and Apparel",
    "dept": "A M D",
    "num": "505",
    "desc": "Prereq: A M D 231, one course in natural science (chemistry with lab preferred); STAT 101, STAT 226, or STAT 401\nPrinciples of product and materials evaluation and quality assurance. Developing specifications and using standard practices for evaluating materials, product characteristics, performance, and quality.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundation of Scholarship in Apparel, Merchandising, and Design",
    "dept": "A M D",
    "num": "510",
    "desc": "Prereq: Graduate classification or permission of instructor\nOverview of scholarship in apparel, merchandising, and design with emphasis on current and future directions.  Fundamentals of writing literature reviews.  Examination of ethical issues in scholarship and academic life.  Introduction to creativity, sustainability, and entrepreneurship.  Development of teaching units.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Technologies in Textile and Apparel Design",
    "dept": "A M D",
    "num": "521",
    "desc": "Prereq: Research Methods course.  Permission of instructor.\nDigital technologies in textile and apparel design. Theories and practices of mass customization and personalization, digital textile printing, 3D body scanning, creating avatars from body scans, and fitting digital apparel designs.\n",
    "credits": "3"
  },
  {
    "course_name": "Experimental Patternmaking",
    "dept": "A M D",
    "num": "525",
    "desc": "Prereq: AMD 121 or equivalent, AMD 225 or equivalent, AMD 510 or taking concurrently, permission of instructor\nResearch, analyze, and apply experimental patternmaking techniques to original garments suitable for entry into a juried competition/exhibitions. Compare, contrast, and organize a framework of research patternmaking principles through content analysis or other appropriate research techniques. Documentation of learning and design process.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Seminar",
    "dept": "A M D",
    "num": "528",
    "desc": "Prereq: Vary with topic.\nFocus on artisanal textile, apparel, or surface and structural design techniques.  Design processes for specialty fabrics and markets.  Topics vary by term.\n",
    "credits": "arr"
  },
  {
    "course_name": "Consumer Aesthetics and Retail Branding",
    "dept": "A M D",
    "num": "545",
    "desc": "Prereq: One course in design elements and principles, psychology, consumer behavior, or marketing\nExamination of hedonic nature of consumer experience and its application to experiential design and branding of retail/hospitality establishments. Emphasis on consumer behavior, environmental psychology, and marketing literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Dress History Research Methods",
    "dept": "A M D",
    "num": "554",
    "desc": "\nUsing a variety of sources and methods of analysis, students will develop their ability to read and interpret primary and secondary sources and to understand the methodology underpinnings and process of constructing dress history.\n",
    "credits": "3"
  },
  {
    "course_name": "Textile Conservation and Collection Management",
    "dept": "A M D",
    "num": "557",
    "desc": "Prereq: A M D 204\nCondition assessment, repair, and stabilization of textiles and apparel in museum collections.  Dry and aqueous cleaning.  Examination of storage and exhibition techniques, materials, and conditions.  Experience with cataloging and management practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Queer Fashions, Styles, and Bodies",
    "dept": "A M D",
    "num": "558",
    "desc": "Prereq: A M D 165; or 3 credits in Women's and Gender Studies or Sociology; or permission of instructor\nThis course focuses on analyzing the dressed and undressed body of individuals in the queer community in various cultural contexts with a focus on material culture.  We will disentangle concepts related to gender and sexuality and the changing definitions and representations of individuals who identify in the queer community focusing on appearance, fashion, and the body.  Historic and current representations of fashion, styles, and appearances will be analyzed and discussed.  Attention will be paid to how sexuality and gender intersect with and/or shape other identities including race, ability, body size, and class.  We will examine the complex structures, systems, and ideologies that uphold discrimination and unequal distribution of power and resources as related to the course material.  Attention will mostly be given to North American perspectives.  We will use material culture to explore how objects related to fashioning the body reveal stories about the owners and consumers.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainability:  Theory and Practical Application",
    "dept": "A M D",
    "num": "565",
    "desc": "Prereq: 3 credits in research methods; basic knowledge of apparel industry and product development; permission of instructor.\nOverview of current sustainability theory, research, and methodology.  Emphasis on the evaluation and discussion of current sustainability literature and sustainable practice of apparel, textiles, and related products and services through people, processes, and the environment.  Development and presentation of original scholarly and creative design work under various sustainability frameworks.\n",
    "credits": "3"
  },
  {
    "course_name": "Consumer Behavior and Apparel",
    "dept": "A M D",
    "num": "567",
    "desc": "Prereq: A M D 467 or MKT 447; STAT 401\nApplication of concepts and theories from the social sciences to the study of consumer behavior. Experience in conducting research; manuscript writing.\n",
    "credits": "3"
  },
  {
    "course_name": "Sourcing and Global Issues",
    "dept": "A M D",
    "num": "572",
    "desc": "Prereq: A course in merchandising, marketing, or economics\nEvaluation of textile and apparel industries in global markets considering ethical, economic, political, social, and professional implications. Sourcing strategies in a global environment.  Corporate and consumer social responsibility and sustainability.  Experience in conducting research using secondary data.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Industry Applications in Merchandising and Management",
    "dept": "A M D",
    "num": "576",
    "desc": "Prereq: A M D 376 or equivalent; A M D 275 or equivalent; or permission of instructor\nUsing the case study method, students apply merchandising theory, principles, and practices to industry scenarios.  Emphasis on problem solving, creative thinking, data analysis, and data interpretation involved in business operations.  Focus on the development of leadership skills while functioning in small and large groups.\n",
    "credits": "3"
  },
  {
    "course_name": "E-Commerce for Apparel and Hospitality Companies",
    "dept": "A M D",
    "num": "577",
    "desc": "Prereq: Course in marketing or permission of instructor\nAnalysis of technology and consumer trends, industry practices, and marketing strategies for e-commerce including big data, data mining, and social media.  Evaluation and development of apparel or hospitality company websites.  Theory application to the development of multi-channel business strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "A M D",
    "num": "590",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Textile Science",
    "dept": "A M D",
    "num": "590A",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Historical, Cultural, and Museum Studies of Dress and Textiles",
    "dept": "A M D",
    "num": "590B",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Textile and Apparel Design",
    "dept": "A M D",
    "num": "590C",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Merchandising, Aesthetics, and Entrepreneurship",
    "dept": "A M D",
    "num": "590E",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Sociological, Psychological, and Consumer Behavioral Aspects of Dress",
    "dept": "A M D",
    "num": "590F",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Product Development, Innovation, and Sourcing",
    "dept": "A M D",
    "num": "590J",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Production and Quality Assurance",
    "dept": "A M D",
    "num": "590S",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Fashion Show, Fashion Public Relations and Marketing",
    "dept": "A M D",
    "num": "590W",
    "desc": "Prereq: Permission of director of graduate education, adviser, and instructor(s)\nIndividually designed  A M D-related projects that reflect the special interests of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Senior Design Studio",
    "dept": "A M D",
    "num": "595",
    "desc": "Prereq: A M D 310, A M D 325 and A M D 329. Permission of instructor.\nCreation of an apparel line from target market research to prototypes through the use of manual techniques and CAD technologies.  The line is to be included in a professional portfolio and pieces submitted to a juried exhibition.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "A M D",
    "num": "599",
    "desc": "Prereq: 9 graduate credits in A M D\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar",
    "dept": "A M D",
    "num": "611",
    "desc": "Prereq: 6 graduate credits in A M D. Permission of instructor\nDiscussion of scholarship and current issues. Topics vary.\n",
    "credits": "1"
  },
  {
    "course_name": "Design Theory and Process",
    "dept": "A M D",
    "num": "625",
    "desc": "Prereq: Permission of instructor.\nAnalysis and application of design theory and creative processes, including strategies for solving aesthetic, functional, and/or technology-focused design problems. Creation and dissemination of design scholarship.\n",
    "credits": "4"
  },
  {
    "course_name": "Social Science Theories of Appearance",
    "dept": "A M D",
    "num": "665",
    "desc": "Prereq: 6 credits in sociology or psychology\nAnalysis of social science theories and concepts applicable to appearance research. Emphasis on qualitative research and philosophy of knowledge, including postmodern, symbolic interaction, semiotic, and feminist theories.  Collection and analysis of qualitative data.\n",
    "credits": "3"
  },
  {
    "course_name": "Merchandising Theory and Research Applications",
    "dept": "A M D",
    "num": "676",
    "desc": "Prereq: A M D 275 or equivalent; statistics course recommended.\nReview of current merchandising theory, research, and methodology.  Emphasis on the evaluation and discussion of current and seminal merchandising literature, understanding research processes, interpretation of findings, assessing implications of research for future directions in merchandising, and the development and presentation of original scholarly work.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "A M D",
    "num": "690",
    "desc": "Prereq: Enrollment in doctoral program, permission of instructor; and approval of D.O.G.E\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "A M D",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Elementary Arabic I",
    "dept": "ARABC",
    "num": "101",
    "desc": "\nBeginning level development of reading, writing, listening comprehension, and speaking in Arabic, within the context of Arabic culture.  Attention to the use of the Arabic alphabet.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Arabic II",
    "dept": "ARABC",
    "num": "102",
    "desc": "Prereq: ARABC 101 or placement by department exam.\nContinuation of ARABC 101. Beginning level development of reading, writing, listening comprehension, and speaking in Arabic, within the context of Arabic culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Study Abroad",
    "dept": "ARABC",
    "num": "195",
    "desc": "\nSupervised instruction in Arabic language and culture, formal class instruction at level appropriate to student's training, augmented by practical living experience. Taught in Arabic.\n",
    "credits": "arr"
  },
  {
    "course_name": "Intermediate Arabic I",
    "dept": "ARABC",
    "num": "201",
    "desc": "Prereq: ARABC 102 or placement by department exam\nIntermediate level development of reading, writing, listening comprehension, and speaking in Arabic, within the context of Arabic culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Arabic II",
    "dept": "ARABC",
    "num": "202",
    "desc": "Prereq: ARABC 201 or placement by department exam\nContinuation of Arabic 201. Intermediate level development of reading, writing, listening comprehension, and speaking in Arabic, within the context of Arabic culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Study Abroad",
    "dept": "ARABC",
    "num": "295",
    "desc": "Prereq: ARABC 102 or equivalent\nSupervised instruction in Arabic language and culture, formal class instruction at level appropriate to student's training, augmented by practical living experience. Taught in Arabic.\n",
    "credits": "arr"
  },
  {
    "course_name": "Arab Culture",
    "dept": "ARABC",
    "num": "375",
    "desc": "\nSurvey of contemporary Arab culture in the Middle East and North Africa as reflected in history, language, the arts, and social institutions with attention to the Arab Diaspora. Taught in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ARABC",
    "num": "490",
    "desc": "Prereq: Permission of Arabic staff and department Chair.\nIndependent study with focus on areas other than those in which courses are offered.\n  No more than 6 credits in ARABC 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Architectural Design I",
    "dept": "ARCH",
    "num": "201",
    "desc": "Prereq: Completion of the pre-professional program and admission into the professional program in Architecture\nIntroduction to architectural design. Introduction to architectural design, including precedent research, drawing conventions, model making, and diagramming. Studio projects focus on investigating the impact of specific site conditions on design, threshold conditions, and small-scale domestic space. Students will learn skills in problem solving, visualization, and written, oral, and graphic communication. Field trips to relevant architectural sites.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design I, Honors",
    "dept": "ARCH",
    "num": "201H",
    "desc": "Prereq: Completion of the pre-professional program and admission into the professional program in Architecture\nIntroduction to architectural design. Introduction to architectural design, including precedent research, drawing conventions, model making, and diagramming. Studio projects focus on investigating the impact of specific site conditions on design, threshold conditions, and small-scale domestic space. Students will learn skills in problem solving, visualization, and written, oral, and graphic communication. Field trips to relevant architectural sites.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design II",
    "dept": "ARCH",
    "num": "202",
    "desc": "Prereq: ARCH 201; MATH 142; PHYS 111\nContinuation of fundamental architectural design exploration. Studio projects focus on the generation of ideas based on experience and an understanding of urban spaces. Emphasis on systematic analysis of urban culture, scale, materiality, and networks. Students work in groups and individually. Representational methods expand on architectural conventions through experimentation. Fieldtrips to relevant architectural sites.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design II, Honors",
    "dept": "ARCH",
    "num": "202H",
    "desc": "Prereq: ARCH 201, MATH 142 and PHYS 111\nContinuation of fundamental architectural design exploration. Studio projects focus on the generation of ideas based on experience and an understanding of urban spaces. Emphasis on systematic analysis of urban culture, scale, materiality, and networks. Students work in groups and individually. Representational methods expand on architectural conventions through experimentation. Fieldtrips to relevant architectural sites.\n",
    "credits": "6"
  },
  {
    "course_name": "Contemporary Architecture",
    "dept": "ARCH",
    "num": "220",
    "desc": "\nSurvey of global architectural ideas and practices from 1960 to the present. Emphasis will be given to recent movements and architectural manifestations, as well as close examinations of socio-cultural conditions for contemporary practice.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Pre-Modern Architecture",
    "dept": "ARCH",
    "num": "221",
    "desc": "\nSurvey of pre-modern western architectural ideas and practices in their social, cultural, and representational contexts. Comparisons with global examples. Ancient through 1750.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Communications I",
    "dept": "ARCH",
    "num": "230",
    "desc": "Prereq: Admission to the professional program in architecture\nInvestigations of various design media and their applications to design. Exercises to develop representational skills and perceptual sensitivity.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Design Representation",
    "dept": "ARCH",
    "num": "231",
    "desc": "Prereq: ARCH 230; Junior, Senior or graduate standing\nAdvanced investigations of various design media and their applications to design. Emphasis on careful consideration of media, mixed-media strategies and development of craft.\n",
    "credits": "3"
  },
  {
    "course_name": "Architectural Design III",
    "dept": "ARCH",
    "num": "301",
    "desc": "Prereq: ARCH 202\nConsideration of landscape as a constructed, cultural artifact. Projects address the perceptual aspects and strategies of situation and location; examination of environmental phenomena and patterns of use and settlement as revealed and affected by the architectural artifact. Development of a critical design process is stressed.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design III, Honors",
    "dept": "ARCH",
    "num": "301H",
    "desc": "Prereq: ARCH 202\nConsideration of landscape as a constructed, cultural artifact. Projects address the perceptual aspects and strategies of situation and location; examination of environmental phenomena and patterns of use and settlement as revealed and affected by the architectural artifact. Development of a critical design process is stressed.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design IV",
    "dept": "ARCH",
    "num": "302",
    "desc": "Prereq: ARCH 301 and minimum 2.0 GPA in previous studio courses\nContinuation of ARCH 301, examining housing in the urban situation; diverse scales of use and occupation within the city as shaped by cultural tendencies. Projects examine collective and individual identities related by the condition of adjacency, the ability to consider varieties of scale within a project, and a further development of critical and technical methods.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design IV, Honors",
    "dept": "ARCH",
    "num": "302H",
    "desc": "Prereq: ARCH 301 and minimum 2.0 GPA in previous studio courses\nContinuation of ARCH 301, examining housing in the urban situation; diverse scales of use and occupation within the city as shaped by cultural tendencies. Projects examine collective and individual identities related by the condition of adjacency, the ability to consider varieties of scale within a project, and a further development of critical and technical methods.\n",
    "credits": "6"
  },
  {
    "course_name": "History of the American City",
    "dept": "ARCH",
    "num": "321",
    "desc": "Prereq: Sophomore classification\nStudy of the development of the built environment and urban condition in the United States from the colonial period to today. Primary attention is given to urban spatial organization, built form, technological change, regulatory and funding patterns, and social categories such as class, race, and gender. Credit counts toward fulfillment of History, Theory, Culture requirements.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Histories and Theories of Modern Architecture",
    "dept": "ARCH",
    "num": "322",
    "desc": "Prereq: Sophomore Classification\nSurvey of global architectural ideas, theories and practices in their social, cultural and representational contexts from 1750 to 1960. Emphasis on European examples with additional material on the global spread of modernism.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer-aided Architectural Design",
    "dept": "ARCH",
    "num": "334",
    "desc": "\nExploration of current and potential applications of computing in architectural design. Projects engage digital design methods, data and media workflows.\n",
    "credits": "3"
  },
  {
    "course_name": "Three-Dimensional Studio",
    "dept": "ARCH",
    "num": "335",
    "desc": "\nThis course deals with three dimensional problems in visual invention, organization, and expression emphasizing creative manipulation of tools, materials, and techniques as means for three-dimensional thinking. Projects cover the additive (modeling), subtractive (carving), substitutional (casting) as well as constructive techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology I",
    "dept": "ARCH",
    "num": "345",
    "desc": "Prereq: Undergraduate: Admission to the professional program in architecture; concurrent enrollment in ARCH 345L; graduate: Admission to the M. Arch. program and concurrent enrollment in ARCH 505 and ARCH 595; concurrent enrollment in ARCH 545L\nFirst course in a sequence focused on architectural building technologies. Lectures and labs cover: environmental forces and systems (solar orientation, climate, daylighting, natural ventilation, human comfort and occupancy patterns), materials and assemblies (drawing conventions, building codes, and physical properties of materials) and fundamental structural principles (forces/loads, equilibrium, and stability). Readings and project presentations.\n",
    "credits": "2"
  },
  {
    "course_name": "Building Science and Technology I Lab",
    "dept": "ARCH",
    "num": "345L",
    "desc": "Prereq: Admission to the professional program in architecture; concurrent enrollment in ARCH 345.\nLaboratory to accompany ARCH 345 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format.\n",
    "credits": "1"
  },
  {
    "course_name": "Building Science and Technology II",
    "dept": "ARCH",
    "num": "346",
    "desc": "Prereq: Undergraduate: ARCH 345, ARCH 345L, MATH 145 and PHYS 111; concurrent enrollment in ARCH 346L. Graduate: ARCH 505, ARCH 545, ARCH 545L, and ARCH 595; concurrent enrollment in ARCH 506, ARCH 546L and ARCH 596.\nSecond course in a sequence focused on architectural building technologies. Lectures and labs cover: environmental systems (heat transfer in the building envelope, passive heating and cooling, daylighting, thermal comfort, analytical guidelines and building energy calculation methods), materials & assemblies (building envelope systems, accessibility, egress, and material properties), and structural systems (structural system selection/comparison, and design and analysis of “form-active” compression and tension structures). Readings and project presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology II Lab",
    "dept": "ARCH",
    "num": "346L",
    "desc": "Prereq: ARCH 345, ARCH 345L, MATH 145 and PHYS 111; concurrent enrollment in ARCH 346.\nLaboratory to accompany ARCH 346 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format.\n",
    "credits": "2"
  },
  {
    "course_name": "Building Science and Technology III",
    "dept": "ARCH",
    "num": "347",
    "desc": "Prereq: Undergraduate: ARCH 346, ARCH 346L; concurrent enrollment in ARCH 347L. Graduate: ARCH 506, ARCH 546, ARCH 546L, and ARCH 596 or advanced standing in the M.Arch program; concurrent enrollment in ARCH 601 and ARCH 547L.\nThird course in a sequence focused on architectural building technologies. Lectures and labs cover: multistory building framing, assembly, and enclosure systems, sizing and selecting structural framing components (foundations, columns, beams, etc.), and an environmental design process that demonstrates the ability to integrate climate into the control of thermal, luminous, ventilative and acoustic environments. Introduction to plumbing and rain water collection systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology III Lab",
    "dept": "ARCH",
    "num": "347L",
    "desc": "Prereq: ARCH 346, ARCH 346L; concurrent enrollment in ARCH 347.\nLaboratory to accompany ARCH 347 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format.\n",
    "credits": "2"
  },
  {
    "course_name": "Building Science and Technology IV",
    "dept": "ARCH",
    "num": "348",
    "desc": "Prereq: Undergraduate: ARCH 347, ARCH 347L; concurrent enrollment in ARCH 348L. Graduate: ARCH 547, ARCH 547L and ARCH 601; concurrent enrollment in ARCH 548L.\nFourth course in a sequence focused on architectural building technologies. Lectures and labs cover: ability to demonstrate active environmental HVAC control systems design, use and design of mechanical, electrical, plumbing, fire safety, transportation, and conveying systems and subsystems, constructed building assemblies and details (building envelope details for waterproofing and enclosure, advanced material properties, costs, and serviceability), and structural design for multi-story structures (design and documenting various framing patterns, integration with other building systems, and lateral stability strategies for wind and seismic).\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology IV Lab",
    "dept": "ARCH",
    "num": "348L",
    "desc": "Prereq: ARCH 347, ARCH 347L; concurrent enrollment in ARCH 348.\nLaboratory to accompany ARCH 348 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format.\n",
    "credits": "2"
  },
  {
    "course_name": "Whole Building Energy Performance Modeling",
    "dept": "ARCH",
    "num": "351",
    "desc": "Prereq: ARCH 202, 245, 341. Open to non-majors by permission of instructor.\nArchitectural design, design evaluation and technical analysis using energy, daylighting, and natural ventilation performance modeling tools. Emphasis will be given to whole building energy efficiency including passive and active systems integration.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Behavior and Environmental Theory",
    "dept": "ARCH",
    "num": "371",
    "desc": "Prereq: Completion of the pre-professional program and admission into the professional program in architecture\nExploration of theories that describe social structure and order and the manner in which individuals and societies organize themselves and structure their environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Architectural Design V",
    "dept": "ARCH",
    "num": "401",
    "desc": "Prereq: ARCH 302\nA rigorous examination of how buildings participate sustainably in socio-political and environmental systems.  Student projects consider in a comprehensive proposal how issues of physical site, socio-economic context, programming, structure, form, materiality, and building systems are interconnected through the design process and within the built environment.  Projects typically focus on a smaller scale urban public building that is closely connected to its physical, environmental, and social context.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design V, Honors",
    "dept": "ARCH",
    "num": "401H",
    "desc": "Prereq: ARCH 302\nA rigorous examination of how buildings participate sustainably in socio-political and environmental systems.  Student projects consider in a comprehensive proposal how issues of physical site, socio-economic context, programming, structure, form, materiality, and building systems are interconnected through the design process and within the built environment.  Projects typically focus on a smaller scale urban public building that is closely connected to its physical, environmental, and social context.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design VI",
    "dept": "ARCH",
    "num": "402",
    "desc": "Prereq: ARCH 401 and minimum 2.0 GPA in previous studio courses\nAn examination of the relationship between architecture and the city. Studio projects stress analysis and interpretation of the diverse forces and conditions that impact and inform architecture in the urban environment. Urban design project. Study abroad option.\n\nMeets International Perspectives Requirement.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design VI, Honors",
    "dept": "ARCH",
    "num": "402H",
    "desc": "Prereq: 401 and minimum 2.0 GPA in previous studio courses\nAn examination of the relationship between architecture and the city. Studio projects stress analysis and interpretation of the diverse forces and conditions that impact and inform architecture in the urban environment. Urban design project. Study abroad option.\n\nMeets International Perspectives Requirement.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design VII",
    "dept": "ARCH",
    "num": "403",
    "desc": "Prereq: ARCH 402\nA rigorous examination of architecture's relationship with culture and technology.  Studio projects stress the interpretation and integration of contextual and historical considerations, as well as structural, environmental, and communication systems, in a comprehensive design proposal.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design VII, Honors",
    "dept": "ARCH",
    "num": "403H",
    "desc": "Prereq: ARCH 402\nA rigorous examination of architecture's relationship with culture and technology. Studio projects stress the interpretation and integration of contextual and historical considerations, as well as structural, environmental, and communication systems, in a comprehensive design proposal.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design VIII",
    "dept": "ARCH",
    "num": "404",
    "desc": "Prereq: ARCH 403\nAdvanced forum for architectural research and/or design. Choice of thematic studios or student initiated research and design. Experimentation and innovation are encouraged. DSN S 446 or DSN S 546, for 6 cr. each time taken, can be substituted for this class and be taken up to a maximum of 12 credits.\n",
    "credits": "6"
  },
  {
    "course_name": "Architectural Design VIII, Honors",
    "dept": "ARCH",
    "num": "404H",
    "desc": "Prereq: ARCH 403\nAdvanced forum for architectural research and/or design. Choice of thematic studios or student initiated research and design. Experimentation and innovation are encouraged. DSN S 446 or DSN S 546, for 6 cr. each time taken, can be substituted for this class and be taken up to a maximum of 12 credits.\n",
    "credits": "6"
  },
  {
    "course_name": "Big and Tall: A History of Construction",
    "dept": "ARCH",
    "num": "417",
    "desc": "Prereq: For ARCH 417, Junior or Senior Classification, for ARCH 517, Graduate classification\nHistory, theory, and principles of construction from ancient times through today.  Analytic project or term paper and weekly readings with discussion questions. Credit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in  American Architecture",
    "dept": "ARCH",
    "num": "420",
    "desc": "Prereq: Junior classification\nHistory, theory, and principles of American architecture and urban design considering relationships to the culture, visual arts, site, and surroundings. Credit counts toward fulfillment of History, Theory, Culture requirements.\n  A maximum of 6 credits of ARCH 420 may be applied to degree program.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Medieval Architecture",
    "dept": "ARCH",
    "num": "422",
    "desc": "Prereq: Junior classification\nHistory, theory, and principles of medieval architecture and urban design considering relationships to the culture, visual arts, site, and surroundings. Credit counts toward fulfillment of History, Theory, Culture requirements.\n  A maximum of 6 credits of ARCH 422 may be applied to degree program.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Renaissance to Mid-Eighteenth Century Architecture",
    "dept": "ARCH",
    "num": "423",
    "desc": "Prereq: Junior classification\nHistory, theory, and principles of renaissance to mid-eighteenth century architecture and urban design considering relationships to the culture, visual arts, site, and surroundings. Credit counts toward fulfillment of History, Theory, Culture requirements.\n  A maximum of 6 credits of ARCH 423 may be applied to degree program.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Nineteenth Century Architecture",
    "dept": "ARCH",
    "num": "424",
    "desc": "Prereq: Junior classification\nHistory, theory, and principles of nineteenth century architecture and urban design considering relationships to the culture, visual arts, site, and surroundings. Credit counts toward fulfillment History, Theory, Culture requirements.\n  A maximum of 6 credits of ARCH 424 may be applied to degree program.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Twentieth Century Architecture",
    "dept": "ARCH",
    "num": "425",
    "desc": "Prereq: Junior classification\nHistory, theory, and principles of twentieth century architecture and urban design considering relationships to the culture, visual arts, site, and surroundings. Credit counts toward fulfillment History, Theory, Culture requirements.\n  A maximum of 6 credits of ARCH 425 may be applied to degree program.",
    "credits": "3"
  },
  {
    "course_name": "Topics in Native American Architecture",
    "dept": "ARCH",
    "num": "426",
    "desc": "Prereq: Junior classification\nHistory, theory, and principles of Native American/American Indian architecture, landscape architecture and planning considering relationships to the culture, visual arts, site, and surroundings. Credit counts toward fulfillment History, Theory, Culture.\n  A maximum of 6 credits of ARCH 426 may be applied to degree program.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History, Theory, and Criticism of Chinese Architecture",
    "dept": "ARCH",
    "num": "427",
    "desc": "Prereq: For ARCH 427, Senior classification, for ARCH 527, Graduate classification\nThe history and theoretical concept of Chinese built environment with emphasis on the morphology of built form and its relationship to art, landscape design, and urban structure. Credit counts toward fulfillment History, Theory, Culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Italian Architecture and Urbanism",
    "dept": "ARCH",
    "num": "429",
    "desc": "Prereq: Junior classification\nHistory, theory and principles of Italian architecture and urban design considering relationships to the culture, visual arts, site, and surroundings. Credit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Analytical Drawing",
    "dept": "ARCH",
    "num": "431",
    "desc": "Prereq: ARCH 230 and ARCH 302\nExploration of 2- and 3-dimensional representations. Emphasis on on-site freehand sketching, perspective and orthographic drawing, rendering of shadows and textures, and use of diverse media.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Computer Lighting and Rendering",
    "dept": "ARCH",
    "num": "432",
    "desc": "Prereq: ARCH 230 and ARCH 301\nExploration of the computer as a design and communication tool. Emphasis on lighting and rendering techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Fabrication",
    "dept": "ARCH",
    "num": "433",
    "desc": "Prereq: ARCH 230 and ARCH 301\nExploration of the computer as a design and manufacturing tool. Emphasis on developing digital fabrication technologies and workflows.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Computer-aided Architectural Design",
    "dept": "ARCH",
    "num": "434",
    "desc": "Prereq: ARCH 334 or by Instructor Permission.\nSpecialized investigations of the computer as a design tool. Development of computer software and workflows for architectural and environmental problem solving.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Design Media",
    "dept": "ARCH",
    "num": "436",
    "desc": "Prereq: ARCH 230\nSpecial topics in design media applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Architectural Photography",
    "dept": "ARCH",
    "num": "437",
    "desc": "Prereq: ARCH 202\nEmphasis on use of the camera and lighting in photographing drawings and interior and exterior building environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Design Theory",
    "dept": "ARCH",
    "num": "439",
    "desc": "Prereq: ARCH 221, Arch 222 or senior classification or graduate standing\nSeminar discussion of critical readings and theories surrounding computational design; This course surveys the history and development of digital computing and its use in design from early thought experiments, to computer-aided design systems, to present day artificial intelligences and robotics. The potentials and consequences of emerging computational design systems are discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology V",
    "dept": "ARCH",
    "num": "445",
    "desc": "Prereq: ARCH 348, ARCH 348L; concurrent enrollment in ARCH 445L.\nFinal course in a sequence of architectural building technology courses comprising environmental systems, materials/assembly, and building structures topics. Using both lectures and labs, the three interrelated modules each emphasize a particular building technology subject with an overall focus on synthesizing and integrating building technologies together in sustainable design strategies. Topics include: integration of active environmental control and service systems into the design of larger scale buildings, the development of construction details for building shell and interiors, and the design and analysis of various long-span structural systems.\n",
    "credits": "2"
  },
  {
    "course_name": "Building Science and Technology V Lab",
    "dept": "ARCH",
    "num": "445L",
    "desc": "Prereq: ARCH 348, ARCH 348L; concurrent enrollment in ARCH 445.\nLaboratory to accompany ARCH 445 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice",
    "dept": "ARCH",
    "num": "482",
    "desc": "Prereq: Junior classification and ARCH 371\nEmphasis on the circumstances and opportunities of the professional practice of architecture: practice as profession, process, organization, business, and evolving models of practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Design: Made in Italy",
    "dept": "ARCH",
    "num": "486",
    "desc": "\nAn investigation of the history of Italian design in its contemporary form as part of International study abroad program in Rome. Credit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ARCH",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nIndependent investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Design Communications.",
    "dept": "ARCH",
    "num": "490A",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nIndependent investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Design",
    "dept": "ARCH",
    "num": "490B",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nIndependent investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Building Science and Technology",
    "dept": "ARCH",
    "num": "490C",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nIndependent investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Architectural History",
    "dept": "ARCH",
    "num": "490D",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nIndependent investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Behavioral Studies",
    "dept": "ARCH",
    "num": "490E",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nIndependent investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Practice",
    "dept": "ARCH",
    "num": "490F",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nIndependent investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "ARCH",
    "num": "490H",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nIndependent investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Architectural Design and Media I:  Mapping, Programming, Building",
    "dept": "ARCH",
    "num": "505",
    "desc": "Prereq: Admission to the M Arch program. Concurrent enrollment in ARCH 545, ARCH 545L and ARCH 595.\nAn introduction to comprehensive architectural design projects that focuses on three interrelated design skills: mapping, programming and building. Projects establish a framework for designing buildings that considers multiple factors such as environmental forces, construction methods, building codes, urban regulations, social relationships, and cultural values.\n",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design and Media II:  Materiality and Representation",
    "dept": "ARCH",
    "num": "506",
    "desc": "Prereq: ARCH 505, ARCH 545, ARCH 545L, ARCH 595 and concurrent enrollment in ARCH 546, ARCH 546L, and ARCH 596\nSmall-scale architectural design projects that investigate design representation through analogue and digital means.  The projects explore different representation strategies to help students develop an understanding of the particular modes of architectural representation that advance the designer's knowledge of space as a complex interaction between materials with inherent physical characteristics, mobile socializing bodies, and changing environmental cycles.\n",
    "credits": "5"
  },
  {
    "course_name": "Architectural Design and Media III:  Design in Detail",
    "dept": "ARCH",
    "num": "507",
    "desc": "Prereq: ARCH 506, ARCH 546, ARCH 546L, ARCH 596 and concurrent enrollment in ARCH 581\nDesign projects that emphasize the multi-faceted role of the architectural detail in the design process through first, understanding the historical specificity of building construction and detailing; second, utilizing working drawing as a mode of communication; and third, designing with details.\n",
    "credits": "5"
  },
  {
    "course_name": "Big and Tall: A History of Construction",
    "dept": "ARCH",
    "num": "517",
    "desc": "Prereq: For ARCH 417, Junior or Senior Classification, for ARCH 517, Graduate classification\nHistory, theory, and principles of construction from ancient times through today.  Analytic project or term paper and weekly readings with discussion questions. Credit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Celluloid Cities, Urbanism in Film",
    "dept": "ARCH",
    "num": "521",
    "desc": "Prereq: Junior classification\nUrban theory and history as manifested in popular films and videos, both fiction and documentary.  Term projects require students to make short videos.  (Experience with video-making not necessary.) Credits counts towards fulfillment of History, Theory, Culture requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Complex Adaptive Systems Theory for the Design of Built Environments",
    "dept": "ARCH",
    "num": "522",
    "desc": "Prereq: Graduate or Senior Classification\nThe principles of complex adaptive systems theory are studied and then applied towards the design of resilient and responsive built environments. Topics cover a broad spectrum, including urban informalities, tactical approaches, the capacity of digital infrastructures to coordinate distributed human practices, and emergent phenomena. Credit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Meaning and Form in Architecture",
    "dept": "ARCH",
    "num": "525",
    "desc": "Prereq: Graduate or Senior classification\nSeminar on critical analysis of meaning and form in architecture and human-made environment in various cultural contexts examined from historical and theoretical perspectives. Analytic term paper and weekly readings with discussion questions. Credit counts toward fulfillment of History, Theory, Culture requirements.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History, Theory, and Criticism of Chinese Architecture",
    "dept": "ARCH",
    "num": "527",
    "desc": "Prereq: For ARCH 427, Senior classification, for ARCH 527, Graduate classification\nThe history and theoretical concept of Chinese built environment with emphasis on the morphology of built form and its relationship to art, landscape design, and urban structure. Credit counts toward fulfillment History, Theory, Culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topical Studies in Architecture",
    "dept": "ARCH",
    "num": "528",
    "desc": "Prereq: ARCH 221, ARCH 222 or senior classification or graduate standing\nCredit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "2"
  },
  {
    "course_name": "Studies in Architecture: Culture",
    "dept": "ARCH",
    "num": "528A",
    "desc": "Prereq: ARCH 221, ARCH 222 or senior classification or graduate standing\nCredit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "2"
  },
  {
    "course_name": "Studies in Architecture: Technology",
    "dept": "ARCH",
    "num": "528B",
    "desc": "Prereq: ARCH 221, ARCH 222 or senior classification or graduate standing\nn/a.\n",
    "credits": "2"
  },
  {
    "course_name": "Studies in Architecture: Communications",
    "dept": "ARCH",
    "num": "528C",
    "desc": "Prereq: ARCH 221, ARCH 222 or senior classification or graduate standing\nn/a.\n",
    "credits": "2"
  },
  {
    "course_name": "Studies in Architecture: Practice",
    "dept": "ARCH",
    "num": "528E",
    "desc": "Prereq: ARCH 221, ARCH 222 or senior classification or graduate standing\n",
    "credits": "2"
  },
  {
    "course_name": "Drawing Culture",
    "dept": "ARCH",
    "num": "531",
    "desc": "Prereq: ARCH 221, Arch 222 or senior classification or graduate standing\nExploration of theories and practices that center on drawing as a fundamental means of knowing.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Computer-aided Architectural Design",
    "dept": "ARCH",
    "num": "534",
    "desc": "Prereq: ARCH 434 or permission of instructor\nEmphasis on advanced, exploratory approaches to design computing. Projects highlight experimentation and integration of multiple media types.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Three-Dimensional Studio",
    "dept": "ARCH",
    "num": "535",
    "desc": "Prereq: ARCH 335 or Graduate classification\nAdvanced investigation of sculptural expression with emphasis on individual projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Design Theory",
    "dept": "ARCH",
    "num": "539",
    "desc": "Prereq: ARCH 221, Arch 222 or senior classification or graduate standing\nSeminar discussion of critical readings and theories surrounding computational design; This course surveys the history and development of digital computing and its use in design from early thought experiments, to computer-aided design systems, to present day artificial intelligences and robotics. The potentials and consequences of emerging computational design systems are discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology I",
    "dept": "ARCH",
    "num": "545",
    "desc": "Prereq: Undergraduate: Admission to the professional program in architecture; concurrent enrollment in ARCH 345L; graduate: Admission to the M. Arch. program and concurrent enrollment in ARCH 505 and ARCH 595; concurrent enrollment in ARCH 545L\nFirst course in a sequence focused on architectural building technologies. Lectures and labs cover: environmental forces and systems (solar orientation, climate, daylighting, natural ventilation, human comfort and occupancy patterns), materials and assemblies (drawing conventions, building codes, and physical properties of materials) and fundamental structural principles (forces/loads, equilibrium, and stability). Readings and project presentations.\n",
    "credits": "2"
  },
  {
    "course_name": "Building Science and Technology I Lab",
    "dept": "ARCH",
    "num": "545L",
    "desc": "Prereq: Admission to the M. Arch. program and concurrent enrollment in ARCH 505 and ARCH 595; concurrent enrollment in ARCH 545.\nLaboratory to accompany ARCH 545 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format. Readings and project presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology II",
    "dept": "ARCH",
    "num": "546",
    "desc": "Prereq: Undergraduate: ARCH 345, ARCH 345L, MATH 145 and PHYS 111; concurrent enrollment in ARCH 346L. Graduate: ARCH 505, ARCH 545, ARCH 545L, and ARCH 595; concurrent enrollment in ARCH 506, ARCH 546L and ARCH 596.\nSecond course in a sequence focused on architectural building technologies. Lectures and labs cover: environmental systems (heat transfer in the building envelope, passive heating and cooling, daylighting, thermal comfort, analytical guidelines and building energy calculation methods), materials & assemblies (building envelope systems, accessibility, egress, and material properties), and structural systems (structural system selection/comparison, and design and analysis of “form-active” compression and tension structures). Readings and project presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology II Lab",
    "dept": "ARCH",
    "num": "546L",
    "desc": "Prereq: ARCH 345, ARCH 345L, MATH 145 and PHYS 111; concurrent enrollment in ARCH 346.\nLaboratory to accompany ARCH 546 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format.\n",
    "credits": "2"
  },
  {
    "course_name": "Building Science and Technology III",
    "dept": "ARCH",
    "num": "547",
    "desc": "Prereq: Undergraduate: ARCH 346, ARCH 346L; concurrent enrollment in ARCH 347L. Graduate: ARCH 506, ARCH 546, ARCH 546L, and ARCH 596 or advanced standing in the M.Arch program; concurrent enrollment in ARCH 601 and ARCH 547L.\nThird course in a sequence focused on architectural building technologies. Lectures and labs cover: multistory building framing, assembly, and enclosure systems, sizing and selecting structural framing components (foundations, columns, beams, etc.), and an environmental design process that demonstrates the ability to integrate climate into the control of thermal, luminous, ventilative and acoustic environments. Introduction to plumbing and rain water collection systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology III Lab",
    "dept": "ARCH",
    "num": "547L",
    "desc": "Prereq: ARCH 506, ARCH 546, ARCH 546L, and ARCH 596 or advanced standing in the M.Arch program; concurrent enrollment in ARCH 547 and ARCH 601.\nLaboratory to accompany ARCH 547 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format.\n",
    "credits": "1"
  },
  {
    "course_name": "Building Science and Technology IV",
    "dept": "ARCH",
    "num": "548",
    "desc": "Prereq: Undergraduate: ARCH 347, ARCH 347L; concurrent enrollment in ARCH 348L. Graduate: ARCH 547, ARCH 547L and ARCH 601; concurrent enrollment in ARCH 548L.\nFourth course in a sequence focused on architectural building technologies. Lectures and labs cover: ability to demonstrate active environmental HVAC control systems design, use and design of mechanical, electrical, plumbing, fire safety, transportation, and conveying systems and subsystems, constructed building assemblies and details (building envelope details for waterproofing and enclosure, advanced material properties, costs, and serviceability), and structural design for multi-story structures (design and documenting various framing patterns, integration with other building systems, and lateral stability strategies for wind and seismic).\n",
    "credits": "3"
  },
  {
    "course_name": "Building Science and Technology IV Lab",
    "dept": "ARCH",
    "num": "548L",
    "desc": "Prereq: ARCH 547, ARCH 547L and ARCH 601; concurrent enrollment in ARCH 548.\nLaboratory to accompany ARCH 548 and must be taken concurrently. Integrating building technologies into architectural designs through experiments and exercises in laboratory format.\n",
    "credits": "1"
  },
  {
    "course_name": "Sustainability and Green Architecture",
    "dept": "ARCH",
    "num": "558",
    "desc": "Prereq: Graduate or Senior classification\nIssues of sustainability as related to living patterns and city design, population, pollution and use and availability of natural resources for the built environment. Issues of green and sustainable architecture as related to critical thinking about methods of building material selection and systems, the environment of the United States and the world, and examples of green or sustainable building designs.\n",
    "credits": "3"
  },
  {
    "course_name": "Preservation, Restoration, and Rehabilitation",
    "dept": "ARCH",
    "num": "567",
    "desc": "Prereq: Senior classification\nConstruction standards and procedures for preserving, restoring, reconstructing, and rehabilitating existing buildings following the guidelines of the National Park Service and the National Trust for Historic Preservation. Credit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Historic Preservation",
    "dept": "ARCH",
    "num": "568",
    "desc": "Prereq: Senior classification\nThe history and theory of the Historic Preservation movement including an overview of the National Trust for Historic Preservation; the National Register of the Historic Places; the National Park Service; federal programs, funding sources, preservation law, national landmarks, and historic distracts. Credit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Design for All People",
    "dept": "ARCH",
    "num": "571",
    "desc": "Prereq: Graduate or Senior classification\nPrinciples and procedures of inclusive design in response to the varying ability level of users. Assessment and analysis of existing buildings and sites with respect to standards and details of accessibility for all people, including visually impaired, mentally impaired, and mobility restricted users. Design is neither a prerequisite nor a required part of the course. Enrollment open to students majoring in related disciplines. Credit counts toward fulfillment of History, Theory, Culture requirements.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Urban Design Theory",
    "dept": "ARCH",
    "num": "575",
    "desc": "Prereq: Graduate or Senior classification\nCurrent urban design theory and its application to urban problems. Credit counts toward fulfillment of History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad Options",
    "dept": "ARCH",
    "num": "576",
    "desc": "\nSpecial topics in environmental design, architectural history and contemporary practice. Travel to relevant countries. General cultural and historical studies, topical projects and individual inquiry. Courses may be taught by departmental faculty or faculty from approved Iowa State Study Abroad programs. See current offerings for detailed syllabus.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Making and Material Practice",
    "dept": "ARCH",
    "num": "581",
    "desc": "Prereq: ARCH 506, ARCH 546, ARCH 546L, and ARCH 596\nPlanning and execution of a project serving a community need.  Learning occurs through both theory and active involvement in on-site work. Projects connect previous coursework to practical applications and community involvement.\n",
    "credits": "5"
  },
  {
    "course_name": "Professional Practice",
    "dept": "ARCH",
    "num": "582",
    "desc": "Prereq: Junior classification and ARCH 371\nEmphasis on the circumstances and opportunities of the professional practice of architecture: practice as profession, process, organization, business, and evolving models of practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Research in Practice",
    "dept": "ARCH",
    "num": "583",
    "desc": "Prereq: Graduate or Senior classification\nFoundational course in the methods and conceptual tools of design research in the context of practice. Through team and individual guided projects, students generate, analyze and represent knowledge in design-related communications and contexts. Alternative models of practice, client groups and communities are addressed within projects that precede, feed, follow, or overlap with architectural contracts.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "ARCH",
    "num": "590",
    "desc": "Prereq: Written approval of instructor and department chair on approved form\nInvestigation of architectural issues having a specialized nature.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar on the Built Environment I: History",
    "dept": "ARCH",
    "num": "595",
    "desc": "Prereq: Admission to the M. Arch. program and concurrent enrollment in ARCH 505, ARCH 545, and ARCH 545L\nIntroduction to historical canons and traditions of architecture and urbanism. Discussion of the relationship between historical inquiry and contemporary practice. Students learn skills in critical thinking, visual analysis, and research methods. Course sessions develop thematically with interdisciplinary readings, group discussions, student presentations, and research projects.\n",
    "credits": "5"
  },
  {
    "course_name": "Seminar on the Built Environment II: Landscape and Society",
    "dept": "ARCH",
    "num": "596",
    "desc": "Prereq: ARCH 505, ARCH 545, ARCH 545L, ARCH 595 and concurrent enrollment in ARCH 506, ARCH 546, and ARCH 546L\nIntroduction to landscape as artifact and multi-disciplinary knowledge-base for design thinking. Literatures and methods of environmental psychology, cultural geography, landscape and architectural history and theory, site and circulation design as intersection of built infrastructural, natural, and social systems. Emphasis on sensory perception, and human movement;  investigations of climate, environmental conditions, and values toward consumption and sustainability in everyday experience of the built environment.\n",
    "credits": "5"
  },
  {
    "course_name": "Seminar on the Built Environment III: Theory",
    "dept": "ARCH",
    "num": "597",
    "desc": "Prereq: Graduate or Senior classification\nMultidisciplinary overview of contemporary theories concerned with the production of the built environment. Particular attention to urbanism as a discourse that relates social interactions and power structures to material space. Credit counts toward fulfillment of History, Theory, Culture requirements.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on the Built Environment IV: Topical Study",
    "dept": "ARCH",
    "num": "598",
    "desc": "Prereq: Graduate or Senior classification\nA research seminar which considers a topic within contemporary discourses on the built environment outside of Europe and North America. The topic will be studied from multiple perspectives highlighting the historical and theoretical relationships between architecture, global cultures, geography, landscape, and urban planning. Credit counts toward fulfillment History, Theory, Culture requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Building Design",
    "dept": "ARCH",
    "num": "601",
    "desc": "Prereq: ARCH 507, ARCH 546, ARCH 546L, and ARCH 596 and concurrent enrollment in ARCH 547 and ARCH 547L\nDesign projects that are developed through integrative design strategies that explore the relationship between buildings and environmental forces to maximize non-wasteful, efficient use of resources such as energy, water and building materials. Projects will include investigations of the impact of solar energy, airflow, building materials, passive and active systems and wall sections on spatial quality and form making. Design decisions will be quantitatively validated through energy modeling and performance simulation.\n",
    "credits": "6"
  },
  {
    "course_name": "Community, Building and the Environment",
    "dept": "ARCH",
    "num": "602",
    "desc": "Prereq: ARCH 601, ARCH 643, ARCH 597 and concurrent enrollment in ARCH 644\nDesign projects that explore the relationships between architectural, cultural, and environmental landscapes. Emphasis on regional sites, socio-economic conditions, and sustainable design and planning practices at multiple scales. Projects stress engagement with local circumstances and stakeholders; systemic interconnections and strategies; and the application of interdisciplinary research.\n",
    "credits": "6"
  },
  {
    "course_name": "Integrative Design",
    "dept": "ARCH",
    "num": "603",
    "desc": "Prereq: ARCH 601\nRigorous examination of architecture's relationship with culture and technology. Studio projects stress the interpretation of contextual and historical considerations while demonstrating broad integration and consideration of environmental stewardship, technical documentation, accessibility, site conditions, life safety, environmental systems, structural systems, and building envelope systems and assemblies. This course fulfills the Graduate College Creative Component Requirement.\n",
    "credits": "6"
  },
  {
    "course_name": "Design Studio Options",
    "dept": "ARCH",
    "num": "604",
    "desc": "Prereq: ARCH 602\nDesign studio selected by the students, which may include but is not limited to: independent design study, interdisciplinary design studio, study abroad, and design build. DSN S 546 for 6 cr. may be substituted for this course.\n",
    "credits": "6"
  },
  {
    "course_name": "Independent Design Study",
    "dept": "ARCH",
    "num": "690",
    "desc": "Prereq: Admission to the M. S. in Arch. program\nIndependent architectural design projects commensurate with student interests requiring approval of Architecture Graduate  Committee.\n",
    "credits": "6"
  },
  {
    "course_name": "Graduate Seminar",
    "dept": "ARCH",
    "num": "698",
    "desc": "Prereq: Admission to the M. Arch. or M. S. in Arch. programs\nSpecial topics and guest speakers.\n",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "ARCH",
    "num": "699",
    "desc": "\nResearch.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Teaching in and Through Art",
    "dept": "ARTED",
    "num": "209",
    "desc": "Prereq: Sophomore level\nMethods of teaching in and through visual art are experienced and applied in this course. Art-centered and interdisciplinary art education methods for K-8 teaching are designed to develop creativity, authentic expression, collaboration, aesthetic sensitivity and pluralistic, global perspectives.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Art Education",
    "dept": "ARTED",
    "num": "211",
    "desc": "Prereq: Sophomore level\nTeaching methods for K-12 art education. Hands-on discipline-specific and integrated art activities are experienced and designed; emphasis is on creativity, artistic and human diversity, community building, and development of thinking skills in holistic, pluralistic art education.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ARTED",
    "num": "490",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "History of Art I",
    "dept": "ART H",
    "num": "280",
    "desc": "\nDevelopment of the visual arts including painting, sculpture, architecture, and crafts, from the prehistoric through Gothic periods.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Art II",
    "dept": "ART H",
    "num": "281",
    "desc": "\nDevelopment of the visual arts of western civilization including painting, sculpture, architecture, and crafts; from the Renaissance to the twentieth century.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Art II: Honors",
    "dept": "ART H",
    "num": "281H",
    "desc": "\nDevelopment of the visual arts of western civilization including painting, sculpture, architecture, and crafts; from the Renaissance to the twentieth century.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Visual Culture Studies",
    "dept": "ART H",
    "num": "292",
    "desc": "\nAn introduction to various topics in visual culture studies, including significant trends in the visual arts, mass media, scientific imagery, visual communications, and other areas related to visual literacy and visual representation in local and global contexts. Cross cultural viewpoints and issues of diversity will be presented in relation to visual culture.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Origins and Evolution of Modern Design",
    "dept": "ART H",
    "num": "293",
    "desc": "\nHistory of designed artifacts, their creators, and their cultural environments in Europe and America from the beginning of the Industrial Revolution to the present.\n",
    "credits": "3"
  },
  {
    "course_name": "Art and Architecture of Asia",
    "dept": "ART H",
    "num": "382",
    "desc": "\nIntroduction to the history of art and architecture in Asia before the modern era. Cultures may include China, Korea, Japan, and India.  Art traditions of Asia are explored in relation to their cultural, historical, and religious contexts.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Greek and Roman Art",
    "dept": "ART H",
    "num": "383",
    "desc": "\nGreek art from Neolithic to Hellenistic periods. Roman art from the traditional founding to the end of the empire in the West.\n",
    "credits": "3"
  },
  {
    "course_name": "Greek and Roman Art: Honors",
    "dept": "ART H",
    "num": "383H",
    "desc": "\nGreek art from Neolithic to Hellenistic periods. Roman art from the traditional founding to the end of the empire in the West.\n",
    "credits": "3"
  },
  {
    "course_name": "Art of Islam",
    "dept": "ART H",
    "num": "384",
    "desc": "\nHistorical survey of the painting, sculpture, crafts, and architecture of the various civilizations of the Islamic world.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Art of Islam, Honors",
    "dept": "ART H",
    "num": "384H",
    "desc": "\nHistorical survey of the painting, sculpture, crafts, and architecture of the various civilizations of the Islamic world.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Renaissance Art",
    "dept": "ART H",
    "num": "385",
    "desc": "\nEuropean art including painting, sculpture, architecture, and crafts; thirteenth through sixteenth centuries.\n",
    "credits": "3"
  },
  {
    "course_name": "Renaissance Art, Honors",
    "dept": "ART H",
    "num": "385H",
    "desc": "\nEuropean art including painting, sculpture, architecture, and crafts; thirteenth through sixteenth centuries.\n",
    "credits": "3"
  },
  {
    "course_name": "American Art to 1945",
    "dept": "ART H",
    "num": "386",
    "desc": "\nSurvey of American art from the early colonial period to 1945, with emphasis on historical and cultural issues that underlie art production in the United States.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Modern Art and Theory",
    "dept": "ART H",
    "num": "388",
    "desc": "\nVisual arts and critical theory of the early 20th century, including Expressionism, Cubism, Futurism, Suprematism, Dada, and Surrealism.\n",
    "credits": "3"
  },
  {
    "course_name": "Art and Theory Since 1945",
    "dept": "ART H",
    "num": "395",
    "desc": "\nVisual arts and critical theory after 1945, including Abstract Expressionism, Pop Art, and Performance Art.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History of Photography",
    "dept": "ART H",
    "num": "396",
    "desc": "\nSurvey of the evolution of photography and photojournalism from the 1830s to the present, seen from an art historical perspective, emphasizing causative factors, cultural influences,and major masters and schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Art History Field Study",
    "dept": "ART H",
    "num": "486",
    "desc": "Prereq: Concurrent enrollment in an art history course and permission of instructor\nStudy and tours of museums, galleries, artist and/or designer studios and other areas of interest within art history.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Nineteenth-Century Art",
    "dept": "ART H",
    "num": "487",
    "desc": "\nEuropean and American art and architecture from 1780 to 1900 focusing on the major movements of western Europe, including Neoclassicism, Romanticism, Realism, Impressionism, and Post-Impressionism.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Comics",
    "dept": "ART H",
    "num": "489",
    "desc": "\nAn art-historical survey of comic strips, comic books, and graphic novels from their origins in the 19th century to present.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Comics: Honors",
    "dept": "ART H",
    "num": "489H",
    "desc": "\nAn art-historical survey of comic strips, comic books, and graphic novels from their origins in the 19th century to present.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ART H",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and department chair on required form before the semester of enrollment\nStudent must have completed art history coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "ART H",
    "num": "490H",
    "desc": "Prereq: Written approval of instructor and department chair on required form before the semester of enrollment\nStudent must have completed art history coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Art History in Europe Seminar",
    "dept": "ART H",
    "num": "491",
    "desc": "Prereq: Permission of instructor and planned enrollment in ART H 492\nCultural and historical aspects of art and design in Western Europe in preparation for study abroad. Area of study varies each time offered. Offered on a satisfactory-fail basis only.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Art History in Europe",
    "dept": "ART H",
    "num": "492",
    "desc": "Prereq: For ART H 492: ART H 491 or equivalent, permission of instructor; For ART H 592: Graduate classification, permission of instructor\nInternational study abroad program in western Europe. Visits to design studios, art museums, and educational facilities. Related activities depending on specific area of study which may vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Women/Gender in Art",
    "dept": "ART H",
    "num": "494",
    "desc": "\nIssues of gender related to cultural environments from the Middle Ages to contemporary times in Europe and America. Feminist movement beginning in the 1970s and specifically gender issues in art that are becoming widespread in the artistic culture.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Museum/Gallery Internship",
    "dept": "ART H",
    "num": "497",
    "desc": "Prereq: Written approval of supervising instructor on required form in advance of semester of enrollment.\nSupervised experience with a cooperating museum or gallery or art center.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Selected Topics in Art History",
    "dept": "ART H",
    "num": "498",
    "desc": "\nSpecialized study in the history or criticism of art and/or design.\n",
    "credits": "3"
  },
  {
    "course_name": "Visual Culture Studies Writing and Methods Seminar",
    "dept": "ART H",
    "num": "499",
    "desc": "\nSustained exploration of topics related to Visual Culture Studies. Course incorporates introduction to methods central to the field of visual culture studies, writing exercises, and guided instruction in the process of conducting research and reporting results of the research process. Course will result in an original paper.\n",
    "credits": "4"
  },
  {
    "course_name": "Issues in Visual and Material Culture Seminar",
    "dept": "ART H",
    "num": "501",
    "desc": "Prereq: Permission of instructor\nIssues and debates that pertain to the study of visual objects and material artifacts in their cultural context. Examination of the role of visual and material culture studies as both relate to allied disciplines including, but not limited to: anthropology, art history, design history, design studies, and new media studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Museum/Gallery Internship",
    "dept": "ART H",
    "num": "586",
    "desc": "Prereq: Graduate classification and permission of instructor. Written approval in advance of semester of enrollment.\nSupervised experience with a cooperating museum or gallery or art center.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Nineteenth Century Art",
    "dept": "ART H",
    "num": "587",
    "desc": "\nEuropean and American art and architecture from 1780 to 1900, focusing on the major movements of western Europe, including Neoclassicism, Romanticism, Realism, Impressionism, and Post-Impressionism.\n",
    "credits": "3"
  },
  {
    "course_name": "Modern Art and Theory",
    "dept": "ART H",
    "num": "588",
    "desc": "Prereq: Graduate classification or permission of instructor\nVisual arts and critical theory of the early 20th century, including Expressionism, Cubism, Futurism, Suprematism, Dada and Surrealism.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Comics",
    "dept": "ART H",
    "num": "589",
    "desc": "\nAn art-historical survey of comic strips, comic books, and graphic novels from their origins in the 19th century to present.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "ART H",
    "num": "590",
    "desc": "Prereq: Graduate classification; written approval of instructor and department chair on required form in advance of semester of enrollment.\nIndependent Study in Art History.\n",
    "credits": "arr"
  },
  {
    "course_name": "Art History in Europe",
    "dept": "ART H",
    "num": "592",
    "desc": "Prereq: For ART H 492: ART H 491 or equivalent, permission of instructor; For ART H 592: Graduate classification, permission of instructor\nInternational study abroad program in western Europe. Visits to design studios, art museums, and educational facilities. Related activities depending on specific area of study which may vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Women/Gender in Art",
    "dept": "ART H",
    "num": "594",
    "desc": "Prereq: Graduate classification or permission of instructor\nIssues of gender related to cultural environments from the Middle Ages to contemporary times in Europe and America.  Feminist movement beginning in the 1970s and specifically gender issues in art that are becoming widespread in the artistic culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Art and Theory Since 1945",
    "dept": "ART H",
    "num": "595",
    "desc": "Prereq: Graduate classification or permission of instructor\nVisual arts and critical theory after 1945, including Abstract Expressionism, Pop Art, and Performance Art.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Photography",
    "dept": "ART H",
    "num": "596",
    "desc": "Prereq: Graduate classification or permission of instructor\nSurvey of the evolution of photography and photojournalism from the 1830s to the present, seen from an art historical perspective, emphasizing causative factors, cultural influences, and major masters and schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Green Art: Earthworks and Beyond",
    "dept": "ART H",
    "num": "597",
    "desc": "Prereq: Graduate classification or permission of instructor\nSeminar covering aspects of art and design based on ecological principles, including earthworks, land-based art, recycled/reused objects, ecofeminism, ephemerality, and green design.\n",
    "credits": "3"
  },
  {
    "course_name": "Selected Topics in Art History",
    "dept": "ART H",
    "num": "598",
    "desc": "\nSpecialized study in the history or criticism of art and/or design.\n",
    "credits": "3"
  },
  {
    "course_name": "North Star Astronomy",
    "dept": "ASTRO",
    "num": "102",
    "desc": "\nAn entirely web-based course covering topics in observing the sky and navigation by the stars for students with little or no previous experience. The course combines material on common naked-eye phenomena, such as daily and seasonal variations in the sky, with information on how these helped navigators determine where they are on Earth. The course \"lectures\" are on-line, interactive units with build in exercises, hands-on (offline) activities and layers of help. Graded homework and quizzes are administered via Blackboard Learn.\n  Students who take Astro 120 may count credit in only one of Astro 102 or 103 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Evening Star",
    "dept": "ASTRO",
    "num": "103",
    "desc": "\nAn entirely web-based course covering topics in celestial mechanics (\"Rocket science!\") for students with little or no previous experience. It combines the geography of the solar system with discussion of methods of traveling to the other planets. The course \"lectures\" are on-line, interactive units with built-in exercises, hands-on (offline) activities, and layers of help. Graded homework and quizzes are administered via Blackboard Learn.\n  Students who take Astro 120 may count credit in only one of Astro 102 or 103 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Earth and Space Science for Elementary Education Majors",
    "dept": "ASTRO",
    "num": "106",
    "desc": "Prereq: Major in elementary or early childhood education.\nFundamental concepts of Earth and Space Science, including the solar system, weather and climate, water and soils, plate tectonics, and geologic hazards. Online course format.\n",
    "credits": "2"
  },
  {
    "course_name": "Earth and Space Science for Elementary Education Majors: Laboratory",
    "dept": "ASTRO",
    "num": "106L",
    "desc": "Prereq: Restricted to elementary and early childhood education majors; to be taken concurrently with GEOL 106/ASTRO 106\nInquiry-based lab exploring fundamental concepts of Earth and Space Science, including the solar system, weather and climate, water and soils, plate tectonics, and geologic hazards. Must be taken concurrently with GEOL/ASTRO 106.\n",
    "credits": "1"
  },
  {
    "course_name": "The Sky and the Solar System",
    "dept": "ASTRO",
    "num": "120",
    "desc": "\nFor the nonscientist. A survey of our view of the universe, and the exploration of the solar system and beyond.  The sky: constellations; motions of the Sun, Moon, and planets; seasons and the calendar; eclipses. The solar system: origin and evolution; characteristics of the Sun, planets, satellites, comets, meteorites, and asteroids. The detection and characterization of other solar systems, and the search for life in the universe.  Extensive use of the planetarium is included.\n  Students who take Astro 120 may count credit in only one of Astro 102 or 103 toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "The Sky and the Solar System Laboratory",
    "dept": "ASTRO",
    "num": "125L",
    "desc": "Prereq: Concurrent or previous enrollment in ASTRO 120\nLaboratory course to accompany ASTRO 120. Students carry out practical exercises involving naked eye and telescopic observing to explore and reinforce ideas covered in ASTRO 120. Activities based on a sky-simulation computer program and other weather-independent exercises are also included.\n",
    "credits": "1"
  },
  {
    "course_name": "Stars, Galaxies, and Cosmology",
    "dept": "ASTRO",
    "num": "150",
    "desc": "\nFor the nonscientist. A survey of astronomy with a focus on the universe beyond our solar system.  Basic observational astronomy and the history of astronomy.  Stellar astronomy: motions, distances, sizes, spectra; types of stars; variability; binary systems. Stellar evolution: the birth, life, and death of stars, including supernovae, neutron stars, and black holes. The structure and evolution of the Milky Way Galaxy.  Other galaxies, clusters of galaxies, quasars. Theories of the origin of the universe.\n",
    "credits": "3"
  },
  {
    "course_name": "Astronomy Bizarre",
    "dept": "ASTRO",
    "num": "250",
    "desc": "Prereq: ASTRO 120 or ASTRO 150\nFor the nonscientist. A small enrollment course examining new and exciting topics in modern astronomy. Galaxy and star formation. Black holes and pulsars. Colliding galaxies. Quasars. Dark Matter.  Dark energy.  Quasars. Cosmology, the Big Bang and the future of the universe. Prospects and searches for extraterrestrial life.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ASTRO",
    "num": "290",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Solar System Astronomy",
    "dept": "ASTRO",
    "num": "342",
    "desc": "Prereq: PHYS 222\nAn introduction to the physics of the Solar System and the planetary systems discovered around other stars.  General characteristics of planetary systems: dynamics, thermodynamics, internal and surface structure of planets and minor bodies, physics of their atmosphere.  Discovery techniques and characterization of extrasolar planets, and planetary systems formation models.  \"Grand tour\" of the Solar System, using data and imagery from probes and telescopes that have visited these worlds.  The origin and evolution of life on Earth, and the ongoing search for life in the Solar System and elsewhere in the universe.\n",
    "credits": "3"
  },
  {
    "course_name": "Astronomy Laboratory",
    "dept": "ASTRO",
    "num": "344L",
    "desc": "Prereq: PHYS 222\nExperiments in optical astronomy. Observational techniques, ranging from stellar photometry to CCD imaging. Data processing and analysis techniques.  Astronomical software packages and online databases and resources.  Available instruments include a variety of small telescopes and astronomical CCD cameras.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Astrophysics",
    "dept": "ASTRO",
    "num": "346",
    "desc": "Prereq: PHYS 222\nAn exploration of the universe beyond our Solar System, with emphasis on the astrophysics of stars and galaxies. Observable properties of stars, physics of stellar atmospheres and interiors. Birth, evolution and death of stars, to understand the past and future of our Sun, the Milky Way galaxy and the other galaxies in the universe. Basic concepts of cosmology, dark matter and dark energy. Use of computer models to calculate the structure and evolution of stars and protostars, and to analyze actual astronomical data obtained by professional astronomers.\n",
    "credits": "3"
  },
  {
    "course_name": "Astrophysical Cosmology",
    "dept": "ASTRO",
    "num": "405",
    "desc": "Prereq: ASTRO 346 or permission of instructor\nIntroduction to modern cosmology and large-scale structure; mathematical and observational fundamentals associated with the origin, structure, and evolution of the Universe.  Scale of the Universe, Hubble's Law, the cosmic microwave background, Big Bang nucleosynthesis, the origin of elements, dark energy and the accelerating universe, and dark matter. For senior undergraduates and graduate students in all areas of physics.\n",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "ASTRO",
    "num": "450",
    "desc": "Prereq: Permission of instructor\nResearch under supervision of astronomy faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "ASTRO",
    "num": "450L",
    "desc": "Prereq: ASTRO 344L and permission of instructor\nLaboratory or observational project under supervision of astronomy faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "ASTRO",
    "num": "490",
    "desc": "Prereq: 6 credits in astronomy, permission of instructor\n  No more than 9 credits of Astro 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "ASTRO",
    "num": "490H",
    "desc": "Prereq: 6 credits in astronomy, permission of instructor\n  No more than 9 credits of Astro 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Astrophysical Cosmology",
    "dept": "ASTRO",
    "num": "505",
    "desc": "Prereq: ASTRO 346 or permission of instructor\nIntroduction to modern cosmology and large-scale structure; mathematical and observational fundamentals associated with the origin, structure, and evolution of the Universe.  Scale of the Universe, Hubble's Law, the cosmic microwave background, Big Bang nucleosynthesis, the origin of elements, dark energy and the accelerating universe, and dark matter. For senior undergraduates and graduate students in all areas of physics.\n",
    "credits": "3"
  },
  {
    "course_name": "Observational Astrophysics",
    "dept": "ASTRO",
    "num": "510",
    "desc": "Prereq: ASTRO 405 or ASTRO 505 or permission of instructor\nTechniques in optical and near-IR astronomy, including spectroscopy and CCD photometry. Emphasis on projects involving proficiency in the use of research telescopes and modern instrumentation. Project topics range from photometric studies of pulsating and binary star systems to deep CCD imaging of faint nebulae and galaxies.\n",
    "credits": "3"
  },
  {
    "course_name": "Stellar Astrophysics",
    "dept": "ASTRO",
    "num": "580",
    "desc": "Prereq: ASTRO 405 or ASTRO 505 or permission of the instructor\nThe interior structure and atmospheric properties of stars:  Stellar structure equations and constitutive relations: energy generation, energy transport by radiation and convection; equation of state, nuclear energy generation and nucleosynthesis. Numerical and analytic solutions to the equations of structure and evolution. Observational connections through the theory of radiative transfer.  Line and continuum processes and sources of opacity.  Non-LTE and statistical equilibrium.  Line profiles.  Interpretation of stellar spectra:  temperature, pressure, and abundance determinations.  Stellar evolution from formation to final phases.\n",
    "credits": "3"
  },
  {
    "course_name": "High Energy Astrophysics",
    "dept": "ASTRO",
    "num": "582",
    "desc": "Prereq: ASTRO 405 or ASTRO 505 or permission of the instructor\nInteractions of high-energy particles, non-thermal radiation processes, spectral evolution of non-thermal systems, cosmic rays, active galactic nuclei, pulsars, neutrinos, measurement techniques for relativistic charged particles, high energy photons, and neutrinos.\n",
    "credits": "3"
  },
  {
    "course_name": "Galactic Astronomy",
    "dept": "ASTRO",
    "num": "584",
    "desc": "Prereq: ASTRO 405 or ASTRO 505 or permission of instructor\nOverall structure of our Galaxy and the interstellar medium.  Physical processes in the interstellar medium (e.g., heating and cooling mechanisms, turbulence).  Observational techniques for studying the interstellar medium.  Kinematics and chemical evolution of the Galaxy.\n",
    "credits": "3"
  },
  {
    "course_name": "Extragalactic Astronomy",
    "dept": "ASTRO",
    "num": "586",
    "desc": "Prereq: ASTRO 405 or ASTRO 505 or permission of the instructor\nGalaxy evolution, dynamics of external galaxies, evolution and classification of galaxies, groups and clusters of galaxies, extragalactic radio sources, quasars, structure formation, cosmological models and their observational consequences.\n",
    "credits": "3"
  },
  {
    "course_name": "Special topics",
    "dept": "ASTRO",
    "num": "590",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "ASTRO",
    "num": "599",
    "desc": "Prereq: Permission of instructor\nIndividually directed study of research-level problems for students electing the nonthesis M.S. option in astronomy.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Seminar",
    "dept": "ASTRO",
    "num": "650",
    "desc": "\nTopics of current interest in astronomy and astrophysics.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Stellar Astrophysics",
    "dept": "ASTRO",
    "num": "675",
    "desc": "Prereq: ASTRO 580 or permission of instructor\nAdvanced topics in stellar astrophysics. Dynamic and extended atmospheres, chromospheres, coronae, and stellar winds.  MHD, stellar activity, and dynamo theory. Radiative transfer and the transition from extended atmospheres to the interstellar medium. Diffusive processes in stellar atmospheres and interiors. Techniques for quantitative analysis of planetary and stellar spectra including detailed modeling and spectrum synthesis.  Evolution in interacting binaries. Nucleosynthesis II.  Variable stars. Supernovae. Neutron stars and black holes.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "ASTRO",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Intercollegiate Athletics",
    "dept": "ATH",
    "num": "101",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Basketball (men)",
    "dept": "ATH",
    "num": "101B",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Basketball (women)",
    "dept": "ATH",
    "num": "101C",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Cross Country (men)",
    "dept": "ATH",
    "num": "101D",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Cross Country (women)",
    "dept": "ATH",
    "num": "101E",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Football (men)",
    "dept": "ATH",
    "num": "101F",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Golf (men)",
    "dept": "ATH",
    "num": "101G",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Gymnastics (women)",
    "dept": "ATH",
    "num": "101J",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Softball (women)",
    "dept": "ATH",
    "num": "101K",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Swimming/Diving (women)",
    "dept": "ATH",
    "num": "101M",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Tennis (women)",
    "dept": "ATH",
    "num": "101O",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Track and Field (men)",
    "dept": "ATH",
    "num": "101P",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Track and Field (women)",
    "dept": "ATH",
    "num": "101Q",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Volleyball (women)",
    "dept": "ATH",
    "num": "101R",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Wrestling (men)",
    "dept": "ATH",
    "num": "101S",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Golf (women)",
    "dept": "ATH",
    "num": "101T",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Intercollegiate Athletics: Soccer (women)",
    "dept": "ATH",
    "num": "101U",
    "desc": "Prereq: Permission of head coach\nLimited to 1 credit per year to a maximum of 4.\n  Offered on a satisfactory-fail basis only.  Credit for a sport section of Ath 101 may not be applied toward graduation if credit is also received for KIN 166 or any skill technique course in the same sport.",
    "credits": "1"
  },
  {
    "course_name": "Orientation to Athletic Training Clinical Experience",
    "dept": "A TR",
    "num": "218",
    "desc": "\nPre-athletic training clinical experience designed to orientate students to the athletic training profession prior to enrolling in athletic training course sequence.  Students will observe athletic trainers in various athletic training clinical sites.  Open to pre-athletic training students only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Clinical Practicum in Athletic Training",
    "dept": "A TR",
    "num": "219",
    "desc": "\nAthletic training clinical experiences designed to review human anatomical structures including origin, insertion, action, innervations of muscles.  Students will gain experience with palpation of these structures to help identify location of anatomical landmarks.  Students will also gain experience identifying bones, ligaments, and tendons.  Open to athletic training students only.\n",
    "credits": "1"
  },
  {
    "course_name": "Basic Athletic Training",
    "dept": "A TR",
    "num": "220",
    "desc": "Prereq: BIOL 155 or BIOL 255 and BIOL 256\nIntroduction to methods of prevention and immediate care of athletic injuries. Basic information concerning health supervision of athletes, and some basic wrapping and strapping techniques for common injuries. Non A TR majors only.\n",
    "credits": "2"
  },
  {
    "course_name": "Pre-Athletic Training Clinical Practicum",
    "dept": "A TR",
    "num": "221",
    "desc": "Prereq: Credit or enrollment in A TR 222\nAthletic training clinical observation experiences to accompany A TR 222. Utilize knowledge to evaluate, analyze and demonstrate appropriate taping, wrapping and basic skill techniques. Open to students interested in the athletic training option.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Basic Athletic Training for Athletic Trainers",
    "dept": "A TR",
    "num": "222",
    "desc": "Prereq: BIOL 255, BIOL 255L\nProvides pre-athletic training students with the knowledge of the profession of a certified athletic trainer, factors associated with injury prevention, treatment, emergency care of athletic injuries, protective equipment, basic organization, administrative, and legal concepts in the athletic training setting. To be taken concurrently with A TR 221.\n",
    "credits": "3"
  },
  {
    "course_name": "Clinical Practicum in Athletic Training",
    "dept": "A TR",
    "num": "223",
    "desc": "Prereq: Permission of Athletic Training Program Director\nAthletic training clinical experiences for athletic training students during pre-season intercollegiate football. Clinical experiences include:  Professional Rescuer CPR, AED certification, emergency splinting and spineboarding, medical record keeping and HIPPA regulations, environmental conditions, prevention of injury screening strategies, athletic training room and education program policies and procedures, review of athletic taping techniques, acute injury management, mouthpiece formation, and anatomy review.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Evaluation of Athletic Injuries I",
    "dept": "A TR",
    "num": "224",
    "desc": "Prereq: Permission of athletic training program director\nSport injury assessment procedures and evaluation techniques for lower body injuries. Includes an overview of mechanisms of injury, general musculoskeletal disorders, and spine or neurological dysfunction. Designed for students in the athletic training major.\n",
    "credits": "3"
  },
  {
    "course_name": "Athletic Injuries I Clinical Practicum",
    "dept": "A TR",
    "num": "225",
    "desc": "Prereq: Permission of athletic training program director\nAthletic training clinical experience to accompany A TR 224. Open to students in the athletic training major.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Evaluation of Athletic Injuries II",
    "dept": "A TR",
    "num": "226",
    "desc": "Prereq: Permission of athletic training program director\nSport injury assessment procedures and evaluation techniques for lower body injuries. Includes an overview of common illnesses of athletes and sport specific injuries. Designed for students in the athletic training major.\n",
    "credits": "3"
  },
  {
    "course_name": "Athletic Injuries II Clinical Practicum",
    "dept": "A TR",
    "num": "227",
    "desc": "Prereq: Permission of athletic training program director\nAthletic training clinical experience to accompany A TR 226. Open to students in the athletic training major.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Taping, Equipment, and Bracing Techniques",
    "dept": "A TR",
    "num": "240",
    "desc": "Prereq: Permission of athletic training program director\nBasic information and laboratory instruction regarding basic taping techniques, athletic equipment fitting procedures, and the use and proper fitting of prophylactic braces. Open to students in the athletic training major.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Therapeutic Modalities for Athletic Trainers",
    "dept": "A TR",
    "num": "323",
    "desc": "Prereq: Permission of athletic training program director\nTheory and technique of therapeutic modalities used in the management of injuries.\n",
    "credits": "3"
  },
  {
    "course_name": "Therapeutic Modalities Clinical Practicum",
    "dept": "A TR",
    "num": "324",
    "desc": "Prereq: Permission of athletic training program director\nAthletic training clinical experience to accompany A TR 323. Open to students in athletic training major.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Rehabilitation of Athletic Injuries",
    "dept": "A TR",
    "num": "326",
    "desc": "Prereq: Permission of athletic training program director\nTheory and practical application of rehabilitation principles used in the management of athletic injuries.\n",
    "credits": "3"
  },
  {
    "course_name": "Rehabilitation of Athletic Injuries Clinical Practicum",
    "dept": "A TR",
    "num": "327",
    "desc": "Prereq: Permission of athletic training program director\nAthletic training clinical experience to accompany A TR 326. Open to students in the athletic training major.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Organization and Administration of Athletic Training",
    "dept": "A TR",
    "num": "425",
    "desc": "Prereq: Permission of athletic training program director, senior classification\nCurrent administrative, professional, and legal issues pertaining to athletic training. Job search techniques and strategies including preparation of materials for athletic training students.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Concerns for the Athletic Trainer",
    "dept": "A TR",
    "num": "450",
    "desc": "Prereq: Permission of athletic training program director\nCurrent medical issues and concerns, including pathology of illness and injury, dermatological conditions, exposure to allied health care professionals, and pharmacological indications in relation to the profession of athletic training and in patient/athlete care.\n",
    "credits": "3"
  },
  {
    "course_name": "Evidence Based Practice in Athletic Training",
    "dept": "A TR",
    "num": "488",
    "desc": "Prereq: Permission of athletic training program director\nClinical experiences in application of athletic training techniques under the supervision of certified athletic trainers. Introduction and utilization of evidence-based practice methodology via online instruction and integration of evidence-based practice into the clinical experience.\n",
    "credits": "2"
  },
  {
    "course_name": "Review of Athletic Training Competencies and Clinical Proficiencies",
    "dept": "A TR",
    "num": "489",
    "desc": "Prereq: Senior classification, permission of athletic training program director\nPreparation for professional endorsement and certification by review of required competencies and clinical proficiencies. Required for endorsement or approval to sit for Board of Certification Exam.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Biochemistry",
    "dept": "BBMB",
    "num": "101",
    "desc": "\nResearch activities, career opportunities in biochemistry and biophysics, and an introduction to the structure of biologically important compounds. For students majoring in biochemistry, agricultural biochemistry or biophysics or considering one of these majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Biochemistry Laboratory",
    "dept": "BBMB",
    "num": "102",
    "desc": "Prereq: Credit or enrollment in CHEM 177 and CHEM 177L or CHEM 201 and CHEM 201L\nTopics in the scientific background of biochemistry, such as macromolecules, metabolism, and catalysis. Laboratory experimentation covers biochemical concepts and the study of bio-molecules including proteins, lipids and nucleic acids. A significant component is practice in scientific communication. For students majoring in biochemistry, agricultural biochemistry or biophysics or considering one of these majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Biochemistry Learning Community Orientation",
    "dept": "BBMB",
    "num": "110",
    "desc": "Prereq: Co-enrollment with BBMB 101 highly recommended.\nOverview of the program of study, academic planning, resources on campus for the successful transition to Iowa State, team‐building, leadership, and community‐focused activities.  For members of the Biochemistry & Biophysics Learning Community.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Biochemistry Learning Community",
    "dept": "BBMB",
    "num": "111",
    "desc": "Prereq: Enrollment in BBMB102 is highly recommended.\nOverview of career-building and research resources within BBMB and across ISU, including internships, lab skills, independent research, and leadership opportunities. For members of the Biochemistry & Biophysics Learning Community.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "The Biochemistry of Beer",
    "dept": "BBMB",
    "num": "120",
    "desc": "\nAn introduction to the major classes of biomolecules, basic biochemical concepts, enzymology, metabolism and genetic engineering as they apply to the production and flavor of beer. All aspects of the biochemistry of beer will be covered, including the malting of barley, starch conversion, yeast fermentation and the chemical changes that occur during the aging of beer. Intended for non-majors.\n  Natural science majors are limited to elective credit only.",
    "credits": "2"
  },
  {
    "course_name": "Medicines, Drugs and You",
    "dept": "BBMB",
    "num": "121",
    "desc": "Prereq: One year of high school chemistry or CHEM 50 and biology.\nAn introduction to how medicines treat disease, what drug molecules look like, how they function, how they can be toxic, modern therapeutics ranging from over-the-counter pain relievers, antibiotics and anti-depressants, to anti-cancer chemotherapies, a discussion of illegal drugs from toxicity to mechanism of action and potential therapeutic benefits. Intended for students of all majors.\n",
    "credits": "2"
  },
  {
    "course_name": "Chemical Principles in Biological Systems",
    "dept": "BBMB",
    "num": "201",
    "desc": "Prereq: Credit or enrollment in CHEM 332\nSurvey of chemical principles as they apply in biological systems including: water, organic chemistry of functional groups in biomolecules and biochemical cofactors, weak bonds and their contribution to biomolecular structure, oxidation-reduction reactions and redox potential, thermodynamic laws and bioenergetics, chemical equilibria and kinetics, inorganic chemistry in biological systems, data presentation.  The subjects will be taught using molecules from biological systems as examples.  Intended for majors in biochemistry, biophysics or agricultural biochemistry.\n",
    "credits": "2"
  },
  {
    "course_name": "Structure and Reactions in Biochemical Processes",
    "dept": "BBMB",
    "num": "221",
    "desc": "Prereq: CHEM 163, CHEM 167, or CHEM 177\nFundamentals necessary for an understanding of biochemical processes. Primarily for students in agriculture.\n  Not acceptable for credit toward a major in biochemistry, biophysics, or agricultural biochemistry. Credit for both BBMB 221 and Chem 231 may not be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Survey of Biochemistry",
    "dept": "BBMB",
    "num": "301",
    "desc": "Prereq: CHEM 231 or CHEM 331\nA survey of biochemistry: structure and function of amino acids, proteins, carbohydrates, lipids, and nucleic acids; enzymology; metabolism; biosynthesis; and selected topics. Course offered online.\n  Not acceptable for credit toward a major in biochemistry, biophysics, or agricultural biochemistry.",
    "credits": "3"
  },
  {
    "course_name": "Principles of Biochemistry",
    "dept": "BBMB",
    "num": "316",
    "desc": "Prereq: CHEM 231 or CHEM 331; BIOL 212; BIOL 313 and BIOL 314 strongly recommended.\nUnderstanding biological systems at the molecular level; chemistry of biological macromolecules, enzyme function and regulation, metabolic pathways; integration of metabolism in diverse living systems. For students in biology and related majors who do not require the more rigorous treatment of biochemistry found in BBMB 404/405. Course offered online.\n  Not acceptable for credit toward a major in biochemistry, biophysics, or agricultural biochemistry.",
    "credits": "3"
  },
  {
    "course_name": "Biochemistry I",
    "dept": "BBMB",
    "num": "404",
    "desc": "Prereq: CHEM 332\nA general overview for graduate and advanced undergraduate students in agricultural, biological, chemical and nutritional sciences. Chemistry of amino acids, proteins, carbohydrates, and lipids, vitamins; protein structure; enzymology; carbohydrate metabolism.     Course offered online.\n  Credit for both BBMB 420 and the BBMB 404 - 405 sequence may not be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Biochemistry II",
    "dept": "BBMB",
    "num": "405",
    "desc": "Prereq: BBMB 404\nA general overview for graduate and advanced undergraduate students in agricultural, biological, chemical, and nutritional sciences. Metabolism of carbohydrates, amino acids, nucleotides and lipids; formation, turnover, and molecular relationships among DNA, RNA, and proteins; genetic code; regulation of gene expression; selected topics in the molecular physiology of plants and animals. Course available online.\n  Credit for both BBMB 420 and the BBMB 404 - BBMB 405 sequence may not be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Techniques in Biochemical Research",
    "dept": "BBMB",
    "num": "411",
    "desc": "Prereq: Credit or enrollment in BBMB 404 or BBMB 504 and BBMB 505; CHEM 211\nLaboratory experimentation and techniques for studying biochemistry, including: chromatographic methods; electrophoresis; spectrophotometry; enzyme purification; enzyme kinetics; and characterization of carbohydrates, proteins, lipids, and nucleic acids. Scientific communication and technical writing are emphasized.\n",
    "credits": "4"
  },
  {
    "course_name": "Mammalian Biochemistry",
    "dept": "BBMB",
    "num": "420",
    "desc": "Prereq: CHEM 332, BIOL 314\nStructure and function of proteins; enzymology; biological oxidation; chemistry and metabolism of carbohydrates, lipids, amino acids and nucleic acids; protein synthesis and the genetic code; relationship of biochemistry to selected animal diseases. Biochemistry of higher animals emphasized.\n  Not acceptable for credit toward a major in agricultural biochemistry or biochemistry. Acceptable for credit toward a major in biophysics. Credit for both BBMB 420 and the BBMB 404 - 405 sequence may not be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Procaryotic Diversity and Ecology",
    "dept": "BBMB",
    "num": "430",
    "desc": "Prereq: MICRO 302, MICRO 302L\nSurvey of the diverse groups of procaryotes emphasizing important and distinguishing metabolic, phylogenetic, morphological, and ecological features of members of those groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Microbial Physiology, Diversity, and Genetics",
    "dept": "BBMB",
    "num": "440",
    "desc": "Prereq: MICRO 302, MICRO 302L, CHEM 332, BIOL 313L\nFundamental techniques and theory for studying the cellular mechanisms, genetic processes and diversity of microbial life. Experimental   techniques will include isolation and physiological characterization of bacteria that inhabit different environments as well as an emphasis on genetic and molecular techniques to understand antibiotic resistance processes and mechanisms. Also included are   techniques for phylogenetic characterization, measuring gene expression, and genetic manipulation of bacteria. Essential components for the effective communication of scientific results are also emphasized.\n",
    "credits": "4"
  },
  {
    "course_name": "Molecular Biophysics",
    "dept": "BBMB",
    "num": "461",
    "desc": "Prereq: Credit or enrollment in MATH 166 and CHEM 178 and PHYS 222 or PHYS 112.\nPhysical methods for the study of molecular structure and organization of biological materials.  X-ray diffraction, nuclear magnetic resonance, hydrodynamics and fluorescence spectroscopy.  Registration for the graduate credit commits the student to graduate-level examinations, which differ from undergraduate-level examinations in the number and/or difficulty of questions.\n",
    "credits": "2"
  },
  {
    "course_name": "Independent Study",
    "dept": "BBMB",
    "num": "490",
    "desc": "Prereq: College of Agriculture: junior or senior classification and permission of instructor; College of Liberal Arts and Sciences: permission of instructor.\nIndependent study with a faculty mentor.\n  No more than 9 credits of BBMB 490 may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "BBMB",
    "num": "490H",
    "desc": "Prereq: College of Agriculture: junior or senior classification and permission of instructor; College of Liberal Arts and Sciences: permission of instructor\nIndependent study with a faculty mentor.\n  No more than 9 credits of BBMB 490 may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "BBMB",
    "num": "499",
    "desc": "Prereq: Permission of faculty member with whom student proposes to work.\nIndependent research under faculty guidance.\n",
    "credits": "1"
  },
  {
    "course_name": "Amino Acids and Proteins",
    "dept": "BBMB",
    "num": "504",
    "desc": "Prereq: CHEM 332 or equivalent\nReview of amino acids and proteins, including atomic interactions, thermodynamics, structure and properties of amino acids, post-translational modifications, protein expression, purification and analysis, protein secondary, tertiary and quaternary structure, protein folding, oxygen transport and hemoglobin, models for equilibrium binding, elementary reactions and enzyme kinetics, biosynthesis of amino acids: pathways and mechanisms.\n",
    "credits": "2"
  },
  {
    "course_name": "Bioenergetics and Metabolism",
    "dept": "BBMB",
    "num": "505",
    "desc": "Prereq: CHEM 211, CHEM 332; a previous course in biochemistry is strongly recommended\nExamination of catabolic pathways involved in the oxidation of organic and inorganic molecules, and energy metabolism involving inputs from light or other non-light sources. Central metabolism and glycolysis, fermentation, aerobic and anaerobic respiration, photosynthesis.\n",
    "credits": "2"
  },
  {
    "course_name": "Membrane Biochemistry",
    "dept": "BBMB",
    "num": "506",
    "desc": "Prereq: CHEM 332 or equivalent\nAnalysis of the structure, function, and synthesis of membranes. Bacterial and eukaryotic membrane characteristics. Membrane transport and signaling mechanisms. Analysis of the structure and function of lipids and membrane proteins.\n",
    "credits": "2"
  },
  {
    "course_name": "Biochemistry of Nucleic Acids",
    "dept": "BBMB",
    "num": "507",
    "desc": "Prereq: CHEM 332 or equivalent\nAnalysis of the chemical structure, function, synthesis, and metabolism of nucleic acids. Chemical characterization of nucleotides, polynucleotides, DNA, and RNA. Analysis of transcription, translation, and the genetic code.\n",
    "credits": "2"
  },
  {
    "course_name": "Molecular Biology and Biochemistry of RNA",
    "dept": "BBMB",
    "num": "510",
    "desc": "Prereq: BIOL 313, BBMB 405, BBMB 502, BBMB 506 and 507 or GEN 409, or equivalent\nBiochemical processes that define structure and function of nucleic acids. Emphasis on the molecular processes that take place during synthesis, processing, and function of different RNA species; review of recent advances in RNA research.\n",
    "credits": "2"
  },
  {
    "course_name": "Procaryotic Diversity and Ecology",
    "dept": "BBMB",
    "num": "530",
    "desc": "Prereq: MICRO 302, MICRO 302L\nSurvey of the diverse groups of procaryotes emphasizing important and distinguishing metabolic, phylogenetic, morphological, and ecological features of members of those groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Enzyme Kinetics and Mechanisms",
    "dept": "BBMB",
    "num": "532",
    "desc": "Prereq: BBMB 504\nAdvanced concepts of enzyme kinetics and catalysis.  Experimental methods for determining kinetic and chemical reaction mechanisms. Enzyme structure/function relationships and the role of dynamics in catalysis.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "BBMB",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "BBMB",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "BBMB",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "BBMB",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "BBMB",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "BBMB",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "BBMB",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Molecular Biophysics",
    "dept": "BBMB",
    "num": "561",
    "desc": "Prereq: Credit or enrollment in MATH 166 and CHEM 178 and PHYS 222 or PHYS 112.\nPhysical methods for the study of molecular structure and organization of biological materials.  X-ray diffraction, nuclear magnetic resonance, hydrodynamics and fluorescence spectroscopy.  Registration for the graduate credit commits the student to graduate-level examinations, which differ from undergraduate-level examinations in the number and/or difficulty of questions.\n",
    "credits": "2"
  },
  {
    "course_name": "Laboratory in Molecular Biophysics",
    "dept": "BBMB",
    "num": "561L",
    "desc": "Prereq: Credit or enrollment in BBMB 461/BBMB 561\nPractice in methods of X-ray diffraction, nuclear magnetic resonance, hydrodynamics and fluorescence spectroscopy as applied to macromolecules.\n",
    "credits": "2"
  },
  {
    "course_name": "Bioinformatics III (Structural Bioinformatics)",
    "dept": "BBMB",
    "num": "569",
    "desc": "Prereq: BCB 567, BBMB 316, GEN 409, STAT 430\nMolecular structures including genes and gene products: protein, DNA and RNA structure. Structure determination methods, structural refinement, structure representation, comparison of structures, visualization, and modeling. Molecular and cellular structure from imaging. Analysis and prediction of protein secondary, tertiary, and higher order  structure, disorder, protein-protein and protein-nucleic acid interactions, protein localization and function, bridging between molecular and cellular structures. Molecular evolution.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "BBMB",
    "num": "590",
    "desc": "\nBy arrangement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Biochemistry and Biophysics",
    "dept": "BBMB",
    "num": "593",
    "desc": "Prereq: Permission and signature of course administrator required.\nWorkshops in selected topics in biochemistry and biophysics. Credit in this course does not meet the requirement for advanced graduate electives in Biochemistry.  Spring only: BBMB Undergraduate Research Symposium  participation. Scheduled class meetings are required in addition to attending the symposium.\n",
    "credits": "1"
  },
  {
    "course_name": "Molecular Immunology",
    "dept": "BBMB",
    "num": "615",
    "desc": "Prereq: BBMB 405 or BBMB 506 and BBMB 507\nCurrent topics in molecular aspects of immunology: T and B cell receptors; major histocompatibility complex; antibody structure; immunosuppressive drugs and viruses; and intracellular signaling pathways leading to expression of genes that control and activate immune function.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Signaling",
    "dept": "BBMB",
    "num": "645",
    "desc": "Prereq: BBMB 405 or BBMB 420; or BBMB 506 and BBMB 507\nMolecular mechanisms of cellular signaling including receptor activation, desensitization and cross talk, signal transduction pathways, and nuclear receptors. Discussion includes a variety of cell surface receptors and their hormone; growth factor and extracellular matrix activators; protein kinases; caspase and transcription factor downstream signals; lipids, gases and cyclic nucleotides as regulators of cell signaling. Course content includes current literature, student and instructor presentations and research proposal writing.\n",
    "credits": "2"
  },
  {
    "course_name": "Current Topics in Neuroscience",
    "dept": "BBMB",
    "num": "661",
    "desc": "Prereq: NEURO 556 (or comparable course) or permission of instructor\nTopics may include molecular and cellular neuroscience, neurodevelopment, neuroplasticity, neurodegenerative diseases, cognitive neuroscience, sensory biology, neural integration, membrane biophysics, neuroethology, techniques in neurobiology and behavior.\n",
    "credits": "2"
  },
  {
    "course_name": "Nucleic Acid Structure and Function",
    "dept": "BBMB",
    "num": "675",
    "desc": "Prereq: BBMB 405 or BBMB 506 and BBMB 507\nIn-depth discussion of nucleic acid properties, structures and structure/function relationships. Interactions between nucleic acids and proteins will be emphasized.\n",
    "credits": "2"
  },
  {
    "course_name": "Biochemistry of Gene Expression in Eucaryotes",
    "dept": "BBMB",
    "num": "676",
    "desc": "Prereq: BBMB 404 and BBMB 504; and BBMB 506 and BBMB 507; or BBMB 405 or BBMB 505 and  or GDCB 511\nAnalysis of the biochemical processes involved in expression of eucaryotic genes and the regulation thereof, including RNA polymerase, transcriptional regulatory proteins, enhancers and silencers, chromosome structure, termination, RNA processing, RNA transport, RNA turnover, small RNAs, translational regulation, protein turnover.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Seminar",
    "dept": "BBMB",
    "num": "681",
    "desc": "Prereq: Permission of instructor\nStudent presentations.\n",
    "credits": "1"
  },
  {
    "course_name": "Departmental Seminar",
    "dept": "BBMB",
    "num": "682",
    "desc": "Prereq: Permission of instructor\nFaculty, staff and invited guest research seminar.\n",
    "credits": "R"
  },
  {
    "course_name": "Research Seminar",
    "dept": "BBMB",
    "num": "696",
    "desc": "\nResearch seminars by faculty and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Molecular, Cellular, and Developmental Biology",
    "dept": "BBMB",
    "num": "698",
    "desc": "\nStudent and faculty presentations.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "BBMB",
    "num": "699",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Bioinformatic Analysis",
    "dept": "BCB",
    "num": "444",
    "desc": "Prereq: MATH 165 and Introductory Statistics (STAT 101, STAT 104, STAT 105, STAT 201, or STAT 330).\nBroad overview of bioinformatics with a significant problem-solving component, including hands-on practice using computational tools to solve a variety of biological problems. Topics include: bioinformatic data processing, Python programming, genome assembly, database search, sequence alignment, gene prediction, next-generation sequencing, comparative and functional genomics, and systems biology.\n",
    "credits": "4"
  },
  {
    "course_name": "Independent Study",
    "dept": "BCB",
    "num": "490",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Bioinformatics",
    "dept": "BCB",
    "num": "544",
    "desc": "Prereq: MATH 165 or STAT 401 or equivalent\nA practical, hands-on overview of how to apply bioinformatics to biological research. Recommended for biologists desiring to gain computational molecular biology skills. Topics include: sequence analysis, genomics, proteomics, phylogenetic analyses, ontology enrichment, systems biology, data visualization and emergent technologies.\n",
    "credits": "4"
  },
  {
    "course_name": "Bioinformatics I (Bioinformatics Algorithms)",
    "dept": "BCB",
    "num": "567",
    "desc": "Prereq: COM S 228; COM S 330; credit or enrollment in BIOL 315, STAT 430\nBiology as an information science. A review of the algorithmic principles that are driving the advances in bioinformatics and computational biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics II (Statistical Bioinformatics)",
    "dept": "BCB",
    "num": "568",
    "desc": "Prereq: BCB 567 or (BIOL 315 and STAT 430), credit or enrollment in GEN 409\nStatistical models for sequence data, including applications in genome annotation, motif discovery, variant discovery, molecular phylogeny, gene expression analysis, and metagenomics.  Statistical topics include model building, inference, hypothesis testing, and simple experimental design, including for big data/complex models.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics III (Structural Bioinformatics)",
    "dept": "BCB",
    "num": "569",
    "desc": "Prereq: BCB 567, BBMB 316, GEN 409, STAT 430\nMolecular structures including genes and gene products: protein, DNA and RNA structure. Structure determination methods, structural refinement, structure representation, comparison of structures, visualization, and modeling. Molecular and cellular structure from imaging. Analysis and prediction of protein secondary, tertiary, and higher order  structure, disorder, protein-protein and protein-nucleic acid interactions, protein localization and function, bridging between molecular and cellular structures. Molecular evolution.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics IV (Systems Biology)",
    "dept": "BCB",
    "num": "570",
    "desc": "Prereq: BCB 567 or COM S 311, COM S 228, GEN 409, STAT 430\nAlgorithmic and statistical approaches in computational functional genomics and systems biology. Analysis of high throughput biological data obtained using system-wide measurements. Topological analysis, module discovery, and comparative analysis of gene and protein networks. Modeling, analysis, and inference of transcriptional regulatory networks, protein-protein interaction networks, and metabolic networks. Dynamic systems and whole-cell models. Ontology-driven, network based, and probabilistic approaches to information integration.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Predictive Plant Phenomics",
    "dept": "BCB",
    "num": "585",
    "desc": "Prereq: Acceptance into the P3 program or instructor permission.\nPrinciples of engineering, data analysis, and plant sciences and their interplay applied to predictive plant phenomics.  Transport phenomena, sensor design, image analysis, graph models, network data analysis, fundamentals of genomics and phenomics.  Multidisciplinary laboratory exercises.\n  None",
    "credits": "4"
  },
  {
    "course_name": "Special Topics",
    "dept": "BCB",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Bioinformatics and Computational Biology",
    "dept": "BCB",
    "num": "593",
    "desc": "\nCurrent topics in bioinformatics and computational biology research. Lectures by off-campus experts. Students read background literature, attend preparatory seminars, attend all lectures, meet with lecturers.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "BCB",
    "num": "598",
    "desc": "Prereq: Permission of the program chair\nOff-campus work periods for graduate students in the field of bioinformatics and computational biology.\n",
    "credits": "R"
  },
  {
    "course_name": "Creative Component",
    "dept": "BCB",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Selected Topics in Bioinformatics and Computational Biology",
    "dept": "BCB",
    "num": "660",
    "desc": "Prereq: Permission of Instructor\nTopics of interest in the major research areas of computational molecular biology, including genomics, structural genomics, functional genomics, and computational systems biology.\n",
    "credits": "1"
  },
  {
    "course_name": "Student Seminar in Bioinformatics and Computational Biology",
    "dept": "BCB",
    "num": "690",
    "desc": "\nStudent research presentations.\n",
    "credits": "1"
  },
  {
    "course_name": "Faculty Seminar in Bioinformatics and Computational Biology",
    "dept": "BCB",
    "num": "691",
    "desc": "\nFaculty research series.\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Research Rotation",
    "dept": "BCB",
    "num": "697",
    "desc": "\nGraduate research projects performed under the supervision of selected faculty members in the Bioinformatics and Computational Biology major.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "BCB",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "BCBIO Orientation",
    "dept": "BCBIO",
    "num": "110",
    "desc": "\nFirst 8 weeks. Orientation to the area of bioinformatics and computational biology. For students considering a major in BCBIO.   Specializations and career opportunities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Introduction to Bioinformatics and Computational Biology",
    "dept": "BCBIO",
    "num": "322",
    "desc": "Prereq: BIOL 212\nGenome sequencing, assembly, structural and functional annotation, and comparative genomics. Investigating these topics will develop skills in programming and scripting (Perl and/or Python), the use of biological databases, sequence alignment, similarity search, identification of sequence patterns, construction of phylogenetic trees, and comparative genomics.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Bioinformatics and Computational Biology",
    "dept": "BCBIO",
    "num": "401",
    "desc": "Prereq: BCBIO 322 and basic programming experience (e.g. COM S 207, COM S 227 or permission of instructor)\nApplication of computer science and engineering to molecular biology.  String algorithms, sequence alignments, data structures, homology search methods, pattern recognition, fragment assembly, genome annotation, construction of bioinformatics databases, and   gathering and distribution of biological information with the Internet.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Systems Biology and Network Science",
    "dept": "BCBIO",
    "num": "402",
    "desc": "Prereq: BIOL 212\nTechnologies: transcriptome, proteome, metabolome; Networks: Gene regulatory network, Protein-protein interaction network, Literature network; Theories: Graph theory, random network, scale-free network, evolving network, network robustness; Tools: Jmol, MeV, Cytoscape, Citespace.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics and Computational Biology Techniques",
    "dept": "BCBIO",
    "num": "442",
    "desc": "Prereq: BIOL 314 recommended\nModular minicourses consisting of guided tutorials and hands-on computer software exercises focused on fundamental problems, approaches, and software applications in bioinformatics and computational biology.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Bioinformatics and Computational Biology Techniques: Sequence Database Searching",
    "dept": "BCBIO",
    "num": "442A",
    "desc": "Prereq: BIOL 314 recommended\nModular minicourses consisting of guided tutorials and hands-on computer software exercises focused on fundamental problems, approaches, and software applications in bioinformatics and computational biology.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Bioinformatics and Computational Biology: Protein Structure Databases, Visualization, and Prediction",
    "dept": "BCBIO",
    "num": "442B",
    "desc": "Prereq: BIOL 314 recommended\nModular minicourses consisting of guided tutorials and hands-on computer software exercises focused on fundamental problems, approaches, and software applications in bioinformatics and computational biology.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Bioinformatics and Computational Biology Techniques: Phylogenetic Analysis",
    "dept": "BCBIO",
    "num": "442C",
    "desc": "Prereq: BIOL 314 recommended\nModular minicourses consisting of guided tutorials and hands-on computer software exercises focused on fundamental problems, approaches, and software applications in bioinformatics and computational biology.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Bioinformatics and Computational Biology Techniques: Microarray Analysis",
    "dept": "BCBIO",
    "num": "442D",
    "desc": "Prereq: BIOL 314 recommended\nModular minicourses consisting of guided tutorials and hands-on computer software exercises focused on fundamental problems, approaches, and software applications in bioinformatics and computational biology.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Bioinformatic Analysis",
    "dept": "BCBIO",
    "num": "444",
    "desc": "Prereq: MATH 165 and Introductory Statistics (STAT 101, STAT 104, STAT 105, STAT 201, or STAT 330).\nBroad overview of bioinformatics with a significant problem-solving component, including hands-on practice using computational tools to solve a variety of biological problems. Topics include: bioinformatic data processing, Python programming, genome assembly, database search, sequence alignment, gene prediction, next-generation sequencing, comparative and functional genomics, and systems biology.\n",
    "credits": "4"
  },
  {
    "course_name": "Independent Study",
    "dept": "BCBIO",
    "num": "490",
    "desc": "Prereq: BCBIO 322, junior or senior classification, permission of instructor\nIndependent research projects for undergraduate students in bioinformatics and computational biology.\n  Students in the College of Liberal Arts and Sciences may use no more than 9 credits of BCBIO 490 and 491 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Team Research Projects.",
    "dept": "BCBIO",
    "num": "491",
    "desc": "Prereq: BCBIO 322, junior or senior classification, permission of instructor\nResearch projects in bioinformatics and computational biology done by teams of students.\n  Students in the College of Liberal Arts and Sciences may use no more than 9 credits of BCBIO 490 and 491 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Scientific Illustration Principles and Techniques",
    "dept": "BPM I",
    "num": "323",
    "desc": "Prereq: DSN S 131, ARTIS 230, or equivalent, and 3 credits in biological sciences; or permission of the instructor\nStudio basics and professional techniques in black & white, continuous tone, and color. Introduction to professional practice and principles of communicating science through art. Emphasis on tools, materials, and rendering.\n",
    "credits": "3"
  },
  {
    "course_name": "Illustration and Illustration Software",
    "dept": "BPM I",
    "num": "326",
    "desc": "Prereq: ARTIS 323/BPM I 323, or permission of the instructor\nAn introduction to digital illustration software. Application of painting, drawing and image making techniques using vector and raster based programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Illustration as Communication",
    "dept": "BPM I",
    "num": "327",
    "desc": "Prereq: ARTIS 326/BPM I 326, or permission of the instructor\nInvestigation of illustration as a form of communication. Emphasis on problem solving, effective composition, and advancement of rendering skills.\n",
    "credits": "3"
  },
  {
    "course_name": "Application of Scientific Illustration Techniques",
    "dept": "BPM I",
    "num": "337",
    "desc": "Prereq: ARTIS 327\nRendering techniques applied to different types of biological and scientific subjects emphasizing communication.  The use of traditional and digital media.  Term project required.\n",
    "credits": "3"
  },
  {
    "course_name": "Field Illustration",
    "dept": "BPM I",
    "num": "395",
    "desc": "Prereq: Permission of instructor\nA combination seminar and field trip course emphasizing nature interpretation, field sketching techniques and preparation of a final illustration based on field experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "BPM I",
    "num": "398",
    "desc": "Prereq: Permission of the program cooperative education coordinator, junior classification\nRequired of all cooperative education students. Students must register for these courses prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Illustrating Nature I Sketching",
    "dept": "BPM I",
    "num": "435I",
    "desc": "\nSketching plants, animals and terrain. Visual communication, development of a personal style, and integration of typographic and visual elements on a page will be emphasized.\n",
    "credits": "2"
  },
  {
    "course_name": "Illustrating Nature II Photography",
    "dept": "BPM I",
    "num": "436I",
    "desc": "\nBeginning to intermediate technical and compositional aspects of color photography of natural areas and their plants and animals.\n",
    "credits": "2"
  },
  {
    "course_name": "Independent Study",
    "dept": "BPM I",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and advisory committee chair on required form in advance of semester of enrollment\n",
    "credits": "1"
  },
  {
    "course_name": "Portfolio Design and Professional Development",
    "dept": "BPM I",
    "num": "491",
    "desc": "Prereq: BPMI 337, junior or senior classification in the BPMI curriculum.\nPortfolio and professional preparation including identity package development, writing  and speaking. Career-readiness, professional practice, leadership, networking, exploring research subfields within scientific visualization. Creating print and digital visual materials, learning approaches for entering the field, and developing business practice skills. Final portfolio materials presented at the end of the term.\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Illustration",
    "dept": "BPM I",
    "num": "494",
    "desc": "\nIntensive exploration of illustration techniques in a studio or field setting.\n",
    "credits": "1"
  },
  {
    "course_name": "Illustration Internship",
    "dept": "BPM I",
    "num": "497",
    "desc": "Prereq: Junior or senior classification in BPM I, written approval of supervising instructor and advisory committee chair on required form in advance of semester of enrollment\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introductory Biology",
    "dept": "BIOL",
    "num": "101",
    "desc": "\nLife considered at cellular, organism, and population levels. Function and diversity of the living world. Presentation of basic biological principles as well as topics and issues of current human interest.  Does not satisfy biology major requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Biology",
    "dept": "BIOL",
    "num": "110",
    "desc": "\nOrientation to the scope of the biological sciences, and discussion of professional opportunities. Required of first year biology majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Opportunities in Biology",
    "dept": "BIOL",
    "num": "111",
    "desc": "\nIntroduction to biological science disciplines and professional opportunities through faculty presentations which examine a variety of current research topics.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Transfer Student Orientation",
    "dept": "BIOL",
    "num": "112",
    "desc": "\nOrientation to opportunities in Biology. Review of degree requirements and other information. Intended for students transferring from other academic institutions.  Offered on a satisfactory-fail basis only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Human Biology",
    "dept": "BIOL",
    "num": "155",
    "desc": "\nA survey course of human biology, including principal structures and functions of the body systems and the diseases and disorders associated with them. Designed to meet general education requirements in natural science. Not recommended for those seeking a career in the allied health professions or for students majoring in life science. Does not satisfy biology major requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biology",
    "dept": "BIOL",
    "num": "173",
    "desc": "\nAn introduction to the structure and function of natural systems at scales from the individual to the biosphere and the complex interactions between humans and their environment. Discussions of human population growth, biodiversity, sustainability, resource use, and pollution. Does not satisfy biology major requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Environmental Issues",
    "dept": "BIOL",
    "num": "201",
    "desc": "\nDiscussion of current and emerging environmental issues such as human population growth, energy use, loss of biodiversity, water resources, and climate change.\n",
    "credits": "2"
  },
  {
    "course_name": "Biodiversity",
    "dept": "BIOL",
    "num": "204",
    "desc": "Prereq: One course in life sciences\nSurvey of the major groups of organisms and biological systems. Definition, measurements, and patterns of distribution of organisms. Sources of information about biodiversity. Does not satisfy biology major requirements.  Half semester course.\n",
    "credits": "2"
  },
  {
    "course_name": "Principles of Biology I",
    "dept": "BIOL",
    "num": "211",
    "desc": "Prereq: High school biology\nIntroduction to the nature of life, including the diversity of microbial, plant, and animal life; the nature of heredity; evolution; and principles of ecology. Intended for life science majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Biology Laboratory I",
    "dept": "BIOL",
    "num": "211L",
    "desc": "Prereq: Credit or enrollment in BIOL 211\nLaboratory to accompany 211.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles of Biology II",
    "dept": "BIOL",
    "num": "212",
    "desc": "Prereq: High School Biology; high school chemistry or credit or enrollment in CHEM 163 or CHEM 177\nIntroduction to the chemical, molecular, and cellular basis of life; form and function of microbial, plant, and animal life. Intended for life science majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Biology Laboratory II",
    "dept": "BIOL",
    "num": "212L",
    "desc": "Prereq: credit or enrollment in BIOL 212\nLaboratory to accompany 212.\n",
    "credits": "1"
  },
  {
    "course_name": "Biological Processes in the Environment",
    "dept": "BIOL",
    "num": "251",
    "desc": "\nPrinciples of Biology from the level of macromolecules to the biosphere.  Biological processes that affect environmental systems: including metabolism, energy pathways, biochemical reactions in cells, plant and microbial structure and function, element and water cycles.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Human Anatomy",
    "dept": "BIOL",
    "num": "255",
    "desc": "Prereq: High School Biology and Chemistry, or BIOL 101\nAn introduction to human anatomy, beginning with cells and tissues, surveying all body systems, relating form to function. Systems covered include: integumentary, bones and joints, muscles, nervous, sensory, endocrine, circulatory, lymphatic, respiratory, digestive, urinary, and  reproductive.  Pre-Medical students should consider BIOL 351 for their anatomy background.  Does not satisfy biology major requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Human Anatomy Laboratory",
    "dept": "BIOL",
    "num": "255L",
    "desc": "Prereq: Credit or enrollment in BIOL 255\nInvestigation of human anatomy using models and dissections of preserved organs and model mammals. Pre-Medical students should consider 351 for their anatomy background.  Does not satisfy biology major requirements.\n",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Human Physiology",
    "dept": "BIOL",
    "num": "256",
    "desc": "Prereq: High School Biology and Chemistry, or BIOL 101, or BIOL 255 (recommended)\nAn introduction to human physiology, studying the function of all body systems. Systems covered  include: integumentary, bones and joints, muscles, nervous, sensory, endocrine, circulatory, lymphatic and immune, respiratory, digestive, urinary, and reproductive. Pre-Medical students should consider 335 for their physiology background.  Does not satisfy biology major requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Human Physiology Laboratory",
    "dept": "BIOL",
    "num": "256L",
    "desc": "Prereq: Credit or enrollment in BIOL 256\nStudent-conducted experiments investigating concepts of human physiology with computer data acquisition and analysis.  Interpretation of experimental results and preparation of lab reports. Pre-Medical students should consider 335 for their anatomy and physiology background.  Does not satisfy biology major requirements.\n",
    "credits": "1"
  },
  {
    "course_name": "Women in Science and Engineering",
    "dept": "BIOL",
    "num": "307",
    "desc": "Prereq: 200 level course in science, engineering or women's studies; ENGL 250\nThe interrelationships of women and science and engineering examined from historical, sociological, philosophical, and biological perspectives. Factors contributing to under-representation; feminist critiques of science; examination of successful strategies.  Does not satisfy biology major advanced credit requirements.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Ecology",
    "dept": "BIOL",
    "num": "312",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, and BIOL 212L\nFundamental concepts and principles of ecology dealing with organisms, populations, communities, and ecosystems. Laboratory and field exercises examine ecological principles and methods as well as illustrate habitats.\n",
    "credits": "4"
  },
  {
    "course_name": "Principles of Genetics",
    "dept": "BIOL",
    "num": "313",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, and BIOL 212L\nIntroduction to the principles of transmission and molecular genetics of plants, animals, and bacteria. Recombination, structure and replication of DNA, gene expression, cloning, quantitative genetics, and population genetics.\n  Students may receive graduation credit for no more than one of the following: Gen 260, Gen 313 and 313L, Gen 320, Biol 313 and 313L, and Agron 320.",
    "credits": "3"
  },
  {
    "course_name": "Genetics Laboratory",
    "dept": "BIOL",
    "num": "313L",
    "desc": "Prereq: Credit or enrollment in BIOL 313\nLaboratory to accompany 313.\n  Students may receive graduation credit for no more than one of the following: Biol 313 and 313L, Gen 260, Gen 313, Gen 320, and Agron 320.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Molecular Cell Biology",
    "dept": "BIOL",
    "num": "314",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, BIOL 212L\nIntegration of elementary principles of metabolism, bioenergetics, cell structure, and cell function to develop a molecular view of how the cell works.\n",
    "credits": "3"
  },
  {
    "course_name": "Biological Evolution",
    "dept": "BIOL",
    "num": "315",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, BIOL 212L.\nThe mechanisms of evolution. Topics in microevolution: population genetics, natural selection, genetic variation, and adaptation. Macroevolution: speciation, extinction, phylogeny, and major evolutionary patterns.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Bioinformatics and Computational Biology",
    "dept": "BIOL",
    "num": "322",
    "desc": "Prereq: BIOL 212\nGenome sequencing, assembly, structural and functional annotation, and comparative genomics. Investigating these topics will develop skills in programming and scripting (Perl and/or Python), the use of biological databases, sequence alignment, similarity search, identification of sequence patterns, construction of phylogenetic trees, and comparative genomics.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular and Cellular Biology of Human Diseases",
    "dept": "BIOL",
    "num": "328",
    "desc": "Prereq: BIOL 212\nSurvey of molecular, genetic, and cellular aspects of human diseases.  Fundamental concepts of cell biology and how they are linked to the pathologies of different classes of human diseases.  Recent scientific advances with an emphasis on new methods of diagnosis and treatment.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Human and Other Animal Physiology",
    "dept": "BIOL",
    "num": "335",
    "desc": "Prereq: BIOL 211, BIOL 212\nIntroduction to physiology of metabolic function in mammals and other animals. Metabolic processes and their interactions with various subsystems, approached from an organismal perspective. Integration of cellular, gastrointestinal, cardiovascular, respiratory, and renal processes, relevant to their control and integration at the nervous and endocrine system levels. Functional aspects of organismal physiology, energy and water balances, physiology of rest exercise, and environmental stress.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Human and Other Animal Physiology Laboratory",
    "dept": "BIOL",
    "num": "335L",
    "desc": "\nOptional laboratory to accompany Biology 335. Student-conducted experiments investigating concepts of physiology.\n",
    "credits": "1"
  },
  {
    "course_name": "Ecological and Evolutionary Animal Physiology",
    "dept": "BIOL",
    "num": "336",
    "desc": "Prereq: BIOL 211, BIOL 212\nStudy of mechanisms by which animals perform life-sustaining functions; the evolution and adaptive significance of physiology traits, the diversity of physiological mechanisms, and how physiology and ecology interact.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Reproduction",
    "dept": "BIOL",
    "num": "344",
    "desc": "Prereq: BIOL 212\nBiology of human reproduction, including reproductive systems, hormones, and endocrinology of pregnancy, presented from a clinically-oriented perspective. Reviews health-related conditions such as infertility, sexually-transmitted diseases, and complicated pregnancy.\n",
    "credits": "3"
  },
  {
    "course_name": "The Genome Perspective in Biology",
    "dept": "BIOL",
    "num": "349",
    "desc": "Prereq: GEN 313 or GEN 320\nAnalysis of genome, RNA, and protein data using computer technology to answer biological questions on topics ranging from microbial diversity to human health. An introduction for students in the life sciences to the fields of genomics, bioinformatics and systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Comprehensive Human Anatomy",
    "dept": "BIOL",
    "num": "350",
    "desc": "Prereq: Credit in BIOL 211 and BIOL 212\nComprehensive survey of human anatomy, emphasizing structural and functional relationships of major organ systems. Compartmental study of normal anatomy; practical clinical application of anatomical regions.\n",
    "credits": "3"
  },
  {
    "course_name": "Comparative Chordate Anatomy",
    "dept": "BIOL",
    "num": "351",
    "desc": "Prereq: BIOL 212, junior classification\nThe evolution of chordates as reflected in the anatomy of extinct and living forms. Lecture topics include the history and diversity of chordates, comparisons of anatomic structures among major groups, and the adaptive significance of anatomic structures. Laboratory involves dissection of representative species.\n",
    "credits": "5"
  },
  {
    "course_name": "Vertebrate Histology",
    "dept": "BIOL",
    "num": "352",
    "desc": "Prereq: BIOL 212\nMicroscopic structure of vertebrate tissues and organs, with an introduction to histological techniques.\n",
    "credits": "4"
  },
  {
    "course_name": "Introductory Parasitology",
    "dept": "BIOL",
    "num": "353",
    "desc": "Prereq: BIOL 212\nBiology and host-parasite relationships of major groups of animal parasites, and techniques of diagnosing and studying parasites.\n",
    "credits": "3"
  },
  {
    "course_name": "Animal Behavior",
    "dept": "BIOL",
    "num": "354",
    "desc": "Prereq: BIOL 212\nEthological and sociobiological approaches to animal behavior. Genetic and developmental aspects of behavior, biological rhythms, orientation (including navigation, migration), communication, and social behavior (mating, aggression, parental care).\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Animal Behavior",
    "dept": "BIOL",
    "num": "354L",
    "desc": "Prereq: Credit or enrollment in BIOL 354\nLaboratory techniques for observation, description and analysis of animal activities; independent projects.\n",
    "credits": "1"
  },
  {
    "course_name": "Plants and People",
    "dept": "BIOL",
    "num": "355",
    "desc": "Prereq: Credit in BIOL 211 and BIOL 211L\nUses of plants and fungi by humans and the importance of plants in the past, present, and future. Discussion of fruits, vegetables, grains, herbs, spices, beverages, oils, fibers, wood, medicines, and drugs, in the context of their agricultural, cultural, and economic roles in modern societies. Emphasis on origins and worldwide diversity of culturally important plants, their characteristics, and uses.\n",
    "credits": "3"
  },
  {
    "course_name": "Dendrology",
    "dept": "BIOL",
    "num": "356",
    "desc": "Prereq: BIOL 211\nIdentification and ecology of North American woody plant species. Importance of woody plants in timber production and wildlife habitat. Historical conditions of North American forest regions will also be addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Biology of Plants",
    "dept": "BIOL",
    "num": "357",
    "desc": "Prereq: BIOL 211 and BIOL 212 (BIOL 211L and 212L recommended)\nStudy of the general biology of plants, including plant cells and functions, basic anatomy of tissues, meristems, and organs; adaptive morphological features.  Review of processes of photosynthesis, respiration, basic plant metabolic functions, and plant reproduction.  Survey of evolutionary aspects of all major groups of land plants, and relationships of plants to their environment.  Intended for Biology and other life science undergraduate majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Invertebrate Biology",
    "dept": "BIOL",
    "num": "364",
    "desc": "Prereq: BIOL 211, 212\nEmphasis on diversity, development, physiology, and behavior of invertebrate organisms- the \"spineless wonders\" of the world. Laboratory involves hands-on study and investigation of living invertebrates.\n",
    "credits": "3"
  },
  {
    "course_name": "Vertebrate Biology",
    "dept": "BIOL",
    "num": "365",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, BIOL 212L\nEvolution, biology, and classification of fish, amphibians, reptiles, birds, and mammals. Emphasis on a comparative analysis of the structure and function of organ systems. Laboratory exercises concentrate on morphology and identification of orders of vertebrates.\n",
    "credits": "4"
  },
  {
    "course_name": "Plant Systematics",
    "dept": "BIOL",
    "num": "366",
    "desc": "Prereq: BIOL 211\nIntroduction to plant phylogenetic systematics, plant classification, survey of flowering plant families, and identification and field study of local plants.\n",
    "credits": "4"
  },
  {
    "course_name": "GIS for Ecology and Environmental Science",
    "dept": "BIOL",
    "num": "370",
    "desc": "Prereq: Six credits in biological and /or physical sciences, and permission of instructor.\nIntroduction to geographic information systems (GIS) with emphasis on ecological and environmental applications. No prior GIS experience required. Guided, individualized study of topics based on student background and interest. For students with prior experience, topics and activities are selected to build upon any previous experience and minimize duplication to previous GIS coursework. Potential topics include: basic concepts of GIS, data structures, database management, spatial analysis, modeling and visualization of ecological and environmental data. Case studies in ecological and environmental applications using ArcGIS.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Ecological Methods",
    "dept": "BIOL",
    "num": "371",
    "desc": "Prereq: A ECL 312; STAT 101 or STAT 104\nQuantitative techniques used in management of natural resources with emphasis on inventory and manipulation of habitat and animal populations.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems I:  Introduction to Environmental Systems",
    "dept": "BIOL",
    "num": "381",
    "desc": "Prereq: 12 credits of natural science including biology and chemistry\nIntroduction to the structure and function of natural environmental systems. Emphasis on the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems II: Analysis of Environmental Systems",
    "dept": "BIOL",
    "num": "382",
    "desc": "Prereq: ENSCI 381\nContinuation of ENSCI 381. Systems approach to the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "North American Field Trips in Biology",
    "dept": "BIOL",
    "num": "393",
    "desc": "Prereq: Two courses in the biological sciences and by approval of application\nExtended field trips, usually during break periods, to North American locations of interest to biologists. Inquire in the Biology Program Office, 103 Bessey Hall, for trip schedule.\n",
    "credits": "1"
  },
  {
    "course_name": "North American Field Trips in Biology: Pre-trip Seminar",
    "dept": "BIOL",
    "num": "393A",
    "desc": "Prereq: Two courses in the biological sciences and by approval of application\nDiscussion of relevant biological and cultural topics during semester preceding extended field trips to North American locations of interest to biologists.\n",
    "credits": "1"
  },
  {
    "course_name": "North American Field Trips in Biology: North American Field trip",
    "dept": "BIOL",
    "num": "393B",
    "desc": "Prereq: Two courses in the biological sciences and by approval of application\nExtended field trip under supervision of faculty member, usually during break periods, to North American locations of interest to biologists. Inquire in the Biology Program Office, 103 Bessey Hall, for trip schedule. Report required.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Trips in Biology",
    "dept": "BIOL",
    "num": "394",
    "desc": "Prereq: Two courses in the biological sciences and by approval of application\nExtended field trips, usually during break periods, to international locations of interest to biologists. Inquire in the Biology Program Office, 103 Bessey Hall, for trip schedule.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Trips in Biology: Pre-trip Seminar",
    "dept": "BIOL",
    "num": "394A",
    "desc": "Prereq: Two courses in the biological sciences and by approval of application\nDiscussion of relevant  biological and cultural topics during semester preceding extended field trip to international locations of interest to biologists.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "International Field Trips in Biology: Field Trip to International Location",
    "dept": "BIOL",
    "num": "394B",
    "desc": "Prereq: Two courses in the biological sciences and by approval of application\nExtended field trips, under supervision of faculty member, usually during break periods, to international locations of interest to biologists. Inquire in the Biology Program Office, 103 Bessey Hall, for trip schedule.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Pathology",
    "dept": "BIOL",
    "num": "402",
    "desc": "Prereq: BIOL 211 and BIOL 212 with labs\nIntroductory exploration of pathology as a medical discipline. This includes study of disease mechanisms via an introduction to general pathology topics (cell degeneration, necrosis, disturbances of growth, disturbances of blood flow, inflammation, neoplasia) and organ system-specific response to injury.\n",
    "credits": "3"
  },
  {
    "course_name": "Life History and Reproductive Strategies",
    "dept": "BIOL",
    "num": "414",
    "desc": "Prereq: BIOL 315 or equivalent recommended.\nEvolution of ecological adaptations at the individual, population, and species level. Emphasis is on evolutionary mechanisms and adaptive strategies related to life histories and reproduction; age and size at maturity; lifespan and senescense; offspring size/number trade-offs; sex and mating systems; sex determination and sex ratios.\n",
    "credits": "3"
  },
  {
    "course_name": "Developmental Biology",
    "dept": "BIOL",
    "num": "423",
    "desc": "Prereq: BIOL 313\nPrinciples of embryogenesis and animal development. Establishment of body axes, organ and limb development, and specification of cell fates.  Emphasis on cell signaling and the control of gene expression within the context of a developing organism.  Medically relevant subjects will be discussed, including stem cells, cancer biology, fertilization, and cloning.\n",
    "credits": "3"
  },
  {
    "course_name": "Developmental Biology Laboratory",
    "dept": "BIOL",
    "num": "423L",
    "desc": "Prereq: Credit or enrollment in BIOL 423 or permission of the instructor.\nExperiments and explorations illustrating fundamental principles of multicellular development.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Cell Biology",
    "dept": "BIOL",
    "num": "428",
    "desc": "Prereq: BIOL 314\nSelected topics on biological structure and function at the cellular level. Emphasis on dynamic nature and regulation of cellular organization and the integration of cellular processes (systems biology). Original research articles will demonstrate interdisciplinary research strategies and how scientific investigation leads to knowledge and understanding of cell biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Plant Physiology",
    "dept": "BIOL",
    "num": "430",
    "desc": "Prereq: BIOL 313 or GEN 320; BIOL 314 or BBMB 301; CHEM 231 or CHEM 332; PHYS 106, PHYS 115, or PHYS 111\nAn overview of classical and current concepts, principles, and approaches regarding the basic mechanisms of plant function underlying growth, development, and survival of plants.  Topics covered include environmental and developmental signals, plant hormone action, signal transduction, mineral nutrition, water relations, metabolism, and photosynthesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Endocrinology",
    "dept": "BIOL",
    "num": "434",
    "desc": "Prereq: BIOL 211, BIOL 212\nChemical integration of vertebrate organisms. The structure, development, and evolution of the endocrine glands and the function and structure of their hormones.\n",
    "credits": "3"
  },
  {
    "course_name": "Neurobiology",
    "dept": "BIOL",
    "num": "436",
    "desc": "Prereq: BIOL 212\nBasic principles of brain function and development. Signaling of nerve cells, synaptic transmission, structure/function of ion channels and receptors, memory and synaptic plasticity, movement and central control, sensation and sensory processing, construction of neural circuits, early brain development, complex brain functions in health and disease.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatic Analysis",
    "dept": "BIOL",
    "num": "444",
    "desc": "Prereq: MATH 165 and Introductory Statistics (STAT 101, STAT 104, STAT 105, STAT 201, or STAT 330).\nBroad overview of bioinformatics with a significant problem-solving component, including hands-on practice using computational tools to solve a variety of biological problems. Topics include: bioinformatic data processing, Python programming, genome assembly, database search, sequence alignment, gene prediction, next-generation sequencing, comparative and functional genomics, and systems biology.\n",
    "credits": "4"
  },
  {
    "course_name": "Plant Evolution and Phylogeny",
    "dept": "BIOL",
    "num": "451",
    "desc": "Prereq: BIOL 315 or equivalent.\nSurvey of land plant evolution; phylogenetic comparison of anatomical, reproductive, and life history specializations. Relationships among bryophytes, lycophytes, pteridophytes, gymnosperms, and angiosperms emphasizing significant evolutionary changes documented by paleobotanical, morphological, and molecular studies.\n",
    "credits": "4"
  },
  {
    "course_name": "Plant Anatomy",
    "dept": "BIOL",
    "num": "454",
    "desc": "Prereq: BIOL 212L; BIOL 366 recommended\nCharacteristics of cell and tissue types in vascular plants. Anatomy of developing and mature stems, roots, and leaves, including secondary (woody) growth. Introduction to the special anatomy of flowers and seeds.\n",
    "credits": "4"
  },
  {
    "course_name": "Bryophyte and Lichen Biodiversity",
    "dept": "BIOL",
    "num": "455",
    "desc": "Prereq: BIOL 211, BIOL 211L\nIntroduction to the biology and ecology of mosses, liverworts, and lichens. Emphasis on identification and diversity of local representatives of these three groups of organisms. Required field trips and service-learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Mycology",
    "dept": "BIOL",
    "num": "456",
    "desc": "Prereq: 10 credits in biological sciences\nMorphology, diversity and ecology of fungi; their relation to agriculture and industry and human health.\n",
    "credits": "3"
  },
  {
    "course_name": "Herpetology",
    "dept": "BIOL",
    "num": "457",
    "desc": "Prereq: BIOL 351 or BIOL 365\nBiology, ecology, and evolution of amphibians (salamanders, frogs, caecilians) and reptiles (lizards, snakes, tuatara, turtles, crocodilians).  Emphasis on structure, physiological adaptation to different environments, behavior, reproduction, roles of amphibians and reptiles in ecosystems, and conservation.  Laboratory focus on survey methods, identification, relationships, distribution, habits, and habitats of amphibians and reptiles.\n",
    "credits": "2"
  },
  {
    "course_name": "Herpetology Laboratory",
    "dept": "BIOL",
    "num": "457L",
    "desc": "Prereq: BIOL 351 or BIOL/A ECL 365; concurrent registration in BIOL 457 or A ECL 457\nLaboratory to accompany Biology/Animal Ecology 457. Focus on survey methods, identification, relationships, distribution, habits, and habitats of amphibians and reptiles.\n",
    "credits": "1"
  },
  {
    "course_name": "Ornithology",
    "dept": "BIOL",
    "num": "458",
    "desc": "Prereq: A ECL 365 or BIOL 351\nBiology, evolution, ecology and taxonomy of birds.  Emphasis on structure, physiology, behavior, communication, navigation, reproduction, and conservation.\n",
    "credits": "2"
  },
  {
    "course_name": "Ornithology Laboratory",
    "dept": "BIOL",
    "num": "458L",
    "desc": "Prereq: BIOL 351 or AECL/BIOL 365. Concurrent enrollment in AECL/BIOL 458 is required.\nLaboratory complements lecture topics with emphasis on external anatomy, identification and distribution of Midwest birds, and field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Mammalogy",
    "dept": "BIOL",
    "num": "459",
    "desc": "Prereq: BIOL 351 or A ECL 365\nBiology, ecology, and evolution of mammals.  Emphasis on structure, physiological adaptation to different environments, behavior, reproduction, roles of mammals in ecosystems, and conservation.\n",
    "credits": "2"
  },
  {
    "course_name": "Mammalogy Laboratory",
    "dept": "BIOL",
    "num": "459L",
    "desc": "Prereq: BIOL 351 or BIOL/AECL 365; concurrent enrollment in AECL 459 or BIOL 459 required.\nLaboratory focus on identification, survey methods, distribution, habits, and habitats of mammals. Several field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Evolutionary Genetics",
    "dept": "BIOL",
    "num": "462",
    "desc": "Prereq: BIOL 315\nThe genetic basis of evolutionary processes in eukaryotic organisms. The role of genetic variation in adaptation, natural selection, adaptive processes, and the influence of random processes on evolutionary change.\n",
    "credits": "3"
  },
  {
    "course_name": "Wetland Ecology",
    "dept": "BIOL",
    "num": "464",
    "desc": "Prereq: 15 credits in biological sciences.\nEcology, classification, creation and restoration, and management of wetlands.  Emphasis on North American temperate wetlands.\n",
    "credits": "3"
  },
  {
    "course_name": "Macroevolution",
    "dept": "BIOL",
    "num": "465",
    "desc": "Prereq: BIOL 315\nThe history and diversity of life on earth; evolutionary patterns and processes above the species level. Diversity from a phylogenetic perspective. Empirical exercises include: phylogeny estimation, ancestral states, estimating diversification rates, evaluating the tempo and mode of evolution, biogeographic patterns, and trait associations across the tree of life.\n",
    "credits": "3"
  },
  {
    "course_name": "Introductory Conservation Biology",
    "dept": "BIOL",
    "num": "471",
    "desc": "Prereq: BIOL 312\nExamination of conservation issues from a population and community perspective.  The role of genetics, demography, and environment in determining population viability, habitat fragmentation, reserve design, biodiversity assessment, and restoration ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Ecology",
    "dept": "BIOL",
    "num": "472",
    "desc": "Prereq: BIOL 312\nThe effect of interspecific interactions on the structure and dynamics of natural and managed communities; including concepts of guild structure and trophic web dynamics and their importance to the productivity, diversity, stability, and sustainability of communities. The implications of interspecifc interactions in the management of wild species will be emphasized with illustrative case histories of interactions between plants, invertebrates, and vertebrates.\n",
    "credits": "3"
  },
  {
    "course_name": "Plant Ecology",
    "dept": "BIOL",
    "num": "474",
    "desc": "Prereq: BIOL 312\nPrinciples of plant population and community ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Functional Ecology",
    "dept": "BIOL",
    "num": "476",
    "desc": "Prereq: BIOL 312\nThe nature of adaptations to physical and biotic environments.  Biophysical, biomechanical, and physiological bases of the structure, form, growth, distribution, and abundance of organisms.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Marine Biology",
    "dept": "BIOL",
    "num": "480",
    "desc": "\nCourses taken at Gulf Coast Research Laboratory and other marine biological stations are transferred to Iowa State University under this number.\n",
    "credits": "1"
  },
  {
    "course_name": "Summer Field Studies",
    "dept": "BIOL",
    "num": "481",
    "desc": "\nCourses taken at summer biological field stations are transferred to Iowa State University under this number. See www.biology.iastate.edu for links to field stations located in different biomes: coastal, Great Lakes, taiga, deciduous forests, deserts, Rocky Mountains.\n",
    "credits": "1"
  },
  {
    "course_name": "Tropical Biology",
    "dept": "BIOL",
    "num": "482",
    "desc": "Prereq: One year of college biology; knowledge of Spanish desirable but not required\nStudents registering for courses taught by the Organization for Tropical Studies will receive credit for this ISU course when requesting a transfer of credits.\n",
    "credits": "1"
  },
  {
    "course_name": "Ecosystem Ecology",
    "dept": "BIOL",
    "num": "484",
    "desc": "Prereq: Combined 12 credits in biology, chemistry, and physics.\nIntroduction of the study of ecosystems and the biological and physical factors that influence their properties and dynamics. Conceptual foundations for ecosystem studies. Interactions among organisms, biological diversity, and ecosystem attributes. Quantitative analyses of accumulations, transformations, and fluxes of nutrients, water, and energy within and among ecosystems. Global change issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "BIOL",
    "num": "486",
    "desc": "Prereq: BIOL 312 or ENSCI 381 or ENSCI 402 or NREM 301\nStructure and function of aquatic ecosystems with application to fishery and pollution problems. Emphasis on lacustrine, riverine, and wetland ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology Laboratory",
    "dept": "BIOL",
    "num": "486L",
    "desc": "Prereq: Concurrent enrollment in BIOL 486\nField trips and laboratory exercises to accompany 486. Hands-on experience with aquatic research and monitoring techniques and concepts.\n",
    "credits": "1"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "BIOL",
    "num": "487",
    "desc": "Prereq: Six credits in biology and 6 credits in chemistry\nIntroduction to major functional groups of autotrophic and heterotrophic microorganisms and their roles in natural and environmental systems. Consequences of microbial activity on water chemistry, weathering, and precipitation/dissolution reactions will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Identification of Aquatic Organisms",
    "dept": "BIOL",
    "num": "488",
    "desc": "\nOn-line taxonomic and identification exercises to accompany 486. Instruction and practice in the identification of algae, aquatic macrophytes, zooplankton, and benthos.\n",
    "credits": "1"
  },
  {
    "course_name": "Population Ecology",
    "dept": "BIOL",
    "num": "489",
    "desc": "Prereq: BIOL 312, STAT 101 or STAT 104, a course in calculus, or graduate standing\nConcepts and theories of population dynamics with emphasis on models of growth, predation, competition, and regulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "BIOL",
    "num": "490",
    "desc": "Prereq: Permission of instructor.\nIndependent study opportunities for undergraduate students in the biological sciences.\n  No more than 9 credits in Biol 490 may be counted toward graduation and, of those, only 2 credits may be applied toward the Biology advanced course requirement.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Teaching Experience",
    "dept": "BIOL",
    "num": "491",
    "desc": "Prereq: Permission of supervising staff\nFor students registering to be undergraduate teaching assistants.\n  Offered on a satisfactory-fail basis only.  A maximum of 2 credits of BIOL 491 may be applied toward the Biology advanced course requirement.",
    "credits": "1"
  },
  {
    "course_name": "Preparing for Graduate School in the Biological Sciences",
    "dept": "BIOL",
    "num": "492",
    "desc": "Prereq: For life science majors; Minimum requirement: sophomore standing.\nFor students considering pursuing a graduate degree in the biological sciences. Professional development topics including the defining of academic and career areas of interest, finding and evaluating appropriate programs of graduate study, the graduate school application process, and developing a curriculum vita. Exploration of learning opportunities at field stations, research internships, and independent research activities.\n",
    "credits": "1"
  },
  {
    "course_name": "Biology Internship",
    "dept": "BIOL",
    "num": "494",
    "desc": "Prereq: 8 credits in biology and permission of instructor\nProfessional experiences in biological sciences. Intended for Biology majors.\n  No more than 9 credits in BIOL 494 may be counted toward graduation and, of those, only 6 credits may be applied toward the Biology advanced course requirement.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Seminar",
    "dept": "BIOL",
    "num": "495",
    "desc": "Prereq: Permission of instructor\nContent varies from year to year and may include detailed discussion of special topics in biology, current issues in biology, or careers in biology.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "BIOL",
    "num": "498",
    "desc": "Prereq: Permission of the Biology Program cooperative education coordinator\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Undergraduate Research Experience",
    "dept": "BIOL",
    "num": "499",
    "desc": "Prereq: Permission of instructor.\nResearch opportunities for undergraduate students in the biological sciences.  Intended for Biology majors.\n  No more than 9 credits in Biol 499 may be counted toward graduation and, of those, only 6 credits may be applied toward the Biology advanced course requirement.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Biomedical Engineering",
    "dept": "B M E",
    "num": "220",
    "desc": "Prereq: BIOL 212, ENGR 160 or equiv, MATH 166, CHEM 167 or CHEM 178, PHYS 222\nEngineering analysis of basic biology and engineering problems associated with living systems and health care delivery. The course will illustrate biomedical engineering applications in such areas as: biotechnology, biomechanics, biomaterials and tissue engineering, and biosignal and image processing, and will introduce the basic life sciences and engineering concepts associated with these topics.\n",
    "credits": "3"
  },
  {
    "course_name": "BioMEMs and Nanotechnology",
    "dept": "B M E",
    "num": "341",
    "desc": "Prereq: B M E 220\nOverview of Micro-Electro-Mechanical-System (MEMS) technologies for bioengineering, fundamentals of microfluidic device design, fabrication, and characterization, survey of microfluidic functional building blocks for lab-on-a-chip applications including mixers, valves, channels, and chambers. Topics of nanotechnology in bioengineering, nanoscale building block technologies for bioengineering including self-assembling, surface chemical treatment, nano-imprinting, nano-particles, nano-tubes, nano-wires, and stimuli-responsive biomaterials.\n",
    "credits": "3"
  },
  {
    "course_name": "BioMEMS and Nanotechnology Laboratory",
    "dept": "B M E",
    "num": "341L",
    "desc": "Prereq: B M E 220, concurrent enrollment in B M E 341\nIntroductory laboratory course accompanying B M E 341.  Design, fabrication, and characterization of BioMEMS lab-on-a-chip devices and nanoscale techniques for bioengineering. Student group projects.\n",
    "credits": "1"
  },
  {
    "course_name": "Molecular, Cellular and Tissue Biomechanics",
    "dept": "B M E",
    "num": "352",
    "desc": "Prereq: B M E 220, E M 324, MAT E 273\nIntroduction to the anatomy of the musculoskeletal system and connective tissue. Range of movement, joint dislocation, bone deformity and fracture. Application of continuum mechanics to both living and non-living systems. Laws of motion, free-body diagrams and simple force analysis of musculoskeletal system. Biomechanical response of soft and hard tissues with emphasis on microstructure and mechanical properties. Applications to bioengineering design.\n",
    "credits": "3"
  },
  {
    "course_name": "Image Processing with Biomedical Applications",
    "dept": "B M E",
    "num": "428",
    "desc": "Prereq: E E 324\nReview of signal processing, linear algebra, probability. Image sampling and quantization. Image transforms, image enhancement, image denoising/restoration. Tomographic reconstruction, segmentation and registration, recognition and shape analysis and applications in Computer Aided disease Detection (CAD).\n",
    "credits": "3"
  },
  {
    "course_name": "Biomedical Applications of Chemical Engineering",
    "dept": "B M E",
    "num": "440",
    "desc": "Prereq: CH E 210, MATH 266 or MATH 267, PHYS 222\nApplications of material and energy balances, transport phenomena, chemical reaction engineering, and thermodynamics to problems in biomedical engineering and applied physiology; survey of biomedical engineering; biomaterials; biomedical imaging.\n",
    "credits": "3"
  },
  {
    "course_name": "Biosensing",
    "dept": "B M E",
    "num": "450",
    "desc": "Prereq: B M E 220\nOverview of biosensors and bioanalytical challenges; designing for performance including various analytical problems, ion-selective membranes, characteristics of enzymes and basics of bioaffinity sensing; fundamentals of bioselective layers including depositing films and membranes, surfaces for immobilization and bioselective agents; survey of different biosensing technologies including electroanalytical, biomembrane, optical, and acoustic-wave based sensors.\n",
    "credits": "3"
  },
  {
    "course_name": "Biosensing Laboratory",
    "dept": "B M E",
    "num": "450L",
    "desc": "Prereq: B M E 220, concurrent enrollment in B M E 450\nLaboratory course accompanying B M E 450. Design, fabrication, and characterization of various electrical, chemical, polymer, optical and acoustic sensors.\n",
    "credits": "1"
  },
  {
    "course_name": "Biomaterials",
    "dept": "B M E",
    "num": "456",
    "desc": "Prereq: CHEM 178 and MAT E 216 or MAT E 273 or MAT E 392\nPresentation of the basic chemical and physical properties of biomaterials, including metals, ceramics, and polymers, as they are related to their manipulation by the engineer for incorporation into living systems. Role of microstructure properties in the choice of biomaterials and design of artificial organs, implants, and prostheses.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "B M E",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "B M E",
    "num": "490",
    "desc": "Prereq: permission of chair for the bioengineering minor\nInvestigation of biomedical engineering topics of special interest to student and supervising faculty member with a final written report.\n",
    "credits": "1"
  },
  {
    "course_name": "Anatomy and Physiology of Domestic Animals",
    "dept": "B M S",
    "num": "329",
    "desc": "Prereq: BIOL 212, BIOL 212L\nSurvey of body systems of  domestic animals. Provides a medical science orientation particularly useful to students in a preveterinary medicine curriculum.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Morphology I",
    "dept": "B M S",
    "num": "330",
    "desc": "Prereq: 10 credits in biological science and permission of the instructor\nAnatomy of the dog and cat: from basics to clinical application.\n",
    "credits": "6"
  },
  {
    "course_name": "Principles of Morphology II",
    "dept": "B M S",
    "num": "331",
    "desc": "Prereq: First-year classification in veterinary medicine. B M S 330\nComparative and topographic anatomy of horse, ruminants, pig, and chicken.\n",
    "credits": "4"
  },
  {
    "course_name": "Biomedical Sciences I",
    "dept": "B M S",
    "num": "333",
    "desc": "Prereq: First-year classification in veterinary medicine\nMicroscopic anatomy and physiology of cells, tissues, cardiovascular system, respiratory system, and urinary system.\n",
    "credits": "6"
  },
  {
    "course_name": "Biomedical Sciences II",
    "dept": "B M S",
    "num": "334",
    "desc": "Prereq: First-year classification in veterinary medicine\nMicroscopic anatomy of the immune system and integument. Microscopic anatomy and physiology of the digestive system, endocrine system, and reproductive system.\n",
    "credits": "6"
  },
  {
    "course_name": "Molecular and Cellular Basis of Disease",
    "dept": "B M S",
    "num": "335",
    "desc": "\nDescriptions of molecular and cellular biology especially as it pertains to veterinary medicine.  Discussions of cellular components, cellular functions and anomalies thereof.  Emphasis placed on divergences relevant to companion animals and livestock.\n",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Nutrition",
    "dept": "B M S",
    "num": "336",
    "desc": "\nIntroduce basic biochemical aspects of metabolism and function of energy, protein, fat, minerals and vitamins in the diet.  Determine nutrient requirements of food animals, pets, and horses under various physiological states.  Understand fate of various nutrients in simple stomached animals, ruminants, and cecal fermenters.  Discuss clinical nutrition problems specific to each species.\n",
    "credits": "2"
  },
  {
    "course_name": "Neuroanatomy",
    "dept": "B M S",
    "num": "337",
    "desc": "Prereq: First-year classification in veterinary medicine\nNeuroanatomy of domestic animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Clinical Foundations I",
    "dept": "B M S",
    "num": "339",
    "desc": "Prereq: First-year classification in veterinary medicine\nCanine physical examination; basic behavior, animal handling and restraint; medical record keeping.\n",
    "credits": "1"
  },
  {
    "course_name": "Case Study I",
    "dept": "B M S",
    "num": "345",
    "desc": "Prereq: First-year classification in veterinary medicine\nClinical applications of basic sciences taught concurrently in the fall semester of the first year curriculum in veterinary medicine.\n",
    "credits": "1"
  },
  {
    "course_name": "Case Study II",
    "dept": "B M S",
    "num": "346",
    "desc": "Prereq: First-year classification in veterinary medicine\nClinical applications of basic sciences taught concurrently in the spring semester of the first year curriculum in veterinary medicine.\n",
    "credits": "1"
  },
  {
    "course_name": "General Pharmacology",
    "dept": "B M S",
    "num": "354",
    "desc": "Prereq: B M S 549 and B M S 552; BBMB 404, BBMB 405\nGeneral principles; drug disposition; drugs acting on the nervous, cardiovascular, renal, gastrointestinal, and endocrine systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Intro to Aquatic Animal Medicine",
    "dept": "B M S",
    "num": "401",
    "desc": "\n8 week course. Introductory course with focus on fin fish production, health and medicine. Course content will help define future roles for veterinarians, producers, and service providers.  Emphasis will be placed on anatomy, pathology, infectious diseases, nutrition, regulatory constraints in production, food safety, and current research. Field trip to aquaculture facility.\n",
    "credits": "1"
  },
  {
    "course_name": "Behavior of Domestic Animals",
    "dept": "B M S",
    "num": "403",
    "desc": "Prereq: Classification in veterinary medicine\nNormal and abnormal behavior of domestic animals.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles of Pharmacology",
    "dept": "B M S",
    "num": "439",
    "desc": "Prereq: A physiology course: B M S 329, BIOL 335, BIOL 336 or the equivalent.\nGeneral principles of drug actions; drug disposition; drug acting or, cardiovascular, respiratory, renal, gastrointestinal, and endocrine systems; anti-inflammatory and antibiotic drug; anti-cancer drugs; anesthetics CNS stimulants; lifestyle drugs; drug addiction, abuse and dependence; drugs in sport; drugs for obesity; biopharmaceuticals and gene therapy; drug development.\n",
    "credits": "4"
  },
  {
    "course_name": "Pharmacology and Therapeutics",
    "dept": "B M S",
    "num": "443",
    "desc": "Prereq: B M S 354\nPharmacology and therapeutic uses of fluids, antimicrobial and antiparasitic drugs, clinical use of veterinary drugs, and adverse drug reactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Anatomy",
    "dept": "B M S",
    "num": "447",
    "desc": "Prereq: Graduate standing and previous biology coursework or instructor permission.\nExamination of gross anatomy and neuroanatomy of the human. Laboratories will center on regional anatomy study through human cadaver dissection, in addition to models and virtual learning solutions.\n",
    "credits": "4"
  },
  {
    "course_name": "Independent Study",
    "dept": "B M S",
    "num": "490",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "B M S",
    "num": "490H",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "International Preceptorship",
    "dept": "B M S",
    "num": "496",
    "desc": "Prereq: Classification in veterinary medicine or permission of the instructor\nInternational Preceptorships and Study Abroad Group programs. This course will provide opportunities for students to be involved in applied clinical, production, and/or research experiences in international locations. The course consists of 40 hour per week experiential learning opportunities.\n",
    "credits": "1"
  },
  {
    "course_name": "Selected Research Methods in Biomedical Sciences",
    "dept": "B M S",
    "num": "501",
    "desc": "Prereq: Graduate classification, permission of a BMS faculty member\nExperience in biomedical techniques in selected BMS laboratories that include but is not limited to cytochemical methods, molecular biological techniques, extracellular and intracellular unit recording, microiontophoresis, microinjection, spectrophoto-fluorometric analysis of chemicals,  use of radioisotopes, radioimmunoassay, Ca2+ imaging, confocal microscopy, fluorescence microscopy, and immunocytochemistry.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Biomedical Sciences",
    "dept": "B M S",
    "num": "502",
    "desc": "\nProvides laboratory experience in the application of methods in biomedical sciences, including animal physiology and pharmacology laboratory techniques; human physiology recordings and urinalysis; pharmacokinetics; basic techniques in analytical laboratory; basic pathology, immunology, bacteriology, and virology laboratory techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Morphology I",
    "dept": "B M S",
    "num": "530",
    "desc": "Prereq: 10 credits in biological science and permission of the instructor\nAnatomy of the dog and cat: from basics to clinical application.\n",
    "credits": "6"
  },
  {
    "course_name": "Principles of Morphology II",
    "dept": "B M S",
    "num": "531",
    "desc": "Prereq: First-year classification in veterinary medicine. B M S 330\nComparative and topographic anatomy of horse, ruminants, pig, and chicken.\n",
    "credits": "4"
  },
  {
    "course_name": "Biomedical Sciences I",
    "dept": "B M S",
    "num": "533",
    "desc": "Prereq: First-year classification in veterinary medicine or graduate student status\nMicroscopic anatomy and physiology of cells, tissues, cardiovascular system, respiratory system, and urinary system.\n",
    "credits": "6"
  },
  {
    "course_name": "Biomedical Sciences II",
    "dept": "B M S",
    "num": "534",
    "desc": "Prereq: First-year classification in veterinary medicine or graduate student status\nMicroscopic anatomy of the immune system and integument. Microscopic anatomy and physiology of the digestive system, endocrine system, and reproductive system.\n",
    "credits": "6"
  },
  {
    "course_name": "Neuroanatomy",
    "dept": "B M S",
    "num": "537",
    "desc": "Prereq: 10 credits in biological science and permission of the instructor\nNeuroanatomy of domestic animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Physiology",
    "dept": "B M S",
    "num": "538",
    "desc": "\nPrinciples of neurophysiology, endocrine and reproductive physiology, muscle physiology, cardiovascular, respiratory, renal, and digestive physiology, and regulation of body fluid.\n",
    "credits": "4"
  },
  {
    "course_name": "Principles of Pharmacology",
    "dept": "B M S",
    "num": "539",
    "desc": "Prereq: A physiology course: B M S 329, BIOL 335, BIOL 336 or the equivalent.\nGeneral principles of drug actions; drug disposition; drug acting or, cardiovascular, respiratory, renal, gastrointestinal, and endocrine systems; anti-inflammatory and antibiotic drug; anti-cancer drugs; anesthetics CNS stimulants; lifestyle drugs; drug addiction, abuse and dependence; drugs in sport; drugs for obesity; biopharmaceuticals and gene therapy; drug development.\n",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "B M S",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "B M S",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "B M S",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "B M S",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "B M S",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "B M S",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "B M S",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "B M S",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pharmacology and Therapeutics",
    "dept": "B M S",
    "num": "543",
    "desc": "Prereq: B M S 354\nPharmacology and therapeutic uses of fluids, antimicrobial and antiparasitic drugs, clinical use of veterinary drugs, and adverse drug reactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Anatomy",
    "dept": "B M S",
    "num": "547",
    "desc": "Prereq: Graduate standing and previous biology coursework or instructor permission.\nExamination of gross anatomy and neuroanatomy of the human. Laboratories will center on regional anatomy study through human cadaver dissection, in addition to models and virtual learning solutions.\n",
    "credits": "4"
  },
  {
    "course_name": "General Pharmacology",
    "dept": "B M S",
    "num": "554",
    "desc": "Prereq: B M S 549 and B M S 552; BBMB 404, BBMB 405\nGeneral principles; drug disposition; drugs acting on the nervous, cardiovascular, renal, gastrointestinal, and endocrine systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Cellular, Molecular and Developmental Neuroscience",
    "dept": "B M S",
    "num": "556",
    "desc": "Prereq: BIOL 335 or BIOL 436; physics recommended\nFundamental principles of neuroscience including cellular and molecular neuroscience, nervous system development, sensory, motor and regulatory systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Cell Biology",
    "dept": "B M S",
    "num": "575",
    "desc": "Prereq: 10 credits in biological science and permission of instructor\nA multi-instructor course covering major topics in cell structure and function, including:  universal features of prokaryotic and eukaryotic cells, types of utilization and conversion of energy, genetic control of cell shape and functionality, internal organization of cells, communication between cells and their environment, development of multicellular systems.  Students have to write a term paper.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "B M S",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Anatomy",
    "dept": "B M S",
    "num": "590A",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Physiology",
    "dept": "B M S",
    "num": "590B",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Pharmacology",
    "dept": "B M S",
    "num": "590C",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Cell biology",
    "dept": "B M S",
    "num": "590D",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "B M S",
    "num": "599",
    "desc": "Prereq: Enrollment in BMS graduate program, and permission of instructor.\nCreative component for non-thesis Master of Science degree.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Review",
    "dept": "B M S",
    "num": "688",
    "desc": "Prereq: Enrollment in BMS graduate program.\nA forum for B M S students to gain experience in the critical exchange of ideas through oral presentation and discussion of scientific information.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "B M S",
    "num": "690",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Anatomy",
    "dept": "B M S",
    "num": "690A",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Physiology",
    "dept": "B M S",
    "num": "690B",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Pharmacology",
    "dept": "B M S",
    "num": "690C",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Cell biology",
    "dept": "B M S",
    "num": "690D",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "B M S",
    "num": "698",
    "desc": "Prereq: Enrollment in BMS graduate program.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar: Attendance",
    "dept": "B M S",
    "num": "698A",
    "desc": "Prereq: Enrollment in BMS graduate program.\n",
    "credits": "R"
  },
  {
    "course_name": "Seminar: Attendance and Presentation",
    "dept": "B M S",
    "num": "698B",
    "desc": "Prereq: Enrollment in B M S graduate program.\nAttendance and presentation required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Attendance and Report",
    "dept": "B M S",
    "num": "698C",
    "desc": "Prereq: Enrollment in BMS graduate program.\nAttendance to all B M S seminars and written reports are required.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "B M S",
    "num": "699",
    "desc": "Prereq: Enrollment in BMS graduate program.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Anatomy",
    "dept": "B M S",
    "num": "699A",
    "desc": "Prereq: Enrollment in BMS graduate program.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Physiology",
    "dept": "B M S",
    "num": "699B",
    "desc": "Prereq: Enrollment in BMS graduate program.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Pharmacology",
    "dept": "B M S",
    "num": "699C",
    "desc": "Prereq: Enrollment in BMS graduate program.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Cell biology",
    "dept": "B M S",
    "num": "699D",
    "desc": "Prereq: Enrollment in BMS graduate program.\n",
    "credits": "arr"
  },
  {
    "course_name": "The Evolving Chemical Industry",
    "dept": "BR C",
    "num": "506",
    "desc": "\nAn overview of the chemical industry including structure and its evolution. Discussion of the dynamics of recent introduction of biorenewable chemicals to the chemical industry.\n",
    "credits": "1"
  },
  {
    "course_name": "Technology-Led Entrepreneurship in Biorenewables",
    "dept": "BR C",
    "num": "507",
    "desc": "Prereq: Graduate Standing or Permission of Instructor.\nDevelop an understanding of the relationship between discovery research entrepreneurship and innovation in biorenewables. Understand critical techno-commercial analyses and intellectual property. Learn critical skills needed to found a company, including how to define key assets, write a business plan, leverage local resources, and secure funding.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "BR C",
    "num": "590",
    "desc": "\nSpecial topics in biorenewable chemicals.\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: K-12 Science Education.",
    "dept": "BR C",
    "num": "590K",
    "desc": "\nUnderstanding of Discovery Research for sixth through 12th grade science teachers. Design, methods and analysis of research associated with biorenewable energy systems. Science teachers will be introduced to the value of scientific inquiry, elements of engineering design, 21st century careers in science, technology, engineering and math (STEM) and how high school students need to be prepared for these careers.\n",
    "credits": "2"
  },
  {
    "course_name": "Catalysis and Catalytic Processes",
    "dept": "BR C",
    "num": "688",
    "desc": "Prereq: CH E 382\nPrinciples and applications of heterogeneous and homogeneous catalysis. Adsorption. Reaction kinetics and mass transfer effects. Catalyst characterization. Industrial catalytic processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Biorenewable Resources",
    "dept": "BRT",
    "num": "501",
    "desc": "Prereq: Previous coursework in introductory physics and chemistry is recommended.\nIntroduction to the science and engineering of converting biorenewable resources into bioenergy and biobased products. Survey of biorenewable resource base and properties; description of biofuels and biobased products; production of biorenewable resources; processing technologies for fuels, chemicals, materials, and energy; environmental impacts; technoeconomic analysis of production and processing; and biofuels policy.\n",
    "credits": "3"
  },
  {
    "course_name": "Biobased Products Seminar: Research Presentations",
    "dept": "BRT",
    "num": "506C",
    "desc": "\nResearch presentations throughout the semester as part of the course seminar series and during the course. Research Poster Symposium at the end of the semester. Typically taken in the last semester(s) when completing degree program.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Technology-Led Entrepreneurship in Biorenewables",
    "dept": "BRT",
    "num": "507",
    "desc": "Prereq: Graduate Standing or Permission of Instructor.\nDevelop an understanding of the relationship between discovery research entrepreneurship and innovation in biorenewables. Understand critical techno-commercial analyses and intellectual property. Learn critical skills needed to found a company, including how to define key assets, write a business plan, leverage local resources, and secure funding.\n",
    "credits": "1"
  },
  {
    "course_name": "Bioprocessing and Bioproducts",
    "dept": "BRT",
    "num": "511",
    "desc": "Prereq: A E 216 or equivalent, MATH 160 or MATH 165, one of CHEM 167 or higher, BIOL 173 or BIOL 211 or higher or BRT 501, senior or graduate classification\nSustainability, cleaner production. Taxonomy, kinetics, metabolism, aerobic and anaerobic fermentation.  Biofuels, bioenergy and coproducts. Mass/energy balances, process integration, pretreatment, separation. Membrane reactors, bioelectrolysis, microbial fuel cells, nanotechnology, genetic engineering, mutagenesis.  Term paper for graduate level only.\n",
    "credits": "3"
  },
  {
    "course_name": "Biorenewables Supply Chain Management",
    "dept": "BRT",
    "num": "513",
    "desc": "Prereq: Graduate Standing or Qualified Undergraduate with Instructor Permission\nEvaluation of supply chain logistics related to the field of biorenewables. Unique challenges associated with the biorenewables supply chain are emphasized and examined: cost analysis, market demand & prices, life cycle analysis, environmental impacts, as well as the technological, social, and political factors related to society.\n",
    "credits": "3"
  },
  {
    "course_name": "Biorenewables Law and Policy",
    "dept": "BRT",
    "num": "515",
    "desc": "\nEvaluation of the biorenewables field as it relates to the areas of law and policy. Primary emphasis on the following topics: concerns that motivated the development and expansion of the biorenewables field, a history of the interactions between biorenewable pathways. U.S. law and policy and controversies that have arisen from these interactions and their effects.\n",
    "credits": "3"
  },
  {
    "course_name": "International Biorenewables Law & Policy",
    "dept": "BRT",
    "num": "516",
    "desc": "\nEvaluation of the international biorenewables field as it relates to the areas of law and policy. Primary emphasis on the following topics: concerns that motivated the development and expansion of the field by adopting countries, a history of the interactions between biorenewable pathways. Law and policy in adopting countries and international controversies that have arisen from these interactions and their effects.\n",
    "credits": "3"
  },
  {
    "course_name": "Thermochemical Processing of Biomass",
    "dept": "BRT",
    "num": "535",
    "desc": "Prereq: Undergraduate course work in thermodynamics and transport phenomena\nIntroduction to thermal and catalytic processes for the conversion of biomass to biofuels and other biobased products. Topics include gasification, fast pyrolysis, hydrothermal processing, syngas to synfuels, and bio-oil upgrading. Application of thermodynamics, heat transfer, and fluid dynamics to bioenergy and biofuels.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "BRT",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nInvestigation/study of an approved barrier area(s) topic on an individual basis. Course content and requirements designed and developed in consultation with the student's major professor/instructor to determine barrier areas covered, but in all cases a formal report should be written.\n",
    "credits": "1"
  },
  {
    "course_name": "Biorenewable Resources Laboratory",
    "dept": "BRT",
    "num": "592L",
    "desc": "Prereq: Graduate student status. Undergraduates with instructor approval\nAn introduction to hands-on experimental laboratory techniques including laboratory safety, calibration, proper usage of chemistry apparatus, chemicals, analytical equipment, and fundamental techniques to ensure successful research.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Food Processing",
    "dept": "BRT",
    "num": "611",
    "desc": "Prereq: FS HN 311, or FS HN 471/472 or equivalent, or FS HN 511.\nRecent advances in the science and technology of food processing and preservation; examples include both thermal and non-thermal processes, including cold plasma, nanotechnology, food packaging, and extrusion. Advances in extraction and separation technologies, waste management, by-product utilization, biorenewables and sustainability in food processing industry will also be discussed. Students to research on select topics and present.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "BRT",
    "num": "699",
    "desc": "Prereq: Permission of student's major professor\n",
    "credits": "arr"
  },
  {
    "course_name": "Business Learning Team Orientation",
    "dept": "BUSAD",
    "num": "102",
    "desc": "\nA required orientation for all College of Business Students involved with a Business Learning Team.  Review of college and university requirements, transfer credits, academic planning, university policies and deadlines and registration procedures.  Includes a consideration of various business majors and careers, tools for success in college including writing skills and presentations from employers, alumni and current students.\n  Only one of BusAd 102 or BusAd 103 may be counted towards graduation.",
    "credits": "1"
  },
  {
    "course_name": "Orientation",
    "dept": "BUSAD",
    "num": "103",
    "desc": "\nA required orientation for all College of Business students. Review of college and university requirements, transfer credits, academic planning, university policies and deadlines, and registration procedures. Includes group advising for course selection and registration.\n  Only one of BUSAD 102 or BUSAD 103 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Business Careers and Employment Preparation",
    "dept": "BUSAD",
    "num": "203",
    "desc": "Prereq: BUSAD 101 or 102\nExplore careers in business and issues relevant to career readiness and professional development. Identifying individual and team strengths, values, developing and implementing a professional job search, resume and professional correspondence, interviewing, evaluating offers, business etiquette, networking and transitioning from student to employee.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Business",
    "dept": "BUSAD",
    "num": "250",
    "desc": "Prereq: COM S 113X\nIntroduction to the functional areas of business and how the functional areas are integrated for the purpose of implementing business strategy. Introduces students to decision making tools (spreadsheets and databases) that are integral to business decision making. Includes application   exercises to all functional areas of business.\n",
    "credits": "3"
  },
  {
    "course_name": "Entrepreneurship & Innovation Learning Community (EILC) Seminar",
    "dept": "BUSAD",
    "num": "292",
    "desc": "Prereq: Current member of or have applied to be a member of Entrepreneurship and Innovation Learning Community (see www.isupjcenter.org/ELC for more information)\nTopics related to entrepreneurship and entrepreneurial thinking. Presentations by entrepreneurs and faculty, field trips, business concept development.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Experiential Learning",
    "dept": "BUSAD",
    "num": "391",
    "desc": "Prereq: 12 credits from College of Business; written approval of Career Services Internship Coordinator on required form prior to the learning experience.\nSupervised work experience in a business related discipline.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Experiential Learning: Domestic Internship",
    "dept": "BUSAD",
    "num": "391A",
    "desc": "Prereq: 12 credits from College of Business; written approval of Career Services Internship Coordinator on required form prior to the learning experience\nSupervised work experience in a business related discipline.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Experiential Learning: International Internship",
    "dept": "BUSAD",
    "num": "391B",
    "desc": "Prereq: 12 credits from College of Business; written approval of Career Services Internship Coordinator on required form prior to the learning experience\nSupervised work experience in a business related discipline.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Experiential Learning: Domestic Travel and Study",
    "dept": "BUSAD",
    "num": "391C",
    "desc": "Prereq: 12 credits from College of Business; written approval of Career Services Internship Coordinator on required form prior to the learning experience\nSupervised travel and study in a business related discipline.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Experiential Learning: International Travel and Study",
    "dept": "BUSAD",
    "num": "391D",
    "desc": "Prereq: 12 credits from College of Business; written approval of Career Services Internship Coordinator on required form prior to the learning experience\nSupervised travel and study in a business related discipline.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Experiential Learning: Other Experiential Learning Experience",
    "dept": "BUSAD",
    "num": "391E",
    "desc": "Prereq: 12 credits from College of Business; written approval of Career Services Internship Coordinator on required form prior to the learning experience\nSupervised work experience in a business related discipline.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "BUSAD",
    "num": "398",
    "desc": "Prereq: Permission of department\nRequired of all cooperative education students engaged in full-time internship/co-op. Students must register for this course prior to commencing each work period. No more than three credits may be taken in addition to BUSAD 398 during any given semester.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Independent Study",
    "dept": "BUSAD",
    "num": "490",
    "desc": "Prereq: Professional program in Business; permission of instructor; for 490H: Admission to the Business Honors Program\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: International Business",
    "dept": "BUSAD",
    "num": "490A",
    "desc": "Prereq: Professional program in Business; permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "BUSAD",
    "num": "490E",
    "desc": "Prereq: senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: General",
    "dept": "BUSAD",
    "num": "490G",
    "desc": "Prereq: Professional program in Business; permission of instructor\nIndependent Study.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "BUSAD",
    "num": "490H",
    "desc": "Prereq: Admission to the Business Honors Program\n",
    "credits": "1"
  },
  {
    "course_name": "Strategic Management",
    "dept": "BUSAD",
    "num": "501",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nCritical analysis of current practice and case studies in strategic management with an emphasis on integrative decision making.  Strategy formulation and implementation will be investigated in the context of complex business environments.\n",
    "credits": "2"
  },
  {
    "course_name": "Quantitative Business Analysis and Decision Making",
    "dept": "BUSAD",
    "num": "502",
    "desc": "Prereq: Enrollment in MBA program or departmental permission\nIntroduction to the sources and statistical analysis of data as well as optimization models for use in making business decisions. Data collection, descriptive and inferential statistics including hypothesis testing, analysis of variance, multiple regression, linear programming and simulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Systems",
    "dept": "BUSAD",
    "num": "503",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nIntroduction to a broad variety of information systems (IS) topics, including current and emerging developments in information technology (IT), IT strategy in the context of corporate strategy, and IS planning and development of enterprise architectures.  Cases, reading, and discussions highlight the techniques and tactics used by managers to cope with strategic issues within an increasingly technical and data-driven competitive environment.\n",
    "credits": "2"
  },
  {
    "course_name": "Marketing and Logistics",
    "dept": "BUSAD",
    "num": "504",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nIntegration of the business functions concerned with the marketing and movement of goods along the supply chain with the primary goal of creating value for the ultimate customer. Coordination of marketing, production, and logistics activities within the firm and with outside suppliers and customers in the supply chain.\n",
    "credits": "3"
  },
  {
    "course_name": "Organizational Behavior",
    "dept": "BUSAD",
    "num": "507",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nUnderstanding human behavior in organizations, and the nature of organizations from a managerial perspective.  Special emphasis on how individual differences, such as perceptions, personality, and motivation, influence individual and group behavior in organizations and on how behavior can be influenced by job design, leadership, groups, and the structure of organizations.\n",
    "credits": "2"
  },
  {
    "course_name": "Accounting and Finance",
    "dept": "BUSAD",
    "num": "508",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nSurvey of fundamental topics in accounting and finance.  Financial statement reporting and analysis for agriculture firms, corporate governance issues related to financial reporting, (e.g., Sarbanes-Oxley). Basic tools and techniques used in financial management, including stock and bond valuation. How to assess and use capital budgeting methods to evaluate proposed firm investments.\n",
    "credits": "3"
  },
  {
    "course_name": "Seed Trade, Policy and Regulation",
    "dept": "BUSAD",
    "num": "509",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nCultural, financial, economic, political, legal/regulatory environments shaping an organization's international business strategy.  Topics include entry (and repatriation) of people, firms, goods, services, and capital. Special attention to the institutions of seed regulation and policy. Ethical issues facing managers operating in an international context.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Business",
    "dept": "BUSAD",
    "num": "590",
    "desc": "Prereq: Enrollment in MBA program or departmental permission.\nA special topics course covering contemporary issues in business. Topics vary by semester.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Experiential Learning",
    "dept": "BUSAD",
    "num": "591",
    "desc": "Prereq: Graduate standing; written approval of supervising instructor and department chair on required form prior to the learning experience\nAcademically supervised travel and/or work experiences in a business related discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "MBA Professional Skills Development",
    "dept": "BUSAD",
    "num": "592",
    "desc": "Prereq: Admission to Full-time MBA Program\nProvides first-year MBA students with tools necessary to develop and implement a successful internship and career search, and to develop professional skills critical for success in the competitive business environment.  Topics include career search strategy, resume and cover letter development, interviewing, strategic networking, salary negotiation, impression management, team skills development, presentation skills development, and business etiquette. Required for all full-time MBA students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "MBA Professional Skills Development II",
    "dept": "BUSAD",
    "num": "594",
    "desc": "Prereq: BUSAD 592\nA second course designed to improve the professional skills of first-year MBA students.  Emphasis on building effective communications and networking skills. Students will participate in professional workshops, company visits, executive speaker seminars, service learning projects, business case competitions, and related activities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "BUSAD",
    "num": "598",
    "desc": "Prereq: Permission of instructor\nProfessional work experience. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Creative Component",
    "dept": "BUSAD",
    "num": "599",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component: Accounting",
    "dept": "BUSAD",
    "num": "599A",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component: Finance",
    "dept": "BUSAD",
    "num": "599C",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component: Management",
    "dept": "BUSAD",
    "num": "599E",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component: Marketing",
    "dept": "BUSAD",
    "num": "599F",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component: Agribusiness",
    "dept": "BUSAD",
    "num": "599I",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component: General Business",
    "dept": "BUSAD",
    "num": "599J",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component: Management Information Systems",
    "dept": "BUSAD",
    "num": "599K",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component: Supply Chain Management",
    "dept": "BUSAD",
    "num": "599M",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Research Methods",
    "dept": "BUSAD",
    "num": "644",
    "desc": "Prereq: In PhD program in the College of Business or consent of instructor\nA survey of the wide variety of research methods used in business. Methods will be presented and discussed with emphasis on applicability in different research situations.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "BUSAD",
    "num": "699",
    "desc": "Prereq: Graduate classification, permission of major professor\nResearch.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Engineering Learning Community",
    "dept": "CH E",
    "num": "104",
    "desc": "Prereq: Enrollment in Chemical Engineering Learning Team\n(1-0) Curriculum in career planning and academic course support for Freshmen learning team.\n",
    "credits": "R"
  },
  {
    "course_name": "Chemical Engineering Problems with Computer Applications Laboratory",
    "dept": "CH E",
    "num": "160",
    "desc": "Prereq: MATH 143 or satisfactory scores on mathematics placement examinations; credit or enrollment in MATH 165\nFormulation and solution of engineering problems. Significant figures.  Use of SI units.  Graphing and curve-fitting.  Flowcharting.  Introduction to material balances, engineering economics, and design.  Use of spreadsheet programs to solve and present engineering problems.  Solution of engineering problems using computer programming languages.  Chemical Engineering examples.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Engineering Seminar",
    "dept": "CH E",
    "num": "202",
    "desc": "Prereq: Credit or enrollment in CH E 210.\nProfessionalism in the context of the engineering/technical workplace.  Introduction to chemical engineering career opportunities.  Process and workplace safety.  Development and demonstration of key workplace competencies:  teamwork, professionalism and ethical responsibility, ability to engage in life-long learning, and knowledge of contemporary issues.  Resumes; professional portfolios; preparation for internship experiences. Restricted to CHE majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Chemical Engineering Continuing  Learning Community",
    "dept": "CH E",
    "num": "204",
    "desc": "Prereq: Enrollment in Chemical Engineering Learning Team\nCurriculum and career planning, academic course support for learning community.\n",
    "credits": "R"
  },
  {
    "course_name": "Chemical Engineering Progress Assessment",
    "dept": "CH E",
    "num": "205",
    "desc": "Prereq: CHEM 178, MATH 166; credit or enrollment in CH E 160 and CH E 210\nAssessment of proficiency in general chemistry, calculus (including infinite series and applications of derivatives and integrals), and material balances, and an ability to use the principles of science and mathematics to identify, formulate, and solve engineering problems.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Material and Energy Balances",
    "dept": "CH E",
    "num": "210",
    "desc": "Prereq: CHEM 178, MATH 166, CH E 160\nIntroduction to chemical processes. Physical behavior of gases, liquids, and solids. Application of material and energy balances to chemical engineering equipment and processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Biomedical Engineering",
    "dept": "CH E",
    "num": "220",
    "desc": "Prereq: BIOL 212, ENGR 160 or equiv, MATH 166, CHEM 167 or CHEM 178, PHYS 222\nEngineering analysis of basic biology and engineering problems associated with living systems and health care delivery. The course will illustrate biomedical engineering applications in such areas as: biotechnology, biomechanics, biomaterials and tissue engineering, and biosignal and image processing, and will introduce the basic life sciences and engineering concepts associated with these topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Methods in Chemical Engineering",
    "dept": "CH E",
    "num": "310",
    "desc": "Prereq: CH E 160, CH E 205, CH E 210, MATH 265\nNumerical methods for solving systems of linear and nonlinear equations, ordinary differential equations, numerical differentiation and integration, and nonlinear regression using chemical engineering examples.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Engineering Laboratory I",
    "dept": "CH E",
    "num": "325",
    "desc": "Prereq: CH E 357, CH E 381; credit or enrollment in ENGL 314 or ENGL 309 or ENGL 312 or JL MC 347\nExperiments covering fundamental material and energy balances, momentum and energy transport operations, and thermodynamics. Computer applications.\n",
    "credits": "2"
  },
  {
    "course_name": "Transport Phenomena I",
    "dept": "CH E",
    "num": "356",
    "desc": "Prereq: CH E 205, CH E 210, PHYS 221; credit or enrollment in MATH 267\nMomentum and mechanical energy balances. Incompressible and compressible fluid flow. Applications to fluid drag, piping system design, filtration, packed beds and settling.\n",
    "credits": "3"
  },
  {
    "course_name": "Transport Phenomena II",
    "dept": "CH E",
    "num": "357",
    "desc": "Prereq: CH E 356\nConduction and diffusion, convective heat and mass transfer, boiling and condensation, radiation, and design of heat exchange equipment. Introduction to diffusion.\n",
    "credits": "3"
  },
  {
    "course_name": "Separations",
    "dept": "CH E",
    "num": "358",
    "desc": "Prereq: CH E 310, CH E 357, CH E 381\nDiffusion and mass transfer in fluids. Analysis and design of continuous contacting and multistage separation processes. Binary and multicomponent distillation, absorption, extraction, evaporation, membrane processes, and simultaneous heat and mass transfer.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Engineering Thermodynamics",
    "dept": "CH E",
    "num": "381",
    "desc": "Prereq: MATH 267, PHYS 222, CHEM 325; credit or enrollment in CH E 310\nApplication of thermodynamic principles to chemical engineering problems. Thermodynamic properties of fluids, phase equilibria, and chemical reaction equilibria.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Reaction Engineering",
    "dept": "CH E",
    "num": "382",
    "desc": "Prereq: CH E 310, CH E 381; credit or enrollment in CH E 357\nKinetics of chemical reactions. Design of homogeneous and heterogeneous chemical reactors.\n",
    "credits": "3"
  },
  {
    "course_name": "Foreign Study Orientation",
    "dept": "CH E",
    "num": "391",
    "desc": "Prereq: CH E 357, CH E 381; credit or enrollment in ENGL 314 or ENGL 309 or ENGL 312 or JL MC 347\n  Offered on a satisfactory-fail basis only.  Credit for graduation allowable only upon completion of Ch E 392.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Foreign Study Program",
    "dept": "CH E",
    "num": "392",
    "desc": "Prereq: CH E 358, CH E 382, CH E 391\nStudy of chemical engineering including laboratories and lectures at collaborating international universities. Comparative study of U.S. and international manufacturing facilities. Expenses required.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Summer Internship",
    "dept": "CH E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "CH E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period. One semester per academic or calendar year. Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Environmental Chemodynamics",
    "dept": "CH E",
    "num": "406",
    "desc": "Prereq: CHE 357, CH E 381\nExamines the mechanisms and rates of chemical transport across air, water, and soil interfaces. Applications of transport and thermodynamic fundamentals to movement of chemicals in the environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Surface and Colloid Chemistry",
    "dept": "CH E",
    "num": "408",
    "desc": "Prereq: CH E 381\nExamines the factors underlying interfacial phenomena, with an emphasis on the thermodynamics of surfaces, structural aspects, and electrical phenomena. Application areas include emulsification, foaming, detergency, sedimentation, fluidization, nucleation, wetting, adhesion, flotation, and electrophoresis.\n",
    "credits": "3"
  },
  {
    "course_name": "Biochemical Engineering",
    "dept": "CH E",
    "num": "415",
    "desc": "Prereq: CH E 357, CHEM 331; BBMB 301 or BBMB 303 or BBMB 404\nApplication of basic chemical engineering principles in biochemical and biological process industries such as enzyme technology and fermentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Process Safety",
    "dept": "CH E",
    "num": "420",
    "desc": "Prereq: CH E 357, CH E 381\nApplication of transport phenomena, thermodynamics, and chemical kinetics to the study of safety, health, and loss prevention.  Government regulations, industrial hygiene, relief sizing, runaway reactions, toxic release, and dispersion models will be used.  Fires, explosions, risk assessment, hazard identification, case studies, accident investigations, and design considerations will be studied.\n",
    "credits": "3"
  },
  {
    "course_name": "Process Control",
    "dept": "CH E",
    "num": "421",
    "desc": "Prereq: CH E 358, CH E 382, MATH 267\nControl of industrial chemical processes. Device applications and limitations. Dynamics of chemical process components and process control systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Engineering Laboratory II",
    "dept": "CH E",
    "num": "426",
    "desc": "Prereq: CH E 325, CH E 358, CH E 382\nExperiments in heat and mass transfer, staged operations, chemical reactor performance, unit processes. Computer applications.\n  Only one of Ch E 426 or 427 may count toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Biological Engineering Laboratory",
    "dept": "CH E",
    "num": "427",
    "desc": "Prereq: CH E 325, CH E 358, CH E 382; BBMB 301 or BBMB 303 or BBMB 404\nExperiments on biological applications in chemical engineering.\n  Only one of CH E 426 or CH E 427 may count toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Process and Plant Design",
    "dept": "CH E",
    "num": "430",
    "desc": "Prereq: CH E 358, CH E 382\nSynthesis of chemical engineering processes, equipment and plants. Cost estimation and feasibility analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "Biomedical Applications of Chemical Engineering",
    "dept": "CH E",
    "num": "440",
    "desc": "Prereq: CH E 210, MATH 266 or MATH 267, PHYS 222\nApplications of material and energy balances, transport phenomena, chemical reaction engineering, and thermodynamics to problems in biomedical engineering and applied physiology; survey of biomedical engineering; biomaterials; biomedical imaging.\n",
    "credits": "3"
  },
  {
    "course_name": "Polymers and Polymer Engineering",
    "dept": "CH E",
    "num": "447",
    "desc": "Prereq: CHEM 331; CH E 382 or MAT E 351\nChemistry of polymers, addition and condensation polymerization. Physical and mechanical properties, polymer rheology, production methods. Applications of polymers in the chemical industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research/Independent Study",
    "dept": "CH E",
    "num": "490",
    "desc": "Prereq: Permission of department\nInvestigation of topics of special interest to student and faculty with a final written report or presentation. Election of course and topic must be approved in advance by Department with completion of Study Proposal.\n  No more than 6 credits of ChE 490 may be counted towards technical electives.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research/Independent Study, Honors",
    "dept": "CH E",
    "num": "490H",
    "desc": "Prereq: Permission of Department\nInvestigation of topics of special interest to student and faculty with a final written report or presentation. Election of course and topic must be approved in advance by Department with completion of Study Proposal.\n  No more than 6 credits of ChE 490 may be counted towards technical electives.",
    "credits": "1"
  },
  {
    "course_name": "Environmental Chemodynamics",
    "dept": "CH E",
    "num": "506",
    "desc": "Prereq: CHE 357, CH E 381\nExamines the mechanisms and rates of chemical transport across air, water, and soil interfaces. Applications of transport and thermodynamic fundamentals to movement of chemicals in the environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Surface and Colloid Chemistry",
    "dept": "CH E",
    "num": "508",
    "desc": "Prereq: CH E 381\nExamines the factors underlying interfacial phenomena, with an emphasis on the thermodynamics of surfaces, structural aspects, and electrical phenomena. Application areas include emulsification, foaming, detergency, sedimentation, fluidization, nucleation, wetting, adhesion, flotation, and electrophoresis.\n",
    "credits": "3"
  },
  {
    "course_name": "Biochemical Engineering",
    "dept": "CH E",
    "num": "515",
    "desc": "Prereq: CH E 357, CHEM 331; BBMB 301 or BBMB 303 or BBMB 404\nApplication of basic chemical engineering principles in biochemical and biological process industries such as enzyme technology and fermentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Biomedical Applications of Chemical Engineering",
    "dept": "CH E",
    "num": "540",
    "desc": "Prereq: CH E 210, MATH 266 or MATH 267, PHYS 222\nApplications of material and energy balances, transport phenomena, chemical reaction engineering, and thermodynamics to problems in biomedical engineering and applied physiology; survey of biomedical engineering; biomaterials; biomedical imaging.\n",
    "credits": "3"
  },
  {
    "course_name": "Polymeric Biomaterials",
    "dept": "CH E",
    "num": "542",
    "desc": "Prereq: CHEM 331 or a polymers class\nPolymeric biomaterials, overview of biomaterial requirements, different classes of polymers used as biomaterials, specific bioapplications of polymers.\n",
    "credits": "3"
  },
  {
    "course_name": "Analytical and Numerical Methods",
    "dept": "CH E",
    "num": "545",
    "desc": "Prereq: CH E 358, MATH 267\nAnalysis of equipment and processes by analytic and/or numerical solution of descriptive differential equations. Operational and series techniques, boundary value problems, numerical interpolation and approximation, integration techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Polymers and Polymer Engineering",
    "dept": "CH E",
    "num": "547",
    "desc": "Prereq: CHEM 331; CH E 382 or MAT E 351\nChemistry of polymers, addition and condensation polymerization. Physical and mechanical properties, polymer rheology, production methods. Applications of polymers in the chemical industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Transport Phenomena",
    "dept": "CH E",
    "num": "554",
    "desc": "Prereq: CH E 357, CH E 381, MATH 267, credit or enrollment in CH E 545\nConservation equations governing diffusive and convective transport of momentum, thermal energy and chemical species.  Transport during laminar flow in conduits, boundary layer flow, creeping flow.  Heat and mass transport coupled with chemical reactions and phase change.  Scaling and approximation methods for mathematical solution of transport models. Diffusive fluxes; conservation equations for heat and mass transfer; scaling and approximation techniques; fundamentals of fluid mechanics; unidirectional flow; creeping flow; laminar flow at high Reynolds number; forced-convection heat and mass transfer in confined and unconfined laminar flows.\n",
    "credits": "4"
  },
  {
    "course_name": "Bioseparations",
    "dept": "CH E",
    "num": "562",
    "desc": "Prereq: CH E 357 or advanced standing in a science major\nPrinciples and techniques for separation and recovery of biologically-produced molecules, especially proteins. Relationship between the chemistry of biological molecules and efficient separation and preservation of biological activity. Includes centrifugation and filtration, membrane processing, extraction, precipitation and crystallization, chromatography, and electrophoresis.\n",
    "credits": "3"
  },
  {
    "course_name": "Turbulence",
    "dept": "CH E",
    "num": "572",
    "desc": "Prereq: AER E 541 or M E 538\nQualitative features of turbulence. Statistical representation of turbulent velocity fields: averages, moments, correlations, length and time scales and the energy cascade. Averaged equations of motion, closure requirements, Reynolds averaged models. Homogeneous shear flows, free shear flows, boundary layers. Numerical simulation of turbulence: DNS, LES, DES.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Thermodynamics",
    "dept": "CH E",
    "num": "583",
    "desc": "Prereq: CH E 381\nApplication of thermodynamic principles to chemical engineering problems. Thermodynamic properties of non-ideal fluids and solutions; phase and chemical-reaction equilibria/stability.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Chemical Reactor Design",
    "dept": "CH E",
    "num": "587",
    "desc": "Prereq: CH E 382\nAnalysis of complex reactions and kinetics. Fixed bed, fluidized bed, and other industrial reactors. Analysis and design of non-ideal flow mixing, and residence times. Heterogeneous reactors.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "CH E",
    "num": "590",
    "desc": "\nInvestigation of an approved topic on an individual basis.\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics",
    "dept": "CH E",
    "num": "595",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Separations",
    "dept": "CH E",
    "num": "595A",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Advanced Control Theory",
    "dept": "CH E",
    "num": "595B",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Crystallization",
    "dept": "CH E",
    "num": "595C",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Thermodynamics",
    "dept": "CH E",
    "num": "595D",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Protein Engineering/Bioseparations",
    "dept": "CH E",
    "num": "595E",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Biological Engineering",
    "dept": "CH E",
    "num": "595F",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Materials and Biomaterials",
    "dept": "CH E",
    "num": "595G",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Surfaces",
    "dept": "CH E",
    "num": "595H",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Combinatorial Design",
    "dept": "CH E",
    "num": "595I",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Creative Component",
    "dept": "CH E",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar",
    "dept": "CH E",
    "num": "601",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Metabolic Engineering",
    "dept": "CH E",
    "num": "625",
    "desc": "Prereq: CH E 382, CHEM 331\nPrinciples of metabolic engineering. Emphasis on emerging examples in biorenewables and plant metabolic engineering. Overview of biochemical pathways, determination of flux distributions by stoichiometric and labeling techniques; kinetics and thermodynamics of metabolic networks; metabolic control analysis; genetic engineering for overexpression, deregulation, or inhibition of enzymes; directed evolution; application of bioinformatics, genomics, and proteomics.\n",
    "credits": "3"
  },
  {
    "course_name": "Multiphase Flow",
    "dept": "CH E",
    "num": "632",
    "desc": "Prereq: M E 538\nSingle particle, mutliparticle and two-phase fluid flow phenomena (gas-solid, liquid-solid and gas-liquid mixtures); particle interactions, transport phenomena, wall effects; bubbles, equations of multiphase flow. Dense phase (fluidized and packed beds) and ducted flows; momentum, heat and mass transfer. Computer solutions.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles and Applications of Molecular Simulation",
    "dept": "CH E",
    "num": "642",
    "desc": "Prereq: CH E 545\nPrinciples of statistical physics. General features of molecular simulations including Monte Carlo (MC) methods, molecular mechanics (MM), and molecular dynamics (MD). Overview of intermolecular and interatomic potentials. Evaluation of phase equilibria, free energies, and surface/interfacial properties. Coarse-grained methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced  Transport",
    "dept": "CH E",
    "num": "652",
    "desc": "Prereq: CH E 552 and CH E 553\nAdvanced topics in momentum transport, fluid mechanics, and mass transport including study of recent literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Catalysis and Catalytic Processes",
    "dept": "CH E",
    "num": "688",
    "desc": "Prereq: CH E 382\nPrinciples and applications of heterogeneous and homogeneous catalysis. Adsorption. Reaction kinetics and mass transfer effects. Catalyst characterization. Industrial catalytic processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "CH E",
    "num": "692",
    "desc": "\nInvestigation of an approved topic on an individual basis. Election of course and topic must be approved in advance by Program of Study Committee.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "CH E",
    "num": "695",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Separations",
    "dept": "CH E",
    "num": "695A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Advanced Statistical Modeling and Control",
    "dept": "CH E",
    "num": "695B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Crystallization",
    "dept": "CH E",
    "num": "695C",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Thermodynamics",
    "dept": "CH E",
    "num": "695D",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Protein Engineering/Bioseparations",
    "dept": "CH E",
    "num": "695E",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Biological Engineering",
    "dept": "CH E",
    "num": "695F",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Materials and Biomaterials",
    "dept": "CH E",
    "num": "695G",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Surfaces",
    "dept": "CH E",
    "num": "695H",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Combinatorial Design",
    "dept": "CH E",
    "num": "695I",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics:  Polymeric and Nanostructured Materials",
    "dept": "CH E",
    "num": "695J",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics:  Biomaterials and Tissue Engineering",
    "dept": "CH E",
    "num": "695K",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics:  Catalysis, Reaction Engineering, and Renewable Energy",
    "dept": "CH E",
    "num": "695L",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "CH E",
    "num": "697",
    "desc": "Prereq: Permission of major professor, graduate classification\nOne semester and one summer maximum per academic year professional work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Chemical Engineering Teaching Practicum",
    "dept": "CH E",
    "num": "698",
    "desc": "Prereq: Graduate student classification and permission of instructor\nDiscussions intended to foster the development of graduate students as teaching assistants and future chemical engineering instructors. Topics include classroom and laboratory instruction, grading, and developing a teaching philosophy.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Chemical Engineering Teaching Practicum: Teaching Practicum",
    "dept": "CH E",
    "num": "698A",
    "desc": "Prereq: Graduate student classification and permission of instructor\nDiscussions intended to foster the development of graduate students as teaching assistants and future chemical engineering instructors. Topics include classroom and laboratory instruction, grading, and developing a teaching philosophy.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Chemical Engineering Teaching Practicum: Teaching Experience",
    "dept": "CH E",
    "num": "698B",
    "desc": "Prereq: CH E 698A\nParticipation in the instruction of a CH E course under the mentorship of a CBE faculty member. Typical activities may include lecture preparation and delivery, laboratory instruction, design of assessments, problem-solving sessions, office hours, and grading.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "CH E",
    "num": "699",
    "desc": "\nAdvanced topic for thesis/dissertation.\n",
    "credits": "arr"
  },
  {
    "course_name": "Preparation for College Chemistry",
    "dept": "CHEM",
    "num": "050",
    "desc": "Prereq: 1 year high school algebra\nAn in-depth active learning experience designed to impart the fundamental concepts and principles of chemistry, with an emphasis on mathematics skills and logical thinking. For students intending to enroll in general chemistry and who have not taken high school chemistry or who have not had a high school college preparatory chemistry course who need a review of chemical problem solving and chemical concepts.\n  Credit for Chem 50 does not count toward graduation.",
    "credits": "0"
  },
  {
    "course_name": "Chemistry Learning Community Orientation",
    "dept": "CHEM",
    "num": "101",
    "desc": "Prereq: Member of the Chemistry Learning Community.\nIntegration of first year and transfer students into the chemistry program. Introduction and overview of  degree requirements and support services on campus, assistance with transition to college and community life, and team-building and leadership activities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Chemistry Learning Community Orientation: On-Campus Orientation",
    "dept": "CHEM",
    "num": "101A",
    "desc": "Prereq: Member of the Chemistry Learning Community.\nIntegration of first year and transfer students into the chemistry program. Introduction and overview of  degree requirements and support services on campus, assistance with transition to college and community life, and team-building and leadership activities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Chemistry Learning Community Orientation: Professional Development Opportunities",
    "dept": "CHEM",
    "num": "101B",
    "desc": "Prereq: Member of the Chemistry Learning Community.\nIntegration of first year and transfer students into the chemistry program. Introduction and overview of  degree requirements and support services on campus, assistance with transition to college and community life, and team-building and leadership activities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Physical Sciences for Elementary Education",
    "dept": "CHEM",
    "num": "102L",
    "desc": "Prereq: MATH 195 or MATH 140\nPhysical science principles for future elementary teachers.  Emphasis on experiments that address current elementary science education standards and that are appropriate for their future students to do, such as measurements of mass, length, time, light from atoms, charge and current, motion due to forces, energy and work, heat, waves, optics, building bridges and making musical instruments, studying states of matter and chemical reactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Cutting-Edge Chemistry: Research and Career Opportunities",
    "dept": "CHEM",
    "num": "110",
    "desc": "\nOverview of careers in chemistry: industrial, governmental, and academic careers; literature and compound search instruction; professional ethics; and an introduction to joining a research lab.  For students majoring or minoring in chemistry or chemistry-related fields.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Chemistry in Modern Society",
    "dept": "CHEM",
    "num": "160",
    "desc": "\nAspects of chemistry visible to a non-scientist in our society. A survey of selected areas of chemistry with emphasis on the interface between chemistry and other fields of human activity.\n",
    "credits": "3"
  },
  {
    "course_name": "College Chemistry",
    "dept": "CHEM",
    "num": "163",
    "desc": "Prereq: 1 year of high school algebra and geometry and Chem 50 or 1 year of high school chemistry; and credit or enrollment in CHEM 163L\nA general survey of chemistry with an emphasis on conceptual problems for those who are not physical and biological science or engineering majors. Nomenclature, chemical reactions, stoichiometry, atomic structure, periodic properties, chemical bonding, states of matter, solutions, thermochemistry, acid-base theory, oxidation-reduction reactions, basic chemical kinetics, and chemical equilibrium.\n  Only one of Chem 163, 167, 177, or 201 may count toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Laboratory in College Chemistry",
    "dept": "CHEM",
    "num": "163L",
    "desc": "Prereq: Credit or enrollment for credit in CHEM 163\nLaboratory to accompany CHEM 163. Must be taken with CHEM 163.\n  Only one of Chem 163L, CHEM 167L, and CHEM 177L may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "General Chemistry for Engineering Students",
    "dept": "CHEM",
    "num": "167",
    "desc": "Prereq: 1 year of high school chemistry or CHEM 50 and MATH 143 pre-calculus or high school equivalent.\nPrinciples of chemistry and properties of matter explained in terms of modern chemical theory with emphasis on topics of general interest to the engineer.\n  Only one of Chem 163, 167, 177, or 201 may count toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Laboratory in General Chemistry for Engineering",
    "dept": "CHEM",
    "num": "167L",
    "desc": "Prereq: Credit or enrollment for credit in CHEM 167\nLaboratory to accompany 167.\n  Only one of Chem 163L, 167L, and 177L may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "General Chemistry I",
    "dept": "CHEM",
    "num": "177",
    "desc": "Prereq: MATH 140 or high school equivalent, and CHEM 50 or 1 year high school chemistry, and credit or enrollment in CHEM 177L. Chemistry and biochemistry majors may consider taking CHEM 201\nThe first semester of a two semester sequence which explores chemistry at a greater depth and with more emphasis on concepts, problems, and calculations than 163. Recommended for physical and biological science majors, chemical engineering majors, and all others intending to take 300-level chemistry courses. Principles and quantitative relationships, stoichiometry, chemical equilibrium, acid-base chemistry, thermochemistry, rates and mechanism of reactions, changes of state, solution behavior, atomic structure, periodic relationships, chemical bonding.\n  Only one of Chem 163, 167, 177, or 201 may count toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Laboratory in General Chemistry I",
    "dept": "CHEM",
    "num": "177L",
    "desc": "Prereq: Credit or enrollment for credit in CHEM 177\nLaboratory to accompany 177. 177L must be taken with 177.\n  Only one of Chem 163L, 167L, and 177L may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Laboratory in General Chemistry I",
    "dept": "CHEM",
    "num": "177N",
    "desc": "Prereq: Credit or enrollment for credit in CHEM 177. For chemistry and biochemistry majors\nLaboratory to accompany CHEM 177. CHEM 177N must be taken with CHEM 177.\n  Only one of Chem 163L, CHEM 167L, and CHEM 177N may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "General Chemistry II",
    "dept": "CHEM",
    "num": "178",
    "desc": "Prereq: CHEM 177, CHEM 177L\nContinuation of 177. Recommended for physical or biological science majors, chemical engineering majors, and all others intending to take 300-level chemistry courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in College Chemistry II",
    "dept": "CHEM",
    "num": "178L",
    "desc": "Prereq: CHEM 177L and credit or enrollment for credit in CHEM 178\nLaboratory to accompany 178. 178L is not a necessary co-requisite with 178.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced General Chemistry",
    "dept": "CHEM",
    "num": "201",
    "desc": "Prereq: Co-enrollment in MATH 165 or credit, one year of high school chemistry, and one year high school physics or advanced chemistry. Co-enrollment in CHEM 201L.\nA one-semester course in general chemistry designed to give students an in-depth, broad-based view of modern chemistry, and, in part, to facilitate participation in independent undergraduate research.  Topics include stoichiometry, atomic and molecular structure, chemical bonding, kinetics, chemical equilibria, and thermodynamics.  Discussion of current trends in various chemical disciplines, which may be given by guest experts in chemistry, biochemistry, and chemical engineering, will help the student appreciate the scope of the chemical sciences and how research is carried out.\n  Only one of Chem 163, 167, 177, or 201 may count toward graduation.",
    "credits": "5"
  },
  {
    "course_name": "Laboratory in Advanced General Chemistry",
    "dept": "CHEM",
    "num": "201L",
    "desc": "Prereq: Credit or enrollment for credit in CHEM 201\nLaboratory to accompany 201. Introductory lab experience in synthesis and analysis to prepare students for research activities. 201L must be taken with 201.\n  Only one of 163L, 167L, 177L, 177N or 201L may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Quantitative and Environmental Analysis",
    "dept": "CHEM",
    "num": "211",
    "desc": "Prereq: CHEM 163 and CHEM 163L, CHEM 201 and CHEM 201L; or credit or enrollment in CHEM 178; and concurrent enrollment in CHEM 211L\nTheory and practice of elementary volumetric, chromatographic, electrochemical and spectrometric methods of analysis. Chemical equilibrium, sampling, and data evaluation. Emphasis on environmental analytical chemistry; the same methods are widely used in biological and materials sciences as well.\n",
    "credits": "2"
  },
  {
    "course_name": "Quantitative and Environmental Analysis Laboratory",
    "dept": "CHEM",
    "num": "211L",
    "desc": "Prereq: Credit or enrollment for credit in CHEM 211\nIntroductory laboratory experience in volumetric, spectrometric, electrochemical and chromatographic methods of chemical analysis.\n",
    "credits": "2"
  },
  {
    "course_name": "Elementary Organic Chemistry",
    "dept": "CHEM",
    "num": "231",
    "desc": "Prereq: CHEM 163, CHEM 163L, or CHEM 177, CHEM 177L; credit or enrollment in CHEM 231L\nA survey of modern organic chemistry including nomenclature, structure and bonding, and reactions of hydrocarbons and important classes of natural and synthetic organic compounds. For students desiring only an elementary course in organic chemistry. Students in physical or biological sciences and premedical or preveterinary curricula should take the full year sequence 331 and 332 (with the accompanying laboratories 331L and 332L).\n  Only one of Chem 231 and 331 or BBMB 221 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Elementary Organic Chemistry",
    "dept": "CHEM",
    "num": "231L",
    "desc": "Prereq: Credit or enrollment for credit in CHEM 231; CHEM 163L or CHEM 177L\nLaboratory to accompany 231. 231L must be taken with 231.\n  Only one of Chem 231L and 331L may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "CHEM",
    "num": "298",
    "desc": "Prereq: Permission of the Department cooperative education coordinator; sophomore classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Undergraduate Research (for Freshmen and Sophomores)",
    "dept": "CHEM",
    "num": "299",
    "desc": "Prereq: Permission of staff member with whom student proposes to work\n",
    "credits": "arr"
  },
  {
    "course_name": "Inorganic Chemistry",
    "dept": "CHEM",
    "num": "301",
    "desc": "Prereq: CHEM 324\nAtomic and molecular structure and bonding principles; molecular shapes and symmetry; acids and bases; solid-state structures and properties; inorganic chemistry of H, B, C.\n",
    "credits": "2"
  },
  {
    "course_name": "Instrumental Methods of Chemical Analysis",
    "dept": "CHEM",
    "num": "316",
    "desc": "Prereq: CHEM 211, CHEM 211L, MATH 166, and concurrent enrollment in CHEM 316L; PHYS 222 recommended\nQuantitative and qualitative instrumental analysis. Operational theory of instruments, atomic and molecular absorption and emission spectroscopy, electroanalysis, mass spectrometry, liquid and gas chromatography, electrophoresis, literature of chemical analysis.\n",
    "credits": "2"
  },
  {
    "course_name": "Instrumental Analysis Laboratory",
    "dept": "CHEM",
    "num": "316L",
    "desc": "Prereq: Credit or enrollment in CHEM 316\nAdvanced laboratory experience in UV-visible spectrophotometry, atomic absorption and emission spectrometry, electrochemistry, gas and liquid chromatography, electrophoresis, mass spectrometry, and other instrumental methods.\n",
    "credits": "2"
  },
  {
    "course_name": "Laboratory in Physical Chemistry",
    "dept": "CHEM",
    "num": "321L",
    "desc": "Prereq: Credit or enrollment in CHEM 324 or CHEM 325.\nError analysis; use of computers for interfacing to experiments and for data analysis; thermodynamics, infrared and optical spectroscopy, lasers. Not applicable towards the B.S. degree in Chemistry.\n  Only one of Chem 321L and 322L may count toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Laboratory in Physical Chemistry",
    "dept": "CHEM",
    "num": "322L",
    "desc": "Prereq: CHEM 324 or CHEM 325.\nError analysis; use of computers for interfacing to experiments and for data analysis; thermodynamics, surface science, infrared and optical spectroscopy, lasers.\n  Only one of Chem 321L and 322L may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Introductory Quantum Mechanics",
    "dept": "CHEM",
    "num": "324",
    "desc": "Prereq: CHEM 178, MATH 166; PHYS 222 recommended.\nQuantum mechanics, atomic and molecular structure, spectroscopy, kinetic theory of gases, chemical kinetics.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Thermodynamics",
    "dept": "CHEM",
    "num": "325",
    "desc": "Prereq: CHEM 178, MATH 166; PHYS 222 recommended\nClassical thermodynamics 1st, 2nd, and 3rd laws with applications to gases and interfacial systems, multicomponent, multiphase equilibrium of reacting systems, surface chemistry, and electrochemical cells. Students taking a two-semester physical chemistry sequence are advised to take 324 first; in the spring semester, a molecular-based section of this course, stressing statistical thermodynamics, is offered for which knowledge of 324 is useful.\n",
    "credits": "3"
  },
  {
    "course_name": "Organic Chemistry I",
    "dept": "CHEM",
    "num": "331",
    "desc": "Prereq: CHEM 178 or CHEM 201, enrollment in CHEM 331L highly recommended\nThe first half of a two semester sequence. Modern organic chemistry including nomenclature, synthesis, structure and bonding, reaction mechanisms. For students majoring in physical and biological sciences, premedical and pre-veterinary curricula, chemistry and biochemistry. Students desiring only one semester of organic chemistry should take 231 and 231L, not 331.\n  Only one of Chem 231 and 331 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Organic Chemistry I",
    "dept": "CHEM",
    "num": "331L",
    "desc": "Prereq: CHEM 177L; credit or enrollment for credit in CHEM 331\nLaboratory to accompany 331. Chemistry and biochemistry majors are encouraged to take 333L.\n  Only one of Chem 231L and 331L may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Organic Chemistry II",
    "dept": "CHEM",
    "num": "332",
    "desc": "Prereq: CHEM 331; enrollment in CHEM 332L highly recommended\nContinuation of 331. Modern organic chemistry including nomenclature, synthesis, structure and bonding, reaction mechanisms, natural products, carbohydrates and proteins. For students majoring in physical and biological sciences, premedical and pre-veterinary curricula, chemistry and biochemistry.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Organic Chemistry II",
    "dept": "CHEM",
    "num": "332L",
    "desc": "Prereq: CHEM 331L; credit or enrollment for credit in CHEM 332\nLaboratory to accompany 332. Chemistry and biochemistry majors are encouraged to take 334L.\n",
    "credits": "1"
  },
  {
    "course_name": "Laboratory in Organic Chemistry I (for Chemistry and Biochemistry Majors)",
    "dept": "CHEM",
    "num": "333L",
    "desc": "Prereq: Credit or enrollment for credit in CHEM 331\nLaboratory to accompany 331 for chemistry and biochemistry majors.\n",
    "credits": "2"
  },
  {
    "course_name": "Laboratory in Organic Chemistry II (for Chemistry and Biochemistry Majors)",
    "dept": "CHEM",
    "num": "334L",
    "desc": "Prereq: CHEM 333L, credit or enrollment for credit in CHEM 332\nLaboratory to accompany 332 for chemistry and biochemistry majors.\n",
    "credits": "2"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "CHEM",
    "num": "398",
    "desc": "Prereq: Permission of the Department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "CHEM",
    "num": "399",
    "desc": "Prereq: Permission of instructor  with whom student proposes to work and junior or senior classification\nUndergraduate research.\n  No more than six total credits of Chem 399 and Chem 499 may count toward graduation. Credits earned in 399/499/490 may only be use to meet one of the advanced course requirements for the B.S. degree.",
    "credits": "arr"
  },
  {
    "course_name": "Inorganic Chemistry Laboratory",
    "dept": "CHEM",
    "num": "401L",
    "desc": "Prereq: CHEM 402\nPreparation and characterization of inorganic and organometallic compounds by modern techniques. For students majoring in chemistry or biochemistry.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Inorganic Chemistry",
    "dept": "CHEM",
    "num": "402",
    "desc": "Prereq: CHEM 301; CHEM 331 recommended\nChemistry of the d and f metals. Structure, bonding, electronic spectra, and reaction mechanisms. Aspects of organometallic solid state and bioinorganic chemistry.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "CHEM",
    "num": "490",
    "desc": "Prereq: Completion of 6 credits in chemistry at the 300 level or higher and permission of instructor\n  No more than 9 credits of Chem 490 may count toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "CHEM",
    "num": "498",
    "desc": "Prereq: Permission of the Department cooperative education coordinator; senior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Senior Research",
    "dept": "CHEM",
    "num": "499",
    "desc": "Prereq: Permission of instructor with whom student proposes to work; B average in all chemistry, physics, and mathematics courses\nResearch in chosen area of chemistry, with final written report as senior thesis. This course should be elected for two consecutive semesters. For students majoring in chemistry.\n  No more than six total credits for Chem 399 and 499 may count toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Inorganic Preparations",
    "dept": "CHEM",
    "num": "501L",
    "desc": "Prereq: CHEM 402\nPreparation and characterization of inorganic and organometallic compounds by modern research techniques.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Inorganic Chemistry",
    "dept": "CHEM",
    "num": "502",
    "desc": "Prereq: CHEM 402; CHEM 331 recommended\nChemistry of the main group (s, p) and transition (d, f) metals. Structure, bonding, electronic spectra, and reaction mechanisms. Aspects of organometallic, solid state, bioinorganic, and nano chemistry.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Inorganic Chemistry",
    "dept": "CHEM",
    "num": "505",
    "desc": "Prereq: CHEM 402 or CHEM 502 and CHEM 324\nElementary group theory and molecular orbital theory applied to inorganic chemistry. Spectroscopic methods of characterization of inorganic compounds and organometallic compounds.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Analytical Chemistry",
    "dept": "CHEM",
    "num": "511",
    "desc": "Prereq: CHEM 316 and CHEM 316L\nGeneral methods of quantitative inorganic and organic analysis. Aqueous and nonaqueous titrimetry; selective reagents; sampling and sample dissolution; modern instrumentation; sensors; atomic and molecular microscopy; bioanalytical methods; data evaluation; chemometrics; and analytical literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Electrochemical Methods of Analysis",
    "dept": "CHEM",
    "num": "512",
    "desc": "Prereq: CHEM 316 and CHEM 316L; Recommended but not Required CHEM 324, and CHEM 322L\nPrinciples of convective-diffusional mass transport in electroanalysis. Applications of potentiometry, voltammetry, and coulometry. Introduction to heterogeneous and homogeneous kinetics in electroanalysis. Analog and digital circuitry. Interfacing.\n",
    "credits": "3"
  },
  {
    "course_name": "Analytical Molecular and Atomic Spectroscopy",
    "dept": "CHEM",
    "num": "513",
    "desc": "Prereq: CHEM 316 and CHEM 316L, CHEM 324, CHEM 322L\nIntroduction to physical optics and design of photometric instruments. Principles of absorption, emission, fluorescence, and Raman spectroscopy. Error and precision of optical methods. Ultraviolet, visible, and infrared methods of qualitative and quantitative organic and inorganic analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Analytical Separations",
    "dept": "CHEM",
    "num": "516",
    "desc": "Prereq: CHEM 316 and CHEM 316L, CHEM 324, CHEM 322L\nPrinciples and examples of inorganic and organic separation methods applied to analytical chemistry. Solvent extraction, volatilization, ion exchange, liquid and gas chromatography, and electrophoresis.\n",
    "credits": "3"
  },
  {
    "course_name": "Organic Synthesis I",
    "dept": "CHEM",
    "num": "531",
    "desc": "Prereq: CHEM 332\nSurvey of organic functional group transformations.\n",
    "credits": "2"
  },
  {
    "course_name": "Organic Synthesis II",
    "dept": "CHEM",
    "num": "532",
    "desc": "Prereq: CHEM 531\nSynthesis of complex organic compounds including natural products.\n",
    "credits": "2"
  },
  {
    "course_name": "Physical Organic Chemistry I",
    "dept": "CHEM",
    "num": "537",
    "desc": "Prereq: CHEM 332\nSurvey of reactive intermediates including cations, anions, carbenes, and radicals.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Organic Chemistry II",
    "dept": "CHEM",
    "num": "538",
    "desc": "Prereq: CHEM 537\nMolecular structure, stereochemistry, introduction to reaction mechanisms, thermodynamic and kinetic data, linear free energy relationships, isotope effects, orbital symmetry.\n",
    "credits": "3"
  },
  {
    "course_name": "Safety in the Chemical Laboratory",
    "dept": "CHEM",
    "num": "550",
    "desc": "Prereq: CHEM 332L\nIntroduction to laboratory safety and chemical hygiene. Use of engineering controls and personal protective equipment. Chemical storage and waste disposal practices. Handling hazardous chemicals. Radiation safety and laser safety.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Teaching College Chemistry",
    "dept": "CHEM",
    "num": "555",
    "desc": "Prereq: Graduate or senior classification.\nMethods of instruction, strategies and techniques for effective teaching and learning along with practice teaching in undergraduate chemistry recitation and laboratory courses. Cooperative learning, guided-inquiry, learning cycles, conceptual change, models and modeling, concept maps, visualization, computer simulations, web-based delivery systems, and learning theories.\n",
    "credits": "2"
  },
  {
    "course_name": "Fundamentals of Quantum Mechanics",
    "dept": "CHEM",
    "num": "561",
    "desc": "Prereq: CHEM 324\nSchroedinger equation and exact solutions; square wells and barriers; harmonic oscillator; the hydrogen atom; atomic orbitals; operators including angular momenta; time-independent and time-dependent perturbation theory; Schroedinger and Heisenberg representations; unitary operators; interaction picture, density matrix.\n",
    "credits": "4"
  },
  {
    "course_name": "Fundamentals of Atomic and Molecular Quantum Mechanics",
    "dept": "CHEM",
    "num": "562",
    "desc": "Prereq: CHEM 561, credit or enrollment in CHEM 583\nVariational method, many electron atoms; addition of angular momentum, self-consistent field method for open and closed shells, linear combinations of atomic orbitals, origin of chemical bonding, many-electron diatomic and polyatomic molecules, treatments of electron correlation, approximation methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Mechanics",
    "dept": "CHEM",
    "num": "563",
    "desc": "Prereq: CHEM 325\nMicroscopic and macroscopic properties, laws of thermodynamics, ensembles and distribution functions, applications to gases, solids, and chemical equilibrium.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Spectroscopy and Structure",
    "dept": "CHEM",
    "num": "564",
    "desc": "Prereq: CHEM 505 or CHEM 562\nMaxwell's field equations, interaction of light with matter including time-dependent perturbation theory, microwave, vibrational (infra-red, Raman) and electronic spectroscopies, symmetry derived selection rules, special lineshapes and introduction to nonlinear and coherent laser spectroscopies.\n",
    "credits": "3"
  },
  {
    "course_name": "Solid-State Chemistry",
    "dept": "CHEM",
    "num": "571",
    "desc": "Prereq: CHEM 301, CHEM 324\nStructural principles, synthetic strategies, analytical methods, and chemical bonding issues applied to solids.  Atomic packings and networks, short-range vs. long-range order, defects; phase diagrams, reactive fluxes, chemical transport; diffraction, spectroscopy; energy bands and their bonding interpretations.\n",
    "credits": "2"
  },
  {
    "course_name": "Spectrometric Identification of Organic Compounds",
    "dept": "CHEM",
    "num": "572",
    "desc": "Prereq: CHEM 332\nPrinciples of infrared, ultraviolet, nuclear magnetic resonance, and mass spectroscopy as applied to organic chemistry.\n",
    "credits": "3"
  },
  {
    "course_name": "Nanochemistry",
    "dept": "CHEM",
    "num": "573",
    "desc": "Prereq: CHEM 301, CHEM 324\nSynthesis, characterization, properties and applications of nanoscale materials (≈ 0.5-500 nm), relationship with molecular, meso and bulk compounds. Chemistry of solid surfaces, zero-, one- and two-dimensional (0D, 1D, 2D) nanostructures , semiconductor quantum dots, plasmonic nanoparticles, carbon nanomaterials, porous nanomaterials, potential health and safety impacts.\n",
    "credits": "2"
  },
  {
    "course_name": "Organometallic Chemistry of the Transition Metals",
    "dept": "CHEM",
    "num": "574",
    "desc": "Prereq: CHEM 301, CHEM 332\nTransition metal complexes with ligands such as cyclopentadienyl, olefins, acetylenes, benzenes, and carbon monoxide. Coverage of structure, bonding, reactivity, fundamental mechanisms, and homogeneous catalysis.\n",
    "credits": "2"
  },
  {
    "course_name": "Surface Chemistry",
    "dept": "CHEM",
    "num": "576",
    "desc": "Prereq: CHEM 324\nGas-surface interactions and techniques of characterization. Idealized surface lattices, surface tension, Wulff plots, work function, adsorbate-adsorbate interactions, 2D phase diagrams, diffusion, thin film growth, adsorption and desorption mechanisms/energetics/kinetics, adsorption isotherms, vacuum techniques, electron- and ion-based spectroscopies for surface analysis (including AES, FIM, XPS, UPS, EXAFS, EELS, SIMS, LEED and STM).\n",
    "credits": "3"
  },
  {
    "course_name": "Mass Spectrometry",
    "dept": "CHEM",
    "num": "577",
    "desc": "\nBasic physics, instrumentation, chemical and biological applications of mass spectrometry.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Kinetics and Mechanisms",
    "dept": "CHEM",
    "num": "578",
    "desc": "Prereq: CHEM 324\nRates and mechanisms; reversible, consecutive, and competing reactions; chain mechanisms; kinetic isotope effects; very rapid reactions; acid-base catalysis, theories of unimolecular reactions; transition state and Marcus theories.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Research in Chemistry",
    "dept": "CHEM",
    "num": "579",
    "desc": "\nIntroduction to the various areas of research in chemistry at Iowa State University.\n",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Computational Quantum Chemistry",
    "dept": "CHEM",
    "num": "580",
    "desc": "Prereq: CHEM 324\nBasic principles of quantum mechanics, schrodinger equation. Hartree-Fock/molecular orbital theory, introduction to group theory, introduction to modern methods of computational chemistry; applications include molecular structure, potential energy surfaces and their relation to chemical reactions; molecular spectroscopy, photochemistry, solvent effects and surface chemistry.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical Group Theory",
    "dept": "CHEM",
    "num": "583",
    "desc": "Prereq: CHEM 324\nBasic concepts and theorems, representation theory; point groups, molecular orbitals, molecular states, molecular vibrations, rotation group and angular momenta; space groups and crystals; permutation group, antisymmetry, and spin states.\n",
    "credits": "1"
  },
  {
    "course_name": "Nonthesis Research",
    "dept": "CHEM",
    "num": "599",
    "desc": "Prereq: Permission of instructor concerned\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Inorganic Chemistry",
    "dept": "CHEM",
    "num": "600",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Selected Topics in Inorganic Chemistry",
    "dept": "CHEM",
    "num": "601",
    "desc": "Prereq: Permission of instructor\nTopics such as molecular structure and bonding; organometallic compounds; physical techniques of structure determination; nonaqueous solutions; Zintl phases; transition-metal oxides; free-radical reactions; electron transfer reactions; metal-metal bonding; and bioinorganic chemistry of nucleic acids.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Analytical Chemistry",
    "dept": "CHEM",
    "num": "611",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Analytical Chemistry",
    "dept": "CHEM",
    "num": "619",
    "desc": "Prereq: Permission of instructor\nRaman spectroscopy, sensors, spectroelectrochemistry, capillary electrophoresis, analytical plasmas, chemometrics and bioanalytical chemistry.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Organic Chemistry",
    "dept": "CHEM",
    "num": "631",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Selected Topics in Organic Chemistry",
    "dept": "CHEM",
    "num": "632",
    "desc": "Prereq: CHEM 537\nTopics of current interest in organic chemistry such as spectroscopy, physical organic chemistry, photochemistry, organometallic chemistry, mechanisms of oxidations and reductions, modern organic synthesis, reactive intermediates, bioorganic chemistry, and polymers.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Physical Chemistry",
    "dept": "CHEM",
    "num": "660",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Physical Chemistry",
    "dept": "CHEM",
    "num": "667",
    "desc": "Prereq: Permission of instructor\nAdvanced and recent developments in physical chemistry are selected for each offering.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "CHEM",
    "num": "699",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Elementary Mandarin Chinese I",
    "dept": "CHIN",
    "num": "101",
    "desc": "\nIntroduction to spoken and written colloquial Mandarin through pinyin and simplified characters.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Mandarin Chinese II",
    "dept": "CHIN",
    "num": "102",
    "desc": "Prereq: CHIN 101\nIntroduction to spoken and written colloquial Mandarin through pinyin and simplified characters.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Mandarin Chinese I",
    "dept": "CHIN",
    "num": "201",
    "desc": "Prereq: CHIN 102\nDevelopment of speaking, writing, reading, and listening skills. Review and expansion of grammar skills, intensification of character acquisition.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Mandarin Chinese II",
    "dept": "CHIN",
    "num": "202",
    "desc": "Prereq: CHIN 201\nDevelopment of speaking, writing, reading, and listening skills. Review and expansion of grammar skills, intensification of character acquisition.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Chinese Culture",
    "dept": "CHIN",
    "num": "272",
    "desc": "\nInterdisciplinary introduction to Chinese society and culture from earliest times to the present. Topics include ancient literature, philosophy, religion, art, architecture, customs, transition to a modern society, social changes, urban life, popular culture, and contemporary values and ideas.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Mandarin Chinese I",
    "dept": "CHIN",
    "num": "301",
    "desc": "Prereq: CHIN 202 or equivalent\nContinuing development of speaking, writing, reading, and listening skills beyond intermediate level. Expansion of cultural literacy through a variety of texts from the humanities, social sciences, mass media and business.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Mandarin Chinese II",
    "dept": "CHIN",
    "num": "302",
    "desc": "Prereq: CHIN 301 or equivalent\nContinuing development of speaking, writing, reading, and listening skills beyond intermediate level. Expansion of cultural literacy through a variety of texts from the humanities, social sciences, mass media and business.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Chinese for Global Professionals",
    "dept": "CHIN",
    "num": "304",
    "desc": "Prereq: CHIN 202 or equivalent\nIntroduction to professional language and culture in China and Chinese-speaking regions in Asia. Development of all four language skills, focusing on practical applications in the professional contexts. Development of global awareness and cross-cultural understanding. Preparation for internships.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Chinese Literature in English Translation",
    "dept": "CHIN",
    "num": "370",
    "desc": "Prereq: ENGL 150 or equivalent\nTopics may include traditional prose, poetry, novel and drama; twentieth-century fiction and film. All readings and class discussions in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "China Today",
    "dept": "CHIN",
    "num": "375",
    "desc": "Prereq: ENGL 250 or equivalent\nFocusing on contemporary society, culture, literature and the arts. All readings, discussions, and papers in English. Topics vary from year to year.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Chinese Film and Society",
    "dept": "CHIN",
    "num": "378",
    "desc": "Prereq: ENGL 150 or equivalent\nSurvey of Chinese cinematic history from 1896 to the present against the background of China’s constant sociocultural transformation; emphasis on narrative themes, film history, and film criticism. Topics vary according to faculty interest.  Taught in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Chinese Language and Culture",
    "dept": "CHIN",
    "num": "403",
    "desc": "Prereq: CHIN 302 or equivalent\nCritical understanding of authentic texts at the advanced level through reading, translation, and/or application in professional contexts; consolidation of existing language skills, in-depth analysis of cultural issues, and development of professional language proficiency. Taught in Chinese.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Chinese Language and Culture: Translating Contemporary Chinese Texts",
    "dept": "CHIN",
    "num": "403A",
    "desc": "Prereq: CHIN 302\nCritical understanding of authentic texts at the advanced level through reading, translation, and/or application in professional contexts; consolidation of existing language skills, in-depth analysis of cultural issues, and development of professional language proficiency. Taught in Chinese.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Chinese Language and Culture: Topics on Business and Professions",
    "dept": "CHIN",
    "num": "403B",
    "desc": "Prereq: CHIN 302 or equivalent\nCritical understanding of authentic texts at the advanced level through reading, translation, and/or application in professional contexts; consolidation of existing language skills, in-depth analysis of cultural issues, and development of professional language proficiency. Taught in Chinese.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Chinese Language and Culture: Reading Chinese Texts",
    "dept": "CHIN",
    "num": "403C",
    "desc": "Prereq: CHIN 302 or equivalent\nCritical understanding of authentic texts at the advanced level through reading, translation, and/or application in professional contexts; consolidation of existing language skills, in-depth analysis of cultural issues, and development of professional language proficiency. Taught in Chinese.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "CHIN",
    "num": "490",
    "desc": "Prereq: 6 credits in Chinese and permission of department chair\nDesigned to meet student needs in areas beyond current course offerings or to accommodate the desire to integrate a study of literature or language with special issues in major fields.\n",
    "credits": "1"
  },
  {
    "course_name": "Internship in Chinese",
    "dept": "CHIN",
    "num": "499",
    "desc": "Prereq: 9 credits of Chinese at the 300 level; permission of adviser and WLC Internship Coordinator\nWork experience using Chinese in the public or private sector, combined with academic work under faculty supervision.\n  Offered on a satisfactory-fail basis only.  No more than 3 credits may apply toward the Chinese minor or LCP minor.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to the Civil Engineering Profession",
    "dept": "C E",
    "num": "105",
    "desc": "\nOverview of the civil engineering profession in regards to its nature and scope. Exploration of the various specialty areas within civil engineering through team activities.  Review and guidance in relation to academic degree options, career avenues and professional practices involving communication, teamwork, leadership, ethics, networking, life-long-learning goals, and mentoring.\n",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Surveying I",
    "dept": "C E",
    "num": "111",
    "desc": "Prereq: MATH 165, C E 160, credit or enrollment in C E 170\nIntroduction to error theory. Fundamentals of observing distances, elevations, and angles. Traversing. Irregular areas. Circular and parabolic curves. Earthwork including mass diagrams. Construction staking. Computer applications and introduction to photogrammetry, geographic information systems and global positioning systems technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Civil Engineering Learning Community",
    "dept": "C E",
    "num": "120",
    "desc": "\nIntegration of first-year students into the Civil Engineering program.  Assignments and activities involving teamwork, academic preparation, study skills, and preparation for entry into the Civil Engineering profession.  Completed both individually and in learning teams under the direction of faculty and peer mentors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Engineering Problems with Computational Laboratory",
    "dept": "C E",
    "num": "160",
    "desc": "Prereq: Credit or enrollment in MATH 165\nFormulation of engineering problems using spreadsheets and Visual Basic for Application for solution. Presenting results using word processing, tables, and graphs. Introduction to engineering economics and statics. Civil engineering examples.\n  Only one of ENGR 160, A B E 160, AER E 160, C E 160, CH E 160, CPR E 185, E E 185, I E 148, M E 160 and S E 185 may count towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Graphics for Civil Engineering",
    "dept": "C E",
    "num": "170",
    "desc": "\nFundamental graphics. Introduction to computer aided drafting and modeling. Civil engineering applications.\n",
    "credits": "2"
  },
  {
    "course_name": "Engineering Economic Analysis and Professional Issues in Civil Engineering",
    "dept": "C E",
    "num": "206",
    "desc": "Prereq: MATH 166, ENGL 250; C E 105; ECON 101 recommended\nEngineering/managerial analysis of the economic aspects of project proposals. Alternative sources of funds; time value of money; expenditure of capital funds and methods of evaluating alternative projects. Professionalism, licensure, liability, ethics, leadership, social responsibility, creative and critical thinking, and applications/impacts of regulations in civil engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Project Management for Civil Engineers",
    "dept": "C E",
    "num": "306",
    "desc": "Prereq: ENGL 250, C E 105\nProject management, including work breakdown structures, cost estimating, scheduling, and project control. Civil engineering project life cycle, including planning, design, construction, and maintenance processes. Techniques in interpretation of contract documents, plan reading, and in estimating quantities.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Environmental Engineering",
    "dept": "C E",
    "num": "326",
    "desc": "Prereq: CHEM 177 or CHEM 178, MATH 166, credit or enrollment in E M 378\nIntroduction to environmental problems, water quality indicators and requirements, potable water quality and quantity objectives, water sources and treatment methods; water pollution control objectives and treatment methods; survey of solid and hazardous waste management and air pollution control.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Analysis I",
    "dept": "C E",
    "num": "332",
    "desc": "Prereq: E M 324\nLoads, shear, moment, and deflected shape diagrams for beams and framed structures. Deformation calculations. Approximate methods. Application of consistent deformation  methods to continuous beams and frames. Application of displacement or slope deflection methods to continuous beams and frames without sway. Influence lines for determinate and indeterminate structures. Computer applications to analyze beams and frames. Validation of computer results.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Steel Design I",
    "dept": "C E",
    "num": "333",
    "desc": "Prereq: C E 332, E M 327\nAISC design methods for structural steel buildings. Design of steel tension members. Design of steel members for flexure. Design of members for compression. Beam-Column member design. Introduction to steel building systems. Steel moment frames and concentrically braced frames. Design of commonly used connections in steel buildings.\n",
    "credits": "3"
  },
  {
    "course_name": "Reinforced Concrete Design I",
    "dept": "C E",
    "num": "334",
    "desc": "Prereq: C E 332, E M 327\nACI design methods for structural concrete members. Emphasis on the analysis and design for flexure of singly reinforced and doubly reinforced sections, T-section, one-way slabs, short columns, and isolated footings. Analysis and design for shear, and serviceability. Bond, anchorage, and development of reinforcement.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of  Transportation Engineering",
    "dept": "C E",
    "num": "355",
    "desc": "Prereq: C E 111\nIntroduction to planning, design, and operations of transportation facilities. Road user, vehicle and roadway characteristics. Technological, economic and environmental factors. Asset management, transportation planning, capacity analysis, traffic control, geometric design, traffic safety.\n",
    "credits": "3"
  },
  {
    "course_name": "Geotechnical Engineering",
    "dept": "C E",
    "num": "360",
    "desc": "Prereq: E M 324, credit or enrollment in GEOL 201\nIntroduction to geotechnical engineering and testing. Identification and classification tests, soil water systems, principles of settlement, stresses in soils, and shear strength testing; slope stability, retaining walls, bearing capacity.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Hydrology and Hydraulics",
    "dept": "C E",
    "num": "372",
    "desc": "Prereq: E M 378, a course in statistics from the approved department list\nThe hydrologic cycle: precipitation, infiltration, runoff, evapotranspiration, groundwater, and streamflow. Hydrograph analysis, flood routing, frequency analysis and urban hydrology. Applied hydraulics including pipe and channel flow with design applications in culverts, pumping, water distribution, storm and sanitary sewer systems. Design project required.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Concretes",
    "dept": "C E",
    "num": "382",
    "desc": "Prereq: E M 274\nPhysical and chemical properties of bituminous, portland, and other cements; aggregate properties and blending; mix design and testing of concretes; admixtures, mixing, handling, placing and curing; principles of pavement thickness design.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Portland Cement Concrete",
    "dept": "C E",
    "num": "383",
    "desc": "Prereq: E M 274\nFor Con E students only. Physical and chemical properties of portland cement and p.c. concrete. Mix design and testing of p.c. concrete.\n  Credit for both C E 382 and C E 383 may not be applied for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Sustainable Engineering and International Development",
    "dept": "C E",
    "num": "388",
    "desc": "Prereq: Junior classification in engineering\nMulti-disciplinary approach to sustainable engineering and international development, sustainable development, appropriate design and engineering, feasibility analysis, international aid, business development, philosophy and politics of technology, and ethics in engineering. Engineering-based projects from problem formulation through implementation. Interactions with partner community organizations or international partners such as nongovernment organizations (NGOs). Course readings, final project/design report.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Perspectives in Transportation",
    "dept": "C E",
    "num": "395",
    "desc": "Prereq: CE 355 or equivalent\nBackground on historical civil engineering design and construction.  Impacts of historical, cultural, social, economic, ethical, environmental, and political conditions on the design and construction of various infrastructure projects outside the United States.  Global road safety and intermodal operations.  Addressing transportation problems in a large metropolitan area.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Summer Internship",
    "dept": "C E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nSummer professional work period. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education (Co-op)",
    "dept": "C E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period.  One semester per academic or calendar year.  Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Program and Outcome Assessment",
    "dept": "C E",
    "num": "403",
    "desc": "Prereq: Verification of undergraduate application for graduation by the end of the first week of class. Permission of instructor for students who are scheduled for summer graduation\nAssessment of C E Curriculum and educational objectives. Assessments to be reviewed by the CE Department to incorporate potential improvements.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Applied and Environmental Geophysics",
    "dept": "C E",
    "num": "413",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nSeismic, gravity, magnetic, resistivity, electromagnetic, and ground-penetrating radar techniques for shallow subsurface investigations and imaging. Data interpretation methods. Lab emphasizes computer interpretation packages. Field work with seismic - and resistivity-imaging systems and radar.\n",
    "credits": "3"
  },
  {
    "course_name": "Land Surveying",
    "dept": "C E",
    "num": "417",
    "desc": "Prereq: C E 111\nLegal principles affecting the determination of land boundaries, public domain survey systems. Locating sequential and simultaneous conveyances. Record research, plat preparation, and land description. Study of selected court cases.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Engineering Chemistry",
    "dept": "C E",
    "num": "420",
    "desc": "Prereq: C E 326, CHEM 178\nPrinciples of chemical and physical phenomena applicable to the treatment of water and wastewater and natural waters; including chemical equilbria, reaction kinetics, acid-base equilibria, chemical precipitation, redox reactions, and mass transfer principles. Individual laboratory practicals and group projects required.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biotechnology",
    "dept": "C E",
    "num": "421",
    "desc": "Prereq: C E 326\nFundamentals of biochemical and microbial processes applied to environmental engineering processes, role of microorganisms in wastewater treatment and bioremediation, bioenergetics and kinetics, metabolism of xenobiotic compounds, waterborne pathogens and parasites, and disinfection. Term paper and oral presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Air Pollution",
    "dept": "C E",
    "num": "424",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Air quality and effects of pollutants",
    "dept": "C E",
    "num": "424A",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Climate change and causes",
    "dept": "C E",
    "num": "424B",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Transportation Air Quality",
    "dept": "C E",
    "num": "424C",
    "desc": "Prereq: C E 524A; PHYS 221 or CHEM 178; MATH 166 or 3 credits in statistics. Senior classification or above.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Off-gas treatment technology",
    "dept": "C E",
    "num": "424D",
    "desc": "Prereq: C E 524A, C E 524B; Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Agricultural sources of pollution",
    "dept": "C E",
    "num": "424E",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Water and Wastewater Treatment Plant Design",
    "dept": "C E",
    "num": "428",
    "desc": "Prereq: C E 326\nPhysical, chemical and biological processes for the treatment of water and wastewater including coagulation and flocculation, sedimentation, filtration, adsorption, chemical oxidation/disinfection, fixed film and suspended growth biological processes and sludge management.\n",
    "credits": "3"
  },
  {
    "course_name": "Seismic Methods in Geology, Engineering, and Petroleum Exploration",
    "dept": "C E",
    "num": "439",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nPhysics of elastic-wave propagation. Seismic surveys in environmental imaging, engineering, and petroleum exploration. Reflection and refraction techniques. Data collection, processing, and geological interpretation. Field work with state-of-the-art equipment.\n",
    "credits": "3"
  },
  {
    "course_name": "Bridge Design",
    "dept": "C E",
    "num": "446",
    "desc": "Prereq: C E 333, C E 334\nBridge design in structural steel and reinforced concrete. Application of AASHTO Bridge Design Specifications. Analysis techniques for complex structures. Preliminary designs include investigating alternative structural systems and materials. Final designs include preparation of design calculations and sketches.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Design",
    "dept": "C E",
    "num": "448",
    "desc": "Prereq: C E 333, C E 334\nBuilding design in structural steel and reinforced concrete. Investigation of structural behavior. Gravity and lateral load resisting systems. Application of current building codes and design specifications. In-depth analysis of gravity and wind loads on buildings. Review of building designs. Preliminary designs include investigating alternative structural systems. Approximate methods of structural analysis for gravity and lateral loads. Final designs include preparation of design calculations and sketches.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Health Monitoring",
    "dept": "C E",
    "num": "449",
    "desc": "Prereq: Senior classification in Engineering or permission of instructor\nIntroductory and advanced topics in structural health monitoring (SHM) of aeronautical, civil, and mechanical systems. Topics include sensors, signal processing in time and frequency domains, data acquisition and transmission systems, design of integrated SHM solutions, nondestructive evaluation techniques, feature extraction methods, and cutting-edge research in the field of SHM. Graduate students will have a supervisory role to assist students in 449 and an additional design project or more in-depth analysis and design.\n",
    "credits": "3"
  },
  {
    "course_name": "Urban Transportation Planning Models",
    "dept": "C E",
    "num": "451",
    "desc": "Prereq: C E 355, STAT 101 or STAT 105\nUrban transportation planning context and process. Project planning and programming. Congestion, mitigation, and air quality issues. Transportation data sources. Travel demand and network modeling. Use of popular travel demand software and applications of geographic information systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Highway Design",
    "dept": "C E",
    "num": "453",
    "desc": "Prereq: C E 306, C E 355\nIntroduction to highway planning and design. Design, construction, and maintenance of highway facilities. Level-of-service, stopping sight distance, highway alignment, earthwork and pavement design. Design project, oral reports and written reports. Computer applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundation Engineering",
    "dept": "C E",
    "num": "460",
    "desc": "Prereq: C E 360\nFundamentals of foundation engineering. Exploration, sampling, and in-situ tests. Shallow and deep foundations. Settlement and bearing capacity analyses. Stability of excavations and earth retaining structures.\n",
    "credits": "3"
  },
  {
    "course_name": "Geomaterials Stabilization",
    "dept": "C E",
    "num": "467",
    "desc": "Prereq: C E 360, C E 382 or C E 383\nSoil and aggregate physical, chemical and biological  stabilization procedures. Stabilization analysis and design.  Ground modification and compaction methods.  Geosynthetics application and design.\n",
    "credits": "3"
  },
  {
    "course_name": "Groundwater Hydrology",
    "dept": "C E",
    "num": "473",
    "desc": "Prereq: C E 372\nPrinciples of groundwater flow, hydraulics of wells, superposition, slug and pumping tests, streamlines and flownets, and regional groundwater flow. Contaminant transport. Computer modeling. Design project. Extra assignments required for graduate students.\n",
    "credits": "3"
  },
  {
    "course_name": "Pavement Analysis and Design",
    "dept": "C E",
    "num": "483",
    "desc": "Prereq: C E 360 and C E 382\nAnalysis, behavior, performance, and structural design of pavement systems. Topics include climate factors, rehabilitation, life cycle design economics, material and system response, pavement foundations and traffic loadings. Development of models for and analysis of pavement systems. Use of transfer functions relating pavement response to pavement performance. Evaluation and application of current and evolving pavement design practices and procedures. Mechanistic-based pavement design techniques and concepts. Analysis of the effects of maintenance activities on pavement performance and economic evaluation of pavement systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Design of Concretes",
    "dept": "C E",
    "num": "484",
    "desc": "Prereq: C E 382\nAsphalt binder characterization, fundamentals of asphalt rheology, asphalt materials behavior under loading and temperature effects.  High-strength, lightweight, fiber-reinforced, and self-consolidating portland cement concretes, mix design, properties, advanced performance testing. A term project is required for graduate level only.\n",
    "credits": "3"
  },
  {
    "course_name": "Civil Engineering Design",
    "dept": "C E",
    "num": "485",
    "desc": "Prereq: C E 206, C E 306, C E 326, C E 333 or C E 334, C E 355, C E 360, C E 372, C E 382, SP CM 212. Course enrollment limited to final graduating semester.\nThe civil engineering design process, interacting with the client, identification of the engineering problems, development of a technical proposal, identification of design criteria, cost estimating, planning and scheduling, codes and standards, development of feasible alternatives, selection of best alternative, and oral presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Civil Infrastructure Systems",
    "dept": "C E",
    "num": "488",
    "desc": "Prereq: Junior or higher classification in engineering or science\nSustainable planning, life cycle analysis, appropriate engineering design, investment levels and overall rating of civil engineering infrastructure systems, including highway, bridge, airport, rail, dam, power and port facilities. Complementary assessment of future civil infrastructure sustainability impacts and challenges in relation to autonomous and electric vehicle development. Overview regarding US and global availability and supply of critical infrastructure commodities (e.g., cement, stone, metals, phosphorus, uranium, etc.). Directed course readings and multiple project/design reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Pavement Preservation and Rehabilitation",
    "dept": "C E",
    "num": "489",
    "desc": "Prereq: C E 382\nOverview of pavement preservation and pavement rehabilitation techniques. Overview and selection of materials used in pavement preservation and rehabilitation strategies. Evaluating suitability of pavement preservation and pavement rehabilitation strategies based on existing structure, pavement distresses and non-condition factors. Use of recycled pavement materials in pavement reconstruction techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "C E",
    "num": "490",
    "desc": "Prereq: Permission of instructor\nIndependent study in any phase of civil engineering. Pre-enrollment contract required.\n  No more than 6 credits of C E 490 may be counted towards engineering topics electives.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "C E",
    "num": "490H",
    "desc": "Prereq: Permission of instructor\nIndependent study in any phase of civil engineering. Pre-enrollment contract required.\n  No more than 6 credits of C E 490H may be counted towards engineering topics electives.",
    "credits": "1"
  },
  {
    "course_name": "Preconstruction Project Engineering and Management",
    "dept": "C E",
    "num": "501",
    "desc": "Prereq: Credit or enrollment in CON E 422 or C E 306 or graduate standing\nApplication of engineering and management control techniques to construction project development from conceptualization to notice to proceed. Emphasis is on managing complex projects using 5-dimensional project management theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Construction Project Engineering and Management",
    "dept": "C E",
    "num": "502",
    "desc": "Prereq: Credit or enrollment in CON E 422 or C E 594A or permission of instructor\nApplication of engineering and management control techniques to complex construction projects. Construction project control techniques, project administration, construction process simulation, quality management, and productivity improvement programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Construction Finance and Business Management",
    "dept": "C E",
    "num": "503",
    "desc": "Prereq: Credit or enrollment in CON E 422 or C E 594A or permission of instructor\nFundamental theories and applied methods for financial management of construction projects and companies. Construction accounting, cash flow analysis, financial planning and management, and risk analysis. Case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Construction Systems",
    "dept": "C E",
    "num": "505",
    "desc": "Prereq: C E 333, C E 360, CON E 322, CON E 340 or graduate standing\nAdvanced design of concrete formwork and falsework systems. Design for excavation and marine construction including temporary retaining structures and cofferdams. Aggregate production operations, including blasting, crushing, and conveying systems. Rigging system design.\n",
    "credits": "3"
  },
  {
    "course_name": "Case Histories in Construction Documents",
    "dept": "C E",
    "num": "506",
    "desc": "Prereq: Graduate standing or permission of instructor\nStudy of cases involving disputes, claims, and responsibilities encountered by management in construction contract documents. Analysis of methods of resolving differences among the owner, architect, engineer, and construction contractor for a project.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Technologies for Construction",
    "dept": "C E",
    "num": "510",
    "desc": "Prereq: Graduate standing or permission of instructor\nInformation technologies including microcomputer based systems, management information systems, automation technologies, computer-aided design, and expert systems and their application in the construction industry. Overview of systems acquisition, communications, and networking.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied and Environmental Geophysics",
    "dept": "C E",
    "num": "513",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nSeismic, gravity, magnetic, resistivity, electromagnetic, and ground-penetrating radar techniques for shallow subsurface investigations and imaging. Data interpretation methods. Lab emphasizes computer interpretation packages. Field work with seismic - and resistivity-imaging systems and radar.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Engineering Chemistry",
    "dept": "C E",
    "num": "520",
    "desc": "Prereq: C E 326, CHEM 178\nPrinciples of chemical and physical phenomena applicable to the treatment of water and wastewater and natural waters; including chemical equilbria, reaction kinetics, acid-base equilibria, chemical precipitation, redox reactions, and mass transfer principles. Individual laboratory practicals and group projects required.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biotechnology",
    "dept": "C E",
    "num": "521",
    "desc": "Prereq: C E 326\nFundamentals of biochemical and microbial processes applied to environmental engineering processes, role of microorganisms in wastewater treatment and bioremediation, bioenergetics and kinetics, metabolism of xenobiotic compounds, waterborne pathogens and parasites, and disinfection. Term paper and oral presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Water Pollution Control Processes",
    "dept": "C E",
    "num": "522",
    "desc": "Prereq: C E 421 or C E 521\nFundamentals of biochemical processes, aerobic growth in a single CSTR, multiple events in complex systems, and techniques for evaluating kinetic parameters; unit processes of activated sludge system, attached growth systems, stabilization and aerated lagoon systems, biosolids digestion and disposal, nutrient removal, and anaerobic treatment systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical-Chemical Treatment Process",
    "dept": "C E",
    "num": "523",
    "desc": "Prereq: C E 520\nMaterial and energy balances. Principles and design of physical-chemical unit processes; including screening, coagulation, flocculation, chemical precipitation, sedimentation, filtration, lime softening and stabilization, oxidation, adsorption, membrane processes, ion exchange and disinfection; recovery of resources from residuals and sludges; laboratory exercises and demonstrations; case studies in mineral processing and secondary industries.\n",
    "credits": "3"
  },
  {
    "course_name": "Air Pollution",
    "dept": "C E",
    "num": "524",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Air quality and effects of pollutants",
    "dept": "C E",
    "num": "524A",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Climate change and causes",
    "dept": "C E",
    "num": "524B",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Transportation Air Quality",
    "dept": "C E",
    "num": "524C",
    "desc": "Prereq: C E 524A; PHYS 221 or CHEM 178; MATH 166 or 3 credits in statistics. Senior classification or above.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Off-gas treatment technology",
    "dept": "C E",
    "num": "524D",
    "desc": "Prereq: C E 524A, C E 524B; Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Agricultural sources of pollution",
    "dept": "C E",
    "num": "524E",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Solid and Hazardous Waste Management",
    "dept": "C E",
    "num": "528",
    "desc": "Prereq: C E 326 or background courses in both environmental chemistry and microbiology; junior or higher standing\nEvaluation, characterization, assessment, planning and design of solid and hazardous waste management systems, regulatory requirements, material characterization and collection, minimization and recycling, energy and materials recovery, composting, off-gas treatment, incineration, stabilization, and landfill design. Design of treatment and disposal systems, including physical, chemical, and biological treatment, solidification, incineration, secure landfill design, and final disposal site closure plus restoration.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Analysis II",
    "dept": "C E",
    "num": "532",
    "desc": "Prereq: C E 332\nAnalysis of indeterminate structural problems by the consistent deformation and generalized direct displacement methods. Direct stiffness method for 2-D frames, grids, 3-D frames. Special topics for the stiffness method.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Steel Design II",
    "dept": "C E",
    "num": "533",
    "desc": "Prereq: C E 333\nTheoretical background and development of AISC Specification equations. In-depth analysis and design of tension members, columns, beams, beam-columns, and plate girders. Emphasis on Load and Resistance Factor Design. Elastic and inelastic buckling of members and member elements. Investigation of amplification factors for members subject to combined bending and axial load and to combined bending and torsion. Effective Length Method and Direct Analysis Method of design. Approximate Second-Order Analysis. Biaxial bending. Torsion and combined bendin and torsion of W-shapes.\n",
    "credits": "3"
  },
  {
    "course_name": "Reinforced Concrete Design II",
    "dept": "C E",
    "num": "534",
    "desc": "Prereq: C E 334\nAdvanced topics in reinforced concrete analysis and design. Moment-curvature and load-deflection behavior. Design of reinforced concrete long columns, two-way floor slabs, and isolated and combined footings. Design and behavior considerations for torsion, biaxial bending, and structural joints. Strut-and-tie modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Prestressed Concrete Structures",
    "dept": "C E",
    "num": "535",
    "desc": "Prereq: C E 334\nDesign of prestressed concrete structures, review of hardware, stress calculations, prestress losses, section proportioning, flexural design, shear design, deflections, and statically indeterminate structures.\n",
    "credits": "3"
  },
  {
    "course_name": "Seismic Methods in Geology, Engineering, and Petroleum Exploration",
    "dept": "C E",
    "num": "539",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nPhysics of elastic-wave propagation. Seismic surveys in environmental imaging, engineering, and petroleum exploration. Reflection and refraction techniques. Data collection, processing, and geological interpretation. Field work with state-of-the-art equipment.\n",
    "credits": "3"
  },
  {
    "course_name": "Dynamic Analysis of Structures",
    "dept": "C E",
    "num": "541",
    "desc": "Prereq: E M 345 and credit or enrollment in C E 532\nSingle and multi-degree-of-freedom systems. Free and forced vibrations. Linear and nonlinear response. Modal analysis. Response spectra. Seismic analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Analysis by Finite Elements",
    "dept": "C E",
    "num": "542",
    "desc": "Prereq: C E 532\nUse of the finite element method for the analysis of complex structural configurations. Plane stress, solid, Axisymmetric and plate elements. Numerical integration. Use of general purpose finite element programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Seismic Design",
    "dept": "C E",
    "num": "545",
    "desc": "Prereq: C E 333, C E 334\nSeismic hazard in the United States. Engineering characteristics of ground motions. Structural damage in past earthquakes. Capacity design philosophy for seismic resistant design. Conceptual design of structures. Capacity design process including design of structural members.\n",
    "credits": "3"
  },
  {
    "course_name": "Bridge Design",
    "dept": "C E",
    "num": "546",
    "desc": "Prereq: C E 333, C E 334\nBridge design in structural steel and reinforced concrete. Application of AASHTO Bridge Design Specifications. Analysis techniques for complex structures. Preliminary designs include investigating alternative structural systems and materials. Final designs include preparation of design calculations and sketches.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis and Design of Plate and Slab Structures",
    "dept": "C E",
    "num": "547",
    "desc": "Prereq: C E 334, E M 514, MATH 266\nBending and buckling of thin plate components in structures utilizing classical and energy methods. Analysis of shell roofs by membrane and bending theories.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Design",
    "dept": "C E",
    "num": "548",
    "desc": "Prereq: C E 333, C E 334\nBuilding design in structural steel and reinforced concrete. Investigation of structural behavior. Gravity and lateral load resisting systems. Application of current building codes and design specifications. In-depth analysis of gravity and wind loads on buildings. Review of building designs. Preliminary designs include investigating alternative structural systems. Approximate methods of structural analysis for gravity and lateral loads. Final designs include preparation of design calculations and sketches.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Health Monitoring",
    "dept": "C E",
    "num": "549",
    "desc": "Prereq: Senior classification in Engineering or permission of instructor\nIntroductory and advanced topics in structural health monitoring (SHM) of aeronautical, civil, and mechanical systems. Topics include sensors, signal processing in time and frequency domains, data acquisition and transmission systems, design of integrated SHM solutions, nondestructive evaluation techniques, feature extraction methods, and cutting-edge research in the field of SHM. Graduate students will have a supervisory role to assist students in 449 and an additional design project or more in-depth analysis and design.\n",
    "credits": "3"
  },
  {
    "course_name": "Urban Transportation Planning Models",
    "dept": "C E",
    "num": "551",
    "desc": "Prereq: C E 355, STAT 101 or STAT 105\nUrban transportation planning context and process. Project planning and programming. Congestion, mitigation, and air quality issues. Transportation data sources. Travel demand and network modeling. Use of popular travel demand software and applications of geographic information systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Traffic Safety, Operations, and Maintenance",
    "dept": "C E",
    "num": "552",
    "desc": "Prereq: C E 355\nEngineering aspects of highway traffic safety. Reduction of crash incidence and severity through highway design and traffic control. Accident analysis. Safety in highway design, maintenance, and operation.\n",
    "credits": "3"
  },
  {
    "course_name": "Traffic Engineering",
    "dept": "C E",
    "num": "553",
    "desc": "Prereq: C E 355\nDriver, pedestrian, and vehicular characteristics. Traffic characteristics; highway capacity; traffic studies and analyses. Principles of traffic control for improved highway traffic service. Application of appropriate computing software and tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Transportation Data Analysis",
    "dept": "C E",
    "num": "556",
    "desc": "Prereq: C E 355, a Statistics course at the 300 level or higher\nAnalysis of transportation data, identification of data sources and limitations. Static and dynamic data elements such as infrastructure characteristics, flow and operations-related data elements. Spatial and temporal extents data for planning, design, operations, and management of transportation systems. Summarizing, analyzing, modeling, and interpreting data. Use of information technologies for highways, transit, and aviation systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Transportation Systems Analysis",
    "dept": "C E",
    "num": "557",
    "desc": "Prereq: C E 355, 3 credits in statistics or probability\nTravel studies and analysis of data. Transportation systems forecasts and analyses. Statewide, regional, and local transportation system planning. Network level systems planning and operations. Optimization of systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Transportation Systems Development and Management",
    "dept": "C E",
    "num": "558",
    "desc": "Prereq: C E 355\nStudy of designated problems in traffic engineering, transportation planning, and development. Forecasting and evaluation of social, economic, and environmental impacts of proposed solutions; considerations of alternatives. Formulation of recommendations and publication of a report. Presentation of recommendations in the host community.\n",
    "credits": "3"
  },
  {
    "course_name": "Transportation Infrastructure/Asset  Management",
    "dept": "C E",
    "num": "559",
    "desc": "Prereq: C E 355\nEngineering management techniques for maintaining and managing infrastructure assets. Systematic approach to management through value engineering, engineering economics, and life cycle cost analysis. Selection and scheduling of maintenance activities. Analysis of network-wide resource needs. Project level analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Soil Mechanics",
    "dept": "C E",
    "num": "560",
    "desc": "Prereq: C E 360\nNature of soil deposits, seepage, settlement and secondary compression, consolidation theories and analysis, failure theories, stress paths, introduction to critical state soil mechanics, constitutive models, soil strength under various drainage conditions, liquefaction of soil, pore pressure parameters, selection of soil parameters.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Foundation Engineering",
    "dept": "C E",
    "num": "561",
    "desc": "Prereq: C E 460\nAnalysis and design of shallow and deep foundations, lateral earth pressure theories and retaining structures, field investigations, in-situ testing, and foundations on problematic soils. Foundation engineering reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Site Evaluations for Civil Engineering Projects",
    "dept": "C E",
    "num": "562",
    "desc": "Prereq: C E 360\nIdentification and mapping of engineering soils from aerial photos, maps, and soil surveys. Planning subsurface investigations, geomaterials prospecting, geotechnical hazards, geomorphology, in situ testing and sampling, geophysical site characterization, instrumentation and monitoring, interpretation of engineering parameter values for design.\n",
    "credits": "3"
  },
  {
    "course_name": "Experimental Methods in Geo-Engineering",
    "dept": "C E",
    "num": "563",
    "desc": "Prereq: C E 360\nPrinciples of geo-engineering laboratory testing including the conduct, analysis, and interpretation of permeability, consolidation, triaxial, direct and ring shear, and direct simple shear tests. Issues regarding laboratory testing versus field testing and acquisition, transport, storage, and preparation of samples for geotechnical testing. Field and laboratory geotechnical monitoring techniques, including the measurements of deformation, strain, total stress and pore water pressure.\n",
    "credits": "3"
  },
  {
    "course_name": "Application of Numerical Methods to Geotechnical Design",
    "dept": "C E",
    "num": "564",
    "desc": "Prereq: C E 560\nApplication of numerical methods to analysis and design of foundations, underground structures, and soil-structure interaction. Application of slope stability software. Layered soils, bearing capacity and settlement for complex geometries, wave equation for piles, and foundation vibrations.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Geomaterials Behavior",
    "dept": "C E",
    "num": "565",
    "desc": "Prereq: C E 382\nAtoms and molecules, crystal chemistry, clay minerals, structure of solids, phase transformations and phase equilibria. Surfaces and interfacial phenomena, colloid chemistry, mechanical properties. Applications to soils and civil engineering materials. Overview of state-of-the-art instrumental techniques for analysis of the physicochemical properties of soils and civil engineering materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Geomaterials Stabilization",
    "dept": "C E",
    "num": "567",
    "desc": "Prereq: C E 360, C E 382 or C E 383\nSoil and aggregate physical, chemical and biological  stabilization procedures. Stabilization analysis and design.  Ground modification and compaction methods.  Geosynthetics application and design.\n",
    "credits": "3"
  },
  {
    "course_name": "Dynamics of Soils and Foundations",
    "dept": "C E",
    "num": "568",
    "desc": "Prereq: C E 360, E M 345\nDynamic soil properties and their measurement.  Foundation dynamics and soil-structure interaction.  Sources and characteristics of dynamic loads.  Vibration of single- and multi-degree-of-freedom systems.  Vibration of continuous systems;  1D, 2D, and 3D analyses, wave propagation. Liquefaction concepts and analysis methods.  Introduction to geotechnical earthquake engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Ground Improvement",
    "dept": "C E",
    "num": "569",
    "desc": "Prereq: C E 360\nClassification of ground improvement methods. Dynamic compaction, vibrocompaction, preloading using fill surcharge, vacuum or a combination of both and prefabricated vertical drains, vibro replacement or stone columns, dynamic replacement, sand compaction piles, geotextile confined columns, rigid inclusion, column supported embankment, microbial methods, particulate and chemical grouting, lime and cement columns, jet grouting, and deep cement mixing.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Hydraulic Design",
    "dept": "C E",
    "num": "570",
    "desc": "Prereq: C E 372\nFlow characteristics in natural and constructed channels; principles of hydraulic design of culverts, bridge waterway openings, spillways, hydraulic gates and gated structures, pumping stations, and miscellaneous water control structures; pipe networks, mathematical modeling. Design project.\n",
    "credits": "3"
  },
  {
    "course_name": "Surface Water Hydrology",
    "dept": "C E",
    "num": "571",
    "desc": "Prereq: C E 372\nAnalysis of hydrologic data including precipitation, infiltration, evapotranspiration, direct runoff and streamflow; theory and use of frequency analysis; theory of streamflow and reservoir routing; use of deterministic and statistical hydrologic models. Fundamentals of surface water quality modeling, point and non-point sources of contamination.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis and Modeling Aquatic Environments",
    "dept": "C E",
    "num": "572",
    "desc": "Prereq: C E 372\nPrinciples of surface water flows and mixing. Introduction to hydrologic transport and water   quality simulation in natural water systems. Advection, diffusion and dispersion, chemical and   biologic kinetics, and water quality dynamics. Applications to temperature, dissolved oxygen,   primary productivity, and other water quality problems in rivers, lakes and reservoirs.   Deterministic vs. stochastic models.\n",
    "credits": "3"
  },
  {
    "course_name": "Groundwater Hydrology",
    "dept": "C E",
    "num": "573",
    "desc": "Prereq: C E 372\nPrinciples of groundwater flow, hydraulics of wells, superposition, slug and pumping tests, streamlines and flownets, and regional groundwater flow. Contaminant transport. Computer modeling. Design project. Extra assignments required for graduate students.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Flows",
    "dept": "C E",
    "num": "576",
    "desc": "Prereq: E M 378 or equivalent\nAnalysis and applications of flows in civil engineering, environmental engineering, and water resources. Primary topics include conservation laws, laminar flow, turbulence, mixing, diffusion, dispersion, water waves, and boundary layers. Associated applications include particle settling, transfer at air-water and water-sediment boundaries, flow and friction in pipes and open channels, contaminant transport, waves in lakes, jets, plumes, and salt wedges.\n",
    "credits": "3"
  },
  {
    "course_name": "Geotechnical and Materials Engineering Seminar",
    "dept": "C E",
    "num": "581",
    "desc": "Prereq: Graduate classification\n(1-0) Students and outside/invited speakers give weekly presentations about the ongoing research work and Geotechnical and Materials Engineering issues.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Pavement Analysis and Design",
    "dept": "C E",
    "num": "583",
    "desc": "Prereq: C E 360 and C E 382\nAnalysis, behavior, performance, and structural design of pavement systems. Topics include climate factors, rehabilitation, life cycle design economics, material and system response, pavement foundations and traffic loadings. Development of models for and analysis of pavement systems. Use of transfer functions relating pavement response to pavement performance. Evaluation and application of current and evolving pavement design practices and procedures. Mechanistic-based pavement design techniques and concepts. Analysis of the effects of maintenance activities on pavement performance and economic evaluation of pavement systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Design of Concretes",
    "dept": "C E",
    "num": "584",
    "desc": "Prereq: C E 382\nAsphalt binder characterization, fundamentals of asphalt rheology, asphalt materials behavior under loading and temperature effects.  High-strength, lightweight, fiber-reinforced, and self-consolidating portland cement concretes, mix design, properties, advanced performance testing. A term project is required for graduate level only.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Asphalt Materials",
    "dept": "C E",
    "num": "586",
    "desc": "Prereq: C E 382\nAdvanced asphalt concrete (SUPERPAVE) mix designs. Aggregates. Admixtures. Production and construction, quality control and inspection. Nondestructive testing. Pavement thickness design. Materials engineering reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Portland Cement Concretes",
    "dept": "C E",
    "num": "587",
    "desc": "Prereq: C E 382 or C E 383\nHydraulic cements, aggregates, admixtures, and concrete mix design; cement hydration and microstructure development; fresh, early-age, and mechanical properties of concrete; concrete distress examination, damage mechanism, and prevention.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Civil Infrastructure Systems",
    "dept": "C E",
    "num": "588",
    "desc": "Prereq: Junior or higher classification in engineering or science\nSustainable planning, life cycle analysis, appropriate engineering design, investment levels and overall rating of civil engineering infrastructure systems, including highway, bridge, airport, rail, dam, power and port facilities. Complementary assessment of future civil infrastructure sustainability impacts and challenges in relation to autonomous and electric vehicle development. Overview regarding US and global availability and supply of critical infrastructure commodities (e.g., cement, stone, metals, phosphorus, uranium, etc.). Directed course readings and multiple project/design reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Pavement Preservation and Rehabilitation",
    "dept": "C E",
    "num": "589",
    "desc": "Prereq: C E 382\nOverview of pavement preservation and pavement rehabilitation techniques. Overview and selection of materials used in pavement preservation and rehabilitation strategies. Evaluating suitability of pavement preservation and pavement rehabilitation strategies based on existing structure, pavement distresses and non-condition factors. Use of recycled pavement materials in pavement reconstruction techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "C E",
    "num": "590",
    "desc": "\nPre-enrollment contract required.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Environmental Engineering",
    "dept": "C E",
    "num": "591",
    "desc": "Prereq: Graduate classification\n(1-0) Contemporary environmental engineering issues. Outside speakers. Review of ongoing research in environmental engineering.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Special Topics in Construction Engineering and Management",
    "dept": "C E",
    "num": "594",
    "desc": "Prereq: Permission of instructor\nSome topics have a set number of credits and some topics have the number of credits vary. Emphasis for a particular offering will be selected from the following topics:.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Planning and Scheduling",
    "dept": "C E",
    "num": "594A",
    "desc": "Prereq: C E 306 or graduate standing\nStudies in planning and scheduling including scheduling and estimating.\n  Credit may not be applied for graduation for Construction Engineering undergraduate students.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Computer Applications for Planning and Scheduling",
    "dept": "C E",
    "num": "594B",
    "desc": "Prereq: Permission of instructor\nStudies in computer applications for planning and scheduling.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Cost Estimating",
    "dept": "C E",
    "num": "594C",
    "desc": "Prereq: Permission of instructor\nStudies in cost estimating.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Computer Applications for Cost Estimating",
    "dept": "C E",
    "num": "594D",
    "desc": "Prereq: Permission of instructor\nStudies in computer applications for cost estimating.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Project Controls",
    "dept": "C E",
    "num": "594E",
    "desc": "Prereq: Permission of instructor\nStudies in project controls.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Computer Applications for Project Controls",
    "dept": "C E",
    "num": "594F",
    "desc": "Prereq: Permission of instructor\nStudies in computer applications for project controls.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engr and Mgt: Integration of Planning, Scheduling and Project Controls",
    "dept": "C E",
    "num": "594G",
    "desc": "Prereq: Permission of instructor\nStudies in integration of planning, scheduling and project controls.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Trenchless Technologies",
    "dept": "C E",
    "num": "594J",
    "desc": "Prereq: Permission of instructor\nStudies in trenchless technologies.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Electrical and Mechanical Construction",
    "dept": "C E",
    "num": "594K",
    "desc": "Prereq: Permission of instructor\nStudies in electrical and mechanical construction.\n",
    "credits": "1"
  },
  {
    "course_name": "Spl Topics Construction Engr and Mgt.: Adv Building Construction Topics - LEED for New Construction",
    "dept": "C E",
    "num": "594L",
    "desc": "Prereq: CON E 352 or C E 306 or graduate standing or permission of instructor\nStudies in advanced building construction topics including LEED.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Design Build Construction",
    "dept": "C E",
    "num": "594M",
    "desc": "Prereq: Permission of instructor\nStudies in design build construction.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Industrial Construction",
    "dept": "C E",
    "num": "594N",
    "desc": "Prereq: Graduate standing or permission of instructor\nStudies in industrial construction.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Highway and Heavy Construction",
    "dept": "C E",
    "num": "594O",
    "desc": "Prereq: CON E 322 or C E 306 or graduate standing\nStudies in highway and heavy construction.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Advanced Building Energy Systems and Technologies",
    "dept": "C E",
    "num": "594P",
    "desc": "Prereq: CON E 352 or graduate standing or permission of instructor\nStudies in advanced building technologies including building energy modeling, building energy performance and efficiency assessments, and demand side management for smart grid applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Construction Quality Control",
    "dept": "C E",
    "num": "594Q",
    "desc": "Prereq: Permission of instructor\nStudies in construction quality control.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Risk Management",
    "dept": "C E",
    "num": "594R",
    "desc": "Prereq: Permission of instructor\nStudies in risk management.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics Construction Engineering and Mgt.: Building Information Modeling",
    "dept": "C E",
    "num": "594S",
    "desc": "Prereq: Permission of instructor\nStudies in building information modeling.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Methods in Construction Engineering and Management",
    "dept": "C E",
    "num": "595",
    "desc": "Prereq: Graduate standing or permission of instructor\nAssigned readings and reports on research methods to solve construction engineering and management problems such as alternative project delivery methods, asset management, data mining, construction procurement, robotics, project controls, automation, construction visualization, etc. Identification of research methods and priorities, selection and development of research design, and critique of research in construction engineering and management.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Methods Seminar in Construction Engineering and Management: Qualitative Methods",
    "dept": "C E",
    "num": "595A",
    "desc": "Prereq: Graduate standing or permission of instructor\nAssigned readings and reports on qualitative research methods to assess and solve  construction engineering and management problems.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Methods Seminar in Construction Engineering and Management: Quantitative Methods",
    "dept": "C E",
    "num": "595B",
    "desc": "Prereq: Graduate standing or permission of instructor\nAssigned readings and reports on quantitative research methods to assess and solve  construction engineering and management problems.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Methods Seminar in Construction Engineering and Management: Technical Reporting",
    "dept": "C E",
    "num": "595C",
    "desc": "Prereq: Graduate standing or permission of instructor\nAssigned readings and reports on research methods for planning and preparation of technical reports with construction engineering and management projects.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Transportation Engineering",
    "dept": "C E",
    "num": "596",
    "desc": "Prereq: C E 355\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics in Transportation Engineering: Geographic Information Systems in Transportation",
    "dept": "C E",
    "num": "596B",
    "desc": "Prereq: C E 355\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics in Transportation Engineering: Hazardous Materials Transportation",
    "dept": "C E",
    "num": "596C",
    "desc": "Prereq: C E 355\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics in Transportation Engineering: Transportation and Public Works",
    "dept": "C E",
    "num": "596D",
    "desc": "Prereq: C E 355\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics in Transportation Engineering: Sustainable Transportation",
    "dept": "C E",
    "num": "596E",
    "desc": "Prereq: C E 355\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics in Transportation Engineering: Freight Transportation",
    "dept": "C E",
    "num": "596F",
    "desc": "Prereq: C E 355\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "C E",
    "num": "599",
    "desc": "\nPre-enrollment contract required. Advanced topic for creative component report in lieu of thesis.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Topics in Environmental Engineering",
    "dept": "C E",
    "num": "622",
    "desc": "Prereq: Permission of environmental engineering graduate faculty\nAdvanced concepts in environmental engineering. Emphasis for a particular offering will be selected from the following topics:.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Topics in Environmental Engineering: Water Pollution Control",
    "dept": "C E",
    "num": "622A",
    "desc": "Prereq: Permission of environmental engineering graduate faculty\nAdvanced concepts in environmental engineering. Emphasis for a particular offering will be selected from the following topics:.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Topics in Environmental Engineering: Water Treatment",
    "dept": "C E",
    "num": "622B",
    "desc": "Prereq: Permission of environmental engineering graduate faculty\nAdvanced concepts in environmental engineering. Emphasis for a particular offering will be selected from the following topics:.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Topics in Environmental Engineering: Solid and Hazardous Waste",
    "dept": "C E",
    "num": "622C",
    "desc": "Prereq: Permission of environmental engineering graduate faculty\nAdvanced concepts in environmental engineering. Emphasis for a particular offering will be selected from the following topics:.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Topics in Environmental Engineering: Water Resources",
    "dept": "C E",
    "num": "622D",
    "desc": "Prereq: Permission of environmental engineering graduate faculty\nAdvanced concepts in environmental engineering. Emphasis for a particular offering will be selected from the following topics:.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Topics in Environmental Engineering: Instrumental Methods for Environmental Analyses",
    "dept": "C E",
    "num": "622E",
    "desc": "Prereq: Permission of environmental engineering graduate faculty\nAdvanced concepts in environmental engineering.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Topics in Transportation Engineering",
    "dept": "C E",
    "num": "650",
    "desc": "Prereq: Permission of Transportation Engineering graduate faculty\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Transportation Engineering: Highway Design",
    "dept": "C E",
    "num": "650A",
    "desc": "Prereq: Permission of Transportation Engineering graduate faculty\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Transportation Engineering: Traffic Operations",
    "dept": "C E",
    "num": "650B",
    "desc": "Prereq: Permission of Transportation Engineering graduate faculty\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Transportation Engineering: Data Analysis",
    "dept": "C E",
    "num": "650C",
    "desc": "Prereq: Permission of Transportation Engineering graduate faculty\nTopics in transportation engineering related to data analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "C E",
    "num": "690",
    "desc": "\nPre-enrollment contract required.\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "C E",
    "num": "697",
    "desc": "Prereq: Permission of coop advisor, graduate classification\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "C E",
    "num": "699",
    "desc": "Prereq: Pre-enrollment contract required\nAdvanced topic for thesis/dissertation.\n",
    "credits": "1"
  },
  {
    "course_name": "Greek and Roman Mythology",
    "dept": "CL ST",
    "num": "273",
    "desc": "\nSurvey of the legends, myths of the classical world with emphasis on the principal gods, and heroes, and their relation to ancient social, psychological, and religious practices; some attention may be given to important modern theories.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Greek and Roman Mythology: Honors",
    "dept": "CL ST",
    "num": "273H",
    "desc": "\nSurvey of the legends, myths of the classical world with emphasis on the principal gods, and heroes, and their relation to ancient social, psychological, and religious practices; some attention may be given to important modern theories.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "The Ancient City",
    "dept": "CL ST",
    "num": "275",
    "desc": "\nExamination of ancient urban life, including historical context, physical space, material culture, religion, literature, and art; examination of civic identity (the \"polis\"). Contrast between the concepts of urban and rural. Examples drawn from specific ancient cities; some attention to modern methods of recovering the conditions of ancient urban life and the fundamental concept of the city in European history.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Cultural Heritage of the Ancient World",
    "dept": "CL ST",
    "num": "304",
    "desc": "Prereq: Sophomore classification\nHistorical examination of art, literature, thought, and religious beliefs of major civilizations of the ancient Mediterranean countries until the end of the 8th century.\n",
    "credits": "3"
  },
  {
    "course_name": "Ancient Philosophy",
    "dept": "CL ST",
    "num": "310",
    "desc": "Prereq: PHIL 201\nSurvey of ancient Greek philosophy, focusing on the pre-Socratics, Plato, and Aristotle. Questions concerning being, knowledge, language, and the good life are treated in depth.\n",
    "credits": "3"
  },
  {
    "course_name": "Rhetorical Traditions",
    "dept": "CL ST",
    "num": "350",
    "desc": "Prereq: ENGL 250\nIdeas about the relationship between rhetoric and society in contemporary and historical contexts. An exploration of classical and contemporary rhetorical theories in relation to selected topics that may include politics, gender, race, ethics, education, science, or technology.\n",
    "credits": "3"
  },
  {
    "course_name": "World Literature: Western Foundations through Renaissance",
    "dept": "CL ST",
    "num": "353",
    "desc": "Prereq: ENGL 250\nRepresentative works from the drama, epics, poetry, and prose of the Ancient World through the late sixteenth century. May include Homer, Aeschylus, Sappho, Catullus, Dante, Marie de France, Boccaccio, Christine de Pizan, Cervantes, and others.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Christianity in the Roman Empire",
    "dept": "CL ST",
    "num": "367",
    "desc": "\nAn historical introduction to the rise of Christianity in the Roman empire, with special attention to the impact of Greco-Roman culture on the thought and practice of Christians and the interaction of early Christians with their contemporaries.\n",
    "credits": "3"
  },
  {
    "course_name": "Religions of Ancient Greece and Rome",
    "dept": "CL ST",
    "num": "368",
    "desc": "\nNature, origins and development of religious beliefs and practices in ancient Greece and Rome from earliest times up to the rise of Christianity. Roles of divinities and rituals in lives of individuals and families and the governing of city-states and empires. Emphasis on historical contexts of the Graeco-Roman world and influences of neighboring cultures in Africa and Asia.\n  None.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Greek and Roman Tragedy and Comedy",
    "dept": "CL ST",
    "num": "372",
    "desc": "Prereq: CL ST 273 or CL ST 275 or one course in Latin or Greek or ENGL 250\nGreek and Roman drama from the beginnings until today. Readings in English from authors such as Aeschylus, Sophocles, Euripides, Aristophanes, Menander, Plautus, Terence, Seneca. Course may cover performance, theories of comedy and tragedy, recent and current expressions of the comic and tragic in film and other media.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Greek and Roman Tragedy and Comedy: Honors",
    "dept": "CL ST",
    "num": "372H",
    "desc": "Prereq: CL ST 273 or CL ST 275 or one course in Latin or Greek or ENGL 250\nGreek and Roman drama from the beginnings until today. Readings in English from authors such as Aeschylus, Sophocles, Euripides, Aristophanes, Menander, Plautus, Terence, Seneca. Course may cover performance, theories of comedy and tragedy, recent and current expressions of the comic and tragic in film and other media.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Heroes of Greece, Rome, and Today",
    "dept": "CL ST",
    "num": "373",
    "desc": "Prereq: CL ST 273 or CL ST 275 or one course in Latin or Greek or ENGL 250.\nCultural and political significance of ancient epic, especially in Greece and Rome. Course may include study of the heroic code in antiquity and its modern expressions including in film. Readings in English from authors such as Homer and Vergil.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Heroes of Greece, Rome, and Today: Honors",
    "dept": "CL ST",
    "num": "373H",
    "desc": "Prereq: CL ST 273 or CL ST 275 or one course in Latin or Greek or ENGL 250.\nCultural and political significance of ancient epic, especially in Greece and Rome. Course may include study of the heroic code in antiquity and its modern expressions including in film. Readings in English from authors such as Homer and Vergil.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Sex, Gender, and Culture in the Ancient Mediterranean World",
    "dept": "CL ST",
    "num": "374",
    "desc": "Prereq: Any one course in Cl St, W S, Latin, or Greek\nChronological and topical survey of the status of women and men, focusing on sex and gender issues in the Ancient Mediterranean world; study of constructs of the female and the feminine. Readings from ancient and modern sources.  Emphasis on ancient Greece, Rome, and Egypt.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Classical Archaeology",
    "dept": "CL ST",
    "num": "376",
    "desc": "\nChronological survey of the material culture of the ancient Graeco-Roman world and the role of archaeological context in understanding the varied aspects of ancient Greek or Roman culture. Among other topics, economy, architecture, arts and crafts, trade and exchange, religion and burial customs will be explored.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Classical Archeology: Bronze Age and Early Iron Age Greece",
    "dept": "CL ST",
    "num": "376A",
    "desc": "\nBronze Age (Minoan and Mycenaean palatial cultures) and Early Iron Age Greece. (ca 3000-700 BCE). Chronological survey of the material culture of the ancient Greece-Roman world and the role of archaeological context in understanding the varied aspects of ancient Greek or Roman culture. Among other topics, economy, architecture, arts and crafts, trade and exchange, religion and burial customs will be explored.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Classical Archeology: Archaic through Hellenistic Greece (ca 700-30 BCE)",
    "dept": "CL ST",
    "num": "376B",
    "desc": "\nChronological survey of the material culture of ancient Greece from ca. 700-30 BCE and the role of archaeological context in understanding the varied aspects of Greek culture during the Archaic, Classical, and Hellenistic periods. Among other topics, economy, architecture, arts and crafts, trade and exchange, religion and burial customs will be explored.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Classical Archaeology: Roman Archaeology (ca 1000 BCE-400 CE)",
    "dept": "CL ST",
    "num": "376C",
    "desc": "\nChronological survey of the material culture of the ancient Roman world and the role of archaeological context in understanding the varied aspects of ancient Roman culture. Among other topics, economy, architecture, arts and crafts, trade and exchange, religion and burial customs will be explored.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Greek and Roman Art",
    "dept": "CL ST",
    "num": "383",
    "desc": "\nGreek art from Neolithic to Hellenistic periods. Roman art from the traditional founding to the end of the empire in the West.\n",
    "credits": "3"
  },
  {
    "course_name": "Greek and Roman Art: Honors",
    "dept": "CL ST",
    "num": "383H",
    "desc": "\nGreek art from Neolithic to Hellenistic periods. Roman art from the traditional founding to the end of the empire in the West.\n",
    "credits": "3"
  },
  {
    "course_name": "Roman Italy: An Introduction",
    "dept": "CL ST",
    "num": "384",
    "desc": "Prereq: Enrollment limited to students participating in CL ST 385/HIST 385. Instructor permission required.\nIntroduction to the topography, history, archaeology, monuments, and art of Rome from the 8th century BCE  to the 5th century CE; attention given to the culture of modern Italy, preparatory to study abroad in Rome.\n\nMeets International Perspectives Requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Study Abroad: Roman Italy: Building the Empire",
    "dept": "CL ST",
    "num": "385",
    "desc": "Prereq: CL ST 384/HIST 384 and instructor’s permission.\nSupervised on-site instruction in the history, archaeology, monuments, and art of Rome and environs from the 8th century BCE to the 5th century CE; attention given to the culture of modern Italy.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "The Archaeology of Greece: An Introduction",
    "dept": "CL ST",
    "num": "394",
    "desc": "\nIntroduction to the topography, history, archaeology, monuments and art of Greece from the Bronze Age through the Ottoman period; attention given to the culture of modern Greece, preparatory to study abroad in Greece (CL ST 395).\n\nMeets International Perspectives Requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Study Abroad: The Archaeology of Greece",
    "dept": "CL ST",
    "num": "395",
    "desc": "Prereq: CL ST 394\nSupervised on-site instruction in the archaeology, monuments, and art of Greece from the Bronze Age through the Ottoman period; attention given to the culture of modern Greece.\n\nMeets International Perspectives Requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Greek Civilization.",
    "dept": "CL ST",
    "num": "402",
    "desc": "Prereq: Sophomore classification\nAncient Greece from the Bronze Age to the Hellenistic period; evolution of the Greek polis and its cultural contributions with a particular emphasis on the writings of Herodotus and Thucydides.\n",
    "credits": "3"
  },
  {
    "course_name": "Roman Civilization.",
    "dept": "CL ST",
    "num": "403",
    "desc": "Prereq: Sophomore classification\nAncient Rome from the Regal Period to the Fall of the Western Empire; evolution of Roman institutions and Rome's cultural contributions studied through original sources.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Western Political Thought",
    "dept": "CL ST",
    "num": "430",
    "desc": "Prereq: 6 credits in political science, philosophy, or European history\nStudy of original texts in political thought ranging from the classical period to the renaissance. Topics such as justice, freedom, virtue, the allocation of political power, the meaning of democracy, human nature, and natural law.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Classical Studies",
    "dept": "CL ST",
    "num": "480",
    "desc": "Prereq: 30 credits in Classical Studies or related courses, permission of Program Chair\nAdvanced study of a selected topic in Classical Studies. Research paper or project selected by the student.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "CL ST",
    "num": "490",
    "desc": "Prereq: 7 credits in classical studies at the 200 level or higher; permission of the Program Chair\nDesigned to meet the needs of students who wish to study specific topics in classical civilization in areas where courses are not offered, or to pursue such study beyond the limits of existing courses.\n",
    "credits": "1"
  },
  {
    "course_name": "Proseminar in European History",
    "dept": "CL ST",
    "num": "512",
    "desc": "Prereq: Permission of instructor.\nReadings in European history.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in European History:  Ancient",
    "dept": "CL ST",
    "num": "512A",
    "desc": "Prereq: Permission of instructor\nReadings in European history.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Western Political Thought",
    "dept": "CL ST",
    "num": "530",
    "desc": "Prereq: 6 credits in political science, philosophy, or European history\nStudy of original texts in political thought ranging from the classical period to the renaissance. Topics such as justice, freedom, virtue, the allocation of political power, the meaning of democracy, human nature, and natural law.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in European History",
    "dept": "CL ST",
    "num": "594",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in European History: Ancient",
    "dept": "CL ST",
    "num": "594A",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Communication Disorders",
    "dept": "CMDIS",
    "num": "275",
    "desc": "\nSurvey of nature, causes, and types of major communication disorders including phonological, adult and child language, voice, cleft palate, fluency, and hearing disorders.\n",
    "credits": "3"
  },
  {
    "course_name": "Communicating with the Deaf",
    "dept": "CMDIS",
    "num": "286",
    "desc": "\nLearn to communicate with the deaf using Signed English and Signed Pidgin English.  Other topics covered include types, causes, and consequences of hearing loss, hearing technology (hearing aids, assistive listening devices, and cochlear implants), education of hearing-impaired children, Deaf culture, and the history of manual communication.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Phonetics and Phonology",
    "dept": "CMDIS",
    "num": "371",
    "desc": "Prereq: ENGL 219\nTerminology, theory, research, and applications of the science of the sounds of spoken language. Emphasis on American English and International Phonetic Alphabet.\n",
    "credits": "3"
  },
  {
    "course_name": "Language and Reading Development in Children",
    "dept": "CMDIS",
    "num": "471",
    "desc": "Prereq: CMDIS 275 or PSYCH 230 or ENGL 219 or LING 219\nDevelopment of spoken language, reading and writing covering semantics, syntax, morphology, phonology, and pragmatics.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Communication Disorders",
    "dept": "CMDIS",
    "num": "480",
    "desc": "Prereq: CMDIS/LING 275, CMDIS/LING 371, and BIOL 255; permission of instructor.\nGuided examination of topics in preparation for graduate work in Speech-Language Pathology or Audiology. Primary course delivery by WWW.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Communication Disorders: Anatomy and Physiology of Speech and Hearing",
    "dept": "CMDIS",
    "num": "480A",
    "desc": "Prereq: CMDIS/LING 275, CMDIS/LING 371, and BIOL 255; permission of instructor.\nStructures and functions of respiratory, phonatory, articulatory, auditory, and nervous systems as they relate to speaking and listening.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Communication Disorders: Articulation and Phonological Disorders",
    "dept": "CMDIS",
    "num": "480B",
    "desc": "Prereq: CMDIS/LING 275, CMDIS/LING 371, and BIOL 255; permission of instructor.\nChildren’s acquisition of English speech sounds. Assessment and management of speech sound disorders in children and adults.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Communication Disorders: Evaluation and diagnosis of communication disorders",
    "dept": "CMDIS",
    "num": "480C",
    "desc": "Prereq: CMDIS/LING 275, CMDIS/LING 371, and BIOL 255; permission of instructor.\nAssessment and diagnosis of speech, language, and swallowing disorders. Preparation of clinical reports based on assessment data.\n",
    "credits": "3"
  },
  {
    "course_name": "Fieldwork in Communication Disorders",
    "dept": "CMDIS",
    "num": "492",
    "desc": "Prereq: CMDIS/LING 371;471; completion or concurrent enrollment in CMDIS/LING 480A or 480B or 480C\nGuided observation of clinical evaluation and treatment in Communication Disorders on campus and in the community. Assessed service learning component.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Communication Studies",
    "dept": "COMST",
    "num": "101",
    "desc": "\nAn introduction to communication theory, the development and functions of communication, and a survey of verbal, nonverbal, interpersonal, small group, organizational, and intercultural communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Communication Studies: Laboratory",
    "dept": "COMST",
    "num": "101L",
    "desc": "Prereq: Concurrent enrollment in COMST 101.\nLaboratory component of COMST 101. Skill building, experiential activities,  and in-depth discussions relevant to the study of communication.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Interpersonal Communication",
    "dept": "COMST",
    "num": "102",
    "desc": "\nApplication of communication principles, theory, and research to the process of interpersonal communication; includes verbal and nonverbal communication, listening, and conflict management. Particular emphasis given to using communication to manage interpersonal relationships.\n",
    "credits": "3"
  },
  {
    "course_name": "Orientation to Communication Studies",
    "dept": "COMST",
    "num": "104",
    "desc": "Prereq: Available only for Communication Studies majors\nOrientation to Communication Studies discipline, program requirements and career opportunities. Required of communication studies majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Communication Research Methods",
    "dept": "COMST",
    "num": "203",
    "desc": "Prereq: COMST 101\nAn introduction to analyzing and conducting communication research. Provides an overview of quantitative and qualitative approaches to communication research.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication and U.S. Diversity",
    "dept": "COMST",
    "num": "210",
    "desc": "\nIntroduction to the role of diversity in communication.  Developing competent communication with diverse social groups within interpersonal and organizational contexts in the United States. Topics may include structured reflection of one’s role in diverse communication experiences, cultural variations in communication mores, impacts of racial/ethnic/gender identities on communication, workplace policies regarding cultural diversity, the intersection of communication and cultural privilege, communication practices that can reduce prejudice/discrimination, and communication characteristics of advocates for diversity.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Communication",
    "dept": "COMST",
    "num": "214",
    "desc": "\nCommunication theory and skill development in organizational settings. Emphasis on interpersonal skill development, team and meeting facilitation, informational interviewing, individual and team presentations, and self-assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Conflict Management",
    "dept": "COMST",
    "num": "218",
    "desc": "\nExploration of communication theories, principles and methods associated with effective conflict management.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Communication Theory",
    "dept": "COMST",
    "num": "301",
    "desc": "Prereq: COMST 101\nExamination of the major theories related to human communication;  with particular emphasis on theories underlying interpersonal, small group, organizational, and intercultural communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Intercultural Communication",
    "dept": "COMST",
    "num": "310",
    "desc": "Prereq: COMST 102, COMST 203, COMST 301\nExamines the theories, principles and research on intercultural communication to enhance cultural sensitivity and to recognize, accept, and adapt to cultural diversity. Interactive assignments.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Interpersonal Communication",
    "dept": "COMST",
    "num": "311",
    "desc": "Prereq: COMST 102, COMST 203, COMST 301\nThis class focuses on studies of contemporary interpersonal communication concepts and theories. Emphasis on research that examines issues central to communication in interpersonal relationships.\n",
    "credits": "3"
  },
  {
    "course_name": "Leadership Communication Theories",
    "dept": "COMST",
    "num": "313",
    "desc": "Prereq: COMST 102, COMST 203, COMST 301\nInvestigation of theories, research and principles of leadership communication. Exploration of the contexts in which leadership and communication occurs, with emphasis on the connection between communication and leadership and the dyadic linkage of leader and follower.\n",
    "credits": "3"
  },
  {
    "course_name": "Organizational Communication",
    "dept": "COMST",
    "num": "314",
    "desc": "Prereq: COMST 102, COMST 203, COMST 301\nTheory and research in organizational communication. Provides strategies for assessing and improving individual and organizational communication effectiveness. Addresses issues such as technology, diversity, work-life negotiation, emotional labor, conflict, socialization, and socially responsible organizations. Explores how organizational meaning is created and sustained through human communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Small Group Communication",
    "dept": "COMST",
    "num": "317",
    "desc": "Prereq: COMST 102, COMST 203, COMST 301\nTheory and research in small group communication; application to group decision-making and leadership. Includes communication analyses of groups and teams.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication Training and Development",
    "dept": "COMST",
    "num": "319",
    "desc": "Prereq: COMST 102, COMST 203, COMST 301\nTheories and approaches to communication training and development; includes adult learning theory. Emphasis on the design, presentation and assessment of communication skills in organizational contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonverbal Communication",
    "dept": "COMST",
    "num": "325",
    "desc": "Prereq: COMST 102, COMST 203, COMST 301\nApproaches to studying nonverbal communication. Foci include topics such as emotion, gestures, gaze, use of space, and parsing intention in social interaction.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Mediated Communication",
    "dept": "COMST",
    "num": "330",
    "desc": "Prereq: COMST 102, COMST 203, COMST 301\nTheories and approaches related to mediated communication in interpersonal and organizational settings. Focus on how new technology impacts human interaction and relationships.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Organizational Communication",
    "dept": "COMST",
    "num": "384",
    "desc": "Prereq: COMST 101, COMST 102 or equivalent course.\nTheory and research of micro-level organizational communication, including interpersonal and small group interactions taking place in a professional setting. Topics include interpersonal dynamics in such areas as conflict, generational communication, negotiation, superior/subordinate communication, external communication, and virtual communication. Not available for major credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar",
    "dept": "COMST",
    "num": "404",
    "desc": "Prereq: COMST 301 plus 3 additional communication studies classes from the following list: COMST 310, COMST 311, COMST 313, COMST 314, COMST 317, COMST 319, COMST 325, or COMST 330.\nCapstone communication studies course. Students develop an original research study linked to the study of communication. Data are collected and analyzed. Results are presented in a final research paper and a presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Communication Studies",
    "dept": "COMST",
    "num": "450",
    "desc": "\nResearch and theory related to special topics and issues in communication studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "COMST",
    "num": "490",
    "desc": "Prereq: 9 credits in communication studies and junior classification\nApplication must be submitted for approval the semester prior to the independent study.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Practicum",
    "dept": "COMST",
    "num": "491",
    "desc": "Prereq: COMST 203, COMST 301 plus permission of instructor.\nProviding research assistance on projects conducted by Communication Studies faculty.\n",
    "credits": "arr"
  },
  {
    "course_name": "Professional Internship",
    "dept": "COMST",
    "num": "497",
    "desc": "Prereq: 12 hours in Communication Studies including COMST 203, COMST 301, and one other 300-level COMST class. Junior Classification.  Application required.\n100 hours of on-site professional work per credit hour plus completion of the academic requirement set by the internship committee. Application should be submitted in the term prior to the term in which the internship will be served. Internship cannot be used to meet degree requirement in Communication Studies.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar",
    "dept": "COMST",
    "num": "504",
    "desc": "Prereq: COMST 301 plus 3 additional communication studies classes from the following list: COMST 310, COMST 311, COMST 313, COMST 314, COMST 317, COMST 319, COMST 325, or COMST 330.\nCapstone communication studies course. Students develop an original research study linked to the study of communication. Data are collected and analyzed. Results are presented in a final research paper and a presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "COMST",
    "num": "590",
    "desc": "\nApplication must be submitted for approval the semester prior to the independent study.\n",
    "credits": "1"
  },
  {
    "course_name": "The North American Metropolis",
    "dept": "C R P",
    "num": "201",
    "desc": "\nExamination of the evolution of American urban centers from the colonial era to the present. Considers the demographic changes and social movements underway in urban America and explores how an understanding of the history of cities provides us with knowledge that we can use to improve our cities today.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Geographic Information Systems",
    "dept": "C R P",
    "num": "251",
    "desc": "\nFundamentals of the concepts, models, functions and operations of Geographic Information Systems (GIS). Principals of spatial problems, spatial questions and hypotheses and their solutions based on spatial data, GIS tools and techniques. Integration of concepts and applications through lectures and facilitated labs. Applications from a variety of areas including design; physical, social, and human science; engineering; agriculture; business and medicine, landscape architecture, architecture, urban planning, geology, forestry, biology, and ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "World Cities and Globalization",
    "dept": "C R P",
    "num": "291",
    "desc": "\nWorld cities and globalization in developed and developing countries. Topics include globalization, world cities and regions, uneven economic development, the international division of labor, multinational corporations, international environmentalism, tourism, popular culture and place- based identity.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Planning",
    "dept": "C R P",
    "num": "293",
    "desc": "\nComprehensive overview of the field of environmental relationships and the efforts being made to organize, control, and coordinate environmental, aesthetic, and cultural characteristics of land, air, and water.\n",
    "credits": "3"
  },
  {
    "course_name": "Urban Analytical Methods",
    "dept": "C R P",
    "num": "301",
    "desc": "Prereq: STAT 101\nAn introduction to the methods and analytical techniques used by planners to study community change. Course includes identification of key sources of planning information and data. Students learn to use quantitative methods for analysis of population, land use, economic and transportation data. Students learn to apply basic analytic methods to community problems and learn the art of effective written, graphic, and oral presentation of data.\n",
    "credits": "4"
  },
  {
    "course_name": "Urban Geography",
    "dept": "C R P",
    "num": "320",
    "desc": "\nAn introduction to urban geography. Study of urban centers, including people and infrastructure. Investigation of the origin and evolution of urban areas and the processes that shape urban change. Topics include urban form, and the social, economic, political, cultural, and institutional factors that shape cities.\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum",
    "dept": "C R P",
    "num": "330",
    "desc": "Prereq: Major in community and regional planning\nStructured work experience under close supervision of a professional planner. Practical planning experience; relationships between theory and practice, professional responsibilities, and the scope of various planning roles.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Practice Seminar",
    "dept": "C R P",
    "num": "331",
    "desc": "Prereq: CRP 301 and junior classification\nPreparation for working as a planning professional; development of resume and portfolio; discussion of professional ethics and expectations of employers and clients; presentations from planning professionals, and discussion of the range of career choices within the planning profession.\n",
    "credits": "2"
  },
  {
    "course_name": "Intermediate Geographic Information Systems",
    "dept": "C R P",
    "num": "351",
    "desc": "Prereq: CRP 251X\nIntermediate GIS for design and non-design students to learn concepts of digital management and representation of spatial data, including spatial problems, data sources and structures, simple spatial operations and cartographic issues. Gain skill set to effectively display feature and tabular data, query features using logical expressions, edit spatial and attribute data, associate tables with joins and relates, produce maps, reports, and graphs.\n",
    "credits": "3"
  },
  {
    "course_name": "Rural, Urban and Regional Economics",
    "dept": "C R P",
    "num": "376",
    "desc": "Prereq: ECON 101\nFirm location with respect to regional resources, transport, scale economies, externalities, and policies. Measures of local comparative advantage and specialization. Spatial markets. Population location considering jobs, wages, commuting, and local amenities. Business, residential, and farm land use and value. Migration. Other topics may include market failure, regulation, the product cycle, theories of rural and urban development, developmental policy, firm recruiting, local public goods and public finance, schools, poverty, segregation, and crime.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory of the Planning Process",
    "dept": "C R P",
    "num": "383",
    "desc": "Prereq: Junior classification\nThe nature of planning and its relation to social and economic planning; levels of planning, place of planning in decision making; steps in the planning process, uses and limitation of knowledge in planning, relation of facts and values.\n",
    "credits": "3"
  },
  {
    "course_name": "Field Travel",
    "dept": "C R P",
    "num": "391",
    "desc": "Prereq: CRP major and permission of instructor\nObservation of professional practice and community or regional problems and issues.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Work Experience",
    "dept": "C R P",
    "num": "410",
    "desc": "Prereq: Permission of department chair\nApproved professional work experience.\n",
    "credits": "R"
  },
  {
    "course_name": "Urban Design and Practice",
    "dept": "C R P",
    "num": "416",
    "desc": "Prereq: C R P 301\nPrinciples of urban design and their application to residential and commercial development in studio projects.\n",
    "credits": "6"
  },
  {
    "course_name": "Urban Revitalization",
    "dept": "C R P",
    "num": "417",
    "desc": "Prereq: Junior classification\nPlanning methods available to further revitalization and preservation efforts, with particular attention to housing and neighborhoods. Relationship between neighborhood change and urban development process; public policy implications.\n",
    "credits": "3"
  },
  {
    "course_name": "Financing Historic Preservation Projects",
    "dept": "C R P",
    "num": "421",
    "desc": "\nInvestigation of the financial tools and incentives used to promote the rehabilitation and redevelopment of historic buildings and neighborhoods in cities and towns. Study of broader economic and social impacts on communities. Examinations of completed preservation projects around the United States.\n",
    "credits": "3"
  },
  {
    "course_name": "Planning in Developing Countries",
    "dept": "C R P",
    "num": "429",
    "desc": "\nIntroduction to issues in planning and governance in an international setting. Problems and strategies may include population movement and change, economic globalization, urban growth, rural development, and housing.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Planning Studio",
    "dept": "C R P",
    "num": "432",
    "desc": "Prereq: C R P 201, C R P 301, C R P 383, or permission of instructor.\nIntegration of planning methods and theory in dealing with a community planning problem. Analysis of problem and formulation of strategies for implementation. Preparation of a community planning report.\n",
    "credits": "4"
  },
  {
    "course_name": "Planning in Small Towns",
    "dept": "C R P",
    "num": "435",
    "desc": "Prereq: Junior classification\nContemporary planning problems in small towns and the design of viable strategies to enhance their social and economic position in today's society.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Economic Development",
    "dept": "C R P",
    "num": "436",
    "desc": "\nThe nature and process of economic development in the context of community development. Recent changes and trends and their implications for local and regional development. Selected case studies and applications. Contemporary community economic development issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Participation in Planning",
    "dept": "C R P",
    "num": "437",
    "desc": "\nRationale and need for public participation in community planning and development. Techniques used to garner participation, and the ability to integrate techniques into a broader participatory process. Techniques covered will include public hearings, public meetings, social action construct, advisory committees, scenario building, social media and asset mapping. Students will also work with a community to demonstrate skills learned.\n  None",
    "credits": "3"
  },
  {
    "course_name": "Site Development",
    "dept": "C R P",
    "num": "442",
    "desc": "\nIntroduction to site development including site review. Studio project integrating concept, finance, selection, analysis, and design.\n",
    "credits": "3"
  },
  {
    "course_name": "Transportation Policy and Planning",
    "dept": "C R P",
    "num": "445",
    "desc": "Prereq: Junior classification;  CRP 545 prerequisite: Graduate classification\nComprehensive overview of key policy issues related to transportation planning and investment in the United States and abroad. Policy issues explored include safety, environmental impact, sustainable communities, and economic development. Policy analysis and planning are studied in conjunction with each policy issue explored. Issues of concern to state, metropolitan, and local governments.\n",
    "credits": "3"
  },
  {
    "course_name": "Geodesign",
    "dept": "C R P",
    "num": "449",
    "desc": "Prereq: CRP 251 or equivalent or permission of the instructor\nGeodesign combines design creativity with scientific thinking based on spatial data. Special focus on sustainable development of future neighborhoods, communities, cities and/or countries. Students learn the geodesign process and implement a set of techniques and technologies that enable project conceptualization, data collection and visualization, spatial analysis, design creation, impact evaluation and stakeholder participation. Final project involves developing cases for analysis using ESRI ArcGIS Online and GeoPlanner software.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Geographic Information Systems",
    "dept": "C R P",
    "num": "451",
    "desc": "\nIntroduction to geographic information systems, including discussions of GIS hardware, software, data structures, data acquisition, data conversion, data presentation, analytical techniques, and implementation procedures. Laboratory emphasizes practical applications and uses of GIS.\n",
    "credits": "3"
  },
  {
    "course_name": "Geographic Data Management and Planning Analysis",
    "dept": "C R P",
    "num": "452",
    "desc": "Prereq: C R P 351 or equivalent\nExtensive coverage of geo-relational database concept and design, GIS database creation and maintenance, geographic data manipulation and analysis. GIS output generation and geographic data presentation. Laboratory emphasizes practical applications and uses of GIS.\n",
    "credits": "3"
  },
  {
    "course_name": "Smart Cities",
    "dept": "C R P",
    "num": "453",
    "desc": "\nIntroduction to concepts of smart cities. Study of novel technologies for smart governance, sustainable energy, innovative ways for citizens' engagement, improved safety, mobility and healthy living. Examples of national and international smart cities. Living Lab experience.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Remote Sensing",
    "dept": "C R P",
    "num": "454",
    "desc": "Prereq: CRP 351 or equivalent or permission of the instructor\nIntroduction to remote sensing techniques needed for basic analysis of satellite images, including: filtering and conflation techniques, stacking, pan sharpening, image rectification, image enhancement, unsupervised and supervised classification. Practical applications in a variety of topics to understand how to interpret images.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS Programming and Automation",
    "dept": "C R P",
    "num": "456",
    "desc": "Prereq: CRP 351 or CRP 551 or NREM 345 or NREM 546 or GEOL 552\nIntroduction to automated geoprocessing in Geographic Information Systems. Focus on learning scripting language and object-oriented programming, automation of custom-designed geoprocessing scripts, and application toward student research and/or interests.\n",
    "credits": "3"
  },
  {
    "course_name": "Web Mapping/GIS",
    "dept": "C R P",
    "num": "458",
    "desc": "Prereq: CRP 451/551, LA 302. GEOL 452/552 or instructor permission.\nUse and development of online mapping tools to support participatory GIS, Volunteered Geographic Information, information sharing, geodesign and decision making actions. Geoprocessing and Web Scripting/coding and user interface design. Laboratory emphasis practical applications and uses of Web GIS.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Justice and Planning",
    "dept": "C R P",
    "num": "460",
    "desc": "\nInvestigation of the topic of social justice as it relates to the challenge of planning more socially just urban societies, emphasizing the importance of social justice issues to planning in a globalized world. Includes a range of issues and case studies of local social justice initiatives, both US and global. Students will complete individual service learning projects as part of the course requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Grant Writing",
    "dept": "C R P",
    "num": "475",
    "desc": "\nA short introduction to effective grant writing for the public and non-profit sectors. Includes identifying appropriate funding sources for an organization, identifying goals and objectives, and budgeting.\n",
    "credits": "1"
  },
  {
    "course_name": "Public Finance and Planning",
    "dept": "C R P",
    "num": "479",
    "desc": "\nEffective management of state and local government finance critical to successful community and regional planning. Economic concepts, topics in budgeting, revenue, expenditure, and financing, analytical techniques, economic impact, and case studies. Understanding of economic assessment in planning and understanding of various linkages between planning and public finance.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Communities",
    "dept": "C R P",
    "num": "484",
    "desc": "Prereq: Junior classification\nThe history and theory of sustainable community planning.  Procedural and substantive dimensions.  Case studies of communities engaged in sustainability planning.  Use and development of indicators.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "C R P",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of an approved topic commensurate with student's interest and ability.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "C R P",
    "num": "490H",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of an approved topic commensurate with student's interest and ability.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Environmental Law and Planning",
    "dept": "C R P",
    "num": "491",
    "desc": "Prereq: 6 credits in natural sciences\nEnvironmental law and policy as applied in planning at the local and state levels. Brownfields, environmental justice, water quality, air quality, wetland and floodplain management, and local government involvement in ecological protection through land use planning and other programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Planning Law, Administration and Implementation",
    "dept": "C R P",
    "num": "492",
    "desc": "Prereq: Junior classification\nThe basis in constitutional, common, and statutory law for the powers of plan implementation. Problems of balancing public and private interests as revealed in the study of leading court cases. Administration of planning agencies and programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Senior Seminar in Planning",
    "dept": "C R P",
    "num": "494",
    "desc": "Prereq: Senior classification\nAn advanced forum for seniors that focuses upon recent trends and important issues affecting planning today. Topics addressed will vary. A demonstration of understanding of current issues and their effects upon planning applications is expected.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Work Experience",
    "dept": "C R P",
    "num": "510",
    "desc": "Prereq: Permission of department chair\nApproved professional work experience.\n",
    "credits": "R"
  },
  {
    "course_name": "Documenting the Historic Built Environment",
    "dept": "C R P",
    "num": "511",
    "desc": "Prereq: Knowledge of GIS helpful but not required.\nPrincipals and methods for researching, identifying, recording, and analyzing buildings, districts, and sites that are historically or architecturally significant. Classroom and fieldwork components will use real-world historic places as case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Urban Design and Practice",
    "dept": "C R P",
    "num": "516",
    "desc": "Prereq: C R P 301\nPrinciples of urban design and their application to residential and commercial development in studio projects.\n",
    "credits": "6"
  },
  {
    "course_name": "Urban Revitalization",
    "dept": "C R P",
    "num": "517",
    "desc": "Prereq: Junior classification\nPlanning methods available to further revitalization and preservation efforts, with particular attention to housing and neighborhoods. Relationship between neighborhood change and urban development process; public policy implications.\n",
    "credits": "3"
  },
  {
    "course_name": "Historic Preservation Planning: Theory and Practice",
    "dept": "C R P",
    "num": "521",
    "desc": "Prereq: None\nIntroduction to the history, theory, and practice of historic preservation and cultural resource management. Cases exploring preservation in US and global contexts; politics of preservation; preservation technologies; and relationship of preservation to other community issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Development",
    "dept": "C R P",
    "num": "526",
    "desc": "Prereq: Enrollment in the MRED or instructor permission.\nOverview of the real estate development process. Topics include the history of real estate development, roles of planning and market forces in real estate development, and financial management of real estate development. Projects involve analysis of market niches, market penetration rates, lease rates, synergism and tenant mix, and the go/no go decision applied to residential, commercial, and mixed-use development.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Community Development",
    "dept": "C R P",
    "num": "527",
    "desc": "Prereq: Enrollment in the MRED or instructor permission.\nIntroduces the central principles of sustainable community design and its implementation in the residential and commercial real estate development sectors. Topics include current practices and regulatory mandates, with a focus on the importance of private participation in the development of sustainable communities.\n",
    "credits": "3"
  },
  {
    "course_name": "Financing Historic Preservation Projects and Revitalizing Communities",
    "dept": "C R P",
    "num": "528",
    "desc": "Prereq: Enrollment in the MRED or instructor permission.\nInvestigation of the financial tools and incentives used to promote the rehabilitation and redevelopment of historic buildings and neighborhoods in cities and towns. Study of broader economic and social impacts on communities. Examinations of completed preservation projects around the United States.\n",
    "credits": "3"
  },
  {
    "course_name": "Planning in Developing Countries",
    "dept": "C R P",
    "num": "529",
    "desc": "\nIntroduction to issues in planning and governance in an international setting. Problems and strategies may include population movement and change, economic globalization, urban growth, rural development, and housing.\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum",
    "dept": "C R P",
    "num": "530",
    "desc": "Prereq: Graduate classification in Community and Regional Planning\nPractical planning experience. Structured work in range of tasks under close supervision of a professional planner. Relationships between theory and practice, exposure to variety of roles in functioning specialties.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Community Planning Studio",
    "dept": "C R P",
    "num": "532",
    "desc": "Prereq: C R P 564 or equivalent\nComprehension and analysis of various geographic contexts pertinent to community planning and the use of planning theory, tools and techniques in an applied setting. Process of making a community plan: historical patterns, current conditions and strategies for planning.\n",
    "credits": "4"
  },
  {
    "course_name": "Planning in Small Towns",
    "dept": "C R P",
    "num": "535",
    "desc": "Prereq: Junior classification\nContemporary planning problems in small towns and the design of viable strategies to enhance their social and economic position in today's society.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Economic Development",
    "dept": "C R P",
    "num": "536",
    "desc": "\nThe nature and process of economic development in the context of community development. Recent changes and trends and their implications for local and regional development. Selected case studies and applications. Contemporary community economic development issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Site Development",
    "dept": "C R P",
    "num": "542",
    "desc": "\nIntroduction to site development including site review. Studio project integrating concept, finance, selection, analysis, and design.\n",
    "credits": "3"
  },
  {
    "course_name": "Transportation Policy and Planning",
    "dept": "C R P",
    "num": "545",
    "desc": "Prereq: Junior classification;  CRP 545 prerequisite: Graduate classification\nComprehensive overview of key policy issues related to transportation planning and investment in the United States and abroad. Policy issues explored include safety, environmental impact, sustainable communities, and economic development. Policy analysis and planning are studied in conjunction with each policy issue explored. Issues of concern to state, metropolitan, and local governments.\n",
    "credits": "3"
  },
  {
    "course_name": "Geodesign",
    "dept": "C R P",
    "num": "549",
    "desc": "Prereq: CRP 251 or equivalent or permission of the instructor\nGeodesign combines design creativity with scientific thinking based on spatial data. Special focus on sustainable development of future neighborhoods, communities, cities and/or countries. Students learn the geodesign process and implement a set of techniques and technologies that enable project conceptualization, data collection and visualization, spatial analysis, design creation, impact evaluation and stakeholder participation. Final project involves developing cases for analysis using ESRI ArcGIS Online and GeoPlanner software.\n",
    "credits": "3"
  },
  {
    "course_name": "Making Resilient Environments",
    "dept": "C R P",
    "num": "550",
    "desc": "Prereq: senior or graduate standing.\nMajor theories and ideas revolving around the concept of resilience.  Assessing the social and political processes associated with policy making for resilience. Application of the concept of resilience in order to understand and evaluate environments. Evaluate the different approaches toward resilience and develop an understanding of the relationship between sustainability and resilience. Case studies of communities that proactively prepare for, absorb, recorver from, and adapt to actual or potential future adverse events.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Geographic Information Systems",
    "dept": "C R P",
    "num": "551",
    "desc": "\nIntroduction to geographic information systems, including discussions of GIS hardware, software, data structures, data acquisition, data conversion, data presentation, analytical techniques, and implementation procedures. Laboratory emphasizes practical applications and uses of GIS.\n",
    "credits": "3"
  },
  {
    "course_name": "Geographic Data Management and Planning Analysis",
    "dept": "C R P",
    "num": "552",
    "desc": "Prereq: C R P 351 or equivalent\nExtensive coverage of geo-relational database concept and design, GIS database creation and maintenance, geographic data manipulation and analysis. GIS output generation and geographic data presentation. Laboratory emphasizes practical applications and uses of GIS.\n",
    "credits": "3"
  },
  {
    "course_name": "Analytical Planning/GIS",
    "dept": "C R P",
    "num": "553",
    "desc": "Prereq: C R P 451/C R P 551\nIntegration of exploratory, participatory and predictive spatial analyses and 3D visualization into the planning process. GIS tools and techniques are used to automate decision analysis and facilitate future planning in analyzing and visualizing planning actions. Laboratory emphasizes practical uses of GIS tools and techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Remote Sensing",
    "dept": "C R P",
    "num": "554",
    "desc": "Prereq: CRP 351 or equivalent or permission of the instructor\nIntroduction to remote sensing techniques needed for basic analysis of satellite images, including: filtering and conflation techniques, stacking, pan sharpening, image rectification, image enhancement, unsupervised and supervised classification. Practical applications in a variety of topics to understand how to interpret images.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS Programming and Automation",
    "dept": "C R P",
    "num": "556",
    "desc": "Prereq: CRP 351 or CRP 551 or NREM 345 or NREM 546 or GEOL 552\nIntroduction to automated geoprocessing in Geographic Information Systems. Focus on learning scripting language and object-oriented programming, automation of custom-designed geoprocessing scripts, and application toward student research and/or interests.\n",
    "credits": "3"
  },
  {
    "course_name": "Web Mapping/GIS",
    "dept": "C R P",
    "num": "558",
    "desc": "Prereq: CRP 451/551, LA 302. GEOL 452/552 or instructor permission.\nUse and development of online mapping tools to support participatory GIS, Volunteered Geographic Information, information sharing, geodesign and decision making actions. Geoprocessing and Web Scripting/coding and user interface design. Laboratory emphasis practical applications and uses of Web GIS.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Justice and Planning",
    "dept": "C R P",
    "num": "560",
    "desc": "\nInvestigation of the topic of social justice as it relates to the challenge of planning more socially just urban societies, emphasizing the importance of social justice issues to planning in a globalized world. Includes a range of issues and case studies of local social justice initiatives, both US and global. Students will complete individual service learning projects as part of the course requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Planning Theory",
    "dept": "C R P",
    "num": "561",
    "desc": "\nUse and development of theory/action relationship in planning practice. Competing normative theories of planning and their evolution, key components and fundamental critiques. Exploration of planning frameworks and approaches, including comprehensive planning; incrementalism; advocacy; communicative rationality; and others.\n",
    "credits": "3"
  },
  {
    "course_name": "Planning the American Metropolis",
    "dept": "C R P",
    "num": "563",
    "desc": "\nFocus on the historical role of planning in the shaping of American cities and regions, from the beginning of the Republic to the present. Examine the legacy of planning by exploring the intersection of design, politics and policy. Investigate the factors and the processes that produce the built environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Analytical Methods for Planning",
    "dept": "C R P",
    "num": "564",
    "desc": "\nApplications of analytical methods in planning with emphasis on the collection, description, analysis, presentation, and interpretation of planning data. Introduction to descriptive statistics. Sources of planning information and data including primary and secondary data types and sources. Demographic analysis, population projection techniques for planning at local and regional levels.\n",
    "credits": "3"
  },
  {
    "course_name": "Policy Analysis and Planning",
    "dept": "C R P",
    "num": "566",
    "desc": "\nPrinciples and methods for analyzing community problems and policies including forecasting, efficiency and equity measures, cost/benefit, political feasibility, and sensitivity analysis. Examination of social, political, economic, and environmental values and their manifestation in decision making methods used in planning. Application of tools used to analyze planning problems, project evaluation and public policies.\n",
    "credits": "3"
  },
  {
    "course_name": "Planning and Development",
    "dept": "C R P",
    "num": "568",
    "desc": "Prereq: C R P 564 or equivalent\nExploration and evaluation of the techniques, processes, and professional skills required to effectively manage land use change at various scales. Land classification systems; land supply and needs inventory for residential uses and commercial and employment centers; capacity and needs analysis for public infrastructure. Includes land use planning project(s) designed to apply the methods explored in this and other courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Grant Writing",
    "dept": "C R P",
    "num": "575",
    "desc": "\nA short introduction to effective grant writing for the public and non-profit sectors. Includes identifying appropriate funding sources for an organization, identifying goals and objectives, and budgeting.\n",
    "credits": "1"
  },
  {
    "course_name": "MRED Capstone Project",
    "dept": "C R P",
    "num": "578",
    "desc": "Prereq: Enrollment in MRED.\nRefinement of students' problem-solving, communication and negotiation skills. Students work on an actual case. Teams will apply knowledge acquired in the classroom to some aspect of a current development on-the-ground and in-process project.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Finance and Planning",
    "dept": "C R P",
    "num": "579",
    "desc": "\nEffective management of state and local government finance critical to successful community and regional planning. Economic concepts, topics in budgeting, revenue, expenditure, and financing, analytical techniques, economic impact, and case studies. Understanding of economic assessment in planning and understanding of various linkages between planning and public finance.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Communities",
    "dept": "C R P",
    "num": "584",
    "desc": "Prereq: Junior classification\nThe history and theory of sustainable community planning.  Procedural and substantive dimensions.  Case studies of communities engaged in sustainability planning.  Use and development of indicators.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "C R P",
    "num": "590",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Planning Law, Administration and Implementation",
    "dept": "C R P",
    "num": "590A",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Economic Development",
    "dept": "C R P",
    "num": "590B",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Urban Design",
    "dept": "C R P",
    "num": "590C",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Housing and Urban Revitalization",
    "dept": "C R P",
    "num": "590D",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Environmental Planning",
    "dept": "C R P",
    "num": "590H",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Land Use and Transportation Planning",
    "dept": "C R P",
    "num": "590I",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: International Planning",
    "dept": "C R P",
    "num": "590N",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Spatial Analytical Methods",
    "dept": "C R P",
    "num": "590O",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Planning in Small Towns",
    "dept": "C R P",
    "num": "590P",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Diversity and Equity in Planning",
    "dept": "C R P",
    "num": "590Q",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Geographic Information Systems",
    "dept": "C R P",
    "num": "590R",
    "desc": "Prereq: Graduate classification and written approval of instructor and department chair on required form\n",
    "credits": "1"
  },
  {
    "course_name": "Environmental Law and Planning",
    "dept": "C R P",
    "num": "591",
    "desc": "Prereq: 6 credits in natural sciences\nEnvironmental law and policy as applied in planning at the local and state levels. Brownfields, environmental justice, water quality, air quality, wetland and floodplain management, and local government involvement in ecological protection through land use planning and other programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Land Use and Development Regulation Law",
    "dept": "C R P",
    "num": "592",
    "desc": "\nAn in-depth analysis of the legal constructs that shape the practice of planning and plan implementation in the United States.  An exploration of how land use regulations are applied to reconcile the competing needs and diverse uses of land.  The positive and negative consequences of developing and implementing regulatory controls will be addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in GIS Applications/Research",
    "dept": "C R P",
    "num": "595",
    "desc": "Prereq: 9 credits in GIS Certificate program\nDiscussion and demonstration of current GIS applications and research in multiple disciplines.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Planning Report",
    "dept": "C R P",
    "num": "599",
    "desc": "\nIndependent planning project with practical application, including research element.\n",
    "credits": "arr"
  },
  {
    "course_name": "Capstone Studio",
    "dept": "C R P",
    "num": "698",
    "desc": "Prereq: Permission of instructor.\nSynthesis and integration of core planning knowledge into professional work in a team setting.\n",
    "credits": "4"
  },
  {
    "course_name": "Research",
    "dept": "C R P",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Community and Natural Resource Management",
    "dept": "C DEV",
    "num": "502",
    "desc": "\nDetailed introduction to community resource management.  Theoretical frameworks, methodological investigation, applied practices.  Enhancement of ability of community development professionals to work with communities to plan, develop and monitor conversation and development of natural resources with multiple functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Development I: Principles and Strategies of Community Change",
    "dept": "C DEV",
    "num": "503",
    "desc": "\nAnalysis of principles and practices of community change and development. Use of case studies to relate community development approaches to conceptual models from diverse disciplines.  Exploration of professional practice principles, and student construction of their personal framework for practicing community development.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Analysis: Introduction to Methods",
    "dept": "C DEV",
    "num": "504",
    "desc": "\nIntroduction to research methods relevant to community development. Formulate and begin a research effort, methods of data collection and how conceptual frameworks are used to develop the questions and analyze data. Emphasis on strategies for reporting findings and applying findings in community action and methods of evaluating the entire research process. Significant attention paid to issues of research ethics and inclusiveness.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Development II: Organizing for Community Change",
    "dept": "C DEV",
    "num": "505",
    "desc": "\nExamines role of civil society in community planning efforts. Comparative approach to planning theories and approaches. Focus on change within communities and the roles of government, planners, and citizens in reacting to or shaping change. Dimensions of social capital and the context of change covered.\n",
    "credits": "3"
  },
  {
    "course_name": "Community and Regional Economic Analysis I",
    "dept": "C DEV",
    "num": "506",
    "desc": "\nIntroduction to concepts of communities and regions, theories of economic growth, drivers of economic growth, the economic base of a community, sources of growth or decline in the community, roles of local government and institutions, and analytical tools. Strategies for local economic development will also be explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Native Communities",
    "dept": "C DEV",
    "num": "507",
    "desc": "\nA base knowledge course. For students currently working within, in partnership with, or considering working with Native communities. Basic understanding within the context of community development of the diversity of the tribal structures and cultures and the unique history and jurisdictional considerations of these nations.  Working with tribes, Federal and Indian relations, and governance and cultural issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecological Economics",
    "dept": "C DEV",
    "num": "508",
    "desc": "\nApproaches economy and community by looking at the inherent interdependence, jointness, and potential complimentarity between ecology and economy (utility) of a place.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Native Community and Economic Capacity",
    "dept": "C DEV",
    "num": "509",
    "desc": "\nFocus on non-western approaches to helping Native communities build their capacity. Students will learn to take a participatory, culture-centered, and strength-based approach to development.\n",
    "credits": "3"
  },
  {
    "course_name": "Indian Country Agriculture and Natural Resources",
    "dept": "C DEV",
    "num": "510",
    "desc": "\nIntroduction to the historical and contemporary issues related to natural resource management on Native American lands.   Philosophical and economic arguments concerning natural resource conservation, preservation and extraction will be explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Communities",
    "dept": "C DEV",
    "num": "512",
    "desc": "\nStudents will learn the conceptual relationships among Community and Sustainable Development and Sustainable Communities and examine the social, environmental, and economic aspects of sustainable communities. The course includes analysis of public policy impacts on community sustainability, practical actions for enhancing sustainability, and changing power dynamics and reward structures involved in incorporating sustainability into Community Development.\n",
    "credits": "3"
  },
  {
    "course_name": "Economic Development Strategies and Programs",
    "dept": "C DEV",
    "num": "513",
    "desc": "\nCourse explores theories of local economic development and addresses the development issues faced by communities in the 21st century. Students will understand and apply concepts from economic development planning, economic analysis, business development, human resource development, community-based development, and high-technology development.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Development Orientation",
    "dept": "C DEV",
    "num": "520",
    "desc": "\nIntroduction to the Community Development program. Focus on on-line delivery methods, graduate level research and writing, technology skills.\n",
    "credits": "2"
  },
  {
    "course_name": "Housing and Development",
    "dept": "C DEV",
    "num": "521",
    "desc": "Prereq: None.\nReview and evaluation of historical and current housing issues, production, and financial systems, including consideration of racial, ethnic, income, and gender issues as they relate to the role of housing developments and programs in community development.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Leadership and Capacity Building",
    "dept": "C DEV",
    "num": "522",
    "desc": "\nDefining leadership and applying it to the workplace. Understanding of potential link between leadership and community capacity. Identifying strategies for leadership development in communities.\n",
    "credits": "3"
  },
  {
    "course_name": "Grantwriting for Community Development Professionals",
    "dept": "C DEV",
    "num": "523",
    "desc": "\nBasic Grant Development and Management will introduce students to the grant-getting process and provide an overview of what happens after a project is funded. The following topics will be covered: researching funding sources, generating cutting edge ideas, assessing needs, planning a project, establishing credibility, formulating a sustainable budget, designing an evaluation plan, managing the funded project, and disseminating project results.\n",
    "credits": "3"
  },
  {
    "course_name": "Non-Profit Management in Community Development",
    "dept": "C DEV",
    "num": "524",
    "desc": "\nUnderstanding of how non-profit organizations are run in order that they may participate more fully   in community development efforts. Learning skills necessary to assist organizations to manage   community development projects and programs, such as, budgeting, planning, personnel, facilities,   volunteer management, and fundraising.\n",
    "credits": "3"
  },
  {
    "course_name": "Role of Tribal Colleges in Economic Development",
    "dept": "C DEV",
    "num": "525",
    "desc": "\nFocus on role of tribally-chartered colleges and universities in economic development within Native communities. Social capital analytic framework to examine and evaluate tribal college model of economic development.\n",
    "credits": "3"
  },
  {
    "course_name": "Immigration and Community Inclusion",
    "dept": "C DEV",
    "num": "526",
    "desc": "\nMechanisms for community inclusion and exclusion in relation to immigration will be examined. Aspects of ethnicity, religion, occupation and transnationalism are addressed in terms of community mechanism for incorporating immigrants as community assets.\n",
    "credits": "3"
  },
  {
    "course_name": "Public and Non-Profit Budgeting",
    "dept": "C DEV",
    "num": "527",
    "desc": "\nIntroduction to the fundamental theories and practices of budgeting in the public and non-profit sectors. Topics covered include overview of budgeting and budget reform, taxation, expenditures, budget preparation and adoption, budget implementation, and performance budgeting.\n",
    "credits": "3"
  },
  {
    "course_name": "Evaluation of Organizations and Programs",
    "dept": "C DEV",
    "num": "528",
    "desc": "Prereq: C DEV 504 with grade of C or better\nIntroduction to the philosophy, techniques, and methodologies of organizational and program evaluation. Overview of program evaluation and theory, techniques to evaluate program processes and performance, evaluation designs, assessing program efficiency, models to diagnose organizations, and methods to assess organizational performance.\n",
    "credits": "3"
  },
  {
    "course_name": "Toward Ethical Engagement",
    "dept": "C DEV",
    "num": "530",
    "desc": "\nUnderstanding what ethics are and identify ethical dimensions of a problem. Ability to employ ethical analysis and engagement strategies in public problem-solving.\n",
    "credits": "3"
  },
  {
    "course_name": "Community and Regional Economic Analysis II",
    "dept": "C DEV",
    "num": "532",
    "desc": "Prereq: C DEV 506\nSubstantive grounding in the theories and practice of measuring community economic dynamics; build solid foundation skills for applied community economic analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "The Policy and Politics of Coastal Areas",
    "dept": "C DEV",
    "num": "542",
    "desc": "\nExploration of political implications of coastal policy. Issues include: \"Carrying capacity,\" zoning, regulation of human development activities, tradeoffs between conservation and jobs, the quality of coastal lifestyle, ways in which citizens participate in policy for coastal areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Community Development",
    "dept": "C DEV",
    "num": "590",
    "desc": "\nSpecial topics in Community Development. Independent Study, must get instructor approval.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "C DEV",
    "num": "599",
    "desc": "\nStudents work with major professor to conduct research and carry out work on their creative component. Instructor permission required.\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis Research",
    "dept": "C DEV",
    "num": "699",
    "desc": "\nThesis Research.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Computer Security Literacy",
    "dept": "CPR E",
    "num": "131",
    "desc": "\nBasic concepts of practical computer and Internet security: passwords, firewalls, antivirus software, malware, social networking, surfing the Internet, phishing, and wireless networks. This class is intended for students with little or no background in information technology or security. Basic knowledge of word processing required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Programs Orientation",
    "dept": "CPR E",
    "num": "166",
    "desc": "\n(1-0) Overview of the nature and scope of electrical engineering and computer engineering professions. Overview of portfolios. Departmental rules, student services operations, degree requirements, program of study planning, career options, and student organizations.\n",
    "credits": "R"
  },
  {
    "course_name": "Computer Engineering Learning Community",
    "dept": "CPR E",
    "num": "184",
    "desc": "Prereq: Member of Cpr E Learning Community\nIntegration of first-year students into the Computer Engineering program. Assignments and activities involving teamwork, academic preparation, study skills, and preparation for entry into the Computer Engineering profession. Completed both individually and in learning teams under the direction of faculty and peer mentors.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Computer Engineering and Problem Solving I",
    "dept": "CPR E",
    "num": "185",
    "desc": "Prereq: MATH 143 or satisfactory scores on mathematics placement examinations; credit or enrollment in MATH 165\nIntroduction to Computer Engineering. Project based examples from computer engineering. Individual interactive skills for small and large groups. Computer-based projects. Solving engineering problems and presenting solutions through technical reports. Solution of engineering problems using a programming language.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computer Engineering and Problem Solving II",
    "dept": "CPR E",
    "num": "186",
    "desc": "Prereq: CPR E 185\nProject based examples from computer engineering. Group skills needed to work effectively in teams. Group problem solving. Computer based projects. Technical reports and presentations. Students will work on 2 or 3 self-directed team based projects that are representative of problems faced by computer engineers.\n",
    "credits": "1"
  },
  {
    "course_name": "Cyber Security Fundamentals",
    "dept": "CPR E",
    "num": "230",
    "desc": "Prereq: COM S 227, E E 285, or MIS 207.\nIntroduction to computer and network infrastructures used to support cyber security. Basic concepts of computer and network configuration used to secure environments. Computer virtualization, network routing and address translation, computer installation and configuration, network monitoring, in a virtual environment. Laboratory experiments and exercises including secure computer and network configuration and management.\n",
    "credits": "3"
  },
  {
    "course_name": "Cyber Security Concepts and Tools",
    "dept": "CPR E",
    "num": "231",
    "desc": "Prereq: CPR E 230\nBasic concepts of practical computer and Internet security and the tools used to protect and attack systems and networks. Computer and network security methods including: user authentication, access control, firewalls, intrusion detection, use of vulnerability assessment tools and methods, and penetration testing. Ethics and legal issues in cyber security will also be covered. Laboratory experiments and exercises including evaluating systems for vulnerabilities, understanding potential exploits of the systems, and defenses for the systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Transfer Orientation",
    "dept": "CPR E",
    "num": "261",
    "desc": "\nIntroduction to the College of Engineering and the engineering profession specifically for transfer students. Information concerning university and college policies, procedures, and resources.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Digital Logic",
    "dept": "CPR E",
    "num": "281",
    "desc": "Prereq: sophomore classification\nNumber systems and representation. Boolean algebra and logic minimization. Combinational and sequential logic design.  Arithmetic circuits and finite state machines. Use of programmable logic devices. Introduction to computer-aided schematic capture systems, simulation tools, and hardware description languages. Design of simple digital systems.\n",
    "credits": "4"
  },
  {
    "course_name": "Embedded Systems I:  Introduction",
    "dept": "CPR E",
    "num": "288",
    "desc": "Prereq: CPR E 281, COM S 207 or COM S 227 or E E 285\nEmbedded C programming. Interrupt handling.  Memory mapped I/O in the context of an application.  Elementary embedded design flow/methodology.  Timers, scheduling, resource allocation, optimization, state machine based controllers, real time constraints within the context of an application.  Applications laboratory exercises with embedded devices.\n",
    "credits": "4"
  },
  {
    "course_name": "Program Discovery",
    "dept": "CPR E",
    "num": "294",
    "desc": "Prereq: CPR E 166 or E E 166\nThe roles of professionals in computer and electrical engineering.  Relationship of coursework to industry and academic careers.  Issues relevant to today's world.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Operating Systems: Principles and Practice",
    "dept": "CPR E",
    "num": "308",
    "desc": "Prereq: CPR E 381 or COM S 321\nOperating system concepts, processes, threads, synchronization between threads, process and thread scheduling, deadlocks, memory management, file systems, I/O systems,security, Linux-based lab experiments.\n",
    "credits": "4"
  },
  {
    "course_name": "Theoretical Foundations of Computer Engineering",
    "dept": "CPR E",
    "num": "310",
    "desc": "Prereq: COM S 228\nPropositional logic and methods of proof; set theory and its applications; mathematical induction and recurrence relations; functions and relations; and counting; trees and graphs; applications in computer engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Applications of Algorithms in Computer Engineering",
    "dept": "CPR E",
    "num": "315",
    "desc": "Prereq: CPR E 310\nSolving computer engineering problems using algorithms.  Emphasis on problems related to the core focus areas in computer engineering.  Real world examples of algorithms used in the computer engineering domain.  Algorithm engineering.  Prototyping of algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Software Project Management",
    "dept": "CPR E",
    "num": "329",
    "desc": "Prereq: COM S 309\nProcess-based software development. Capability Maturity Model (CMM). Project planning, cost estimation, and scheduling. Project management tools. Factors influencing productivity and success. Productivity metrics. Analysis of options and risks. Version control and configuration management. Inspections and reviews. Managing the testing process. Software quality metrics. Modern software engineering techniques and practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Electronics",
    "dept": "CPR E",
    "num": "330",
    "desc": "Prereq: E E 201, credit or enrollment in E E 230, CPR E 281\nSemiconductor technology for integrated circuits. Modeling of integrated devices including diodes, BJTs, and MOSFETs. Physical layout. Circuit simulation. Digital building blocks and digital circuit synthesis. Analysis and design of analog building blocks. Laboratory exercises and design projects   with CAD tools and standard cells.\n",
    "credits": "4"
  },
  {
    "course_name": "Cyber Defense Competition",
    "dept": "CPR E",
    "num": "332",
    "desc": "\nParticipation in cyber defense competition driven by scenario-based network design. Includes computer system setup, risk assessment and implementation of security systems, as well as defense of computer and network systems against trained attackers. Team based.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Software Architecture and Design",
    "dept": "CPR E",
    "num": "339",
    "desc": "Prereq: S E 319\nModeling and design of software at the architectural level. Architectural styles. Basics of model-driven architecture. Object-oriented design and analysis. Iterative development and unified process. Design patterns. Design by contract. Component based design. Product families. Measurement theory and appropriate use of metrics in design. Designing for qualities such as performance, safety, security, reliability, reusability, etc. Analysis and evaluation of software architectures. Introduction to architecture definition languages. Basics of software evolution, reengineering, and reverse engineering. Case studies. Introduction to distributed system software.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Organization and Assembly Level Programming",
    "dept": "CPR E",
    "num": "381",
    "desc": "Prereq: CPR E 288\nIntroduction to computer organization, evaluating performance of computer systems, instruction set design.  Assembly level programming:  arithmetic operations, control flow instructions, procedure calls, stack management.  Processor design.  Datapath and control, scalar pipelines, introduction to memory and I/O systems.\n",
    "credits": "4"
  },
  {
    "course_name": "Embedded Systems II: Mobile Platforms",
    "dept": "CPR E",
    "num": "388",
    "desc": "Prereq: CPR E 288\nContemporary programming techniques for event driven systems. Mobile platforms and operating systems. Location and motion sensors based user interfaces. Threading and scheduling. Resource management - measurement and control techniques - for memory and energy. Client-server application design. Distributed applications. Laboratory includes exercises based on a mobile platform.\n",
    "credits": "4"
  },
  {
    "course_name": "Program Exploration",
    "dept": "CPR E",
    "num": "394",
    "desc": "Prereq: CPR E 294 or E E 294\nExploration of academic and career fields for electrical and computer engineers.  Examination of professionalism in the context of engineering and technology with competencies based skills.  Introduction to professional portfolio development and construction.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Summer Internship",
    "dept": "CPR E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education (Co-op)",
    "dept": "CPR E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period. One semester per academic or calendar year. Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Formal Methods in Software Engineering",
    "dept": "CPR E",
    "num": "412",
    "desc": "Prereq: COM S 311, STAT 330; for graduate credit: graduate standing or permission of instructor\nA study of formal techniques for model-based specification and verification of software systems. Topics include logics, formalisms, graph theory, numerical computations, algorithms and tools for automatic analysis of systems. Graduate credit requires in-\u00addepth study of concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Software Evolution and Maintenance",
    "dept": "CPR E",
    "num": "416",
    "desc": "Prereq: COM S 309\nPractical importance of software evolution and maintenance, systematic defect analysis and debugging techniques, tracing and understanding large software, impact analysis, program migration and transformation, refactoring, tools for software evolution and maintenance, experimental studies and quantitative measurements of software evolution. Written reports and oral presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "High Speed System Engineering Measurement and Testing",
    "dept": "CPR E",
    "num": "418",
    "desc": "Prereq: E E 230 and E E 311\nMeasurement of high speed systems and mixed signal systems.  Measurement accuracy and error.  Network analysis and spectrum analysis used in high speed measurement and testing.  Test specification process and parametric measurement.  Sampling and digital signal processing concepts.  Design for testability.  Testing equipment. Applications.\n",
    "credits": "4"
  },
  {
    "course_name": "Software Tools for Large Scale Data Analysis",
    "dept": "CPR E",
    "num": "419",
    "desc": "Prereq: CPR E 308 or COM S 352, COM S 309\nSoftware tools for managing and manipulating large volumes of data, external memory processing, large scale parallelism, and stream processing, data interchange formats. Weekly programming labs that involve the use of a parallel computing cluster.\n",
    "credits": "4"
  },
  {
    "course_name": "Software Analysis and Verification for Safety and Security",
    "dept": "CPR E",
    "num": "421",
    "desc": "Prereq: COM S 309; CPR E 310 or COM S 230\nSignificance of software safety and security; various facets of security in cyber-physical and computer systems; threat modeling for software safety and security; and categorization of software vulnerabilities. Software analysis and verification: mathematical foundations, data structures and algorithms, program comprehension, analysis, and verification tools; automated vs. human-on-the-loop approach to analysis and verification; and practical considerations of efficiency, accuracy, robustness, and scalability of analysis and verification. Cases studies with application and systems software; evolving landscape of software security threats and mitigation techniques. Understanding large software, implementing software analysis and verification algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to High Performance Computing",
    "dept": "CPR E",
    "num": "424",
    "desc": "Prereq: MATH 265; MATH 207 or MATH 317; or permission of instructor.\nUnix, serial programming of scientific applications, OpenMP for shared-memory parallelization. No Unix, Fortran or C experience required.\n",
    "credits": "3"
  },
  {
    "course_name": "High Performance Computing for Scientific and Engineering Applications",
    "dept": "CPR E",
    "num": "425",
    "desc": "Prereq: COM S 311, ENGL 250, SP CM 212\nIntroduction to high performance computing platforms including parallel computers and workstation clusters. Discussion of parallel architectures, performance, programming models, and software development issues. Sample applications from science and engineering. Practical issues in high performance computing will be emphasized via a number of programming projects using a variety of programming models and case studies. Oral and written reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Parallel Algorithms and Programming",
    "dept": "CPR E",
    "num": "426",
    "desc": "Prereq: CPR E 308 or COM S 321, CPR E 315 or COM S 311\nModels of parallel computation, performance measures, basic parallel constructs and communication primitives, parallel programming using MPI, parallel algorithms for selected problems including sorting, matrix, tree and graph problems, fast Fourier transforms.\n",
    "credits": "4"
  },
  {
    "course_name": "Network Protocols and Security",
    "dept": "CPR E",
    "num": "430",
    "desc": "Prereq: CPR E 381 or equivalent\nDetailed examination of networking standards, protocols, and their implementation. TCP/IP protocol suite, network application protocols.  Network security issues, attack and mitigation techniques. Emphasis on laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Basics of Information System Security",
    "dept": "CPR E",
    "num": "431",
    "desc": "Prereq: credit or enrollment in CPR E 308 or COM S 352\nIntroduction to and application of basic mechanisms for protecting information systems from accidental and intentional threats. Basic cryptography use and practice. Computer security issues including authentication, access control, and malicious code. Network security mechanisms such as intrusion detection, firewalls, IPSEC, and related protocols. Ethics and legal issues in information security. Wireless security. Programming and system configuration assignments.\n",
    "credits": "3"
  },
  {
    "course_name": "Analog VLSI Circuit Design",
    "dept": "CPR E",
    "num": "435",
    "desc": "Prereq: E E 330\nBasic analog integrated circuit and system design including design space exploration, performance enhancement strategies, operational amplifiers, references, integrated filters, and data converters.\n",
    "credits": "4"
  },
  {
    "course_name": "Bioinformatic Analysis",
    "dept": "CPR E",
    "num": "444",
    "desc": "Prereq: MATH 165 and Introductory Statistics (STAT 101, STAT 104, STAT 105, STAT 201, or STAT 330).\nBroad overview of bioinformatics with a significant problem-solving component, including hands-on practice using computational tools to solve a variety of biological problems. Topics include: bioinformatic data processing, Python programming, genome assembly, database search, sequence alignment, gene prediction, next-generation sequencing, comparative and functional genomics, and systems biology.\n",
    "credits": "4"
  },
  {
    "course_name": "Distributed Systems and Middleware",
    "dept": "CPR E",
    "num": "450",
    "desc": "Prereq: CPR E 308 or COM S 352\nFundamentals of distributed computing, software agents, naming services, distributed transactions, security management, distributed object-based systems, web-based systems, middleware-based application design and development, case studies of middleware and internet applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Distributed Systems",
    "dept": "CPR E",
    "num": "454",
    "desc": "Prereq: COM S 311, COM S 352; for graduate credit: graduate standing or permission of instructor\nTheoretical and practical issues of design and implementation of distributed systems. The client server paradigm, inter-process communications, synchronization and concurrency control, naming, consistency and replication, fault tolerance, and distributed file systems. Graduate credit requires additional in-depth study of concepts. Programming projects and written reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Real  Time Systems",
    "dept": "CPR E",
    "num": "458",
    "desc": "Prereq: CPR E 308 or COM S 352\nFundamental concepts in real-time systems. Real time task scheduling paradigms. Resource management in uniprocessor, multiprocessor, and distributed real-time systems. Fault-tolerance, resource reclaiming, and overload handling. Real-time channel, packet scheduling, and real-time LAN protocols. Case study of real-time operating systems. Laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital VLSI Design",
    "dept": "CPR E",
    "num": "465",
    "desc": "Prereq: E E 330\nDigital design of integrated circuits employing very large scale integration (VLSI) methodologies. Technology considerations in design. High level hardware design languages, CMOS logic design styles, area-energy-delay design space characterization, datapath blocks: arithmetic and memory, architectures and systems on a chip (SOC) considerations. VLSI chip hardware design project.\n",
    "credits": "4"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "CPR E",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design II",
    "dept": "CPR E",
    "num": "467",
    "desc": "Prereq: Student must be within two semesters of graduation or receive permission of instructor.\nBuild and test of a conceptual design. Detail design, manufacturability, test criteria and procedures. Application of design tools such as CAD and CAM and manufacturing techniques such as rapid prototyping. Development and testing of a full-scale prototype with appropriate documentation in the form of design journals, written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphics Processing and Architecture",
    "dept": "CPR E",
    "num": "480",
    "desc": "Prereq: CPR E 381 or COM S 321\nIntroduction to hardware architectures for computer graphics and their programming models. System-level view, including framebuffers, video output devices, displays, 2D and 3D graphics acceleration, and device interfacing. Architectural design of GPUs, from 2D and 3D sprite engines to 3D rendering pipelines to unified shader architectures. Computing models for graphics processors. GPGPU and GPU computing.\n",
    "credits": "4"
  },
  {
    "course_name": "Hardware Software Integration",
    "dept": "CPR E",
    "num": "483",
    "desc": "Prereq: CPR E 381\nEmbedded system design using hardware description language (HDL) and field programmable gate array (FPGA).  HDL modeling concepts and styles are introduced; focus on synthesizability, optimality, reusability and portability in hardware design description. Introduction to complex hardware cores for data buffering, data input/output interfacing, data processing. System design with HDL cores and implementation in FPGA. Laboratory-oriented design projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Embedded Systems Design",
    "dept": "CPR E",
    "num": "488",
    "desc": "Prereq: CPR E 381 or COM S 321\nEmbedded microprocessors, embedded memory and I/O devices, component interfaces, embedded software, program development, basic compiler techniques, platform-based FPGA technology, hardware synthesis, design methodology, real-time operating system concepts, performance analysis and optimizations.\n",
    "credits": "4"
  },
  {
    "course_name": "Computer Networking and Data Communications",
    "dept": "CPR E",
    "num": "489",
    "desc": "Prereq: CPR E 381 or E E 324\nModern computer networking and data communications concepts. TCP/IP, OSI protocols, client server programming, data link protocols, local area networks, and routing protocols.\n",
    "credits": "4"
  },
  {
    "course_name": "Independent Study",
    "dept": "CPR E",
    "num": "490",
    "desc": "Prereq: Senior classification in computer engineering\nInvestigation of an approved topic.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "CPR E",
    "num": "490H",
    "desc": "Prereq: Senior classification in computer engineering\nInvestigation of an approved topic.\n",
    "credits": "arr"
  },
  {
    "course_name": "Senior Design Project I and Professionalism",
    "dept": "CPR E",
    "num": "491",
    "desc": "Prereq: E E 322 or CPR E 308, completion of 24 credits in the E E core professional program or 29 credits in the Cpr E core professional program, ENGL 314\nPreparing for entry to the workplace. Selected professional topics. Use of technical writing skills in developing project plan and design report; design review presentation. First of two-semester team-oriented, project design and implementation experience.\n",
    "credits": "3"
  },
  {
    "course_name": "Senior Design Project II",
    "dept": "CPR E",
    "num": "492",
    "desc": "Prereq: CPR E 491 or E E 491\nSecond semester of a team design project experience. Emphasis on the successful implementation and demonstration of the design completed in E E 491 or CPR E 491 and the evaluation of project results. Technical writing of final project report; oral presentation of project achievements; project poster.\n",
    "credits": "2"
  },
  {
    "course_name": "Portfolio Assessment",
    "dept": "CPR E",
    "num": "494",
    "desc": "Prereq: CPR E 394 or E E 394, credit or enrollment in CPR E 491 or E E 491\nPortfolio update and evaluation. Portfolios as a tool to enhance career opportunities.\n",
    "credits": "R"
  },
  {
    "course_name": "Analog and Mixed-Signal VLSI Circuit Design Techniques",
    "dept": "CPR E",
    "num": "501",
    "desc": "Prereq: E E 435\nDesign techniques for analog and mixed-signal VLSI circuits. Amplifiers; operational amplifiers, transconductance amplifiers, finite gain amplifiers and current amplifiers. Linear building blocks; differential amplifiers, current mirrors, references, cascading and buffering. Performance characterization of linear integrated circuits; offset, noise, sensitivity and stability. Layout considerations, simulation, yield and modeling for high-performance linear integrated circuits.\n",
    "credits": "4"
  },
  {
    "course_name": "CMOS and BiCMOS Data Conversion Circuits",
    "dept": "CPR E",
    "num": "505",
    "desc": "Prereq: E E 501\nTheory, design and applications of data conversion circuits (A/D and D/A converters) including: architectures, characterization, quantization effects, conversion algorithms, spectral performance, element matching, design for yield, and practical comparators, implementation issues.\n",
    "credits": "4"
  },
  {
    "course_name": "Design of CMOS Phase-Locked Loops",
    "dept": "CPR E",
    "num": "506",
    "desc": "Prereq: E E 435 or E E 501 or instructor approval\nAnalysis and design of phase-locked loops implemented in modern CMOS processes including: architectures, performance metrics, and characterization; noise and stability analysis; and design issues of phase-frequency detectors, charge pumps, loop filters (passive and active), voltage controlled oscillators, and frequency dividers.\n",
    "credits": "4"
  },
  {
    "course_name": "VLSI Communication Circuits",
    "dept": "CPR E",
    "num": "507",
    "desc": "Prereq: E E 435 or E E 501\nPhase-locked loops, frequency synthesizers, clock and data recovery circuits, theory and implementation of adaptive filters, low-noise amplifiers, mixers, power amplifiers, transmitter and receiver architectures.\n",
    "credits": "4"
  },
  {
    "course_name": "Design and Analysis of Algorithms",
    "dept": "CPR E",
    "num": "511",
    "desc": "Prereq: COM S 311\nA study of algorithm design and analysis techniques. Network flows and linear programming. Randomized algorithms. NP-completeness. Approximation algorithms. Fixed-parameter algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations and Applications of Program Analysis",
    "dept": "CPR E",
    "num": "513",
    "desc": "Prereq: COM S 331, COM S 342\nAlgorithms and tools for automatically reasoning about code and program executions to predict software behavior. Theory and foundations related to control flow analysis, dataflow analysis, abstract interpretation and symbolic execution. Applications of program analysis to improve software security, performance and testing. Concepts, algorithms, tools, benchmarks, methodologies for solving problems using program analysis and for preparing research in program analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Radio Networks",
    "dept": "CPR E",
    "num": "522",
    "desc": "Prereq: Permission of instructor\nTopics on cognitive radio networks: Cognitive Radio Networks Architecture; Software Defined Radio Architecture; Spectrum Sensing; Spectrum Management; Spectrum Sharing; Spectrum Mobility; Applications of Cognitive Radio Networks.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical Analysis of High Performance Computing",
    "dept": "CPR E",
    "num": "525",
    "desc": "Prereq: CPR E 308 or MATH 481; experience in scientific programming; knowledge of FORTRAN or C\nIntroduction to parallelization techniques and numerical methods for distributed memory high performance computers. A semester project in an area related to each student’s research interests is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Parallel Algorithms and Programming",
    "dept": "CPR E",
    "num": "526",
    "desc": "Prereq: CPR E 308 or COM S 321, CPR E 315 or COM S 311\nModels of parallel computation, performance measures, basic parallel constructs and communication primitives, parallel programming using MPI, parallel algorithms for selected problems including sorting, matrix, tree and graph problems, fast Fourier transforms.\n",
    "credits": "4"
  },
  {
    "course_name": "Probabilistic Methods in Computer Engineering",
    "dept": "CPR E",
    "num": "528",
    "desc": "Prereq: CPR E 315 or COM S 311\nThe application of randomization and probabilistic methods in the design of computer algorithms, and their efficient implementation. Discrete random variables in modeling algorithm behavior, with applications to sorting, selection, graph algorithms, hashing, pattern matching, cryptography, distributed systems, and massive data set algorithmics.\n",
    "credits": "3"
  },
  {
    "course_name": "Data Analytics in Electrical and Computer Engineering",
    "dept": "CPR E",
    "num": "529",
    "desc": "Prereq: E E 322 or equivalent\nIntroduces a variety of data analytics techniques ‐ particularly those relevant for electrical and computer engineers ‐ from a foundational perspective. Topics to be covered include techniques for classification, visualization, and parameter estimation, with applications to signals, images, matrices, and graphs. Emphasis will be placed on rigorous analysis as well as principled design of such techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Network Protocols and Security",
    "dept": "CPR E",
    "num": "530",
    "desc": "Prereq: CPR E 381 or equivalent\nDetailed examination of networking standards, protocols, and their implementation. TCP/IP protocol suite, network application protocols.  Network security issues, attack and mitigation techniques. Emphasis on laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Information System Security",
    "dept": "CPR E",
    "num": "531",
    "desc": "Prereq: CPR E 489 or CPR E 530 or COM S 586 or MIS 535\nComputer, software, and data security: basic cryptography, security policies, multilevel security models, attack and protection mechanisms, legal and ethical issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Warfare",
    "dept": "CPR E",
    "num": "532",
    "desc": "Prereq: CPR E 531\nComputer system and network security: implementation, configuration, testing of security software and hardware, network monitoring. Authentication, firewalls, vulnerabilities, exploits, countermeasures. Study and use of attack tools. Ethics in information assurance. Emphasis on laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Cryptography",
    "dept": "CPR E",
    "num": "533",
    "desc": "Prereq: MATH 301 or CPR E 310 or COM S 230\nBasic concepts of secure communication, DES and AES, public-key cryptosystems, elliptic curves, hash algorithms, digital signatures, applications. Relevant material on number theory and finite fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Legal and Ethical Issues in Information Assurance",
    "dept": "CPR E",
    "num": "534",
    "desc": "Prereq: Graduate classification; CPR E 531 or INFAS 531\nLegal and ethical issues in computer security. State and local codes and regulations. Privacy issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Steganography and Digital Image Forensics",
    "dept": "CPR E",
    "num": "535",
    "desc": "Prereq: E E 524 or MATH 317 or MATH 407 or COM S 230\nBasic principles of covert communication, steganalysis, and forensic analysis for digital images. Steganographic security and   capacity, matrix embedding, blind attacks, image forensic detection and device identification techniques. Related material on coding   theory, statistics, image processing, pattern recognition.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer and Network Forensics",
    "dept": "CPR E",
    "num": "536",
    "desc": "Prereq: CPR E 489 or CPR E 530\nFundamentals of computer and network forensics, forensic duplication and analysis, network surveillance, intrusion detection and response, incident response, anonymity and pseudonymity, privacy-protection techniques, cyber law, computer security policies and guidelines, court testimony and report writing, and case studies. Emphasis on hands-on experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Wireless Network Security",
    "dept": "CPR E",
    "num": "537",
    "desc": "Prereq: Credit or enrollment in CPR E 489 or CPR E 530\nIntroduction to the physical layer and special issues associated with the security of wireless networks. The basics of wireless communication systems (antennas and propagation, modulation, multiple access, channel modeling, specific security issues of the wireless link), jamming and countermeasures (spread spectrum technologies, channel coding, interleaving), authentication and confidentiality (basics of classic cryptography, common authentication and encryption algorithms). Detailed case studies on authentication, encryption and privacy flaws, and good practices based on the most common wireless technologies, including WiFi, GSM/3G, Bluetooth, and RFID. Individual or team-based class projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Reverse Engineering and Security Testing",
    "dept": "CPR E",
    "num": "538",
    "desc": "Prereq: COM S 321 or CPR E 381, COM S 352 or CPR E 308\nTechniques and tools for understanding the behavior of software/hardware systems based on reverse engineering. Flaw hypothesis, black, grey, and white box testing as well as other methods for testing the security of software systems. Discussion of counter-reverse engineering techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Cyber Physical System Security for the Smart Grid",
    "dept": "CPR E",
    "num": "539",
    "desc": "\nIntroduction to cyber security, cyber physical system (CPS), and smart grid automation technologies; supervisor control and data acquisition (SCADA) systems; cyber risk modeling, vulnerability analysis, impact analysis, defense and mitigation techniques; cyber security of wide-area monitoring, protection, and control; security and privacy in advanced metering infrastructure (AMI), cyber security compliance and best practices, CPS security test-beds and attack-defense hands-on laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "High-Performance Communication Networks",
    "dept": "CPR E",
    "num": "541",
    "desc": "Prereq: CPR E 489 or CPR E 530\nComputer architectures and protocols designed for high-performance networking environments; software defined networking (SDN) and supporting protocols; cloud and data center networks; network traffic management and congestion control strategies; quality of service; high-speed access network protocols.\n",
    "credits": "3"
  },
  {
    "course_name": "Optical Communication Networks",
    "dept": "CPR E",
    "num": "542",
    "desc": "Prereq: CPR E 489\nOptical components and interfaces; optical transmission and reception techniques; wavelength division multiplexing; network architectures and protocol for first generation, single and multihop optical network; routing and wavelength assignment in second generation wavelength routing networks; traffic grooming, optical network control; survivability; access networks; metro networks.\n",
    "credits": "3"
  },
  {
    "course_name": "Wireless Network Architecture",
    "dept": "CPR E",
    "num": "543",
    "desc": "Prereq: Credit or enrollment in CPR E 489 or CPR E 530\nIntroduction to the protocol architecture of the data link layer, network layer and transport layer for wireless networking. Operation and management of Medium Access Control in Wireless Local Area Networks (WLAN) and Wireless Metropolitan Area Networks (WMAN); recent developments in IEEE 802.11 & 802.16 and Bluetooth; Mobile IP; Mobile TCP.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Bioinformatics",
    "dept": "CPR E",
    "num": "544",
    "desc": "Prereq: MATH 165 or STAT 401 or equivalent\nA practical, hands-on overview of how to apply bioinformatics to biological research. Recommended for biologists desiring to gain computational molecular biology skills. Topics include: sequence analysis, genomics, proteomics, phylogenetic analyses, ontology enrichment, systems biology, data visualization and emergent technologies.\n",
    "credits": "4"
  },
  {
    "course_name": "Fault-Tolerant Systems",
    "dept": "CPR E",
    "num": "545",
    "desc": "Prereq: CPR E 381\nFaults and their manifestations, errors, and failures; fault detection, location and reconfiguration techniques; time, space, and information (coding) redundancy management; design for testability; self-checking and fail-safe circuits; system-level fault diagnosis; Byzantine agreement; stable storage and RAID; clock synchronization; fault-tolerant networks; fault tolerance in real-time systems; reliable software design; checkpointing and rollback recovery; atomic actions; replica management protocols; and reliability evaluation techniques and tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Wireless and Sensor Networks",
    "dept": "CPR E",
    "num": "546",
    "desc": "Prereq: CPR E 489 or CPR E 530\nFundamental and well-known protocols for wireless ad hoc and sensor networks at various layers, including physical layer issues, MAC (medium access control) layer protocols, routing protocols for wireless ad hoc and sensor networks, data management in sensor networks, coverage and connectivity, localization and tracking, security and privacy issues. Introduction to TinyOS and the nesC language. Hands-on experiments with Crossbow Mote sensor devices.\n",
    "credits": "3"
  },
  {
    "course_name": "Resource Allocation in Communication Networks",
    "dept": "CPR E",
    "num": "547",
    "desc": "\nAnalytical approach to resource allocation on communication networks (e.g. the Internet, multihop wireless networks, etc.). Network utility maximization and the internet congestion control algorithm. Layering as optimization decomposition: a cross-layer design approach in multihop wireless networks. Capacity of ad hoc wireless networks.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Algorithms in Computational Biology",
    "dept": "CPR E",
    "num": "549",
    "desc": "Prereq: COM S 311 and either COM S 228 or COM S 208\nDesign and analysis of algorithms for applications in computational biology, pairwise and multiple sequence alignments, approximation algorithms, string algorithms including in-depth coverage of suffix trees, semi-numerical string algorithms, algorithms for selected problems in fragment assembly, phylogenetic trees and protein folding. No background in biology is assumed. Also useful as an advanced algorithms course in string processing.\n",
    "credits": "3"
  },
  {
    "course_name": "Distributed Systems and Middleware",
    "dept": "CPR E",
    "num": "550",
    "desc": "Prereq: CPR E 308 or COM S 352\nFundamentals of distributed computing, software agents, naming services, distributed transactions, security management, distributed object-based systems, web-based systems, middleware-based application design and development, case studies of middleware and internet applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Distributed Systems",
    "dept": "CPR E",
    "num": "554",
    "desc": "Prereq: COM S 311, COM S 352; for graduate credit: graduate standing or permission of instructor\nTheoretical and practical issues of design and implementation of distributed systems. The client server paradigm, inter-process communications, synchronization and concurrency control, naming, consistency and replication, fault tolerance, and distributed file systems. Graduate credit requires additional in-depth study of concepts. Programming projects and written reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Scalable Software Engineering",
    "dept": "CPR E",
    "num": "556",
    "desc": "Prereq: COM S 309\nDesign and analysis techniques scalable to large software, project-based learning of problem solving techniques, automation tools for high productivity and reliability of software, analysis-based measurement and estimation techniques for predictable software engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Graphics and Geometric Modeling",
    "dept": "CPR E",
    "num": "557",
    "desc": "Prereq: M E 421, programming experience in C\nFundamentals of computer graphics technology. Data structures. Parametric curve and surface modeling. Solid model representations. Applications in engineering design, analysis, and manufacturing.\n",
    "credits": "3"
  },
  {
    "course_name": "Real  Time Systems",
    "dept": "CPR E",
    "num": "558",
    "desc": "Prereq: CPR E 308 or COM S 352\nFundamental concepts in real-time systems. Real time task scheduling paradigms. Resource management in uniprocessor, multiprocessor, and distributed real-time systems. Fault-tolerance, resource reclaiming, and overload handling. Real-time channel, packet scheduling, and real-time LAN protocols. Case study of real-time operating systems. Laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Security and Privacy in Cloud Computing",
    "dept": "CPR E",
    "num": "559",
    "desc": "Prereq: COM S 352 or CPR E 308, and COM S 486 or CPR E 489 or CPR E 530\nIntroduction to cloud computing concepts and systems. Security and privacy threats in cloud computing. Practical techniques for cloud computing security. Theoretical and practical solutions for secure outsourcing of data and computation. Oral presentations and research projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Data-Driven Security and Privacy",
    "dept": "CPR E",
    "num": "560",
    "desc": "Prereq: CPR E 531; COM S 474 or COM S 573\nExamination of applications of machine learning and big data techniques to various security and privacy problems, as well as secure and privacy-preserving machine learning algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Design of VLSI Systems",
    "dept": "CPR E",
    "num": "566",
    "desc": "Prereq: CPR E 465\nPhysical design of VLSI systems. Partitioning algorithms. Placement and floorplanning algorithms. Routing-global and detailed. Layout compaction. Physical design of FPGA's and MCM's. Performance-driven layout synthesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics I (Bioinformatics Algorithms)",
    "dept": "CPR E",
    "num": "567",
    "desc": "Prereq: COM S 228; COM S 330; credit or enrollment in BIOL 315, STAT 430\nBiology as an information science. A review of the algorithmic principles that are driving the advances in bioinformatics and computational biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics III (Structural Bioinformatics)",
    "dept": "CPR E",
    "num": "569",
    "desc": "Prereq: BCB 567, BBMB 316, GEN 409, STAT 430\nMolecular structures including genes and gene products: protein, DNA and RNA structure. Structure determination methods, structural refinement, structure representation, comparison of structures, visualization, and modeling. Molecular and cellular structure from imaging. Analysis and prediction of protein secondary, tertiary, and higher order  structure, disorder, protein-protein and protein-nucleic acid interactions, protein localization and function, bridging between molecular and cellular structures. Molecular evolution.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics IV (Systems Biology)",
    "dept": "CPR E",
    "num": "570",
    "desc": "Prereq: BCB 567 or COM S 311, COM S 228, GEN 409, STAT 430\nAlgorithmic and statistical approaches in computational functional genomics and systems biology. Analysis of high throughput biological data obtained using system-wide measurements. Topological analysis, module discovery, and comparative analysis of gene and protein networks. Modeling, analysis, and inference of transcriptional regulatory networks, protein-protein interaction networks, and metabolic networks. Dynamic systems and whole-cell models. Ontology-driven, network based, and probabilistic approaches to information integration.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Perception",
    "dept": "CPR E",
    "num": "575",
    "desc": "Prereq: Graduate standing or permission of instructor\nStatistical and algorithmic methods for sensing, recognizing, and interpreting the activities of people by a computer. Focuses on machine perception techniques that facilitate and augment human-computer interaction. Introduce computational perception on both theoretical and practical levels. Participation in small groups to design, implement, and evaluate a prototype of a human-computer interaction system that uses one or more of the techniques covered in the lectures.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Systems Architecture",
    "dept": "CPR E",
    "num": "581",
    "desc": "Prereq: CPR E 381\nQuantitative principles of computer architecture design, instruction set design, processor architecture: pipelining and superscalar design, instruction level parallelism, memory organization: cache and virtual memory systems, multiprocessor architecture, cache coherency, interconnection networks and message routing, I/O devices and peripherals.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Systems Performance",
    "dept": "CPR E",
    "num": "582",
    "desc": "Prereq: CPR E 381, CPR E 310 and STAT 330\nReview of probability and stochastic processes concepts; Markovian processes; Markovian queues; renewal theory; semi-Markovian queues; queueing networks, applications to multiprocessor architectures, computer networks, and switching systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Reconfigurable Computing Systems",
    "dept": "CPR E",
    "num": "583",
    "desc": "Prereq: Background in computer architecture, design, and organization\nIntroduction to reconfigurable computing, FPGA technology and architectures, spatial computing architectures such as systolic and bit serial adaptive network architectures, static and dynamic rearrangeable interconnection architectures, processor architectures incorporating reconfigurabiltiy.\n",
    "credits": "3"
  },
  {
    "course_name": "Models and Techniques in Embedded Systems",
    "dept": "CPR E",
    "num": "584",
    "desc": "\nIndustry-standard tools and optimization strategies; practical embedded platforms and technology (reconfigurable platforms, multi-core platforms, low-power platforms); instruction augmentation, memory-mapped accelerator design, embedded software optimization. Students will be encouraged to compete as teams in an embedded system design competition.\n",
    "credits": "3"
  },
  {
    "course_name": "Developmental Robotics",
    "dept": "CPR E",
    "num": "585",
    "desc": "Prereq: knowledge of C/C++ programming language.\nAn introduction to the emerging interdisciplinary field of Developmental Robotics, which crosses the boundaries between robotics, artificial intelligence, developmental psychology, and philosophy. The main goal of this field is to create autonomous robots that are more intelligent, more adaptable, and more useful than the robots of today, which can only function in very limited domains and situations.\n",
    "credits": "3"
  },
  {
    "course_name": "Pervasive Computing",
    "dept": "CPR E",
    "num": "586",
    "desc": "Prereq: CPR E 489 or CPR E 530\nFundamentals of pervasive computing, including location and context awareness, mobile and location services, ubiquitous data access, low power computing and energy management, middleware, security and privacy issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Embedded Computer Systems",
    "dept": "CPR E",
    "num": "588",
    "desc": "Prereq: CPR E 308\nHardware/software systems and codesign. Models of computation for embedded systems. System-level design. Modeling, specification, synthesis, and verification. Hardware/software implementation. Design space exploration. Performance analysis and optimization. Multiprocessor system on chip. Platform-based design. Design methodologies and tools.  Case studies and design projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "CPR E",
    "num": "590",
    "desc": "\nFormulation and solution of theoretical or practical problems in computer engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Computer Engineering",
    "dept": "CPR E",
    "num": "592",
    "desc": "Prereq: Permission of instructor\nProjects or seminar in Computer Engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Selected Topics in Computer Engineering",
    "dept": "CPR E",
    "num": "594",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Electrical and Computer Engineering Learning Community Seminar",
    "dept": "CPR E",
    "num": "598",
    "desc": "Prereq: Electrical and Computer Engineering Graduate Student\nIntroduction to graduate study in Electrical and Computer Engineering at Iowa State University. Building networks, introduction to core requirements, and tools and techniques for success.\n  Offered on a satisfactory-fail basis only.  ECpE",
    "credits": "R"
  },
  {
    "course_name": "Creative Component",
    "dept": "CPR E",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Parallel Algorithms for Scientific Applications",
    "dept": "CPR E",
    "num": "626",
    "desc": "Prereq: CPR E 526\nAlgorithm design for high-performance computing. Parallel algorithms for multidimensional tree data structures, space-filling curves, random number generation, graph partitioning and load balancing. Applications to grid and particle-based methods and computational biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Assurance Capstone Design",
    "dept": "CPR E",
    "num": "632",
    "desc": "Prereq: INFAS 531, INFAS 532, INFAS 534\nCapstone design course which integrates the security design process. Design of a security policy. Creation of a security plan. Implementation of the security plan. The students will attack each other's secure environments in an effort to defeat the security systems. Students evaluate the security plans and the performance of the plans. Social, political and ethics issues. Student self-evaluation, journaling, final written report.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Computer Architecture",
    "dept": "CPR E",
    "num": "681",
    "desc": "Prereq: CPR E 581.  Repeatable with Instructor permission\nCurrent topics in computer architecture design and implementation. Advanced pipelining, cache and memory design techniques. Interaction of algorithms with architecture models and implementations. Tradeoffs in architecture models and implementations.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "CPR E",
    "num": "697",
    "desc": "\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "CPR E",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Orientation",
    "dept": "COM S",
    "num": "101",
    "desc": "\nIntroduction to the computer science discipline and code of ethics, Com S courses, research and networking opportunities, procedures, policies, help and computing resources, extra-curricular activities offered by the Department of Computer Science and Iowa State University. Discussion of issues relevant to student adjustment to college life. Offered on a satisfactory-fail basis only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Computer Literacy and Applications",
    "dept": "COM S",
    "num": "103",
    "desc": "\nIntroduction to computer literacy and applications. Literacy: Impact of computer technology in today’s societies, hardware, software, software programming, database and information systems, communication and networks, digital media technology, computer security and safety, ethics and privacy. Applications: In-depth hands-on experience with the operating systems, Microsoft word processing, spreadsheets, database management and presentation software. No prior computer experience necessary. Offered online only. Attendance required at an orientation session the first week of class.\n",
    "credits": "4"
  },
  {
    "course_name": "Brief Introduction to Computer Programming for Non-Majors",
    "dept": "COM S",
    "num": "104",
    "desc": "\nOffered first 8 weeks and last 8 weeks. Use of personal computer and workstation operating systems and beginning programming. Project-oriented approach to computer operation and programming, including use of tools to aid in programming. Topics from computer history, using basic Windows and Unix tools, program structure, expression, variables, decision and logic, and iteration. No prior computer experience necessary.\n",
    "credits": "2"
  },
  {
    "course_name": "Short Course in Computer Programming",
    "dept": "COM S",
    "num": "105",
    "desc": "Prereq: COM S 104\n8-week course in programming, including instruction in syntax and semantics, of the following current programming languages.\n",
    "credits": "2"
  },
  {
    "course_name": "Short Course in Computer Programming: Perl",
    "dept": "COM S",
    "num": "105A",
    "desc": "Prereq: COM S 104\n8-week course in programming using Perl.\n",
    "credits": "2"
  },
  {
    "course_name": "Short Course in Computer Programming: MATLAB",
    "dept": "COM S",
    "num": "105B",
    "desc": "Prereq: COM S 104\n8-week course in programming using MATLAB.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Web Programming",
    "dept": "COM S",
    "num": "106",
    "desc": "\nIntroduction to web programming basics. Fundamentals of developing web pages using a comprehensive web development life cycle. Learn to code programs and earn in-depth experience with current web design techniques such as HTML5 and cascading style sheets. Programming with JavaScript, jQuery, PHP, SQL, and MySQL. Strategies for accessibility, usability and search engine optimization. No prior computer programming experience necessary.\n",
    "credits": "3"
  },
  {
    "course_name": "Windows Application Programming",
    "dept": "COM S",
    "num": "107",
    "desc": "\nIntroduction to computer programming for non-majors using a language such as the Visual Basic language. Basics of good programming and algorithm development. Graphical user interfaces.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Computer Programming for Non-Majors",
    "dept": "COM S",
    "num": "108",
    "desc": "Prereq: COM S 107 or equivalent\nAdvanced programming applications in Visual Basic for non-majors. Emphasis on programming projects including sorting, file processing, database processing, web programming, and graphics and animation. Students will learn problem solving techniques and advanced programming skills to build real-world applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spreadsheets and Databases",
    "dept": "COM S",
    "num": "113",
    "desc": "\nUsing Microsoft Excel spreadsheets and Microsoft Access databases to input, store, process, manipulate, query, and analyze data for business and industrial applications.\n  Credit in Com S 113 may not be applied toward graduation in the COM S, S E, and CPR E majors.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computer Programming",
    "dept": "COM S",
    "num": "127",
    "desc": "Prereq: Credit or Enrollment in MATH 140 or higher\nIntroduction to computer programming with an emphasis on problem solving. Topics include: program structures, expressions, variables, decision and logic, iteration, collections, input and output. Program construction and testing. Programming assignments including games and applications. No prior programming experience necessary. This course is intended for Computer Science majors.\n",
    "credits": "4"
  },
  {
    "course_name": "Careers in Computer Science",
    "dept": "COM S",
    "num": "203",
    "desc": "\nComputer science as a profession. Introduction to career fields open to computer science majors. Relationship of coursework to careers. Presentations by computer science professionals.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Fundamentals of Computer Programming",
    "dept": "COM S",
    "num": "207",
    "desc": "Prereq: MATH 150 or placement into MATH 140 or higher\nAn introduction to computer programming using an object-oriented programming language. Emphasis on the basics of good programming techniques and style. Extensive practice in designing, implementing, and debugging small programs. Use of abstract data types. Interactive and file I/O. This course is not designed for computer science, software engineering, and computer engineering majors.\n  Credit may not be applied toward graduation for both Com S 207/MIS 207 and Com S 227.",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Computer Programming",
    "dept": "COM S",
    "num": "208",
    "desc": "Prereq: MIS/COM S 207, credit or enrollment in MATH 151, MATH 160, or MATH 165\nIntermediate-level programming techniques. Emphasis on designing, writing, testing, debugging, and documenting medium-sized programs. Data structures and their uses. Dynamic memory usage. Inheritance and polymorphism. Algorithm design and efficiency: recursion, searching, and sorting. Event-driven and GUI programming. The software development process. This course is not designed for computer science, software engineering and computer engineering majors.\n  Credit may not be applied toward the major in computer science, software engineering, or computer engineering.",
    "credits": "3"
  },
  {
    "course_name": "Object-oriented Programming",
    "dept": "COM S",
    "num": "227",
    "desc": "Prereq: Credit or Enrollment in MATH 143 or higher; recommended: a previous high school or college course in programming or equivalent experience.\nComputer programming using objects as the mechanism for modularity, abstraction, and code reuse.  Instance variables, methods, and encapsulation.  Review of control structures for conditionals and iteration. Developing algorithms on strings, arrays, and lists. Recursion, searching, and sorting. Text parsing and file I/O.  Interfaces, inheritance, polymorphism, and abstract classes. Exception handling. Tools for unit testing and debugging. Emphasis on a disciplined approach to specification, code development, and testing. Course intended for Com S majors.\n  Credit may not be applied toward graduation for both Com S 207 and 227.",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Data Structures",
    "dept": "COM S",
    "num": "228",
    "desc": "Prereq: Minimum of C- in COM S 227, credit or enrollment in MATH 165\nAn object-oriented approach to data structures and algorithms. Object-oriented analysis, design, and programming, with emphasis on data abstraction, inheritance and subtype polymorphism, and generics. Abstract data type specification and correctness. Collections including lists, stacks, queues, trees, heaps, maps, hash tables, and graphs. Big-O notation and algorithm analysis. Searching and sorting. Graph search and shortest path algorithms. Emphasis on object-oriented design, writing and documenting medium-sized programs. This course is designed for majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Discrete Computational Structures",
    "dept": "COM S",
    "num": "230",
    "desc": "Prereq: Minimum of C- in COM S 227 and MATH 165; ENGL 150\nConcepts in discrete mathematics as applied to computer science. Logic, set theory, functions, relations, combinatorics, discrete probability, graph theory and number theory. Proof techniques, induction and recursion.\n",
    "credits": "3"
  },
  {
    "course_name": "Linux Operating System Essentials",
    "dept": "COM S",
    "num": "252",
    "desc": "Prereq: CPR E 185 or S E 185 or COM S 127 or COM S 207 or COM S 227\nIntroduction to installation, utilization, and administration of Linux systems.  Topics include open-source software, package installation and management, shell programming and command-line utilities, process and service management, account management, network configuration, file sharing, interoperation with other computers and operating systems, automation, and system security.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "COM S",
    "num": "290",
    "desc": "Prereq: Permission of instructor\n  No more than 6 credits of Com S 290 or Com S 290H may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "COM S",
    "num": "290H",
    "desc": "Prereq: Permission of instructor\n  No more than 6 credits of Com S 290 or Com S 290H may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Software Development Practices",
    "dept": "COM S",
    "num": "309",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165\nA practical introduction to methods for managing software development. Process models, requirements analysis, structured and object-oriented design, coding, testing, maintenance, cost and schedule estimation, metrics. Programming projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the Design and Analysis of Algorithms",
    "dept": "COM S",
    "num": "311",
    "desc": "Prereq: Minimum of C- in COM S 228; MATH 166, ENGL 150, and COM S 230 or CPR E 310\nBasic techniques for design and analysis of  algorithms. Sorting, searching, graph algorithms, string matching, and NP-completeness. Design techniques such as dynamic programming, divide and conquer,  greedy method, and approximation.  Asymptotic, worst-case, average-case and amortized analyses. Topics from advanced data structures such as balanced trees and hashing.\n",
    "credits": "3"
  },
  {
    "course_name": "Construction of User Interfaces",
    "dept": "COM S",
    "num": "319",
    "desc": "Prereq: COM S 228\nOverview of user interface design. Evaluation and testing of user interfaces.  Review of principles of object orientation, object oriented design and analysis using UML in the context of user interface design. Design of windows, menus and commands. Developing Web and Windows-based user-interfaces. Event-driven programming. Introduction to Frameworks and APIs for the construction of user interfaces.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computer Architecture and Machine-Level Programming",
    "dept": "COM S",
    "num": "321",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165; COM S 230 or CPR E 281; ENGL 250\nIntroduction to computer architecture and organization. Emphasis on evaluation of performance, instruction set architecture, datapath and control, memory-hierarchy design, and pipelining. Assembly language programming.\n",
    "credits": "3"
  },
  {
    "course_name": "C for Programmers",
    "dept": "COM S",
    "num": "326",
    "desc": "Prereq: Minimum of C- in COM S 228; COM S 230\nHalf-semester course.  Design and implementation of libraries and applications in C, for students with prior programming background.  Emphasis on differences between C and other languages, including file I/O, string processing, memory management, and buffer overruns.  Using build systems, debuggers, and other development tools.  Programming projects.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Programming Techniques",
    "dept": "COM S",
    "num": "327",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165\nObject-oriented programming experience using a language suitable for exploring advanced topics in programming. Topics include memory management, parameter passing, inheritance, compiling, debugging, and maintaining programs. Significant programming projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory of Computing",
    "dept": "COM S",
    "num": "331",
    "desc": "Prereq: Minimum of C- in COM S 228, MATH 166, and in COM S 230 or CPR E 310;  ENGL 250\nModels of computation: finite state automata, pushdown automata and Turing machines. Study of grammars and their relation to automata. Limits of digital computation, unsolvability and Church-Turing thesis. Relations between classes of languages.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computer Graphics",
    "dept": "COM S",
    "num": "336",
    "desc": "Prereq: COM S 327, CoReq MATH 207 or MATH 317\nProgramming interactive computer graphics systems using standard low-level libraries (such as OpenGL or DirectX) with an emphasis on 3D rendering.  The graphics pipeline and programmable shaders.  Coordinate systems and transformations in two and three dimensions.  Homogeneous coordinates, viewing transformations and perspective.  Euler angles and quaternions.  Visible surface algorithms.  Lighting models and shading.  Texture mapping, bump mapping, reflection, elementary ray tracing.  Offscreen buffers, render-to-texture and related techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Programming Languages",
    "dept": "COM S",
    "num": "342",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165; COM S 230 or CPR E 310\nStudy of concepts in programming languages, especially functional programming concepts. Overview of major programming paradigms, their relationship, and tradeoffs among paradigms enabling sound choices of programming language for application-specific development. Programming projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Number Theory",
    "dept": "COM S",
    "num": "350",
    "desc": "Prereq: MATH 201 or COM S 230\nDivisibility, integer representations, primes and divisors, linear diophantine equations, congruences, and multiplicative functions. Applications to cryptography. Additional topics, chosen at the discretion of the instructor.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Operating Systems",
    "dept": "COM S",
    "num": "352",
    "desc": "Prereq: COM S 321 or CPR E 381 and COM S 327 or CPR E 288; ENGL 250\nSurvey of operating system, networking and parallel programming issues. Introduction of processes, threads, process synchronization, deadlocks, memory, file systems, networking, security threats and encryption. Programming projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Object-Oriented Analysis and Design",
    "dept": "COM S",
    "num": "362",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165; ENGL 250\nObject-oriented requirements analysis and systems design. Design notations such as the Unified Modeling Language. Design Patterns.  Group design and programming with large programming projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Database Management Systems",
    "dept": "COM S",
    "num": "363",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165; ENGL 250\nRelational, object-oriented, semistructured and query languages. SQL, XML, and NO-SQL. Database design using entity-relationship model, data dependencies, and relational database design. Application development in SQL-like languages and general purpose host languages with application program interfaces and a commonly used Object Relational Mapping framework. Web application development. Programming Projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "COM S",
    "num": "398",
    "desc": "Prereq: Permission of department chair\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Computer Science Senior Project",
    "dept": "COM S",
    "num": "402",
    "desc": "Prereq: COM S 309, COM S 311, COM S 321, and COM S 331, Senior Classification\nStudents work as individuals and teams to complete the planning, design, and implementation of a significant project in the topic area. Oral and written reports.\n  No more than 6 credits of 402A, 402B, and 402C may be used toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Computer Science Senior Project: Multimedia and Computer Gaming I",
    "dept": "COM S",
    "num": "402A",
    "desc": "Prereq: COM S 309, COM S 311, COM S 321, COM S 331, and COM S 437, Senior Classification\nStudents conceive, plan, architect and design a computer game. Student registered in this course will work with students in ARTIS 409. Oral and written reports.\n  No more than 6 credits of 402A, 402B, and 402C may be used toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Computer Science Senior Project: Multimedia and Computer Gaming II",
    "dept": "COM S",
    "num": "402B",
    "desc": "Prereq: COM S 402A, Senior Classification\nStudents implement, test, and present a completed production computer game. Students in this class will work with students in ARTIS 409. Oral and written reports.\n  No more than 6 credits of 402A, 402B, and 402C may be used toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Computer Science Senior Project: Project in Computer Science",
    "dept": "COM S",
    "num": "402C",
    "desc": "Prereq: COM S 309, COM S 311, COM S 321, and COM S 331, Senior Classification\nStudents work as individuals and teams to complete the planning, design, and implementation of a significant project in the topic area. Oral and written reports.\n  No more than 6 credits of 402A, 402B, and 402C may be used toward graduation.",
    "credits": "2"
  },
  {
    "course_name": "Software Requirements Engineering",
    "dept": "COM S",
    "num": "409",
    "desc": "Prereq: COM S 309; for graduate credit: graduate standing or permission of instructor\nThe requirements engineering process including elicitation, requirements analysis fundamentals, requirements specification and communication, and requirements evaluation.  Modeling of functional and nonfunctional requirements, traceability, and requirements change management. Case studies and software projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Distributed Development of Software",
    "dept": "COM S",
    "num": "410",
    "desc": "Prereq: COMS 228, COMS 309, COMS 327; for graduate credit: graduate standing or permission of instructor\nTeams of students develop software applications in a modern software engineering environment. Importance, effective processes pertaining to team organization, management and communication, and cultural issues of distributed development. Graduate credit requires in-\u00addepth study of concepts and oral presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Formal Methods in Software Engineering",
    "dept": "COM S",
    "num": "412",
    "desc": "Prereq: COM S 311, STAT 330; for graduate credit: graduate standing or permission of instructor\nA study of formal techniques for model-based specification and verification of software systems. Topics include logics, formalisms, graph theory, numerical computations, algorithms and tools for automatic analysis of systems. Graduate credit requires in-\u00addepth study of concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations and Applications of Program Analysis",
    "dept": "COM S",
    "num": "413",
    "desc": "Prereq: COM S 331, COM S 342\nAlgorithms and tools for automatically reasoning about code and program executions to predict software behavior. Theory and foundations related to control flow analysis, dataflow analysis, abstract interpretation and symbolic execution. Applications of program analysis to improve software security, performance and testing. Concepts, algorithms, tools, benchmarks, methodologies for solving problems using program analysis and for preparing research in program analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Gerontechnology in Smart Home Environments",
    "dept": "COM S",
    "num": "414",
    "desc": "Prereq: COM S 227 or COM S 207 or GERON 377 or ARTGR 271 or equivalent; for graduate credit: graduate standing or permission of instructor\nInterdisciplinary course designed for students interested in assistive technology, pervasive computing, mobile computing and principles of universal and inclusive design for end users, in particular, the elderly population. Students work in semester-long projects as interdisciplinary teams to apply knowledge obtained from lectures and mutual presentations. Research report and oral presentation required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Software System Safety",
    "dept": "COM S",
    "num": "415",
    "desc": "Prereq: COM S 309 or COM S 311; for graduate credit: graduate standing or permission of instructor\nAn introduction to the hazard analysis, safety requirements, design, and testing of software for safety-critical and high-dependability systems. Safety analysis techniques, fault identification and recovery, and certification issues. Emphasizes a case-based and systematic approach to software's role in safe systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Software Testing",
    "dept": "COM S",
    "num": "417",
    "desc": "Prereq: COM S 309; COM S 230 or CPR E 310; ENGL 250, SP CM 212\nAn introduction to software testing principles and techniques. Test models, test design, test adequacy criteria; regression, integration, and system testing; and software testing tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computational Geometry",
    "dept": "COM S",
    "num": "418",
    "desc": "Prereq: COM S 311 or permission of instructor; for graduate credit: graduate standing or permission of instructor\nIntroduction to data structures, algorithms, and analysis techniques for computational problems that involve geometry.  Convex hulls, line segment intersection, polygon triangulation, 2D linear programming, range queries, point location, arrangements and duality, Voronoi diagrams, Delaunay triangulations, geometric data structures, robot motion planning, visibility graphs. Other selected topics. Programming assignments. Scholarly report required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Logic for Mathematics and Computer Science",
    "dept": "COM S",
    "num": "421",
    "desc": "Prereq: MATH 301 or MATH 207 or MATH 317 or COM S 230\nPropositional and predicate logic.  Topics selected from Horn logic, equational logic,   resolution and unification, foundations of logic programming, reasoning about programs, program specification and verification, model checking and binary decision diagrams, temporal logic and modal logic.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to High Performance Computing",
    "dept": "COM S",
    "num": "424",
    "desc": "Prereq: MATH 265; MATH 207 or MATH 317; or permission of instructor.\nUnix, serial programming of scientific applications, OpenMP for shared-memory parallelization. No Unix, Fortran or C experience required.\n",
    "credits": "3"
  },
  {
    "course_name": "High Performance Computing for Scientific and Engineering Applications",
    "dept": "COM S",
    "num": "425",
    "desc": "Prereq: COM S 311, ENGL 250, SP CM 212\nIntroduction to high performance computing platforms including parallel computers and workstation clusters. Discussion of parallel architectures, performance, programming models, and software development issues. Sample applications from science and engineering. Practical issues in high performance computing will be emphasized via a number of programming projects using a variety of programming models and case studies. Oral and written reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Parallel Algorithms and Programming",
    "dept": "COM S",
    "num": "426",
    "desc": "Prereq: CPR E 308 or COM S 321, CPR E 315 or COM S 311\nModels of parallel computation, performance measures, basic parallel constructs and communication primitives, parallel programming using MPI, parallel algorithms for selected problems including sorting, matrix, tree and graph problems, fast Fourier transforms.\n",
    "credits": "4"
  },
  {
    "course_name": "Concurrent Programming in Practice",
    "dept": "COM S",
    "num": "430",
    "desc": "Prereq: COM S 311, COM S 362 or COM S 363, ENGL 250, SP CM 212\nA practical course in concepts, techniques, languages, and frameworks for concurrent and asynchronous systems.  Concurrency fundamentals: threads, synchronization locks, waiting and notification, memory visibility.  Immutability and thread confinement.  Concurrent data structures and utilities, thread pools. Asynchronous programming with callbacks, futures, and message passing.  Issues of aliasing, ownership and borrowing. Transactional memory, immutable and versioned data structures.  Alternatives to threads and locks: event-driven systems, the actor model, CSP, coroutines.  Students will investigate several non-mainstream languages supporting different concurrency models.  Oral and written reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Programming of Nanoscale Devices and Processes",
    "dept": "COM S",
    "num": "433",
    "desc": "Prereq: Minimum of C- in COM S 331 or permission of instructor; for graduate credit: graduate standing or permission of instructor\nProgramming, modeling, and analysis of natural and engineered systems at the nanoscale. Topics include chemical reaction networks, strand displacement systems, models of self-assembly, biomolecular origami, and molecular robotics.  Emphasis on mathematical methods of describing, simulating, programming, and assessing the computational power of such systems.  Graduate credit requires a written or oral report on current research.\n",
    "credits": "3"
  },
  {
    "course_name": "Algorithms for Large Data Sets: Theory and Practice",
    "dept": "COM S",
    "num": "435",
    "desc": "Prereq: COM S 311 or equivalent; for graduate credit: graduate standing or permission of instructor\nAlgorithmic challenges involved in solving computational problems on massive data sets.  Probabilistic data structures, Curse of Dimensionality and dimensionality reduction, locality sensitive hashing, similarity measures, matrix decompositions. Optimization problems  in massive data analysis.  Computational problems that arise in the context of web search,  social network analysis, online advertising etc.  Practical aspects include implementation and performance evaluation of the algorithms on real world data sets. Graduate credit requires a written report on current research.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Game and Media Programming",
    "dept": "COM S",
    "num": "437",
    "desc": "Prereq: COM S 336 or permission of instructor\nStudents will learn video game programming using current game engine interfaces with real hardware. Particular attention is paid to the development environment, tool chains, 2D graphics, 3D graphics, controllers, memory management, and audio systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles and Practice of Compiling",
    "dept": "COM S",
    "num": "440",
    "desc": "Prereq: COM S 331, COM S 342, ENGL 250, SP CM 212; for graduate credit: graduate standing or permission of instructor\nTheory of compiling and implementation issues of programming languages. Programming projects leading to the construction of a compiler. Projects with different difficulty levels will be given for 440 and 540. Topics include: lexical, syntactic and semantic analyses, syntax-directed translation, code generation, runtime environment and library support.\n",
    "credits": "3"
  },
  {
    "course_name": "Programming Languages",
    "dept": "COM S",
    "num": "441",
    "desc": "Prereq: COM S 342 or COM S 440; for graduate credit: graduate standing or permission of instructor\nSurvey of the goals and problems of language design. Formal and informal studies of a wide variety of programming language features including type systems. Creative use of functional and declarative programming paradigms.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatic Analysis",
    "dept": "COM S",
    "num": "444",
    "desc": "Prereq: MATH 165 and Introductory Statistics (STAT 101, STAT 104, STAT 105, STAT 201, or STAT 330).\nBroad overview of bioinformatics with a significant problem-solving component, including hands-on practice using computational tools to solve a variety of biological problems. Topics include: bioinformatic data processing, Python programming, genome assembly, database search, sequence alignment, gene prediction, next-generation sequencing, comparative and functional genomics, and systems biology.\n",
    "credits": "4"
  },
  {
    "course_name": "Privacy Preserving Algorithms and Data Security",
    "dept": "COM S",
    "num": "453",
    "desc": "Prereq: COM S 311\nFundamentals of privacy preserving algorithms, data security, anonymization, and techniques and mechanisms to minimize disclosure of sensitive information while maintaining availability. Theory and fundamentals underpinning measures to evaluate the privacy and availability of data; implementation and deployment of privacy-preserving data operations including pre- and post-randomization techniques, homomorphisms, and secure function evaluation protocols.  Theory and practice of the algorithmic limits on data privacy, including the cost in terms of time and space complexity.\n",
    "credits": "3"
  },
  {
    "course_name": "Distributed Systems",
    "dept": "COM S",
    "num": "454",
    "desc": "Prereq: COM S 311, COM S 352; for graduate credit: graduate standing or permission of instructor\nTheoretical and practical issues of design and implementation of distributed systems. The client server paradigm, inter-process communications, synchronization and concurrency control, naming, consistency and replication, fault tolerance, and distributed file systems. Graduate credit requires additional in-depth study of concepts. Programming projects and written reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Simulation: Algorithms and Implementation",
    "dept": "COM S",
    "num": "455",
    "desc": "Prereq: COM S 311 and COM S 230, STAT 330, ENGL 150, SP CM 212; for graduate credit: graduate standing or permission of instructor\nIntroduction to discrete-event simulation with a focus on computer science applications, including performance evaluation of networks and distributed systems. Overview of algorithms and data structures necessary to implement simulation software. Discrete and continuous stochastic models, random number generation, elementary statistics, simulation of queuing and inventory systems, Monte Carlo simulation, point and interval parameter estimation. Graduate credit requires additional in-depth study of concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles and Internals of Database Systems",
    "dept": "COM S",
    "num": "461",
    "desc": "Prereq: COM S 311, ENGL 250, SP CM 212; for graduate credit: graduate standing or permission of instructor\nDatabase design including entity-relationship model, relational data model, and non-relational data models, data dependency, and normalization. Database management including physical storage, access methods, query processing, and transaction management. Database systems of special purposes such as spatial databases, mobile object databases, and multimedia databases. Introduction to current database research such as cloud data management and Internet information retrieval.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Artificial Intelligence",
    "dept": "COM S",
    "num": "472",
    "desc": "Prereq: COM S 311,  STAT 330 or STAT 305, ENGL 250, SP CM 212; for graduate credit: graduate standing or permission of instructor\nSpecification, design, implementation, and selected applications of intelligent software agents and multi-agent systems. Computational models of intelligent behavior, including problem solving, knowledge representation, reasoning, planning, decision making, learning, perception, action, communication and interaction. Reactive, deliberative, rational, adaptive, learning and communicative agents and multiagent systems. Artificial intelligence programming. Research project and written report required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Machine Learning",
    "dept": "COM S",
    "num": "474",
    "desc": "Prereq: COM S 311, STAT 330 or STAT 305, MATH 165, ENGL 250, SP CM  212; for graduate credit: graduate standing or permission of instructor\nIntroduction to tools and techniques of machine learning for applications. Selected machine learning techniques in practical data mining for classification, regression, and clustering, e.g., association rules, decision trees, linear models, Bayesian learning, support vector machines, artificial neural networks, instance-based learning, probabilistic graphical models, ensemble learning, and clustering algorithms. Selected applications in data mining and pattern recognition.\n",
    "credits": "3"
  },
  {
    "course_name": "Problem Solving Techniques for Applied Computer Science",
    "dept": "COM S",
    "num": "477",
    "desc": "Prereq: COM S 228; COM S 230 or CPR E 310, MATH 166, MATH 207 or MATH 317, or consent of the instructor; for graduate credit: graduate standing or permission of instructor\nSelected topics in applied mathematics, algorithms, and geometry that have found applications in areas such as geometric modeling, graphics, robotics, vision, human machine interface, speech recognition, computer animation, etc. Homogeneous coordinates and transformations, perspective projection, rotations in space, quaternions, polynomial interpolation, roots of polynomials and polynomial systems, solution of linear and nonlinear equations, parametric and algebraic curves, curvature, torsion, Frenet formulas, surfaces, principal curvatures, Gaussian and mean curvatures, geodesics, approximation, Fourier series and fast Fourier transform, linear programming, data fitting, least squares, simplex method, nonlinear optimization, Lagrange multipliers, calculus of variations. Programming components. Scholarly report required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical Methods for Differential Equations",
    "dept": "COM S",
    "num": "481",
    "desc": "Prereq: MATH 265 and either MATH 266 or MATH 267\nFirst order Euler method, high order Runge-Kutta methods, and multistep methods for solving ordinary differential equations. Finite difference and finite element methods for solving partial differential equations. Local truncation error, stability, and convergence for finite difference method.  Numerical solution space, polynomial approximation, and error estimate for finite element method.  Computer programming required.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamental Concepts in Computer Networking",
    "dept": "COM S",
    "num": "486",
    "desc": "Prereq: COM S 352\nAn introduction to fundamental concepts in the design and implementation of computer communication in both wired and wireless networks, their protocols, and applications. Layered network architecture in the Internet, applications, transport, network, and data link layers and their protocols, Socket API, software-defined networking, and network security.\n",
    "credits": "3"
  },
  {
    "course_name": "Network Programming, Applications, and Research Issues",
    "dept": "COM S",
    "num": "487",
    "desc": "Prereq: COM S 352 or CPR E 489 or equivalent; for graduate credit: graduate standing or permission of instructor\nProgramming paradigms for building distributed and networking applications, including multithreaded client-server programming, socket programming, distributed object frameworks and programming suites, and web computing and security. Introduction to some on-going research issues in distributed and networking applications, including peer-to-peer computing, multimedia communications, and mobile computing and networking.  Written report and oral presentation required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "COM S",
    "num": "490",
    "desc": "Prereq: 6 credits in computer science, permission of instructor\n  No more than 9 credits of Com S 490 or Com S 490H may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "COM S",
    "num": "490H",
    "desc": "Prereq: 6 credits in computer science, permission of instructor\n  No more than 9 credits of Com S 490 or Com S 490H may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Software Requirements Engineering",
    "dept": "COM S",
    "num": "509",
    "desc": "Prereq: COM S 309; for graduate credit: graduate standing or permission of instructor\nThe requirements engineering process including elicitation, requirements analysis fundamentals, requirements specification and communication, and requirements evaluation.  Modeling of functional and nonfunctional requirements, traceability, and requirements change management. Case studies and software projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Distributed Development of Software",
    "dept": "COM S",
    "num": "510",
    "desc": "Prereq: COMS 228, COMS 309, COMS 327; for graduate credit: graduate standing or permission of instructor\nTeams of students develop software applications in a modern software engineering environment. Importance, effective processes pertaining to team organization, management and communication, and cultural issues of distributed development. Graduate credit requires in-\u00addepth study of concepts and oral presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Analysis of Algorithms",
    "dept": "COM S",
    "num": "511",
    "desc": "Prereq: COM S 311\nA study of algorithm design and analysis techniques. Network flows and linear programming. Randomized algorithms. NP-completeness. Approximation algorithms. Fixed-parameter algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Formal Methods in Software Engineering",
    "dept": "COM S",
    "num": "512",
    "desc": "Prereq: COM S 311, STAT 330; for graduate credit: graduate standing or permission of instructor\nA study of formal techniques for model-based specification and verification of software systems. Topics include logics, formalisms, graph theory, numerical computations, algorithms and tools for automatic analysis of systems. Graduate credit requires in-\u00addepth study of concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations and Applications of Program Analysis",
    "dept": "COM S",
    "num": "513",
    "desc": "Prereq: COM S 331, COM S 342\nAlgorithms and tools for automatically reasoning about code and program executions to predict software behavior. Theory and foundations related to control flow analysis, dataflow analysis, abstract interpretation and symbolic execution. Applications of program analysis to improve software security, performance and testing. Concepts, algorithms, tools, benchmarks, methodologies for solving problems using program analysis and for preparing research in program analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Gerontechnology in Smart Home Environments",
    "dept": "COM S",
    "num": "514",
    "desc": "Prereq: COM S 227 or COM S 207 or GERON 377 or ARTGR 271 or equivalent; for graduate credit: graduate standing or permission of instructor\nInterdisciplinary course designed for students interested in assistive technology, pervasive computing, mobile computing and principles of universal and inclusive design for end users, in particular, the elderly population. Students work in semester-long projects as interdisciplinary teams to apply knowledge obtained from lectures and mutual presentations. Research report and oral presentation required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Software System Safety",
    "dept": "COM S",
    "num": "515",
    "desc": "Prereq: COM S 309 or COM S 311; for graduate credit: graduate standing or permission of instructor\nAn introduction to the hazard analysis, safety requirements, design, and testing of software for safety-critical and high-dependability systems. Safety analysis techniques, fault identification and recovery, and certification issues. Emphasizes a case-based and systematic approach to software's role in safe systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computational Geometry",
    "dept": "COM S",
    "num": "518",
    "desc": "Prereq: COM S 311 or permission of instructor; for graduate credit: graduate standing or permission of instructor\nIntroduction to data structures, algorithms, and analysis techniques for computational problems that involve geometry.  Convex hulls, line segment intersection, polygon triangulation, 2D linear programming, range queries, point location, arrangements and duality, Voronoi diagrams, Delaunay triangulations, geometric data structures, robot motion planning, visibility graphs. Other selected topics. Programming assignments. Scholarly report required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical Analysis of High Performance Computing",
    "dept": "COM S",
    "num": "525",
    "desc": "Prereq: CPR E 308 or MATH 481; experience in scientific programming; knowledge of FORTRAN or C\nIntroduction to parallelization techniques and numerical methods for distributed memory high performance computers. A semester project in an area related to each student’s research interests is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Parallel Algorithms and Programming",
    "dept": "COM S",
    "num": "526",
    "desc": "Prereq: CPR E 308 or COM S 321, CPR E 315 or COM S 311\nModels of parallel computation, performance measures, basic parallel constructs and communication primitives, parallel programming using MPI, parallel algorithms for selected problems including sorting, matrix, tree and graph problems, fast Fourier transforms.\n",
    "credits": "4"
  },
  {
    "course_name": "Theory of Computation",
    "dept": "COM S",
    "num": "531",
    "desc": "Prereq: COM S 331\nA systematic study of the fundamental models and analytical methods of theoretical computer science. Computability, the Church-Turing thesis, decidable and undecidable problems. Computational resources such as time, space, and nonuniformity. Complexity classes, computational intractability and completeness. Selected topics from randomness, algorithmic information theory, and logic.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Programming of Nanoscale Devices and Processes",
    "dept": "COM S",
    "num": "533",
    "desc": "Prereq: Minimum of C- in COM S 331 or permission of instructor; for graduate credit: graduate standing or permission of instructor\nProgramming, modeling, and analysis of natural and engineered systems at the nanoscale. Topics include chemical reaction networks, strand displacement systems, models of self-assembly, biomolecular origami, and molecular robotics.  Emphasis on mathematical methods of describing, simulating, programming, and assessing the computational power of such systems.  Graduate credit requires a written or oral report on current research.\n",
    "credits": "3"
  },
  {
    "course_name": "Algorithms for Large Data Sets: Theory and Practice",
    "dept": "COM S",
    "num": "535",
    "desc": "Prereq: COM S 311 or equivalent; for graduate credit: graduate standing or permission of instructor\nAlgorithmic challenges involved in solving computational problems on massive data sets.  Probabilistic data structures, Curse of Dimensionality and dimensionality reduction, locality sensitive hashing, similarity measures, matrix decompositions. Optimization problems  in massive data analysis.  Computational problems that arise in the context of web search,  social network analysis, online advertising etc.  Practical aspects include implementation and performance evaluation of the algorithms on real world data sets. Graduate credit requires a written report on current research.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles and Practice of Compiling",
    "dept": "COM S",
    "num": "540",
    "desc": "Prereq: COM S 331, COM S 342, ENGL 250, SP CM 212; for graduate credit: graduate standing or permission of instructor\nTheory of compiling and implementation issues of programming languages. Programming projects leading to the construction of a compiler. Projects with different difficulty levels will be given for 440 and 540. Topics include: lexical, syntactic and semantic analyses, syntax-directed translation, code generation, runtime environment and library support.\n",
    "credits": "3"
  },
  {
    "course_name": "Programming Languages",
    "dept": "COM S",
    "num": "541",
    "desc": "Prereq: COM S 342 or COM S 440; for graduate credit: graduate standing or permission of instructor\nSurvey of the goals and problems of language design. Formal and informal studies of a wide variety of programming language features including type systems. Creative use of functional and declarative programming paradigms.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Bioinformatics",
    "dept": "COM S",
    "num": "544",
    "desc": "Prereq: MATH 165 or STAT 401 or equivalent\nA practical, hands-on overview of how to apply bioinformatics to biological research. Recommended for biologists desiring to gain computational molecular biology skills. Topics include: sequence analysis, genomics, proteomics, phylogenetic analyses, ontology enrichment, systems biology, data visualization and emergent technologies.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Algorithms in Computational Biology",
    "dept": "COM S",
    "num": "549",
    "desc": "Prereq: COM S 311 and either COM S 228 or COM S 208\nDesign and analysis of algorithms for applications in computational biology, pairwise and multiple sequence alignments, approximation algorithms, string algorithms including in-depth coverage of suffix trees, semi-numerical string algorithms, algorithms for selected problems in fragment assembly, phylogenetic trees and protein folding. No background in biology is assumed. Also useful as an advanced algorithms course in string processing.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Techniques for Genome Assembly and Analysis",
    "dept": "COM S",
    "num": "551",
    "desc": "Prereq: COM S 311 and some knowledge of programming\nIntroduction to a big data research area in bioinformatics. Focus on applying computational techniques to huge genomic sequence data. These techniques include finding optimal sequence alignments, generating genome assemblies, finding genes in genomic sequences, mapping short sequences onto a genome assembly, finding single-nucleotide and structural variations, building phylogenetic trees from genome sequences, and performing genome-wide association studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Operating Systems",
    "dept": "COM S",
    "num": "552",
    "desc": "Prereq: For graduate credit: graduate standing or permission of instructor\nA comparative study of high-level language facilities for process synchronization and communication. Analysis of deadlock, concurrency control and recovery. Protection issues including capability-based systems, access and flow control, encryption, and authentication. Additional topics chosen from distributed operating systems, soft real-time operating systems, and advanced security issues. Programming and research projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Distributed Systems",
    "dept": "COM S",
    "num": "554",
    "desc": "Prereq: COM S 311, COM S 352; for graduate credit: graduate standing or permission of instructor\nTheoretical and practical issues of design and implementation of distributed systems. The client server paradigm, inter-process communications, synchronization and concurrency control, naming, consistency and replication, fault tolerance, and distributed file systems. Graduate credit requires additional in-depth study of concepts. Programming projects and written reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Simulation: Algorithms and Implementation",
    "dept": "COM S",
    "num": "555",
    "desc": "Prereq: COM S 311 and COM S 230, STAT 330, ENGL 150, SP CM 212; for graduate credit: graduate standing or permission of instructor\nIntroduction to discrete-event simulation with a focus on computer science applications, including performance evaluation of networks and distributed systems. Overview of algorithms and data structures necessary to implement simulation software. Discrete and continuous stochastic models, random number generation, elementary statistics, simulation of queuing and inventory systems, Monte Carlo simulation, point and interval parameter estimation. Graduate credit requires additional in-depth study of concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis Algorithms for Stochastic Models",
    "dept": "COM S",
    "num": "556",
    "desc": "Prereq: Graduate standing or permission of instructor\nIntroduction to the use of stochastic models to study complex systems, including network communication and distributed systems. Data structures and algorithms for analyzing discrete-state models expressed in high-level formalisms. State space and reachability graph construction, model checking, Markov chain construction and numerical solution, computation of performance measures, product-form models, approximations, and advanced techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Graphics and Geometric Modeling",
    "dept": "COM S",
    "num": "557",
    "desc": "Prereq: M E 421, programming experience in C\nFundamentals of computer graphics technology. Data structures. Parametric curve and surface modeling. Solid model representations. Applications in engineering design, analysis, and manufacturing.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the 3D Visualization of Scientific Data",
    "dept": "COM S",
    "num": "558",
    "desc": "Prereq: Graduate-student standing in the mathematical or natural sciences or engineering; basic programming knowledge\nIntroduction to visualizing scientific information with 3D computer graphics and their foundation in human perception. Overview of different visualization techniques and examples of 3D visualization projects from different disciplines (natural sciences, medicine, and engineering). Class project in interactive 3D visualization using the ParaView, Mayavi, TVTK, VTK or a similar system.\n",
    "credits": "3"
  },
  {
    "course_name": "Security and Privacy in Cloud Computing",
    "dept": "COM S",
    "num": "559",
    "desc": "Prereq: COM S 352 or CPR E 308, and COM S 486 or CPR E 489 or CPR E 530\nIntroduction to cloud computing concepts and systems. Security and privacy threats in cloud computing. Practical techniques for cloud computing security. Theoretical and practical solutions for secure outsourcing of data and computation. Oral presentations and research projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Data-Driven Security and Privacy",
    "dept": "COM S",
    "num": "560",
    "desc": "Prereq: CPR E 531; COM S 474 or COM S 573\nExamination of applications of machine learning and big data techniques to various security and privacy problems, as well as secure and privacy-preserving machine learning algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles and Internals of Database Systems",
    "dept": "COM S",
    "num": "561",
    "desc": "Prereq: COM S 311, ENGL 250, SP CM 212; for graduate credit: graduate standing or permission of instructor\nDatabase design including entity-relationship model, relational data model, and non-relational data models, data dependency, and normalization. Database management including physical storage, access methods, query processing, and transaction management. Database systems of special purposes such as spatial databases, mobile object databases, and multimedia databases. Introduction to current database research such as cloud data management and Internet information retrieval.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics I (Bioinformatics Algorithms)",
    "dept": "COM S",
    "num": "567",
    "desc": "Prereq: COM S 228; COM S 330; credit or enrollment in BIOL 315, STAT 430\nBiology as an information science. A review of the algorithmic principles that are driving the advances in bioinformatics and computational biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics II (Statistical Bioinformatics)",
    "dept": "COM S",
    "num": "568",
    "desc": "Prereq: BCB 567 or (BIOL 315 and STAT 430), credit or enrollment in GEN 409\nStatistical models for sequence data, including applications in genome annotation, motif discovery, variant discovery, molecular phylogeny, gene expression analysis, and metagenomics.  Statistical topics include model building, inference, hypothesis testing, and simple experimental design, including for big data/complex models.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics III (Structural Bioinformatics)",
    "dept": "COM S",
    "num": "569",
    "desc": "Prereq: BCB 567, BBMB 316, GEN 409, STAT 430\nMolecular structures including genes and gene products: protein, DNA and RNA structure. Structure determination methods, structural refinement, structure representation, comparison of structures, visualization, and modeling. Molecular and cellular structure from imaging. Analysis and prediction of protein secondary, tertiary, and higher order  structure, disorder, protein-protein and protein-nucleic acid interactions, protein localization and function, bridging between molecular and cellular structures. Molecular evolution.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics IV (Systems Biology)",
    "dept": "COM S",
    "num": "570",
    "desc": "Prereq: BCB 567 or COM S 311, COM S 228, GEN 409, STAT 430\nAlgorithmic and statistical approaches in computational functional genomics and systems biology. Analysis of high throughput biological data obtained using system-wide measurements. Topological analysis, module discovery, and comparative analysis of gene and protein networks. Modeling, analysis, and inference of transcriptional regulatory networks, protein-protein interaction networks, and metabolic networks. Dynamic systems and whole-cell models. Ontology-driven, network based, and probabilistic approaches to information integration.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Artificial Intelligence",
    "dept": "COM S",
    "num": "572",
    "desc": "Prereq: COM S 311,  STAT 330 or STAT 305, ENGL 250, SP CM 212; for graduate credit: graduate standing or permission of instructor\nSpecification, design, implementation, and selected applications of intelligent software agents and multi-agent systems. Computational models of intelligent behavior, including problem solving, knowledge representation, reasoning, planning, decision making, learning, perception, action, communication and interaction. Reactive, deliberative, rational, adaptive, learning and communicative agents and multiagent systems. Artificial intelligence programming. Research project and written report required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Machine Learning",
    "dept": "COM S",
    "num": "573",
    "desc": "Prereq: Graduate standing or permission of instructor\nBasic principles, techniques, and applications of machine learning. Design, analysis, implementation, and applications of learning algorithms. Selected machine learning techniques in supervised learning, unsupervised learning, and reinforcement learning, including Bayesian decision theory, computational learning theory, decision trees, linear models, support vector machines, artificial neural networks, instance-based learning, probabilistic graphical models, ensemble learning, clustering algorithms, dimensionality reduction and feature selection. Selected applications in data mining and pattern recognition.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Machine Learning",
    "dept": "COM S",
    "num": "574",
    "desc": "Prereq: COM S 311, STAT 330 or STAT 305, MATH 165, ENGL 250, SP CM  212; for graduate credit: graduate standing or permission of instructor\nIntroduction to tools and techniques of machine learning for applications. Selected machine learning techniques in practical data mining for classification, regression, and clustering, e.g., association rules, decision trees, linear models, Bayesian learning, support vector machines, artificial neural networks, instance-based learning, probabilistic graphical models, ensemble learning, and clustering algorithms. Selected applications in data mining and pattern recognition.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Perception",
    "dept": "COM S",
    "num": "575",
    "desc": "Prereq: Graduate standing or permission of instructor\nStatistical and algorithmic methods for sensing, recognizing, and interpreting the activities of people by a computer. Focuses on machine perception techniques that facilitate and augment human-computer interaction. Introduce computational perception on both theoretical and practical levels. Participation in small groups to design, implement, and evaluate a prototype of a human-computer interaction system that uses one or more of the techniques covered in the lectures.\n",
    "credits": "3"
  },
  {
    "course_name": "Problem Solving Techniques for Applied Computer Science",
    "dept": "COM S",
    "num": "577",
    "desc": "Prereq: COM S 228; COM S 230 or CPR E 310, MATH 166, MATH 207 or MATH 317, or consent of the instructor; for graduate credit: graduate standing or permission of instructor\nSelected topics in applied mathematics, algorithms, and geometry that have found applications in areas such as geometric modeling, graphics, robotics, vision, human machine interface, speech recognition, computer animation, etc. Homogeneous coordinates and transformations, perspective projection, rotations in space, quaternions, polynomial interpolation, roots of polynomials and polynomial systems, solution of linear and nonlinear equations, parametric and algebraic curves, curvature, torsion, Frenet formulas, surfaces, principal curvatures, Gaussian and mean curvatures, geodesics, approximation, Fourier series and fast Fourier transform, linear programming, data fitting, least squares, simplex method, nonlinear optimization, Lagrange multipliers, calculus of variations. Programming components. Scholarly report required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Systems Architecture",
    "dept": "COM S",
    "num": "581",
    "desc": "Prereq: CPR E 381\nQuantitative principles of computer architecture design, instruction set design, processor architecture: pipelining and superscalar design, instruction level parallelism, memory organization: cache and virtual memory systems, multiprocessor architecture, cache coherency, interconnection networks and message routing, I/O devices and peripherals.\n",
    "credits": "3"
  },
  {
    "course_name": "Reconfigurable Computing Systems",
    "dept": "COM S",
    "num": "583",
    "desc": "Prereq: Background in computer architecture, design, and organization\nIntroduction to reconfigurable computing, FPGA technology and architectures, spatial computing architectures such as systolic and bit serial adaptive network architectures, static and dynamic rearrangeable interconnection architectures, processor architectures incorporating reconfigurabiltiy.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Network Architectures",
    "dept": "COM S",
    "num": "586",
    "desc": "Prereq: COM S 511, COM S 552 or CPR E 489\nDesign and implementation of computer communication networks: layered network architectures, local area networks, data link protocols, distributed routing, transport services, network programming interfaces, network applications, error control, flow/congestion control, interconnection of heterogeneous networks, TCP/IP, software-defined networking and network security.\n",
    "credits": "3"
  },
  {
    "course_name": "Network Programming, Applications, and Research Issues",
    "dept": "COM S",
    "num": "587",
    "desc": "Prereq: COM S 352 or CPR E 489 or equivalent; for graduate credit: graduate standing or permission of instructor\nProgramming paradigms for building distributed and networking applications, including multithreaded client-server programming, socket programming, distributed object frameworks and programming suites, and web computing and security. Introduction to some on-going research issues in distributed and networking applications, including peer-to-peer computing, multimedia communications, and mobile computing and networking.  Written report and oral presentation required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "COM S",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nSpecial Topics in Computer Science.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research Colloquia",
    "dept": "COM S",
    "num": "592",
    "desc": "Prereq: Graduate classification\nAttend Computer Science Research Colloquia. Written summary is required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Graduate Internship",
    "dept": "COM S",
    "num": "598",
    "desc": "Prereq: Graduate Classification\nSupervised internship working in professional settings appropriate to the student's degree program. Academic work under faculty supervision.\n",
    "credits": "R"
  },
  {
    "course_name": "Creative Component",
    "dept": "COM S",
    "num": "599",
    "desc": "\nCreative component for nonthesis option of Master of Science degree.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "COM S",
    "num": "610",
    "desc": "\nSeminar in Computer Science.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics in Analysis of Algorithms",
    "dept": "COM S",
    "num": "611",
    "desc": "Prereq: COM S 511, COM S 531\nAdvanced algorithm analysis and design techniques. Topics include, but are not limited to, graph algorithms, geometric algorithms, approximation algorithms, fixed-parameter algorithms, randomized algorithms and advanced data structures. Content varies by semester.\n",
    "credits": "3"
  },
  {
    "course_name": "Distributed Algorithms",
    "dept": "COM S",
    "num": "612",
    "desc": "Prereq: COM S 511 or COM S 531\nThe theory of distributed computation. Algorithms, lower bounds and impossibility results. Fundamental problems including consensus, leader election, mutual exclusion and clock synchronization. Synchronous, asynchronous and partially synchronous distributed systems models. Shared memory and message passing systems. Fault-tolerance and randomization. Wait-free object simulations. Distributed shared memory. Special topics vary from year to year.\n",
    "credits": "3"
  },
  {
    "course_name": "Parallel Algorithms for Scientific Applications",
    "dept": "COM S",
    "num": "626",
    "desc": "Prereq: CPR E 526\nAlgorithm design for high-performance computing. Parallel algorithms for multidimensional tree data structures, space-filling curves, random number generation, graph partitioning and load balancing. Applications to grid and particle-based methods and computational biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Computational Complexity",
    "dept": "COM S",
    "num": "631",
    "desc": "Prereq: COM S 531\nAdvanced study in the quantitative theory of computation. Time and space complexity of algorithmic problems. The structure of P, NP, PH, PSPACE, and other complexity classes, especially with respect to resource-bounded reducibilities and complete problems. Complexity relative to auxiliary information, including oracle computation and relativized classes, randomized algorithms, advice machines, Boolean circuits. Kolmogorov complexity and randomness.  Novel models of computation emerging in a rapidly changing field.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Computational Randomness",
    "dept": "COM S",
    "num": "633",
    "desc": "Prereq: COM S 531\nAdvanced study of the role of randomness in computation. Randomized algorithms, derandomization, and probabilistic complexity classes. Kolmogorov complexity, algorithmic information theory, and algorithmic randomness. Applications chosen from cryptography, interactive proof systems, computational learning, lower bound arguments, mathematical logic, and the organization of complex systems.  Novel models of computation emerging in a rapidly changing field.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory of Games, Knowledge and Uncertainty",
    "dept": "COM S",
    "num": "634",
    "desc": "Prereq: COM S 230\nFundamentals of Game Theory: individual decision making, strategic and extensive games, mixed strategies, backward induction, Nash and other equilibrium concepts. Discussion of Auctions and Bargaining. Repeated, Bayesian and evolutionary games. Interactive Epistemology: reasoning about knowledge in multiagent environment, properties of knowledge, agreements, and common knowledge. Reasoning about and representing uncertainty, probabilities, and beliefs. Uncertainty in multiagent environments. Aspects and applications of game theory, knowledge, and uncertainty in other areas, especially Artificial Intelligence and Economics, will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Programming Language Semantics",
    "dept": "COM S",
    "num": "641",
    "desc": "Prereq: COM S 531, COM S 541\nOperational and other mathematical models of programming language semantics. Type systems and their soundness. Applications of semantics on areas such as program correctness, language design or translation.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Distributed Operating Systems",
    "dept": "COM S",
    "num": "652",
    "desc": "Prereq: COM S 552\nConcepts and techniques for network and distributed operating systems: communications protocols, processes and threads, name and object management, synchronization, consistency and replications for consistent distributed data, fault tolerance, protection and security, and distributed file systems. Research project.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Computer Graphics",
    "dept": "COM S",
    "num": "657",
    "desc": "Prereq: COM S 228, I E 557/M E 557/CPR E 557/COM S 557\nModern lighting models: Rendering Equation, Spherical Harmonics, Lafortune, Cook-Torrance. Non-polygonal primitives: volumes, points, particles. Textures: filtering, reflections creation. Graphics hardware: pipeline, performance issues, programmability in vertex and fragment path. Per-pixel lighting. Nonphotorealistic rendering. Radiosity; Ray tracing.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Database Systems",
    "dept": "COM S",
    "num": "661",
    "desc": "Prereq: COM S 461 or COM S 561\nAdvanced topics chosen from the following: database design, data models, query systems, query optimization, incomplete information, logic and databases, multimedia databases; temporal, spatial and belief databases, semistructured data, concurrency control, parallel and distributed databases, information retrieval, data warehouses, wrappers, mediators, and data mining.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Software Engineering",
    "dept": "COM S",
    "num": "665",
    "desc": "Prereq: COM S 511\nAdvanced topics on software repository analysis, data mining and software engineering, software engineering for context-aware and situation-aware computing, distributed development, product lines, safety, security, and reliability, and traceability.  Content varies by semester.\n  Maximum 6 credits of COM S 665 may apply toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Software Engineering: Foundations",
    "dept": "COM S",
    "num": "665A",
    "desc": "Prereq: COM S 511\nAdvanced topics on theoretical and technical foundations in Software Engineering. Content varies by semester.\n  Maximum 6 credits of COM S 665 may apply toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Software Engineering: Empirical",
    "dept": "COM S",
    "num": "665B",
    "desc": "Prereq: COM S 511\nAdvanced topics on empirical studies on human factors and other software engineering topics. Content varies by semester.\n  Maximum 6 credits of COM S 665 may apply toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Computational Intelligence",
    "dept": "COM S",
    "num": "672",
    "desc": "Prereq: COM S 572 or COM S 573 or COM S 472 or COM S 474\nSelected topics in probabilistic graphical models, causal inference, semantic web, information retrieval, natural language processing, knowledge representation and reasoning, deep learning, embedding, distributed learning, incremental learning, multi-task learning, multi-strategy learning,  multi-relational learning, modeling the internet and the web, automated scientific discovery, neural and cognitive modeling. Advanced applications of artificial intelligence in bioinformatics, distributed systems, natural language, multimedia data, decision making, robotics, and more.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Computational Models of Learning",
    "dept": "COM S",
    "num": "673",
    "desc": "Prereq: COM S 572 or COM S 573 or COM S 472 or COM S 474\nAdvanced topics in machine learning. Selected topics in computational learning theory,  Bayesian and information theoretic models (ML, MAP, MDL, MML), probabilistic graphical models, statistical relational learning, reinforcement learning, and deep learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Computer Architecture",
    "dept": "COM S",
    "num": "681",
    "desc": "Prereq: CPR E 581.  Repeatable with Instructor permission\nCurrent topics in computer architecture design and implementation. Advanced pipelining, cache and memory design techniques. Interaction of algorithms with architecture models and implementations. Tradeoffs in architecture models and implementations.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "COM S",
    "num": "699",
    "desc": "Prereq: Approval of instructor\nResearch.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Cornerstone Learning Community: Orientation to Academic Life",
    "dept": "CON E",
    "num": "121",
    "desc": "\nIntegration of first-year and transfer students into the engineering profession and the Construction Engineering program. Assignments and activities completed both individually and in learning teams involving teamwork, academic preparation, and study skills. Introduction to construction industry professionals. Teamwork topics include interdisciplinary teamwork, skills for academic success, diversity issues and leadership. Introduction to organization of program, department, college, and university. Overview of faculty, staff, policies, procedures and resources.\n",
    "credits": "1"
  },
  {
    "course_name": "Cornerstone Learning Community: Orientation to Professional Life",
    "dept": "CON E",
    "num": "122",
    "desc": "\nContinuation of CON E 121. Integration of first-year and transfer students into the engineering profession. Career preparation, professional ethics, construction research, leadership. Introduction to construction industry professionals including how they interact with engineers in other disciplines. Continued introduction to program, department, college, and university organization. Overview of faculty, staff, policies, procedures and resources.\n",
    "credits": "1"
  },
  {
    "course_name": "Contractor Organization and Management of Construction",
    "dept": "CON E",
    "num": "222",
    "desc": "Prereq: Completion of basic program\nEntry level course for construction engineering: integration of significant engineering and management issues related to construction company operations.  Company organization and operations; construction and project administration; construction contracts; delivery systems; construction safety; contract documents.\n",
    "credits": "3"
  },
  {
    "course_name": "Construction Materials and Methods",
    "dept": "CON E",
    "num": "241",
    "desc": "Prereq: Completion of basic program\nIntroduction to materials and methods of building construction and to construction drawings. Foundation, structural framing, floor, roof, and wall systems. Blueprint reading and quantity takeoff techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical/Electrical Materials and Methods",
    "dept": "CON E",
    "num": "251",
    "desc": "Prereq: Credit or enrollment in CON E 241\nIntroduction to the materials and methods for mechanical and electrical construction systems and drawings. HVAC, water and waste water, power distribution, lighting, and fire protection. Blueprint reading and quantity takeoff.\n",
    "credits": "1"
  },
  {
    "course_name": "Construction Equipment and Heavy Construction Methods",
    "dept": "CON E",
    "num": "322",
    "desc": "Prereq: CON E 222 and CON E 241, or C E 306 in lieu of CON E 222 and 241\nSelection and acquisition of construction equipment. Application of engineering fundamentals and economics to performance characteristics and production of equipment. Heavy construction methods and economic applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Concrete and Steel Construction",
    "dept": "CON E",
    "num": "340",
    "desc": "Prereq: E M 324 and CON E 222, or CE 306 in lieu of CON E 222\nPlanning and field engineering for concrete and steel construction. Design and applications of concrete formwork to construction. Erection of structural steel.  Emerging industry themes.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Systems in Buildings",
    "dept": "CON E",
    "num": "352",
    "desc": "Prereq: CON E 222, CON E 251, PHYS 222; or permission of instructor\nComprehensive coverage of mechanical systems, plumbing, fire protection.  Analysis techniques and design principles for each system.  Required comprehensive design project for a major building project.\n",
    "credits": "3"
  },
  {
    "course_name": "Electrical Systems in Buildings",
    "dept": "CON E",
    "num": "353",
    "desc": "Prereq: PHYS 222 and credit or enrollment in CON E 352; or permission of instructor\nComprehensive coverage of building electrical systems including power, lighting, fire alarm, security and communications.  Analysis techniques and design principles for each system. Required comprehensive design project for a major building project.\n",
    "credits": "3"
  },
  {
    "course_name": "Building Energy Performance",
    "dept": "CON E",
    "num": "354",
    "desc": "Prereq: CON E 352 or permission of instructor\nEnergy performance of buildings, building shells, HVAC, electrical and other building systems.  Analysis and evaluation of building performance, energy efficiency, environmental quality, first costs, and operating costs.  Strategies to exceed energy code requirements through the ASHRAE Standard 90.1.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Law",
    "dept": "CON E",
    "num": "380",
    "desc": "Prereq: Junior classification\nIntroduction to law and judicial procedure as they relate to the practicing engineer. Contracts, professional liability, professional ethics, licensing, bidding procedures, intellectual property, products liability, risk analysis.  Emphasis on development of critical thinking process, abstract problem analysis and evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Bidding Construction Projects I",
    "dept": "CON E",
    "num": "381",
    "desc": "Prereq: Permission of the instructor\nTeam development of construction process designs and cost estimates for transportation construction projects under closely simulated conditions. Examine project sites, consult with construction industry mentors, obtain subcontractor and supplier quotations, and submit bids.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects I: Heavy and Highway",
    "dept": "CON E",
    "num": "381A",
    "desc": "Prereq: Permission of the instructor\nTeam development of construction process designs and cost estimates for transportation construction projects under closely simulated conditions. Examine project sites, consult with construction industry mentors, obtain subcontractor and supplier quotations, and submit bids.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects I: Building",
    "dept": "CON E",
    "num": "381B",
    "desc": "Prereq: Permission of the instructor\nTeam development of construction process designs and cost estimates for transportation construction projects under closely simulated conditions. Examine project sites, consult with construction industry mentors, obtain subcontractor and supplier quotations, and submit bids.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects I: Mechanical",
    "dept": "CON E",
    "num": "381C",
    "desc": "Prereq: Permission of the instructor\nTeam development of construction process designs and cost estimates for transportation construction projects under closely simulated conditions. Examine project sites, consult with construction industry mentors, obtain subcontractor and supplier quotations, and submit bids.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects I: Electrical",
    "dept": "CON E",
    "num": "381D",
    "desc": "Prereq: Permission of the instructor\nTeam development of construction process designs and cost estimates for transportation construction projects under closely simulated conditions. Examine project sites, consult with construction industry mentors, obtain subcontractor and supplier quotations, and submit bids.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects I: Mechanical and Electrical",
    "dept": "CON E",
    "num": "381E",
    "desc": "Prereq: Permission of the instructor\nTeam development of construction process designs and cost estimates for transportation construction projects under closely simulated conditions. Examine project sites, consult with construction industry mentors, obtain subcontractor and supplier quotations, and submit bids.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects I: Miscellaneous",
    "dept": "CON E",
    "num": "381F",
    "desc": "Prereq: Permission of the instructor\nTeam development of construction process designs and cost estimates for transportation construction projects under closely simulated conditions. Examine project sites, consult with construction industry mentors, obtain subcontractor and supplier quotations, and submit bids.\n",
    "credits": "1"
  },
  {
    "course_name": "Summer Internship",
    "dept": "CON E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education (Co-op)",
    "dept": "CON E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period.  One semester per academic or calendar year.  Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Construction Cost Estimating and Cost Engineering",
    "dept": "CON E",
    "num": "422",
    "desc": "Prereq: CON E 241, CON E 251, I E 305\nConceptual and detailed cost estimating. Theory and practice of estimating construction costs of materials, labor, equipment, contingency, overhead and markup. Estimating competencies and bid ethics. Electronic quantity take off and pricing methods. Assemblies costs, unit costs, production rates. Analysis of project profitability, cost analysis and cost control methods. Value engineering. Life cycle cost analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Construction Planning, Scheduling, and Control",
    "dept": "CON E",
    "num": "441",
    "desc": "Prereq: Credit or enrollment in CON E 422\nIntegration of previous construction coursework into the planning, scheduling, and management of time, costs, and other resources. Emphasis on preparation and analysis of network schedules. Comprehensive planning and scheduling project. Computer project management applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Bidding Construction Projects II",
    "dept": "CON E",
    "num": "481",
    "desc": "Prereq: Permission of the instructor\nSimilar to CON E 381, except students with previous experience attempt projects with larger scope or lead students with less experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects II: Heavy and Highway",
    "dept": "CON E",
    "num": "481A",
    "desc": "Prereq: Permission of the instructor\nSimilar to CON E 381, except students with previous experience attempt projects with larger scope or lead students with less experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects II: Building",
    "dept": "CON E",
    "num": "481B",
    "desc": "Prereq: Permission of the instructor\nSimilar to CON E 381, except students with previous experience attempt projects with larger scope or lead students with less experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects II: Mechanical",
    "dept": "CON E",
    "num": "481C",
    "desc": "Prereq: Permission of the instructor\nSimilar to CON E 381, except students with previous experience attempt projects with larger scope or lead students with less experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects II: Electrical",
    "dept": "CON E",
    "num": "481D",
    "desc": "Prereq: Permission of the instructor\nSimilar to CON E 381, except students with previous experience attempt projects with larger scope or lead students with less experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects II: Mechanical and Electrical",
    "dept": "CON E",
    "num": "481E",
    "desc": "Prereq: Permission of the instructor\nSimilar to CON E 381, except students with previous experience attempt projects with larger scope or lead students with less experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Bidding Construction Projects II: Miscellaneous",
    "dept": "CON E",
    "num": "481F",
    "desc": "Prereq: Permission of the instructor\nSimilar to CON E 381, except students with previous experience attempt projects with larger scope or lead students with less experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Construction Engineering Design I",
    "dept": "CON E",
    "num": "487",
    "desc": "Prereq: CON E 340 (B, H), CON E 352 (B, E, M), CON E 353 (B, E, M), CON E 422, CON E 441. Student must be within two semesters of graduation\nThe integrated delivery of project services as a team, including preliminary engineering design process, constructability review, interaction with the client, identification of engineering problems, developments of a proposal, identification of design criteria, cost estimating, planning and scheduling, application of codes and standards, development of feasible alternatives, selection of best alternative, and delivery of oral presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Construction Engineering Design II",
    "dept": "CON E",
    "num": "488",
    "desc": "Prereq: CON E 340 (B,H), CON E 352 (B,E,M), CON E 353 (B,E,M), CON E 422, CON E 441. Student must be within two semesters of graduation.\nApplication of team design concepts to a construction engineering project. Project planning. Advanced construction and project management.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "CON E",
    "num": "490",
    "desc": "Prereq: Permission of instructor\nIndividual study in any phase of construction engineering. Pre-enrollment contract required.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Forensic Science",
    "dept": "CJ ST",
    "num": "220",
    "desc": "Prereq: none\nStudy of fundamental forensic science techniques and procedures covering types of physical, chemical, and biological evidence and how this information is used in the legal system.  Assessment of crime scenes and various forensic specialties will be introduced.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the U.S. Criminal Justice System",
    "dept": "CJ ST",
    "num": "240",
    "desc": "\nProvides systematic overview of law, police organization and behavior, prosecution and defense, sentencing, the judiciary, community corrections, penology, and capital punishment. The course demonstrates the role of discretion in all of these agencies as well as the sociological influences of age, race, gender, and social class on criminal justice system processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Youth and Crime",
    "dept": "CJ ST",
    "num": "241",
    "desc": "\nAn examination of delinquency that focuses on the relationship between youth as victims and as offenders, social and etiological features of delinquency, the role of the criminal justice system, delinquents' rights, and traditional and alternative ways of dealing with juvenile crime.\n",
    "credits": "3"
  },
  {
    "course_name": "American Judicial Process",
    "dept": "CJ ST",
    "num": "320",
    "desc": "Prereq: POL S 215\nAn overview of the American judicial process.  Emphasis on specific topics such as application of constitutional rights to the states (particularly the Fourth, Fifth, Sixth, and Fourteenth Amendments), mechanics of judicial opinions, constitutional philosophies of Supreme Court Justices, decisions of first impression, and the value and scope of precedent.\n",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Law",
    "dept": "CJ ST",
    "num": "332",
    "desc": "Prereq: PHIL 201 or PHIL 230\nExtent of our obligation to obey the law; what constitutes just punishment; how much of the immoral should be made illegal? Relation of these questions to major theories of law and the state. Discussion of such concepts as coercion, equality, and responsibility.\n",
    "credits": "3"
  },
  {
    "course_name": "Liberty and Law in America",
    "dept": "CJ ST",
    "num": "339",
    "desc": "Prereq: Sophomore status\nCompeting conceptions of liberty in American political thought. Debates about how liberty should be protected by the law, in fields such as health care, drugs, property, speech, religion, and sex.\n",
    "credits": "3"
  },
  {
    "course_name": "Deviant and Criminal Behavior",
    "dept": "CJ ST",
    "num": "340",
    "desc": "Prereq: SOC 134 or CJ ST 240\nTheory and research on the etiology of types of social deviance; issues relating to crime, antisocial behavior and social policies designed to control deviant behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Criminology",
    "dept": "CJ ST",
    "num": "341",
    "desc": "Prereq: CJ ST 240\nThe nature of crime and criminology; the concept of crime; statistics and theories of criminality; major forms of crime; official responses to crime and control of crime.\n",
    "credits": "3"
  },
  {
    "course_name": "Police and Society",
    "dept": "CJ ST",
    "num": "351",
    "desc": "Prereq: CJ ST 241, SOC 241 or CJ ST 240\nIntroduction and overview of law enforcement in the United States.  Theory and research on police history, function, and organization; constitutional issues of policing; and critical topics, such as community policing, officer discretion and decision-making, corruption, use of force, and racial profiling.  The course illustrates the interconnections between communities, police organizations, citizens, and criminal offenders.\n",
    "credits": "3"
  },
  {
    "course_name": "Punishment, Corrections, and Society",
    "dept": "CJ ST",
    "num": "352",
    "desc": "Prereq: CJ ST 241, SOC 241 or CJ ST 240\nIntroduction and overview of corrections in the United States.  Theory and research on probation, parole, intermediate sanctions, prison, inmate society, inmate behavior and misconduct, capital punishment, recidivism, correctional treatment, rehabilitation, and offender reintegration into society.\n",
    "credits": "3"
  },
  {
    "course_name": "White-Collar Crime",
    "dept": "CJ ST",
    "num": "402",
    "desc": "Prereq: CJ ST 241, SOC 241 or CJ ST 240\nIntroduction and overview of white-collar crime as a form of deviance.  Theory and research on occupational, corporate, and organizational offending; prevalence, costs, and consequences of white-collar crime; predictors and correlates of white-collar crime; and political, business, and public policy responses to white-collar crime.\n",
    "credits": "3"
  },
  {
    "course_name": "Criminal Offenders",
    "dept": "CJ ST",
    "num": "403",
    "desc": "Prereq: CJ ST 240 or CJ ST 241\nIntroduction and overview of criminal offenders. Theory and research on epidemiology, offender typologies, etiology of violence, recidivism, societal costs, correctional supervision, treatment, and prevention of serious antisocial behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Capital Punishment",
    "dept": "CJ ST",
    "num": "410",
    "desc": "Prereq: CJ ST 240\nHistory, philosophy, demographics, administration, and punishment rationales of capital punishment in the United States from its founding to the present. Methods of execution and trends in public opinion about the death penalty. Examination of correlates of capital offending and criminological characteristics of persons who are sentenced to death.\n",
    "credits": "3"
  },
  {
    "course_name": "Criminal and Juvenile Justice Practicum",
    "dept": "CJ ST",
    "num": "460",
    "desc": "Prereq: Junior or senior classification; permission of criminal justice studies coordinator; major or minor in criminal justice or sociology\nStudy of the criminal and juvenile justice systems and social control processes. Supervised placement in a police department, prosecutor's office, court, probation and parole department, penitentiary, juvenile correctional institution, community-based rehabilitation program, or related agency. Assessed service learning component.\n  Offered on a satisfactory-fail basis only.  No more than a total of 9 credits of 460 can be counted toward graduation. No credits in Soc 460 may be used to satisfy minimum sociology requirements for sociology majors.",
    "credits": "3"
  },
  {
    "course_name": "Topical Studies in Criminal and Juvenile Justice",
    "dept": "CJ ST",
    "num": "484",
    "desc": "Prereq: 6 credits in CJ ST and permission from instructor\nThematic or topical issues and studies dealing with the sociology of police, judiciary, institutional and community-based corrections, gender/ethnicity and crime/delinquency, criminal and delinquent gangs, and crime and delinquency prevention.\n",
    "credits": "3"
  },
  {
    "course_name": "Modern Dance I",
    "dept": "DANCE",
    "num": "120",
    "desc": "\nIntroduction and practice of basic dance concepts, including preparatory techniques and guided creativity problems. No previous modern dance experience required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Ballet I",
    "dept": "DANCE",
    "num": "130",
    "desc": "\nIntroduction to the basic skills, vocabulary, and tradition of ballet with concentration on control and proper alignment. No previous ballet experience required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Jazz I",
    "dept": "DANCE",
    "num": "140",
    "desc": "\nIntroduction to the modern jazz style with concentration on isolation and syncopation. No previous jazz experience required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Tap Dance I",
    "dept": "DANCE",
    "num": "150",
    "desc": "\nInstruction and practice in basic tap technique and terminology. No previous tap experience required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Ballroom Dance I",
    "dept": "DANCE",
    "num": "160",
    "desc": "\nInstruction and practice in foxtrot, waltz, swing, cha cha, rhumba, tango, and selected contemporary dances.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Dance Continuum",
    "dept": "DANCE",
    "num": "199",
    "desc": "Prereq: Permission of instructor\nAdvance registration required. Continued instruction and practice in either modern dance, recreational dance, ballet, jazz and/or compositional skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Fundamentals and Methods of Social and World Dance",
    "dept": "DANCE",
    "num": "211",
    "desc": "\nSkill enhancement, teaching, progressions with emphasis on world and social dance. Designed for kinesiology and health majors, open to others.\n",
    "credits": "1"
  },
  {
    "course_name": "Modern Dance Composition",
    "dept": "DANCE",
    "num": "220",
    "desc": "Prereq: DANCE 120 or previous modern dance experience\nTheory and practice of the creative skills involved in solo and small group composition.\n",
    "credits": "2"
  },
  {
    "course_name": "Modern Dance II",
    "dept": "DANCE",
    "num": "222",
    "desc": "Prereq: DANCE 120 or previous modern dance experience\nDance techniques emphasizing strength, balance, endurance, rhythmic activity and extended combinations.\n",
    "credits": "1"
  },
  {
    "course_name": "Modern Dance III",
    "dept": "DANCE",
    "num": "223",
    "desc": "Prereq: DANCE 222\nContinued experience in dance techniques and extended combinations. Emphasis on maturation of skill and artistry. Exposure to a variety of modern dance technical styles.\n",
    "credits": "1"
  },
  {
    "course_name": "Concert and Theatre Dance",
    "dept": "DANCE",
    "num": "224",
    "desc": "Prereq: By audition only\nChoreography, rehearsal, and performance in campus dance concerts and/or musical theatre productions.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Ballet II",
    "dept": "DANCE",
    "num": "232",
    "desc": "Prereq: Previous ballet experience\nTechnical skills in the classical movement vocabulary. Emphasis on alignment, techniques, sequence development, and performing quality.\n",
    "credits": "1"
  },
  {
    "course_name": "Ballet III",
    "dept": "DANCE",
    "num": "233",
    "desc": "Prereq: DANCE 232\nConcentration on technical proficiency at the intermediate level. Pointe work and partnering opportunities available.\n",
    "credits": "1"
  },
  {
    "course_name": "Jazz II",
    "dept": "DANCE",
    "num": "242",
    "desc": "Prereq: Previous jazz dance experience\nDance concepts within the jazz idiom. Instruction in extended movement sequences and artistic interpretation.\n",
    "credits": "1"
  },
  {
    "course_name": "Yoga Movement",
    "dept": "DANCE",
    "num": "250",
    "desc": "\nMixed-level Hatha Yoga class that emphasizes Iyengar style yoga. Yoga Movement is designed for developing awareness and personal practice with yoga poses and relaxation techniques. Attention will be paid to postural alignment to safely develop strength, endurance, flexibility, balance, and reduce stress. The practice develops awareness and consciousness in the physical body to help unite body and mind. Class will include introduction to other somatic practices, asanas (poses), breathing practices, meditation, yoga philosophy and deep relaxation.\n",
    "credits": "1"
  },
  {
    "course_name": "Dance Appreciation",
    "dept": "DANCE",
    "num": "270",
    "desc": "\nIntroduction to the many forms and functions of dance in world cultures. Develop abilities to distinguish and analyze various dance styles. No dance experience required.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Sound and Movement",
    "dept": "DANCE",
    "num": "320",
    "desc": "Prereq: DANCE 220\nIntermediate composition based on the relationship of movement to improvised sounds, rhythmic scores, and the musical works of composers from various periods.\n",
    "credits": "3"
  },
  {
    "course_name": "History and Philosophy of Dance",
    "dept": "DANCE",
    "num": "360",
    "desc": "Prereq: DANCE 270\nStudy of the history of dance from early to modern times with emphasis on the theories and philosophies of contemporary modern dance, dancers, and dance educators.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Studies in Dance",
    "dept": "DANCE",
    "num": "370",
    "desc": "Prereq: 2 credits in dance\nAdvance registration required. Designed to meet special interests and talents of students to include both group and independent study in various aspects of dance as a performing art including production, choreography, and performance.\n",
    "credits": "1"
  },
  {
    "course_name": "Teaching Children's Dance",
    "dept": "DANCE",
    "num": "384",
    "desc": "\nContent, experiences, and methods of a comprehensive dance program at the elementary school level. Theories and practice in guiding elementary school children in expressive movement experiences.\n",
    "credits": "2"
  },
  {
    "course_name": "Methods of Teaching Dance",
    "dept": "DANCE",
    "num": "385",
    "desc": "\nMethods and techniques of teaching social and world dance forms. Introduction to teaching educational modern dance.\n",
    "credits": "2"
  },
  {
    "course_name": "Teaching Dance Technique and Composition",
    "dept": "DANCE",
    "num": "386",
    "desc": "Prereq: DANCE 320\nTeaching yoga, body therapies, mindfulness and dance composition to enhance the physical and mental performance of the individual.\n",
    "credits": "2"
  },
  {
    "course_name": "Independent Study",
    "dept": "DANCE",
    "num": "490",
    "desc": "Prereq: 6 credits in dance and permission of coordinator\nIndependent study of problems or areas of interest in dance.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Dance",
    "dept": "DANCE",
    "num": "490A",
    "desc": "Prereq: 6 credits in dance and permission of coordinator\nIndependent study of problems or areas of interest in dance.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study in Dance - Honors",
    "dept": "DANCE",
    "num": "490H",
    "desc": "Prereq: 6 credits in dance and permission of coordinator\nIndependent study of problems or areas of interest in dance for those admitted to the honors program.\n",
    "credits": "1"
  },
  {
    "course_name": "Orientation to Data Science",
    "dept": "DS",
    "num": "110",
    "desc": "\nIntroduction to the procedures and policies of Iowa State University and the Data Science program, test-outs, honorary societies, etc. Issues relevant to student adjustment to college life will also be discussed.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Data Science",
    "dept": "DS",
    "num": "201",
    "desc": "Prereq: 1-1/2 Years of High School Algebra\nData Science concepts and their applications; domain case studies with applications in various fields; overview of data analysis; major components of data analysis pipelines; computing concepts for data science; descriptive data analysis; hands-on data analysis experience; communicating findings to stakeholders, and ethical issues in data science.\n",
    "credits": "3"
  },
  {
    "course_name": "Data Acquisition and Exploratory Data Analysis",
    "dept": "DS",
    "num": "202",
    "desc": "Prereq: DS 201\nData acquisition: file structures, web-scraping, database access; ethical aspects of data acquisition; types of data displays; numerical and visual summaries of data; pipelines for data analysis: filtering, transformation, aggregation, visualization and (simple) modeling; good practices of displaying data; data exploration cycle; graphics as tools of data exploration; strategies and techniques for data visualizations; basics of reproducibility and repeatability; web-based interactive applets for visual presentation of data and results. Programming exercises.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Data Modeling and Predictive Analysis",
    "dept": "DS",
    "num": "301",
    "desc": "Prereq: DS 201, one of STAT 101, 104, 105, 201, 226, 231, 305, 322, 330\nElements of predictive analysis such as training and test sets; feature extraction; survey of algorithmic machine learning techniques, e.g. decision trees, Naïve Bayes, and random forests; survey of data modeling techniques, e.g. linear model and regression analysis; assessment and diagnostics: overfitting, error rates, residual analysis, model assumptions checking; communicating findings to stakeholders in written, oral, verbal and electronic form, and ethical issues in data science. Participation in a multi-disciplinary team project.\n",
    "credits": "3"
  },
  {
    "course_name": "Concepts and Applications of Machine Learning",
    "dept": "DS",
    "num": "303",
    "desc": "Prereq: DS 201\nMachine learning concepts such as training and test sets; feature extraction; principles of machine learning techniques; regression; pattern recognition methods; unsupervised learning techniques; assessment and diagnostics: overfitting, error rates, residual analysis, model assumptions checking, feature selection; ethical issues in data science; communicating findings to stakeholders in written, oral, visual and electronic form.\n",
    "credits": "3"
  },
  {
    "course_name": "Data Science Capstone",
    "dept": "DS",
    "num": "401",
    "desc": "Prereq: DS 202X; DS 301X\nStudents work as individuals and teams to complete the planning, design, and implementation of a significant multi-disciplinary project in data science. Oral and written reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Thinking",
    "dept": "DES",
    "num": "230",
    "desc": "\nIntroduction to the phenomenon of design thinking as it appears in various design fields, including methodologies of reasoning and problem solving; patterns of creativity and individual style; and the interaction of art, science, and technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Interdisciplinary Foundation Studio I",
    "dept": "DES",
    "num": "241",
    "desc": "Prereq: Completion of College of Design Core Program.\nIntegration of contemporary strategies, methods, and approaches to design. Move through cycles of ideation, iteration, communication and revision, including the use of non-traditional materials and processes. Emphasis on the specific issues of interdisciplinary design practices and an ethical understanding of the materials of drawing.\n",
    "credits": "4"
  },
  {
    "course_name": "Interdisciplinary Foundation Studio II",
    "dept": "DES",
    "num": "242",
    "desc": "Prereq: Completion of College of Design Core Program.\nDevelopment and practice of mental flexibility in creative processes leading to high-quality design solutions and develop fluency in \"bias toward action.\" Move conceptual works quickly into visible and tangible forms that can be shared, tested, and evaluated based of quality. Multiple studio projects that will move at a fast pace and be iterative.\n",
    "credits": "4"
  },
  {
    "course_name": "Design Forum",
    "dept": "DES",
    "num": "250",
    "desc": "Prereq: DSN S 102, DSN S 131, DSN S 183 and credit or concurrent enrollment in DES 230\nIntroduction of themes and issues that are relevant to the design fields through theoretical readings, case studies, and visiting lecturers.\n",
    "credits": "2"
  },
  {
    "course_name": "Design Field Study",
    "dept": "DES",
    "num": "259",
    "desc": "Prereq: Enrollment in or 2 credits of DES 240.\nOff-campus tours of areas of interest within the design professions such as design offices, museums, buildings, and neighborhoods.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Visual Literacy for Design Critique",
    "dept": "DES",
    "num": "330",
    "desc": "Prereq: DSN S 102 or DSN S 183 or 3 credits of ART H or equivalent.\nStudents will learn to interpret, analyze and evaluate visual materials, use images and text effectively to communicate ideas, and understand issues surrounding the creation and use of images and visual media for design critique. Precedent study and critique of sample student design work to understand principles of visual literacy and how to apply them to the presentation of design work. Emphasis on peer-to-peer discussion and in-class participation. Lecture and discussion format.\n",
    "credits": "3"
  },
  {
    "course_name": "Time-Based Digital Media",
    "dept": "DES",
    "num": "333",
    "desc": "Prereq: DSN S 232 or equivalent.\nIntroduction to various time-based digital media tools to develop basic skills including sequencing, storytelling, animation, sound editing, and video production.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Studio II",
    "dept": "DES",
    "num": "340",
    "desc": "Prereq: 4 credits of DES 240 or equivalent.\nHalf-semester course.  Studio projects of increasing complexity requiring interdisciplinary approaches to contemporary challenges and opportunities.  Continued development of students' abilities to generate ideas and communicate those ideas visually, orally, and through writing.  Field trip.\n",
    "credits": "2"
  },
  {
    "course_name": "Portfolio and Professional Preparation",
    "dept": "DES",
    "num": "491",
    "desc": "Prereq: classification as DES major; 4 credits of DES 240\nPreparation of printed and online portfolio of student work and materials for job search and/or graduate school applications.  Guidance for interviewing, professional networking, business etiquette, and resume writing.  Workshops and lectures.\n",
    "credits": "4"
  },
  {
    "course_name": "Capstone Experience",
    "dept": "DES",
    "num": "495",
    "desc": "Prereq: classification as DES major; 2 credits of DES 340\nLaunchpad to design careers. Comprehensive interdisciplinary design work in three areas: design research, design management, design leadership. Demonstration of design skills and project planning and development.\n",
    "credits": "4"
  },
  {
    "course_name": "Design Studio I",
    "dept": "DSN S",
    "num": "102",
    "desc": "\nA foundation design studio exploring two and three-dimensional design. Emphasis on fundamental skills and ideas shared across design disciplines. Creative processes, visual order, materials, and critical thinking are investigated through studio projects. Lectures and discussions cover the topics introduced in studios.\n",
    "credits": "4"
  },
  {
    "course_name": "Design Exchange Seminar I",
    "dept": "DSN S",
    "num": "110",
    "desc": "Prereq: Member of Design Exchange Learning Community\nOrientation to the College of Design. Introduction to the design disciplines and studio pedagogy.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Design Exchange Seminar II",
    "dept": "DSN S",
    "num": "111",
    "desc": "Prereq: Member of the Design Exchange Learning Community\nDevelopment and clarification of career and academic plans.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Design Collaborative Seminar",
    "dept": "DSN S",
    "num": "115",
    "desc": "Prereq: Member of Design Collaborative Learning Community\nOrientation to the College of Design.  Introduction to the design disciplines and studio pedagogy.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Drawing I",
    "dept": "DSN S",
    "num": "131",
    "desc": "\nAn introduction to methods of visual thinking and drawing through studio experiences and lectures. All design fields utilize visual communication and drawing. Focus on the use of drawing as a method for creative problem solving, design development and visual communication. Explore, from observation and imagination, the use of fast sketching and in-depth drawing, using various scales, mediums and processes.\n",
    "credits": "4"
  },
  {
    "course_name": "Diversity in Art",
    "dept": "DSN S",
    "num": "145",
    "desc": "Prereq: None\nDiscussion on issues of diversity and inclusion utilizing the Art on Campus and University’s Permanent Collection. Topics include ethnic heritage, family background, religious traditions, and interpersonal relationships, with a significant focus on instilling visual analysis skills.\n  None",
    "credits": "1"
  },
  {
    "course_name": "Design in Context",
    "dept": "DSN S",
    "num": "183",
    "desc": "\nExplores designed media, objects, places, spaces, structures, and systems as products of varied and often intersecting contexts. Using historical and contemporary case studies, investigates how cultural, economic, environmental, spatial, social, and temporal contexts, among others, affect design. Explores in particular how design addresses complex and multifaceted problems.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Design Communications",
    "dept": "DSN S",
    "num": "232",
    "desc": "\nIntroductory investigations of various digital design media to develop multi-dimensional problem solving, digital communication skills and perceptual sensitivity. Open to all university majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad Preparation Seminar",
    "dept": "DSN S",
    "num": "301",
    "desc": "\nCultural introduction to host country, introduction to faculty sponsor and program of study, the particulars of traveling and living abroad, and financial and logistical preparations. Guest lectures. Required of all students planning to participate in a College of Design study abroad program for 9 or more credits.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Design Leadership Seminar",
    "dept": "DSN S",
    "num": "302",
    "desc": "Prereq: Selection as a peer mentor for the Core Design program.\nFor students serving as peer mentors for the Core Design Program, under faculty supervision.  Development of teaching and leadership skills within the context of design education experiences.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Design Ambassadors",
    "dept": "DSN S",
    "num": "303",
    "desc": "Prereq: Admittance into one of the professional programs in the College of Design\nOpportunity to strengthen leadership, communication and presentation skills.  Introduction to student development theory.  Students participate in collaborative projects focused on prospective design students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Practical Experience",
    "dept": "DSN S",
    "num": "310",
    "desc": "Prereq: Permission of adviser or Coordinator of Design Studies\nIndependent educational enrichment through practical experience.  Students must register for this course prior to commencing each term.  Available only to students taking course loads of eleven credits or less.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Multi-Dimensional Digital Design Communication",
    "dept": "DSN S",
    "num": "332",
    "desc": "Prereq: ARCH 230, ARTGR 275, DSN S 232, or permission of the instructor\nInvestigations if interoperable digital-design tools, techniques and methods directed at human scale interactive hybrid design from ideation to visualization, synthesis to analysis, and realization to fabrication.\n",
    "credits": "3"
  },
  {
    "course_name": "Time-Based Digital Media",
    "dept": "DSN S",
    "num": "333",
    "desc": "Prereq: DSN S 232 or equivalent.\nIntroduction to various time-based digital media tools to develop basic skills including sequencing, storytelling, animation, sound editing, and video production.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Art/Public Space",
    "dept": "DSN S",
    "num": "445",
    "desc": "Prereq: Junior Standing, DSN S 102, DSN S 131, DSN S 183\nExploration of the history, precedents, and practice of public art and public space with a focus on developments since 1970 in the United States and abroad. Course includes development of a proposal for a site specific work of art.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Interdisciplinary Design Studio",
    "dept": "DSN S",
    "num": "446",
    "desc": "Prereq: Junior classification in a curriculum in the College of Design and permission of instructor\nAdvanced interdisciplinary design projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Interdisciplinary Design Studio: Honors",
    "dept": "DSN S",
    "num": "446H",
    "desc": "Prereq: Junior classification in a curriculum in the College of Design and permission of instructor\nAdvanced interdisciplinary design projects.\n",
    "credits": "5"
  },
  {
    "course_name": "Landscape Architecture: History/Theory/Criticism",
    "dept": "DSN S",
    "num": "478D",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture: Landscape Planning",
    "dept": "DSN S",
    "num": "478E",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture: Graphics",
    "dept": "DSN S",
    "num": "478G",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture: Interdisciplinary Studies",
    "dept": "DSN S",
    "num": "478I",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture: International Studies",
    "dept": "DSN S",
    "num": "478J",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Computer Applications",
    "dept": "DSN S",
    "num": "478K",
    "desc": "Prereq: L A 371 or senior classification or graduate standing\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Independent Study",
    "dept": "DSN S",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: History",
    "dept": "DSN S",
    "num": "490A",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Technology",
    "dept": "DSN S",
    "num": "490B",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Communications",
    "dept": "DSN S",
    "num": "490C",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Design",
    "dept": "DSN S",
    "num": "490D",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "DSN S",
    "num": "490E",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Social/Behavioral",
    "dept": "DSN S",
    "num": "490F",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Outreach",
    "dept": "DSN S",
    "num": "490G",
    "desc": "Prereq: Written  approval of instructor and department chair on required form prior to semester of enrollment.\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "DSN S",
    "num": "490H",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Sustainability",
    "dept": "DSN S",
    "num": "490I",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment.\nIndependent investigation of a topic of special interest to the student.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Italian Culture",
    "dept": "DSN S",
    "num": "492",
    "desc": "Prereq: Enrollment in the College of Design Rome Study Abroad Program\nIntroduction to Italian contemporary culture for design students, including food, religion, fashion, politics, media, and social mores.\n",
    "credits": "1"
  },
  {
    "course_name": "Interdisciplinary Design Studio",
    "dept": "DSN S",
    "num": "546",
    "desc": "Prereq: Graduate or senior standing in the College of Design and permission of instructor\nAdvanced interdisciplinary design projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture",
    "dept": "DSN S",
    "num": "578",
    "desc": "Prereq: Senior Classification or graduate standing\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Construction",
    "dept": "DSN S",
    "num": "578C",
    "desc": "Prereq: Senior Classification or graduate standing\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture: Honors",
    "dept": "DSN S",
    "num": "578H",
    "desc": "Prereq: Senior classification or graduate standing\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Renaissance Art",
    "dept": "DSN S",
    "num": "585",
    "desc": "Prereq: Graduate classification and permission of instructor\nEuropean art including painting, sculpture, architecture, and crafts; thirteenth through sixteenth centuries.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "DSN S",
    "num": "590",
    "desc": "Prereq: Written approval of instructor and department chair on required form prior to semester of enrollment\nIndependent investigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Methods",
    "dept": "DIET",
    "num": "511",
    "desc": "Prereq: Enrollment in GP-IDEA MFCS in Dietetics\nAn overview of diverse research approaches focusing on methods for collecting and analyzing quantitative and qualitative data. www only.\n  Only one of DIET 511 or FCEDS 511 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Financial Management and Cost Controls",
    "dept": "DIET",
    "num": "524",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nOverview of the fundamental knowledge of financial management, managerial accounting, and operational cost controls for dietetics professionals. Topics include a review of managerial accounting concepts for not- for-profit organizations and for-profit organizations based on the Uniform System of Accounts, value and risk analysis, budgeting, asset management, franchising and management contracts, cost-volume-profit analyses, and operational applications for financial performance.\n",
    "credits": "3"
  },
  {
    "course_name": "Obesity Across the Lifespan",
    "dept": "DIET",
    "num": "526",
    "desc": "\nExploration of the affects that obesity has on public health, the healthcare system, and society in general. Overview of strategies to prevent obesity across the lifespan.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition in Wellness",
    "dept": "DIET",
    "num": "530",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nAddresses wellness promotion through nutrition.  Nutritional risk and protective factors will be examined in relation to public health and individual nutrition. www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Maternal and Child Nutrition",
    "dept": "DIET",
    "num": "532",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nCritical examination of behavioral, physiological, and public health issues impacting dietary and nutritional factors that support normal growth and development.  Content focuses on early stages of the life cycle: gestation, lactation, infancy, preschool, school age, and adolescence.  www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition: A Focus on Life Stages",
    "dept": "DIET",
    "num": "538",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nExplores influence of normal physiological stresses on nutritional needs throughout the life span.  Evaluates dietary intake and identification of appropriate community nutrition services in on-line discussions.  Specific considerations, such as the influence of age and cultural heritage, are incorporated. www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Physical Activity in Aging",
    "dept": "DIET",
    "num": "540",
    "desc": "\nWWW only. Basic physiologic changes during aging and their impacts in health and disease. The focus will be on successful aging with special emphasis on physical activity and nutrition. Practical application to community settings is addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Pediatric Clinical Nutrition",
    "dept": "DIET",
    "num": "544",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in dietetics\nExamines the physiological, biochemical and nutritional aspects of disease processes relevant to infants and children up to 18 years of age.  Discussion of medical nutrition therapy for a variety of medical conditions in this population including inborn errors of metabolism, food hypersensitivity, obesity, and diseases of the major organ systems.  www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Phytochemicals",
    "dept": "DIET",
    "num": "546",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nOverview of phytochemicals (non-nutritive biologically active compounds) from fruits, vegetables, cereals and oilseeds.  Covers recent findings of chemistry, physiological functions, and potential health implications of phytochemicals. www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Functional Foods in Chronic Disease Prevention",
    "dept": "DIET",
    "num": "547",
    "desc": "\nExamination of nutritional science, food science, regulatory principles, and nutrient metabolism to understand and explain functional foods, nutraceuticals, and dietary supplements. Additionally students will evaluate the biochemical basis, technologies, legal requirements, and clinical assessment in the marketplace.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistics",
    "dept": "DIET",
    "num": "554",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nTools used to make statistical decisions. Major emphasis on explanation and understanding of important concepts involved; basic theme is understanding of data and methods used to analyze such data. www only.\n  Only one of DIET 554 or Stat 401, 495, 542 may count toward graduation by students in the GPIDEA Dietetics program.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Nutrition: Micronutrients",
    "dept": "DIET",
    "num": "556",
    "desc": "Prereq: BBMB 404 or BBMB 420 or equivalent; enrollment in GP-IDEA MFCS in Dietetics\nThe course features interrelationships of micronutrients in terms of biochemistry, physiology, genetics, and nutrition. Emphasis of the course is on developing understanding of how the coordination of structure and function is related to metabolic needs of the cell and its response to the environment. This integrated approach forms the basis for evaluating the micronutrient needs of humans in both normal and altered metabolic states.\n  Only one of DIET 556 or NUTRS 502 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Nutrition: Macronutrients",
    "dept": "DIET",
    "num": "558",
    "desc": "Prereq: BBMB 404 or BBMB 420 or equivalent; enrollment in GP-IDEA MFCS in Dietetics\nIntegration of the molecular, cellular and physiological aspects of macronutrients and energy metabolism in mammalian systems.  Dietary energy, carbohydrates, fiber, lipids, proteins, their interactions, metabolic consequences, and major research methodologies.  www only.\n  Only one of DIET 558 or NUTRS 501 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Medical Nutrition Therapy",
    "dept": "DIET",
    "num": "560",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nPathophysiology of selected acute and chronic disease states and their associated medical problems. Specific attention directed to medical nutrition needs of patients in the treatment of each disease state. www only.\n  Only two of DIET 560 or NUTRS 561, 564 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "International Nutrition and World Hunger",
    "dept": "DIET",
    "num": "565",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nIdentification and assessment of malnutrition in low-income countries.  Social, cultural, political, economic, and geographic determinants of malnutrition.  Protein-energy malnutrition, vitamin and mineral deficiencies.  Intervention approaches; international efforts and local sustainability.  www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition Counseling and Education Methods",
    "dept": "DIET",
    "num": "566",
    "desc": "Prereq: FS HN 361 and FS HN 362\nApplication of counseling and learning theories with individuals and groups in community and clinical settings. Includes discussion and experience in building rapport, assessment, diagnosis, intervention, monitoring, evaluation, and documentation. Literature review of specific counseling and learning theories.\n",
    "credits": "3"
  },
  {
    "course_name": "Entrepreneurship Theory and Practice",
    "dept": "DIET",
    "num": "568",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nDefinition and discussion of entrepreneurship and its importance to economic and business environment. www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Dietary and Herbal Supplements",
    "dept": "DIET",
    "num": "569",
    "desc": "Prereq: Enrollment in GP-IDEA MFCS in Dietetics\nDevelop skills to partner with patients in making dietary supplement decisions.  Explore the safe, efficacious use of botanicals and supplements in nutritional support of aging, maternal health and wellness.  Discussions on supplementation in the prevention and treatment of chronic disease include: arthritis, cancer, cardiovascular, diabetes, digestive, liver and renal disorders.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Human Performance",
    "dept": "DIET",
    "num": "570",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nDevelop an understanding of nutrition based on knowledge of the biochemical and physiological process and functions of specific nutrients in meeting nutritional requirements. Emphasis on the relationship of optimal nutrition and physical efficiency and performance. www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Leadership in Dietetics",
    "dept": "DIET",
    "num": "571",
    "desc": "\nUsing leadership theories to develop the fundamental concepts and skills to bridge the gap between theory and practice. Students will be able to successfully evaluate classic and contemporary leadership theories, investigate current leadership trends and identify positive applications in the dietetics community.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues and Trends",
    "dept": "DIET",
    "num": "572",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nOverview of current topics, issues, and trends in dietetics practice.  www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Healthcare Administration",
    "dept": "DIET",
    "num": "573",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nA comprehensive review of today's health care institutions and their response to the economics, social, ethical, political, legal, technological, and ecological environments. www only.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Immunology",
    "dept": "DIET",
    "num": "574",
    "desc": "\nPrinciples and issues related to nutrition and immunology. Impact of nutrients and nutritional status on immune responses. Impact of disease states on nutritional status.\n",
    "credits": "3"
  },
  {
    "course_name": "Grant Writing for the Professional",
    "dept": "DIET",
    "num": "595",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nGrant writing, identifying external funding, managing grants, preparing manuscripts for peer-reviewed publication, and preparing papers and poster for presentation at professional meetings.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutritional Aspects of Oncology",
    "dept": "DIET",
    "num": "597",
    "desc": "Prereq: B.S. in nutrition, dietetics, biology, or related discipline.\nUnderstanding of basic cancer biology and methodology used to study nutrition and cancer relationships. Using current research as a basis, the role of nutrition in specific cancers will be explored. Students will learn about sources of information for cancer prevention programs, and how to apply this information to clinical patient management.\n",
    "credits": "3"
  },
  {
    "course_name": "Clinical Aspects of Nutrition Support",
    "dept": "DIET",
    "num": "598",
    "desc": "Prereq: Enrollment in GPIDEA - Dietetics program\nSpecialized nutrition assessment and support. Review of energy expenditure and substrate utilization in specific disease states. Current Methods for the initiation and management of enteral and parenteral nutrition therapy including access, metabolic and mechanical complications. Evaluation of nutrition support methodology in selected disease states.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "DIET",
    "num": "599",
    "desc": "Prereq: Enrollment in GPIDEA MS Dietetics\nFor non-thesis option only.\n",
    "credits": "arr"
  },
  {
    "course_name": "Child Development – Ages Birth to 3",
    "dept": "E C P",
    "num": "201",
    "desc": "Prereq: HD FS 102\nDevelopment from birth to age three. Major theories and research on development will be covered including growth patterns, the influences of disabilities and risk factors, environmental factors and their effects on attachment styles, language acquisition, brain development, cognitive development, social-emotional development, and perceptual and sensory motor skills. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Child Development – Ages 4 to 8",
    "dept": "E C P",
    "num": "202",
    "desc": "Prereq: HD FS 102\nDevelopment from ages four through eight. Major theories and research on development will be covered including growth patterns, the influences of disabilities and risk factors, environmental factors and their effects on attachment styles, language acquisition, brain development, cognitive development, social-emotional development, and perceptual and sensory motor skills. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Early Care and Education for a Mobile Society",
    "dept": "E C P",
    "num": "305",
    "desc": "Prereq: HD FS 102\nExploring the role of a professional as a teacher, administrator or advocate in early childhood programming. Students will learn about professionalism and ethics, identifying child abuse, and applying universal precautions. Discussion of qualities of the early childhood educator role, program models, and working with children and professional colleagues. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Health, Safety, and Nutrition",
    "dept": "E C P",
    "num": "306",
    "desc": "Prereq: HD FS 102\nImportant elements for planning, promoting and maintaining healthy and safe learning/care environments, understanding childhood illnesses and establishing healthy lifestyles, first aid, and care providers maintaining their own health. Maintaining safe relationships with others, including identifying and reporting abuse, neglect, and exploitation of children. Exploration of nutrients for life and feeding, food preparation and safety policies and guidelines, food allergies and intolerances, appropriate feeding practices. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Child Guidance and Classroom Environments",
    "dept": "E C P",
    "num": "307",
    "desc": "Prereq: HD FS 102\nWorking knowledge of developmentally appropriate practice in child guidance.  This goal will be accomplished through review of current guidance methods and programs in order to familiarize students with successful guidance techniques.  By the end of this course, students will develop their own approach to guidance based upon practices best suited to their own unique skills and strengths. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum I – Child Observations in Classroom Environments",
    "dept": "E C P",
    "num": "320",
    "desc": "Prereq: E C P 201, E C P 202, E C P 305, E C P 306, E C P 307, HD FS 103\nPracticum in Early Childhood Education is an opportunity for ECP teacher candidates to have a guided learning experience in a professional agency that provides services to children and families. It is expected that learning experiences and projects at the practicum site will provide teacher candidates with the opportunity to utilize and implement theories and practices learned in other ECP classes. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Diversity in the Lives of Young Children and Families",
    "dept": "E C P",
    "num": "322",
    "desc": "Prereq: HD FS 102\nExploration of cultural diversity in daily life and beliefs in families with young children. The focus is on U.S. families, with attention to the multiple cultures from which they come. (on-line course offering via Distance Education).\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Working with Families",
    "dept": "E C P",
    "num": "323",
    "desc": "Prereq: HD FS 102\nApplication of an ecological model to the understanding of variation in parental roles, perspectives, relationships, approaches, and challenges. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Technology and Young Children",
    "dept": "E C P",
    "num": "324",
    "desc": "Prereq: HD FS 102\nImpact of electronic technology on the development of young children in educational, home, and community environments, and how technology can be used to enhance teaching and learning.  Students will be critical thinkers and informed consumers of technology related to young children. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Development of Curriculum for Children Ages Birth to 3",
    "dept": "E C P",
    "num": "412",
    "desc": "Prereq: E C P 201, E C P 202, E C P 305, E C P 306, E C P 307, E C P 320\nCurriculum development related to children from birth to age 3: (1) learn and utilize assessment and documentation to inform curriculum, (2) plan and evaluate developmentally appropriate activities, and (3) learn about effective ways to share curriculum information with families. All areas of developmental domains and content areas; issues related to diversity in family composition, culture, and individual abilities will also be addressed. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Development of Curriculum for Children Ages 4 to 8",
    "dept": "E C P",
    "num": "413",
    "desc": "Prereq: E C P 201, E C P 202, E C P 305, E C P 306, E C P 307, E C P 320\nDevelopment of curriculum for children ages 4 to 8 years: (1) learn and utilize assessment and documentation to inform curriculum, (2) plan and evaluate developmentally appropriate activities, and (3) learn about effective ways to share curriculum information with families. This course addresses all areas of developmental domains and content areas, and issues related to diversity in family composition, culture, and individual abilities will also be addressed. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Assessing Young Children and Their Environments to Enhance Development",
    "dept": "E C P",
    "num": "424",
    "desc": "Prereq: E C P 201, E C P 202, E C P 305, E C P 306, E C P 307, E C P 320\nStudents will learn to select, evaluate, and use appropriate assessment tools for children birth to age 8. Students will use assessment data to inform decisions about teaching (environments and practice) and intervention. There will be an emphasis on the ethical use of assessments, validity of assessments, multicultural sensitivity, and assessments for children with special needs. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Understanding and Adapting for Developmental Differences",
    "dept": "E C P",
    "num": "425",
    "desc": "Prereq: E C P 201, E C P 202, E C P 305, E C P 306, E C P 307, E C P 320\nKnowledge of disability conditions, assessment and identification, interventions in inclusive environments, and collaborations among family members and service providers. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum II – Curriculum Development and Implementation",
    "dept": "E C P",
    "num": "440",
    "desc": "Prereq: E C P 412, E C P 413, E C P 424, E C P 425\nPracticum in Early Childhood Education is an opportunity for ECE teacher candidates to have a guided learning experience in a professional agency that provides services to children and families. It is expected that learning experiences and projects at the practicum site will provide teacher candidates with the opportunity to utilize and implement theories and practices learned in other required classes. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Administration and Supervision in Early Childhood Settings",
    "dept": "E C P",
    "num": "442",
    "desc": "Prereq: HD FS 102\nExploration of issues surrounding the administration of early childhood programs including identification of community needs, analysis of business opportunities, the evaluation and appropriate use of space and quality programming, consideration of policy and legal responsibilities, and professionalism in the field. In addition, the course explores best practices in staff selection, training, coaching, and supervision. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum III – Capstone Experience",
    "dept": "E C P",
    "num": "460",
    "desc": "Prereq: E C P 322, E C P 323, E C P 324, E C P 440, E C P 442\nProfessional practicum as a 15 week experience designed to allow the student to demonstrate practical application of developmentally appropriate early childhood teaching techniques and skills, actual teaching experience and developmental feedback. Practicum students will be involved in observation and evaluation of classroom experiences, environmental design, classroom management, and parent communication. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Conceptual Foundations in Ecology and Evolutionary Biology",
    "dept": "EEB",
    "num": "511",
    "desc": "Prereq: Graduate classification\nIntroduction to key figures and ideas that have shaped the development of ecology and evolutionary biology. Covers major developments in ecology and evolutionary biology at five levels of biological organization: Genome, Organism, Population, Community, and Ecosystem. Impacts of these developments on current approaches to investigation and argument formulation. Effects of technological advances on the direction of scientific investigations. Introduction to analytical skills important for critical thinking in ecology and evolutionary biology and the impact of accepted lines of scientific reasoning on the objectives and conduct of research, such as explanation and prediction, design of studies as experimentation, and structured or unstructured observation.\n",
    "credits": "4"
  },
  {
    "course_name": "Extended Field Trip",
    "dept": "EEB",
    "num": "585",
    "desc": "Prereq: Graduate classification, permission of instructor\nExtended field trip to study major terrestrial and aquatic ecosystems. Location and duration vary. Report required.\n",
    "credits": "2"
  },
  {
    "course_name": "Extended Field Trip: Pre-Trip Lecture",
    "dept": "EEB",
    "num": "585A",
    "desc": "Prereq: Graduate classification, permission of instructor\nExtended field trip to study major terrestrial and aquatic ecosystems. Location and duration vary. Report required.\n",
    "credits": "1"
  },
  {
    "course_name": "Extended Field Trip: Travel",
    "dept": "EEB",
    "num": "585B",
    "desc": "Prereq: Graduate classification, EEB 585A and permission of instructor.\nExtended field trip to study major terrestrial and aquatic ecosystems. Location and duration vary. Report required.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "EEB",
    "num": "590",
    "desc": "Prereq: Graduate classification and permission of instructor\nFor students wishing to conduct in-depth study of a particular topic in ecology and evolutionary biology.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "EEB",
    "num": "698",
    "desc": "\nReports and discussion of recent research and literature.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "EEB",
    "num": "699",
    "desc": "\nThesis and dissertation research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Animal Behavior",
    "dept": "EEOB",
    "num": "507",
    "desc": "Prereq: Graduate standing, BIOL 354, or permission of instructor\nAnalysis of current research in animal behavior. Topics covered may include behavioral ecology, mechanisms of behavior, evolution of behavior, applications of animal behavior to conservation biology, and applications of animal behavior to wild animals in captivity.\n",
    "credits": "3"
  },
  {
    "course_name": "Life History and Reproductive Strategies",
    "dept": "EEOB",
    "num": "514",
    "desc": "Prereq: BIOL 315 or equivalent recommended.\nEvolution of ecological adaptations at the individual, population, and species level. Emphasis is on evolutionary mechanisms and adaptive strategies related to life histories and reproduction; age and size at maturity; lifespan and senescense; offspring size/number trade-offs; sex and mating systems; sex determination and sex ratios.\n",
    "credits": "3"
  },
  {
    "course_name": "Conservation Biology",
    "dept": "EEOB",
    "num": "531",
    "desc": "Prereq: BIOL 312; BIOL 313 or graduate standing\nExamination of conservation issues from a population and a community perspective. Population-level analysis will focus on the role of genetics, demography, and environment in determining population viability. Community perspectives will focus on topics such as habitat fragmentation, reserve design, biodiversity assessment, and restoration ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Conservation Biology",
    "dept": "EEOB",
    "num": "531I",
    "desc": "Prereq: IA LL 312I\nPopulation-and community-level examination of factors influencing the viability of plant and animal populations from both demographic and genetic perspectives; assessment of biodiversity; design and management of preserves.\n",
    "credits": "4"
  },
  {
    "course_name": "Endocrinology",
    "dept": "EEOB",
    "num": "534",
    "desc": "Prereq: BIOL 211, BIOL 212\nChemical integration of vertebrate organisms. The structure, development, and evolution of the endocrine glands and the function and structure of their hormones.\n",
    "credits": "3"
  },
  {
    "course_name": "Restoration Ecology",
    "dept": "EEOB",
    "num": "535",
    "desc": "Prereq: BIOL 366 or BIOL 474 or graduate standing\nTheory and practice of restoring animal and plant diversity, structure and function of disturbed ecosystems. Restored freshwater wetlands, forests, prairies and reintroduced species populations will be used as case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Restoration Ecology",
    "dept": "EEOB",
    "num": "535I",
    "desc": "Prereq: A course in ecology\nEcological principles for the restoration of native ecosystems; establishment (site preparation, selection of seed   mixes, planting techniques) and management (fire, mowing, weed control) of native vegetation; evaluation of restorations. Emphasis on the restoration of prairie and wetland vegetation.\n",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "EEOB",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "EEOB",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "EEOB",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "EEOB",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "EEOB",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "EEOB",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "EEOB",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "EEOB",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Plant Evolution and Phylogeny",
    "dept": "EEOB",
    "num": "551",
    "desc": "Prereq: BIOL 315 or equivalent.\nSurvey of land plant evolution; phylogenetic comparison of anatomical, reproductive, and life history specializations. Relationships among bryophytes, lycophytes, pteridophytes, gymnosperms, and angiosperms emphasizing significant evolutionary changes documented by paleobotanical, morphological, and molecular studies.\n",
    "credits": "4"
  },
  {
    "course_name": "Agrostology",
    "dept": "EEOB",
    "num": "553",
    "desc": "Prereq: BIOL 366 or equivalent.\nStructure, identification, classification, phylogeny, and economic aspects of grasses and related families.\n",
    "credits": "3"
  },
  {
    "course_name": "Bryophyte and Lichen Biodiversity",
    "dept": "EEOB",
    "num": "555",
    "desc": "Prereq: BIOL 211, BIOL 211L\nIntroduction to the biology and ecology of mosses, liverworts, and lichens. Emphasis on identification and diversity of local representatives of these three groups of organisms. Required field trips and service-learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Ornithology",
    "dept": "EEOB",
    "num": "558",
    "desc": "Prereq: A ECL 365 or BIOL 351\nDual-listed with BIOL 458. Biology, ecology, evolution, and taxonomy of birds. Emphasis on structure, physiology, behavior, communication, navigation, reproduction, and conservation.\n",
    "credits": "2"
  },
  {
    "course_name": "Mammalogy",
    "dept": "EEOB",
    "num": "559",
    "desc": "Prereq: BIOL 351 or A ECL 365\nBiology, ecology, and evolution of mammals.  Emphasis on structure, physiological adaptation to different environments, behavior, reproduction, roles of mammals in ecosystems, and conservation.\n",
    "credits": "2"
  },
  {
    "course_name": "Evolutionary and Ecological Genomics",
    "dept": "EEOB",
    "num": "561",
    "desc": "Prereq: Permission of instructor; BCBIO 444 recommended.\nUse of genomic and other \"omic\" data in evolution and ecology. Review of data-generation platforms, computational methods, and examples of how phylogenomics, metagenomics, epigenomics, and population genomics are transforming the disciplines of evolution and ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Evolutionary Genetics",
    "dept": "EEOB",
    "num": "562",
    "desc": "Prereq: Permission of instructor\nSeminar/discussion course covering the genetic basis of evolutionary processes in multicellular organisms.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Phylogenetics",
    "dept": "EEOB",
    "num": "563",
    "desc": "Prereq: BIOL 313 and BIOL 315\nAn overview of the theory underlying phylogenetic analysis and the application of phylogenetic methods to molecular datasets. The course emphasizes a hands-on approach to molecular phylogenetics and combines lecture presentations with computer exercises and discussion of original scientific literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Wetland Ecology",
    "dept": "EEOB",
    "num": "564",
    "desc": "Prereq: 15 credits in biological sciences.\nEcology, classification, creation and restoration, and management of wetlands.  Emphasis on North American temperate wetlands.\n",
    "credits": "3"
  },
  {
    "course_name": "Wetland Ecology",
    "dept": "EEOB",
    "num": "564I",
    "desc": "Prereq: IA LL 312I\nEcology, classification, creation, restoration, and management of wetlands. Field studies will examine the composition, structure and functions of local natural wetlands and restored prairie pothole wetlands. Individual or group projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Macroevolution",
    "dept": "EEOB",
    "num": "565",
    "desc": "Prereq: BIOL 315\nThe history and diversity of life on earth; evolutionary patterns and processes above the species level. Diversity from a phylogenetic perspective. Empirical exercises include: phylogeny estimation, ancestral states, estimating diversification rates, evaluating the tempo and mode of evolution, biogeographic patterns, and trait associations across the tree of life.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Evolution",
    "dept": "EEOB",
    "num": "566",
    "desc": "Prereq: Permission of instructor\nSeminar/discussion course covering the fundamentals of molecular evolution. Emphasis is placed on original scientific literature and current topics, including rates and patterns of genetic divergence; nucleotide and allelic diversity; molecular clocks; gene duplications; genome structure; organellar genomes; polyploidy; transposable elements; and modes and mechanisms of gene and genome evolution.\n",
    "credits": "3"
  },
  {
    "course_name": "Empirical Population Genetics",
    "dept": "EEOB",
    "num": "567",
    "desc": "Prereq: Permission of instructor\nAn overview of fundamental population genetic theory and the ecological and evolutionary factors underlying the distribution of genetic variation within and among natural populations. Emphasis on the analysis of inbreeding, breeding systems, parentage, relatedness, spatial autocorrelation, effective population size, hierarchial population models, and phylogeography.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Systematics",
    "dept": "EEOB",
    "num": "568",
    "desc": "Prereq: Permission of instructor\nPrinciples and practice of systematic biology; taxonomy, nomenclature and classification of plants and animals; sources and interpretation of systematic data; speciation; fundamentals of phylogenetic systematics.\n",
    "credits": "3"
  },
  {
    "course_name": "Biogeography",
    "dept": "EEOB",
    "num": "569",
    "desc": "Prereq: BIOL 315 or equivalent; permission of instructor\nPrinciples underlying the geographic distribution of organisms throughout the world; biological influences of geological history and tectonic movements; role of climate, migration, dispersal, habitat, and phylogeny on past and present organismal distribution patterns; biogeographic methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Techniques for Biology Teaching",
    "dept": "EEOB",
    "num": "573",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching : Animal Biology",
    "dept": "EEOB",
    "num": "573A",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Plant Biology",
    "dept": "EEOB",
    "num": "573B",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Fungi and Lichens",
    "dept": "EEOB",
    "num": "573C",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Aquatic Ecology",
    "dept": "EEOB",
    "num": "573D",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Prairie Ecology",
    "dept": "EEOB",
    "num": "573E",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Wetland Ecology",
    "dept": "EEOB",
    "num": "573F",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Limnology",
    "dept": "EEOB",
    "num": "573G",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Animal Behavior",
    "dept": "EEOB",
    "num": "573H",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Insect Ecology",
    "dept": "EEOB",
    "num": "573I",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Biology of Invertebrates",
    "dept": "EEOB",
    "num": "573J",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Non-invasive Use of Living Organisms",
    "dept": "EEOB",
    "num": "573K",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Project WET",
    "dept": "EEOB",
    "num": "573W",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Field Mycology",
    "dept": "EEOB",
    "num": "575I",
    "desc": "\nIdentification and classification of the common fungi; techniques for identification, preservation, and culture practiced with members of the various fungi groups.\n",
    "credits": "4"
  },
  {
    "course_name": "Functional Ecology",
    "dept": "EEOB",
    "num": "576",
    "desc": "Prereq: BIOL 312\nThe nature of adaptations to physical and biotic environments.  Biophysical, biomechanical, and physiological bases of the structure, form, growth, distribution, and abundance of organisms.\n",
    "credits": "3"
  },
  {
    "course_name": "Concepts in Theoretical Ecology and Evolution",
    "dept": "EEOB",
    "num": "577",
    "desc": "\nReadings and discussion of influential ideas in ecological and evolutionary theory, with an emphasis on how models are used as conceptual tools for building synthetic paradigms. Topics are chosen according to student interests; may include spatial ecology, behavioral theory, chaos, community assembly and biodiversity, and others.\n",
    "credits": "1"
  },
  {
    "course_name": "Ecology and Systematics of Diatoms",
    "dept": "EEOB",
    "num": "580I",
    "desc": "\nField and laboratory study of freshwater diatoms; techniques in collection, preparation, and identification of diatom samples; study of environmental factors affecting growth, distribution, taxonomic characters; project design and execution including construction of reference and voucher collections and data organization and analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "Environmental Systems I:  Introduction to Environmental Systems",
    "dept": "EEOB",
    "num": "581",
    "desc": "Prereq: 12 credits of natural science including biology and chemistry\nIntroduction to the structure and function of natural environmental systems. Emphasis on the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems II: Analysis of Environmental Systems",
    "dept": "EEOB",
    "num": "582",
    "desc": "Prereq: ENSCI 381\nContinuation of ENSCI 381. Systems approach to the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Science",
    "dept": "EEOB",
    "num": "584",
    "desc": "Prereq: Combined 12 credits in biology, chemistry, and physics.\nAdvanced studies of ecosystems and the biological and physical factors that influence their properties and dynamics. Conceptual foundations and modern approaches to  ecosystem studies. Interactions among organisms, biological diversity, and ecosystem attributes. Quantitative analyses of accumulations, transformations, and fluxes of nutrients, water, and energy within and among ecosystems.  Global change issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Community Ecology",
    "dept": "EEOB",
    "num": "585",
    "desc": "Prereq: BIOL 312\nFactors controlling species diversity, species abundance, and the structure and function of communities in space and time. Relationships between species diversity and ecosystem process rates and community stability.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "EEOB",
    "num": "586",
    "desc": "Prereq: BIOL 312 or ENSCI 381 or ENSCI 402 or NREM 301\nStructure and function of aquatic ecosystems with application to fishery and pollution problems. Emphasis on lacustrine, riverine, and wetland ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology Laboratory",
    "dept": "EEOB",
    "num": "586L",
    "desc": "Prereq: Concurrent enrollment in BIOL 486\nField trips and laboratory exercises to accompany 486. Hands-on experience with aquatic research and monitoring techniques and concepts.\n",
    "credits": "1"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "EEOB",
    "num": "587",
    "desc": "Prereq: Six credits in biology and 6 credits in chemistry\nIntroduction to major functional groups of autotrophic and heterotrophic microorganisms and their roles in natural and environmental systems. Consequences of microbial activity on water chemistry, weathering, and precipitation/dissolution reactions will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Population Ecology",
    "dept": "EEOB",
    "num": "589",
    "desc": "Prereq: BIOL 312, STAT 101 or STAT 104, a course in calculus, or graduate standing\nConcepts and theories of population dynamics with emphasis on models of growth, predation, competition, and regulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "EEOB",
    "num": "590",
    "desc": "Prereq: 10 credits in biology, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Current Topics in Ecology",
    "dept": "EEOB",
    "num": "590A",
    "desc": "Prereq: 10 credits in biology, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Current Topics in Evolutionary Biology",
    "dept": "EEOB",
    "num": "590B",
    "desc": "Prereq: 10 credits in biology, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Current Topics in Organismal Biology",
    "dept": "EEOB",
    "num": "590C",
    "desc": "Prereq: 10 credits in biology, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Graduate Independent Study",
    "dept": "EEOB",
    "num": "590I",
    "desc": "Prereq: Graduate classification and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Ecology and Society",
    "dept": "EEOB",
    "num": "596",
    "desc": "Prereq: Graduate classification in biological or environmental sciences/studies with at least one course in ecology\nAnalysis of conceptual and methodological debates in ecology. Historical development of competing research traditions and philosophies. Topics include i) methodological issues in ecological science, ii) conceptual issues in theoretical ecology, iii) conceptual issues in applied ecology, iv) relation of ecology to environmental and social issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "EEOB",
    "num": "599",
    "desc": "\nResearch toward nonthesis master's degree.\n",
    "credits": "arr"
  },
  {
    "course_name": "Analysis of Populations",
    "dept": "EEOB",
    "num": "611",
    "desc": "Prereq: BIOL 312; STAT 401; a course in calculus\nQuantitative techniques for analyzing vertebrate population data to estimate parameters such as density and survival. Emphasis on statistical inference and computing.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar",
    "dept": "EEOB",
    "num": "698",
    "desc": "\nMeetings of graduate students and faculty to discuss recent literature and problems under investigation.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "EEOB",
    "num": "699",
    "desc": "\nResearch for thesis or dissertation.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Iowa Lakeside Laboratory. (Cross-listed with Ia LL 699I)",
    "dept": "EEOB",
    "num": "699I",
    "desc": "\nResearch for thesis or dissertation.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Principles of Microeconomics",
    "dept": "ECON",
    "num": "101",
    "desc": "\nResource allocation, opportunity cost, comparative and absolute advantage. Supply and demand. Marginal analysis. Theories of production and consumption, pricing, and the market system. Perfect and imperfect competition and strategic behavior. Factor markets. Present discounted value.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Microeconomics: Honors",
    "dept": "ECON",
    "num": "101H",
    "desc": "Prereq: Honors program students only\nResource allocation, opportunity cost, comparative and absolute advantage. Supply and demand. Marginal analysis. Theories of production and consumption, pricing, and the market system. Perfect and imperfect competition and strategic behavior. Factor markets. Present discounted value.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Principles of Microeconomics",
    "dept": "ECON",
    "num": "101L",
    "desc": "Prereq: Concurrent enrollment in the appropriate section of ECON 101\nDiscussion of material typically covered in ECON 101. Application of economic principles to real world problems. Economic principles and basic business management concepts applied to decision-making in agribusiness operations.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles of Macroeconomics",
    "dept": "ECON",
    "num": "102",
    "desc": "Prereq: ECON 101 recommended\nMeasurement of macro variables and general macro identities. Classical models of full employment. Production and growth. Savings and investment. Employment and unemployment. Money, inflation, and price levels. Operation of the U.S. banking system. Fiscal and monetary policy. Elements of international finance.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Macroeconomics: Honors",
    "dept": "ECON",
    "num": "102H",
    "desc": "Prereq: ECON 101 recommended; admission to the Honors program.\nMeasurement of macro variables and general macro identities. Classical models of full employment. Production and growth. Savings and investment. Employment and unemployment. Money, inflation, and price levels. Operation of the U.S. banking system. Fiscal and monetary policy. Elements of international finance.\n",
    "credits": "3"
  },
  {
    "course_name": "Orientation in Agricultural Business",
    "dept": "ECON",
    "num": "110",
    "desc": "\nOrientation course for freshman and new transfer students in agricultural business.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Economic Optimization",
    "dept": "ECON",
    "num": "207",
    "desc": "Prereq: MATH 151, MATH 160, MATH 165 or equivalent\nApplication of linear algebra, calculus and unconstrained and constrained optimization techniques to economic problems. Learning outcomes include the ability to (i) identify the objective, decision variables and constraints in economic decision problems, (ii) represent elements of an economic problem in simple mathematical models, (iii) identify and apply mathematical tools that can be used to solve the problems, (iv) identify the strengths and limitations of the solution method, and (v) interpret the economic meaning and implications of the solution.\n",
    "credits": "3"
  },
  {
    "course_name": "Farm Business Management",
    "dept": "ECON",
    "num": "230",
    "desc": "Prereq: ECON 101; ACCT 284\nBusiness and economic principles applied to decision making and problem solving in the management of a farm business. Cash flow, partial, enterprise, and whole farm budgeting. Information systems for farm accounting, analysis, and control. Obtaining and managing land, capital, and labor resources. Alternatives for farm business organization and risk management.\n",
    "credits": "3"
  },
  {
    "course_name": "Small Business Management",
    "dept": "ECON",
    "num": "234",
    "desc": "Prereq: ECON 101\nAn introduction to small business management, entrepreneurship, and economics utilizing a series of case studies. Exploration of issues related to starting or acquiring a new business and development of knowledge and skills for successful management of a small business, with an emphasis on agricultural business.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Agricultural Markets",
    "dept": "ECON",
    "num": "235",
    "desc": "Prereq: ECON 101\nBasic concepts and economics principles related to markets for agricultural inputs and products. Overview of current marketing problems faced by farms and agribusinesses, farm and retail price behavior, structure of markets, food marketing channels, food quality and food safety, and the role of agriculture in the general economy. The implications of consumer preferences at the farm level. Introduction to hedging, futures, and other risk management tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Career Seminar",
    "dept": "ECON",
    "num": "292",
    "desc": "Prereq: Classification in economics or agricultural business\nCareer opportunities in the various industries and government institutions. Required training and skills needed to perform successfully in different types of careers. Factors important in finding and obtaining employment either before or after graduation including personal resumes, interviewing, and letter writing.\n  Only one of ECON 292, 292A, and 292B can be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Career Seminar: Agricultural Business",
    "dept": "ECON",
    "num": "292A",
    "desc": "Prereq: Classification in economics or agricultural business\nCareer opportunities in the various industries and government institutions. Required training and skills needed to perform successfully in different types of careers. Factors important in finding and obtaining employment either before or after graduation including personal resumes, interviewing, and letter writing.\n  Only one of ECON 292, 292A, and 292B can be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Career Seminar: Economics and Business Economics",
    "dept": "ECON",
    "num": "292B",
    "desc": "Prereq: Classification in economics or agricultural business\nCareer opportunities in the various industries and government institutions. Required training and skills needed to perform successfully in different types of careers. Factors important in finding and obtaining employment either before or after graduation including personal resumes, interviewing, and letter writing.\n  Only one of ECON 292, 292A, and 292B can be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Internship",
    "dept": "ECON",
    "num": "297",
    "desc": "Prereq: Permission of instructor and classification in agricultural business or economics\nStudents complete a research report, based on their internship or approved work experience, that examines chosen topics in management, marketing or finance.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "ECON",
    "num": "298",
    "desc": "Prereq: Permission of the department cooperative education coordinator; sophomore classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Intermediate Microeconomics",
    "dept": "ECON",
    "num": "301",
    "desc": "Prereq: ECON 101; ECON 207 or MATH 166\nTheory of consumer and business behavior; optimal consumption choices and demand; theory of firm behavior; costs, production, and supply; competitive and imperfectly competitive markets; theory of demand for and supply of factors of production; general equilibrium analysis. Recitation required for 4 credits.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Microeconomics: Honors",
    "dept": "ECON",
    "num": "301H",
    "desc": "Prereq: ECON 101; ECON 207 or MATH 166\nTheory of consumer and business behavior; optimal consumption choices and demand; theory of firm behavior; costs, production, and supply; competitive and imperfectly competitive markets; theory of demand for and supply of factors of production; general equilibrium analysis. Recitation required for 4 credits.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Macroeconomics",
    "dept": "ECON",
    "num": "302",
    "desc": "Prereq: ECON 101, ECON 102; MATH 160 or MATH 165\nTheory of income, employment, interest rates, and the price level; fiscal and monetary policy; budget and trade deficits; money and capital inflows, interest rates, and inflation.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Macroeconomics: Honors",
    "dept": "ECON",
    "num": "302H",
    "desc": "Prereq: ECON 101, ECON 102; MATH 160 or MATH 165\nTheory of income, employment, interest rates, and the price level; fiscal and monetary policy; budget and trade deficits; money and capital inflows, interest rates, and inflation.\n",
    "credits": "3"
  },
  {
    "course_name": "Economics of Sports",
    "dept": "ECON",
    "num": "313",
    "desc": "Prereq: ECON 101\nApplication of economics to issues in sports, including franchising; rival leagues and barriers to entry; cooperative, competitive, and collusive behavior; player productivity and compensation; contracts, unions, and discrimination; antitrust, taxation, and subsidies. Economic concepts include supply and demand, labor economics, pricing, public finance, production, game theory, and industrial organization.\n",
    "credits": "3"
  },
  {
    "course_name": "Labor Economics",
    "dept": "ECON",
    "num": "320",
    "desc": "Prereq: ECON 101\nEconomic analysis of contemporary domestic and international labor market issues including labor supply and demand, unemployment, and employment in the U.S. and elsewhere; investments in and returns to education, training, health, immigration and migration; income inequality; labor productivity; out-sourcing and global competitiveness; work incentives; compensation including benefits; and labor policies such as minimum wages, over-time pay, discrimination, unions, and immigration.  Examples drawn from the U.S. and other developed countries with reference to developing countries where relevant.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Economics of Discrimination",
    "dept": "ECON",
    "num": "321",
    "desc": "Prereq: ECON 101\nEconomic theories of discrimination. Analysis of the economic problems of women and minorities in such areas as earnings, occupations, and unemployment. Public policy concerning discrimination. Poverty measurement and antipoverty programs in the U.S.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Farm Business Management",
    "dept": "ECON",
    "num": "330",
    "desc": "Prereq: ECON 230\nEffective use of strategic planning, decision methods, and computer assistance for solving farm problems. Applications of economic and management theory to analyze farm business decisions using efficiency measures to assess current resource use and direct the farm business analysis, planning, and tax process.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperatives",
    "dept": "ECON",
    "num": "332",
    "desc": "Prereq: ECON 101\nSurvey of cooperative business structure, including historical developments in the United States, principles of cooperation, state and federal authorization for cooperative activity, economic motivations and foundations, governance, marketing and pricing strategies, and financing, capitalization and taxation considerations.  Students will learn how the cooperative model is applied in a variety of markets.\n",
    "credits": "3"
  },
  {
    "course_name": "Entrepreneurship in Agriculture",
    "dept": "ECON",
    "num": "334",
    "desc": "Prereq: ECON 101\nIntroduction to the process of entrepreneurship within the agricultural and food sectors.  Emphasis on opportunity recognition and assessment, resource acquisition and feasibility analysis for both private and social enterprises.  Students will develop a comprehensive feasibility study for a new business or non-profit organization.\n",
    "credits": "3"
  },
  {
    "course_name": "The Economics of Global Agricultural Food and Bio-energy",
    "dept": "ECON",
    "num": "335",
    "desc": "Prereq: ECON 101\nApplied economic analysis of the determinants of world agricultural production, marketing, and use in feed, food, fiber, biofuel, and other applications, and global food processing and consumption.  Analysis of market case studies and various data on global agricultural production and transformation, land and resource use, demography, economic activity, nutrition and health trends.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Selling",
    "dept": "ECON",
    "num": "336",
    "desc": "Prereq: ECON 101\nPrinciples of selling with application to agricultural and food related businesses. Attitudes, value systems, and behavioral patterns that relate to agricultural sales. Electronic marketing, selling strategies, preparing for sales calls, making sales presentations, handling objections, and closing sales. Analysis of the buying or purchasing process. Evaluation of agri-selling as a possible career choice.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Marketing",
    "dept": "ECON",
    "num": "337",
    "desc": "Prereq: ECON 101 required, ECON 235 recommended\nUnderstanding of agricultural commodity markets for grain, livestock and dairy with emphasis on marketing decisions and risk management for farmers and processors. Hands-on applications of marketing and management tools via market simulations.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Finance",
    "dept": "ECON",
    "num": "344",
    "desc": "Prereq: ECON 101\nThe economic role of governments in market economies. Public goods, externalities, income distribution, and income maintenance programs. The effect of taxes on economic behavior, descriptions of the structure of the principal U.S. taxes, and current reform proposals.\n",
    "credits": "3"
  },
  {
    "course_name": "Money, Banking, and Financial Institutions",
    "dept": "ECON",
    "num": "353",
    "desc": "Prereq: ECON 101, ECON 102\nTheoretical and applied analysis of money, banking, and financial markets; interest rates and portfolio choice; the banking industry in transition; the money supply process; the Federal Reserve System and the conduct of monetary policy; macro implications of monetary policy; international finance.\n",
    "credits": "3"
  },
  {
    "course_name": "International Trade and Finance",
    "dept": "ECON",
    "num": "355",
    "desc": "Prereq: ECON 101, ECON 102\nExplanations of causes of international trade and the impact of trade on welfare and employment patterns. Analysis of government policies towards trade, such as tariffs, quotas, and free trade areas. Theory of balance of payments and exchange rate determination, and the role of government policies. Examination of alternative international monetary arrangements.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Ethics in Agriculture",
    "dept": "ECON",
    "num": "362",
    "desc": "Prereq: ECON 101 or SOC 134, junior or senior status in the College of Agriculture\nIdentify major ethical issues and dilemmas in the conduct of agricultural and agribusiness management and decision making. Discuss and debate proper ethical behavior in these issues and situations and the relationship between business and personal ethical behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Rural Property Appraisal",
    "dept": "ECON",
    "num": "364",
    "desc": "Prereq: ECON 101\nUse of income capitalization, sales comparison and cost appraisal concepts in appraising agricultural resources. Application of underlying economic/business/management principles, especially present value, as they relate to farmland appraisal. Determination and estimation of economic impacts of special consideration and property use factors. Evaluate feasibility and profitability of investment in rural property.\n",
    "credits": "3"
  },
  {
    "course_name": "Introductory Econometrics",
    "dept": "ECON",
    "num": "371",
    "desc": "Prereq: ECON 301, ECON 302 OR ECON 353, STAT 326\nIntroduction to the models and methods used to estimate relationships and test hypotheses pertaining to economic variables. Among the topics covered in the course are: Single and multiple regression analysis; functional forms; omitted variable analysis; multicollinearity; heteroskedasticity; autocorrelation; simultaneous equations; and dynamic models.\n",
    "credits": "4"
  },
  {
    "course_name": "Rural, Urban and Regional Economics",
    "dept": "ECON",
    "num": "376",
    "desc": "Prereq: ECON 101\nFirm location with respect to regional resources, transport, scale economies, externalities, and policies. Measures of local comparative advantage and specialization. Spatial markets. Population location considering jobs, wages, commuting, and local amenities. Business, residential, and farm land use and value. Migration. Other topics may include market failure, regulation, the product cycle, theories of rural and urban development, developmental policy, firm recruiting, local public goods and public finance, schools, poverty, segregation, and crime.\n",
    "credits": "3"
  },
  {
    "course_name": "Retirement Planning and Employee Benefits",
    "dept": "ECON",
    "num": "378",
    "desc": "Prereq: 3 credits in introductory economics\nEconomic well-being in the context of demographic change, the present and future of Social Security, family retirement needs analysis, investment strategies and characteristics of retirement plans, helping others to work towards financial security, family economic issues for retired persons. Overview of employee and retirement benefits.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Energy, Environmental and Resource Economics",
    "dept": "ECON",
    "num": "380",
    "desc": "Prereq: ECON 101\nNatural resource availability, use, conservation, and government policy, with emphasis on energy issues. Environmental quality and pollution control policies.\n",
    "credits": "3"
  },
  {
    "course_name": "Economic Development",
    "dept": "ECON",
    "num": "385",
    "desc": "Prereq: ECON 101, ECON 102\nCurrent problems of developing countries, theories of economic development, agriculture, and economic development, measurement and prediction of economic performance of developing countries, alternative policies and reforms required for satisfying basic needs of Third World countries, interrelationships between industrialized countries and the developing countries, including foreign aid.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Economies of China and India",
    "dept": "ECON",
    "num": "387",
    "desc": "Prereq: ECON 101\nThe economic development of China and India within the larger historical, political, and socioeconomic contexts. The characteristics of the development paths of major industries. The drivers of and impediments for future economic development. The two economies' connections with the world economy.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "ECON",
    "num": "398",
    "desc": "Prereq: Permission of the department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Topics in Microeconomics",
    "dept": "ECON",
    "num": "401",
    "desc": "Prereq: ECON 301, STAT 226\nAdvanced treatment of selected topics from one or more of the following areas: household production models, factor markets, game theory and imperfect competition, general equilibrium, intertemporal choice, asset markets, income distribution, externalities and public goods, etc.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Macroeconomics",
    "dept": "ECON",
    "num": "402",
    "desc": "Prereq: ECON 301, ECON 302, STAT 226\nAdvanced treatment of selected topics from one or more of the following areas: business cycle theory, growth theory, fiscal and monetary policy, coordination issues, open economy macroeconomics, and financial economics.\n",
    "credits": "3"
  },
  {
    "course_name": "Industrial Organization",
    "dept": "ECON",
    "num": "416",
    "desc": "Prereq: ECON 301\nStudy of the structure of firms and markets and of their interaction, with emphasis on imperfectly competitive markets. Behavior of firms in strategic settings and insights of basic game-theoretic models. Welfare implications of alternative market organizations, consequences of market power, and scope for government regulation and antitrust/competition policies. Topics include monopoly and price discrimination, oligopoly models, product quality, product differentiation, vertical integration, information and advertising, patents, R&D and innovation, and regulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Game Theory",
    "dept": "ECON",
    "num": "418",
    "desc": "Prereq: ECON 301\nSystematic introduction to game theory and its uses in economics. Develops the basic framework, models and tools necessary to analyze games of strategy, including: Strategic and extensive-form representations of games; best response functions and Nash equilibrium, mixed strategies backward induction and subgame-perfect equilibrium, imperfect and incomplete information, Bayesian and sequential equilibria. Examples and applications taken from economics, business, political science, law and biology.\n",
    "credits": "3"
  },
  {
    "course_name": "Managerial Economics",
    "dept": "ECON",
    "num": "431",
    "desc": "Prereq: ECON 301\nTheory of the firm; organizational incentives and efficiency; moral hazard; role of information and decision making under uncertainty; ownership and control; business investment.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis of Food Markets",
    "dept": "ECON",
    "num": "435",
    "desc": "Prereq: STAT 226, ECON 235, ECON 301.\nFood market analysis from an economics perspective; food markets and consumption; methods of economic analysis; food industry structure and organization; food and agriculture regulations; labeling; consumer concerns; agricultural commodity promotion. Final project required.\n",
    "credits": "3"
  },
  {
    "course_name": "Commodity Marketing and Risk Management",
    "dept": "ECON",
    "num": "437",
    "desc": "Prereq: ECON 235, ECON 301, STAT 326\nThe purpose and performance of commodity markets. How commodity marketing institutions function. Merchandising arrangements. Distinguishing features of agricultural commodities. Hedging, arbitrage, and speculation in commodity spot, forward, futures, and options markets. Valuation theory.\n",
    "credits": "3"
  },
  {
    "course_name": "International Trade",
    "dept": "ECON",
    "num": "455",
    "desc": "Prereq: ECON 301\nRigorous treatment of theories of international trade and international factor movements.  Examination of the impact of trade and labor migration on domestic and world welfare and on the distribution of income.  Theoretical analysis of government policies towards trade and factor movements, including quotas, tariffs, free trade areas and immigration restrictions.  Discussion of contemporary issues and controversies concerning globalization, including multinational firms and labor migration.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "International Finance",
    "dept": "ECON",
    "num": "457",
    "desc": "Prereq: ECON 302\nNational income accounting and balance of payments; foreign exchange rates and exchange rate markets; money, interest rates, and exchange rate determination; prices, exchange rates, and output in the short run; international monetary arrangements; fixed versus flexible exchange rates; optimal currency areas; international capital flows; currency and financial crises in emerging markets.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Economic Systems for Electric Power Planning",
    "dept": "ECON",
    "num": "458",
    "desc": "Prereq: E E 303 or ECON 301\nEvolution of electric power industry. Power system operation and planning and related information systems. Linear and integer optimization methods.  Short-term electricity markets and locational marginal prices. Risk management and financial derivatives. Basics of public good economics. Cost recovery models including tax treatment for transmission investments.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural, Food, and Trade Policy",
    "dept": "ECON",
    "num": "460",
    "desc": "Prereq: ECON 301 or ECON 501\nDescription and analysis of economic problems of U.S. agriculture. Explanation and economic analysis of government policies and programs to develop agriculture, conserve agricultural resources, address consumer food concerns, stabilize farm prices, and raise farm incomes. The influence of macropolicy, world economy, international trade, and bioenergy on U.S. agriculture.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Finance",
    "dept": "ECON",
    "num": "466",
    "desc": "Prereq: ECON 301, STAT 226, FIN 301 and ECON 353 (recommended)\nFinancial analysis of agricultural businesses; liquidity, capital structure, and growth and risk of agricultural firms; capital budgeting methods; analysis of land investments, leasing, and costs of credit; financial intermediation and major financial institutions for agriculture; borrower-lender relationships, and asset-liability management techniques by financial intermediaries; public policies affecting agricultural credit markets.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Environmental and Resource Economics",
    "dept": "ECON",
    "num": "480",
    "desc": "Prereq: ECON 301 or ECON 501\nTheories of natural resource utilization and allocation. Externalities, public goods, and environmental quality. Renewable energy, biofuels, land use change and life cycle analysis of carbon, and sustainability and resource conservation. Methodologies for analyzing natural resource and environmental problems and evaluating resource policies.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ECON",
    "num": "490",
    "desc": "Prereq: Junior or senior classification, 14 credits in economics\n  Offered on a satisfactory-fail basis only.  No more than 9 credits of Econ 490 may be used toward graduation",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "ECON",
    "num": "490E",
    "desc": "Prereq: Junior or senior classification, 14 credits in economics\n  Offered on a satisfactory-fail basis only.  No more than 9 credits of Econ 490 may be used toward graduation",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "ECON",
    "num": "490H",
    "desc": "Prereq: Junior or senior classification, 14 credits in economics\n  Offered on a satisfactory-fail basis only.  No more than 9 credits of Econ 490 may be used toward graduation",
    "credits": "1"
  },
  {
    "course_name": "Graduating Senior Survey",
    "dept": "ECON",
    "num": "492",
    "desc": "Prereq: Graduating senior\nFinal preparations for graduation. The final stages of job searching, interviewing, letter writing, and resume preparation. Outcomes assessment information from graduating seniors including opinion surveys, instructor/advisor/course evaluations, exit interviews, student accomplishment surveys, job placement surveys, and comprehensive skills examinations. Departmental recognition of graduating seniors. Life as an alumnus - expectations and obligations. Convocation and commencement information.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Economics Domestic Travel Course",
    "dept": "ECON",
    "num": "495",
    "desc": "Prereq: Sophomore status. Permission of instructor\nTour and study of domestic businesses, markets, and economic institutions located outside Iowa to expose students to the diversity of activities within the U.S. economy. Pre-trip sessions arranged. Locations and duration of tours will vary.\n",
    "credits": "1"
  },
  {
    "course_name": "Economics International Travel Course",
    "dept": "ECON",
    "num": "496",
    "desc": "Prereq: Sophomore status; permission of instructor.\nTour and study of international agricultural and/or nonagricultural economies, markets, and institutions. Locations and duration of tours will vary. Limited enrollment.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "ECON",
    "num": "498",
    "desc": "Prereq: Permission of the department cooperative education coordinator; senior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Quantitative Methods in Economic Analysis I",
    "dept": "ECON",
    "num": "500",
    "desc": "Prereq: ECON 301, 1 year of calculus, STAT 401, and permission of Director of Graduate Education\nEconomic applications of selected mathematical and statistical concepts: linear models and matrix algebra; differential calculus and optimization; integral calculus and economic dynamics; probability distributions, estimation, and hypothesis testing in the analysis of economic data.\n",
    "credits": "4"
  },
  {
    "course_name": "Microeconomics",
    "dept": "ECON",
    "num": "501",
    "desc": "Prereq: ECON 301, credit or enrollment in ECON 500 or equivalent background in calculus and statistics\nThe theory of the consumer, theory of the firm, perfect and imperfect competition, welfare economics, and selected topics in general equilibrium and uncertainty.\n",
    "credits": "4"
  },
  {
    "course_name": "Macroeconomics",
    "dept": "ECON",
    "num": "502",
    "desc": "Prereq: ECON 302, credit or enrollment in ECON 500 or equivalent background in calculus and statistics\nModels of aggregate supply and demand, theories of consumption and investment, money supply and demand, inflation, rational expectations, stabilization policy, financial markets, and international finance.\n",
    "credits": "4"
  },
  {
    "course_name": "Applied Numerical Methods in Economics",
    "dept": "ECON",
    "num": "509",
    "desc": "Prereq: ECON 500, ECON 501; or ECON 600, ECON 601\nUse of numerical techniques to solve economic problems. Numerical differentiation and integration numeric solutions of systems of equations, static and dynamic optimization problems including unconstrained optimization, maximum likelihood methods, general nonlinear programming methods, dynamic programming and optimal control, numerical methods for solving functional equations.\n",
    "credits": "3"
  },
  {
    "course_name": "Experimental Economics",
    "dept": "ECON",
    "num": "510",
    "desc": "Prereq: ECON 501 or ECON 601\nIntroduction to experimental economics and major subject areas addressed by laboratory and field experiments. Exploration of experimental methods by concentrating on series of experiments. Applications include individual decision-making, behavioral game theory, markets, behavioral labor, public and development economics, social network, and neuroeconomics. Research project.\n",
    "credits": "3"
  },
  {
    "course_name": "Labor Supply and Human Capital Formation",
    "dept": "ECON",
    "num": "520",
    "desc": "Prereq: ECON 501 or ECON 601\nLabor supply decisions and empirical analysis for agricultural operators and other self-employed and wage-earning households; multiple job holding; resource allocation in productive households; human capital formation by households, firms, and public institutions, which includes schooling, on-the-job training, migration, health, research, raising of children, and implications for household income and welfare; applications to problems in rural areas of developing and developed countries.\n",
    "credits": "3"
  },
  {
    "course_name": "Labor Markets",
    "dept": "ECON",
    "num": "521",
    "desc": "Prereq: ECON 501 or ECON 601\nAnalysis of labor demand and market determination of wages and employment; analysis of distortions in labor markets due to non-competitive forces, legislation, and discrimination; wage inequality, compensation and work incentives; compensating differentials; microeconomic analysis of unemployment and job search.\n",
    "credits": "3"
  },
  {
    "course_name": "Managerial Economics for the Global Organization",
    "dept": "ECON",
    "num": "532",
    "desc": "Prereq: ECON 101 and enrollment in MBA or BAS program; not for economics majors\nApplications of microeconomic theory and decision analysis for firms operating in U.S. and internationally. Topics include demand & supply, consumer choice theory, production and cost theory, short run and long run business decisions, input cost and human capital differences across countries, empirical estimation of demand and supply, pricing, exchange rates, government and business, market structures and strategy.\n",
    "credits": "3"
  },
  {
    "course_name": "Commodity Markets: Analysis and Strategy",
    "dept": "ECON",
    "num": "537",
    "desc": "Prereq: ECON 501 or ECON 532 or ECON 601, ECON 571 or STAT 326\nAnalysis of exchange-traded and over-the-counter commodity markets, their functions and performance. Evaluation of hedging, speculation, and arbitrage strategies. Commodity transformation over space and time. Valuation of derivatives and comparison with derivatives on financial assets. Efficiency and the role of information in commodity markets. Market regulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Economics",
    "dept": "ECON",
    "num": "545",
    "desc": "Prereq: ECON 501 or ECON 601\nEconomic justifications for government activities; illustrative theoretical and empirical analyses of expenditure programs; foundations of excess burden, incidence analysis, and optimal taxation; effects of taxation on labor supply; public goods and externalities; social insurance; introduction to economics of the health sector with an emphasis on the role of market failures.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural, Food, and Trade Policy",
    "dept": "ECON",
    "num": "560",
    "desc": "Prereq: ECON 301 or ECON 501\nDescription and analysis of economic problems of U.S. agriculture. Explanation and economic analysis of government policies and programs to develop agriculture, conserve agricultural resources, address consumer food concerns, stabilize farm prices, and raise farm incomes. The influence of macropolicy, world economy, international trade, and bioenergy on U.S. agriculture.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Econometrics",
    "dept": "ECON",
    "num": "571",
    "desc": "Prereq: ECON 500\nSingle and multiple equation regression models; dummy explanatory variables; serial correlation; heteroskedasticity; distributed lags; qualitative dependent variables; simultaneity. Use of econometric models for tests of economic theories and forecasting.\n",
    "credits": "3"
  },
  {
    "course_name": "Spatial Economics",
    "dept": "ECON",
    "num": "576",
    "desc": "Prereq: ECON 501 or ECON 601\nAnalysis of location choice by firms, employees, and households emphasizing the role of spatial variations in agglomeration economies, economies of scale, distance, transport, endowments, amenities, and local government. Models of land use, urban form, spatial competition, central place theory, and migration. Techniques of discrete choice analysis, statistical analysis of categorical data, urban system modeling, and interregional computable general equilibrium.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Environmental and Resource Economics",
    "dept": "ECON",
    "num": "580",
    "desc": "Prereq: ECON 301 or ECON 501\nTheories of natural resource utilization and allocation. Externalities, public goods, and environmental quality. Renewable energy, biofuels, land use change and life cycle analysis of carbon, and sustainability and resource conservation. Methodologies for analyzing natural resource and environmental problems and evaluating resource policies.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Environmental Economics",
    "dept": "ECON",
    "num": "581",
    "desc": "Prereq: ECON 501 or ECON 601\nInterrelationships of natural resource use and the environment. Applied welfare and benefit-cost analyses. Externalities and pollution abatement. Nonmarket valuation of resources. Property rights. Legal and social constraints. Policy approaches.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "ECON",
    "num": "590",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "ECON",
    "num": "599",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Microeconomic Analysis I",
    "dept": "ECON",
    "num": "601",
    "desc": "Prereq: ECON 301, previous or concurrent enrollment in 600 and permission of Director of Graduate Education\nEconomic theory and methodology; theory of consumer behavior, theory of the competitive firm, supply and factor demand; duality relations in consumer and producer theory, welfare change measures; partial equilibrium analysis, perfect competition, monopoly; choice under uncertainty, the expected utility model, risk aversion; insurance, portfolio and production decisions under risk.\n",
    "credits": "4"
  },
  {
    "course_name": "Macroeconomic Analysis",
    "dept": "ECON",
    "num": "602",
    "desc": "Prereq: ECON 301, ECON 302, previous or concurrent enrollment in 600 and permission of Director of Graduate Education\nNeoclassical aggregate growth models; the overlapping generations model; endogenous growth models; equilibrium business cycle theories; equilibrium job search and matching; models of money; fiscal and monetary policy; income and wealth distribution.\n",
    "credits": "4"
  },
  {
    "course_name": "Microeconomic Analysis II",
    "dept": "ECON",
    "num": "603",
    "desc": "Prereq: ECON 601, ECON 602 and permission of Director of Graduate Education\nGeneral equilibrium analysis, efficiency, and welfare; market failures, externalities, and the theory of the second best; introduction to game theory; adverse selection, signaling, screening and moral hazard.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Macroeconomic Analysis",
    "dept": "ECON",
    "num": "604",
    "desc": "Prereq: ECON 601, ECON 602 and permission of Director of Graduate Education\nTopics will be selected from: new Keynesian approaches to business cycle theory; endogenously generated business cycles; models of credit and financial intermediation; mechanism design and time inconsistency issues; political economy models; heterogeneous-agent models with strategic interaction; path dependence, network effects, and lock-in; economies as evolving self-organizing systems.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Topics in Macroeconomics",
    "dept": "ECON",
    "num": "606",
    "desc": "Prereq: ECON 603, and credit or current enrollment in ECON 604\nSelected topics in macroeconomic theory of current significance to the profession.\n",
    "credits": "3"
  },
  {
    "course_name": "Theoretical Industrial Organization",
    "dept": "ECON",
    "num": "615",
    "desc": "Prereq: ECON 603\nTheoretical analysis of traditional topics in industrial organization. Review of game theory. Monopoly and oligopoly theory, price discrimination, product differentiation, research and development, diffusion of innovation, network externalities, and asymmetric information.\n",
    "credits": "3"
  },
  {
    "course_name": "Game Theory",
    "dept": "ECON",
    "num": "618",
    "desc": "Prereq: ECON 603, or ECON 501 and permission of instructor\nTheoretical analysis and applications of strategic games, extensive form games, and cooperative games. Nash equilibrium, correlated equilibrium, Bayesian games, subgame perfect equilibrium, the core, evolutionary equilibrium, repeated games with finite automata, and common knowledge.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Economics I",
    "dept": "ECON",
    "num": "641",
    "desc": "Prereq: ECON 603\nDemand and supply for agricultural products, market equilibrium models, implications of government policies on the agricultural sector, evaluation of research and development policies in agriculture, and biofuel and energy policy analysis. Commodity promotion programs, food safety and consumers’ valuation of product attributes.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Economics II",
    "dept": "ECON",
    "num": "642",
    "desc": "Prereq: ECON 603\nAdvanced treatment of topics and models in agricultural economics with emphasis on stochastic models. Topics will include analysis of risk in decision making by consumers, firms and farms; analysis of risk management strategies for farmers; the economics of commodity storage; analysis of the impact of biofuels on commodity prices; and models of agricultural inputs and outputs.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Economics",
    "dept": "ECON",
    "num": "653",
    "desc": "Prereq: ECON 603, ECON 672. Recommended: ECON 674, STAT 551\nReview of decision-making under uncertainty. Portfolio Theory. Theoretical foundations of asset valuation models: capital asset pricing model (CAPM), arbitrage pricing theory (APT), representative agent models, pricing of derivative securities. Complete and incomplete asset markets, credit markets, financial intermediaries, the role of government in the financial sector. Market frictions, crashes, bubbles. Applications of asset valuation models, with emphasis on their testable implications.\n",
    "credits": "3"
  },
  {
    "course_name": "International Trade",
    "dept": "ECON",
    "num": "655",
    "desc": "Prereq: ECON 603\nTheories of international trade; welfare and distributional aspects of trade and commercial policies. Optimal trade policies in the presence of domestic distortions; strategic trade policy; international trade and economic growth.\n",
    "credits": "3"
  },
  {
    "course_name": "International Finance",
    "dept": "ECON",
    "num": "657",
    "desc": "Prereq: ECON 602\nThe intertemporal approach to current account determination; non-traded goods and the real exchange rate; fiscal policy in the open economy; monetary approach to balance of payments and exchange rate determination; sticky price models of the open economy; exchange-rate based stabilizations; capital inflows; financial and balance of payments crises; international business cycles.\n",
    "credits": "3"
  },
  {
    "course_name": "Econometrics I",
    "dept": "ECON",
    "num": "671",
    "desc": "Prereq: ECON 501 and STAT 447 or STAT 542\nProbability and distribution theory for univariate and multivariate normal random variables, introduction to the theory of estimators for linear models, hypothesis testing and inference, introduction to large sample properties of estimators; derivation of common estimators and their properties for the classical and general multiple regression models, hypothesis testing, forecasting, implications of specification errors - missing data, left-out regressors, measurement error, stochastic regressors.\n",
    "credits": "4"
  },
  {
    "course_name": "Econometrics II",
    "dept": "ECON",
    "num": "672",
    "desc": "Prereq: ECON 671\nIdentification, estimation, and evaluation of systems of simultaneous equations; qualitative choice and limited dependent variable models; introduction to time series methods and applications, including alternative variance specifications.\n",
    "credits": "4"
  },
  {
    "course_name": "Microeconometrics",
    "dept": "ECON",
    "num": "673",
    "desc": "Prereq: ECON 672, ECON 601\nEconometric treatment of models arising in microeconometric applications. Methods are primarily concerned with the analysis of cross-section data. Topics may include: systems of demand equations in panel data settings, random utility models of discrete choices, production possibilities frontier estimation, and discrete/continuous models of participation and consumption.\n",
    "credits": "3"
  },
  {
    "course_name": "Macroeconometrics",
    "dept": "ECON",
    "num": "674",
    "desc": "Prereq: ECON 672, ECON 602\nTime-series econometric techniques and their application to macroeconomics and financial markets. Techniques may include GARCH and ARCH-M models, unit-root tests, nonlinear adjustment models, structural VARs, and cointegration tests.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Resource Economics",
    "dept": "ECON",
    "num": "680",
    "desc": "Prereq: ECON 603\nDynamic allocation of scarce, exhaustible, and renewable natural resources, including minerals and energy, soil, water, forests, and fish. Social versus private decisions. Market and nonmarket considerations. Technological change. Regulation. Dynamics and uncertainty.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "ECON",
    "num": "690",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Third-Year Paper",
    "dept": "ECON",
    "num": "691",
    "desc": "\nUnder the direction of the major professor, Ph.D. students write a formal research paper as an introduction to the dissertation research process.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Workshops",
    "dept": "ECON",
    "num": "693",
    "desc": "\nWorkshop in economics.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Research Workshop",
    "dept": "ECON",
    "num": "694A",
    "desc": "Prereq: Third year status in the Economics Ph.D. program or permission of instructor.\nInstruction in basic and applied research methods commonly used in economics. Survey methodologies, critique written work, summarize and evaluate data, prepare and present work orally, and develop an original research paper. Satisfactory-fail only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Research Workshop",
    "dept": "ECON",
    "num": "694B",
    "desc": "Prereq: ECON 694A\nWriting and communicating economic research. Continuation of ECON 694A, resulting in completion of an original research paper. Satisfactory-fail only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Research for Thesis or Dissertation",
    "dept": "ECON",
    "num": "699",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Principles of Inclusive Educational Leadership",
    "dept": "EDADM",
    "num": "541",
    "desc": "Prereq: Teacher licensure and permission of instructor\nBasic principles of educational organizations, including an understanding of organizational behavior and theoretical approaches to administration. Exploration of substantive elements related to school reform, such as the change process, current issues in education, and developing a shared vision and mission around inclusive leadership.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervision for Learning Environments",
    "dept": "EDADM",
    "num": "551",
    "desc": "Prereq: EDADM 541\nStudy of effective classroom instructional practices that reflect current principles of learning. Understanding and   practice of supervisory techniques that support teachers in improving the teaching and learning process,   including skills in observational data collection, data analysis, collaboration, and conferencing skills.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Issues in Principal Leadership",
    "dept": "EDADM",
    "num": "552",
    "desc": "Prereq: EDADM 541\nDevelops an equity-centered principal and building-level leadership understanding of school/work and community context. Emphasis placed on understanding essential tasks of building-level leadership and management; connecting management and operational decisions to mission and vision; building expertise in instructional leadership to improve teacher practice and student learning; leveraging school culture/atmosphere to provide opportunities and success for all students and their learning needs; advocacy for resources; and, examining the role of principals in a changing world.\n",
    "credits": "3"
  },
  {
    "course_name": "Leading School Reform",
    "dept": "EDADM",
    "num": "554",
    "desc": "Prereq: EDADM 541\nStudy of principles of transformational leadership and collaborative decision-making skills. Leadership activities that facilitate the development of a school culture that embraces change and school reforms that result in high quality schools dedicated to improved student achievement.\n",
    "credits": "3"
  },
  {
    "course_name": "Leading for Equitable Learning in School Systems",
    "dept": "EDADM",
    "num": "556",
    "desc": "Prereq: EDADM 541\nThis course builds on Ed Admin 541, Principles of Educational Leadership, to explore more fully how a leader can establish a vision for equitable and excellent learning. It provides historical, practical and theoretical perspectives on the culture and systems of schools, particularly in an age of accountability.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Resource Development for Learning",
    "dept": "EDADM",
    "num": "557",
    "desc": "Prereq: EDADM 541\nLeadership theory and practice that focuses on the professional development of school staff to promote improved student learning. Principles of school personnel evaluation; legal issues related to hiring, retention, and dismissal; evaluation models for professional and classified staff; and effective professional development models to support lifelong learning and reflective practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Diverse Learning Needs",
    "dept": "EDADM",
    "num": "558",
    "desc": "Prereq: EDADM 541\nThis course is designed to address practical and ethical dimensions of school leadership, especially related to disability status, race, gender, language status, and other minoritized statuses. Specific focus will be on the various ecological contexts of the school, the community, and the family as means of making effective use of multiple resources to enrich education.\n",
    "credits": "3"
  },
  {
    "course_name": "Curriculum Leadership",
    "dept": "EDADM",
    "num": "559",
    "desc": "Prereq: EDADM 541\nAnalysis of PK-12 school curricula (hidden, explicit, and null), including current and historical curriculum and instructional issues; design, development, and evaluation of instructional materials. Promoting a vision of learning and instructional program conducive to student learning and staff professional growth. Examining the role curricula play in maintaining and advancing bodies of thought, norms, and historic attitudes. Draws on critical curriculum leadership theories to promote socially just curriculum leadership.\n",
    "credits": "3"
  },
  {
    "course_name": "Education Law and Ethics",
    "dept": "EDADM",
    "num": "575",
    "desc": "Prereq: EDADM 541\nExamination of constitutional, statutory, and judicial provisions as a basis for the legal operation of educational institutions. Rights and ethical responsibilities of school leaders are examined in relation to their roles and responsibilities with boards, other school personnel, and students.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "EDADM",
    "num": "590",
    "desc": "Prereq: 9 credits in education\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience",
    "dept": "EDADM",
    "num": "591",
    "desc": "Prereq: EDADM 541 and admission to program and instructor's approval\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Elementary Principal",
    "dept": "EDADM",
    "num": "591A",
    "desc": "Prereq: EDADM 541 and admission to program and instructor's approval\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Secondary Principal",
    "dept": "EDADM",
    "num": "591B",
    "desc": "Prereq: EDADM 541 and admission to program and instructor's approval\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops",
    "dept": "EDADM",
    "num": "593",
    "desc": "Prereq: 9 credits in education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component Development",
    "dept": "EDADM",
    "num": "599",
    "desc": "Prereq: 9 credits in educational administration\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "EDADM",
    "num": "615",
    "desc": "\nIn-depth study of administrative topics of contemporary interest and importance.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Client Focus",
    "dept": "EDADM",
    "num": "615A",
    "desc": "\nIn-depth study of administrative topics of contemporary interest and importance.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Research",
    "dept": "EDADM",
    "num": "615B",
    "desc": "\nIn-depth study of administrative topics of contemporary interest and importance.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Quality Improvement",
    "dept": "EDADM",
    "num": "615C",
    "desc": "\nIn-depth study of administrative topics of contemporary interest and importance.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Special Services",
    "dept": "EDADM",
    "num": "615D",
    "desc": "\nIn-depth study of administrative topics of contemporary interest and importance.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Assessment",
    "dept": "EDADM",
    "num": "615E",
    "desc": "\nIn-depth study of administrative topics of contemporary interest and importance.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Leadership",
    "dept": "EDADM",
    "num": "615F",
    "desc": "\nIn-depth study of administrative topics of contemporary interest and importance.\n",
    "credits": "1"
  },
  {
    "course_name": "Program Induction Leadership Seminar",
    "dept": "EDADM",
    "num": "620",
    "desc": "Prereq: EDADM 541\nAssessment of candidate skill areas, including communication, leadership, technology, and team facilitation for the development of an individualized learning plan for the program.  Orientation to program expectations and leadership challenges in the context of schooling for a global society.\n",
    "credits": "3"
  },
  {
    "course_name": "Aligning the System for Student Achievement",
    "dept": "EDADM",
    "num": "621",
    "desc": "Prereq: EDADM 541\nAlignment of system goals and leadership theory with student achievement, governance, systems thinking, and communication and collaboration with various publics.\n",
    "credits": "5"
  },
  {
    "course_name": "Maximizing Human and Financial Resources for Student Achievement",
    "dept": "EDADM",
    "num": "622",
    "desc": "Prereq: EDADM 541\nAllocation of system resources to enhance student achievement; human resource development and negotiations; and coaching and evaluating the administrative team.\n",
    "credits": "3"
  },
  {
    "course_name": "Mid-Program Leadership Seminar",
    "dept": "EDADM",
    "num": "623",
    "desc": "Prereq: EDADM 541\nMid-program assessment of candidate progress and exploration of leadership strategies for working with diverse populations.\n",
    "credits": "1"
  },
  {
    "course_name": "School Finance",
    "dept": "EDADM",
    "num": "624",
    "desc": "Prereq: EDADM 541\nGeneral issues of school finance and managing a school district’s financial responsibilities. Role of the federal, state and local governments in educational finance, tax issues, and structures; budgeting procedures; and financial analysis and accountability. Includes attendance at selected sessions of the Iowa School Business Management Academy in the spring and two additional class sessions during the summer.\n",
    "credits": "2"
  },
  {
    "course_name": "Achieving Results Through Accountability Strategies",
    "dept": "EDADM",
    "num": "631",
    "desc": "Prereq: EDADM 541\nAccountability strategies for applying leadership theory to student achievement, governance, systems thinking, change agentry, and communication and collaboration with various publics.\n",
    "credits": "5"
  },
  {
    "course_name": "Using System Assets to Create a Culture of Learning",
    "dept": "EDADM",
    "num": "632",
    "desc": "Prereq: EDADM 541\nLeadership strategies to promote a culture of high student achievement; effective human capital management, including recruitment and induction of new personnel; and effective communication with parents and other patrons.\n",
    "credits": "3"
  },
  {
    "course_name": "Career Induction Leadership Seminar",
    "dept": "EDADM",
    "num": "633",
    "desc": "Prereq: EDADM 541\nDevelopment of entry plan for creating a culture of collaboration; professional growth plan for first year in new position; and authentic performance assessment of values and beliefs platform.\n",
    "credits": "1"
  },
  {
    "course_name": "School Business Management and Accountability",
    "dept": "EDADM",
    "num": "634",
    "desc": "Prereq: EDADM 541\nManagement of school operations; accountability and ethical business practices; risk management; school plant operations, food service and student transportation. Includes attendance at selected sessions of the Iowa School Business Management Academy in the spring and two additional class sessions during the summer.\n",
    "credits": "2"
  },
  {
    "course_name": "Ethics, Spirituality, and Social Justice in Administrative Practice",
    "dept": "EDADM",
    "num": "651",
    "desc": "\nExploration of ethical models and practice of educational administrators. Participants develop personal and professional codes of ethics: define concepts of care, spirituality, democracy, equity, diversity, and social justice; and explain how those concepts relate to students' academic and social success. Case studies offer opportunities to consider moral and legal consequences of decision-making. Participants develop their own vision of leadership.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Special Topics",
    "dept": "EDADM",
    "num": "690",
    "desc": "Prereq: 9 credits in educational administration\n",
    "credits": "1"
  },
  {
    "course_name": "Clinical Dilemmas of Practice",
    "dept": "EDADM",
    "num": "691",
    "desc": "Prereq: EDADM 541, admission to program, and instructor's approval\nSupervised on-the-job field leadership experience in clinical dilemmas of practice.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Dissertation Research",
    "dept": "EDADM",
    "num": "699",
    "desc": "Prereq: 9 credits in education\n",
    "credits": "arr"
  },
  {
    "course_name": "Social Justice Field Experience",
    "dept": "EL PS",
    "num": "591",
    "desc": "Prereq: EL PS 620\nSupervised field experience in equity and social justice inside/outside higher education.\n",
    "credits": "1"
  },
  {
    "course_name": "Thematic Seminars",
    "dept": "EL PS",
    "num": "615",
    "desc": "Prereq: Admission to educational leadership doctoral program\n",
    "credits": "1"
  },
  {
    "course_name": "Thematic Seminars: Communication and Team Building",
    "dept": "EL PS",
    "num": "615A",
    "desc": "Prereq: Admission to educational leadership doctoral program\n",
    "credits": "1"
  },
  {
    "course_name": "Thematic Seminars: Governance, Politics and Policies",
    "dept": "EL PS",
    "num": "615B",
    "desc": "Prereq: Admission to educational leadership doctoral program\n",
    "credits": "1"
  },
  {
    "course_name": "Thematic Seminars: Law, Equity, Equality",
    "dept": "EL PS",
    "num": "615C",
    "desc": "Prereq: Admission to educational leadership doctoral program\n",
    "credits": "1"
  },
  {
    "course_name": "Thematic Seminars: Ethics, Justice, and Caring",
    "dept": "EL PS",
    "num": "615D",
    "desc": "Prereq: Admission to educational leadership doctoral program\n",
    "credits": "1"
  },
  {
    "course_name": "Thematic Seminars: Problem Solving and Planning",
    "dept": "EL PS",
    "num": "615E",
    "desc": "Prereq: Admission to educational leadership doctoral program\n",
    "credits": "1"
  },
  {
    "course_name": "Thematic Seminars: Critical and Creative Thinking",
    "dept": "EL PS",
    "num": "615F",
    "desc": "Prereq: Admission to educational leadership doctoral program\n",
    "credits": "1"
  },
  {
    "course_name": "Capstone Experience",
    "dept": "EL PS",
    "num": "616",
    "desc": "Prereq: 4 credits of EL PS 615\nThis experience is designed to explore a topic addressed in one of the thematic seminars. The product of the capstone experience is a written paper of sufficient quality to be submitted to a scholarly journal for review.\n",
    "credits": "3"
  },
  {
    "course_name": "Education for Social Justice",
    "dept": "EL PS",
    "num": "620",
    "desc": "\nIntroduction to social justice theory, research, and practice from a variety of theoretical perspectives in the context of education and broader society.\n",
    "credits": "3"
  },
  {
    "course_name": "Pedagogies of Dissent",
    "dept": "EL PS",
    "num": "621",
    "desc": "Prereq: EL PS 620\nCritical examination of the philosophical foundations of education that seek to challenge the status quo and advance radical educational change.  Exploration of macro-level (and some micro-level) issues relevant to educational change, in relation to how they inform practices of dissent and every day social relations.\n",
    "credits": "3"
  },
  {
    "course_name": "Decolonizing Praxis",
    "dept": "EL PS",
    "num": "622",
    "desc": "Prereq: EL PS 620\nCritically probes the philosophical and historical foundations of anti/post-colonial theory.  Examination of policy, social, theoretical and educational issues from an anti/post-colonial perspective.\n",
    "credits": "3"
  },
  {
    "course_name": "Critical Race Theory in Education",
    "dept": "EL PS",
    "num": "624",
    "desc": "\nExploration of the central tenets of critical race theory.  Examination of policy, social and educational issues from a critical race perspective.\n",
    "credits": "3"
  },
  {
    "course_name": "Gender and Sexuality in Education",
    "dept": "EL PS",
    "num": "625",
    "desc": "\nExploration of gender and sexuality in education.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Justice and Social Change in Education",
    "dept": "EL PS",
    "num": "626",
    "desc": "Prereq: EL PS 621\nAn examination of how changes in the interest of social justice have occurred historically in education.  Exploration of social movements and theories of social change.\n",
    "credits": "3"
  },
  {
    "course_name": "Education Policy and Analysis",
    "dept": "EL PS",
    "num": "630",
    "desc": "Prereq: Advanced graduate standing\nIntroduction to current theoretical, practical, and research-based policy debates related to the P-20 educational system.  Critical analysis and evaluation of government policies, initiatives, funding, and other regulatory levers related to education. Intensive reading and discussion of the nature of theory, evidence, practice of education policy.\n",
    "credits": "3"
  },
  {
    "course_name": "Educational Technologies in the PK-6 Classroom",
    "dept": "EDUC",
    "num": "201",
    "desc": "\nOverview of ways to use educational technologies to support instruction in PK-6 settings. Focus on pedagogical approaches that integrate technologies to support learning in the content areas. Laboratory experiences include development of activities to use web 2.0 tools, apps, multimedia, web page development, digital video and other technologies to facilitate learning and teaching.\n",
    "credits": "3"
  },
  {
    "course_name": "Educational Technologies in the 7-12 Classroom",
    "dept": "EDUC",
    "num": "202",
    "desc": "\nOverview of ways to use educational technologies to support instruction in 7-12 settings.  Focus on pedagogical approaches that integrate technologies to support learning in the content areas.  Laboratory experiences include development of activities to use tool software, multimedia, web page development, digital video and other technologies to facilitate learning and teaching.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Foundations of Education in the United States: Secondary",
    "dept": "EDUC",
    "num": "204",
    "desc": "\nIntroduction to the historical and contemporary landscape of schooling in the United States. Emphasis is placed on topics and tensions in the relationship between school and society (e.g. equity of access to education and competing purposes of education) and the implications of these topics and tensions for teaching and learning at the secondary level in public schools. For prospective teachers in an ISU Secondary Education teacher preparation program; open to students who are considering teaching and/or work in education as a career path. Students in Early Childhood and Elementary Education programs should take C I 205.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Foundations of Education in the United States: Early Childhood and Elementary Education",
    "dept": "EDUC",
    "num": "205",
    "desc": "\nIntroduction to the historical and contemporary landscape of schooling in the United States. Emphasis on topics and tensions in the relationship between school and society (e.g., equity of access to education and competing purposes of education) and the implications of these topics and tensions for teaching and learning in public schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Learning Community Orientation to Teacher Education",
    "dept": "EDUC",
    "num": "216",
    "desc": "Prereq: All first semester freshman Elementary Education majors are automatically enrolled.\nLearning Community for Elementary Education majors to help with their transition to university life.  Offers an overview of K-8 teacher certification in Iowa as well as degree and career planning.  With the help of guest speakers and peer mentors, students learn about elementary teaching as a profession and are introduced to a social justice orientation to teaching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Orientation to Teacher Education: Math, Science, FCS Education, and History/Social Science Majors",
    "dept": "EDUC",
    "num": "219",
    "desc": "Prereq: Students seeking teacher licensure in mathematics, science family and consumer sciences, or history/social sciences in grades 5-12\nOverview of mathematics, science, family and consumer sciences and history/social sciences secondary education (grades 5-12), teacher licensure requirements in Iowa and other states. Program and career planning.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Landscape of Teaching",
    "dept": "EDUC",
    "num": "245",
    "desc": "Prereq: EDUC 205; sophomore classification.\nIntroduction to the landscape of teaching including instructional planning,  basic lesson design and assessment, and philosophies of classroom management that  provide equitable learning opportunities for all students in culturally affirming ways. Open to students majoring in Elementary Education or Early Childhood Education.\n",
    "credits": "3"
  },
  {
    "course_name": "Pre-Student Teaching Experience I",
    "dept": "EDUC",
    "num": "280",
    "desc": "Prereq: EDUC 201 or EDUC 202. Permission of instructor needed for 2 credits\nPre-Student teaching experience in learning technologies in various educational settings with K-12 technology leaders. 2 1/2-hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Core Experience",
    "dept": "EDUC",
    "num": "280A",
    "desc": "Prereq: Restricted to students with admission to teacher education.\nPre-Student teaching experience in school settings.  1/2 day of time needed. Clinical Experience Level 2.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Educational Technologies",
    "dept": "EDUC",
    "num": "280B",
    "desc": "Prereq: EDUC 201 or EDUC 202.\nPre-Student teaching experience with technologies in various educational settings with K-12 technology leaders. 2 1/2-hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Native American Tutoring",
    "dept": "EDUC",
    "num": "280C",
    "desc": "\nPre-Student teaching experience in Native American tutoring in school settings. 2 1/2 hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Museum Education",
    "dept": "EDUC",
    "num": "280D",
    "desc": "Prereq: Completion of or concurrent enrollment in EDUC 280A.\nPre-Student teaching experience in museum settings. 2 1/2-hour blocks of time needed. Supervision level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Multicultural Youth",
    "dept": "EDUC",
    "num": "280E",
    "desc": "Prereq: EDUC 280A must be either a prerequisite or taken currently; permission of instructor for 2 credits.\nPre-Student teaching experience for multicultural youth in school settings. 2 1/2-hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Mild/Moderate Disabilities",
    "dept": "EDUC",
    "num": "280I",
    "desc": "Prereq: Admission to teacher education; concurrent enrollment in SP ED 330 and SP ED 334.\nPre-Student teaching experience in mild/moderate disabilities in school settings. 2 1/2-hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Mathematics Clinic",
    "dept": "EDUC",
    "num": "280J",
    "desc": "\nEarly field experience where students explore and develop an understanding of research-based instructional practices that could be implemented with middle level students to teach mathematical concepts. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Music",
    "dept": "EDUC",
    "num": "280K",
    "desc": "\nPre-student teaching experience in music in school settings.  Permission of Music coordinator required prior to enrollment. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "0"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Secondary Education",
    "dept": "EDUC",
    "num": "280L",
    "desc": "\nPre-student teaching experience for secondary education students in school settings. 2 1/2 hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "0"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Secondary Science",
    "dept": "EDUC",
    "num": "280M",
    "desc": "Prereq: Permission of instructor for 2 credits.\nPre-student teaching experience in secondary science in school settings. 2 1/2-hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Learning Community",
    "dept": "EDUC",
    "num": "280N",
    "desc": "\nPre-student teaching experience for Preparing Tomorrow's Teachers learning community students in school settings. 2 1/2-hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience 1: Art Education",
    "dept": "EDUC",
    "num": "280O",
    "desc": "\nPre-student teaching experience in art education in school settings. 2 1/2-hour blocks of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: English as a Second Language (ESL)",
    "dept": "EDUC",
    "num": "280S",
    "desc": "Prereq: Admission to teacher education.\nPre-student teaching experience in English as a Second Language. 1/2 day of time needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Tutoring",
    "dept": "EDUC",
    "num": "280T",
    "desc": "\nPre-student teaching experience tutoring in a school setting focused on mathematics, literacy, and/or other content areas. Two, one-hour blocks of time per week needed. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "EDUC",
    "num": "290",
    "desc": "Prereq: 6 credits in Education, permission of department chair\nIndependent study, under faculty supervision, of a topic in the field of education.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles and Practices of Learning with Technology",
    "dept": "EDUC",
    "num": "302",
    "desc": "Prereq: EDUC 201 or EDUC 202\nAdvanced integration of learning technologies into K-12 educational contexts. Examine current trends in using learning technologies with K-12 students; explore current applications used in formal and informal educational settings; and discuss issues focused on technology use in education. Required for Learning Technologies minor.\n",
    "credits": "3"
  },
  {
    "course_name": "Transfer Orientation",
    "dept": "EDUC",
    "num": "315",
    "desc": "\nOffers an overview of Elementary Education requirements, university procedures, K-8 certification in Iowa as well as degree and career planning.  With the help of guest speakers and peer mentors, students learn about elementary teaching as a profession and are introduced to a social justice orientation to teaching.  Learning community required of all transfer students and change of major students pursuing Elementary Education.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Educational Psychology of  Early Childhood and Elementary Education",
    "dept": "EDUC",
    "num": "332",
    "desc": "Prereq: PSYCH 230 or HD FS 102, open only to majors in Early Childhood Education or Elementary Education\nPsychological theories relevant to student development, learning, and motivation. Review of assessment principles and practices. Implications of theory for teaching children and for assessing learning in educational settings with primary and intermediate grade children.\n",
    "credits": "3"
  },
  {
    "course_name": "Educational Psychology",
    "dept": "EDUC",
    "num": "333",
    "desc": "Prereq: PSYCH 230 or HD FS 102, application to the teacher education program or major in psychology\nPsychological theories relevant to student development, learning, and motivation. Review of assessment principles and practices. Implications of theory for teaching children and for assessing learning in K-12 educational settings, with an emphasis on grades 5 – 12.\n",
    "credits": "3"
  },
  {
    "course_name": "Nature of Science",
    "dept": "EDUC",
    "num": "347",
    "desc": "Prereq: EDUC 280M; concurrent enrollment in EDUC 418 or instructor permission\nThe intersection of issues in the history, philosophy, and sociology of science and their application to and impact on science teaching and learning, science teacher education, and science education research.\n",
    "credits": "3"
  },
  {
    "course_name": "Toying with Technology",
    "dept": "EDUC",
    "num": "370",
    "desc": "Prereq: EDUC 201 or EDUC 202\nIntegration of learning technologies into PK-12 STEM contexts with a focus on engineering design and computational thinking. Examine current trends and explore how technology can be used to design creative and innovative hands-on experiences that promote critical thinking and problem-solving skills across STEM -related educational contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "The Teaching of Reading and Language Arts in the Primary Grades (K-3)",
    "dept": "EDUC",
    "num": "377",
    "desc": "Prereq: Admission to teacher education program, EDUC 245, SP ED 250, HD FS 240 (ECE majors); concurrent enrollment in EDUC 405, EDUC 448, EDUC 468A, and EDUC 468C (EL ED majors) or EDUC 438, EDUC 468F, EDUC 468G, SP ED 368.\nTheories, teaching strategies, and instructional materials pertinent to teaching reading, writing, listening, and speaking to children in kindergarten through third grade.\n",
    "credits": "4"
  },
  {
    "course_name": "The Teaching of Reading and Language Arts in the Intermediate Grades (4-6)",
    "dept": "EDUC",
    "num": "378",
    "desc": "Prereq: EDUC 377; concurrent enrollment in EDUC 449, EDUC 468B, EDUC 468D, and EDUC 443\nTheories and processes of literacy. Application through reading and writing across the curriculum, integration of language arts, literature-based instruction, and metacognitive strategies.\n",
    "credits": "4"
  },
  {
    "course_name": "Teaching Disciplinary Literacy",
    "dept": "EDUC",
    "num": "395",
    "desc": "Prereq: EDUC 204 and junior classification.\nAnalysis and application of strategies to enhance students' disciplinary literacy development in middle and secondary school setting.  Research paper related to a course topic.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Justice Education and Teaching: Early Childhood and Elementary",
    "dept": "EDUC",
    "num": "405",
    "desc": "Prereq: EDUC 201, EDUC 332, junior classification, admission to teacher education program.\nOpportunity to expand understanding of issues related to educational and social justice at the levels of Self, Systems, and Teaching. Personal growth and awareness; education within a broader social and historical context; equity and justice-oriented teaching. Special attention is given to enacting culturally relevant teaching in grades PK through 6, along with curriculum transformation and social action in those grades. Restricted to those enrolled in Early Childhood and Elementary Education Programs. Elementary education majors should take EDUC 405 with Block 1 practicum.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Social Justice Education and Teaching: Secondary",
    "dept": "EDUC",
    "num": "406",
    "desc": "Prereq: EDUC 201 or EDUC 202, EDUC 332 or EDUC 333, junior classification, admission to teacher preparation program. Restricted to those enrolled in Secondary and K-12 Education Programs.\nAwareness and nature of social justice in relation to the educational system; need for cultural competence; multicultural concepts and theories; awareness of context of cultural groups - their history, perspective, needs, and contributions; problems and issues regarding prejudice, and discrimination based on race, ethnicity, socioeconomic class, gender, sexual identity and language in the school environment. Special attention to culturally relevant teaching in grades 7 through 12, along with curriculum transformation and social action in those grades.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Principles and Practices of Distance Learning",
    "dept": "EDUC",
    "num": "407",
    "desc": "Prereq: EDUC 201 or EDUC 202; convenient access to the Web\nReview of flexible and distance learning (FDL) cases in a variety of contexts and pedagogic styles, identification of underlying principles and frameworks for best practice in this field. Required for the Learning Technologies minor.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Student Teaching  - Elementary",
    "dept": "EDUC",
    "num": "416",
    "desc": "Prereq: GPA 2.5; full admission to teacher education; senior classification;  EDUC 378, EDUC 443, EDUC 448, EDUC 449; reservation required\nSupervised teaching experience in the elementary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Student Teaching - Elementary: Primary grades (K-3)",
    "dept": "EDUC",
    "num": "416A",
    "desc": "Prereq: GPA 2.5; full admission to teacher education; senior classification; EDUC 378, EDUC 443, EDUC 448, EDUC 449; reservation required\nSupervised teaching experience in the elementary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Student Teaching - Elementary: Intermediate grades (4-6)",
    "dept": "EDUC",
    "num": "416B",
    "desc": "Prereq: GPA 2.5; full admission to teacher education; senior classification; EDUC 378, EDUC 443, EDUC 448, EDUC 449; reservation required\nSupervised teaching experience in the elementary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Student Teaching  - Elementary: World Language",
    "dept": "EDUC",
    "num": "416C",
    "desc": "Prereq: GPA 2.5; full admission to teacher education; senior classification; EDUC 378, EDUC 443, EDUC 448, EDUC 449; reservation required\nSupervised teaching experience in the elementary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Student Teaching  - Elementary: International Student Teaching - Primary Grades",
    "dept": "EDUC",
    "num": "416D",
    "desc": "Prereq: GPA 2.5; full admission to teacher education; senior classification; EDUC 378, EDUC 443, EDUC 448, EDUC 449; reservation required\nSupervised teaching experience in the elementary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Student Teaching - Elementary: International Student Teaching - Intermediate  Grades",
    "dept": "EDUC",
    "num": "416E",
    "desc": "Prereq: GPA 2.5; full admission to teacher education; senior classification; EDUC 378, EDUC 443, EDUC 448, EDUC 449; reservation required\nSupervised teaching experience in the elementary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Student Teaching  - Elementary: English as a Second Language",
    "dept": "EDUC",
    "num": "416Z",
    "desc": "Prereq: GPA 2.5; full admission to teacher education; senior classification; ENGL 219; ENGL 220; ENGL 425; EDUC 280S; EDUC 480S; EDUC 378.\nSupervised teaching experience in the elementary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching",
    "dept": "EDUC",
    "num": "417",
    "desc": "Prereq: Full admission to teacher education or licensed teacher; approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Social Studies-Middle School",
    "dept": "EDUC",
    "num": "417A",
    "desc": "Prereq: GPA 2.5; Admission to teacher education, approval of coordinator during semester before student   teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Physical Sciences",
    "dept": "EDUC",
    "num": "417B",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in physical sciences grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Mathematics",
    "dept": "EDUC",
    "num": "417C",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in mathematics grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Biological Sciences",
    "dept": "EDUC",
    "num": "417D",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in biological sciences grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Speech",
    "dept": "EDUC",
    "num": "417F",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching.\nEvaluation of instruction, lesson planning, and teaching in speech.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: World Language",
    "dept": "EDUC",
    "num": "417G",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in world languages, secondary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Earth Sciences",
    "dept": "EDUC",
    "num": "417J",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in earth sciences grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Science - Basic",
    "dept": "EDUC",
    "num": "417M",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in basic sciences grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: International",
    "dept": "EDUC",
    "num": "417N",
    "desc": "Prereq: GPA 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Social Studies-High School",
    "dept": "EDUC",
    "num": "417P",
    "desc": "Prereq: GPA 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Music-Elementary",
    "dept": "EDUC",
    "num": "417R",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Music-Secondary",
    "dept": "EDUC",
    "num": "417S",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: English as Second Language",
    "dept": "EDUC",
    "num": "417Z",
    "desc": "Prereq: GPA 2.5; Admission to teacher education, approval of coordinator during semester before student teaching.\nEvaluation of instruction, lesson planning, and teaching in English as a Second Language grades 7-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Secondary Science Methods I: A Research-Based Framework for Teaching Science",
    "dept": "EDUC",
    "num": "418",
    "desc": "Prereq: EDUC 280M or EDUC 514; undergraduate students must register concurrently for EDUC 347 and EDUC 468J\nDevelopment of a research-based framework for teaching science that includes student goals, congruent student actions, the character and role of science inquiry, teaching behaviors and strategies, contemporary learning theories, and self evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Secondary Science Methods II: Advancing a Research-Based Framework for Teaching Science",
    "dept": "EDUC",
    "num": "419",
    "desc": "Prereq: EDUC 418 or EDUC 518, undergraduate students must register concurrently for EDUC 468K\nAdvancing a research-based framework for teaching science in a variety of school settings; emphasizing the teacher's role, content area reading strategies, science safety and classroom management, issues in using technology, and student assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Bilingualism, Bilingual Education, and U.S. Mexican Youth",
    "dept": "EDUC",
    "num": "420",
    "desc": "Prereq: EDUC 405 or EDUC 406\nIntroduction to research on bilingualism and examination of the social, historical, and political contexts of bilingual education in U.S. schools.  Attention to policy environment, school program structure, mode of classroom instruction, family and community context, and attainment of bilingualism and biculturalism for U.S. Mexican youth.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching and Learning Iowa History",
    "dept": "EDUC",
    "num": "422",
    "desc": "\nMulticultural and social justice focus on Iowa history; different theme each summer. Effective pedagogical and assessment strategies for integrating these themes into K-12 curriculum.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Secondary Education",
    "dept": "EDUC",
    "num": "426",
    "desc": "Prereq: Senior classification and admission to teacher education program\nIntroduction to secondary education teaching strategies, lesson planning that provides equitable learning opportunities for all students, classroom management, legal aspects of schools, professional and ethical issues, current educational issues, professional learning communities, and social-justice oriented teaching.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Social Studies in the Primary Grades",
    "dept": "EDUC",
    "num": "433",
    "desc": "Prereq: EDUC 377, HD FS 224; concurrent enrollment in EDUC 439, SP ED 355, SP ED 455, and EDUC 468I\nEmphasis is placed on providing equity and justice-oriented social studies learning experiences (e.g. curriculum content, instructional strategies, and assessment) for primary grade children.\n",
    "credits": "2"
  },
  {
    "course_name": "Teaching Mathematics in the Primary Grades",
    "dept": "EDUC",
    "num": "438",
    "desc": "Prereq: MATH 195 (minimum grade of C-), MATH 196 (minimum grade of C-); concurrent enrollment in EDUC 377, EDUC 468F, EDUC 468G and SP ED 368\nDevelop an understanding of effective mathematics teaching practices situated in equitable pedagogies that support primary students' mathematical understanding.\n",
    "credits": "2"
  },
  {
    "course_name": "Teaching Science in the Primary Grades",
    "dept": "EDUC",
    "num": "439",
    "desc": "Prereq: EDUC 377, HD FS 224; concurrent enrollment in EDUC 433, EDUC 468I, SP ED 355, SP ED 455\nDevelopment and application of current methods in the teaching and learning of primary science. Emphasis is on research-based teaching practices, developmental implications, and providing appropriate science learning experiences in the early elementary grades.\n",
    "credits": "2"
  },
  {
    "course_name": "The Teaching of Social Studies",
    "dept": "EDUC",
    "num": "443",
    "desc": "Prereq: EDUC 377, concurrent enrollment in EDUC 378, EDUC 449, EDUC 468B and EDUC 468D (EL ED majors)\nEmphasis is placed on providing equity and justice-oriented social studies learning experiences (e.g. curriculum content, instructional strategies, and assessment) for primary and intermediate grade children.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Children Mathematics",
    "dept": "EDUC",
    "num": "448",
    "desc": "Prereq: MATH 195 (minimum grade of C-), MATH 196 (minimum grade of C-); concurrent enrollment in EDUC 377, EDUC 468A, EDUC 468C, and EDUC 405 (EL ED majors) or EDUC 377, EDUC 468F, EDUC 468G and SP ED 368 (ECE majors)\nDevelop an understanding of effective mathematics teaching practices situated in equitable pedagogies that support elementary students' mathematical understanding.\n",
    "credits": "3"
  },
  {
    "course_name": "The Teaching of Science",
    "dept": "EDUC",
    "num": "449",
    "desc": "Prereq: EDUC 377, concurrent enrollment in EDUC 378, EDUC 468B, EDUC 468D and EDUC 443\nDevelopment and application of current methods in the teaching and learning of elementary science. Emphasis is on research-based teaching practices, developmental implications, and providing appropriate science learning experiences in the elementary grades.\n",
    "credits": "3"
  },
  {
    "course_name": "Ethnicity and Learning",
    "dept": "EDUC",
    "num": "450",
    "desc": "Prereq: EDUC 332 or EDUC 333; EDUC 406\nExamination of cultural relevance in education. Development and application of strategies and techniques for implementing multicultural goals and multiethnic perspectives in PreK-12 school classroom settings.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Assessment for Literacy and Learning",
    "dept": "EDUC",
    "num": "452",
    "desc": "Prereq: EDUC 378 or equivalent\nIdentification, analysis and correction of reading problems in five areas: print knowledge, integration of print knowledge, oral reading fluency, vocabulary, and comprehension.\n",
    "credits": "3"
  },
  {
    "course_name": "Emerging Topics in Learning Technologies",
    "dept": "EDUC",
    "num": "454",
    "desc": "Prereq: EDUC 201 or EDUC 202\nDevelopment and application of emerging technology topics related to digital learning. Series of 1-3 credit on-line learning modules on current technology being used in education and topics being addressed. These modules extend learning opportunities from other courses and experiences. Required for the Learning Technologies minor.\n",
    "credits": "1"
  },
  {
    "course_name": "Integrating Technology into Literacy",
    "dept": "EDUC",
    "num": "456",
    "desc": "Prereq: EDUC 201 or EDUC 202; EDUC 377\nMethods and strategies used to integrate technology into K-8 literacy. Examination of the use and evaluation of technology appropriate for elementary literacy classrooms.\n",
    "credits": "3"
  },
  {
    "course_name": "Critical Approaches to Teaching Children’s and Adolescent Literature",
    "dept": "EDUC",
    "num": "459",
    "desc": "Prereq: Admission into teacher education program; EDUC 377; prerequisite or concurrent enrollment in EDUC 378.\nResearch and discussion of issues surrounding the classroom use of literature for children and young adults including censorship, diversity, selection, critical literacy and the influences of technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Pre-Student Teaching Experience II",
    "dept": "EDUC",
    "num": "468",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods, and instructional experiences with children in a supervised elementary, middle, or high school classroom while engaged in other methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Primary Grades, Reading and Language Arts",
    "dept": "EDUC",
    "num": "468A",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods and instructional experiences with children in a supervised K-3 elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Intermediate Grades, Reading and Language Arts",
    "dept": "EDUC",
    "num": "468B",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods and instructional experiences with children in a supervised 3-6 elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Primary Grades, Mathematics",
    "dept": "EDUC",
    "num": "468C",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods, and instructional experiences with children in a supervised K-3 elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Intermediate Grades, Science",
    "dept": "EDUC",
    "num": "468D",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods and instructional experiences with children in a supervised 3-6 elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: World Languages",
    "dept": "EDUC",
    "num": "468E",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods, and instructional experiences with children in a supervised K-6 elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Primary Grades Inclusive, Literacy",
    "dept": "EDUC",
    "num": "468F",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods and instructional experiences with children in a supervised K-3 inclusive elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Primary Grades Inclusive, Mathematics",
    "dept": "EDUC",
    "num": "468G",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods and instructional experiences with children in a supervised K-3 inclusive elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Primary Grades Inclusive, Science",
    "dept": "EDUC",
    "num": "468I",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods and instructional experiences with children in a supervised K-3 inclusive elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Secondary Science I",
    "dept": "EDUC",
    "num": "468J",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods and instructional experiences with children in a supervised grade 5-12 science classroom while engaged in other elementary methods courses. Clinical Supervision Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Secondary Science II",
    "dept": "EDUC",
    "num": "468K",
    "desc": "Prereq: Admission to teacher education program\nApplication of current methods and instructional experiences with children in a supervised 5-12 science classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Pre-Student Teaching Experience II: Intermediate Grades, Reading Endorsement",
    "dept": "EDUC",
    "num": "468R",
    "desc": "Prereq: Admission to teacher education program. Permission of School of Education required; concurrent enrollment in EDUC 378\nApplication of current methods and instructional experiences with children in a supervised 3-6 elementary classroom while engaged in other elementary methods courses. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-student Teaching Seminar",
    "dept": "EDUC",
    "num": "469",
    "desc": "Prereq: Admission to teacher education program.\nFuture teachers learn about teaching as they connect theory, practice and classroom experiences. Learning is supported with video-based seminars focused on effective classroom practices.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience III",
    "dept": "EDUC",
    "num": "480",
    "desc": "Prereq: Admission to Teacher Education\nObservation and participation in a variety of school settings after admission to the teacher education program. Permission of area coordinator required prior to enrollment. (S/F grading may be used in some offerings of some sections.).\n",
    "credits": "0"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: History/Social Sciences",
    "dept": "EDUC",
    "num": "480A",
    "desc": "Prereq: Admission to Teacher Education\nSupervised participation in a 5-12 school setting. Permission of History/Social Sciences coordinator required prior to  enrollment. 1/2 day of time needed. Clinical Supervision Level 3.\n",
    "credits": "2"
  },
  {
    "course_name": "Field Experience for Secondary Teaching Preparation: Physical Sciences",
    "dept": "EDUC",
    "num": "480B",
    "desc": "Prereq: Permission of area coordinator required prior to enrolllment\nObservation and participation in a variety of school settings after admission to the teacher preparation program. Physical Sciences.\n",
    "credits": "2"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: Mathematics",
    "dept": "EDUC",
    "num": "480C",
    "desc": "Prereq: Admission to teacher education\nSupervised  participation mathematics in a 5-12 school setting. Permission of mathematics coordinator required prior to enrollment. 1/2 day of time needed. Clinical Experience Level 3.\n",
    "credits": "0"
  },
  {
    "course_name": "Field Experience for Secondary Teaching Preparation: Biological Sciences",
    "dept": "EDUC",
    "num": "480D",
    "desc": "Prereq: Permission of area coordinator required prior to enrollment\n",
    "credits": "2"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: English",
    "dept": "EDUC",
    "num": "480E",
    "desc": "Prereq: Admission to teacher education\nSupervised participation in a 5-12 school setting. Cross listed with English 480K. Permission of English coordinator required prior to enrollment. 1/2 day of time needed. Clinical Experience Level 3.\n",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: World Languages and Cultures",
    "dept": "EDUC",
    "num": "480G",
    "desc": "Prereq: Admission to teacher education\nSupervised participation in a 5-12 school setting. Permission of World Languages and Cultures coordinator required prior to enrollment. 1/2 day of time needed. Clinical Experience Level 3.\n",
    "credits": "1"
  },
  {
    "course_name": "Field Experience for Secondary Teaching Preparation: Earth Science",
    "dept": "EDUC",
    "num": "480J",
    "desc": "Prereq: Permission of area coordinator required prior to enrollment\n",
    "credits": "2"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: Music",
    "dept": "EDUC",
    "num": "480K",
    "desc": "Prereq: Admission to teacher education\nParticipation in a K-12 school setting. Permission of Music coordinator required prior to enrollment. Clinical Experience Level 2.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: English as a Second Language (ESL)",
    "dept": "EDUC",
    "num": "480S",
    "desc": "Prereq: EDUC 280S, ENGL 219/LING 219; ENGL 220/LING 220; ENGL 511/LING 511; admission to teaching education.\nSupervised participation in a school setting. Permission of ESL area coordinator required prior to enrollment. 1/2 day of time needed. Clinical experience level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Philosophy of Education",
    "dept": "EDUC",
    "num": "481",
    "desc": "\nIntroduction to Western philosophy of education. Emphasis is placed on enduring debates about the purposes(s) of education in a just society. Readings include classic and contemporary texts.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Elementary School World Language Instruction",
    "dept": "EDUC",
    "num": "486",
    "desc": "Prereq: 25 credits in a world language\nPlanning, implementation, and assessment of standards-based, student-centered, and thematic instruction in the elementary (K-8) classroom.  Special emphasis on K-8 students' communicative skills, cultural knowledge, and content learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Secondary School World Language Instruction",
    "dept": "EDUC",
    "num": "487",
    "desc": "Prereq: 25 credits in a world language, admission to the teacher education program, OPI\nTheories and principles of contemporary world language learning and teaching. Special emphasis on designing instruction and assessments for active learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Tutoring in Reading",
    "dept": "EDUC",
    "num": "488",
    "desc": "Prereq: Concurrent enrollment in or completion of one course in corrective reading; diagnosis and correction of reading problems; graduate status required for EDUC 588\nUsing formal and informal diagnostic procedures to plan and implement individualized reading instruction. Field experience in tutoring and a related research project.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "EDUC",
    "num": "490",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Education",
    "dept": "EDUC",
    "num": "490A",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent Study in Music.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Curriculum Construction",
    "dept": "EDUC",
    "num": "490C",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Principles of Education",
    "dept": "EDUC",
    "num": "490D",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Methods of Teaching",
    "dept": "EDUC",
    "num": "490E",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Educational Psychology",
    "dept": "EDUC",
    "num": "490F",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Digital Learning",
    "dept": "EDUC",
    "num": "490G",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "EDUC",
    "num": "490H",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Social and Cultural Studies",
    "dept": "EDUC",
    "num": "490J",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: History/Social Sciences",
    "dept": "EDUC",
    "num": "490K",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Literacy Education",
    "dept": "EDUC",
    "num": "490L",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Mathematics Education",
    "dept": "EDUC",
    "num": "490M",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: World Language",
    "dept": "EDUC",
    "num": "490N",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Foundations of Education",
    "dept": "EDUC",
    "num": "490O",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Science Education",
    "dept": "EDUC",
    "num": "490P",
    "desc": "Prereq: GPA of 2.5 or more for preceding semester\n",
    "credits": "1"
  },
  {
    "course_name": "Practice and Theory of Teaching Literature in the Secondary Schools",
    "dept": "EDUC",
    "num": "494",
    "desc": "Prereq: ENGL 310, ENGL 397, 9 other credits in English beyond ENGL 250, PSYCH 333, admission to teacher education program\nPortfolio review. Current theories and practices in the teaching of literature to secondary school students. Integrating literary study and writing. Preparation and selection of materials. Classroom presentation. Unit planning. (Taken concurrently with C I 280, Cr. 2, and Sp Ed 450).\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study: Teaching Speech",
    "dept": "EDUC",
    "num": "495B",
    "desc": "Prereq: C I 301; 9 credits in speech communication; minimum GPA of 2.5 in speech communication courses\nProblems, methods, and materials related to teaching speech, theatre, and media in secondary schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Secondary School Mathematics",
    "dept": "EDUC",
    "num": "497",
    "desc": "Prereq: 15 credits in college mathematics.  If in a teacher licensure program, concurrent enrollment in EDUC 426 or EDUC 526.\nDevelop an understanding of instructional planning, lesson implementation, and assessment in grades 5-12 mathematics, with a focus on reform-based mathematics, equity, and conceptual understanding.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Teaching History/Social Sciences",
    "dept": "EDUC",
    "num": "498",
    "desc": "Prereq: Concurrent enrollment in HIST 480A; Admission to teacher education and 30 credits in subject-matter field\nConcurrent enrollment in 480A; Admission to teacher education and 30 credits in subject-matter field. Theories and processes of teaching and learning secondary history/social sciences. Emphasis on development and enactment of current methods, assessments, and curriculum materials for providing appropriate learning experiences.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Educational Technology",
    "dept": "EDUC",
    "num": "501",
    "desc": "Prereq: Graduate classification\nEducational philosophies and theories of teaching, learning, and learning technologies. Understanding of how people learn with, and through, educational technology, in many settings. Overview of significant topics in educational technology. Major learning theories, including recent debates in how educators conceive of learning; teaching and learning with technology; new literacies practices; and critical theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Mathematics to English Language Learners",
    "dept": "EDUC",
    "num": "502",
    "desc": "Prereq: EDUC 448 or EDUC 497/EDUC 597 for degree students. Classroom teaching experience for non-degree students and in-service teachers\nUnderstanding the needs of various English language learners, learn to use ELLs’ language and culture as a resource in mathematics classrooms, and implement research-based instructional strategies that are effective to teach mathematics for ELLs. For pre–service/in–service teachers and others who will work or currently works with English language learners (ELLs).\n",
    "credits": "3"
  },
  {
    "course_name": "Designing Effective Learning Environments",
    "dept": "EDUC",
    "num": "503",
    "desc": "Prereq: EDUC 501\nApplication of theories and models of instructional design. Design decision-making based on the analysis of performance problems and instructional inputs.  Practical experience with the design and development of instruction and evaluation principles.\n",
    "credits": "3"
  },
  {
    "course_name": "Evaluating Technology-based Learning Environments",
    "dept": "EDUC",
    "num": "504",
    "desc": "Prereq: EDUC 501\nPrinciples and procedures to plan, design, and conduct effective evaluation studies (formative, summative, usability) in different settings are studied. Opportunities to engage in real or simulated evaluation projects of substantial scope are provided. Create evaluation instruments, develop methods with which to evaluate a product or program, conduct try-outs or usability sessions, analyze the data, report the findings, and recommendations are some of the course activities.\n",
    "credits": "3"
  },
  {
    "course_name": "Using Technology in Learning and Teaching",
    "dept": "EDUC",
    "num": "505",
    "desc": "Prereq: Graduate classification\nTeaching and learning using educational technology. Selection and evaluation of digital tools for teaching and learning. Research on instructional technology. Tool software. Trends in computer-based instruction.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Justice Education and Teaching: Advanced",
    "dept": "EDUC",
    "num": "506",
    "desc": "Prereq: 6 graduate credits in Education\nEngage with justice-oriented multicultural frameworks for transformative education and education research, understand equity in education in historical and contemporary contexts, develop principled approaches to critical self-reflection, interpret educational situations in justice-oriented ways, and counter inequities in education through curriculum, pedagogy, and research.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles and Practices of Distance Learning",
    "dept": "EDUC",
    "num": "507",
    "desc": "Prereq: EDUC 201 or EDUC 202; convenient access to the Web\nReview of flexible and distance learning (FDL) cases in a variety of contexts and pedagogic styles, identification of underlying principles and frameworks for best practice in this field. Required for the Learning Technologies minor.\n",
    "credits": "3"
  },
  {
    "course_name": "Algebra in the K-12 Classrooms",
    "dept": "EDUC",
    "num": "508",
    "desc": "Prereq: 6 credits of mathematics; credit or concurrent enrollment in EDUC 448 or EDUC 497 or EDUC 597\nFocus on Algebraic reasoning, concepts, and associated procedures in K-12 classrooms, especially middle level. Using algebra and algebraic reasoning to solve a real-life problem.  Attention is given to algebraic habits of mind, generalization,  representation, and transition from arithmetic algorithms to algebra.\n",
    "credits": "3"
  },
  {
    "course_name": "Geometry in the K-12 Classrooms",
    "dept": "EDUC",
    "num": "509",
    "desc": "Prereq: 6 credits of mathematics; credit or concurrent enrollment in EDUC 448 or EDUC 497 or EDUC 597\nExplore the fundamental mathematical theory underlying the content area of geometry and measurement through research-based pedagogies in K-12 classrooms. An investigative approach involving problem solving, reasoning and proof, connections, and communication are emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology Diffusion, Leadership, and Change",
    "dept": "EDUC",
    "num": "511",
    "desc": "Prereq: Admission to graduate study, EDUC 501 or equivalent and EDUC 505 or equivalent\nPrinciples and practices of technology diffusion, leadership and school change. Coursework focuses on technology diffusion broadly and implications on educational contexts. Leadership frameworks and strategies for professional development and organizational change are examined, as well as new literacy practices, critical theory, and current debates in the field.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Trends in Educational Technology",
    "dept": "EDUC",
    "num": "512",
    "desc": "Prereq: Admission to graduate study and at least two courses in research and foundations of instructional technology\nCritical review and synthesis of current research trends in educational technology. Designed for students to synthesize knowledge of issues in research, and methods of conducting research in practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Mathematical Problem Solving in K-12 Classrooms",
    "dept": "EDUC",
    "num": "513",
    "desc": "Prereq: 6 credits of mathematics; credit or concurrent enrollment in EDUC 448 or EDUC 497 or EDUC 597\nDevelop problem solving strategies across all strands of mathematics.  Issues surrounding the appropriate role of problem solving in K-12 mathematics classrooms are discussed, including distinctions among teaching \"about,\" \"for,\" and \"through\" problem solving. Emphasis on task modification and mathematical modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Science Teaching and Learning",
    "dept": "EDUC",
    "num": "514",
    "desc": "Prereq: Admission to M.A.T. program\nIntroduction to critical issues facing science education, science education goals reflecting contemporary purposes of schooling, and how people learn science.\n",
    "credits": "1"
  },
  {
    "course_name": "Action Research in Education",
    "dept": "EDUC",
    "num": "515",
    "desc": "Prereq: Admission to graduate study.\nMethods of conducting and communicating action research focused on improving educational practices. Develop first cycle of action plan with purpose of investigating an educational setting. Learn to identify problems to investigate, select appropriate research methods, collect and analyze data, and draw conclusions from research.\n",
    "credits": "3"
  },
  {
    "course_name": "Antiracist Curriculum Development and Implementation",
    "dept": "EDUC",
    "num": "516",
    "desc": "Prereq: 9 credits in Education\nIntroduction to historical, sociological, philosophical and pedagogical foundations of antiracist/multicultural education. Examination of causes of racism, and other forms of discrimination from different theoretical perspectives and experiential exercises.\n",
    "credits": "3"
  },
  {
    "course_name": "Student Teaching",
    "dept": "EDUC",
    "num": "517",
    "desc": "Prereq: Full admission to teacher education or licensed teacher; approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Social Studies-Middle School",
    "dept": "EDUC",
    "num": "517A",
    "desc": "Prereq: GPA 2.5; Admission to teacher education, approval of coordinator during semester before student   teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Physical Sciences",
    "dept": "EDUC",
    "num": "517B",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in physical sciences grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Mathematics",
    "dept": "EDUC",
    "num": "517C",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in mathematics grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Biological Sciences",
    "dept": "EDUC",
    "num": "517D",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in biological sciences grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: World Language",
    "dept": "EDUC",
    "num": "517G",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in world languages, secondary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Earth Sciences",
    "dept": "EDUC",
    "num": "517J",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in earth sciences grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Science - Basic",
    "dept": "EDUC",
    "num": "517M",
    "desc": "Prereq: Full admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in basic sciences grades 5-12.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: International",
    "dept": "EDUC",
    "num": "517N",
    "desc": "Prereq: GPA 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Social Studies-High School",
    "dept": "EDUC",
    "num": "517P",
    "desc": "Prereq: GPA 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Music-Elementary",
    "dept": "EDUC",
    "num": "517R",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Music-Secondary",
    "dept": "EDUC",
    "num": "517S",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Secondary Science Methods I: A Research-Based Framework for Teaching Science",
    "dept": "EDUC",
    "num": "518",
    "desc": "Prereq: EDUC 280M or EDUC 514; undergraduate students must register concurrently for EDUC 347 and EDUC 468J\nDevelopment of a research-based framework for teaching science that includes student goals, congruent student actions, the character and role of science inquiry, teaching behaviors and strategies, contemporary learning theories, and self evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Secondary Science Methods II: Advancing a Research-Based Framework for Teaching Science",
    "dept": "EDUC",
    "num": "519",
    "desc": "Prereq: EDUC 418 or EDUC 518, undergraduate students must register concurrently for EDUC 468K\nAdvancing a research-based framework for teaching science in a variety of school settings; emphasizing the teacher's role, content area reading strategies, science safety and classroom management, issues in using technology, and student assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Bilingualism, Bilingual Education, and U.S. Mexican Youth",
    "dept": "EDUC",
    "num": "520",
    "desc": "Prereq: EDUC 405 or EDUC 406\nIntroduction to research on bilingualism and examination of the social, historical, and political contexts of bilingual education in U.S. schools.  Attention to policy environment, school program structure, mode of classroom instruction, family and community context, and attainment of bilingualism and biculturalism for U.S. Mexican youth.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching and Learning Iowa History",
    "dept": "EDUC",
    "num": "522",
    "desc": "\nMulticultural and social justice focus on Iowa history; different theme each summer. Effective pedagogical and assessment strategies for integrating these themes into K-12 curriculum.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Students who Struggle in Mathematics",
    "dept": "EDUC",
    "num": "523",
    "desc": "Prereq: EDUC 438 or EDUC 448\nExplore and develop an understanding of research-based instructional practices that could be implemented with elementary students who are struggling with learning mathematical concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Secondary Education",
    "dept": "EDUC",
    "num": "526",
    "desc": "Prereq: Senior classification and admission to teacher education program\nIntroduction to secondary education teaching strategies, lesson planning that provides equitable learning opportunities for all students, classroom management, legal aspects of schools, professional and ethical issues, current educational issues, professional learning communities, and social-justice oriented teaching.\n",
    "credits": "3"
  },
  {
    "course_name": "Educational Psychology and the Secondary Classroom",
    "dept": "EDUC",
    "num": "529",
    "desc": "Prereq: Bachelor's degree; admission into a graduate level teacher licensure program\nAnalysis of psychological research theory related to learning, cognition, motivation, individual differences, and teaching techniques.  Student and classroom assessment to facilitate positive learning outcomes.  Adaption and differentiation of instruction to meet individual learners' needs.  This course can only be used for teacher licensure programs.  It is not acceptable for use in meeting the non-licensure M.Ed., M.S. or Ph.D. requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Theories of Learning",
    "dept": "EDUC",
    "num": "533",
    "desc": "\nMajor theories of learning and cognition in educational settings. Emphasis on behavioral, cognitive, constructivist, and sociocultural theories and their implications for educational policy and practice.\n",
    "credits": "3"
  },
  {
    "course_name": "How People Learn: Implications for Teaching Science and Mathematics",
    "dept": "EDUC",
    "num": "541",
    "desc": "Prereq: Bachelor's degree\nCurrent theories of learning and motivation in science and mathematics education and their application to classrooms. Examination of teaching models congruent with learning theory and current research in science and mathematics education.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Pedagogy in Science Education",
    "dept": "EDUC",
    "num": "546",
    "desc": "Prereq: Bachelor's degree\nAdvanced examination of pedagogy, emphasizing teacher behaviors and strategies, methods of self-assessment, action research, and current issues and trends in science education.\n",
    "credits": "3"
  },
  {
    "course_name": "Nature of Science",
    "dept": "EDUC",
    "num": "547",
    "desc": "Prereq: EDUC 280M; concurrent enrollment in EDUC 418 or instructor permission\nThe intersection of issues in the history, philosophy, and sociology of science and their application to and impact on science teaching and learning, science teacher education, and science education research.\n",
    "credits": "3"
  },
  {
    "course_name": "Restructuring Science Activities",
    "dept": "EDUC",
    "num": "548",
    "desc": "Prereq: Admission to teacher education or teaching license\nModification of laboratory activities and other everyday science activities so they are more congruent with how students learn, the nature of science, and national standards.\n",
    "credits": "3"
  },
  {
    "course_name": "Ethnicity and Learning",
    "dept": "EDUC",
    "num": "550",
    "desc": "Prereq: EDUC 332 or EDUC 333; EDUC 406\nExamination of cultural relevance in education. Development and application of strategies and techniques for implementing multicultural goals and multiethnic perspectives in PreK-12 school classroom settings.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Reading and Language Arts",
    "dept": "EDUC",
    "num": "551",
    "desc": "Prereq: Teaching license\nAnalyzing, discussing, and researching the theory and practice of current literacy issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Assessment for Literacy and Learning",
    "dept": "EDUC",
    "num": "552",
    "desc": "Prereq: EDUC 378 or equivalent\nIdentification, analysis and correction of reading problems in five areas: print knowledge, integration of print knowledge, oral reading fluency, vocabulary, and comprehension.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Adolescent Readers with Reading Difficulties",
    "dept": "EDUC",
    "num": "553",
    "desc": "Prereq: Teaching license or senior status\nInstructional strategies for enhancing the fluency, vocabulary and comprehension of adolescents with reading difficulties. Attention to content-area reading materials and strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Literacy, Leadership, and Advocacy",
    "dept": "EDUC",
    "num": "555",
    "desc": "Prereq: Graduate Standing\nExamination of the roles of literacy specialists/coaches in diverse pre-K-12 schools and communities.  Particular focus placed on current theories, research, standards, and policies relative to literacy processes and instruction, including culturally responsive literacy; processes of successful literacy coaching; and methods of supporting teachers and other school personnel in planning, implementing, and evaluating literacy instruction for all students.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrating Technology into Literacy",
    "dept": "EDUC",
    "num": "556",
    "desc": "Prereq: EDUC 201 or EDUC 202; EDUC 377\nMethods and strategies used to integrate technology into K-8 literacy. Examination of the use and evaluation of technology appropriate for elementary literacy classrooms.\n",
    "credits": "3"
  },
  {
    "course_name": "Perspectives on Reading Comprehension",
    "dept": "EDUC",
    "num": "558",
    "desc": "Prereq: Graduate standing\nCritical examination of the topics central to the study of reading comprehension, including processes, development, contexts, motivation, teaching and learning, and assessment. Reading and discussion of research literature in reading comprehension and comprehension instruction.\n",
    "credits": "3"
  },
  {
    "course_name": "Critical Approaches to Teaching Children’s and Adolescent Literature",
    "dept": "EDUC",
    "num": "559",
    "desc": "Prereq: Admission into teacher education program; EDUC 377; prerequisite or concurrent enrollment in EDUC 378.\nResearch and discussion of issues surrounding the classroom use of literature for children and young adults including censorship, diversity, selection, critical literacy and the influences of technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Literacy: Connecting Research, Policy and Practice",
    "dept": "EDUC",
    "num": "565",
    "desc": "Prereq: Graduate standing\nCritical examination of current policy initiatives and reform efforts that affect how literacy is viewed, assessed, and practiced, as well as how literacy professionals are prepared for their roles in public schools and colleges.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Mathematics to Struggling Secondary Learners",
    "dept": "EDUC",
    "num": "567",
    "desc": "Prereq: Secondary teaching experience\nInstructional methods and assessment techniques for secondary students struggling to learn mathematics.  Particular emphasis on current research, practices, and trends in mathematics interventions for at-risk students and students with disabilities.\n",
    "credits": "3"
  },
  {
    "course_name": "New Media Literacies: Understanding Research and Practice",
    "dept": "EDUC",
    "num": "568",
    "desc": "Prereq: Graduate Standing\nDesigned to increase awareness and understanding of critical issues surrounding the evolving concept of literacy and examine the effect that technology has on the literacy we use every day, teach in our schools, and need in order to function as 21st century citizens.\n",
    "credits": "3"
  },
  {
    "course_name": "Historical Perspectives on Technology Equity: Implications for Policy and Practice",
    "dept": "EDUC",
    "num": "577",
    "desc": "Prereq: Graduate Status\nExamination of the definition and origin of the \"digital divide\" and its relationship to the histories of racism, sexism, classism, and imperialism/globalization. Exploration of the historical, political, sociological, and economic factors that engender global inequities. Exploration and analysis of research-based alternative approaches to alleviating technology inequities in educational settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Pedagogy, Equality of Opportunity, and the Education of Blacks in the United States",
    "dept": "EDUC",
    "num": "578",
    "desc": "Prereq: Graduate or senior level status or permission of instructor\nExamination of the historical, social, economic, political, and legal contexts of the education of African Americans in the U.S. Educational theories and philosophies, Critical Race Theory and Black Feminist Thought form the framework for investigating broad-based, multiple issues of education for African Americans in the U.S. as they are situated in the prevailing dominant views.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in the Foundations of Education in the United States",
    "dept": "EDUC",
    "num": "580",
    "desc": "Prereq: Admission to graduate licensure program in teacher education or permission of instructor\nIntroduction to the historical and contemporary landscape of schooling in the United States. Emphasis is placed on topics and tensions in the relationship between school and society (e.g. equity of access to education and competing purposes of education) and the implications of these topics and tensions for teaching and learning in public schools. Designed for students in a graduate licensure program.\n",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Education",
    "dept": "EDUC",
    "num": "581",
    "desc": "\nIntroduction to Western philosophy of education. Emphasis is placed on enduring debates about the purposes(s) of education in a just society. Readings include classic and contemporary texts.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Public Schooling in the United States",
    "dept": "EDUC",
    "num": "582",
    "desc": "Prereq: Graduate classification\nExamination of the history of public schools in the United States. Historicizes the development of an educational system marked by both profound expectations and extreme inequalities. Readings include primary and secondary materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Tutoring in Reading",
    "dept": "EDUC",
    "num": "588",
    "desc": "Prereq: Concurrent enrollment in or completion of one course in corrective reading; diagnosis and correction of reading problems; graduate status required for EDUC 588\nUsing formal and informal diagnostic procedures to plan and implement individualized reading instruction. Field experience in tutoring and a related research project.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "EDUC",
    "num": "590",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Curriculum",
    "dept": "EDUC",
    "num": "590A",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Educational Technology",
    "dept": "EDUC",
    "num": "590B",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Science Education",
    "dept": "EDUC",
    "num": "590C",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Secondary Education",
    "dept": "EDUC",
    "num": "590D",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Social and Cultural Studies",
    "dept": "EDUC",
    "num": "590F",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Mathematics Education",
    "dept": "EDUC",
    "num": "590G",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Elementary Education",
    "dept": "EDUC",
    "num": "590I",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: World Language Education",
    "dept": "EDUC",
    "num": "590J",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Educational Psychology",
    "dept": "EDUC",
    "num": "590K",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Social Studies Education",
    "dept": "EDUC",
    "num": "590L",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Literacy Education",
    "dept": "EDUC",
    "num": "590M",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Level Pre-Student Teaching Experience",
    "dept": "EDUC",
    "num": "591",
    "desc": "Prereq: 15 graduate credits in special area; admission to teacher education.\nSupervised pre-student teaching experience in secondary schools. Supervision level 3.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Elementary Education",
    "dept": "EDUC",
    "num": "591C",
    "desc": "Prereq: 15 graduate credits in special area\nSupervised on-the-job field experience in special area.\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Level Pre-Student Teaching Experience: Secondary Science",
    "dept": "EDUC",
    "num": "591D",
    "desc": "Prereq: 15 graduate credits in specialty area; admission to teacher education\nSupervised pre-student teaching experience in secondary science education. Supervision level 3.\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Level Pre-Student Teaching Experience: Secondary Mathematics Education",
    "dept": "EDUC",
    "num": "591G",
    "desc": "Prereq: 15 graduate credits in specialty area; admission to teacher education\nSupervised pre-student teaching experience in mathematics education. Supervision level 3.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Literacy",
    "dept": "EDUC",
    "num": "591M",
    "desc": "Prereq: 15 graduate credits in special area\nSupervised on-the-job field experience in special area.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: College Teaching",
    "dept": "EDUC",
    "num": "591N",
    "desc": "Prereq: 15 graduate credits in special area.\nSupervised on-the-job field experience in special area.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops",
    "dept": "EDUC",
    "num": "593",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Curriculum",
    "dept": "EDUC",
    "num": "593A",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Educational Technology",
    "dept": "EDUC",
    "num": "593B",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Science Education",
    "dept": "EDUC",
    "num": "593C",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Secondary Education",
    "dept": "EDUC",
    "num": "593D",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Social and Cultural Studies",
    "dept": "EDUC",
    "num": "593F",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Mathematics Education",
    "dept": "EDUC",
    "num": "593G",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Elementary Education",
    "dept": "EDUC",
    "num": "593I",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: World Language Education",
    "dept": "EDUC",
    "num": "593J",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Educational Psychology",
    "dept": "EDUC",
    "num": "593K",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Social Studies Education",
    "dept": "EDUC",
    "num": "593L",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops: Literacy Education",
    "dept": "EDUC",
    "num": "593M",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Contemporary Curriculum Theory and Principles",
    "dept": "EDUC",
    "num": "594",
    "desc": "Prereq: Graduate standing\nTheoretical and historical perspectives of contemporary curriculum; social, cultural, and epistemological aspects of curriculum theory; diverse philosophical positions and approaches to understanding curriculum as it relates to educational settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Disciplinary Literacy",
    "dept": "EDUC",
    "num": "595",
    "desc": "Prereq: EDUC 204 and junior classification.\nAnalysis and application of strategies to enhance students' disciplinary literacy development in middle and secondary school setting.  Research paper related to a course topic.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Secondary School Mathematics",
    "dept": "EDUC",
    "num": "597",
    "desc": "Prereq: 15 credits in college mathematics; and either in a teacher licensure program or in the process of applying, concurrent enrollment in EDUC 426 or EDUC 526\nDevelop an understanding of instructional planning, lesson implementation, and assessment in grades 5-12 mathematics, with a focus on reform-based mathematics, equity, and conceptual understanding.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "EDUC",
    "num": "599",
    "desc": "Prereq: 9 graduate credits in Education\nCreative Component.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Curriculum",
    "dept": "EDUC",
    "num": "599A",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Educational Technology",
    "dept": "EDUC",
    "num": "599B",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Science Education",
    "dept": "EDUC",
    "num": "599C",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Secondary Education",
    "dept": "EDUC",
    "num": "599D",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Social and Cultural Studies",
    "dept": "EDUC",
    "num": "599F",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Mathematics Education",
    "dept": "EDUC",
    "num": "599G",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Elementary Education",
    "dept": "EDUC",
    "num": "599I",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: World Language Education",
    "dept": "EDUC",
    "num": "599J",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Educational Psychology",
    "dept": "EDUC",
    "num": "599K",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Social Studies Education",
    "dept": "EDUC",
    "num": "599L",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Literacy Education",
    "dept": "EDUC",
    "num": "599M",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "1"
  },
  {
    "course_name": "Educational Inquiry in Action",
    "dept": "EDUC",
    "num": "602",
    "desc": "Prereq: EDUC 601\nOpportunities to learn about a variety of faculty research in the School of Education, engage faculty in conversation about their research, and continue reflecting on the theory and practice of educational inquiry.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Learning Environments Design",
    "dept": "EDUC",
    "num": "603",
    "desc": "Prereq: EDUC 503\nExploration of advanced aspects of the learning environments design process. Application of analysis, design, development and production, evaluation, implementation, and project management principles. Theory and research in educational technology provides the foundation for design decisions. Focus on current trends in learning environment design and the production and use of educational technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Learning in Teacher Education",
    "dept": "EDUC",
    "num": "610",
    "desc": "Prereq: EDUC 505\nResearch on using technology in teacher education programs. Application examples studied. Field component involving relating material from class to a teacher education situation.\n",
    "credits": "2"
  },
  {
    "course_name": "Philosophical Foundations of Educational Technology",
    "dept": "EDUC",
    "num": "611",
    "desc": "Prereq: 12 graduate credits in Education\nExploration of philosophies of science that serve as foundations for research and practice in instructional technology, including positivism, post-positivism, interpretivism/constructivism, and critical theory. The roles of language, nature of truth and reality, and acceptable ways of knowing are explored in terms of their implications for instructional technology design, delivery, research, and scholarship.\n",
    "credits": "3"
  },
  {
    "course_name": "Socio-psychological Foundations of Educational Technology",
    "dept": "EDUC",
    "num": "612",
    "desc": "Prereq: 12 graduate credits in Education\nExamining socio-psychological theories of educational technology, their historical development, and their implications for the research and design of learning and instructional environments. Emphasis on cognitive and social constructivist paradigms and the creation and use of learning environments supported by technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar",
    "dept": "EDUC",
    "num": "615",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Curriculum",
    "dept": "EDUC",
    "num": "615A",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Educational Technology",
    "dept": "EDUC",
    "num": "615B",
    "desc": "\nSelected topics in educational technology; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Science Education",
    "dept": "EDUC",
    "num": "615C",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Secondary Education",
    "dept": "EDUC",
    "num": "615D",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Social and Cultural Studies",
    "dept": "EDUC",
    "num": "615F",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Mathematics Education",
    "dept": "EDUC",
    "num": "615G",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Elementary Education",
    "dept": "EDUC",
    "num": "615I",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: World Language Education",
    "dept": "EDUC",
    "num": "615J",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Educational Psychology",
    "dept": "EDUC",
    "num": "615K",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Social Studies Education",
    "dept": "EDUC",
    "num": "615L",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Literacy Education",
    "dept": "EDUC",
    "num": "615M",
    "desc": "\nSelected topics in curriculum and instruction; an analysis of research potential; evaluation of impact upon the profession; implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Special Topics",
    "dept": "EDUC",
    "num": "690",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Curriculum",
    "dept": "EDUC",
    "num": "690A",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Educational Technology",
    "dept": "EDUC",
    "num": "690B",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Science Education",
    "dept": "EDUC",
    "num": "690C",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Secondary Education",
    "dept": "EDUC",
    "num": "690D",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Social and Cultural Studies",
    "dept": "EDUC",
    "num": "690F",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Mathematics Education",
    "dept": "EDUC",
    "num": "690G",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Elementary Education",
    "dept": "EDUC",
    "num": "690I",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: World Language Education",
    "dept": "EDUC",
    "num": "690J",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Educational Psychology",
    "dept": "EDUC",
    "num": "690K",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Social Studies Education",
    "dept": "EDUC",
    "num": "690L",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Literacy Education",
    "dept": "EDUC",
    "num": "690M",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "EDUC",
    "num": "699",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Curriculum",
    "dept": "EDUC",
    "num": "699A",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Educational Technology",
    "dept": "EDUC",
    "num": "699B",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Science Education",
    "dept": "EDUC",
    "num": "699C",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Secondary Education",
    "dept": "EDUC",
    "num": "699D",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Social and Cultural Studies",
    "dept": "EDUC",
    "num": "699F",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Mathematics Education",
    "dept": "EDUC",
    "num": "699G",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Elementary Education",
    "dept": "EDUC",
    "num": "699I",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: World Language Education",
    "dept": "EDUC",
    "num": "699J",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Educational Psychology",
    "dept": "EDUC",
    "num": "699K",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Social Studies Education",
    "dept": "EDUC",
    "num": "699L",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Literacy Education",
    "dept": "EDUC",
    "num": "699M",
    "desc": "Prereq: 9 graduate credits in Education\n",
    "credits": "arr"
  },
  {
    "course_name": "Professional Programs Orientation",
    "dept": "E E",
    "num": "166",
    "desc": "\n(1-0) Overview of the nature and scope of electrical engineering and computer engineering professions. Overview of portfolios. Departmental rules, advising center operations, degree requirements, program of study planning, career options, and student organizations.\n",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Electrical Engineering and Problem-Solving I",
    "dept": "E E",
    "num": "185",
    "desc": "Prereq: MATH 143 or satisfactory scores on mathematics placement examinations; credit or enrollment in MATH 165\nProject based examples from electrical engineering. Systematic thinking process for engineering problem solving. Group problem solving. Mathematical, conceptual and computer based projects. Solving engineering problems and presenting solutions through technical reports and oral presentations. Solutions of engineering problems using computation tools and basic programming.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Electrical Engineering and Problem Solving II",
    "dept": "E E",
    "num": "186",
    "desc": "Prereq: E E 185\nProject based and hands on continuation of 185. Group skills needed to work effectively in teams. Individual interactive skills for small and large groups. Learning to use tools and methods for solving electrical engineering problems.\n",
    "credits": "1"
  },
  {
    "course_name": "Electric Circuits",
    "dept": "E E",
    "num": "201",
    "desc": "Prereq: Credit or enrollment in MATH 267 and PHYS 222\nEmphasis on mathematical tools. Circuit elements (resistors, inductors, capacitors) and analysis methods including power and energy relationships. Network theorems. DC, sinusoidal steady-state, and transient analysis. AC power. Frequency response. Two port models. Diodes, PSPICE. Laboratory   instrumentation and experimentation.\n  Credit for only E E 201 or 442 may be used towards graduation.",
    "credits": "4"
  },
  {
    "course_name": "Signals and Systems I",
    "dept": "E E",
    "num": "224",
    "desc": "Prereq: E E 201, MATH 267, PHYS 222\nMathematical preliminaries. Introduction to signals and systems. Signal manipulations. System properties. LTI systems, impulse response and convolution. Fourier Series representation and properties. Continuous and discrete-time Fourier Transforms and properties. Sampling and reconstruction. Modulation and demodulation. Applications and demonstrations using Matlab.\n",
    "credits": "4"
  },
  {
    "course_name": "Electronic Circuits and Systems",
    "dept": "E E",
    "num": "230",
    "desc": "Prereq: E E 201, MATH 267, PHYS 222\nFrequency domain characterization of electronic circuits and systems, transfer functions, sinusoidal steady state response. Time domain models of linear and nonlinear electronic circuits, linearization, small signal analysis. Stability and feedback circuits. Operational amplifiers, device models, linear and nonlinear applications, transfer function realizations. A/D and D/A converters, sources of distortions, converter linearity and spectral characterization, applications. Design and laboratory instrumentation and measurements.\n",
    "credits": "4"
  },
  {
    "course_name": "Transfer Orientation",
    "dept": "E E",
    "num": "261",
    "desc": "\nIntroduction to the College of Engineering and the engineering profession specifically for transfer students. Information concerning university and college policies, procedures, and resources.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Problem Solving Methods and Tools for Electrical Engineering",
    "dept": "E E",
    "num": "285",
    "desc": "\nIntegration  of field-specific computational tools for practically solving electrical engineering problems.  Methods for systematically reducing problems into sequential steps compatible with  computer based tools.  Structuring computer programs for efficiency and maintainability.  Integration of multi-platform operating systems and multi-vendor tools for solving engineering problems.  Hands-on laboratory experiences using Matlab, C, and other computational tools.\n",
    "credits": "4"
  },
  {
    "course_name": "Program Discovery",
    "dept": "E E",
    "num": "294",
    "desc": "Prereq: CPR E 166 or E E 166\nThe roles of professionals in computer and electrical engineering.  Relationship of coursework to industry and academic careers.  Issues relevant to today's world.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Energy Systems and Power Electronics",
    "dept": "E E",
    "num": "303",
    "desc": "Prereq: MATH 267, PHYS 222; credit or enrollment in E E 230\nStructure of competitive electric energy systems.  System operation and economic optimization. Mutual inductance, transformers. Synchronous generators. Balanced three-phase circuit analysis and power calculations. Network calculations and associated numerical algorithms. Two-port circuits. Voltage regulation. Resonance and power factor correction. DC and induction motors. Power electronic circuit applications to power supplies and motor drives.\n",
    "credits": "3"
  },
  {
    "course_name": "Electromagnetic Fields and Waves",
    "dept": "E E",
    "num": "311",
    "desc": "Prereq: E E 201, MATH 265, PHYS 222, credit or enrollment in MATH 267\nFundamentals and applications of electric and magnetic fields and materials. Electrostatics and magentostatics, potentials, capacitance and inductance, energy, force, torque. Uniform plane electromagnetic waves, Poynting vector. Transmission lines: transient and sinusoidal steady-state conditions, reflection coefficient.\n",
    "credits": "4"
  },
  {
    "course_name": "Electromagnetics for non Electrical Engineers",
    "dept": "E E",
    "num": "314",
    "desc": "Prereq: PHYS 222, PHYS 112, or equivalent\nConceptual study of electomagnetism and its application in engineering and related fields. EM fundamentals, EM spectrum, radiation, radiating systems, wireless, modern concepts of physics, quantum computing, transmission lines, high speed effects, waveguides, GPS and other related phenomena will be discussed and explained with the application in mind.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication Systems I",
    "dept": "E E",
    "num": "321",
    "desc": "Prereq: E E 224\nFrequency domain analysis, spectral filtering, bandwidth. Linear modulation systems. Angle modulation systems. Phase locked loop, super-heterodyne receiver. Sampling and pulse code modulation. Digital data transmission, line coding, pulse shaping, multiplexing.\n",
    "credits": "3"
  },
  {
    "course_name": "Probabilistic Methods for Electrical Engineers",
    "dept": "E E",
    "num": "322",
    "desc": "Prereq: E E 224\nIntroduction to probability with applications to electrical engineers. Sets and events, probability space, conditional probability, total probability and Bayes' rule. Discrete and continuous random variables, cumulative distribution function, probability mass and density functions, expectation, moments, moment generating function, multiple random variables, functions of random variables. Elements of statistics, hypothesis testing, confidence intervals, least squares. Introduction to random processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Signals and Systems II",
    "dept": "E E",
    "num": "324",
    "desc": "Prereq: E E 224\nLaplace and z-Transforms, properties and inverses.  Applications to LTI systems and analog/digital filters.  Feedback systems and stability. State-space representation and analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "Integrated Electronics",
    "dept": "E E",
    "num": "330",
    "desc": "Prereq: E E 201, credit or enrollment in E E 230, CPR E 281\nSemiconductor technology for integrated circuits. Modeling of integrated devices including diodes, BJTs, and MOSFETs. Physical layout. Circuit simulation. Digital building blocks and digital circuit synthesis. Analysis and design of analog building blocks. Laboratory exercises and design projects   with CAD tools and standard cells.\n",
    "credits": "4"
  },
  {
    "course_name": "Semiconductor Materials and Devices",
    "dept": "E E",
    "num": "332",
    "desc": "Prereq: PHYS 222; MAT E majors: MAT E 317; CPR E and E E majors: E E 230\nIntroduction to semiconductor material and device physics. Quantum mechanics and band theory of semiconductors. Charge carrier distributions, generation/recombination, transport properties. Physical and electrical properties and fabrication of semiconductor devices such as MOSFETs, bipolar transistors, laser diodes and LED's.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Systems Design",
    "dept": "E E",
    "num": "333",
    "desc": "Prereq: E E 230, credit or enrollment in CPR E 288\nFurther topics in electronic systems design: Use of sensors and actuators. High-power amplifying and switching components. Linear and switched-mode power supplies. Linear and switched-mode amplifiers. Interfacing electronic components with programmable microcontrollers. Printed circuit board technology and design tools. Laboratory exercises and design projects incorporating printed circuit technology.\n",
    "credits": "4"
  },
  {
    "course_name": "Analysis of Energy Systems",
    "dept": "E E",
    "num": "351",
    "desc": "Prereq: PHYS 222\nEnergy-scientific, engineering and economic foundations. Energy utilization-global and national. Sectoral analysis of energy consumption. Relationship of energy consumption and production to economic growth and environment. Technology for energy production. Economic evaluation of energy utilization and production. Scientific basis for global warming. Environmental impact of energy production and utilization. Renewable energy.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Engineering and International Development",
    "dept": "E E",
    "num": "388",
    "desc": "Prereq: Junior classification in engineering\nMulti-disciplinary approach to sustainable engineering and international development, sustainable development, appropriate design and engineering, feasibility analysis, international aid, business development, philosophy and politics of technology, and ethics in engineering. Engineering-based projects from problem formulation through implementation. Interactions with partner community organizations or international partners such as nongovernment organizations (NGOs). Course readings, final project/design report.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Open Laboratory and Design Studio",
    "dept": "E E",
    "num": "391",
    "desc": "Prereq: E E 224\nStudio-based activity (guided problem-based learning and design) focusing on elements of design, measurement, data capture, and data interpretation. Team building, engineering professionalism, engineering process of review and critique, and presentation. Open design activities that may include working with other studios.\n",
    "credits": "2"
  },
  {
    "course_name": "Program Exploration",
    "dept": "E E",
    "num": "394",
    "desc": "Prereq: CPR E 294 or E E 294\nExploration of academic and career fields for electrical and computer engineers.  Examination of professionalism in the context of engineering and technology with competencies based skills.  Introduction to professional portfolio development and construction.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Summer Internship",
    "dept": "E E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education (Co-op)",
    "dept": "E E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period.  One semester per academic or calendar year.  Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Microwave Engineering",
    "dept": "E E",
    "num": "414",
    "desc": "Prereq: E E 230, E E 311\nPrinciples, analyses, and instrumentation used in the microwave portion of the electromagnetic spectrum. Wave theory in relation to circuit parameters. S parameters, couplers, discontinuities, and microwave device equivalent circuits. RF amplifier design, microwave sources, optimum noise figure and maximum power designs. Microwave filters and oscillators.\n",
    "credits": "4"
  },
  {
    "course_name": "Electromagnetic Radiation, Antennas, and Propagation",
    "dept": "E E",
    "num": "417",
    "desc": "Prereq: E E 311\nFundamental antenna concepts. Radiation from wire-and aperture-type sources. Radio transmission formulas. Wave and antenna polarization. Antenna arrays. Modern antenna topics. Practical antenna design. Antenna noise. Radiowave propagation in the presence of the earth and its atmosphere. Antenna measurements and computer aided analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "High Speed System Engineering Measurement and Testing",
    "dept": "E E",
    "num": "418",
    "desc": "Prereq: E E 230 and E E 311\nMeasurement of high speed systems and mixed signal systems.  Measurement accuracy and error.  Network analysis and spectrum analysis used in high speed measurement and testing.  Test specification process and parametric measurement.  Sampling and digital signal processing concepts.  Design for testability.  Testing equipment. Applications.\n",
    "credits": "4"
  },
  {
    "course_name": "Magnetism and Magnetic Materials",
    "dept": "E E",
    "num": "419",
    "desc": "Prereq: E E 311 or MAT E 317 or PHYS 364\nMagnetic fields, flux density and magnetization. Magnetic materials, magnetic measurements. Magnetic properties of materials. Domains, domain walls, domain processes, magnetization curves and hysteresis. Types of magnetic order, magnetic phases and critical phenomena. Magnetic moments of electrons, theory of electron magnetism. Technological application, soft magnetic materials for electromagnets, hard magnetic materials, permanent magnets, magnetic recording technology, magnetic measurements of properties for materials evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication Systems II",
    "dept": "E E",
    "num": "422",
    "desc": "Prereq: E E 321, E E 322, enrollment in E E 423\nIntroduction to probability and random processes; Performance of analog systems with noise; Performance of digital communication with noise; optimum receivers, transmission impairments, and error rates; Introduction to information theory and coding: source coding, channel coding, channel capacity.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication Systems Laboratory",
    "dept": "E E",
    "num": "423",
    "desc": "Prereq: E E 321, enrollment in E E 422\nConstruction and evaluation of modulators, demodulators and other components for analog and digital communications. Design, simulate,and evaluate wireless communication systems and their key components. Noise measurement.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Digital Signal Processing",
    "dept": "E E",
    "num": "424",
    "desc": "Prereq: E E 224\nSampling and reconstruction. Concepts and mathematical tools in discrete-time signal processing with examples from digital signal processing and communications.  Discrete-time correlation and matched-filter receivers.  Discrete Fourier transform (DFT).  Fast Fourier algorithms. Z transforms.  Design of finite impulse response (FIR) and infinite impulse response (IIR) filters.  Realizations of discrete-time systems and quantization effects.  Multi-rate signal processing.  Laboratory experiments illustrating DSP implementations and applications.\n",
    "credits": "4"
  },
  {
    "course_name": "Microelectronics Fabrication Techniques",
    "dept": "E E",
    "num": "432",
    "desc": "Prereq: credit or enrollment in E E 332\nTechniques used in modern integrated circuit fabrication, including diffusion, oxidation, ion implantation, lithography, evaporation, sputtering, chemical-vapor deposition, and etching. Process integration. Process evaluation and final device testing. Extensive laboratory exercises utilizing fabrication methods to build electronic devices. Use of computer simulation tools for predicting processing outcomes. Recent advances in processing CMOS ICs and micro-electro-mechanical systems (MEMS).\n",
    "credits": "4"
  },
  {
    "course_name": "Analog VLSI Circuit Design",
    "dept": "E E",
    "num": "435",
    "desc": "Prereq: E E 330\nBasic analog integrated circuit and system design including design space exploration, performance enhancement strategies, operational amplifiers, references, integrated filters, and data converters.\n",
    "credits": "4"
  },
  {
    "course_name": "Electronic Properties of Materials",
    "dept": "E E",
    "num": "437",
    "desc": "Prereq: E E 332 or MAT E 317 or PHYS 322\nReview of classical and quantum mechanical descriptions of electrons in solids, band theory, metallic conduction, lattice vibrations, semiconductors, semiconductor devices, dielectrics, polarization, dielectric relaxation, crystal anisotropy, ferroelectricity, piezoelectricity, superconductivity, magnetism, device applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Optoelectronic Devices and Applications",
    "dept": "E E",
    "num": "438",
    "desc": "Prereq: E E 311, E E 332\nTransmission and reflection of electromagnetic plane waves. Propagation in dielectric and fiber optic waveguides. LED and laser operating principles and applications. Photodetectors and solar cells. Optical modulation and switching.\n",
    "credits": "3"
  },
  {
    "course_name": "Nanoelectronics",
    "dept": "E E",
    "num": "439",
    "desc": "Prereq: E E 332 or MAT E 334\nConcepts of quantum mechanics relevant to nanoelectronic devices, including quantization, tunneling, and transport; overview of some of the leading technologies for nanoelectronics, including carbon nanotubes, quantum dots, and molecular transistors; fabrication methods for building nanoelectronic devices.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Circuits and Instruments",
    "dept": "E E",
    "num": "442",
    "desc": "Prereq: PHYS 222, MATH 267\nHalf-semester course. Basic circuit analysis using network theorems with time domain and Laplace   transform techniques for resistive, resistive-inductive, resistive-capacitive, and resistive-  inductive-capacitive circuits. Transient circuit behavior. Basic operational amplifiers and   applications. Familiarization with common E E instrumentation and demonstration of basic   principles.\n  Credit for only 201 or 442 may be counted toward graduation; credit for 442 will not count toward graduation for E E or Cpr E majors.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to AC Circuits and Motors",
    "dept": "E E",
    "num": "448",
    "desc": "Prereq: E E 442\nHalf-semester course. Basics of DC machines, stepper motors, AC induction motors, and synchronous generators. AC steady state analysis, transformers, and three-phase circuit analysis.\n",
    "credits": "2"
  },
  {
    "course_name": "Biosensing",
    "dept": "E E",
    "num": "450",
    "desc": "Prereq: B M E 220\nOverview of biosensors and bioanalytical challenges; designing for performance including various analytical problems, ion-selective membranes, characteristics of enzymes and basics of bioaffinity sensing; fundamentals of bioselective layers including depositing films and membranes, surfaces for immobilization and bioselective agents; survey of different biosensing technologies including electroanalytical, biomembrane, optical, and acoustic-wave based sensors.\n",
    "credits": "3"
  },
  {
    "course_name": "Biosensing Laboratory",
    "dept": "E E",
    "num": "450L",
    "desc": "Prereq: B M E 220, concurrent enrollment in B M E 450\nLaboratory course accompanying B M E 450. Design, fabrication, and characterization of various electrical, chemical, polymer, optical and acoustic sensors.\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Acoustics",
    "dept": "E E",
    "num": "451",
    "desc": "Prereq: PHYS 221 and MATH 266 or MATH 267\nThe basics of acoustic wave propagation in fluids with an emphasis on sound propagation in air. Topics include transmission and reflection of sound at a boundary; role of acoustic sources in directing sound fields; diffraction of sound around solid objects; reverberation of sound in a room; and the measurement of sound fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Electrical Machines and Power Electronic Drives",
    "dept": "E E",
    "num": "452",
    "desc": "Prereq: E E 303, E E 324\nBasic concepts of electromagnetic energy conversion. DC motors and three-phase induction motors. Basic introduction to power electronics. Adjustable speed drives used for control of DC, induction, and AC motors. Experiments with converter topologies, DC motors, AC motors and adjustable speed drives.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Energy Distribution Systems",
    "dept": "E E",
    "num": "455",
    "desc": "Prereq: E E 303, credit or registration in E E 324\nOverhead and underground distribution system descriptions and characteristics, load descriptions and characteristics, overhead line and underground cable models, distribution transformers, power flow and fault analysis, overcurrent protection, power factor correction, system planning and automation, and economics in a deregulated environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Power System Analysis I",
    "dept": "E E",
    "num": "456",
    "desc": "Prereq: E E 303, credit or registration in E E 324\nPower transmission lines and transformers, synchronous machine modeling, network analysis, power system representation, load flow.\n",
    "credits": "3"
  },
  {
    "course_name": "Power System Analysis II",
    "dept": "E E",
    "num": "457",
    "desc": "Prereq: E E 303, credit or registration in E E 324\nPower system protection, symmetrical components, faults, stability. Power system operations including the new utility environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Economic Systems for Electric Power Planning",
    "dept": "E E",
    "num": "458",
    "desc": "Prereq: E E 303 or ECON 301\nEvolution of electric power industry. Power system operation and planning and related information systems. Linear and integer optimization methods.  Short-term electricity markets and locational marginal prices. Risk management and financial derivatives. Basics of public good economics. Cost recovery models including tax treatment for transmission investments.\n",
    "credits": "3"
  },
  {
    "course_name": "Electromechanical Wind Energy Conversion and Grid Integration",
    "dept": "E E",
    "num": "459",
    "desc": "Prereq: Credit or enrollment in E E 452, E E 456\nSummary of industry status and expected growth; power extraction from the air stream; operation and modeling of electric machines, and power electronics topologies for wind energy conversion; analysis of machine-grid power electronic circuits, controller interface, and collector (distribution) networks; treatment of harmonics, flicker, over/under-voltages, filters, low-voltage ride-through, and reactive compensation; relaying; effects on transmission expansion, planning and grid operation and coordination including variability, frequency control, reserves, and electricity markets; overview of storage technologies and hybrid configurations.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital VLSI Design",
    "dept": "E E",
    "num": "465",
    "desc": "Prereq: E E 330\nDigital design of integrated circuits employing very large scale integration (VLSI) methodologies. Technology considerations in design. High level hardware design languages, CMOS logic design styles, area-energy-delay design space characterization, datapath blocks: arithmetic and memory, architectures and systems on a chip (SOC) considerations. VLSI chip hardware design project.\n",
    "credits": "4"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "E E",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design II",
    "dept": "E E",
    "num": "467",
    "desc": "Prereq: Student must be within two semesters of graduation or receive permission of instructor.\nBuild and test of a conceptual design. Detail design, manufacturability, test criteria and procedures. Application of design tools such as CAD and CAM and manufacturing techniques such as rapid prototyping. Development and testing of a full-scale prototype with appropriate documentation in the form of design journals, written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Automatic Control Systems",
    "dept": "E E",
    "num": "475",
    "desc": "Prereq: E E 324\nStability and performance analysis of automatic control systems. The state space, root locus, and frequency response methods for control systems design. PID control and lead-lag compensation. Computer tools for control system analysis and design.\n",
    "credits": "3"
  },
  {
    "course_name": "Control System Simulation",
    "dept": "E E",
    "num": "476",
    "desc": "Prereq: E E 475\nComputer aided techniques for feedback control system design, simulation, and implementation.\n",
    "credits": "3"
  },
  {
    "course_name": "Eddy Current Nondestructive Evaluation",
    "dept": "E E",
    "num": "488",
    "desc": "Prereq: MATH 265 and (MAT E 216 or MAT E 273 or MAT E 392 or E E 311 or PHYS 364)\nElectromagnetic fields of various eddy current probes. Probe field interaction with conductors, cracks and other material defects. Ferromagnetic materials. Layered conductors. Elementary inversion of probe signals to characterize defects. Special techniques including remote-field, transient, potential drop nondestructive evaluation and the use of Hall sensors. Practical assignments using a 'virtual' eddy current instrument will demonstrate key concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of Remote Sensing Technologies",
    "dept": "E E",
    "num": "489",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nElectromagnetic-radiation principles, active and passive sensors, multispectral and hyperspectral sensors, imaging radar, SAR, thermal imaging, lidar. Examples of applications. Also offered online S.\n",
    "credits": "3"
  },
  {
    "course_name": "Satellite Remote Sensing Laboratory",
    "dept": "E E",
    "num": "489L",
    "desc": "Prereq: Completion or concurrent enrollment in MTEOR/GEOL/NREM/EE 489/589\nProcessing and analysis of satellite sensor data (optical and radar). Provides practical applications in an environmental context.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "E E",
    "num": "490",
    "desc": "Prereq: Senior classification in electrical engineering\nInvestigation of an approved topic commensurate with the student's prerequisites.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "E E",
    "num": "490H",
    "desc": "Prereq: Senior classification in electrical engineering\nInvestigation of an approved topic commensurate with the student's prerequisites.\n",
    "credits": "arr"
  },
  {
    "course_name": "Senior Design Project I and Professionalism",
    "dept": "E E",
    "num": "491",
    "desc": "Prereq: E E 322 or CPR E 308, completion of 24 credits in the E E core professional program or 29 credits in the Cpr E core professional program, ENGL 314\nPreparing for entry to the workplace. Selected professional topics. Use of technical writing skills in developing project plan and design report; design review presentation. First of two-semester team-oriented, project design and implementation experience.\n",
    "credits": "3"
  },
  {
    "course_name": "Senior Design Project II",
    "dept": "E E",
    "num": "492",
    "desc": "Prereq: CPR E 491 or E E 491\nSecond semester of a team design project experience. Emphasis on the successful implementation and demonstration of the design completed in E E 491 or CPR E 491 and the evaluation of project results. Technical writing of final project report; oral presentation of project achievements; project poster.\n",
    "credits": "2"
  },
  {
    "course_name": "Portfolio Assessment",
    "dept": "E E",
    "num": "494",
    "desc": "Prereq: CPR E 394 or E E 394, credit or enrollment in CPR E 491 or E E 491\nPortfolio update and evaluation. Portfolios as a tool to enhance career opportunities.\n",
    "credits": "R"
  },
  {
    "course_name": "Modern Optics",
    "dept": "E E",
    "num": "496",
    "desc": "Prereq: Credit or enrollment in PHYS 322, PHYS 365, and PHYS 480\nReview of wave and electromagnetic theory; topics selected from: reflection/refraction, interference, geometrical optics, Fourier analysis, dispersion, coherence, Fraunhofer and Fresnel diffraction, holography, quantum optics, nonlinear optics.\n",
    "credits": "3"
  },
  {
    "course_name": "Analog and Mixed-Signal VLSI Circuit Design Techniques",
    "dept": "E E",
    "num": "501",
    "desc": "Prereq: E E 435\nDesign techniques for analog and mixed-signal VLSI circuits. Amplifiers; operational amplifiers, transconductance amplifiers, finite gain amplifiers and current amplifiers. Linear building blocks; differential amplifiers, current mirrors, references, cascading and buffering. Performance characterization of linear integrated circuits; offset, noise, sensitivity and stability. Layout considerations, simulation, yield and modeling for high-performance linear integrated circuits.\n",
    "credits": "4"
  },
  {
    "course_name": "CMOS and BiCMOS Data Conversion Circuits",
    "dept": "E E",
    "num": "505",
    "desc": "Prereq: E E 501\nTheory, design and applications of data conversion circuits (A/D and D/A converters) including: architectures, characterization, quantization effects, conversion algorithms, spectral performance, element matching, design for yield, and practical comparators, implementation issues.\n",
    "credits": "4"
  },
  {
    "course_name": "Design of CMOS Phase-Locked Loops",
    "dept": "E E",
    "num": "506",
    "desc": "Prereq: E E 435 or E E 501 or instructor approval\nAnalysis and design of phase-locked loops implemented in modern CMOS processes including: architectures, performance metrics, and characterization; noise and stability analysis; and design issues of phase-frequency detectors, charge pumps, loop filters (passive and active), voltage controlled oscillators, and frequency dividers.\n",
    "credits": "4"
  },
  {
    "course_name": "VLSI Communication Circuits",
    "dept": "E E",
    "num": "507",
    "desc": "Prereq: E E 435 or E E 501\nPhase-locked loops, frequency synthesizers, clock and data recovery circuits, theory and implementation of adaptive filters, low-noise amplifiers, mixers, power amplifiers, transmitter and receiver architectures.\n",
    "credits": "4"
  },
  {
    "course_name": "Filter Design and Applications",
    "dept": "E E",
    "num": "508",
    "desc": "Prereq: E E 501\nFilter design concepts. Approximation and synthesis. Transformations. Continuous-time and discrete time filters. Discrete, active and integrated synthesis techniques.\n",
    "credits": "4"
  },
  {
    "course_name": "Mixed-Signal IC Testing and Built In Self Test",
    "dept": "E E",
    "num": "509",
    "desc": "Prereq: E E 424 or equivalent and E E 435 or E E 501\nIntroduction to mixed-signal IC testing; measurement uncertainty and test validity; IEEE standard test algorithms; high performance test and built-in self test challenges; new mixed-signal test algorithms and techniques to reduce data acquisition to relax instrumentation requirements, to simplify test setup, to improve test validity, and/or to enable co-testing of heterogeneous functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Electromagnetics",
    "dept": "E E",
    "num": "510",
    "desc": "Prereq: E E 311\n",
    "credits": "1"
  },
  {
    "course_name": "Modern Optical Communications",
    "dept": "E E",
    "num": "511",
    "desc": "Prereq: E E 311\nPropagation in optical media. Optical fibers. Optical sources and detectors. Fiber optic communications systems. DWDM considerations.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Electromagnetic Field Theory I",
    "dept": "E E",
    "num": "512",
    "desc": "Prereq: E E 311\nReview of static electric and magnetic fields. Maxwell's equations. Circuit concepts and impedance elements. Propagation and reflection of plane waves in isotropic media. Guided electromagnetic wave. Characteristics of common waveguides and transmission lines. Propagation in anisotropic media. Special theorems and concepts. Radiation and scattering.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Electromagnetic Field Theory II",
    "dept": "E E",
    "num": "513",
    "desc": "Prereq: E E 512\nGreen's functions, perturbational and variational techniques. Analysis of microstrip lines and interconnects. Spectral domain approach, waves in layered media. Integral equations and method of moments. Inverse scattering. Electromagnetic applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Microwave Engineering",
    "dept": "E E",
    "num": "514",
    "desc": "Prereq: E E 230, E E 311\nPrinciples, analyses, and instrumentation used in the microwave portion of the electromagnetic spectrum. Wave theory in relation to circuit parameters. S parameters, couplers, discontinuities, and microwave device equivalent circuits. RF amplifier design, microwave sources, optimum noise figure and maximum power designs. Microwave filters and oscillators.\n",
    "credits": "4"
  },
  {
    "course_name": "Computational Methods in Electromagnetics",
    "dept": "E E",
    "num": "516",
    "desc": "Prereq: E E 311\nMaxwell's equations. Differential equation based methods. Finite difference and finite difference time domain methods, boundary conditions. Finite element method and applications to the analysis of practical devices. Integral equation based methods. Electric and magnetic field integral equations. Matrix solvers. Fast solution methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Electromagnetic Radiation, Antennas, and Propagation",
    "dept": "E E",
    "num": "517",
    "desc": "Prereq: E E 311\nFundamental antenna concepts. Radiation from wire-and aperture-type sources. Radio transmission formulas. Wave and antenna polarization. Antenna arrays. Modern antenna topics. Practical antenna design. Antenna noise. Radiowave propagation in the presence of the earth and its atmosphere. Antenna measurements and computer aided analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "Microwave Remote Sensing",
    "dept": "E E",
    "num": "518",
    "desc": "Prereq: MATH 265\nMicrowave remote sensing of Earth's surface and atmosphere using satellite-based or ground-based instruments. Specific examples include remote sensing of atmospheric temperature and water vapor, precipitation, ocean salinity, and soil moisture.\n",
    "credits": "3"
  },
  {
    "course_name": "Magnetism and Magnetic Materials",
    "dept": "E E",
    "num": "519",
    "desc": "Prereq: E E 311 or MAT E 317 or PHYS 364\nMagnetic fields, flux density and magnetization. Magnetic materials, magnetic measurements. Magnetic properties of materials. Domains, domain walls, domain processes, magnetization curves and hysteresis. Types of magnetic order, magnetic phases and critical phenomena. Magnetic moments of electrons, theory of electron magnetism. Technological application, soft magnetic materials for electromagnets, hard magnetic materials, permanent magnets, magnetic recording technology, magnetic measurements of properties for materials evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Selected Topics in Communications and Signal Processing",
    "dept": "E E",
    "num": "520",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Communications",
    "dept": "E E",
    "num": "521",
    "desc": "Prereq: E E 422, credit or enrollment in E E 523\nDigital communication systems overview. Characterization of communication channels. Digital modulation and demodulation design and performance analysis. Channel capacity and error-control coding concepts. Waveform design for band-limited channels. Equalization.   Wireless fading channels and performance.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Radio Networks",
    "dept": "E E",
    "num": "522",
    "desc": "Prereq: Permission of instructor\nTopics on cognitive radio networks: Cognitive Radio Networks Architecture; Software Defined Radio Architecture; Spectrum Sensing; Spectrum Management; Spectrum Sharing; Spectrum Mobility; Applications of Cognitive Radio Networks.\n",
    "credits": "3"
  },
  {
    "course_name": "Random Processes for Communications and Signal Processing",
    "dept": "E E",
    "num": "523",
    "desc": "Prereq: E E 322, MATH 317\nAxioms of probability; Repeated trials; Functions of a random variable and multiple random variables: covariance matrix, conditional distribution, joint distribution, moments, and joint moment generating function; Mean square estimation; stochastic convergence; Some important stochastic processes: Random walk, Poisson, Wiener, and shot noise; Markov chaines; Power spectral analysis; Selected applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Signal Processing",
    "dept": "E E",
    "num": "524",
    "desc": "Prereq: E E 322, E E 424, MATH 317\nReview:  sampling and reconstruction of signals; discrete-time signals, systems, and transforms.  Multi-rate digital signal processing and introduction to filter banks. Optimal linear filtering and prediction. Introductions to adaptive filtering and spectral estimation. Applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Data Analytics in Electrical and Computer Engineering",
    "dept": "E E",
    "num": "525",
    "desc": "Prereq: E E 322 or equivalent\nIntroduction to a variety of data analytics techniques -- particularly those relevant for electrical and computer engineers -- from a foundational perspective. Topics to be covered include techniques for classification, visualization, and parameter estimation, with applications to signals, images, matrices, and graphs. Emphasis will be placed on rigorous analysis as well as principled design of such techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Detection and Estimation Theory",
    "dept": "E E",
    "num": "527",
    "desc": "Prereq: E E 422\nStatistical estimation theory and performance measures:  maximum likelihood estimation, Cramer-Rao bound, Bayesian estimation, optimal demodulation, signal design.  Introduction to graphical models.  Hidden Markov models and Kalman filter.  Classical statistical decision theory, decision criteria, binary and composite hypothesis tests.  Error probability and Chernoff bound. Applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Image Processing",
    "dept": "E E",
    "num": "528",
    "desc": "Prereq: E E 322, E E 424\nReview of sampling, linear algebra and probability. Classical image processing topics such as image sampling and quantization, image transforms (2D Fourier, KLT, DCT, etc), image enhancement, restoration and filtering. Image analysis topics including edge detection, segmentation, registration and tracking (uses least squares estimation, EM, Kalman filter). Medical image reconstruction from tomographic projections (Radon transform, Fourier slice theorem and reconstruction algorithms using them) and Magnetic Resonance Imaging (MRI). Basic introduction to image and video compression methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Data Analytics in Electrical and Computer Engineering",
    "dept": "E E",
    "num": "529",
    "desc": "Prereq: E E 322 or equivalent\nIntroduces a variety of data analytics techniques ‐ particularly those relevant for electrical and computer engineers ‐ from a foundational perspective. Topics to be covered include techniques for classification, visualization, and parameter estimation, with applications to signals, images, matrices, and graphs. Emphasis will be placed on rigorous analysis as well as principled design of such techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Selected Topics in Electronics, Microelectronics and Photonics",
    "dept": "E E",
    "num": "530",
    "desc": "Prereq: E E 332\n",
    "credits": "3"
  },
  {
    "course_name": "Microelectronics Fabrication Techniques",
    "dept": "E E",
    "num": "532",
    "desc": "Prereq: credit or enrollment in E E 332\nTechniques used in modern integrated circuit fabrication, including diffusion, oxidation, ion implantation, lithography, evaporation, sputtering, chemical-vapor deposition, and etching. Process integration. Process evaluation and final device testing. Extensive laboratory exercises utilizing fabrication methods to build electronic devices. Use of computer simulation tools for predicting processing outcomes. Recent advances in processing CMOS ICs and micro-electro-mechanical systems (MEMS).\n",
    "credits": "4"
  },
  {
    "course_name": "Physics of Semiconductors",
    "dept": "E E",
    "num": "535",
    "desc": "Prereq: E E 311 and E E 332\nBasic elements of quantum theory, Fermi statistics, motion of electrons in periodic structures, crystal structure, energy bands, equilibrium carrier concentration and doping, excess carriers and recombination, carrier transport at low and high fields, space charge limited current, photo-conductivity in solids, phonons, optical properties, amorphous semiconductors, heterostructures, and surface effects. Laboratory experiments on optical properties, carrier lifetimes, mobility, defect density, doping density, photo-conductivity, diffusion length of carriers.\n",
    "credits": "4"
  },
  {
    "course_name": "Physics of Semiconductor Devices",
    "dept": "E E",
    "num": "536",
    "desc": "Prereq: E E 535\nP-n junctions, band-bending theory, tunneling phenomena, Schottky barriers, heterojunctions, bipolar transistors, field-effect transistors, negative-resistance devices and optoelectronic devices.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Properties of Materials",
    "dept": "E E",
    "num": "537",
    "desc": "Prereq: E E 332 or MAT E 317 or PHYS 322\nReview of classical and quantum mechanical descriptions of electrons in solids, band theory, metallic conduction, lattice vibrations, semiconductors, semiconductor devices, dielectrics, polarization, dielectric relaxation, crystal anisotropy, ferroelectricity, piezoelectricity, superconductivity, magnetism, device applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Optoelectronic Devices and Applications",
    "dept": "E E",
    "num": "538",
    "desc": "Prereq: E E 311, E E 332\nTransmission and reflection of electromagnetic plane waves. Propagation in dielectric and fiber optic waveguides. LED and laser operating principles and applications. Photodetectors and solar cells. Optical modulation and switching.\n",
    "credits": "3"
  },
  {
    "course_name": "Pattern Recognition",
    "dept": "E E",
    "num": "547",
    "desc": "Prereq: E E 324\nMathematical formulation of pattern recognition problems and decision functions. Statistical approaches: Bayes classifier, probability density function estimation and expectation minimization. Clustering (supervised and unsupervised), learning, and neural network algorithms. Fuzzy recognition systems. Feature selection systems. Classifier comparison. Current applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Energy System Planning",
    "dept": "E E",
    "num": "552",
    "desc": "Prereq: E E 456, E E 457 or equivalent\nCharacteristics of bulk energy conversion, storage, and transport technologies. Environmental legislation. Modeling of electricity markets. Evaluation of sustainability and resiliency. Types of planning analyses: economic, multi-sector, long-term, national. Planning tools and associated optimization methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Steady State Analysis",
    "dept": "E E",
    "num": "553",
    "desc": "Prereq: E E 456, E E 457\nPower flow, economic dispatch, unit commitment, electricity markets, automatic generation control, sparse matrix techniques, interconnected operation, voltage control.\n",
    "credits": "3"
  },
  {
    "course_name": "Power System Dynamics",
    "dept": "E E",
    "num": "554",
    "desc": "Prereq: E E 456, E E 457, E E 475\nDynamic performance of power systems with emphasis on stability. Modeling of system components and control equipment. Analysis of the dynamic behavior of the system in response to small and large disturbances.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Energy Distribution Systems",
    "dept": "E E",
    "num": "555",
    "desc": "Prereq: E E 455\nTransient models of distribution components, automated system planning and distribution automation, surge protection, reliability, power quality, power electronics and intelligent systems applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Power Electronic Systems",
    "dept": "E E",
    "num": "556",
    "desc": "Prereq: E E 452\nConverter topologies, AC/DC, DC/DC, DC/AC, AC/AC. Converter applications to do motor drives, power supplies, AC motor drives, power system utility applications (var compensators) and power quality.\n",
    "credits": "3"
  },
  {
    "course_name": "Electromechanical Wind Energy Conversion and Grid Integration",
    "dept": "E E",
    "num": "559",
    "desc": "Prereq: Credit or enrollment in E E 452, E E 456\nSummary of industry status and expected growth; power extraction from the air stream; operation and modeling of electric machines, and power electronics topologies for wind energy conversion; analysis of machine-grid power electronic circuits, controller interface, and collector (distribution) networks; treatment of harmonics, flicker, over/under-voltages, filters, low-voltage ride-through, and reactive compensation; relaying; effects on transmission expansion, planning and grid operation and coordination including variability, frequency control, reserves, and electricity markets; overview of storage technologies and hybrid configurations.\n",
    "credits": "3"
  },
  {
    "course_name": "Systems Engineering and Analysis",
    "dept": "E E",
    "num": "565",
    "desc": "Prereq: Coursework in basic statistics\nIntroduction to organized multidisciplinary approach to designing and developing systems. Concepts, principles, and practice of systems engineering as applied to large integrated systems. Life-cycle costing, scheduling, risk management, functional analysis, conceptual and detail design, test, evaluation and systems engineering planning and organization.\n  Not available for degrees in industrial engineering.",
    "credits": "3"
  },
  {
    "course_name": "Avionics Systems Engineering",
    "dept": "E E",
    "num": "566",
    "desc": "Prereq: E E 565\nAvionics functions. Applications of systems engineering principles to avionics. Top down design of avionics systems. Automated design tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Systems Engineering Analysis and Design",
    "dept": "E E",
    "num": "570",
    "desc": "Prereq: E E 475, E E 577\nSelected topics in abstract algebra, linear algebra, real analysis, functional analysis, and optimization methods in electrical engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Convex Optimization",
    "dept": "E E",
    "num": "571",
    "desc": "\nIntroduction to convex optimization problems emerging in electrical engineering. Efficiently solving convex optimization problems with the use of interior point algorithms software. Review of linear algebra, convex functions, convex sets, convex optimization problems, duality, disciplined convex programming, applications to optimal filtering, estimation, control and resources allocations, sensor network, distributed systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Random Signal Analysis and Kalman Filtering",
    "dept": "E E",
    "num": "573",
    "desc": "Prereq: E E 324 or AER E 331 or M E 370 or M E 411 or MATH 341\nElementary notions of probability. Random processes. Autocorrelation and spectral functions. Estimation of spectrum from finite data. Response of linear systems to random inputs. Discrete and continuous Kalman filter theory and applications. Smoothing and prediction. Linearization of nonlinear dynamics.\n",
    "credits": "3"
  },
  {
    "course_name": "Optimal Control",
    "dept": "E E",
    "num": "574",
    "desc": "Prereq: E E 577\nThe optimal control problem. Variational approach. Pontryagin's principle, Hamilton-Jacobi equation. Dynamic programming. Time-optimal, minimum fuel, minimum energy control systems. The regulator problem. Structures and properties of optimal controls.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Robust Control",
    "dept": "E E",
    "num": "575",
    "desc": "Prereq: E E 577\nIntroduction to modern robust control. Model and signal uncertainty in control systems. Uncertainty description. Stability and performance robustness to uncertainty. Solutions to the H2, Hoo, and l1 control problems. Tools for robustness analysis and synthesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Feedback Control Systems",
    "dept": "E E",
    "num": "576",
    "desc": "Prereq: E E 475 or AER E 432 or M E 411 or MATH 415; and MATH 267\nSampled data, discrete data, and the z-transform. Design of digital control systems using transform methods: root locus, frequency response and direct design methods. Design using state-space methods. Controllability, observability, pole placement, state estimators. Digital filters in control systems. Microcomputer implementation of digital filters. Finite wordlength effects. Linear quadratic optimal control in digital control systems. Simulation of digital control systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Linear Systems",
    "dept": "E E",
    "num": "577",
    "desc": "Prereq: E E 324 or AER E 331 or MATH 415; and MATH 207\nLinear algebra review. Least square method and singular value decomposition. State space modeling of linear continuous-time systems. Solution of linear systems. Controllability and observability. Canonical description of linear equations. Stability of linear systems. State feedback and pole placements. Observer design for linear systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonlinear Systems",
    "dept": "E E",
    "num": "578",
    "desc": "Prereq: E E 577\nLinear vs nonlinear systems. Phase plane analysis. Bifurcation and center manifold theory. Lyapunov stability. Absolute stability of feedback systems. Input-output stability. Passivity theory and feedback linearization. Nonlinear control design techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Eddy Current Nondestructive Evaluation",
    "dept": "E E",
    "num": "588",
    "desc": "Prereq: MATH 265 and (MAT E 216 or MAT E 273 or MAT E 392 or E E 311 or PHYS 364)\nElectromagnetic fields of various eddy current probes. Probe field interaction with conductors, cracks and other material defects. Ferromagnetic materials. Layered conductors. Elementary inversion of probe signals to characterize defects. Special techniques including remote-field, transient, potential drop nondestructive evaluation and the use of Hall sensors. Practical assignments using a 'virtual' eddy current instrument will demonstrate key concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of Remote Sensing Technologies",
    "dept": "E E",
    "num": "589",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nElectromagnetic-radiation principles, active and passive sensors, multispectral and hyperspectral sensors, imaging radar, SAR, thermal imaging, lidar. Examples of applications. Also offered online S.\n",
    "credits": "3"
  },
  {
    "course_name": "Satellite Remote Sensing Laboratory",
    "dept": "E E",
    "num": "589L",
    "desc": "Prereq: Completion or concurrent enrollment in MTEOR/GEOL/NREM/EE 489/589\nProcessing and analysis of satellite sensor data (optical and radar). Provides practical applications in an environmental context.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "E E",
    "num": "590",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Electromagnetic Theory",
    "dept": "E E",
    "num": "590A",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Control Systems",
    "dept": "E E",
    "num": "590B",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Communication Systems",
    "dept": "E E",
    "num": "590C",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Computer Engineering",
    "dept": "E E",
    "num": "590E",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Electric Power",
    "dept": "E E",
    "num": "590F",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Electrical Materials",
    "dept": "E E",
    "num": "590G",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Electronic Devices and Circuits",
    "dept": "E E",
    "num": "590H",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Signal Processing",
    "dept": "E E",
    "num": "590I",
    "desc": "\nFormulation and solution of theoretical or practical problems in electrical engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Electronics, Microelectronics, and Photonics",
    "dept": "E E",
    "num": "591",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Electric Power",
    "dept": "E E",
    "num": "594",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Control Systems",
    "dept": "E E",
    "num": "596",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Communications and Signal Processing",
    "dept": "E E",
    "num": "597",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Electrical and Computer Engineering Learning Community Seminar",
    "dept": "E E",
    "num": "598",
    "desc": "Prereq: Electrical and Computer Engineering Graduate Student\nIntroduction to graduate study in Electrical and Computer Engineering at Iowa State University. Building networks, introduction to core requirements, and tools and techniques for success.\n  Offered on a satisfactory-fail basis only.  ECpE",
    "credits": "R"
  },
  {
    "course_name": "Creative Component",
    "dept": "E E",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Coding Theory",
    "dept": "E E",
    "num": "621",
    "desc": "Prereq: E E 521\nFundamentals of error-control coding techniques: coding gain, linear block codes. Galois fields. Cyclic codes: BCH, Reed-Solomon. Convolutional codes and the Viterbi algorithm. Trellis-coded modulation. Iterative decoding. Recent developments in coding theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Theory",
    "dept": "E E",
    "num": "622",
    "desc": "Prereq: E E 521, E E 523\nInformation system overview. Entropy and mutual information. Data Compression and source encoding. Discrete memoryless channel capacity. Noisy channel coding theorem. Rate distortion theory. Waveform channels. Advanced topics in information theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Electric Power System Engineering",
    "dept": "E E",
    "num": "653",
    "desc": "Prereq: Permission of instructor\nAdvanced topics of current interest in electric power system engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Systems Engineering",
    "dept": "E E",
    "num": "674",
    "desc": "Prereq: Permission of instructor\nAdvanced topics of current interest in the areas of control theory, stochastic processes, digital signal processing, and image processing.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "E E",
    "num": "697",
    "desc": "\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "E E",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Engineering Orientation",
    "dept": "ENGR",
    "num": "101",
    "desc": "\nIntroduction to the College of Engineering and the engineering profession. Information concerning university and college policies, procedures, and resources. Undeclared sections: Considerations in choosing an engineering curriculum. Opportunities to interact with departments. Declared sections:  Introduction to major-specific topics.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "LEAD Program Orientation",
    "dept": "ENGR",
    "num": "104",
    "desc": "\nOrientation for LEAD Learning/Living Community participants. Introduction to college and university resources, tools and techniques to promote academic, professional and social/cultural development and success.  Focus on building support networks with peers, faculty, and staff.  Introduction to core engineering competencies including but not limited to initiative, communication, teamwork, and cultural adaptability.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "LEAD Program Seminar",
    "dept": "ENGR",
    "num": "105",
    "desc": "\nSeminar for LEAD Learning/Living Community participants. Focus on professional development and exposure to various engineering disciplines through hands-on lab experiences, industry visits and networking opportunities with alumni, faculty, and staff.  Development of core competencies:  engineering/technical knowledge, communication and teamwork.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Learning Skills for Engineering",
    "dept": "ENGR",
    "num": "121",
    "desc": "\nExploration of personal and academic strategies that promote academic and career success.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Learning Community Seminar",
    "dept": "ENGR",
    "num": "131",
    "desc": "\nPeer-mentored review of course topics in engineering undeclared learning communities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Foundations of Leadership Development and Learning",
    "dept": "ENGR",
    "num": "150",
    "desc": "Prereq: ELP students only\nLeadership development with focus on global context and awareness of events shaping the context. Exposure to theory of leadership with examples. Necessary characteristics of a leader, and strategies for leadership skills development. Exposure to non-traditional career paths for engineers. Outline of personalized leadership development.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Engineering Problems with Computer Applications Laboratory",
    "dept": "ENGR",
    "num": "160",
    "desc": "Prereq: MATH 143 or satisfactory scores on mathematics placement examinations\nSolving engineering problems and presenting solutions through technical reports. Significant figures. Use of SI units. Graphing and curve-fitting. Flowcharting. Introduction to mechanics, statistics and engineering economics. Use of spreadsheet programs to solve and present engineering problems. Solution of engineering problems using computer programming languages. (The honors section includes application of programming to mobile robotics).\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Problems with Computer Applications Laboratory",
    "dept": "ENGR",
    "num": "160H",
    "desc": "Prereq: MATH 143 or satisfactory scores on mathematics placement examinations; credit or enrollment in MATH 165\nSolving engineering problems and presenting solutions through technical reports. Significant figures. Use of SI units. Graphing and curve-fitting. Flowcharting. Introduction to mechanics, statistics and engineering economics. Use of spreadsheet programs to solve and present engineering problems. Solution of engineering problems using computer programming languages. (The honors section includes application of programming to mobile robotics).\n",
    "credits": "3"
  },
  {
    "course_name": "Leadership in Engineering Teams",
    "dept": "ENGR",
    "num": "250",
    "desc": "\nBuilding and sustaining decision-making engineering teams. Students will explore the interrelated processes of discerning purpose, thinking systemically, developing reflective judgment, and exercising leadership by mobilizing and setting the direction for adaptive change within a team. Industry based examples and information from engineering and natural resource sciences will be infused into the course.\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering: Getting from Thought to Thing",
    "dept": "ENGR",
    "num": "260",
    "desc": "\nWhat is engineering, technology and their roles in society? Investigation of engineering methods through case studies of everyday objects. Explore questions about the impact of technology in society. Apply engineering methods to design and failure analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of the Impacts of Engineering Activity",
    "dept": "ENGR",
    "num": "265",
    "desc": "\nSurvey of the economic, environmental, societal, and political benefits and problems resulting from engineering activity.  Effects of engineering projects on human health, social structures, and the environment.  Examination of improvements in economic opportunities and quality of life resulting from engineering activity. Case studies of the effects of engineering activity.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of How Things Work",
    "dept": "ENGR",
    "num": "270",
    "desc": "\nRemoving mysteries surrounding science and technology. Identify key concepts from applied science and technology to obtain better understanding on how things work. Review and explain the principles behind the technologies which define our modern way of life.   A survey of broad range of technology could include: cell phones, GPS, radio, television, computers, ultrasound, microwave ovens, automobile, bioengineering and other industrial and consumer technologies.  Common day technology examples illustrating scientific knowledge and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "International Experience Report",
    "dept": "ENGR",
    "num": "320",
    "desc": "Prereq: Satisfactory completion of international work experience of at least ten weeks or nine credits of approved course work taken abroad. Permission of student's department prior to departure\nCritique of work/study abroad experience as it relates to professional development. Taken the semester after completion of work abroad or study abroad. Written report and presentation.\n  Offered on a satisfactory-fail basis only.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Voices of Public Policy",
    "dept": "ENGR",
    "num": "327",
    "desc": "Prereq: Sophomore classification in engineering\nRole and impact of legislative process, partisan politics, government, lobbyists, the media, expert testimony and grassroots activism on public policy. Critical analysis of context; of claims, assumptions, premises, and evidence of both sides; represented and disenfranchised populations; the ethical issues to develop personal position and courses of action to impact public policy process.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Wind Energy:  System Design & Delivery",
    "dept": "ENGR",
    "num": "340",
    "desc": "Prereq: MATH 166, PHYS 222\nIntroduction to wind energy.  Economic analysis related to wind energy.  Electrical power generation, transmission, and grid operations.  Tower, blade and nacelle materials and manufacturing.  Tower design. Construction, transportation, supply chain and life cycle analysis for wind turbine components.\n",
    "credits": "3"
  },
  {
    "course_name": "Dean's Leadership Seminar",
    "dept": "ENGR",
    "num": "350",
    "desc": "Prereq: Selection based on demonstrated commitment to leadership development; for junior status or above.\nUnderstanding the complexities of leadership in building an organization, decision-making styles, communication, managing change, building trust, shared responsibility leadership, creating legacy, prioritizing, effective use of authority, conflict, ethics, integrity, transparency, accountability.\n  Offered on a satisfactory-fail basis only.  May not apply toward a degree in Engineering",
    "credits": "1"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "ENGR",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design II",
    "dept": "ENGR",
    "num": "467",
    "desc": "Prereq: Student must be within two semesters of graduation or receive permission of instructor.\nBuild and test of a conceptual design. Detail design, manufacturability, test criteria and procedures. Application of design tools such as CAD and CAM and manufacturing techniques such as rapid prototyping. Development and testing of a full-scale prototype with appropriate documentation in the form of design journals, written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Entrepreneurship",
    "dept": "ENGR",
    "num": "490E",
    "desc": "Prereq: Junior or senior classification in engineering, college approval\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "ENGR",
    "num": "490L",
    "desc": "\nLeadership.\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Statics",
    "dept": "E M",
    "num": "274",
    "desc": "Prereq: PHYS 221, credit or enrollment in MATH 166\nVector analysis; analysis of force systems; resultant in two and three dimensions; free-body diagrams; equilibrium; analysis of trusses, frames, and machines; friction, belts and pulleys; shear and bending moment in beams, centroid and center of mass; second moments of areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Materials",
    "dept": "E M",
    "num": "324",
    "desc": "Prereq: E M 274\nPlane stress, plane strain, stress-strain relationships, and elements of material behavior. Application of stress and deformation analysis to members subject to centric, torsional, flexural, and combined loadings. Elementary considerations of theories of failure, buckling.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Materials Laboratory",
    "dept": "E M",
    "num": "327",
    "desc": "Prereq: E M 324\nExperimental determination of mechanical properties of selected engineering materials. Experimental verification of assumptions made in 324. Use of strain measuring devices. Preparation of reports.\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Dynamics",
    "dept": "E M",
    "num": "345",
    "desc": "Prereq: E M 274, credit or enrollment in MATH 266 or MATH 267\nParticle and rigid body kinematics, Newton's laws of motion, kinetics of plane motion, rigid body problems using work-energy, linear, and angular impulse-momentum principles, vibrations.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Nondestructive Testing",
    "dept": "E M",
    "num": "362",
    "desc": "Prereq: PHYS 112 or PHYS 222\nRadiography, ultrasonic testing, magnetic particle inspection, eddy current testing, dye penetrant inspection, and other techniques. Physical bases of tests, materials to which applicable, types of defects detectable, calibration standards, and reliability safety precautions.\n",
    "credits": "3"
  },
  {
    "course_name": "Nondestructive Testing Laboratory",
    "dept": "E M",
    "num": "362L",
    "desc": "Prereq: Credit or enrollment in MAT E 362\nApplication of nondestructive testing techniques to the detection and sizing of flaws in materials and to the characterization of material's microstructure. Included are experiments in hardness, dye penetrant, magnetic particle, x-ray, ultrasonic and eddy current testing. Field trips to industrial laboratories.\n",
    "credits": "1"
  },
  {
    "course_name": "Mechanics of Fluids",
    "dept": "E M",
    "num": "378",
    "desc": "Prereq: E M 274\nProperties of fluids. Fluid statics. Kinematics and kinetics of fluid flow. Mass, momentum, and energy conservation laws; dimensional analysis; flow in pipes and channels. Selected laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Experimental Mechanics",
    "dept": "E M",
    "num": "417",
    "desc": "Prereq: E M 324; MAT E 273\nIntroduction to fundamental concepts for force, displacement, stress and strain measurements for structures and materials applications.  Strain gage theory and application.  Full field deformation measurements with laser interferometry and digital image processing.  Advanced experimental concepts at the micro- and nano-scale regimes.  Selected laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Mechanics of Materials",
    "dept": "E M",
    "num": "424",
    "desc": "Prereq: E M 324\nAnalysis of stresses, strains, and deflections. Torsion and bending of unsymmetrical members. Analysis of thick wall pressure vessels and shrink fit problems. Dynamic load effects, fatigue and fracture mechanics introduction. Work-strain energy methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the Finite Element Method",
    "dept": "E M",
    "num": "425",
    "desc": "Prereq: E M 324, MATH 266 or MATH 267\nIntroduction of finite element analysis through applications to one-dimensional, steady-state problems such as elastic deformation, heat and fluid flow, consolidation, beam bending, and mass transport. Transient heat conduction and wave propagation. Two-dimensional triangular and quadrilateral elements. Plane problems of torsion, thermal and potential flow, stress analysis. Simple computer programs for one- and two-dimensional problems.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Acoustics",
    "dept": "E M",
    "num": "451",
    "desc": "Prereq: PHYS 221 and MATH 266 or MATH 267\nThe basics of acoustic wave propagation in fluids with an emphasis on sound propagation in air. Topics include transmission and reflection of sound at a boundary; role of acoustic sources in directing sound fields; diffraction of sound around solid objects; reverberation of sound in a room; and the measurement of sound fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Ultrasonic Nondestructive Evaluation",
    "dept": "E M",
    "num": "480",
    "desc": "Prereq: E M 324, MATH 266 or MATH 267, PHYS 222\nIntroduction to stress/strain, Hooke’s law, and elastic wave propagation in two dimensions in isotropic media. Ultrasonic plane-wave reflection and transmission; and simple straight-crested guided waves. Transducer construction, behavior, and performance. Simple signal analysis and discrete signal processing. The last few weeks of the course are devoted to case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "E M",
    "num": "490",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "E M",
    "num": "490H",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Continuum Mechanics",
    "dept": "E M",
    "num": "510",
    "desc": "Prereq: MATH 385\nIntroduction to Cartesian tensors as linear vector transformations. Kinematics of continuous deformations, Lagrangian and Eulerian descriptions of motion. Fundamental equations or balance laws of continuous media, linear and angular momentum balance. Conservation laws of momentum and energy. Introduction to constitutive equations of classical elastic solids and simple fluids. Formulations and solutions of some canonical problems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Mechanics of Materials",
    "dept": "E M",
    "num": "514",
    "desc": "Prereq: E M 324\nTheory of stress and strain, stress-strain relationships. Unsymmetrical bending, curved beams, shear center. Torsion of thin-walled noncircular sections. Equilibrium, compatibility equations. Airy stress functions. Membrane stresses in shells, thick-walled cylinders.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Elasticity and Mechanics of Deformable Solids",
    "dept": "E M",
    "num": "516",
    "desc": "Prereq: E M 510\nFundamental mechanics of linear elasticity, formulation and solution of simple elastostatic boundary value problems. Kinematics of small deformations, constitutive equations for isotropic and anisotropic media. Field equations for elastic solids, plane strain/plane stress and some classic analytical solutions such as Boussinesq, Hertz, Kirsch, Lamé, and Mitchell.  Stress functions and potential methods and introduction to finite elements.\n",
    "credits": "3"
  },
  {
    "course_name": "Experimental Mechanics",
    "dept": "E M",
    "num": "517",
    "desc": "Prereq: E M 324; MAT E 273\nIntroduction to fundamental concepts for force, displacement, stress and strain measurements for structures and materials applications.  Strain gage theory and application.  Full field deformation measurements with laser interferometry and digital image processing.  Advanced experimental concepts at the micro- and nano-scale regimes.  Selected laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Waves in Elastic Solids with Applications to Ultrasonic Nondestructive Evaluation",
    "dept": "E M",
    "num": "518",
    "desc": "Prereq: MATH 385\nPropagation of bulk waves, surface waves, and guided waves in isotropic and anisotropic elastic media. Transmission and reflection of waves at plane and curved interfaces. Radiation of sources with application to ultrasonic transducer beam modeling. Elastic wave scattering from cracks and inclusions. Reciprocity principles and their use in the development of an ultrasonic measurement model. Characterization and measurement of material attenuation.\n",
    "credits": "3"
  },
  {
    "course_name": "Finite Element Analysis",
    "dept": "E M",
    "num": "525",
    "desc": "Prereq: E M 425, MATH 385\nVariational and weighted residual approach to finite element equations. Emphasis on two- and three-dimensional problems in solid mechanics. Isoparametric element formulation, higher order elements, numerical integration, imposition of constraints and penalty, convergence, and other more advanced topics. Use of two- and three-dimensional computer programs. Dynamic and vibrational problems, eigenvalues, and time integration. Introduction to geometric and material nonlinearities.\n",
    "credits": "3"
  },
  {
    "course_name": "Boundary Element Methods in Engineering",
    "dept": "E M",
    "num": "526",
    "desc": "Prereq: E M 514 or E M 516\nIntroductory boundary element methods through plane problems. Singular integrals, Cauchy principal values, integral representations and boundary integrals in one dimension. Direct and indirect formulations. Plane potential and elastostatic problems. Higher order elements, numerical integration. Regularizations. Body forces and infinite regions. Specialized fundamental solutions, half-plane and axisymmetric problems. Diffusion and wave problems. Coupling with finite elements.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Random Vibrations and Nonlinear Dynamics",
    "dept": "E M",
    "num": "543",
    "desc": "\nVibrations of continuous systems. Nonlinear vibration phenomena, perturbation expansions; methods of multiple time scales and slowly-varying amplitude and phase. Characteristics of random vibrations; random processes, probability distributions, spectral density and its significance, the normal or Gaussian random process. Transmission of random vibration, response of simple single and two-degree-of-freedom systems to stationary random excitation. Fatigue failure due to random excitation.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Engineering Dynamics",
    "dept": "E M",
    "num": "548",
    "desc": "Prereq: E M 345, MATH 266 or MATH 267\n3-D kinematics and dynamics of particles and rigid bodies. Coordinate systems, calculus of variations. Lagrange's equations with constraints, modified Euler's equations, torque-free motion of rigid bodies in 3-D, moment equations with constraints.\n",
    "credits": "3"
  },
  {
    "course_name": "Nondestructive Evaluation",
    "dept": "E M",
    "num": "550",
    "desc": "Prereq: E M 324, MATH 385\nPrinciples of five basic NDE methods and their application in engineering inspections. Materials behavior and simple failure analysis. NDE reliability, and damage-tolerant design. Advanced methods such as acoustic microscopy, laser ultrasonics, thermal waves, and computed tomography are analyzed. Computer-based experiments on a selection of methods: ultrasonics, eddy currents, x-rays are assigned for student completion.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Acoustics",
    "dept": "E M",
    "num": "552",
    "desc": "Prereq: E M 451\nTheoretical acoustics: wave propagation in fluids; acoustic radiation, diffraction and scattering; nonlinear acoustics; radiation force; cavitation; and ray acoustics.\n",
    "credits": "3"
  },
  {
    "course_name": "Fracture and Fatigue",
    "dept": "E M",
    "num": "564",
    "desc": "Prereq: E M 324 and either MAT E 216 or MAT E 273 or MAT E 392. Undergraduates: Permission of instructor\nMaterials and mechanics approach to fracture and fatigue. Fracture mechanics, brittle and ductile fracture, fracture and fatigue characteristics, fracture of thin films and layered structures. Fracture and fatigue tests, mechanics and materials designed to avoid fracture or fatigue.\n",
    "credits": "3"
  },
  {
    "course_name": "Phase Transformation in Elastic Materials",
    "dept": "E M",
    "num": "566",
    "desc": "Prereq: EM 510 or EM 516 or EM 514\nContinuum thermodynamics and kinetics approaches to phase transformations.  Phase field approach to stress- and temperature-induced martensitic transformations and twinning at the nanoscale. Nucleation and growth. Nanostructural evaluation. Analytical and numerical solutions. Surface stresses and energy. Surface-induced phase transformations. Large Strain formulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Composite and Combined Materials",
    "dept": "E M",
    "num": "569",
    "desc": "Prereq: E M 324\nMechanics of fiber-reinforced materials. Micromechanics of lamina. Macromechanical behavior of lamina and laminates. Strength and interlaminar stresses of laminates. Failure criteria. Stress analysis of laminates. Thermal moisture and residual stresses. Joints in composites.\n",
    "credits": "3"
  },
  {
    "course_name": "Wind Engineering",
    "dept": "E M",
    "num": "570",
    "desc": "Prereq: E M 378, E M 345\nAtmospheric circulations, atmospheric boundary layer wind, bluff-body aerodynamics, aeroelastic phenomena, wind-tunnel and full-scale testing, wind-load code and standards, effect of tornado and thunderstorm winds, design applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Mechanics Special Topics",
    "dept": "E M",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Introduction to Dislocation and Plasticity",
    "dept": "E M",
    "num": "590F",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Mechanics of Thin Films and Adhesives",
    "dept": "E M",
    "num": "590H",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Mechanics of Cellular and Porous Media",
    "dept": "E M",
    "num": "590I",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Other",
    "dept": "E M",
    "num": "590J",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "E M",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Engineering Mechanics Special Topics",
    "dept": "E M",
    "num": "690",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Advanced Experimental Methods",
    "dept": "E M",
    "num": "690N",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Advanced Wave Propagation",
    "dept": "E M",
    "num": "690O",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Advanced Materials",
    "dept": "E M",
    "num": "690P",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Advanced Computational Methods",
    "dept": "E M",
    "num": "690Q",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Reliability and Failure",
    "dept": "E M",
    "num": "690R",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Mechanics Special Topics: Other",
    "dept": "E M",
    "num": "690S",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "E M",
    "num": "697",
    "desc": "Prereq: Permission of DOGE (Director of Graduate Education), graduate classification\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "E M",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Intensive English and Orientation Program Reading",
    "dept": "ENGL",
    "num": "011",
    "desc": "\nStudy of English for speakers of other languages. Brochure available from the IEOP Office, 102 Landscape Architecture, or at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Reading: Beginner",
    "dept": "ENGL",
    "num": "011A",
    "desc": "\nAcademic reading classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Reading: Low Intermediate",
    "dept": "ENGL",
    "num": "011B",
    "desc": "\nAcademic reading classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Reading: Intermediate",
    "dept": "ENGL",
    "num": "011C",
    "desc": "\nAcademic reading classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Reading: High Intermediate",
    "dept": "ENGL",
    "num": "011D",
    "desc": "\nAcademic reading classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Reading: High",
    "dept": "ENGL",
    "num": "011E",
    "desc": "\nAcademic reading classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Reading: Advanced",
    "dept": "ENGL",
    "num": "011F",
    "desc": "\nAcademic reading classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Writing",
    "dept": "ENGL",
    "num": "012",
    "desc": "\nAcademic writing classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Writing: Beginner",
    "dept": "ENGL",
    "num": "012A",
    "desc": "\nAcademic writing classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Writing: Low Intermediate",
    "dept": "ENGL",
    "num": "012B",
    "desc": "\nAcademic writing classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Writing: Intermediate",
    "dept": "ENGL",
    "num": "012C",
    "desc": "\nAcademic writing classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Writing: High Intermediate",
    "dept": "ENGL",
    "num": "012D",
    "desc": "\nAcademic writing classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Writing: High",
    "dept": "ENGL",
    "num": "012E",
    "desc": "\nAcademic writing classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Writing: Advanced",
    "dept": "ENGL",
    "num": "012F",
    "desc": "\nAcademic writing classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Listening and Speaking",
    "dept": "ENGL",
    "num": "013",
    "desc": "\nAcademic listening and speaking classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Listening and Speaking: Beginner",
    "dept": "ENGL",
    "num": "013A",
    "desc": "\nAcademic listening and speaking classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Listening and Speaking: Low Intermediate",
    "dept": "ENGL",
    "num": "013B",
    "desc": "\nAcademic listening and speaking classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Listening and Speaking: Intermediate",
    "dept": "ENGL",
    "num": "013C",
    "desc": "\nAcademic listening and speaking classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Listening and Speaking: High Intermediate",
    "dept": "ENGL",
    "num": "013D",
    "desc": "\nAcademic listening and speaking classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Listening and Speaking: High",
    "dept": "ENGL",
    "num": "013E",
    "desc": "\nAcademic listening and speaking classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Listening and Speaking: Advanced",
    "dept": "ENGL",
    "num": "013F",
    "desc": "\nAcademic listening and speaking classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Grammar",
    "dept": "ENGL",
    "num": "014",
    "desc": "\nAcademic grammar classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Grammar: Beginner",
    "dept": "ENGL",
    "num": "014A",
    "desc": "\nAcademic grammar classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Grammar: Low Intermediate",
    "dept": "ENGL",
    "num": "014B",
    "desc": "\nAcademic grammar classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Grammar: Intermediate",
    "dept": "ENGL",
    "num": "014C",
    "desc": "\nAcademic grammar classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Grammar: High Intermediate",
    "dept": "ENGL",
    "num": "014D",
    "desc": "\nAcademic grammar classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Grammar: High",
    "dept": "ENGL",
    "num": "014E",
    "desc": "\nAcademic grammar classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Grammar: Advanced",
    "dept": "ENGL",
    "num": "014F",
    "desc": "\nAcademic grammar classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Exit Academic Skills",
    "dept": "ENGL",
    "num": "015",
    "desc": "\nAcademic Skills classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Exit Orientation",
    "dept": "ENGL",
    "num": "016",
    "desc": "\nAcademic Orientation classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Exit Technology",
    "dept": "ENGL",
    "num": "017",
    "desc": "\nAcademic Technology classes for speakers of other languages. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English Orientation Program Business Oral English Communication: Listening and Speaking",
    "dept": "ENGL",
    "num": "018",
    "desc": "\nAcademic English classes for speakers of other languages focusing on Business. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English Orientation Program Business Written English Communication: Reading and Writing",
    "dept": "ENGL",
    "num": "019",
    "desc": "\nAcademic English classes for speakers of other languages focusing on Business. More information available at www.ieop.iastate.edu.\n",
    "credits": "0"
  },
  {
    "course_name": "Intensive English and Orientation Program Optional Seminar",
    "dept": "ENGL",
    "num": "020",
    "desc": "\nCustomized academic English and cultural orientation for speakers of other languages.\n",
    "credits": "0"
  },
  {
    "course_name": "Strategies for Nonnative Speakers of English",
    "dept": "ENGL",
    "num": "099",
    "desc": "Prereq: Recommendation of English Department; placement in sections L and R is determined by examination; section S is open to all   interested international students. Available P/NP to graduate students at their department's option\n",
    "credits": "0"
  },
  {
    "course_name": "Strategies for Nonnative Speakers of English: Strategies for Reading",
    "dept": "ENGL",
    "num": "099R",
    "desc": "Prereq: Recommendation of English Department; placement in sections L and R is determined by examination; section S is open to all   interested international students. Available P/NP to graduate students at their department's option\n",
    "credits": "0"
  },
  {
    "course_name": "Strategies for Nonnative Speakers of English: Academic Speaking and Pronunciation",
    "dept": "ENGL",
    "num": "099S",
    "desc": "Prereq: Recommendation of English Department; placement in sections L and R is determined by examination; section S is open to all   interested international students. Available P/NP to graduate students at their department's option\n",
    "credits": "0"
  },
  {
    "course_name": "English for Native Speakers of Other Languages",
    "dept": "ENGL",
    "num": "101",
    "desc": "Prereq: Recommendation of English Department; placement in various sections is determined by examination. (See English Requirement for International Students in Index.)\nFor undergraduates: Completion of ENGL 101 requirement prepares students for ENGL 150.  For graduates: Completion of ENGL 101 satisfies the English requirement of the Graduate College. ENGL 101 courses are limited to students who are nonnative speakers of English.\n  Credit from ENGL 101 does not count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "English for Native Speakers of Other Languages: Academic English",
    "dept": "ENGL",
    "num": "101B",
    "desc": "Prereq: Recommendation of English Department; placement in various sections is determined by examination. (See English Requirement for International Students in Index.)\nFor undergraduates: Completion of ENGL 101 requirement prepares students for ENGL 150.  For graduates: Completion of ENGL 101 satisfies the English requirement of the Graduate College. ENGL 101 courses are limited to students who are nonnative speakers of English.\n  Credit from ENGL 101 does not count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "English for Native Speakers of Other Languages: Academic English II--Undergraduates",
    "dept": "ENGL",
    "num": "101C",
    "desc": "Prereq: Recommendation of English Department; placement in various sections is determined by examination. (See English Requirement for International Students in Index.)\nFor undergraduates: Completion of ENGL 101 requirement prepares students for ENGL 150.  For graduates: Completion of  ENGL 101 satisfies the English requirement of the Graduate College. ENGL 101 courses are limited to students who are nonnative speakers of English.\n  Credit from ENGL 101 does not count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "English for Native Speakers of Other Languages: Academic English II--Graduates",
    "dept": "ENGL",
    "num": "101D",
    "desc": "Prereq: Recommendation of English Department; placement in various sections is determined by examination. (See English Requirement for International Students in Index.)\nAvailable P/NP to graduate students at their department's option. For undergraduates: Completion of ENGL 101 requirement prepares students for ENGL 150.  For graduates: Completion of  ENGL 101 satisfies the English requirement of the Graduate College. ENGL 101 courses are limited to students who are nonnative speakers of English.\n  Credit from ENGL 101 does not count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Computers and Language",
    "dept": "ENGL",
    "num": "120",
    "desc": "\nIntroduction to the use of linguistic knowledge in computer applications today and the basic computational techniques used in such applications.  The development of these techniques throughout the history of computational linguistics.  How the study of language has contributed to the advancement of technology and how certain computational problems have influenced the way linguists study language.\n",
    "credits": "3"
  },
  {
    "course_name": "Critical Thinking and Communication",
    "dept": "ENGL",
    "num": "150",
    "desc": "Prereq: Concurrent enrollment in LIB 160 is recommended.\nApplication of critical reading and thinking abilities to topics of civic and cultural importance. Introduction of basic oral, visual, and electronic communication principles to support writing development.  Initiation of communication portfolio.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication Skills for International Teaching Assistants",
    "dept": "ENGL",
    "num": "180",
    "desc": "\nPlacement based upon OECT test results. Persons whose native language is English cannot take ENGL 180 for credit. No more than one section of ENGL 180 may be taken per semester; up to two sections total.\n  Offered on a satisfactory-fail basis only.  Credit for ENGL 180 does not apply toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Communication Skills for International Teaching Assistants: Speaking Skills",
    "dept": "ENGL",
    "num": "180A",
    "desc": "\nEmphasis on pronunciation improvement and greater fluency in spoken English. Placement based upon OECT test results. Persons whose native language is English cannot take ENGL 180 for credit. No more than one section of ENGL 180 may be taken per semester; up to two sections total.\n  Offered on a satisfactory-fail basis only.  Credit for ENGL 180 does not apply toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Communication Skills for International Teaching Assistants: Intermediate Spoken English",
    "dept": "ENGL",
    "num": "180B",
    "desc": "\nPlacement based upon OECT test results. Persons whose native language is English cannot take ENGL 180 for credit. No more than one section of ENGL 180 may be taken per semester; up to two sections total.\n  Offered on a satisfactory-fail basis only.  Credit for ENGL 180 does not apply toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Communication Skills for International Teaching Assistants: Advanced Spoken English",
    "dept": "ENGL",
    "num": "180C",
    "desc": "\nFor students who have completed ENGL 180A or ENGL 180B but have not reached the passing level on the OECT test. Placement based upon OECT test results. Persons whose native language is English cannot take ENGL 180 for credit. No more than one section of ENGL 180 may be taken per semester; up to two sections total.\n  Offered on a satisfactory-fail basis only.  Credit for ENGL 180 does not apply toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Communication Skills for International Teaching Assistants: Presentation Skills",
    "dept": "ENGL",
    "num": "180D",
    "desc": "\nDeveloping explanations, leading discussions and handling questions in a teaching environment. Placement based upon OECT test results. Persons whose native language is English cannot take ENGL 180 for credit. No more than one section of ENGL 180 may be taken per semester; up to two sections total.\n  Offered on a satisfactory-fail basis only.  Credit for ENGL 180 does not apply toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Communication Skills for International Teaching Assistants: Supervised Independent Study",
    "dept": "ENGL",
    "num": "180E",
    "desc": "\nSeminar with individual observation and consultation. Placement based upon OECT test results. Persons whose native language is English cannot take 180 for credit. No more than one section of ENGL 180 may be taken per semester; up to two sections total.\n  Offered on a satisfactory-fail basis only.  Credit for ENGL 180 does not apply toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Literature",
    "dept": "ENGL",
    "num": "201",
    "desc": "Prereq: Credit in or exemption from 150\nStudy of selected examples of drama, poetry, short fiction, and the novel drawn from both British and American literature. Recommended for nonmajors.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Creative Writing",
    "dept": "ENGL",
    "num": "207",
    "desc": "Prereq: Credit in or exemption from 150\nCourse introduces students to the fundamentals of writing fiction, poetry, and creative nonfiction. Extensive readings in all three genres. Students learn creative processes through writing exercises, workshops, and conferences.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Technical Communication",
    "dept": "ENGL",
    "num": "214",
    "desc": "Prereq: ENGL 150\nA broad introduction to the culture of professional work as a technical communicator, with particular emphasis on principles and best practices for developing and managing technical information and digital media. Examination of user-centered design, the history of the discipline, cross-cultural communication, and the ethics of communicating complex information to lay audiences. Study and practice of team-based collaboration, project management, and technical editing.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Linguistics",
    "dept": "ENGL",
    "num": "219",
    "desc": "Prereq: Sophomore classification\nIntroduction to linguistic concepts and principles of linguistic analysis with English as the primary source of data. Sound and writing systems, sentence structure, vocabulary, and meaning. Issues in the study of usage, regional and social dialects, language acquisition, and language change.\n",
    "credits": "3"
  },
  {
    "course_name": "Descriptive English Grammar",
    "dept": "ENGL",
    "num": "220",
    "desc": "Prereq: ENGL 250\nOverview of grammatical structures and functions. Parts of speech; phrase, clause, and sentence structure; sentence types and sentence analysis; rhetorical grammar and sentence style; terminology. Not a remedial, English composition, or ESL course.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of British Literature to 1800",
    "dept": "ENGL",
    "num": "225",
    "desc": "Prereq: ENGL 250\nRepresentative works of British literature from the origins to 1800 in historical, cultural, and literary contexts. Will include multiple genres.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of British Literature since 1800",
    "dept": "ENGL",
    "num": "226",
    "desc": "Prereq: ENGL 250\nRepresentative works from 1800 to the present in historical, cultural, and literary contexts. Will include multiple genres and may   include texts that reflect and/or critique the impact and legacy of the British empire on its former colonies, i.e., postcolonial   literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of American Literature to 1865",
    "dept": "ENGL",
    "num": "227",
    "desc": "Prereq: ENGL 250\nRepresentative works of American literature from its origins (including indigenous and conquest literatures) through the end of the Civil War in historical, cultural, and literary contexts. Will include multiple genres.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of American Literature since 1865",
    "dept": "ENGL",
    "num": "228",
    "desc": "Prereq: ENGL 250\nRepresentative works written in the United States since the Civil War in historical, cultural, and literary contexts, with attention to the cultural and ethnic diversity of Americans. Will include multiple genres.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of Film History",
    "dept": "ENGL",
    "num": "237",
    "desc": "Prereq: Credit in or exemption from 150\nA survey of the history of film, both U.S. and international, from the beginnings in the late nineteenth century to the present.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to American Indian Literature",
    "dept": "ENGL",
    "num": "240",
    "desc": "Prereq: Credit in or exemption from ENGL 150\nAppreciation of oral and written forms of American Indian literatures. Tropes and techniques in oral, visual and written texts. Focus on the role of American Indians in interdisciplinary approaches to modern social and environmental issues as expressed in literary works.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Written, Oral, Visual, and Electronic Composition",
    "dept": "ENGL",
    "num": "250",
    "desc": "Prereq: ENGL 150 or exemption from ENGL 150; sophomore classification or exemption from ENGL 150; credit for or concurrent enrollment in LIB 160\nAnalyzing, composing, and reflecting on written, oral, visual, and electronic (WOVE) discourse within academic, civic, and cultural   contexts.  Emphasis on supporting a claim and using primary and secondary sources.  Continued development of communication portfolio.\n  The University requires a minimum grade of C in ENGL 250 to meet the Communication Proficiency graduation requirement; some majors/degree programs may set higher standards.",
    "credits": "3"
  },
  {
    "course_name": "Written, Oral, Visual, and Electronic Composition: Honors",
    "dept": "ENGL",
    "num": "250H",
    "desc": "Prereq: Exemption from ENGL 150 and admission to Freshman Honors Program; credit for or concurrent enrollment in LIB 160\nIn-depth analysis, composition, and reflection on written, oral, visual, and electronic (WOVE) discourse within academic, civic, and   cultural contexts.  Emphasis on argumentation: developing claims, generating reasons, providing evidence.  Individual sections   organized by special topics.  Development of communication portfolio.\n  The University requires a minimum grade of C in ENGL 250 to meet the Communication Proficiency graduation requirement; some majors/degree programs may set higher standards.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Literary Study",
    "dept": "ENGL",
    "num": "260",
    "desc": "Prereq: Credit in or exemption from 150\nBasic principles of literary study. Emphasis on writing of interpretive and critical essays. Particular attention to poetry. Designed for English majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis of Popular Culture Texts",
    "dept": "ENGL",
    "num": "275",
    "desc": "Prereq: Credit in or equivalent of 250\nAnalysis of how information and entertainment forms persuade and manipulate audiences. Study of several forms that may include newspapers, speeches, television, film, advertising, fiction, and magazines. Special attention to verbal and visual devices.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Communication",
    "dept": "ENGL",
    "num": "302",
    "desc": "Prereq: ENGL 250, junior classification\nRhetorical concepts and processes to successfully communicate individually and collaboratively via written, oral, visual, and electronic modes across a range of business disciplines. Covers strategies for analyzing audiences internal and external to an organization in order to communicate positive, neutral, and negative messages clearly, completely, correctly, and ethically; save an audience’s time; and create goodwill.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Communication: Honors",
    "dept": "ENGL",
    "num": "302H",
    "desc": "Prereq: ENGL 250, junior classification\nTheory, principles and processes of effective written, oral, visual, and electronic communication typically encountered in business and the professions. Extensive practice in many areas of workplace communication, including letter, memo, and email correspondence; short proposals and reports; policies and procedures; job packet including letters of application and resumes; website analysis;  brochures; and individual and team presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Free-Lance Writing for Popular Magazines",
    "dept": "ENGL",
    "num": "303",
    "desc": "Prereq: ENGL 250, not open to freshmen\nPractical workshop in writing nonfiction articles for popular magazines. Emphasis on writing, market research, preparation of manuscripts, methods of submission. Major goal of the course is production of marketable material.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing: Fiction",
    "dept": "ENGL",
    "num": "304",
    "desc": "Prereq: ENGL 250, not open to freshmen\nProgresses from practice in basic techniques of fiction writing to fully developed short stories. Emphasis on writing, analytical reading, workshop criticism, and individual conferences.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing: Nonfiction",
    "dept": "ENGL",
    "num": "305",
    "desc": "Prereq: ENGL 250, not open to freshmen\nWorkshop in writing imaginative essays, both critical and personal. Analytical reading, development of literary techniques. Individual and small group conferences.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing: Poetry",
    "dept": "ENGL",
    "num": "306",
    "desc": "Prereq: ENGL 250, not open to freshmen\nProgresses from traditional to contemporary forms. Emphasis on writing, analytical reading, workshop criticism, and individual conferences.\n",
    "credits": "3"
  },
  {
    "course_name": "Write Like a Woman",
    "dept": "ENGL",
    "num": "308",
    "desc": "Prereq: ENGL 250\nWriting and reading interpretive fiction written by women. Emphasis on stories that embody a female literary life, gender-specific ways of creating characters and conflicts, analytical reading and writing, workshop criticism and shared commentaries. Includes multi-modal projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Proposal and Report Writing",
    "dept": "ENGL",
    "num": "309",
    "desc": "Prereq: ENGL 250, junior classification\nRhetorical concepts and processes to individually and collaboratively develop proposals for business, governmental, nonprofit, or other organizations and to report on the work completed both orally and in writing. Emphasizes the structure and classification of proposal and report types, qualitative and quantitative research methods, audience analysis, document design, and data visualization.\n",
    "credits": "3"
  },
  {
    "course_name": "Rhetorical Analysis",
    "dept": "ENGL",
    "num": "310",
    "desc": "Prereq: ENGL 250\nFundamental principles of rhetorical criticism. Focus on selected theories for analyzing cultural texts, including essays, speeches, film, technical and scientific documents, and websites. Emphasis on identifying artifacts, formulating research questions, applying methodologies, and understanding and practicing critical analysis through discussion and in writing.\n",
    "credits": "3"
  },
  {
    "course_name": "Biological Communication",
    "dept": "ENGL",
    "num": "312",
    "desc": "Prereq: ENGL 250\nRhetorical concepts and processes to successfully communicate individually and collaboratively via written, oral, visual, and electronic modes in disciplines in and related to biological sciences. Emphasizes the strategies for analyzing and adapting to audiences in the biological sciences. Covers developing and designing documentation, presenting scientific data visually, and communicating results orally.\n",
    "credits": "3"
  },
  {
    "course_name": "Rhetorical Website Design",
    "dept": "ENGL",
    "num": "313",
    "desc": "Prereq: ENGL 250\nRhetorical principles of multimodal composing in hypertextual environments. Focus on writing according to web style guidelines, employing cascading stylesheets for layout and design, and using principles of information architecture to determine optimal site structure. Final project involves constructing interactive client site using latest web standards.\n",
    "credits": "3"
  },
  {
    "course_name": "Technical Communication",
    "dept": "ENGL",
    "num": "314",
    "desc": "Prereq: ENGL 250, junior classification\nRhetorical concepts and processes to successfully communicate technical information individually and collaboratively via written, oral, visual, and electronic modes. Emphasizes the major strategies for analyzing expert and lay audiences and adapting information to those audiences. Covers developing and designing usable technical documentation, visualizing data, and presenting technical information orally.\n",
    "credits": "3"
  },
  {
    "course_name": "Technical Communication: Honors",
    "dept": "ENGL",
    "num": "314H",
    "desc": "Prereq: ENGL 250, junior classification\nTheories, principles, and processes of effective written, oral, visual, and electronic communication of technical information. Attention to major strategies for analyzing and adapting to audiences in various communication situations and composing technical discourse including organizing visual and verbal information.  Extensive practice in many areas of technical communication, including instructions and procedures, proposals and reports, website analysis and design, and individual and team presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing: Screenplays",
    "dept": "ENGL",
    "num": "315",
    "desc": "Prereq: ENGL 250, not open to freshmen\nStresses master scene technique of writing fully developed screenplays. Emphasis on movie techniques, writing, workshop criticism, analytical reading and viewing, and individual conferences.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing: Playwriting",
    "dept": "ENGL",
    "num": "316",
    "desc": "Prereq: ENGL 250, not open to freshmen\nProgresses from production of scenes to fully developed one-act plays. Emphasis on action, staging, writing, analytical reading, workshop criticism, and individual conferences.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to ESL methods and materials",
    "dept": "ENGL",
    "num": "318",
    "desc": "Prereq: ENGL/LING 219\nIntroduction to methods and materials for teaching English as a Second Language (ESL) for elementary and secondary students. Strategies and resources for teaching reading, writing, speaking and listening skills. Elementary Education students must take this course in the same semester as either CI 280S or CI 480S.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Language and Diversity",
    "dept": "ENGL",
    "num": "319",
    "desc": "Prereq: ENGL 250\nSpecial topics related to the role of language and linguistics in US diversity, such as Dialects and American literature, American English Accents, Legal and Social Aspects of English-only Laws in the US. Connections between language use and social diversity.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Linguistic Structure",
    "dept": "ENGL",
    "num": "320",
    "desc": "Prereq: ENGL 219/LING 219, ENGL 220/LING 220\nSpecial topics related to the study of linguistic structure. Focus on language structure in areas not covered in detail by existing courses. Topics include field linguistics, morphology, forensic linguistics, neurolinguistics, semantics, non-English phonology, acoustic phonetics, linguistic universals, and historical linguistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Language and Society",
    "dept": "ENGL",
    "num": "322",
    "desc": "Prereq: ENGL/LING 219\nIntroduction to variation in language use in society. Survey of factors affecting language use, including background characteristics of language users, location, and purpose of interaction in addition to institutional, state, and national language policies.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Teaching ESL Literacy",
    "dept": "ENGL",
    "num": "324",
    "desc": "Prereq: ENGL/LING 219\nIntroduction to the issues and methods involved in teaching literacy skills to English as a second language (ESL) learners. The nature of literacy and materials and methods for developing ESL literacy at the middle school, high school, and adult ages across multiple levels of competency.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Methods for ESL Learners: Oral Communication Skills",
    "dept": "ENGL",
    "num": "325",
    "desc": "Prereq: ENGL/LING 219\nIssues and methods in teaching oral communication skills (listening, speaking, pronunciation) to English as a second language (ESL) learners. The nature of oral language ability. Materials and Methods for developing oral communication skills at middle school, high school, and adult contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Science Fiction",
    "dept": "ENGL",
    "num": "330",
    "desc": "Prereq: ENGL 250\nStudy of science fiction from its origins in nineteenth-century to the present. May include study of specific types of science fiction, such as classic, cyberpunk, feminist, or apocalyptic narratives; and may include consideration of science fiction film and/or theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Visual Communication of Quantitative Information",
    "dept": "ENGL",
    "num": "332",
    "desc": "Prereq: STAT 101, STAT 104, STAT 201 or STAT 226; ENGL 250\nCommunicating quantitative information using visual displays; visualizing data; interactive and dynamic data displays; evaluating current examples in the media; color, perception, and representation in graphs; interpreting data displays.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Film",
    "dept": "ENGL",
    "num": "335",
    "desc": "Prereq: ENGL 250\nPrinciples of film art and the traditional vocabulary of literature as applied to film. Influence of film on modes of thought and behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Literary Theory and Criticism",
    "dept": "ENGL",
    "num": "339",
    "desc": "Prereq: ENGL 260 and 3 additional credits in literature\nStudy of selected texts of literary criticism, with attention to the purposes and practices of criticism.\n",
    "credits": "3"
  },
  {
    "course_name": "Women's Literature",
    "dept": "ENGL",
    "num": "340",
    "desc": "Prereq: ENGL 250\nHistorical and thematic survey of literature by and about women. May include autobiographies, journals, letters, poetry, fiction, and drama.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "U.S. Latino/a Literature",
    "dept": "ENGL",
    "num": "344",
    "desc": "Prereq: ENGL 250\nAn introduction to the literature of Mexican Americans, Puerto Ricans, Cuban Americans and other Latino/a sub-groups. Special emphasis on themes such as ethnic relations and comparisons with EuroAmerican literary traditions.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women and Literature: Selected Topics",
    "dept": "ENGL",
    "num": "345",
    "desc": "Prereq: ENGL 250\nLiterature by women and/or dealing with the images of women, e.g., study of individual authors or related schools of authors; exploration of specific themes or genres in women's literature; analysis of recurrent images of women in literature.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "American Indian Literature",
    "dept": "ENGL",
    "num": "346",
    "desc": "Prereq: ENGL 250\nSurvey of literature by Native Americans from pre-Columbian tales and songs to contemporary novels and poetry.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in African American Literature",
    "dept": "ENGL",
    "num": "347",
    "desc": "Prereq: ENGL 250\nLiterature by African Americans, which may include study of individual authors, movements, themes, genres.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Multicultural Literatures of the United States",
    "dept": "ENGL",
    "num": "349",
    "desc": "Prereq: ENGL 250\nLiterature by writers from U.S. multicultural groups. May include literature of several groups or focus upon one of the following: Asian Americans, African Americans, Latino/a Americans, American Indians.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Rhetorical Traditions",
    "dept": "ENGL",
    "num": "350",
    "desc": "Prereq: ENGL 250\nIdeas about the relationship between rhetoric and society in contemporary and historical contexts. An exploration of classical and contemporary rhetorical theories in relation to selected topics that may include politics, gender, race, ethics, education, science, or technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Gay and Lesbian Literature",
    "dept": "ENGL",
    "num": "352",
    "desc": "Prereq: ENGL 250\nLiterary portrayals of gay and lesbian lives and relationships from many different genres.  Attention to changing definitions and representations of sexual orientation and gender identity over time.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "World Literature: Western Foundations through Renaissance",
    "dept": "ENGL",
    "num": "353",
    "desc": "Prereq: ENGL 250\nRepresentative works from the drama, epics, poetry, and prose of the Ancient World through the late sixteenth century. May include Homer, Aeschylus, Sappho, Catullus, Dante, Marie de France, Boccaccio, Christine de Pizan, Cervantes, and others.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "World Literature: Seventeenth Century to the Present",
    "dept": "ENGL",
    "num": "354",
    "desc": "Prereq: ENGL 250\nGlobal literatures in their various cultural and aesthetic contexts. Representative works, oral and written literature, including poetry,   fiction, nonfiction, and drama.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Literature and the Environment",
    "dept": "ENGL",
    "num": "355",
    "desc": "Prereq: ENGL 250\nStudy of literary texts that address the following topics, among others: the relationship between people and natural/urban environments, ecocriticism, and the importance of place in the literary imagination.\n",
    "credits": "3"
  },
  {
    "course_name": "Myth and Fairytale",
    "dept": "ENGL",
    "num": "358",
    "desc": "Prereq: ENGL 250\nStudy of traditional fairytales, myths, and legends from diverse cultures.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in American Literature to 1800",
    "dept": "ENGL",
    "num": "360",
    "desc": "Prereq: ENGL 250; sophomore classification\nSelected readings in American literature from its beginnings through the colonial period; may reflect themes, genres, or social and cultural contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in 19th Century American Literature",
    "dept": "ENGL",
    "num": "362",
    "desc": "Prereq: ENGL 250; sophomore classification\nSelected readings in American literature of the 19th century; may reflect themes, genres, or social and cultural contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in American Literature: 1900 to the Present",
    "dept": "ENGL",
    "num": "364",
    "desc": "Prereq: ENGL 250; sophomore classification\nSelected readings in American literature since 1900; may reflect themes, genres, or social and cultural contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Shakespeare",
    "dept": "ENGL",
    "num": "370",
    "desc": "Prereq: ENGL 250\nReading and analysis of selected plays. Development of Shakespeare's dramatic art in its social and intellectual context.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in British Literature: The Middle Ages",
    "dept": "ENGL",
    "num": "373",
    "desc": "Prereq: ENGL 250; sophomore classification\nSelected readings in medieval literature from its beginnings through the fifteenth century; may reflect themes, genres, or social and cultural contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in British Literature: The Restoration and 18th Century",
    "dept": "ENGL",
    "num": "375",
    "desc": "Prereq: ENGL 250; sophomore classification\nSelected readings in British literature from 1660 to 1800; may reflect themes, genres, or social and cultural contexts.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in British Literature",
    "dept": "ENGL",
    "num": "376",
    "desc": "Prereq: ENGL 250; sophomore classification\nSelected readings from British literature from the late eighteenth century to about 1900; may reflect themes, genres, or social and cultural contexts.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in British Literature: Romantic",
    "dept": "ENGL",
    "num": "376A",
    "desc": "Prereq: ENGL 250; sophomore classification\nSelected readings from British literature from the late eighteenth century to about 1900; may reflect themes, genres, or social and cultural contexts.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in British Literature: Victorian",
    "dept": "ENGL",
    "num": "376B",
    "desc": "Prereq: ENGL 250; sophomore classification\nSelected readings from British literature from the late eighteenth century to about 1900; may reflect themes, genres, or social and cultural contexts.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Postcolonial Literature",
    "dept": "ENGL",
    "num": "389",
    "desc": "Prereq: ENGL 250; sophomore classification\nHistorical, thematic and theoretical study of postcolonial literatures from one or more of the following areas: Africa, South Asia, the Caribbean, and the Middle East. Irish and immigrant British writers may also be included.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "The History of Children's Literature",
    "dept": "ENGL",
    "num": "393",
    "desc": "Prereq: ENGL 250\nOrigin and development of English and American children's literature through the early twentieth century. Special emphasis on     nature, structure, and enduring themes of fantasy literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Study and Travel",
    "dept": "ENGL",
    "num": "395",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Study and Travel: Literature",
    "dept": "ENGL",
    "num": "395A",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Study and Travel: Creative Writing",
    "dept": "ENGL",
    "num": "395B",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Study and Travel: Linguistics",
    "dept": "ENGL",
    "num": "395C",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Study and Travel: Rhetoric and Professional Communication",
    "dept": "ENGL",
    "num": "395D",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Study and Travel: Teacher Education",
    "dept": "ENGL",
    "num": "395E",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Teaching the Reading of Young Adult Literature",
    "dept": "ENGL",
    "num": "396",
    "desc": "Prereq: ENGL 250\nCritical study and evaluation of themes, genres, and cultures found in young adult literature.  Strategies of effective reading; instructional strategies including discussion techniques and use of technology; matching texts to reader needs and proficiencies. Evaluation of fiction, nonfiction, and media-based materials for use in school programs. Lesson planning.\n",
    "credits": "3"
  },
  {
    "course_name": "Practice and Theory of Teaching Writing in the Secondary Schools",
    "dept": "ENGL",
    "num": "397",
    "desc": "Prereq: ENGL 219 or ENGL 220; application process initiated for admission to university teacher education program; concurrent enrollment in C I 280 (cr. 2); and background check initiated with state of Iowa Department of Criminal Investigation\nIntroduction to teaching secondary language arts. Current theories and practices in the teaching of writing to secondary school students. Theories of rhetoric, approaches to teaching, lesson design and planning. Evaluating writing. Professional portfolio preparation.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Workshop: Fiction",
    "dept": "ENGL",
    "num": "404",
    "desc": "Prereq: ENGL 304\nIndividual projects in short fiction on a workshop and conference basis. Readings in short fiction. Discussion of elements of narrative such as plot, point of view, characterization, theme, setting.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Workshop: Nonfiction",
    "dept": "ENGL",
    "num": "405",
    "desc": "Prereq: ENGL 305\nIndividual projects in memoir, immersion journalism, character studies, and/or the personal essay on a workshop and conference basis. Readings in creative nonfiction.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Workshop--Poetry",
    "dept": "ENGL",
    "num": "406",
    "desc": "Prereq: ENGL 306\nIndividual projects in poetry on a workshop and conference basis. Readings in poetry. Discussion of poetic elements such as image, sound, internal structure, rhythm, tone, figurative language.\n",
    "credits": "3"
  },
  {
    "course_name": "Language as Data",
    "dept": "ENGL",
    "num": "410",
    "desc": "Prereq: Junior standing\nMethods of discovering language patterns in text documents solve practical text analysis problems in the disciplines. Fundamentals of linguistics and its role in text analysis. Practice writing R scripts to perform text analysis and visualize textual data.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology, Rhetoric, and Professional Communication",
    "dept": "ENGL",
    "num": "411",
    "desc": "Prereq: ENGL 310; ENGL 302, ENGL 309, ENGL 313, or ENGL 314; junior classification\nSeminar course on the implication of technologies, especially computer technology, for the writing and reading of business,   technical, and academic texts. Extensive reading, discussion, and writing on selected technology-related topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Business and Technical Editing",
    "dept": "ENGL",
    "num": "415",
    "desc": "Prereq: ENGL 302, ENGL 309, or ENGL 314; junior classification\nEditing concepts and processes for choosing the appropriate level of editing for the particular rhetorical situation. Covers using editorial tools such as copy-marking symbols, developing style sheets and guides, and managing document production. Emphasizes developing an editorial eye for verbal and visual details in order to achieve accuracy, consistency, correctness, and completeness.\n",
    "credits": "3"
  },
  {
    "course_name": "Visual Aspects of Business and Technical Communication",
    "dept": "ENGL",
    "num": "416",
    "desc": "Prereq: ENGL 302, ENGL 309, or ENGL 314; junior classification\nRhetorical strategies and perceptual principles for designing print and digital visual elements such as diagrams and graphs and integrating those visual elements into business and technical communications. Covers strategies for employing visual elements such as typeface, page and screen layout, and illustrations in order to make communications more usable.\n",
    "credits": "3"
  },
  {
    "course_name": "Student Teaching",
    "dept": "ENGL",
    "num": "417",
    "desc": "Prereq: admission to teacher education, approval of coordinator the semester prior to student teaching\nFull-time teaching in content licensure area: long term and unit planning, lesson planning, classroom teaching practice.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: English and Literature",
    "dept": "ENGL",
    "num": "417E",
    "desc": "Prereq: ENGL 494, admission to teacher education, approval of coordinator the semester prior to student teaching\nFull-time teaching in secondary English: long term and unit planning, lesson planning, classroom teaching practice in English language arts.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Argumentation",
    "dept": "ENGL",
    "num": "418",
    "desc": "Prereq: ENGL 310, junior classification\nAdvanced seminar in theory and analysis with extensive practice in various modes of argument.\n",
    "credits": "3"
  },
  {
    "course_name": "History of the English Language",
    "dept": "ENGL",
    "num": "420",
    "desc": "Prereq: ENGL 219 or LING 219, ENGL 220 or LING 220\nComparison of English to other languages by family background and by type.  Analysis of representative Old, Middle, Early Modern   and present-day English texts, including both literary works and non-literary documents.\n",
    "credits": "3"
  },
  {
    "course_name": "Women, Men, and the English Language",
    "dept": "ENGL",
    "num": "422",
    "desc": "Prereq: ENGL 219 or LING 219\nThe ways men and women differ in using language in varied settings and the ways in which language both creates and reflects gender divisions.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Second Language Learning and Teaching",
    "dept": "ENGL",
    "num": "425",
    "desc": "Prereq: ENGL 219 or LING 219; junior classification\nThe process of second language learning and principles and techniques of teaching second languages. Learning and teaching in specific situations and for particular purposes. Current applications of technology in teaching and assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Grammatical Analysis",
    "dept": "ENGL",
    "num": "437",
    "desc": "Prereq: ENGL 220 or LING 220; ENGL 219 or LING 219 or introductory course in linguistics; junior classification\nTheories and methods for analysis of syntax and morphology.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in British Literature",
    "dept": "ENGL",
    "num": "440",
    "desc": "Prereq: Completion of 9 credits of surveys; junior classification\nSelected authors, movements, eras, or genres in British literature. Readings in criticism; required research paper.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in American Literature",
    "dept": "ENGL",
    "num": "441",
    "desc": "Prereq: Completion of 9 credits of surveys; junior classification\nSelected authors, movements, eras, or genres in American literature. Readings in criticism; required research paper.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar:  Literature Crossing Boundaries",
    "dept": "ENGL",
    "num": "445",
    "desc": "Prereq: Completion of 9 credits of surveys; junior classification\nIntensive study of selected literature that bridges traditional genre, period, national, or disciplinary boundaries.  Readings in   criticism; required research paper.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Literary Genres",
    "dept": "ENGL",
    "num": "450",
    "desc": "Prereq: Completion of 9 credits of surveys;  junior classification\nIntensive study of drama, film, fiction, poetry, or prose.  Selected movements, eras, or national traditions. Readings in criticism;   required research paper.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Gender and Ethnicity",
    "dept": "ENGL",
    "num": "460",
    "desc": "Prereq: Completion of 9 credits of surveys; junior classification\nSelected readings of various authors, movements, eras, or genres. Readings in criticism; required research paper.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Technical Communication",
    "dept": "ENGL",
    "num": "477",
    "desc": "Prereq: ENGL 302, ENGL 309, or ENGL 314\nIntensive study of a selected topic that bridges theory and practice in technical communication. Required project that contributes to the understanding of an emerging issue in the profession.\n",
    "credits": "3"
  },
  {
    "course_name": "Internship in Business, Technical, and Professional Communication",
    "dept": "ENGL",
    "num": "487",
    "desc": "Prereq: 9 credits in ENGL 302, ENGL 309, ENGL 313, ENGL 314, ENGL 415 (preferred), ENGL 416, or ENGL 477; junior classification; and permission of coordinator\nAn opportunity to write, edit, and design business and technical documents in a professional setting. Projects might include reports, proposals, manuals, brochures, newsletters.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "ENGL",
    "num": "490",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Literature",
    "dept": "ENGL",
    "num": "490A",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Linguistics",
    "dept": "ENGL",
    "num": "490B",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee or Linguistics Adviser\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Rhetoric, Teaching of Composition",
    "dept": "ENGL",
    "num": "490C",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Criticism and Theory of Literature",
    "dept": "ENGL",
    "num": "490D",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Instructional Methods and Research",
    "dept": "ENGL",
    "num": "490E",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Creative Writing",
    "dept": "ENGL",
    "num": "490F",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Business/Technical Communication",
    "dept": "ENGL",
    "num": "490G",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "ENGL",
    "num": "490H",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered or who desire to integrate a study of literature or language with special problems in major fields.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Undergraduate Teaching Experience",
    "dept": "ENGL",
    "num": "492",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee\nTeaching assistant experience.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Creative Writing Workshop—Multi-Genre",
    "dept": "ENGL",
    "num": "493",
    "desc": "Prereq: ENGL 304, ENGL 305, or ENGL 306 and junior standing\nAdvanced workshop of individual creative writing projects in short fiction, nonfiction, and poetry. Readings and discussion of published examples of short fiction, nonfiction, and poetry by authors of national and international note. Extensive discussion and written analysis of elements of craft across genres.\n",
    "credits": "3"
  },
  {
    "course_name": "Practice and Theory of Teaching Literature in the Secondary Schools",
    "dept": "ENGL",
    "num": "494",
    "desc": "Prereq: ENGL 310, ENGL 397, 9 other credits in English beyond ENGL 250, PSYCH 333, admission to teacher education program\nPortfolio review. Current theories and practices in the teaching of literature to secondary school students. Integrating literary study and writing. Preparation and selection of materials. Classroom presentation. Unit planning. (Taken concurrently with C I 280, Cr. 2, and Sp Ed 450).\n",
    "credits": "3"
  },
  {
    "course_name": "Capstone Assessment",
    "dept": "ENGL",
    "num": "497",
    "desc": "Prereq: Junior status\nMust be taken in conjunction with a 400-level English course.\n",
    "credits": "1"
  },
  {
    "course_name": "Teaching Multimodal Composition",
    "dept": "ENGL",
    "num": "500",
    "desc": "Prereq: Graduate classification; must be teaching ENGL 150 or ENGL 250 concurrently\nIntroduction to the teaching of ISUComm Foundation Courses. Foundational and relevant newer composition theory and pedagogical methods related to ISUComm Foundation Courses objectives and their classroom enactment, including development of assignments and supporting activities, and evaluation of student projects. Required of all new teaching assistants teaching ISUComm Foundation Courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Research in Rhetoric, Composition, and Professional Communication",
    "dept": "ENGL",
    "num": "501",
    "desc": "Prereq: 6 graduate credits in English\nSurvey of the major rhetorical, qualitative, and quantitative methods used in research on communication and language in academic and nonacademic settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Composition Theory",
    "dept": "ENGL",
    "num": "503",
    "desc": "Prereq: 6 graduate credits in English\nIn-depth consideration of the theory and practice of composition pedagogy. Opportunities for actual classroom application.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Advanced Communication",
    "dept": "ENGL",
    "num": "504",
    "desc": "Prereq: Graduate classification\nTeaching business and technical communication in university, community college, and industry settings. Emphasizes curriculum planning, materials development, assignment design, responding to student work, assessment of student work, and distance (online) teaching.\n",
    "credits": "3"
  },
  {
    "course_name": "User Experience Architecture and Testing for Advanced Communication",
    "dept": "ENGL",
    "num": "505",
    "desc": "Prereq: Graduate classification\nSeminar course examining user experience (UX) interface design and development in technical communication. Focus is on the UX project cycle: creating userfaces, conducting user research, system testing, and implementing data-driven results.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Communication Theory",
    "dept": "ENGL",
    "num": "506",
    "desc": "Prereq: Admission to English Department graduate degree program\nIntroduction to professional communication as a discipline, with emphasis on theories of communication and discourse that inform professional communication research and on trends and developments in that research and the field.\n",
    "credits": "3"
  },
  {
    "course_name": "Writing for Academic Publication",
    "dept": "ENGL",
    "num": "508",
    "desc": "Prereq: 6 graduate credits\nHands-on practice in writing academic discourse for publication; rhetorical analyses of student-selected academic journals; discussion of current trends in academic writing; professional perspectives on the referee process and on journal editorial decision making. Focus on the writing of selected short pieces (opinion essays, standard reviews, conference-length papers) and of article-length manuscripts.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Computers in Applied Linguistics",
    "dept": "ENGL",
    "num": "510",
    "desc": "Prereq: Graduate classification\nUse of software and web applications for language teaching, linguistic analysis, and statistical analysis. Issues and problems in applied linguistics related to computer methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Linguistic Analysis",
    "dept": "ENGL",
    "num": "511",
    "desc": "Prereq: Graduate classification\nPrinciples and methods of linguistic analysis with emphasis on phonology, morphology, and syntax. Description of linguistic variation and current theoretical approaches to linguistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Second Language Acquisition",
    "dept": "ENGL",
    "num": "512",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nTheory, methods, and results of second language acquisition research with emphasis on approaches relevant to second language teaching.\n",
    "credits": "3"
  },
  {
    "course_name": "Language Assessment Practicum",
    "dept": "ENGL",
    "num": "513",
    "desc": "Prereq: ENGL 519 or LING 519\nAdvanced practicum in language assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Sociolinguistics",
    "dept": "ENGL",
    "num": "514",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nTheories and methods of examining language in its social setting. Analysis of individual characteristics (e.g., age, gender, ethnicity, social class, region), interactional factors (e.g., situation, topic, purpose) and national policies affecting language use.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Natural Language Processing",
    "dept": "ENGL",
    "num": "515",
    "desc": "Prereq: STAT 330 or equivalent, recommended ENGL 219 or LING 219, or ENGL 511 or LING 511\nIntroduction to computational techniques involving human language and speech in applications such as information retrieval and extraction, automatic text categorization, word prediction, intelligent Web searching, spelling and grammar checking, speech recognition and synthesis, statistical machine translation, n-grams, POS-tagging, word-sense disambiguation, on-line lexicons and thesauri, markup languages, corpus analysis, and Python programming language.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Formal Linguistic Analysis",
    "dept": "ENGL",
    "num": "516",
    "desc": "Prereq: ENGL 219/LING 219 or equivalent.\nData and knowledge structures for formal representation of natural language and speech data. Designing and implementing algorithms for automating linguistic analysis tasks. Conceptual issues for natural language and speech processing programming.\n",
    "credits": "3"
  },
  {
    "course_name": "Second Language Assessment",
    "dept": "ENGL",
    "num": "519",
    "desc": "Prereq: ENGL 511 or LING 511\nPrinciples of second language assessment including reliability, validity, authenticity and practicality. Constructing, scoring,   interpreting, and evaluating second language tests for a variety of situations.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Analysis of English",
    "dept": "ENGL",
    "num": "520",
    "desc": "Prereq: ENGL 510 or LING 510, and ENGL 511 or LING 511\nConcepts and practices for analysis of English by computer with emphasis on the applications of computational analysis to problems   in applied linguistics such as corpus analysis and recognition of learner language in computer-assisted learning and language   assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching of Literature and the Literature Curriculum",
    "dept": "ENGL",
    "num": "521",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nExamination of the roles of the literary work, reader, and teacher in literary study. Responses to literature. Place of literature in language arts. Study and development of curriculum materials for middle school, high school, and college levels of instruction.\n",
    "credits": "3"
  },
  {
    "course_name": "Literary Theory and Criticism",
    "dept": "ENGL",
    "num": "522",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nExamination of the history, logic, and rhetoric of contemporary literary criticism and analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Old English Language and Literature",
    "dept": "ENGL",
    "num": "523",
    "desc": "Prereq: Course in medieval literature or history or history of the English language recommended\nIntroductory study of Old English language and literature in prose and poetry, including extracts from Beowulf. Some attention to Anglo-Saxon culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Literacy: Issues and Methods for Nonnative Speakers of English",
    "dept": "ENGL",
    "num": "524",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nTheoretical and practical issues and techniques in the teaching of literacy in a variety of contexts, involving children and adults at basic skill levels and teens and adults in academic and vocational programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Research and Teaching of Second Language Pronunciation",
    "dept": "ENGL",
    "num": "525",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nTheoretical and practical issues and techniques in the teaching of second language pronunciation as it relates to other areas of language, especially listening and speaking skills. Topics will include segmental and suprasegmental features; intelligibility; pronunciation in language assessment; classroom, technology and individual instruction; and research issues. Topics will be relevant to those intending to teach or research in various contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer-Assisted Language Learning",
    "dept": "ENGL",
    "num": "526",
    "desc": "Prereq: ENGL 511 or LING 511 or equivalent\nTheory, research, and practice in computer use for teaching nonnative speakers of English. Methods for planning and evaluating computer-based learning activities.\n",
    "credits": "3"
  },
  {
    "course_name": "Discourse Analysis",
    "dept": "ENGL",
    "num": "527",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nMethods and theoretical foundations for linguistic approaches to discourse analysis. Applications of discourse analysis to the study of texts in a variety of settings, including academic and research contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "English for Specific Purposes",
    "dept": "ENGL",
    "num": "528",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nIssues and techniques in analyzing, teaching, and assessing English for specific purposes. Topics include theories of specific purpose language use, analysis of learner needs in target language contexts, and corpus-informed syllabus and materials development for teaching and assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Content Management",
    "dept": "ENGL",
    "num": "529",
    "desc": "Prereq: ENGL 313\nStrategies for developing and delivering multimodal content via digital media. Focus on the principles of database design, interface development, usability testing, and collaborative content management within professional communication settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology and Oral Language",
    "dept": "ENGL",
    "num": "530",
    "desc": "Prereq: ENGL 219 or ENGL 511 or equivalent.\nStructure and description of oral language and discourse. How spoken language is linguistically described, analyzed, and taught for research and for education. Using technology to record, transcribe, and analyze spoken language at all levels of linguistic structure.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in the Study of Literature",
    "dept": "ENGL",
    "num": "531",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nIntensive study of literary genres, periods, movements, or themes; e.g., Literature and Historicism, Narrating the Feminine, Allegory.\n",
    "credits": "3"
  },
  {
    "course_name": "American Literature to 1865",
    "dept": "ENGL",
    "num": "532",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nSelected texts in American literature from Beginnings to the Civil War. Study may include Native American literature, the literature of European conquest, Colonial and Revolutionary periods, Early Republic, and Jacksonian Era, in critical and cultural contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "British Literature to 1830",
    "dept": "ENGL",
    "num": "533",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nSelected texts from the Medieval, Renaissance, Restoration, Eighteenth-Century, and/or Romantic periods, in critical and cultural contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "American Literature 1865 to the Present",
    "dept": "ENGL",
    "num": "534",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nSelected texts in American literature from the Civil War to the present. Study may include Realism, Naturalism, Modernism, and Postmodernism, with significant attention to race/ethnicity, gender, and identity, and to contemporary critical views. Range of authors and genres.\n",
    "credits": "3"
  },
  {
    "course_name": "British Literature 1830 to the Present",
    "dept": "ENGL",
    "num": "535",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nSelected texts from the Victorian, Edwardian, Modernist, and/or Contemporary periods, in critical and cultural contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Corpus Approaches to Grammatical Analysis",
    "dept": "ENGL",
    "num": "537",
    "desc": "Prereq: ENGL 220 or LING 220; ENGL 219, LING 219, ENGL 511, LING 511, or introductory course in linguistics; graduate classification\nCorpus-informed analysis of syntax in authentic writing and speech, with emphasis on approaches used in applied linguistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Fiction",
    "dept": "ENGL",
    "num": "538",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nSelected fiction writers in English; range of authors and genres. Emphasis on both male and female writers; attention to the relationships between fiction and cultural change.\n",
    "credits": "3"
  },
  {
    "course_name": "Poetry",
    "dept": "ENGL",
    "num": "539",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nSelected poets writing in English, considered in representative groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Drama",
    "dept": "ENGL",
    "num": "540",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nPrimary texts in dramatic genres from various literary periods, in critical and cultural contexts. Frequently concentrates on the English Renaissance and the Shakespearean stage.\n",
    "credits": "3"
  },
  {
    "course_name": "Document Design and Editing",
    "dept": "ENGL",
    "num": "542",
    "desc": "Prereq: Senior classification\nOverview of the principles of desktop publishing as practiced in the field of technical communication. Focus on theories of print document design and project management, as well as digital prepress techniques employed to produce documents using external print services. Requires extensive use of current desktop publishing software.\n",
    "credits": "3"
  },
  {
    "course_name": "The Study of Environmental Literature",
    "dept": "ENGL",
    "num": "543",
    "desc": "Prereq: Graduate classification\nIntensive study of environmental literary genres, periods, figures, movements, or themes: e.g., Ecofeminism, Imagining Natural Disaster, Material Ecocriticism, Environmental Justice, Posthumanism.\n",
    "credits": "3"
  },
  {
    "course_name": "Women's Literature",
    "dept": "ENGL",
    "num": "545",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nPrimary texts by women writers; historical, thematic, formal, or theoretical approaches; secondary readings; e.g., Nineteenth-Century Women Writers; American Women's Personal Narratives; Southern Women Writers of the U.S.\n",
    "credits": "3"
  },
  {
    "course_name": "Issues in the Study of Literature",
    "dept": "ENGL",
    "num": "546",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nIntensive study of current and emerging topics and problems concerning literature and its relationship to theory and to language study; e.g., Theory of Metaphor; Renegotiating the Canon; Feminist Theory.\n",
    "credits": "3"
  },
  {
    "course_name": "The History of Rhetorical Theory I: From Plato to Bacon",
    "dept": "ENGL",
    "num": "547",
    "desc": "Prereq: 6 credits in English\nRhetorical theory from the classical period of ancient Greece and Rome through the Middle Ages to the early Renaissance; attention to its relation to the nature of knowledge, communication, practice, and pedagogy.\n",
    "credits": "3"
  },
  {
    "course_name": "The History of Rhetorical Theory II: From Bacon to the Present",
    "dept": "ENGL",
    "num": "548",
    "desc": "Prereq: 6 credits in English\nRhetorical theory from the early modern period (Bacon, Descartes, and Locke) to the present; attention to its relation to the nature of knowledge, communication practice, and pedagogy.\n",
    "credits": "3"
  },
  {
    "course_name": "Multimedia and Interaction Design",
    "dept": "ENGL",
    "num": "549",
    "desc": "Prereq: Senior classification\nRhetorical principles of interactive multimedia design, such as those in DVDs, Blu-Ray videos, and streaming web multimedia. Practical understanding of computer applications used in interactive multimedia development. Focus on theoretical and practical elements of producing multimedia training in both education and industry. Work with interactive hypertext, digital audio, and nonlinear video editing.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing: Craft and Professional Practice",
    "dept": "ENGL",
    "num": "550",
    "desc": "Prereq: Admission into MFA Program in Creative Writing and Environment\nA multigenre craft course required of all incoming students in the MFA Program in Creative Writing and Environment. Students develop an understanding of craft and environmental writing across genres (poetry, fiction, nonfiction) as well as learn about editing and publication practice through the lens of a working literary journal, \"Flyway: A Journal of Writing and Environment.\" Other course activities include presentations on the production practices of leading literary journals, individual editing projects, pragmatic tips for finding publication outlets for polished creative work, and a field trip to publishing houses.\n",
    "credits": "3"
  },
  {
    "course_name": "Master Workshop",
    "dept": "ENGL",
    "num": "551",
    "desc": "Prereq: Fifth-semester or equivalent standing in the Creative Writing and Environment MFA program\nAn advanced multigenre creative writing workshop. Students work intensively on book-length manuscripts of fiction, creative nonfiction, scriptwriting, or poetry.\n",
    "credits": "3"
  },
  {
    "course_name": "Workshop: Fiction",
    "dept": "ENGL",
    "num": "554",
    "desc": "Prereq: ENGL 550 and graduate classification. Open to graduate students outside MFA in Creative Writing and Environment with permission of instructor\nIndividual projects in fiction on a workshop and conference basis. Readings in short fiction. Discussion of elements of narrative such as plot, point of view, characterization, theme, setting.\n",
    "credits": "3"
  },
  {
    "course_name": "Workshop: Nonfiction",
    "dept": "ENGL",
    "num": "555",
    "desc": "Prereq: ENGL 550 and graduate classification. Open to graduate students outside MFA in Creative Writing and Environment with permission of instructor\nIndividual projects in memoir, immersion journalism, character studies, and/or the personal essay on a workshop and conference basis. Readings in creative nonfiction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop: Poetry",
    "dept": "ENGL",
    "num": "556",
    "desc": "Prereq: ENGL 550 and graduate classification. Open to graduate students outside MFA in Creative Writing and Environment with permission of instructor\nIndividual projects in poetry on a workshop and conference basis. Readings in poetry. Discussion of poetic elements such as image, sound, internal structure, rhythm, tone, figurative language.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Creative Writing",
    "dept": "ENGL",
    "num": "557",
    "desc": "Prereq: Graduate classification. Open to graduate students outside MFA in Creative Writing and Environment with permission of instructor.\nSpecial topics course on ideas, issues, and techniques in creative writing. Subject matter may include specific genres, aspects of the creative writing process, or themes of particular interest. Significant readings and written work required; previous workshop experience helpful.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Creative Writing",
    "dept": "ENGL",
    "num": "558",
    "desc": "Prereq: Graduate classification\nPedagogical approaches that are effective for grade-school through adult-education creative writing teaching. Writing exercises, workshops, text evaluation, and visits from creative writers.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Writing Teaching Internship",
    "dept": "ENGL",
    "num": "559",
    "desc": "Prereq: Permission of participating instructors\nStudents assist in an introductory creative writing class. Some supervised teaching but mainly evaluation of submissions and individual conferences. Requirements and grades determined by participating instructors.\n",
    "credits": "1"
  },
  {
    "course_name": "Environmental Field Experience",
    "dept": "ENGL",
    "num": "560",
    "desc": "Prereq: ENGL 550 and graduate classification. Open to graduate students outside MFA in Creative Writing and Environment with permission of instructor\nStudents spend a term on a project that requires fieldwork. Projects might include working for a federal, state, or private non-profit environmental organization or farm, or living and working in a specified natural area.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods for Scholarship in Literature and the Humanities",
    "dept": "ENGL",
    "num": "561",
    "desc": "Prereq: Graduate classification or permission from the instructor\nIntensive study of research methods and perspectives concerning the study of literature and the humanities at the master’s level. Introduction to resources and techniques of research, the structure of academic articles, and strategies for argument in academic communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in the Study of Film",
    "dept": "ENGL",
    "num": "562",
    "desc": "Prereq: Graduate classification or 6 credits in film at 300 level or above\nIntensive study of cinematic genres, periods, movements, or themes; e.g., The Musical, Classical Hollywood Cinema, Structural Film, Art and Cinema. General emphasis will be on American, British, and other Anglophone cinemas.\n",
    "credits": "3"
  },
  {
    "course_name": "Grant Writing",
    "dept": "ENGL",
    "num": "569",
    "desc": "Prereq: at least two prior years of graduate classification.\nWriting a winning proposal.\n",
    "credits": "1"
  },
  {
    "course_name": "Visual Rhetoric in Professional Communication",
    "dept": "ENGL",
    "num": "586",
    "desc": "Prereq: A course in professional communication\nRhetorical theory and research in graphics, document design, and related principles of visual communication. Methods of designing texts, data displays, illustrations, and other visual elements in business and technical communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Internship in Business, Technical, and Professional Communication",
    "dept": "ENGL",
    "num": "587",
    "desc": "Prereq: Three graduate credits in business and technical writing or composition and rhetoric, permission of instructor. Limited to master's and doctoral degree candidates in the field of rhetoric and professional communication\nAn opportunity to write, edit, and design business and technical documents in a professional setting.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Practice Teaching in Teaching English as a Second Language",
    "dept": "ENGL",
    "num": "588",
    "desc": "Prereq: 9 credits toward the TESL/TEFL Certificate, 15 credits toward the TESL/AL master's degree, or 18 credits completed toward the ESL Endorsement option.\nIntensive observation of ESL instruction and supervised practice in teaching learners of English in a context appropriate to the student teacher's goals.\n  ENGL 588 cannot be used for teacher licensure and cannot be taken during student teaching.",
    "credits": "3"
  },
  {
    "course_name": "Supervised Practicum in Literary Editing",
    "dept": "ENGL",
    "num": "589",
    "desc": "Prereq: ENGL 550 and permission of instructor\nAn opportunity to edit literary texts and gain experience in a literary publishing setting.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "ENGL",
    "num": "590",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Literature",
    "dept": "ENGL",
    "num": "590A",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Teaching English as a Second Language (TESL)/Applied Linguistics",
    "dept": "ENGL",
    "num": "590B",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Composition and Rhetoric",
    "dept": "ENGL",
    "num": "590C",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Rhetoric and Professional Communication",
    "dept": "ENGL",
    "num": "590E",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Creative Writing",
    "dept": "ENGL",
    "num": "590F",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Applied Linguistics and Technology",
    "dept": "ENGL",
    "num": "590G",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Directed Readings",
    "dept": "ENGL",
    "num": "591",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Directed Readings: Literature",
    "dept": "ENGL",
    "num": "591A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Directed Readings: Teaching English as a Second Language (TESL)/Applied Linguistics",
    "dept": "ENGL",
    "num": "591B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Directed Readings: Composition and Rhetoric",
    "dept": "ENGL",
    "num": "591C",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Directed Readings: Rhetoric and Professional Communication",
    "dept": "ENGL",
    "num": "591E",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Directed Readings: Creative Writing",
    "dept": "ENGL",
    "num": "591F",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Directed Readings: Applied Linguistics and Technology",
    "dept": "ENGL",
    "num": "591G",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Core Studies in Rhetoric, Composition, and Professional Communication",
    "dept": "ENGL",
    "num": "592",
    "desc": "Prereq: 12 credits in rhetoric, linguistics, or literature, excluding ENGL 150 and ENGL 250\nSeminar on topics central to the fields of rhetoric and professional communication or composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Core Studies: Rhetoric",
    "dept": "ENGL",
    "num": "592A",
    "desc": "Prereq: 12 credits in rhetoric, linguistics, or literature, excluding ENGL 150 and ENGL 250\nSeminar on topics central to the fields of rhetoric and professional communication or composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Core Studies: Composition",
    "dept": "ENGL",
    "num": "592B",
    "desc": "Prereq: 12 credits in rhetoric, linguistics, or literature, excluding ENGL 150 and ENGL 250\nSeminar on topics central to the fields of rhetoric and professional communication or composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Core Studies: Professional Communication",
    "dept": "ENGL",
    "num": "592C",
    "desc": "Prereq: 12 credits in rhetoric, linguistics, or literature, excluding ENGL 150 and ENGL 250\nSeminar on topics central to the fields of rhetoric and professional communication or composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Study and Travel",
    "dept": "ENGL",
    "num": "595",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Study and Travel: Literature",
    "dept": "ENGL",
    "num": "595A",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Study and Travel: Creative Writing",
    "dept": "ENGL",
    "num": "595B",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Study and Travel: Linguistics",
    "dept": "ENGL",
    "num": "595C",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Study and Travel: Rhetoric and Professional Communication",
    "dept": "ENGL",
    "num": "595D",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Study and Travel: Teacher Education",
    "dept": "ENGL",
    "num": "595E",
    "desc": "Prereq: Permission of instructor\nSupervised study of an appropriate area of the discipline while traveling in a foreign country or in the U.S. Special fees apply.\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "ENGL",
    "num": "599",
    "desc": "Prereq: Graduate classification, permission of major professor\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Rhetoric, Composition, and Professional Communication",
    "dept": "ENGL",
    "num": "602",
    "desc": "Prereq: ENGL 501\nA workshop for advanced graduate students in rhetoric and professional communication. Focus on rhetorical analysis, qualitative methods, or quantitative methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Rhetoric, Composition, and Professional Communication: Qualitative Research",
    "dept": "ENGL",
    "num": "602A",
    "desc": "Prereq: ENGL 501\nA workshop for advanced graduate students in rhetoric and professional communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Rhetoric, Composition, and Professional Communication: Quantitative Research",
    "dept": "ENGL",
    "num": "602B",
    "desc": "Prereq: ENGL 501\nA workshop for advanced graduate students in rhetoric and professional communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Rhetoric, Composition, and Professional Communication: Rhetorical Analysis",
    "dept": "ENGL",
    "num": "602C",
    "desc": "Prereq: ENGL 501\nExtended practice in close textual analysis of various kinds of rhetorical artifacts. Attention to important theoretical concepts used in rhetorical analysis and to historical controversies over the scope and function of rhetorical analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Composition Theory",
    "dept": "ENGL",
    "num": "603",
    "desc": "Prereq: ENGL 503\nExploration of relationships between theory and practice in current pedagogy. Intensive examination of contemporary theories of poststructuralism, new media, feminism, postcolonialism, or cultural studies  and their impact on current pedagogical practice. Participation in pedagogical research and theory building.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Rhetorical Theory",
    "dept": "ENGL",
    "num": "611",
    "desc": "Prereq: ENGL 547 or ENGL 548\nRhetorical theory, criticism, and/or practice in relation to an historical period or a particular theoretical issue.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Applied Linguistics",
    "dept": "ENGL",
    "num": "623",
    "desc": "Prereq: ENGL 511 or LING 511\nSurvey of research traditions in applied linguistics. Focus on theoretical and practical aspects of quantitative and qualitative approaches to applied linguistic study, including experimental and quasiexperimental methods, classroom observation and research, introspective methods, elicitation techniques, case studies, interactional analysis, ethnography, and program evaluation. Computational tools and resources for linguistic research will be highlighted.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer-Assisted Language Testing",
    "dept": "ENGL",
    "num": "626",
    "desc": "Prereq: ENGL 510 or LING 510, ENGL 511 or LING 511, ENGL 519 or LING 519\nPrinciples and practice for the use and study of computers and the Internet in second language assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Applied Linguistics",
    "dept": "ENGL",
    "num": "630",
    "desc": "Prereq: ENGL 510 or LING 510, ENGL 511 or LING 511\nTopic changes each semester. Topics include advanced methods in natural language processing, technology and literacy in a global context, feedback in CALL programs, technology and pronunciation, and advances in language assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Administration and Organization of Multimodal Writing Programs",
    "dept": "ENGL",
    "num": "631",
    "desc": "Prereq: ENGL 500, ENGL 503, ENGL 504, or ENGL 603\nSurvey of the major components of writing instruction in academic and nonacademic settings. History, theory, organization, and evaluation of writing programs. Guided observation of writing program functions at various institutions and businesses.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "ENGL",
    "num": "699",
    "desc": "Prereq: Graduate classification, permission of major professor\nResearch.\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to Insects",
    "dept": "ENT",
    "num": "201",
    "desc": "\n5 weeks. Classroom section spring only. World Wide Web section of course offered summer and fall semesters. Biological and ecological aspects of insects.\n",
    "credits": "1"
  },
  {
    "course_name": "Insects and Society",
    "dept": "ENT",
    "num": "211",
    "desc": "Prereq: ENT 201\n11 weeks. Classroom section spring only. World Wide Web section offered fall semester.  The importance of insects in human well-being. Insect-human interactions. Primarily for nonscience and nonagriculture majors.\n",
    "credits": "2"
  },
  {
    "course_name": "Insects in Forensic Science",
    "dept": "ENT",
    "num": "214",
    "desc": "Prereq: none\nIntroduction to the use of insects as evidence in court and how they can assist in solving crimes. Topics covered include basic insect biology, systematics, behavior, with emphasis on applications of forensic entomology.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Forensic Science",
    "dept": "ENT",
    "num": "220",
    "desc": "Prereq: none\nStudy of fundamental forensic science techniques and procedures covering types of physical, chemical, and biological evidence and how this information is used in the legal system.  Assessment of crime scenes and various forensic specialties will be introduced.\n",
    "credits": "3"
  },
  {
    "course_name": "Pesticide Application Certification",
    "dept": "ENT",
    "num": "283",
    "desc": "\nCore background and specialty topics in agricultural, and horticultural pesticide applicator certification. Students can select certification categories and have the opportunity to obtain pesticide applicator certification at the completion of the course. Commercial pesticide applicator certification is emphasized.\n",
    "credits": "2"
  },
  {
    "course_name": "Insect Biology",
    "dept": "ENT",
    "num": "370",
    "desc": "Prereq: BIOL 101 or BIOL 211\nStructure, physiology, evolution, behavior, life histories, and recognition of insects. Collection required.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Insect Ecology",
    "dept": "ENT",
    "num": "371I",
    "desc": "\nField and laboratory study of insects, their diversity, life history; emphasis on ecology and behavior.\n",
    "credits": "4"
  },
  {
    "course_name": "Livestock Entomology",
    "dept": "ENT",
    "num": "372",
    "desc": "\nClassroom and off-campus videotape sections. 12 weeks. Recognition, biology, behavior, economic importance, and   management of insects and other arthropods affecting livestock and poultry production.\n",
    "credits": "2"
  },
  {
    "course_name": "Insects and Our Health",
    "dept": "ENT",
    "num": "374",
    "desc": "Prereq: 3 credits in biological sciences\nIdentification, biology, and significance of insects and arthropods that affect the health of humans and animals, particularly those that are vectors of disease.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Insects and Our Health Laboratory",
    "dept": "ENT",
    "num": "374L",
    "desc": "Prereq: Credit or enrollment in ENT 374\nLaboratory and field techniques for studying medical or public health entomology, including: collection, identification and maintenance of medically significant arthropods and experimental design and execution related to the biology of arthropods or arthropod-pathogen interactions.\n",
    "credits": "1"
  },
  {
    "course_name": "Plant Protection Using Natural Enemies",
    "dept": "ENT",
    "num": "375",
    "desc": "Prereq: ENT 370 or ENT 376\nOverview of the biology, ecology, and classification of insect pathogens, predators, and parasitoids. Discussion of   the use of these organisms in plant protection, including an emphasis on genetic alteration of natural enemies.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Entomology and Pest Management",
    "dept": "ENT",
    "num": "376",
    "desc": "Prereq: BIOL 101 or BIOL 211\nIntroduction to entomology and insect-pest management, including life processes, ecology, economics, tactics of population suppression, and ecological backlash.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Insects",
    "dept": "ENT",
    "num": "425",
    "desc": "Prereq: BIOL 312 or equivalent\nMorphology, ecology, diversity, and significance of aquatic insects, with emphasis on the collection, curation and identification of taxa in local streams and lakes.\n",
    "credits": "3"
  },
  {
    "course_name": "Pesticides in the Environment",
    "dept": "ENT",
    "num": "450",
    "desc": "Prereq: 9 credits of biological sciences\nFate and significance of pesticides in soil, water, plants, animals, and the atmosphere.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Management of Diseases and Insect Pests of Turfgrasses",
    "dept": "ENT",
    "num": "452",
    "desc": "Prereq: HORT 351\nIdentification and biology of important diseases and insect pests of turfgrasses. Development of integrated pest management programs in various turfgrass environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Service Management",
    "dept": "ENT",
    "num": "466",
    "desc": "Prereq: permission of instructor\nLand use and conservation techniques for improving ecosystem services including: pollination of crops, biological control of pests, prevention of erosion and water quality improvement.\n",
    "credits": "3"
  },
  {
    "course_name": "Insect Ecology",
    "dept": "ENT",
    "num": "471",
    "desc": "Prereq: 9 credits biological sciences\nThe contribution of insects to ecosystem function is staggering.  This course will focus on insect population ecology, predator-prey interaction and chemical ecology.  The role of insects in nutrient cycling, pollination and pest management will be discussed with case studies used to highlight the applied nature of insect ecology and its relationship to agriculture.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ENT",
    "num": "490",
    "desc": "Prereq: 15 credits in biological sciences, junior or senior classification\n  A maximum of 9 credits of all (university-wide) 490 credits may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Research or work experience.",
    "dept": "ENT",
    "num": "490E",
    "desc": "Prereq: 15 credits in biological sciences, junior or senior classification\n  A maximum of 9 of all (university-wide) 490 credits may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Laboratory teaching experience",
    "dept": "ENT",
    "num": "490U",
    "desc": "Prereq: 15 credits in biological sciences, junior or senior classification. For students registering to be undergraduate laboratory assistants.\n  A maximum of 9 of all (university-wide) 490 credits may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Integrated Management of  Tropical Crops",
    "dept": "ENT",
    "num": "511",
    "desc": "Prereq: PL P 408 or PL P 416 or ENT 370 or ENT 376 or HORT 221\nApplications of Integrated Crop Management principles (including plant pathology, entomology, and horticulture) to tropical cropping systems. Familiarization with a variety of tropical agroecosystems and Costa Rican culture is followed by 10-day tour of Costa Rican agriculture during spring break, then writeup of individual projects.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Insects",
    "dept": "ENT",
    "num": "525",
    "desc": "Prereq: BIOL 312 or equivalent\nMorphology, ecology, diversity, and significance of aquatic insects, with emphasis on the collection, curation and identification of taxa in local streams and lakes.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecologically Based Pest Management Strategies",
    "dept": "ENT",
    "num": "530",
    "desc": "\nDurable, least-toxic strategies for managing weeds, pathogens, and insect pests, with emphasis on underlying ecological processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Pesticides in the Environment",
    "dept": "ENT",
    "num": "550",
    "desc": "Prereq: 9 credits of biological sciences\nFate and significance of pesticides in soil, water, plants, animals, and the atmosphere.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Management of Diseases and Insect Pests of Turfgrasses",
    "dept": "ENT",
    "num": "552",
    "desc": "Prereq: HORT 351\nIdentification and biology of important diseases and insect pests of turfgrasses. Development of integrated pest management programs in various turfgrass environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Insect Physiology",
    "dept": "ENT",
    "num": "555",
    "desc": "Prereq: ENT 370\nLife processes of the insects, including reviews of current problems in insect physiology.\n",
    "credits": "4"
  },
  {
    "course_name": "Ecosystem Service Management",
    "dept": "ENT",
    "num": "566",
    "desc": "Prereq: permission of instructor\nLand use and conservation techniques for improving ecosystem services including: pollination of crops, biological control of pests, prevention of erosion and water quality improvement.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Systematics",
    "dept": "ENT",
    "num": "568",
    "desc": "Prereq: Permission of instructor\nPrinciples and practice of systematic biology; taxonomy, nomenclature and classification of plants and animals; sources and interpretation of systematic data; speciation; fundamentals of phylogenetic systematics.\n",
    "credits": "3"
  },
  {
    "course_name": "Plant-Insect Interaction",
    "dept": "ENT",
    "num": "570",
    "desc": "Prereq: 9 credits in biological sciences\nPhysiological, behavioral, ecological, and evolutionary factors that govern interactions between insects and plants, applications of this knowledge to agriculture, and important results from the study of natural systems. Additional topics covered during the semester include: tritrophic interactions, biological control of plants by insects, and pollination biology. Student-led discussions and draws on both the primary and secondary literature.\n",
    "credits": "2"
  },
  {
    "course_name": "Insect Ecology",
    "dept": "ENT",
    "num": "571",
    "desc": "Prereq: 9 credits biological sciences\nThe contribution of insects to ecosystem function is staggering.  This course will focus on insect population ecology, predator-prey interaction and chemical ecology.  The role of insects in nutrient cycling, pollination and pest management will be discussed with case studies used to highlight the applied nature of insect ecology and its relationship to agriculture.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Entomology",
    "dept": "ENT",
    "num": "574",
    "desc": "Prereq: 9 credits in biological sciences\nIdentification, biology, and significance of insects and other arthropods that attack people and animals, particularly those that are vectors of disease.\n",
    "credits": "4"
  },
  {
    "course_name": "Plant Protection Using Natural Enemies",
    "dept": "ENT",
    "num": "575",
    "desc": "Prereq: ENT 370 or ENT 376\nOverview of the biology, ecology, and classification of insect pathogens, predators, and parasitoids. Discussion of   the use of these organisms in plant protection, including an emphasis on genetic alteration of natural enemies.\n",
    "credits": "3"
  },
  {
    "course_name": "Systematic Entomology",
    "dept": "ENT",
    "num": "576",
    "desc": "Prereq: ENT 370\nClassification, distribution, and natural history of insects, including fundamentals of phylogenetic systematics, biogeography, taxonomic procedures, and insect collection and curation.\n",
    "credits": "5"
  },
  {
    "course_name": "Special Topics",
    "dept": "ENT",
    "num": "590",
    "desc": "Prereq: 15 credits in biological sciences.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Biological Control and Pathology.",
    "dept": "ENT",
    "num": "590A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Chemical Ecology and Behavior.",
    "dept": "ENT",
    "num": "590B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Ecology and Pest Management.",
    "dept": "ENT",
    "num": "590C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Evolution and Systematics.",
    "dept": "ENT",
    "num": "590D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Special Research Topics.",
    "dept": "ENT",
    "num": "590E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Medical and Veterinary Entomology.",
    "dept": "ENT",
    "num": "590F",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Molecular Entomology.",
    "dept": "ENT",
    "num": "590G",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Toxicology",
    "dept": "ENT",
    "num": "590I",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Teaching Experience.",
    "dept": "ENT",
    "num": "590K",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Extension Internship.",
    "dept": "ENT",
    "num": "590L",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Immature Insects.",
    "dept": "ENT",
    "num": "590M",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Population Genetics.",
    "dept": "ENT",
    "num": "590N",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "ENT",
    "num": "600",
    "desc": "\nPresentation of research results.\n",
    "credits": "1"
  },
  {
    "course_name": "Insecticide Toxicology",
    "dept": "ENT",
    "num": "675",
    "desc": "Prereq: ENT 555 or TOX 501\nPrinciples of insecticide toxicology; classification, mode of action, metabolism, and environmental effects of insecticides.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "ENT",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Entrepreneurship and Innovation",
    "dept": "ENTSP",
    "num": "310",
    "desc": "Prereq: Sophomore classification\nReview of the entrepreneurial process with emphasis on starting a new business. How to analyze opportunities, develop an innovative product, organize, finance, market, launch, and manage a new venture. Deals with the role of the entrepreneur and the importance of a business plan. Speakers and field project.\n",
    "credits": "3"
  },
  {
    "course_name": "Feasibility Analysis and Business Planning",
    "dept": "ENTSP",
    "num": "313",
    "desc": "Prereq: MGMT 310\nDeveloping an idea for a new business venture, conducting a feasibility study, researching the potential market, analyzing the competition, and writing a formal business plan. Basic business functions are discussed in terms of their application to conducting feasibility analysis and writing a business plan for an entrepreneurial venture.\n",
    "credits": "3"
  },
  {
    "course_name": "Corporate Entrepreneurship, Innovation and Technology Management",
    "dept": "ENTSP",
    "num": "320",
    "desc": "Prereq: MGMT 310\nEntrepreneurial approaches aimed at the identification, development and exploitation of technical and organizational innovations, the management of new product or process developments, and the effective management of new ventures in the context of mid-size to large corporations in manufacturing as well as in service industries. Development of an awareness and understanding of the range, scope, and complexity of issues related to the creation of a corporate environment that is supportive of entrepreneurial endeavors as well as to gain insights concerning the effective implementation of technological and organizational innovations in corporate settings.\n",
    "credits": "3"
  },
  {
    "course_name": "International Entrepreneurship",
    "dept": "ENTSP",
    "num": "367",
    "desc": "Prereq: Sophomore classification\nThe essentials of operating an entrepreneurial firm in an international environment. Topics include understanding the role of entrepreneurship in economic development, starting and developing a business in an international market, financing international ventures, international management issues and exchange rates.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Entrepreneurship",
    "dept": "ENTSP",
    "num": "410",
    "desc": "Prereq: Sophomore classification\nIntroduction to issues related to the role of social entrepreneurship in helping to solve social problems, including innovation, opportunity recognition, planning and the launch of new non-profit organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Entrepreneurship: Executing New Ventures and Projects",
    "dept": "ENTSP",
    "num": "480",
    "desc": "Prereq: MGMT 310; MGMT 313 or MGMT 320\nExperiential learning through student-identified project. Students identify, propose and execute an experiential learning project that will be completed during the semester. The course provides application oriented learning of entrepreneurship. The course project must include a significant experiential learning activity, such as launching a venture or business, writing a business plan, or completing an internship in an entrepreneurial setting. Requires a field project.\n",
    "credits": "3"
  },
  {
    "course_name": "Trends and Theories of Entrepreneurship",
    "dept": "ENTSP",
    "num": "485",
    "desc": "Prereq: MGMT 310; MGMT 313 or MGMT 320\nA broad examination of historical, literary, and business perspectives on entrepreneurship. The entrepreneurial process is studied by examining the role of individuals, new ventures, and established organizations in the discovery, evaluation, and exploitation of economic opportunities. Emphasis is placed on tracing the evolution of entrepreneurship theories over time, as well as analyzing current trends related to the study of entrepreneurship.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Strategic Management",
    "dept": "ENTSP",
    "num": "605",
    "desc": "\nCritical review of theory and research in the field of strategic management. Introduction to representative conceptual and empirical research. Review theories that provide the foundation for management research, and review current research in associate research streams. The review will cover fundamental questions in strategy.\n",
    "credits": "3"
  },
  {
    "course_name": "Orientation to Environmental Science",
    "dept": "ENSCI",
    "num": "110",
    "desc": "Prereq: Freshman classification in EnSci\nOverview of Environmental Science curriculum and discussion of professional opportunities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Environmental Issues",
    "dept": "ENSCI",
    "num": "201",
    "desc": "\nDiscussion of current and emerging environmental issues such as human population growth, energy use, loss of biodiversity, water resources, and climate change.\n",
    "credits": "2"
  },
  {
    "course_name": "Exploration of Environmental and Sustainability Issues",
    "dept": "ENSCI",
    "num": "202",
    "desc": "Prereq: Credit or enrollment in ENSCI 201\nExploration of specific environmental and sustainability issues; designed to complement ENSCI 201.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Exploration of Environmental Science",
    "dept": "ENSCI",
    "num": "203",
    "desc": "Prereq: ENSCI 202.\nContinued exploration of specific environmental science issues developed in ENSCI 202.  Topics may vary in different years.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Environmental Geography",
    "dept": "ENSCI",
    "num": "250",
    "desc": "\nThe distribution, origins and functions of the earth's physical systems and the spatial relationship between human activity and the natural world.\n",
    "credits": "3"
  },
  {
    "course_name": "Biological Processes in the Environment",
    "dept": "ENSCI",
    "num": "251",
    "desc": "\nPrinciples of Biology from the level of macromolecules to the biosphere.  Biological processes that affect environmental systems: including metabolism, energy pathways, biochemical reactions in cells, plant and microbial structure and function, element and water cycles.\n",
    "credits": "3"
  },
  {
    "course_name": "Natural Resource Ecology and Soils",
    "dept": "ENSCI",
    "num": "301",
    "desc": "Prereq: BIOL 211, BIOL 211L; FOR 201 or a second course in biology\nEffects of environmental factors on ecosystem structure and function using forest, prairie and agricultural ecosystems as models. Special emphasis is given to soil-forming factors and the role of soil in nutrient and water cycling and ecosystem dynamics.  Additional emphasis is given to human influences on natural ecosystems and the role of perennial plant communities in agricultural landscapes.\n",
    "credits": "4"
  },
  {
    "course_name": "Ecology",
    "dept": "ENSCI",
    "num": "312",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, and BIOL 212L\nFundamental concepts and principles of ecology dealing with organisms, populations, communities, and ecosystems. Laboratory and field exercises examine ecological principles and methods as well as illustrate habitats.\n",
    "credits": "4"
  },
  {
    "course_name": "Ecology",
    "dept": "ENSCI",
    "num": "312I",
    "desc": "\nAn introduction to the principles of ecology at the population, community and ecosystem level. Field studies of local lakes, wetlands and prairies are used to examine factors controlling distributions, interactions, and roles of plants and animals in native ecosystems.\n",
    "credits": "4"
  },
  {
    "course_name": "Energy and the Environment",
    "dept": "ENSCI",
    "num": "324",
    "desc": "Prereq: CHEM 163 or CHEM 177, MATH 140\nExploration of the origin of Earth’s energy resources and the environmental and climatic impacts of energy acquisition and consumption. Renewable and non-renewable energy resources within an Earth-system context. Various environmentally-relevant topics such as water quality and availability, habitat destruction, greenhouse-gas emissions, and health and safety hazards to wildlife and human communities.\n",
    "credits": "3"
  },
  {
    "course_name": "Natural Resource Photogrammetry and Geographic Information Systems",
    "dept": "ENSCI",
    "num": "345",
    "desc": "Prereq: Junior classification\nMeasurement and interpretation of aerial photos in resource management. Introduction to Geographic Information Systems (GIS) using ArcGIS including digitizing, development and query of attribute tables, georeferencing, and use of multiple GIS layers in simple spatial analyses.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Soil Science",
    "dept": "ENSCI",
    "num": "360",
    "desc": "Prereq: AGRON 182 (or equivalent) or ENSCI 250 or GEOL 201\nApplication of soil science to contemporary environmental problems; comparison of the impacts that different management strategies have on short- and long-term environmental quality and land development. Emphasis on participatory learning activities.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Ecology and Environmental Science",
    "dept": "ENSCI",
    "num": "370",
    "desc": "Prereq: Six credits in biological and /or physical sciences, and permission of instructor.\nIntroduction to geographic information systems (GIS) with emphasis on ecological and environmental applications. No prior GIS experience required. Guided, individualized study of topics based on student background and interest. For students with prior experience, topics and activities are selected to build upon any previous experience and minimize duplication to previous GIS coursework. Potential topics include: basic concepts of GIS, data structures, database management, spatial analysis, modeling and visualization of ecological and environmental data. Case studies in ecological and environmental applications using ArcGIS.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Environmental Systems I:  Introduction to Environmental Systems",
    "dept": "ENSCI",
    "num": "381",
    "desc": "Prereq: 12 credits of natural science including biology and chemistry\nIntroduction to the structure and function of natural environmental systems. Emphasis on the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems II: Analysis of Environmental Systems",
    "dept": "ENSCI",
    "num": "382",
    "desc": "Prereq: ENSCI 381\nContinuation of ENSCI 381. Systems approach to the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Ecosystems",
    "dept": "ENSCI",
    "num": "384",
    "desc": "Prereq: 12 credits of natural science including biology and chemistry\nBiological and physical processes affecting material and energy flows in natural and managed ecosystems. Understanding and predicting climate and management impacts on ecosystem services and sustainability.\n",
    "credits": "3"
  },
  {
    "course_name": "Internship in Environmental Science",
    "dept": "ENSCI",
    "num": "390",
    "desc": "Prereq: Approval of the Environmental Science coordinator\nSupervised off-campus work experience in the field of environmental science.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Apprenticeship",
    "dept": "ENSCI",
    "num": "391",
    "desc": "Prereq: Approval of the Environmental Science Coordinator\nPractical experience in an approved setting such as a research laboratory, government office, or private office.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Watershed Hydrology",
    "dept": "ENSCI",
    "num": "402",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nExamination of watersheds as systems, emphasizing the surface components of the hydrologic cycle.  Combines qualitative understanding of hydrological processes and uncertainty with quantitative representation.  Laboratory emphasizes field investigation and measurement of watershed processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Hydrology and Surficial Processes",
    "dept": "ENSCI",
    "num": "402I",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nEffects of geomorphology, soils, and land use on transport of water and materials (nutrients, contaminates) in watersheds. Fieldwork will emphasize investigations of the Iowa Great Lakes watershed.\n",
    "credits": "4"
  },
  {
    "course_name": "Global Change",
    "dept": "ENSCI",
    "num": "404",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nRecent changes in global biogeochemical cycles and climate; models of future changes in the climate system; impacts of global change on agriculture, water resources and human health; ethical issues of global environmental change.  Also offered online Alt. F, even-numbered years.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biophysics",
    "dept": "ENSCI",
    "num": "405",
    "desc": "Prereq: MATH 165 and some exposure to computer programming (any language)\nThe movement of energy and mass among the soil, vegetation, and atmosphere.  The heat and water budget of humans, other animals, plants, and plant communities.  Relevance to weather and climate, the effect of climate change on organisms, and remote sensing.\n",
    "credits": "3"
  },
  {
    "course_name": "World Climates",
    "dept": "ENSCI",
    "num": "406",
    "desc": "Prereq: AGRON 206/MTEOR 206\nDistribution and causes of different climates around the world. Effects of climate and climate variations on human activities including society, economy and agriculture. Current issues such as climate change and international efforts to assess and mitigate the consequences of a changing climate.  Semester project and in-class presentation required.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Management",
    "dept": "ENSCI",
    "num": "407",
    "desc": "Prereq: A course in general biology\nManaging human impacts on the hydrologic cycle. Field and watershed level best management practices for modifying the impacts on water quality, quantity and timing are discussed. Field project includes developing a management plan using landscape buffers.\n",
    "credits": "4"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "ENSCI",
    "num": "408I",
    "desc": "Prereq: Courses in ecology, chemistry, and physics\nAnalysis of aquatic ecosystems; emphasis on basic ecological principles; ecological theories tested in the field; identification of common plants and animals.\n",
    "credits": "4"
  },
  {
    "course_name": "Field Methods in Hydrogeology",
    "dept": "ENSCI",
    "num": "409",
    "desc": "Prereq: GEOL/ENSCI 402 or GEOL/ENSCI 411 or C E 473\nIntroduction to field methods used in groundwater investigations. In-field implementation of pumping tests, slug tests, monitoring well installation and drilling techniques, geochemical and water quality sampling, seepage meters, minipiezometers, stream gaging, and electronic instrumentation for data collection. Field trips to investigate water resource, water quality, and remediation projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrogeology",
    "dept": "ENSCI",
    "num": "411",
    "desc": "Prereq: Four courses in biological or physical sciences\nPhysical principles of groundwater flow, nature and origin of aquifers and confining units, well hydraulics, groundwater modeling, and contaminant transport. Lab emphasizes applied field and laboratory methods for hydrogeological investigations.\n",
    "credits": "4"
  },
  {
    "course_name": "Micropaleontology",
    "dept": "ENSCI",
    "num": "412",
    "desc": "Prereq: GEOL 102 and GEOL 102L\nEvolution, identification and utility of major microfossil groups from the Mesozoic to present. Focus on Cenozoic applications including biostratigraphy, paleoclimate, and paleothermometry using assemblages, stable isotopes, Mg/Ca, and molecular fossils. Laboratory includes processing and analysis of specific microfossils. Major groups covered include foraminifera, calcareous nannofossils, sponge spicules, diatoms, radiolarians, and silicoflagellates.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied and Environmental Geophysics",
    "dept": "ENSCI",
    "num": "413",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nSeismic, gravity, magnetic, resistivity, electromagnetic, and ground-penetrating radar techniques for shallow subsurface investigations and imaging. Data interpretation methods. Lab emphasizes computer interpretation packages. Field work with seismic - and resistivity-imaging systems and radar.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Groundwater Flow Modeling",
    "dept": "ENSCI",
    "num": "414",
    "desc": "Prereq: GEOL 411 or C E 473; MATH 165 or MATH 181\nIntroduction to the principles of modeling groundwater flow systems. Finite-difference and analytic-element methods, spreadsheet models, boundary conditions, calibration, sensitivity analysis, parameter estimation, particle tracking, and post-audit analysis. Application of MODFLOW to regional flow-system analysis. Computer laboratory emphasizes assigned problems that illustrate topics discussed in the course.\n",
    "credits": "3"
  },
  {
    "course_name": "Paleoclimatology",
    "dept": "ENSCI",
    "num": "415",
    "desc": "Prereq: Four courses in biological or physical science\nIntroduction to mechanisms that drive climate, including the interplay between oceanic and atmospheric circulation and fluctuation in Earth's orbital parameters. Examination and analysis of past climate records ranging from historical documentation to ecological and geochemical proxies (e.g. tree ring analysis; O and C isotopes of skeletal carbonates and soils). Dating methods used to constrain and correlate climatic periods, utility of computer models to reconstruct past climates and predict future climate change. Emphasis placed on paleoclimatology and paleoecology of the late Quaternary (last ~1 million years).\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrologic Modeling and Analysis",
    "dept": "ENSCI",
    "num": "416",
    "desc": "Prereq: Four courses in Earth science, meteorology, or engineering; junior standing.\nStudy of the basic principles of hydrologic modeling, including rainfall-runoff analysis, lumped and distributed modeling, conceptual and physical models, parameter estimation and sensitivity analysis, input and validation data, uncertainty analysis, and the use of models in surface water hydrology. A range of common models are applied to study hydrologic topics such as flood forecasting and land use change impacts. Previous experience with Matlab or other programming language is needed.\n",
    "credits": "3"
  },
  {
    "course_name": "Stream Ecology",
    "dept": "ENSCI",
    "num": "418",
    "desc": "Prereq: A ECL 486\nBiological, chemical, physical, and geological processes that determine the structure and function of flowing water ecosystems. Current ecological theories as well as applications to stream management for water quality and fisheries.\n",
    "credits": "3"
  },
  {
    "course_name": "Aqueous and Environmental Geochemistry",
    "dept": "ENSCI",
    "num": "419",
    "desc": "Prereq: CHEM 178, CHEM 178L; junior classification\nGeochemistry of natural waters and water-rock interactions. Acid-base equilibria, carbonate chemistry and buffer systems, mineral dissolution and precipitation, sorption, ion exchange, and redox reactions. Introduction to thermodynamics and kinetics. Laboratory emphasizes chemical analysis of waters and computer modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Engineering Chemistry",
    "dept": "ENSCI",
    "num": "420",
    "desc": "Prereq: C E 326, CHEM 178\nPrinciples of chemical and physical phenomena applicable to the treatment of water and wastewater and natural waters; including chemical equilbria, reaction kinetics, acid-base equilibria, chemical precipitation, redox reactions, and mass transfer principles. Individual laboratory practicals and group projects required.\n",
    "credits": "3"
  },
  {
    "course_name": "Prairie Ecology",
    "dept": "ENSCI",
    "num": "422I",
    "desc": "Prereq: Familiarity with basic principles in biological sciences and ecology\nBasic patterns and underlying physical and biotic causes of both regional and local distributions of plants and animals of North American prairies; field and laboratory analyses and projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Air Pollution",
    "dept": "ENSCI",
    "num": "424",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Air quality and effects of pollutants",
    "dept": "ENSCI",
    "num": "424A",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Climate change and causes",
    "dept": "ENSCI",
    "num": "424B",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Transportation Air Quality",
    "dept": "ENSCI",
    "num": "424C",
    "desc": "Prereq: C E 524A; PHYS 221 or CHEM 178; MATH 166 or 3 credits in statistics. Senior classification or above.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Off-gas treatment technology",
    "dept": "ENSCI",
    "num": "424D",
    "desc": "Prereq: C E 524A, C E 524B; Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Agricultural sources of pollution",
    "dept": "ENSCI",
    "num": "424E",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Stable Isotopes in the Environment",
    "dept": "ENSCI",
    "num": "426",
    "desc": "Prereq: Four courses in biological or physical science\nIntroduction to the theory, methods and applications of stable isotopes. Primary focus on the origin, natural abundance, and fractionation of carbon, hydrogen, oxygen, nitrogen isotopes. Applications of isotopic occurrence for elucidation of physical, chemical, biological, and environmental processes. Effects of plant physiology, photosynthesis, trophic structure, diffusion, evaporation, chemical precipitation, soil and atmospheric processes, and environmental factors on isotope abundance.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Modeling and Policy",
    "dept": "ENSCI",
    "num": "437",
    "desc": "Prereq: CE 372 or equivalent\nA project-based course on watershed-scale models for improving water quality. Legislative and judicial basis of the Total Maximum Daily Load (TMDL) program; approaches to TMDL development; principles and techniques for implementation; stakeholder engagement strategies. Hands-on experiences with GIS-interfaced models, data sources, calibration/validation, statistical assessment of model results, and simulation using multiple tools. In addition to other assignments, graduate students will present case studies of TMDLs using different modeling tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrating GPS and GIS for Natural Resource Management",
    "dept": "ENSCI",
    "num": "446",
    "desc": "Prereq: 12 credits in student's major at 300 level or above, NREM 345 or equivalent experience with ArcGIS\nEmphasis on the use of GPS as a data collection tool for GIS. Basic theory of GPS. Use of Global Positioning System technology for spatial data collection and navigation. Post-processing and real-time correction of GPS data. GPS data transfer to GIS for mapping applications. Use of GIS to construct waypoints for use in GPS navigation.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists",
    "dept": "ENSCI",
    "num": "452",
    "desc": "Prereq: GEOL 100, GEOL 201 or equivalent\nIntroduction to geographic information systems (GIS) with particular emphasis on geoscientific data. Uses ESRI's ArcGIS Desktop Software and extension modules. Emphasizes typical GIS operations and analyses in the geosciences to prepare students for advanced GIS courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Soil and Water Chemistry",
    "dept": "ENSCI",
    "num": "459",
    "desc": "Prereq: Two semesters of college-level chemistry, MATH 140, AGRON 182 (or equivalent) or AGRON 360; GEOL 100 and AGRON 354 recommended\nAn introduction to the chemical properties of soils, chemical reactions and transformations in soils and surface waters, and their impact on the environment. Topics include solution chemistry in soils and surface waters, solid-phase composition of soils, reactions at the solid-solution interface, and applications to contemporary environmental issues.\n",
    "credits": "4"
  },
  {
    "course_name": "Introduction to GIS",
    "dept": "ENSCI",
    "num": "461I",
    "desc": "\nDescriptive and predictive GIS modeling techniques, spatial statistics, and map algebra.  Application of GIS modeling techniques to environmental planning and resource management.\n",
    "credits": "4"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "ENSCI",
    "num": "463",
    "desc": "Prereq: AGRON 182 (or equivalent) or AGRON 260\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use. Two weekend field trips.\n  Credit for one of AGRON 463 or AGRON 463I may be applied for graduation.",
    "credits": "3"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "ENSCI",
    "num": "463I",
    "desc": "Prereq: AGRON 182 (or equivalent)\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use.\n  Credit for only Agron 563 or 563I may be applied for graduation.",
    "credits": "2"
  },
  {
    "course_name": "Wetland Ecology",
    "dept": "ENSCI",
    "num": "464",
    "desc": "Prereq: 15 credits in biological sciences.\nEcology, classification, creation and restoration, and management of wetlands.  Emphasis on North American temperate wetlands.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Service Management",
    "dept": "ENSCI",
    "num": "466",
    "desc": "Prereq: permission of instructor\nLand use and conservation techniques for improving ecosystem services including: pollination of crops, biological control of pests, prevention of erosion and water quality improvement.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Geostatistics for Geoscientists",
    "dept": "ENSCI",
    "num": "468",
    "desc": "Prereq: GEOL 452, C R P 351, C R P 452, NREM 345, or NREM 446\nIntroduction to geospatial data collection, analysis, interpretation, and presentation. Geospatial techniques including geographic information systems (GIS), remote sensing (RS), and global positioning systems (GPS). Study of applied geostatistical analysis (e.g., interpolation and spatial regression).\n",
    "credits": "3"
  },
  {
    "course_name": "Soil Physics",
    "dept": "ENSCI",
    "num": "477",
    "desc": "Prereq: AGRON 182 or equivalent and MATH 166 recommended\nThe physical soil system: the soil components and their physical interactions; transport processes involving water, air, and heat.\n",
    "credits": "3"
  },
  {
    "course_name": "Surficial Processes",
    "dept": "ENSCI",
    "num": "479",
    "desc": "Prereq: GEOL 100 and GEOL 100L; or GEOL 201; or equivalent experience.\nThe study of physical processes that shape Earth's surface. Topics include weathering, sediment transport, and landform genesis with emphasis on fluvial, glacial, hillslope, eolian, and coastal processes. Applications to engineering and environmental problems. Laboratory includes topographic map interpretation and local field trips.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Analysis of Biological Systems",
    "dept": "ENSCI",
    "num": "480",
    "desc": "Prereq: A B E 380 or permission of the instructor\nSystems-level quantitative analysis of biological systems, including applications in foods, feeds, biofuels, bioenergy, and other biological systems. Introduction to economic analysis and life-cycle assessment of these systems at multiple production scales. Applying these tools to evaluate and improve cost and sustainability performance of these biological systems. Students enrolled in ABE 580 will be required to answer additional exam questions and report on two journal articles.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Ecology",
    "dept": "ENSCI",
    "num": "484",
    "desc": "Prereq: Combined 12 credits in biology, chemistry, and physics.\nIntroduction of the study of ecosystems and the biological and physical factors that influence their properties and dynamics. Conceptual foundations for ecosystem studies. Interactions among organisms, biological diversity, and ecosystem attributes. Quantitative analyses of accumulations, transformations, and fluxes of nutrients, water, and energy within and among ecosystems. Global change issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil and Environmental Microbiology",
    "dept": "ENSCI",
    "num": "485",
    "desc": "Prereq: AGRON 182 or equivalent; MICRO 201 and MICRO 201L recommended\nThe living organisms in the soil and what they do. Emphasis on soil biota composition, the carbon cycle and bioremediation, soil-plant-microbial relationships, and environmental issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "ENSCI",
    "num": "486",
    "desc": "Prereq: BIOL 312 or ENSCI 381 or ENSCI 402 or NREM 301\nStructure and function of aquatic ecosystems with application to fishery and pollution problems. Emphasis on lacustrine, riverine, and wetland ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology Laboratory",
    "dept": "ENSCI",
    "num": "486L",
    "desc": "Prereq: Concurrent enrollment in BIOL 486\nField trips and laboratory exercises to accompany 486. Hands-on experience with aquatic research and monitoring techniques and concepts.\n",
    "credits": "1"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "ENSCI",
    "num": "487",
    "desc": "Prereq: Six credits in biology and 6 credits in chemistry\nIntroduction to major functional groups of autotrophic and heterotrophic microorganisms and their roles in natural and environmental systems. Consequences of microbial activity on water chemistry, weathering, and precipitation/dissolution reactions will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists II",
    "dept": "ENSCI",
    "num": "488",
    "desc": "Prereq: GIS course, such as GEOL 452, CRP 451, CRP 452, NREM 345, NREM 446, AE 408 or equivalent\nGIS course with focus on the spatial analysis and modeling of raster data and triangulated irregular network (TIN) data. Uses ArcGIS and various extensions, such as Spatial Analyst, 3D Analyst, and ArcScene. Includes practical exercises during lectures, lab exercises, homework assignments, and (for GEOL 588) a class project.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ENSCI",
    "num": "490",
    "desc": "Prereq: Permission of the instructor and approval of the Environmental Science coordinator\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study:  Honors",
    "dept": "ENSCI",
    "num": "490H",
    "desc": "\nPermission of instructor and approval of Environmental Science coordinator.\n",
    "credits": "arr"
  },
  {
    "course_name": "Current  Topics and Case Studies in Environmental Science",
    "dept": "ENSCI",
    "num": "495",
    "desc": "Prereq: Junior classification in Environmental Science, permission of instructor\nCurrent topics and case studies related to the analysis and management of environmental systems. Individual and/or group projects.\n",
    "credits": "1"
  },
  {
    "course_name": "Travel Course",
    "dept": "ENSCI",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nExtended field trips to study environmental topics in varied locations. Location and duration of trips will vary. Trip expenses paid by students. Check with department for current offerings.  A.  International Tour  B.  Domestic Tour.\n",
    "credits": "arr"
  },
  {
    "course_name": "Travel Course: International Tour",
    "dept": "ENSCI",
    "num": "496A",
    "desc": "Prereq: Permission of instructor\nExtended field trips to study environmental topics in varied locations. Location and duration of trips will vary. Trip expenses paid by students. Check with department for current offerings.\n",
    "credits": "arr"
  },
  {
    "course_name": "Travel Course: Domestic Tour",
    "dept": "ENSCI",
    "num": "496B",
    "desc": "Prereq: Permission of instructor\nExtended field trips to study environmental topics in varied locations. Location and duration of trips will vary. Trip expenses paid by students. Check with department for current offerings.\n",
    "credits": "arr"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "ENSCI",
    "num": "498",
    "desc": "Prereq: Permission of Environmental Science Coordinator\nRequired of all cooperative education students. Students must register prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Watershed Hydrology",
    "dept": "ENSCI",
    "num": "502",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nExamination of watersheds as systems, emphasizing the surface components of the hydrologic cycle.  Combines qualitative understanding of hydrological processes and uncertainty with quantitative representation.  Laboratory emphasizes field investigation and measurement of watershed processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Change",
    "dept": "ENSCI",
    "num": "504",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nRecent changes in global biogeochemical cycles and climate; models of future changes in the climate system; impacts of global change on agriculture, water resources and human health; ethical issues of global environmental change.  Also offered online Alt. F, even-numbered years.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biophysics",
    "dept": "ENSCI",
    "num": "505",
    "desc": "Prereq: MATH 165 and some exposure to computer programming (any language)\nThe movement of energy and mass among the soil, vegetation, and atmosphere.  The heat and water budget of humans, other animals, plants, and plant communities.  Relevance to weather and climate, the effect of climate change on organisms, and remote sensing.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Management",
    "dept": "ENSCI",
    "num": "507",
    "desc": "Prereq: A course in general biology\nManaging human impacts on the hydrologic cycle. Field and watershed level best management practices for modifying the impacts on water quality, quantity and timing are discussed. Field project includes developing a management plan using landscape buffers.\n",
    "credits": "4"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "ENSCI",
    "num": "508I",
    "desc": "Prereq: Courses in ecology, chemistry, and physics\nAnalysis of aquatic ecosystems; emphasis on basic ecological principles; ecological theories tested in the field; identification of common plants and animals.\n",
    "credits": "4"
  },
  {
    "course_name": "Field Methods in Hydrogeology",
    "dept": "ENSCI",
    "num": "509",
    "desc": "Prereq: GEOL/ENSCI 402 or GEOL/ENSCI 411 or C E 473\nIntroduction to field methods used in groundwater investigations. In-field implementation of pumping tests, slug tests, monitoring well installation and drilling techniques, geochemical and water quality sampling, seepage meters, minipiezometers, stream gaging, and electronic instrumentation for data collection. Field trips to investigate water resource, water quality, and remediation projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrogeology",
    "dept": "ENSCI",
    "num": "511",
    "desc": "Prereq: Four courses in biological or physical sciences\nPhysical principles of groundwater flow, nature and origin of aquifers and confining units, well hydraulics, groundwater modeling, and contaminant transport. Lab emphasizes applied field and laboratory methods for hydrogeological investigations.\n",
    "credits": "4"
  },
  {
    "course_name": "Applied and Environmental Geophysics",
    "dept": "ENSCI",
    "num": "513",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nSeismic, gravity, magnetic, resistivity, electromagnetic, and ground-penetrating radar techniques for shallow subsurface investigations and imaging. Data interpretation methods. Lab emphasizes computer interpretation packages. Field work with seismic - and resistivity-imaging systems and radar.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Groundwater Flow Modeling",
    "dept": "ENSCI",
    "num": "514",
    "desc": "Prereq: GEOL 411 or C E 473; MATH 165 or MATH 181\nIntroduction to the principles of modeling groundwater flow systems. Finite-difference and analytic-element methods, spreadsheet models, boundary conditions, calibration, sensitivity analysis, parameter estimation, particle tracking, and post-audit analysis. Application of MODFLOW to regional flow-system analysis. Computer laboratory emphasizes assigned problems that illustrate topics discussed in the course.\n",
    "credits": "3"
  },
  {
    "course_name": "Paleoclimatology",
    "dept": "ENSCI",
    "num": "515",
    "desc": "Prereq: Four courses in biological or physical science\nIntroduction to mechanisms that drive climate, including the interplay between oceanic and atmospheric circulation and fluctuation in Earth's orbital parameters. Examination and analysis of past climate records ranging from historical documentation to ecological and geochemical proxies (e.g. tree ring analysis; O and C isotopes of skeletal carbonates and soils). Dating methods used to constrain and correlate climatic periods; utility of computer models to reconstruct past climates and predict future climate change. Emphasis placed on paleoclimatology and paleoecology of the late Quaternary (last ~ 1 million years).\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrologic Modeling and Analysis",
    "dept": "ENSCI",
    "num": "516",
    "desc": "Prereq: Four courses in earth science, meteorology, or engineering; junior standing\nStudy of the basic principles of hydrologic modeling, including rainfall-runoff analysis, lumped and distributed modeling, conceptual and physical models, parameter estimation and sensitivity analysis, input and validation data, uncertainty analysis, and the use of models in surface water hydrology. A range of common models are applied to study hydrologic topics such as flood forecasting and land use change impacts. Previous experience with Matlab or other programming language is needed.\n",
    "credits": "3"
  },
  {
    "course_name": "Stream Ecology",
    "dept": "ENSCI",
    "num": "518",
    "desc": "Prereq: A ECL 486\nBiological, chemical, physical, and geological processes that determine the structure and function of flowing water ecosystems. Current ecological theories as well as applications to stream management for water quality and fisheries.\n",
    "credits": "3"
  },
  {
    "course_name": "Aqueous and Environmental Geochemistry",
    "dept": "ENSCI",
    "num": "519",
    "desc": "Prereq: CHEM 178, CHEM 178L; junior classification\nGeochemistry of natural waters and water-rock interactions. Acid-base equilibria, carbonate chemistry and buffer systems, mineral dissolution and precipitation, sorption, ion exchange, and redox reactions. Introduction to thermodynamics and kinetics. Laboratory emphasizes chemical analysis of waters and computer modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Engineering Chemistry",
    "dept": "ENSCI",
    "num": "520",
    "desc": "Prereq: C E 326, CHEM 178\nPrinciples of chemical and physical phenomena applicable to the treatment of water and wastewater and natural waters; including chemical equilbria, reaction kinetics, acid-base equilibria, chemical precipitation, redox reactions, and mass transfer principles. Individual laboratory practicals and group projects required.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biotechnology",
    "dept": "ENSCI",
    "num": "521",
    "desc": "Prereq: C E 326\nFundamentals of biochemical and microbial processes applied to environmental engineering processes, role of microorganisms in wastewater treatment and bioremediation, bioenergetics and kinetics, metabolism of xenobiotic compounds, waterborne pathogens and parasites, and disinfection. Term paper and oral presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Water Pollution Control Processes",
    "dept": "ENSCI",
    "num": "522",
    "desc": "Prereq: C E 421 or C E 521\nFundamentals of biochemical processes, aerobic growth in a single CSTR, multiple events in complex systems, and techniques for evaluating kinetic parameters; unit processes of activated sludge system, attached growth systems, stabilization and aerated lagoon systems, biosolids digestion and disposal, nutrient removal, and anaerobic treatment systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical-Chemical Treatment Process",
    "dept": "ENSCI",
    "num": "523",
    "desc": "Prereq: C E 520\nMaterial and energy balances. Principles and design of physical-chemical unit processes; including screening, coagulation, flocculation, chemical precipitation, sedimentation, filtration, lime softening and stabilization, oxidation, adsorption, membrane processes, ion exchange and disinfection; recovery of resources from residuals and sludges; laboratory exercises and demonstrations; case studies in mineral processing and secondary industries.\n",
    "credits": "3"
  },
  {
    "course_name": "Air Pollution",
    "dept": "ENSCI",
    "num": "524",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Air quality and effects of pollutants",
    "dept": "ENSCI",
    "num": "524A",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Climate change and causes",
    "dept": "ENSCI",
    "num": "524B",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Transportation Air Quality",
    "dept": "ENSCI",
    "num": "524C",
    "desc": "Prereq: C E 524A; PHYS 221 or CHEM 178; MATH 166 or 3 credits in statistics. Senior classification or above.\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Off-gas treatment technology",
    "dept": "ENSCI",
    "num": "524D",
    "desc": "Prereq: C E 524A, C E 524B; Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n",
    "credits": "1"
  },
  {
    "course_name": "Air Pollution: Agricultural sources of pollution",
    "dept": "ENSCI",
    "num": "524E",
    "desc": "Prereq: Either PHYS 221 or CHEM 178 and either MATH 166 or 3 credits in statistics. Senior classification or above\n1 cr. per module. Module A prereq for all modules; module B prereq for D and E.\n",
    "credits": "1"
  },
  {
    "course_name": "Stable Isotopes in the Environment",
    "dept": "ENSCI",
    "num": "526",
    "desc": "Prereq: Four courses in biological or physical science\nIntroduction to the theory, methods and applications of stable isotopes. Primary focus on the origin, natural abundance, and fractionation of carbon, hydrogen, oxygen, nitrogen isotopes. Applications of isotopic occurrence for elucidation of physical, chemical, biological, and environmental processes. Effects of plant physiology, photosynthesis, trophic structure, diffusion, evaporation, chemical precipitation, soil and atmospheric processes, and environmental factors on isotope abundance.\n",
    "credits": "3"
  },
  {
    "course_name": "Solid and Hazardous Waste Management",
    "dept": "ENSCI",
    "num": "528",
    "desc": "Prereq: C E 326 or background courses in both environmental chemistry and microbiology; junior or higher standing\nEvaluation, characterization, assessment, planning and design of solid and hazardous waste management systems, regulatory requirements, material characterization and collection, minimization and recycling, energy and materials recovery, composting, off-gas treatment, incineration, stabilization, and landfill design. Design of treatment and disposal systems, including physical, chemical, and biological treatment, solidification, incineration, secure landfill design, and final disposal site closure plus restoration.\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Evaluation of Soil and Water Conservation Systems",
    "dept": "ENSCI",
    "num": "531",
    "desc": "Prereq: E M 378 or CH E 356\nHydrology and hydraulics in agricultural and urbanizing watersheds. Design and evaluation of systems for the conservation and quality preservation of soil and water resources. Use and analysis of hydrologic data in engineering design; relationship of topography, soils, crops, climate, and cultural practices in conservation and quality preservation of soil and water for agriculture. Small watershed hydrology, water movement and utilization in the soil-plant-atmosphere system, agricultural water management, best management practices, and agricultural water quality. Graduate students will prepare several research literature reviews on topics covered in the class in addition to the other assignments.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonpoint Source Pollution and Control",
    "dept": "ENSCI",
    "num": "532",
    "desc": "Prereq: A B E 431 or C E 372\nCharacteristics and courses of non-point source (NPS) pollution in agricultural and urban watersheds, computer modeling and NPS pollution for terrestrial and aquatic systems, strategies to control and manage NPS pollution of water bodies, total maximum daily loads (TMDLs) and integrated watershed management. Graduate students are required to review research papers and develop/deliver lecture models on assigned topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Erosion and Sediment Transport",
    "dept": "ENSCI",
    "num": "533",
    "desc": "Prereq: C E 372 or GEOL/ENSCI/MTEOR 402, MATH 166 or equivalent\nSoil erosion processes, soil loss equations and their application to conservation planning, sediment properties, initiation of sediment motion and over land flow, flow in alluvial channels and theory of sediment transport, channel stability, reservoir sedimentation, wind erosion, BMPs for controlling erosion.\n",
    "credits": "3"
  },
  {
    "course_name": "Contaminant Hydrogeology",
    "dept": "ENSCI",
    "num": "534",
    "desc": "Prereq: GEOL 511 or equivalent\nTheory and practical considerations of fate and transport of solutes through porous geologic materials. Organic and inorganic contaminants in industrial and agricultural settings. Subsurface microbiology and biodegradation of aromatic and chlorinated hydrocarbons. Investigation of coupled processes (diffusion, advection, dispersion, sorption, and biodegradation) using computer models. Soil and groundwater monitoring and remediation strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Restoration Ecology",
    "dept": "ENSCI",
    "num": "535",
    "desc": "Prereq: BIOL 366 or BIOL 474 or graduate standing\nTheory and practice of restoring animal and plant diversity, structure and function of disturbed ecosystems. Restored freshwater wetlands, forests, prairies and reintroduced species populations will be used as case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Restoration Ecology",
    "dept": "ENSCI",
    "num": "535I",
    "desc": "Prereq: A course in ecology\nEcological principles for the restoration of native ecosystems; establishment (site preparation, selection of seed   mixes, planting techniques) and management (fire, mowing, weed control) of native vegetation; evaluation of restorations. Emphasis on the restoration of prairie and wetland vegetation.\n",
    "credits": "4"
  },
  {
    "course_name": "Design and Evaluation of Soil and Water Monitoring Systems",
    "dept": "ENSCI",
    "num": "536",
    "desc": "Prereq: A B E 431\nDevelopment of monitoring systems that support effective planning, performance evaluation, modeling, or environmental impact assessment of soil-, water-, and waste-management systems.  Typical soil and water pollutants and physical, chemical, and biological characteristics that affect sample location and timing. Sample collection, documentation, chain-of-custody, and quality assurance procedures.  In addition to other assignments, graduate students will prepare several research literature reviews on topics covered in the class and develop monitoring plans.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Modeling and Policy",
    "dept": "ENSCI",
    "num": "537",
    "desc": "Prereq: CE 372 or equivalent\nA project-based course on watershed-scale models for improving water quality. Legislative and judicial basis of the Total Maximum Daily Load (TMDL) program; approaches to TMDL development; principles and techniques for implementation; stakeholder engagement strategies. Hands-on experiences with GIS-interfaced models, data sources, calibration/validation, statistical assessment of model results, and simulation using multiple tools. In addition to other assignments, graduate students will present case studies of TMDLs using different modeling tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrating GPS and GIS for Natural Resource Management",
    "dept": "ENSCI",
    "num": "546",
    "desc": "Prereq: 12 credits in student's major at 300 level or above, NREM 345 or equivalent experience with ArcGIS\nEmphasis on the use of GPS as a data collection tool for GIS. Basic theory of GPS. Use of Global Positioning System technology for spatial data collection and navigation. Post-processing and real-time correction of GPS data. GPS data transfer to GIS for mapping applications. Use of GIS to construct waypoints for use in GPS navigation.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists",
    "dept": "ENSCI",
    "num": "552",
    "desc": "Prereq: GEOL 100, GEOL 201 or equivalent\nIntroduction to geographic information systems (GIS) with particular emphasis on geoscientific data. Uses ESRI's ArcGIS Desktop Software and extension modules. Emphasizes typical GIS operations and analyses in the geosciences to prepare students for advanced GIS courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil-Plant Relationships",
    "dept": "ENSCI",
    "num": "553",
    "desc": "Prereq: AGRON 354\nComposition and properties of soils in relation to the nutrition and growth of plants.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory Methods in Soil Chemistry",
    "dept": "ENSCI",
    "num": "558",
    "desc": "Prereq: AGRON 354 and CHEM 211\nExperimental and descriptive inorganic and organic analyses. Operational theory and principles of applicable instruments, including spectrophotometry, atomic and molecular absorption and emission spectroscopy, mass spectrometry, X-ray diffraction and fluorescence, gas and ion chromatography, and ion-selective electrodes.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Soil and Water Chemistry",
    "dept": "ENSCI",
    "num": "559",
    "desc": "Prereq: Two semesters of college-level chemistry, MATH 140, AGRON 182 (or equivalent) or AGRON 360; GEOL 100 and AGRON 354 recommended\nAn introduction to the chemical properties of soils, chemical reactions and transformations in soils and surface waters, and their impact on the environment. Topics include solution chemistry in soils and surface waters, solid-phase composition of soils, reactions at the solid-solution interface, and applications to contemporary environmental issues.\n",
    "credits": "4"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "ENSCI",
    "num": "563",
    "desc": "Prereq: AGRON 182 (or equivalent) or AGRON 260\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use. Two weekend field trips.\n  Credit for one of AGRON 463 or AGRON 463I may be applied for graduation.",
    "credits": "3"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "ENSCI",
    "num": "563I",
    "desc": "Prereq: AGRON 182 (or equivalent)\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use.\n  Credit for only Agron 563 or 563I may be applied for graduation.",
    "credits": "2"
  },
  {
    "course_name": "Wetland Ecology",
    "dept": "ENSCI",
    "num": "564",
    "desc": "Prereq: 15 credits in biological sciences.\nEcology, classification, creation and restoration, and management of wetlands.  Emphasis on North American temperate wetlands.\n",
    "credits": "3"
  },
  {
    "course_name": "Wetland Ecology",
    "dept": "ENSCI",
    "num": "564I",
    "desc": "Prereq: IA LL 312I\nEcology, classification, creation, restoration, and management of wetlands.  Field studies will examine the composition, structure and functions of local natural wetlands and restored prairie pothole wetlands.  Individual or group projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Ecosystem Service Management",
    "dept": "ENSCI",
    "num": "566",
    "desc": "Prereq: permission of instructor\nLand use and conservation techniques for improving ecosystem services including: pollination of crops, biological control of pests, prevention of erosion and water quality improvement.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Geostatistics for Geoscientists",
    "dept": "ENSCI",
    "num": "568",
    "desc": "Prereq: GEOL 452, C R P 351, C R P 452, NREM 345, or NREM 446\nIntroduction to geospatial data collection, analysis, interpretation, and presentation. Geospatial techniques including geographic information systems (GIS), remote sensing (RS), and global positioning systems (GPS). Study of applied geostatistical analysis (e.g., interpolation and spatial regression).\n",
    "credits": "3"
  },
  {
    "course_name": "Surface Water Hydrology",
    "dept": "ENSCI",
    "num": "571",
    "desc": "Prereq: C E 372\nAnalysis of hydrologic data including precipitation, infiltration, evapotranspiration, direct runoff and streamflow; theory and use of frequency analysis; theory of streamflow and reservoir routing; use of deterministic and statistical hydrologic models. Fundamentals of surface water quality modeling, point and non-point sources of contamination.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis and Modeling Aquatic Environments",
    "dept": "ENSCI",
    "num": "572",
    "desc": "Prereq: C E 372\nPrinciples of surface water flows and mixing. Introduction to hydrologic transport and water   quality simulation in natural water systems. Advection, diffusion and dispersion, chemical and   biologic kinetics, and water quality dynamics. Applications to temperature, dissolved oxygen,   primary productivity, and other water quality problems in rivers, lakes and reservoirs.   Deterministic vs. stochastic models.\n",
    "credits": "3"
  },
  {
    "course_name": "Groundwater Hydrology",
    "dept": "ENSCI",
    "num": "573",
    "desc": "Prereq: C E 372\nPrinciples of groundwater flow, hydraulics of wells, superposition, slug and pumping tests, streamlines and flownets, and regional groundwater flow. Contaminant transport. Computer modeling. Design project. Extra assignments required for graduate students.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil Formation and Transformation",
    "dept": "ENSCI",
    "num": "575",
    "desc": "Prereq: AGRON 463 or equivalent\nAdvanced study of soil formation, emphasizing relationships among soils, landscapes, environment, humans, and land use.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil Physics",
    "dept": "ENSCI",
    "num": "577",
    "desc": "Prereq: AGRON 182 or equivalent and MATH 166 recommended\nThe physical soil system: the soil components and their physical interactions; transport processes involving water, air, and heat.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory Methods in Soil Physics",
    "dept": "ENSCI",
    "num": "578",
    "desc": "Prereq: concurrent enrollment in AGRON 477 or AGRON 577\nMethods of measuring soil physical properties such as texture, density, and water content, and transport of heat, water, and gases.\n",
    "credits": "1"
  },
  {
    "course_name": "Surficial Processes",
    "dept": "ENSCI",
    "num": "579",
    "desc": "Prereq: GEOL 100 and GEOL 100L; or GEOL 201; or equivalent experience.\nThe study of physical processes that shape Earth's surface. Topics include weathering, sediment transport, and landform genesis with emphasis on fluvial, glacial, hillslope, eolian, and coastal processes. Applications to engineering and environmental problems. Laboratory includes topographic map interpretation and local field trips.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems I:  Introduction to Environmental Systems",
    "dept": "ENSCI",
    "num": "581",
    "desc": "Prereq: 12 credits of natural science including biology and chemistry\nIntroduction to the structure and function of natural environmental systems. Emphasis on the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems II: Analysis of Environmental Systems",
    "dept": "ENSCI",
    "num": "582",
    "desc": "Prereq: ENSCI 381\nContinuation of ENSCI 381. Systems approach to the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Science",
    "dept": "ENSCI",
    "num": "584",
    "desc": "Prereq: Combined 12 credits in biology, chemistry, and physics.\nAdvanced studies of ecosystems and the biological and physical factors that influence their properties and dynamics. Conceptual foundations and modern approaches to  ecosystem studies. Interactions among organisms, biological diversity, and ecosystem attributes. Quantitative analyses of accumulations, transformations, and fluxes of nutrients, water, and energy within and among ecosystems.  Global change issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil and Environmental Microbiology",
    "dept": "ENSCI",
    "num": "585",
    "desc": "Prereq: AGRON 182 or equivalent; MICRO 201 and MICRO 201L recommended\nThe living organisms in the soil and what they do. Emphasis on soil biota composition, the carbon cycle and bioremediation, soil-plant-microbial relationships, and environmental issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "ENSCI",
    "num": "586",
    "desc": "Prereq: BIOL 312 or ENSCI 381 or ENSCI 402 or NREM 301\nStructure and function of aquatic ecosystems with application to fishery and pollution problems. Emphasis on lacustrine, riverine, and wetland ecology.\n",
    "credits": "3"
  },
  {
    "course_name": "Aquatic Ecology Laboratory",
    "dept": "ENSCI",
    "num": "586L",
    "desc": "Prereq: Concurrent enrollment in BIOL 486\nField trips and laboratory exercises to accompany 486. Hands-on experience with aquatic research and monitoring techniques and concepts.\n",
    "credits": "1"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "ENSCI",
    "num": "587",
    "desc": "Prereq: Six credits in biology and 6 credits in chemistry\nIntroduction to major functional groups of autotrophic and heterotrophic microorganisms and their roles in natural and environmental systems. Consequences of microbial activity on water chemistry, weathering, and precipitation/dissolution reactions will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists II",
    "dept": "ENSCI",
    "num": "588",
    "desc": "Prereq: GIS course, such as GEOL 452, CRP 451, CRP 452, NREM 345, NREM 446, AE 408 or equivalent\nGIS course with focus on the spatial analysis and modeling of raster data and triangulated irregular network (TIN) data. Uses ArcGIS and various extensions, such as Spatial Analyst, 3D Analyst, and ArcScene. Includes practical exercises during lectures, lab exercises, homework assignments, and (for GEOL 588) a class project.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "ENSCI",
    "num": "590",
    "desc": "Prereq: Permission of major professor in Environmental Science faculty\nLiterature reviews and conference in accordance with needs and interest of the student.\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "ENSCI",
    "num": "599",
    "desc": "Prereq: Permission of major professor in Environmental Science faculty\nCreative component for nonthesis master of science degree.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Soil Biochemistry",
    "dept": "ENSCI",
    "num": "685",
    "desc": "Prereq: AGRON 585\nChemistry of soil organic matter and biochemical transformations brought about by microorganisms and enzymes in soils.\n",
    "credits": "2"
  },
  {
    "course_name": "Seminar in Environmental Science",
    "dept": "ENSCI",
    "num": "698",
    "desc": "\nReports and discussion of recent research and literature.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "ENSCI",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Environmental Geology: Earth in Crisis",
    "dept": "ENV S",
    "num": "101",
    "desc": "\nAn introduction to geologic processes and the consequences of human activity from local to global scales. Discussion of human population growth, resource depletion, pollution and waste disposal, global warming and ozone depletion, desertification, and geologic hazards such as earthquakes, landslides, flooding, and volcanism. Summer - online only.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Oceanography",
    "dept": "ENV S",
    "num": "108",
    "desc": "\nIntroduction to study of the oceans. Ocean exploration. Waves and currents. Shape, structure, and origin of the ocean basins. Sedimentary record of oceanic life. Composition of seawater and its significance for life. Ocean circulation and its influence on climate. Life of the oceans, including coral reefs. Use and misuse of ocean resources. Anthropogenic impacts on the oceanic environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Geological Disasters",
    "dept": "ENV S",
    "num": "111",
    "desc": "\nIntroduction to the catastrophic geologic processes that disrupt ecosystems and human activity. Includes a discussion on the role of plate tectonics, the hydrologic cycle, and humans as the driving forces behind selected case studies on volcanic eruptions, earthquakes, tsunamis, landslides, and floods. Summer and fall - online only.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Renewable Resources",
    "dept": "ENV S",
    "num": "120",
    "desc": "\nOverview of soil, water, plants, and animals as renewable natural resources in an ecosystem context. History and organization of resource management. Concepts of integrated resource management.\n",
    "credits": "3"
  },
  {
    "course_name": "Natural Resources and Agriculture",
    "dept": "ENV S",
    "num": "130",
    "desc": "\nSurvey of the ecology and management of fish, forest, and wildlife resources in areas of intensive agriculture, with emphasis on Iowa. Conservation and management practices for private agricultural lands. Designed for nonmajors.\n",
    "credits": "3"
  },
  {
    "course_name": "Water Resources of the World",
    "dept": "ENV S",
    "num": "160",
    "desc": "\nStudy of the occurrence, history, development, and management of world water resources.  Basic hydrologic principles including climate, surface water, groundwater, and water quality.  Historical and current perspectives on water policy, use, and the role of water in society and the environment.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biology",
    "dept": "ENV S",
    "num": "173",
    "desc": "\nAn introduction to the structure and function of natural systems at scales from the individual to the biosphere and the complex interactions between humans and their environment. Discussions of human population growth, biodiversity, sustainability, resource use, and pollution. Does not satisfy biology major requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Environmental Issues",
    "dept": "ENV S",
    "num": "201",
    "desc": "\nDiscussion of current and emerging environmental issues such as human population growth, energy use, loss of biodiversity, water resources, and climate change.\n",
    "credits": "2"
  },
  {
    "course_name": "Biodiversity",
    "dept": "ENV S",
    "num": "204",
    "desc": "Prereq: One course in life sciences\nSurvey of the major groups of organisms and biological systems. Definition, measurements, and patterns of distribution of organisms. Sources of information about biodiversity. Does not satisfy biology major requirements.  Half semester course.\n",
    "credits": "2"
  },
  {
    "course_name": "Globalization and Sustainability",
    "dept": "ENV S",
    "num": "220",
    "desc": "\nAn introduction to understanding the key global issues in sustainability. Focuses on interconnected roles of energy, materials, human resources, economics, and technology in building and maintaining sustainable systems. Applications discussed will include challenges in both the developed and developing world and will examine the role of technology in a resource-constrained world.\n  Cannot be used for technical elective credit in any engineering department.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Geography",
    "dept": "ENV S",
    "num": "250",
    "desc": "\nThe distribution, origins and functions of the earth's physical systems and the spatial relationship between human activity and the natural world.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations in Natural Resource Policy and History",
    "dept": "ENV S",
    "num": "270",
    "desc": "\nThe development of natural resource conservation philosophy and policy from the Colonial Era to the present. North American wildlife, forestry, and environmental policy; national parks and other protected lands; federal and state agencies.  Relationship to cultural contexts, including urban reform and American planning movement. Discussion of common pool resources, public and private lands.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Planning",
    "dept": "ENV S",
    "num": "293",
    "desc": "\nComprehensive overview of the field of environmental relationships and the efforts being made to organize, control, and coordinate environmental, aesthetic, and cultural characteristics of land, air, and water.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecofeminism",
    "dept": "ENV S",
    "num": "320",
    "desc": "Prereq: WGS 201 or 3 credits in WGS at the 300 level or above\nWomen's relationships with the earth, non-human nature, and other humans. The course explores the connections between society’s treatment of women and nature; origins of ecofeminism and how it relates to the science of ecology, conventional and sustainable agriculture as well as how ecofeminism relates to other branches of feminist philosophy. Evaluation and critique of modern science, technology, political systems and SOLUTIONS will be included.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Energy and the Environment",
    "dept": "ENV S",
    "num": "324",
    "desc": "Prereq: CHEM 163 or CHEM 177, MATH 140\nExploration of the origin of Earth’s energy resources and the environmental and climatic impacts of energy acquisition and consumption. Renewable and non-renewable energy resources within an Earth-system context. Various environmentally-relevant topics such as water quality and availability, habitat destruction, greenhouse-gas emissions, and health and safety hazards to wildlife and human communities.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Ethics",
    "dept": "ENV S",
    "num": "334",
    "desc": "Prereq: Three credits in philosophy or junior classification\nThorough study of some of the central moral issues arising in connection with human impact on the environment, e.g., human overpopulation, species extinction, forest and wilderness management, pollution. Several world views of the proper relationship between human beings and nature will be explored.\n",
    "credits": "3"
  },
  {
    "course_name": "World Food Issues: Past and Present",
    "dept": "ENV S",
    "num": "342",
    "desc": "Prereq: Junior classification\nIssues associated with global agricultural and food systems including ethical, social, economic, environmental, and policy contexts. Investigation of various causes and consequences of overnutrition/undernutrition, poverty, hunger, access, and distribution.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "World Food Issues: Past and Present, Honors",
    "dept": "ENV S",
    "num": "342H",
    "desc": "Prereq: Junior classification\nIssues in the agricultural and food systems of the developed and developing world. Emphasis on economic, social, historical, ethical and environmental contexts. Causes and consequences of overnutrition/undernutrition, poverty, hunger and access/distribution. Explorations of current issues and ideas for the future. Team projects.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Population and Society",
    "dept": "ENV S",
    "num": "345",
    "desc": "Prereq: SOC 134\nHuman population growth and structure; impact on food, environment, and resources; gender issues; trends of births, deaths, and migration; projecting future population; population policies and laws; comparison of the United States with other societies throughout the world.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Literature and the Environment",
    "dept": "ENV S",
    "num": "355",
    "desc": "Prereq: ENGL 250\nStudy of literary texts that address the following topics, among others: the relationship between people and natural/urban environments, ecocriticism, and the importance of place in the literary imagination.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Environmental History",
    "dept": "ENV S",
    "num": "362",
    "desc": "Prereq: Either one of HIST 201, 202, or 207; or 3 credits of Environmental Studies; and sophomore classification.\nSurvey of the interactions of human communities with their environments from the beginnings of human history to the present. Topics include the domestication of animals, the agricultural revolution, industrialization, urbanization, deforestation, hydraulic management, fossil fuel consumption, and climate change.\n",
    "credits": "3"
  },
  {
    "course_name": "U. S. Environmental History",
    "dept": "ENV S",
    "num": "363",
    "desc": "Prereq: Sophomore classification\nSurvey of the interactions of human communities with the North American environment. Focus on the period from presettlement to the present, with a particular concentration on natural resources, disease, settlement patterns, land use, and conservation policies.\n",
    "credits": "3"
  },
  {
    "course_name": "Energy, Environmental and Resource Economics",
    "dept": "ENV S",
    "num": "380",
    "desc": "Prereq: ECON 101\nNatural resource availability, use, conservation, and government policy, with emphasis on energy issues. Environmental quality and pollution control policies.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Systems I:  Introduction to Environmental Systems",
    "dept": "ENV S",
    "num": "381",
    "desc": "Prereq: 12 credits of natural science including biology and chemistry\nIntroduction to the structure and function of natural environmental systems. Emphasis on the analysis of material and energy flows in natural environmental systems and the primary environmental factors controlling these systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Sociology",
    "dept": "ENV S",
    "num": "382",
    "desc": "Prereq: SOC 134 or 3 credits of ENV S\nEnvironment-society relations; social construction of nature and the environment; social and environmental impacts of resource extraction, production, and consumption; environmental inequality; environmental mobilization and movements; U.S. and international examples.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Politics and Policies",
    "dept": "ENV S",
    "num": "383",
    "desc": "Prereq: sophomore classification\nMajor ideologies' relations to conservation and ecology. Processes, participants, and institutions involved in state, national, and global environmental policymaking. Case studies of environmental controversies and proposals for policy reform.\n",
    "credits": "3"
  },
  {
    "course_name": "Religion and Ecology",
    "dept": "ENV S",
    "num": "384",
    "desc": "\nIntroduction to concepts of religion and ecology as they appear in different religious traditions, from both a historical and contemporary perspective. Special attention to religious response to contemporary environmental issues.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Internship in Environmental Studies",
    "dept": "ENV S",
    "num": "390",
    "desc": "Prereq: Approval of the Environmental Studies Coordinator\nPractical experience with nature centers, government agencies, schools, private conservation groups, and other organizations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Global Change",
    "dept": "ENV S",
    "num": "404",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nRecent changes in global biogeochemical cycles and climate; models of future changes in the climate system; impacts of global change on agriculture, water resources and human health; ethical issues of global environmental change.  Also offered online Alt. F, even-numbered years.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Management",
    "dept": "ENV S",
    "num": "407",
    "desc": "Prereq: A course in general biology\nManaging human impacts on the hydrologic cycle. Field and watershed level best management practices for modifying the impacts on water quality, quantity and timing are discussed. Field project includes developing a management plan using landscape buffers.\n",
    "credits": "4"
  },
  {
    "course_name": "Urban and Peri-urban Watershed Assessment",
    "dept": "ENV S",
    "num": "417",
    "desc": "Prereq: Junior classification and 6 credits of natural science\nAssessment and reduction of impacts in urban and peri-urban watershed areas. Course prepares students to work with various analysis methods for vegetation, topography, stormwater and stream condition as well as work with data from other disciplines. Emphasis on communicating with the public. Introductory GIS and GPS technologies are utilized. Learning is largely field-based.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable and Environmental Horticulture Systems",
    "dept": "ENV S",
    "num": "424",
    "desc": "\nInquiry into ethical issues and environmental consequences of horticultural cropping systems, production practices and managed landscapes. Emphasis on systems that are resource efficient, environmentally sound, socially acceptable, and profitable.\n",
    "credits": "3"
  },
  {
    "course_name": "The Policy and Politics of Coastal Areas",
    "dept": "ENV S",
    "num": "442",
    "desc": "\nExploration of political implications of coastal policy. Issues include: \"Carrying capacity,\" zoning, regulation of human development activities, trade-offs between conservation and jobs, the quality of coastal lifestyle, ways in which citizens participate in policy for coastal areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Issues in Sustainable Agriculture",
    "dept": "ENV S",
    "num": "450",
    "desc": "\nAgricultural science as a human activity; contemporary agricultural issues from agroecological perspective. Comparative analysis of intended and actual consequences of development of industrial agricultural practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Controversies in Natural  Resource Management",
    "dept": "ENV S",
    "num": "460",
    "desc": "Prereq: NREM 120, and A ECL 312 or NREM 301, and Junior classification\nAnalysis of controversial natural resource issues using a case approach that considers uncertainty and adequacy of information and scientific understanding. Ecological, social, political, economic, and ethical implications of issues will be analyzed.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to GIS",
    "dept": "ENV S",
    "num": "461I",
    "desc": "\nDescriptive and predictive GIS modeling techniques, spatial statistics, and map algebra. Application of GIS modeling techniques to environmental planning and resource management.\n",
    "credits": "4"
  },
  {
    "course_name": "Sustainable Communities",
    "dept": "ENV S",
    "num": "484",
    "desc": "Prereq: Junior classification\nThe history and theory of sustainable community planning.  Procedural and substantive dimensions.  Case studies of communities engaged in sustainability planning.  Use and development of indicators.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ENV S",
    "num": "490",
    "desc": "Prereq: Permission of instructor and approval of Environmental Studies coordinator\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study:  Honors",
    "dept": "ENV S",
    "num": "490H",
    "desc": "Prereq: Permission of instructor and approval of Environmental Studies coordinator.\n",
    "credits": "arr"
  },
  {
    "course_name": "Environmental Law and Planning",
    "dept": "ENV S",
    "num": "491",
    "desc": "Prereq: 6 credits in natural sciences\nEnvironmental law and policy as applied in planning at the local and state levels. Brownfields, environmental justice, water quality, air quality, wetland and floodplain management, and local government involvement in ecological protection through land use planning and other programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Travel Course",
    "dept": "ENV S",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nExtended field trips to study environmental topics in varied locations. Location and duration of   trips will vary. Trip expenses paid by students. Check with department for current offerings.\n",
    "credits": "arr"
  },
  {
    "course_name": "International Tour",
    "dept": "ENV S",
    "num": "496A",
    "desc": "Prereq: Permission of instructor\nExtended field trips to study environmental topics in varied locations. Location and duration of   trips will vary. Trip expenses paid by students. Check with department for current offerings.\n",
    "credits": "arr"
  },
  {
    "course_name": "Domestic Tour",
    "dept": "ENV S",
    "num": "496B",
    "desc": "Prereq: Permission of instructor\nExtended field trips to study environmental topics in varied locations. Location and duration of   trips will vary. Trip expenses paid by students. Check with department for current offerings.\n",
    "credits": "arr"
  },
  {
    "course_name": "Digital Production in Event Management",
    "dept": "EVENT",
    "num": "212",
    "desc": "Prereq: Event Management major\nApplications of skills in Adobe Suite and other software technologies.  Introduction to design elements used within the event management industry with a focus on digital publishing of marketing and promotional materials, wayfinding, and other stationery items.  Face-to-face lecture and laboratory work.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Event Management",
    "dept": "EVENT",
    "num": "271",
    "desc": "\nOverview of the event management industries. Techniques and procedures required for producing successful and sustainable events.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Digital Promotion in Event Management",
    "dept": "EVENT",
    "num": "277",
    "desc": "Prereq: EVENT 271\nEvent management digital channels and platforms, including display advertising, search advertising, social media, and mobile. Students will be introduced to the most popular event management platforms as well as digital event management topics of visual marketing, digital media planning, and content marketing.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Club Management",
    "dept": "EVENT",
    "num": "289",
    "desc": "Prereq: HSP M 101\nOrganization and management of private clubs including city, country, and other recreational and social clubs. Field trip may be required.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "EVENT",
    "num": "290",
    "desc": "Prereq: Freshman or Sophomore Classification.  Permission of instructor, adviser, and department chair.\nIndependent study on topics of special interest to the student, facilitated by approved faculty member.\n  No more than 9 credits of EVENT 290 and EVENT 490 may be applied towards graduation requirements.",
    "credits": "1"
  },
  {
    "course_name": "Attractions and Amusement Park Administration",
    "dept": "EVENT",
    "num": "320",
    "desc": "Prereq: HSP M 101 or permission of instructor\nExamination of current issues in the attractions and amusement park industry.  Emphasis will be placed on development and design along with the functional departments of modern amusement parks and themed attractions.\n",
    "credits": "3"
  },
  {
    "course_name": "Incentive Meeting Management",
    "dept": "EVENT",
    "num": "328",
    "desc": "Prereq: EVENT 271, Event Management major\nOverview of the incentive meeting industry. Focus on incentive meeting planning, destination selection, program development, risk management, cultural aspects of international/national site selection and incentive meeting execution, and incentive meeting evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Entertainment Venue Management",
    "dept": "EVENT",
    "num": "333",
    "desc": "Prereq: EVENT 271 or equivalent\nOrganization and management of various types of entertainment venues including clubs, theaters, auditoriums, and arenas.\n",
    "credits": "3"
  },
  {
    "course_name": "Event Sales",
    "dept": "EVENT",
    "num": "367",
    "desc": "Prereq: EVENT 271; AESHM 340\nOverview of sales marketing management in the event industry and the role of the professional event sales manager in the marketing process.  As an event professional, learn best sales practices to develop your personal selling style, to build on your strengths, and to create a referral business that delivers results.  Principles covered include the characteristics and skills necessary for success in sales; strategic planning; sales leadership; analyzing customers and markets; designing and developing the sales force; the importance of relationship building; process management; and measurement, analysis, and knowledge management.\n",
    "credits": "3"
  },
  {
    "course_name": "Conference and Meeting Planning",
    "dept": "EVENT",
    "num": "371",
    "desc": "Prereq: EVENT 271 and junior standing\nApplication of event management principles to conference and meeting planning.  Providing a comprehensive introduction to the key elements of the global conference, convention and meetings focus on destination marketing and professional development.\n",
    "credits": "3"
  },
  {
    "course_name": "Wedding Planning and Management",
    "dept": "EVENT",
    "num": "373",
    "desc": "Prereq: EVENT 371 and Event Management major\nOverview of wedding event industry.  Focus on wedding planning processes and implementation, design, and business planning and development.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Event Management",
    "dept": "EVENT",
    "num": "378",
    "desc": "Prereq: EVENT 271, EVENT majors.\nIntroduction to international sustainable event standards, and how to measure the environmental impact of an event.  Topics include ethics, corporate social responsibility (CSR), and sustainability related practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonprofit Fundraising Event Planning",
    "dept": "EVENT",
    "num": "379",
    "desc": "Prereq: EVENT 271, Instructor's permission.\nThe role of Nonprofit Organizations (NPOs) in the United States, and how NPOs secure essential income and help educate donors, guests, and volunteers of the organizational mission. Fundamentals of an event-based fundraising (e.g., a gala dinner) or community-based fundraising (e.g., runs, walks, and rides).  Budgeting, marketing outreach, logistics management. Use of strategic tools, such as website and social media, to help increase financial success of a fundraising event. Grant-writing content.\n",
    "credits": "3"
  },
  {
    "course_name": "Event Management Workshop",
    "dept": "EVENT",
    "num": "393",
    "desc": "Prereq: EVENT Junior or Senior Classification and Permission of Instructor\nIntensive 2 to 8 week workshop exploration.  Topics vary each time offered.\n  Maximum of 6 Event 393 credits can be applied to graduation.",
    "credits": "1"
  },
  {
    "course_name": "International Meetings and Conferences Management",
    "dept": "EVENT",
    "num": "423",
    "desc": "Prereq: EVENT 271, EVENT 371\nStrategies and tactics for planning a meeting, exposition, or convention that is held outside of the United States; and a meeting, exposition, or convention that attracts numerous international attendees to the United States.\n",
    "credits": "3"
  },
  {
    "course_name": "Case Studies in Event Management",
    "dept": "EVENT",
    "num": "431",
    "desc": "Prereq: Graduate-level standing and permission by instructor.\nOperational and strategic challenges in the event management industry through directed case studies, roundtable discussions, and industry-related readings. Students will critically evaluate case studies related to event management in areas of event strategy, financial management, event operations, stakeholder development, event design, marketing, and other event topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Events Coordination",
    "dept": "EVENT",
    "num": "471",
    "desc": "Prereq: EVENT 371 and junior standing; permission of instructor.\nAdvanced application event management. Provide leadership and communicate direction for production of an event including developing event strategy, financial management, wayfinding, volunteer management, and marketing.\n",
    "credits": "3"
  },
  {
    "course_name": "Event Management Production",
    "dept": "EVENT",
    "num": "485",
    "desc": "Prereq: EVENT 471; limited to Event Management majors; application and instructor permission\nPlanning and execution of an event including strategic planning, site selection, stakeholder development, event sponsorship, financial management, event marketing, event operations, and event evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "EVENT",
    "num": "490",
    "desc": "Prereq: Sections B-D: Program approval; Section H: Full membership in Honors Program\nIndependent study.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Conferences",
    "dept": "EVENT",
    "num": "490B",
    "desc": "Prereq: Program approval\nIndependent study.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Special Events",
    "dept": "EVENT",
    "num": "490C",
    "desc": "Prereq: Program approval.\nIndependent study.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Event Management",
    "dept": "EVENT",
    "num": "490D",
    "desc": "Prereq: Sections B-D: Program approval; Section H: Full membership in Honors Program\nIndependent study.\n",
    "credits": "arr"
  },
  {
    "course_name": "Professional Roles in Family and Consumer Sciences",
    "dept": "FCEDS",
    "num": "206",
    "desc": "Prereq: HD FS 103 or concurrent enrollment in HD FS 103\nIntroduction to various roles in professional settings (community agencies, secondary schools, business and industry, and Cooperative Extension). Focus on factors that have influenced the development and mission of Family and Consumer Sciences programs nationwide. Includes 12 hours of observational practicum experience outside of the regular class schedule.\n",
    "credits": "2"
  },
  {
    "course_name": "Short Course: Current Family and Consumer Sciences Offerings",
    "dept": "FCEDS",
    "num": "301",
    "desc": "Prereq: 6 credits in family and consumer sciences or education\nShort course in current family and consumer sciences offerings.\n",
    "credits": "3"
  },
  {
    "course_name": "Short Course: Housing",
    "dept": "FCEDS",
    "num": "301F",
    "desc": "Prereq: 6 credits in family and consumer sciences or education\nShort course in housing.\n",
    "credits": "3"
  },
  {
    "course_name": "Short Course: General",
    "dept": "FCEDS",
    "num": "301G",
    "desc": "Prereq: 6 credits in family and consumer sciences or education\nGeneral short course in FCEDS.\n",
    "credits": "3"
  },
  {
    "course_name": "Short Course: Textile Selection and Apparel Construction Methods",
    "dept": "FCEDS",
    "num": "301K",
    "desc": "Prereq: 6 credits in family and consumer sciences or education\nShort course in textile selection and apparel construction.\n",
    "credits": "3"
  },
  {
    "course_name": "Educational Principles for Family and Consumer Sciences",
    "dept": "FCEDS",
    "num": "306",
    "desc": "Prereq: FCEDS 206\nPrinciples of teaching and learning applied to family and consumer sciences content incorporating literacy and STEM strategies for diverse audiences. Focus on providing a broad overview of effective instructional methods and substantial technological tools to meet varied learning needs. Includes 12 hours of arranged practicum and team teaching.\n",
    "credits": "4"
  },
  {
    "course_name": "Planning and Assessment for Family and Consumer Sciences",
    "dept": "FCEDS",
    "num": "413",
    "desc": "Prereq: FCEDS 306 and admission to Teacher Education\nDevelopment of curriculum and assessment tools for family and consumer sciences programs in school settings. Focus on accommodating exceptional learners and alignment of teaching standards for classroom assessment. Includes 12 hours of Career and Technical Student Organization Competitive Event Assessment at the state/national level.\n",
    "credits": "4"
  },
  {
    "course_name": "Supervised Teaching in Family and Consumer Sciences",
    "dept": "FCEDS",
    "num": "417",
    "desc": "Prereq: FCEDS 413; 24 credits in family and consumer sciences subject matter; cumulative grade point of 2.50; admission to teacher education, reservation required.\nSupervised teaching experience in secondary schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Teaching in Family and Consumer Sciences: Vocational family and consumer sciences.",
    "dept": "FCEDS",
    "num": "417A",
    "desc": "Prereq: FCEDS 413, 24 credits in family and consumer sciences subject matter, cumulative grade point of 2.50, admission to teacher education, reservation required.\nSupervised teaching experience in secondary schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Teaching in Family and Consumer Sciences: Family and consumer sciences.",
    "dept": "FCEDS",
    "num": "417B",
    "desc": "Prereq: FCEDS 413, 24 credits in family and consumer sciences subject matter, cumulative grade point of 2.50, admission to teacher education, reservation required.\nSupervised teaching experience in secondary schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Career and Technical Education in Family and Consumer Sciences",
    "dept": "FCEDS",
    "num": "418",
    "desc": "Prereq: Admission to teacher education, FCEDS 413 or concurrent enrollment in FCEDS 413.\nInvestigation into the philosophy of Career and Technical Education (CTE). Historical development of family and consumer sciences. Planning and implementing programs in  family and consumer sciences including FCCLA. Impact of selected legislation on family and consumer sciences programs. Techniques for cooperative education, school-to-work, and work-based education programs. Includes educational opportunities off campus for professional development and career advancement. May be used toward Multioccupations Endorsement.\n",
    "credits": "3"
  },
  {
    "course_name": "Pre-Student Teaching Experience in Family and Consumer Sciences Education",
    "dept": "FCEDS",
    "num": "480",
    "desc": "Prereq: Admission to teacher education.\nLaboratory experience in foods, textiles and human development in family and consumer sciences secondary programs. At least 2 hour blocks of time needed for field experience. Observation of family and consumer sciences laboratories in diverse classrooms. Planning, implementing, managing and assessing laboratory lessons in family and consumer sciences.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience in FCS Education: Practicum in FCS Labs (High School)",
    "dept": "FCEDS",
    "num": "480A",
    "desc": "Prereq: FCEDS 306 and admission to teacher education\nLaboratory experience in foods, hospitality management, culinary, prostart, textiles, fashion design, housing, and human development related to family and consumer sciences courses taught at the secondary level. Planning, implementing, managing, and assessing laboratory lessons in family and consumer sciences. Includes 24 hours practicum and supervised individual teaching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience in FCS Education: Practicum in Diverse Settings (Middle School)",
    "dept": "FCEDS",
    "num": "480B",
    "desc": "Prereq: FCEDS 306 and admission to teacher education.\nLaboratory experience in foods, textiles, and human development related to family and consumer sciences exploratory programs. Planning, implementing, managing and assessing laboratory lessons in family and consumer sciences. Includes 24 hours practicum and supervised individual teaching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "FCEDS",
    "num": "490",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: General",
    "dept": "FCEDS",
    "num": "490G",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "FCEDS",
    "num": "490H",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Experiences in a Professional Setting",
    "dept": "FCEDS",
    "num": "491",
    "desc": "Prereq: HD FS 418B; 24 credits in family and consumer sciences; reservation required\nSupervised professional experience in an approved setting such as Cooperative Extension, business, community, human service, or government agency.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Supervised Experiences in a Professional Setting: Communications",
    "dept": "FCEDS",
    "num": "491A",
    "desc": "Prereq: HD FS 418B; 24 credits in family and consumer sciences; reservation required\nSupervised professional experience in an approved setting such as Cooperative Extension, business, community, human service, or government agency.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Supervised Experiences in a Professional Setting: Professional Studies",
    "dept": "FCEDS",
    "num": "491B",
    "desc": "Prereq: HD FS 418B; 24 credits in family and consumer sciences; reservation required\nSupervised professional experience in an approved setting such as Cooperative Extension, business, community, human service, or government agency.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Financial Theory and Research I",
    "dept": "FFP",
    "num": "520",
    "desc": "\nTheories of family functioning, macroeconomic theory related to family resource allocation decisions, the family as an economic unit, and the interaction of the economy and families.  (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Theory and Research II",
    "dept": "FFP",
    "num": "525",
    "desc": "\nMicroeconomic theory as it relates to family resource allocation decisions, theories of household behavior, the lifecycle hypothesis, behavioral economics, behavioral finance, theories of behavioral change, and psychological theories of family well-being. Focus on empirical research investigating household financial decision-making. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Family Financial Planning",
    "dept": "FFP",
    "num": "530",
    "desc": "\nThe nature and functioning of financial systems, including currencies, markets, monetary and fiscal policy, and supply/demand for land, labor, and capital. Focus is on the impact of global financial interdependence on individuals and families in the U.S. Current and emerging issues, as well as current research and theory relative to financial systems. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Counseling",
    "dept": "FFP",
    "num": "535",
    "desc": "\nTheory and research regarding the interactive process between the client and the practitioner, including communication techniques, motivation and esteem building, the counseling environment, ethics, and methods of data intake, verification, and analysis. Other topics include legal issues, compensation, uses of technology to identify resources, information management, and current or emerging issues. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Estate Planning for Families",
    "dept": "FFP",
    "num": "540",
    "desc": "\nFundamentals of the estate planning process, including estate settlement, estate and gift taxes, property ownership and transfer, and powers of appointment. Tools and techniques used in implementing an effective estate plan, ethical considerations used in providing estate planning services, and new and emerging issues in the field. Case studies provide experience in developing estate plans suitable for varied family forms. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Housing and Real Estate in Family Financial Planning",
    "dept": "FFP",
    "num": "541",
    "desc": "\nThe role of housing and real estate in the family financial planning process, including taxation, mortgages, financial calculations, legal concerns, and ethical issues related to home ownership and real estate investments. Emphasis on emerging issues in the context of housing and real estate. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Retirement Planning, Employee Benefits, and the Family",
    "dept": "FFP",
    "num": "545",
    "desc": "\nStudy of micro and macro considerations for retirement planning. Survey of various types of retirement plans, ethical considerations in providing retirement planning services, assessing and forecasting financial needs in retirement, and integration of retirement plans with government benefits.(on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Military Personal Financial Readiness",
    "dept": "FFP",
    "num": "550",
    "desc": "\nOverview of the topics relevant to the financial planning process that address the unique needs of military service members and their families. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Insurance Planning for Families",
    "dept": "FFP",
    "num": "555",
    "desc": "\nIn-depth study of risk management concepts, tools, and strategies for individuals and families, including life insurance; property and casualty insurance; liability insurance; accident, disability, health, and long-term care insurance; and government-subsidized programs. Current and emerging issues and ethical considerations relative to risk management. Case studies provide experience in selecting insurance products suitable for individuals and family, study of investment options for clients including common stocks, fixed income securities, convertible securities, and related choices. Relationships between investment options and employee/employer benefit plan choices. Current and emerging issues and ethics are included. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Personal Income Taxation",
    "dept": "FFP",
    "num": "565",
    "desc": "\nIn-depth information on income tax practices and procedures including tax regulations, tax return preparation, the tax audit processes, the appeals process, preparation for an administrative or judicial forum, and ethical considerations of taxation. New and emerging issues related to taxation. Family/individual case studies provide practice in applying and analyzing tax information and recommending appropriate tax strategies. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Practices in Financial Planning",
    "dept": "FFP",
    "num": "570",
    "desc": "\nChallenges of managing financial planning practices including, but not limited to: business valuation, personnel, marketing, client services, ethics and technological applications. Relying both on a theoretical as well as an applied approach, students analyze case studies that provide relevant, practical exposure to practice management issues, with a strong emphasis on current research findings. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Investing for the Family's Future",
    "dept": "FFP",
    "num": "583",
    "desc": "\nEvaluation of investment markets for the household. Analysis of how families choose where to put their savings. Emphasis is on using the family's overall financial and economic goals to help inform investment choices. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum",
    "dept": "FFP",
    "num": "591",
    "desc": "\nSupervised experience in family financial planning.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Planning - Case Studies",
    "dept": "FFP",
    "num": "595",
    "desc": "Prereq: FFP 530, FFP 540, FFP 545, FFP 555, FFP 565, FFP 583\nProfessional issues in financial planning, including ethical considerations, regulation and certification requirements, communication skills, and professional responsibility. Students are expected to utilize skills obtained in other courses and work experiences in the completion of personal finance case studies, the development of a targeted investment policy, and other related financial planning assignments. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Finance",
    "dept": "FIN",
    "num": "301",
    "desc": "Prereq: ACCT 284, ECON 101, STAT 226\nIntroduction to financial management with emphasis on corporate financing and investment decision making, time value of money, asset valuation, capital budgeting decision methods, cash budgeting, and financial markets.\n",
    "credits": "3"
  },
  {
    "course_name": "Corporate Finance",
    "dept": "FIN",
    "num": "310",
    "desc": "Prereq: FIN 301\nTheory used in a firm's investment and financing decisions. Analysis of environment in which financial decisions are made; applications of analytical techniques to financial management problems.\n",
    "credits": "3"
  },
  {
    "course_name": "Investments",
    "dept": "FIN",
    "num": "320",
    "desc": "Prereq: FIN 301\nIntroduction to securities and markets from the viewpoint of the individual investor. Emphasis on mechanics of trading, measurement of return and risk, behavior of security prices, valuation of stocks and bonds, mutual funds, portfolio selection techniques, and performance evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Fixed Income Securities",
    "dept": "FIN",
    "num": "327",
    "desc": "Prereq: FIN 301\nValuation of fixed income securities, including pricing conventions, term structure of interest rates, default, duration, and hedging of interest rate risk with derivatives. Analysis of bond market sectors, including treasury, agency, corporate, sovereign, municipal, and residential mortgage bonds.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Markets and Institutions",
    "dept": "FIN",
    "num": "330",
    "desc": "Prereq: FIN 301\nIntroduction to the structure and operations of the United States financial system and its markets and institutions. Emphasis on developing an integrated understanding of markets and financial service providers including global linkages.\n",
    "credits": "3"
  },
  {
    "course_name": "Personal Risk Management and Insurance",
    "dept": "FIN",
    "num": "361",
    "desc": "Prereq: ECON 101\nRisk concepts and the use of insurance by individuals and families. Emphasis on the insurance mechanism and methods of dealing with income, property, and liability risks.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Principles",
    "dept": "FIN",
    "num": "371",
    "desc": "Prereq: ECON 101\nLegal, economic, social and financial aspects of real estate, including property rights, contracts, mortgage instruments, tax factors, brokerage, valuation, risk and return analysis, financing techniques, and investments.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Financing Decisions",
    "dept": "FIN",
    "num": "415",
    "desc": "Prereq: FIN 301\nIn depth study of the firm's external financing decision. Emphasis on the development of cash flow statements, projected financing needs and the selection of the appropriate financing instrument. Focus on case studies and application of developed techniques on actual field project.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Futures and Options",
    "dept": "FIN",
    "num": "424",
    "desc": "Prereq: FIN 320 and STAT 326\nAdvanced study of pricing and using derivatives - instruments deriving value from fundamental items such as commodities, currency exchange rates, market indices, equities and bonds. Addresses basic building blocks of derivatives (i.e., forwards, futures, options and swaps) and relevant current topics and issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Security Analysis and Portfolio Management",
    "dept": "FIN",
    "num": "425",
    "desc": "Prereq: FIN 320, STAT 326 and permission of instructor\nAdvanced study of security analysis, security selection techniques and portfolio management. Emphasis on the applications of methods learned via the selection and evaluation of a portfolio of actual securities purchased in securities markets in the U.S. or abroad. Tracking and periodic reporting of the portfolio's performance relative to standard benchmarks is also required.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Fixed Income Analysis and Portfolio Management",
    "dept": "FIN",
    "num": "428",
    "desc": "Prereq: FIN 327, FIN 320, STAT 326\nAdvanced analysis of fixed income markets and securities, including valuation and trading of treasury securities, corporate bonds, mortgage backed securities. Analysis of structured financial securities, including CDO, CMBS, and ABS. Analysis of active and passive investment strategies for managing fixed income portfolios. Students are required to manage a fixed income portfolio for an institutional investor. A top-down approach to portfolio management is assumed, with active bets taken on market direction, duration, yield curve, and credit spreads.\n",
    "credits": "3"
  },
  {
    "course_name": "Venture Capital, Private Equity, and Mergers and Acquisitions",
    "dept": "FIN",
    "num": "435",
    "desc": "Prereq: FIN 310, FIN 320, STAT 326\nAn advanced investments class that focuses on alternative investments. Topics include techniques for valuing public and private firms, venture capital finance, investment banking, private equity finance, leveraged buyouts, hedge funds, the structure and financing of mergers and acquisitions, and divestitures.\n",
    "credits": "3"
  },
  {
    "course_name": "Bank Management Decisions",
    "dept": "FIN",
    "num": "445",
    "desc": "Prereq: STAT 326; and FIN 330 or ECON 353\nAnalysis of operations of depository financial institutions from management viewpoint. Emphasis on evaluating performance, policy formation, asset and liability management, the role of capital, and the operating environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Analytical Methods in Finance",
    "dept": "FIN",
    "num": "450",
    "desc": "Prereq: STAT 326, and ECON 301 or FIN 301\nApplied empirical methods commonly employed in the analysis of firm and market data. Specific applications to financial and agricultural markets. Experiential learning experience using lectures with frequent in-class computer work sessions. Experience with financial and agricultural data sources. Application and interpretation of empirical techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Corporate Risk Management and  Insurance",
    "dept": "FIN",
    "num": "462",
    "desc": "Prereq: FIN 301 and STAT 326\nAnalysis of an organization's approaches to the management of price, credit, and pure risk. Emphasis on the consideration and selection of risk control and financing treatments and the decision making framework underlying the alternatives selected. Covers commercial insurance, self-insurance, and alternative financing arrangements.\n",
    "credits": "3"
  },
  {
    "course_name": "Risk Management Derivatives",
    "dept": "FIN",
    "num": "464",
    "desc": "\nAdvanced models for options and bond pricing. Geometric Brownian motion, risk-neutral pricing, no-arbitrage pricing models, exotic options, pricing options through simulation, and applications of derivatives to hedging market and credit risk exposure. Risk management tools and how they are applied within financial institutions such as banks, insurance companies, mutual funds, and hedge funds, as well as the corporate enterprise. Topics include the Basel accords, volatility modelling, value-at-risk analysis, extreme value theory, credit default swaps, and portfolio simulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Finance",
    "dept": "FIN",
    "num": "472",
    "desc": "Prereq: FIN 301 and STAT 326\nIntroduction to the techniques of assessing the value of real estate and real estate financing instruments.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Investment",
    "dept": "FIN",
    "num": "474",
    "desc": "Prereq: FIN 301, FIN 371\nIntroduction to theories and methods of investment analysis applied to real estate. Studies cash flow analysis, alternative measures of investment performance, the impact of the financing decision on real estate investment risks and return, and various real estate financing techniques. Covers cases involving more complex financing and capital markets tools used in real estate.\n",
    "credits": "3"
  },
  {
    "course_name": "International Finance",
    "dept": "FIN",
    "num": "480",
    "desc": "Prereq: FIN 310, FIN 320 or FIN 330\nAdvanced study of currency market equilibrium, use and analysis of currency derivatives, hedging currency risk, and additional topics, which could include multinational capital budgeting, taxation, raising capital internationally, international portfolio diversification, international capital market equilibrium, political and country risk, financing international trade, multinational corporate treasury management, and current issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "FIN",
    "num": "490",
    "desc": "Prereq: FIN 301, STAT 326 and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Finance Internship",
    "dept": "FIN",
    "num": "499",
    "desc": "Prereq: GPA 2.5; permission of internship coordinator; STAT 326; FIN 499A: FIN 330; FIN 499B: FIN 361; FIN 499C: FIN 301 plus 3 additional credits in finance; FIN 499D: FIN 320; FIN 499E: FIN 310\nSupervised experience in a private sector banking, insurance, real estate, investments or corporate organization or in a governmental agency that regulates such organizations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Finance Internship:Banking",
    "dept": "FIN",
    "num": "499A",
    "desc": "Prereq: GPA 2.5; permission of internship coordinator; STAT 326.\nSupervised experience in a private sector banking, insurance, real estate, investments or corporate organization or in a governmental agency that regulates such organizations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Insurance",
    "dept": "FIN",
    "num": "499B",
    "desc": "Prereq: GPA 2.5; permission of internship coordinator; FIN 361 and STAT 326\nSupervised experience in a private sector insurance organization or in a governmental agency that regulates such organizations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Real Estate",
    "dept": "FIN",
    "num": "499C",
    "desc": "Prereq: GPA 2.5; permission of internship coordinator; FIN 301 plus 3 additional credits in finance and STAT 326;\nSupervised experience in a private sector real estate organization or in a governmental agency that regulates such organizations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Investments",
    "dept": "FIN",
    "num": "499D",
    "desc": "Prereq: GPA 2.5; permission of internship coordinator; FIN 320 and STAT 326\nSupervised experience in a private sector investment organization or in a governmental agency that regulates such organizations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Corporate",
    "dept": "FIN",
    "num": "499E",
    "desc": "Prereq: GPA 2.5; permission of internship coordinator; FIN 310 and STAT 326\nSupervised experience in a private sector corporate organization or in a governmental agency that regulates such organizations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Financial  Valuation and Corporate Financial Decisions",
    "dept": "FIN",
    "num": "501",
    "desc": "Prereq: Enrollment in MBA program or departmental permission.\nShareholder wealth maximization as the goal of the firm within a social responsibility context, financial Math, valuation of securities, the global financial market place as the test of value, estimation of cost of capital, global capital investment decisions, capital structure policy, working capital management.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Corporate Finance",
    "dept": "FIN",
    "num": "510",
    "desc": "Prereq: FIN 501\nExamines corporate financial decisions, including theory and associated empirical evidence. Topics include agency conflicts, corporate governance, executive compensation, becoming publicly traded, raising capital through public and private offerings, capital structure, financial distress and bankruptcy, leasing, dividend policy, corporate control, restructuring, and risk management.\n",
    "credits": "3"
  },
  {
    "course_name": "Case Studies in Financial Decision Making",
    "dept": "FIN",
    "num": "515",
    "desc": "Prereq: FIN 501\nThis course focuses on case studies to develop an integrated set of financial decisions. Topic areas include fixed asset, working capital, capital structure, dividend and merger/acquisition decisions. The objective of the course is to examine different firm settings and establish a framework within which to apply financial tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Investments",
    "dept": "FIN",
    "num": "520",
    "desc": "Prereq: FIN 501\nAnalysis of risk and return for individual securities and portfolios of securities. Topics include the market environment, mechanics of trading, measurement of return and risk, valuation of stocks and bonds, mutual funds, optimal asset allocation, market efficiency, portfolio performance evaluation, and risk management.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Fixed Income Analysis and Portfolio Management",
    "dept": "FIN",
    "num": "528",
    "desc": "Prereq: FIN 327, FIN 320, STAT 326\nAdvanced analysis of fixed income markets and securities, including valuation and trading of treasury securities, corporate bonds, mortgage backed securities. Analysis of structured financial securities, including CDO, CMBS, and ABS. Analysis of active and passive investment strategies for managing fixed income portfolios. Students are required to manage a fixed income portfolio for an institutional investor. A top-down approach to portfolio management is assumed, with active bets taken on market direction, duration, yield curve, and credit spreads.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Analysis and Valuation",
    "dept": "FIN",
    "num": "530",
    "desc": "Prereq: FIN 501\nValuation of public and private firms through analysis of financial statements and other information. Study of drivers of value creation, industry analysis, patterns of growth, models for forecasting and analyzing firm cash flows, estimating and adjusting cost of capital, alternative methods of cash flow valuation, the calculation and use of valuation multiples, and valuing mergers and acquisitions.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Derivatives",
    "dept": "FIN",
    "num": "534",
    "desc": "Prereq: Graduate classification\nAn applied course in derivative markets. Topics covered include futures and options markets, option pricing, swaps, use and rating of insurance products, and alternative forms of reinsurance. Emphasis will be placed on agricultural commodity markets, but energy, interest, currency and stock index contracts will also be covered.\n",
    "credits": "3"
  },
  {
    "course_name": "Venture Capital, Private Equity, and Mergers and Acquisitions",
    "dept": "FIN",
    "num": "535",
    "desc": "Prereq: FIN 501\nAdvanced investments class focusing on alternative investments. Topics include the nature and scope of investment banking, techniques for valuing public and private firms, venture capital finance, private equity finance, leveraged buyouts, hedge funds, the structure and financing of mergers and acquisitions, and divestitures.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Econometrics",
    "dept": "FIN",
    "num": "550",
    "desc": "Prereq: FIN 501, ECON 571\nAnalysis, modeling, and forecasting of time series data, volatility modeling and forecasting, maximum likelihood estimation, robust standard error computation, specification testing, estimation under alternative distributional assumptions, and Monte Carlo simulation. Applications include tests of asset pricing models, analysis of asset volatility, corporate event studies, and value at risk analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Derivatives and Risk Management",
    "dept": "FIN",
    "num": "564",
    "desc": "Prereq: FIN 501, FIN 534\nRisk management tools and how they are applied within financial institutions and the corporate enterprise. Focus on measuring exposure to stock market risk, interest rate risk, currency risk, and credit risk and how these exposures may be managed. Topics include bank risk management regulations, volatility modeling, value at risk analysis, extreme value theory, credit default swaps, and portfolio simulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Finance",
    "dept": "FIN",
    "num": "572",
    "desc": "Prereq: FIN 501 or enrollment in MRED\nSurvey of techniques for assessing the value of real estate assets.  Introduction to real estate financing instruments, their use and appropriateness.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Investment",
    "dept": "FIN",
    "num": "574",
    "desc": "Prereq: FIN 501; enrollment in the MRED or instructor permission.\nIntroduction to theories and methods of investment analysis applied to real estate. Designed as second course in the sequence of real estate finance and investments. Basics of income-producing properties, the valuations of those properties using pro-forma, risk management and various other issues about the finance and investment of income-producing properties. Study of analysis of sustainable real estate development from capital budgeting perspective. Discussion of the financing practices in real estate and land development.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Securitization and Portfolio Management",
    "dept": "FIN",
    "num": "575",
    "desc": "Prereq: Enrollment in the MRED or instructor permission.\nMechanics, incentives and importance of securitization in firms' efforts to raise capital with application to residential and commercial real estate. Design and implementation of portfolio management strategies of private-market real estate investments. Additional topics include devising alpha strategies, approaches to diversification, creating investment plans to achieve different risk profiles and peformance measurement and analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Estate Market Analysis",
    "dept": "FIN",
    "num": "576",
    "desc": "Prereq: Enrollment in the MRED or instructor permission.\nIntroduction to the structure of real estate markets. Topics include determinants of supply and demand in space and capital markets, house price dynamics and causes and consequences of market cycles. Discussion of likely behavior of U.S. real estate markets and comparisons with markets in other countries.\n",
    "credits": "3"
  },
  {
    "course_name": "MRED Capstone Project",
    "dept": "FIN",
    "num": "578",
    "desc": "Prereq: Enrollment in MRED.\nRefinement of students' problem-solving, communication and negotiation skills. Students work on an actual case. Teams will apply knowledge acquired in the classroom to some aspect of a current development on-the-ground and in-process project.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "FIN",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nFor students wishing to do individual research in a particular area of finance.\n",
    "credits": "1"
  },
  {
    "course_name": "Food and the Consumer",
    "dept": "FS HN",
    "num": "101",
    "desc": "Prereq: High school biology and chemistry or 3 credits each of biology and chemistry\nThe food system from point of harvest to the consumption of the food by the consumer. Properties of food constituents. Protection of food against deterioration and microbial contamination. Introduction of foods into the marketplace. Processes for making various foods. Government regulations. Use of food additives. Current and controversial topics. Electronic communication from web emphasized for class reports, notes and assignments.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition for Sport Performance",
    "dept": "FS HN",
    "num": "102",
    "desc": "\nA scientific evaluation of dietary needs, dietary supplementation, and pop-culture claims relative to physical/sport performance. Discussion of safe and effective practices to enhance physical/sport performance.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Professional Skills in Culinary Science",
    "dept": "FS HN",
    "num": "104",
    "desc": "\nIntroduction to culinary science. Students will develop fundamental culinary skills by arranged on-campus work experience (100 hours).  Sessions with instructor arranged.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional and Educational Preparation",
    "dept": "FS HN",
    "num": "110",
    "desc": "\nIntroduction to professional and educational development within the food science and human nutrition disciplines.  Focus is on university and career acclimation as well as enhancement of communication skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Food Preparation",
    "dept": "FS HN",
    "num": "111",
    "desc": "Prereq: FS HN 101 or FS HN 167; high school chemistry or CHEM 160; concurrent enrollment in FSHN 115.\nPrinciples involved in preparation of food products of standard quality. Influence of composition and techniques on properties of food products.\n",
    "credits": "2"
  },
  {
    "course_name": "Food Preparation Laboratory",
    "dept": "FS HN",
    "num": "115",
    "desc": "Prereq: Credit or enrollment in FS HN 111 or FS HN 214\nPractice standard methods of food preparation with emphasis on quality, nutrient retention, and safety.\n",
    "credits": "1"
  },
  {
    "course_name": "The Biochemistry of Beer",
    "dept": "FS HN",
    "num": "120",
    "desc": "\nAn introduction to the major classes of biomolecules, basic biochemical concepts, enzymology, metabolism and genetic engineering as they apply to the production and flavor of beer. All aspects of the biochemistry of beer will be covered, including the malting of barley, starch conversion, yeast fermentation and the chemical changes that occur during the aging of beer. Intended for non-majors.\n  Natural science majors are limited to elective credit only.",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Human Nutrition",
    "dept": "FS HN",
    "num": "167",
    "desc": "Prereq: High school biology or 3 credits of biology\nUnderstanding and implementing present day knowledge of nutrition. The role of nutrition in the health and well being of the individual and family.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Issues in Food Science and Human Nutrition",
    "dept": "FS HN",
    "num": "203",
    "desc": "\nIntroduction to presentation of published research and discussion of current issues in food science and human nutrition.  Emphasis on sources of credible information, ethics, and communication.\n",
    "credits": "1"
  },
  {
    "course_name": "Processing of Foods: Basic Principles and Applications",
    "dept": "FS HN",
    "num": "207",
    "desc": "Prereq: FS HN 101\nLecture and lab-based instruction on principles of food processing for preservation, raw food materials and their impact on food processing, food product-based discussion and activities highlighting required unit operations and resulting food quality and safety; water, heat, acidity, and oxygen effect on processing, separation and mixing operations, packaging materials properties and methods, and cleaning and sanitation in processing plants.\n",
    "credits": "2"
  },
  {
    "course_name": "Scientific Study of Food",
    "dept": "FS HN",
    "num": "214",
    "desc": "Prereq: FS HN 167 or FS HN 265; CHEM 231 or CHEM 331; plus concurrent enrollment in FS HN 115 or 215\nComposition and structure of foods. Principles of preparation of standard quality food products. Behavior and interactions of food constituents.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Food Preparation Laboratory",
    "dept": "FS HN",
    "num": "215",
    "desc": "Prereq: Credit or enrollment in FS HN 214\nPractice standard methods of food preparation with emphasis on quality, nutrient retention, and safety.  Development of culinary skills and advanced food preparation.\n",
    "credits": "2"
  },
  {
    "course_name": "The US Food System",
    "dept": "FS HN",
    "num": "242",
    "desc": "\nExploration of the components of our food system including food production, food processing, and food access and the social, political and ethical influences on these components. Controversial topics related to how food is produced, processed, marketed and consumed will be discussed.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Nutritional Biochemistry and Metabolism",
    "dept": "FS HN",
    "num": "264",
    "desc": "Prereq: FS HN 167; CHEM 163, CHEM 163L; BIOL 211\nDigestion, absorption, metabolism, and biochemical functions of nutrients.  Biochemical aspects of nutrient deficiencies.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition for Active and Healthy Lifestyles",
    "dept": "FS HN",
    "num": "265",
    "desc": "Prereq: FS HN 167, plus credit or enrollment in BBMB 301 or credit in FS HN 264\nFundamentals of nutrient metabolism and nutrient requirements. Role of macronutrient metabolism in physical performance and disease prevention. Effect of manipulation of macronutrient metabolism on physical performance and disease prevention. Applications of nutrient metabolism principles to dietary recommendations and planning.\n",
    "credits": "3"
  },
  {
    "course_name": "Understanding Grape and Wine Science",
    "dept": "FS HN",
    "num": "276",
    "desc": "Prereq: High school biology and chemistry.\nA scientific introduction to viticulture (grape-growing) and enology (wine-making).  Topics include grape species and varieties, viticulture practices, fruit quality, geography, history, principles of fermentation and aging, wine classification, appreciation, evaluation, storage and service, regulations, wine as food.  No wine tasting.\n",
    "credits": "3"
  },
  {
    "course_name": "Dairy Products: Current Issues and Controversies",
    "dept": "FS HN",
    "num": "308",
    "desc": "\nCourse will address milk chemistry, microbiology, handling, processing, regulations, organic production, and nutrition; dispel myths about dairy foods; improve critical thinking and communication skills.  Students will participate in structured controversies.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Chemistry",
    "dept": "FS HN",
    "num": "311",
    "desc": "Prereq: ENGL 250; CHEM 231 or CHEM 331; credit or enrollment in BBMB 301\nThe structure, properties, and chemistry of food constituents and animal and plant commodities.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Chemistry Laboratory",
    "dept": "FS HN",
    "num": "311L",
    "desc": "Prereq: Credit or concurrent enrollment in FSHN 311.\nThe laboratory practices of structure, properties, and chemistry of food constituents.\n",
    "credits": "1"
  },
  {
    "course_name": "Foundations of Culinary Food Science",
    "dept": "FS HN",
    "num": "314",
    "desc": "\nIntroduction to the roles culinary scientists hold within industry including product development, research, and quality assurance.  Discussions focused on professional and educational development, enhancement of communication skills, ethics and emerging issues and trends in culinary science.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Development for Food Science Majors",
    "dept": "FS HN",
    "num": "315",
    "desc": "Prereq: Food Science major with at least a junior level status\nPreparation for internships and careers in Food Science. Importance of soft skills and application of those skills to potential job situations.\n",
    "credits": "2"
  },
  {
    "course_name": "Foundations of Dietetic Practice",
    "dept": "FS HN",
    "num": "340",
    "desc": "Prereq: DIET or PDEX classification\nIntroduction to the profession of dietetics and responsibilities associated with dietetic professional practice. Emphasis on exploring career options in dietetics and preparation for a dietetic internship. Leadership and professional career development for the dietitian is addressed through self reflection, creation of materials for post-baccalaureate programs and job shadowing experience. Professional issues related to dietetic practice include Code of Ethics, legal credentialing and standards of professional practice, leadership and future trends in the profession.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "World Food Issues: Past and Present",
    "dept": "FS HN",
    "num": "342",
    "desc": "Prereq: Junior classification\nIssues associated with global agricultural and food systems including ethical, social, economic, environmental, and policy contexts. Investigation of various causes and consequences of overnutrition/undernutrition, poverty, hunger, access, and distribution.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Food Engineering Concepts",
    "dept": "FS HN",
    "num": "351",
    "desc": "Prereq: MATH 160 or equivalent,  PHYS 111 or equivalent, FS HN 207 or permission of the instructor.\nMethodology for solving problems in food processing and introduction to food engineering concepts including food properties, material and energy balances, sources of energy, thermodynamics, fluid flow, heat transfer, and mass transfer.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Nutrition and the Regulation of Metabolism",
    "dept": "FS HN",
    "num": "360",
    "desc": "Prereq: ENGL 250, FS HN 265, 3 credits in biochemistry; 3 credits in physiology recommended\nPhysiological and biochemical basis for nutrient needs; assessment of nutrient deficiency and toxicity; examination of nutrient functions and the regulation of metabolism; nutrient-gene interactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Health Assessment",
    "dept": "FS HN",
    "num": "361",
    "desc": "Prereq: FS HN 265; 3 credits in statistics; 3 credits in physiology recommended\nThe assessment of nutritional status in healthy individuals. Laboratory experiences in food composition and assessment of dietary intake, body composition, and biochemical indices of nutritional status.\n",
    "credits": "2"
  },
  {
    "course_name": "Nutrition in Growth and Development",
    "dept": "FS HN",
    "num": "362",
    "desc": "Prereq: FS HN 360; credit or enrollment in a course in physiology\nMolecular, biochemical and physiological basis to understand the nutritional aspects of human development and aging. Nutrient needs and various disease states at each stage of human life cycle.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Prevention of Chronic Disease",
    "dept": "FS HN",
    "num": "364",
    "desc": "Prereq: FS HN 264 or FS HN 265 or accepted into Nursing major\nOverview of nutrients, their functions, metabolism, food sources and optimal choices for the promotion of health and wellness. Nutrition strategies for the prevention of chronic disease, including cancer, diabetes and obesity, as they apply to individuals or the wider population will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Obesity and Weight Management",
    "dept": "FS HN",
    "num": "365",
    "desc": "Prereq: BIOL 256 and BIOL 256L, or BIOL 306, or accepted into Nursing major\nMultifactorial aspects of obesity, maintenance of healthy weight, and the relationship of weight status and chronic disease prevention. Traditional and novel nutrition and exercise theories as well as current popular diet and exercise trends will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Communicating Nutrition Messages",
    "dept": "FS HN",
    "num": "366",
    "desc": "Prereq: FS HN 264 or FS HN 265\nTheory and application of adult learning and behavior change as it relates to the role of nutrition in health promotion and disease prevention.  Discussion of nutrition education and interventions relative to various models. Factors to consider in developing the nutrition education/intervention practicum experience. Focus on communication strategies for providing nutrition messages to diverse community audiences using various forms of media and outreach (print, radio, TV, newspaper, consumer publications, websites, community venues).  Development of nutrition messages using various forms of media for a target population.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Terminology for Health Professionals",
    "dept": "FS HN",
    "num": "367",
    "desc": "\nAn independent course focused on medical terminology, abbreviations, and simple clinical mathematical calculations. (offered online only).\n",
    "credits": "1"
  },
  {
    "course_name": "Food Laws and Regulations",
    "dept": "FS HN",
    "num": "403",
    "desc": "Prereq: 3 credits in food science coursework at 200 level or above\nHistory of food law in the US and the world. Relationship between policy, legislation and regulation. Introduction to primary US regulatory agencies and enforcement principles. Discussion of key laws related to food safety and nutrition. Overview of federal and independent research tools and sources of food law.\n",
    "credits": "2"
  },
  {
    "course_name": "Food Quality Assurance",
    "dept": "FS HN",
    "num": "405",
    "desc": "Prereq: FS HN 214 or FS HN 311; STAT 101 or STAT 104\nFundamentals of food quality management programs and the establishment of decision-making processes. Emphasis on  statistical process and quality control procedures and their applications to food systems. Development  of procedures, specifications, grades, and standards (government and industry) to determine the quality of foods in the marketplace.\n",
    "credits": "2"
  },
  {
    "course_name": "Sensory Evaluation of Food",
    "dept": "FS HN",
    "num": "406",
    "desc": "Prereq: FS HN 214 or FS HN 311 or AN S 360; 3 credits in statistics\nSensory evaluation techniques used to evaluate the appearance, aroma, flavor, texture and acceptability of foods. Relationships between sensory and instrumental measurements of color and texture. Work independently and cooperatively (in a team) to identify sensory evaluation objectives, write hypotheses, design and conduct experiments, and analyze and interpret data.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbiological Safety of Foods of Animal Origins",
    "dept": "FS HN",
    "num": "407",
    "desc": "Prereq: MICRO 420\nExamination of the various factors in the production of foods, from production through processing, distribution and final consumption which contribute to the overall microbiological safety of the food. Upon successful completion of this class, the student will receive both the Preventive Controls for Human Foods certificate (FDA program) and the International HACCP Alliance certificate (USDA-FSIS program).\n",
    "credits": "3"
  },
  {
    "course_name": "Dairy Products Evaluation",
    "dept": "FS HN",
    "num": "408",
    "desc": "Prereq: Permission of instructor\nGain experience in identifying quality defects in dairy products including milk, cottage cheese, cheddar cheese, strawberry yogurt, butter, and vanilla ice cream. Intensive training for the National Collegiate Dairy Products Evaluation competition and for dairy product evaluation in the food industry.\n",
    "credits": "1"
  },
  {
    "course_name": "Food Analysis",
    "dept": "FS HN",
    "num": "410",
    "desc": "Prereq: FS HN 214 or FS HN 311 or CHEM 211\nAn introduction to the theory and application of chemical and instrumental methods for determining the constituents of food. Use of standard procedures for food analysis and food composition data bases.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Ingredient Interactions and Formulations",
    "dept": "FS HN",
    "num": "411",
    "desc": "Prereq: FSHN 214 or FS HN 311 and FS HN 115, FS HN 215 or FS HN 311L.\nApplication of food science principles to ingredient substitutions in food products.  Laboratory procedures for standard formulations and instrumental evaluation, with emphasis on problem-solving and critical thinking.\n",
    "credits": "2"
  },
  {
    "course_name": "Food Product Development",
    "dept": "FS HN",
    "num": "412",
    "desc": "Prereq: FS HN 311 or FS HN 411; senior classification\nPrinciples of developing consumer packaged food products. Application of skills gained in food chemistry, formulation, quality, sensory and processing. Some pilot plant experiences. Emphasis on teamwork and effective communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Foodborne Hazards",
    "dept": "FS HN",
    "num": "419",
    "desc": "Prereq: MICRO 201 or MICRO 302, a course in biochemistry\nPathogenesis of human microbiological foodborne infections and intoxications, principles of toxicology, major classes of toxicants in the food supply, governmental regulation of foodborne hazards. Assessed service learning component.\n  Only one of FS HN 419 and FS HN 519 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Food Microbiology",
    "dept": "FS HN",
    "num": "420",
    "desc": "Prereq: MICRO 201 or MICRO 302\nEffects of microbial growth in foods. Methods to control, detect, and enumerate microorganisms in food and water. Foodborne infections and intoxications.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Microbiology Laboratory",
    "dept": "FS HN",
    "num": "421",
    "desc": "Prereq: MICRO 201 or MICRO 302; MICRO 201L or MICRO 302L. Credit or enrollment in FS HN/MICRO 420\nStandard techniques used for the microbiological examination of foods. Independent and group projects on student-generated questions in food microbiology. Emphasis on oral and written communication and group interaction.\n",
    "credits": "3"
  },
  {
    "course_name": "Issues in Food and Society",
    "dept": "FS HN",
    "num": "442",
    "desc": "Prereq: FS HN 242, FS HN 342\nIn-depth discussion, synthesis, and analysis of domestic and international food issues including: food systems from farm to fork, poverty and world hunger, overnutrition, population, agriculture and the environment, ethics, biotechnology, and policy.\n",
    "credits": "2"
  },
  {
    "course_name": "Global Nutrition",
    "dept": "FS HN",
    "num": "460",
    "desc": "\nAn overview of global nutrition issues, including the sociocultural, biological, economic, and environmental context of nutrition related topics. The etiology, epidemiology, and program/policy responses to issues will be presented. Areas to be covered include childhood malnutrition, growth stunting, micronutrient deficiencies, parasites and nutrition, sanitation, and obesity and chronic disease incidence in developing countries.  Participatory course, students will engage in a series of class activities, discussions, and presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Nutrition and Disease I",
    "dept": "FS HN",
    "num": "461",
    "desc": "Prereq: FS HN 360, FS HN 361, FS HN 367; plus BIOL 256 and 256L or BIOL 306 or BIOL 335\n(Dual-listed with NUTRS 561) Pathophysiology of selected chronic disease states and their associated medical problems. Specific attention will be directed to medical nutrition needs of patients in the treatment of each disease state.\n",
    "credits": "4"
  },
  {
    "course_name": "Community Nutrition",
    "dept": "FS HN",
    "num": "463",
    "desc": "Prereq: FS HN 265 or FS HN 360; FS HN 366 recommended\nDual-listed with NUTRS 563. Survey of current public health nutrition problems among nutritionally vulnerable individuals and groups. Discussion of the multidimensional nature of those problems and of community programs addressing them. Grant writing as a means for funding community nutrition program development. Significant emphasis on written and oral communication at the lay and professional level.  Field trip.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Nutrition and Disease II",
    "dept": "FS HN",
    "num": "464",
    "desc": "Prereq: FS HN 461\n(Dual-listed with NUTRS 564) Pathophysiology of selected acute and chronic disease states and their associated medical problems. Specific attention will be directed to medical nutrition needs of patients in the treatment of each disease state.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition Counseling and Education Methods",
    "dept": "FS HN",
    "num": "466",
    "desc": "Prereq: FS HN 361 and FS HN 362\nApplication of counseling and learning theories with individuals and groups in community and clinical settings. Includes discussion and experience in building rapport, assessment, diagnosis, intervention, monitoring, evaluation, and documentation. Literature review of specific counseling and learning theories.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Basis of Nutrition in the Development, Prevention, and Treatment of Disease",
    "dept": "FS HN",
    "num": "467",
    "desc": "Prereq: FS HN 360 or equivalent\nUnderstanding the molecular basis for the role of nutrients, nutrient-derivatives, and bioactive compounds in the development, prevention, and treatment of common diseases including diabetes, cancer, vascular disease, obesity, neurological disease, aberrant mineral metabolism, and autoimmune disease. Translating this understanding into practical approaches for improving the health of individuals and populations.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Processing",
    "dept": "FS HN",
    "num": "471",
    "desc": "Prereq: FS HN 351 or A E 451 or CH E 357; MICRO 201 or 302.\nPrinciples and application of food processing using both thermal (ex., blanching, pasteurization, canning, drying, freezing, evaporation, aseptic processing, extrusion) and non-thermal (ex., high pressure, irradiation, pulsed electric field, fermentation) unit operations. Emphasis on microbial inactivation, process heat and mass balance, and numerical problem solving.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Processing Laboratory",
    "dept": "FS HN",
    "num": "472",
    "desc": "Prereq: Credit or enrollment in FS HN 471 or A E 451 or CH E 357\nHands-on and demonstration laboratory activities related to food processing principles and applications using lab and pilot-scale equipment. Laboratory experiences include important food processing operations, e.g., blanching/ pasteurization, canning, freezing, drying, corn wet milling, fermentation, baking etc. Emphasis on mass balance, interpreting data, writing reports, and presentations. Occasional field trips.\n",
    "credits": "2"
  },
  {
    "course_name": "Professional Communication in Food Science and Human Nutrition",
    "dept": "FS HN",
    "num": "480",
    "desc": "Prereq: FS HN 203, senior classification in the department\nPresentation of current topics using written and oral communication to a lay audience.  Emphasis on communication skills for the profession.\n",
    "credits": "1"
  },
  {
    "course_name": "Issues in Food Safety",
    "dept": "FS HN",
    "num": "489",
    "desc": "Prereq: Credit or enrollment in FS HN 101 or FS HN 272 or HSP M 233; FS HN 419 or FS HN 420; FS HN 403\nCapstone seminar for the food safety minor. Case discussions and independent projects about safety issues in the food system from a multidisciplinary perspective.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "FS HN",
    "num": "490",
    "desc": "Prereq: Permission of instructor\nIndependent work in food science, nutrition, or dietetics.\n  A maximum of 6 credits of FS HN 490 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Dietetics",
    "dept": "FS HN",
    "num": "490A",
    "desc": "Prereq: Permission of instructor\nIndependent work in food science, nutrition, or dietetics.\n  A maximum of 6 credits of FS HN 490 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Food Science",
    "dept": "FS HN",
    "num": "490B",
    "desc": "Prereq: Permission of instructor\nIndependent work in food science, nutrition, or dietetics.\n  A maximum of 6 credits of FS HN 490 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Nutrition",
    "dept": "FS HN",
    "num": "490C",
    "desc": "Prereq: Permission of instructor\nIndependent work in food science, nutrition, or dietetics.\n  A maximum of 6 credits of FS HN 490 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: International Experience",
    "dept": "FS HN",
    "num": "490D",
    "desc": "Prereq: Permission of instructor\nIndependent work in food science, nutrition, or dietetics.\n  A maximum of 6 credits of FS HN 490 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "FS HN",
    "num": "490E",
    "desc": "Prereq: Permission of instructor\nIndependent work in food science, nutrition, or dietetics.\n  A maximum of 6 credits of FS HN 490 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "FS HN",
    "num": "490H",
    "desc": "Prereq: Permission of instructor\nIndependent work in food science, nutrition, or dietetics.\n  A maximum of 6 credits of FS HN 490 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience",
    "dept": "FS HN",
    "num": "491",
    "desc": "Prereq: Advance approval of instructor and adviser\nSupervised off-campus work experience relevant to the academic major.\n  Offered on a satisfactory-fail basis only.  A maximum of 4 credits of FS HN 491 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience: Dietetics",
    "dept": "FS HN",
    "num": "491A",
    "desc": "Prereq: Advance approval of instructor and adviser\nSupervised off-campus work experience relevant to the academic major.\n  Offered on a satisfactory-fail basis only.  A maximum of 4 credits of FS HN 491 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience: Food Science",
    "dept": "FS HN",
    "num": "491B",
    "desc": "Prereq: Advance approval of instructor and adviser\nSupervised off-campus work experience relevant to the academic major.\n  Offered on a satisfactory-fail basis only.  A maximum of 4 credits of FS HN 491 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience: Nutrition",
    "dept": "FS HN",
    "num": "491C",
    "desc": "Prereq: Advance approval of instructor and adviser\nSupervised off-campus work experience relevant to the academic major.\n  Offered on a satisfactory-fail basis only.  A maximum of 4 credits of FS HN 491 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Supervised Work Experience: Culinary Science",
    "dept": "FS HN",
    "num": "491D",
    "desc": "Prereq: Advance approval of instructor and adviser\nSupervised off-campus work experience relevant to the academic major.\n  Offered on a satisfactory-fail basis only.  A maximum of 4 credits of FS HN 491 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Research Concepts in Human Nutrition",
    "dept": "FS HN",
    "num": "492",
    "desc": "Prereq: senior classification or permission of instructor; FS HN 360\nStudents will develop and implement research projects with faculty supervision, based on knowledge gained from nutrition, biology and chemistry courses. Students will prepare a research proposal, conduct research and report results.  Students will gain appreciation for independent research and experience creative and innovative aspects of nutrition research.\n",
    "credits": "2"
  },
  {
    "course_name": "Food Preparation Workshop",
    "dept": "FS HN",
    "num": "493",
    "desc": "\nSelected topics in food preparation including scientific principles, culture and culinary techniques. Variable format may include laboratory, recitation, and lecture.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Practicum",
    "dept": "FS HN",
    "num": "495",
    "desc": "Prereq: Senior classification in Nutritional Science-Nutrition and Wellness option or permission of instructor; FS HN 366; credit or enrollment in FS HN 463.\nStudents will develop, implement and assess a community-based project that engages groups in learning and practicing concepts related to nutrition and wellness. Assessed service learning component.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Food Science and Human Nutrition Travel Course",
    "dept": "FS HN",
    "num": "496",
    "desc": "Prereq: Permission of instructor\n(One credit per week traveled and 1 credit for pre-departure class, if offered.) Limited enrollment. Tour and study of food industry, culinary science, dietetic and nutritional agencies in different regions of the world. Pre-travel session arranged. Travel expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "Food Science and Human Nutrition Travel Course: International travel",
    "dept": "FS HN",
    "num": "496A",
    "desc": "Prereq: Permission of instructor\n(One credit per week traveled.) Limited enrollment. Tour and study of food industry, dietetic and nutritional agencies in different regions of the world. Pre-travel session arranged. Travel expenses paid by students.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Food Science and Human Nutrition Travel Course: Domestic travel",
    "dept": "FS HN",
    "num": "496B",
    "desc": "Prereq: Permission of instructor\n(One credit per week traveled.) Limited enrollment. Tour and study of food industry, dietetic and nutritional agencies in different regions of the world. Pre-travel session arranged. Travel expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "FS HN",
    "num": "498",
    "desc": "Prereq: Permission of department chair.\nRequired for students completing professional work periods in a cooperative education program. Students must register prior to commencing each work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "FS HN",
    "num": "499",
    "desc": "Prereq: Permission of staff member with whom student proposes to work\nResearch under staff guidance.\n  A maximum of 6 credits of FS HN 499 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Food Quality Assurance",
    "dept": "FS HN",
    "num": "505",
    "desc": "Prereq: FS HN 214 or FS HN 311; STAT 101 or STAT 104\nFundamentals of food quality management programs and the establishment of decision-making processes. Emphasis on  statistical process and quality control procedures and their applications to food systems. Development  of procedures, specifications, grades, and standards (government and industry) to determine the quality of foods in the marketplace.\n",
    "credits": "2"
  },
  {
    "course_name": "Sensory Evaluation of Food",
    "dept": "FS HN",
    "num": "506",
    "desc": "Prereq: FS HN 214 or FS HN 311 or AN S 360; 3 credits in statistics\nSensory evaluation techniques used to evaluate the appearance, aroma, flavor, texture and acceptability of foods. Relationships between sensory and instrumental measurements of color and texture. Work independently and cooperatively (in a team) to identify sensory evaluation objectives, write hypotheses, design and conduct experiments, and analyze and interpret data.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbiological Safety of Foods of Animal Origins",
    "dept": "FS HN",
    "num": "507",
    "desc": "Prereq: MICRO 420\nExamination of the various factors in the production of foods, from production through processing, distribution and final consumption which contribute to the overall microbiological safety of the food. Upon successful completion of this class, the student will receive both the Preventive Controls for Human Foods certificate (FDA program) and the International HACCP Alliance certificate (USDA-FSIS program).\n",
    "credits": "3"
  },
  {
    "course_name": "Sensory Evaluation of Wines",
    "dept": "FS HN",
    "num": "509",
    "desc": "Prereq: Must be at least 21 years of age; senior or graduate status.\nPrinciples of sensory evaluation and their application to wine evaluation. Sensory testing methods such as discrimination tests, ranking, descriptive analysis and scoring of wines will be covered. Students will have the opportunity to evaluate and learn about major types and styles of wines of the world. Lab fee.\n",
    "credits": "2"
  },
  {
    "course_name": "Integrated Food Science",
    "dept": "FS HN",
    "num": "511",
    "desc": "Prereq: 3 credits in each of organic chemistry, physics, mathematics, and microbiology.\nCritical review of the key principles of food science and applications in the chemistry, microbiology, and processing of food. Understanding of the impact of processing on the quality of foods with respect to composition, quality and safety.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Product Development",
    "dept": "FS HN",
    "num": "512",
    "desc": "Prereq: FS HN 311 or FS HN 411; senior classification\nPrinciples of developing consumer packaged food products. Application of skills gained in food chemistry, formulation, quality, sensory and processing. Some pilot plant experiences. Emphasis on teamwork and effective communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Nutrition I",
    "dept": "FS HN",
    "num": "516",
    "desc": "Prereq: Acceptance in the Master’s of Professional Practice in Dietetics program.\nExamination of current literature relative to molecular, cellular, and physiologic aspects of macronutrient and micronutrient metabolism.  Integration of current evidence-based information, including peer-reviewed literature, to inform advanced professional nutrition practice.\n",
    "credits": "2"
  },
  {
    "course_name": "Gut Microbiome: Implications for Health and Diseases",
    "dept": "FS HN",
    "num": "517",
    "desc": "Prereq: Basic Knowledge in microbiology\nExplore current research on gut microbiome including modern tools used to study the gut microbiome. Examine the linkages between gut microbiome and health status, diseases, and manipulation of gut microbiome to improve health.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Nutrition II",
    "dept": "FS HN",
    "num": "518",
    "desc": "Prereq: Acceptance in the Master’s of Professional Practice in Dietetics program.\nPrinciples of research design/methods and interpreting results/statistics in the current peer-reviewed scientific literature. Critical evaluation of the evidence-base to inform advanced professional nutrition practice.\n",
    "credits": "2"
  },
  {
    "course_name": "Microbiology of Food",
    "dept": "FS HN",
    "num": "521",
    "desc": "Prereq: A course in microbiology with laboratory; enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nThis course deals with the identification, enumeration, and characterization of bacteria, yeasts, and mold associated with foods and food processing.  Effects of physical and chemical agents on micro-organisms will be studied.  Microbiological problems in food spoilage, food preservation, food fermentation, and food-borne disease will be discussed.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Food Microbiology and Biotechnology",
    "dept": "FS HN",
    "num": "522",
    "desc": "Prereq: Food microbiology, a course in biochemistry; enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nThis course will cover basic principles in biotechnology and applied food microbiology, including current topics of interest in food biotechnology.  Students will be introduced to recombinant DNA techniques and how they are applied to genetically modify microorganisms, the use of nucleic acids as tools of rapid detection of microorganisms in foods, basic enzyme immobilization and down-stream processing techniques, and regulatory aspects of food biotechnology.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "A Multidisciplinary Overview of Food Safety and Security",
    "dept": "FS HN",
    "num": "523",
    "desc": "Prereq: A course in biology or chemistry; enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nMultidisciplinary food safety and security perspectives provided by numerous subject matter experts.  Topics include food safety policy, ag bioterrorism, border security, animal ID, food defense and site security, risk analysis, crisis communication, epidemiology, HACCP, and more.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Food Microbiology",
    "dept": "FS HN",
    "num": "524",
    "desc": "Prereq: A course in microbiology with laboratory; enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nFood Microbiology looks at the nature, physiology, and interactions of microorganisms in foods.  The course is an introduction to food-borne diseases, the effect of food processing systems on the microflora of foods, principles of food preservation, food spoilage, and foods produced by microorganisms.  Additionally, the course looks at food plant sanitation and criteria for establishing microbial standards for food products.  Offered online only.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of HACCP",
    "dept": "FS HN",
    "num": "525",
    "desc": "Prereq: Undergraduate biology and chemistry courses;enrollment in GP-IDEA Food Safety and Defense Certificate or permission of instructor.\nA comprehensive study of the Hazard Analysis and Critical Control Point System and its application in the food industry.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Ethnic Foods: Food Safety, Food Protection and Defense",
    "dept": "FS HN",
    "num": "526",
    "desc": "Prereq: Graduate standing; enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nUnderstanding of the various factors that impact safety of ethnic and imported ethnic foods; knowledge about the handling, preparation, processing and storage of ethnic and imported foods and food products; science-based characterization of representative ethnic foods.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Microbiology of Fermented Foods",
    "dept": "FS HN",
    "num": "527",
    "desc": "Prereq: Food microbiology; enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nMicrobiology of fermented foods covers the physiology, biochemistry, and genetics of microorganisms important in food fermentations.  The course looks at how microorganisms are used in fermentations and the effects of processing and manufacturing conditions on production of fermented foods.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Food Protection and Defense-Essential Concepts",
    "dept": "FS HN",
    "num": "528",
    "desc": "Prereq: Enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nThis course will provide students with an understanding of the principles required in a food defense program for a food manufacturing, warehousing or distribution center.  The topics covered include: defining threats and aggressors; the Bioterrorism Act; food defense teams; vulnerability assessments; security programs; recall and traceability basics; security inspections; crisis management; emergency preparedness; and workplace violence.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Foodborne Toxicants",
    "dept": "FS HN",
    "num": "529",
    "desc": "Prereq: A course in biochemistry; enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nMechanisms of action, metabolism, sources, remediation/detoxification, risk assessment of major foodborne toxicants of current interest, design of HAACP plans for use in food industries targeting foodborne toxicants, discussion of toxicants from a food defense perspective.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Medical Nutrition Therapy",
    "dept": "FS HN",
    "num": "538",
    "desc": "Prereq: Acceptance in the Master’s of Professional Practice in Dietetics program.\nNutritional biochemistry and physiology related to selected pathophysiology of disease with emphasis on treatment of complex medical problems. The nutrition care process will be utilized. Evidenced-based practice will be integrated into each disease state covered. Offered WWW only.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "FS HN",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "FS HN",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "FS HN",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "FS HN",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "FS HN",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "FS HN",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "FS HN",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "FS HN",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Dietetic Internship I",
    "dept": "FS HN",
    "num": "554",
    "desc": "\nFor students enrolled in the Dietetic Internship program only.  Supervised practice experience in operational management, medical nutrition therapy and community nutrition. Capstone research project. Experiences and activities designed to meet accreditation standards.\n",
    "credits": "5"
  },
  {
    "course_name": "Dietetic Internship II",
    "dept": "FS HN",
    "num": "555",
    "desc": "Prereq: Concurrent enrollment or successful completion of FS HN 554\nFor students enrolled in the Dietetic Internship program only.  Supervised practice experience in operational management, medical nutrition therapy and community nutrition. Capstone research project.  Experiences and activities designed to meet accreditation standards.\n",
    "credits": "5"
  },
  {
    "course_name": "Dietetic Internship III",
    "dept": "FS HN",
    "num": "556",
    "desc": "Prereq: Concurrent enrollment or successful completion of FS HN 554 and FS HN 555\nFor students enrolled in the Dietetic Internship program only.  Supervised practice experience in operational management, medical nutrition therapy and community nutrition. Capstone research project.  Experiences and activities designed to meet accreditation standards.\n",
    "credits": "5"
  },
  {
    "course_name": "Global Nutrition",
    "dept": "FS HN",
    "num": "560",
    "desc": "\nAn overview of global nutrition issues, including the sociocultural, biological, economic, and environmental context of nutrition related topics. The etiology, epidemiology, and program/policy responses to issues will be presented. Areas to be covered include childhood malnutrition, growth stunting, micronutrient deficiencies, parasites and nutrition, sanitation, and obesity and chronic disease incidence in developing countries.  Participatory course, students will engage in a series of class activities, discussions, and presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition Counseling and Education Methods",
    "dept": "FS HN",
    "num": "566",
    "desc": "Prereq: FS HN 361 and FS HN 362\nApplication of counseling and learning theories with individuals and groups in community and clinical settings. Includes discussion and experience in building rapport, assessment, diagnosis, intervention, monitoring, evaluation, and documentation. Literature review of specific counseling and learning theories.\n",
    "credits": "3"
  },
  {
    "course_name": "Processed Foods",
    "dept": "FS HN",
    "num": "575",
    "desc": "Prereq: FS HN 214 or FS HN 311; a course in nutrition\nThis course will examine effect of industrial and domestic food processing on the nutrient content of food and risk of developing chronic disease.\n",
    "credits": "3"
  },
  {
    "course_name": "Orientation to Food Science and Nutrition Research",
    "dept": "FS HN",
    "num": "580",
    "desc": "\nOrientation to and discussion of research interests in food science and nutrition. Discussion of policy and ethical issues in the conduct of research. Intended for entering students in FS HN.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "FS HN",
    "num": "581",
    "desc": "\nDiscussion and practice of oral presentation of scientific data in a professional setting. Discussion of issues related to data presentation. Intended for graduate students in their first or second semester in FS HN.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "FS HN",
    "num": "590",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Nutrition",
    "dept": "FS HN",
    "num": "590A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Food Science",
    "dept": "FS HN",
    "num": "590B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Teaching",
    "dept": "FS HN",
    "num": "590C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Grant Writing for the Professional",
    "dept": "FS HN",
    "num": "595",
    "desc": "Prereq: enrollment in GP-IDEA MFCS in Dietetics\nGrant writing, identifying external funding, managing grants, preparing manuscripts for peer-reviewed publication, and preparing papers and poster for presentation at professional meetings.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Science and Human Nutrition Travel Course: International travel",
    "dept": "FS HN",
    "num": "596A",
    "desc": "Prereq: Permission of instructor\n(One credit per week traveled.) Limited enrollment. Tour and study of food industry, dietetic and nutritional agencies in different regions of the world. Pre-travel session arranged. Travel expenses paid by students.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Food Science and Human Nutrition Travel Course: Domestic travel",
    "dept": "FS HN",
    "num": "596B",
    "desc": "Prereq: Permission of instructor\n(One credit per week traveled.) Limited enrollment. Tour and study of food industry, dietetic and nutritional agencies in different regions of the world. Pre-travel session arranged. Travel expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "Nutritional Aspects of Oncology",
    "dept": "FS HN",
    "num": "597",
    "desc": "Prereq: B.S. in nutrition, dietetics, biology, or related discipline.\nUnderstanding of basic cancer biology and methodology used to study nutrition and cancer relationships. Using current research as a basis, the role of nutrition in specific cancers will be explored. Students will learn about sources of information for cancer prevention programs, and how to apply this information to clinical patient management.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "FS HN",
    "num": "599",
    "desc": "\nNonthesis option only.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Food Analysis and Instrumentation",
    "dept": "FS HN",
    "num": "606",
    "desc": "Prereq: FS HN 311, or FS HN 410, or FS HN 511 or equivalent.\nInstrumental methods for measuring chemical and physical properties of foods, food quality and functionality. Techniques for methods development, sample preparation, optimization of operating conditions, and data analysis needed to obtain accurate, reproducible results by means of instrumentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Food Processing",
    "dept": "FS HN",
    "num": "611",
    "desc": "Prereq: FS HN 311, or FS HN 471/472 or equivalent, or FS HN 511.\nRecent advances in the science and technology of food processing and preservation; examples include both thermal and non-thermal processes, including cold plasma, nanotechnology, food packaging, and extrusion. Advances in extraction and separation technologies, waste management, by-product utilization, biorenewables and sustainability in food processing industry will also be discussed. Students to research on select topics and present.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Food Chemistry",
    "dept": "FS HN",
    "num": "612",
    "desc": "Prereq: FS HN 311, or FS HN 411, or FS HN 511, or BBMB 404, or equivalent.\nStructure, chemical and physical properties of lipids, proteins and carbohydrates, and their food and industrial applications. Changes in functionalities during processing and storage.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Food Microbiology",
    "dept": "FS HN",
    "num": "626",
    "desc": "Prereq: FS HN 420 or FS HN 421 or FS HN 504\nTopics of current interest in food microbiology, including new foodborne pathogens, rapid identification methods, effect of food properties and new preservation techniques on microbial growth, and mode of action of antimicrobials.\n",
    "credits": "3"
  },
  {
    "course_name": "Rapid Methods in Food Microbiology",
    "dept": "FS HN",
    "num": "627",
    "desc": "Prereq: FS HN 420 or FS HN 421 or FS HN 504\nProvides an overview of rapid microbial detection methods for use in foods. Topics include historical aspects of rapid microbial detection, basic categories of rapid tests (phenotypic, genotypic, whole cell, etc.), existing commercial test formats and kits, automation in testing, sample preparation and \"next generation\" testing formats now in development.\n",
    "credits": "2"
  },
  {
    "course_name": "Seminar",
    "dept": "FS HN",
    "num": "681",
    "desc": "\nPresentation of thesis or dissertation research. Must be taken once for each graduate program; once for the M.S. program and once for the Ph.D. program.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar Reflection",
    "dept": "FS HN",
    "num": "682",
    "desc": "\nActive listening and critical thinking activities related to research seminars in food science and human nutrition. Required each semester for all FSHN graduate students. Electronic documentation.\n",
    "credits": "R"
  },
  {
    "course_name": "Special Problems",
    "dept": "FS HN",
    "num": "690",
    "desc": "Prereq: FS HN 502 or FS HN 503 or FS HN 504 or FS HN 553 or FS HN 554\n",
    "credits": "arr"
  },
  {
    "course_name": "Grant Proposal Writing",
    "dept": "FS HN",
    "num": "695",
    "desc": "Prereq: 3 credits of graduate course work in food science and/or nutritional sciences\nGrant proposal preparation experiences including writing and critiquing of proposals and budget planning. Formation of grant writing teams in food science and/or nutritional sciences. Discussion of the role of successful grant writing in career development.\n",
    "credits": "1"
  },
  {
    "course_name": "Research in Food Science and Technology",
    "dept": "FS HN",
    "num": "699",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Forest Biology",
    "dept": "FOR",
    "num": "201",
    "desc": "Prereq: Concurrent enrollment in FOR 202, FOR 203, FOR 204, FOR 205, and FOR 206\nDiscussion of ecological concepts, individual tree structure and growth, variation and diversity in tree populations. Physical environment of trees and forests, ecological processes in forest communities, and introduction to different regional forest communities.\n",
    "credits": "2"
  },
  {
    "course_name": "Sustainable Materials: Wood Utilization",
    "dept": "FOR",
    "num": "202",
    "desc": "Prereq: Concurrent enrollment in FOR 201, FOR 203, FOR 204, FOR 205, and FOR 206\nBasis for use of wood as an industrial raw material for lumber, composites, pulp and paper, energy and chemicals. Implications of use of alternative renewable and non-renewable materials for societal infrastructure and consumer goods.\n",
    "credits": "2"
  },
  {
    "course_name": "Resource Measurements/Evaluation",
    "dept": "FOR",
    "num": "203",
    "desc": "Prereq: Concurrent enrollment in FOR 201, FOR 202, FOR 204, FOR 205, and FOR 206; MATH 140\nSurvey techniques involved in quantification, valuation, and evaluation of tree and stand growth and other variables in the forest environment (e.g., recreational use, wildlife habitat value, biomass, and solid wood).\n",
    "credits": "2"
  },
  {
    "course_name": "Forest Ecosystem Decision-Making",
    "dept": "FOR",
    "num": "204",
    "desc": "Prereq: Concurrent enrollment in FOR 201, FOR 202, FOR 203, FOR 205, and FOR 206\nMethods of decision-making related to forest ecosystems including communications, teams and conflict resolution. Current issues relating to public, private, and urban forests; quantification of processes, services, and goods produced by the forest and expected by the public such as wildlife, water, range, recreation, wilderness, biodiversity, as well as wood and fiber products.\n",
    "credits": "2"
  },
  {
    "course_name": "Integrated Forestry Laboratory",
    "dept": "FOR",
    "num": "205",
    "desc": "Prereq: Concurrent enrollment in FOR 201, FOR 202, FOR 203, FOR 204, and FOR 206\nField and laboratory exercises integrating the evaluation and management of forest goods, services, and the processing of wood products.\n",
    "credits": "3"
  },
  {
    "course_name": "Fall Forestry Camp",
    "dept": "FOR",
    "num": "206",
    "desc": "Prereq: Concurrent enrollment in FOR 201, FOR 202, FOR 203, FOR 204, and FOR 205\nThree-week field camp to address topics and issues covered in 201, 202, 203, 204, and 205.\n",
    "credits": "4"
  },
  {
    "course_name": "Wood Properties and Identification",
    "dept": "FOR",
    "num": "280",
    "desc": "\nProperties of wood and how they relate to its successful use. Comparative anatomical characteristics, scientific nomenclature, and hand lens identification of commercially important North American woods.\n",
    "credits": "4"
  },
  {
    "course_name": "Pesticide Application Certification",
    "dept": "FOR",
    "num": "283",
    "desc": "\nCore background and specialty topics in agricultural, and horticultural pesticide applicator certification. Students can select certification categories and have the opportunity to obtain pesticide applicator certification at the completion of the course. Commercial pesticide applicator certification is emphasized.\n",
    "credits": "2"
  },
  {
    "course_name": "Special Problems",
    "dept": "FOR",
    "num": "290",
    "desc": "Prereq: Freshman or Sophomore classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Problems: Leadership in Forestry Teams (LIFT) Learning Community",
    "dept": "FOR",
    "num": "290A",
    "desc": "Prereq: Freshman or Sophomore classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Problems: Forest Ecosystem Management",
    "dept": "FOR",
    "num": "290B",
    "desc": "Prereq: Freshman or Sophomore classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Problems: Natural Resource Conservation",
    "dept": "FOR",
    "num": "290C",
    "desc": "Prereq: Freshman or Sophomore classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Problems: Urban and Community Forestry",
    "dept": "FOR",
    "num": "290D",
    "desc": "Prereq: Freshman or Sophomore classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Problems: Wood Science and Technology",
    "dept": "FOR",
    "num": "290E",
    "desc": "Prereq: Freshman or Sophomore classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Silviculture",
    "dept": "FOR",
    "num": "302",
    "desc": "Prereq: FOR 201, FOR 356, NREM 301\nManipulation of forest vegetation based on ecological principles for the production of goods and services.\n",
    "credits": "4"
  },
  {
    "course_name": "Dendrology",
    "dept": "FOR",
    "num": "356",
    "desc": "Prereq: BIOL 211\nIdentification and ecology of North American woody plant species. Importance of woody plants in timber production and wildlife habitat. Historical conditions of North American forest regions will also be addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Forest Herbaceous Layer: Ecology and Identification.",
    "dept": "FOR",
    "num": "358",
    "desc": "Prereq: BIOL 212\nSurvey of the major plant families, general, and representative species of the forest herbaceous layer. Functional ecology and restoration.\n",
    "credits": "1"
  },
  {
    "course_name": "Forest Insects and Diseases",
    "dept": "FOR",
    "num": "416",
    "desc": "Prereq: 8 credits in biological sciences, including BIOL 211 or equivalent.\nNature of insects and pathogens of forest and shade trees; their role in the dynamics of natural and     managed forest ecosystems; and the management of indigenous and exotic pests.\n",
    "credits": "3"
  },
  {
    "course_name": "Forest Insects and Diseases Laboratory",
    "dept": "FOR",
    "num": "416L",
    "desc": "Prereq: 8 credits in biological sciences, including BIOL 211 or equivalent. Credit or enrollment in PL P 416.\nLaboratory experience working with insect and fungal pests of trees.\n",
    "credits": "1"
  },
  {
    "course_name": "Dynamics of Forest Stands",
    "dept": "FOR",
    "num": "442",
    "desc": "Prereq: NREM 301, FOR 302, STAT 101 or their equivalents\nChange in forest species composition and structure at the stand and landscape scales resulting from site quality, tree growth, competition, succession, and disturbance. Methods for assessing tree growth and reconstructing past stand development. Applications to forest and savanna management.\n",
    "credits": "3"
  },
  {
    "course_name": "Forest Resource Economics and Quantitative Methods",
    "dept": "FOR",
    "num": "451",
    "desc": "Prereq: FOR 203, MATH 150\nApplication of economic principles to forest resource management considering both market and non-market goods and services. Methods of identifying and specifying problems in the management and use of forest resources. Application of mathematical and statistical models to the solution of managerial problems.\n",
    "credits": "4"
  },
  {
    "course_name": "Ecosystem Management",
    "dept": "FOR",
    "num": "452",
    "desc": "Prereq: Senior classification, and NREM 120 or its equivalent\nPrinciples of planning, regulating, and decision-making associated with public and private lands, with consideration of forest, grassland, wetland, and freshwater aquatic ecosystems.  Integrated natural resources management within ecological, social, economic and policy constraints.\n",
    "credits": "3"
  },
  {
    "course_name": "Forestry Practicum",
    "dept": "FOR",
    "num": "454",
    "desc": "Prereq: 20 credits in student's major at 300 level or above\nIntegrated decision-making related to the conservation, management, and preservation of private and public forests, wildlands, urban/community forests, and/or the production and utilization of wood products. Student teams work with a client and develop management plans that incorporate ecological, social, economic, ethical, and institutional/political factors. Effective teamwork, written/oral/visual communication, and problem-solving stressed. Multiple trips to project site and client.\n",
    "credits": "3"
  },
  {
    "course_name": "Urban Forestry",
    "dept": "FOR",
    "num": "475",
    "desc": "Prereq: Junior or senior classification, 3 credits in biology\nDiscussion of establishment and management of woody perennials in community-owned urban greenspaces, consideration of urban site and soil characteristics, plant physiology, plant culture, urban forest valuation, inventory methods, species selection, and urban forest maintenance (health care and pest management).\n",
    "credits": "3"
  },
  {
    "course_name": "Wood Anatomy and Fiber Analysis",
    "dept": "FOR",
    "num": "480",
    "desc": "Prereq: FOR 280 or permission of instructor\nMicroscopic anatomy and ultrastructure of wood and other industrial lignocellulosic materials. Microscopy techniques for fiber analysis. Comparison of fiber properties.\n",
    "credits": "3"
  },
  {
    "course_name": "Conversion of Lignocellulosic Materials",
    "dept": "FOR",
    "num": "481",
    "desc": "Prereq: FOR 280 or equivalent\nChemical properties of lignocellulosic materials. Wood chemistry. Various conversion processes. Pulp and paper technology. Biobased products. Other fiber products. Cellulose derivatives. Term paper and/or student project required for graduate level.\n",
    "credits": "3"
  },
  {
    "course_name": "Wood and Natural Fiber Composites",
    "dept": "FOR",
    "num": "485",
    "desc": "Prereq: FOR 280 or TSM 240\nConsolidation behavior of wood and other lignocellulosic materials.  Principles of adhesion.  Manufacturing processes for wood and lignocellulose composites such as plywood, oriented strand products, laminated lumber, particleboard, medium density fiberboard, and bast fiber products.  Extrusion processing of natural fiber/plastic composites.\n",
    "credits": "3"
  },
  {
    "course_name": "Drying Processes for Wood and Other Lignocellulosic Materials",
    "dept": "FOR",
    "num": "486",
    "desc": "Prereq: FOR 280 or TSM 240\nPrinciples of moisture relations in hygroscopic materials; adsorption, desorption, equilibrium moisture content. Transport processes in natural materials such as wood. Drying processes for wood and other lignocellulosic materials. Influence of moisture on dimensional stability and durability of wood and lignocelluosic composites.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Properties of Wood",
    "dept": "FOR",
    "num": "487",
    "desc": "Prereq: FOR 280\nMechanical, thermal, electrical, and acoustical properties of wood. Lumber grading and stress rating, nondestructive evaluation of wood and wood composite products.\n",
    "credits": "4"
  },
  {
    "course_name": "Dynamics of Forest Stands",
    "dept": "FOR",
    "num": "542",
    "desc": "Prereq: NREM 301, FOR 302, STAT 101 or their equivalents\nChange in forest species composition and structure at the stand and landscape scales resulting from site quality, tree growth, competition, succession, and disturbance. Methods for assessing tree growth and reconstructing past stand development. Applications to forest and savanna management.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Management",
    "dept": "FOR",
    "num": "552",
    "desc": "Prereq: Senior classification, and NREM 120 or its equivalent\nPrinciples of planning, regulating, and decision-making associated with public and private lands, with consideration of forest, grassland, wetland, and freshwater aquatic ecosystems.  Integrated natural resources management within ecological, social, economic and policy constraints.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "FOR",
    "num": "599",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Forest Biology",
    "dept": "FOR",
    "num": "599A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Forest Biometry",
    "dept": "FOR",
    "num": "599B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Forest and Recreation Economics",
    "dept": "FOR",
    "num": "599C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Forest Management and Administration",
    "dept": "FOR",
    "num": "599D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component: Wood Science",
    "dept": "FOR",
    "num": "599E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar",
    "dept": "FOR",
    "num": "696",
    "desc": "\nResearch seminars by faculty and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "FOR",
    "num": "699",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research: Forest Biology - Wood Science",
    "dept": "FOR",
    "num": "699A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research: Forest Biometry",
    "dept": "FOR",
    "num": "699B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research: Forest Economics",
    "dept": "FOR",
    "num": "699C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research: Forest Management and Administration",
    "dept": "FOR",
    "num": "699D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research: Wood Science",
    "dept": "FOR",
    "num": "699E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research: Plant Physiology",
    "dept": "FOR",
    "num": "699F",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Elementary French I",
    "dept": "FRNCH",
    "num": "101",
    "desc": "\nBeginning level development of reading, writing, listening comprehension, and speaking in French, within the context of French culture.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary French II",
    "dept": "FRNCH",
    "num": "102",
    "desc": "Prereq: FRNCH 101\nBeginning level development of reading, writing, listening comprehension, and speaking in French, within the context of French culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate French I",
    "dept": "FRNCH",
    "num": "201",
    "desc": "Prereq: FRNCH 102\nIntermediate level development of reading, writing, listening comprehension, and speaking in French within the context of French culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate French II",
    "dept": "FRNCH",
    "num": "202",
    "desc": "Prereq: FRNCH 201\nIntermediate level development of reading, writing, listening comprehension, and speaking in French within the context of French culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "French Writing and Grammar",
    "dept": "FRNCH",
    "num": "301",
    "desc": "Prereq: FRNCH 202\nEmphasis on developing functional language skills in reading and writing. Selective review of grammar within the context of cultural and literary prose.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Reading and Writing French",
    "dept": "FRNCH",
    "num": "302",
    "desc": "Prereq: FRNCH 301\nReadings in French prose, theater and poetry. Introduction to close reading and analysis. Development of reading and writing skills for upper-level courses.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "French for Global Professionals",
    "dept": "FRNCH",
    "num": "304",
    "desc": "Prereq: FRNCH 301\nCommunication in business and professional contexts in French-speaking countries. Development of effective communication strategies and project management in the workplace. Cultural contexts of business and professional practice. Emphasis on working across French-American cultures. Preparation for internships.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "French Conversation",
    "dept": "FRNCH",
    "num": "305",
    "desc": "Prereq: FRNCH 202\nIntensive conversational and listening practice emphasizing contemporary France and the Francophone world. Native or near-native speakers are not eligible to enroll.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "France Today",
    "dept": "FRNCH",
    "num": "320",
    "desc": "Prereq: FRNCH 202\nSelected topics dealing with contemporary French society and culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in French or Francophone Film",
    "dept": "FRNCH",
    "num": "326",
    "desc": "Prereq: FRNCH 302 or concurrent enrollment in FRNCH 302\nIn-depth study of a selected filmmaker, genre, or movement.  Emphasis on analytical interpretation and relationship between film and French or Francophone culture, history, and society. Counts toward World Film Studies Minor.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in French or Francophone Literature",
    "dept": "FRNCH",
    "num": "340",
    "desc": "Prereq: FRNCH 302 or concurrent enrollment in FRNCH 302\nIn-depth study of a selected topic, genre, movement or writer in French or Francophone literature, civilization or culture.  Emphasis on close readings and discussion.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "French Studies in English",
    "dept": "FRNCH",
    "num": "370",
    "desc": "Prereq: For fourth credit, 6 credits in French at 300 level.\nAuthor, genre, or period study in French or Francophone history, literature, or culture.Three credits: readings, discussions and papers in English; open to all students. Four credits: required for French concentration credit, supplementary readings and written course work in French.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation: French Topics on Women and Gender Studies",
    "dept": "FRNCH",
    "num": "370F",
    "desc": "\nTopics vary according to faculty interest. Readings, discussions, and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "French Film Studies in English",
    "dept": "FRNCH",
    "num": "378",
    "desc": "Prereq: For fourth credit, 6 credits in French at 300 level.\nAnalysis and interpretation of film in French society. Topics vary according to faculty interest. Film directors, genres, movements (e.g. The New Wave), historical survey, aesthetics, and cinematography. Three credits: readings, discussions and papers in English; open to all students. Four credits: required for French concentration credit, supplementary readings and written course work in French. Counts toward World Film Studies Minor.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "French Culture and Society in English",
    "dept": "FRNCH",
    "num": "476",
    "desc": "\nKey moments and themes in French society and culture up to the modern era. Subjects vary according to faculty interest. Readings, discussions, and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "FRNCH",
    "num": "490",
    "desc": "Prereq: Permission of French staff and department chair\nDesigned to meet the needs of students who wish to focus on areas other than those in which courses are offered.\n  No more than 9 credits in Frnch 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Internship in French",
    "dept": "FRNCH",
    "num": "499",
    "desc": "Prereq: 9 credits of French at the 300 level; permission of advisor and WLC Internship Coordinator.  Work experience using French language skills in the public or private sector, combined with academic work under faculty supervision\nCredits may be applied only to LCP major.\n  Offered on a satisfactory-fail basis only.  No more than 3 credits of Frnch 499 may be applied to the major.",
    "credits": "1"
  },
  {
    "course_name": "Special  Topics in French",
    "dept": "FRNCH",
    "num": "590",
    "desc": "Prereq: Permission of instructor; 6 credtis of 400 level French\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in French: Literature or Literary Criticism",
    "dept": "FRNCH",
    "num": "590A",
    "desc": "Prereq: Permission of instructor; 6 credtis of 400 level French\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in French: Linguistics",
    "dept": "FRNCH",
    "num": "590B",
    "desc": "Prereq: Permission of instructor; 6 credtis of 400 level French\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in French: Language Pedagogy",
    "dept": "FRNCH",
    "num": "590C",
    "desc": "Prereq: Permission of instructor; 6 credtis of 400 level French\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in French: Civilization",
    "dept": "FRNCH",
    "num": "590D",
    "desc": "Prereq: Permission of instructor; 6 credtis of 400 level French\n",
    "credits": "2"
  },
  {
    "course_name": "Entrepreneurship in Science and Technology",
    "dept": "GDCB",
    "num": "505",
    "desc": "\nHigh level success at modern science requires entrepreneurship both in and outside the laboratory. Scientists are in a unique position to not only think, but to thrive, \"outside of the box\" and take unorthodox approaches to research that lead to positive paradigm shifts in our lives. Exploration of many facets of science, technology, industry and commerce, with frequent guest lectures from entrepreneurs.\n",
    "credits": "3"
  },
  {
    "course_name": "Transmission Genetics",
    "dept": "GDCB",
    "num": "510",
    "desc": "Prereq: GEN 410 or graduate standing\nIn-depth investigations of modern research practices of transmission genetics. Designed for students interested in genetic research. Topics include: Mendelian genetic analysis, analysis of genetic pathways, mutational analysis of gene function, chromosomal mechanics, genetic mapping, epigenetic inheritance, human genetic analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Molecular Genetics",
    "dept": "GDCB",
    "num": "511",
    "desc": "Prereq: BIOL 313 and BBMB 405\nMechanisms of molecular genetic processes in eukaryotes and prokaryotes, including DNA replication and repair, transcription, translation and regulation of gene expression. Critical evaluation and discussion of current primary literature, methodologies and experimental data.\n",
    "credits": "3"
  },
  {
    "course_name": "Plant Metabolism",
    "dept": "GDCB",
    "num": "513",
    "desc": "Prereq: BIOL 330, PHYS 111, CHEM 331; one semester of biochemistry recommended\nPhotosynthesis, respiration, and other aspects of plant metabolism.\n",
    "credits": "2"
  },
  {
    "course_name": "Advances in Molecular Cell Biology",
    "dept": "GDCB",
    "num": "528",
    "desc": "Prereq: Courses in general cell biology and biochemistry\nCell biological processes including cell signaling, cell division, intracellular trafficking, biogenesis of organelles, cell adhesion and motility.\n",
    "credits": "3"
  },
  {
    "course_name": "Advances in Developmental Biology",
    "dept": "GDCB",
    "num": "533",
    "desc": "Prereq: BIOL 314 or BIOL 423\nFundamental principles in multicellular development. Emphasis on cellular and molecular regulation of developmental processes, and experimental approaches as illustrated in the current literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Genetics",
    "dept": "GDCB",
    "num": "536",
    "desc": "Prereq: STAT 401, STAT 447; GEN 320 or BIOL 313\nStatistical models and methods for genetics covering models of population processes: selection, mutation, migration, population structure, and linkage disequilibrium, and inference techniques: genetic mapping, linkage analysis, and quantitative trait analysis. Applications include genetic map construction, gene mapping, genome-wide association studies (GWAS), inference about population structure, phylogenetic tree construction, and forensic and paternity identification.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "GDCB",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "GDCB",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "GDCB",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "GDCB",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "GDCB",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "GDCB",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "GDCB",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "GDCB",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Bioinformatics",
    "dept": "GDCB",
    "num": "544",
    "desc": "Prereq: MATH 165 or STAT 401 or equivalent\nA practical, hands-on overview of how to apply bioinformatics to biological research. Recommended for biologists desiring to gain computational molecular biology skills. Topics include: sequence analysis, genomics, proteomics, phylogenetic analyses, ontology enrichment, systems biology, data visualization and emergent technologies.\n",
    "credits": "4"
  },
  {
    "course_name": "Plant Molecular, Cell and Developmental Biology",
    "dept": "GDCB",
    "num": "545",
    "desc": "Prereq: BIOL 313, BIOL 314, BIOL 330 or BBMB 405\nPlant nuclear and organelle genomes; regulation of gene expression; hormone signaling; organization, function, and development of plant cells and subcellular structures; regulation of plant growth and development.\n",
    "credits": "3"
  },
  {
    "course_name": "Cellular, Molecular and Developmental Neuroscience",
    "dept": "GDCB",
    "num": "556",
    "desc": "Prereq: BIOL 335 or BIOL 436; physics recommended\nFundamental principles of neuroscience including cellular and molecular neuroscience, nervous system development, sensory, motor and regulatory systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Neuroscience Techniques",
    "dept": "GDCB",
    "num": "557",
    "desc": "Prereq: NEURO 556 or equivalent course\nResearch methods and techniques; lectures, laboratory exercises and/or demonstrations representing individual faculty specialties.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics II (Statistical Bioinformatics)",
    "dept": "GDCB",
    "num": "568",
    "desc": "Prereq: BCB 567 or (BIOL 315 and STAT 430), credit or enrollment in GEN 409\nStatistical models for sequence data, including applications in genome annotation, motif discovery, variant discovery, molecular phylogeny, gene expression analysis, and metagenomics.  Statistical topics include model building, inference, hypothesis testing, and simple experimental design, including for big data/complex models.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics III (Structural Bioinformatics)",
    "dept": "GDCB",
    "num": "569",
    "desc": "Prereq: BCB 567, BBMB 316, GEN 409, STAT 430\nMolecular structures including genes and gene products: protein, DNA and RNA structure. Structure determination methods, structural refinement, structure representation, comparison of structures, visualization, and modeling. Molecular and cellular structure from imaging. Analysis and prediction of protein secondary, tertiary, and higher order  structure, disorder, protein-protein and protein-nucleic acid interactions, protein localization and function, bridging between molecular and cellular structures. Molecular evolution.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics IV (Systems Biology)",
    "dept": "GDCB",
    "num": "570",
    "desc": "Prereq: BCB 567 or COM S 311, COM S 228, GEN 409, STAT 430\nAlgorithmic and statistical approaches in computational functional genomics and systems biology. Analysis of high throughput biological data obtained using system-wide measurements. Topological analysis, module discovery, and comparative analysis of gene and protein networks. Modeling, analysis, and inference of transcriptional regulatory networks, protein-protein interaction networks, and metabolic networks. Dynamic systems and whole-cell models. Ontology-driven, network based, and probabilistic approaches to information integration.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Predictive Plant Phenomics",
    "dept": "GDCB",
    "num": "585",
    "desc": "Prereq: Acceptance into the P3 program or instructor permission.\nPrinciples of engineering, data analysis, and plant sciences and their interplay applied to predictive plant phenomics.  Transport phenomena, sensor design, image analysis, graph models, network data analysis, fundamentals of genomics and phenomics.  Multidisciplinary laboratory exercises.\n  None",
    "credits": "4"
  },
  {
    "course_name": "Special Topics",
    "dept": "GDCB",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Current Topics in Neuroscience",
    "dept": "GDCB",
    "num": "661",
    "desc": "Prereq: NEURO 556 (or comparable course) or permission of instructor\nTopics may include molecular and cellular neuroscience, neurodevelopment, neuroplasticity, neurodegenerative diseases, cognitive neuroscience, sensory biology, neural integration, membrane biophysics, neuroethology, techniques in neurobiology and behavior.\n",
    "credits": "2"
  },
  {
    "course_name": "Seminar in GDCB",
    "dept": "GDCB",
    "num": "690",
    "desc": "\nResearch seminars by faculty, invited speakers, and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Faculty Seminar",
    "dept": "GDCB",
    "num": "691",
    "desc": "\nFaculty research series.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar",
    "dept": "GDCB",
    "num": "696",
    "desc": "\nResearch seminars by faculty and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Molecular, Cellular, and Developmental Biology",
    "dept": "GDCB",
    "num": "698",
    "desc": "\nStudent and faculty presentations.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "GDCB",
    "num": "699",
    "desc": "\nResearch for thesis or dissertation.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "GDCB",
    "num": "699I",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Genetics Orientation",
    "dept": "GEN",
    "num": "110",
    "desc": "\nThis course is intended for first year students and others new to the genetics major.  Discussion of university policies and resources, requirements of the major, career opportunities, and other topics related to the first year experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Genetics Orientation for Transfer Students",
    "dept": "GEN",
    "num": "112",
    "desc": "\nEight-week course for external transfer students and internal change of major students. Discussion of university policies and resources, requirements of the major, and career opportunities.\n  Only one of GEN 110 or 112 may count toward graduation.",
    "credits": "0"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "GEN",
    "num": "298",
    "desc": "Prereq: Permission of department cooperative education coordinator; sophomore classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Principles of Genetics",
    "dept": "GEN",
    "num": "313",
    "desc": "Prereq: BIOL 211, BIOL 211L, BIOL 212, and BIOL 212L\nIntroduction to the principles of transmission and molecular genetics of plants, animals, and bacteria. Recombination, structure and replication of DNA, gene expression, cloning, quantitative genetics, and population genetics.\n  Students may receive graduation credit for no more than one of the following: Gen 260, Gen 313 and 313L, Gen 320, Biol 313 and 313L, and Agron 320.",
    "credits": "3"
  },
  {
    "course_name": "Genetics Laboratory",
    "dept": "GEN",
    "num": "313L",
    "desc": "Prereq: Credit or enrollment in BIOL 313\nLaboratory to accompany 313.\n  Students may receive graduation credit for no more than one of the following: Biol 313 and 313L, Gen 260, Gen 313, Gen 320, and Agron 320.",
    "credits": "1"
  },
  {
    "course_name": "Genetics, Agriculture and Biotechnology",
    "dept": "GEN",
    "num": "320",
    "desc": "Prereq: BIOL 212\nTransmission and molecular genetics with an emphasis on applications in agriculture, the structure and expression of the gene, how genes behave in populations and how recombinant DNA technology can be used to improve agriculture.\n  Credit for graduation will not be allowed for more than one of the following: Gen 260, 313, 320 and Biol 313 and 313L.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Bioinformatics and Computational Biology",
    "dept": "GEN",
    "num": "322",
    "desc": "Prereq: BIOL 212\nGenome sequencing, assembly, structural and functional annotation, and comparative genomics. Investigating these topics will develop skills in programming and scripting (Perl and/or Python), the use of biological databases, sequence alignment, similarity search, identification of sequence patterns, construction of phylogenetic trees, and comparative genomics.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Genetics",
    "dept": "GEN",
    "num": "340",
    "desc": "Prereq: BIOL 313 or GEN 313\nFundamental concepts and current issues of human genetics. Human chromosome analysis, pedigree analysis, gene mapping, the human genome project, sex determination, genetics of the immune system, genetics of cancer, gene therapy, the genetic basis of human diversity, eugenics.\n",
    "credits": "3"
  },
  {
    "course_name": "The Genome Perspective in Biology",
    "dept": "GEN",
    "num": "349",
    "desc": "Prereq: GEN 313 or GEN 320\nAnalysis of genome, RNA, and protein data using computer technology to answer biological questions on topics ranging from microbial diversity to human health. An introduction for students in the life sciences to the fields of genomics, bioinformatics and systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "GEN",
    "num": "398",
    "desc": "Prereq: Permission of department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Microbial Genetics and Genomics",
    "dept": "GEN",
    "num": "402",
    "desc": "Prereq: MICRO 302, BIOL 313\nThe fundamental concepts of bacterial and bacteriophage genetics including mutagenesis, mechanisms of vertical and horizontal genetic information transfer and gene regulation are covered, along with genetic and genomic-based approaches to study these and other cellular processes of microorganisms.  Review and discussion of research literature to examine experimental design, methodology, and interpretation of both historical and contemporary relevance to microbial genetics and genomics.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Genetics",
    "dept": "GEN",
    "num": "409",
    "desc": "Prereq: BIOL 313 or GEN 313\nPrinciples of molecular genetics and analysis of gene expression, including elements of the Central Dogma (DNA replication, transcription, and translation) and gene regulation. Utilizing examples from the primary literature to illustrate experimental design, data analysis, and interpretation.\n",
    "credits": "3"
  },
  {
    "course_name": "Analytical Genetics",
    "dept": "GEN",
    "num": "410",
    "desc": "Prereq: BIOL 313 or GEN 313\nThe principles and practice of genetic analysis. Mendelian genetic analysis, mutational, transgenic, and genomic analysis of gene function, linkage and gene     mapping, chromosomal aberrations, aneuploidy and polyploidy, extrachromosomal inheritance, analysis of genetic pathways.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatic Analysis",
    "dept": "GEN",
    "num": "444",
    "desc": "Prereq: MATH 165 and Introductory Statistics (STAT 101, STAT 104, STAT 105, STAT 201, or STAT 330).\nBroad overview of bioinformatics with a significant problem-solving component, including hands-on practice using computational tools to solve a variety of biological problems. Topics include: bioinformatic data processing, Python programming, genome assembly, database search, sequence alignment, gene prediction, next-generation sequencing, comparative and functional genomics, and systems biology.\n",
    "credits": "4"
  },
  {
    "course_name": "Evolutionary Genetics",
    "dept": "GEN",
    "num": "462",
    "desc": "Prereq: BIOL 315\nThe genetic basis of evolutionary processes in eukaryotic organisms. The role of genetic variation in adaptation, natural selection, adaptive processes, and the influence of random processes on evolutionary change.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "GEN",
    "num": "490",
    "desc": "Prereq: GEN 313, junior or senior classification, permission of instructor\nIndependent study in any area of genetics.\n  Students may use no more than 9 credits of university-wide 490 credits (including Gen 490) toward the total of 120 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Seminar, Professional Practice in Genetics Disciplines",
    "dept": "GEN",
    "num": "491",
    "desc": "Prereq: BIOL/GEN 313; credit or enrollment in GEN 409 or GEN 410; Junior Classification\nIntended to develop career objectives and obtain positions appropriate to the goals of students, in particular juniors, in preparation for position searches in the senior year.  Discussion of various career paths in genetics disciplines; identification of experiences to enhance entry to specific careers; exposure to professional practices not covered elsewhere including literature database management, scientific figure preparation for publication, the peer-review journal system, the federal competitive grants system, laboratory budgets and management, authorship and collaborations, etc.; preparation of effective curricula vitae and application letters; and verbal scientific discourse appropriate to interview interactions and other professional settings.\n",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Teaching Experience",
    "dept": "GEN",
    "num": "492",
    "desc": "Prereq: BIOL 212, junior or senior classification, permission of instructor\nFor students registering to be undergraduate laboratory or classroom assistants.\n  Offered on a satisfactory-fail basis only.  No more than 2 credits of GEN 492 may be applied toward the Genetics advanced course requirement.",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Genetics",
    "dept": "GEN",
    "num": "495",
    "desc": "Prereq: GEN 313; permission of instructor\nContent varies from year to year.\n  Genetics students may use no more than 9 credits of university-wide 490-499 credits toward the total of 120 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Attendance and Critique of Genetics Seminars",
    "dept": "GEN",
    "num": "496",
    "desc": "Prereq: GEN 313, junior or senior classification, permission of instructor\nAttendance and critique of departmental seminars in BBMB, GDCB, or EEOB.\n  Offered on a satisfactory-fail basis only.  Genetics students may use no more than 9 credits of university-wide 490 - 499 credits toward the total of 120 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "GEN",
    "num": "498",
    "desc": "Prereq: Permission of department cooperative education coordinator; senior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Genetics Research",
    "dept": "GEN",
    "num": "499",
    "desc": "Prereq: GEN 313, junior or senior classification, permission of instructor\nIndependent research in any area of genetics.\n  Genetics students may use no more than 9 credits of university-wide 490-499 credits toward the total of 120 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Genetics Research for Honors",
    "dept": "GEN",
    "num": "499H",
    "desc": "Prereq: GEN 313, junior or senior classification, permission of instructor\nIndependent research in any area of genetics; for Honors students only.\n  Genetics students may use no more than 9 credits of university-wide 490-499 credits toward the total of 120 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Ethics and Biological Sciences",
    "dept": "GENET",
    "num": "539",
    "desc": "\nIntroduction to Bioethics through case studies, discussion of contemporary work on central bioethics topics, and discussion of important emerging ethical issues associated with recent research or technological development.  Issues covered will vary somewhat from year to year, but will include at least some of the following:  ethics and responsible research practice, animal ethics and the use of animals in teaching and research, cloning, human reproductive and stem cell research, regulation of genetically modified crops and foods, plant biotechnology, gene patents.   Students will be divided into groups to develop their own case study, to be presented in class at the end of the term.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Special Topics",
    "dept": "GENET",
    "num": "590",
    "desc": "\nContact individual faculty for special projects or topics.  Graded.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Genetics",
    "dept": "GENET",
    "num": "591",
    "desc": "Prereq: Permission of instructor\nCurrent topics in genetics research. Lectures by off-campus experts. Students read background literature, attend preparatory seminars, attend all lectures, meet with lecturers.\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Student Seminar in Genetics",
    "dept": "GENET",
    "num": "690",
    "desc": "Prereq: Permission of instructor\nResearch presentations by students to improve their ability to:  orally present scientific work in a clear and meaningful way, critically evaluate oral presentations, and give and receive constructive criticism. Students may enroll in one seminar per school year.\n",
    "credits": "1"
  },
  {
    "course_name": "Faculty Seminar in Genetics",
    "dept": "GENET",
    "num": "691",
    "desc": "Prereq: Permission of instructor\nFaculty research seminars that introduce students to the variety of genetics research projects on campus and provide an opportunity for students to become engaged in the scientific presentation to the point where they can think critically and ask meaningful questions.\n",
    "credits": "1"
  },
  {
    "course_name": "Conceptual Foundations of Genetics",
    "dept": "GENET",
    "num": "692",
    "desc": "Prereq: Permission of instructor\nLandmark papers in the development of genetics concepts.  Papers are presented and discussions led by students, guided and mentored by the instructors.  Instructors provide a broad overview and history of the development of fundamental concepts in genetics.\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Research Rotation",
    "dept": "GENET",
    "num": "697",
    "desc": "\nGraduate research projects performed under the supervision of selected faculty members in the graduate Genetics major.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "GENET",
    "num": "699",
    "desc": "\nResearch.\n",
    "credits": "arr"
  },
  {
    "course_name": "How the Earth Works",
    "dept": "GEOL",
    "num": "100",
    "desc": "\nHow does the earth work, what is it made of, and how does it change through time? Plate tectonics, Earth materials, landforms, structures, climate, and natural resources. Emphasis on the observations and hypotheses used to interpret earth system processes. Students may also enroll in GEOL 100L.\n",
    "credits": "3"
  },
  {
    "course_name": "How the Earth Works: Laboratory",
    "dept": "GEOL",
    "num": "100L",
    "desc": "Prereq: Credit or enrollment in GEOL 100\nStudents will gain understanding of how Earth processes affect their lives and how they affect the Earth, and of the complex nature of the Earth and its processes. They will gain a deep knowledge of the methods used to understand the time scales and rates of Earth processes also through an applied research experience on groundwater and surface water.\n",
    "credits": "1"
  },
  {
    "course_name": "Environmental Geology: Earth in Crisis",
    "dept": "GEOL",
    "num": "101",
    "desc": "\nAn introduction to geologic processes and the consequences of human activity from local to global scales. Discussion of human population growth, resource depletion, pollution and waste disposal, global warming and ozone depletion, desertification, and geologic hazards such as earthquakes, landslides, flooding, and volcanism. Summer - online only.\n",
    "credits": "3"
  },
  {
    "course_name": "History of the Earth",
    "dept": "GEOL",
    "num": "102",
    "desc": "Prereq: GEOL 100 or GEOL 201\nThe Earth's physical and biological evolution; concepts of global tectonics. Methods used to decipher earth history. Students majoring in geology must also enroll in GEOL 102L.\n",
    "credits": "3"
  },
  {
    "course_name": "History of the Earth: Laboratory",
    "dept": "GEOL",
    "num": "102L",
    "desc": "Prereq: Credit or enrollment in GEOL 102\nIntroduction to the use of sedimentary rocks and fossils in reconstructing the Earth's history.\n",
    "credits": "1"
  },
  {
    "course_name": "Age of Dinosaurs",
    "dept": "GEOL",
    "num": "103",
    "desc": "\nIntroduction to the diversity of dinosaur species. Discussion of basic evolutionary theory and interpretation of fossil evidence. Overview of Mesozoic Earth history including paleogeographic and paleoclimate reconstructions. Course available via the World Wide Web.\n",
    "credits": "1"
  },
  {
    "course_name": "Gems and Gemstones",
    "dept": "GEOL",
    "num": "105",
    "desc": "\nOffered in second half of the semester. Introduction to gems and gemstones, physical and optical properties of gems and gemstones, explanation of where gems come from and how they are found, how to distinguish between synthetic and naturally occurring gems, how the value of gems are determined, and the history of famous gems.\n",
    "credits": "1"
  },
  {
    "course_name": "Earth and Space Science for Elementary Education Majors",
    "dept": "GEOL",
    "num": "106",
    "desc": "Prereq: Major in elementary or early childhood education.\nFundamental concepts of Earth and Space Science, including the solar system, weather and climate, water and soils, plate tectonics, and geologic hazards. Online course format.\n",
    "credits": "2"
  },
  {
    "course_name": "Earth and Space Science for Elementary Education Majors: Laboratory",
    "dept": "GEOL",
    "num": "106L",
    "desc": "Prereq: Restricted to elementary and early childhood education majors; to be taken concurrently with GEOL 106/ASTRO 106\nInquiry-based lab exploring fundamental concepts of Earth and Space Science, including the solar system, weather and climate, water and soils, plate tectonics, and geologic hazards. Must be taken concurrently with GEOL/ASTRO 106.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Oceanography",
    "dept": "GEOL",
    "num": "108",
    "desc": "\nIntroduction to study of the oceans. Ocean exploration. Waves and currents. Shape, structure, and origin of the ocean basins. Sedimentary record of oceanic life. Composition of seawater and its significance for life. Ocean circulation and its influence on climate. Life of the oceans, including coral reefs. Use and misuse of ocean resources. Anthropogenic impacts on the oceanic environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Geological Disasters",
    "dept": "GEOL",
    "num": "111",
    "desc": "\nIntroduction to the catastrophic geologic processes that disrupt ecosystems and human activity. Includes a discussion on the role of plate tectonics, the hydrologic cycle, and humans as the driving forces behind selected case studies on volcanic eruptions, earthquakes, tsunamis, landslides, and floods. Summer and fall - online only.\n",
    "credits": "1"
  },
  {
    "course_name": "Geoscience Orientation",
    "dept": "GEOL",
    "num": "112",
    "desc": "\nOrientation course for students enrolled in the Earth, Wind and Fire Learning Community. Provides an introduction to Iowa State University and meteorology, geology, and Earth science programs for students enrolled in the department's learning community. Activities include academic and social activities, talks and presentations on academic success, resume writing, and study abroad, as well as research talks by faculty members.\n",
    "credits": "1"
  },
  {
    "course_name": "Spring Geoscience Orientation for Earth, Wind and Fire Learning Community",
    "dept": "GEOL",
    "num": "113",
    "desc": "\nSpring orientation course for students enrolled in the \"Earth, Wind and Fire\" Learning Community.  Develop and apply quantitative, data-analysis, management, and communication skills on an authentic research project in a team to focus on professionalism and resilience.  Introduction to interview strategies and the importance of creating a professional image on social media. Academic and social events, plus two field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Water Resources of the World",
    "dept": "GEOL",
    "num": "160",
    "desc": "\nStudy of the occurrence, history, development, and management of world water resources.  Basic hydrologic principles including climate, surface water, groundwater, and water quality.  Historical and current perspectives on water policy, use, and the role of water in society and the environment.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Geology for Engineers and Environmental Scientists",
    "dept": "GEOL",
    "num": "201",
    "desc": "\nIntroduction to Earth materials and processes with emphasis on engineering and environmental applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "GEOL",
    "num": "290",
    "desc": "Prereq: Permission of instructor\nIndependent study for freshman and sophomore students.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "GEOL",
    "num": "298",
    "desc": "Prereq: GEOL 100 or GEOL 201, GEOL 100L, GEOL 102, GEOL 102L, and permission of the department cooperative education coordinator; sophomore classification\nRequired of all cooperative education students. Students must register for this course prior to commencing the work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Summer Field Studies",
    "dept": "GEOL",
    "num": "302",
    "desc": "Prereq: GEOL 102, GEOL 356, GEOL 368\nGeologic mapping; structural, stratigraphic, sedimentologic, metamorphic, geomorphic, and environmental analyses. Study areas in the Bighorn Basin and Wind River Range and excursions to Yellowstone and Grand Teton National Parks. A 6-week summer field course required of all geology majors.\n",
    "credits": "6"
  },
  {
    "course_name": "Mineralogy and Earth Materials",
    "dept": "GEOL",
    "num": "315",
    "desc": "Prereq: GEOL 100 or GEOL 201, CHEM 177\nIntroduction to mineral classification, elementary crystal chemistry, crystal growth and morphology, mineral stability, and mineral associations.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Mineralogy and Earth Materials",
    "dept": "GEOL",
    "num": "315L",
    "desc": "Prereq: GEOL 100 or GEOL 201\nMineral identification methods, especially hand-specimen identification.\n",
    "credits": "1"
  },
  {
    "course_name": "Optical Mineralogy",
    "dept": "GEOL",
    "num": "316",
    "desc": "Prereq: GEOL 100 or GEOL 201, CHEM 177, credit or enrollment in GEOL 315\nLaboratory problems in mineral-identification methods utilizing optical microscopic techniques.\n",
    "credits": "1"
  },
  {
    "course_name": "Energy and the Environment",
    "dept": "GEOL",
    "num": "324",
    "desc": "Prereq: CHEM 163 or CHEM 177, MATH 140\nExploration of the origin of Earth’s energy resources and the environmental and climatic impacts of energy acquisition and consumption. Renewable and non-renewable energy resources within an Earth-system context. Various environmentally-relevant topics such as water quality and availability, habitat destruction, greenhouse-gas emissions, and health and safety hazards to wildlife and human communities.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Geology and Tectonics",
    "dept": "GEOL",
    "num": "356",
    "desc": "Prereq: GEOL 100 or GEOL 201; PHYS 111\nPrinciples of stress, strain, and rheology. Brittle and ductile behavior of rocks. Mechanics of formation, description, and classification of fractures, faults, folds, foliation, and lineation. From micro-structures to tectonic processes. Laboratory includes application of learned concepts to real-world scenarios, geometrical techniques to solve structural problems.\n",
    "credits": "4"
  },
  {
    "course_name": "Geological Mapping and Field Methods",
    "dept": "GEOL",
    "num": "357",
    "desc": "Prereq: GEOL 100 or GEOL 201; PHYS 111; credit or enrollment in GEOL 356\nGeneration and interpretation of geological maps via a combination of laboratory and field exercises. Developing skills in 3D thinking, cross-section construction, stereonet analysis, field data collection, and communicating scientific results.\n",
    "credits": "1"
  },
  {
    "course_name": "Igneous and Metamorphic Petrology",
    "dept": "GEOL",
    "num": "365",
    "desc": "Prereq: GEOL 315, GEOL 315L, GEOL 316\nNature and origin of igneous and metamorphic rocks. Emphasis on important rock-forming environments and processes and their influence on rock characteristics. Laboratory includes thin section study of rock textures and mineralogy and the interpretation of these features.\n",
    "credits": "3"
  },
  {
    "course_name": "Sedimentary Geology",
    "dept": "GEOL",
    "num": "368",
    "desc": "Prereq: GEOL 102\nExploration of the interplay between weathering, sedimentation, sea-level change, tectonics, and life through time that creates sedimentary rocks and stratigraphic packages. Understanding of the historical development of sedimentary geology through the development of petrography, paleontology, deep earth sampling, geophysical technologies, and geochemistry. Field and laboratory problem sets illuminate lecture material.\n",
    "credits": "4"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "GEOL",
    "num": "398",
    "desc": "Prereq: GEOL 100 or GEOL 201, GEOL 100L, GEOL 102, GEOL 102L, and permission of the department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Watershed Hydrology",
    "dept": "GEOL",
    "num": "402",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nExamination of watersheds as systems, emphasizing the surface components of the hydrologic cycle.  Combines qualitative understanding of hydrological processes and uncertainty with quantitative representation.  Laboratory emphasizes field investigation and measurement of watershed processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Geology Field Course",
    "dept": "GEOL",
    "num": "406",
    "desc": "Prereq: GEOL 100 or GEOL 201\nWeekly seminar introduces students to a selected geological region or theme that is visited on a required ten-day field excursion. Introduction to field-safety leadership.\n",
    "credits": "1"
  },
  {
    "course_name": "Field Methods in Hydrogeology",
    "dept": "GEOL",
    "num": "409",
    "desc": "Prereq: GEOL/ENSCI 402 or GEOL/ENSCI 411 or C E 473\nIntroduction to field methods used in groundwater investigations. In-field implementation of pumping tests, slug tests, monitoring well installation and drilling techniques, geochemical and water quality sampling, seepage meters, minipiezometers, stream gaging, and electronic instrumentation for data collection. Field trips to investigate water resource, water quality, and remediation projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrogeology",
    "dept": "GEOL",
    "num": "411",
    "desc": "Prereq: Four courses in biological or physical sciences\nPhysical principles of groundwater flow, nature and origin of aquifers and confining units, well hydraulics, groundwater modeling, and contaminant transport. Lab emphasizes applied field and laboratory methods for hydrogeological investigations.\n",
    "credits": "4"
  },
  {
    "course_name": "Micropaleontology",
    "dept": "GEOL",
    "num": "412",
    "desc": "Prereq: GEOL 102 and GEOL 102L\nEvolution, identification and utility of major microfossil groups from the Mesozoic to present. Focus on Cenozoic applications including biostratigraphy, paleoclimate, and paleothermometry using assemblages, stable isotopes, Mg/Ca, and molecular fossils. Laboratory includes processing and analysis of specific microfossils. Major groups covered include foraminifera, calcareous nannofossils, sponge spicules, diatoms, radiolarians, and silicoflagellates.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied and Environmental Geophysics",
    "dept": "GEOL",
    "num": "413",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nSeismic, gravity, magnetic, resistivity, electromagnetic, and ground-penetrating radar techniques for shallow subsurface investigations and imaging. Data interpretation methods. Lab emphasizes computer interpretation packages. Field work with seismic - and resistivity-imaging systems and radar.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Groundwater Flow Modeling",
    "dept": "GEOL",
    "num": "414",
    "desc": "Prereq: GEOL 411 or C E 473; MATH 165 or MATH 181\nIntroduction to the principles of modeling groundwater flow systems. Finite-difference and analytic-element methods, spreadsheet models, boundary conditions, calibration, sensitivity analysis, parameter estimation, particle tracking, and post-audit analysis. Application of MODFLOW to regional flow-system analysis. Computer laboratory emphasizes assigned problems that illustrate topics discussed in the course.\n",
    "credits": "3"
  },
  {
    "course_name": "Paleoclimatology",
    "dept": "GEOL",
    "num": "415",
    "desc": "Prereq: Four courses in biological or physical science\nIntroduction to mechanisms that drive climate, including the interplay between oceanic and atmospheric circulation and fluctuation in Earth's orbital parameters. Examination and analysis of past climate records ranging from historical documentation to ecological and geochemical proxies (e.g. tree ring analysis; O and C isotopes of skeletal carbonates and soils). Dating methods used to constrain and correlate climatic periods; utility of computer models to reconstruct past climates and predict future climate change. Emphasis placed on paleoclimatology and paleoecology of the late Quaternary (last ~1 million years).\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrologic Modeling and Analysis",
    "dept": "GEOL",
    "num": "416",
    "desc": "Prereq: Four courses in Earth science, meteorology, or engineering; junior standing\nStudy of the basic principles of hydrologic modeling, including rainfall-runoff analysis, lumped and distributed modeling, conceptual and physical models, parameter estimation and sensitivity analysis, input and validation data, uncertainty analysis, and the use of models in surface water hydrology. A range of common models are applied to study hydrologic topics such as flood forecasting and land use change impacts. Previous experience with Matlab or other programming language is needed.\n",
    "credits": "3"
  },
  {
    "course_name": "Aqueous and Environmental Geochemistry",
    "dept": "GEOL",
    "num": "419",
    "desc": "Prereq: CHEM 178, CHEM 178L; junior classification\nGeochemistry of natural waters and water-rock interactions. Acid-base equilibria, carbonate chemistry and buffer systems, mineral dissolution and precipitation, sorption, ion exchange, and redox reactions. Introduction to thermodynamics and kinetics. Laboratory emphasizes chemical analysis of waters and computer modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Mineral Resources",
    "dept": "GEOL",
    "num": "420",
    "desc": "Prereq: GEOL 365\nGeology and geochemistry of non-metallic and metallic ore deposits. Major processes that concentrate metals in the Earth. Geochemical conditions of ore formation using stable-isotope and fluid-inclusion studies.  Laboratory emphasizes the study of metallic ores.\n",
    "credits": "3"
  },
  {
    "course_name": "Stable Isotopes in the Environment",
    "dept": "GEOL",
    "num": "426",
    "desc": "Prereq: Four courses in biological or physical science\nIntroduction to the theory, methods and applications of stable isotopes. Primary focus on the origin, natural abundance, and fractionation of carbon, hydrogen, oxygen, nitrogen isotopes. Applications of isotopic occurrence for elucidation of physical, chemical, biological, and environmental processes. Effects of plant physiology, photosynthesis, trophic structure, diffusion, evaporation, chemical precipitation, soil and atmospheric processes, and environmental factors on isotope abundance.\n",
    "credits": "3"
  },
  {
    "course_name": "Seismic Methods in Geology, Engineering, and Petroleum Exploration",
    "dept": "GEOL",
    "num": "439",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nPhysics of elastic-wave propagation. Seismic surveys in environmental imaging, engineering, and petroleum exploration. Reflection and refraction techniques. Data collection, processing, and geological interpretation. Field work with state-of-the-art equipment.\n",
    "credits": "3"
  },
  {
    "course_name": "Petroleum Geoscience and Engineering",
    "dept": "GEOL",
    "num": "444",
    "desc": "\nThe geoscience and engineering aspects of exploration, development, and production of hydrocarbon resources around the world, as well as the historical and legal frameworks through which the industry has developed. Broader discussions of safety, risk, uncertainty, cost, and integrity as relevant to the petroleum industry.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists",
    "dept": "GEOL",
    "num": "452",
    "desc": "Prereq: GEOL 100, GEOL 201 or equivalent\nIntroduction to geographic information systems (GIS) with particular emphasis on geoscientific data. Uses ESRI's ArcGIS Desktop Software and extension modules. Emphasizes typical GIS operations and analyses in the geosciences to prepare students for advanced GIS courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Geostatistics for Geoscientists",
    "dept": "GEOL",
    "num": "468",
    "desc": "Prereq: GEOL 452, C R P 351, C R P 452, NREM 345, or NREM 446\nIntroduction to geospatial data collection, analysis, interpretation, and presentation. Geospatial techniques including geographic information systems (GIS), remote sensing (RS), and global positioning systems (GPS). Study of applied geostatistical analysis (e.g., interpolation and spatial regression).\n",
    "credits": "3"
  },
  {
    "course_name": "Glacial and Quaternary Geology",
    "dept": "GEOL",
    "num": "474",
    "desc": "Prereq: GEOL 100 or GEOL 201 or equivalent experience\nThe study of glaciers and glacial processes. Discussion of glaciology, glacial sediment transport, glacial landforms, and Quaternary history. Laboratory emphasizes topographic map interpretation and the Quaternary landscapes of Iowa.\n",
    "credits": "3"
  },
  {
    "course_name": "Surficial Processes",
    "dept": "GEOL",
    "num": "479",
    "desc": "Prereq: GEOL 100 and GEOL 100L; or GEOL 201; or equivalent experience.\nThe study of physical processes that shape Earth's surface. Topics include weathering, sediment transport, and landform genesis with emphasis on fluvial, glacial, hillslope, eolian, and coastal processes. Applications to engineering and environmental problems. Laboratory includes topographic map interpretation and local field trips.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "GEOL",
    "num": "487",
    "desc": "Prereq: Six credits in biology and 6 credits in chemistry\nIntroduction to major functional groups of autotrophic and heterotrophic microorganisms and their roles in natural and environmental systems. Consequences of microbial activity on water chemistry, weathering, and precipitation/dissolution reactions will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists II",
    "dept": "GEOL",
    "num": "488",
    "desc": "Prereq: GIS course, such as GEOL 452, CRP 451, CRP 452, NREM 345, NREM 446, AE 408 or equivalent\nGIS course with focus on the spatial analysis and modeling of raster data and triangulated irregular network (TIN) data. Uses ArcGIS and various extensions, such as Spatial Analyst, 3D Analyst, and ArcScene. Includes practical exercises during lectures, lab exercises, homework assignments, and (for GEOL 588) a class project.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of Remote Sensing Technologies",
    "dept": "GEOL",
    "num": "489",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nElectromagnetic-radiation principles, active and passive sensors, multispectral and hyperspectral sensors, imaging radar, SAR, thermal imaging, lidar. Examples of applications. Also offered online S.\n",
    "credits": "3"
  },
  {
    "course_name": "Satellite Remote Sensing Laboratory",
    "dept": "GEOL",
    "num": "489L",
    "desc": "Prereq: Completion or concurrent enrollment in MTEOR/GEOL/NREM/EE 489/589\nProcessing and analysis of satellite sensor data (optical and radar). Provides practical applications in an environmental context.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "GEOL",
    "num": "490",
    "desc": "Prereq: 6 credits in geology and permission of instructor\nIndependent study for senior students.\n  No more than 9 credits of Geol 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Seminar",
    "dept": "GEOL",
    "num": "495",
    "desc": "Prereq: Junior or senior classification\nWeekly seminar on topics of current research interest. Requires written summaries of three presentations of choice.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "GEOL",
    "num": "498",
    "desc": "Prereq: GEOL 100 or GEOL 201, GEOL 100L, GEOL 102, GEOL 102L, and permission of the department cooperative education coordinator; senior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Watershed Hydrology",
    "dept": "GEOL",
    "num": "502",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nExamination of watersheds as systems, emphasizing the surface components of the hydrologic cycle.  Combines qualitative understanding of hydrological processes and uncertainty with quantitative representation.  Laboratory emphasizes field investigation and measurement of watershed processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Geology Field Course",
    "dept": "GEOL",
    "num": "506",
    "desc": "Prereq: Graduate classification\nWeekly seminar introduces students to a selected geological region or theme that is visited on a required ten-day field excursion. Graduate students are expected to assist in field teaching and safety leadership.\n",
    "credits": "1"
  },
  {
    "course_name": "Midwestern Geology Field Trip",
    "dept": "GEOL",
    "num": "507",
    "desc": "Prereq: GEOL 365\nOn-site inspection of various ore deposits, mining operations, and terrains dominated by igneous or metamorphic rocks.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Field Methods in Hydrogeology",
    "dept": "GEOL",
    "num": "509",
    "desc": "Prereq: GEOL/ENSCI 402 or GEOL/ENSCI 411 or C E 473\nIntroduction to field methods used in groundwater investigations. In-field implementation of pumping tests, slug tests, monitoring well installation and drilling techniques, geochemical and water quality sampling, seepage meters, minipiezometers, stream gaging, and electronic instrumentation for data collection. Field trips to investigate water resource, water quality, and remediation projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrogeology",
    "dept": "GEOL",
    "num": "511",
    "desc": "Prereq: Four courses in biological or physical sciences\nPhysical principles of groundwater flow, nature and origin of aquifers and confining units, well hydraulics, groundwater modeling, and contaminant transport. Lab emphasizes applied field and laboratory methods for hydrogeological investigations.\n",
    "credits": "4"
  },
  {
    "course_name": "Micropaleontology",
    "dept": "GEOL",
    "num": "512",
    "desc": "Prereq: GEOL 102 and GEOL 102L\nEvolution, identification and utility of major microfossil groups from the Mesozoic to present. Focus on Cenozoic applications including biostratigraphy, paleoclimate, and paleothermometry using assemblages, stable isotopes, Mg/Ca, and molecular fossils. Laboratory includes processing and analysis of specific microfossils. Major groups covered include foraminifera, calcareous nannofossils, sponge spicules, diatoms, radiolarians, and silicoflagellates.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied and Environmental Geophysics",
    "dept": "GEOL",
    "num": "513",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nSeismic, gravity, magnetic, resistivity, electromagnetic, and ground-penetrating radar techniques for shallow subsurface investigations and imaging. Data interpretation methods. Lab emphasizes computer interpretation packages. Field work with seismic - and resistivity-imaging systems and radar.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Groundwater Flow Modeling",
    "dept": "GEOL",
    "num": "514",
    "desc": "Prereq: GEOL 411 or C E 473; MATH 165 or MATH 181\nIntroduction to the principles of modeling groundwater flow systems. Finite-difference and analytic-element methods, spreadsheet models, boundary conditions, calibration, sensitivity analysis, parameter estimation, particle tracking, and post-audit analysis. Application of MODFLOW to regional flow-system analysis. Computer laboratory emphasizes assigned problems that illustrate topics discussed in the course.\n",
    "credits": "3"
  },
  {
    "course_name": "Paleoclimatology",
    "dept": "GEOL",
    "num": "515",
    "desc": "Prereq: Four courses in biological or physical science\nIntroduction to mechanisms that drive climate, including the interplay between oceanic and atmospheric circulation and fluctuation in Earth's orbital parameters. Examination and analysis of past climate records ranging from historical documentation to ecological and geochemical proxies (e.g. tree ring analysis; O and C isotopes of skeletal carbonates and soils). Dating methods used to constrain and correlate climatic periods; utility of computer models to reconstruct past climates and predict future climate change. Emphasis placed on paleoclimatology and paleoecology of the late Quaternary (last ~ 1 million years).\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrologic Modeling and Analysis",
    "dept": "GEOL",
    "num": "516",
    "desc": "Prereq: Four courses in earth science, meteorology, or engineering; junior standing\nStudy of the basic principles of hydrologic modeling, including rainfall-runoff analysis, lumped and distributed modeling, conceptual and physical models, parameter estimation and sensitivity analysis, input and validation data, uncertainty analysis, and the use of models in surface water hydrology. A range of common models are applied to study hydrologic topics such as flood forecasting and land use change impacts. Previous experience with Matlab or other programming language is needed.\n",
    "credits": "3"
  },
  {
    "course_name": "Aqueous and Environmental Geochemistry",
    "dept": "GEOL",
    "num": "519",
    "desc": "Prereq: CHEM 178, CHEM 178L; junior classification\nGeochemistry of natural waters and water-rock interactions. Acid-base equilibria, carbonate chemistry and buffer systems, mineral dissolution and precipitation, sorption, ion exchange, and redox reactions. Introduction to thermodynamics and kinetics. Laboratory emphasizes chemical analysis of waters and computer modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Mineral Resources",
    "dept": "GEOL",
    "num": "520",
    "desc": "Prereq: GEOL 365\nGeology and geochemistry of non-metallic and metallic ore deposits. Major processes that concentrate metals in the Earth. Geochemical conditions of ore formation using stable-isotope and fluid-inclusion studies.  Laboratory emphasizes the study of metallic ores.\n",
    "credits": "3"
  },
  {
    "course_name": "Stable Isotopes in the Environment",
    "dept": "GEOL",
    "num": "526",
    "desc": "Prereq: Four courses in biological or physical science\nIntroduction to the theory, methods and applications of stable isotopes. Primary focus on the origin, natural abundance, and fractionation of carbon, hydrogen, oxygen, nitrogen isotopes. Applications of isotopic occurrence for elucidation of physical, chemical, biological, and environmental processes. Effects of plant physiology, photosynthesis, trophic structure, diffusion, evaporation, chemical precipitation, soil and atmospheric processes, and environmental factors on isotope abundance.\n",
    "credits": "3"
  },
  {
    "course_name": "Seismic Methods in Geology, Engineering, and Petroleum Exploration",
    "dept": "GEOL",
    "num": "539",
    "desc": "Prereq: GEOL 100 or GEOL 201, algebra and trigonometry\nPhysics of elastic-wave propagation. Seismic surveys in environmental imaging, engineering, and petroleum exploration. Reflection and refraction techniques. Data collection, processing, and geological interpretation. Field work with state-of-the-art equipment.\n",
    "credits": "3"
  },
  {
    "course_name": "Petroleum Geoscience and Engineering",
    "dept": "GEOL",
    "num": "544",
    "desc": "\nThe geoscience and engineering aspects of exploration, development, and production of hydrocarbon resources around the world, as well as the historical and legal frameworks through which the industry has developed. Broader discussions of safety, risk, uncertainty, cost, and integrity as relevant to the petroleum industry.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists",
    "dept": "GEOL",
    "num": "552",
    "desc": "Prereq: GEOL 100, GEOL 201 or equivalent\nIntroduction to geographic information systems (GIS) with particular emphasis on geoscientific data. Uses ESRI's ArcGIS Desktop Software and extension modules. Emphasizes typical GIS operations and analyses in the geosciences to prepare students for advanced GIS courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Soil Mineralogy",
    "dept": "GEOL",
    "num": "555",
    "desc": "Prereq: AGRON 473, CHEM 178. Recommend: GEOL 311\nStructure and behavior of clay minerals, humic substances and biochar in soil environments, with emphasis on reactions and environmental implications.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the 3D Visualization of Scientific Data",
    "dept": "GEOL",
    "num": "558",
    "desc": "Prereq: Graduate-student standing in the mathematical or natural sciences or engineering; basic programming knowledge\nIntroduction to visualizing scientific information with 3D computer graphics and their foundation in human perception. Overview of different visualization techniques and examples of 3D visualization projects from different disciplines (natural sciences, medicine, and engineering). Class project in interactive 3D visualization using the ParaView, Mayavi, TVTK, VTK or a similar system.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Geostatistics for Geoscientists",
    "dept": "GEOL",
    "num": "568",
    "desc": "Prereq: GEOL 452, C R P 351, C R P 452, NREM 345, or NREM 446\nIntroduction to geospatial data collection, analysis, interpretation, and presentation. Geospatial techniques including geographic information systems (GIS), remote sensing (RS), and global positioning systems (GPS). Study of applied geostatistical analysis (e.g., interpolation and spatial regression).\n",
    "credits": "3"
  },
  {
    "course_name": "Glacial and Quaternary Geology",
    "dept": "GEOL",
    "num": "574",
    "desc": "Prereq: GEOL 100 or GEOL 201 or equivalent experience\nThe study of glaciers and glacial processes. Discussion of glaciology, glacial sediment transport, glacial landforms, and Quaternary history. Laboratory emphasizes topographic map interpretation and the Quaternary landscapes of Iowa.\n",
    "credits": "3"
  },
  {
    "course_name": "Surficial Processes",
    "dept": "GEOL",
    "num": "579",
    "desc": "Prereq: GEOL 100 and GEOL 100L; or GEOL 201; or equivalent experience.\nThe study of physical processes that shape Earth's surface. Topics include weathering, sediment transport, and landform genesis with emphasis on fluvial, glacial, hillslope, eolian, and coastal processes. Applications to engineering and environmental problems. Laboratory includes topographic map interpretation and local field trips.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "GEOL",
    "num": "587",
    "desc": "Prereq: Six credits in biology and 6 credits in chemistry\nIntroduction to major functional groups of autotrophic and heterotrophic microorganisms and their roles in natural and environmental systems. Consequences of microbial activity on water chemistry, weathering, and precipitation/dissolution reactions will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "GIS for Geoscientists II",
    "dept": "GEOL",
    "num": "588",
    "desc": "Prereq: GIS course, such as GEOL 452, CRP 451, CRP 452, NREM 345, NREM 446, AE 408 or equivalent\nGIS course with focus on the spatial analysis and modeling of raster data and triangulated irregular network (TIN) data. Uses ArcGIS and various extensions, such as Spatial Analyst, 3D Analyst, and ArcScene. Includes practical exercises during lectures, lab exercises, homework assignments, and (for GEOL 588) a class project.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of Remote Sensing Technologies",
    "dept": "GEOL",
    "num": "589",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nElectromagnetic-radiation principles, active and passive sensors, multispectral and hyperspectral sensors, imaging radar, SAR, thermal imaging, lidar. Examples of applications. Also offered online S.\n",
    "credits": "3"
  },
  {
    "course_name": "Satellite Remote Sensing Laboratory",
    "dept": "GEOL",
    "num": "589L",
    "desc": "Prereq: Completion or concurrent enrollment in MTEOR/GEOL/NREM/EE 489/589\nProcessing and analysis of satellite sensor data (optical and radar). Provides practical applications in an environmental context.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "GEOL",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Surficial Processes",
    "dept": "GEOL",
    "num": "590A",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Stratigraphy",
    "dept": "GEOL",
    "num": "590B",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Sedimentation",
    "dept": "GEOL",
    "num": "590C",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Paleontology",
    "dept": "GEOL",
    "num": "590D",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Petrology",
    "dept": "GEOL",
    "num": "590E",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Structural Geology",
    "dept": "GEOL",
    "num": "590F",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Geochemistry",
    "dept": "GEOL",
    "num": "590G",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Hydrogeology",
    "dept": "GEOL",
    "num": "590H",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Earth Science",
    "dept": "GEOL",
    "num": "590I",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Mineral Resources",
    "dept": "GEOL",
    "num": "590J",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Geophysics",
    "dept": "GEOL",
    "num": "590K",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Mineralogy",
    "dept": "GEOL",
    "num": "590L",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Tectonics",
    "dept": "GEOL",
    "num": "590M",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Paleoecology and Paleoclimatology",
    "dept": "GEOL",
    "num": "590N",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Isotope Geochemistry",
    "dept": "GEOL",
    "num": "590O",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Computational Methods and GIS",
    "dept": "GEOL",
    "num": "590P",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Surface Hydrology",
    "dept": "GEOL",
    "num": "590R",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Oceanography",
    "dept": "GEOL",
    "num": "590S",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Seminar",
    "dept": "GEOL",
    "num": "595",
    "desc": "Prereq: Senior or graduate classification\nWeekly seminar on topics of current research interest. All students seeking a graduate degree must enroll during each semester of residence. Students pursuing a non-thesis option for the M.S. in Earth Science must enroll for one semester.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Graduate Seminar: Presentation Required",
    "dept": "GEOL",
    "num": "595A",
    "desc": "Prereq: Senior or graduate classification\nWeekly seminar on topics of current research interest. All students seeking a graduate degree must enroll during each semester of residence. Students pursuing a non-thesis option for the M.S. in Earth Science must enroll for one semester.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Graduate Seminar: Attendance Only",
    "dept": "GEOL",
    "num": "595B",
    "desc": "Prereq: Senior or graduate classification\nAttendance only. Weekly seminar on topics of current research interest. All students seeking a graduate degree must enroll during each semester of residence. Students pursuing a non-thesis option for the M.S. in Earth Science must enroll for one semester.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Creative Component",
    "dept": "GEOL",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Seminar",
    "dept": "GEOL",
    "num": "610",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Earth Materials",
    "dept": "GEOL",
    "num": "610A",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Economic Geology",
    "dept": "GEOL",
    "num": "610B",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Environmental Geochemistry",
    "dept": "GEOL",
    "num": "610C",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Geophysics",
    "dept": "GEOL",
    "num": "610D",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Geotectonics",
    "dept": "GEOL",
    "num": "610E",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Hydrogeology",
    "dept": "GEOL",
    "num": "610F",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Surficial Processes",
    "dept": "GEOL",
    "num": "610G",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Sedimentation and Stratigraphy",
    "dept": "GEOL",
    "num": "610H",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Paleoecology and Paleoclimatology",
    "dept": "GEOL",
    "num": "610I",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Isotope Geochemistry",
    "dept": "GEOL",
    "num": "610J",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Seminar: Computational Methods and GIS",
    "dept": "GEOL",
    "num": "610K",
    "desc": "Prereq: Graduate standing and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "GEOL",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Surficial Processes",
    "dept": "GEOL",
    "num": "699A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Stratigraphy",
    "dept": "GEOL",
    "num": "699B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Sedimentation",
    "dept": "GEOL",
    "num": "699C",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Paleontology",
    "dept": "GEOL",
    "num": "699D",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Petrology",
    "dept": "GEOL",
    "num": "699E",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Structural Geology",
    "dept": "GEOL",
    "num": "699F",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Geochemistry",
    "dept": "GEOL",
    "num": "699G",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Hydrogeology",
    "dept": "GEOL",
    "num": "699H",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Earth Science",
    "dept": "GEOL",
    "num": "699I",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Mineral Resources",
    "dept": "GEOL",
    "num": "699J",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Geophysics",
    "dept": "GEOL",
    "num": "699K",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Mineralogy",
    "dept": "GEOL",
    "num": "699L",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Tectonics",
    "dept": "GEOL",
    "num": "699M",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Paleoecology and Paleoclimatology",
    "dept": "GEOL",
    "num": "699N",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Isotope Geochemistry",
    "dept": "GEOL",
    "num": "699O",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Computational Methods and GIS",
    "dept": "GEOL",
    "num": "699P",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Surface Hydrology",
    "dept": "GEOL",
    "num": "699R",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Geoscience Education",
    "dept": "GEOL",
    "num": "699S",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Elementary German I",
    "dept": "GER",
    "num": "101",
    "desc": "\nBeginning level development of reading, writing, listening comprehension, and speaking in German within the context of German culture. For beginning-level learners who have little or no prior exposure to German.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary German II",
    "dept": "GER",
    "num": "102",
    "desc": "Prereq: GER 101\nBeginning level development of reading, writing, listening comprehension, and speaking in German within the context of German culture. For beginning level learners with only one semester of German (or exposure equivalent to two years or less in high school.).\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate German I",
    "dept": "GER",
    "num": "201",
    "desc": "Prereq: GER 102\nIntermediate level development of reading, writing, listening comprehension, and speaking in German within the context of German culture.   Intensive review of basic grammar covered in the first-year German class (or equivalent high school courses) while exploring cultural topics and themes.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate German II",
    "dept": "GER",
    "num": "202",
    "desc": "Prereq: GER 201\nIntermediate level development of reading, writing, listening comprehension, and speaking in German within the context of German culture. Emphasis on intermediate level grammar and communication about topics and themes beyond the personal realm.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Reading: Problems of the Early Twentieth Century",
    "dept": "GER",
    "num": "301",
    "desc": "Prereq: GER 202\nEmphasis on the development of reading skills through a variety of text types with a focus on German Culture from circa 1900 to 1933.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Composition",
    "dept": "GER",
    "num": "302",
    "desc": "Prereq: GER 202\nEmphasis on writing skills, with further development of grammar and reading skills using a variety of current and historical materials.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "German for Global Professionals",
    "dept": "GER",
    "num": "304",
    "desc": "Prereq: GER 202\nCommunication in business and professional contexts in German-speaking countries. Development of effective communication strategies and project management in the workplace. Cultural contexts of business and professional practice. Preparation for internships.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Conversation: The City in Contemporary Europe",
    "dept": "GER",
    "num": "305",
    "desc": "Prereq: GER 202 minimum, GER 301 recommended\nIntensive conversational and listening practice in German with an emphasis on a major German-speaking city.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Germany Today",
    "dept": "GER",
    "num": "320",
    "desc": "Prereq: GER 301 or GER 304\nSelected topics dealing with contemporary German society and culture. Introduction to materials, resources, and forms of communication available on the Internet, and in other electronic and print media.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "German Literature and Culture",
    "dept": "GER",
    "num": "330",
    "desc": "Prereq: GER 301 or permission of instructor\nSelected readings in German literature from Classicism to present. Emphasis on techniques of reading and analysis of literary texts.\n  No more than six credits of Ger 330 may be counted toward the major.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "German Studies in English",
    "dept": "GER",
    "num": "370",
    "desc": "Prereq: Sophomore classification. For fourth credit, 6 credits in German at the 300 level\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Three credits: English, open to all students. Four credits: Required for German concentration credit, supplementary readings and compositions in German.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation: German Topics on Women or Feminism",
    "dept": "GER",
    "num": "370G",
    "desc": "Prereq: Sophomore classification. For fourth credit, 6 credits in German at the 300 level\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Three credits: English, open to all students. Four credits: Required for German concentration credit, supplementary readings and compositions in German.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "The Holocaust in Text, Image, and Memory",
    "dept": "GER",
    "num": "371",
    "desc": "Prereq: Sophomore classification. For fourth credit, 6 credits in German at the 300 level\nExamination of such topics as the origins and expressions of Anti-Semitism in central Europe, the political events and structures of the Holocaust, the reality of ghettos and concentration camps, the impact of technological modernization on the Final Solution, and resistance to the Nazis. Materials will include non-fictional texts, literature, art, and music. Three credits: English, open to all students. Four credits: required for German major credit, supplementary readings and compositions in German. Four credits: required for German concentration credit, supplementary readings and compositions in German.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Grimms' Tales",
    "dept": "GER",
    "num": "375",
    "desc": "Prereq: Sophomore classification. For fourth credit, 6 credits in German at the 300 level\nIntroduction to Germanic antiquities, mythology, and heroic legends; Herder's concept of Naturpoesie. Emphasis on the Grimm tales: theoretical approaches to the tales from the late 19th and early 20th centuries; perversions of these traditional tales by the National Socialists (Nazis). Readings in contemporary Grimm scholarship. Taught in English. Three credits: English, open to all students. Four credits: required for German concentration credit, supplementary readings and compositions in German.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "German Film and Media Studies",
    "dept": "GER",
    "num": "378",
    "desc": "Prereq: Sophomore classification. For fourth credit, 6 credits in German at the 300 level\nAnalysis and interpretation of film or media in German society. Study of media production and reception within multicultural and global contexts. Thematic emphases based on faculty and student interest including: 1) film directors, genres, movements (e.g. New German Cinema), aesthetics, and cinematography or 2) media studies (e.g. television, mass press, popular culture). Three credits: English, open to all students. Four credits: required for German concentration credit, supplementary readings and compositions in German. Counts towards the World Film Studies Minor.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad",
    "dept": "GER",
    "num": "395",
    "desc": "Prereq: 2 years university-level German\nSupervised instruction in language and culture of Germany; formal class instruction at level appropriate to student's training, augmented by practical living experience.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in German Cultural Studies",
    "dept": "GER",
    "num": "476",
    "desc": "Prereq: Sophomore classification. For fourth credit, six credits in German at the 300-level courses instructed in German\nKey topics and themes in German history and culture up to the modern era.  Three credits: Taught in English, open to all students.  Four credits: Required for German concentration credit, supplementary readings and compositions in German.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "GER",
    "num": "490",
    "desc": "Prereq: 6 credits in German and permission of department chair\nDesigned to meet the needs of students who seek work in areas other than those in which courses are offered, or who desire to integrate a study of literature or language with special problems in major fields.\n  No more than 9 credits of Ger 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Internship in German",
    "dept": "GER",
    "num": "499",
    "desc": "Prereq: 9 credits of German at the 300 level; permission of advisor and the World Languages and Cultures Internship coordinator\nWork experience using German language skills in the public or private sector, combined with academic work under faculty supervision. Available only to majors and minors.\n  Offered on a satisfactory-fail basis only.  Ger 499 may be repeated to a maximum of 6 credits. No more than 3 credits of Ger 499 may be applied to the major.",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in German",
    "dept": "GER",
    "num": "590",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level German\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in German: Literature or Literary Criticism",
    "dept": "GER",
    "num": "590A",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level German\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in German: Linguistics",
    "dept": "GER",
    "num": "590B",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level German\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in German: Language Pedagogy",
    "dept": "GER",
    "num": "590C",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level German\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in German: Civilization",
    "dept": "GER",
    "num": "590D",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level German\n",
    "credits": "2"
  },
  {
    "course_name": "Adult Development",
    "dept": "GERON",
    "num": "234",
    "desc": "Prereq: HD FS 102 or PSYCH 230\nIntroductory exploration of the health, individual and social factors associated with adult development including younger adulthood, middle age and older adulthood. Information is presented from a life-span developmental framework.\n",
    "credits": "3"
  },
  {
    "course_name": "Death as a Part of Living",
    "dept": "GERON",
    "num": "373",
    "desc": "Prereq: HD FS 102\nConsideration of death in the life span of the individual and the family with opportunity for exploration of personal and societal attitudes.\n",
    "credits": "3"
  },
  {
    "course_name": "Aging and the Family",
    "dept": "GERON",
    "num": "377",
    "desc": "Prereq: HD FS 102\nInterchanges of the aged and their families. Emphasis on role changes, social interaction, and independence as influenced by health, finances, life styles, and community development.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Retirement Planning and Employee Benefits",
    "dept": "GERON",
    "num": "378",
    "desc": "Prereq: 3 credits in introductory economics\nEconomic well-being in the context of demographic change, the present and future of Social Security, family retirement needs analysis, investment strategies and characteristics of retirement plans, helping others to work towards financial security, family economic issues for retired persons. Overview of employee and retirement benefits.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Gerontechnology in Smart Home Environments",
    "dept": "GERON",
    "num": "414",
    "desc": "Prereq: COM S 227 or (COM S 207 or GERON 377 or ARTGR 271) or equivalent.\nAn interdisciplinary course designed for students who are interested in assistive technology, pervasive computing, mobile computing and principles of universal and inclusive design for end users, in particular, the elderly population. Students will work in semester-long projects as interdisciplinary teams to apply knowledge obtained from lectures and mutual presentations. For graduate credit students are required to submit a research report and give an oral presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Gerontechnology in Smart Home Environments",
    "dept": "GERON",
    "num": "415",
    "desc": "Prereq: COM S 227 or (COM S 207 or GERON 377)\nAn interdisciplinary course designed for students who are interested in assistive technology, pervasive computing, mobile computing and principles of universal software design for end users, in particular the elderly population.  Students will have the chance to learn both about the theories and principles about aging and assistive technology, as well as to engage in the practical semester-long project while working with students from other disciplines.\n",
    "credits": "3"
  },
  {
    "course_name": "Environments for the Aging",
    "dept": "GERON",
    "num": "463",
    "desc": "Prereq: HD FS 360 or 3 credits in housing, architecture, interior design, rehabilitation, psychology, or human development and family studies or permission of instructor\nEmphasis on independent living within residential settings including specialized shelter, supportive services and housing management. Application of criteria appropriate for accessibility and functional performance of activities; universal design principles. Creative project provides service learning opportunities. (on-line course offering via Distance Education).\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Gerontology Prepracticum Seminar",
    "dept": "GERON",
    "num": "466",
    "desc": "Prereq: 9 credits in core courses for the gerontology minor and approval of the gerontology undergraduate coordinator\nPrepracticum training for students planning a gerontology practicum. Exploration of possible agencies for the practicum, in-depth study of a selected agency, and development of goals and objectives for the practicum.\n",
    "credits": "1"
  },
  {
    "course_name": "Gerontology Practicum",
    "dept": "GERON",
    "num": "467",
    "desc": "Prereq: GERON 466, advance reservation\nSupervised field experience related to aging.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "GERON",
    "num": "490",
    "desc": "\nConsult program coordinator for procedure.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar",
    "dept": "GERON",
    "num": "501",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Survey of Gerontology",
    "dept": "GERON",
    "num": "510",
    "desc": "\nProvides an overview of important gerontological issues.\n",
    "credits": "1"
  },
  {
    "course_name": "Gerontechnology in Smart Home Environments",
    "dept": "GERON",
    "num": "514",
    "desc": "Prereq: COM S 227 or (COM S 207 or GERON 377 or ARTGR 271) or equivalent.\nAn interdisciplinary course designed for students who are interested in assistive technology, pervasive computing, mobile computing and principles of universal and inclusive design for end users, in particular, the elderly population. Students will work in semester-long projects as interdisciplinary teams to apply knowledge obtained from lectures and mutual presentations. For graduate credit students are required to submit a research report and give an oral presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Women and Aging",
    "dept": "GERON",
    "num": "520",
    "desc": "\nWomen and Aging is the study of theory, research and application of issues related to women and the aging experience. This course will examine gender differences in areas such as health, mental health, income security, crime, and public policy.  Attention will be given to ways in which younger women can prepare to meet the challenges and opportunities awaiting them as they age.\n",
    "credits": "3"
  },
  {
    "course_name": "Biological Principles of Aging",
    "dept": "GERON",
    "num": "521",
    "desc": "\nBasic biological principles of aging. Course modules include an introduction to the aging process, body systems and normal aging, and environment and the biology of aging.  In addition, disorders and diseases of aging, prevention and treatment and exercise and aging topics will be covered.\n",
    "credits": "3"
  },
  {
    "course_name": "Long-Term Care",
    "dept": "GERON",
    "num": "522",
    "desc": "\nAdministration principles involved in the planning, organizing and directing of long-term care agencies.  Includes an in-depth exposure to federal and state standards and regulations governing long-term care.\n",
    "credits": "3"
  },
  {
    "course_name": "Mental Health and Aging",
    "dept": "GERON",
    "num": "523",
    "desc": "\nIntroduction to the range of issues involved in aging and mental health.  From a systems framework the major emotional and psychiatric problems encountered in old age will be examined including mood, anxiety, adjustment and personality disorders, dementia, cognitive problems, substance abuse, and suicide. Barriers to treatment and cohort and cultural issues will be explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Health",
    "dept": "GERON",
    "num": "524",
    "desc": "\nCognitive skills form the foundation for functioning in everyday life and these skills take on added importance in older adulthood. This course focuses on selected theoretical approaches and current research related to cognitive aging. We will review normative and non-normative cognitive changes, assessment techniques, and prevention/intervention efforts. Throughout the course we will keep the role of environment and life-span implications in the forefront of our discussion.\n",
    "credits": "3"
  },
  {
    "course_name": "Perspectives in Gerontology",
    "dept": "GERON",
    "num": "530",
    "desc": "\nOverview of current aging issues including theory and research, critical social and political issues in aging, the interdisciplinary focus of gerontology, career opportunities, and aging in the future. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Adult Development",
    "dept": "GERON",
    "num": "534",
    "desc": "\nExploration of the biological, psychological and social factors associated with aging. Although the focus is on the later years, information is presented from a life-span developmental framework. Empirical studies are reviewed and their strengths, limitations and implications for normative and optimal functioning are discussed. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Nutrition and Physical Activity in Aging",
    "dept": "GERON",
    "num": "540",
    "desc": "\nWWW only. Basic physiologic changes during aging and their impacts in health and disease. The focus will be on successful aging with special emphasis on physical activity and nutrition. Practical application to community settings is addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Economics, Public Policy, and Aging",
    "dept": "GERON",
    "num": "545",
    "desc": "\nPolicy development in the context of the economic status of the older adult population. Retirement planning and the retirement decisions; social security and public transfer programs; intra-family transfers to/from the aged; private pensions; financing medical care; prospects and issues for the future.\n",
    "credits": "3"
  },
  {
    "course_name": "Environments for the Aging",
    "dept": "GERON",
    "num": "563",
    "desc": "Prereq: HD FS 360 or 3 credits in housing, architecture, interior design, rehabilitation, psychology, or human development and family studies or permission of instructor\nEmphasis on independent living within residential settings including specialized shelter, supportive services and housing management. Application of criteria appropriate for accessibility and functional performance of activities; universal design principles. Creative project provides service learning opportunities. (on-line course offering via Distance Education).\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Design for All People",
    "dept": "GERON",
    "num": "571",
    "desc": "Prereq: Graduate or Senior classification\nPrinciples and procedures of inclusive design in response to the varying ability level of users. Assessment and analysis of existing buildings and sites with respect to standards and details of accessibility for all people, including visually impaired, mentally impaired, and mobility restricted users. Design is neither a prerequisite nor a required part of the course. Enrollment open to students majoring in related disciplines. Credit counts toward fulfillment of History, Theory, Culture requirements.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Aging in the Family Setting",
    "dept": "GERON",
    "num": "577",
    "desc": "Prereq: 9 credits in social sciences or permission of instructor\nTheories and research related to personal and family adjustments in later life affecting older persons and their intergenerational relationships. Related issues including demographics also are examined through the use of current literature. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Program Evaluation and Research Methods in Gerontology",
    "dept": "GERON",
    "num": "584",
    "desc": "\nOverview of program evaluation, research methods, and grant writing in gerontology. Includes application of quantitative and qualitative methods in professional settings. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "GERON",
    "num": "590",
    "desc": "\nConsult program coordinator for procedure.\n",
    "credits": "arr"
  },
  {
    "course_name": "Internship",
    "dept": "GERON",
    "num": "591",
    "desc": "\nSupervised experience in an area of gerontology.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Seminar in Gerontology",
    "dept": "GERON",
    "num": "594",
    "desc": "\nAn integrative experience for gerontology students designed to be taken near the end of the degree program. By applying knowledge gained in earlier coursework, students will strengthen skills in ethical decision-making behavior, applying these skills in gerontology-related areas such as advocacy, professionalism, family and workplace issues. Students from a variety of professions will bring their unique perspectives to bear on topics of common interest. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "GERON",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Adult Development, Aging, and Health",
    "dept": "GERON",
    "num": "635",
    "desc": "Prereq: HD FS 510 or permission of instructor\nReview of the impact of the growing older adult population as well as individual development and aging on individuals, families, and society. Exploration of theoretical perspectives applied to adult development and aging and distinction of normative and non-normative changes in adulthood. Discussion of methods to assess development across adulthood and consideration of the role of individual and environmental factors impacting efforts to optimize adult development.(on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "GERON",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Orientation",
    "dept": "GLOBE",
    "num": "110",
    "desc": "\nAn introduction to Global Resource Systems (GRS) program. University and career acclimation, development of educational and professional skills, participation in GRS Learning Community.  Assessed service-learning component.\n",
    "credits": "1"
  },
  {
    "course_name": "Geography of Global Resource Systems",
    "dept": "GLOBE",
    "num": "120",
    "desc": "\nA survey of geographic concepts with a specific focus on the distribution of natural and human-generated resources and the demand for those resources on a global scale.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Resource Systems",
    "dept": "GLOBE",
    "num": "201",
    "desc": "\nA comparative analysis of global resources and the various natural and human systems affecting those resources.  Assessed service-learning component.\n",
    "credits": "3"
  },
  {
    "course_name": "Issues in Global Resource Systems",
    "dept": "GLOBE",
    "num": "211",
    "desc": "\nDiscussion of topics of current importance in global resource systems.\n  Offered on a satisfactory-fail basis only.  A maximum of 3 credits of 211 may be used towards degree requirements.",
    "credits": "1"
  },
  {
    "course_name": "Globalization and Sustainability",
    "dept": "GLOBE",
    "num": "220",
    "desc": "\nAn introduction to understanding the key global issues in sustainability. Focuses on interconnected roles of energy, materials, human resources, economics, and technology in building and maintaining sustainable systems. Applications discussed will include challenges in both the developed and developing world and will examine the role of technology in a resource-constrained world.\n  Cannot be used for technical elective credit in any engineering department.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Apprenticeship",
    "dept": "GLOBE",
    "num": "221",
    "desc": "Prereq: Approval by the Global Resource Systems Faculty Coordinator\nPractical work experience in approved domestic or international settings such as with a company, research laboratory, governmental agency or non-governmental organization.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Independent Study",
    "dept": "GLOBE",
    "num": "290",
    "desc": "Prereq: Permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nIndependent study on topics of special interest to the student. Comprehensive report required. Intended primarily for first-year students and sophomores.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "GLOBE",
    "num": "290H",
    "desc": "Prereq: Permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nIndependent study on topics of special interest to the student. Comprehensive report required. Intended primarily for first-year students and sophomores.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural, Food and Natural Global Resource Systems",
    "dept": "GLOBE",
    "num": "303",
    "desc": "Prereq: GLOBE 201, ECON 101 or ECON 102\nIn-depth analysis of the opportunities, constraints and consequences of agricultural, food and natural resource systems. Topics integrate global natural resources with agriculture and food systems, nutrition and health, sustainable development, and societal structures, including gender, migration and urbanization. Course content utilizes a systems approach.\n",
    "credits": "3"
  },
  {
    "course_name": "Socio-Economic Global Resource Systems",
    "dept": "GLOBE",
    "num": "304",
    "desc": "Prereq: GLOBE 201, ECON 101 or ECON 102\nIn-depth analysis of the opportunities, constraints and consequences of social, economic and political global resource systems. Topics integrate agriculture and food production, globalization, population, economic planning, energy, security, trade, and policy and their role in defining different world regions. Course content utilizes a systems approach.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Resource Systems Internship Preparation",
    "dept": "GLOBE",
    "num": "320",
    "desc": "Prereq: Permission of instructor.\nStudents enrolled in this course intend to enroll in GLOBE 321 or 322 in the following term.  Topics provide a pre-departure orientation, including logistical, academic, cultural, and personal requirements for completion of an experiential supervised work experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Internship - Global",
    "dept": "GLOBE",
    "num": "321",
    "desc": "Prereq: GLOBE 320, Junior or Senior and enrollment in Global Resource Systems major; permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nA supervised learning experience including an analysis of an international location's resource system via immersion in a foreign culture lasting at least five weeks. The experience should focus on the region consistent with the student's degree track.  Course expenses paid by student.\n  A maximum of 12 credits of GLOBE 321 and 322 may be used for degree requirements.",
    "credits": "3"
  },
  {
    "course_name": "Internship - United States",
    "dept": "GLOBE",
    "num": "322",
    "desc": "Prereq: GLOBE 320, Junior or Senior and enrollment in Global Resource Systems major; permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nA supervised learning experience including an analysis of a domestic location's resource system via immersion in a different culture within the United States lasting at least five weeks. Designed for international students and for students who are not in a position to leave the United States.  Course expenses paid by student.\n  A maximum of 12 credits of Globe 321 and 322 may be used for degree requirements.",
    "credits": "3"
  },
  {
    "course_name": "The Economics of Global Agricultural Food and Bio-energy",
    "dept": "GLOBE",
    "num": "335",
    "desc": "Prereq: ECON 101\nApplied economic analysis of the determinants of world agricultural production, marketing, and use in feed, food, fiber, biofuel, and other applications, and global food processing and consumption.  Analysis of market case studies and various data on global agricultural production and transformation, land and resource use, demography, economic activity, nutrition and health trends.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Economic Development",
    "dept": "GLOBE",
    "num": "385",
    "desc": "Prereq: ECON 101, ECON 102\nCurrent problems of developing countries, theories of economic development, agriculture, and economic development, measurement and prediction of economic performance of developing countries, alternative policies and reforms required for satisfying basic needs of Third World countries, interrelationships between industrialized countries and the developing countries, including foreign aid.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "GLOBE",
    "num": "398",
    "desc": "Prereq: Permission of faculty coordinator for the major.\nStudents must complete GLOBE 398 Cooperative Education Approval Form and register for GLOBE 398 before commencing each work period. Work periods for students in cooperative education related to Global Resource Systems.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Senior Project",
    "dept": "GLOBE",
    "num": "401",
    "desc": "Prereq: Senior classification in Global Resource Systems\nResearch project in collaboration with faculty that complements and furthers a student's experiences from GLOBE 321 and 322 while simultaneously bringing into focus entire four-year experience. Student will write a research report and make either an oral or poster presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Senior Project, Honors",
    "dept": "GLOBE",
    "num": "401H",
    "desc": "Prereq: Senior classification in Global Resource Systems\nResearch project in collaboration with faculty that complements and furthers a student's experiences from GLOBE 321 and 322 while simultaneously bringing into focus entire four-year experience. Student will write a research report and make either an oral or poster presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Responses to Global Resource System Challenges",
    "dept": "GLOBE",
    "num": "402",
    "desc": "\nCapstone analysis of critical global resource challenges facing both developed and developing countries.  Students will use research skills to investigate specific global resource issues and use communications skills to work as a team to integrate their research, develop an interdisciplinary perspective, and evaluate potential solutions to resource challenges.\n",
    "credits": "3"
  },
  {
    "course_name": "International Animal Agriculture",
    "dept": "GLOBE",
    "num": "441",
    "desc": "Prereq: Two courses from AN S 223, AN S 225, AN S 226, AN S 229, AN S 235\nAn overview of animal agriculture with emphasis in developing countries. Historical, economic, environmental, and political considerations will be assessed and evaluated. Issues related to gender, resilience and sustainability for different production systems including alternative livestock species, will be investigated. The role of animal source foods in attainment of global food security will be discussed.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "International Issues and Challenges in Sustainable Development",
    "dept": "GLOBE",
    "num": "446",
    "desc": "Prereq: 3-credit biology course, Sophomore or higher classification, permission of Instructor\nInterdisciplinary study and analysis of agricultural systems, sustainable management, and impact on plants and animal biodiversity. International field experience in evaluating different agricultural systems and impact on biodiversity may be required. A program fee is charged to students for international study abroad.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "GLOBE",
    "num": "490",
    "desc": "Prereq: Permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nIndependent study on topics of special interest to the student.  Comprehensive report required. Intended primarily for juniors and seniors.\n  A maximum of 9 credits of all (university-wide) 490 courses may be used for degree requirements.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: General",
    "dept": "GLOBE",
    "num": "490A",
    "desc": "Prereq: Permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nIndependent study on topics of special interest to the student.  Comprehensive report required. Intended primarily for juniors and seniors.\n  A maximum of 9 credits of all (university-wide) 490 courses may be used for degree requirements.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "GLOBE",
    "num": "490E",
    "desc": "Prereq: Permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nIndependent study on topics of special interest to the student.  Comprehensive report required. Intended primarily for juniors and seniors.\n  A maximum of 9 credits of all (university-wide)490 courses may be used for degree requirements.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "GLOBE",
    "num": "490H",
    "desc": "Prereq: Permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nIndependent study on topics of special interest to the student.  Comprehensive report required. Intended primarily for juniors and seniors.\n  A maximum of 9 credits of all (university-wide) 490 courses may be used for degree requirements.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Service Learning",
    "dept": "GLOBE",
    "num": "490Z",
    "desc": "Prereq: Permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nIndependent study on topics of special interest to the student.  Comprehensive report required. Intended primarily for juniors and seniors.  Assessed service-learning component.\n  A maximum of 9 credits of all (university-wide) 490 courses may be used for degree requirements.",
    "credits": "1"
  },
  {
    "course_name": "Service Learning",
    "dept": "GLOBE",
    "num": "494",
    "desc": "Prereq: Permission of instructor.\nSelected projects that result in outcomes benefiting a non-Iowa State University entity while instilling a professional ethics and accomplishing student learning goals.  Course expenses paid by student.  Assessed service-learning component.\n",
    "credits": "arr"
  },
  {
    "course_name": "Service Learning: International",
    "dept": "GLOBE",
    "num": "494A",
    "desc": "Prereq: Permission of instructor.\nSelected projects that result in outcomes benefiting a non-Iowa State University entity while instilling a professional ethics and accomplishing student learning goals.  Course expenses paid by student.  Assessed service-learning component.\n",
    "credits": "arr"
  },
  {
    "course_name": "Service Learning: Domestic",
    "dept": "GLOBE",
    "num": "494B",
    "desc": "Prereq: Permission of instructor.\nSelected projects that result in outcomes benefiting a non-Iowa State University entity while instilling a professional ethics and accomplishing student learning goals.  Course expenses paid by student.  Assessed service-learning component.\n",
    "credits": "arr"
  },
  {
    "course_name": "Service Learning:  U.S. Diversity Project",
    "dept": "GLOBE",
    "num": "494C",
    "desc": "Prereq: Permission of Instructor\nSelected projects that result in outcomes benefiting a non-Iowa State University entity, while instilling professional ethics and accomplishing student learning goals.  Academic work under faculty supervision may include written reports, presentations, and guided readings.  Course expenses paid by student.  Assessed service-learning component.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Global Resource Systems Study Abroad Course Preparation",
    "dept": "GLOBE",
    "num": "495",
    "desc": "Prereq: Permission of instructor\nGlobal resource systems topics will include the agricultural industries, climate, crops, culture, economics, food, geography, government, history, livestock, marketing, natural resources, public policies, soils, and preparation for travel to locations to be visited. Students enrolled in this course intend to register for GLOBE 494A, 496 or 497 the following term.\n",
    "credits": "1"
  },
  {
    "course_name": "Global Resource Systems Study Abroad",
    "dept": "GLOBE",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nExtended field trips abroad to study global resource systems.  Location and duration of trips will vary. Pre-trip sessions arranged through GLOBE 495. Trip expenses paid by student.\n\nMeets International Perspectives Requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Deans Global Ag and Food Leadership Program",
    "dept": "GLOBE",
    "num": "497",
    "desc": "Prereq: Permission of instructor\nAn integrated agricultural and food production and policy program that allows students to assess, analyze and evaluate complex, country-specific situations and to develop their skills, knowledge and abilities via team-oriented projects that involve complex issues such as development of effective foreign food aid and agricultural and food production systems, drivers of world hunger, sustainable resource management and efficacy of policy, and the role of the USA and the United Nations and other development agencies in these systems. International location and duration of program will vary. Pre-trip sessions arranged through GLOBE 495. Trip expenses paid by students.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "GLOBE",
    "num": "499",
    "desc": "Prereq: Permission of the instructor and approval by the Global Resource Systems Faculty Coordinator\nResearch projects in collaboration with faculty.\n",
    "credits": "arr"
  },
  {
    "course_name": "Preparing Publishable Thesis Chapters",
    "dept": "GR ST",
    "num": "529",
    "desc": "Prereq: Instructor permission\nReporting original research results within the norms for writing of a student's discipline. Emphasis on preparing thesis/dissertation chapters that will be both acceptable to the Graduate College and ready for submission to a refereed journal in the student's discipline. Focus on reporting student-generated data, norms for discourse within disciplines, and how thesis chapters differ from journal manuscripts.\n",
    "credits": "3"
  },
  {
    "course_name": "Responsible Conduct of Research in Science and Engineering",
    "dept": "GR ST",
    "num": "565",
    "desc": "Prereq: Graduate classification\nEthical and legal issues facing researchers in the sciences and engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Communications in Science",
    "dept": "GR ST",
    "num": "566",
    "desc": "Prereq: graduate classification\nReading and reviewing manuscripts; publishing papers; oral and poster presentations.\n",
    "credits": "0"
  },
  {
    "course_name": "Time Management and Mentoring",
    "dept": "GR ST",
    "num": "567",
    "desc": "Prereq: graduate classification\nBalancing life and career; mentoring; lab management.\n",
    "credits": "0"
  },
  {
    "course_name": "The Interview Process",
    "dept": "GR ST",
    "num": "568",
    "desc": "Prereq: graduate classification.\nApplying and interviewing for academia, industry and government.\n",
    "credits": "0"
  },
  {
    "course_name": "Grant Writing",
    "dept": "GR ST",
    "num": "569",
    "desc": "Prereq: at least two prior years of graduate classification.\nWriting a winning proposal.\n",
    "credits": "1"
  },
  {
    "course_name": "Teaching Practices",
    "dept": "GR ST",
    "num": "570",
    "desc": "Prereq: graduate classification.\nPreparation of a teaching portfolio and course materials; lecturing, technology.\n",
    "credits": "0"
  },
  {
    "course_name": "Preparing Future Faculty Introductory Seminar",
    "dept": "GR ST",
    "num": "585",
    "desc": "Prereq: One year of graduate course work; admission into PFF program\nIntroduction to faculty life issues such as hiring, tenure, teaching, and service at a variety of higher education institutions. Includes presentations from faculty at other institutions.\n",
    "credits": "2"
  },
  {
    "course_name": "Preparing Future Faculty Intermediate Seminar",
    "dept": "GR ST",
    "num": "586",
    "desc": "Prereq: Admission into PFF program; completion of 585 or permission of instructor\nConsideration of a wide range of faculty life issues. Includes topics such as higher education trends, diversity issues, learning styles, assessment, grant and proposal writing, and legal and ethical issues. Written components include job and teaching portfolios.\n",
    "credits": "1"
  },
  {
    "course_name": "Preparing Future Faculty Teaching Practicum",
    "dept": "GR ST",
    "num": "587",
    "desc": "Prereq: Permission of instructor, GR ST 585, credit for or concurrent enrollment in GR ST 586\nStudents complete a stand-alone teaching assignment at Iowa State or another higher education institution. Written components include pedagogical documents.\n",
    "credits": "1"
  },
  {
    "course_name": "Preparing Future Faculty Special Topics",
    "dept": "GR ST",
    "num": "588",
    "desc": "Prereq: Permission of instructor, GR ST 585, credit for or concurrent enrollment in GR ST 586\nIn-depth study of topic providing academic professional development.\n",
    "credits": "1"
  },
  {
    "course_name": "Summer Graduate Assistant",
    "dept": "GR ST",
    "num": "633",
    "desc": "\nOnly for students not registered in other courses in the summer term.\n",
    "credits": "R"
  },
  {
    "course_name": "Doctoral Post Prelim (Continuous) Registration",
    "dept": "GR ST",
    "num": "680",
    "desc": "\nReserved for Ph.D. candidates only. See the Graduate College Handbook for specific requirements.\n",
    "credits": "R"
  },
  {
    "course_name": "Required Registration",
    "dept": "GR ST",
    "num": "681",
    "desc": "\nRequired registration for graduate students when they have no mandatory classes left to take. Students need to register for Section A, B, or C.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Required Registration:  Doctoral Continuous Registration",
    "dept": "GR ST",
    "num": "681A",
    "desc": "Prereq: Must have taken and passed preliminary oral exam.\n  Offered on a satisfactory-fail basis only.  Credits may not count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Required Registration: Final Exam Only",
    "dept": "GR ST",
    "num": "681B",
    "desc": "Prereq: Completed all necessary program requirements to take final exam.\n  Offered on a satisfactory-fail basis only.  This course cannot be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Required Registration: Graduate Assistant Enrollment",
    "dept": "GR ST",
    "num": "681C",
    "desc": "Prereq: Student needs to be a Graduate Assistant\n  Offered on a satisfactory-fail basis only.  The course cannot count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Curricular Practical Training",
    "dept": "GR ST",
    "num": "697",
    "desc": "\nProfessional work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Graphic Design Studio I",
    "dept": "ARTGR",
    "num": "270",
    "desc": "Prereq: DSN S 102, DSN S 131 and enrollment in ARTGR 275; admission to the graphic design program through department review\nBasic design concepts and color principles used for visual communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Studio II",
    "dept": "ARTGR",
    "num": "271",
    "desc": "Prereq: ART 230, ARTGR 270, ARTGR 275 and enrollment in ARTGR 276\nPrinciples of typographic composition, structure and hierarchy. Formal and conceptual principles of symbology.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Photography for Graphic Design",
    "dept": "ARTGR",
    "num": "272",
    "desc": "Prereq: Concurrent enrollment in ARTGR 270 OR ARTGR 271\nThis course will address the development of \"seeing\" as a medium design, expression, and visual communication including compositional dynamics, advanced digital image manipulation, software usage and support, digital camera operations along with scanning and other digital input devices, color management, digital format for presentation and printing with digital ready formats.\n",
    "credits": "3"
  },
  {
    "course_name": "Typography I",
    "dept": "ARTGR",
    "num": "273",
    "desc": "Prereq: Concurrent enrollment in ARTGR 270\nEmphasizes foundational typographic principles from letterform construction to hierarchies of extended text, directed toward typographic vocabulary, and typographic organization. Students will also understand both classical and contemporary typographic forms, as well as having the ability to construct typographic compositions and systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Typography II",
    "dept": "ARTGR",
    "num": "274",
    "desc": "Prereq: Concurrent enrollment in ARTGR 271\nAdvances the skills and principles learned in Graphic Design Typography I. Exploration of more complex problems that address typographic hierarchy, context, sequence and typography and image.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Technology I",
    "dept": "ARTGR",
    "num": "275",
    "desc": "Prereq: concurrent enrollment in ARTGR 270\nBasic 2-dimensional computer skills for graphic design.\n",
    "credits": "2"
  },
  {
    "course_name": "Graphic Technology II",
    "dept": "ARTGR",
    "num": "276",
    "desc": "Prereq: ARTGR 275 and concurrent enrollment in ARTGR 271\nBasic 3-dimensional computer skills for graphic design.\n",
    "credits": "2"
  },
  {
    "course_name": "Visual Communication and Branding",
    "dept": "ARTGR",
    "num": "281",
    "desc": "\nIntroduction to basic principles of visual communication that contribute to the successful comprehension of intended visual messages; these include promotional messages, such as corporate branding and marketing campaigns, as well as informational messages, such as those used in computer interface design or in the clear presentation of diagrammatic data. Emphasis is placed on sensitivity to the diversity of the intended American or global audience, and to the cross-cultural differences that may affect the ways that visual messages are interpreted. Methods for creating brand experiences are explored as they apply to both small and large enterprises, ranging from personal brand to corporate brand identities.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Studio III",
    "dept": "ARTGR",
    "num": "370",
    "desc": "Prereq: ARTGR 271, ARTGR 276, and credit or concurrent enrollment in ARTGR 387\nCreation and design of images and symbols for communication. Application and integration of typography with images and symbols.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Studio IV",
    "dept": "ARTGR",
    "num": "371",
    "desc": "Prereq: ARTGR 370 and ARTGR 387\nDevelopment and preparation of design concepts for application to the printing and electronic publishing process. Creative problem-solving skills, introduction to systems design.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Materials and Processes",
    "dept": "ARTGR",
    "num": "372",
    "desc": "Prereq: Credit or concurrent enrollment in ARTGR 371\nLecture about the processes and materials involved in graphic design arts reproduction. Course covers pre-press, paper selection and specification, ink systems, type systems and fonts, output technology, printing presses and bindery operations.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Internship Seminar",
    "dept": "ARTGR",
    "num": "377",
    "desc": "Prereq: Credit or concurrent enrollment in ARTGR 370 or ARTGR 371\nProcedural and ethical concerns related to the graphic design internship. Personal goals, preparation of resume and plans for internship. Study and tours of areas of interest within the graphic design profession.\n",
    "credits": "1"
  },
  {
    "course_name": "Critical Issues in Graphic Design",
    "dept": "ARTGR",
    "num": "378",
    "desc": "Prereq: Credit or concurrent enrollment in ARTGR 370\nLecture, discussion and writing about the critical issues facing the communications field today and in the future.\n",
    "credits": "2"
  },
  {
    "course_name": "Graphic Design History/Theory/ Criticism I",
    "dept": "ARTGR",
    "num": "387",
    "desc": "\nLate nineteenth century to the 1990s. This course will explore the cultural, social, political, industrial, and technological forces that have influenced the practice of graphic design in Britain, Europe, and the United States. Students will study the historical issues and problems facing designers, their clients, and their publics.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design History/Theory/ Criticism II",
    "dept": "ARTGR",
    "num": "388",
    "desc": "\nCritical issues that affect the contemporary practice of graphic design as it relates to the United States. Students will study a variety of issues that include, but are not exclusive to, new media, gender, class, design and the public sphere, design as social action, postmodern design theory, sustainability, and ethical practice.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Field Study",
    "dept": "ARTGR",
    "num": "391",
    "desc": "Prereq: Concurrent enrollment in 300 or 400 level graphic design studio course\nTravel, study, and tours of areas of interest within the graphic design profession such as print production companies, design studios, and museums.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "3D Motion Graphics",
    "dept": "ARTGR",
    "num": "463",
    "desc": "Prereq: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470\n3D visualization in a Motion Graphics context. Emphasis on design in 3D computer animation as it relates to various electronic media.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Imaging",
    "dept": "ARTGR",
    "num": "464",
    "desc": "Prereq: Concurrent enrollment in ARTGR 370, ARTGR 371 or ARTGR 470.\nStudio in experimental techniques using the digital drawing tablet combined with manual drawing mediums, exploring the digital tablet, scanner, and camera as ways to collect and make images, conceptual and compositional development of digital techniques and software, and connecting digital techniques to visual processes and ideation. Students will have a better understanding of different ways of working digitally while exploring image-making processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Studio V",
    "dept": "ARTGR",
    "num": "470",
    "desc": "Prereq: ARTGR 371\nAdvanced design systems as applied to corporate identity and environmental graphic design. Symbology as an integrated component of communication systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Capstone",
    "dept": "ARTGR",
    "num": "471",
    "desc": "Prereq: ARTGR 470 or permission of instructor\nExperience design and innovation in a multi-disciplinary design studio. Class will use unique research, design, evaluation, creativity, and innovation methodologies to solve human problems on special topics. Designed solutions will be in the form of products, artifacts, interfaces, information, and human environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Photography and Narrative Message",
    "dept": "ARTGR",
    "num": "472",
    "desc": "Prereq: Enrollment in ARTGR 370, ARTGR 371, ARTGR 470, or ARTGR 471\nPhotography as a tool for creating conceptually-driven images and metaphors. Emphasis is on photography as an evocative storytelling device for a range of audiences and design applications. Compositional and technical aspects are explored to ensure successful interpretation of the photograph's intended message.\n",
    "credits": "3"
  },
  {
    "course_name": "Multimedia Design",
    "dept": "ARTGR",
    "num": "473",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470 Graduate: graduate enrollment in College of Design\nThe design of visual, aural and textual communication for electronic media.\n",
    "credits": "3"
  },
  {
    "course_name": "Exhibition Design",
    "dept": "ARTGR",
    "num": "474",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470 Graduate: graduate enrollment in College of Design\nVisual communication applied to exhibition design focusing on educational or interactive museum exhibitions, trade show booth design, and modular unit design for traveling exhibitions. Translation of graphic information to a three-dimensional space.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Typography",
    "dept": "ARTGR",
    "num": "475",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470 Graduate: graduate classification in College of Design\nTypographic theory exploring traditional and non-traditional forms, both historical and contemporary typographic achievements.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Methodology",
    "dept": "ARTGR",
    "num": "476",
    "desc": "Prereq: Undergraduate:  Concurrent enrollment in ARTGR 370, ARTGR 371 or ARTGR 470 Graduate: graduate enrollment in College of Design\nAnalysis and application of scientific, systematic, and non-traditional problem-solving and problem-seeking techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Practicum",
    "dept": "ARTGR",
    "num": "477",
    "desc": "Prereq: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470\nGraphic design outreach and problem solving. Individual and group projects for non-profit clients selected by the instructor.\n",
    "credits": "3"
  },
  {
    "course_name": "Design for E-Commerce/Graphic Applications",
    "dept": "ARTGR",
    "num": "478",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470. Graduate: Graduate enrollment in College of Design\nThe development of advanced and experimental web design for the applications of e-commerce, education and the communication of visual information.\n",
    "credits": "3"
  },
  {
    "course_name": "Wayfinding Design",
    "dept": "ARTGR",
    "num": "479",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470. Graduate: Graduate enrollment in College of Design\nStudy of the navigational challenges of built environments and outdoor spaces, including site analysis, development of navigational plans, and design of wayfinding sign systems.  Issues of function, accessibility, legibility, and fabrication are considered.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Internship",
    "dept": "ARTGR",
    "num": "480",
    "desc": "Prereq: ARTGR 377, 12 credits in graphic design; permission of instructor, registration in advance of enrollment\nGraphic design experience in an off-campus professional environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Professional Practices",
    "dept": "ARTGR",
    "num": "481",
    "desc": "Prereq: Credit or concurrent enrollment in ARTGR 470\nProfessional design management: ethics, setting up a new business, client/designer relationships, contractual options, billing practices, and effective operating procedures.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Presentation",
    "dept": "ARTGR",
    "num": "482",
    "desc": "Prereq: ARTGR 470 and concurrent enrollment in ARTGR 471\nExploration and development of the graphic design portfolio and resume in electronic, print, and photographic form.\n",
    "credits": "2"
  },
  {
    "course_name": "Selected Studies in Graphic Design",
    "dept": "ARTGR",
    "num": "484",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470. Graduate: graduate enrollment in College of Design.\nSpecial issues related to graphic design. Topics vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "ARTGR",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed related graphic design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Theory, Criticism, and Methodology",
    "dept": "ARTGR",
    "num": "490A",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed related graphic design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Two-Dimensional Design",
    "dept": "ARTGR",
    "num": "490B",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed related graphic design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Three-Dimensional Design",
    "dept": "ARTGR",
    "num": "490C",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed related graphic design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "ARTGR",
    "num": "490H",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed related graphic design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Internship/Cooperative (in-depth experience other than ArtGr 480)",
    "dept": "ARTGR",
    "num": "490I",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed related graphic design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Publication Design: Magazines",
    "dept": "ARTGR",
    "num": "491",
    "desc": "Prereq: Graduate enrollment in College of Design\nThe philosophy, concepts and structures of magazine design.\n",
    "credits": "3"
  },
  {
    "course_name": "Publication Design: Books",
    "dept": "ARTGR",
    "num": "492",
    "desc": "Prereq: Graduate enrollment in College of Design\nThe philosophy, concepts and structures of book design.\n",
    "credits": "3"
  },
  {
    "course_name": "Workshop",
    "dept": "ARTGR",
    "num": "493",
    "desc": "Prereq: Evidence of satisfactory experience in area of specialization\nIntensive 2 to 4 week studio exploration. Topics vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Graphic Design in Europe Seminar",
    "dept": "ARTGR",
    "num": "494",
    "desc": "Prereq: Permission of instructor and planned enrollment in ARTGR 495.\nCultural and historical aspects of art and design in Western Europe in preparation for study abroad. Area of study varies each time offered.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Graphic Design Abroad",
    "dept": "ARTGR",
    "num": "495",
    "desc": "Prereq: Permission of instructor\nInternational study abroad program with visits to design studios, art museums, and educational facilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Field Study",
    "dept": "ARTGR",
    "num": "496",
    "desc": "Prereq: Concurrent enrollment in a graphic design studio and permission of instructor.\nStudy and tours of museums, galleries, artist and/or designer studios and other areas of interest within art and design.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Graphic Design Field Study",
    "dept": "ARTGR",
    "num": "497",
    "desc": "Prereq: Acceptance to the undergraduate or graduate programs in graphic design.\nIntroduction to places related to graphic design in urban environments such as museums and design studios. Culture and context of design in the urban environment.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Graphic Design Theory",
    "dept": "ARTGR",
    "num": "510",
    "desc": "Prereq: Graduate classification in College of Design or permission of instructor.\nThis course will investigate graphic design as a tool to represent and create imageability in the mind of the audience, through relevant readings in graphic design theory and principles of visual organization in various media.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Graphic Design Studio I",
    "dept": "ARTGR",
    "num": "511",
    "desc": "Prereq: Graduate classification in College of Design or permission of instructor.\nTheory and investigation of systems, structures, principles of visual organization for communication through the experimental application of traditional and non-traditional media. Studio problems will be influenced by social, cultural, environmental, or technological factors.\n",
    "credits": "3"
  },
  {
    "course_name": "Audience and Perception",
    "dept": "ARTGR",
    "num": "512",
    "desc": "Prereq: Graduate classification in College of Design or permission of instructor.\nTheory and investigation of systems, structures, principles of visual organization for communication through the experimental application of traditional and non-traditional media. Studio problems will be influenced by social, cultural, environmental, or technological factors.\n",
    "credits": "3"
  },
  {
    "course_name": "Design & Cultural Semiotics",
    "dept": "ARTGR",
    "num": "520",
    "desc": "Prereq: Graduate classification in College of Design or permission of instructor.\nIntroduction to semiotics as it relates to art, design and culture. Historical and contemporary vantage points and the importance of designers as makers of meaning. Key concepts of semiotics and the interrelationship between message, meaning, design and culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Graduate Studio II",
    "dept": "ARTGR",
    "num": "521",
    "desc": "Prereq: Enrollment in the Graphic Design Graduate Program.\nIn this advanced graduate graphic design studio led by a variety of faculty, students will be introduced to a range of research topics, methods and ideas that are predicated on learning through the process of creation.\n",
    "credits": "3"
  },
  {
    "course_name": "Critical Media",
    "dept": "ARTGR",
    "num": "522",
    "desc": "Prereq: Enrollment in the Graphic Design Graduate Program.\nAdvanced theory and investigation of critical media and application of principles of visual organization for communication. Through hypothetical design work with critical media tools, studio problems will examine and be informed by social, cultural, environmental, or technological factors.\n",
    "credits": "3"
  },
  {
    "course_name": "User Engagement",
    "dept": "ARTGR",
    "num": "530",
    "desc": "Prereq: Graduate enrollment in the Graphic Design Program or graduate enrollment in College of Design or permission of instructor\nThe exploration and design of interface/interaction with products, systems, and technologies.\n",
    "credits": "3"
  },
  {
    "course_name": "Design for Behavioral Change.",
    "dept": "ARTGR",
    "num": "540",
    "desc": "Prereq: Graduate enrollment in the Graphic Design Program or graduate enrollment in College of Design or permission of instructor\nThe exploration and design of educational experiences and artifacts as they relate to the social, emotional, and behavioral aspects of society.\n",
    "credits": "3"
  },
  {
    "course_name": "3D Motion Graphics",
    "dept": "ARTGR",
    "num": "563",
    "desc": "Prereq: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470\n3D visualization in a Motion Graphics context. Emphasis on design in 3D computer animation as it relates to various electronic media.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Imaging",
    "dept": "ARTGR",
    "num": "564",
    "desc": "Prereq: Concurrent enrollment in ARTGR 370, ARTGR 371 or ARTGR 470.\nStudio in experimental techniques using the digital drawing tablet combined with manual drawing mediums, exploring the digital tablet, scanner, and camera as ways to collect and make images, conceptual and compositional development of digital techniques and software, and connecting digital techniques to visual processes and ideation. Students will have a better understanding of different ways of working digitally while exploring image-making processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Studies in Visual Communication",
    "dept": "ARTGR",
    "num": "570",
    "desc": "Prereq: Graduate classification in College of Design\nTheory and investigation of systems, structures, principles of visual organization, and typography for communication. Studio problems will be influenced by social, cultural, environmental, or technological factors.\n",
    "credits": "3"
  },
  {
    "course_name": "Signs, Symbols, Images",
    "dept": "ARTGR",
    "num": "571",
    "desc": "Prereq: Graduate Classification in College of Design\nInvestigation and application of signs, symbols and semiotic theory for communication. Studio problems influenced by social, cultural, environmental, or technological factors.\n",
    "credits": "3"
  },
  {
    "course_name": "Photography and Narrative Message",
    "dept": "ARTGR",
    "num": "572",
    "desc": "Prereq: Enrollment in ARTGR 370, ARTGR 371, ARTGR 470, or ARTGR 471\nPhotography as a tool for creating conceptually-driven images and metaphors. Emphasis is on photography as an evocative storytelling device for a range of audiences and design applications. Compositional and technical aspects are explored to ensure successful interpretation of the photograph's intended message.\n",
    "credits": "3"
  },
  {
    "course_name": "Multimedia Design",
    "dept": "ARTGR",
    "num": "573",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470 Graduate: graduate enrollment in College of Design\nThe design of visual, aural and textual communication for electronic media.\n",
    "credits": "3"
  },
  {
    "course_name": "Exhibition Design",
    "dept": "ARTGR",
    "num": "574",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470 Graduate: graduate enrollment in College of Design\nVisual communication applied to exhibition design focusing on educational or interactive museum exhibitions, trade show booth design, and modular unit design for traveling exhibitions. Translation of graphic information to a three-dimensional space.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Typography",
    "dept": "ARTGR",
    "num": "575",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470 Graduate: graduate classification in College of Design\nTypographic theory exploring traditional and non-traditional forms, both historical and contemporary typographic achievements.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design Methodology",
    "dept": "ARTGR",
    "num": "576",
    "desc": "Prereq: Undergraduate:  Concurrent enrollment in ARTGR 370, ARTGR 371 or ARTGR 470 Graduate: graduate enrollment in College of Design\nAnalysis and application of scientific, systematic, and non-traditional problem-solving and problem-seeking techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Design for E-Commerce/Graphic Applications",
    "dept": "ARTGR",
    "num": "578",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470. Graduate: Graduate enrollment in College of Design\nThe development of advanced and experimental web design for the applications of e-commerce, education and the communication of visual information.\n",
    "credits": "3"
  },
  {
    "course_name": "Wayfinding Design",
    "dept": "ARTGR",
    "num": "579",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470. Graduate: Graduate enrollment in College of Design\nStudy of the navigational challenges of built environments and outdoor spaces, including site analysis, development of navigational plans, and design of wayfinding sign systems.  Issues of function, accessibility, legibility, and fabrication are considered.\n",
    "credits": "3"
  },
  {
    "course_name": "Selected Studies in Graphic Design",
    "dept": "ARTGR",
    "num": "584",
    "desc": "Prereq: Undergraduate: Concurrent enrollment in ARTGR 370, ARTGR 371, or ARTGR 470. Graduate: graduate enrollment in College of Design.\nSpecial issues related to graphic design. Topics vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Graphic Design History/Theory/ Criticism I",
    "dept": "ARTGR",
    "num": "587",
    "desc": "\nLate nineteenth century to the 1990s. This course will explore the cultural, social, political, industrial, and technological forces that have influenced the practice of graphic design in Britain, Europe, and the United States. Students will study the historical issues and problems facing designers, their clients, and their publics.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design History/Theory/ Criticism II",
    "dept": "ARTGR",
    "num": "588",
    "desc": "\nCritical issues that affect the contemporary practice of graphic design as it relates to the United States. Students will study a variety of issues that include, but are not exclusive to, new media, gender, class, design and the public sphere, design as social action, postmodern design theory, sustainability, and ethical practice.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Ethics",
    "dept": "ARTGR",
    "num": "589",
    "desc": "Prereq: Graduate classification or permission of instructor.\nIssues in ethics and decision-making as they relate to technology, design, design research, HCI, and the design industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "ARTGR",
    "num": "590",
    "desc": "Prereq: Bachelor's degree in graphic design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Theory, Criticism, and Methodology",
    "dept": "ARTGR",
    "num": "590A",
    "desc": "Prereq: Bachelor's degree in graphic design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Two-Dimensional Design",
    "dept": "ARTGR",
    "num": "590B",
    "desc": "Prereq: Bachelor's degree in graphic design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Three-Dimensional Design",
    "dept": "ARTGR",
    "num": "590C",
    "desc": "Prereq: Bachelor's degree in graphic design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Publication Design: Magazines",
    "dept": "ARTGR",
    "num": "591",
    "desc": "Prereq: Graduate enrollment in College of Design\nThe philosophy, concepts and structures of magazine design.\n",
    "credits": "3"
  },
  {
    "course_name": "Publication Design: Books",
    "dept": "ARTGR",
    "num": "592",
    "desc": "Prereq: Graduate enrollment in College of Design\nThe philosophy, concepts and structures of book design.\n",
    "credits": "3"
  },
  {
    "course_name": "Workshop",
    "dept": "ARTGR",
    "num": "593",
    "desc": "Prereq: Graduate classification; evidence of satisfactory experience in area of specialization\nIntensive 2 to 4 week studio exploration. Topics vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Graphic Design Abroad",
    "dept": "ARTGR",
    "num": "595",
    "desc": "Prereq: Permission of instructor\nInternational study abroad program with visits to design studios, art museums, and educational facilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "ARTGR",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis Preparation Studio",
    "dept": "ARTGR",
    "num": "610",
    "desc": "Prereq: ARTGR 531, Graduate enrollment in the College of Design.\nInitial development and exploration of graduate thesis topic, investigation of design research and creative scholarship. Determine Faculty Committee and Program of Study and file forms with Graduate College.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching in Higher Education and Design Practice",
    "dept": "ARTGR",
    "num": "611",
    "desc": "Prereq: Graduate classification\nIntroduction to teaching methods, curriculum design, project development, and business strategies for Design Education and Professional Practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Thesis Studio I",
    "dept": "ARTGR",
    "num": "620",
    "desc": "Prereq: ARTGR 610.\nAdvanced creative scholarship in specialized area of focus within graphic design. Culminates in a development plan, preliminary design work, and supporting documentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Thesis Studio II",
    "dept": "ARTGR",
    "num": "630",
    "desc": "Prereq: ARTGR 620\nAdvanced research component in specialized area of focus within graphic design. Advances a development plan, preliminary design work, and supporting documentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Design and Human Interaction",
    "dept": "ARTGR",
    "num": "672",
    "desc": "Prereq: ARTGR 570, ARTGR 571, and graduate enrollment in College of Design or permission of instructor\nThe theory and investigation of experience design as it applies to human interactions in contemporary society and culture. Studio problems may involve such areas as: exhibition design, electronic interface design, wayfinding, package design, and publication design.\n",
    "credits": "3"
  },
  {
    "course_name": "Consumer Experience Design and Branding.",
    "dept": "ARTGR",
    "num": "672C",
    "desc": "Prereq: ARTGR 570, ARTGR 571, and graduate enrollment in College of Design or permission of instructor\nThe theory and investigation of experience design as it applies to human interactions in contemporary society and culture. Studio problems may involve such areas as: exhibition design, electronic interface design, wayfinding, package design, and publication design.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "ARTGR",
    "num": "690",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Current Issues in Graphic Design",
    "dept": "ARTGR",
    "num": "698",
    "desc": "Prereq: Graduate enrollment in College of Design or permission of instructor\nSelected issues in contemporary graphic design. Topics and readings vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Research-Thesis",
    "dept": "ARTGR",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Elementary Ancient and New Testament Greek I",
    "dept": "GREEK",
    "num": "101",
    "desc": "\nGrammar and vocabulary of ancient Greek, within the context of Greek culture; reading knowledge through texts adapted from classical and New Testament works.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Ancient and New Testament Greek II",
    "dept": "GREEK",
    "num": "102",
    "desc": "Prereq: GREEK 101\nGrammar and vocabulary of ancient Greek, within the context of Greek culture; reading knowledge through texts adapted from classical and New Testament works.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Independent Study",
    "dept": "GREEK",
    "num": "490",
    "desc": "Prereq: 6 credits in Greek and permission of department chair\nDesigned to meet the needs of students who seek work in areas other than those in which courses are offered, or who desire to integrate a study of literature or language with special problems in major fields.\n  No more than 9 credits of Greek 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "First Aid and Emergency Care",
    "dept": "H S",
    "num": "105",
    "desc": "\nDiscussion and application of the basic techniques of utilizing bloodborne pathogen safety measures,  administering first aid and cardiopulmonary resuscitation. ARC layperson certification available.\n",
    "credits": "2"
  },
  {
    "course_name": "Personal and Consumer Health",
    "dept": "H S",
    "num": "110",
    "desc": "\nPhysical, mental, emotional and social aspects of health as a basis for understanding and promoting health, and preventing poor health conditions. Study of personal responsibility on the long-term benefits of maintaining a high level of wellness and health.  Identification and mitigation of negative lifestyle habits.\n",
    "credits": "3"
  },
  {
    "course_name": "Drug Education",
    "dept": "H S",
    "num": "215",
    "desc": "Prereq: PSYCH 101 or PSYCH 230\nDiscussion of use, abuse and addiction of mood modifying substances in contemporary society. Includes study of tobacco, alcohol, and other drugs.\n",
    "credits": "3"
  },
  {
    "course_name": "Health Education in the Elementary School",
    "dept": "H S",
    "num": "275",
    "desc": "Prereq: HD FS 102 or HD FS 226\nThe application of instructional strategies related to health education and physical education for teachers at the elementary level.\n  Credit for both H S 275 and 375 may not be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Pre-Internship in Kinesiology and Health",
    "dept": "H S",
    "num": "285",
    "desc": "Prereq: Kinesiology and Health major and permission of internship coordinator.\nPre-internship experience with a health organization based on option.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "H S",
    "num": "290",
    "desc": "Prereq: 2nd semester freshmen, sophomores and permission from instructor.\nStudy under supervision of faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Instructor's First Aid and Cardio-pulmonary Resuscitation",
    "dept": "H S",
    "num": "305",
    "desc": "Prereq: H S 105\nDiscussion and practice of skills needed to teach first aid and cardiopulmonary resuscitation. ARC certification available.\n",
    "credits": "2"
  },
  {
    "course_name": "Community and Public Health",
    "dept": "H S",
    "num": "310",
    "desc": "Prereq: H S 110\nIntroduction to community health problems, programs of prevention, environmental health agencies, and health services. Study of local, state, and national community health agencies, their purposes and functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Diseases",
    "dept": "H S",
    "num": "350",
    "desc": "Prereq: H S 110 and BIOL 255, BIOL 256\nDiscussion of disease process and ill-health in the twentieth century. Emphasis on epidemiology, prevention, treatment, and the understanding of the etiology of communicable and noncommunicable diseases.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching-Learning Process in Health Education",
    "dept": "H S",
    "num": "375",
    "desc": "Prereq: H S 105, H S 110, H S 215\nPrinciples, methods, materials, and resources involved in the teaching of health. Includes organization and development of the health education curriculum (K-12).\n  Credit for both H S 275 and 375 may not be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Worksite Health Promotion",
    "dept": "H S",
    "num": "380",
    "desc": "Prereq: KIN 258, KIN 366\nThe design and implementation of worksite health promotion programs and the benefits these programs have for both employees and employers. Review of various health risk appraisals and planning theory-based incentive programs designed to promote positive lifestyles.\n",
    "credits": "3"
  },
  {
    "course_name": "Preparation and Search Strategies for Kinesiology and Health Internships",
    "dept": "H S",
    "num": "385",
    "desc": "Prereq: Junior classification; to be taken minimum of two semesters prior to required internship.\nPreparation of relevant material for a successful internship/career search.  Specific internship timeline, process, procedures will be reviewed.\n",
    "credits": "0"
  },
  {
    "course_name": "Supervised Teaching in Health Education in the Secondary School",
    "dept": "H S",
    "num": "417",
    "desc": "Prereq: H S 375\nAdvance registration required.\n",
    "credits": "16"
  },
  {
    "course_name": "Supervised Teaching in Health Education in the Secondary School: Initial Endorsement",
    "dept": "H S",
    "num": "417A",
    "desc": "Prereq: H S 375\nStudents must be fully admitted to Teacher Education and must apply for approval to enroll at the beginning of the semester prior to registering.\n",
    "credits": "16"
  },
  {
    "course_name": "Supervised Teaching in Health Education in the Secondary School: Additional Endorsement",
    "dept": "H S",
    "num": "417B",
    "desc": "Prereq: H S 375\nStudents must be fully admitted to Teacher Education and must apply for approval to enroll at the beginning of the semester prior to registering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Community Health Program Development",
    "dept": "H S",
    "num": "430",
    "desc": "\nTechniques of needs assessment, program design, administration, and evaluation of community health education programs in various settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Activity Epidemiology",
    "dept": "H S",
    "num": "464",
    "desc": "Prereq: KIN 358 or H S 350; STAT 101 or STAT 587.\nUnderstanding health benefits of physical activity on chronic disease prevention and health promotion throughout the life span, from clinical and public health perspectives.  Discussion and application of real-life physical activity assessment, research, guidelines, and promotion in population levels.\n",
    "credits": "3"
  },
  {
    "course_name": "Internship in Health Studies",
    "dept": "H S",
    "num": "485",
    "desc": "Prereq: Senior classification and advanced registration.\nAdvance registration required. Supervised experience in health related agencies.\n  Offered on a satisfactory-fail basis only.",
    "credits": "8"
  },
  {
    "course_name": "Internship in Health Studies: Community and Public Health",
    "dept": "H S",
    "num": "485A",
    "desc": "Prereq: All required courses and C- or better in HS 310 and HS 430.  Kinesiology and Health majors only.  Cumulative GPA 2.0.\nObservation and practice in selected community and public health agencies.\n  Offered on a satisfactory-fail basis only.",
    "credits": "8"
  },
  {
    "course_name": "Internship in Health Studies: Physical Activity and Health Promotion",
    "dept": "H S",
    "num": "485B",
    "desc": "Prereq: All required courses and C- or better in KIN 485 and KIN 467.  Kinesiology and Health majors only.  Cumulative GPA 2.0.\nObservation and practice in selected physical activity and health promotion agencies.\n  Offered on a satisfactory-fail basis only.",
    "credits": "8"
  },
  {
    "course_name": "Independent Study",
    "dept": "H S",
    "num": "490",
    "desc": "Prereq: 6 credits in health studies and permission of coordinator\n",
    "credits": "1"
  },
  {
    "course_name": "Physical Activity Epidemiology",
    "dept": "H S",
    "num": "564",
    "desc": "Prereq: KIN 358 or H S 350; STAT 101 or STAT 587.\nUnderstanding health benefits of physical activity on chronic disease prevention and health promotion throughout the life span, from clinical and public health perspectives.  Discussion and application of real-life physical activity assessment, research, guidelines, and promotion in population levels.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Higher Education in the United States",
    "dept": "HG ED",
    "num": "504",
    "desc": "Prereq: Graduate classification\nSurvey course in the history of higher education in the United States, from the colonial era to the present. Emphasis is placed on enduring debates about the purpose(s) of higher education and issues of equity and access along lines of race, class, and gender. Readings include primary and secondary materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Leadership: Learning, Ethics, Self and Interaction",
    "dept": "HG ED",
    "num": "540",
    "desc": "Prereq: permission of instructor\nServing as an introduction to developing practicing leaders, this course will create the foundation   upon which enduring understanding of leadership will be built.  Specifically explored will be   learning as the foundation of human enterprise, everyday leadership, determination of common good,   roots of individual's actions, sensitivity to others, merits of divergent ideas, questioning the   status quo, ethics as personal responsibility and choosing to grow.\n",
    "credits": "2"
  },
  {
    "course_name": "Learning, Leadership, Ethics and Community",
    "dept": "HG ED",
    "num": "541",
    "desc": "Prereq: permission of instructor\nServing as the second semester in a program to develop practicing leaders, this course will build   upon the foundation started first semester to help students embrace the enduring understandings of   leadership.  Specifically explored will be team learning and the effect on individuals, skills   required for a team to move forward, importance of decisions based on the good of the community,   reflection as a means of enhancing learning, and interconnectedness of the individual, the   community, and the world.\n",
    "credits": "2"
  },
  {
    "course_name": "Learning, Leadership, Ethics, and Teams; Knowing, Doing and Being",
    "dept": "HG ED",
    "num": "542",
    "desc": "Prereq: permission of instructor\nThe overall purpose of this course is to expand the foundation started in Foundations of   Leadership: Learning, Ethics, Self and Interactions and Learning, Leadership, Ethics and Community   for developing practicing leadership.  The focus will shift from a naive understanding of the   concepts of self within a team and community to a more sophisticated understanding of knowing,   being and doing leadership.\n",
    "credits": "2"
  },
  {
    "course_name": "Learning, Leadership, Ethics and Teams in Action",
    "dept": "HG ED",
    "num": "543",
    "desc": "Prereq: permission of instructor\nThe purpose of this last (in a series of four) course is to allow students to put their knowledge,   skills, and abilities related to leadership, learning, Ethics and Teams into practice.  In addition   to         planning and implementing a major service learning project, the focus will be on the   next wave of the study of leadership - connecting leadership to the research about the brain and   human learning.\n",
    "credits": "2"
  },
  {
    "course_name": "Foundations of Leadership & Learning",
    "dept": "HG ED",
    "num": "544",
    "desc": "Prereq: graduate student classification\nFirst of two-course series to help leaders develop the knowledge and skills to engage the collective capacity of a group to think, learn, and achieve important purpose.  The foundation for developing deep understanding about leadership, learning, and the relationships therein.  Focus on application of recent knowledge about human learning in the professional practice of leadership. Relationship leadership model and relationship to other leadership models, theories, and concepts; current theories of human learning (including expert/novice and transfer of learning), and interrelationships with leadership practice; critical understanding of self; facilitating learning for others; metacognition as a habit of mind; fundamentals of group interaction theories; social interdependence, communication, trusting, trustworthy goals, decision-making, cohesion, controversy, team development; power, resources, and development of community.\n",
    "credits": "3"
  },
  {
    "course_name": "Connecting Leadership & Learning in Practice",
    "dept": "HG ED",
    "num": "545",
    "desc": "Prereq: Graduate student classification and completion of HG ED 544\nSecond of a two-course series designed to help leaders develop the knowledge and skills to best engage the collective capacity of a group to think, learn and achieve important purpose. Builds on foundation course to support students in creating applications of the relationships between leadership and learning.  Focus on developing the habits of mind and habits of practice to best use knowledge about human learning in the professional practice of leadership. Applications of relational leadership model; applications of group interaction theories; development and implementation of action plans to achieve measurable goals; application of current theories of human learning as they relate to leadership; exploration of the fundamentals of emotional intelligence and the impacts on leadership; developing critical habits of mind to practice leadership focused on learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching, Learning and Leadership",
    "dept": "HG ED",
    "num": "550",
    "desc": "Prereq: Teacher licensure\nCurrent issues and practices in community college teaching and learning, and the roles and responsibilities of teachers as leaders.\n",
    "credits": "3"
  },
  {
    "course_name": "College Teaching",
    "dept": "HG ED",
    "num": "561",
    "desc": "Prereq: 6 graduate credits\nEducational theories, methods and strategies for the improvement of college instruction.   Assist potential college instructors in developing knowledge of protocol, assessment, and the   scholarship and art of teaching. Emphasis on the unique challenge of college teaching in a changing student population environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Curriculum Development in Colleges",
    "dept": "HG ED",
    "num": "562",
    "desc": "Prereq: Graduate classification\nModes of curriculum design, development, and change in colleges. Development of curricular leadership and evaluation strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Education Policy Analysis",
    "dept": "HG ED",
    "num": "568",
    "desc": "Prereq: HG ED 504\nAssessment of global education policy issues in education. Analysis of policies, implementation strategies, and policy outcomes.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Topics in Student Affairs",
    "dept": "HG ED",
    "num": "570",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in student affairs practice. Topics developed to the specific needs of student affairs professionals. Primarily for off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Student Affairs: Residential Life",
    "dept": "HG ED",
    "num": "570D",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in student affairs practice. Topics developed to the specific needs of student affairs professionals. Primarily for off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Student Affairs: Student Affairs Institute",
    "dept": "HG ED",
    "num": "570G",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in student affairs practice. Topics developed to the specific needs of student affairs professionals. Primarily for off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Student Affairs: Student Diversity",
    "dept": "HG ED",
    "num": "570H",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in student affairs practice. Topics developed to the specific needs of student affairs professionals. Primarily for off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Equity, Diversity, and Inclusion in Student Affairs",
    "dept": "HG ED",
    "num": "573",
    "desc": "Prereq: Graduate Standing\nExplores theories of equity, diversity, and inclusion to build knowledge and skills related to multicultural competence in student affairs practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Student Affairs Practice in Higher Education",
    "dept": "HG ED",
    "num": "574",
    "desc": "Prereq: Graduate classification, admission to Higher Education Program\nInstroduction to the profession of Student Affairs in higher education. As a survey course, readings, learning artifacts, and class discussions will be used to uncover a breadth of topics related to the student affairs profession. Course content is organized around, but will not be limited to, the history, philosophical underpinnings, values, ethics, and standards espoused, as well as the concepts of learning and community development.\n",
    "credits": "3"
  },
  {
    "course_name": "Organization and Administration of Student Affairs",
    "dept": "HG ED",
    "num": "575",
    "desc": "Prereq: Admission to Higher Education Program, HG ED 574\nTopics related to organization and administration of student affairs in higher education. The course surveys organizational and administrative aspects of student affairs within the broader context of post-secondary education with particular attention paid to organizational development, budget and finance, and law and policy.\n",
    "credits": "3"
  },
  {
    "course_name": "Student Development in Higher Education",
    "dept": "HG ED",
    "num": "576",
    "desc": "Prereq: Admission to Higher Education Program\nTheories of student and adult development and their applications in student affairs programs, services, and activities are reviewed. Emphasis is placed on theories exploring psychosocial, cognitive, moral, and social identity development as well as on integrated theories of development.\n",
    "credits": "3"
  },
  {
    "course_name": "Campus Environments and Cultures",
    "dept": "HG ED",
    "num": "577",
    "desc": "Prereq: Admission to Higher Education Program\nStudy of the impact of the college environment on students and use of environmental theory to create positive learning situations for students.\n",
    "credits": "3"
  },
  {
    "course_name": "Students in American Higher Education",
    "dept": "HG ED",
    "num": "578",
    "desc": "Prereq: Admission to Higher Education Program\nThe relationship between college students and characteristics from 1950 to the present. Traditional assumptions about the impact of higher education on students will be reviewed and challenged. Campus issues and concerns relative to commuters and residential life. Participants will analyze institutional responses to students through college missions, organizational development, structure, core curriculum and retention.\n",
    "credits": "3"
  },
  {
    "course_name": "Advising and Helping Skills",
    "dept": "HG ED",
    "num": "579",
    "desc": "Prereq: HG ED 574, HG ED 576\nDevelopment of effective, basic counseling skills. Understanding of group dynamics. Ability to work effectively in groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Topics in Community Colleges",
    "dept": "HG ED",
    "num": "580",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Student Needs",
    "dept": "HG ED",
    "num": "580A",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: General and Liberal Education",
    "dept": "HG ED",
    "num": "580B",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Counseling and Advising",
    "dept": "HG ED",
    "num": "580C",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Adult and Continuing   Education",
    "dept": "HG ED",
    "num": "580D",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Development and Remedial Education",
    "dept": "HG ED",
    "num": "580E",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Student Services",
    "dept": "HG ED",
    "num": "580F",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Faculty and Staff Evaluation",
    "dept": "HG ED",
    "num": "580G",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Organization and Administration",
    "dept": "HG ED",
    "num": "580H",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Learning and Teaching",
    "dept": "HG ED",
    "num": "580I",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics in Community Colleges: Human Relations",
    "dept": "HG ED",
    "num": "580J",
    "desc": "Prereq: Graduate classification\nCurrent issues and new directions in community college education. Topics developed to the specific needs of   colleges. For off-campus.\n",
    "credits": "1"
  },
  {
    "course_name": "The Comprehensive Community College",
    "dept": "HG ED",
    "num": "582",
    "desc": "Prereq: Graduate classification\nThe community college as a unique social and educational institution: its history, philosophy, functions, programs, faculty and student characteristics, organization and finance, trends, and issues. Reviews current research and exemplary community college practices internationally, nationally, and in Iowa.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "HG ED",
    "num": "590",
    "desc": "Prereq: 9 credits in education\nIndependent study on specific topics arranged with an instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Student Services",
    "dept": "HG ED",
    "num": "590A",
    "desc": "Prereq: 9 credits in education\nIndependent study on specific topics arranged with an instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Community Colleges",
    "dept": "HG ED",
    "num": "590B",
    "desc": "Prereq: 9 credits in education\nIndependent study on specific topics arranged with an instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Current Issues",
    "dept": "HG ED",
    "num": "590C",
    "desc": "Prereq: 9 credits in education\nIndependent study on specific topics arranged with an instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: International Higher Education",
    "dept": "HG ED",
    "num": "590D",
    "desc": "Prereq: 9 credits in education\nIndependent study on specific topics arranged with an instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Federal and State Affairs",
    "dept": "HG ED",
    "num": "590E",
    "desc": "Prereq: 9 credits in education\nIndependent study on specific topics arranged with an instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Law in Higher Education",
    "dept": "HG ED",
    "num": "590F",
    "desc": "Prereq: 9 credits in education\nIndependent study on specific topics arranged with an instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Institutional Research",
    "dept": "HG ED",
    "num": "590G",
    "desc": "Prereq: 9 credits in education\nIndependent study on specific topics arranged with an instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience",
    "dept": "HG ED",
    "num": "591",
    "desc": "Prereq: 9 credits graduate work\nSupervised on-the-job field experience.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshops",
    "dept": "HG ED",
    "num": "593",
    "desc": "Prereq: 15 credits in education\n",
    "credits": "1"
  },
  {
    "course_name": "Capstone Seminar",
    "dept": "HG ED",
    "num": "598",
    "desc": "\nThe primary goal of this course is for advanced students to demonstrate their preparedness to progress in the field of Student Affairs as educators who are able to apply concepts and formal (and informal) theories addressed in previous course and fieldwork to their professional student affairs thinking and practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "HG ED",
    "num": "599",
    "desc": "Prereq: 9 credits in education\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminars in Higher Education",
    "dept": "HG ED",
    "num": "615",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Higher Education: Student Services",
    "dept": "HG ED",
    "num": "615A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Higher Education: Community Colleges",
    "dept": "HG ED",
    "num": "615B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Higher Education: Current Issues",
    "dept": "HG ED",
    "num": "615C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Higher Education: International Higher Education",
    "dept": "HG ED",
    "num": "615D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Higher Education: Federal and State Affairs",
    "dept": "HG ED",
    "num": "615E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Higher Education: Law in Higher Education",
    "dept": "HG ED",
    "num": "615F",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Higher Education: Institutional Research",
    "dept": "HG ED",
    "num": "615G",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Higher Education: Research Designs in Higher   Education",
    "dept": "HG ED",
    "num": "615H",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "College Organization and Administration",
    "dept": "HG ED",
    "num": "664",
    "desc": "\nAdministrative organization and behavior: communications, leadership, finance, strategic planning, and institutional governance.\n",
    "credits": "3"
  },
  {
    "course_name": "Financing Higher Education",
    "dept": "HG ED",
    "num": "665",
    "desc": "\nLectures, discussions, and individual investigation relating to financial administration in colleges and universities. Budgeting, auxiliary enterprises, administration of financial planning, fund raising, examination of theories on expenditures. Designed for persons aspiring to serve as college administrators.\n",
    "credits": "3"
  },
  {
    "course_name": "Academic Issues and Cultures",
    "dept": "HG ED",
    "num": "666",
    "desc": "\nExamination of institutional culture and issues in higher education focusing on the roles and responsibilities of faculty and academic administrators.\n",
    "credits": "3"
  },
  {
    "course_name": "Student Development Theory II",
    "dept": "HG ED",
    "num": "676",
    "desc": "Prereq: HG ED 576\nAn examination of social identity theories including those exploring race, ethnicity, gender, class, ability, sexuality, and spirituality.  An exploration of how social identity is influenced by the dynamics of power and oppression in education and society and how to enhance the college experiences of students from diverse backgrounds.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Special Topics",
    "dept": "HG ED",
    "num": "690",
    "desc": "Prereq: 9 credits in education\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "HG ED",
    "num": "699",
    "desc": "Prereq: 9 credits in education\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to History",
    "dept": "HIST",
    "num": "195",
    "desc": "Prereq: classification as history major\nIntroduction to the discipline of history and how historians think and work. Focus on research methodologies, writing and analytical practices of historians, and specialization in the discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Western Civilization I",
    "dept": "HIST",
    "num": "201",
    "desc": "\nWestern civilization from ancient Mediterranean world to 1500. Social and cultural developments; economic and political ideas and institutions; problems of historical change and continuity.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Western Civilization II",
    "dept": "HIST",
    "num": "202",
    "desc": "\nWestern civilization from 1500 to present. Social and cultural developments; economic and political ideas and institutions; problems of historical change and continuity.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Chinese Civilization",
    "dept": "HIST",
    "num": "207",
    "desc": "\nOrigins, development, decline and transformation of China from earliest times to 1911.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of United States History I",
    "dept": "HIST",
    "num": "221",
    "desc": "\nColonial foundations: revolution, confederation, and constitution; nationalism and democracy; sectional disunity, Civil War, and reunion.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of United States History II",
    "dept": "HIST",
    "num": "222",
    "desc": "\nIndustrialization; emergence as a great power; boom and depression; war, internationalism and Cold War; modern industrial society.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Asian American Studies",
    "dept": "HIST",
    "num": "225",
    "desc": "\nAn interdisciplinary and chronological examination of Asian American immigration experiences from the early 19th century to the 21st century. Focus on how these immigration histories are accompanied by changing racial constructions. Discussion of racial stereotyping, the model minority myth, identity development, and efforts for social justice.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to World History, 1500-Present",
    "dept": "HIST",
    "num": "255",
    "desc": "Prereq: None\nSocial and cultural developments; economic and political ideas and institutions; colonization of the Americas; biological exchanges; industrialization; political revolutions; European colonialism; emergence of the Global South; Cold War; decolonization; fossil fuels and energy; global environmental change.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to History of Science I",
    "dept": "HIST",
    "num": "280",
    "desc": "\nIdeas of nature from ancient Greece to the seventeenth-century scientific revolution.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to History of Science II",
    "dept": "HIST",
    "num": "281",
    "desc": "\nScience from seventeenth-century scientific revolution to Darwin and Einstein.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Wonders of the World, Global History of Innovation",
    "dept": "HIST",
    "num": "284",
    "desc": "\nInnovation across cultures from the ancient “Seven Wonders of the World” to the modern world, with developments in Egypt, Greece, Rome, the Islamic World, India, China, Europe, and the Americas. Topics include major inventions, agricultural technologies, architecture, manufacturing, warfare, engineering, printing, entertainment, transport, and communications.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Cultural Heritage of the Ancient World",
    "dept": "HIST",
    "num": "304",
    "desc": "Prereq: Sophomore classification\nHistorical examination of art, literature, thought, and religious beliefs of major civilizations of the ancient Mediterranean countries until the end of the 8th century.\n",
    "credits": "3"
  },
  {
    "course_name": "American Popular Culture",
    "dept": "HIST",
    "num": "307",
    "desc": "Prereq: Sophomore classification\nSocial practices, beliefs and material traits of everyday life in America from the mid-19th century to the present. Includes literature, music, theater and other entertainments. Dime novels, vaudeville, rock and roll music, Hollywood and establishment of professional athletic leagues are among the cultural artifacts and phenomena considered.\n",
    "credits": "3"
  },
  {
    "course_name": "Africa under Colonial Rule",
    "dept": "HIST",
    "num": "311",
    "desc": "Prereq: 3 credits of 200-level HIST at Iowa State, and sophomore classification.\nDevelopment of Africa from imposition of colonial rule to independence, including processes of European domination, African reaction and resistance, emergence of nationalism, and dismantling of colonialism.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Medieval Europe, 300-1500",
    "dept": "HIST",
    "num": "316",
    "desc": "Prereq: Sophomore classification\nSurvey of political, social, and cultural developments in western Europe for the entire medieval period, 300-1500.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Early Modern Europe, 1450-1789",
    "dept": "HIST",
    "num": "318",
    "desc": "Prereq: Sophomore classification\nSurvey of major themes in the social, political, cultural, and religious history of early modern Europe, including the eras of renaissance and reformation, the age of exploration, development of the modern individual and household, and enlightenment.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Modern Europe, 1789 to Present",
    "dept": "HIST",
    "num": "320",
    "desc": "Prereq: 3 credits of 200-level HIST at Iowa State, and sophomore classification.\nSurvey of major themes in the social, political, and religious history of Europe from the French Revolution to the present. Topics to be covered include the French Revolution, nationalism, the Industrial Revolution, the Russian Revolution, World Wars I and II, the Cold War, the fall of the Soviet Union, and the history of globalization.\n",
    "credits": "3"
  },
  {
    "course_name": "Society and Politics in England, 1525-1700",
    "dept": "HIST",
    "num": "325",
    "desc": "Prereq: Sophomore classification\nSocial, cultural, demographic, and economic experiences. Religious Reformation. Growth of the State (and Empire) and political institutions.\n",
    "credits": "3"
  },
  {
    "course_name": "History of the British Empire",
    "dept": "HIST",
    "num": "327",
    "desc": "Prereq: Sophomore classification\nDevelopment of British Empire from origins in the seventeenth century to dissolution in the twentieth century. Attention given to empire in S. Pacific, N. America, India and S. Asia, Hong Kong, Africa and the Middle East, as well as theories of empire and the impact of immigration on British society. Irish history also covered.\n  none\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of the Islamic World to 1800",
    "dept": "HIST",
    "num": "331",
    "desc": "Prereq: 3 credits of 200-level HIST at Iowa State and sophomore classification.\nSurvey of the Islamic world from pre-Islamic Arabia to the 19th century covering the life of the Prophet Muhammad, the spread of Islam through the Arab conquests and the Caliphal dynasties of the Umayyads and the Abbasids, the Mongol conquests, Turkic migrations from Central Asia, and the rise of the Ottoman Empire.\n",
    "credits": "3"
  },
  {
    "course_name": "Asian American Material Cultures",
    "dept": "HIST",
    "num": "333",
    "desc": "\nExamination of material objects made and used by Asian Americans with both historical and contemporary focuses; transnational and interdisciplinary lenses to interpret the material world; contemporary approaches to analysis of artifacts.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History of Modern China I",
    "dept": "HIST",
    "num": "336",
    "desc": "Prereq: Sophomore classification\nChina from 1644 to 1912; internal and external stimuli on traditional structure leading to reform and revolution.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Modern China II",
    "dept": "HIST",
    "num": "337",
    "desc": "Prereq: Sophomore classification\nChina from 1912 to present; search for a new order and continuing Chinese revolution.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Modern Japanese History",
    "dept": "HIST",
    "num": "338",
    "desc": "Prereq: Sophomore classification\nJapan 1600 to the present; emphasis on transformation of feudal Japan into a post-industrial society.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Latin America I",
    "dept": "HIST",
    "num": "340",
    "desc": "Prereq: Sophomore classification\nColonial Latin America from European discovery and colonization to wars for independence.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Latin America II",
    "dept": "HIST",
    "num": "341",
    "desc": "Prereq: Sophomore classification\nModern Latin America national origins from 1800 to present.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of African Americans I",
    "dept": "HIST",
    "num": "353",
    "desc": "Prereq: Sophomore classification\nExamines African roots of black culture and the African American experience in the United States from the colonial period through the Civil War. Topics include Atlantic Slave Trade, slavery and American identity, abolition, the emergence of Black Nationalism, and black participation in the Civil War.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History of African Americans II",
    "dept": "HIST",
    "num": "354",
    "desc": "Prereq: Sophomore classification\nExplores African American political thought and political action from Reconstruction to the present. Topics include rise of Jim Crow segregation, urban migration, Garvey movement, Harlem Renaissance, Depression and world wars, Pan-Africanism, civil rights, Black Power, and black feminism.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "American Family History",
    "dept": "HIST",
    "num": "357",
    "desc": "Prereq: Sophomore classification\nThe impact on American families from colonial times onward of agricultural change, industrialization, urbanization, and wars and depressions.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Environmental History",
    "dept": "HIST",
    "num": "362",
    "desc": "Prereq: Either one of HIST 201, 202, or 207; or 3 credits of Environmental Studies; and sophomore classification.\nSurvey of the interactions of human communities with their environments from the beginnings of human history to the present. Topics include the domestication of animals, the agricultural revolution, industrialization, urbanization, deforestation, hydraulic management, fossil fuel consumption, and climate change.\n",
    "credits": "3"
  },
  {
    "course_name": "U. S. Environmental History",
    "dept": "HIST",
    "num": "363",
    "desc": "Prereq: Sophomore classification\nSurvey of the interactions of human communities with the North American environment. Focus on the period from presettlement to the present, with a particular concentration on natural resources, disease, settlement patterns, land use, and conservation policies.\n",
    "credits": "3"
  },
  {
    "course_name": "American Agriculture I:  The Maya to McCormick's Reaper",
    "dept": "HIST",
    "num": "365",
    "desc": "Prereq: Sophomore classification\nNorth American agricultural development to 1865.  American Indian agricultural systems, European background and agricultural revolution, agriculture in the colonial era, early republic and antebellum period.  Topics include origins of modern crops, agriculture's role in the economy, politics, and settlement of the U.S., slavery, rural and frontier life, and mechanization.\n",
    "credits": "3"
  },
  {
    "course_name": "American Agriculture II:  Homestead Act to GMOs",
    "dept": "HIST",
    "num": "366",
    "desc": "Prereq: Sophomore classification\nAmerican agricultural development since 1865.  Post-Civil War adjustments; westward expansion; economic boom and bust; mechanization; Dust Bowl and environmental challenges; Great Depression and New Deal; changing rural life; scientific and technological advances; farm crisis and late twentieth century challenges.\n",
    "credits": "3"
  },
  {
    "course_name": "America Eats",
    "dept": "HIST",
    "num": "367",
    "desc": "Prereq: Sophomore classification\nThematic approach to the development of the American agricultural system through the topics of food and eating.  Changes in American food systems from Native American, pre-contact diets through modern innovations such as fast food, organics, and eating locally.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Iowa",
    "dept": "HIST",
    "num": "370",
    "desc": "Prereq: Sophomore classification\nSurvey of major social, cultural and economic developments in Iowa from the late 1700s.  Emphasis on minority groups, pioneer life, early economic development, industrial development, educational and religious development, and outstanding personalities.\n",
    "credits": "3"
  },
  {
    "course_name": "Mexican American History",
    "dept": "HIST",
    "num": "371",
    "desc": "Prereq: 3 credits of 200-level HIST at Iowa State and sophomore classification.\nHistory of the Mexican American community in the U.S. from the 1820s to the present. Topics include community development, employment, social marginalization, racism/discrimination, depression and world wars, civil rights, ethnic power and politics.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Latina/o History",
    "dept": "HIST",
    "num": "372",
    "desc": "\nHistorical and cultural heritage of Latinas/os in the United States. The histories of Mexican, Puerto Rican, Cuban, and other Latin American peoples in the U.S. emphasizing political and cultural convergence and congruencies.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Sex, Gender, and Culture in the Ancient Mediterranean World",
    "dept": "HIST",
    "num": "374",
    "desc": "Prereq: Any one course in Cl St, W S, Latin, or Greek\nChronological and topical survey of the status of women and men, focusing on sex and gender issues in the Ancient Mediterranean world; study of constructs of the female and the feminine. Readings from ancient and modern sources.  Emphasis on ancient Greece, Rome, and Egypt.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Women in Science, Technology, and Medicine",
    "dept": "HIST",
    "num": "380",
    "desc": "Prereq: Sophomore classification\nHistory of women's relationship to the fields of science, technology, and medicine, as students and professionals, consumers, subjects and patients, family members, workers and citizens. Concentrates especially on 19th and 20th century United States, concluding with an examination of current issues of special interest to women in science, technology, and medicine.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History and Philosophy of the Scientific Revolution.",
    "dept": "HIST",
    "num": "382",
    "desc": "\nThe emergence of empirical science as the authoritative methodology for production of knowledge about the natural world in the period between Copernicus and Kant. Scientific progress achieved during the period, including the work of Galileo, Descartes, and Newton. The re-shaping of epistemology in the Western intellectual tradition. Implications for philosophy and historiography.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology, Public Science, and European Culture, 1715-Present",
    "dept": "HIST",
    "num": "383",
    "desc": "Prereq: Sophomore classification\nA survey from the Age of Enlightenment to the end of the twentieth century of the relationship between science, technology, and public or popular culture in a comparative European context (including Russia and the former Soviet Union).\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Roman Italy: An Introduction",
    "dept": "HIST",
    "num": "384",
    "desc": "Prereq: Enrollment limited to students participating in CL ST 385/HIST 385. Instructor permission required.\nIntroduction to the topography, history, archaeology, monuments, and art of Rome from the 8th century BCE  to the 5th century CE; attention given to the culture of modern Italy, preparatory to study abroad in Rome.\n\nMeets International Perspectives Requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Study Abroad: Roman Italy: Building the Empire",
    "dept": "HIST",
    "num": "385",
    "desc": "Prereq: CL ST 384/HIST 384 and instructor’s permission.\nSupervised on-site instruction in the history, archaeology, monuments, and art of Rome and environs from the 8th century BCE to the 5th century CE; attention given to the culture of modern Italy.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Women in America",
    "dept": "HIST",
    "num": "386",
    "desc": "Prereq: Sophomore classification\nA survey of social, economic, and political aspects of women's role from colonial era to present; emphasis on employment, education, concepts of sexuality, and changing nature of the home.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "American Military History",
    "dept": "HIST",
    "num": "389",
    "desc": "Prereq: Sophomore classification\nAmerican military experience from the Pequot War to Vietnam, including King Philip's War, the French & Indian Wars, the American Revolution, the War of 1812, the Mexican-American War, the Civil War, the Spanish-American War, World Wars I & II, and the Korean War.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "World Military History",
    "dept": "HIST",
    "num": "390",
    "desc": "Prereq: Sophomore classification\nCovers military history from the Napoleonic era through the mid- and late-19th century wars, the First and Second World Wars, and wars of national liberation and regional conflicts since 1945.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "American Diplomatic History",
    "dept": "HIST",
    "num": "391",
    "desc": "Prereq: Sophomore classification\nA study of US foreign relations during the twentieth century, including the rise to global power, the First World War, diplomacy during prosperity and depression, the Second World War, the Cold War, relations with Latin America, East and South Asia, and Africa, the search for markets, and the perceptions of American foreign policy held by the US, its allies and adversaries, and others.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in History",
    "dept": "HIST",
    "num": "396",
    "desc": "Prereq: Sophomore classification or permission of instructor\nSpecialized topics in history; topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in History: Europe",
    "dept": "HIST",
    "num": "396A",
    "desc": "Prereq: Sophomore classification or permission of instructor\nSpecialized topics in history; topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in History: U.S. and North America",
    "dept": "HIST",
    "num": "396B",
    "desc": "Prereq: Sophomore classification or permission of instructor\nSpecialized topics in history; topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in History: Global",
    "dept": "HIST",
    "num": "396C",
    "desc": "Prereq: Sophomore classification or permission of instructor\nSpecialized topics in history; topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Greek Civilization",
    "dept": "HIST",
    "num": "402",
    "desc": "Prereq: Sophomore classification\nAncient Greece from the Bronze Age to the Hellenistic period; evolution of the Greek polis and its   cultural contributions, with a particular emphasis on the writings of Herodotus and Thucydides.\n",
    "credits": "3"
  },
  {
    "course_name": "Roman Civilization",
    "dept": "HIST",
    "num": "403",
    "desc": "Prereq: Sophomore classification\nAncient Rome from the Regal Period to the fall of the Western Empire; evolution of Roman institutions and Rome's cultural contributions studied through original sources.\n",
    "credits": "3"
  },
  {
    "course_name": "Transformations of the Early Medieval World",
    "dept": "HIST",
    "num": "405",
    "desc": "Prereq: Sophomore classification\nExamines major political, religious, and cultural transformations in Western Europe and the Mediterranean, 300-1000.  Major topics include the fall of Rome, rise of Christianity, Germanic kingdoms, and Carolingian empire.\n",
    "credits": "3"
  },
  {
    "course_name": "The Birth of Europe in the High Middle Ages",
    "dept": "HIST",
    "num": "406",
    "desc": "Prereq: Sophomore classification\nExamines political, economic, religious, and cultural forms emerging in Europe, 1000-1300, that still characterize Western society to this day.  Major topics include the medieval agricultural revolution, English and French monarchies, crisis of church and state, and growth of the papacy and personal religion.\n",
    "credits": "3"
  },
  {
    "course_name": "Crises of the Late Middle Ages",
    "dept": "HIST",
    "num": "407",
    "desc": "Prereq: Sophomore classification.\nExamines major political, economic, religious, and intellectual crises that beset Europe, 1300-1500, paving the way for early modernity.  Major topics include Black Death, 100 Years War, papal schism, and origins of Renaissance and Reformation.\n",
    "credits": "3"
  },
  {
    "course_name": "Europe, 1500-1648",
    "dept": "HIST",
    "num": "408",
    "desc": "Prereq: Sophomore classification\nRenaissance; Protestantism and the Age of Catholic reform; social, cultural, and economic changes; global expansion; religious warfare.\n",
    "credits": "3"
  },
  {
    "course_name": "The Holocaust in History",
    "dept": "HIST",
    "num": "410",
    "desc": "Prereq: Sophomore classification\nHistorical and historiographical coverage of the Holocaust. Actions of perpetrators, experiences of the murdered, and inaction or action of bystanders within global, European, German, and Jewish history. Topics include history, historical methods, and contemporary and historical commemoration of the Holocaust. Seminar discussion format.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "European Cultural and Intellectual History",
    "dept": "HIST",
    "num": "414",
    "desc": "Prereq: Sophomore classification\nA study of the development of key themes in European thought: nature, man, God, society, history, and creativity from Rousseau to Post-Modernism.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Modern France",
    "dept": "HIST",
    "num": "419",
    "desc": "Prereq: Sophomore classification\nFrom absolutism to revolution and the rise of modern democracy.\n",
    "credits": "3"
  },
  {
    "course_name": "France's Revolutionary Century, 1715-1815",
    "dept": "HIST",
    "num": "420",
    "desc": "Prereq: Sophomore classification\nAn in-depth investigation of the French Revolution, its causes and consequences, beginning in the Ancien Regime and ending with the fall of Napoleon.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Russia I",
    "dept": "HIST",
    "num": "421",
    "desc": "Prereq: Sophomore classification\nRussia to 1850. Origins of Russian people; Byzantine influences; Mongol invasion; rise of Moscow; Westernization.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Russia II",
    "dept": "HIST",
    "num": "422",
    "desc": "Prereq: Sophomore classification\nRussia since 1850. Reform and revolution; transformation of society; USSR as a world power; recent changes.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "The Russian and Soviet Mind: Intellectual and Cultural Life, 1762-1991",
    "dept": "HIST",
    "num": "423",
    "desc": "Prereq: Sophomore Classification\nRussian intellectual history from the reign of Catherine the Great to the collapse of Communism. Discussion of Russian literary, philosophical and cultural trends in the nineteenth century and the relationship between intellectual & cultural figures and the Soviet state in the twentieth century.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Modern Germany",
    "dept": "HIST",
    "num": "424",
    "desc": "Prereq: Sophomore classification.\nPolitical, social, and cultural history of Germany from the 19th century to the present.\n",
    "credits": "3"
  },
  {
    "course_name": "Crime and Policing in England 1550-1850",
    "dept": "HIST",
    "num": "427",
    "desc": "Prereq: Sophomore classification\nCourse examines different forms and ideas of criminality and the nature and development of law enforcement in England between 1550 and 1856. Significant issues will include the nature of criminal records and statistics, the legal system, the politics of the law and its links with social relations, policing, female crime, juvenile delinquency, organized crime, riots, \"social crime,\" and the treatment of crime in creative literary texts.\n",
    "credits": "3"
  },
  {
    "course_name": "Punishment, Mentalities, and Society in England, 1550-1868",
    "dept": "HIST",
    "num": "428",
    "desc": "Prereq: Sophomore classification\nExplores the history of punishing criminals in England and shows how interdisciplinary perspectives, ideas, and practices of punishment are related to mentalities, and socio-economic change. Issues of significance examined: violence, civility, manners, madness, public punishment, execution, imprisonment, transportation, mercy, the rise of asylums, and penal reform.\n",
    "credits": "3"
  },
  {
    "course_name": "\"Monstrous London\": London's Histories 1500-1800",
    "dept": "HIST",
    "num": "429",
    "desc": "Prereq: Sophomore classification\nStudy of London's social, economic, cultural, political, and environmental history 1500-1800, using both quantitative and qualitative methods to examine contemporary and secondary sources. Course combines standard lecture and discussion format with one week of intensive study abroad for 4th hour of course credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Modern England",
    "dept": "HIST",
    "num": "431",
    "desc": "Prereq: Sophomore classification\nEngland since 1850. Parliamentary and constitutional development; social reform and economic change; imperial Britain; welfare state.\n",
    "credits": "3"
  },
  {
    "course_name": "History of the Modern Middle East",
    "dept": "HIST",
    "num": "435",
    "desc": "Prereq: Sophomore classification.\nOttoman and Qajar reform movements; constitutional revolutions; European legal imperialism; colonialism; World War I and the mandate system; Israeli-Palestinian conflict; Arab nationalism; the Islamic Revolution in Iran; Islamist movements; oil resources; terrorism; sectarianism.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Modern Mexico and Central America",
    "dept": "HIST",
    "num": "441",
    "desc": "Prereq: Sophomore classification.\nPolitical, economic, and social development of Mexico and Central America in nineteenth and twentieth centuries.\n",
    "credits": "3"
  },
  {
    "course_name": "Rebellions and Revolutions in Latin America",
    "dept": "HIST",
    "num": "442",
    "desc": "Prereq: Sophomore classification.\nSurvey of rebellions, revolutionary movements, and social revolutions in the twentieth century, including Guatemalan, Cuban, Mexican, Chilean, and Nicaraguan cases.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "US Gilded Age, 1877-1900",
    "dept": "HIST",
    "num": "449",
    "desc": "Prereq: Sophomore classification\nU.S. History from the end of Reconstruction to the turn of the twentieth century. Discussion of prominent themes, including the opening of the West, the emergence of big business, rapid urbanization, immigration, race relations, American imperialism, and social reform.\n",
    "credits": "3"
  },
  {
    "course_name": "Colonial America",
    "dept": "HIST",
    "num": "450",
    "desc": "Prereq: Sophomore classification\nExploration, colonization, and development of political, economic, religious, and cultural institutions of North American colonies before 1754. Topics also include social history, emergence of African-American slavery, relations with American Indians.\n",
    "credits": "3"
  },
  {
    "course_name": "American Revolutionary Era",
    "dept": "HIST",
    "num": "451",
    "desc": "Prereq: Sophomore classification\nParticipants, ideas, and events leading to independence and the foundation of the United States, 1754 to 1789. Topics include political, military, social, cultural history, also issues of gender and race relations.\n",
    "credits": "3"
  },
  {
    "course_name": "Law and Society in U.S. History:  Crime, Race, Family, Work and Property",
    "dept": "HIST",
    "num": "453",
    "desc": "Prereq: Sophomore classification.\nThe development of both law and the legal system from colonial times to the present, highlighting their crucial role in aspects of American life such as marriage, family, employment, racial identification, and economic exchange. Topics will include important past legal disputes, the different levels of courts, the various actors in the legal process (e.g., police, prosecutors, prisoners, judges and juries), the relationship between the individuals and institutions that comprise the legal system.\n",
    "credits": "3"
  },
  {
    "course_name": "Early American Republic",
    "dept": "HIST",
    "num": "454",
    "desc": "Prereq: Sophomore classification\nExamination of the United States from the Constitutional Convention up to the Mexican War. Topics include the Washington, Jefferson, and Jackson administrations, the War of 1812, slavery and the South, economic and social development, Westward expansion and reform.\n",
    "credits": "3"
  },
  {
    "course_name": "U.S. Civil War and Reconstruction Era",
    "dept": "HIST",
    "num": "455",
    "desc": "Prereq: Sophomore classification\nExamination of the social and economic contradictions that led to Civil War and the reconstruction of American freedom and democracy. Topics include the Mexican War, sectional conflict and the crisis of disunion, economic, political and social aspects of civil war, emancipation, and reconstruction.\n",
    "credits": "3"
  },
  {
    "course_name": "History of American Sexualities",
    "dept": "HIST",
    "num": "457",
    "desc": "Prereq: Sophomore classification.\nThe social construction of American sexualities from the colonial era to the present with particular emphasis on how ideas about sex and sexuality have shaped American public life, including education, public policy, party politics, and racial justice.\n",
    "credits": "3"
  },
  {
    "course_name": "U.S. 1900 to 1945",
    "dept": "HIST",
    "num": "458",
    "desc": "Prereq: Sophomore classification\nAmerica in transition and crisis: Progressivism, World War I, the twenties, the Great Depression, and World War II.\n",
    "credits": "3"
  },
  {
    "course_name": "U.S. 1945 to the Present",
    "dept": "HIST",
    "num": "459",
    "desc": "Prereq: Sophomore classification\nModern American history with an emphasis on political, socio-cultural, ethno-racial, and military history.  Topics include the Cold War, the wars in Korea and Vietnam, civil rights and Black/ethnic Power, modern feminism, and the conservative movement.\n",
    "credits": "3"
  },
  {
    "course_name": "The Great Plains",
    "dept": "HIST",
    "num": "460",
    "desc": "Prereq: Sophomore Classification\nHistory of the Great Plains from prehistoric period.  Emphasis on agricultural and rural development, Native Americans, cattle ranching, land policy, agrarian reform movements and federal policy.\n",
    "credits": "3"
  },
  {
    "course_name": "The Rural South",
    "dept": "HIST",
    "num": "461",
    "desc": "Prereq: Sophomore classification\nHistory of the American South from colonial period to present. Emphasis on economic, social, and political change in this rural region.\n",
    "credits": "3"
  },
  {
    "course_name": "The American West",
    "dept": "HIST",
    "num": "465",
    "desc": "Prereq: Sophomore classification\nHistory of trans-Mississippi West from 1800 to present, concentrating on settlement and regional identity. Emphasis on the state, the environment, urbanization, agriculture, Native Americans, and minority communities.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Rural America",
    "dept": "HIST",
    "num": "468",
    "desc": "Prereq: Sophomore classification\nHistory of rural America from the colonial period to the present. Emphasizes immigration, ethnicity, religion, social and cultural change, and agriculture in relation to rural settlement, institution building, demographic change, gender, class, and political and economic development.\n",
    "credits": "3"
  },
  {
    "course_name": "Civil Rights and Ethnic Power",
    "dept": "HIST",
    "num": "473",
    "desc": "Prereq: Sophomore classification\nComparative history of the civil rights and ethnic power movements (African American, Chicano, American Indian, Puerto Rican, among others) in the U.S. from World War II to the present. Topics include institutional foundations, leadership, gender and racial dynamics, and the convergences and divergences of these differing ethnic struggles for rights.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Tradition and Transformation of China's Foreign Affairs",
    "dept": "HIST",
    "num": "474",
    "desc": "Prereq: Sophomore classification\nEvolution of China's external relations from the antiquities to our own times; conceptions, practices, and relationships that characterized the inter-state relations of the so-called \"Chinese world order,\" interactions between \"Eastern\" and \"Western,\" and \"revolutionary\" and \"conventional\" modes of international behaviors.\n",
    "credits": "3"
  },
  {
    "course_name": "China and the Cold War",
    "dept": "HIST",
    "num": "479",
    "desc": "Prereq: Sophomore classification\nImportant events in China's Cold War involvement, connections between domestic and foreign affairs, factors and rationales in China's foreign policy making the relationship between China's Cold War experience and recent developments.\n",
    "credits": "3"
  },
  {
    "course_name": "Field Experience for Secondary Teaching Preparation",
    "dept": "HIST",
    "num": "480",
    "desc": "Prereq: Permission of area coordinator required prior to enrollment\nObservation and participation in a variety of school settings after admission to the teacher preparation program. (S/F grading may be used in some offerings of some sections.).\n",
    "credits": "0"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: History/Social Sciences",
    "dept": "HIST",
    "num": "480A",
    "desc": "Prereq: Admission to Teacher Education\nSupervised participation in a 5-12 school setting. Permission of History/Social Sciences coordinator required prior to  enrollment. 1/2 day of time needed. Clinical Supervision Level 3.\n",
    "credits": "2"
  },
  {
    "course_name": "Public History",
    "dept": "HIST",
    "num": "481",
    "desc": "Prereq: Sophomore classification.\nDevelopment of theories and methods in the field of public history. Emphasis on practical applications such as archival research, museum interpretation, historic preservation, and oral history within the context of United States history.\n  None",
    "credits": "3"
  },
  {
    "course_name": "Birth, Death, Medicine, and Disease",
    "dept": "HIST",
    "num": "482",
    "desc": "Prereq: Sophomore classification\nHistory of medicine, sickness, and public health from ancient times to the twenty-first century in the US, Europe, and around the world. Topics include changing ideas of health and illness, development of doctors and hospitals, social and ethical issues in health care, and epidemics from cholera to AIDS.\n",
    "credits": "3"
  },
  {
    "course_name": "American Stuff, Colonial Times to the Present",
    "dept": "HIST",
    "num": "488",
    "desc": "Prereq: Sophomore classification\nInventions, innovations, artifacts, and material culture in the United States, from homespun cloth and the Colt revolver, through the transcontinental railroad and Model T, to fast food and the iPhone.\n",
    "credits": "3"
  },
  {
    "course_name": "The World at War",
    "dept": "HIST",
    "num": "489",
    "desc": "Prereq: Sophomore standing\nIn-depth exploration of a particular global conflict (topic varies; e.g., the French and Indian War, the Napoleonic Wars, World War I, World War II, the Vietnam War, and post-Cold War U.S. overseas conflicts) by focusing on multiple aspects of that conflict such as belligerents’ justification, diplomacy, manpower policy, technology, strategies and tactics, morality, protest, civilian and military experiences, gender roles, the aftermath of conflict, and collective memory and memorialization.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "HIST",
    "num": "490",
    "desc": "Prereq: 9 credits in history; permission of department chair\nReading and reports on problems selected in conference with each student.\n  No more than 6 credits of Hist 490 may be counted toward graduation with a major in History.  No credits of Hist 490 may count toward a minor in History.",
    "credits": "1"
  },
  {
    "course_name": "Historiography and Research Writing",
    "dept": "HIST",
    "num": "495",
    "desc": "Prereq: Senior history majors with at least 12 credits of 300+ level history courses\nVariable topics seminar that focuses on historiographical and research skills and writing. Required of majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in History",
    "dept": "HIST",
    "num": "496",
    "desc": "Prereq: Sophomore classification or permission of instructor.\nSpecialized topics in history, topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in History: Europe",
    "dept": "HIST",
    "num": "496A",
    "desc": "Prereq: Sophomore classification or permission of instructor.\nSpecialized topics in history, topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in History: U.S. and North America",
    "dept": "HIST",
    "num": "496B",
    "desc": "Prereq: Sophomore classification or permission of instructor.\nSpecialized topics in history, topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in History: Global",
    "dept": "HIST",
    "num": "496C",
    "desc": "Prereq: Sophomore classification or permission of instructor.\nSpecialized topics in history, topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Teaching History/Social Sciences",
    "dept": "HIST",
    "num": "498",
    "desc": "Prereq: Concurrent enrollment in HIST 480A; Admission to teacher education and 30 credits in subject-matter field\nConcurrent enrollment in 480A; Admission to teacher education and 30 credits in subject-matter field. Theories and processes of teaching and learning secondary history/social sciences. Emphasis on development and enactment of current methods, assessments, and curriculum materials for providing appropriate learning experiences.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in East Asian History",
    "dept": "HIST",
    "num": "510",
    "desc": "Prereq: Permission of instructor\nReadings in East Asian history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American History",
    "dept": "HIST",
    "num": "511",
    "desc": "Prereq: Permission of instructor\nReadings in American history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American History: Colonial Period",
    "dept": "HIST",
    "num": "511A",
    "desc": "Prereq: Permission of instructor\nReadings in American history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American History: Nineteenth Century",
    "dept": "HIST",
    "num": "511B",
    "desc": "Prereq: Permission of instructor\nReadings in American history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American History: Twentieth Century",
    "dept": "HIST",
    "num": "511C",
    "desc": "Prereq: Permission of instructor\nReadings in American history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American History: Social and Cultural",
    "dept": "HIST",
    "num": "511E",
    "desc": "Prereq: Permission of instructor\nReadings in American history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American History:  West",
    "dept": "HIST",
    "num": "511F",
    "desc": "Prereq: Permission of instructor\nReadings in American history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in European History",
    "dept": "HIST",
    "num": "512",
    "desc": "Prereq: Permission of instructor\nReadings in European history.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in European History:  Ancient",
    "dept": "HIST",
    "num": "512A",
    "desc": "Prereq: Permission of instructor\nReadings in European history.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in European History: Medieval and Early Modern",
    "dept": "HIST",
    "num": "512B",
    "desc": "Prereq: Permission of instructor\nReadings in European history.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in European History: Modern",
    "dept": "HIST",
    "num": "512C",
    "desc": "Prereq: Permission of instructor\nReadings in European history.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Latin American History",
    "dept": "HIST",
    "num": "513",
    "desc": "Prereq: Permission of instructor\nReadings in Latin American history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Modern Russian/Soviet History",
    "dept": "HIST",
    "num": "530",
    "desc": "Prereq: HIST 422\nReadings in modern Russian history. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in European Rural and Agricultural History",
    "dept": "HIST",
    "num": "550",
    "desc": "Prereq: Permission of instructor\nReadings in European rural and agricultural history.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American Rural and Agricultural History",
    "dept": "HIST",
    "num": "552",
    "desc": "Prereq: Permission of instructor\nReadings in American rural and agricultural history.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American Rural and Agricultural History: American Agriculture",
    "dept": "HIST",
    "num": "552A",
    "desc": "Prereq: Permission of instructor\nReadings in American agricultural history.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American Rural and Agricultural History: Agrarian Reform Movements",
    "dept": "HIST",
    "num": "552B",
    "desc": "Prereq: Permission of instructor\nReadings on American agrarian reform movements.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American Rural and Agricultural History: Midwestern Rural Society",
    "dept": "HIST",
    "num": "552C",
    "desc": "Prereq: Permission of instructor\nReadings on American Midwestern rural society.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in American Rural and Agricultural History: Women in Rural Life",
    "dept": "HIST",
    "num": "552D",
    "desc": "Prereq: Permission of instructor\nReadings on American women and rural life.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Environmental History",
    "dept": "HIST",
    "num": "554",
    "desc": "Prereq: Permission of instructor.\nReadings in environmental history.  Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Environmental History:  American",
    "dept": "HIST",
    "num": "554A",
    "desc": "Prereq: Permission of instructor.\nReadings in American environmental history.  Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Environmental History:  European",
    "dept": "HIST",
    "num": "554B",
    "desc": "Prereq: Permission of instructor.\nReadings in European environmental history.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Environmental History:  Global",
    "dept": "HIST",
    "num": "554C",
    "desc": "Prereq: Permission of Instructor\nReadings in global environmental history.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Technological History",
    "dept": "HIST",
    "num": "575",
    "desc": "Prereq: Permission of instructor\nReadings in the history of technology.  Topics vary each time taught.\n",
    "credits": "3"
  },
  {
    "course_name": "Historical Methods",
    "dept": "HIST",
    "num": "583",
    "desc": "\nStudy of evidence, theory, and methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Historical Methods:  Narrative",
    "dept": "HIST",
    "num": "583A",
    "desc": "Prereq: Permission of instructor.\nStudy of the methodologies of historical narrative.\n",
    "credits": "3"
  },
  {
    "course_name": "Historical Methods:  Statistical Evidence and Analysis",
    "dept": "HIST",
    "num": "583B",
    "desc": "Prereq: Permission of instructor.\nStudy of methodologies of using statistical evidence in writing history.\n",
    "credits": "3"
  },
  {
    "course_name": "Historical Methods:  Issues in Historiography",
    "dept": "HIST",
    "num": "583C",
    "desc": "Prereq: Permission of instructor.\nStudy of issues surrounding the development of historiography and historical theories.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Methods for the Modern Europe Survey",
    "dept": "HIST",
    "num": "585",
    "desc": "Prereq: Graduate status or instructor approval.\nPedagogy and historiography of Europe, from the Protestant Reformation to the present. Pedagogical topics covered include general principles of survey-course construction, lecture technique, and textbook evaluation; historiographical topics will include the Reformation, the Enlightenment, the Industrial Revolution, the French Revolution, the rise of Nationalism, imperialism, the two World Wars, the Cold War and decolonization.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Women's History and Feminist Theory",
    "dept": "HIST",
    "num": "586",
    "desc": "Prereq: Permission of instructor\nFeminism as a movement and feminst theory from the early modern period to the present as it relates to the writing of women's history.  Analysis of intepretations of European and U.S. women's history from patriarchal and postmodernist perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "HIST",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar in American History",
    "dept": "HIST",
    "num": "593",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in American History: Colonial Period",
    "dept": "HIST",
    "num": "593A",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in American History: Nineteenth Century",
    "dept": "HIST",
    "num": "593B",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in American History: Twentieth Century",
    "dept": "HIST",
    "num": "593C",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in American History:  West",
    "dept": "HIST",
    "num": "593F",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in European History",
    "dept": "HIST",
    "num": "594",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in European History: Ancient",
    "dept": "HIST",
    "num": "594A",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in European History: Medieval and Early Modern",
    "dept": "HIST",
    "num": "594B",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in European History: Modern",
    "dept": "HIST",
    "num": "594C",
    "desc": "Prereq: Permission of instructor\nTopics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "HIST",
    "num": "599",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar in American Rural and Agricultural History",
    "dept": "HIST",
    "num": "610",
    "desc": "Prereq: Permission of instructor\nEmphasis varies each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in Environmental History",
    "dept": "HIST",
    "num": "612",
    "desc": "Prereq: Permission of instructor.\nEmphasis varies each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in Technological History",
    "dept": "HIST",
    "num": "614",
    "desc": "Prereq: Permission of instructor.\nEmphasis varies each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "HIST",
    "num": "699",
    "desc": "\nGraduate student thesis research.\n",
    "credits": "1"
  },
  {
    "course_name": "First-Year Honors Seminar",
    "dept": "HON",
    "num": "121",
    "desc": "Prereq: Membership in the First-Year Honors Program\nOrientation to Iowa State University and to the University Honors Program.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Special Problems",
    "dept": "HON",
    "num": "290",
    "desc": "Prereq: Membership in and permission of the University Honors Program\nIndependent study on topics of an interdisciplinary nature. Intended primarily for freshmen and sophomores.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Honors",
    "dept": "HON",
    "num": "290H",
    "desc": "Prereq: Membership in and permission of the University Honors Program\nIndependent study on topics of an interdisciplinary nature. Intended primarily for freshmen and sophomores.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "HON",
    "num": "290U",
    "desc": "Prereq: Membership in and permission of the University Honors Program\nIndependent study on topics of an interdisciplinary nature. Intended primarily for freshmen and sophomores.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Honors Leadership Seminar",
    "dept": "HON",
    "num": "302",
    "desc": "Prereq: Selection as a leader of a First-Year Honors Seminar\nFor students serving as leaders of First-Year Honors Seminars, under faculty supervision. Development of teaching and leadership skills within the context of an Honors education experience.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "University Honors Seminars",
    "dept": "HON",
    "num": "321",
    "desc": "Prereq: Membership in the University Honors Program\nInterdisciplinary seminars on topics to be announced in advance.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "University Honors Seminars",
    "dept": "HON",
    "num": "322",
    "desc": "Prereq: Membership in the University Honors Program\nInterdisciplinary seminars on topics to be announced in advance.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "University Honors Seminars",
    "dept": "HON",
    "num": "323",
    "desc": "Prereq: Membership in the University Honors Program\nInterdisciplinary seminars on topics to be announced in advance.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "University Honors Seminars",
    "dept": "HON",
    "num": "324",
    "desc": "Prereq: Membership in the University Honors Program\nInterdisciplinary seminars on topics to be announced in advance.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "HON",
    "num": "490",
    "desc": "Prereq: Membership in and permission of the University Honors Program\nIndependent study on topics of an interdisciplinary nature. Intended primarily for juniors and seniors.\n",
    "credits": "arr"
  },
  {
    "course_name": "Professional and Educational Development in Horticulture.",
    "dept": "HORT",
    "num": "110",
    "desc": "\nIntended for first-year students and others new to the horticulture curriculum.  Introduction to professional and educational development within horticulture.  Focus is on university and career acclimation.  Assessed service-learning component.\n",
    "credits": "1"
  },
  {
    "course_name": "Home Horticulture",
    "dept": "HORT",
    "num": "121",
    "desc": "\nGrowing plants in and around the home including requirements for growing indoor plants, plant propagation, landscape design, and maintaining trees, lawns, flower, fruit, and vegetable gardens.  Recitation includes demonstrations and hands-on activities that illustrate principles of designing, growing and maintaining plants for both indoor and outdoor gardens.\n",
    "credits": "3"
  },
  {
    "course_name": "Floral Design",
    "dept": "HORT",
    "num": "131",
    "desc": "\nIntroduces basic geometric design of fresh arrangements, corsages, and holiday arrangements.  Includes use of tools and supplies.\n",
    "credits": "2"
  },
  {
    "course_name": "Topics in Horticulture",
    "dept": "HORT",
    "num": "193",
    "desc": "\nPractical courses in the field of horticulture.\n  A maximum of 6 credits of Hort 193 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Topics in Horticulture: Greenhouse Crops",
    "dept": "HORT",
    "num": "193A",
    "desc": "\nPractical courses in the field of horticulture.\n  A maximum of 6 credits of Hort 193 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Topics in Horticulture: Nursery Crops",
    "dept": "HORT",
    "num": "193B",
    "desc": "\nPractical courses in the field of horticulture.\n  A maximum of 6 credits of Hort 193 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Topics in Horticulture: Turfgrass",
    "dept": "HORT",
    "num": "193C",
    "desc": "\nPractical courses in the field of horticulture.\n  A maximum of 6 credits of Hort 193 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Topics in Horticulture: Fruit Crops",
    "dept": "HORT",
    "num": "193D",
    "desc": "\nPractical courses in the field of horticulture.\n  A maximum of 6 credits of Hort 193 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Topics in Horticulture: Vegetable Crops",
    "dept": "HORT",
    "num": "193E",
    "desc": "\nPractical courses in the field of horticulture.\n  A maximum of 6 credits of Hort 193 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Topics in Horticulture: Cross-Commodity",
    "dept": "HORT",
    "num": "193F",
    "desc": "\nPractical courses in the field of horticulture.\n  A maximum of 6 credits of Hort 193 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Topics in Horticulture: Landscape Horticulture",
    "dept": "HORT",
    "num": "193G",
    "desc": "\nPractical courses in the field of horticulture.\n  A maximum of 6 credits of Hort 193 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Principles of Horticulture Science",
    "dept": "HORT",
    "num": "221",
    "desc": "Prereq: BIOL 211 or concurrent enrollment\nBiological principles of growing horticultural crops including anatomy, reproduction, light, temperature, water, nutrition, and growth and development. Laboratory exercises emphasize environmental factors and permit detailed observation of plant growth.\n",
    "credits": "3"
  },
  {
    "course_name": "Spanish for Horticulture",
    "dept": "HORT",
    "num": "225",
    "desc": "\nIntroduction to basic conversation and communication skills in Spanish, and cross-cultural skills for working with Spanish speakers in the Horticulture industry, emphasizing the use of vocabulary and expressions common in the workplace.\n",
    "credits": "3"
  },
  {
    "course_name": "Trees, Shrubs, and Woody Vines for Landscaping",
    "dept": "HORT",
    "num": "240",
    "desc": "\nIdentification of trees, shrubs, and woody vines. Factors influencing the horticultural use of woody plants.  Field trips outside of regular class time may be required.\n",
    "credits": "3"
  },
  {
    "course_name": "Understanding Grape and Wine Science",
    "dept": "HORT",
    "num": "276",
    "desc": "Prereq: High school biology and chemistry.\nA scientific introduction to viticulture (grape-growing) and enology (wine-making).  Topics include grape species and varieties, viticulture practices, fruit quality, geography, history, principles of fermentation and aging, wine classification, appreciation, evaluation, storage and service, regulations, wine as food.  No wine tasting.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Graphics",
    "dept": "HORT",
    "num": "281",
    "desc": "\nIntroduction to computer and hand rendering techniques of landscape graphics.  Students will gain proficiency in plan view and elevation graphics.  Intensive studio and computer based instruction.\n",
    "credits": "2"
  },
  {
    "course_name": "Educating Youth Through Horticulture",
    "dept": "HORT",
    "num": "282",
    "desc": "\nPlanning, developing, and implementing science-based educational programs in a garden setting. Through hands-on experiences students will learn about horticulture, learning theory, and the application of science principles as they pertain to educating youth.  Assessed service-learning component.\n",
    "credits": "3"
  },
  {
    "course_name": "Pesticide Application Certification",
    "dept": "HORT",
    "num": "283",
    "desc": "\nCore background and specialty topics in agricultural, and horticultural pesticide applicator certification. Students can select certification categories and have the opportunity to obtain pesticide applicator certification at the completion of the course. Commercial pesticide applicator certification is emphasized.\n",
    "credits": "2"
  },
  {
    "course_name": "Horticulture Professional Development",
    "dept": "HORT",
    "num": "291",
    "desc": "Prereq: Permission of instructor\nIntensive training in preparation for intercollegiate competition in turfgrass, planting, design, plant identification, installation, cost estimating, and other skills at national contests in horticulture.  Students must compete in related national competition to earn credit.\n  Offered on a satisfactory-fail basis only.  Only one credit of HORT 291A, 291B, or 291C may count toward Horticulture credits for graduation. A maximum of four credits of any combination of HORT 291A, 291B, and 291C may count toward credits for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Horticulture Professional Development: Turfgrass Competition",
    "dept": "HORT",
    "num": "291A",
    "desc": "Prereq: Permission of instructor\nIntensive training in preparation for intercollegiate competition in turfgrass, planting, design, plant identification, installation, cost estimating, and other skills at national contests in horticulture. Students must compete in related national competition to earn credit.\n  Offered on a satisfactory-fail basis only.  Only one credit of HORT 291A, 291B, or 291C may count toward Horticulture credits for graduation. A maximum of four credits of any combination of HORT 291A, 291B, and 291C may count toward credits for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Horticulture Professional Development: Landscape Competition",
    "dept": "HORT",
    "num": "291B",
    "desc": "Prereq: Permission of instructor\nIntensive training in preparation for intercollegiate competition in planting, design, plant identification, installation, cost estimating, and other skills at national contests in horticulture. Students must compete in related national competition to earn credit.\n  Offered on a satisfactory-fail basis only.  Only one credit of HORT 291A, 291B, or 291C may count toward Horticulture credits for graduation. A maximum of four credits of any combination of HORT 291A, 291B, and 291C may count toward credits for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Horticulture Professional Development: Cross-Commodity",
    "dept": "HORT",
    "num": "291C",
    "desc": "Prereq: Permission of instructor\nIntensive training in preparation for intercollegiate competition in planting, plant identification and other skills at national contests in horticulture. Students must compete in related national competition to earn credit.\n  Offered on a satisfactory-fail basis only.  Only one credit of HORT 291A, 291B, or 291C may count toward Horticulture credits for graduation. A maximum of four credits of any combination of HORT 291A, 291B, and 291C may count toward credits for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Horticulture Physiology",
    "dept": "HORT",
    "num": "321",
    "desc": "Prereq: HORT 221 or BIOL 211\nPrinciples of plant physiology relating to growth and development of horticultural plants including plant water relations, membrane transport, photosynthesis, photomorphogenesis, respiration, and phytohormones. Emphasis on plant's responses to environmental factors (temperature, water, and light) including cellular and whole-plant physiology under stressful environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Plant Propagation",
    "dept": "HORT",
    "num": "322",
    "desc": "Prereq: HORT 221 or BIOL 211\nFundamental principles underlying sexual and asexual propagation of plants; practice in reproducing plants by use of seeds, cuttings, layering, grafting and budding and tissue culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Herbaceous Ornamental Plants",
    "dept": "HORT",
    "num": "330",
    "desc": "Prereq: HORT 221 or by permission of instructor\nIdentification, botanical characteristics, origins, propagation, uses and general culture of herbaceous annual and perennial plants for Midwestern gardens and landscapes.\n",
    "credits": "3"
  },
  {
    "course_name": "Hydroponic Food Crop Production",
    "dept": "HORT",
    "num": "331",
    "desc": "Prereq: HORT 221 or AGRON 181 or 3 credits in biological sciences\nPrinciples and practices of hydroponic systems, crop production and culture, aquaponic systems, and new food crops for hydroponic systems will be discussed. Laboratories will focus on demonstration and participation in practices and procedures used in hydroponic food crop production.  Assessed service-learning component.\n",
    "credits": "3"
  },
  {
    "course_name": "Greenhouse and Nursery Operations and Management",
    "dept": "HORT",
    "num": "332",
    "desc": "Prereq: HORT 221\nOperation and management of greenhouses, nurseries, and other controlled environment agriculture structures and facilities.  Principle of site selection, facility design and methods of monitoring and manipulating environmental, cultural, and management factors such as light, temperature, fertility, substrate, etc., to maximize production efficiency.  Emphasis placed on the principles of production of both ornamental and food crops.  Greenhouse analysis project required.\n",
    "credits": "4"
  },
  {
    "course_name": "Seed Science and Technology",
    "dept": "HORT",
    "num": "338",
    "desc": "Prereq: AGRON 181 (or equivalent) or HORT 221; BIOL 212\nSeed production, maturation, dormancy, vigor, deterioration, and related aspects of enhancement, conditioning, storage, and quality evaluation. Aspects of the seed industry and regulation of seed marketing.\n",
    "credits": "3"
  },
  {
    "course_name": "Woody Plant Cultivars: Shade Trees, Ornamental Trees and Woody Shrubs",
    "dept": "HORT",
    "num": "341",
    "desc": "Prereq: HORT 240 or L A 221 or  L A 222\nCultivars of the most prevalent and economically important woody landscape plants will be taught.  The importance of cultivars to the nursery and landscaping professions and suggestions for their proper usage will be discussed.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Plant Installation, Establishment, and Maintenance",
    "dept": "HORT",
    "num": "342",
    "desc": "Prereq: HORT 240 or L A 221 or L A 222\nPrinciples and practices involved with establishment and maintenance of managed landscapes.  Laboratory work involves site evaluation, installation techniques, postplant care, and maintenance of established landscape plants.\n",
    "credits": "3"
  },
  {
    "course_name": "Turfgrass Establishment and Management",
    "dept": "HORT",
    "num": "351",
    "desc": "Prereq: HORT 221 or AGRON 181 (or equivalent) or BIOL 211\nPrinciples and practices of turfgrass propagation, establishment, and management. Specialized practices relative to professional lawn care, golf courses, athletic fields, highway roadsides, and seed and sod production. The biology and control of turfgrass pests.\n",
    "credits": "3"
  },
  {
    "course_name": "Turfgrass Establishment and Management Laboratory",
    "dept": "HORT",
    "num": "351L",
    "desc": "Prereq: Credit or enrollment in HORT 351\nThose enrolled in the horticulture curriculum are required to take 351L in conjunction with 351 except by permission of the instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Soils and Plant Growth",
    "dept": "HORT",
    "num": "354",
    "desc": "Prereq: AGRON 182 or equivalent and BIOL 101\nEffects of chemical, physical, and biological properties of soils on plant growth, with emphasis on nutritive elements, pH, organic matter maintenance, and rooting development.\n",
    "credits": "3"
  },
  {
    "course_name": "Soils and Plant Growth Laboratory",
    "dept": "HORT",
    "num": "354L",
    "desc": "Prereq: Agron or Hort major with credit or enrollment in AGRON 354\nLaboratory exercises in soil testing that assess a soil's ability to support nutritive requirements for plant growth.\n",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Field Production of Horticultural Food Crops",
    "dept": "HORT",
    "num": "376",
    "desc": "Prereq: HORT 221 or AGRON 181\nAn introduction to field production of fruit and vegetable crops and the theoretical and practical knowledge required for successfully producing them. Topics will include basic principles and practices of fruit and vegetable production, site selection, soil techniques, irrigation management, equipment and tools, integrated pest management, season extension strategies, postharvest handling and food safety, marketing, and basic business planning for fruit and vegetable enterprises. Additionally, this course will prepare students for HORT 461 and HORT 471, that are advanced level courses focusing on fruit and vegetable production.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Garden Composition",
    "dept": "HORT",
    "num": "380",
    "desc": "\nFunctional and aesthetic aspects of landscape planning as a basis for design decisions; emphasis on spatial design and plant selection. Includes site analysis, development process, and design principles.\n",
    "credits": "2"
  },
  {
    "course_name": "Beginning Garden Composition Studio",
    "dept": "HORT",
    "num": "381",
    "desc": "Prereq: HORT 281 and HORT 240 or HORT 330, concurrent enrollment in HORT 380\nIntroduction to landscape design process.  Intensive studio-based projects implementing principles of landscape design, concept development, and graphic communication.\n",
    "credits": "2"
  },
  {
    "course_name": "Horticultural Management Experience",
    "dept": "HORT",
    "num": "391",
    "desc": "Prereq: HORT 221 or permission of instructor\nA structured work experience for the student to gain insight into management operations associated with production and management of horticultural crops. A report of 10 or more pages describing the student's experience is required. One credit is given for each term the student is enrolled in the course.\n  A maximum of two credits may be used toward the horticultural sciences course requirements, and two additional credits may be used toward the 128 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "HORT",
    "num": "398",
    "desc": "Prereq: Permission of department resource and career center coordinator\nStudents must register for this course before commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Plant Breeding",
    "dept": "HORT",
    "num": "421",
    "desc": "Prereq: GEN 320 or BIOL 313\nFundamental principles of plant breeding and cultivar development, breeding methods for self-pollinated, cross-pollinated and clonal crops.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable and Environmental Horticulture Systems",
    "dept": "HORT",
    "num": "424",
    "desc": "\nInquiry into ethical issues and environmental consequences of horticultural cropping systems, production practices and managed landscapes. Emphasis on systems that are resource efficient, environmentally sound, socially acceptable, and profitable.\n",
    "credits": "3"
  },
  {
    "course_name": "Floriculture Crop Production",
    "dept": "HORT",
    "num": "434",
    "desc": "Prereq: HORT 332\nPrinciples and practices of flowering and ornamental greenhouse crop production. Emphasis is placed on production of flowering potted plants, cut flowers, and foliage crops produced in greenhouses and other controlled environments. An overnight class field trip outside scheduled class time is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Plant Production",
    "dept": "HORT",
    "num": "435",
    "desc": "Prereq: HORT 332\nPrinciples and practices of producing herbaceous and woody landscape plants for gardens, landscapes, restoration and other outdoor uses.  Emphasis is placed on the production of: seedling plugs and rooted cuttings; container grown herbaceous annual and perennials; trees, shrubs, and vines; and native plants. An overnight class field trip outside scheduled class time is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Construction Management",
    "dept": "HORT",
    "num": "444",
    "desc": "\nPrinciples and practices of residential landscape construction. Encompasses project management, landscape estimating and overview of common landscape materials.  Laboratory work involves field trips and project installation.\n",
    "credits": "3"
  },
  {
    "course_name": "Horticulture Management and Administration",
    "dept": "HORT",
    "num": "445",
    "desc": "Prereq: HORT 221 and junior or senior classification\nIn-depth presentation and discussion of skills and strategies needed to manage a horticultural enterprise.  Topics include motivating employees, managing meetings, conducting performance appraisals, dealing with conflict, and managing an increasingly diverse work force.\n",
    "credits": "2"
  },
  {
    "course_name": "Professional Turfgrass Management",
    "dept": "HORT",
    "num": "451",
    "desc": "Prereq: HORT 351\nTurfgrass science including the study of (1) specific information on soil chemistry and soil modification as they relate to the development and maintenance of turfgrass areas, (2) specialized management practices used in athletic field care, professional lawn care, and golf course industries, and (3) construction methods for golf courses and sports fields.\n",
    "credits": "2"
  },
  {
    "course_name": "Integrated Management of Diseases and Insect Pests of Turfgrasses",
    "dept": "HORT",
    "num": "452",
    "desc": "Prereq: HORT 351\nIdentification and biology of important diseases and insect pests of turfgrasses. Development of integrated pest management programs in various turfgrass environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Sports Turf Management",
    "dept": "HORT",
    "num": "453",
    "desc": "Prereq: HORT 351\nManagement techniques for today's specialized athletic fields. The horticultural and budgetary aspects of football, soccer, baseball, and softball fields will be presented. Field trips and laboratory exercises will develop a practical understanding of actual principles in field development, construction, and management.\n",
    "credits": "3"
  },
  {
    "course_name": "Turf & Landscape Irrigation",
    "dept": "HORT",
    "num": "454",
    "desc": "\nIrrigation systems and principles for turf and landscape environments.  Topics include design, installation, equipment, management, and trouble shooting of irrigation systems for golf, athletic fields, residential lawns and landscapes.  Participation in practical exercises and local field trips to irrigation sites is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Fruit Crop Production and Management",
    "dept": "HORT",
    "num": "461",
    "desc": "Prereq: HORT 221\nPrinciples and practices of small fruit, tree fruit, and nut culture and production. Morphology, physiology of growth and development, plant establishment, pest management, pruning, training, harvesting, storage, and marketing of commercial temperate fruit and nut crops. Emphasis on sustainable practices.  Participation in practical exercises and local field trips is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Vegetable Production and Management",
    "dept": "HORT",
    "num": "471",
    "desc": "Prereq: HORT 221\nPrinciples of vegetable production with emphasis on sustainable production practices, market outlets, business aspects, and risk management. Topics will include crop classification and rotation; planting methods; crop climatic conditions, physiological growth & development; soil, water, and pest management; cover cropping; season extension strategies; harvest and postharvest management and marketing.  Course involves visits to growers fields to observe/experience their production enterprise.\n",
    "credits": "2"
  },
  {
    "course_name": "Vegetable Production and Management Lab",
    "dept": "HORT",
    "num": "471L",
    "desc": "Prereq: Junior or Senior status and concurrent enrollment in HORT 471 is required.\nHands-on training in the area of vegetable crop production.  Students will have an opportunity to grow a variety of vegetables in a heated greenhouse and also conduct greenhouse and lab experiments.  The lab also involves visits to vegetable production sites in Iowa to observe/experience and learn from growers and other agricultural professionals.\n",
    "credits": "1"
  },
  {
    "course_name": "Urban Forestry",
    "dept": "HORT",
    "num": "475",
    "desc": "Prereq: Junior or senior classification, 3 credits in biology\nDiscussion of establishment and management of woody perennials in community-owned urban greenspaces, consideration of urban site and soil characteristics, plant physiology, plant culture, urban forest valuation, inventory methods, species selection, and urban forest maintenance (health care and pest management).\n",
    "credits": "3"
  },
  {
    "course_name": "Horticultural Postharvest Technology",
    "dept": "HORT",
    "num": "476",
    "desc": "Prereq: HORT 221\nStudy of pre- and post-harvest factors, procedures, and challenges that affect market quality of horticultural commodities. Emphasis on storage and handling technologies to preserve quality and extend storage life of edible and ornamental horticultural crops. Field trips outside scheduled class time required.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Garden Composition",
    "dept": "HORT",
    "num": "481",
    "desc": "Prereq: HORT 240 and HORT 330 and HORT 380 and HORT 381\nPriority given to Landscape Design Installation and Management option students.  Development of residential landscapes using design principles and the design process.  Projects encompass site analysis, concept development, preliminary design, final design, and graphic presentation techniques.  Techniques will include hand and computer rendering.\n",
    "credits": "2"
  },
  {
    "course_name": "Organic Agricultural Theory and Practice",
    "dept": "HORT",
    "num": "484",
    "desc": "Prereq: 9 cr. in biological or physical sciences\nUnderstanding of the historical origins and ecological theories underpinning the practices involved in organic agriculture. Interdisciplinary examination of crop and livestock production and socio-economic processes and policies in organic agriculture from researcher and producer perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "HORT",
    "num": "490",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Greenhouse Crops",
    "dept": "HORT",
    "num": "490A",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Nursery Crops",
    "dept": "HORT",
    "num": "490B",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Turfgrass",
    "dept": "HORT",
    "num": "490C",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Fruit Crops",
    "dept": "HORT",
    "num": "490D",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Vegetable Crops",
    "dept": "HORT",
    "num": "490E",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Cross-Commodity",
    "dept": "HORT",
    "num": "490F",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Landscape Horticulture",
    "dept": "HORT",
    "num": "490G",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "HORT",
    "num": "490H",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: International Study",
    "dept": "HORT",
    "num": "490I",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "HORT",
    "num": "490J",
    "desc": "Prereq: Junior or Senior classification in horticulture or permission of instructor\nInvestigation of topic holding special interest to the student. Comprehensive report required. Election of course and topic must be approved by department head.\n  A maximum of 4 credits of Hort 490 and an additional 2 credits of 490 from outside Horticulture may be used toward the total of 129 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Seed Science Internship Experience",
    "dept": "HORT",
    "num": "491",
    "desc": "Prereq: AGRON 338, advanced approval and participation of employer and instructor\nA professional work experience and creative project for seed science secondary majors. The project requires the prior approval and participation of the employer and instructor. The student must submit a written report.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Horticulture",
    "dept": "HORT",
    "num": "493",
    "desc": "\nOff campus. Offered as demand warrants. Workshops in horticulture.\n",
    "credits": "arr"
  },
  {
    "course_name": "Service Learning",
    "dept": "HORT",
    "num": "494",
    "desc": "Prereq: Permission of instructor\nSelected projects that result in outcomes benefiting a non-Iowa State University entity while instilling professional ethics and accomplishing student learning goals. Course expenses paid by student. A maximum of 4 credits of 494 may be used toward the Horticulture credits required for graduation. Assessed service-learning component.\n",
    "credits": "arr"
  },
  {
    "course_name": "Service Learning: International",
    "dept": "HORT",
    "num": "494A",
    "desc": "Prereq: Permission of instructor\nSelected projects that result in outcomes benefiting a non-Iowa State University entity while instilling professional ethics and accomplishing student learning goals. Course expenses paid by student. A maximum of 4 credits of 494 may be used toward the Horticulture credits required for graduation. Assessed service-learning component.\n",
    "credits": "arr"
  },
  {
    "course_name": "Service Learning: Domestic",
    "dept": "HORT",
    "num": "494B",
    "desc": "Prereq: Permission of instructor\nSelected projects that result in outcomes benefiting a non-Iowa State University entity while instilling professional ethics and accomplishing student learning goals. Course expenses paid by student. A maximum of 4 credits of 494 may be used toward the Horticulture credits required for graduation. Assessed service-learning component.\n",
    "credits": "arr"
  },
  {
    "course_name": "Horticulture Travel Course Preparation",
    "dept": "HORT",
    "num": "495",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Students enrolled in this course also intend to register for HORT 496 the following term. Topics include preparation for safe international travel, the horticultural/agricultural industries, climate, crops, economics, geography, history, marketing, soils, culture, traditions, and horticultural/agricultural development of the country to be visited. Students enroll in this course the term immediately before travel to the foreign country.\n",
    "credits": "R"
  },
  {
    "course_name": "Horticulture Travel Course",
    "dept": "HORT",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Study and tour of production methods in major horticultural regions of the world. Influence of climate, economics, geography, soils, landscapes, markets, cultures, and history of horticultural crops. Location and duration of tours will vary. Tour expenses paid by students.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Crop Genetics",
    "dept": "HORT",
    "num": "506",
    "desc": "\nIntroduction to genetics of reproductive systems, recombination, segregation and linkage analysis, inbreeding, quantitative inheritance, fertility regulation, and polyploidy to prepare students for subsequent courses in crop improvement. Enrollment is restricted to off-campus MS in Plant Breeding students.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Management of  Tropical Crops",
    "dept": "HORT",
    "num": "511",
    "desc": "Prereq: PL P 408 or PL P 416 or ENT 370 or ENT 376 or HORT 221\nApplications of Integrated Crop Management principles (including plant pathology, entomology, and horticulture) to tropical cropping systems. Familiarization with a variety of tropical agroecosystems and Costa Rican culture is followed by 10-day tour of Costa Rican agriculture during spring break, then writeup of individual projects.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable and Environmental Horticulture Systems",
    "dept": "HORT",
    "num": "524",
    "desc": "\nInquiry into ethical issues and environmental consequences of horticultural cropping systems, production practices and managed landscapes. Emphasis on systems that are resource efficient, environmentally sound, socially acceptable, and profitable.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Orientation",
    "dept": "HORT",
    "num": "530",
    "desc": "\nInstruction in scientific methods and communication skills.\n",
    "credits": "2"
  },
  {
    "course_name": "Seed Physiology and the Environment",
    "dept": "HORT",
    "num": "538",
    "desc": "Prereq: AGRON 316; CHEM 231 or CHEM 331\nPhysiological aspects of seed development, maturation, longevity, dormancy, and germination of agronomic and horticultural crops and their interactions with field and storage environments. Emphasis on current literature and advanced methodology.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "HORT",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "HORT",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "HORT",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "HORT",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "HORT",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "HORT",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "HORT",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "HORT",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Seed Physiology",
    "dept": "HORT",
    "num": "543",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nBrief introduction to plant physiology.  Physiological aspects of seed development, maturation, longevity, dormancy and germination.  Links between physiology and seed quality.\n",
    "credits": "2"
  },
  {
    "course_name": "Strategies for Diversified Farming Systems",
    "dept": "HORT",
    "num": "546",
    "desc": "Prereq: SUSAG 509\nProject-focused engagement in food and farming systems using tools and perspectives drawn from multiple disciplines. Includes a field component.\n",
    "credits": "3"
  },
  {
    "course_name": "Growth and Development of Perennial Grasses",
    "dept": "HORT",
    "num": "551",
    "desc": "Prereq: Junior or senior or graduate classification or permission of instructor\nSelected topics on anatomy, morphology, and physiology relative to growth and development of perennial grasses. Emphasis on growth and development characteristics peculiar to grasses and variations of such characteristics under natural and managed conditions.\n",
    "credits": "2"
  },
  {
    "course_name": "Integrated Management of Diseases and Insect Pests of Turfgrasses",
    "dept": "HORT",
    "num": "552",
    "desc": "Prereq: HORT 351\nIdentification and biology of important diseases and insect pests of turfgrasses. Development of integrated pest management programs in various turfgrass environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Horticultural Postharvest Technology",
    "dept": "HORT",
    "num": "576",
    "desc": "Prereq: HORT 221\nStudy of pre- and post-harvest factors, procedures, and challenges that affect market quality of horticultural commodities. Emphasis on storage and handling technologies to preserve quality and extend storage life of edible and ornamental horticultural crops. Field trips outside scheduled class time required.\n",
    "credits": "3"
  },
  {
    "course_name": "Organic Agricultural Theory and Practice",
    "dept": "HORT",
    "num": "584",
    "desc": "Prereq: 9 cr. in biological or physical sciences\nUnderstanding of the historical origins and ecological theories underpinning the practices involved in organic agriculture. Interdisciplinary examination of crop and livestock production and socio-economic processes and policies in organic agriculture from researcher and producer perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "HORT",
    "num": "590",
    "desc": "Prereq: a major or minor in horticulture\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Horticulture",
    "dept": "HORT",
    "num": "593",
    "desc": "\nWorkshops in horticulture, with emphasis on off-campus instruction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Horticulture: Greenhouse Crops",
    "dept": "HORT",
    "num": "593A",
    "desc": "\nWorkshops in horticulture, with emphasis on off-campus instruction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Horticulture: Nursery Crops",
    "dept": "HORT",
    "num": "593B",
    "desc": "\nWorkshops in horticulture, with emphasis on off-campus instruction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Horticulture: Turfgrass",
    "dept": "HORT",
    "num": "593C",
    "desc": "\nWorkshops in horticulture, with emphasis on off-campus instruction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Horticulture: Fruit Crops",
    "dept": "HORT",
    "num": "593D",
    "desc": "\nWorkshops in horticulture, with emphasis on off-campus instruction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Horticulture: Vegetable Crops",
    "dept": "HORT",
    "num": "593E",
    "desc": "\nWorkshops in horticulture, with emphasis on off-campus instruction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Horticulture: Cross-Commodity",
    "dept": "HORT",
    "num": "593F",
    "desc": "\nWorkshops in horticulture, with emphasis on off-campus instruction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop in Horticulture: Landscape Horticulture",
    "dept": "HORT",
    "num": "593G",
    "desc": "\nWorkshops in horticulture, with emphasis on off-campus instruction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "HORT",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Seminar",
    "dept": "HORT",
    "num": "610",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "HORT",
    "num": "690",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research Seminar",
    "dept": "HORT",
    "num": "696",
    "desc": "\nResearch seminars by faculty and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Horticulture Teaching Practicum",
    "dept": "HORT",
    "num": "698",
    "desc": "Prereq: Graduate student classification\nDiscussions are intended to foster the development of graduate students as teaching assistants and future horticulture/plant science teachers.  Topics include establishing a classroom presence, improving lectures, motivating students, dealing with difficult or disruptive students, and developing a teaching philosophy.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Thesis and Dissertation Research",
    "dept": "HORT",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis and Dissertation Research: Greenhouse Crops",
    "dept": "HORT",
    "num": "699A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis and Dissertation Research: Nursery Crops",
    "dept": "HORT",
    "num": "699B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis and Dissertation Research: Turfgrass",
    "dept": "HORT",
    "num": "699C",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis and Dissertation Research: Fruit Crops",
    "dept": "HORT",
    "num": "699D",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis and Dissertation Research: Vegetable Crops",
    "dept": "HORT",
    "num": "699E",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis and Dissertation Research: Cross-Commodity",
    "dept": "HORT",
    "num": "699F",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis and Dissertation Research: Landscape Horticulture",
    "dept": "HORT",
    "num": "699G",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis and Dissertation Research: Biotechnology",
    "dept": "HORT",
    "num": "699I",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to the Hospitality Industry",
    "dept": "HSP M",
    "num": "101",
    "desc": "\nIntroduction to the foodservice, lodging, and tourism components of the hospitality industry. Background information, current issues, and future challenges in various segments of the industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Safety Certification",
    "dept": "HSP M",
    "num": "133",
    "desc": "\nIntroduction to safety and sanitation principles in foodservice operations.  Characteristics of food, supplies, and equipment as related to quality, sanitation, and safety are discussed.  Application of sanitation principles in restaurants are covered as well.  Students must pass a National Sanitation Certification Examination to receive credit.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to University Dining Services Management",
    "dept": "HSP M",
    "num": "189",
    "desc": "\nOverview of management concepts and distinct features of university dining services.\n",
    "credits": "1"
  },
  {
    "course_name": "Casino Management I",
    "dept": "HSP M",
    "num": "201",
    "desc": "\nAn overview of the gaming industry. Emphasis will be placed on examination of the history and development of gaming, casino operations, casino games, marketing of the core gaming products, and social and economic impacts of the gaming industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Hospitality Performance Analysis",
    "dept": "HSP M",
    "num": "230",
    "desc": "\nIntroduction to Uniform Systems of Accounts for hospitality industry, profitability, income statements, budgeting, managing cash, accounts receivable and payable, costs control, pricing, and evaluation related to restaurant, lodging, and club industry. Preparation for a hospitality accounting certification exam.\n",
    "credits": "3"
  },
  {
    "course_name": "Hospitality Sanitation and Safety",
    "dept": "HSP M",
    "num": "233",
    "desc": "\nSanitation and safety principles in hospitality operations. Issues impacting consumers and operators. Characteristics of food, supplies, and equipment as related to quality, sanitation and safety.  Application of HACCP.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Tourism Management",
    "dept": "HSP M",
    "num": "260",
    "desc": "\nOverview of the global tourism industry: hospitality and related services, destination/ attractions, tourist behaviors, and destination marketing.  Introduction to destination mix, socio-economic and cultural impacts of tourism, destination organizations, tourist motivations, destination image, marketing, promotions, tourism distribution system, and the future of tourism.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Non-alcoholic Beverages and Café Operations",
    "dept": "HSP M",
    "num": "280",
    "desc": "Prereq: HSP M 101, HSP M 133\nAdvanced knowledge, preparation, and service of non-alcoholic beverages applied for café operations.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Club Management",
    "dept": "HSP M",
    "num": "289",
    "desc": "Prereq: HSP M 101\nOrganization and management of private clubs including city, country, and other recreational and social clubs. Field trip may be required.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "HSP M",
    "num": "290",
    "desc": "Prereq: Freshman or Sophomore classification.  Permission of instructor, adviser, and department chair.\nIndependent study on topics of special interest to the student, facilitated by approved faculty member.\n  Maximum of 9 credits combined of HSP M 290 and HSP M 490 can be applied to graduation.",
    "credits": "1"
  },
  {
    "course_name": "Hospitality Law",
    "dept": "HSP M",
    "num": "315",
    "desc": "Prereq: HSP M 101\nLaws relating to ownership and operation of hospitality organizations. The duties and rights of both hospitality business operators and customers.  Legal implications of various managerial decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Attractions and Amusement Park Administration",
    "dept": "HSP M",
    "num": "320",
    "desc": "Prereq: HSP M 101 or permission of instructor\nExamination of current issues in the attractions and amusement park industry.  Emphasis will be placed on development and design along with the functional departments of modern amusement parks and themed attractions.\n",
    "credits": "3"
  },
  {
    "course_name": "Hospitality Operations Cost Controls",
    "dept": "HSP M",
    "num": "333",
    "desc": "Prereq: Credit or enrollment in HSP M 380, HSP M 380L; 3 credits MATH and HSP M 230\nIntroduction to revenue and cost systems in the hospitality industry. Application of principles related to procurement, production, and inventory controls.\n",
    "credits": "3"
  },
  {
    "course_name": "Lodging Operations Management I",
    "dept": "HSP M",
    "num": "352",
    "desc": "Prereq: Credit or enrollment in HSP M 101\nIntroduction to functional department activities and current issues of lodging organizations with emphasis on front office and housekeeping. Reservation activities and night audit exercises. Case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Production Management",
    "dept": "HSP M",
    "num": "380",
    "desc": "Prereq: HSP M 233 or 2 cr MICRO; FS HN 111 or FS HN 214; FS HN 115 or FS HN 215; at least junior classification; enrollment in HSP M 380L\nPrinciples of and procedures used in quantity food production management including menu planning, food costing, work methods, food production systems, quality control, and service.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Production Management Experience",
    "dept": "HSP M",
    "num": "380L",
    "desc": "Prereq: HSP M 233 or 2 cr MICRO; FS HN 111 or FS HN 214; FS HN 115 or FS HN 215; at least junior classification; enrollment in HSP M 380\nApplication of quantity food production and service management principles and procedures in the program's foodservice operation.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Wine, Beer, and Spirits",
    "dept": "HSP M",
    "num": "383",
    "desc": "Prereq: Must be at least 21 years old\nIntroduction to history and methods of production for a variety of wines, beers, and spirits.  Beverage tasting and sensory analysis; product knowledge; service techniques; sales; and alcohol service related to the hospitality industry.  Field trip.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Wine, Spirits, and Mixology Laboratory",
    "dept": "HSP M",
    "num": "383L",
    "desc": "Prereq: HSP M 383 or concurrent enrollment.  Must be at least 21 years old\nThe application of the management principles and procedures related to the sale and service of alcohol, specialty beverages, and cocktails served in the beverage and hospitality industry.  Beverage tasting and sensory analysis of products commonly served in the beverage industry.\n",
    "credits": "1"
  },
  {
    "course_name": "Foodservice Systems Management I",
    "dept": "HSP M",
    "num": "391",
    "desc": "Prereq: Credit or enrollment in HSP M 380, HSP M 380L\nPrinciples and techniques related to basic management, leadership, and human resource management of foodservices in health care and other on-site foodservice settings. Food safety and sanitation for on-site foodservice operations.\n  Credit for either HSP M 391 or AESHM 287 and AESHM 438 may count toward graduation. Not accepted for credit toward a major in Hospitality Management.",
    "credits": "3"
  },
  {
    "course_name": "Foodservice Systems Management II",
    "dept": "HSP M",
    "num": "392",
    "desc": "Prereq: HSP M 391\nIntroduction to cost control in foodservice departments: procedures for controlling food, labor, and other variable costs. Application of principles related to food product selection, specification, purchase, and storage in health care and other onsite operations.\n  Credit for either HSP M 392 or HSP M 233 and HSP M 333 may count toward graduation. Not accepted for credit toward a major in Hospitality Management.",
    "credits": "3"
  },
  {
    "course_name": "Hospitality Management Industry Workshop",
    "dept": "HSP M",
    "num": "393",
    "desc": "Prereq: HSP M Junior or Senior Classification and Permission of Instructor.\nIntensive 2 to 8 week workshop exploration.  Topics vary each time offered.\n  Maximum of 6 credits of HSPM 393 can be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Case Studies in Event Management",
    "dept": "HSP M",
    "num": "431",
    "desc": "Prereq: Graduate-level standing and permission by instructor.\nOperational and strategic challenges in the event management industry through directed case studies, roundtable discussions, and industry-related readings. Students will critically evaluate case studies related to event management in areas of event strategy, financial management, event operations, stakeholder development, event design, marketing, and other event topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Hospitality Financial Management",
    "dept": "HSP M",
    "num": "433",
    "desc": "Prereq: HSP M 333; ACCT 284; ECON 101; credit or enrollment in STAT 101\nUse of common financial statements, accounting ratios, and financial techniques to impact management decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Hospitality and Event Technology Applications",
    "dept": "HSP M",
    "num": "437",
    "desc": "Prereq: HSP M 101\nIntroduction to hospitality information technology. Property management and point-of-sales system interfaces:  customer relationship management, selecting and purchasing computer systems, electronic distribution systems, internet and its related application systems, managing internal and external communication networks. Case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Hospitality Human Resource Management",
    "dept": "HSP M",
    "num": "439",
    "desc": "Prereq: AESHM 238\nEmphasis on development of management personnel in hospitality organizations. Case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Lodging Operations Management II",
    "dept": "HSP M",
    "num": "452",
    "desc": "Prereq: HSP M 352; credit or enrollment in HSP M 333\nDevelopment of business plan and evaluation of business performance in a simulated environment. Operational decision making practices by applying concepts of management, operations, marketing, and finance for a computer-mediated environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Management in Hospitality",
    "dept": "HSP M",
    "num": "455",
    "desc": "Prereq: AESHM 238 and AESHM 340; credit or enrollment in HSP M 433\nIntroduction to  strategic management principles and practices with an application of human resources, operations, marketing, and financial management concepts. Case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Professional Internship: Hospitality",
    "dept": "HSP M",
    "num": "470",
    "desc": "Prereq: AESHM 270, AESHM 211, 9 credits in HSP M, and minimum 2.0 GPA; permission by application; junior or senior classification; employer location should be different than employer/location used for AESHM 170 and AESHM 270\nSupervised work experience with a cooperating firm or organization.\n  No more than 12 credits from AESHM 170, AESHM 270, and AESHM 470 may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Fine Dining Event Management",
    "dept": "HSP M",
    "num": "487",
    "desc": "Prereq: HSP M 380, HSP M 380L\nExploration of the historical and cultural development of the world food table.  Creative experiences with U.S. regional and international foods. Application of management and financial principles in food preparation and service in fine dining settings.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Issues in Food Safety",
    "dept": "HSP M",
    "num": "489",
    "desc": "Prereq: Credit or enrollment in FS HN 101 or FS HN 272 or HSP M 233; FS HN 419 or FS HN 420; FS HN 403\nCapstone seminar for the food safety minor. Case discussions and independent projects about safety issues in the food system from a multidisciplinary perspective.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "HSP M",
    "num": "490",
    "desc": "Prereq: Sections B-E:  Program approval; Section H:  Full membership in Honors Program\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Hospitality Management",
    "dept": "HSP M",
    "num": "490B",
    "desc": "Prereq: Sections B-E: Program approval\nIndependent Study in Hospitality Management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Lodging Operations",
    "dept": "HSP M",
    "num": "490D",
    "desc": "Prereq: Sections B-E: Program approval; Section H: Full membership in Honors Program\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Foodservice Operations",
    "dept": "HSP M",
    "num": "490E",
    "desc": "Prereq: Sections B-E: Program approval; Section H: Full membership in Honors Program\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "HSP M",
    "num": "490H",
    "desc": "Prereq: Sections B-E: Program approval; Section H: Full membership in Honors Program\n",
    "credits": "arr"
  },
  {
    "course_name": "Hospitality Management Scholarship and Applications",
    "dept": "HSP M",
    "num": "505",
    "desc": "\nFocus on teaching and research scholarship involving the hospitality industry.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Issues in Hospitality Management",
    "dept": "HSP M",
    "num": "506",
    "desc": "\nFocus on current issues related to the hospitality industry.\n",
    "credits": "1"
  },
  {
    "course_name": "Case Studies in Event Management",
    "dept": "HSP M",
    "num": "531",
    "desc": "Prereq: Graduate-level standing and permission by instructor.\nOperational and strategic challenges in the event management industry through directed case studies, roundtable discussions, and industry-related readings. Students will critically evaluate case studies related to event management in areas of event strategy, financial management, event operations, stakeholder development, event design, marketing, and other event topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Decision Making in Hospitality Organizations",
    "dept": "HSP M",
    "num": "533",
    "desc": "Prereq: HSP M 433\nConcepts of financial management applied to strategic decision making.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Resources Development in Hospitality Organizations",
    "dept": "HSP M",
    "num": "538",
    "desc": "Prereq: AESHM 238\nTheories of human resources management. Practices and principles related to development of management personnel.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Marketing",
    "dept": "HSP M",
    "num": "540",
    "desc": "Prereq: AESHM 340\nApplication of marketing principles in developing effective marketing strategies for hospitality, apparel, and retail organizations. Evaluation of multi-dimensional marketing functions in hospitality organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Management in Hospitality Organizations",
    "dept": "HSP M",
    "num": "555",
    "desc": "Prereq: Courses in MKT, FIN, MGMT, and HSP M.  Permission of instructor\nStrategic management process as a planning and decision-making framework; integration of human resources, operations, marketing, and financial management concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Tourism Management and Tourist Behavior",
    "dept": "HSP M",
    "num": "560",
    "desc": "Prereq: HSP M 260 or equivalent\nTourism theories and research. Overview of tourism industry, tourism theories, methods, and current issues in destination marketing and management and travel behavior. Evaluation of tourism and destination research.\n  NA",
    "credits": "3"
  },
  {
    "course_name": "Fine Dining Event Management",
    "dept": "HSP M",
    "num": "587",
    "desc": "Prereq: HSP M 380, HSP M 380L\nExploration of the historical and cultural development of the world food table.  Creative experiences with U.S. regional and international foods. Application of management and financial principles in food preparation and service in fine dining settings.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "HSP M",
    "num": "590",
    "desc": "Prereq: 9 credits in HRI at 400 level or above; application process\nTopics in hospitality management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Hospitality Management",
    "dept": "HSP M",
    "num": "590B",
    "desc": "Prereq: 9 credits in HSP M at 400 level or above; application process.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Tourism",
    "dept": "HSP M",
    "num": "590C",
    "desc": "Prereq: 9 credits in HSP M at 400 level or above; application process\nSpecial topics in tourism.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Lodging Operations",
    "dept": "HSP M",
    "num": "590D",
    "desc": "Prereq: 9 credits in HSP M at 400 level or above; application process.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Commercial/Retail Foodservice Operations",
    "dept": "HSP M",
    "num": "590E",
    "desc": "Prereq: 9 credits in HSP M at 400 level or above; application process.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Onsite Foodservice Operations",
    "dept": "HSP M",
    "num": "590F",
    "desc": "Prereq: 9 credits in HSP M at 400 level or above; application process.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics:  Event Management",
    "dept": "HSP M",
    "num": "590G",
    "desc": "Prereq: 9 credits in HSP M or EVENT at 500 level or above; application process\nSpecial Topics in Event Management.\n  Only 6 credits of HSP M 590G can be applied toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "HSP M",
    "num": "599",
    "desc": "\nCreative component as arranged with instructor.\n",
    "credits": "arr"
  },
  {
    "course_name": "Professional Writing",
    "dept": "HSP M",
    "num": "604",
    "desc": "Prereq: Enrollment in PhD program\nDevelopment of professional written communication with emphasis on abstracts, proposals, manuscripts, and technical reports.\n",
    "credits": "2"
  },
  {
    "course_name": "Administrative Problems",
    "dept": "HSP M",
    "num": "608",
    "desc": "Prereq: Permission of instructor; enrollment in PhD program\nAdvanced administrative problems; case studies in foodservice and lodging organizations.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Hospitality Financial Management",
    "dept": "HSP M",
    "num": "633",
    "desc": "Prereq: HSP M 433; Enrollment in PhD program\nTheories and research in financial management with emphasis on financial performance and financing decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory and Research Seminar in Event Management",
    "dept": "HSP M",
    "num": "634",
    "desc": "Prereq: STAT 401 or a graduate level course in statistics or by permission of instructor\nAnalysis and application of theories and research methodologies in event management and is designed to strengthen students’ analytical and critical perspectives to evaluate event management research. Multidisciplinary approach to the areas of sports events, festivals and fairs, conventions and tradeshows, mega events, lifecycle/religious/nonprofit events, and event tourism.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Human Resources Management in Hospitality Organizations",
    "dept": "HSP M",
    "num": "638",
    "desc": "Prereq: HSP M 538; Enrollment in PhD program\nResearch in human resources management with an emphasis on organization or unit administration.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on Marketing Thoughts",
    "dept": "HSP M",
    "num": "640",
    "desc": "Prereq: HSP M 540; STAT 401.  Enrollment in PhD program\nConceptual and theoretical development of marketing strategies. Analytical and critical review of marketing research and industry practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Lodging Operations",
    "dept": "HSP M",
    "num": "652",
    "desc": "Prereq: Enrollment in PhD program\nAnalysis and applications of concepts and theories of operations research for lodging operations.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar in Tourism Management",
    "dept": "HSP M",
    "num": "660",
    "desc": "Prereq: Enrollment in PhD program\nAdvanced graduate course on tourism and destination theories and research.  Analysis and application of theories, research findings, and research methods in tourism and destination management.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis of Research in Foodservice Operations",
    "dept": "HSP M",
    "num": "680",
    "desc": "Prereq: Enrollment in PhD program\nAnalysis and application of theories, research, and research methods in foodservice operations.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "HSP M",
    "num": "690",
    "desc": "Prereq: Enrollment in PhD program, application process\nAdvanced study of current topics in hospitality management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Hospitality Management",
    "dept": "HSP M",
    "num": "690B",
    "desc": "Prereq: Enrollment in PhD program, application process\nAdvanced study of current topics in hospitality management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Tourism",
    "dept": "HSP M",
    "num": "690C",
    "desc": "Prereq: Enrollment in PhD program, application process\nAdvanced study of current topics in hospitality management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Lodging Operations",
    "dept": "HSP M",
    "num": "690D",
    "desc": "Prereq: Enrollment in PhD program, application process\nAdvanced study of current topics in hospitality management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Commercial/Retail Foodservice Operations",
    "dept": "HSP M",
    "num": "690E",
    "desc": "Prereq: Enrollment in PhD program, application process\nAdvanced study of current topics in hospitality management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Onsite Foodservice Operations",
    "dept": "HSP M",
    "num": "690F",
    "desc": "Prereq: Enrollment in PhD program, application process\nAdvanced study of current topics in hospitality management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Event Management",
    "dept": "HSP M",
    "num": "690G",
    "desc": "Prereq: Enrollment in PhD program, application process\nAdvanced study of current topics in event management and hospitality management.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "HSP M",
    "num": "699",
    "desc": "Prereq: Enrollment in PhD program\nResearch.\n",
    "credits": "arr"
  },
  {
    "course_name": "Evaluating Technology-based Learning Environments",
    "dept": "HCI",
    "num": "504",
    "desc": "Prereq: EDUC 501\nPrinciples and procedures to plan, design, and conduct effective evaluation studies (formative, summative, usability) in different settings are studied. Opportunities to engage in real or simulated evaluation projects of substantial scope are provided. Create evaluation instruments, develop methods with which to evaluate a product or program, conduct try-outs or usability sessions, analyze the data, report the findings, and recommendations are some of the course activities.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of 3D Character Animation",
    "dept": "HCI",
    "num": "507",
    "desc": "Prereq: ARTIS 308\nAnimation techniques using the computer and available software. Principles of character animation. Prior knowledge of modeling, lighting, texturing and rendering with available software is assumed.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer/Video Game Design and Development",
    "dept": "HCI",
    "num": "509",
    "desc": "Prereq: Permission of instructor\nIndependent project based creation and development of \"frivolous and non-frivolous\" computer games in a cross-disciplinary team. Projects require cross-disciplinary teams. Aspects of Indie development and computer/video game history will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Natural Language Processing",
    "dept": "HCI",
    "num": "515",
    "desc": "Prereq: STAT 330 or equivalent, recommended ENGL 219 or LING 219, or ENGL 511 or LING 511\nIntroduction to computational techniques involving human language and speech in applications such as information retrieval and extraction, automatic text categorization, word prediction, intelligent Web searching, spelling and grammar checking, speech recognition and synthesis, statistical machine translation, n-grams, POS-tagging, word-sense disambiguation, on-line lexicons and thesauri, markup languages, corpus analysis, and Python programming language.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Analysis of English",
    "dept": "HCI",
    "num": "520",
    "desc": "Prereq: ENGL 510 or LING 510, and ENGL 511 or LING 511\nConcepts and practices for analysis of English by computer with emphasis on the applications of computational analysis to problems   in applied linguistics such as corpus analysis and recognition of learner language in computer-assisted learning and language   assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Psychology of Human Computer Interaction",
    "dept": "HCI",
    "num": "521",
    "desc": "Prereq: Graduate classification or instructor approval\nBiological, behavioral, perceptual, cognitive and social issues relevant to human computer interactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Scientific Methods in Human Computer Interaction",
    "dept": "HCI",
    "num": "522",
    "desc": "Prereq: PSYCH 521 and STAT 101 or equivalent\nBasics of hypothesis testing, experimental design, analysis and interpretation of data, and the ethical principles of human research as they apply to research in human computer interaction.\n",
    "credits": "3"
  },
  {
    "course_name": "Optimization Methods for Complex Designs",
    "dept": "HCI",
    "num": "525",
    "desc": "Prereq: M E 160, MATH 265\nOptimization involves finding the 'best' according to specified criteria. Review of a range of optimization methods from traditional nonlinear to modern evolutionary methods such as Genetic algorithms. Examination of how these methods can be used to solve a wide variety of design problems across disciplines, including mechanical systems design, biomedical device design, biomedical imaging, and interaction with digital medical data. Students will gain knowledge of numerical optimization algorithms and sufficient understanding of the strengths and weaknesses of these algorithms to apply them appropriately in engineering design. Experience includes code writing and off-the-shelf routines. Numerous case-studies of real-world situations in which problems were modeled and solved using advanced optimization techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the 3D Visualization of Scientific Data",
    "dept": "HCI",
    "num": "558",
    "desc": "Prereq: Graduate-student standing in the mathematical or natural sciences or engineering; basic programming knowledge\nIntroduction to visualizing scientific information with 3D computer graphics and their foundation in human perception. Overview of different visualization techniques and examples of 3D visualization projects from different disciplines (natural sciences, medicine, and engineering). Class project in interactive 3D visualization using the ParaView, Mayavi, TVTK, VTK or a similar system.\n",
    "credits": "3"
  },
  {
    "course_name": "UX Lab Studies: Eyetracking & Other UX Tools",
    "dept": "HCI",
    "num": "570",
    "desc": "\nPractical introduction to User Experience (UX) tools and how to use them for research: Designing a UX study; developing meaningful user tasks; how to plan a research study that integrates eyetracking measures, UX measures, behavioral measures, surveys, interviews and IRB applications; analyzing UX data; and presenting UX study results.\n",
    "credits": "1"
  },
  {
    "course_name": "Augmented Reality",
    "dept": "HCI",
    "num": "571",
    "desc": "Prereq: M E 557/CPR E 557/COM S 557, or equivalent computer graphics experience\nFundamental technologies enabling augmented reality (AR) application development. Assessment and integration of the hardware and software systems necessary for AR including, tracking, image processing and rendering. Programming skills in C++ and GPU-based optimization are developed to enable evaluation of interaction devices and modalities afforded by AR.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Implementation and Prototyping in HCI",
    "dept": "HCI",
    "num": "574",
    "desc": "\nFundamental concepts of software programming and the practical use of the Python programming language. Assignments include user interaction and interface design, information visualization, as well as other computational HCI tools. Intended for graduate students without prior background in software development. Requires programming during class lectures.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Perception",
    "dept": "HCI",
    "num": "575",
    "desc": "Prereq: Graduate standing or permission of instructor\nThis class covers statistical and algorithmic methods for sensing, recognizing, and interpreting   the activities of people by a computer. This semester we will focus on machine perception   techniques that facilitate and augment human-computer interaction. The main goal of the class is to   introduce computational perception on both theoretical and practical levels. Participation in small   groups to design, implement, and evaluate a prototype of a human-computer interaction system that   uses one or more of the techniques covered in the lectures.\n",
    "credits": "3"
  },
  {
    "course_name": "Virtual Environments, Virtual Worlds, and Application",
    "dept": "HCI",
    "num": "580",
    "desc": "Prereq: Senior or Graduate status.\nA systematic introduction to the underpinnings of Virtual Environments (VE), Virtual Worlds, advanced displays and immersive technologies; and an overview of some of the applications areas particularly virtual engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Developmental Robotics",
    "dept": "HCI",
    "num": "585",
    "desc": "Prereq: knowledge of C/C++ programming language.\nAn introduction to the emerging interdisciplinary field of Developmental Robotics, which crosses the boundaries between robotics, artificial intelligence, developmental psychology, and philosophy. The main goal of this field is to create autonomous robots that are more intelligent, more adaptable, and more useful than the robots of today, which can only function in very limited domains and situations.\n",
    "credits": "3"
  },
  {
    "course_name": "Models and Theories in Human Computer Interaction",
    "dept": "HCI",
    "num": "587",
    "desc": "\nSurvey of the multidisciplinary models and theories that form the foundation of the science of Human Computer Interaction.  Application of the scientific method to solve practical problems by using analyses or approaches from the behavioral and social sciences, and information and computer technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Ethics",
    "dept": "HCI",
    "num": "589",
    "desc": "Prereq: Graduate classification or permission of instructor.\nIssues in ethics and decision-making as they relate to technology, design, design research, HCI, and the design industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "HCI",
    "num": "590",
    "desc": "\nInvestigation of problems of special interest in human computer interaction.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Human Computer Interaction",
    "dept": "HCI",
    "num": "591",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Entrepreneurship Workshop",
    "dept": "HCI",
    "num": "592",
    "desc": "\nStudents will be taken step-by-step through activities that must be undertaken when attempting to commercialize a technology or start their own company.  Speakers will be brought in to introduce relevant topics, provide resources, answer questions, and provide working examples.\n",
    "credits": "1"
  },
  {
    "course_name": "Visual Design of HCI",
    "dept": "HCI",
    "num": "595",
    "desc": "\nHuman interaction design as it applies to HCI. Aspects of audience analysis, design methodologies for creating concepts and solutions, techniques of concept prototyping, and the fundamentals of visual design such as color, type, symbolism, and grid structure. Class discussions, tutorials, and hands-on projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Emerging Practices in Human-Computer Interaction",
    "dept": "HCI",
    "num": "596",
    "desc": "Prereq: HCI 521\nUsability evaluation with emphasis on requirements gathering, rapid prototyping, evaluation, and communicating results through report writing along with emerging practices.\n",
    "credits": "3"
  },
  {
    "course_name": "HCI Design, Implementation and Implications",
    "dept": "HCI",
    "num": "598",
    "desc": "Prereq: 21 credits in human computer interaction or permission of the instructor\nCapstone course in HCI. Through a significant design project, students demonstrate their mastery of core courses in HCI. This course is the final course for students in the HCI Online MS program.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "HCI",
    "num": "599",
    "desc": "\nCreative component for nonthesis option of Master of Science degree.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Learning Environments Design",
    "dept": "HCI",
    "num": "603",
    "desc": "Prereq: EDUC 503\nExploration of advanced aspects of the learning environments design process. Application of analysis, design, development and production, evaluation, implementation, and project management principles. Theory and research in educational technology provides the foundation for design decisions. Focus on current trends in learning environment design and the production and use of educational technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Organizational and Social Implications of Human Computer Interaction",
    "dept": "HCI",
    "num": "655",
    "desc": "Prereq: Graduate Classification\nExamine opportunities and implications of information technologies and human computer interaction   on social and organizational systems. Explore ethical and social issues appurtenant to human   computer interaction, both from a proscriptive and prescriptive perspective. Develop informed   perspective on human computer interaction. Implications on research and development programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Engineering",
    "dept": "HCI",
    "num": "681",
    "desc": "Prereq: I E 572 or I E 577 or PSYCH 516 or HCI/PSYCH 521 or equivalent\nProvides an overview of human cognitive capabilities and limitations in the design of products, work places, and large systems. Contexts vary broadly and could range from simple use of mobile devices to an air-traffic control or nuclear plant command center. Course focuses on what we can infer about users' thoughts and feelings based on what we can measure about their performance and physiological state. Covers the challenge of designing automated systems.\n",
    "credits": "3"
  },
  {
    "course_name": "HCI Internship",
    "dept": "HCI",
    "num": "697",
    "desc": "Prereq: Permission of Director of Graduate Education, graduate classification\n",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "HCI",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Individual and Family Development, Health, and Well-being",
    "dept": "HD FS",
    "num": "102",
    "desc": "\nOverview of life-span developmental tasks (physical, cognitive, language, social, emotional) examined from various theoretical perspectives. Discussion of topics related to family diversity, individual/family health and well-being and reciprocal relationships as affected by external factors.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Principles for Working with Children",
    "dept": "HD FS",
    "num": "103",
    "desc": "\nIntroduction to professional principles and ethics, understanding of child abuse reporting, universal precautions. Completion of criminal background checks for ISU practica.\n  Offered on a satisfactory-fail basis only.  Only one of HD FS 103 or 105 may count toward graduation.",
    "credits": "0"
  },
  {
    "course_name": "Professional Principles for Working with Youth and Adults",
    "dept": "HD FS",
    "num": "105",
    "desc": "\nIntroduction to professional principles and ethics, understanding of child, dependent adults and elder abuse reporting, working with aging adults, universal precautions.\n  Offered on a satisfactory-fail basis only.  Only one of HD FS 103 or 105 may count toward graduation.",
    "credits": "0"
  },
  {
    "course_name": "Freshman Learning Community Orientation",
    "dept": "HD FS",
    "num": "110",
    "desc": "Prereq: Membership in HD FS Learning Community\nIntroduction to the Department of Human Development and Family Studies including academic requirements and opportunities, strategies for transitioning to college, learning and study strategies, reading and reflection, and career awareness.\n",
    "credits": "1"
  },
  {
    "course_name": "New Transfer Student Seminar",
    "dept": "HD FS",
    "num": "111",
    "desc": "\nIntroduction to HD FS curricula and faculty for students in CH FS, FCEDS or F C P. Department and University policies and procedures, degree audits, and registration.  Exploration of campus resources and strategies for student success.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Personal Finance in Early Adulthood",
    "dept": "HD FS",
    "num": "183",
    "desc": "\nIntroduction to basic concepts and budgeting practices for management of resources and prevention of financial problems commonly associated with college, including credit and student loans.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Early Childhood Education Teacher Orientation",
    "dept": "HD FS",
    "num": "208",
    "desc": "Prereq: classification as ECE major\nOverview of early childhood education (birth-grade 3) teacher licensure requirements.  Program planning and university procedures.  Required of all students majoring in early childhood education.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Orientation and Service Learning",
    "dept": "HD FS",
    "num": "218",
    "desc": "Prereq: Credit or concurrent enrollment in HD FS 102. For child, adult and family services majors.\nEthics, professional development, and career exploration in child, adult and family services. Visits to and service learning with programs that serve children, adults and families with diverse needs. Participation in service learning project required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Child Development and Health",
    "dept": "HD FS",
    "num": "223",
    "desc": "\nTypical and atypical development of children prenatal through middle childhood. Examination of healthy development and potential impact of health issues in children. Discussion of influence of the family and society on development.\n  Either HD FS 223 or HD FS 224, but not both, may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Development in Young Children: Birth through Age 8",
    "dept": "HD FS",
    "num": "224",
    "desc": "Prereq: HD FS 102 and HD FS 103\nLearning, growth, and development (typical and atypical) of children from birth through age eight. Explores importance of family, programs, and a diverse society. Strategies for observing, recording, and interpreting children's cognitive, communication, motor, social, and emotional development. Practicum.\n  Either HD FS 223 or HD FS 224, but not both, may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Development and Guidance in Middle Childhood",
    "dept": "HD FS",
    "num": "226",
    "desc": "Prereq: HD FS 102 or PSYCH 230\nPhysical, cognitive, socioemotional, and identity development from 5 to 12 years of age. Development within the contexts of family, school, peers, and society. Guidance of children in family and group settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Adolescent and Emerging Adulthood",
    "dept": "HD FS",
    "num": "227",
    "desc": "Prereq: HD FS 102 or PSYCH 230\nPhysical, cognitive, and socioemotional development of adolescents and emerging adults in the context of family, relationships, and culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Adult Development",
    "dept": "HD FS",
    "num": "234",
    "desc": "Prereq: HD FS 102 or PSYCH 230\nIntroductory exploration of the health, individual and social factors associated with adult development including younger adulthood, middle age and older adulthood. Information is presented from a life-span developmental framework.\n",
    "credits": "3"
  },
  {
    "course_name": "Consumer Issues",
    "dept": "HD FS",
    "num": "239",
    "desc": "\nIntroduction to factors affecting consumer decisions of individuals and families, including housing, healthcare, and personal finances. Emphasis on accessibility and affordability, community contexts for families; and  consumer protection, legislation and regulation, and consumer fraud.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Literature for Children",
    "dept": "HD FS",
    "num": "240",
    "desc": "\nEvaluation of literature for children, including an emphasis on diversity and inclusion; cultural competence. Roles of literature in the overall development of children. Literature selection and use in the home and educational settings.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Parenting and Family Diversity Issues",
    "dept": "HD FS",
    "num": "249",
    "desc": "\nParenting practices and family relationships across the lifespan. Practical knowledge and techniques about how to be an effective parent. Diverse families, discipline, and parent education programs.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Family Communications and Relationships",
    "dept": "HD FS",
    "num": "270",
    "desc": "Prereq: HD FS 102 or PSYCH 230\nFamily communication and its functions to develop, maintain, enrich and limit family relationships. Family theories related to communication and ethical considerations when working with families.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Human Sexuality",
    "dept": "HD FS",
    "num": "276",
    "desc": "\nBehavioral, biological, and psychological aspects of human sexuality within the social context of family, culture, and society. Role of sexuality in human development. Critical analysis of media and research. Communication and decision-making skills relating to sexuality issues and relationships.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Personal and Family Finance",
    "dept": "HD FS",
    "num": "283",
    "desc": "\nIntroduction to basic principles of personal and family finance. Budgeting, record keeping, checking and savings accounts, consumer credit, insurance, investments, and taxes.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Field Experiences",
    "dept": "HD FS",
    "num": "317",
    "desc": "Prereq: Permission of instructor.\nConsult department office for procedure. Supervised field experience in human development and family studies programs.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Field Experiences: Human Development and Family Studies",
    "dept": "HD FS",
    "num": "317B",
    "desc": "Prereq: 9 credits in HD FS.\nConsult department office for procedure. Supervised field experience in human development and family studies programs.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Field Experiences: Honors",
    "dept": "HD FS",
    "num": "317H",
    "desc": "Prereq: 9 credits in HD FS\nConsult department office for procedure. Supervised field experience in human development and family studies programs.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Assessment and Curriculum: Ages Birth through 2 Years",
    "dept": "HD FS",
    "num": "340",
    "desc": "Prereq: HD FS 103; HD FS 224; admission to teacher education program\nAssessment strategies for infants and toddlers, including those with special needs. Curricula, learning environments, teaching strategies, health and nutritional practices, and schedules that are developmentally, individually, and culturally appropriate. Using assessment to plan, implement, and evaluate activities to promote physical, motor, cognitive, communication, and social emotional development. Practicum.\n",
    "credits": "4"
  },
  {
    "course_name": "Household Finance and Policy",
    "dept": "HD FS",
    "num": "341",
    "desc": "\nThe social, economic, and governmental contexts of financial decision-making at the household level.\n",
    "credits": "3"
  },
  {
    "course_name": "Guidance and Group Management in Early Childhood",
    "dept": "HD FS",
    "num": "342",
    "desc": "Prereq: HD FS 103; HD FS 224\nGuiding prosocial development, self-regulation, and task engagement of children birth to age 8. Focus is on promoting prosocial behaviors through supportive relationships and environments within diverse home, center, or school settings. Functional behavior assessment and ongoing progress monitoring for targeted and intensive interventions. Practicum.\n",
    "credits": "3"
  },
  {
    "course_name": "Assessment and Curriculum: Ages 3 through 6 Years",
    "dept": "HD FS",
    "num": "343",
    "desc": "Prereq: HD FS 103; HD FS 224; HD FS 240; admission to teacher education program\nAssessment strategies for preschool and kindergarten children, including those with special needs. Learning environments, schedules, activities, nutritional practices, and teaching strategies that are developmentally, individually, and culturally appropriate. Using assessment to plan, implement, and evaluate activities to promote physical motor, cognitive, communication, and social emotional development. Practicum.\n",
    "credits": "4"
  },
  {
    "course_name": "Programming for Children in Early Care and Education",
    "dept": "HD FS",
    "num": "344",
    "desc": "Prereq: HD FS 103; HD FS 224\nProgramming in inclusive child care centers and family child care homes, including those with special needs, aged birth through 8 years. Developing, implementing, and evaluating learning environments; activities and materials; behavioral guidance and classroom management practices; health and nutritional practices; and schedules to ensure developmental, individual, and cultural appropriateness. Monitoring children's development and behavior to promote physical, motor, cognitive, communication, and social emotional development. Learning to collaborate effectively with parents and staff. Practicum.\n",
    "credits": "4"
  },
  {
    "course_name": "Adapting Programming in Inclusive Settings",
    "dept": "HD FS",
    "num": "345",
    "desc": "Prereq: HD FS 224; SP ED 250\nAdapting instruction, materials, and equipment to meet developmental needs of young children birth through age 8 with diverse learning needs and multiple disabilities in inclusive settings. Addressing individualized education programs; special health care needs, challenging behavior, and positioning and handling techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Housing and Services for Families and Children",
    "dept": "HD FS",
    "num": "360",
    "desc": "Prereq: 6 credits in social sciences\nApproaches to and assessment of housing and services that assist those with special needs including those with disabilities, low-income, children at risk, single-parents, and the homeless. Emphasis on community settings; e.g., residential facilities, group housing, shelters and transitional housing.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Abuse and Illness in Families",
    "dept": "HD FS",
    "num": "367",
    "desc": "Prereq: HD FS 102 or PSYCH 230\nCauses and consequences of family stressors including physical, sexual, and emotional abuse; substance abuse; and mental and physical illness across the life span. Interplay between victims, offenders, and the treatment system.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Human Development and Family Studies",
    "dept": "HD FS",
    "num": "369",
    "desc": "Prereq: HD FS 102 or PSYCH 230; 9 hours in HD FS; junior or senior status.\nUnderstanding and evaluating research. Use of primary and secondary data to identify and study problems related to human development and family issues. An introduction to statistical concepts and data analysis. Computer laboratory experience.\n",
    "credits": "3"
  },
  {
    "course_name": "Death as a Part of Living",
    "dept": "HD FS",
    "num": "373",
    "desc": "Prereq: HD FS 102\nConsideration of death in the life span of the individual and the family with opportunity for exploration of personal and societal attitudes.\n",
    "credits": "3"
  },
  {
    "course_name": "Aging and the Family",
    "dept": "HD FS",
    "num": "377",
    "desc": "Prereq: HD FS 102\nInterchanges of the aged and their families. Emphasis on role changes, social interaction, and independence as influenced by health, finances, life styles, and community development.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Retirement Planning and Employee Benefits",
    "dept": "HD FS",
    "num": "378",
    "desc": "Prereq: 3 credits in introductory economics\nEconomic well-being in the context of demographic change, the present and future of Social Security, family retirement needs analysis, investment strategies and characteristics of retirement plans, helping others to work towards financial security, family economic issues for retired persons. Overview of employee and retirement benefits.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Financial Planning",
    "dept": "HD FS",
    "num": "383",
    "desc": "Prereq: HD FS 283\nFundamental principles of the financial planning process, client/planner interactions, time value of money applications as well as analyses of ethics review, financial statements, cash flow and debt management, education planning, retirement planning, tax planning, and estate planning needs of families.\n",
    "credits": "3"
  },
  {
    "course_name": "Children, Families, and Public Policy",
    "dept": "HD FS",
    "num": "395",
    "desc": "Prereq: HD FS 369 or equivalent\nPublic policy and politics as they affect children and families. Examination of how individuals and groups influence policy. Investigation of current issues and programs influencing the well-being and welfare of children and families.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Development and Family Studies Seminar",
    "dept": "HD FS",
    "num": "416",
    "desc": "Prereq: 8 credits in human development and family studies\nIntensive study of a selected topic in human development and family studies.\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Student Teaching",
    "dept": "HD FS",
    "num": "417",
    "desc": "Prereq: Reservation required\n",
    "credits": "8"
  },
  {
    "course_name": "Supervised Student Teaching: Early Childhood Special Education Programs.",
    "dept": "HD FS",
    "num": "417C",
    "desc": "Prereq: GPA 2.5, full admission to teacher education program, HD FS 455; HD FS 456.\nTeaching experience with preschool children with disabilities.\n",
    "credits": "8"
  },
  {
    "course_name": "Professional Practice Reflection/Discussion",
    "dept": "HD FS",
    "num": "418",
    "desc": "\nDiscussion of professional practice experience.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Professional Practice Reflection/Discussion: Teaching",
    "dept": "HD FS",
    "num": "418A",
    "desc": "Prereq: Taken concurrently with HD FS 417\nDiscussion of HD FS 417 student teaching field experience.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Professional Practice Reflection/Discussion: Internships",
    "dept": "HD FS",
    "num": "418B",
    "desc": "Prereq: Junior classification\nProcess and development of skills necessary for professional preparation and practice including career planning, resume writing, and interviewing. Strategies for successful career management.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Program Evaluation and Proposal Writing",
    "dept": "HD FS",
    "num": "449",
    "desc": "Prereq: HD FS 369\nTheory and practice of program evaluation and proposal writing in human services including needs assessment, outcome development and measurement, and proposal components.   Assessment of programs' success in meeting goals.\n",
    "credits": "3"
  },
  {
    "course_name": "Curriculum and Interventions: Ages 3 through 6 Years",
    "dept": "HD FS",
    "num": "455",
    "desc": "Prereq: HD FS 343, HD FS 345, SP ED 405 and SP ED 458\nProgram models and methods leading to development and organization of appropriate curricula in preschool and kindergarten programs for young children with diverse learning needs. Government regulations and professional standards for child programming. Teaming with parents, colleagues, and paraprofessionals to plan, implement, and evaluate developmentally and culturally appropriate individualized education plans in inclusive settings. Practicum.\n",
    "credits": "4"
  },
  {
    "course_name": "Working with Families in Early Intervention",
    "dept": "HD FS",
    "num": "456",
    "desc": "Prereq: Current background check; HD FS 340 or HD FS 344; or permission of instructor\nApplying family systems theory and family centered principles in early intervention. Understanding the impact of disability on families and young children. Utilizing strategies for delivering family-centered interventions and service coordination in home-based and natural environments. Building trusting relationships, teaming with families and interdisciplinary colleagues to create, implement, and evaluate Individualized Family Service Plans (IFSPs) for children birth to age three. Understanding foundations of theory and policy and empowering families through effective supports and services. Experiences with families.\n",
    "credits": "3"
  },
  {
    "course_name": "Environments for the Aging",
    "dept": "HD FS",
    "num": "463",
    "desc": "Prereq: HD FS 360 or 3 credits in housing, architecture, interior design, rehabilitation, psychology, or human development and family studies or permission of instructor\nEmphasis on independent living within residential settings including specialized shelter, supportive services and housing management. Application of criteria appropriate for accessibility and functional performance of activities; universal design principles. Creative project provides service learning opportunities. (on-line course offering via Distance Education).\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Family Interaction Dynamics",
    "dept": "HD FS",
    "num": "479",
    "desc": "Prereq: HD FS 102 or equivalent; HD FS 369 or equivalent; 9 hours in social sciences; junior or senior status\nAnalysis of research related to family interaction processes across the family life span. Emphasis on relationship dynamics and cultural differences.\n",
    "credits": "3"
  },
  {
    "course_name": "Family Savings and Investments",
    "dept": "HD FS",
    "num": "482",
    "desc": "Prereq: HD FS 283\nManagement of family financial resources; emphasis on savings and the investment planning process; issues facing financial planners who manage family assets. Identification of investment options including common stocks, fixed income securities, convertible securities, and related choices.\n",
    "credits": "3"
  },
  {
    "course_name": "Estate Planning for Families",
    "dept": "HD FS",
    "num": "484",
    "desc": "Prereq: HD FS 283\nStudy of estate planning focusing on efficient conservation and transfer of wealth, consistent with client’s goals.  Legal, tax, financial and non-financial aspects of estate planning process; trusts, wills, probate, advanced directives, charitable giving, wealth transfers and related taxes.\n",
    "credits": "3"
  },
  {
    "course_name": "Capstone: Family Financial Planning",
    "dept": "HD FS",
    "num": "485",
    "desc": "Prereq: HD FS 341, HD FS 378, HD FS 383, HD FS 482, FIN 361\nDevelopment and refinement of competencies required by personal financial planners to work with individuals and families in meeting financial objectives. Utilization of skills obtained in financial planning emphasis to complete one or more financial planning narratives.\n",
    "credits": "3"
  },
  {
    "course_name": "Administration of Human Services Programs",
    "dept": "HD FS",
    "num": "486",
    "desc": "Prereq: Junior classification; 6 credits in HD FS at 300 level and above\nExamination of purpose, policies, staffing, operations, and clientele of organizations serving children, adults and families with diverse needs.  Management/leadership principles and techniques. Introduction to financial management. Administrators/supervisors roles in employee management as well as development of client-oriented programs, fundraising, goal setting, strategic planning, and advocacy.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Counseling",
    "dept": "HD FS",
    "num": "489",
    "desc": "Prereq: HD FS 283 for 489, graduate classification for 589\nPersonal, social/psychological and legal climates affecting family financial decisions. A life cycle approach to financial decision making. Development of financial counseling and planning skills to assist families and individuals to become self-sufficient in family financial management.\n",
    "credits": "2"
  },
  {
    "course_name": "Financial Counseling Laboratory",
    "dept": "HD FS",
    "num": "489L",
    "desc": "Prereq: HD FS 283 for 489L, graduate classification for 589L\nHands-on financial counseling experience using preventative, remedial, and productive strategies in one-on-one and/or group situations. Students work with clients to develop diverse and inclusive decision-making and problem-solving methods to achieve goals or to remove barriers.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "HD FS",
    "num": "490",
    "desc": "Prereq: 6 credits in human development and family studies\nConsult department office for procedure.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "HD FS",
    "num": "490H",
    "desc": "Prereq: 6 credits in human development and family studies\nConsult department office for procedure.\n",
    "credits": "arr"
  },
  {
    "course_name": "Internship",
    "dept": "HD FS",
    "num": "491",
    "desc": "Prereq: HD FS 418B; permission of instructor; senior classification; minimum 2.0 GPA.\nSupervised work experience related to the student's curriculum.\n  Offered on a satisfactory-fail basis only.",
    "credits": "4"
  },
  {
    "course_name": "Workshop",
    "dept": "HD FS",
    "num": "493",
    "desc": "Prereq: Senior classification\nWorkshop in HD FS.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "HD FS",
    "num": "499",
    "desc": "Prereq: Consult department office for procedures.\nSupervised research experience.\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Studies, Research, and Ethics in HD FS",
    "dept": "HD FS",
    "num": "501",
    "desc": "Prereq: Admission to HD FS Graduate program\nOverview of graduate study, research, ethics, and professional development in the field of human development and family studies. Curriculum, programs of study, portfolios, faculty research interests,  dissemination of research, career planning, and teaching discussed.\n",
    "credits": "2"
  },
  {
    "course_name": "Professional Development in Human Development and Family Studies",
    "dept": "HD FS",
    "num": "502",
    "desc": "Prereq: graduate classification; HD FS 501\nOverview of professional skills, portfolio building, preparation for academic and nonacademic jobs, leadership fundamentals and project management training, time management, work balance issues, and professional ethics. Opportunities for graduate students to work on their professional development tailored to individual needs of students. Develop an individual professional portfolio.\n",
    "credits": "2"
  },
  {
    "course_name": "Quantitative Research Methods",
    "dept": "HD FS",
    "num": "503",
    "desc": "Prereq: Permission of instructor\nConcepts, methods, and strategies for quantitative research in human development and family studies. Topics include the descriptive and inferential statistical techniques for quantitative research, using statistical packages to store and conduct statistical analyses, basic research methods in human development and family studies, and the relation between research designs and statistics.\n",
    "credits": "4"
  },
  {
    "course_name": "Qualitative Research Methods",
    "dept": "HD FS",
    "num": "504",
    "desc": "Prereq: 9 credits of social sciences or permission of instructor\nIntroduction to qualitative research methodology. Application of fieldwork methods, analysis, interpretation, and writing through individual qualitative research projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Application of Quantitative Research Methods",
    "dept": "HD FS",
    "num": "505",
    "desc": "Prereq: HD FS 503 or permission of instructor\nPractical applications of quantitative research methods, including an introduction to secondary data analysis, correlation and regression analysis, regression diagnostics; reporting results.\n",
    "credits": "3"
  },
  {
    "course_name": "Theories of Human Development",
    "dept": "HD FS",
    "num": "510",
    "desc": "Prereq: 9 credits of social sciences or permission of instructor\nTheoretical approaches and current research in child, adolescent, and adult development. Individual life span perspectives. Implications for research, policy and practice. (Summer course offering is on-line).\n",
    "credits": "3"
  },
  {
    "course_name": "Family Theory",
    "dept": "HD FS",
    "num": "511",
    "desc": "Prereq: 9 credits in social sciences or permission of instructor\nTheoretical approaches and current research in family development. Review the nature and value of theory to the study of the family and evaluate the use of theory in empirical research. Implications for research, policy and practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Perspectives in Gerontology",
    "dept": "HD FS",
    "num": "530",
    "desc": "\nOverview of current aging issues including theory and research, critical social and political issues in aging, the interdisciplinary focus of gerontology, career opportunities, and aging in the future. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Adult Development",
    "dept": "HD FS",
    "num": "534",
    "desc": "\nExploration of the biological, psychological and social factors associated with aging. Although the focus is on the later years, information is presented from a life-span developmental framework. Empirical studies are reviewed and their strengths, limitations and implications for normative and optimal functioning are discussed. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Developmental Disabilities",
    "dept": "HD FS",
    "num": "538",
    "desc": "Prereq: 9 credits in human development and family studies or psychology or permission of instructor\nTheories, research, and current issues regarding the intersection of development and disabilities. Investigation of interventions with individuals and families. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Housing and Real Estate in Family Financial Planning",
    "dept": "HD FS",
    "num": "541",
    "desc": "\nThe role of housing and real estate in the family financial planning process, including taxation, mortgages, financial calculations, legal concerns, and ethical issues related to home ownership and real estate investments. Emphasis on emerging issues in the context of housing and real estate. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Economics, Public Policy, and Aging",
    "dept": "HD FS",
    "num": "545",
    "desc": "\nPolicy development in the context of the economic status of the older adult population. Retirement planning and the retirement decisions; social security and public transfer programs; intra-family transfers to/from the aged; private pensions; financing medical care; prospects and issues for the future.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues and Research in Early Childhood Services",
    "dept": "HD FS",
    "num": "555",
    "desc": "Prereq: 9 credits in social sciences or permission of instructor\nAnalysis of contemporary and historical early childhood/early intervention/early childhood special education model programs and services. Examination of relationships among service systems and implementation, program quality, teacher effectiveness, and outcomes for children with and without disabilities. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Environments for the Aging",
    "dept": "HD FS",
    "num": "563",
    "desc": "Prereq: HD FS 360 or 3 credits in housing, architecture, interior design, rehabilitation, psychology, or human development and family studies or permission of instructor\nEmphasis on independent living within residential settings including specialized shelter, supportive services and housing management. Application of criteria appropriate for accessibility and functional performance of activities; universal design principles. Creative project provides service learning opportunities. (on-line course offering via Distance Education).\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Family Policy",
    "dept": "HD FS",
    "num": "566",
    "desc": "Prereq: 6 credits in social sciences or permission of instructor\nAn introduction to policy for family researchers and practitioners. Examination of relevant policies through a family lens via discussion of theory and student interests in current and enduring family policies and programs. Descriptions of work roles in family policy and the interaction of family researchers and policymakers.\n",
    "credits": "3"
  },
  {
    "course_name": "Family Stress, Abuse, and Illness",
    "dept": "HD FS",
    "num": "567",
    "desc": "Prereq: 9 credits in social sciences or permission of instructor\nExplores research related to family stress within romantic, parent-child, and sibling relationships. Examines contemporary theory and research on the nature, causes, and consequences of family stressors. These stressors include, but are not limited to economic distress; physical and emotional abuse; substance abuse; and mental and physical illness across the life span. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Individual and Family Assessment",
    "dept": "HD FS",
    "num": "568",
    "desc": "Prereq: HD FS 510 or permission of instructor\nUse of interviews, observational assessments, direct tests with individuals and families for research and intervention. Opportunities to practice assessments.\n",
    "credits": "3"
  },
  {
    "course_name": "Cross-cultural Perspectives about Families and Children",
    "dept": "HD FS",
    "num": "575",
    "desc": "Prereq: 6 credits in social sciences or permission of instructor\nReview of current research regarding family diversity including an examination of cultural and structural influences on the development and well-being of families and children. Discussion of the impact on human rights and social justice. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Aging in the Family Setting",
    "dept": "HD FS",
    "num": "577",
    "desc": "Prereq: 9 credits in social sciences or permission of instructor\nTheories and research related to personal and family adjustments in later life affecting older persons and their intergenerational relationships. Related issues including demographics also are examined through the use of current literature. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Family Well-being Across the Lifespan",
    "dept": "HD FS",
    "num": "579",
    "desc": "Prereq: 9 credits in social sciences or permission of instructor\nReview of current research to provide a theoretical and practical understanding of the economic, social, and psychological factors that influence interpersonal relationships and individual well-being within the institution of the family system. Economic and policy effects considered.(on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "International Study in Human Development and Family Studies",
    "dept": "HD FS",
    "num": "581",
    "desc": "Prereq: Permission by application\nLimited enrollment. Supervised international study experiences in Human Development and Family Studies. Countries vary.\n",
    "credits": "1"
  },
  {
    "course_name": "International Study in HD FS: Practicum",
    "dept": "HD FS",
    "num": "581A",
    "desc": "Prereq: Permission by application\nLimited enrollment. Supervised international study experiences in Human Development and Family Studies. Countries vary.\n",
    "credits": "1"
  },
  {
    "course_name": "International Study in HD FS: Exchange",
    "dept": "HD FS",
    "num": "581B",
    "desc": "Prereq: Permission by application\nLimited enrollment. Supervised international study experiences in Human Development and Family Studies. Countries vary.\n",
    "credits": "1"
  },
  {
    "course_name": "International Study in HD FS: Group Study",
    "dept": "HD FS",
    "num": "581C",
    "desc": "Prereq: Permission by application\nLimited enrollment. Supervised international study experiences in Human Development and Family Studies. Countries vary.\n",
    "credits": "1"
  },
  {
    "course_name": "Investing for the Family's Future",
    "dept": "HD FS",
    "num": "583",
    "desc": "\nEvaluation of investment markets for the household. Analysis of how families choose where to put their savings. Emphasis is on using the family's overall financial and economic goals to help inform investment choices. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Program Evaluation and Research Methods in Gerontology",
    "dept": "HD FS",
    "num": "584",
    "desc": "\nOverview of program evaluation, research methods, and grant writing in gerontology. Includes application of quantitative and qualitative methods in professional settings. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Program Evaluation",
    "dept": "HD FS",
    "num": "585",
    "desc": "Prereq: 6 credits in graduate level social sciences or permission of instructor\nTheoretical and practical issues related to design and implementation of program evaluation in social sciences. Includes theory, design, implementation, analysis and proposal writing to assist programs to be successful in meeting program goals.\n",
    "credits": "3"
  },
  {
    "course_name": "Family, Income, and the Economy",
    "dept": "HD FS",
    "num": "588",
    "desc": "Prereq: 9 credits in social sciences or permission of instructor\nAnalysis of family income, wealth, and economic well-being. Emphasis on effects of family behavior and public policies on the adequacy and security of income across the family life cycle. Implications of resource allocation within the family for adult and child well-being.\n",
    "credits": "3"
  },
  {
    "course_name": "Financial Counseling",
    "dept": "HD FS",
    "num": "589",
    "desc": "Prereq: HD FS 283 for 489, graduate classification for 589\nPersonal, social/psychological and legal climates affecting family financial decisions. A life cycle approach to financial decision making. Development of financial counseling and planning skills to assist families and individuals to become self-sufficient in family financial management.\n",
    "credits": "2"
  },
  {
    "course_name": "Financial Counseling Laboratory",
    "dept": "HD FS",
    "num": "589L",
    "desc": "Prereq: HD FS 283 for 489L, graduate classification for 589L\nHands-on financial counseling experience using preventative, remedial, and productive strategies in one-on-one and/or group situations. Students work with clients to develop diverse and inclusive decision-making and problem-solving methods to achieve goals or to remove barriers.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "HD FS",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nConsult department office on procedure for filing a written plan of study.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Human Development and Family Studies",
    "dept": "HD FS",
    "num": "590I",
    "desc": "Prereq: Permission of instructor\nConsult department office on procedure for filing a written plan of study.\n",
    "credits": "arr"
  },
  {
    "course_name": "Internship",
    "dept": "HD FS",
    "num": "591",
    "desc": "Prereq: 10 graduate credits\nSupervised experience in an area of human development and family studies.\n",
    "credits": "arr"
  },
  {
    "course_name": "Internship: Human Development and Family Studies",
    "dept": "HD FS",
    "num": "591I",
    "desc": "Prereq: 10 graduate credits\nSupervised experience in an area of human development and family studies.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop",
    "dept": "HD FS",
    "num": "593",
    "desc": "Prereq: Senior classification\nWorkshop in HD FS.\n",
    "credits": "arr"
  },
  {
    "course_name": "Professional Seminar in Gerontology",
    "dept": "HD FS",
    "num": "594",
    "desc": "\nAn integrative experience for gerontology students designed to be taken near the end of the degree program. By applying knowledge gained in earlier coursework, students will strengthen skills in ethical decision-making behavior, applying these skills in gerontology-related areas such as advocacy, professionalism, family and workplace issues. Students from a variety of professions will bring their unique perspectives to bear on topics of common interest. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "HD FS",
    "num": "599",
    "desc": "Prereq: 9 graduate credits in HD FS\nNonthesis students creative component (e.g., a special report, capstone course, integrated field experience, annotated bibliography, research project, design, or other creative endeavor). A minimum of five credits of independent work is required on the programs of study (POS). Creative component format determined cooperation with the POS committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Quantitative Methods",
    "dept": "HD FS",
    "num": "603",
    "desc": "Prereq: HD FS 503, HD FS 505; STAT 402 or STAT 404 or permission of instructor\nMethodological and analytical issues in research in human development and family studies. Advanced research design and measurement, selection of statistical techniques, and issues in the interpretation of findings.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Qualitative Methods",
    "dept": "HD FS",
    "num": "604",
    "desc": "Prereq: HD FS 504 or permission of instructor\nResearch methodologies including phenomenology, grounded theory, ethnography, and case studies.  Methods of data collection and analysis procedures. Issues of ethics and interpretation of findings. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Multi-level Modeling",
    "dept": "HD FS",
    "num": "605",
    "desc": "Prereq: HD FS 503 and HD FS 505 or STAT 404 or permission of instructor\nRationale for and interpretation of random coefficient models. Strategies for the analysis of multi-level and panel data including models for random intercepts, random slopes, and growth curves.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Structural Equation and Longitudinal Modeling",
    "dept": "HD FS",
    "num": "606",
    "desc": "Prereq: HD FS 603 or STAT 404 or permission of instructor\nRationale for and interpretation of advanced structural equation modeling for the analysis of longitudinal data. Emphasis will be placed on developing a working familiarity with some of the common statistical procedures, coupled with their application through the use of statistical software.\n",
    "credits": "3"
  },
  {
    "course_name": "Mixed Methods",
    "dept": "HD FS",
    "num": "607",
    "desc": "Prereq: HD FS 503, HD FS 504,HD FS 505, or permission of instructor\nFoundations of mixed methods research, controversies, and philosophical concerns. Rationale for and interpretation of mixed methods designs. Research design, sampling, data collection, data analysis, results, and interpretation. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Grant Writing for Research",
    "dept": "HD FS",
    "num": "608",
    "desc": "Prereq: HD FS 503, HD FS 505, and HD FS 504 or permission of instructor\nUnderstand how to identify funding sources as well as the fundamental components of a federal research grant proposal such as the abstract or summary, background and significance, specific aims/goals and objectives, project design and methods, sustainability, assessment, broader impacts, dissemination, budget, budget justification, and cover letter.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar",
    "dept": "HD FS",
    "num": "616",
    "desc": "\nMay be repeated. F.S.SS.\n",
    "credits": "arr"
  },
  {
    "course_name": "Child Health and Development",
    "dept": "HD FS",
    "num": "631",
    "desc": "Prereq: HD FS 510 or permission of instructor\nYoung children’s cognitive, physical, communication, and social-emotional health and development will be examined. Both typical and atypical trajectories will be explored. Research on current trends in the field will be emphasized.(on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Behavioral Interventions in Early Childhood",
    "dept": "HD FS",
    "num": "632",
    "desc": "Prereq: HD FS 510 or permission of instructor\nIssues related to behavioral development and needs of children ages 3-8.  Design and implementation of group and individual behavioral interventions. Discussion of coaching strategies to improve intervention implementation. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Infant Mental Health",
    "dept": "HD FS",
    "num": "633",
    "desc": "Prereq: HD FS 510 or permission of instructor\nExamination of the individual, interpersonal, and familial factors that influence infant (birth through age 3) mental health. Analysis of the risk and protective factors that influence these systems and their potential effects on social-emotional development. Current issues relating to effective programs for improving parent-infant interactions and additional supports available to families.(on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Adolescent and Emerging Adult Health and Development",
    "dept": "HD FS",
    "num": "634",
    "desc": "Prereq: HD FS 510 or permission of instructor\nTheory and research on biopsychosocial, cognitive, physical and sexual health and development from early adolescence to emerging adulthood. Contexts of development including families, peers, schools, neighborhoods, romantic relationships, economics and public policies are considered.(on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Adult Development, Aging, and Health",
    "dept": "HD FS",
    "num": "635",
    "desc": "Prereq: HD FS 510 or permission of instructor\nReview of the impact of the growing older adult population as well as individual development and aging on individuals, families, and society. Exploration of theoretical perspectives applied to adult development and aging and distinction of normative and non-normative changes in adulthood. Discussion of methods to assess development across adulthood and consideration of the role of individual and environmental factors impacting efforts to optimize adult development.(on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Biomarkers and Family Research",
    "dept": "HD FS",
    "num": "640",
    "desc": "Prereq: HD FS 510 or permission of instructor.\nResearch on the biological underpinnings of human development and the biobehavioral health of the family. Exposure to interdisciplinary research and practice on biomarkers in the family, with particular emphasis on health-and well being-related measures. Application of biomarker collection, measurement, analysis and dissemination.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "HD FS",
    "num": "690",
    "desc": "Prereq: Permission of instructor and enrollment in Ph.D. program\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Human Development and Family Studies",
    "dept": "HD FS",
    "num": "690I",
    "desc": "Prereq: Permission of instructor and enrollment in Ph.D. program\n",
    "credits": "arr"
  },
  {
    "course_name": "Internship",
    "dept": "HD FS",
    "num": "691",
    "desc": "Prereq: Permission of instructor\nSupervised practice and experience in the following specified areas.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Internship: College Teaching",
    "dept": "HD FS",
    "num": "691A",
    "desc": "Prereq: Permission of instructor\nSupervised practice and experience in college-level teaching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Internship: Research",
    "dept": "HD FS",
    "num": "691B",
    "desc": "Prereq: Permission of instructor\nSupervised practice and experience in conducting research.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Internship: Professional Experience",
    "dept": "HD FS",
    "num": "691D",
    "desc": "Prereq: Permission of instructor\nSupervised practice and experience in relevant professional experiences.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "HD FS",
    "num": "699",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Research: Human Development and Family Studies",
    "dept": "HD FS",
    "num": "699I",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Orientation and Human Sciences Career Exploration",
    "dept": "H SCI",
    "num": "110",
    "desc": "\nOrientation and adjustment to the university and college; review of policies and procedures; academic resources; and course selection and planning. Comprehensive approach to career development; intensive self-analysis; and in-depth examination of majors in Human Sciences. Required for all students declared as an Undecided major in the College of Human Sciences.\n",
    "credits": "2"
  },
  {
    "course_name": "Dialogues on Diversity",
    "dept": "H SCI",
    "num": "150",
    "desc": "\nAn exploration of diversity within the context of the Iowa State University community through understanding human relations issues.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "H SCI",
    "num": "490",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Entrepreneurship",
    "dept": "H SCI",
    "num": "490E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Current  Topics Workshop in Immunology",
    "dept": "IMBIO",
    "num": "602",
    "desc": "\nLectures provided by off-campus experts. Students are required to participate in discussion sessions with lecturers.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Immunobiology",
    "dept": "IMBIO",
    "num": "604",
    "desc": "\nStudent and faculty presentation.\n",
    "credits": "1"
  },
  {
    "course_name": "Comparative Immunology and Infectious Disease",
    "dept": "IMBIO",
    "num": "661",
    "desc": "Prereq: Graduate level Immunology or permission of instructor.\nDiscuss and define similarities and differences of varied host responses to infectious challenge. Learning will focus on comparative aspects of the host response and the unique aspects of immunity from different organisms, while highlighting molecular and mechanistic similarities of pathogen recognition, response and resolution.\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics",
    "dept": "IMBIO",
    "num": "690",
    "desc": "\nAdvanced study of specific topics in specialized field of immunobiology.\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Research Rotation",
    "dept": "IMBIO",
    "num": "697",
    "desc": "\nGraduate research projects performed under the supervision of selected faculty members in the Interdepartmental Immunobiology major.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "IMBIO",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Industrial Design Studio I",
    "dept": "IND D",
    "num": "201",
    "desc": "Prereq: Admission to the industrial design program, enrollment in IND D 231.\nProduct scale form development and visual communication.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Design Studio II",
    "dept": "IND D",
    "num": "202",
    "desc": "Prereq: IND D 201\nThrough a progressive series of structured exercises and projects, IND D 202 covers basic modeling principles and three dimensional form development required for industrial design activity. These activities include explorative studies in: assembly, disassembly, process efficiency, structures, materials identification, hand fabrication, and testing.  Students will work in a variety of media including: paper, foam core, poly-styrene, and wood.\n",
    "credits": "6"
  },
  {
    "course_name": "Introduction to Industrial Design",
    "dept": "IND D",
    "num": "231",
    "desc": "Prereq: DSN S 102 and DSN S 131, enrollment in 201; admission to the industrial design program through department review or permission of instructor.\nThe history, definition, scope, and basic principles of industrial design. Overview of technical, artistic, and sociological context of the profession.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Thinking for Industrial Design",
    "dept": "IND D",
    "num": "232",
    "desc": "Prereq: IND D 231\nExploration of strategies, methods, and processes associated with creative thinking skills and problem solving. Discussion of the nature of creativity and its implications in different contexts that cross content boundaries.\n",
    "credits": "3"
  },
  {
    "course_name": "Activity-Centered Industrial Design",
    "dept": "IND D",
    "num": "251",
    "desc": "Prereq: Admitted to Industrial Design Program and by permission of the instructor\nIntroduction to design for complex and dynamic situations that include people, products, activities and environments. Emphasizes the relationship between internal and external factors that impact pleasure and performance in these systems. Includes an overview of human diversity and examines the role of the industrial designer in developing the artifacts of daily activity.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering: Getting from Thought to Thing",
    "dept": "IND D",
    "num": "260",
    "desc": "\nWhat is engineering, technology and their roles in society? Investigation of engineering methods through case studies of everyday objects. Explore questions about the impact of technology in society. Apply engineering methods to design and failure analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of How Things Work",
    "dept": "IND D",
    "num": "270",
    "desc": "\nRemoving mysteries surrounding science and technology. Identify key concepts from applied science and technology to obtain better understanding on how things work. Review and explain the principles behind the technologies which define our modern way of life.   A survey of broad range of technology could include: cell phones, GPS, radio, television, computers, ultrasound, microwave ovens, automobile, bioengineering and other industrial and consumer technologies.  Common day technology examples illustrating scientific knowledge and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Industrial Design Studio III",
    "dept": "IND D",
    "num": "301",
    "desc": "Prereq: IND D 202\nSystematic design methodology and integration of creative thinking techniques.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Design Studio IV",
    "dept": "IND D",
    "num": "302",
    "desc": "Prereq: IND D 301 or permission of instructor\nExploration of commercial factors in industrial design. Meets Industrial Design Experiential Learning Requirements.\n",
    "credits": "6"
  },
  {
    "course_name": "Design Research Methods",
    "dept": "IND D",
    "num": "332",
    "desc": "Prereq: IND D 231 or permission of instructor.\nSurvey of qualitative and quantitative methods with an emphasis on contextual user-centered research. Integration of user data collection, visualization, and synthesis as a source for design. Experience of a small-scale research practice related to industrial design.\n",
    "credits": "3"
  },
  {
    "course_name": "Materials and Processes for Industrial Design",
    "dept": "IND D",
    "num": "334",
    "desc": "Prereq: IND D 201 and IND D 231.\nIntroduction to materials and manufacturing methods for mass production and distribution of products.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Aided Industrial Design I",
    "dept": "IND D",
    "num": "341",
    "desc": "Prereq: IND D 301\nEmphasis on the computer as an industrial design and visualization tool.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Human Factors Lab",
    "dept": "IND D",
    "num": "351",
    "desc": "Prereq: IND D 231 and enrollment in ARTID 251\nTheory and application of human factors issues in the industrial design field, specifically their impact on the relationship of the user, the product, and the product systems.\n",
    "credits": "1"
  },
  {
    "course_name": "History of Industrial Design I",
    "dept": "IND D",
    "num": "387",
    "desc": "Prereq: 30 credits earned at ISU\nIntroduction to contemporary and historic factors influencing industrial design craft and practice. Discussion of social, political, cultural and technological context for industrial design.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History and Culture of Industrial Design II",
    "dept": "IND D",
    "num": "388",
    "desc": "Prereq: 30 credits earned at ISU.\nCritical examination of meanings of objects from the perspectives of history, design, material culture, philosophy and cultural studies. Discussion of social, political, cultural and technological context for industrial design.\n",
    "credits": "3"
  },
  {
    "course_name": "Industrial Design Internship",
    "dept": "IND D",
    "num": "397",
    "desc": "Prereq: IND D 202, 18 credits in industrial design, permission of instructor.\nProfessional industrial design, off-campus experience.  Meets Industrial Design Experiential Learning Requirements.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Design Studio",
    "dept": "IND D",
    "num": "401",
    "desc": "Prereq: IND D 301 or permission of instructor\nAdvanced topics focused on industrial design applications. Topics vary each time offered. Meets Industrial Design Experiential Learning Requirements.\n",
    "credits": "6"
  },
  {
    "course_name": "Special Topics",
    "dept": "IND D",
    "num": "490",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nAdvanced topics focused on industrial design applications. Topics vary each time offered.   A. Theory, Criticism, Methodology B. Experimental Techniques C. Three Dimensional Design D. Distributed Collaboration.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Theory, Criticism, Methodology",
    "dept": "IND D",
    "num": "490A",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nAdvanced topics focused on industrial design applications. Topics vary each time offered.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Experimental Techniques",
    "dept": "IND D",
    "num": "490B",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nAdvanced topics focused on industrial design applications. Topics vary each time offered.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Three-Dimensional Design",
    "dept": "IND D",
    "num": "490C",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nAdvanced topics focused on industrial design applications. Topics vary each time offered.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Distributed Collaboration",
    "dept": "IND D",
    "num": "490D",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nAdvanced topics focused on industrial design applications. Topics vary each time offered.\n",
    "credits": "arr"
  },
  {
    "course_name": "Study Abroad Option",
    "dept": "IND D",
    "num": "495",
    "desc": "Prereq: IND D 202 and permission of instructor\nInternational study abroad program. Visits to design studios, showrooms, museums and manufacturing facilities.  Meets Industrial Design Experiential Learning Requirements.\n",
    "credits": "6"
  },
  {
    "course_name": "Senior Project",
    "dept": "IND D",
    "num": "499",
    "desc": "Prereq: IND D 495 or IND D 507 and senior standing\nAdvanced practice in specialized area of industrial design. Topics vary.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Design Studio Intensive I",
    "dept": "IND D",
    "num": "501",
    "desc": "Prereq: Admission into  the Graduate Intensive Track or graduate standing in the industrial design program.\nBasic concepts and techniques for industrial design. Emphasis on form development, structure, function and communication.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Design Studio Intensive II",
    "dept": "IND D",
    "num": "502",
    "desc": "Prereq: Admission into the Graduate Intensive Track or graduate standing in the industrial design program.\nAdvanced concepts and techniques for industrial design. Emphasis on systematic design methodology and commercial factors, and visual and verbal communication of design problems and solutions.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Design Studio I",
    "dept": "IND D",
    "num": "503",
    "desc": "Prereq: Admission to the industrial design graduate program or completion of Graduate Intensive Track.\nAdvanced, project-based application of industrial design concepts and techniques.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Design Studio II",
    "dept": "IND D",
    "num": "504",
    "desc": "Prereq: IND D 502.\nAdvanced, project based application of industrial design concepts and techniques, with an emphasis on service and system design, and its implications for the community.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Design Practicum",
    "dept": "IND D",
    "num": "507",
    "desc": "Prereq: Evidence of satisfactory experience in area of specialization; admitted by application and written permission of instructor only.\nStudio project focused on topics generated with external partners. Topics vary.  Meets Industrial Design Experiential Learning Requirements.\n",
    "credits": "6"
  },
  {
    "course_name": "Colloquium",
    "dept": "IND D",
    "num": "511",
    "desc": "Prereq: Admission into the Graduate Intensive Track or graduate standing in the industrial design program.\nPresentation and discussion of creative activity carried out in various design disciplines and their relationship to industrial design. Seminar sessions focusing on exemplary pieces of design research undertaken by faculty and graduate students in the design field.\n",
    "credits": "1"
  },
  {
    "course_name": "Design Thinking",
    "dept": "IND D",
    "num": "532",
    "desc": "Prereq: Senior or graduate standing in any ISU program, or permission of the instructor.\nExploration of design thinking process, toolkits, and mindsets as creative problem solving approaches for systems, products, and processes, across diverse contexts. Strategies for problem-solution co-evolution process, with a focus on collaborative and interdisciplinary design to investigate real-world problems and opportunities.\n",
    "credits": "3"
  },
  {
    "course_name": "Product Realization for Industrial Design",
    "dept": "IND D",
    "num": "534",
    "desc": "Prereq: Admission into the Graduate Intensive Track or graduate standing in the industrial design program.\nIntroduction to materials and manufacturing methods for products. Exploration of emerging materials and new applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Visual Communication for Industrial Design",
    "dept": "IND D",
    "num": "540",
    "desc": "Prereq: Advanced standing in any ISU program\nExploration of multiple visual communication techniques primarily used in industrial design with a focus on visually breaking down complex information.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Aided Industrial Design",
    "dept": "IND D",
    "num": "541",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nExploration of the computer as an industrial design and visualization tool. Advanced concepts in computer to machine interface for manufacture.\n",
    "credits": "3"
  },
  {
    "course_name": "Portfolio and Professional Practice",
    "dept": "IND D",
    "num": "543",
    "desc": "Prereq: Advanced standing in the industrial design program.\nDiscussion of industrial design practice and career planning. Development and preparation of personal promotional materials for a range of media.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Factors",
    "dept": "IND D",
    "num": "551",
    "desc": "Prereq: IND D 532\nHuman factors issues and the study of relationships between the user, the product, and the human body and its physical functions. Investigations of bio-mechanics, anthropometry, instrumental displays and control, and their measurement as they relate to the design process.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "IND D",
    "num": "590",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nAdvanced topics focused on industrial design applications. Topics include theory, criticism, methodology, experimental techniques, three dimensional design, distributed collaboration. Meets Industrial Design Experiential Learning Requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Projects",
    "dept": "IND D",
    "num": "592",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nPlanned projects in topics related to theory, criticism, methodology, experimental techniques, three dimensional design, distributed collaboration.\n",
    "credits": "arr"
  },
  {
    "course_name": "Experiential Learning Special Projects",
    "dept": "IND D",
    "num": "593",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nProject based topics related to theory, criticism, methodology, experimental learning, three dimensional design, distributed collaboration that supports experiential learning.\n",
    "credits": "arr"
  },
  {
    "course_name": "Study Abroad Option",
    "dept": "IND D",
    "num": "595",
    "desc": "Prereq: Completion of industrial design studio or permission of instructor.\nInternational study abroad program. Visits to design studios, showrooms, museums and manufacturing facilities.  Meets Industrial Design Experiential Learning Requirements.\n",
    "credits": "6"
  },
  {
    "course_name": "Internship",
    "dept": "IND D",
    "num": "597",
    "desc": "Prereq: Completion of Industrial design studio or permission of instructor.\nProfessional industrial design, off-campus experience.  Meets Industrial Design Experiential Learning Requirements.\n",
    "credits": "6"
  },
  {
    "course_name": "Graduate Project I",
    "dept": "IND D",
    "num": "601",
    "desc": "Prereq: IND D 632\nAdvanced creative component in specialized area of focus within industrial design. Culminates in a development plan and supporting documentary.\n",
    "credits": "6"
  },
  {
    "course_name": "Graduate Project II",
    "dept": "IND D",
    "num": "602",
    "desc": "Prereq: IND D 601\nAdvanced creative component in specialized area of focus within industrial design. Culminates in a physical or digital artifact and supporting documentation.\n",
    "credits": "6"
  },
  {
    "course_name": "Design Research Methods",
    "dept": "IND D",
    "num": "631",
    "desc": "Prereq: Senior or graduate standing in any ISU program, or permission of the instructor\nUser-centered research methods to examine the impact of design on humans, environments, and social contexts. Examination and critique of current research methods employed in industrial design, service design and user experience (UX) design.\n",
    "credits": "3"
  },
  {
    "course_name": "Thesis Preparation",
    "dept": "IND D",
    "num": "632",
    "desc": "Prereq: IND D 631\nExploration and formulation of graduate thesis or project topics, with proposed studies and investigations. Introduction to structuring a design research prospectus and university requirements for graduation. Determine Faculty Committee and Program of Study and file forms with Graduate College.\n",
    "credits": "3"
  },
  {
    "course_name": "Thesis",
    "dept": "IND D",
    "num": "699",
    "desc": "Prereq: IND D 632\nAdvanced research component in specialized area of focus within industrial design. Culminates in a thesis document.\n",
    "credits": "6"
  },
  {
    "course_name": "Industrial Engineering Profession",
    "dept": "I E",
    "num": "101",
    "desc": "\n(1-0) Introduce students to the industrial engineering profession, its scope, industrial engineering tools, and future trends.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Information  Engineering",
    "dept": "I E",
    "num": "148",
    "desc": "Prereq: Credit or enrollment in MATH 143\nDevelopment of information solutions for engineering problems. Fundamentals of the software development process. Engineering computations and the human/computer interface. Data models and database development. Program connectivity and network applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Design & Analysis Methods for System Improvements",
    "dept": "I E",
    "num": "222",
    "desc": "Prereq: I E 248; credit or enrollment in I E 271.\nStudy of system improvement methods and strategies. Specific areas of lean system improvements include continuous improvement, setup reduction, workplace organization, and inventory and waste reduction.  Methods and strategies to analyze and quantify the impact of changes.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering System Design, Manufacturing Processes and Specifications",
    "dept": "I E",
    "num": "248",
    "desc": "Prereq: MATH 166 and PHYS 221. Credit or enrollment in I E 101 and MAT E 273.\nIntroduction to metrology, engineering drawings and specifications.  Engineering methods for designing and improving systems. Theory, applications, and quality issues related to machining processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Ergonomics and Work Design",
    "dept": "I E",
    "num": "271",
    "desc": "Prereq: PHYS 221\nBasic concepts of ergonomics and work design. Their impact on worker and work place productivity, and cost. Investigations of work physiology, biomechanics, anthropometry, work methods, and their measurement as they relate to the design of human-machine systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Economic Analysis",
    "dept": "I E",
    "num": "305",
    "desc": "Prereq: MATH 166\nEconomic analysis of engineering decisions under uncertainty. Financial engineering  basics including time value of money, cash flow estimation, and asset evaluation. Make versus  buy decisions. Comparison of project alternatives accounting for taxation, depreciation,  inflation, and risk.\n",
    "credits": "3"
  },
  {
    "course_name": "Optimization",
    "dept": "I E",
    "num": "312",
    "desc": "Prereq: Credit or enrollment in MATH 267.\nConcepts, optimization and analysis techniques, and applications of operations research. Formulation of mathematical models for systems, concepts, and methods of improving search, linear programming and sensitivity analysis, network models, and integer programming.\n",
    "credits": "3"
  },
  {
    "course_name": "Production Systems",
    "dept": "I E",
    "num": "341",
    "desc": "Prereq: STAT 231; credit or enrollment in I E 312\nIntroduction of key concepts in the design and analysis of production systems. Topics include inventory control, forecasting, material requirement planning, project planning and scheduling, operations scheduling, and other production systems such as Just-In-Time (JIT), warehousing, and global supply chains.\n",
    "credits": "3"
  },
  {
    "course_name": "Solidification Processes",
    "dept": "I E",
    "num": "348",
    "desc": "Prereq: I E 248 and MAT E 273, or MAT E 215\nTheory and applications related to metal casting, welding, polymer processing, powder metallurgy, and composites manufacturing, and related rapid manufacturing processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Quality Assurance",
    "dept": "I E",
    "num": "361",
    "desc": "Prereq: STAT 231, STAT 301, STAT 326 or STAT 401\nStatistical methods for process improvement. Simple quality assurance principles and tools.  Measurement system precision and accuracy assessment. Control charts. Process capability assessment. Experimental design and analysis for process improvement. Significant external project in process improvement.\n",
    "credits": "3"
  },
  {
    "course_name": "Summer Internship",
    "dept": "I E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education (Co-op)",
    "dept": "I E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period.  One semester per academic or calendar year.  Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Sustainable Production Systems",
    "dept": "I E",
    "num": "403",
    "desc": "Prereq: Credit or enrollment I E 341\nQuantitative  introduction of sustainability concepts in production planning and inventory control. Review of material recovery (recycling) and product/component recovery (remanufacturing) from productivity perspectives. Sustainability rubrics ranging from design and process to systems. Application to multi-echelon networks subject to forward/backward flow of material and information. Closed-loop supply chains. Comparative study of sustainable vs. traditional models for local and global production systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Engineering Economy for Complex Engineering Projects",
    "dept": "I E",
    "num": "405",
    "desc": "Prereq: MATH 265, MATH 267, STAT 231 and I E 305, or permission by instructor\nOverview of engineering economic valuation and complex engineering projects. Stochastic dynamic programming for project valuation. Modeling and analysis of confounding factors of engineering projects. Integration and synthesis of valuation methodologies to complex projects. Applications to power plants, transmission networks, and satellites.\n",
    "credits": "3"
  },
  {
    "course_name": "Stochastic Modeling, Analysis and Simulation",
    "dept": "I E",
    "num": "413",
    "desc": "Prereq: MATH 267, STAT 231\nDevelopment and analysis of simulation models using a simulation language. Application to various areas of manufacturing and service systems such as assembly, material handling, and customer queues. Utilizing model output to make important business decisions. Fitting of data to statistical distributions. Introduction to Markov processes and other queuing models.\n",
    "credits": "4"
  },
  {
    "course_name": "Industrial Automation",
    "dept": "I E",
    "num": "432",
    "desc": "Prereq: PHYS 222\nOverview of electrical circuit theory and its relationship to industrial control systems.   Theory and application of transducers in the form of sensors and actuators, with applications in manufacturing, distribution and mechanical systems.   Programmable Logic Controllers (PLC), their programming and use for automation solutions.   Introduction of automated identification systems such as Radio Frequency Identification (RFID) and Bar Coding technologies.\n",
    "credits": "3"
  },
  {
    "course_name": "Industrial Engineering Design",
    "dept": "I E",
    "num": "441",
    "desc": "Prereq: I E 248, I E 271, I E 361; credit or enrollment in I E 341, I E 413, and I E 448\nA large, open-ended design project related to an enterprise. Application of engineering design principles including problem definition, analysis, synthesis, and evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Geometric Variability in Manufacturing",
    "dept": "I E",
    "num": "446",
    "desc": "Prereq: I E 348, or MAT E 216, or M E 324\nAssessment, accommodation, and control of geometric variability in manufacturing processes, specifically composites, metalcasting, welding, machining, powder metallurgy and additive processing. Techniques include the design of the component, tooling, process plan and inspection methodology.\n",
    "credits": "3"
  },
  {
    "course_name": "Biomedical Design and Manufacturing",
    "dept": "I E",
    "num": "447",
    "desc": "Prereq: Undergraduate students with three semesters or less before graduation while graduate standing for graduate students\nExploration of biology, materials, body mechanics, manufacturing, quality control, and ethics and the intersection of these subjects as they relate to biomedical manufacturing.\n",
    "credits": "3"
  },
  {
    "course_name": "Manufacturing Systems Engineering",
    "dept": "I E",
    "num": "448",
    "desc": "Prereq: I E 248, I E 305\nFixturing and tooling requirements for manufacturing process planning, geometric dimensioning and  tolerancing, computer aided inspection, cellular and flexible manufacturing, and facility layout. Lean manufacturing principles and controlled flow production.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Aided Design and Manufacturing",
    "dept": "I E",
    "num": "449",
    "desc": "Prereq: Prereq: I E 248 or similar manufacturing engineering course, MATH 265.\nRepresentation and interpretation of curves, surfaces and solids. Parametric curves and surfaces and solid modeling. Use of CAD software and CAD/CAM integration. Computer numerical control, CNC programming languages, and process planning.\n",
    "credits": "3"
  },
  {
    "course_name": "Technical Sales for Engineers I",
    "dept": "I E",
    "num": "450",
    "desc": "Prereq: Credit or enrollment in I E 305.\nSales process methodology, techniques for building professional   relationships, sales automation software, prospecting and account   development, market analysis and segmentation, responding to   RFQ's and RFP's in written and verbal form.  Developing technical value   propositions and competitive positioning, evaluating organizational   decision processes and people, technical marketing strategies, sales   closing strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Technical Sales for Engineers II",
    "dept": "I E",
    "num": "451",
    "desc": "Prereq: I E 450\nCase studies and experiential lessons on the development and   application of technical sales strategies.  Specific topics include   developing pricing and distribution strategies, managing a sales   staff and channel, developing sales teams and global sales plans, bid   and negotiation strategies, time management skills, and implementing   sales automation technologies.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "I E",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design II",
    "dept": "I E",
    "num": "467",
    "desc": "Prereq: Student must be within two semesters of graduation or receive permission of instructor.\nBuild and test of a conceptual design. Detail design, manufacturability, test criteria and procedures. Application of design tools such as CAD and CAM and manufacturing techniques such as rapid prototyping. Development and testing of a full-scale prototype with appropriate documentation in the form of design journals, written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Large-Scale Complex Engineered Systems (LSCES)",
    "dept": "I E",
    "num": "468",
    "desc": "Prereq: senior standing in College of Engineering or permission of AerE 468 instructor\nIntroduction to the theoretical foundation and methods associated with the design for large-scale complex engineered systems, including objective function formation, design reliability, value-driven design, product robustness, utility theory, economic factors for the formation of a value function and complexity science as a means of detecting unintended consequences in the product behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "e-Commerce Systems Engineering",
    "dept": "I E",
    "num": "481",
    "desc": "Prereq: I E 148\nDesign, analysis, and implementation of e-commerce systems. Information infrastructure, enterprise models, enterprise processes, enterprise views. Data structures and algorithms used in e-commerce systems, SQL, exchange protocols, client/server model, web-based views.\n",
    "credits": "3"
  },
  {
    "course_name": "Data Mining",
    "dept": "I E",
    "num": "483",
    "desc": "Prereq: I E 148, I E 312, and STAT 231\nFoundations of classification, data clustering and association rule mining.  Techniques for data mining, including probabilistic and statistical methods, optimization algorithms and deep learning with neural networks, visualization techniques, and mathematical programming. Advanced topics include web-mining and mining of multimedia data. Case studies from both manufacturing and service industries. A computing project is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Big Data Analytics and Optimization",
    "dept": "I E",
    "num": "487",
    "desc": "Prereq: IE 312, STAT 231\nOptimization and statistical learning related to big data problems. Modern modeling for data-driven optimization problems and their applications in big data analytics. Fast algorithms for optimization and statistical learning and their implementation. Applications in large-scale text analysis, energy/smart grid systems, image recognition, surveillance video analysis and social network data analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "I E",
    "num": "490",
    "desc": "Prereq: Senior classification, permission of instructor\nIndependent study and work in the areas of industrial engineering design, practice, or research.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "I E",
    "num": "490H",
    "desc": "Prereq: Senior classification, permission of instructor\nIndependent study and work in the areas of industrial engineering design, practice, or research.\n",
    "credits": "1"
  },
  {
    "course_name": "I E Graduate Seminar",
    "dept": "I E",
    "num": "501",
    "desc": "Prereq: Enrollment in graduate program in Industrial Engineering. Research presentations by internal and external scholars.\nPrinciples and practices for research tasks at the M.S. level including proposal writing, presentations, paper preparation, and project management.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Sustainable Production Systems",
    "dept": "I E",
    "num": "503",
    "desc": "Prereq: Credit or enrollment I E 341\nQuantitative  introduction of sustainability concepts in production planning and inventory control. Review of material recovery (recycling) and product/component recovery (remanufacturing) from productivity perspectives. Sustainability rubrics ranging from design and process to systems. Application to multi-echelon networks subject to forward/backward flow of material and information. Closed-loop supply chains. Comparative study of sustainable vs. traditional models for local and global production systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Engineering Economy for Complex Engineering Projects",
    "dept": "I E",
    "num": "505",
    "desc": "Prereq: MATH 265, MATH 267, STAT 231 and I E 305, or permission by instructor\nOverview of engineering economic valuation and complex engineering projects. Stochastic dynamic programming for project valuation. Modeling and analysis of confounding factors of engineering projects. Integration and synthesis of valuation methodologies to complex projects. Applications to power plants, transmission networks, and satellites.\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Analysis of Allocation Mechanisms",
    "dept": "I E",
    "num": "508",
    "desc": "Prereq: I E 312 or MATH 307\nMarket-based allocation mechanisms from quantitative economic systems perspective. Pricing and costing models designed and analyzed with respect to decentralized decision processes, information requirements, and coordination. Financial Engineering Techniques. Case studies and examples from industries such as regulated utilities, semiconductor manufacturers, and financial engineering services.\n",
    "credits": "3"
  },
  {
    "course_name": "Network Analysis",
    "dept": "I E",
    "num": "510",
    "desc": "Prereq: I E 312\nFormulation and solution of deterministic network flow problems including shortest path, minimum cost flow, and maximum flow. Network and graph formulations of combinatorial problems including assignment, matching, and spanning trees. Introduction to deterministic and stochastic dynamic programming.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis of Stochastic Systems",
    "dept": "I E",
    "num": "513",
    "desc": "Prereq: STAT 231\nIntroduction to modeling and analysis of manufacturing and service systems subject to uncertainty. Topics include the Poisson process, renewal processes, Markov chains, and Brownian motion. Applications to inventory systems, production system design, production scheduling, reliability, and capacity planning.\n",
    "credits": "3"
  },
  {
    "course_name": "Production Scheduling",
    "dept": "I E",
    "num": "514",
    "desc": "Prereq: I E 312, I E 341\nIntroduction to the theory of machine shop systems. Complexity results for various systems such as job, flow and open shops. Applications of linear programming, integer programming, network analysis. Enumerative methods for machine sequencing. Introduction to stochastic scheduling.\n",
    "credits": "3"
  },
  {
    "course_name": "Simulation Modeling and Analysis",
    "dept": "I E",
    "num": "519",
    "desc": "Prereq: COM S 311, STAT 401\nEvent scheduling, process interaction, and continuous modeling techniques. Probability and statistics related to simulation parameters including run length, inference, design of experiments, variance reduction, and stopping rules. Aspects of simulation languages.\n",
    "credits": "3"
  },
  {
    "course_name": "Quality Control and Engineering Statistics",
    "dept": "I E",
    "num": "531",
    "desc": "Prereq: STAT 401; STAT 342 or STAT 447\nStatistical methods and theory applicable to problems of industrial process monitoring and improvement. Statistical issues in industrial measurement; Shewhart, CUSUM, and other control charts; feedback control; process characterization studies; estimation of product and process characteristics; acceptance sampling, continuous sampling and sequential sampling; economic and decision theoretic arguments in industrial statistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Reliability",
    "dept": "I E",
    "num": "533",
    "desc": "Prereq: STAT 342 or STAT 432 or STAT 447\nProbabilistic modeling and inference in engineering reliability; lifetime models, product limit estimator, probability plotting, maximum likelihood estimation for censored data, Bayesian methods in reliability, system reliability models, competing risk analysis, acceleration models and analysis of accelerated test data; analysis of recurrence and degradation data; planning studies to obtain reliability data.\n",
    "credits": "3"
  },
  {
    "course_name": "Linear Programming",
    "dept": "I E",
    "num": "534",
    "desc": "Prereq: I E 312\nFormulation of optimization problems as mathematical models, including linear programming, integer programming concepts, multi-objective optimization, and bilevel optimization. Introduction to classic optimization algorithms, including Simplex, cutting plane, and branch-and-bound. Basic concepts of duality theory and sensitivity analysis. Using computer solvers (Matlab and Gusek) to obtain optimal solutions to optimization models.\n",
    "credits": "3"
  },
  {
    "course_name": "Reliability and Safety Engineering",
    "dept": "I E",
    "num": "537",
    "desc": "Prereq: STAT 231 or STAT 401\nMathematical basics for dealing with reliability data, theory, and analysis. Bayesian reliability analysis. Engineering ethics in safety evaluations. Case studies of accidents in large technological systems. Fault and event tree analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Inventory Control and Production Planning",
    "dept": "I E",
    "num": "541",
    "desc": "Prereq: I E 341\nEconomic Order Quantity, dynamic lot sizing, newsboy, base stock, and (Q,r) models. Material Requirements Planning, Just-In-Time (JIT), variability in production systems, push and pull production systems, aggregate and workforce planning, and capacity management. Supply Chain Contracts.\n",
    "credits": "3"
  },
  {
    "course_name": "Wind Energy Manufacturing",
    "dept": "I E",
    "num": "543",
    "desc": "Prereq: Undergraduate engineering degree or permission of instructor.\nMaterials, processes and systems required to produce the major components (blades, towers, nacelles) of megawatt scale wind turbines. Transportation, manufacturing siting and procurement decisions as it relates to these large components in an expanding industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Rapid Prototyping and Manufacturing",
    "dept": "I E",
    "num": "545",
    "desc": "Prereq: Prereq: I E 248 or similar manufacturing engineering course, MATH 265. Undergraduates at Senior Standing if given permission by instructor.\nIntroduction to rapid prototyping processes and other rapid manufacturing methodologies. Operating principles and characteristics of current and developing rapid prototyping processes. Use of rapid prototypes in product design, development, and service. Selection of rapid prototyping systems based on rapid methodologies used in manufacturing processes and rapid tooling approaches.\n",
    "credits": "3"
  },
  {
    "course_name": "Geometric Variability in Manufacturing",
    "dept": "I E",
    "num": "546",
    "desc": "Prereq: I E 348, or MAT E 216, or M E 324\nAssessment, accommodation, and control of geometric variability in manufacturing processes, specifically composites, metalcasting, welding, machining, powder metallurgy and additive processing. Techniques include the design of the component, tooling, process plan and inspection methodology.\n",
    "credits": "3"
  },
  {
    "course_name": "Biomedical Design and Manufacturing",
    "dept": "I E",
    "num": "547",
    "desc": "Prereq: Undergraduate students with three semesters or less before graduation while graduate standing for graduate students\nExploration of biology, materials, body mechanics, manufacturing, quality control, and ethics and the intersection of these subjects as they relate to biomedical manufacturing.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Aided Design and Manufacturing",
    "dept": "I E",
    "num": "549",
    "desc": "Prereq: Prereq: I E 248 or similar manufacturing engineering course, MATH 265.\nRepresentation and interpretation of curves, surfaces and solids. Parametric curves and surfaces and solid modeling. Use of CAD software and CAD/CAM integration. Computer numerical control, CNC programming languages, and process planning.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Risk Analysis",
    "dept": "I E",
    "num": "560",
    "desc": "Prereq: Coursework in basic probability and statistics\nOverview of probabilistic risk analysis, modeling risks, and risk management. Topics include probability, influence diagrams, subjective probability assessment, fault tree analysis, decision making with uncertainty, risk perception, risk communication, and intelligent adversary. Use of Monte Carlo simulation to combine different sources of uncertainty and risk to generate probability distributions over an outcome. Application of probabilistic risk analysis to business investments, engineering systems, critical infrastructure, defense and security, and health systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Total Quality Management",
    "dept": "I E",
    "num": "561",
    "desc": "Prereq: Course in quality control\nPerspectives for how to analyze and implement total quality management in different organizations, to include manufacturing firms, service industries, the non-profit sector, and government agencies. Topics include the different viewpoints of quality (from the customer, workforce, and process perspective); aligning quality in an organization’s goals; performance measurement; quality in supply chain management; and reliability. Some advanced statistical elements of quality control will also be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering and Systems Management",
    "dept": "I E",
    "num": "563",
    "desc": "Prereq: Course in probability and statistics.\nIntroduction to engineering management concepts and examples relevant to the engineering manager today. Topics include decision trees and associated probabilities; personnel issues and challenges; working with management, client and the project team; personality types; and documents/forms that are useful for the engineering manager. Case studies, and a group project required.\n",
    "credits": "3"
  },
  {
    "course_name": "Decision Analysis",
    "dept": "I E",
    "num": "564",
    "desc": "Prereq: Course in probability and statistics.\nApplication of normative decision theory to problems with uncertainty and/or multiple objectives. The first decision framework will be a single-objective decision problem with uncertainty that takes into account a decision maker’s attitude towards risk. The second decision framework will be a multi-criteria decision problem in which a decision maker has multiple objectives. Topics include utility theory, value of information, sensitivity analysis, value-focused thinking, cost-effectiveness analysis, influence diagrams, and behavioral decision making. Examples will be drawn from business, systems engineering and design, and government.\n",
    "credits": "3"
  },
  {
    "course_name": "Systems Engineering and Analysis",
    "dept": "I E",
    "num": "565",
    "desc": "Prereq: Coursework in basic statistics\nIntroduction to organized multidisciplinary approach to designing and developing systems. Concepts, principles, and practice of systems engineering as applied to large integrated systems. Life cycle costing, scheduling, risk management, functional analysis, conceptual and detail design, test and evaluation, and systems engineering planning and organization.\n  Not available for degrees in industrial engineering.",
    "credits": "3"
  },
  {
    "course_name": "Applied Systems Engineering",
    "dept": "I E",
    "num": "566",
    "desc": "Prereq: I E 565\nDesign for reliability, maintainability, usability, supportability, producibility, disposability, and life cycle costs in the context of the systems engineering process. Students will be required to apply the principles of systems engineering to a project including proposal, program plan, systems engineering management plan, and test and evaluation plan.\n  Not available for degrees in industrial engineering.",
    "credits": "3"
  },
  {
    "course_name": "Large-Scale Complex Engineered Systems (LSCES)",
    "dept": "I E",
    "num": "568",
    "desc": "Prereq: senior standing in College of Engineering or permission of AerE 468 instructor\nIntroduction to the theoretical foundation and methods associated with the design for large-scale complex engineered systems, including objective function formation, design reliability, value-driven design, product robustness, utility theory, economic factors for the formation of a value function and complexity science as a means of detecting unintended consequences in the product behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Systems Engineering and Project Management",
    "dept": "I E",
    "num": "570",
    "desc": "Prereq: Coursework in basic statistics\nSystems view of projects and the processes by which they are implemented. Focuses on qualitative and quantitative tools and techniques of project management. Topics will include organizational structure types; project selection methodologies; simulation and optimization; and earned value management. Case studies will be included, and a group project required.\n",
    "credits": "3"
  },
  {
    "course_name": "Occupational Biomechanics",
    "dept": "I E",
    "num": "571",
    "desc": "Prereq: E M 274, STAT 231\nAnatomical, physiological, and biomechanical bases of physical ergonomics. Anthropometry, body mechanics, strength of biomaterials, human motor control.  Use of bioinstrumentation, passive industrial surveillance techniques and active risk assessment techniques. Acute injury and cumulative trauma disorders. Static and dynamic biomechanical modeling. Emphasis on low back, shoulder and hand/wrist biomechanics.\n",
    "credits": "3"
  },
  {
    "course_name": "Design and Evaluation of Human-Computer Interaction",
    "dept": "I E",
    "num": "572",
    "desc": "Prereq: I E 271 or graduate classification\nHuman factors methods applied to interface requirements, design, prototyping, and evaluation. Concepts related to understanding user characteristics, design principles, usability analysis, methods and techniques for design and evaluation of the interface. The evaluation and design of the information presentation characteristics of a wide variety of interfaces: web sites (e-commerce), mobile applications, and information presentation systems (cockpits, instrumentation, etc.).\n",
    "credits": "3"
  },
  {
    "course_name": "Human Factors in Product Design",
    "dept": "I E",
    "num": "576",
    "desc": "Prereq: I E 572 or I E 577\nInvestigation of the human interface to consumer and industrial systems and products, providing a basis for their design and evaluation. Discussions of human factors in the product design process: modeling the human during product use; usability; human factors methods in product design evaluation; user-device interface; safety, warnings, and instructions for products; considerations for human factors in the design of products for international use.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Factors",
    "dept": "I E",
    "num": "577",
    "desc": "Prereq: I E 271 or graduate classification\nPhysical and psychological factors affecting human performance in systems. Signal detection theory, human reliability modeling, information theory, and performance shaping applied to safety, reliability, productivity, stress reduction, training, and human/equipment interface design. Laboratory assignments related to system design and operation.\n",
    "credits": "3"
  },
  {
    "course_name": "e-Commerce Systems Engineering",
    "dept": "I E",
    "num": "581",
    "desc": "Prereq: I E 148\nDesign, analysis, and implementation of e-commerce systems. Information infrastructure, enterprise models, enterprise processes, enterprise views. Data structures and algorithms used in e-commerce systems, SQL, exchange protocols, client/server model, web-based views.\n",
    "credits": "3"
  },
  {
    "course_name": "Enterprise Modeling and Integration",
    "dept": "I E",
    "num": "582",
    "desc": "Prereq: 3 credits in information technology or information systems\nThe design and analysis of enterprise models to support information engineering of enterprise-wide systems. Representation of system behavior and structure including process modeling, information modeling, and conceptual modeling. Applications in enterprise application integration, enterprise resource planning systems, product data management systems, and manufacturing execution systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Data Mining",
    "dept": "I E",
    "num": "583",
    "desc": "Prereq: I E 148, I E 312, and STAT 231\nFoundations of classification, data clustering and association rule mining.  Techniques for data mining, including probabilistic and statistical methods, optimization algorithms and deep learning with neural networks, visualization techniques, and mathematical programming. Advanced topics include web-mining and mining of multimedia data. Case studies from both manufacturing and service industries. A computing project is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Requirements and Architecture Engineering",
    "dept": "I E",
    "num": "585",
    "desc": "Prereq: 3 credits in information technology or information systems\nPrinciples and practices for requirements engineering as part of the product development process with emphasis on software systems engineering. Problem definition, problem analysis, requirements analysis, requirements elicitation, validation, specifications. Case studies using requirements engineering methods and techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Big Data Analytics and Optimization",
    "dept": "I E",
    "num": "587",
    "desc": "Prereq: IE 312, STAT 231\nOptimization and statistical learning related to big data problems. Modern modeling for data-driven optimization problems and their applications in big data analytics. Fast algorithms for optimization and statistical learning and their implementation. Applications in large-scale text analysis, energy/smart grid systems, image recognition, surveillance video analysis and social network data analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Systems for Manufacturing",
    "dept": "I E",
    "num": "588",
    "desc": "Prereq: I E 148, I E 448\nDesign and implementation of systems for the collection, maintenance, and usage of information needed for manufacturing operations, such as process control, quality, process definition, production definitions, inventory, and plant maintenance. Topics include interfacing with multiple data sources, methods to utilize the information to improve the process, system architectures, and maintaining adequate and accurate data for entities internal and external to the enterprise to achieve best manufacturing practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "I E",
    "num": "590",
    "desc": "\nAdvanced study of a research topic in the field of industrial engineering.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "I E",
    "num": "599",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Stochastic Production Systems",
    "dept": "I E",
    "num": "613",
    "desc": "Prereq: I E 513\nModeling techniques to evaluate performance and address issues in design, control, and operation of systems. Markov models of single-stage make-to-order and make-to-stock systems. Approximations for non-Markovian systems. Impact of variability on flow lines. Open and closed queuing networks.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonlinear Programming",
    "dept": "I E",
    "num": "631",
    "desc": "Prereq: I E 534\nDevelop nonlinear models, convex sets and functions, optimality conditions, Lagrangian duality, unconstrained minimization techniques. Constrained minimization techniques covering penalty and barrier functions, sequential quadratic programming, the reduced gradient method, nonlinear control concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Integer Programming",
    "dept": "I E",
    "num": "632",
    "desc": "Prereq: I E 534\nInteger programming including cutting planes, branch and bound, and Lagrangian relaxation. Introduction to complexity issues and search-based heuristics.\n",
    "credits": "3"
  },
  {
    "course_name": "Stochastic Programming",
    "dept": "I E",
    "num": "633",
    "desc": "Prereq: I E 513 or STAT 447, I E 534 or equivalent\nMathematical programming with uncertain parameters; modeling risk within optimization; multi-stage recourse and probabilistically constrained models; solution and approximation algorithms including Benders decomposition and progressive hedging; and applications to planning, allocation and design problems.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Optimization",
    "dept": "I E",
    "num": "634",
    "desc": "Prereq: I E 534 or equivalent.\nTheory, algorithm, and computer implementation of optimization models. Simplex, Benders decomposition, computational complexity, mixed integer linear program, linear program with complementarity constraints, inverse optimization, bilevel discrete optimization. CPLEX, Matlab, and Tomlab will be used for computer implementation.\n",
    "credits": "3"
  },
  {
    "course_name": "Simultaneous Engineering in Manufacturing Systems",
    "dept": "I E",
    "num": "642",
    "desc": "Prereq: I E 549 or M E 415\nCurrent engineering methods for the product life cycle process. Feature-based design, computer-aided process planning, and data-driven product engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Practicum in Human Factors and Ergonomics",
    "dept": "I E",
    "num": "671",
    "desc": "Prereq: I E 571 or I E 577 or IE 572\nResearch topic development, literature evaluation, experimental design, use of bioinstrumentation, data collection, basic data interpretation, statistical analysis, manuscript preparation.\n",
    "credits": "3"
  },
  {
    "course_name": "Spine Biomechanics",
    "dept": "I E",
    "num": "673",
    "desc": "Prereq: I E 571 or equivalent\nGross and fine anatomy of spine, mechanism of pain, epidemiology, in vitro testing, psychophysical studies, spine stability models, bioinstrumentation: intradiscal pressure, intra-abdominal pressure and electromyography. Biomechanics of lifting and twisting, effects of vibration, effects of posture/lifting style, lifting belts, physical models, optimization models, mathematical models, muscle models, finite element models, current trends in medical management and rehabilitation, chiropractic.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Engineering",
    "dept": "I E",
    "num": "681",
    "desc": "Prereq: I E 572 or I E 577 or PSYCH 516 or HCI/PSYCH 521 or equivalent\nProvides an overview of human cognitive capabilities and limitations in the design of products, work places, and large systems. Contexts vary broadly and could range from simple use of mobile devices to an air-traffic control or nuclear plant command center. Course focuses on what we can infer about users' thoughts and feelings based on what we can measure about their performance and physiological state. Covers the challenge of designing automated systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "I E",
    "num": "690",
    "desc": "Prereq: Permission of the instructor\nAdvanced topics related to Ph.D. research in industrial engineering under the direction of the instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "I E",
    "num": "697",
    "desc": "Prereq: Permission of department\nOne Fall OR Spring semester combined with one summer, maximum per academic year.  Excludes Fall/Spring combination.  Professional work period.  Offered satisfactory/fail basis only. (With Instructor Permission).\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "I E",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to Computer Security Literacy",
    "dept": "INFAS",
    "num": "131",
    "desc": "\nBasic concepts of practical computer and Internet security: passwords, firewalls, antivirus software, malware, social networking, surfing the Internet, phishing, and wireless networks. This class is intended for students with little or no background in information technology or security. Basic knowledge of word processing required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Cyber Defense Competition",
    "dept": "INFAS",
    "num": "332",
    "desc": "\nParticipation in cyber defense competition driven by scenario-based network design. Includes computer system setup, risk assessment and implementation of security systems, as well as defense of computer and network systems against trained attackers. Team based.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Network Protocols and Security",
    "dept": "INFAS",
    "num": "430",
    "desc": "Prereq: CPR E 381 or equivalent\nDetailed examination of networking standards, protocols, and their implementation. TCP/IP protocol suite, network application protocols.  Network security issues, attack and mitigation techniques. Emphasis on laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Network Protocols and Security",
    "dept": "INFAS",
    "num": "530",
    "desc": "Prereq: CPR E 381 or equivalent\nDetailed examination of networking standards, protocols, and their implementation. TCP/IP protocol suite, network application protocols.  Network security issues, attack and mitigation techniques. Emphasis on laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Information System Security",
    "dept": "INFAS",
    "num": "531",
    "desc": "Prereq: CPR E 489 or CPR E 530 or COM S 586 or MIS 535\nComputer, software, and data security: basic cryptography, security policies, multilevel security models, attack and protection mechanisms, legal and ethical issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Warfare",
    "dept": "INFAS",
    "num": "532",
    "desc": "Prereq: CPR E 531\nComputer system and network security: implementation, configuration, testing of security software and hardware, network monitoring. Authentication, firewalls, vulnerabilities, exploits, countermeasures. Study and use of attack tools. Ethics in information assurance. Emphasis on laboratory experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Cryptography",
    "dept": "INFAS",
    "num": "533",
    "desc": "Prereq: MATH 301 or CPR E 310 or COM S 230\nBasic concepts of secure communication, DES and AES, public-key cryptosystems, elliptic curves, hash algorithms, digital signatures, applications. Relevant material on number theory and finite fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Legal and Ethical Issues in Information Assurance",
    "dept": "INFAS",
    "num": "534",
    "desc": "Prereq: Graduate classification; CPR E 531 or INFAS 531\nLegal and ethical issues in computer security. State and local codes and regulations. Privacy issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Steganography and Digital Image Forensics",
    "dept": "INFAS",
    "num": "535",
    "desc": "Prereq: E E 524 or MATH 317 or MATH 407 or COM S 230\nBasic principles of covert communication, steganalysis, and forensic analysis for digital images. Steganographic security and   capacity, matrix embedding, blind attacks, image forensic detection and device identification techniques. Related material on coding   theory, statistics, image processing, pattern recognition.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer and Network Forensics",
    "dept": "INFAS",
    "num": "536",
    "desc": "Prereq: CPR E 489 or CPR E 530\nFundamentals of computer and network forensics, forensic duplication and analysis, network surveillance, intrusion detection and response, incident response, anonymity and pseudonymity, privacy-protection techniques, cyber law, computer security policies and guidelines, court testimony and report writing, and case studies. Emphasis on hands-on experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Reverse Engineering and Security Testing",
    "dept": "INFAS",
    "num": "538",
    "desc": "Prereq: COM S 321 or CPR E 381, COM S 352 or CPR E 308\nTechniques and tools for understanding the behavior of software/hardware systems based on reverse engineering. Flaw hypothesis, black, grey, and white box testing as well as other methods for testing the security of software systems. Discussion of counter-reverse engineering techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Data-Driven Security and Privacy",
    "dept": "INFAS",
    "num": "560",
    "desc": "Prereq: CPR E 531; COM S 474 or COM S 573\nExamination of applications of machine learning and big data techniques to various security and privacy problems, as well as secure and privacy-preserving machine learning algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Information Assurance",
    "dept": "INFAS",
    "num": "592",
    "desc": "Prereq: Permission of instructor\nProjects or seminar in Information Assurance.\n",
    "credits": "1"
  },
  {
    "course_name": "Information Assurance Capstone Design",
    "dept": "INFAS",
    "num": "632",
    "desc": "Prereq: INFAS 531, INFAS 532, INFAS 534\nCapstone design course which integrates the security design process. Design of a security policy. Creation of a security plan. Implementation of the security plan. The students will attack each other's secure environments in an effort to defeat the security systems. Students evaluate the security plans and the performance of the plans. Social, political and ethics issues. Student self-evaluation, journaling, final written report.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Research Problems in Cyber Security",
    "dept": "INFAS",
    "num": "634",
    "desc": "Prereq: CPR E 530, CPR E 531, permission of instructor.\nDiscussion of complex cyber security problems. Students will learn how to apply research techniques, think clearly about these issues, formulate and analyze potential solutions, and communicate their results. Working in small groups under the mentorship of technical clients from government and industry, each student will formulate, carry out, and present original research on complex current cybersecurity/information assurance problems of interest to the nation. This course will be run in a synchronized distance fashion, coordinating some activities with our partner schools and our technical clients.\n",
    "credits": "0"
  },
  {
    "course_name": "Information Assurance Summer Internship",
    "dept": "INFAS",
    "num": "697",
    "desc": "Prereq: Permission of department, graduate classification\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Creative Visual Thinking",
    "dept": "ARTIS",
    "num": "201",
    "desc": "\nExploration of the nature of visual perception in relation to issues of visual communication, problem solving, envisioning information, and visual thinking. Studio assignments to be digitized and sent to instructor electronically for evaluation and critique.\n",
    "credits": "3"
  },
  {
    "course_name": "Studio Fundamentals: Wood",
    "dept": "ARTIS",
    "num": "202",
    "desc": "Prereq: Open to all students; sophomore level and above. Required of all ISA BFA majors\nHalf-semester course. Introduction to wood's physical properties, its potential as an expressive medium, and basic wood working hand tools and techniques.\n",
    "credits": "2"
  },
  {
    "course_name": "Studio Fundamentals: Jewelry/Metalsmithing",
    "dept": "ARTIS",
    "num": "203",
    "desc": "Prereq: Open to all students; sophomore level and above. Required of all ISA BFA majors\nHalf semester course. Introduction to basic jewelry/metals design and fabrication. Forming, texturing, and joining techniques (soldering/riveting) will be explored and applied to two projects.\n",
    "credits": "2"
  },
  {
    "course_name": "Studio Fundamentals: Ceramics",
    "dept": "ARTIS",
    "num": "204",
    "desc": "Prereq: Open to all students, sophomore level and above. Required of all ISA BFA majors\nHalf-semester course providing an introduction to ceramic techniques including hand-building, high fire and low fire glaze applications and expressive approaches that will be applied to two projects. The emphasis is on creative communication through ceramics.\n",
    "credits": "2"
  },
  {
    "course_name": "Studio Fundamentals: Printmaking",
    "dept": "ARTIS",
    "num": "206",
    "desc": "Prereq: Open to all students, sophomore level and above. Required of all ISA BFA majors.\nIntroduction to relief, monoprint, lithographic and intaglio printing as methods for visual communication and expression.\n",
    "credits": "2"
  },
  {
    "course_name": "Color",
    "dept": "ARTIS",
    "num": "208",
    "desc": "Prereq: Open to all students, sophomore level and above. Required for all ISA BFA majors.\nHalf-semester course.  Introduction to color theory and color systems using various media for visual communication and creative expression.\n",
    "credits": "2"
  },
  {
    "course_name": "Studio Fundamentals: Photo",
    "dept": "ARTIS",
    "num": "210",
    "desc": "Prereq: Open to all students, sophomore level and above. Required of all ISA BFA majors.\nIntroduction to film camera operation and traditional black and white darkroom methods for visual communication and creative expression. Film cameras required for class but may be checked out for short periods during semester.\n",
    "credits": "2"
  },
  {
    "course_name": "Studio Fundamentals: Computers",
    "dept": "ARTIS",
    "num": "212",
    "desc": "Prereq: Open to all students, sophomore level and above. Required of all ISA BFA majors.\nIntroduction to digital media tools and concepts and digital fabrication processes to create two dimensional, three dimensional, and time-based artworks.  Students will be introduced to major digital art and design software packages.\n",
    "credits": "3"
  },
  {
    "course_name": "Studio Fundamentals: Painting",
    "dept": "ARTIS",
    "num": "213",
    "desc": "Prereq: Open to all students, sophomore level and above. Required of all ISA BFA majors.\nHalf-semester course. Introduction to preparation of painting grounds, color mixing, manipulation of paint and pictorial space as methods for visual communication and expression.\n",
    "credits": "2"
  },
  {
    "course_name": "Studio Fundamentals: Textiles",
    "dept": "ARTIS",
    "num": "214",
    "desc": "Prereq: Open to all students, sophomore level and above. Required of all ISA BFA majors.\nHalf semester course. Introduction to two-dimensional and three-dimensional textile techniques used for visual communication and expression.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Creative Digital Photography",
    "dept": "ARTIS",
    "num": "227",
    "desc": "Prereq: DSN S 102, DSN S 131 and DSN S 183 or permission of instructor.\nThis course will include the functions and operations of the digital camera, scanning and other image input devices, digital image manipulation, software usage and support, color management and printing, presentation of images, compositional dynamics and the development of \"seeing\" as a medium of design, expression, and communication. Students should have access to a good or high quality digital camera with the ability to separately adjust shutter speed, f/stop and exposure, a laptop with updated Adobe Photoshop software, and enough digital storage for all class assignments.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Creative Digital Photography: Honors",
    "dept": "ARTIS",
    "num": "227H",
    "desc": "Prereq: DSN S 102, DSN S 131 and DSN S 183\nThis course will include the functions and operations of the digital camera, scanning and other image input devices, digital image manipulation, software usage and support, color management and printing, presentation of images, compositional dynamics and the development of \"seeing\" as a medium of design, expression, and communication. Students should have access to a good or high quality digital camera with the ability to separately adjust shutter speed, f/stop and exposure, a laptop with updated Adobe Photoshop software, and enough digital storage for all class assignments.\n",
    "credits": "3"
  },
  {
    "course_name": "Drawing II",
    "dept": "ARTIS",
    "num": "230",
    "desc": "Prereq: DSN S 102, DSN S 183 and DSN S 131\nA continuation of DSN S 131. Further development of perceptual drawing skills from a variety of subject matter. Continued practice with drawing materials and techniques with emphasis on tonal and color media.\n",
    "credits": "3"
  },
  {
    "course_name": "Watercolor Painting",
    "dept": "ARTIS",
    "num": "233",
    "desc": "Prereq: ARTIS 230\nFundamentals of painting using water-based media applied to observation-based painting. Subject matter may include working from actual or two-dimensional references of still life, landscape, architectural space, and the human form.\n",
    "credits": "3"
  },
  {
    "course_name": "Watercolor Painting: Honors",
    "dept": "ARTIS",
    "num": "233H",
    "desc": "Prereq: ARTIS 230\nFundamentals of painting using water-based media applied to observation-based painting. Subject matter may include working from actual or two-dimensional references of still life, landscape, architectural space, and the human form.\n",
    "credits": "3"
  },
  {
    "course_name": "Painting I",
    "dept": "ARTIS",
    "num": "238",
    "desc": "Prereq: ARTIS 230\nFundamentals of painting using acrylic and oil media applied to observation-based painting. Subject matter may include working from actual or two-dimensional references of still life, landscape, and the human form.\n",
    "credits": "3"
  },
  {
    "course_name": "Painting I: Honors",
    "dept": "ARTIS",
    "num": "238H",
    "desc": "Prereq: ARTIS 230\nFundamentals of painting using acrylic and oil media applied to observation-based painting. Subject matter may include working from actual or two-dimensional references of still life, landscape, and the human form.\n",
    "credits": "3"
  },
  {
    "course_name": "Collage, Assemblage, and the Found Object",
    "dept": "ARTIS",
    "num": "305",
    "desc": "Prereq: 6 credits of 200 level studio or permission of instructor\nUsing techniques of collage and assemblage, this course will explore the significance of recycling, sustainable methods of art making, and thrift-store culture as medium and subject matter for artists. Through selected readings, slide presentations, and studio activities, we will address the environmental cause and effect of materials and methods, consumption and waste, and one's personal responsibility as stewards for the planet we share. Emphasis will be on conceptual development.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Modeling, Rendering and Virtual Photography",
    "dept": "ARTIS",
    "num": "308",
    "desc": "Prereq: ARTIS 230 or permission of instructor\nIntroduction to  3D modeling using computer and available software. Modeling, texturing, lighting, and rendering with respect to 3D object and still scene creation.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Modeling, Rendering and Virtual Photography,:Honors",
    "dept": "ARTIS",
    "num": "308H",
    "desc": "Prereq: ARTIS 230 or permission of instructor\nIntroduction to 3D modeling using computer and available software. Modeling, texturing, lighting, and rendering with respect to 3D object and still scene creation.\n",
    "credits": "3"
  },
  {
    "course_name": "Sources and Methods of Visual Art",
    "dept": "ARTIS",
    "num": "310",
    "desc": "\nStudy and application of methods used by contemporary artists for the purpose of generating ideas for new work. Field trip.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Issues in Studio Art",
    "dept": "ARTIS",
    "num": "311",
    "desc": "\nExploration of issues and directions in current art. Readings, discussions, and studio research projects to build an experimental and applied knowledge base for understanding each student's place in the contemporary art world.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Furniture Design",
    "dept": "ARTIS",
    "num": "320",
    "desc": "Prereq: ARTIS 202 or permission of instructor.\nDesign and production of basic furniture forms in wood. Introduction to power tools. Develop an individual design process including an understanding of scale and proportion. Develop a deeper understanding of wood and the issues of sustainability in furniture design.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Furniture Design: Honors",
    "dept": "ARTIS",
    "num": "320H",
    "desc": "Prereq: ARTIS 202 or permission of instructor.\nDesign and production of basic furniture forms in wood. Introduction to power tools. Develop an individual design process including an understanding of scale and proportion. Develop a deeper understanding of wood and the issues of sustainability in furniture design.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Ceramics Studio",
    "dept": "ARTIS",
    "num": "322",
    "desc": "Prereq: ARTIS 204 or permission of instructor.\nInvestigation of expressive forms and techniques in ceramics; introduction to throwing on the wheel, to exploration of utilitarian and sculptural approaches in the medium, and to glaze-making research and electric kiln firing.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Ceramics Studio: Honors",
    "dept": "ARTIS",
    "num": "322H",
    "desc": "Prereq: ARTIS 204 or permission of instructor.\nInvestigation of expressive forms and techniques in ceramics; introduction to throwing on the wheel, to exploration of utilitarian and sculptural approaches in the medium, and to glaze-making research and electric kiln firing.\n",
    "credits": "3"
  },
  {
    "course_name": "Scientific Illustration Principles and Techniques",
    "dept": "ARTIS",
    "num": "323",
    "desc": "Prereq: DSN S 131, ARTIS 230, or equivalent, and 3 credits in biological sciences; or permission of the instructor\nStudio basics and professional techniques in black & white, continuous tone, and color. Introduction to professional practice and principles of communicating science through art. Emphasis on tools, materials, and rendering.\n",
    "credits": "3"
  },
  {
    "course_name": "Jewelry/Metalsmithing II",
    "dept": "ARTIS",
    "num": "324",
    "desc": "Prereq: ARTIS 203 or permission of instructor\nContinued study of traditional and contemporary metalsmithing fabrication techniques applicable to jewelry and object construction, including container forms. Emphasis on design, modeling and rendering techniques and progressive skill development. Basic stone setting and lost wax casting introduced.\n",
    "credits": "3"
  },
  {
    "course_name": "Jewelry/Metalsmithing II: Honors",
    "dept": "ARTIS",
    "num": "324H",
    "desc": "Prereq: ARTIS 203 or permission of instructor\nContinued study of traditional and contemporary metalsmithing fabrication techniques applicable to jewelry and object construction, including container forms. Emphasis on design, modeling and rendering techniques and progressive skill development. Basic stone setting and lost wax casting introduced.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Studio Arts Seminar",
    "dept": "ARTIS",
    "num": "325",
    "desc": "Prereq: Open to ISA BFA majors\nContemporary issues in studio arts explored through lectures, presentations and critiques.\n",
    "credits": "2"
  },
  {
    "course_name": "Illustration and Illustration Software",
    "dept": "ARTIS",
    "num": "326",
    "desc": "Prereq: ARTIS 323/BPM I 323, or permission of the instructor\nAn introduction to digital illustration software. Application of painting, drawing and image making techniques using vector and raster based programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Illustration as Communication",
    "dept": "ARTIS",
    "num": "327",
    "desc": "Prereq: ARTIS 326/BPM I 326, or permission of the instructor\nInvestigation of illustration as a form of communication. Emphasis on problem solving, effective composition, and advancement of rendering skills.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Photography",
    "dept": "ARTIS",
    "num": "329",
    "desc": "Prereq: ARTIS 210 or permission of instructor\nContinuation and expansion of concepts and processes from introductory photography. The class begins with advanced film camera techniques and experimentation with medium format cameras. It then moves into digital and color photography while also addressing output and presentation. Emphasis will be on the use of photography for visual communication and creative expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Photography, Honors",
    "dept": "ARTIS",
    "num": "329H",
    "desc": "Prereq: ARTIS 210 or permission of instructor\nContinuation and expansion of concepts and processes from introductory photography. The class begins with advanced film camera techniques and experimentation with medium format cameras. It then moves into digital and color photography while also addressing output and presentation. Emphasis will be on the use of photography for visual communication and creative expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Drawing III: Life Drawing",
    "dept": "ARTIS",
    "num": "330",
    "desc": "Prereq: ARTIS 230\nDrawing from the human figure.\n",
    "credits": "3"
  },
  {
    "course_name": "Drawing III: Life Drawing, Honors",
    "dept": "ARTIS",
    "num": "330H",
    "desc": "Prereq: ARTIS 230\nDrawing from the human figure.\n",
    "credits": "3"
  },
  {
    "course_name": "Alternative materials for Artist/Designer",
    "dept": "ARTIS",
    "num": "331",
    "desc": "Prereq: 200 level ISA studio courses, or permission of instructor\nExploration of alternative materials (primarily non-metallics, both natural and manufactured) applicable to the design and creation of small designed objects and adornment. Students will learn additive and reductive processes, experiment with found object inclusion, rubber mold- making, and resin casting. A series of finished pieces will result. Open to all majors in the College of Design.\n",
    "credits": "3"
  },
  {
    "course_name": "Application of Scientific Illustration Techniques",
    "dept": "ARTIS",
    "num": "337",
    "desc": "Prereq: ARTIS 327\nRendering techniques applied to different types of biological and scientific subjects emphasizing communication.  The use of traditional and digital media.  Term project required.\n",
    "credits": "3"
  },
  {
    "course_name": "Painting II",
    "dept": "ARTIS",
    "num": "338",
    "desc": "Prereq: ARTIS 238 or ARTIS 213 and ARTIS 230\nPainting using acrylic and oil media; composition and expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Painting II: Honors",
    "dept": "ARTIS",
    "num": "338H",
    "desc": "Prereq: ARTIS 238 or ARTIS 213 and ARTIS 230\nPainting using acrylic and oil media; composition and expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Woven Textile Structures",
    "dept": "ARTIS",
    "num": "345",
    "desc": "Prereq: ARTIS 214 or permission of instructor\nIntroduction to woven textile construction using commercial and hand-dyed yarns. Emphasis on technical development of weaving as a means for personal expression as well as an understanding of its role within the applied arts.\n",
    "credits": "3"
  },
  {
    "course_name": "Woven Textile Structures, Honors",
    "dept": "ARTIS",
    "num": "345H",
    "desc": "Prereq: ARTIS 214 or permission of instructor\nIntroduction to woven textile construction using commercial and hand-dyed yarns. Emphasis on technical development of weaving as a means for personal expression as well as an understanding of its role within the applied arts.\n",
    "credits": "3"
  },
  {
    "course_name": "Natural Dyes",
    "dept": "ARTIS",
    "num": "346",
    "desc": "\nIntroduction to natural dyes.  Course includes a historical overview of natural dyes with attention to global perspectives.  Emphasis on technical skill development and application of research in the creation of contemporary textile artwork, apparel and home furnishings.\n",
    "credits": "3"
  },
  {
    "course_name": "Natural Dyes: Honors",
    "dept": "ARTIS",
    "num": "346H",
    "desc": "\nIntroduction to natural dyes.  Course includes a historical overview of natural dyes with attention to global perspectives.  Emphasis on technical skill development and application of research in the creation of contemporary textile artwork, apparel and home furnishings.\n",
    "credits": "3"
  },
  {
    "course_name": "Printed Textile Design",
    "dept": "ARTIS",
    "num": "347",
    "desc": "Prereq: ARTIS 214 or permission of instructor\nTextile hand-printing methods on fabric including block, stencil and screen-printing using synthetic and natural dyes, discharging agents and pigments. Digital printing on fabric will be introduced. Experimental printing methods will also be explored. Emphasis on research and development of surface design techniques as a means for personal expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Printed Textile Design: Honors",
    "dept": "ARTIS",
    "num": "347H",
    "desc": "Prereq: ARTIS 214 or permission of instructor\nTextile hand-printing methods on fabric including block, stencil and screen-printing using synthetic and natural dyes, discharging agents and pigments. Digital printing on fabric will be introduced. Experimental printing methods will also be explored. Emphasis on research and development of surface design techniques as a means for personal expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Relief Printmaking: Digital/Traditional",
    "dept": "ARTIS",
    "num": "356",
    "desc": "Prereq: For ARTIS 356: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission; For ARTIS 556: Graduate classification or instructor permission\nIn-depth exploration of digital or traditional design and block cutting processes (computer/laser cutter/CNC router or drawing/chisels). Use relief printmaking to create a unified body of prints from those blocks. Emphasis is on experimental and creative use of printmaking with study of contemporary trends.\n",
    "credits": "3"
  },
  {
    "course_name": "Relief Printmaking: Digital/Traditional, Honors",
    "dept": "ARTIS",
    "num": "356H",
    "desc": "Prereq: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission\nExplore the techniques and aesthetic qualities of black and white and color relief printmaking with woodcuts, computer/laser cutter/CNC router blocks, or photopolymer plates. Emphasis is on experimental and creative use of printmaking with study of contemporary trends.\n",
    "credits": "3"
  },
  {
    "course_name": "Intaglio and Monotype Printmaking: Digital / Traditional",
    "dept": "ARTIS",
    "num": "357",
    "desc": "Prereq: For ARTIS 357: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission; For ARTIS 557: Graduate classification or instructor permission\nExplore the techniques and aesthetic qualities of black and white and color intaglio printmaking primarily through etching, aquatint, laser-cut plates and collagraph processes. Students will generate imagery through traditional drawing, collage and digital processes. Unique, one-of-a-kind black and white and color prints from Plexiglas will also be introduced. Emphasis is on experimental and creative use of printmaking for artistic expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Intaglio and Monotype Printmaking: Digital / Traditional, Honors",
    "dept": "ARTIS",
    "num": "357H",
    "desc": "Prereq: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission\nExplore the techniques and aesthetic qualities of black and white and color intaglio printmaking primarily through etching, aquatint, laser-cut plates and collagraph processes. Students will generate imagery through traditional drawing, collage and digital processes. Unique, one-of-a-kind black and white and color prints from Plexiglas will also be introduced. Emphasis is on experimental and creative use of printmaking for artistic expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Lithography: Digital / Traditional",
    "dept": "ARTIS",
    "num": "358",
    "desc": "Prereq: For ARTIS 358: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission; For ARTIS 558: Graduate classification or instructor permission\nExamine the techniques and aesthetic qualities of lithography primarily through hand-drawn and photographic plates. Students may generate imagery through traditional drawing, collage or digital processes. Emphasis is on experimental and creative use of printmaking for artistic expression. For those taking the course for a second semester, focus is on stone lithography and increased work with color.\n",
    "credits": "3"
  },
  {
    "course_name": "Lithography: Digital / Traditional, Honors",
    "dept": "ARTIS",
    "num": "358H",
    "desc": "Prereq: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission\nExamine the techniques and aesthetic qualities of lithography primarily through hand-drawn and photographic plates. Students may generate imagery through traditional drawing, collage or digital processes. Emphasis is on experimental and creative use of printmaking for artistic expression. For those taking the course for a second semester, focus is on stone lithography and increased work with color.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Design and Fabrication of Furniture",
    "dept": "ARTIS",
    "num": "360",
    "desc": "\nAn introduction to issues of design and fabrication of furniture focusing on sustainability. Exploration of the effect of consumers on design and how this affects our environment and our global society.\n",
    "credits": "3"
  },
  {
    "course_name": "Artists, Designers and Sustainable Development",
    "dept": "ARTIS",
    "num": "362",
    "desc": "Prereq: Junior level standing in the University\nThe artist/designer's role in sustainable development with a focus on cultural understanding of the collaborating communities. Class discussion, visual exercises, and the creation of creative collaborative service-learning projects such as product design, habitat design, and visual arts projects. Preorientation for travel to Ghana in ARTIS 363.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studio Abroad: Ghana",
    "dept": "ARTIS",
    "num": "363",
    "desc": "Prereq: ARTIS 362\nTraveling studio to Ghana, West Africa; an experiential tour of arts and history combined with design focused collaborative service-learning projects. Projects may include product development, design consultation, sustainable building design, and learning and teaching of visual arts. Student teams will develop projects in partnership with Ghanaians.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "BFA Professional Practice",
    "dept": "ARTIS",
    "num": "399",
    "desc": "Prereq: Junior classification in ISA BFA curriculum.\nIntroduction to professional practices including development of portfolio (visual and written components). Lecture and presentation topics include applying to graduate school, internships, applying for jobs, grants/funding opportunities, professional networking, exhibition opportunities, and best practices for studio artists. Half-semester course. Required of all ISA majors.\n",
    "credits": "2"
  },
  {
    "course_name": "Principles of 3D Character Animation",
    "dept": "ARTIS",
    "num": "407",
    "desc": "Prereq: ARTIS 308\nAnimation techniques using the computer and available software. Principles of character animation. Prior knowledge of modeling, lighting, texturing and rendering with available software is assumed.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of 3D Character Animation: Honors",
    "dept": "ARTIS",
    "num": "407H",
    "desc": "Prereq: ARTIS 308\nAnimation techniques using the computer and available software. Principles of character animation. Prior knowledge of   modeling, lighting, texturing and rendering with available software is assumed.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of 3D Animation",
    "dept": "ARTIS",
    "num": "408",
    "desc": "Prereq: ARTIS 308\nAnimation techniques using the computer and available software. Principles of animation. Prior knowledge of modeling, lighting, texturing, animation and rendering with computer and available software is assumed.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of 3D Animation: Honors",
    "dept": "ARTIS",
    "num": "408H",
    "desc": "Prereq: ARTIS 308\nAnimation techniques using the computer and available software. Principles of animation. Prior knowledge of modeling, lighting, texturing, animation and rendering with computer and available software is assumed.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer/Video Game Design and Development",
    "dept": "ARTIS",
    "num": "409",
    "desc": "Prereq: Permission of instructor. Programming emphasis: COM S 227, COM S 228, COM S 229 or equivalent in engineering; art or graphics emphasis: ARTIS 230 and ARTIS 308; writing emphasis: an English course in creative writing or writing screen plays; business or marketing students: Junior classification\nIndependent project based creation and development of \"frivolous and non-frivolous\" computer games in a cross-disciplinary team. Projects require cross-disciplinary teams.  Aspects of Indie development and computer/video game history will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Furniture Design",
    "dept": "ARTIS",
    "num": "420",
    "desc": "Prereq: ARTIS 320\nDesign and creation of increasingly complex furniture forms with consideration of precedents and innovative techniques and approaches. Continued development of a unique personal approach to the design and making of furniture. Refined sensitivity to wood, and continued consideration of various sustainable practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Furniture Design: Honors",
    "dept": "ARTIS",
    "num": "420H",
    "desc": "Prereq: ARTIS 320\nDesign and creation of increasingly complex furniture forms with consideration of precedents and innovative techniques and approaches. Continued development of a unique personal approach to the design and making of furniture.  Refined sensitivity to wood, and continued consideration of various sustainable practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Ceramics Studio",
    "dept": "ARTIS",
    "num": "422",
    "desc": "Prereq: For ARTIS 422: ARTIS 322; For ARTIS 522: graduate classification in the MFA program in Integrated Visual Arts; or permission of instructor\nCreation of a body of work in personal ceramic forms and unique surface treatments. Gas Kiln firings, research into contemporary ceramic artists and development of a body of increasingly skilled work are emphasized. Students are expected to be capable of independent studio work and take responsibility for kiln firings.\n",
    "credits": "3"
  },
  {
    "course_name": "Ceramics Studio: Honors",
    "dept": "ARTIS",
    "num": "422H",
    "desc": "Prereq: ARTIS 322\nCreation of a body of work in personal ceramic forms and unique surface treatments. Gas Kiln firings, research into contemporary ceramic artists and development of a body of increasingly skilled work are emphasized. Students are expected to be capable of independent studio work and take responsibility for kiln firings.\n",
    "credits": "3"
  },
  {
    "course_name": "Jewelry/Metalsmithing III",
    "dept": "ARTIS",
    "num": "424",
    "desc": "Prereq: For ARTIS 424: ARTIS 324 or permission of instructor; For ARTIS 524: Graduate Classification in the MFA program in Integrated Visual Arts, or instructor permission\nEmphasis on metal fabrication and hollow construction techniques applicable to jewelry, functional objects and sculptural art forms. Processes introduced include raising, forming, and anticlastic shell forming techniques. Introduction to mechanisms and tool making. Advanced students are encouraged to integrate alternative materials and technologies. A focus is placed on independent research, professional engagement and portfolio development.\n",
    "credits": "3"
  },
  {
    "course_name": "Jewelry/Metalsmithing III: Honors",
    "dept": "ARTIS",
    "num": "424H",
    "desc": "Prereq: ARTIS 324 or permission of instructor\nEmphasis on metal fabrication and hollow construction techniques applicable to jewelry, functional objects and sculptural art forms. Processes introduced include raising, forming, and anticlastic shell forming techniques. Introduction to mechanisms and tool making. Advanced students are encouraged to integrate alternative materials and technologies. A focus is placed on independent research, professional engagement and portfolio development.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Photography",
    "dept": "ARTIS",
    "num": "429",
    "desc": "Prereq: ARTIS 329\nIndependent, advanced work in traditional alternative and/or digital photographic processes. Emphasis is on development of a unified body of work and research into contemporary photographers and aesthetic concern.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Photography: Honors",
    "dept": "ARTIS",
    "num": "429H",
    "desc": "Prereq: ARTIS 329\nIndependent, advanced work in traditional alternative and/or digital photographic processes. Emphasis is on development of a unified body of work and research into contemporary photographers and aesthetic concern.\n",
    "credits": "3"
  },
  {
    "course_name": "Drawing IV",
    "dept": "ARTIS",
    "num": "430",
    "desc": "Prereq: ARTIS 330\nFigurative and/or non-figurative drawing with advanced work in media, composition, and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Drawing IV: Honors",
    "dept": "ARTIS",
    "num": "430H",
    "desc": "Prereq: ARTIS 330\nFigurative and/or non-figurative drawing with advanced work in media, composition, and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Character and Scene Design",
    "dept": "ARTIS",
    "num": "431",
    "desc": "Prereq: For ARTIS 431: DSN S 131, plus ARTIS 230, ARTIS 330, or instructor permission after portfolio review. For ARTIS 531: Graduate classification in the MFA program in Integrated Visual Arts; or instructor permission after portfolio review.\nDrawing directed toward designing characters and environments to be used for telling stories in a variety of contexts. Emphasis on ideation, research, concept art and other process work over finished art.\n",
    "credits": "3"
  },
  {
    "course_name": "Sequential Narrative Drawing",
    "dept": "ARTIS",
    "num": "432",
    "desc": "Prereq: For ARTIS 432: DSN S 131, plus ARTIS 230, ARTIS 330, or instructor permission after portfolio review. For ARTIS 532, Graduate classification in the MFA program in Integrated Visual Arts; or instructor permission after portfolio review.\nStudio course in drawing focusing on the fundamentals of communicating a narrative through sequential images in a variety of applications. Emphasis will be placed on visual research, ideation, concept art and process sketching.\n",
    "credits": "3"
  },
  {
    "course_name": "Painting III",
    "dept": "ARTIS",
    "num": "438",
    "desc": "Prereq: ARTIS 338\nFigurative and non-figurative painting with advanced work in media, composition, and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Painting III: Honors",
    "dept": "ARTIS",
    "num": "438H",
    "desc": "Prereq: ARTIS 338\nFigurative and non-figurative painting with advanced work in media, composition, and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Printed Textile Design",
    "dept": "ARTIS",
    "num": "447",
    "desc": "Prereq: For ARTIS 447: ARTIS 347 or permission of instructor; For ARTIS 547: Graduate classification.\nExploration of hand-printing methods on fabric including block, stencil, and screen-printing using dyes, discharging agents, and pigments. Individualized research and development of surface design techniques as means for personal expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Textile Design",
    "dept": "ARTIS",
    "num": "448",
    "desc": "Prereq: Junior classification in either College of Design or Apparel, Merchandising, & Design\nThis hands-on studio course will allow students to explore digital printing technology and its application to textile design for those working within industry as well as independent studio practitioners. Digital design development includes pattern repeats and photo manipulation to create unique textile designs for fashion, interior and fine art applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Printmaking",
    "dept": "ARTIS",
    "num": "458",
    "desc": "Prereq: ARTIS 356, ARTIS 357, or ARTIS 358, and permission of instructor\nIndependent, advanced work in printmaking processes. Emphasis is on development of a unified body of work and research into contemporary artists.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Printmaking: Honors",
    "dept": "ARTIS",
    "num": "458H",
    "desc": "Prereq: ARTIS 356, ARTIS 357, or ARTIS 358, and permission of instructor\nIndependent, advanced work in printmaking processes. Emphasis is on development of a unified body of work and research into contemporary artists.\n",
    "credits": "3"
  },
  {
    "course_name": "Community-Engaged Arts Management.",
    "dept": "ARTIS",
    "num": "462",
    "desc": "\nIntroduction to aspects of community arts management and art gallery operations. Class meets at ISU Design on Main Gallery, a community arts space in the Main Street Cultural District of Ames. Students will staff the gallery and assist in the conception, design and realization of exhibitions.\n",
    "credits": "3"
  },
  {
    "course_name": "Video Art",
    "dept": "ARTIS",
    "num": "473",
    "desc": "Prereq: ARTIS 212 or permission of instructor for enrollment in ARTIS 473; graduate standing or permission of instructor for enrollment in ARTIS 573\nUsage of professional video editing software and application of best practices for video production and post-production to realize original artworks. Creation of narrative and non-narrative videos and site specific video installations. Prominent examples in the history of video art provide context for the coursework. Non-repeatable for graduate students.\n",
    "credits": "3"
  },
  {
    "course_name": "Interactive Art",
    "dept": "ARTIS",
    "num": "475",
    "desc": "Prereq: For ARTIS 475: ARTIS 212 or Permission of Instructor; for ARTIS 575: Graduate standing or permission of instructor.\nCreate software and integrate the sensors required to create interactive artworks, video games, and installations. Prominent examples in the history of interactive art provide context for the coursework.\n",
    "credits": "3"
  },
  {
    "course_name": "Selected Topics in Studio Art",
    "dept": "ARTIS",
    "num": "482",
    "desc": "Prereq: Permission of instructor\nSpecial issues related to studio art. Topics vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "ARTIS",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed craft design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Ceramics",
    "dept": "ARTIS",
    "num": "490B",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Computer Art and Design",
    "dept": "ARTIS",
    "num": "490C",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Drawing",
    "dept": "ARTIS",
    "num": "490D",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Textiles",
    "dept": "ARTIS",
    "num": "490E",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Illustration",
    "dept": "ARTIS",
    "num": "490F",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Metals",
    "dept": "ARTIS",
    "num": "490G",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "ARTIS",
    "num": "490H",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Painting",
    "dept": "ARTIS",
    "num": "490I",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Photography",
    "dept": "ARTIS",
    "num": "490J",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Printmaking",
    "dept": "ARTIS",
    "num": "490K",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Furniture",
    "dept": "ARTIS",
    "num": "490L",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Mixed Media",
    "dept": "ARTIS",
    "num": "490M",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Post Baccalaureate Capstone Course",
    "dept": "ARTIS",
    "num": "491",
    "desc": "Prereq: Enrollment in Post Baccalaureate Program.\nExhibition of artwork completed in the Post Baccalaureate program, required for fulfillment of certificate.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Workshop",
    "dept": "ARTIS",
    "num": "493",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Ceramics",
    "dept": "ARTIS",
    "num": "493B",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Computer Art and Design",
    "dept": "ARTIS",
    "num": "493C",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Drawing",
    "dept": "ARTIS",
    "num": "493D",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Textiles",
    "dept": "ARTIS",
    "num": "493E",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Illustration",
    "dept": "ARTIS",
    "num": "493F",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Metals",
    "dept": "ARTIS",
    "num": "493G",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Honors",
    "dept": "ARTIS",
    "num": "493H",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Painting",
    "dept": "ARTIS",
    "num": "493I",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Photography",
    "dept": "ARTIS",
    "num": "493J",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Printmaking",
    "dept": "ARTIS",
    "num": "493K",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Furniture",
    "dept": "ARTIS",
    "num": "493L",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Mixed Media",
    "dept": "ARTIS",
    "num": "493M",
    "desc": "Prereq: Permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Integrated Studio Arts in Europe Seminar",
    "dept": "ARTIS",
    "num": "494",
    "desc": "Prereq: Permission of instructor and planned enrollment in ARTIS 495\nCultural and historical aspects of art and design in Western Europe in preparation for study abroad. Area of study varies each time offered. Offered on a satisfactory-fail basis only.\n  Offered on a satisfactory-fail basis only.\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Integrated Studio Arts in Europe",
    "dept": "ARTIS",
    "num": "495",
    "desc": "Prereq: Graduate classification, ARTIS 494 or equivalent, permission of instructor\nInternational study abroad program in western Europe. Visits to design studios, art museums, and educational facilities. Related activities depending on specific area of study which may vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Art and Design Field Study",
    "dept": "ARTIS",
    "num": "496",
    "desc": "Prereq: Concurrent enrollment in an art and design studio or integrated studio arts course and permission of instructor\nStudy and tours of museums, galleries, artist and/or designer studios and other areas of interest within art and design.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Studio Internship",
    "dept": "ARTIS",
    "num": "497",
    "desc": "Prereq: Advanced classification in a department curriculum\nWritten approval of supervising instructor and department chair on required form in advance of semester of enrollment. Supervised experience with a cooperating artist or studio.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "BFA Exhibition",
    "dept": "ARTIS",
    "num": "499",
    "desc": "Prereq: ARTIS 399 and senior classification in the ISA BFA Curriculum.\nCapstone experience for the BFA degree, including the refinement of a final portfolio (visual and written components). Guest lecturers cover range of topics relevant to the professional practice of art and design. Course culminates in the planning, design and installation of the BFA group exhibition in a formal gallery setting. Half-semester course. Required of all ISA majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Collage, Assemblage, and the Found Object",
    "dept": "ARTIS",
    "num": "505",
    "desc": "Prereq: 6 credits of 200 level studio or permission of instructor\nUsing techniques of collage and assemblage, this course will explore the significance of recycling, sustainable methods of art making, and thrift-store culture as medium and subject matter for artists. Through selected readings, slide presentations, and studio activities, we will address the environmental cause and effect of materials and methods, consumption and waste, and one's personal responsibility as stewards for the planet we share. Emphasis will be on conceptual development.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of 3D Character Animation",
    "dept": "ARTIS",
    "num": "507",
    "desc": "Prereq: ARTIS 308\nAnimation techniques using the computer and available software. Principles of character animation. Prior knowledge of modeling, lighting, texturing and rendering with available software is assumed.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Aided Animation and Visualization",
    "dept": "ARTIS",
    "num": "508",
    "desc": "Prereq: ARTIS 408 or graduate classification and permission of instructor\nFurther investigations begun in ARTIS 408. Attention given to the workflow and management of creating animation and visualizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer/Video Game Design and Development",
    "dept": "ARTIS",
    "num": "509",
    "desc": "Prereq: Permission of instructor. Programming emphasis: COM S 227, COM S 228, COM S 229 or equivalent in engineering; art or graphics emphasis: ARTIS 230 and ARTIS 308; writing emphasis: an English course in creative writing or writing screen plays; business or marketing students: Junior classification\nIndependent project based creation and development of \"frivolous and non-frivolous\" computer games in a cross-disciplinary team. Projects require cross-disciplinary teams.  Aspects of Indie development and computer/video game history will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Teaching",
    "dept": "ARTIS",
    "num": "511",
    "desc": "Prereq: Graduate classification\nReadings and discussion of university level design education issues, studio/classroom observation, development of a teaching philosophy, lesson planning and presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Furniture Design",
    "dept": "ARTIS",
    "num": "520",
    "desc": "Prereq: ARTIS 320\nDesign and creation of increasingly complex furniture forms with consideration of precedents and innovative techniques and approaches. Continued development of a unique personal approach to the design and making of furniture. Refined sensitivity to wood, and continued consideration of various sustainable practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Ceramics Studio",
    "dept": "ARTIS",
    "num": "522",
    "desc": "Prereq: For ARTIS 422: ARTIS 322; For ARTIS 522: graduate classification in the MFA program in Integrated Visual Arts; or permission of instructor\nCreation of a body of work in personal ceramic forms and unique surface treatments. Gas Kiln firings, research into contemporary ceramic artists and development of a body of increasingly skilled work are emphasized. Students are expected to be capable of independent studio work and take responsibility for kiln firings.\n",
    "credits": "3"
  },
  {
    "course_name": "Jewelry/Metalsmithing III",
    "dept": "ARTIS",
    "num": "524",
    "desc": "Prereq: For ARTIS 424: ARTIS 324 or permission of instructor; For ARTIS 524: Graduate Classification in the MFA program in Integrated Visual Arts, or instructor permission\nEmphasis on metal fabrication and hollow construction techniques applicable to jewelry, functional objects and sculptural art forms. Processes introduced include raising, forming, and anticlastic shell forming techniques. Introduction to mechanisms and tool making. Advanced students are encouraged to integrate alternative materials and technologies. A focus is placed on independent research, professional engagement and portfolio development.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Photography",
    "dept": "ARTIS",
    "num": "529",
    "desc": "Prereq: ARTIS 329\nIndependent, advanced work in traditional alternative and/or digital photographic processes. Emphasis is on development of a unified body of work and research into contemporary photographers and aesthetic concern.\n",
    "credits": "3"
  },
  {
    "course_name": "Drawing IV",
    "dept": "ARTIS",
    "num": "530",
    "desc": "Prereq: ARTIS 330\nFigurative and/or non-figurative drawing with advanced work in media, composition, and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Character and Scene Design",
    "dept": "ARTIS",
    "num": "531",
    "desc": "Prereq: For ARTIS 431: DSN S 131, plus ARTIS 230, ARTIS 330, or instructor permission after portfolio review. For ARTIS 531: Graduate classification in the MFA program in Integrated Visual Arts; or instructor permission after portfolio review.\nDrawing directed toward designing characters and environments to be used for telling stories in a variety of contexts. Emphasis on ideation, research, concept art and other process work over finished art.\n",
    "credits": "3"
  },
  {
    "course_name": "Sequential Narrative Drawing",
    "dept": "ARTIS",
    "num": "532",
    "desc": "Prereq: For ARTIS 432: DSN S 131, plus ARTIS 230, ARTIS 330, or instructor permission after portfolio review. For ARTIS 532, Graduate classification in the MFA program in Integrated Visual Arts; or instructor permission after portfolio review.\nStudio course in drawing focusing on the fundamentals of communicating a narrative through sequential images in a variety of applications. Emphasis will be placed on visual research, ideation, concept art and process sketching.\n",
    "credits": "3"
  },
  {
    "course_name": "Painting III",
    "dept": "ARTIS",
    "num": "538",
    "desc": "Prereq: ARTIS 338\nFigurative and non-figurative painting with advanced work in media, composition, and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Printed Textile Design",
    "dept": "ARTIS",
    "num": "547",
    "desc": "Prereq: For ARTIS 447: ARTIS 347 or permission of instructor; For ARTIS 547: Graduate classification.\nExploration of hand-printing methods on fabric including block, stencil, and screen-printing using dyes, discharging agents, and pigments. Individualized research and development of surface design techniques as means for personal expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Textile Design",
    "dept": "ARTIS",
    "num": "548",
    "desc": "Prereq: Junior classification in either College of Design or Apparel, Merchandising, & Design\nThis hands-on studio course will allow students to explore digital printing technology and its application to textile design for those working within industry as well as independent studio practitioners. Digital design development includes pattern repeats and photo manipulation to create unique textile designs for fashion, interior and fine art applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Relief Printmaking: Digital/Traditional",
    "dept": "ARTIS",
    "num": "556",
    "desc": "Prereq: For ARTIS 356: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission; For ARTIS 556: Graduate classification or instructor permission\nIn-depth exploration of digital or traditional design and block cutting processes (computer/laser cutter/CNC router or drawing/chisels). Use relief printmaking to create a unified body of prints from those blocks. Emphasis is on experimental and creative use of printmaking with study of contemporary trends.\n",
    "credits": "3"
  },
  {
    "course_name": "Intaglio and Monotype Printmaking: Digital / Traditional",
    "dept": "ARTIS",
    "num": "557",
    "desc": "Prereq: For ARTIS 357: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission; For ARTIS 557: Graduate classification or instructor permission\nExplore the techniques and aesthetic qualities of black and white and color intaglio printmaking primarily through etching, aquatint, laser-cut plates and collagraph processes. Students will generate imagery through traditional drawing, collage and digital processes. Unique, one-of-a-kind black and white and color prints from Plexiglas will also be introduced. Emphasis is on experimental and creative use of printmaking for artistic expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Lithography: Digital / Traditional",
    "dept": "ARTIS",
    "num": "558",
    "desc": "Prereq: For ARTIS 358: ARTIS 206 and credit or enrollment in ARTIS 230, or instructor permission; For ARTIS 558: Graduate classification or instructor permission\nExamine the techniques and aesthetic qualities of lithography primarily through hand-drawn and photographic plates. Students may generate imagery through traditional drawing, collage or digital processes. Emphasis is on experimental and creative use of printmaking for artistic expression. For those taking the course for a second semester, focus is on stone lithography and increased work with color.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminar: Grants, Residencies, Exhibitions, Entrepreneurialism",
    "dept": "ARTIS",
    "num": "571A",
    "desc": "Prereq: Admission into graduate program in the College of Design\nProfessional opportunities and avenues of support available to studio artists.  Skill development in preparing visual portfolios and writing applications and statements for grants, residencies and exhibitions. Comprehensive development of strategies needed to advance one’s career as a professional studio artist. Students learn to create and apply a personalized plan that will guide them toward a successful studio practice as an emerging, mid-career and established artist.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminar: Critique and Creative Process",
    "dept": "ARTIS",
    "num": "571B",
    "desc": "Prereq: Admission into graduate program in the College of Design\nOngoing weekly critiques and dialog about sources, methods, and progress of studio projects. Graduate students will learn to articulate their ideas from concept to creation. The interaction of students at different levels in a broad spectrum of studio courses will reveal commonalities and connections among all of the visual arts, accelerating individual creative development.\n",
    "credits": "3"
  },
  {
    "course_name": "Video Art",
    "dept": "ARTIS",
    "num": "573",
    "desc": "Prereq: ARTIS 212 or permission of instructor for enrollment in ARTIS 473; graduate standing or permission of instructor for enrollment in ARTIS 573\nUsage of professional video editing software and application of best practices for video production and post-production to realize original artworks. Creation of narrative and non-narrative videos and site specific video installations. Prominent examples in the history of video art provide context for the coursework. Non-repeatable for graduate students.\n",
    "credits": "3"
  },
  {
    "course_name": "Interactive Art",
    "dept": "ARTIS",
    "num": "575",
    "desc": "Prereq: For ARTIS 475: ARTIS 212 or Permission of Instructor; for ARTIS 575: Graduate standing or permission of instructor.\nCreate software and integrate the sensors required to create interactive artworks, video games, and installations. Prominent examples in the history of interactive art provide context for the coursework.\n",
    "credits": "3"
  },
  {
    "course_name": "Selected Topics in Studio Art",
    "dept": "ARTIS",
    "num": "582",
    "desc": "Prereq: Permission of instructor\nSpecial issues related to studio art. Topics vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "ARTIS",
    "num": "590",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Ceramics",
    "dept": "ARTIS",
    "num": "590B",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Computer Art and Design",
    "dept": "ARTIS",
    "num": "590C",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Drawing",
    "dept": "ARTIS",
    "num": "590D",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Textiles",
    "dept": "ARTIS",
    "num": "590E",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Illustration",
    "dept": "ARTIS",
    "num": "590F",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Metals",
    "dept": "ARTIS",
    "num": "590G",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Painting",
    "dept": "ARTIS",
    "num": "590I",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Photography",
    "dept": "ARTIS",
    "num": "590J",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Printmaking",
    "dept": "ARTIS",
    "num": "590K",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Furniture",
    "dept": "ARTIS",
    "num": "590L",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Mixed Media",
    "dept": "ARTIS",
    "num": "590M",
    "desc": "Prereq: Bachelor degree in art and/or design, or evidence of satisfactory equivalency in specialized area\nWritten approval of instructor and department chair on required form in advance of semester of enrollment.\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop",
    "dept": "ARTIS",
    "num": "593",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Ceramics",
    "dept": "ARTIS",
    "num": "593B",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Computer Art and Design",
    "dept": "ARTIS",
    "num": "593C",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Drawing",
    "dept": "ARTIS",
    "num": "593D",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Textiles",
    "dept": "ARTIS",
    "num": "593E",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Illustration",
    "dept": "ARTIS",
    "num": "593F",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Metals",
    "dept": "ARTIS",
    "num": "593G",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Painting",
    "dept": "ARTIS",
    "num": "593I",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Photography",
    "dept": "ARTIS",
    "num": "593J",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Printmaking",
    "dept": "ARTIS",
    "num": "593K",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Furniture",
    "dept": "ARTIS",
    "num": "593L",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop: Mixed Media",
    "dept": "ARTIS",
    "num": "593M",
    "desc": "Prereq: Graduate classification and permission of instructor\nIntensive 2 to 4 week studio exploration. Topics vary each time offered and may have prerequisites.\n",
    "credits": "1"
  },
  {
    "course_name": "Integrated Studio Arts in Europe",
    "dept": "ARTIS",
    "num": "595",
    "desc": "Prereq: Graduate classification, ARTIS 494 or equivalent, permission of instructor\nInternational study abroad program in western Europe. Visits to design studios, art museums, and educational facilities. Related activities depending on specific area of study which may vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods",
    "dept": "ARTIS",
    "num": "605",
    "desc": "Prereq: Permission of instructor\nResearch strategies related to fine art and technology. Application of selected methods to specific issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermedia",
    "dept": "ARTIS",
    "num": "607",
    "desc": "Prereq: Graduate classification and permission of instructor.\nExploration and application of media with various materials, methods and ideas.\n",
    "credits": "3"
  },
  {
    "course_name": "Studio Internship",
    "dept": "ARTIS",
    "num": "697",
    "desc": "Prereq: Graduate classification and approval of POS committee\nSupervised off-campus learning experience with a prominent artist, designer, or firm.\n",
    "credits": "arr"
  },
  {
    "course_name": "Current Issues in Studio Arts",
    "dept": "ARTIS",
    "num": "698",
    "desc": "Prereq: Graduate classification and permission of instructor.\nSelected issues in contemporary studio arts. Topics and readings vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "ARTIS",
    "num": "699",
    "desc": "\nResearch in Integrated Studio Arts.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Thesis",
    "dept": "ARTIS",
    "num": "699A",
    "desc": "\nResearch thesis.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Thesis-exhibition",
    "dept": "ARTIS",
    "num": "699B",
    "desc": "\nResearch exhibition.\n",
    "credits": "arr"
  },
  {
    "course_name": "Orientation in Community Development",
    "dept": "IGS",
    "num": "520",
    "desc": "\nIntroduction to the Community Development program.  Focus on on-line delivery methods, graduate level research and writing, technology skills.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "IGS",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis Research",
    "dept": "IGS",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Fundamentals of Interior Design",
    "dept": "ARTID",
    "num": "250",
    "desc": "\nThe profession, issues, and the role of interior design.\n",
    "credits": "2"
  },
  {
    "course_name": "Human Factors in Design",
    "dept": "ARTID",
    "num": "251",
    "desc": "\nOverview of issues related to the human/built environment interface: introduction to health and safety factors, ergonomics, anthropometrics, sensory perception, psycho-behavioral response, physical performance, cultural factors and universal design. Emphasis on application of human factor methods to the analysis, solution, and evaluation of design problems.\n",
    "credits": "3"
  },
  {
    "course_name": "Forces That Shape Interior Space",
    "dept": "ARTID",
    "num": "255",
    "desc": "\nA survey of variables influencing the nature and function of \"interior\" environments.  Review of professional, geo-political, utilitarian, social-cultural, economic, humanistic, historical, technological, and other factors as generators of form and space.\n",
    "credits": "3"
  },
  {
    "course_name": "Sophomore Field Study",
    "dept": "ARTID",
    "num": "259",
    "desc": "Prereq: Enrollment in interior design studio course\nStudy and tours of areas of interest within the interior design profession such as manufacturers, design studios, showrooms and museums.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Graphic Communication for Interior Design I",
    "dept": "ARTID",
    "num": "261",
    "desc": "Prereq: Admission to the interior design program through program review and enrollment in ARTID 265\nPerspective drawing, design sketching, and presentation drawings. Introduction to technical drawing conventions, and design drawings. Emphasis on drawing layout, line quality, and lettering. Use of various rendering media and techniques on 2D and 3D drawings. Overview of presentation techniques, both visual and verbal.\n",
    "credits": "3"
  },
  {
    "course_name": "Graphic Communication for Interior Design II",
    "dept": "ARTID",
    "num": "263",
    "desc": "Prereq: ARTID 261, enrollment in ARTID 267\nComputer visualization techniques and applications; projects employing computer graphic methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio I",
    "dept": "ARTID",
    "num": "265",
    "desc": "Prereq: Credit or enrollment in ARTID 250 and ARTID 261; admission to the interior design program through program review\nEnhanced creative interior design problem solving. Emphasis on research, spatial composition theories and graphic ideation and communication as applied to the interior design of small scale environments. Modeling and manual visualization techniques.\n",
    "credits": "4"
  },
  {
    "course_name": "Interior Design Studio II",
    "dept": "ARTID",
    "num": "267",
    "desc": "Prereq: ARTID 265\nHuman factors issues including ergonomics, human behavior and the requirements of special groups. Color theories related to interior spaces. Residential interior design and medium scale projects. Detail drawings, and expansion of visualization techniques.\n",
    "credits": "4"
  },
  {
    "course_name": "Interior Finish Materials and Systems",
    "dept": "ARTID",
    "num": "350",
    "desc": "Prereq: Completion of the College of Design Core.\nExploration of concepts, materials, and assemblies associated with development of interior elements including floors, walls, ceiling, windows, and finishes. Fiber, plastic, sheet metal, and other surfacing materials. Attention to related human factors, testing, detailing, specifications writing and end-use application.\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Health and Safety Systems",
    "dept": "ARTID",
    "num": "351",
    "desc": "Prereq: Completion of the College of Design Core.\nExploration of interior design concepts, materials, and assemblies as they contribute to the user, health, safety and general well-being. Wood, steel, masonry, and glass assemblies. Attention to related human factors, testing, codes, detailing, specifications writing and end-use application.\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Environmental Control Systems",
    "dept": "ARTID",
    "num": "352",
    "desc": "Prereq: Completion of the College of Design Core.\nExploration of concepts, materials, assemblies associated with building service systems. Overview of electrical, lighting, acoustical, HVAC, plumbing and other non-structural building features. Attention to related human factors, testing, codes, detailing, specifications writing and end-use application.\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Building Systems and Details",
    "dept": "ARTID",
    "num": "353",
    "desc": "Prereq: Completion of the College of Design Core.\nExploration of building construction concepts, materials, and assemblies and their influence on interior design. Attention to human factors, codes, detailing, and other interior design issues related to buildings.\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Design History/Theory/Criticism I",
    "dept": "ARTID",
    "num": "355",
    "desc": "\nTheoretical approaches to evaluation of interior finishes, furnishings, and decorative arts in relation to parallel developments in art and architecture, from a critical, historical and multicultural perspective. Focus on pre-1850.\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Design History/Theory/Criticism II",
    "dept": "ARTID",
    "num": "356",
    "desc": "Prereq: Credit or enrollment in ARTID 355 or permission of instructor\nAdvanced theoretical approaches to evaluation of interior finishes, furnishings, and decorative arts in relation to parallel developments in art and architecture from a critical, historical, and multicultural perspective. Focus on mid-nineteenth and twentieth century.\n",
    "credits": "3"
  },
  {
    "course_name": "Made in Italy",
    "dept": "ARTID",
    "num": "357",
    "desc": "Prereq: Participation in Study Abroad Rome program\nAn investigation of the 20th century roots of modern Italian design and its contemporary form.  Lectures and seminar presentations highlight major Italian designers and internationally significant design in the 20th century.  Focus is on innovative design that exhibits a synthesis of formal and social functions.\n\nMeets International Perspectives Requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Junior Field Study",
    "dept": "ARTID",
    "num": "359",
    "desc": "Prereq: Enrollment in third year interior design studio course\nStudy and tours of areas of interest within the interior design profession such as manufacturers, design studios, showrooms, and museums.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Sophomore Interior Design Internship Seminar",
    "dept": "ARTID",
    "num": "360",
    "desc": "Prereq: Sophomore classification in interior design program.\nProcedural and ethical concerns relating to interior design internship. Preparation of documents for internship search. Formulation of personal internship and career goals.\n",
    "credits": "1"
  },
  {
    "course_name": "Junior Interior Design Internship Seminar",
    "dept": "ARTID",
    "num": "361",
    "desc": "Prereq: junior classification in interior design program.\nProcedural and ethical concerns relating to interior design internship. Refinement of placement credentials and personal goals. Internship search process and agreements.\n",
    "credits": "1"
  },
  {
    "course_name": "Interior Design Studio III",
    "dept": "ARTID",
    "num": "365",
    "desc": "Prereq: ARTID 263, ARTID 267, and enrollment in ARTID 359\nRefined methods of problem identification design programming and problem solving, including theoretically-based concept development and refinement. Emphasis and compliance with codes and standards. Produce small and large scale projects. Alternative manual and computer-based visualization methods. Teamwork. Multi-cultural, study abroad option.\n",
    "credits": "4"
  },
  {
    "course_name": "Interior Design Studio IV",
    "dept": "ARTID",
    "num": "367",
    "desc": "Prereq: ARTID 365\nEmphasis on three-dimensional spatial development in large scale, multiple scale unit institutional projects. Inclusion of extensive design documentation. Expansion of alternative manual and computer-based visualization methods. Teamwork.\n",
    "credits": "4"
  },
  {
    "course_name": "Interior Design Studio IV: Honors",
    "dept": "ARTID",
    "num": "367H",
    "desc": "Prereq: ARTID 365\nEmphasis on three-dimensional spatial development in large scale, multiple scale unit institutional projects. Inclusion of extensive design documentation. Expansion of alternative manual and computer-based visualization methods. Teamwork.\n",
    "credits": "4"
  },
  {
    "course_name": "Senior Field Study",
    "dept": "ARTID",
    "num": "459",
    "desc": "Prereq: Enrollment in fourth year interior design studio course\nStudy and tours of areas of interest within the interior design profession such as manufacturers, design studios, showrooms and museums.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Interior Design Internship",
    "dept": "ARTID",
    "num": "460",
    "desc": "Prereq: ARTID 350, 360, and 365\nProfessional interior design off-campus experience.\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Professional Practices",
    "dept": "ARTID",
    "num": "461",
    "desc": "Prereq: ARTID 460\nOrganization and general management of the interior design office: agreements, business procedures, and professional ethics. Professional interior design issues and concerns.\n",
    "credits": "2"
  },
  {
    "course_name": "Interior Design Professional Practices: Honors",
    "dept": "ARTID",
    "num": "461H",
    "desc": "Prereq: ARTID 460\nOrganization and general management of the interior design office: agreements, business procedures, and professional ethics. Professional interior design issues and concerns.\n",
    "credits": "2"
  },
  {
    "course_name": "Environments for the Aging",
    "dept": "ARTID",
    "num": "463",
    "desc": "Prereq: HD FS 360 or 3 credits in housing, architecture, interior design, rehabilitation, psychology, or human development and family studies or permission of instructor\nEmphasis on independent living within residential settings including specialized shelter, supportive services and housing management. Application of criteria appropriate for accessibility and functional performance of activities; universal design principles. Creative project provides service learning opportunities. (on-line course offering via Distance Education).\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio V",
    "dept": "ARTID",
    "num": "465",
    "desc": "Prereq: ARTID 460, or permission of instructor, and enrollment in ARTID 459\nDesign research and refined problem solving methods including functional analysis, programming and detailing.\n",
    "credits": "4"
  },
  {
    "course_name": "Interior Design Studio VI",
    "dept": "ARTID",
    "num": "467",
    "desc": "Prereq: ARTID 465\nRefinement of technical, analytical and theoretical problem-solving methods and comprehensive design documentation. In-depth development of interior design projects. Current issues in interior design.\n",
    "credits": "4"
  },
  {
    "course_name": "Interior Design in an Urban Setting",
    "dept": "ARTID",
    "num": "468",
    "desc": "Prereq: Enrollment or credit in third year studio courses\nStudy of selected interior design projects and designers practicing in an urban setting. Studio project examining issues related to interior design in an urban context.\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Design in an Urban Setting: Honors",
    "dept": "ARTID",
    "num": "468H",
    "desc": "Prereq: Enrollment or credit in third year studio courses\nStudy of selected interior design projects and designers practicing in an urban setting. Studio project examining issues related to interior design in an urban context.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "ARTID",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed related interior design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "ARTID",
    "num": "490H",
    "desc": "Prereq: Written approval of instructor and department chair on required form in advance of semester of enrollment\nStudent must have completed related interior design coursework appropriate to planned independent study. Offered on a graded basis or a satisfactory-fail basis.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop",
    "dept": "ARTID",
    "num": "493",
    "desc": "Prereq: Evidence of satisfactory experience in area of specialization\nIntensive 2 to 4 week studio exploration. Topics vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Design Humanics",
    "dept": "ARTID",
    "num": "551",
    "desc": "Prereq: Instructor permission\nAn exploration of human nature as broadly defined and as applied to design of the built environment.  Consideration of human characteristics, responses and performance, at varying scales, as sources of design insight.  Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Humanics: Sensory Perception & Ergonomic Factors",
    "dept": "ARTID",
    "num": "551A",
    "desc": "Prereq: Instructor permission\nHuman factors\u2028 related to the nature, performance and accommodation of the individuals and small groups, including sensation and perception, physical requirements, anthropometrics, safety and other issues connecting human needs and built environmental responses.  Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Humanics: Emotional, Behavioral & Contextual Factors",
    "dept": "ARTID",
    "num": "551B",
    "desc": "Prereq: Instructor permission\nHuman factors issues related to the nature, performance and accommodation of medium to large groups and settings. Emphasis on psychological, sociological, cultural, interpersonal safety, and related human needs and built environmental responses.  Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Methods: Design Methods",
    "dept": "ARTID",
    "num": "552",
    "desc": "Prereq: Permission of instructor\nSurvey of methodologies and methodological tools for varied end uses and drawn from wide ranging sources.  Emphasis on their organization and application to design of the human environment.  Topics vary each time offered.\n",
    "credits": "2"
  },
  {
    "course_name": "Design Methods: Investigation Analysis",
    "dept": "ARTID",
    "num": "552A",
    "desc": "Prereq: Permission of instructor\nMethods of design research, analysis, programming and theory formulation.\n",
    "credits": "2"
  },
  {
    "course_name": "Design Methods: Synthesis",
    "dept": "ARTID",
    "num": "552B",
    "desc": "Prereq: Permission of instructor\nMethods of synthesizing design concepts and solutions.\n",
    "credits": "2"
  },
  {
    "course_name": "Design Methods: Communication",
    "dept": "ARTID",
    "num": "552C",
    "desc": "Prereq: Permission of instructor\nMethods of managing, translating, communicating and otherwise utilizing text, image, abstract and other forms of information.\n",
    "credits": "2"
  },
  {
    "course_name": "Design Methods: Procedural Alternatives",
    "dept": "ARTID",
    "num": "552D",
    "desc": "Prereq: Permission of instructor\nNew and specialized methodological trends, including subject or setting-specific methods.\n",
    "credits": "2"
  },
  {
    "course_name": "Interior Design Teaching Practicum",
    "dept": "ARTID",
    "num": "554",
    "desc": "Prereq: ARTID 668 and permission of instructor\nSupervised practical application of interior design theory, materials, and practice to the educational process.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Interior Design Field Study",
    "dept": "ARTID",
    "num": "559",
    "desc": "Prereq: Graduate enrollment or permission of instructor\nStudy and tours of places of interior design-related interest such as manufacturers, design studios, related professional offices, showrooms, museums, and historical sites.\n",
    "credits": "1"
  },
  {
    "course_name": "Interior Design Internship",
    "dept": "ARTID",
    "num": "560",
    "desc": "Prereq: Permission of instructor.\nProfessional interior design off-campus experience.\n",
    "credits": "3"
  },
  {
    "course_name": "Environments for the Aging",
    "dept": "ARTID",
    "num": "563",
    "desc": "Prereq: HD FS 360 or 3 credits in housing, architecture, interior design, rehabilitation, psychology, or human development and family studies or permission of instructor\nEmphasis on independent living within residential settings including specialized shelter, supportive services and housing management. Application of criteria appropriate for accessibility and functional performance of activities; universal design principles. Creative project provides service learning opportunities. (on-line course offering via Distance Education).\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Interior Design Studio V",
    "dept": "ARTID",
    "num": "565",
    "desc": "Prereq: ARTID 460, or permission of instructor, and enrollment in ARTID 459\nDesign research and refined problem solving methods including functional analysis, programming and detailing.\n",
    "credits": "4"
  },
  {
    "course_name": "Interior Design Studio VI",
    "dept": "ARTID",
    "num": "567",
    "desc": "Prereq: ARTID 465\nRefinement of technical, analytical and theoretical problem-solving methods and comprehensive design documentation. In-depth development of interior design projects. Current issues in interior design.\n",
    "credits": "4"
  },
  {
    "course_name": "Experimental Interior Design",
    "dept": "ARTID",
    "num": "568",
    "desc": "Prereq: Graduate classification and permission of instructor\nApplication of alternative design methods and sources of insight to the solution of human environmental design problems. Focus on the identification, formulation, refinement and application of theory to the design process. Emphasis on the pursuit of new discovery and innovative problem solving. Approaches, settings and scales vary each time offered.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Studies in Interior Design",
    "dept": "ARTID",
    "num": "569",
    "desc": "Prereq: Graduate classification or permission of instructor\nExamination of special issues with emphasis on their translation into design application.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Studies in Interior Design: Design Theory",
    "dept": "ARTID",
    "num": "569A",
    "desc": "Prereq: Graduate classification or permission of instructor\nExamination of special issues with emphasis on their translation into design application.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Studies in Interior Design: Advanced Color",
    "dept": "ARTID",
    "num": "569B",
    "desc": "Prereq: Graduate classification or permission of instructor\nExamination of special issues with emphasis on their translation into design application.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Studies in Interior Design: Sustainable Technology",
    "dept": "ARTID",
    "num": "569C",
    "desc": "Prereq: Graduate classification or permission of instructor\nExamination of special issues with emphasis on their translation into design application.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Studies in Interior Design: Variable Topics",
    "dept": "ARTID",
    "num": "569D",
    "desc": "Prereq: Graduate classification or permission of instructor\nExamination of special issues with emphasis on their translation into design application.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "ARTID",
    "num": "590",
    "desc": "Prereq: Bachelor's degree in interior design, or evidence of satisfactory equivalency in specialized area. Written approval of instructor and department chair on required form in advance of semester of enrollment\n",
    "credits": "arr"
  },
  {
    "course_name": "Workshop",
    "dept": "ARTID",
    "num": "593",
    "desc": "Prereq: Graduate classification; evidence of satisfactory experience in area of specialization\nIntensive 2 to 4 week studio exploration. Topics vary each time offered.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Forum",
    "dept": "ARTID",
    "num": "598",
    "desc": "Prereq: Concurrent enrollment in ARTID 565, ARTID 567, ARTID 568, ARTID ARTID 665, or ARTID 668, and permission of instructor\nPresentation and discussion of cross-disciplinary design research theory, methods, and application.  Focus on the investigation, application, and communication of types of design research.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "ARTID",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research Methods",
    "dept": "ARTID",
    "num": "660",
    "desc": "Prereq: Permission of instructor\nResearch strategies related to design. Application of selected methods to specific issues. Open to non-majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Experimental Interior Design",
    "dept": "ARTID",
    "num": "668",
    "desc": "Prereq: Graduate classification and permission of instructor.\nApplication of alternative design methods and sources of insight to the solution of human environmental design problems. Focus on the identification, formulation, refinement and application of theory to the design process. Emphasis on the pursuit of new discovery and innovative problem solving. Approaches, settings and scales vary each time offered.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "ARTID",
    "num": "690",
    "desc": "Prereq: M.F.A classification, permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Design Practicum",
    "dept": "ARTID",
    "num": "697",
    "desc": "Prereq: Approval of POS committee\nApplied, off campus, professional interior design-related experience.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "ARTID",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis",
    "dept": "ARTID",
    "num": "699A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis-Exhibition",
    "dept": "ARTID",
    "num": "699B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Interior Design Internship",
    "dept": "ARTID A",
    "num": "560",
    "desc": "Prereq: Permission of instructor.\nProfessional interior design off-campus experience.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to International Studies",
    "dept": "INTST",
    "num": "235",
    "desc": "\nOverview of international studies, emphasizing cultural, geographic, economic, and political characteristics of   major world areas and nations.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "International Experience Abroad",
    "dept": "INTST",
    "num": "295",
    "desc": "Prereq: 12 college-level credits\nSupervised instruction in an international setting, augmented by practical living experience.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in International Studies",
    "dept": "INTST",
    "num": "350",
    "desc": "\nExploration of key topics and themes in International Studies. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Interdisciplinary Study Abroad",
    "dept": "INTST",
    "num": "395",
    "desc": "\nMulti-faceted exploration of a selected world region directed at developing a comprehensive understanding of a selected culture's role in contemporary society.\n",
    "credits": "1"
  },
  {
    "course_name": "Interdisciplinary Study Abroad: Pre-Departure Seminar",
    "dept": "INTST",
    "num": "395A",
    "desc": "\nMulti-faceted exploration of a selected world region directed at developing a comprehensive understanding of a selected culture's role in contemporary society.\n",
    "credits": "1"
  },
  {
    "course_name": "Interdisciplinary Study Abroad: Humanities",
    "dept": "INTST",
    "num": "395B",
    "desc": "\nMulti-faceted exploration of a selected world region directed at developing a comprehensive understanding of a selected culture's role in contemporary society.\n",
    "credits": "1"
  },
  {
    "course_name": "Interdisciplinary Study Abroad: Communications",
    "dept": "INTST",
    "num": "395C",
    "desc": "\nMulti-faceted exploration of a selected world region directed at developing a comprehensive understanding of a selected culture's role in contemporary society.\n",
    "credits": "1"
  },
  {
    "course_name": "Interdisciplinary Study Abroad: Mathematics and Natural Science",
    "dept": "INTST",
    "num": "395D",
    "desc": "\nMulti-faceted exploration of a selected world region directed at developing a comprehensive understanding of a selected culture's role in contemporary society.\n",
    "credits": "1"
  },
  {
    "course_name": "Interdisciplinary Study Abroad: Social Sciences",
    "dept": "INTST",
    "num": "395E",
    "desc": "\nMulti-faceted exploration of a selected world region directed at developing a comprehensive understanding of a selected culture's role in contemporary society.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in International Studies",
    "dept": "INTST",
    "num": "430",
    "desc": "Prereq: INTST 235, junior classification or higher\nCapstone seminar in international studies focused on economic development, women's issues, war and ethnic conflict, population, the environment, globalization, human rights, international trade and business and other issues. Students develop a project on a subject linked to their area of professional interest or academic specialization.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "International Issues and Challenges in Sustainable Development",
    "dept": "INTST",
    "num": "446",
    "desc": "Prereq: 3-credit biology course, Sophomore or higher classification, permission of Instructor\nInterdisciplinary study and analysis of agricultural systems, sustainable management, and impact on plants and animal biodiversity. International field experience in evaluating different agricultural systems and impact on biodiversity may be required. A program fee is charged to students for international study abroad.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "INTST",
    "num": "490",
    "desc": "Prereq: Permission of International Studies director and faculty supervisor\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered or to integrate areas of study appropriate to special problems with international foci.\n  No more than 3 credits of IntSt 490 may be used in the International Studies major or minor.",
    "credits": "1"
  },
  {
    "course_name": "Experiences Abroad: Learning to Think Globally",
    "dept": "INTST",
    "num": "491",
    "desc": "Prereq: Minimum of 3 cr. of study abroad and/or internship abroad\nStudents returning from study abroad gain perspective on the personal, academic, and professional impact of their time spent abroad through readings and discussions.  Students will be expected to make one presentation about the culture they experienced to an audience outside of ISU.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Natural History Workshop",
    "dept": "IA LL",
    "num": "293",
    "desc": "\nOffered as demand warrants. Five-day-long, nontechnical introductions to a specific aspect of the natural history of the Upper Midwest or techniques for studying natural history.\n",
    "credits": "1"
  },
  {
    "course_name": "Prairies",
    "dept": "IA LL",
    "num": "293G",
    "desc": "\nOffered as demand warrants. Five-day-long, nontechnical introductions to a specific aspect of the natural history of the Upper Midwest or techniques for studying natural history.\n",
    "credits": "1"
  },
  {
    "course_name": "Plant-Animal Interactions",
    "dept": "IA LL",
    "num": "302",
    "desc": "Prereq: One course in the biological sciences\nIntroduction to ecology and co-evolution of plants and animals; emphasis on dispersal, pollination, and plant-herbivore interactions; field and laboratory work, reading, discussion.\n",
    "credits": "4"
  },
  {
    "course_name": "Undergraduate Internships",
    "dept": "IA LL",
    "num": "303I",
    "desc": "Prereq: Permission of instructor and sophomore standing\nPlacement with county conservation boards, camps, parks, etc. for experience as interpreters, rangers, and technicians.\n",
    "credits": "1"
  },
  {
    "course_name": "Ecology",
    "dept": "IA LL",
    "num": "312I",
    "desc": "\nAn introduction to the principles of ecology at the population, community and ecosystem level. Field studies of local lakes, wetlands and prairies are used to examine factors controlling distributions, interactions, and roles of plants and animals in native ecosystems.\n",
    "credits": "4"
  },
  {
    "course_name": "Ornithology",
    "dept": "IA LL",
    "num": "326I",
    "desc": "\nThe biology, ecology, and behavior of birds with emphasis on field studies of local avifauna. Group projects stress techniques of population analysis and methodology for population studies.\n",
    "credits": "2"
  },
  {
    "course_name": "Animals and Their Ecosystems",
    "dept": "IA LL",
    "num": "333",
    "desc": "Prereq: Introductory biology\nVertebrate and invertebrate animals of the Midwest are observed in nature either through passive observational techniques or active trapping exercises. Once identified, animals are placed in their proper taxonomic position (e.e., put onto the \"Tree of Life\"). They also are put into ecological perspective, including habitat pereferences (i.e., wetland, lake, prairie, forest, river, edge), trophic position, and activity patterns. Conservation status is discussed.\n",
    "credits": "4"
  },
  {
    "course_name": "Biology of Aquatic Plants",
    "dept": "IA LL",
    "num": "364",
    "desc": "\nA field-oriented introduction to the taxonomy and ecology of aquatic plants in lakes, wetlands and rivers. Individual or group projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Plant Taxonomy",
    "dept": "IA LL",
    "num": "367",
    "desc": "\nPrinciples of classification and evolution of vascular plants; taxonomic tools and collection techniques; use of keys. Field and laboratory studies emphasizing identification of local flowering plants and recognition of major plant families.\n",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Insect Ecology",
    "dept": "IA LL",
    "num": "371I",
    "desc": "\nField and laboratory study of insects, their diversity, life history; emphasis on ecology and behavior.\n",
    "credits": "4"
  },
  {
    "course_name": "Watershed Hydrology and Surficial Processes",
    "dept": "IA LL",
    "num": "402I",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nEffects of geomorphology, soils, and land use on transport of water and materials (nutrients, contaminates) in watersheds. Fieldwork will emphasize investigations of the Iowa Great Lakes watershed.\n",
    "credits": "4"
  },
  {
    "course_name": "Evolution",
    "dept": "IA LL",
    "num": "403",
    "desc": "\nMechanisms and patterns in microevolution and macroevolution. Field exercises will emphasize studies of natural selection, adaptation, genetic variation, and population genetics of local plant and animal populations.\n",
    "credits": "4"
  },
  {
    "course_name": "Behavioral Ecology",
    "dept": "IA LL",
    "num": "404I",
    "desc": "Prereq: Two semesters of biology\nAnimal coloniality, courtship, territoriality, predator defense, habitat selection, foraging, mating systems, and parental care will be examined in the field in order to evaluate various ecological and evolutionary theories of animal behavior.\n",
    "credits": "4"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "IA LL",
    "num": "408I",
    "desc": "Prereq: Courses in ecology, chemistry, and physics\nAnalysis of aquatic ecosystems; emphasis on basic ecological principles; ecological theories tested in the field; identification of common plants and animals.\n",
    "credits": "4"
  },
  {
    "course_name": "Freshwater Invertebrates",
    "dept": "IA LL",
    "num": "415",
    "desc": "Prereq: One or more ecology courses\nField-oriented introduction to the identification, life-history, and ecology of common, free-living freshwater invertebrates of north-temperate lakes, rivers, and wetlands. Emphasis on the role of invertebrates in aquatic food chains and litter processing.\n",
    "credits": "4"
  },
  {
    "course_name": "Vertebrate Ecology and Evolution",
    "dept": "IA LL",
    "num": "419I",
    "desc": "\nField and laboratory study of representative vertebrates of northwestern Iowa. Observations and experimentation emphasize ecological histories by integrating concepts of functional morphology, behavioral ecology, and evolutionary biology.\n",
    "credits": "4"
  },
  {
    "course_name": "Amphibians and Reptiles",
    "dept": "IA LL",
    "num": "420I",
    "desc": "Prereq: Two semesters of biology\nEcology, behavior, and conservation biology of amphibians and reptiles with emphasis on their anatomy and morphology; temperature and water regulation; locomotion; life history; reproduction; population and community ecology; and conservation.\n",
    "credits": "2"
  },
  {
    "course_name": "Prairie Ecology",
    "dept": "IA LL",
    "num": "422I",
    "desc": "Prereq: Familiarity with basic principles in biological sciences and ecology\nBasic patterns and underlying physical and biotic causes of both regional and local distributions of plants and animals of North American prairies; field and laboratory analyses and projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Aquatic Toxicology and Wetland Dynamics in Freshwater Systems",
    "dept": "IA LL",
    "num": "425I",
    "desc": "Prereq: Introductory biology course and general chemistry course\nFundamental knowledge and understanding of the scientific concepts related to the physio-chemical and biological environment. Problems and issues (global, national, regional, and local) associated with freshwater systems and how wetland restoration can be used to ameliorate problems. Discussion and application of basic tools used to assess aquatic toxicological problems.\n",
    "credits": "2"
  },
  {
    "course_name": "Field Archaeology",
    "dept": "IA LL",
    "num": "427I",
    "desc": "\nNature of cultural and environmental evidence in archaeology and how they are used to model past human behavior and land use; emphasis on Iowa prehistory; basic reconnaissance surveying and excavation techniques.\n",
    "credits": "4"
  },
  {
    "course_name": "Illustrating Nature I Sketching",
    "dept": "IA LL",
    "num": "435I",
    "desc": "\nSketching plants, animals and terrain. Visual communication, development of a personal style, and integration of typographic and visual elements on a page will be emphasized.\n",
    "credits": "2"
  },
  {
    "course_name": "Illustrating Nature II Photography",
    "dept": "IA LL",
    "num": "436I",
    "desc": "\nBeginning to intermediate technical and compositional aspects of color photography of natural areas and their plants and animals.\n",
    "credits": "2"
  },
  {
    "course_name": "Topics in Ecology and Sustainability",
    "dept": "IA LL",
    "num": "450",
    "desc": "Prereq: general biology course\nScientific introduction to ecology and evolution of important groups of organisms: algae to vertebrates, different ecological phenomena (e.g., fire and climate change), varying landforms, different ecosystems (e.g., prairies and aquatic systems); emphasis on sustainability with introduction to concepts, issues, and practices; ability to communicate environmental information through a variety of means.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to GIS",
    "dept": "IA LL",
    "num": "461I",
    "desc": "\nDescriptive and predictive GIS modeling techniques, spatial statistics, and map algebra. Application of GIS   modeling techniques to environmental planning and resource management.\n",
    "credits": "4"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "IA LL",
    "num": "463I",
    "desc": "Prereq: AGRON 182 (or equivalent)\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use.\n  Credit for only Agron 563 or 563I may be applied for graduation.",
    "credits": "2"
  },
  {
    "course_name": "Ecology and Systematics of Diatoms",
    "dept": "IA LL",
    "num": "480I",
    "desc": "\nField and laboratory study of freshwater diatoms; techniques in collection, preparation, and identification of diatom samples; study of environmental factors affecting growth, distribution, taxonomic characters; project design and execution including construction of reference and voucher collections and data organization and analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "Plant Ecology",
    "dept": "IA LL",
    "num": "484",
    "desc": "\nPrinciples of plant population, community, and ecosystem ecology illustrated through studies of native   vegetation in local prairies, wetlands and forests. Group or individual projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Iowa Lakeside Laboratory",
    "dept": "IA LL",
    "num": "490I",
    "desc": "Prereq: 8 credits in biology and permission of instructor\nResearch opportunities for undergraduate students in the biological sciences.\n  No more than 9 credits in Biol 490 may be counted toward graduation and of those, only 6 credits may be applied to the major.",
    "credits": "1"
  },
  {
    "course_name": "Natural History Workshop",
    "dept": "IA LL",
    "num": "493",
    "desc": "\nOffered as demand warrants. Five day-long, non-technical introductions to a specific aspect of the natural   history of the Upper Midwest or techniques for studying natural history.\n",
    "credits": "1"
  },
  {
    "course_name": "Ecosystems of North America",
    "dept": "IA LL",
    "num": "494",
    "desc": "Prereq: A general ecology course and permission of the instructor\nAn extended field trip to study a particular type of ecosystem (prairie, coastal wetland, forest, alpine, coral reefs,   etc.) or the ecosystems of a specific region (Rocky Mountains, Gulf Coast, Appalachian Mountains, Deserts of   the Southwest, Central America, etc.). Prior to the field trip, there will be an orientation period and after each   field trip a review and synthesis period. A field trip fee will be assessed to cover travel expenses.\n",
    "credits": "2"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "IA LL",
    "num": "499",
    "desc": "Prereq: Junior or senior classification and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Freshwater Algae",
    "dept": "IA LL",
    "num": "501",
    "desc": "\nStructure and taxonomy of freshwater algae based on field collected material; emphasis on genus-level identifications, habitats visited include lakes, fens, streams, and rivers; algal ecology.\n",
    "credits": "4"
  },
  {
    "course_name": "Graduate Internships",
    "dept": "IA LL",
    "num": "503",
    "desc": "Prereq: Permission of instructor and graduate standing\nPlacement with county conservation boards, camps, parks, schools, etc. for experience as interpreters, rangers,   technicians, and teachers.\n",
    "credits": "1"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "IA LL",
    "num": "508I",
    "desc": "Prereq: Courses in ecology, chemistry, and physics\nAnalysis of aquatic ecosystems; emphasis on basic ecological principles; ecological theories tested in the field; identification of common plants and animals.\n",
    "credits": "4"
  },
  {
    "course_name": "Fish Ecology",
    "dept": "IA LL",
    "num": "523I",
    "desc": "\nBasic principles of fish interaction with the biotic and abiotic environment. Field methods, taxonomy, and biology of fish with emphasis on the fish fauna of northwestern Iowa.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Field Ornithology",
    "dept": "IA LL",
    "num": "526I",
    "desc": "Prereq: Concurrent registration in IA LL 326I\nField study of birds of the upper Midwest; extended field trip to Minnesota and Wisconsin; individual or group project.\n",
    "credits": "2"
  },
  {
    "course_name": "Conservation Biology",
    "dept": "IA LL",
    "num": "531I",
    "desc": "Prereq: IA LL 312I\nPopulation-and community-level examination of factors influencing the viability of plant and animal populations from both demographic and genetic perspectives; assessment of biodiversity; design and management of preserves.\n",
    "credits": "4"
  },
  {
    "course_name": "Analysis of Environmental Data",
    "dept": "IA LL",
    "num": "532",
    "desc": "Prereq: An undergraduate course in statistics, understanding of basic concepts such as correlation and regression, and   familiarity with PC-based software for data analysis\nAnalysis of Environmental Data will provide students with training in the theory and application of a range of   statistical techniques useful for the analysis of ecological and paleoecological data. Topics will include data   management, exploratory data analysis, regression analysis, direct and indirect ordination methods,   classification techniques, transfer functions and the analysis of temporal data. Practical classes will provide   hands-on training in the use of statistical and graphical software including R, CANOCO, C2, and TWINSPAN.   The course will be directed towards advanced undergraduate, graduate and working professionals in ecology   and paleoecology.\n",
    "credits": "2"
  },
  {
    "course_name": "Restoration Ecology",
    "dept": "IA LL",
    "num": "535I",
    "desc": "Prereq: A course in ecology\nEcological principles for the restoration of native ecosystems; establishment (site preparation, selection of seed   mixes, planting techniques) and management (fire, mowing, weed control) of native vegetation; evaluation of restorations. Emphasis on the restoration of prairie and wetland vegetation.\n",
    "credits": "4"
  },
  {
    "course_name": "Topics in Ecology and Sustainability",
    "dept": "IA LL",
    "num": "550",
    "desc": "Prereq: general biology course\nScientific introduction to ecology and evolution of important groups of organisms: algae to vertebrates, different ecological phenomena (e.g., fire and climate change), varying landforms, different ecosystems (e.g., prairies and aquatic systems); emphasis on sustainability with introduction to concepts, issues, and practices; ability to communicate environmental information through a variety of means.\n",
    "credits": "1"
  },
  {
    "course_name": "Soil Formation and Landscape Relationships",
    "dept": "IA LL",
    "num": "563I",
    "desc": "Prereq: AGRON 182 (or equivalent)\nRelationships between soil formation, geomorphology, and environment. Soil description, classification, geography, mapping, and interpretation for land use.\n  Credit for only Agron 563 or 563I may be applied for graduation.",
    "credits": "2"
  },
  {
    "course_name": "Wetland Ecology",
    "dept": "IA LL",
    "num": "564I",
    "desc": "Prereq: IA LL 312I\nEcology, classification, creation, restoration, and management of wetlands. Field studies will examine the composition, structure and functions of local natural wetlands and restored prairie pothole wetlands. Individual or group projects.\n",
    "credits": "4"
  },
  {
    "course_name": "Techniques for Biology Teaching",
    "dept": "IA LL",
    "num": "573",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching : Animal Biology",
    "dept": "IA LL",
    "num": "573A",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Plant Biology",
    "dept": "IA LL",
    "num": "573B",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Fungi and Lichens",
    "dept": "IA LL",
    "num": "573C",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Aquatic Ecology",
    "dept": "IA LL",
    "num": "573D",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Prairie Ecology",
    "dept": "IA LL",
    "num": "573E",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Wetland Ecology",
    "dept": "IA LL",
    "num": "573F",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Limnology",
    "dept": "IA LL",
    "num": "573G",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Animal Behavior",
    "dept": "IA LL",
    "num": "573H",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Insect Ecology",
    "dept": "IA LL",
    "num": "573I",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Biology of Invertebrates",
    "dept": "IA LL",
    "num": "573J",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Non-invasive Use of Living Organisms",
    "dept": "IA LL",
    "num": "573K",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Techniques for Biology Teaching: Project WET",
    "dept": "IA LL",
    "num": "573W",
    "desc": "\nThe development and implementation of laboratory exercises suitable for inclusion in elementary, middle, high school, and community college biology and environmental courses. Exercises will be built around common organisms and ecosystems in Iowa. Field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Field Mycology",
    "dept": "IA LL",
    "num": "575I",
    "desc": "\nIdentification and classification of the common fungi; techniques for identification, preservation, and culture practiced with members of the various fungi groups.\n",
    "credits": "4"
  },
  {
    "course_name": "Ecology and Systematics of Diatoms",
    "dept": "IA LL",
    "num": "580I",
    "desc": "\nField and laboratory study of freshwater diatoms; techniques in collection, preparation, and identification of diatom samples; study of environmental factors affecting growth, distribution, taxonomic characters; project design and execution including construction of reference and voucher collections and data organization and analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "Graduate Independent Study",
    "dept": "IA LL",
    "num": "590",
    "desc": "Prereq: Graduate classification and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Graduate Independent Study",
    "dept": "IA LL",
    "num": "590I",
    "desc": "Prereq: Graduate classification and permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Natural History Workshop",
    "dept": "IA LL",
    "num": "593",
    "desc": "Prereq: Permission of instructor\nGraduate workshop on some aspect of the natural history of the Upper Midwest or on techniques for studying   natural history.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "IA LL",
    "num": "699I",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Intensive Beginning Italian",
    "dept": "ITAL",
    "num": "107",
    "desc": "\nA communicative approach to grammar and vocabulary within the context of Italian culture for students whose native language is not Italian. Taught in Italian.\n",
    "credits": "4"
  },
  {
    "course_name": "Mass Media and Society",
    "dept": "JL MC",
    "num": "101",
    "desc": "\nCommunication theory models and their application to the mass media; the mass communication process; organization, characteristics and responsibilities of the mass media; media literacy process.\n",
    "credits": "3"
  },
  {
    "course_name": "Orientation to Journalism and Communication",
    "dept": "JL MC",
    "num": "110",
    "desc": "\nOrientation to professional and pre-professional opportunities, writing for the mass media and curriculum requirements in the Greenlee School. Basic media writing preparation.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Reporting and Writing for the Mass Media",
    "dept": "JL MC",
    "num": "201",
    "desc": "Prereq: Greenlee majors only or departmental permission. Must pass departmental assessment exam in language skills before registering; ENGL 250; credit or concurrent enrollment in JL MC 110.\nGenerating story ideas, exercising news judgment and gathering information via interviews, observation and documentary sources to produce news and informational material for the mass media. Emphasis on analyzing and organizing information, as well as accuracy and principles of good writing. Use of AP Style.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Journalism",
    "dept": "JL MC",
    "num": "240",
    "desc": "\nAnalysis of journalism industry and specific audiences served by print, electronic, visual and digital media. Introduction to core values of journalism and guiding principles that encompass literacy, ethics, law, history, the economy and cultural and societal implications.\n",
    "credits": "3"
  },
  {
    "course_name": "Visual Principles for Mass Communicators",
    "dept": "JL MC",
    "num": "242",
    "desc": "\nUnderstanding and analysis of the visual message. Visual perception, visual communication theory, design syntax, design elements and how they are applied in mass communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Reporting and Writing for the Mass Media",
    "dept": "JL MC",
    "num": "302",
    "desc": "Prereq: JL MC 110 and Minimum of C+ in JL MC 201\nResearching, organizing and writing for newspapers, magazines and digital media. Enhancing and refining skills in developing sources and generating story ideas. Information-gathering techniques, reporting and writing.\n",
    "credits": "3"
  },
  {
    "course_name": "Reporting and Writing for Broadcast Media",
    "dept": "JL MC",
    "num": "303",
    "desc": "Prereq: JL MC 110 and Minimum of C+ in JL MC 201\nResearching, organizing, and writing for radio, television and digital media. Basic principles of news programming and storytelling across broadcast media platforms. An emphasis on development, content and structure.\n",
    "credits": "3"
  },
  {
    "course_name": "Broadcast Media Production",
    "dept": "JL MC",
    "num": "306",
    "desc": "Prereq: Minimum of C+ in JL MC 201\nIntroduction to studio production using professional equipment. Course focus on visual concepts, maintenance and practical operation of studio equipment.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Video Production",
    "dept": "JL MC",
    "num": "307",
    "desc": "\nCreation of video productions for use as communication tools in advertising, promotions, short documentaries and public relations. Technical and artistic fundamentals of video production including planning, scripting, shooting, lighting and digital editing.\n",
    "credits": "3"
  },
  {
    "course_name": "Broadcast News Gathering and Production",
    "dept": "JL MC",
    "num": "308",
    "desc": "Prereq: Minimum of C+ in JL MC 201.\nField techniques in single-camera video production used to shoot and edit visual stories. Introduction to broadcast news gathering.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Photojournalism",
    "dept": "JL MC",
    "num": "310",
    "desc": "Prereq: Minimum of C+ in JL MC 201\nBasic photojournalism techniques. Includes camera operation, lighting, composition and photo reproduction techniques for print or computer-mediated applications. Emphasis on using the camera as a reporting tool. Basic use of digital imaging and editing software. Ethical issues involving photojournalism. A digital SLR camera is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Techniques in Photojournalism",
    "dept": "JL MC",
    "num": "312",
    "desc": "Prereq: JL MC 310 or permission of instructor\nAdvanced techniques and problem solving, both ethical and technical, for photographers who seek to be members of newsgathering teams. Photographic storytelling using a combination of audio and still photography techniques to report stories for print and web publications. Hands on experience with latest digital imaging technology. A digital SLR camera is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Multimedia Production",
    "dept": "JL MC",
    "num": "315",
    "desc": "Prereq: JL MC 308 or JL MC 310 or JL MC 316 or equivalent computer design proficiency\nVisual storytelling concepts and principles for evaluating, constructing and designing information for the Web and other electronic publication systems. Issues of ethics and ownership of work pertinent to the new media.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Digital Publishing",
    "dept": "JL MC",
    "num": "316",
    "desc": "Prereq: Credit or enrollment in JL MC 242 and C+ or better in JL MC 201\nDigital publishing and beginning techniques in layout, photo editing and vector artwork. Application of visual principles to design print projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Publishing for Mobile Devices",
    "dept": "JL MC",
    "num": "317",
    "desc": "Prereq: JL MC 316 or equivalent computer design proficiency and JL MC 310 or 315.\nCreating, designing and publishing content for mobile devices (e.g., cell phones and tablets). Use of digital publishing tools (e.g., In Design). Exposure to animation and video editing software.\n",
    "credits": "3"
  },
  {
    "course_name": "Feature Writing",
    "dept": "JL MC",
    "num": "344",
    "desc": "Prereq: Minimum of C+ in JL MC 302, JL MC 303 or P R 321\nReporting and writing short- and long- form stories for magazines, newspapers, corporate communication and the Web. Focus on departmental stories, personal essays, trend or conflict articles and personality profiles. Emphasis on immersion reporting.\n  Majors may not apply both 344 and Engl 303 toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Public Affairs Reporting",
    "dept": "JL MC",
    "num": "346",
    "desc": "Prereq: Minimum of C+ in JL MC 302, JL MC 303 or P R 321\nReporting and writing about government, business, and other institutions; identification of and access to public records; investigative reporting techniques; developing major stories about government and nonprofit organizations; and ethical issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Science Communication",
    "dept": "JL MC",
    "num": "347",
    "desc": "Prereq: Graduate classification for JL MC 547. JL MC 347: C+ or better in JL MC 302, JL MC 303 or P R 321. Nonmajors and minors by permission of instructor.\nReporting and writing about science and technology topics for general audiences. Outlets for stories include print, broadcast and online media. Story topics include reporting about basic, applied and social sciences, as well as ethical, political and policy issues related to science and technology.\n",
    "credits": "3"
  },
  {
    "course_name": "News and Feature Editing",
    "dept": "JL MC",
    "num": "349",
    "desc": "Prereq: Minimum of C+ in JL MC 302, JL MC 303 or P R 321\nEditing content for multiple platforms, including websites, magazines, newspapers, and newsletters. Adapting material for audiences, including selection and organization of text and visuals, grammar, punctuation, usage, logic and accuracy. Designing print and online layouts. Using search engine optimization and social media to promote content.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Electronic Media Production",
    "dept": "JL MC",
    "num": "354",
    "desc": "Prereq: JL MC 206.\nApplication of advanced television techniques: writing, producing, and managing live and recorded information programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Skills Development",
    "dept": "JL MC",
    "num": "390",
    "desc": "Prereq: Minimum of C+ in JL MC 201; other vary by topic. Instructor permission for non-majors.\nCheck with Greenlee School for course availability.\n",
    "credits": "1"
  },
  {
    "course_name": "Mass Communication Theory",
    "dept": "JL MC",
    "num": "401",
    "desc": "Prereq: Junior classification\nTheory and research in mass communication processes and effects; the scientific process; methods of measuring, evaluating and reporting mass communication research.\n",
    "credits": "3"
  },
  {
    "course_name": "Media Management",
    "dept": "JL MC",
    "num": "406",
    "desc": "Prereq: Graduate classification or instructor permission.\nDecision-making functions of media. Basic media market analysis, media organization and management, circulation and audience development, technological developments affecting management decisions, and relationships with labor and regulatory agencies that affect media operations.\n",
    "credits": "3"
  },
  {
    "course_name": "Law of Mass Communication",
    "dept": "JL MC",
    "num": "460",
    "desc": "Prereq: JL MC 110 and minimum of C+ in JL MC 201; junior classification. Nonmajors by permission of department.\nFirst Amendment law, libel, privacy, obscenity, contempt, copyright, trademark, the Federal Communications Act; laws affecting advertising, legal publication, and other business activities of the media.\n",
    "credits": "3"
  },
  {
    "course_name": "History of American Journalism",
    "dept": "JL MC",
    "num": "461",
    "desc": "Prereq: Junior classification\nRole of the mass media, including advertising and public relations, in shaping the social, economic and political history of America; impact of change in these areas on the development, traditions and philosophies of the media.\n",
    "credits": "3"
  },
  {
    "course_name": "Media Ethics, Freedom, Responsibility",
    "dept": "JL MC",
    "num": "462",
    "desc": "Prereq: JL MC 110 and minimum of C+ in JL MC 201. Greenlee majors only.\nEthics and professionalism in the practice of journalism, public relations and advertising.\n",
    "credits": "3"
  },
  {
    "course_name": "Journalism and Literature",
    "dept": "JL MC",
    "num": "464",
    "desc": "Prereq: Junior classification\nA study of journalism's impact on literary writing and literature's impact on journalism, as seen through the works of esteemed American author-journalists.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication Technology and Social Change",
    "dept": "JL MC",
    "num": "474",
    "desc": "Prereq: Junior classification\nExamination of historical and current communication technologies, including how they shape and are shaped by the cultural and social practices into which they are introduced.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "World Communication Systems",
    "dept": "JL MC",
    "num": "476",
    "desc": "Prereq: JL MC 476: Junior Classification. JL MC 576: Graduate classification or instructor permission.\nWorld communication systems and social, political, and economic factors determining flow, character, and volume of news. Impact of media information, advertising and public relations on nations and societies. Comparative analysis of role and impact of traditional modes of communication, the mass media and computer-mediated systems.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Diversity in the Media",
    "dept": "JL MC",
    "num": "477",
    "desc": "Prereq: Junior classification\nPortrayals of ethnic groups, gender, sexual orientation and social class in the media in news, advertising, information and entertainment; the effects of mass media on social issues and population groups.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Communication",
    "dept": "JL MC",
    "num": "490",
    "desc": "Prereq: Junior classification and contract with supervising professor to register\nProjects during which students may study problems associated with a medium, a professional specialization, a philosophical or practical concern, a reportorial method or writing technique, or a special topic in their field. Credit is not given for working on student or professional media without an accompanying research component.\n  No more than 3 credits of ADVRT/JLMC/PR 490 may be used toward a degree in the Greenlee School.",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics in Communication",
    "dept": "JL MC",
    "num": "497",
    "desc": "Prereq: Junior classification. See Schedule of Classes for possible pre-requisites.\nSeminars or one-time classes on topics of relevance to students in communication.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Media Internship",
    "dept": "JL MC",
    "num": "499",
    "desc": "Prereq: JL MC majors: JLMC 110 and minimum of C+ in JL MC 302 or JL MC 306; ADVRT majors: JLMC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JLMC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nRequired of all Greenlee School majors. A 400-hour (for 3 credits) internship in the student's journalism and mass communication or advertising or public relations specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Media Internship: Required",
    "dept": "JL MC",
    "num": "499A",
    "desc": "Prereq: JL MC majors: JLMC 110 and minimum of C+ in JL MC 302 or JL MC 306; ADVRT majors: JLMC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JLMC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nInitial, required internship. A 400-hour (for 3 credits) internship in the student's specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Professional Media Internship: Optional",
    "dept": "JL MC",
    "num": "499B",
    "desc": "Prereq: JL MC majors: JLMC 110 and minimum of C+ in JL MC 302 or JL MC 306; ADVRT majors: JLMC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JLMC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nOptional internship in the student's specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Theories of Mass Communication",
    "dept": "JL MC",
    "num": "501",
    "desc": "Prereq: Graduate classification or instructor permission.\nHistorical overview of mass communication theories. Examination of major areas of research activity and theoretical development related to organization, functions, and effects of mass communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Communication Research Methods",
    "dept": "JL MC",
    "num": "502",
    "desc": "Prereq: JL MC 501 or concurrent enrollment.\nResearch methods in journalism and mass communication, including problem selection, sampling, hypothesis formulation, research design, data collection and analysis. Designing a research strategy appropriate for a variety of communication-related questions and assessing the appropriateness, validity, and generalizability of research results.\n",
    "credits": "3"
  },
  {
    "course_name": "Media Management",
    "dept": "JL MC",
    "num": "506",
    "desc": "Prereq: Graduate classification or instructor permission.\nDecision-making functions of media. Basic media market analysis, media organization and management, circulation and audience development, technological developments affecting management decisions, and relationships with labor and regulatory agencies that affect media operations.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategies of Communication",
    "dept": "JL MC",
    "num": "510",
    "desc": "Prereq: JL MC 501\nThe process of developing professional communication and persuasion strategies, with emphasis on problem definition, behavioral objectives, situation analysis, strategy formulation, and justification through application of communication theories and research.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Relations Theory and Methods",
    "dept": "JL MC",
    "num": "520",
    "desc": "Prereq: Graduate classification or instructor permission.\nOverview of dominant theories and research methods applied to the study and practice of public relations.\n",
    "credits": "3"
  },
  {
    "course_name": "Theories of  Visual Communication",
    "dept": "JL MC",
    "num": "521",
    "desc": "Prereq: Graduate classification or instructor permission.\nExplores the theoretical frameworks in visual communication, including concepts of perception, visual language, visual persuasion, and the social, political and cultural implications of the use of images. Understanding the function of images in changing knowledge, attitudes and behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Science Communication",
    "dept": "JL MC",
    "num": "547",
    "desc": "Prereq: Graduate classification for JL MC 547. JL MC 347: C+ or better in JL MC 302, JL MC 303 or P R 321. Nonmajors and minors by permission of instructor.\nReporting and writing about science and technology topics for general audiences. Outlets for stories include print, broadcast and online media. Story topics include reporting about basic, applied and social sciences, as well as ethical, political and policy issues related to science and technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Risk Perception and Communication",
    "dept": "JL MC",
    "num": "560",
    "desc": "Prereq: Graduate classification or instructor permission.\nStudy of risk communication principles, models and theories applicable to any risk communication situation. Emphasis on science, technology and risk issues, such as food, health, agriculture and the environment. Examines roles of scientists and communicators in cultivating a public informed about scientific and technological issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Media and Society: Interrelationships",
    "dept": "JL MC",
    "num": "561",
    "desc": "Prereq: Graduate classification or instructor permission.\nMedia roles and functions in society including interrelationships between the media and a variety of social actors and forces. Theories and practices regarding social networking and communication via social media; influence of social media and social networking.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication Technologies and Social Change",
    "dept": "JL MC",
    "num": "574",
    "desc": "Prereq: Graduate classification or instructor permission.\nPersonal, organizational, and social implications of the use of communication technologies. Includes theories and empirical research across the continuum of perspectives, from techno-utopianism through an anti-technology stance.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "World Communication Systems",
    "dept": "JL MC",
    "num": "576",
    "desc": "Prereq: JL MC 476: Junior Classification. JL MC 576: Graduate classification or instructor permission.\nWorld communication systems and social, political, and economic factors determining flow, character, and volume of news. Impact of media information, advertising and public relations on nations and societies. Comparative analysis of role and impact of traditional modes of communication, the mass media and computer-mediated systems.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "JL MC",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Media Studies",
    "dept": "JL MC",
    "num": "590A",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Professional Specialization",
    "dept": "JL MC",
    "num": "590B",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Research Problems and Methods",
    "dept": "JL MC",
    "num": "590C",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Technique and Style",
    "dept": "JL MC",
    "num": "590D",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Specialized Communication",
    "dept": "JL MC",
    "num": "590E",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Professional Internship",
    "dept": "JL MC",
    "num": "591",
    "desc": "Prereq: Permission of instructor\nSupervised internship experience.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Graduate Study in Journalism and Mass Communication",
    "dept": "JL MC",
    "num": "592",
    "desc": "Prereq: Graduate classification in JL MC.\nOverview of advanced study in journalism and mass communication with special emphasis on requirements for obtaining the master of science degree.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication",
    "dept": "JL MC",
    "num": "598",
    "desc": "Prereq: graduate classification or instructor permission.\nSeminar in Mass Communication.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Audiences and Effects",
    "dept": "JL MC",
    "num": "598A",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Communication Technology",
    "dept": "JL MC",
    "num": "598B",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Professional Communication",
    "dept": "JL MC",
    "num": "598C",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Development Communication",
    "dept": "JL MC",
    "num": "598D",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Evaluation Methods",
    "dept": "JL MC",
    "num": "598E",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: International Communication",
    "dept": "JL MC",
    "num": "598F",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Mass Communication History",
    "dept": "JL MC",
    "num": "598G",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Mass Communication Law",
    "dept": "JL MC",
    "num": "598H",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Media Management",
    "dept": "JL MC",
    "num": "598I",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Research Methods",
    "dept": "JL MC",
    "num": "598J",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Society and Mass Communication",
    "dept": "JL MC",
    "num": "598K",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Journalism and Mass Communication Education",
    "dept": "JL MC",
    "num": "598L",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Visual Communication",
    "dept": "JL MC",
    "num": "598M",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Broadcast Communication",
    "dept": "JL MC",
    "num": "598N",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Communication Theory",
    "dept": "JL MC",
    "num": "598O",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Computer Mediated Communication",
    "dept": "JL MC",
    "num": "598P",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminars in Mass Communication: Science, Technology and Risk Communication.",
    "dept": "JL MC",
    "num": "598Q",
    "desc": "Prereq: Graduate classification or instructor permission.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "JL MC",
    "num": "599",
    "desc": "Prereq: Approved creative component proposal\n",
    "credits": "arr"
  },
  {
    "course_name": "Thesis Research",
    "dept": "JL MC",
    "num": "699",
    "desc": "Prereq: Approved thesis proposal\n",
    "credits": "arr"
  },
  {
    "course_name": "Swimming I",
    "dept": "KIN",
    "num": "101",
    "desc": "\nBasic course for nonswimmers. Emphasis on two fundamental strokes and personal water safety skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Swimming II",
    "dept": "KIN",
    "num": "102",
    "desc": "Prereq: KIN 101 or equivalent skill\nIntermediate course. Emphasis on learning and improving five basic strokes and personal water safety skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Aquatic Fitness",
    "dept": "KIN",
    "num": "108",
    "desc": "Prereq: KIN 102 or equivalent skill\nWater related exercises, activities, and swimming workouts to improve physical fitness.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Badminton",
    "dept": "KIN",
    "num": "122",
    "desc": "\nIntroduction to fundamental badminton skills and strategic game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Bowling",
    "dept": "KIN",
    "num": "129",
    "desc": "\nIntroduction to bowling skills and strategic game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Golf",
    "dept": "KIN",
    "num": "135",
    "desc": "\nIntroduction to fundamental golf skills and strategic game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Racquetball",
    "dept": "KIN",
    "num": "144",
    "desc": "\nIntroduction to fundamental racquetball skills and strategic game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Ice Skating",
    "dept": "KIN",
    "num": "153",
    "desc": "\nIntroduction to fundamental ice skating skills and strategic game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Tennis",
    "dept": "KIN",
    "num": "158",
    "desc": "\nIntroduction to basic skills (forehand, backhand, service) and basic knowledge of game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Physical Fitness",
    "dept": "KIN",
    "num": "163",
    "desc": "\nEvaluation of fitness status. Exercises, activities, and programs to improve physical fitness. Improve physical fitness and weight control.\n  Offered on a satisfactory-fail basis only.  Credit for only KIN 163 or 258 may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Walking for Fitness",
    "dept": "KIN",
    "num": "164",
    "desc": "\nFitness walking as an activity to improve health and fitness; values of this type of activity as a lifetime endeavor with knowledge and usage of pedometers.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Running for Fitness",
    "dept": "KIN",
    "num": "165",
    "desc": "\nRunning as a physical activity to improve physical fitness and health.  Promotion of this activity as a lifetime endeavor.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Weight Training",
    "dept": "KIN",
    "num": "166",
    "desc": "\nIntroduction to fundamental skills of weight training and strategic game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Judo",
    "dept": "KIN",
    "num": "168",
    "desc": "\nFundamentals of self defense, focusing on throwing with the hands, hips and feet as well as applying pins, chokes and arm-bars.  The physical skills will be taught focused on training through development of courtesy, integrity, perseverance, self control, & indomitable spirit.  Emphasis on learning a way of life that promotes personal development, physical health and citizenship.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Tae Kwon Do/Karate I",
    "dept": "KIN",
    "num": "170",
    "desc": "\nTeaches fundamentals of self-defense, focusing on hand and foot striking and blocking techniques.  The physical skills will be taught focused on training through development of courtesy, integrity, perseverance, self-control and indomitable spirit.  It will be emphasized that each student learns a way of life that promotes personal development, physical health and citizenship.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Tae Kwon Do/Karate II",
    "dept": "KIN",
    "num": "171",
    "desc": "\nTeaches advanced application of self-defense focusing on hand and foot striking and blocking techniques.  The physical skills will be taught focused on training through development of courtesy, integrity, perseverance, self-control and indomitable spirit.  It will be emphasized that each student learns a way of life that promotes personal development, physical health and citizenship.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Hap Ki Do/Martial Self-Defense",
    "dept": "KIN",
    "num": "173",
    "desc": "\nTeaches fundamentals of self-defense focusing on joint locks, pressure points and throwing techniques to escape from an attacker.  The physical skills will be taught focused on training through development of courtesy, integrity, perseverance, self-control and indomitable spirit.  It will be emphasized that each student learns a way of life that promotes personal development, physical health & citizenship.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Volleyball",
    "dept": "KIN",
    "num": "182",
    "desc": "\nIntroduction to fundamental volleyball skills and strategic game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Soccer",
    "dept": "KIN",
    "num": "185",
    "desc": "\nIntroduction to fundamental soccer skills and strategic game play.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Concepts of Fitness and Wellness",
    "dept": "KIN",
    "num": "210",
    "desc": "\nCoverage of behavioral skills needed to adopt and maintain lifestyles conducive to fitness and wellness.  Provides students with knowledge and skills needed to adopt and maintain healthy lifestyles.  Includes self-assessments and content on physical activity, nutrition, weight control, stress management and other lifestyle behaviors related to health.  For non-kinesiology majors.\n",
    "credits": "2"
  },
  {
    "course_name": "Building Comprehensive School Physical Activity Programs",
    "dept": "KIN",
    "num": "214",
    "desc": "Prereq: Freshman Classification\nService learning with practical experience in school research focused on promoting physical activity and wellness in youth.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of  Tumbling and Gymnastics",
    "dept": "KIN",
    "num": "231",
    "desc": "Prereq: Eligibility for admission to KIN teacher education program\nFundamentals of tumbling and gymnastics apparatus. Skill enhancement, analysis, understanding practice and the development of progressions.\n",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Team Sports",
    "dept": "KIN",
    "num": "232",
    "desc": "Prereq: Eligibility for admission to KIN teacher education program\nFundamentals of indoor and outdoor team sports, for example basketball, volleyball, flag football, and soccer. Skill enhancement, analysis, understanding practice and the development of progressions.\n",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Individual Sports and Fitness",
    "dept": "KIN",
    "num": "236",
    "desc": "Prereq: Eligibility for admission to KIN teacher education program\nFundamentals of individual sports and fitness, for example disc golf, bowling, badminton, and weight training. Skill enhancement, analysis, understanding practice and the development of progressions.\n",
    "credits": "1"
  },
  {
    "course_name": "Planning for Success in a Health Career",
    "dept": "KIN",
    "num": "242",
    "desc": "Prereq: KIN H major in PHP option with sophomore status or above.\nExploration of various health fields to clarify career goals and prepare a parallel career plan outside of medicine.  Facilitate preparation of relevant materials for professional and graduate school admission.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Disciplines and Professions in Kinesiology and Health",
    "dept": "KIN",
    "num": "252",
    "desc": "\nOverview of the various disciplines and professions that comprise the field of Kinesiology (the study of human movement) and help students determine the career option that best fits their interests.\n",
    "credits": "1"
  },
  {
    "course_name": "Orientation and Learning Community in Kinesiology and Health",
    "dept": "KIN",
    "num": "253",
    "desc": "Prereq: Concurrent enrollment or credit in KIN 252\nOverview of ISU policies and procedures, academic advising operations, degree requirements, program of study planning, and campus resources.  Students will have out-of-class activities and work with faculty, staff and mentors to explore careers in Kinesiology and complete assignments related to identification & development of their skills and interests.  Department of Kinesiology students only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Physical Fitness and Conditioning",
    "dept": "KIN",
    "num": "258",
    "desc": "\nIntroduction to five components of fitness: cardiorespiratory, muscular strength, muscular endurance, flexibility, and body composition. Students will be introduced to basic exercise prescription and evaluation principles, develop skills to assess each component of fitness, and learn different exercise modalities to enhance each component.\n  Credit for only one of the following courses may be applied toward graduation: KIN 163, 258.",
    "credits": "2"
  },
  {
    "course_name": "Leadership Techniques for Fitness Programs",
    "dept": "KIN",
    "num": "259",
    "desc": "Prereq: KIN 258\nDevelopment of exercise leadership skills for a variety of activities.  Includes planning, promotion, and teaching techniques for developing fitness in others using a variety of exercise modalities including group fitness and weight training.  Kinesiology and health majors only.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Strength Training and Conditioning",
    "dept": "KIN",
    "num": "266",
    "desc": "Prereq: KIN 258\nThis course is designed to enhance the student's current level of knowledge and expertise to an advanced level in the area of strength training and conditioning.  The course will prepare students interested in taking the National Strength and Conditioning Association Certified and Conditioning Specialist's exam.  The course will focus on the assessment and implementation of training programs with strong emphasis on the areas of resistance training, metabolic training, flexibility, reaction time, speed, and agility. Kinesiology and health majors only and permission of instructor needed.\n",
    "credits": "2"
  },
  {
    "course_name": "Directed Field Experience in Elementary Physical Education",
    "dept": "KIN",
    "num": "280",
    "desc": "\nObserving, planning, and facilitating movement experiences of children in an elementary school setting.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Directed Field Experience in Secondary Physical Education",
    "dept": "KIN",
    "num": "281",
    "desc": "Prereq: Admission to Educator Preparation Program\nObserving, planning, and facilitating movement experiences of students in a middle and/or high school setting.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Field Experience with Educational Outreach",
    "dept": "KIN",
    "num": "282",
    "desc": "Prereq: Admission to Educator Preparation Program\nPlanning and facilitating physical education experiences for children in a community outreach setting.  Experiences take place on campus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Elementary and Pre-school Movement Education",
    "dept": "KIN",
    "num": "284",
    "desc": "Prereq: 3 credits in human development and family studies\nApproaches to teaching movement skills, health-related fitness and school-based physical activities (in the classroom, in PE, during recess) to pre-school and elementary school age children are covered. Emphasis is placed on planning and conducting developmentally appropriate movement experiences for preschool and elementary aged children throughout the school day based upon educational psychology, exercise psychology and motor development research. Practical experience is provided.\n  Credit in only one of the following courses may be applied toward graduation: KIN 284, 312.",
    "credits": "3"
  },
  {
    "course_name": "Pre-Internship in Kinesiology and Health",
    "dept": "KIN",
    "num": "285",
    "desc": "Prereq: Kinesiology and Health major and permission of internship coordinator.\nPre-internship experience with a health organization based on option.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "KIN",
    "num": "290",
    "desc": "Prereq: 2nd semester freshmen, sophomores and permission from instructor.\nStudy under supervision of faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Movement Education in Elementary School Physical Education",
    "dept": "KIN",
    "num": "312",
    "desc": "Prereq: Admission to Educator Preparation Program, KIN 280\nPlanning for management and instruction of developmentally appropriate physical education for children pre-school through grade six. Laboratory experience required.\n  Credit for only one of KIN 284 or KIN 312 may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Teaching Secondary Physical Education",
    "dept": "KIN",
    "num": "313",
    "desc": "Prereq: Admission to Educator Preparation Program, KIN 281\nCurrent theory, practice and research on teaching focusing on management, instructional, and learning styles of students in secondary schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Coaching Theory and Administrative Issues",
    "dept": "KIN",
    "num": "315",
    "desc": "\nStudy in the theory, ethics, strategy, and mechanics of coaching various interscholastic and/or intercollegiate sports. Emphasis on formulating a philosophy, identifying goals and psychological aspects, teaching skills, and developing strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Management of Health-Fitness Programs and Facilities",
    "dept": "KIN",
    "num": "345",
    "desc": "\nApplication of management concepts to the fitness industry, e.g., understanding customers, marketing, program management, financial management, legal issues, and evaluation and planning.\n",
    "credits": "3"
  },
  {
    "course_name": "Biomechanics",
    "dept": "KIN",
    "num": "355",
    "desc": "Prereq: PHYS 111 or PHYS 115\nMechanical basis of human performance; application of mechanical principles to exercise, sport and other physical activities.\n",
    "credits": "3"
  },
  {
    "course_name": "Physiology of Exercise",
    "dept": "KIN",
    "num": "358",
    "desc": "Prereq: BIOL 255, BIOL 255L, BIOL 256 and BIOL 256L\nPhysiological basis of human performance; effects of physical activity on body functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Exercise Physiology Lab",
    "dept": "KIN",
    "num": "359",
    "desc": "Prereq: Concurrent enrollment in KIN 358\nLearning lab techniques in Exercise Physiology and engaging in the experimental process.\n",
    "credits": "1"
  },
  {
    "course_name": "Sociology of Physical Activity and Health",
    "dept": "KIN",
    "num": "360",
    "desc": "Prereq: SOC 134\nProvide an overview of sociology to enhance students understanding of societal forces influencing behavior; Provide insights about people, environments, organization and policies that impact Kinesiology professionals.\n",
    "credits": "3"
  },
  {
    "course_name": "Basic Electrocardiography",
    "dept": "KIN",
    "num": "363",
    "desc": "\nUnderstanding of human electrocardiography, including normal and abnormal 12-lead ECGs and arrhythmia identification.\n",
    "credits": "2"
  },
  {
    "course_name": "Sport  Psychology",
    "dept": "KIN",
    "num": "365",
    "desc": "Prereq: PSYCH 101 or PSYCH 230\nPsychological factors that influence performance in sport settings.  The influence of personality, anxiety, motivation and social factors.  Psychological skills training and strategic methods for improvement of athletic performance.\n",
    "credits": "3"
  },
  {
    "course_name": "Exercise Psychology",
    "dept": "KIN",
    "num": "366",
    "desc": "Prereq: PSYCH 101 or PSYCH 230\nPsychological theories for understanding and predicting health-oriented exercise behavior. Psychological and psychobiological responses to exercise. Psychological interventions for increasing exercise participation and adherence rates.\n",
    "credits": "3"
  },
  {
    "course_name": "Motor Control and Learning Across the Lifespan",
    "dept": "KIN",
    "num": "372",
    "desc": "Prereq: PSYCH 101 or PSYCH 230, BIOL 255, BIOL 256\nIntroduction to major concepts of neuromotor control, behavioral motor control  and motor learning in the child, adult and older adult, with emphasis on the adult system.\n",
    "credits": "3"
  },
  {
    "course_name": "Preparation and Search Strategies for Kinesiology and Health Internships",
    "dept": "KIN",
    "num": "385",
    "desc": "Prereq: Junior classification; to be taken minimum of two semesters prior to required internship.\nPreparation of relevant material for a successful internship/career search.  Specific internship timeline, process, procedures will be reviewed.\n",
    "credits": "0"
  },
  {
    "course_name": "Service Learning Leadership Experience",
    "dept": "KIN",
    "num": "391",
    "desc": "\nApplied service learning experiences designed to provide students with opportunities to apply classroom knowledge to real world applications.  Students will gain professional skills and programming experience while supporting health, education and wellness programming in school, work site or community settings.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Adapted Physical Education",
    "dept": "KIN",
    "num": "395",
    "desc": "Prereq: Admission to Educator Preparation Program, KIN 280/281\nEtiology, characteristics, needs, and movement experiences for individuals with disabilities.  Designed to provide appropriate methods of physical education instruction for students including those with disabilities as identified by the Individuals with Disabilities Education Act and students who are talented and gifted. Assessments and strategies to differentiate instruction and to adapt activities for all exceptional learners will be addressed. Laboratory experience required.\n  KIN 595 may not be taken by students who previously earned credit in KIN 395.",
    "credits": "3"
  },
  {
    "course_name": "Recreational Sport Management",
    "dept": "KIN",
    "num": "399",
    "desc": "Prereq: SOC 134\nThe role of sport in developing fitness, recreational opportunities, and tourism, with special emphasis on issues related to youth sport, volunteerism, and the marketing of sport events and facilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Teaching in Physical Education in the Secondary School",
    "dept": "KIN",
    "num": "417",
    "desc": "Prereq: KIN 281, KIN 282, KIN 313, KIN 355, KIN 395, KIN 471, KIN 475; admission to Teacher Education; approval before enrolling in the course.\nSupervised teaching in the secondary schools.\n",
    "credits": "arr"
  },
  {
    "course_name": "Supervised Teaching in Physical Education in the Elementary School",
    "dept": "KIN",
    "num": "418",
    "desc": "Prereq: KIN 280, KIN 282, KIN 312, KIN 355, KIN 395, KIN 471, KIN 475. Students must be fully admitted to Teacher Education and must apply for approval to enroll at the beginning of the semester prior to registering\nSupervised teaching in the elementary schools.\n",
    "credits": "8"
  },
  {
    "course_name": "Legal Aspects of Sport",
    "dept": "KIN",
    "num": "445",
    "desc": "\nStudents will understand legal concepts and terminology relevant to sport/activity, identify strategies for limiting liability in sport/fitness programs, and identify solutions for elimination of discriminatory practices in sport and physical activity.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Topics in Biomechanics",
    "dept": "KIN",
    "num": "455",
    "desc": "Prereq: KIN 355 or permission of instructor\nExamination of biomechanics and kinesiology research literature to evaluate the application of mechanical principles and analyses to human movement in exercise, sport, physical activity, and activities of daily living and to assess research outcomes and their implications for motor performance, movement energetic, musculoskeletal loading, and injury.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Fitness Assessment and Exercise Prescription",
    "dept": "KIN",
    "num": "458",
    "desc": "Prereq: KIN 258, KIN 358\nPrinciples of cardiac risk factor identification and modification; risk classification of potential exercise clients; fitness assessments; developing comprehensive exercise prescriptions for individuals.\n",
    "credits": "4"
  },
  {
    "course_name": "Internship in Exercise Leadership",
    "dept": "KIN",
    "num": "459",
    "desc": "Prereq: C- or better in KIN 259, CPR certification, concurrent enrollment in KIN 458\nObservation and practice of exercise leadership techniques in an on-campus adult fitness program.\n",
    "credits": "1"
  },
  {
    "course_name": "Medical Aspects of Exercise",
    "dept": "KIN",
    "num": "462",
    "desc": "Prereq: KIN 358\nThe role of exercise in preventive medicine. Impact of exercise on various diseases, and the effect of various medical conditions on the ability to participate in vigorous exercise and competitive sports. Principles of exercise testing and prescription for individuals with these conditions. Environmental and nutritional aspects of exercise.\n",
    "credits": "3"
  },
  {
    "course_name": "Exercise and Health:  Behavior Change",
    "dept": "KIN",
    "num": "467",
    "desc": "Prereq: Introductory course with emphasis on exercise psychology (i.e., KIN 366 or equivalent)\nAdvanced analysis of theoretical health behavior models and their application to physical activity behavior.  Includes practical techniques, tools and interventions (e.g., counseling skills, motivational interviewing) to enhance exercise prescription and motivation, and considerations for working with special populations.\n",
    "credits": "3"
  },
  {
    "course_name": "Measurement in Physical Education",
    "dept": "KIN",
    "num": "471",
    "desc": "Prereq: Admission to Educator Preparation Program, KIN 280 and KIN 281\nCurrent theory, practice and research on measurement and evaluation in physical education and youth physical activity settings.  Statistics, grading, and specific assessments including fitness, motor skill, sport skill, physical activity, affective, and cognitive testing will be addressed.\n  KIN 571 may not be taken by students who previously earned credit in KIN 471.",
    "credits": "3"
  },
  {
    "course_name": "Neural Basis of Human Movement",
    "dept": "KIN",
    "num": "472",
    "desc": "Prereq: KIN 372 or PSYCH 310\nAddresses the role of the central nervous system in the control of voluntary human movement, with the focus on the cerebral cortex, basal ganglia and cerebellum. Content organized around specific nervous system damage (such as stroke, apraxia, spasticity, or spinal cord damage) and functional movements (such as reaching and grasping, balance and gait). Converging evidence from human movement disorders, brain imaging, animal lesion and single cell studies provide the primary basis for the content.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Dimensions of Aging",
    "dept": "KIN",
    "num": "473",
    "desc": "Prereq: KIN 355 or KIN 358 or KIN 372\nUnderstanding the physiological, behavioral, and cognitive changes associated with aging with focus on the effects of physical activity on the aging human system.  Discussions of what it means to become older, what a person can expect during the aging process, and what kind of control a person has over the aging process.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Education Curriculum Design and Program Organization",
    "dept": "KIN",
    "num": "475",
    "desc": "Prereq: Admission to Educator Preparation Program, KIN 280 and 281\nCurrent theory, practices and principles applied to curriculum development for programs in physical education, K-12. Organizing for teaching in a variety of school settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Functional Anatomy",
    "dept": "KIN",
    "num": "480",
    "desc": "Prereq: KIN 355; BIOL 155 or BIOL 255 and BIOL 256\nThe structure and function of human muscular, skeletal and nervous systems. The relationship of these systems to efficient and safe human motion.\n",
    "credits": "3"
  },
  {
    "course_name": "Biomechanics Lab",
    "dept": "KIN",
    "num": "481",
    "desc": "Prereq: KIN 355\nLearning lab techniques in Biomechanics and engaging in the experimental process.\n",
    "credits": "1"
  },
  {
    "course_name": "Exercise Psychology Lab",
    "dept": "KIN",
    "num": "483",
    "desc": "Prereq: KIN 366\nLearning lab techniques in Exercise Psychology and engaging in the experimental process.\n",
    "credits": "1"
  },
  {
    "course_name": "Assessment and Control of Locomotion",
    "dept": "KIN",
    "num": "484",
    "desc": "Prereq: KIN 372\nLearning lab techniques in Motor Control and engaging in the experimental process.\n",
    "credits": "1"
  },
  {
    "course_name": "Internship in Kinesiology",
    "dept": "KIN",
    "num": "485",
    "desc": "Prereq: Senior classification and advance registration.\nObservation and practice in exercise/fitness agencies.\n  Offered on a satisfactory-fail basis only.",
    "credits": "8"
  },
  {
    "course_name": "Internship in Exercise Science",
    "dept": "KIN",
    "num": "485A",
    "desc": "Prereq: Prereq: All required courses and C- or better in KIN 458, KIN 459 and KIN 462, Kinesiology and Health majors only. Cumulative GPA 2.0.\nObservation and practice in selected exercise science agencies.\n  Offered on a satisfactory-fail basis only.",
    "credits": "8"
  },
  {
    "course_name": "Internship in Kinesiology: General",
    "dept": "KIN",
    "num": "485G",
    "desc": "Prereq: Senior classification and advance registration.\nObservation and practice in exercise/fitness agencies.\n  Offered on a satisfactory-fail basis only.",
    "credits": "8"
  },
  {
    "course_name": "Independent Study",
    "dept": "KIN",
    "num": "490",
    "desc": "Prereq: 6 credits from KIN advanced core and permission of coordinator\nIndependent study of problems of areas of interest in exercise and sport science and related areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Exercise and Sport Science",
    "dept": "KIN",
    "num": "490A",
    "desc": "Prereq: 6 credits from KIN advanced core and permission of coordinator\nIndependent study of problems of areas of interest in exercise and sport science and related areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "KIN",
    "num": "490H",
    "desc": "Prereq: 6 credits from KIN advanced core and permission of coordinator\nIndependent study of problems of areas of interest in exercise and sport science and related areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Motivational Interviewing for Health",
    "dept": "KIN",
    "num": "494",
    "desc": "Prereq: Junior/Senior status and permission of instructor\nThis supervised practicum course is designed for students interested in learning how to conduct ‘motivational interviewing’ for behavior change and health coaching applications. Students will learn strategies of motivational interviewing and have opportunities to practice applying these skills with adult clients.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Motivational Interviewing for Health: Principles of Motivational Interviewing",
    "dept": "KIN",
    "num": "494A",
    "desc": "Prereq: Junior/Senior status and permission of instructor\nIntroduction to the principles of ‘motivational interviewing’ for behavior change and health coaching applications. Students interested in gaining practical experience in health coaching should enroll in the associated practicum course (KIN 494B).\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Motivational Interviewing for Health: Supervised Experience",
    "dept": "KIN",
    "num": "494B",
    "desc": "Prereq: KIN 494A Permission of Instructor\nThis supervised practicum course is designed for students interested in gaining experience in applying ‘motivational interviewing’ strategies in behavior change and health coaching applications. Students will have opportunities to practice motivational interviewing skills with adult clients and receive on-going support and assistance needed to refine their skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Kinesiology",
    "dept": "KIN",
    "num": "495",
    "desc": "Prereq: Junior or Senior classification\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research Methods in Physical Activity",
    "dept": "KIN",
    "num": "501",
    "desc": "Prereq: Graduate classification in kinesiology and health\nMethods and techniques used in the design and interpretation of research involving physical activity. Emphasis on styles of writing, library use, and computer applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Laboratory Techniques in Exercise Physiology",
    "dept": "KIN",
    "num": "505",
    "desc": "Prereq: KIN 358 or equivalent course with basic laboratory experience\nApplication and use of laboratory research equipment in exercise physiology, including operation, calibration, and use in selected situations.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Medical Aspects of Exercise",
    "dept": "KIN",
    "num": "510",
    "desc": "Prereq: KIN 358\nThe role of exercise in preventive medicine. Impact of exercise on various diseases, and the effect of various medical conditions on the ability to participate in vigorous exercise and competitive sports. Principles of exercise testing and prescription for individuals with these conditions.\n",
    "credits": "2"
  },
  {
    "course_name": "Physical Activity Strategies for Youth",
    "dept": "KIN",
    "num": "511",
    "desc": "\nProvide adequate opportunities to develop a more in-depth understanding of (a) the challenges in youth physical activity (PA), (b) the relevant theoretical models that are popular in youth PA, (c) the strategies that can be implemented to promote PA in youth.\n",
    "credits": "3"
  },
  {
    "course_name": "Movement Education in Elementary School Physical Education",
    "dept": "KIN",
    "num": "512",
    "desc": "\nPlanning for management and instruction of developmentally appropriate physical education for children pre-school through grade six.  Laboratory experience required.  Emphasis on evaluating published research on physical education and school-wide physical activity.\n",
    "credits": "3"
  },
  {
    "course_name": "Injury Biomechanics",
    "dept": "KIN",
    "num": "515",
    "desc": "Prereq: KIN 355 or permission of instructor.\nUtilization of biomechanical principles to model injury mechanisms. Introduction to tissue mechanics of bone, articular cartilage, ligament, tendon, muscle, and nerve.  Biomechanics of lower extremity, upper extremity, and head/neck/trunk injuries.\n",
    "credits": "3"
  },
  {
    "course_name": "Quantitative Analysis of Human Movement",
    "dept": "KIN",
    "num": "516",
    "desc": "Prereq: KIN 355\nApplication of the principles of mechanics to the analysis of human motion. Investigation of the effects of kinematics and kinetics on the human body with special emphasis on exercise and sport applications. Includes consideration of two-dimensional and three-dimensional imaging techniques and force measurements.\n",
    "credits": "3"
  },
  {
    "course_name": "Musculoskeletal Modeling",
    "dept": "KIN",
    "num": "517",
    "desc": "Prereq: KIN 355 or permission from instructor\nSystematic problem-solving approaches and design of computer programs for biomechanical analyses.  Estimation of anthropometric parameters and mechanical properties of muscles, bones, and joints.  Integration of anthropometrics, kinematics, EMG, and muscle mechanics into simulations of human movement.\n",
    "credits": "3"
  },
  {
    "course_name": "Student Teaching in Elementary Physical Education",
    "dept": "KIN",
    "num": "518",
    "desc": "Prereq: KIN 512, KIN 570, KIN 575\nStudent teaching for 8 weeks in an elementary school.\n",
    "credits": "8"
  },
  {
    "course_name": "Student Teaching in Secondary Physical Education",
    "dept": "KIN",
    "num": "519",
    "desc": "Prereq: KIN 512, KIN 570, KIN 575\nStudent teaching for 8 weeks in a middle or high school.\n",
    "credits": "8"
  },
  {
    "course_name": "The Social Analysis of Sport",
    "dept": "KIN",
    "num": "520",
    "desc": "Prereq: KIN 360; open to majors only or by permission of instructor\nSociological analysis of sport with emphasis on sociological theory, sports structure, and function in modern industrialized society; the systems of sport in regard to their role structure; formal organization, and professionalization and its differentiation along social class, age, and sex.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Exercise and Sport Psychology",
    "dept": "KIN",
    "num": "521",
    "desc": "Prereq: KIN 365 or KIN 366, 3 courses in psychology; open to majors only or by permission of instructor\nAspects of psychology which form a basis for understanding and explaining behavior in the context of exercise and sport. Emphasis on evaluating published research, particularly theory and research methodology. Student presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Vertebrate Physiology I",
    "dept": "KIN",
    "num": "549",
    "desc": "Prereq: recommended: an undergraduate physiology course and a biochemistry course\nOverview of mammalian physiology. Cell biology, endocrinology, cardiovascular, respiratory, immune, digestive, skeletal muscle and reproductive systems.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Physiology of Exercise I",
    "dept": "KIN",
    "num": "550",
    "desc": "Prereq: KIN 505\nConcepts and methods of assessing neurological, muscular, cardiovascular, and respiratory adjustments to exercise.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Physiology of Exercise II",
    "dept": "KIN",
    "num": "551",
    "desc": "Prereq: KIN 505\nAnalysis of factors affecting work capacity and performance. Human energy metabolism concepts and measurement.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Vertebrate Physiology II",
    "dept": "KIN",
    "num": "552",
    "desc": "Prereq: BIOL 335; credit or enrollment in BBMB 404 or BBMB 420\nCardiovascular, renal, respiratory, and digestive physiology.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Fitness - Principles, Programs and Evaluation",
    "dept": "KIN",
    "num": "558",
    "desc": "Prereq: KIN 358\nPhysiological principles of physical fitness, design and administration of fitness programs; testing, evaluation, and prescription; electrocardiogram interpretation.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Motor Control and Learning",
    "dept": "KIN",
    "num": "560",
    "desc": "Prereq: KIN 372\nTheoretical perspectives of motor control and learning will be examined as well as factors that facilitate motor learning. Motor control and learning will also be addressed by studying functional tasks such as reach and grasp, posture and locomotor, handwriting, catching and/or speech.\n",
    "credits": "3"
  },
  {
    "course_name": "Motor Development and Physical Activity",
    "dept": "KIN",
    "num": "561",
    "desc": "Prereq: PSYCH 230\nAddresses theories and underlying mechanisms of motor development and motor control applied to typically and atypically developing children. Developmental control of balance, locomotion, reach-to-grasp, and other functional skills will be discussed, as will the role of physical activity in a child's life.\n",
    "credits": "2"
  },
  {
    "course_name": "Exercise and Health:  Behavior Change",
    "dept": "KIN",
    "num": "567",
    "desc": "Prereq: Introductory course with emphasis on exercise psychology (i.e., KIN 366 or equivalent)\nAdvanced analysis of theoretical health behavior models and their application to physical activity behavior.  Includes practical techniques, tools and interventions (e.g., counseling skills, motivational interviewing) to enhance exercise prescription and motivation, and considerations for working with special populations.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Activity Assessment for Health Related Research",
    "dept": "KIN",
    "num": "570",
    "desc": "\nThis course will cover the broad scope of research in physical activity and public health.  Emphasis will be placed on the application of physical activity assessment techniques since accurate measures are needed to more accurately assess the health benefits from physical activity and to evaluate the effectiveness of behavioral interventions designed to promote physical activity.\n",
    "credits": "3"
  },
  {
    "course_name": "Measurement in Physical Education",
    "dept": "KIN",
    "num": "571",
    "desc": "Prereq: Admission to Educator Preparation Program, KIN 280 and KIN 281\nCurrent theory, practice and research on measurement and evaluation in physical education and youth physical activity settings.  Statistics, grading, and specific assessments including fitness, motor skill, sport skill, physical activity, affective, and cognitive testing will be addressed.\n  KIN 571 may not be taken by students who previously earned credit in KIN 471.",
    "credits": "3"
  },
  {
    "course_name": "Neural Basis of Human Movement",
    "dept": "KIN",
    "num": "572",
    "desc": "Prereq: KIN 372 or PSYCH 310\nAddresses the role of the central nervous system in the control of voluntary human movement, with the focus on the cerebral cortex, basal ganglia and cerebellum. Content organized around specific nervous system damage (such as stroke, apraxia, spasticity, or spinal cord damage) and functional movements (such as reaching and grasping, balance and gait). Converging evidence from human movement disorders, brain imaging, animal lesion and single cell studies provide the primary basis for the content.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Education Curriculum Design and Program Organization",
    "dept": "KIN",
    "num": "575",
    "desc": "Prereq: Admission to Educator Preparation Program, KIN 280 and 281\nCurrent theory, practices and principles applied to curriculum development for programs in physical education, K-12. Organizing for teaching in a variety of school settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "KIN",
    "num": "590",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Physical Education",
    "dept": "KIN",
    "num": "590A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Health and Exercise Promotion",
    "dept": "KIN",
    "num": "590B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Exercise Physiology",
    "dept": "KIN",
    "num": "590D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Sport Sociology",
    "dept": "KIN",
    "num": "590E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Sport/Exercise Psychology",
    "dept": "KIN",
    "num": "590F",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Motor Behavior",
    "dept": "KIN",
    "num": "590G",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Biomechanics",
    "dept": "KIN",
    "num": "590H",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Research Ethics",
    "dept": "KIN",
    "num": "590I",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience",
    "dept": "KIN",
    "num": "591",
    "desc": "Prereq: 10 graduate credits in kinesiology and/or related areas\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Physical Education",
    "dept": "KIN",
    "num": "591A",
    "desc": "Prereq: 10 graduate credits in kinesiology and/or related areas\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Health and Exercise Promotion",
    "dept": "KIN",
    "num": "591B",
    "desc": "Prereq: 10 graduate credits in kinesiology and/or related areas\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Exercise Physiology",
    "dept": "KIN",
    "num": "591D",
    "desc": "Prereq: 10 graduate credits in kinesiology and/or related areas\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in College Teaching",
    "dept": "KIN",
    "num": "592",
    "desc": "\nSupervised experience with teaching an upper division, classroom-based course.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Adapted Physical Education",
    "dept": "KIN",
    "num": "595",
    "desc": "Prereq: Admission to Educator Preparation Program, KIN 280/281\nEtiology, characteristics, needs, and movement experiences for individuals with disabilities.  Designed to provide appropriate methods of physical education instruction for students including those with disabilities as identified by the Individuals with Disabilities Education Act and students who are talented and gifted. Assessments and strategies to differentiate instruction and to adapt activities for all exceptional learners will be addressed. Laboratory experience required.\n  KIN 595 may not be taken by students who previously earned credit in KIN 395.",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "KIN",
    "num": "599",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "KIN",
    "num": "615",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Advance Research Methods in Physical Activity",
    "dept": "KIN",
    "num": "620",
    "desc": "Prereq: KIN 501, STAT 402 and STAT 587. Doctoral students only\nCulminating seminar designed to synthesize statistical and design courses with practical research issues using data from physical activity.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Biology of Muscle",
    "dept": "KIN",
    "num": "670",
    "desc": "Prereq: BBMB 405, BBMB 420\nUltrastructure of muscle; chemistry, structure, function, and molecular biology of muscle proteins. Molecular aspects of muscle contraction, development and turnover. Cytoskeletal proteins and dynamics.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "KIN",
    "num": "699",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "City Play!",
    "dept": "L A",
    "num": "171",
    "desc": "\nExploration of play in cities. Introduction to two important concepts: how play has become a central theme in the economic development and sustainability of cities around the world; and, how the design of cities needs to make room for equitable access to play for everyone.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Studio: Landscape Interpretation and Representation",
    "dept": "L A",
    "num": "201",
    "desc": "Prereq: Enrollment in the professional program\nReading and representing varied landscapes; development of aesthetic sensitivity to the geomorphology, vegetation, and cultural influences on these landscapes. Small-scale interventions and exploration of landscape phenomena and change. Emphasis on a variety of documentation and drawing techniques.\n",
    "credits": "6"
  },
  {
    "course_name": "Studio: Site  Design I",
    "dept": "L A",
    "num": "202",
    "desc": "Prereq: L A 201\nFundamental issues of landscape planning and design at a site scale. Projects introduce a variety of (objective and subjective) site inquiry methods, space and place making, and sensitive integration of architecture and landscape for specific land uses. User needs, precedent study, programming, site engineering, planting design, and outdoor space design expressed through a variety of three-dimensional modeling, graphic, and written media.\n",
    "credits": "6"
  },
  {
    "course_name": "Digital Design Methods for Landscape Architecture",
    "dept": "L A",
    "num": "211",
    "desc": "\nIntroduction of computer applications and standards used by landscape architects and other design professions and their place in a replicable work flow. Foundational knowledge and basic skills in a range of industry-standard 2D, 3D, and 4D computer applications used for design development and communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Native Plants of the Savanna Ecotone",
    "dept": "L A",
    "num": "221",
    "desc": "Prereq: Enrollment in the professional program\nObservation and study of the wetland, prairie, and woodland vegetation native to the savanna ecotone. Emphasis on plant communities, their distribution, structure, habitat and aesthetics. Plant identification and use in landscape design. Precedent and case studies of vegetation preservation, restoration and use in built works.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduced Plants of the Midwest",
    "dept": "L A",
    "num": "222",
    "desc": "Prereq: L A 221\nIdentification, observation, and study of plants introduced to cultivation in the Midwest region.  Plant cultural requirements, including adaptations to climate changes, solar exposure, and soil conditions.  Investigation of history of plant introduction and use in designed landscape, including consequent impacts of plant introduction such as plant invasion.  Introduction to planting design at the site scale, including matching plant cultural requirements to site conditions, functional uses of plants and expressive composition using plant form, texture and color.\n",
    "credits": "3"
  },
  {
    "course_name": "Developing Identity as a Landscape Architect",
    "dept": "L A",
    "num": "241",
    "desc": "Prereq: Enrollment in the professional program\nDevelopment of life skills for conflict resolution, effective interpersonal communication, and CPR/First Aid. Examination of personal values as they relate to the backgrounds, abilities, attitudes, and   values of others; exploration of how these influence personal decision-making and group interaction. Reading, discussion, class   activities, journal-keeping, writing.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Foundations in Natural Resource Policy and History",
    "dept": "L A",
    "num": "270",
    "desc": "\nThe development of natural resource conservation philosophy and policy from the Colonial Era to the present. North American wildlife, forestry, and environmental policy; national parks and other protected lands; federal and state agencies.  Relationship to cultural contexts, including urban reform and American planning movement. Discussion of common pool resources, public and private lands.\n",
    "credits": "3"
  },
  {
    "course_name": "Cultural Landscape Studies",
    "dept": "L A",
    "num": "272",
    "desc": "Prereq: Enrollment in the professional program\nExploration of landscapes, from broad settlement patterns to individual sites. Investigation of relationships between vernacular and designed landscapes. Landscapes considered as modes of cultural production that shape and are shaped by social, political, and economic processes. Lectures, reading, ﬁeld studies, and writing.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "The Social and Behavioral Landscape",
    "dept": "L A",
    "num": "274",
    "desc": "\nExploration of social and behavioral factors pertinent to design of the domestic, civic, and commercial landscape. Focus on working familiarity with design principles as they relate to the behavior and activities of people across a broad demographic and cultural spectrum; application of these principles to design of outdoor environments. Lectures and discussions, including group exercises and field trips.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Investigating Landscape Form, Process, and Detail",
    "dept": "L A",
    "num": "281",
    "desc": "Prereq: Enrollment in professional program\nExploration of the poetics and principles of landscape construction. Investigation and interpretation of landform and geomorphic processes such as the hydrologic cycle, erosion, and sedimentation. Close observation and representation of detail design, with an emphasis on material types, their connections, and weathering. Readings, field studies, and drawings in analog and digital media.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Dynamics",
    "dept": "L A",
    "num": "282",
    "desc": "Prereq: Sophomore standing\nUnderstand design implications presented by geotechnical and ecological processes in the landscape including ecology, vegetation, soils and water. Understand the influence of landforms, geology, plants, soils, and water on the creation of landscape designs. Course relates current issues including water quality impairment, erosion, and invasive species with design strategies such as stormwater management, soil quality management, and plant community restoration. Field trips.\n",
    "credits": "3"
  },
  {
    "course_name": "Site Design II",
    "dept": "L A",
    "num": "301",
    "desc": "Prereq: L A 202\nDevelopment of half-acre to hundred-acre landscape design and planning proposals, potentially in collaboration with students in other programs. Apply critical methodological frameworks to shape site systems while providing appropriate support for diverse user groups and creating culturally meaningful places. Assess and interpret a program of use, organize subjective and objective site inventory and analysis, develop functional and poetic design strategies for infrastructure and natural systems, and craft artistic and functionally explicit landscape architectural proposals. Development of appropriate technique and high level of craft in representations to support design thinking process and final scheme presentation.\n",
    "credits": "6"
  },
  {
    "course_name": "Ecological Design at the Regional Scale",
    "dept": "L A",
    "num": "302",
    "desc": "Prereq: L A 282, L A 301, L A 381 and NREM 120\nApplication of ecological theories and processes in design and planning at the hundred plus-acre scale specifically focusing on urban and urban fringe landscapes. Apply advanced landscape analysis of soil, water, and vegetation utilizing geographic information systems. Particular focus on stream and wetland restoration, mitigation, and regulations and developing design representations for public use.\n",
    "credits": "6"
  },
  {
    "course_name": "Field Travel",
    "dept": "L A",
    "num": "309",
    "desc": "Prereq: Enrollment in the professional program and permission of instructor\nObservation of and reflection on professional practice and landscapes in urban, rural, and wilderness areas.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Planting Design",
    "dept": "L A",
    "num": "322",
    "desc": "Prereq: L A 221\nThe art and techniques of creating plant compositions in the landscape that respond to cultural and biophysical contexts. Investigation of soil properties and plant/soil relationships relevant to the built environment.  Methods of site inventory and analysis, developing plant palettes and composing plant assemblages that address expressive and functional needs.  Introduction to the techniques of preparing planting plans, including standards for plant selection, plant lists and plant specification.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Landscape Architecture",
    "dept": "L A",
    "num": "341",
    "desc": "Prereq: L A 301\nExploration of contemporary landscape architectural practice through individualized research into practicing firms. Preparation of paper and presentation outlining broad framework and specific parameters of a selected area of contemporary practice using specific projects as examples. Work may result in invitation of current practitioner(s) as a lecture series or event. Resume and portfolio preparation in advance of required off-campus semester (L A 444 A, B or C).\n",
    "credits": "1"
  },
  {
    "course_name": "History of Modern Landscapes, 1750 to Present",
    "dept": "L A",
    "num": "371",
    "desc": "\nInvestigation of landscape design concepts and trends as observed over time, from approximately 1750 to the present, with emphasis on the United States and Europe. Examination of significant figures and outstanding works (sites, gardens, landscapes, monuments, subdivisions, city plans, etc.) of varied geographic regions. Analysis of the social, economic, political, and technical   forces contributing to the development of landscape design styles, vocabulary, and literature. Lectures, readings, projects, research papers.\n",
    "credits": "3"
  },
  {
    "course_name": "Gardens and Landscapes from Antiquity to 1750",
    "dept": "L A",
    "num": "373",
    "desc": "\nInvestigation of international landscape design concepts and trends as observed over time, from pre-history to the mid 18th century. Examination of significant figures and outstanding works (sites, gardens, landscapes, monuments, subdivisions, city plans, etc.) of varied geographic regions. Analysis of the social, economic, political, and technical forces contributing to the development of landscape design styles, vocabulary, and literature. Lectures, readings, projects, research papers.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Shaping the Land",
    "dept": "L A",
    "num": "381",
    "desc": "Prereq: L A 282 and MATH 143 or MATH 145\nDesign of landforms to achieve aesthetic, functional, and safety goals. Landform changes to accommodate human uses and activities. Impacts and implications of landform transformation on the surrounding environment. Surface and subsurface drainage design, storm water runoff best management practices, contour manipulation to incorporate slopes, swales, culverts, pads, retaining walls, walks, steps, terraces, buildings, and other structures in the landscape. Road layout and alignment, parking lot design, and earthwork volume estimates. Design communication using CAD, perspectives, cross-sections, contour maps, landform models, and narratives. Class exercises, case study precedents, and preliminary construction documents.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Design",
    "dept": "L A",
    "num": "401",
    "desc": "Prereq: L A 402\nPhysical planning and design of places utilizing community-based methods. Projects address social and cultural dimensions of placemaking such as reuse of abandoned sites, in-fill development, and community visioning. Emphasis on development of user-client relationship skills and design research. Integrated seminar component.\n",
    "credits": "6"
  },
  {
    "course_name": "Community Design: Honors",
    "dept": "L A",
    "num": "401H",
    "desc": "Prereq: L A 402\nPhysical planning and design of places utilizing community-based methods. Projects address social and cultural dimensions of placemaking such as reuse of abandoned sites, in-fill development, and community visioning. Emphasis on development of user-client relationship skills and design research. Integrated seminar component.\n",
    "credits": "7"
  },
  {
    "course_name": "Urban Design",
    "dept": "L A",
    "num": "402",
    "desc": "Prereq: L A 302\nComprehensive planning and design for urban sites or for sites within urban contexts. Projects typically include planning for a variety of integrated land uses, and cover the full range of design scales from master planning to proposals for site details. Emphasis on written and verbal as well as graphic communications. Integrated seminar component.\n",
    "credits": "6"
  },
  {
    "course_name": "Urban Design: Honors",
    "dept": "L A",
    "num": "402H",
    "desc": "Prereq: L A 302\nComprehensive planning and design for urban sites or for sites within urban contexts. Projects typically include planning for a variety of integrated land uses, and cover the full range of design scales from master planning to proposals for site details. Emphasis on written and verbal as well as graphic communications. Integrated seminar component.\n",
    "credits": "7"
  },
  {
    "course_name": "Senior Thesis Preparation Tutorial",
    "dept": "L A",
    "num": "403H",
    "desc": "Prereq: L A 402, permission of thesis advisor, enrollment in Honors program\nPreparation for senior thesis.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Landscape Architectural Design",
    "dept": "L A",
    "num": "404",
    "desc": "Prereq: L A 401\nAdvanced forum for the demonstration of sophistication in landscape architectural design. Experimentation and innovation are encouraged.\n",
    "credits": "6"
  },
  {
    "course_name": "Advanced Landscape Architectural Design: Honors",
    "dept": "L A",
    "num": "404H",
    "desc": "Prereq: L A 401\nAdvanced forum for the demonstration of sophistication in landscape architectural design. Experimentation and innovation are encouraged.\n",
    "credits": "6"
  },
  {
    "course_name": "Senior Thesis",
    "dept": "L A",
    "num": "405H",
    "desc": "Prereq: L A 401, L A 402, L A 403, enrollment in Honors program and permission of adviser, chair and thesis adviser\nIndividual advanced forum for the demonstration of sophistication in landscape architectural design. Experimentation and innovation are expected.\n",
    "credits": "6"
  },
  {
    "course_name": "Urban and Peri-urban Watershed Assessment",
    "dept": "L A",
    "num": "417",
    "desc": "Prereq: Junior classification and 6 credits of natural science\nAssessment and reduction of impacts in urban and peri-urban watershed areas. Course prepares students to work with various analysis methods for vegetation, topography, stormwater and stream condition as well as work with data from other disciplines. Emphasis on communicating with the public. Introductory GIS and GPS technologies are utilized. Learning is largely field-based.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Practice",
    "dept": "L A",
    "num": "442",
    "desc": "Prereq: L A 481\nStudies of conventional and developing forms of public and private practice. Explore relationships between professional life and the culture of the professional design firm; investigate firm identities and structures; understand design projects, their delivery process, and contractual agreements. Lecture and class discussion.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture Independent Educational Enrichment",
    "dept": "L A",
    "num": "444",
    "desc": "Prereq: L A 341 or permission of adviser and chair\nIndependent educational enrichment through exploration of landscape architectural practice in a professional internship, international studies, or out-of-region national study experience.\n",
    "credits": "R"
  },
  {
    "course_name": "Landscape Architecture Independent Educational Enrichment: Professional Internship",
    "dept": "L A",
    "num": "444A",
    "desc": "Prereq: L A 341 or permission of adviser and chair\nIndependent educational enrichment through exploration of landscape architectural practice in a professional internship, international studies, or out-of-region national study experience.\n",
    "credits": "R"
  },
  {
    "course_name": "Landscape Architecture Independent Educational Enrichment: Study Abroad",
    "dept": "L A",
    "num": "444B",
    "desc": "Prereq: L A 341 or permission of adviser and chair\nIndependent educational enrichment through exploration of landscape architectural practice in a professional internship, international studies, or out-of-region national study experience.\n",
    "credits": "R"
  },
  {
    "course_name": "Landscape Architecture Independent Educational Enrichment: National Student Exchange",
    "dept": "L A",
    "num": "444C",
    "desc": "Prereq: L A 341 or permission of adviser and chair\nIndependent educational enrichment through exploration of landscape architectural practice in a professional internship, international studies, or out-of-region national study experience.\n",
    "credits": "R"
  },
  {
    "course_name": "Fundamentals of Remote Sensing",
    "dept": "L A",
    "num": "454",
    "desc": "Prereq: CRP 351 or equivalent or permission of the instructor\nIntroduction to remote sensing techniques needed for basic analysis of satellite images, including: filtering and conflation techniques, stacking, pan sharpening, image rectification, image enhancement, unsupervised and supervised classification. Practical applications in a variety of topics to understand how to interpret images.\n",
    "credits": "3"
  },
  {
    "course_name": "Web Mapping/GIS",
    "dept": "L A",
    "num": "458",
    "desc": "Prereq: CRP 451/551, LA 302. GEOL 452/552 or instructor permission.\nUse and development of online mapping tools to support participatory GIS, Volunteered Geographic Information, information sharing, geodesign and decision making actions. Geoprocessing and Web Scripting/coding and user interface design. Laboratory emphasis practical applications and uses of Web GIS.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Design Methods for Landscape Architecture",
    "dept": "L A",
    "num": "459",
    "desc": "\nIntroduction to digital tools used by landscape architects for design communication, visualization, and design development, with emphasis on 3D modeling and workflow interoperability.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to GIS",
    "dept": "L A",
    "num": "461I",
    "desc": "\nDescriptive and predictive GIS modeling techniques, spatial statistics, and map algebra. Application of GIS modeling techniques to environmental planning and resource management.\n",
    "credits": "4"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture",
    "dept": "L A",
    "num": "478",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Landscape Design",
    "dept": "L A",
    "num": "478A",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Planting Design",
    "dept": "L A",
    "num": "478B",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Construction",
    "dept": "L A",
    "num": "478C",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: History/Theory/Criticism",
    "dept": "L A",
    "num": "478D",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Landscape Planning",
    "dept": "L A",
    "num": "478E",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Urban Design",
    "dept": "L A",
    "num": "478F",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Graphics",
    "dept": "L A",
    "num": "478G",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Honors",
    "dept": "L A",
    "num": "478H",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Interdisciplinary Studies",
    "dept": "L A",
    "num": "478I",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: International Studies",
    "dept": "L A",
    "num": "478J",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture: Computer Applications",
    "dept": "L A",
    "num": "478K",
    "desc": "Prereq: Senior classification or graduate standing\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Ecological Design",
    "dept": "L A",
    "num": "478L",
    "desc": "Prereq: L A 202 or senior classification or graduate standing\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Landscape Architecture: Social/Behavioral",
    "dept": "L A",
    "num": "478M",
    "desc": "Prereq: L A 202 or senior classification or graduate standing\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Natural Resources",
    "dept": "L A",
    "num": "478N",
    "desc": "Prereq: L A 202 or senior classification or graduate standing\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Construction",
    "dept": "L A",
    "num": "481",
    "desc": "Prereq: L A 381\nDevelopment of construction details with emphasis on materials and their aesthetic and functional uses as building materials.  Explore characteristics and uses of construction materials and application of wood systems, paving systems, retaining walls, masonry and concrete systems, and metals; investigate structural theory of wood systems. Preliminary preparation of construction documents.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Landscape Construction",
    "dept": "L A",
    "num": "482",
    "desc": "Prereq: L A 481\nAdvanced site construction issues, including proposal preparation, construction documentation, project scheduling, estimating, and specification writing.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "L A",
    "num": "490",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Landscape Design",
    "dept": "L A",
    "num": "490A",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Planting Design",
    "dept": "L A",
    "num": "490B",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Construction",
    "dept": "L A",
    "num": "490C",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: History/Theory/Criticism",
    "dept": "L A",
    "num": "490D",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Landscape Planning",
    "dept": "L A",
    "num": "490E",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Urban Design",
    "dept": "L A",
    "num": "490F",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Graphics",
    "dept": "L A",
    "num": "490G",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "L A",
    "num": "490H",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Interdisciplinary Studies",
    "dept": "L A",
    "num": "490I",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: International Studies",
    "dept": "L A",
    "num": "490J",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Computer Applications",
    "dept": "L A",
    "num": "490K",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Ecological Design",
    "dept": "L A",
    "num": "490L",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Social/Behavioral",
    "dept": "L A",
    "num": "490M",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Natural Resources",
    "dept": "L A",
    "num": "490N",
    "desc": "Prereq: Written approval of instructor and department chair on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Environmental Law and Planning",
    "dept": "L A",
    "num": "491",
    "desc": "Prereq: 6 credits in natural sciences\nEnvironmental law and policy as applied in planning at the local and state levels. Brownfields, environmental justice, water quality, air quality, wetland and floodplain management, and local government involvement in ecological protection through land use planning and other programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Field Travel",
    "dept": "L A",
    "num": "509",
    "desc": "Prereq: Enrollment in the professional program and permission of instructor\nObservation of and reflection on professional and academic practice and landscapes.  Field study and travel to conferences and educational events. Reading and final report.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Urban and Peri-urban Watershed Assessment",
    "dept": "L A",
    "num": "517",
    "desc": "Prereq: Junior classification and 6 credits of natural science\nAssessment and reduction of impacts in urban and peri-urban watershed areas. Course prepares students to work with various analysis methods for vegetation, topography, stormwater and stream condition as well as work with data from other disciplines. Emphasis on communicating with the public. Introductory GIS and GPS technologies are utilized. Learning is largely field-based.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Plant Technology",
    "dept": "L A",
    "num": "522",
    "desc": "Prereq: Junior or graduate standing\nIntroduction to the science that supports green technologies. Plant and soil design for performance in the built environment. Design studies and lab explorations will complement readings, lecture and project case study presentations by practitioners. Green streets, green roofs, bio- phyto-remediation and other technologies are introduced. Final project integrates scientific and technical knowledge in a holistic landscape design.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Inquiry",
    "dept": "L A",
    "num": "541",
    "desc": "Prereq: Graduate standing\nExamination of design inquiry and introduction to research methods relevant to design.  Consideration of where knowledge comes from, and how different research methods help create knowledge in various contexts. Readings, discussions, and sketch problems. Preparation of a written research proposal.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Practice",
    "dept": "L A",
    "num": "542",
    "desc": "Prereq: L A 481\nStudies of conventional and developing forms of public and private practice. Explore relationships between professional life and the culture of the professional design firm; investigate firm identities and structures; understand design projects, their delivery process, and contractual agreements. Lecture and class discussion.\n",
    "credits": "2"
  },
  {
    "course_name": "Colloquium I: Landscape Architecture Research",
    "dept": "L A",
    "num": "543",
    "desc": "Prereq: Graduate standing.\nGraduate forum on current research in landscape architecture.  Weekly presentations of scholarly and professional work by department faculty. Readings, discussions, and development of student research focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Colloquium II: Interdisciplinary Research",
    "dept": "L A",
    "num": "545",
    "desc": "Prereq: LA 543 or graduate standing.\nStudent-run graduate forum on current research in landscape architecture and related disciplines. Weekly presentations by invited faculty from the departments across the College of Design, University, and professional guests.  Readings, discussions, and writing.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Remote Sensing",
    "dept": "L A",
    "num": "554",
    "desc": "Prereq: CRP 351 or equivalent or permission of the instructor\nIntroduction to remote sensing techniques needed for basic analysis of satellite images, including: filtering and conflation techniques, stacking, pan sharpening, image rectification, image enhancement, unsupervised and supervised classification. Practical applications in a variety of topics to understand how to interpret images.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Parametrics & Design Coding",
    "dept": "L A",
    "num": "557",
    "desc": "Prereq: Junior classification\nIntroduction to parametric landscape design through traditional and visual computer programming of the landscape palette. Geometric parameters for terrain, vegetation, water, weather and lighting effects are modeled and developed algorithmically. Computational thinking, logic and computer graphics interactivity are combined to produce stand-alone software application prototypes that address core landscape design principles.\n",
    "credits": "3"
  },
  {
    "course_name": "Web Mapping/GIS",
    "dept": "L A",
    "num": "558",
    "desc": "Prereq: CRP 451/551, LA 302. GEOL 452/552 or instructor permission.\nUse and development of online mapping tools to support participatory GIS, Volunteered Geographic Information, information sharing, geodesign and decision making actions. Geoprocessing and Web Scripting/coding and user interface design. Laboratory emphasis practical applications and uses of Web GIS.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Design Methods for Landscape Architecture",
    "dept": "L A",
    "num": "559",
    "desc": "\nIntroduction to digital tools used by landscape architects for design communication, visualization, and design development, with emphasis on 3D modeling and workflow interoperability.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced GIS Landscape Modeling",
    "dept": "L A",
    "num": "567",
    "desc": "Prereq: L A 302 or C R P 451/C R P 551\nApplication of Geographic Information Systems (GIS) modeling techniques to landscape planning and management issues. Selection, acquisition, and conversion of digital landscape data. Modeling applications for studio projects, outreach projects, and research projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Architectural  Theory",
    "dept": "L A",
    "num": "571",
    "desc": "Prereq: graduate classification or permission of instructor\nExamination of the development of landscape architectural ideas in their historical contexts and in relation to social and cultural practices. Emphasis on exposure to key modern and contemporary texts and projects in landscape architecture, architecture, art, and related fields. Readings, discussions, and writings.\n",
    "credits": "3"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture",
    "dept": "L A",
    "num": "578",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Landscape Design",
    "dept": "L A",
    "num": "578A",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Planting Design",
    "dept": "L A",
    "num": "578B",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Construction",
    "dept": "L A",
    "num": "578C",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: History/Theory/Criticism",
    "dept": "L A",
    "num": "578D",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Landscape Planning",
    "dept": "L A",
    "num": "578E",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Urban Design",
    "dept": "L A",
    "num": "578F",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Graphics",
    "dept": "L A",
    "num": "578G",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Interdisciplinary Studies",
    "dept": "L A",
    "num": "578I",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: International Studies",
    "dept": "L A",
    "num": "578J",
    "desc": "Prereq: L A 202 or senior or graduate classification\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Landscape Architecture: Computer Applications",
    "dept": "L A",
    "num": "578K",
    "desc": "Prereq: Senior classification or graduate standing\nOfferings vary with each term; check with department for available sections. Course contact hours can range from (2-0) to (3-0) depending on number of credits.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Ecological Design",
    "dept": "L A",
    "num": "578L",
    "desc": "Prereq: L A 202 or senior classification or graduate standing\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Landscape Architecture: Social/Behavioral",
    "dept": "L A",
    "num": "578M",
    "desc": "Prereq: L A 202 or senior classification or graduate standing\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Topical Studies in Landscape Architecture: Natural Resources",
    "dept": "L A",
    "num": "578N",
    "desc": "Prereq: L A 202 or senior classification or graduate standing\nOfferings vary with each term; check with department for available sections.\n",
    "credits": "2"
  },
  {
    "course_name": "Thesis, Creative Component Tutorial",
    "dept": "L A",
    "num": "580",
    "desc": "Prereq: Permission of major professor\nHands-on participation in a creative or research activity in the student's area of specialization. Development of a detailed prospectus that defines the thesis or creative component.\n",
    "credits": "1"
  },
  {
    "course_name": "Landscape TopoGraphics",
    "dept": "L A",
    "num": "583",
    "desc": "Prereq: LA 602\nDesign of landforms to achieve aesthetic, functional, and safety goals. Impacts and implications of landform transformation on the surrounding environment.  Design communication using CAD, perspectives, cross-sections, contour maps, landform models, and narratives. Class exercises, case study precedents, and preliminary construction documents.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Structures",
    "dept": "L A",
    "num": "587",
    "desc": "Prereq: LA 583\nIntroduction to construction practices in landscape architecture. Emphasis on the aesthetic and functional components of built environments including materials, assemblies and techniques; integrate the principles of sustainability as they relate to current and emerging construction methods, materials and technologies. Introduction to the preparation of construction documents.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "L A",
    "num": "590",
    "desc": "Prereq: Graduate standing.\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Landscape Design",
    "dept": "L A",
    "num": "590A",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Planting Design",
    "dept": "L A",
    "num": "590B",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Construction",
    "dept": "L A",
    "num": "590C",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: History/Theory/Criticism",
    "dept": "L A",
    "num": "590D",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Landscape Planning",
    "dept": "L A",
    "num": "590E",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Urban Design",
    "dept": "L A",
    "num": "590F",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Graphics",
    "dept": "L A",
    "num": "590G",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Interdisciplinary Studies",
    "dept": "L A",
    "num": "590I",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: International Studies",
    "dept": "L A",
    "num": "590J",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Computer Applications",
    "dept": "L A",
    "num": "590K",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Ecological Design",
    "dept": "L A",
    "num": "590L",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Social/Behavioral",
    "dept": "L A",
    "num": "590M",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Natural Resources",
    "dept": "L A",
    "num": "590N",
    "desc": "Prereq: Approval of instructor and Director of Graduate Education on required form\nInvestigation of a topic of special interest to the student.\n",
    "credits": "1"
  },
  {
    "course_name": "Environmental Law and Planning",
    "dept": "L A",
    "num": "591",
    "desc": "Prereq: 6 credits in natural sciences\nEnvironmental law and policy as applied in planning at the local and state levels. Brownfields, environmental justice, water quality, air quality, wetland and floodplain management, and local government involvement in ecological protection through land use planning and other programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Justice in Built Environments",
    "dept": "L A",
    "num": "594",
    "desc": "Prereq: Graduate standing or senior classification.\nExamination of the equitable distribution of environmental burdens and benefits for sustainable and resilient cities. Focus on impact of climate change, social exclusion, and physical isolation on cumulative risk amongst vulnerable populations. Synthesis of recent social and environmental research to develop innovative physical planning and urban design strategies that support healthy behaviors.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "L A",
    "num": "599",
    "desc": "Prereq: Permission of major professor\nComprehensive study and original development of a project selected by the student and approved by the major professor. Completed project must be submitted to and approved by a graduate faculty committee as evidence of mastery of the principles of landscape architecture.\n",
    "credits": "1"
  },
  {
    "course_name": "Studio I: Design Representation",
    "dept": "L A",
    "num": "601",
    "desc": "Prereq: Graduate standing\nIntroduction to history, techniques, and conventions of landscape architecture representation. Production of design drawings that facilitate critical thinking, the testing of design ideas, and effective communication. Use of two- and three-dimensional media, both analog and digital.\n",
    "credits": "3"
  },
  {
    "course_name": "Studio II: Land Form and Plant Scape",
    "dept": "L A",
    "num": "602",
    "desc": "Prereq: L A 601\nLandscape design integrating knowledge of land patterns, plant ecosystems, and human processes. Project involve landform and plants at varied scale of design. Emphasis on competencies in design based in natural process, human behavior, and representation.\n",
    "credits": "6"
  },
  {
    "course_name": "Studio III: Performance Landscapes",
    "dept": "L A",
    "num": "603",
    "desc": "Prereq: L A 602\nTheory and methods of landscape design at a variety of scales to achieve desired cultural and biophysical impacts. Development and use of performance metrics drawn from design, humanities, and science. Construction of integrated rhetorical structures of representation and analysis and critical viewpoints to create rigorous design \"arguments\" and meaningful, just and vibrant environments.\n",
    "credits": "6"
  },
  {
    "course_name": "Studio IV: City Matters",
    "dept": "L A",
    "num": "604",
    "desc": "Prereq: L A 603\nExploration of sociopolitical, ecological, and visual-spatial conditions of the urban environment through design at multiple scales. Focus on urban projects that highlight the complexity of human, ecological, and emerging infrastructural systems. Development of innovative strategies for sustainable, healthy, and just cities. Special attention is paid to new technologies and building material in cities.\n",
    "credits": "6"
  },
  {
    "course_name": "Studio V: Land Works/Land Digits",
    "dept": "L A",
    "num": "605",
    "desc": "Prereq: L A 604\nLandscape design focusing on broadening the representational palette for landscape architectural concepts applied to complex sites at multiple scales. Emphasis on ideation and technical competency through advanced conceptualization, performance metrics, and skills in design research, digital representation, and teamwork.\n",
    "credits": "6"
  },
  {
    "course_name": "Thesis Research",
    "dept": "L A",
    "num": "699",
    "desc": "Prereq: Permission of major professor\nAdvanced and original scholarship in a specialized area. Culminates in a thesis document submitted to and approved by a graduate faculty committee as evidence of mastery of research in landscape architecture.\n",
    "credits": "1"
  },
  {
    "course_name": "Elementary Latin I",
    "dept": "LATIN",
    "num": "101",
    "desc": "\nGrammar and vocabulary of classical Latin, within the context of Roman culture; reading knowledge through texts adapted from classical authors.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Latin II",
    "dept": "LATIN",
    "num": "102",
    "desc": "Prereq: LATIN 101\nGrammar and vocabulary of classical Latin, within the context of Roman culture; reading knowledge through texts adapted from classical authors.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Latin",
    "dept": "LATIN",
    "num": "201",
    "desc": "Prereq: LATIN 102\nEmphasis on grammatical principles, composition and reading Latin texts.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to Latin Literature",
    "dept": "LATIN",
    "num": "332",
    "desc": "Prereq: LATIN 201\nReadings in Latin Literature with emphasis on critical analysis of style, structure or thought.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study",
    "dept": "LATIN",
    "num": "490",
    "desc": "Prereq: 6 credits in Latin and permission of department chair\nDesigned to meet the needs of students who seek work in areas other than those in which courses are offered, or who desire to integrate a study of literature or language with special problems in major fields.\n  No more than 9 credits in Latin 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Leading with Purpose",
    "dept": "LD ST",
    "num": "122",
    "desc": "\nDesigned for emerging student leaders. Basic leadership skills covering personal skills development, goal achievement, values-based behaviors and mission statement development.\n",
    "credits": "1"
  },
  {
    "course_name": "Campus Leadership Development",
    "dept": "LD ST",
    "num": "270",
    "desc": "\nTheory and practice of effective leadership in a campus and community context. Study of effective leadership models and leadership in complex systems. Expectation of engagement in campus activities and community organizations. Assessed service-learning component.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "LD ST",
    "num": "290",
    "desc": "Prereq: Permission of the instructor.\nIndependent study in leadership studies.\n  No more than 6 credits of LD ST 290 or LD ST 490 may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Leading Through Service Learning",
    "dept": "LD ST",
    "num": "291",
    "desc": "Prereq: Permission of the instructor.\nIntegration of meaningful service work with instruction and reflection in leadership theory. Academic work may include written projects, presentations, reports, and guided readings.\n",
    "credits": "1"
  },
  {
    "course_name": "Leading Through Service Learning: General",
    "dept": "LD ST",
    "num": "291A",
    "desc": "Prereq: Permission of the instructor.\nIntegration of meaningful service work with instruction and reflection in leadership theory. Academic work may include written projects, presentations, reports, and guided readings.\n",
    "credits": "1"
  },
  {
    "course_name": "Leading Through Service Learning: U.S. Diversity",
    "dept": "LD ST",
    "num": "291B",
    "desc": "Prereq: Permission of the instructor.\nIntegration of meaningful service work with instruction and reflection in leadership theory with a U.S. Diversity focus. Academic work may include written projects, presentations, reports, and guided readings.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "Leading Through Service Learning: International Perspectives",
    "dept": "LD ST",
    "num": "291C",
    "desc": "Prereq: Permission of the instructor.\nIntegration of meaningful service work with instruction and reflection in leadership theory with an International Perspectives focus. Academic work may include written projects, presentations, reports, and guided readings.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Projects",
    "dept": "LD ST",
    "num": "293",
    "desc": "Prereq: Permission of the instructor.\nSpecial projects for the Leadership Studies Program.\n",
    "credits": "1"
  },
  {
    "course_name": "Leadership Styles and Strategies in a Diverse Society",
    "dept": "LD ST",
    "num": "322",
    "desc": "Prereq: Sophomore classification\nDevelop and practice leadership skills through understanding personal leadership styles, leadership theory and communication theory, including how they relate to gender issues and cultural diversity. Explore personality types, communication styles and leadership styles; set goals; and participate in leadership opportunities and service.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women and Leadership",
    "dept": "LD ST",
    "num": "333",
    "desc": "Prereq: Sophomore classification\nExamination of historical and contemporary barriers to and opportunities for women's leadership in a variety of contexts, including professions and public service. Theories of women's leadership, gender differences in leadership styles, and perceptions and expectations about women's leadership. Multiple perspectives of women's leadership highlighted through lectures, readings, videos, guest speakers and group work.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Cultural Competency and Global Leadership",
    "dept": "LD ST",
    "num": "360",
    "desc": "Prereq: Sophomore classification or approval by the instructor.\nLeadership theories and their applications in an international context. The development of an intercultural mindset essential for effective leadership.  Contextual influences on leadership and the development of global leadership capacities.\n  None",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "LD ST",
    "num": "370",
    "desc": "Prereq: None\nSeminar on special topics, research and theory in leadership studies. Students must register for a different topic each time. Not open to first-year students.\n",
    "credits": "1"
  },
  {
    "course_name": "Leadership Capstone Seminar: Theory to Practice",
    "dept": "LD ST",
    "num": "422",
    "desc": "Prereq: LD ST 322\nCritical analysis of leadership theory to inform practice, with emphasis on ethical leadership, research, and the alignment of personal and organizational values.\n",
    "credits": "3"
  },
  {
    "course_name": "Research on Women and Leadership",
    "dept": "LD ST",
    "num": "488",
    "desc": "\nResearch on women and leadership in selected content areas (e.g., business, education, politics and public service, and popular culture). Following an overview of quantitative and qualitative methods and critical analyses of journal articles on women and leadership, students work individually or in groups in selected content areas to write and present papers.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "LD ST",
    "num": "490",
    "desc": "Prereq: Permission of the instructor.\nIndependent study in leadership studies.\n  No more than 6 credits of LD ST 290 or LD ST 490 may count toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Foundations of Learning and Productive Team Membership",
    "dept": "L L S",
    "num": "112",
    "desc": "\nIntroduction to developing intentional learners and worthy team members. Learning as the foundation of human enterprise; intellectual curiosity; ethics as a personal responsibility; everyday leadership; effective team and community interactions including team learning and the effects on individuals; and growth through understanding self, demonstrating ownership of own learning, and internalizing commitment to helping others. Intentional mental processing as a means of enhancing learning. Interconnectedness of the individual, the community, and the world.\n",
    "credits": "2"
  },
  {
    "course_name": "Developing Responsible Learners and Effective Leaders",
    "dept": "L L S",
    "num": "114",
    "desc": "Prereq: L L S 112\nFocus on team and community. Application of fundamentals of human learning; evidence of development as a responsible learner; intentional mental processing as a habit of mind; planning and facilitating learning opportunities for others; responsibility of the individual to the community and the world; leading from within; holding self and others accountable for growth and development as learners and leaders.\n",
    "credits": "2"
  },
  {
    "course_name": "Habits of Mind and Decision-Making in Leadership",
    "dept": "L L S",
    "num": "212",
    "desc": "Prereq: L L S 114\nApplication of theories about habits of mind, mindset, and critical thinking to structured cross-disciplinary problem-solving scenarios. Development and utilization of personal and team action plans for specific habits of mind associated with leadership.\n",
    "credits": "2"
  },
  {
    "course_name": "Problem Solving and Action Planning in Leadership",
    "dept": "L L S",
    "num": "312",
    "desc": "Prereq: L L S 212\nTransfer of theories about learning and leadership to practice. Leading for change. Using knowledge of self and interactive skills to explore interdependence. Development of an action plan that addresses a real-world problem.\n",
    "credits": "3"
  },
  {
    "course_name": "Learning and Leadership in Practice",
    "dept": "L L S",
    "num": "412",
    "desc": "Prereq: L L S 312\nTeamwork in a practicum to execute a project that will positively change the community.  Application of learning and leadership theory: framing a problem, justifying approaches, taking action, getting feedback, and planning new actions.  Application to be accompanied by continual reflection and feedback.  Development of final portfolio to showcase cumulative leadership growth in the Learning and Leadership Sciences minor.\n",
    "credits": "3"
  },
  {
    "course_name": "Orientation for Open Option and Preprofessional Students",
    "dept": "LAS",
    "num": "101",
    "desc": "\nIntroduction to all undergraduate colleges. Provides information about university resources and services, assists with a successful academic transition to the university, and helps initiate the process of identifying academic major(s) and eventual career paths.  Required of all first-year students in Open Option and Preprofessional Programs.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Frontiers of the Discipline",
    "dept": "LAS",
    "num": "103",
    "desc": "\nLearning Community/ Seminar focusing entirely on the \"cutting edge\" research activities of faculty members.\n  Offered on a satisfactory-fail basis only.  A maximum of three total credits of LAS 103A, 103B, 103C, 103D, 103E can count for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Frontiers of the Discipline: General",
    "dept": "LAS",
    "num": "103A",
    "desc": "\nLearning Community/ Seminar focusing entirely on the \"cutting edge\" research activities of faculty members.\n  Offered on a satisfactory-fail basis only.  A maximum of three total credits of LAS 103A, 103B, 103C, 103D, 103E can count for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Frontiers of the Discipline: Humanities",
    "dept": "LAS",
    "num": "103B",
    "desc": "\nLearning Community/ Seminar focusing entirely on the \"cutting edge\" research activities of faculty members.\n  Offered on a satisfactory-fail basis only.  A maximum of three total credits of LAS 103A, 103B, 103C, 103D, 103E can count for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Frontiers of the Discipline: Communication",
    "dept": "LAS",
    "num": "103C",
    "desc": "\nLearning Community/ Seminar focusing entirely on the \"cutting edge\" research activities of faculty members.\n  Offered on a satisfactory-fail basis only.  A maximum of three total credits of LAS 103A, 103B, 103C, 103D, 103E can count for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Frontiers of the Discipline: Mathematics and Natural Sciences",
    "dept": "LAS",
    "num": "103D",
    "desc": "\nLearning Community/ Seminar focusing entirely on the \"cutting edge\" research activities of faculty members.\n  Offered on a satisfactory-fail basis only.  A maximum of three total credits of LAS 103A, 103B, 103C, 103D, 103E can count for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Frontiers of the Discipline: Social Sciences",
    "dept": "LAS",
    "num": "103E",
    "desc": "\nLearning Community/ Seminar focusing entirely on the \"cutting edge\" research activities of faculty members.\n  Offered on a satisfactory-fail basis only.  A maximum of three total credits of LAS 103A, 103B, 103C, 103D, 103E can count for graduation.",
    "credits": "1"
  },
  {
    "course_name": "BOLD Learning Community Orientation",
    "dept": "LAS",
    "num": "105",
    "desc": "Prereq: Member of the BOLD Learning Community.\nOrientation to the university for the \"Bridging Opportunities in Leadership and Diversity\" (BOLD) Learning Community students. Support for academic, social, and leadership development. Opportunity to connect with campus and college resources, explore career opportunities and build group identity. Includes regular one to one peer mentoring with multicultural student leaders.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "BOLD Learning Community Seminar",
    "dept": "LAS",
    "num": "106",
    "desc": "Prereq: Member of the BOLD Learning Community.\nContinued exploration of university services, academic, social, and leadership development for BOLD Learning Community students. Individual and group identity development. Includes regular one-on-one peer mentoring with multicultural student leaders and an assessed service-learning component.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Connections",
    "dept": "LAS",
    "num": "125",
    "desc": "Prereq: First year student\nLinks a large lecture class with a small learning community / seminar.  In each case the professor teaching the large lecture facilitates a small weekly seminar.  Informal discussions about critical issues of the day connected to lecture topics through films, public lectures and other events which students and the faculty leader attend.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Connections: General",
    "dept": "LAS",
    "num": "125A",
    "desc": "Prereq: First year student\nLinks a large lecture class with a small learning community / seminar.  In each case the professor teaching the large lecture facilitates a small weekly seminar.  Informal discussions about critical issues of the day connected to lecture topics through films, public lectures and other events which students and the faculty leader attend.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Connections: Humanities",
    "dept": "LAS",
    "num": "125B",
    "desc": "Prereq: First year student\nLinks a large lecture class with a small learning community / seminar.  In each case the professor teaching the large lecture facilitates a small weekly seminar.  Informal discussions about critical issues of the day connected to lecture topics through films, public lectures and other events which students and the faculty leader attend.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Connections: Communication",
    "dept": "LAS",
    "num": "125C",
    "desc": "Prereq: First year student\nLinks a large lecture class with a small learning community / seminar.  In each case the professor teaching the large lecture facilitates a small weekly seminar.  Informal discussions about critical issues of the day connected to lecture topics through films, public lectures and other events which students and the faculty leader attend.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Connections: Mathematics and Natural Sciences",
    "dept": "LAS",
    "num": "125D",
    "desc": "Prereq: First year student\nLinks a large lecture class with a small learning community / seminar.  In each case the professor teaching the large lecture facilitates a small weekly seminar.  Informal discussions about critical issues of the day connected to lecture topics through films, public lectures and other events which students and the faculty leader attend.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Connections: Social Sciences",
    "dept": "LAS",
    "num": "125E",
    "desc": "Prereq: First year student\nLinks a large lecture class with a small learning community / seminar.  In each case the professor teaching the large lecture facilitates a small weekly seminar.  Informal discussions about critical issues of the day connected to lecture topics through films, public lectures and other events which students and the faculty leader attend.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Dean’s Leadership Seminar I",
    "dept": "LAS",
    "num": "151",
    "desc": "Prereq: Selection based on application.\nBeginning to study leadership through applied examples, including the importance of community, communication, trust, shared responsibility, modeling the way, and inspiring a shared vision. Students will be introduced to campus leadership opportunities.\n",
    "credits": "1"
  },
  {
    "course_name": "Dean’s Leadership Seminar II",
    "dept": "LAS",
    "num": "152",
    "desc": "Prereq: Selection based on application.\nContinuing to study leadership through applied examples, including the importance of challenging the process, enabling others to act, and encouraging the heart. Students will engage more deeply in campus leadership opportunities.\n",
    "credits": "1"
  },
  {
    "course_name": "Pre-Law Seminar",
    "dept": "LAS",
    "num": "240",
    "desc": "\nPreparation for law school and careers in law. Introduction to the culture of law school, law school application process and admission criteria, strategies for Law School Admissions Test preparation, and how to finance a legal education.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "STEM Scholars Seminar",
    "dept": "LAS",
    "num": "245",
    "desc": "\nIntroduction to the culture of science at a research university. Concepts and strategies supporting success in science courses and in career pathways in science.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "LAS",
    "num": "290",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences.\nIndependent work as appropriate to the student’s degree program. Academic work under faculty supervision may include written projects, presentations, reports, and guided readings.\n",
    "credits": "1"
  },
  {
    "course_name": "Service Learning",
    "dept": "LAS",
    "num": "291",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIntegration of meaningful service work with instruction and reflection. Academic work may include written projects, presentations, reports, and guided readings.\n",
    "credits": "1"
  },
  {
    "course_name": "Service Learning: General",
    "dept": "LAS",
    "num": "291A",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIntegration of meaningful service work with instruction and reflection. Academic work may include written projects, presentations, reports, and guided readings.\n",
    "credits": "1"
  },
  {
    "course_name": "Service Learning: U.S. Diversity Project",
    "dept": "LAS",
    "num": "291B",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIntegration of meaningful service work with instruction and reflection with a US Diversity focus. Academic work may include written projects, presentations, reports, and guided readings.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "Service Learning: International Perspectives Project",
    "dept": "LAS",
    "num": "291C",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIntegration of meaningful service work with instruction and reflection with an International Perspectives focus. Academic work may include written projects, presentations, reports, and guided readings.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Projects",
    "dept": "LAS",
    "num": "293",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences.\nSpecial projects work supervised by the College of Liberal Arts and Sciences. Offered on a satisfactory-fail basis only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Special Projects: LAS Ambassadors",
    "dept": "LAS",
    "num": "293A",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Special Projects: Advising Project",
    "dept": "LAS",
    "num": "293B",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Special Projects: Career Services",
    "dept": "LAS",
    "num": "293C",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences.\nSpecial Project supervised by LAS Career Services.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Special Projects: General",
    "dept": "LAS",
    "num": "293D",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences.\nSpecial project supervised by the College of Liberal Arts and Sciences.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Internship/Co-op",
    "dept": "LAS",
    "num": "298",
    "desc": "Prereq: Permission of Liberal Arts and Sciences Career Services; Liberal Arts and Sciences majors; freshman or sophomore classification\nStudents participating in an internship or co-op on a full-time or part-time basis must register for this course prior to beginning their work experience to remain in student status.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Topics in Interdisciplinary Studies",
    "dept": "LAS",
    "num": "350",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Interdisciplinary Studies: Interdisciplinary",
    "dept": "LAS",
    "num": "350A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Interdisciplinary Studies: Humanities",
    "dept": "LAS",
    "num": "350B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Interdisciplinary Studies: Mathematics and Natural Science",
    "dept": "LAS",
    "num": "350C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Interdisciplinary Studies: Social Sciences",
    "dept": "LAS",
    "num": "350D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "LAS",
    "num": "399",
    "desc": "Prereq: Permission of the instructor or College of Liberal Arts and Sciences\nSupervised research.\n",
    "credits": "R"
  },
  {
    "course_name": "Independent Study",
    "dept": "LAS",
    "num": "490",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIndependent work as appropriate to the student’s degree program. Academic work under supervision; may include written projects, presentations, reports, and guided readings.\n  No more than 9 credits of LAS 490 may be applied toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: General",
    "dept": "LAS",
    "num": "490A",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIndependent work as appropriate to the student’s degree program. Academic work under supervision; may include written projects, presentations, reports, and guided readings.\n  No more than 9 credits of LAS 490 may be applied toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Entrepreneurial Studies",
    "dept": "LAS",
    "num": "490E",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIndependent work as appropriate to the student’s degree program. Academic work under supervision; may include written projects, presentations, reports, and guided readings. This section intended for students in the Entrepreneurial Studies Minor.\n  No more than 9 credits of LAS 490 may be applied toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Service Learning",
    "dept": "LAS",
    "num": "491",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIntegration of meaningful service work with advanced instruction and reflection. Academic work may include written projects, presentations, reports, and guided readings.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Service Learning: General",
    "dept": "LAS",
    "num": "491A",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIntegration of meaningful service work with advanced instruction and reflection. Academic work may include written projects, presentations, reports, and guided readings.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Service Learning: U.S. Diversity Project",
    "dept": "LAS",
    "num": "491B",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIntegration of meaningful service work with advanced instruction and reflection with a U.S. Diversity focus. Academic work may include written projects, presentations, reports, and guided readings.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Service Learning: International Perspectives Project",
    "dept": "LAS",
    "num": "491C",
    "desc": "Prereq: Permission of the College of Liberal Arts and Sciences\nIntegration of meaningful service work with advanced instruction and reflection with an International Perspectives focus. Academic work may include written projects, presentations, reports, and guided readings.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Internship/Co-op",
    "dept": "LAS",
    "num": "498",
    "desc": "Prereq: Permission of Liberal Arts and Sciences Career Services; Liberal Arts and Sciences majors; junior or senior classification\nStudents participating in an internship or co-op on a full-time or part-time basis must register for this course prior to beginning their work experience to remain in student status.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Internship",
    "dept": "LAS",
    "num": "499",
    "desc": "Prereq: Permission of Liberal Arts and Sciences Career Services; Liberal Arts and Sciences majors\nSemester-long internship appropriate to the student's degree program. Must include an academic component under faculty supervision such as written projects, reports, and guided reading. Students must register for this course prior to beginning their internship.\n",
    "credits": "1"
  },
  {
    "course_name": "Information Literacy",
    "dept": "LIB",
    "num": "160",
    "desc": "Prereq: For students placed in ENGL 101: Completion of ENGL 101 requirement.\nEight-week course required for undergraduate degree. Provides a solid understanding of information literacy and the research process with emphases on finding, evaluating, and using scholarly information; the ethical and legal framework related to information use; and utilization of library discovery tools. To be taken as early as possible in the student's undergraduate career. See course descriptions of ENGL 150 and ENGL 250 for requirements related to LIB 160.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to the Study of Linguistics",
    "dept": "LING",
    "num": "101",
    "desc": "\nCross-disciplinary perspectives on the study of linguistics.  Applications of linguistics to real world problems.  Careers in linguistics.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to World Languages",
    "dept": "LING",
    "num": "119",
    "desc": "\nStudy of language diversity and the personal, social and political effects of diversity. Language families, attitudes toward language and language use, language and culture, multilingualism, foreign language learning, written codes, official languages, and language policy.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Computers and Language",
    "dept": "LING",
    "num": "120",
    "desc": "\nIntroduction to the use of linguistic knowledge in computer applications today and the basic computational techniques used in such applications. The development of these techniques throughout the history of computational linguistics. How the study of language has contributed to the advancement of technology and how certain computational problems have influenced the way linguists study language.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Symbolic Logic",
    "dept": "LING",
    "num": "207",
    "desc": "\nIntroduction to fundamental logical concepts and logical symbolism. Development of natural deduction through first order predicate logic with identity. Applications to arguments in ordinary English and to philosophical issues. Linguistics majors should take LING/PHIL 207 as early as possible.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Linguistics",
    "dept": "LING",
    "num": "219",
    "desc": "Prereq: Sophomore classification\nIntroduction to linguistic concepts and principles of linguistic analysis with English as the primary source of data. Sound and writing systems, sentence structure, vocabulary, and meaning. Issues in the study of usage, regional and social dialects, language acquisition, and language change.\n",
    "credits": "3"
  },
  {
    "course_name": "Descriptive English Grammar",
    "dept": "LING",
    "num": "220",
    "desc": "Prereq: ENGL 250\nOverview of grammatical structures and functions. Parts of speech; phrase, clause, and sentence structure; sentence types and sentence analysis; rhetorical grammar and sentence style; terminology. Not a remedial, English composition, or ESL course.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Communication Disorders",
    "dept": "LING",
    "num": "275",
    "desc": "\nSurvey of nature, causes, and types of major communication disorders including phonological, adult and child language, voice, cleft palate, fluency, and hearing disorders.\n",
    "credits": "3"
  },
  {
    "course_name": "Communicating with the Deaf",
    "dept": "LING",
    "num": "286",
    "desc": "\nLearn to communicate with the deaf using Signed English and Signed Pidgin English.  Other topics covered include types, causes, and consequences of hearing loss, hearing technology (hearing aids, assistive listening devices, and cochlear implants), education of hearing-impaired children, Deaf culture, and the history of manual communication.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Language, Thought and Action",
    "dept": "LING",
    "num": "305",
    "desc": "Prereq: ENGL 250\nThe study of symbolic processes and how meaning is conveyed in words, sentences, and utterances; discussion of modern theories of meaning; and an exploration of relationships among language, thought and action.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Culture and Language",
    "dept": "LING",
    "num": "309",
    "desc": "Prereq: ANTHR 201 recommended\nIntroduction to study of language, culture and society from an anthropological perspective. Focus on language and thought,   ethnography of speaking, discourse and narrative, writing and literacy, and media communication. Discussion of key theories and   methods of linguistic anthropology.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to ESL methods and materials",
    "dept": "LING",
    "num": "318",
    "desc": "Prereq: ENGL/LING 219\nIntroduction to methods and materials for teaching English as a Second Language (ESL) for elementary and secondary students. Strategies and resources for teaching reading, writing, speaking and listening skills. Elementary Education students must take this course in the same semester as either CI 280S or CI 480S.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Language and Diversity",
    "dept": "LING",
    "num": "319",
    "desc": "Prereq: ENGL 250\nSpecial topics related to the role of language and linguistics in US diversity, such as Dialects and American literature, American English Accents, Legal and Social Aspects of English-only Laws in the US. Connections between language use and social diversity.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Linguistic Structure",
    "dept": "LING",
    "num": "320",
    "desc": "Prereq: ENGL 219/LING 219, ENGL 220/LING 220\nSpecial topics related to the study of linguistic structure. Focus on language structure in areas not covered in detail by existing courses. Topics include field linguistics, morphology, forensic linguistics, neurolinguistics, semantics, non-English phonology, acoustic phonetics, linguistic universals, and historical linguistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Language and Society",
    "dept": "LING",
    "num": "322",
    "desc": "Prereq: ENGL/LING 219\nIntroduction to variation in language use in society. Survey of factors affecting language use, including background characteristics of language users, location, and purpose of interaction in addition to institutional, state, and national language policies.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Teaching ESL Literacy",
    "dept": "LING",
    "num": "324",
    "desc": "Prereq: ENGL/LING 219\nIntroduction to the issues and methods involved in teaching literacy skills to English as a second language (ESL) learners. The nature of literacy and materials and methods for developing ESL literacy at the middle school, high school, and adult ages across multiple levels of competency.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Methods for ESL Learners: Oral Communication Skills",
    "dept": "LING",
    "num": "325",
    "desc": "Prereq: ENGL/LING 219\nIssues and methods in teaching oral communication skills (listening, speaking, pronunciation) to English as a second language (ESL) learners. The nature of oral language ability. Materials and Methods for developing oral communication skills at middle school, high school, and adult contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory of Computing",
    "dept": "LING",
    "num": "331",
    "desc": "Prereq: Minimum of C- in COM S 228, MATH 166, and in COM S 230 or CPR E 310;  ENGL 250\nModels of computation: finite state automata, pushdown automata and Turing machines. Study of grammars and their relation to automata. Limits of digital computation, unsolvability and Church-Turing thesis. Relations between classes of languages.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish-English Translation",
    "dept": "LING",
    "num": "351",
    "desc": "Prereq: SPAN 303A or SPAN 303B or SPAN 304\nIntroduction to the theory, methods, techniques, and problems of translation. Consideration of material from business, literature, and the social sciences. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish Phonology",
    "dept": "LING",
    "num": "352",
    "desc": "Prereq: SPAN 303A or SPAN 303B or SPAN 304\nAn introductory study of the articulation, classification, distribution, and regional variations of the sounds of the Spanish language. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish-English Interpretation",
    "dept": "LING",
    "num": "354",
    "desc": "Prereq: SPAN 351\nIntroduction to the theory, methods, techniques, and problems of consecutive and simultaneous interpretation.  Consideration of material from business, agriculture, law, design, medicine, literature, advertisement, and sports. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Phonetics and Phonology",
    "dept": "LING",
    "num": "371",
    "desc": "Prereq: ENGL 219\nTerminology, theory, research, and applications of the science of the sounds of spoken language. Emphasis on American English and International Phonetic Alphabet.\n",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad",
    "dept": "LING",
    "num": "395",
    "desc": "\nInstruction in issues of language policy, practice and learning. Observation and experience with language use outside of the United States.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Language as Data",
    "dept": "LING",
    "num": "410",
    "desc": "Prereq: Junior standing\nMethods of discovering language patterns in text documents solve practical text analysis problems in the disciplines. Fundamentals of linguistics and its role in text analysis. Practice writing R scripts to perform text analysis and visualize textual data.\n",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Language",
    "dept": "LING",
    "num": "413",
    "desc": "Prereq: PSYCH 101\nIntroduction to psycholinguistics. Topics may include origin of language, speech perception, language comprehension, reading, bilingualism, brain bases of language, and computational modeling of language processes.\n",
    "credits": "3"
  },
  {
    "course_name": "History of the English Language",
    "dept": "LING",
    "num": "420",
    "desc": "Prereq: ENGL 219 or LING 219, ENGL 220 or LING 220\nComparison of English to other languages by family background and by type.  Analysis of representative Old, Middle, Early Modern   and present-day English texts, including both literary works and non-literary documents.\n",
    "credits": "3"
  },
  {
    "course_name": "Women, Men, and the English Language",
    "dept": "LING",
    "num": "422",
    "desc": "Prereq: ENGL 219 or LING 219\nThe ways men and women differ in using language in varied settings and the ways in which language both creates and reflects gender divisions.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Second Language Learning and Teaching",
    "dept": "LING",
    "num": "425",
    "desc": "Prereq: ENGL 219 or LING 219; junior classification\nThe process of second language learning and principles and techniques of teaching second languages. Learning and teaching in specific situations and for particular purposes. Current applications of technology in teaching and assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Grammatical Analysis",
    "dept": "LING",
    "num": "437",
    "desc": "Prereq: ENGL 220 or LING 220; ENGL 219 or LING 219 or introductory course in linguistics; junior classification\nTheories and methods for analysis of syntax and morphology.\n",
    "credits": "3"
  },
  {
    "course_name": "Contrastive Analysis of Spanish/ English for Translators",
    "dept": "LING",
    "num": "462",
    "desc": "Prereq: SPAN 351\nLinguistic study of the major differences between the Spanish and English grammatical systems and their applications in the translation of Spanish to English. Taught in Spanish.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Spanish Linguistics",
    "dept": "LING",
    "num": "463",
    "desc": "Prereq: SPAN 352\nStudy of various topics related to the Spanish language. Topics may include bilingualism, historical linguistics and dialectology, Spanish in the U.S., language assessment, computer-assisted language learning and instruction, and second language acquisition. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Language and Reading Development in Children",
    "dept": "LING",
    "num": "471",
    "desc": "Prereq: CMDIS 275 or PSYCH 230 or ENGL 219 or LING 219\nDevelopment of spoken language, reading and writing covering semantics, syntax, morphology, phonology, and pragmatics.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Communication Disorders",
    "dept": "LING",
    "num": "480",
    "desc": "Prereq: CMDIS/LING 275, CMDIS/LING 371, and BIOL 255; permission of instructor.\nGuided examination of topics in preparation for graduate work in Speech-Language Pathology or Audiology. Primary course delivery by WWW.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Communication Disorders: Anatomy and Physiology of Speech and Hearing",
    "dept": "LING",
    "num": "480A",
    "desc": "Prereq: CMDIS/LING 275, CMDIS/LING 371, and BIOL 255; permission of instructor.\nStructures and functions of respiratory, phonatory, articulatory, auditory, and nervous systems as they relate to speaking and listening.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Communication Disorders: Articulation and Phonological Disorders",
    "dept": "LING",
    "num": "480B",
    "desc": "Prereq: CMDIS/LING 275, CMDIS/LING 371, and BIOL 255; permission of instructor.\nChildren’s acquisition of English speech sounds. Assessment and management of speech sound disorders in children and adults.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Communication Disorders: Evaluation and diagnosis of communication disorders",
    "dept": "LING",
    "num": "480C",
    "desc": "Prereq: CMDIS/LING 275, CMDIS/LING 371, and BIOL 255; permission of instructor.\nAssessment and diagnosis of speech, language, and swallowing disorders. Preparation of clinical reports based on assessment data.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Elementary School World Language Instruction",
    "dept": "LING",
    "num": "486",
    "desc": "Prereq: 25 credits in a world language\nPlanning, implementation, and assessment of standards-based, student-centered, and thematic instruction in the elementary (K-8) classroom.  Special emphasis on K-8 students' communicative skills, cultural knowledge, and content learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Secondary School World Language Instruction",
    "dept": "LING",
    "num": "487",
    "desc": "Prereq: 25 credits in a world language, admission to the teacher education program, OPI\nTheories and principles of contemporary world language learning and teaching. Special emphasis on designing instruction and assessments for active learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study: Linguistics",
    "dept": "LING",
    "num": "490B",
    "desc": "Prereq: 9 credits in English beyond ENGL 250 appropriate to the section taken, junior classification, permission of Undergraduate Studies Committee or Linguistics Adviser\nDesigned to meet the needs of students who wish to study in areas other than those in which courses are offered.\n  No more than 9 credits of ENGL 490 may be used toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Linguistic Anthropology",
    "dept": "LING",
    "num": "490D",
    "desc": "Prereq: 9 credits in anthropology.\n  No more than 9 credits of Anthr 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Fieldwork in Communication Disorders",
    "dept": "LING",
    "num": "492",
    "desc": "Prereq: CMDIS/LING 371;471; completion or concurrent enrollment in CMDIS/LING 480A or 480B or 480C\nGuided observation of clinical evaluation and treatment in Communication Disorders on campus and in the community. Assessed service learning component.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Computers in Applied Linguistics",
    "dept": "LING",
    "num": "510",
    "desc": "Prereq: Graduate classification\nUse of software and web applications for language teaching, linguistic analysis, and statistical analysis. Issues and problems in applied linguistics related to computer methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Linguistic Analysis",
    "dept": "LING",
    "num": "511",
    "desc": "Prereq: Graduate classification\nPrinciples and methods of linguistic analysis with emphasis on phonology, morphology, and syntax. Description of linguistic variation and current theoretical approaches to linguistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Second Language Acquisition",
    "dept": "LING",
    "num": "512",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nTheory, methods, and results of second language acquisition research with emphasis on approaches relevant to second language teaching.\n",
    "credits": "3"
  },
  {
    "course_name": "Language Assessment Practicum",
    "dept": "LING",
    "num": "513",
    "desc": "Prereq: ENGL 519 or LING 519\nAdvanced practicum in language assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Sociolinguistics",
    "dept": "LING",
    "num": "514",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nTheories and methods of examining language in its social setting. Analysis of individual characteristics (e.g., age, gender, ethnicity, social class, region), interactional factors (e.g., situation, topic, purpose) and national policies affecting language use.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Natural Language Processing",
    "dept": "LING",
    "num": "515",
    "desc": "Prereq: STAT 330 or equivalent, recommended ENGL 219 or LING 219, or ENGL 511 or LING 511\nIntroduction to computational techniques involving human language and speech in applications such as information retrieval and extraction, automatic text categorization, word prediction, intelligent Web searching, spelling and grammar checking, speech recognition and synthesis, statistical machine translation, n-grams, POS-tagging, word-sense disambiguation, on-line lexicons and thesauri, markup languages, corpus analysis, and Python programming language.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Formal Linguistic Analysis",
    "dept": "LING",
    "num": "516",
    "desc": "Prereq: ENGL 219/LING 219 or equivalent.\nData and knowledge structures for formal representation of natural language and speech data. Designing and implementing algorithms for automating linguistic analysis tasks. Conceptual issues for natural language and speech processing programming.\n",
    "credits": "3"
  },
  {
    "course_name": "Second Language Assessment",
    "dept": "LING",
    "num": "519",
    "desc": "Prereq: ENGL 511 or LING 511\nPrinciples of second language assessment including reliability, validity, authenticity and practicality. Constructing, scoring,   interpreting, and evaluating second language tests for a variety of situations.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Analysis of English",
    "dept": "LING",
    "num": "520",
    "desc": "Prereq: ENGL 510 or LING 510, and ENGL 511 or LING 511\nConcepts and practices for analysis of English by computer with emphasis on the applications of computational analysis to problems   in applied linguistics such as corpus analysis and recognition of learner language in computer-assisted learning and language   assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Literacy: Issues and Methods for Nonnative Speakers of English",
    "dept": "LING",
    "num": "524",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nTheoretical and practical issues and techniques in the teaching of literacy in a variety of contexts, involving children and adults at basic skill levels and teens and adults in academic and vocational programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Research and Teaching of Second Language Pronunciation",
    "dept": "LING",
    "num": "525",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nTheoretical and practical issues and techniques in the teaching of second language pronunciation as it relates to other areas of language, especially listening and speaking skills. Topics will include segmental and suprasegmental features; intelligibility; pronunciation in language assessment; classroom, technology and individual instruction; and research issues. Topics will be relevant to those intending to teach or research in various contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer-Assisted Language Learning",
    "dept": "LING",
    "num": "526",
    "desc": "Prereq: ENGL 511 or LING 511 or equivalent\nTheory, research, and practice in computer use for teaching nonnative speakers of English. Methods for planning and evaluating computer-based learning activities.\n",
    "credits": "3"
  },
  {
    "course_name": "Discourse Analysis",
    "dept": "LING",
    "num": "527",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nMethods and theoretical foundations for linguistic approaches to discourse analysis. Applications of discourse analysis to the study of texts in a variety of settings, including academic and research contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "English for Specific Purposes",
    "dept": "LING",
    "num": "528",
    "desc": "Prereq: ENGL 511 or LING 511 or an introductory course in linguistics\nIssues and techniques in analyzing, teaching, and assessing English for specific purposes. Topics include theories of specific purpose language use, analysis of learner needs in target language contexts, and corpus-informed syllabus and materials development for teaching and assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology and Oral Language",
    "dept": "LING",
    "num": "530",
    "desc": "Prereq: ENGL 219 or ENGL 511 or equivalent.\nStructure and description of oral language and discourse. How spoken language is linguistically described, analyzed, and taught for research and for education. Using technology to record, transcribe, and analyze spoken language at all levels of linguistic structure.\n",
    "credits": "3"
  },
  {
    "course_name": "Corpus Approaches to Grammatical Analysis",
    "dept": "LING",
    "num": "537",
    "desc": "Prereq: ENGL 220 or LING 220; ENGL 219, LING 219, ENGL 511, LING 511, or introductory course in linguistics; graduate classification\nCorpus-informed analysis of syntax in authentic writing and speech, with emphasis on approaches used in applied linguistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish-English Interpretation",
    "dept": "LING",
    "num": "554",
    "desc": "Prereq: SPAN 351\nIntroduction to the theory, methods, techniques, and problems of consecutive and simultaneous interpretation.  Consideration of material from business, agriculture, law, design, medicine, literature, advertisement, and sports. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Supervised Practice Teaching in Teaching English as a Second Language",
    "dept": "LING",
    "num": "588",
    "desc": "Prereq: 9 credits toward the TESL/TEFL Certificate, 15 credits toward the TESL/AL master's degree, or 18 credits completed toward the ESL Endorsement option.\nIntensive observation of ESL instruction and supervised practice in teaching learners of English in a context appropriate to the student teacher's goals.\n  ENGL 588 cannot be used for teacher licensure and cannot be taken during student teaching.",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "LING",
    "num": "590",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Teaching English as a Second Language (TESL)/Applied Linguistics",
    "dept": "LING",
    "num": "590B",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Applied Linguistics and Technology",
    "dept": "LING",
    "num": "590G",
    "desc": "Prereq: Permission of the Director of Graduate Education according to guidelines available online\n",
    "credits": "arr"
  },
  {
    "course_name": "Studies in Applied Linguistics",
    "dept": "LING",
    "num": "591",
    "desc": "Prereq: 6 credits in TESL/Applied Linguistics\nIntensive study of applied linguistic theory as it relates to specific issues in language acquisition, teaching, or use.\n",
    "credits": "3"
  },
  {
    "course_name": "Directed Readings: Teaching English as a Second Language (TESL)/Applied Linguistics",
    "dept": "LING",
    "num": "591B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Directed Readings: Applied Linguistics and Technology",
    "dept": "LING",
    "num": "591G",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research Methods in Applied Linguistics",
    "dept": "LING",
    "num": "623",
    "desc": "Prereq: ENGL 511 or LING 511\nSurvey of research traditions in applied linguistics. Focus on theoretical and practical aspects of quantitative and qualitative approaches to applied linguistic study, including experimental and quasiexperimental methods, classroom observation and research, introspective methods, elicitation techniques, case studies, interactional analysis, ethnography, and program evaluation. Computational tools and resources for linguistic research will be highlighted.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer-Assisted Language Testing",
    "dept": "LING",
    "num": "626",
    "desc": "Prereq: ENGL 510 or LING 510, ENGL 511 or LING 511, ENGL 519 or LING 519\nPrinciples and practice for the use and study of computers and the Internet in second language assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Applied Linguistics",
    "dept": "LING",
    "num": "630",
    "desc": "Prereq: ENGL 510 or LING 510, ENGL 511 or LING 511\nTopic changes each semester. Topics include advanced methods in natural language processing, technology and literacy in a global context, feedback in CALL programs, technology and pronunciation, and advances in language assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Computer Programming",
    "dept": "MIS",
    "num": "207",
    "desc": "Prereq: MATH 150 or placement into MATH 140 or higher\nAn introduction to computer programming using an object-oriented programming language. Emphasis on the basics of good programming techniques and style. Extensive practice in designing, implementing, and debugging small programs. Use of abstract data types. Interactive and file I/O. This course is not designed for computer science, software engineering, and computer engineering majors.\n  Credit may not be applied toward graduation for both Com S 207/MIS 207 and Com S 227.",
    "credits": "3"
  },
  {
    "course_name": "Management Information Systems",
    "dept": "MIS",
    "num": "301",
    "desc": "Prereq: COM S 113 or BUSAD 150\nThe role of information technology in organizations. Overview of methodologies for design and development of systems including decision support systems, expert systems, data bases, end-user computing, etc. Computer applications relate concepts to practice. Lecture and laboratory work emphasizes the enabling role of IT in contemporary organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Business Programming",
    "dept": "MIS",
    "num": "307",
    "desc": "Prereq: MIS 207/COM S 207 or COM S 227; credit or enrollment in MIS 301\nIntroduction to the concepts and use of data structures, file accesses and object oriented programming methodologies in contemporary business environments. Application development environments will be covered.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Systems Analysis",
    "dept": "MIS",
    "num": "310",
    "desc": "Prereq: credit or enrollment in MIS 301\nCritical analysis of business processes, data and process modeling, feasibility studies, CASE tools, and developing system design specifications.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Data Streams and Issues",
    "dept": "MIS",
    "num": "315",
    "desc": "Prereq: COM S 113, MIS 301, ACCT 284\nIdentification of open data sources and other private data sources. Develop methods of data access, collection, and sharing; develop methods to validate and standardize data sources; develop methods to assess data worthiness (risk).\n",
    "credits": "3"
  },
  {
    "course_name": "Database Management Systems",
    "dept": "MIS",
    "num": "320",
    "desc": "Prereq: Credit or enrollment in MIS 301\nDatabase design, development, and implementation. Focus on data models, both classical and object oriented. Uses relational and/or object oriented database management systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Project Management",
    "dept": "MIS",
    "num": "340",
    "desc": "Prereq: credit or enrollment in MIS 301\nEquips students to support team activities in the general project management environment and better manage their careers. Practical experience using project management techniques and tools. Course topics include project initiation and execution, risk assessment, estimating and contracts, planning, human factors, and standard methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Analytics",
    "dept": "MIS",
    "num": "368",
    "desc": "Prereq: MKT 340\nUse of different tools to conduct various analyses to support marketing strategies. Topics include data visualization and exploration, forecasting, social media analytics and other marketing techniques. Development of skills such as structuring problems, and synthesizing results from quantitative analyses.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Business Programming",
    "dept": "MIS",
    "num": "407",
    "desc": "Prereq: MIS 307\nAdvanced software development and topics in contemporary programming languages. Topics include basic syntax, advanced programming techniques, file structures and management, database access, algorithm design, web forms and graphical user interfaces.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Commerce Strategy",
    "dept": "MIS",
    "num": "434",
    "desc": "Prereq: MIS 301, MKT 340, SCM 301\nOverview of business strategies and technologies used for electronic commerce. Emphasis is on the strategic, operational, and technical issues associated with global electronic commerce using class lecture/discussion and case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Systems Infrastructure",
    "dept": "MIS",
    "num": "435",
    "desc": "Prereq: MIS 301\nOverview of Internet and telecommunications technology used in business applications. Understand Internet and network protocols, network and application architectures, design, and implementation.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Business Analytics",
    "dept": "MIS",
    "num": "436",
    "desc": "Prereq: MIS 320\nIntroduction to the field of business analytics (BA). Students will examine BA processes and techniques used in transforming data to knowledge and creating value for organizations. Business cases, presentations by business professionals, class lectures and discussions on data analysis, design and modeling, and extensive hands-on analytical exercises.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Management of Information Systems",
    "dept": "MIS",
    "num": "439",
    "desc": "Prereq: MIS 301, permission of instructor\nA variety of topics will be covered and topics may vary between semesters. Some of the topics are information resources management, electronic commerce, decision support systems, and expert systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Supply Chain Information Systems",
    "dept": "MIS",
    "num": "440",
    "desc": "Prereq: MIS 301, SCM 301\nInternal and inter-organizational information systems necessary for a supply chain to achieve competitive advantage. Topics include: design, development, implementation, and maintenance of supply chain information systems; enterprise resource planning; advanced planning and scheduling, manufacturing execution systems; and the interface between manufacturing planning and control processes, logistics processes, and the information system.\n",
    "credits": "3"
  },
  {
    "course_name": "Enterprise Systems and Architecture",
    "dept": "MIS",
    "num": "445",
    "desc": "Prereq: MIS 301\nContemporary theories, concepts, and practices in network infrastructure, network design, and information security. Design, install, and administer a complex network infrastructure. Study security threats and attacks and countermeasures. Investigate exposure to attacks, firewalls, and development of intrusion detection systems. Other security topics such as risk management, IT audit, and security regulations will also be addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Business Analytics",
    "dept": "MIS",
    "num": "446",
    "desc": "Prereq: MIS 301 and MIS 320\nProjects-based course which provides an in-depth understanding of BA methods of visualization, data mining, text mining, web-mining, and predictions through the use of specific BA tools. For students who are interested in understanding advanced techniques and applications of data analytics and acquiring hands-on skills for making intelligent business decisions in data-rich organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Information Systems Development",
    "dept": "MIS",
    "num": "447",
    "desc": "Prereq: MIS 301 and MIS 310\nDesign of business systems using contemporary tools and methods such as SQL, CASE tools, OOD tools, etc. Focuses on synthesizing concepts from earlier MIS courses.\n",
    "credits": "3"
  },
  {
    "course_name": "Enterprise Resource Planning Systems in Supply Chain",
    "dept": "MIS",
    "num": "450",
    "desc": "Prereq: SCM 301, MIS 301 or I E 148, I E 341\nExamination of the role of enterprise resource planning systems (ERP) in the supply chain. Hands-on experience with a major software application in use by many corporations to manage and improve the efficiency of their supply chains and operations. Students will develop a more process-centric perspective about how a supply chain operates and how ERP enables and supports such operations.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "MIS",
    "num": "490",
    "desc": "Prereq: MIS 301, senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Case Practicum",
    "dept": "MIS",
    "num": "495",
    "desc": "Prereq: MIS 301\nStudents explore different practical scenarios related information systems projects and cases. Students acquire necessary skills and knowledge to solve practical issues associated with presented cases and problems. Students compete at different venues around the country.\n",
    "credits": "3"
  },
  {
    "course_name": "Management Information Systems",
    "dept": "MIS",
    "num": "501",
    "desc": "Prereq: Enrollment in MBA program or departmental permission.\nThis course exposes the student to current theories and practices appropriate for understanding the role and application of information systems for individuals, organizations, and society within a globally competitive context.  The course focuses on information technology and its uses in improving work practices, products, and tools for individuals and organizations. The course also addresses issues pertaining to current and emerging topics in the development and use of technology, the role of technology in and its alignment with organizational strategy and sustainable business practices, information system planning and the development of enterprise architectures, and human interface and personal characteristics in the design and use of technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Data",
    "dept": "MIS",
    "num": "515",
    "desc": "\nUnderstanding the issues and challenges of data from multiple sources, different velocities, in large volumes with questionable veracity.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Business Software Development",
    "dept": "MIS",
    "num": "532",
    "desc": "\nA survey of business-oriented programming languages with emphasis on state-of-the-art development techniques for business software. Topics include object-oriented and Internet programming issues and methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Data Management for Decision Makers",
    "dept": "MIS",
    "num": "533",
    "desc": "Prereq: MIS 501\nAddresses data needs of functions such as marketing, finance, and production. Advanced skills needed to design, develop and use database, data warehousing and data mining systems for effective decision support. Emphasis on importance of contemporary technologies.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Commerce",
    "dept": "MIS",
    "num": "534",
    "desc": "Prereq: MIS 501\nOverview of how modern communication technologies including the internet and world wide web have revolutionized the way we do business. Provides an understanding of various internet technologies and how companies are using the internet for commercial purposes. Explores future scenarios on the use of these technologies and their impact on various industries and the society.\n",
    "credits": "3"
  },
  {
    "course_name": "Networks and Information Security Management",
    "dept": "MIS",
    "num": "535",
    "desc": "Prereq: MIS 501\nIssues involved in the management of telecommunications function. Overview of communications technology used in various business applications, local area network, wide area network, broad band network, wireless and voice networks. Internet technologies and protocols. Analyzing the strategic impact of these technologies on organizations. Strategic planning for telecommunications, including network planning and analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Analytics Foundation",
    "dept": "MIS",
    "num": "536",
    "desc": "\nIntroduction to Business Analytics (BA) concepts and tools. Hands-on lab exercises and business case studies in data preparation, data querying and data visualization. Also covers various modeling techniques in predictive and prescriptive analytics.\n",
    "credits": "3"
  },
  {
    "course_name": "Project Management",
    "dept": "MIS",
    "num": "537",
    "desc": "Prereq: MIS 501\nPrepares students to support team activities in the general project management environment and provides them with a working understanding of the full scope of project management activities.  Students will also have practical experience using project management techniques and tools. Course topics include project initiation and execution, risk assessment, estimating and contracts, planning, human factors, and standard methods.  The course follows the recommended content areas of the Project Management Institute, and provides students with a recognized foundational training in project management.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Process Systems",
    "dept": "MIS",
    "num": "538",
    "desc": "Prereq: MIS 501\nExamine current and historical perspectives on business process management. Topics include process identification, mapping, and improvement. Additional topics will address business process automation and integration, business process outsourcing. Investigate current and potential tools and methods for business process management. Include process management projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Management of Information Systems",
    "dept": "MIS",
    "num": "539",
    "desc": "Prereq: MIS 501\nA variety of topics may be offered in different semesters. Topics may include electronic commerce, information resources management, decision support systems, and expert systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Media Business Applications and Analytics",
    "dept": "MIS",
    "num": "544",
    "desc": "Prereq: NONE\nThis course is designed to educate students about the  the role of new collaborative social technologies and analysis of social media data. Exploration of strategic and operational applications of social media and of tools that support the analysis of social network and social media data. Application of text analysis and social network theory.\n  None",
    "credits": "3"
  },
  {
    "course_name": "Advanced Business Analytics",
    "dept": "MIS",
    "num": "546",
    "desc": "\nAn in-depth discussion of various advanced topics in Business Analytics (BA) such as Big Data Analytics, Text Analytics, and Web Analytics. Extensive hands-on exercises of using BA tools to solve real-world problems. Preparation for students’ capstone projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Teams, Communication, and Project Management",
    "dept": "MIS",
    "num": "547",
    "desc": "\nProvides business analytics students with an intensive preparation in teamwork and project management skills necessary to prosper in the program and carry forward into their professional lives. The course topics include project management, team management, in class exercises, and case studies. Practical experience using project management techniques and tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Business Analytics Capstone Project",
    "dept": "MIS",
    "num": "556",
    "desc": "Prereq: MIS 547 or departmental permissions\nSynthesize analytics concepts, skills, and practices learned during the program of study to complete a course project. Projects proposals relevant to a firm are proposed and accepted midway through the program. Student cohort teams will complete the capstone project under the supervision of an advisory team of faculty. At the completion of the course teams will present their project marking the completion of the program of study.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Marketing Analytics",
    "dept": "MIS",
    "num": "568",
    "desc": "\nIntegration of various concepts to solve problems using appropriate tools. Specifically, the course consist of the following three components: (a) help students develop consultative problem-solving skills; (b) introduce various newly developed consumer behavior theories; (c) provide an overview of quantitative models in the field of marketing analytics. Hands-on experiences to enhance skills such as formulating problems, structuring and prioritizing problems, synthesizing results and communicating intuition from complicated analyses.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "MIS",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nFor students wishing to do individual research in a particular area of MIS.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar in Management Information Systems",
    "dept": "MIS",
    "num": "598",
    "desc": "Prereq: Graduate classification\nExamines issues such as the nature and content of information systems research; aspects of starting and pursuing research topics in information systems; exploring and understanding relevant research methods and tools. Develop preliminary research proposals.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "MIS",
    "num": "599",
    "desc": "Prereq: Graduate classification, permission of supervisory committee chair\nPreparation and writing of creative component.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Information Systems Research I",
    "dept": "MIS",
    "num": "601",
    "desc": "Prereq: MIS 501 or equivalent, enrollment in PhD program\nThe state of behavioral research in the IS function.  MIS activities in an organization span the following three major areas: design and implementation of the MIS, use of the MIS, and management of the MIS function.  Each of these processes is carried out at several levels: individual, group, organizational and inter-organizational.  Identify behavioral issues of relevance for the cells defined by the process and level dimensions. Reading and discussion of the research literature surrounding the development, use, and implications of information technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Information Systems Research II",
    "dept": "MIS",
    "num": "602",
    "desc": "Prereq: MIS 501 or equivalent, enrollment in PhD program\nThree fundamental areas of Information Systems, namely, infrastructure, management, and processes. Infrastructure studies examine the IT architecture including computing, communication, data, and application. Management focuses on addressing the value added notion of IT. Finally processing addresses topics related to enabling role of IT in myriad of areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on IT Strategy and Structure",
    "dept": "MIS",
    "num": "603",
    "desc": "Prereq: MIS 601\nStrategic issues in IT management.  Address issues such as aligning IT strategy with corporate strategy and functional strategies, IT structure, valuation, governance and control, and related topics.  Provide students with research skills related to the boundary between IT and the firm's external environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Collaboration, Knowledge, and Intelligence in Organizations",
    "dept": "MIS",
    "num": "604",
    "desc": "Prereq: MIS 601\nResearch issues in the emerging areas of collaboration, knowledge management, and enterprise intelligence. Topics will include emerging and contemporary technologies of Data Mining, Knowledge Discovery from Databases, Web Mining, organizational memory, and knowledge management.\n",
    "credits": "3"
  },
  {
    "course_name": "Technical Research Methods in Information Systems",
    "dept": "MIS",
    "num": "605",
    "desc": "Prereq: MIS 501 or equivalent, enrollment in PhD program\nFocuses on analytical modeling and empirical analyses using methods drawn from economics, management science, and statistics/econometrics, etc. Example topics include economics of information goods; impact of information technologies on firm performance and policy outcomes; and analysis of data generated from social media and business transactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Economic Research Methods in Information Systems",
    "dept": "MIS",
    "num": "606",
    "desc": "Prereq: MIS 501 or equivalent, enrollment in PhD program\nFocuses on analytical modeling and empirical analyses using methods drawn from economics, management science, and statistics/econometrics, etc. Example topics include economics of information goods; impact of information technologies on firm performance and policy outcomes; and analysis of data generated from social media and business transactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Practicum I",
    "dept": "MIS",
    "num": "650",
    "desc": "Prereq: enrollment in the PhD program\nPreparation of a research manuscript to be submitted to a peer-reviewed academic journal. Students will work with a faculty mentor on a research project.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Practicum II",
    "dept": "MIS",
    "num": "651",
    "desc": "Prereq: enrollment in the PhD program\nPreparation of a second research manuscript to be submitted to a peer-reviewed academic journal. Although students work under the supervision of a faculty mentor, the students will take independent responsibility for the research project.\n",
    "credits": "1"
  },
  {
    "course_name": "Organizational and Social Implications of Human Computer Interaction",
    "dept": "MIS",
    "num": "655",
    "desc": "Prereq: Graduate classification\nExamine opportunities and implications of information technologies and human computer interaction on social and organizational systems. Explore ethical and social issues appurtenant to human computer interaction, both from a proscriptive and prescriptive perspective. Develop informed perspective on human computer interaction. Implications on research and development programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "MIS",
    "num": "699",
    "desc": "Prereq: Graduate classification, permission of dissertation supervisor\nResearch.\n",
    "credits": "3"
  },
  {
    "course_name": "Entrepreneurship and Innovation",
    "dept": "MGMT",
    "num": "310",
    "desc": "Prereq: Sophomore classification\nReview of the entrepreneurial process with emphasis on starting a new business. How to analyze opportunities, develop an innovative product, organize, finance, market, launch, and manage a new venture. Deals with the role of the entrepreneur and the importance of a business plan. Speakers and field project.\n",
    "credits": "3"
  },
  {
    "course_name": "Feasibility Analysis and Business Planning",
    "dept": "MGMT",
    "num": "313",
    "desc": "Prereq: MGMT 310\nDeveloping an idea for a new business venture, conducting a feasibility study, researching the potential market, analyzing the competition, and writing a formal business plan. Basic business functions are discussed in terms of their application to conducting feasibility analysis and writing a business plan for an entrepreneurial venture.\n",
    "credits": "3"
  },
  {
    "course_name": "Corporate Entrepreneurship, Innovation and Technology Management",
    "dept": "MGMT",
    "num": "320",
    "desc": "Prereq: MGMT 310\nEntrepreneurial approaches aimed at the identification, development and exploitation of technical and organizational innovations, the management of new product or process developments, and the effective management of new ventures in the context of mid-size to large corporations in manufacturing as well as in service industries. Development of an awareness and understanding of the range, scope, and complexity of issues related to the creation of a corporate environment that is supportive of entrepreneurial endeavors as well as to gain insights concerning the effective implementation of technological and organizational innovations in corporate settings.\n",
    "credits": "3"
  },
  {
    "course_name": "International Entrepreneurship",
    "dept": "MGMT",
    "num": "367",
    "desc": "Prereq: Sophomore classification\nThe essentials of operating an entrepreneurial firm in an international environment. Topics include understanding the role of entrepreneurship in economic development, starting and developing a business in an international market, financing international ventures, international management issues and exchange rates.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Management of Organizations",
    "dept": "MGMT",
    "num": "370",
    "desc": "Prereq: ECON 101 or ECON 102\nA management functions approach is used to explain what managers do in organizations; how they deal with external constituents, how they structure their companies, and how they deal with employees. A contingency approach is used as a framework for understanding how to increase the effectiveness and efficiency of organizations in today's dynamic, highly competitive business environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Organizational Behavior",
    "dept": "MGMT",
    "num": "371",
    "desc": "Prereq: Sophomore classification\nThe study of individual attributes, interpersonal relations, and employee attitudes in organizations. Instructional emphasis is placed on how management concepts such as reward systems, job design, leadership, teams, etc., can be used to manage employee attitudes and behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Responsible Management and Leadership in Business",
    "dept": "MGMT",
    "num": "372",
    "desc": "Prereq: PHIL 230\nProfessional responsibilities of executives in terms of personal conduct and individual integrity, executive leadership style and values, formal organizational ethics policies, board and chief executive leadership roles, governance reform and ethics, corporate social responsibility, stakeholder management, strategies for sustainable development, pursuit of societal and corporate goals, and the manager as architect of corporate values and culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Entrepreneurship",
    "dept": "MGMT",
    "num": "410",
    "desc": "Prereq: Sophomore classification\nIntroduction to issues related to the role of social entrepreneurship in helping to solve social problems, including innovation, opportunity recognition, planning and the launch of new non-profit organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "International Management",
    "dept": "MGMT",
    "num": "414",
    "desc": "Prereq: MGMT 370 or MGMT 371\nThe nature and economic role of the multinational firm and entrepreneurial ventures, including the impact of legal, political, and cultural variables upon firm performance and managerial activity; case studies illustrate interdependent nature of functional areas of business projected across national boundaries.\n",
    "credits": "3"
  },
  {
    "course_name": "Personnel and Human Resource Management",
    "dept": "MGMT",
    "num": "471",
    "desc": "Prereq: MGMT 371\nRecruitment and selection, utilization, and development of people in organizations. Examination of each personnel function; interrelationships among the functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Management of Diversity",
    "dept": "MGMT",
    "num": "472",
    "desc": "Prereq: Junior classification\nOne of the most crucial problems in organizations today is the management of diversity. Attempts to define the difference between equal employment opportunity/affirmative action, which has a legal basis, and diversity which has an educational basis. Organized around the concepts of: (1) cultural diversity and cultural unity; (2) development of skills and tools to manage diversity; and (3) structure of diversity development programs in organizations.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Management",
    "dept": "MGMT",
    "num": "478",
    "desc": "Prereq: ACCT 285, FIN 301; MGMT 370 or MGMT 371; MKT 340, SCM 301 and graduating senior\nStrategy formulation, implementation, and evaluation and control in today's organizations. Emphasis is on strategic planning and decision making using the case method and/or projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Entrepreneurship: Executing New Ventures and Projects",
    "dept": "MGMT",
    "num": "480",
    "desc": "Prereq: MGMT 310; MGMT 313 or MGMT 320\nExperiential learning through student-identified project. Students identify, propose and execute an experiential learning project that will be completed during the semester. The course provides application oriented learning of entrepreneurship. The course project must include a significant experiential learning activity, such as launching a venture or business, writing a business plan, or completing an internship in an entrepreneurial setting. Requires a field project.\n",
    "credits": "3"
  },
  {
    "course_name": "Trends and Theories of Entrepreneurship",
    "dept": "MGMT",
    "num": "485",
    "desc": "Prereq: MGMT 310; MGMT 313 or MGMT 320\nA broad examination of historical, literary, and business perspectives on entrepreneurship. The entrepreneurial process is studied by examining the role of individuals, new ventures, and established organizations in the discovery, evaluation, and exploitation of economic opportunities. Emphasis is placed on tracing the evolution of entrepreneurship theories over time, as well as analyzing current trends related to the study of entrepreneurship.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "MGMT",
    "num": "490",
    "desc": "Prereq: senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Organizational Behavior",
    "dept": "MGMT",
    "num": "502",
    "desc": "Prereq: Enrollment in MBA program or departmental permission\nUnderstanding human behavior in organizations and the nature of sustainable organizations from a managerial perspective. Special emphasis is placed on how individual differences, such as perceptions, personality, and motivation, influence individual and group behavior in organizations and on how behavior can be influenced by job design, leadership, groups, and the structure of organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Responsibility in Business and Society",
    "dept": "MGMT",
    "num": "503",
    "desc": "Prereq: Enrollment in MBA program or department permission, ACCT 501, FIN 501, MGMT 502, MKT 501\nEthical and social responsibilities of top managers in corporations. Topics include stakeholder management, corporate social responsibilities, strategies for sustainable development, pursuit of societal and corporate goals, board and chief executive leadership roles, governance reform and ethics, and executive leadership style and values. The presentation of course concepts is facilitated by the use of cases, discussion scenarios, and ethical dilemmas.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Management",
    "dept": "MGMT",
    "num": "504",
    "desc": "Prereq: Enrollment in MBA program or departmental permission, ACCT 501, FIN 501, MGMT 502, MKT 501\nCritical analysis of case studies in strategic management with an emphasis on integrative decision making.  Strategy implementation in light of the global, legal, economic, cultural, and political contexts of business.\n",
    "credits": "3"
  },
  {
    "course_name": "Negotiation and Conflict Resolution",
    "dept": "MGMT",
    "num": "522",
    "desc": "\nTheory and practice of negotiation in a variety of settings, while focusing on understanding the behavior of individuals, groups and organizations in the context of competitive situations. Team work and team building is integrated to better understand interdependent relationships and processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Resource Management Analytics",
    "dept": "MGMT",
    "num": "525",
    "desc": "Prereq: Enrolled in the MBA or other master's program in the College of Business\nAn organization’s competitive advantage resides in the talent and commitment of its people. This course is designed to provide students with an overview of human resources management and is designed to provide students with fundamentals for understanding how managers should staff organizations, train and develop their employees, and understand compensation systems. Moreover, as organizations now collect a myriad of data, this course will train students to make sense of that data to determine whether or not an organization’s selection procedures are effective, whether or not to invest more/less money into training and develop programs, and whether or not its compensation structure facilitates satisfied and committed employees. Performance management, managing careers, and mentoring also are important to job performance and career satisfaction and will be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Leadership and Conflict Resolution",
    "dept": "MGMT",
    "num": "530",
    "desc": "Prereq: Enrollment in the MRED or instructor permission.\nIntroduction to the theory and practice of leadership and negotiation. Emphasis on the science of influencing and resolving conflict, and securing an agreement between two or more interdependent parties. Behavior of individuals, groups, and organizations in the context of demanding situations.\n",
    "credits": "3"
  },
  {
    "course_name": "Entrepreneurship and New Business Creation",
    "dept": "MGMT",
    "num": "566",
    "desc": "Prereq: Graduate classification or permission of instructor.\nThe essentials of starting and operating a new business. Topics include current research on entrepreneurial perspective, starting and developing a new business, financing the venture, managing the growing firm, and special issues.\n",
    "credits": "3"
  },
  {
    "course_name": "International Entrepreneurship",
    "dept": "MGMT",
    "num": "567",
    "desc": "\nEssentials of operating an entrepreneurial firm in an international environment. Topics include international entrepreneurship, starting and developing a business in an international market, financing international ventures, international management issues, exchange rates, and culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology Entrepreneurship",
    "dept": "MGMT",
    "num": "569",
    "desc": "Prereq: Graduate standing or instructor's permission\nIdentification of high-potential, technology-intensive commercial opportunities, resources? gathering, and risk management under environmental uncertainty. Focus on technology ventures and firms that use technology strategically across several industries. Topics include key success factors and forecasting analysis across main value-chain activities.\n",
    "credits": "3"
  },
  {
    "course_name": "Managing Employee Attitudes and Behaviors",
    "dept": "MGMT",
    "num": "570",
    "desc": "Prereq: MGMT 371 or MGMT 502 or PSYCH 450\nAdvanced topics germane to the management of individuals and groups over their work lives; sustained work commitment, motivation and job/career satisfaction, absenteeism, turnover, stress, leadership and career development (e.g., career ladders, mentoring).\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Personnel and Human Resources Management",
    "dept": "MGMT",
    "num": "571",
    "desc": "Prereq: MGMT 371 or MGMT 502 or SOC 420\nTopics and issues in personnel management with a focus on the management of human resources in organizations. Current personnel practices, philosophies, and behavioral science research.\n",
    "credits": "3"
  },
  {
    "course_name": "Personality and Management",
    "dept": "MGMT",
    "num": "572",
    "desc": "Prereq: Graduate standing or permission of instructor\nPersonality and individual differences have significant implications for human resource management, organizational behavior and strategic management.  Research has shown that these characteristics affect many core management topics including motivation, leadership, and decision making. Surveys the literature relating personality and individual differences to management and organizations. Students will complete a wide variety of personality assessments and get their results, and reflect on how personality and individual differences can be practically relevant in the modern work environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Topics in Strategy",
    "dept": "MGMT",
    "num": "581",
    "desc": "Prereq: MGMT 504 or permission of instructor\nDiscussion of concepts and techniques used in long range strategic planning. Examination of planning practices in business and not-for-profit organizations. Topics include environmental scanning, industry analysis, forecasting, corporate and competitive strategies, and tactics.\n",
    "credits": "3"
  },
  {
    "course_name": "Corporate Governance and Top Management",
    "dept": "MGMT",
    "num": "582",
    "desc": "Prereq: MGMT 503 or permission\nDuties, structure, and functioning of top management teams and corporate boards of directors. CEO/board tenure and succession planning, top management compensation, board committee composition, assessment of CEO and board performance, theories of corporate governance, management of the corporate strategic agenda, governance codes, international governance, and chairman/CEO duality. Case studies and contemporary issues discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Management of Innovation",
    "dept": "MGMT",
    "num": "583",
    "desc": "Prereq: MGMT 504 or permission of instructor\nCritical analysis and discussion of cases focused on strategic management of innovation.  Assessment of a firm s innovative capabilities and competitive dynamics to manage innovative processes.  Practical applications through emphasis on implementation including internal corporate venturing, management of the corporate R&D function, and institutionalization of innovation.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "MGMT",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nFor students wishing to do individual research in a particular area of management.\n",
    "credits": "1"
  },
  {
    "course_name": "Philosophy of Science",
    "dept": "MGMT",
    "num": "601",
    "desc": "Prereq: enrollment in the PhD program\nThis course provides a philosophical introduction to the theoretical and empirical development of scientific knowledge.  It focuses on a variety of basic problems common to the social sciences: the nature of explanation, the structure of theories, forms of knowledge, scientific laws, nature of theory and ethics. The purpose of the course is to help doctoral students define a research context by addressing the purposes, assumptions and primary components of scientific inquiry.\n",
    "credits": "3"
  },
  {
    "course_name": "Organizational Theory",
    "dept": "MGMT",
    "num": "602",
    "desc": "Prereq: enrollment in the PhD program\nThis seminar involves the examination of the core theories and perspectives in organizational theory, as well as their applications and extensions. This material addresses the fundamental rationale for organizations in modern society, basic processes of organizing and organizational structure, a consideration of inter-organizational relationships and the external environment, and a variety of factors that help determine organizational effectiveness.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Management of Technology and Innovation",
    "dept": "MGMT",
    "num": "603",
    "desc": "Prereq: MGMT 601\nThis course will offer a critical review of organizational decision making with respect to technology and innovation.  Students will learn how technological change can alter the basis of competition; how competitive strategy drives technology investment decisions; how market-orientation should be the other backbone of technological innovation; and best practices of organizing and managing the new product development process to achieve strategic goals.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Organizational Behavior",
    "dept": "MGMT",
    "num": "604",
    "desc": "Prereq: enrollment in the PhD program\nThe purpose of this seminar is to introduce behavioral science literature relevant to the study of behavior in organizational settings.  The course will focus on the individual's role within organizations and cover topics such as individual differences, motivation, leadership, decision-making. Learning, risk taking, interpersonal relations, etc.  Both theoretical and empirical contributions will be examined, with emphasis on integration of diverse theoretical perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Strategic Management",
    "dept": "MGMT",
    "num": "605",
    "desc": "\nCritical review of theory and research in the field of strategic management. Introduction to representative conceptual and empirical research. Review theories that provide the foundation for management research, and review current research in associate research streams. The review will cover fundamental questions in strategy.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Practicum I",
    "dept": "MGMT",
    "num": "650",
    "desc": "Prereq: enrollment in the PhD program\nPreparation of a research manuscript to be submitted to a peer-reviewed academic journal. Students will work with a faculty mentor on a research project.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Practicum",
    "dept": "MGMT",
    "num": "651",
    "desc": "Prereq: enrollment in the PhD program\nPreparation of a second research manuscript to be submitted to a peer-reviewed academic journal. Although students work under the supervision of a faculty mentor, the students will take independent responsibility for the research project.\n",
    "credits": "1"
  },
  {
    "course_name": "Dissertation",
    "dept": "MGMT",
    "num": "699",
    "desc": "Prereq: Graduate classification, permission of dissertation supervisor\nResearch.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles of Marketing",
    "dept": "MKT",
    "num": "340",
    "desc": "Prereq: credit or current enrollment in ECON 101\nThe role of marketing in society. Markets, marketing institutions, and marketing functions with emphases on product, price, marketing communication, and marketing channel decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Services Marketing",
    "dept": "MKT",
    "num": "351",
    "desc": "Prereq: MKT 340\nIn-depth appreciation and understanding of the unique challenges inherent in creating, managing, and delivering quality services. Students will be introduced to and have the opportunity to work with concepts, tools, and strategies that address these challenges.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Media Marketing Strategy",
    "dept": "MKT",
    "num": "361",
    "desc": "Prereq: MKT 340\nThe course will cover marketing, advertising and communications strategies in the new media landscape where traditional media (e.g., television, print) and the online social media (i.e., Web 2.0; e.g., online social networks, user-generated content, blogs, forums) co-exist. Students will be expected to have knowledge about the fundamentals of traditional advertising methods and strategies. With this background knowledge, the primary focus of this course will be on understanding social media, how to build social media marketing strategies, and how to track their effectiveness. This course will not look at more tactical aspects of advertising/communications such as creative, message management, and publicity. This will first and foremost be a marketing strategy course.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Analytics",
    "dept": "MKT",
    "num": "368",
    "desc": "Prereq: MKT 340\nUse of different tools to conduct various analyses to support marketing strategies. Topics include data visualization and exploration, forecasting, social media analytics and other marketing techniques. Development of skills such as structuring problems, and synthesizing results from quantitative analyses.\n",
    "credits": "3"
  },
  {
    "course_name": "Promotional Strategy",
    "dept": "MKT",
    "num": "410",
    "desc": "Prereq: Credit or enrollment in MKT 447\nPrinciples, concepts, and problems involved in the development and implementation of promotional strategies. Coordination of a variety of promotional elements: advertising, sales promotion, direct marketing, public relations and publicity of web communications, and personal selling.\n",
    "credits": "3"
  },
  {
    "course_name": "Sales Management",
    "dept": "MKT",
    "num": "442",
    "desc": "Prereq: MKT 340\nFunctional aspects of sales force management; personal selling methods; procedures for recruiting, selecting, and training new salespeople; compensation and expense control systems; problems of sales force motivation and supervision; methods of territorial and quota assignment; sales department budgets; distributor-dealer relations; other selected topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Marketing Management",
    "dept": "MKT",
    "num": "443",
    "desc": "Prereq: MKT 444, MKT 447\nAnalysis of major elements of strategic marketing management. May include case studies or business simulations involving decision making using marketing tools from previous courses. (For marketing majors only.).\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Research",
    "dept": "MKT",
    "num": "444",
    "desc": "Prereq: MKT 340, STAT 226\nMarketing research techniques: problem formulation, research design, questionnaire construction, sampling, data collection procedures, and analysis and interpretation of data related to marketing decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Customer Relationship Management",
    "dept": "MKT",
    "num": "445",
    "desc": "Prereq: MKT 340\nExamines how customer data can be used to enhance decisions relating to acquisition, development and retention.  Topics include customer lifetime value, customer as assets, customer loyalty programs and customization.\n",
    "credits": "3"
  },
  {
    "course_name": "Retailing",
    "dept": "MKT",
    "num": "446",
    "desc": "Prereq: MKT 340\nBasic areas of retail management: buying, merchandising, retail promotion, store location, store layout, credit management, and inventory control. Emphasis on practical application of retail management principles.\n",
    "credits": "3"
  },
  {
    "course_name": "Consumer Behavior",
    "dept": "MKT",
    "num": "447",
    "desc": "Prereq: MKT 340\nStudy of how consumers select, purchase, use, and dispose of goods and services. Includes analyses of how markets and others influence these processes. Application of concepts and methods of the behavioral sciences to marketing management decision making.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Marketing",
    "dept": "MKT",
    "num": "448",
    "desc": "Prereq: MKT 340\nMarketing from a global perspective and familiarity with the problems and perspectives that global companies face. Concepts and principles of marketing strategies, market assessment, identify marketing opportunities, entry decision, emerging markets, effects of political, legal, economic and cultural environments, and decisions relating to segmentation, positioning, branding, product, price, distribution and promotions in a global setting.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Seminar",
    "dept": "MKT",
    "num": "449",
    "desc": "Prereq: MKT 340\nAnalysis of current issues and problems in marketing with emphasis on new theoretical and methodological developments. Additional seminars may be offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Professional Selling",
    "dept": "MKT",
    "num": "450",
    "desc": "Prereq: MKT 340\nAnalysis of the theory and practice of personal selling with the context of relationship marketing and salesforce automation. Topics include: goal setting, prospecting, time/territory management, questioning, presentations, objections, commitment and customer service; simulations of selling situations.\n",
    "credits": "3"
  },
  {
    "course_name": "Sales and Distribution Strategy",
    "dept": "MKT",
    "num": "451",
    "desc": "Prereq: MKT 340\nFocuses on marketing channels, the downstream part of a value chain, companies that come together to bring products and services from their point of origin to the point of consumption.  Topics include channel institutions, channel design, channel coordination and implementation. Highlights international and technological aspects of marketing channels so that students can successfully develop and manage marketing channels in a contemporary business environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Brand Management",
    "dept": "MKT",
    "num": "453",
    "desc": "Prereq: MKT 447\nExamines the role of brands and branding in market environments characterized by intense competition and consumer power. Covers issues relating to why branding is important to firms, what brands represent to consumers, and what should be done to manage them effectively.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "MKT",
    "num": "490",
    "desc": "Prereq: MKT 340, senior classification; permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Comparative Marketing",
    "dept": "MKT",
    "num": "492",
    "desc": "Prereq: MKT 340\nProvides experience to students in culture, social, economic, and political environment of marketing in a foreign country. Students complete a term project (e.g., a marketing plan) based on information collected in the foreign country. Students attend briefings by experts/officials of private and public organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing",
    "dept": "MKT",
    "num": "501",
    "desc": "Prereq: Enrollment in MBA program or departmental permission\nAn analytical approach to the study of marketing issues and challenges of business firms and nonprofit organizations. Emphasis on the influence of the global marketplace and the marketing environment on marketing decision making; the determination of the organization's products, prices, channels and communication strategies; an orientation that ensures sustainability of marketing operations; and the organization's system for planning and controlling its marketing effort.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Marketing Management",
    "dept": "MKT",
    "num": "540",
    "desc": "Prereq: MKT 501\nStrategic marketing and decision making, with emphasis on cases utilizing qualitative and quantitative techniques and marketing models.\n",
    "credits": "3"
  },
  {
    "course_name": "International Marketing",
    "dept": "MKT",
    "num": "541",
    "desc": "Prereq: MKT 501, MKT 509\nScope and nature of global marketing operation; the context of international environment in which firms operate. Recent developments of international business activities, and a framework for better understanding of the basic forces driving international business and marketing operations. Development of market entry strategies and global marketing mix policies, as well as export operations. Organizational issues related to the globalization of the firm.\n",
    "credits": "3"
  },
  {
    "course_name": "New Product Strategy and Analytics",
    "dept": "MKT",
    "num": "542",
    "desc": "Prereq: MKT 501\nPrinciples and concepts of new product development and introduction; decision areas include market definition and structure, idea generation, concept evaluation, test marketing, launch tracking, and global product planning; models and techniques of new product evaluation used by consumer product companies.\n",
    "credits": "3"
  },
  {
    "course_name": "Services Marketing",
    "dept": "MKT",
    "num": "543",
    "desc": "Prereq: MKT 501 and instructor permission\nIn-depth appreciation and understanding of the unique challenges inherent in managing and delivering quality services. Students will be introduced to and have the opportunity to work with tools and strategies that address these challenges.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Research",
    "dept": "MKT",
    "num": "544",
    "desc": "Prereq: MKT 501, BUSAD 502 or STAT 401\nMarketing research methods are examined with emphasis on the use of advanced research methods in business research. Application of advanced sampling, measurement, and data analysis methods in research on market segmentation, market structure, consumers' perceptions and decision processes, marketing communication, new product development, and pricing.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Marketing Communication",
    "dept": "MKT",
    "num": "545",
    "desc": "Prereq: MKT 501\nIntroduces the student to the field of marketing communications. Covers a number of topics and areas essential for understanding how to design and evaluate communication strategies necessary for the successful marketing of products and services. An integrated marketing communications (IMC) perspective is employed in covering material, with a corresponding focus on various elements of an IMC strategy, including advertising, promotions, point-of-purchase communications, direct marketing techniques, and other topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Customer Relationship and Business-To-Business Marketing",
    "dept": "MKT",
    "num": "546",
    "desc": "Prereq: MKT 501\nCore concepts and issues involved in customer relationship strategy and management in consumer and business-to-business markets. Emphasis on customer opportunity analyses, customer relationship management tools and strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Consumer Behavior",
    "dept": "MKT",
    "num": "547",
    "desc": "Prereq: MKT 501\nThe behavior of consumers. Intensive review of literature from relevant disciplines. Applications of concepts and methods of the behavioral sciences to marketing management decision making.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Marketing Planning and Execution",
    "dept": "MKT",
    "num": "549",
    "desc": "Prereq: MKT 501\nAllows students to develop the ability to plan and execute a B2B business by integrating aspects of marketing with other business functions in the international context.  Product strategy, innovation, foreign market entry, supply strategies for foreign markets, pricing strategy, market research, customer service, international payments, managing international subsidiaries, licensing, distribution strategy, and responding to changing international environmental conditions. Involves a simulation-based instruction in planning and managing an international B2B business.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Channels",
    "dept": "MKT",
    "num": "551",
    "desc": "Prereq: MKT 501\nDesign of marketing channels, developing and managing relationships with resellers, and evaluating channel performance. Emphasis on international and technological aspects of marketing channels.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Insights",
    "dept": "MKT",
    "num": "552",
    "desc": "\nIntegrate various concepts to solve problems in marketing. Enhance skills such as formulating problems, structuring and prioritizing problems, synthesizing results and communicating intuition from complicated analyses. Topics include problem definition, issue tree dis-aggregation and the Pyramid Principle. The course will also provide an overview of various newly developed marketing theories and analytical tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Analytics",
    "dept": "MKT",
    "num": "568",
    "desc": "\nIntegration of various concepts to solve problems using appropriate tools. Specifically, the course consist of the following three components: (a) help students develop consultative problem-solving skills; (b) introduce various newly developed consumer behavior theories; (c) provide an overview of quantitative models in the field of marketing analytics. Hands-on experiences to enhance skills such as formulating problems, structuring and prioritizing problems, synthesizing results and communicating intuition from complicated analyses.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "MKT",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nFor students wishing to do individual research in a particular area of marketing.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Consumer Behavior",
    "dept": "MKT",
    "num": "601",
    "desc": "Prereq: MGMT 601\nA rigorous foundation of the major conceptual and methodological paradigms in the consumer-behavior literature. Seeks to aid students in understanding the psychological, sociological, and anthropological roots of consumer behavior research.  Read the latest research in the area reported in leading consumer behavior/psychology journals.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Strategy",
    "dept": "MKT",
    "num": "602",
    "desc": "Prereq: MGMT 601\nReview major contributions and recent developments in marketing strategy research and practice. Review commonly used modeling approaches and research methods to study strategic interaction between firms seeking to build competitive advantages. Provide an overview of empirical research regarding measurement, level and persistence of business success and implications of findings for theory and strategy development.\n",
    "credits": "3"
  },
  {
    "course_name": "Customer Management Strategy and Implementation",
    "dept": "MKT",
    "num": "603",
    "desc": "Prereq: MKT 601\nAddresses key strategy and implementation issues behind customer management. Topics such as typology of CM strategies, antecedents and outcomes; environmental and managerial influences on strategy formation; technology and impact on CM strategy; and value of CM strategy.  Examine theories and concepts behind important CM issues such as customer satisfaction, customer loyalty and customer profitability.\n",
    "credits": "3"
  },
  {
    "course_name": "Marketing Issues in Inter-Organizational Relations",
    "dept": "MKT",
    "num": "604",
    "desc": "Prereq: MGMT 602\nInter-firm and network competition; relationship among suppliers, distributors, alliance partners, external employees, and internal employees. Theories including agency theory, network theory, relationship marketing, channels of distribution theories on cooperation versus competition, IOS theories.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Consumer Behavior II",
    "dept": "MKT",
    "num": "606",
    "desc": "Prereq: MKT 601\nA rigorous foundation of the major conceptual and methodological paradigms in the consumer-behavior literature. Seeks to further develop and study issues contained in MKT 601.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods",
    "dept": "MKT",
    "num": "644",
    "desc": "Prereq: Knowledge of introductory statistics, Stat 401, enrollment in the PhD program\nIntroduction to methodological issues that arise when addressing a wide variety of research questions in organizational and consumer studies.  Address measurement issues (scales, reliability and construct validity), design (for experiments, surveys, or qualitative studies), sampling, and analysis (univariate and multivariate statistical procedures).  Measurement issues in cross-cultural and international research will also be covered. It is assumed that students entering the course have knowledge of introductory statistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Practicum I",
    "dept": "MKT",
    "num": "650",
    "desc": "Prereq: enrollment in the PhD program\nPreparation of a research manuscript to be submitted to a peer-reviewed academic journal. Students will work with a faculty mentor on a research project.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Practicum II",
    "dept": "MKT",
    "num": "651",
    "desc": "Prereq: enrollment in the PhD program\nPreparation of a second research manuscript to be submitted to a peer-reviewed academic journal. Although students work under the supervision of a faculty mentor, the students will take independent responsibility for the research project.\n",
    "credits": "1"
  },
  {
    "course_name": "Dissertation",
    "dept": "MKT",
    "num": "699",
    "desc": "Prereq: Graduate classification, permission of dissertation supervisor\nResearch.\n",
    "credits": "12"
  },
  {
    "course_name": "Materials Science & Engineering Learning Community Seminar",
    "dept": "MAT E",
    "num": "101",
    "desc": "Prereq: Enrollment in Materials Science & Engineering Learning Community\nIntroduction to the Materials Science & Engineering Department and resources available to support student success.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Structural Characterization of Materials",
    "dept": "MAT E",
    "num": "214",
    "desc": "Prereq: MAT E 215, PHYS 221\nStructural characterization of ceramic, electronic, polymeric and metallic materials. Techniques include optical and electron microscopy, x-ray diffraction, and thermal analysis. Identification of materials type, microstructure, and crystal structure.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Materials Science and Engineering I",
    "dept": "MAT E",
    "num": "215",
    "desc": "Prereq: MATH 165 AND (CHEM 177 or CHEM 167)\nIntroduction to the structure and properties of engineering materials. Structure of crystalline solids and imperfections. Atomic diffusion. Mechanical properties and failure of ductile and brittle materials. Dislocations and strengthening mechanisms. Phase equilibria, phase transformations, microstructure development, and heat treatment principles of common metallurgical systems including steels and aluminum alloys. Engineering applications.\n  Only one of Mat E 215, 273, or 392 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Materials Science and Engineering I - Lab",
    "dept": "MAT E",
    "num": "215L",
    "desc": "Prereq: Credit or enrollment in MAT E 215 or MAT E 273 or MAT E 392\nMaterials Engineering majors only. Laboratory exercise in materials.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Materials Science and Engineering II",
    "dept": "MAT E",
    "num": "216",
    "desc": "Prereq: MAT E 215, MAT E 273 or MAT E 392; credit or enrollment in PHYS 222\nMaterials Engineering majors only. Fundamentals of ceramic, polymeric, and composite materials; degradation, electronic, thermal, magnetic, and optical properties of materials. Materials for energy, biomaterials, and nanomaterials.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Materials Science and Engineering II - Lab",
    "dept": "MAT E",
    "num": "216L",
    "desc": "Prereq: Credit or enrollment in 216\nMaterials Engineering majors only. Laboratory exercise in materials.\n",
    "credits": "1"
  },
  {
    "course_name": "Globalization and Sustainability",
    "dept": "MAT E",
    "num": "220",
    "desc": "\nAn introduction to understanding the key global issues in sustainability. Focuses on interconnected roles of energy, materials, human resources, economics, and technology in building and maintaining sustainable systems. Applications discussed will include challenges in both the developed and developing world and will examine the role of technology in a resource-constrained world.\n  Cannot be used for technical elective credit in any engineering department.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Materials Science and Engineering",
    "dept": "MAT E",
    "num": "273",
    "desc": "Prereq: CHEM 167 or CHEM 177; MATH 165\nIntroduction to the structure and properties of engineering materials. Structure of crystalline solids and imperfections. Atomic diffusion. Mechanical properties and failure of ductile and brittle materials.  Dislocations and strengthening mechanisms. Phase equilibria, phase transformations, microstructure development, and heat treatment principles of common metallurgical systems including steels and aluminum alloys. Structure and mechanical properties of ceramic, polymeric and composite materials. Thermal properties of materials. Corrosion and degradation. Basic electronic properties of materials. Engineering applications.\n  Only one of Mat E 215,  273, or 392 may count toward graduation",
    "credits": "3"
  },
  {
    "course_name": "Materials Engineering Professional Planning",
    "dept": "MAT E",
    "num": "301",
    "desc": "Prereq: Junior or senior classification in materials engineering\nPreparation for a career in materials engineering or graduate school; experiential learning, resumes, interviewing, Myers-Briggs Type Indicator, leadership, international opportunities, professional ethics, graduate school preparation and opportunities, and alternative career paths (med school, law school, etc.).\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Thermodynamics in Materials Engineering",
    "dept": "MAT E",
    "num": "311",
    "desc": "Prereq: CHEM 178, MAT E 216, and credit or enrollment in MATH 267\nBasic laws of thermodynamics applied to phase equilibria, transformations, and reactions in multicomponent multiphase materials systems; thermodynamic descriptions of heterogeneous systems; binary and ternary phase diagrams; interfaces, surfaces, and defects.\n",
    "credits": "3"
  },
  {
    "course_name": "Kinetics and Phase Equilibria in Materials",
    "dept": "MAT E",
    "num": "314",
    "desc": "Prereq: MAT E 216, MAT E 311\nKinetic phenomena and phase equilibria relevant to the origins and stability of microstructure in metallic, ceramic and polymeric systems. Application of thermodynamics to the understanding of stable and metastable phase equilibria, interfaces and their effects on stability: defects and diffusion, empirical rate equations for transformation kinetics, driving forces and kinetics of nucleation, diffusional and diffusionless phase transformations.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Electronic Properties of Ceramic, Metallic, and Polymeric Materials",
    "dept": "MAT E",
    "num": "317",
    "desc": "Prereq: MAT E 216 and PHYS 222\nMaterials Engineering majors only. Introduction to electronic properties of materials and their practical applications. Classical conduction models and electronic properties of metallic and ceramic materials. Elementary quantum mechanics and band theory of electron states in solids. Quantum theory of metallic conduction. Elementary semiconductor theory and devices. Polarization and dielectric properties of materials. Electron conduction in polymeric systems. Magnetic properties and applications of metals and ceramics.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Structures and Materials",
    "dept": "MAT E",
    "num": "319",
    "desc": "Prereq: PHYS 221, credit or enrollment in MATH 166\nFundamentals of engineering mechanics as applied to materials. Forces and moments; stresses in loaded bodies; elasticity and stress analysis including stress / strain relationships; failure of materials including the mechanics of creep, fracture, and fatigue.\n  Only one of MAT E 319 or E M 324 may be used for graduation requirements.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Ceramic Science",
    "dept": "MAT E",
    "num": "321",
    "desc": "Prereq: MAT E 216\nCeramic crystal structures, defects, diffusion and transport. Phase equilibria and microstructures. Thermal, electronic, optical and magnetic properties of ceramics.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Ceramic Processing",
    "dept": "MAT E",
    "num": "322",
    "desc": "Prereq: MAT E 214, MAT E 321\nSynthesis and characterization of ceramic powders. Colloidal phenomena, rheology of suspensions, ceramic forming methods, and drying. High temperature ceramic reactions, liquid and solid-state sintering, grain growth, microstructure development. Processing/microstructure/property relationships.\n",
    "credits": "3"
  },
  {
    "course_name": "Semiconductor Materials and Devices",
    "dept": "MAT E",
    "num": "332",
    "desc": "Prereq: PHYS 222; MAT E majors: MAT E 317; CPR E and E E majors: E E 230\nIntroduction to semiconductor material and device physics. Quantum mechanics and band theory of semiconductors. Charge carrier distributions, generation/recombination, transport properties. Physical and electrical properties and fabrication of semiconductor devices such as MOSFETs, bipolar transistors, laser diodes and LED's.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic & Magnetic Properties of Metallic Materials",
    "dept": "MAT E",
    "num": "334",
    "desc": "Prereq: MAT E 317\nElectronic conduction in metals and the properties of conducting materials. Quantum mechanical behavior of free electrons and electrons in potentials wells, bonds and lattices. Development of the band theory of electron states in solids and the Free and Nearly Free Electron models. Density-of-states in energy bands and the Fermi-Dirac statistics of state occupancy. Quantum mechanical model of metallic conduction; Brillouin zones and Fermi surfaces. Additional topics include the thermal properties of metals, electron phase transitions in metallic alloys and the BCS theory of superconductivity. Classical and quantum mechanical treatment of the origins of magnetism in materials; orbital and spin angular momentum. Theory of magnetic behavior in dia-, para-magnetic, ferromagnetic materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Metals Processing",
    "dept": "MAT E",
    "num": "341",
    "desc": "Prereq: MAT E 214 and either MAT E 215, 273 or 392\nTheory and practice of metal processing, including casting; powder metallurgy; additive manufacturing; rolling; forging; extrusion; drawing; material removal; joining; surface modification; and heat treatment. Use of processing software.\n",
    "credits": "3"
  },
  {
    "course_name": "Structure/Property Relations in Nonferrous Metals",
    "dept": "MAT E",
    "num": "342",
    "desc": "Prereq: MAT E 215 or 273 or 392\nProcessing of metals and alloys to obtain desired mechanical properties by manipulation of their microstructure and composition of constituent phase(s). Relevance of defects to mechanical properties, plastic flow. Strengthening mechanisms in metals and alloys. Microstructure, heat treatment and mechanical properties of engineering alloys. Metal-matrix composites.\n",
    "credits": "3"
  },
  {
    "course_name": "Solidification Processes",
    "dept": "MAT E",
    "num": "348",
    "desc": "Prereq: I E 248 and MAT E 273, or MAT E 215\nTheory and applications related to metal casting, welding, polymer processing, powder metallurgy, and composites manufacturing, and related rapid manufacturing processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Polymers and Polymer Engineering.",
    "dept": "MAT E",
    "num": "350",
    "desc": "Prereq: MAT E 216\nFundamental concepts of soft matter, including polymer, colloid and surfactant. Their physical and chemical properties, rheology and production methods. Applications of polymers in the chemical industry. Related topics in surface, diffusion and stability.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Polymeric Materials",
    "dept": "MAT E",
    "num": "351",
    "desc": "Prereq: MAT E 216\nIntroduction to polymeric materials, synthesis, structure and properties. Relationship between polymer composition, processing and properties.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Nondestructive Testing",
    "dept": "MAT E",
    "num": "362",
    "desc": "Prereq: PHYS 112 or PHYS 222\nRadiography, ultrasonic testing, magnetic particle inspection, eddy current testing, dye penetrant inspection, and other techniques. Physical bases of tests, materials to which applicable, types of defects detectable, calibration standards, and reliability safety precautions.\n",
    "credits": "3"
  },
  {
    "course_name": "Nondestructive Testing Laboratory",
    "dept": "MAT E",
    "num": "362L",
    "desc": "Prereq: Credit or enrollment in MAT E 362\nApplication of nondestructive testing techniques to the detection and sizing of flaws in materials and to the characterization of material's microstructure. Included are experiments in hardness, dye penetrant, magnetic particle, x-ray, ultrasonic and eddy current testing. Field trips to industrial laboratories.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to US Women's roles in Industry and Preparation for Summer Study",
    "dept": "MAT E",
    "num": "391",
    "desc": "\nIntroduction to the historical role of women as related to US industry, family and community with emphasis on the years 1830 - 1945, but also related to the current climate. Topics completed in 392 with arranged lectures at Brunel University. Orientation for Brunel summer study program.\n  Offered on a satisfactory-fail basis only.  Credit for graduation allowable only upon completion of Mat E 392.\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Materials Science and Engineering",
    "dept": "MAT E",
    "num": "392",
    "desc": "Prereq: MAT E 391, MATH 165, CHEM 167 or CHEM 177\nIntroduction to the structure and properties of engineering materials. Structure of crystalline solids and imperfections. Atomic diffusion. Mechanical properties and failure of ductile and brittle materials. Dislocations and strengthening mechanisms. Phase equilibria, phase transformations, microstructure development, and heat treatment principles of common metallurgical systems including steels and aluminum alloys. Structure and mechanical properties of ceramic, polymeric and composite materials. Thermal properties of materials. Corrosion and degradation. Basic electronic properties of materials. Engineering applications.\n  Only one of MAT E 215, 273, or 392 may count toward graduation.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Summer Internship",
    "dept": "MAT E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education (Co-op)",
    "dept": "MAT E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period.  One semester per academic or calendar year.  Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Materials Design and Professional Practice I",
    "dept": "MAT E",
    "num": "413",
    "desc": "Prereq: Senior Classification: MAT E 413-414 sequence is intended for students in their final two semesters before graduation.\nFundamentals of materials engineering design, information sources, team behavior, professional preparation, quantitative design including finite-element analysis and computer aided design, materials selection, informatics and combinatorial methods. Analysis of design problems, development of solutions, selected case studies.  Oral presentation skills. Preparations for spring project.\n",
    "credits": "3"
  },
  {
    "course_name": "Materials Design and Professional Practice II",
    "dept": "MAT E",
    "num": "414",
    "desc": "Prereq: MAT E 413\nIntegration of materials processing, structure/composition, properties and performance principles in materials engineering problems. Multi-scale design of materials, materials processing, case studies including cost analysis, ethics, risk and safety. Team projects specified by either industry or academic partners.  Written and oral final project reports.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Behavior of Materials",
    "dept": "MAT E",
    "num": "418",
    "desc": "Prereq: MAT E 216, MAT E 319\nMechanical behavior of ceramics, metals, polymers, and composites. Relationships between materials processing and atomic aspects of elasticity, plasticity, fracture, and fatigue. Life prediction, stress-and failure analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Magnetism and Magnetic Materials",
    "dept": "MAT E",
    "num": "419",
    "desc": "Prereq: E E 311 or MAT E 317 or PHYS 364\nMagnetic fields, flux density and magnetization. Magnetic materials, magnetic measurements. Magnetic properties of materials. Domains, domain walls, domain processes, magnetization curves and hysteresis. Types of magnetic order, magnetic phases and critical phenomena. Magnetic moments of electrons, theory of electron magnetism. Technological application, soft magnetic materials for electromagnets, hard magnetic materials, permanent magnets, magnetic recording technology, magnetic measurements of properties for materials evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Glass Science and Engineering",
    "dept": "MAT E",
    "num": "425",
    "desc": "Prereq: MAT E 214, MAT E 321\nComposition, structure, properties manufacturing, and applications of inorganic glasses. Mechanical, structural, thermal, optical, ionic, electronic, and biological applications of inorganic glasses, especially silicate glasses. Contemporary topics in glass science and engineering such as glass optical fiber communication and flat panel display technologies. Laboratory exercises in the preparation and characterization of silicate glasses.\n",
    "credits": "3"
  },
  {
    "course_name": "Microelectronics Fabrication Techniques",
    "dept": "MAT E",
    "num": "432",
    "desc": "Prereq: credit or enrollment in E E 332\nTechniques used in modern integrated circuit fabrication, including diffusion, oxidation, ion implantation, lithography, evaporation, sputtering, chemical-vapor deposition, and etching. Process integration. Process evaluation and final device testing. Extensive laboratory exercises utilizing fabrication methods to build electronic devices. Use of computer simulation tools for predicting processing outcomes. Recent advances in processing CMOS ICs and micro-electro-mechanical systems (MEMS).\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Ceramics and Electronic Materials",
    "dept": "MAT E",
    "num": "433",
    "desc": "Prereq: MAT E 317, MAT E 321\nCharged point defects and formation equations. Non-stoichiometric conductors, dielectric, ferroelectric, and piezoelectric materials and applications. Optical properties, optical spectra of materials, optoelectronic devices. Magnetic and superconducting materials. Contemporary topics in advanced ceramics.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Properties of Materials",
    "dept": "MAT E",
    "num": "437",
    "desc": "Prereq: E E 332 or MAT E 317 or PHYS 322\nReview of classical and quantum mechanical descriptions of electrons in solids, band theory, metallic conduction, lattice vibrations, semiconductors, semiconductor devices, dielectrics, polarization, dielectric relaxation, crystal anisotropy, ferroelectricity, piezoelectricity, superconductivity, magnetism, device applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Metallurgy of Ferrous Alloys",
    "dept": "MAT E",
    "num": "443",
    "desc": "Prereq: credit or enrollment in 314\nProduction and processing of ferrous metals. Extraction of pig iron from ore. Steelmaking processes. Equilibrium and nonequilibrium phases in the Fe-C system. Properties and processing of cast irons, plain carbon and alloy steels, stainless and specialty steels. Transformation diagrams, hardenability, and surface treatments. Continuous casting, forging, hot rolling, quenching, and tempering as they apply to ferrous materials. Cost and mechanical performance considerations in cast iron and steel selection and heat treatment.\n",
    "credits": "3"
  },
  {
    "course_name": "Corrosion and Failure Analysis",
    "dept": "MAT E",
    "num": "444",
    "desc": "Prereq: MAT E 214, 215 or 273 or 392\nCorrosion and corrosion control of metallic systems. Corrosion fundamentals, classification of different types of metallic corrosion, corrosion properties of various engineering alloys, corrosion control. Failure analysis. Characteristics of common types of metallic failures, case studies of failures, designing to reduce failure risk.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical and Mechanical Properties of Polymers",
    "dept": "MAT E",
    "num": "453",
    "desc": "Prereq: MAT E 214, MAT E 351\nOverview of polymer chemical composition, microstructure, thermal and mechanical properties, rheology, and principles of polymer materials selection. Intensive laboratory experiments include chemical composition studies, microstructural characterization, thermal analysis, and mechanical testing.\n",
    "credits": "3"
  },
  {
    "course_name": "Polymer Composites and Processing",
    "dept": "MAT E",
    "num": "454",
    "desc": "Prereq: MAT E 351\nBasic concepts in polymer composites, blends, and block copolymers. Phase separation and miscibility, microstructures and mechanical behavior. Fiber reinforced and laminated composites. Viscosity, rheology, viscoelasticity of polymers. Polymer melt processing methods such as injection molding and extrusion; selection of suitable processing methods and their applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Biomaterials",
    "dept": "MAT E",
    "num": "456",
    "desc": "Prereq: CHEM 178 and MAT E 216 or MAT E 273 or MAT E 392\nPresentation of the basic chemical and physical properties of biomaterials, including metals, ceramics, and polymers, as they are related to their manipulation by the engineer for incorporation into living systems. Role of microstructure properties in the choice of biomaterials and design of artificial organs, implants, and prostheses.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical and Physical Metallurgy of Rare Earth Metals",
    "dept": "MAT E",
    "num": "457",
    "desc": "Prereq: MAT E 311 or CHEM 325\nElectronic configuration, valence states, minerals, ores, beneficiation, extraction, separation, metal preparation and purification. Crystal structures, phase transformations and polymorphism, and thermochemical properties of rare earth metals.  Chemical properties: inorganic and organometallic compounds, alloy chemistry, nature of the chemical bonding.  Physical properties: mechanical and elastic properties, magnetic properties, resistivity, and superconductivity.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "MAT E",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design II",
    "dept": "MAT E",
    "num": "467",
    "desc": "Prereq: Student must be within two semesters of graduation or receive permission of instructor.\nBuild and test of a conceptual design. Detail design, manufacturability, test criteria and procedures. Application of design tools such as CAD and CAM and manufacturing techniques such as rapid prototyping. Development and testing of a full-scale prototype with appropriate documentation in the form of design journals, written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Modeling of Materials",
    "dept": "MAT E",
    "num": "481",
    "desc": "Prereq: MATH 265 and MAT E 311 or CH E 381 or CHEM 325 or PHYS 304\nIntroduction to the basic methods used in the computational modeling and simulation of materials, from atomistic simulations to methods at the mesoscale. Students will be expected to develop and run sample programs. Topics to be covered include, for example, electronic structure calculations, molecular dynamics, Monte Carlo, phase-field methods, etc.\n",
    "credits": "3"
  },
  {
    "course_name": "Eddy Current Nondestructive Evaluation",
    "dept": "MAT E",
    "num": "488",
    "desc": "Prereq: MATH 265 and (MAT E 216 or MAT E 273 or MAT E 392 or E E 311 or PHYS 364)\nElectromagnetic fields of various eddy current probes. Probe field interaction with conductors, cracks and other material defects. Ferromagnetic materials. Layered conductors. Elementary inversion of probe signals to characterize defects. Special techniques including remote-field, transient, potential drop nondestructive evaluation and the use of Hall sensors. Practical assignments using a 'virtual' eddy current instrument will demonstrate key concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "MAT E",
    "num": "490",
    "desc": "\nInvestigation of individual research or special topics.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Approved Student Submitted Proposal",
    "dept": "MAT E",
    "num": "490C",
    "desc": "Prereq: permission of department\nIndependent study that is being proposed to be used toward graduation or minor requirements as a technical elective. This requires a proposal to the department's Curriculum Committee before the semester starts.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Senior Honors Project",
    "dept": "MAT E",
    "num": "490H",
    "desc": "Prereq: permission of department\nIndependent study that is being proposed to be used for a Senior Honors Project (2 credits) and possibly for extra credits toward graduation or minor requirements. This requires a proposal to the department's Curriculum Committee before the semester starts.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Research",
    "dept": "MAT E",
    "num": "490R",
    "desc": "Prereq: permission of department\nIndependent study that is being proposed to gain research experience. This requires a proposal to the department's Curriculum Committee before the semester starts.\n  Credits can only be used by Mat E majors toward graduation as a free elective.",
    "credits": "arr"
  },
  {
    "course_name": "Fundamentals of Structure and Chemistry of Materials",
    "dept": "M S E",
    "num": "510",
    "desc": "Prereq: MATH 165, PHYS 221, and CHEM 167\nGeometric and algebraic representations of symmetry.  Pair distribution function.  Structure, chemistry, and basic properties of covalent, ionic, and metallic solids, glasses and liquids, and polymers.  Interactions of materials with particles and waves.  Relationships between direct and reciprocal spaces.  The kinematical theory of diffraction, with an introduction to the dynamical theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Magnetism and Magnetic Materials",
    "dept": "M S E",
    "num": "519",
    "desc": "Prereq: E E 311 or MAT E 317 or PHYS 364\nMagnetic fields, flux density and magnetization. Magnetic materials, magnetic measurements. Magnetic properties of materials. Domains, domain walls, domain processes, magnetization curves and hysteresis. Types of magnetic order, magnetic phases and critical phenomena. Magnetic moments of electrons, theory of electron magnetism. Technological application, soft magnetic materials for electromagnets, hard magnetic materials, permanent magnets, magnetic recording technology, magnetic measurements of properties for materials evaluation.\n",
    "credits": "3"
  },
  {
    "course_name": "Thermodynamics and Kinetics in Multicomponent Materials",
    "dept": "M S E",
    "num": "520",
    "desc": "Prereq: MAT E 311 or CHEM 321, MATH 266 or MATH 267\nA review of the fundamental principles of heat, work, basic thermodynamic relations, and criteria for equilibrium. Analytical treatments for the thermodynamic description of multicomponent chemical solutions and reacting systems are developed and employed to predict phase equilibria in materials systems. Builds on the thermodynamic construction to treat the kinetics of chemical reactions and phase transformations. Topics include general first order and second order transitions, along with chemical diffusion. Detailed examples involving nucleation and diffusion limited growth, spinodal decomposition, martensitic transformations, magnetic and electric transitions, and glass formation will be considered.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Behavior and Manufacturing of Polymers and Composites",
    "dept": "M S E",
    "num": "521",
    "desc": "Prereq: M E 324 or MAT E 272 and E M 324\nEffect of chemical structure and morphology on properties. Linear viscoelasticity, damping and stress relaxation phenomena. Structure and mechanics of filler and fiber reinforced composites. Mechanical properties and failure mechanisms. Material selection and designing with polymers. Processing of polymer and composite parts.\n",
    "credits": "3"
  },
  {
    "course_name": "Solid State Science",
    "dept": "M S E",
    "num": "530",
    "desc": "Prereq: MAT E 334 or E E 332 or PHYS 322\nDevelopment of a quantitative description of the electronic structure of solids starting with fundamentals of atoms, atomic bonding, basic crystallography, and band theory of solids. Continuum properties of solids in response to electromagnetic fields and thermal gradients.  Quantitative description of the atomistic properties of solids through electron-electron interactions, electron-phonon interactions, and dipole interactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Microelectronics Fabrication Techniques",
    "dept": "M S E",
    "num": "532",
    "desc": "Prereq: credit or enrollment in E E 332\nTechniques used in modern integrated circuit fabrication, including diffusion, oxidation, ion implantation, lithography, evaporation, sputtering, chemical-vapor deposition, and etching. Process integration. Process evaluation and final device testing. Extensive laboratory exercises utilizing fabrication methods to build electronic devices. Use of computer simulation tools for predicting processing outcomes. Recent advances in processing CMOS ICs and micro-electro-mechanical systems (MEMS).\n",
    "credits": "4"
  },
  {
    "course_name": "Electronic Properties of Materials",
    "dept": "M S E",
    "num": "537",
    "desc": "Prereq: E E 332 or MAT E 317 or PHYS 322\nReview of classical and quantum mechanical descriptions of electrons in solids, band theory, metallic conduction, lattice vibrations, semiconductors, semiconductor devices, dielectrics, polarization, dielectric relaxation, crystal anisotropy, ferroelectricity, piezoelectricity, superconductivity, magnetism, device applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Behavior of Materials",
    "dept": "M S E",
    "num": "540",
    "desc": "Prereq: MAT E 418, MATH 266 or MATH 267\nMechanical behavior of materials with emphasis on micromechanics of deformation in three generic regimes: elasticity, plasticity, and fracture. A materials science approach is followed to understand and model the mechanical behavior that combines continuum mechanics, thermodynamics, kinetics, and microstructure. Some topics include elastic properties of materials, permanent deformation mechanisms at different temperatures (e.g., via dislocation motion and creep), and fracture in ductile and brittle materials. Specific classes of materials that are studied: metals, ceramics, polymers, glasses and composites.\n",
    "credits": "3"
  },
  {
    "course_name": "Nondestructive Evaluation",
    "dept": "M S E",
    "num": "550",
    "desc": "Prereq: E M 324, MATH 385\nPrinciples of five basic NDE methods and their application in engineering inspections. Materials behavior and simple failure analysis. NDE reliability, and damage-tolerant design. Advanced methods such as acoustic microscopy, laser ultrasonics, thermal waves, and computed tomography are analyzed. Computer-based experiments on a selection of methods: ultrasonics, eddy currents, x-rays are assigned for student completion.\n",
    "credits": "4"
  },
  {
    "course_name": "Characterization Methods in Materials Science",
    "dept": "M S E",
    "num": "551",
    "desc": "Prereq: MAT E 214\nCharacterization of ceramic, metal, polymer and glassy materials using modern analytical techniques. Spectroscopic (IR, Raman, UV/VIS/NIR, and NMR), thermal (DSC, DTA/TGA, and DMA) methods, mechanical and rheological testing, magnetic and electrical characterization, and powder characterization.\n",
    "credits": "3"
  },
  {
    "course_name": "Scanning and Auger Electron Microscopy",
    "dept": "M S E",
    "num": "552",
    "desc": "Prereq: PHYS 222\nCharacterization of materials using scanning electron microscope (SEM), electron microprobe, and auger spectrometer. Compositional determination using energy and wavelength dispersive x-ray and Auger spectroscopies. Specimen preparation. Laboratory covers SEM operation.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical and Mechanical Properties of Polymers",
    "dept": "M S E",
    "num": "553",
    "desc": "Prereq: MAT E 351\nOverview of polymer chemical composition, microstructure, thermal and mechanical properties, rheology, and principles of polymer materials selection. Intensive laboratory experiments include chemical composition studies, microstructural characterization, thermal  analysis, and mechanical testing.\n",
    "credits": "3"
  },
  {
    "course_name": "Polymer Composites and Processing",
    "dept": "M S E",
    "num": "554",
    "desc": "Prereq: MAT E 351\nBasic concepts in polymer composites, blends, and block copolymers. Phase separation and miscibility, microstructures and mechanical behavior. Fiber reinforced and laminated composites. Viscosity, rheology, viscoelasticity of polymers. Polymer melt processing methods such as injection molding and extrusion; selection of suitable processing methods and their applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Biomaterials",
    "dept": "M S E",
    "num": "556",
    "desc": "Prereq: CHEM 178 and MAT E 216 or MAT E 273 or MAT E 392\nPresentation of the basic chemical and physical properties of biomaterials, including metals, ceramics, and polymers, as they are related to their manipulation by the engineer for incorporation into living systems. Role of microstructure properties in the choice of biomaterials and design of artificial organs, implants, and prostheses.\n",
    "credits": "3"
  },
  {
    "course_name": "Chemical and Physical Metallurgy of Rare Earth Metals",
    "dept": "M S E",
    "num": "557",
    "desc": "Prereq: MAT E 311 or CHEM 325\nElectronic configuration, valence states, minerals, ores, beneficiation, extraction, separation, metal preparation and purification. Crystal structures, phase transformations and polymorphism, and thermochemical properties of rare earth metals.  Chemical properties: inorganic and organometallic compounds, alloy chemistry, nature of the chemical bonding.  Physical properties: mechanical and elastic properties, magnetic properties, resistivity, and superconductivity.\n",
    "credits": "3"
  },
  {
    "course_name": "Fracture and Fatigue",
    "dept": "M S E",
    "num": "564",
    "desc": "Prereq: E M 324 and either MAT E 216 or MAT E 273 or MAT E 392. Undergraduates: Permission of instructor\nMaterials and mechanics approach to fracture and fatigue. Fracture mechanics, brittle and ductile fracture, fracture and fatigue characteristics, fracture of thin films and layered structures. Fracture and fatigue tests, mechanics and materials designed to avoid fracture or fatigue.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Composite and Combined Materials",
    "dept": "M S E",
    "num": "569",
    "desc": "Prereq: E M 324\nMechanics of fiber-reinforced materials. Micromechanics of lamina. Macromechanical behavior of lamina and laminates. Strength and interlaminar stresses of laminates. Failure criteria. Stress analysis of laminates. Thermal moisture and residual stresses. Joints in composites.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Modeling of Materials",
    "dept": "M S E",
    "num": "581",
    "desc": "Prereq: MATH 265 and MAT E 311 or CH E 381 or CHEM 325 or PHYS 304\nIntroduction to the basic methods used in the computational modeling and simulation of materials, from atomistic simulations to methods at the mesoscale. Students will be expected to develop and run sample programs. Topics to be covered include, for example, electronic structure calculations, molecular dynamics, Monte Carlo, phase-field methods, etc.\n",
    "credits": "3"
  },
  {
    "course_name": "Eddy Current Nondestructive Evaluation",
    "dept": "M S E",
    "num": "588",
    "desc": "Prereq: MATH 265 and (MAT E 216 or MAT E 273 or MAT E 392 or E E 311 or PHYS 364)\nElectromagnetic fields of various eddy current probes. Probe field interaction with conductors, cracks and other material defects. Ferromagnetic materials. Layered conductors. Elementary inversion of probe signals to characterize defects. Special techniques including remote-field, transient, potential drop nondestructive evaluation and the use of Hall sensors. Practical assignments using a 'virtual' eddy current instrument will demonstrate key concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "M S E",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "M S E",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Materials Seminar",
    "dept": "M S E",
    "num": "601",
    "desc": "Prereq: MSE Graduate Student Status\nSeminar course - presentations given on a weekly basis by leading U.S. and International researchers that are experts in their respective fields closely related to Materials Science.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Phase Transformations",
    "dept": "M S E",
    "num": "620",
    "desc": "Prereq: M S E 520\nExplores various advanced theoretical treatments of the energetics and kinetics of multicomponent materials. Topics include analytical and computational descriptions of thermodynamic quantities, experimental measurement of essential physical properties, analytical and computational treatments of kinetic processes, and the use of theoretical predictions of phase equilibria and evolution in materials systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Properties of Solids",
    "dept": "M S E",
    "num": "630",
    "desc": "Prereq: M S E 530\nAdvanced course in the behavior of solids within the framework of solid state physics and chemistry.  Includes magnetic, dielectric, transport, and optical phenomena in solids.  Influence of phase transformations and crystal symmetry on the physical properties.\n",
    "credits": "3"
  },
  {
    "course_name": "Powder Diffraction Methods",
    "dept": "M S E",
    "num": "651",
    "desc": "Prereq: M S E 510\nAdvanced structural characterization of materials using powder diffraction. Production of X-ray and neutron radiation. Review of symmetry, group and kinematical theories of diffraction. Mathematical and computational backgrounds of powder diffraction data. Introduction to single crystal diffraction methods, origin of powder diffraction pattern, history of the technique. Modern powder diffraction methods. Indexing of powder diffraction patterns, figures of merit, precise lattice parameters. Phase problem, determining crystal structures from symmetry and geometry, Patterson, direct and Fourier methods. Rietveled method, precise crystal structures: atomic parameters, qualitative and quantitative phase identification, preferred orientation, grain size, strain, residual stress, order-disorder. Powder diffraction at non-ambient conditions. Applications of powder diffraction: data bases, phase transformations, phase diagrams, local structures, magnetism.\n",
    "credits": "3"
  },
  {
    "course_name": "Transmission Electron Microscopy",
    "dept": "M S E",
    "num": "652",
    "desc": "Prereq: M S E 510\nTheory and application of transmission electron microscopy to inorganic materials. Specimen preparation, selected area and convergent beam electron diffraction, bright field/dark field/high resolution imaging. Compositional analysis using X-ray and electron energy loss spectroscopy.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics in Materials Science",
    "dept": "M S E",
    "num": "690",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "M S E",
    "num": "697",
    "desc": "Prereq: Permission of department, graduate classification\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "M S E",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "High School Algebra",
    "dept": "MATH",
    "num": "010",
    "desc": "\nFor students who do not have adequate facility with topics from high school algebra or do   not meet the algebra admission requirement.  The course is divided into tracks of one- and   two-semester lengths. For most students a diagnostic exam will determine which track   must be taken. Students will receive a grade in MATH 25 or MATH 30 respectively depending on the   level of material covered. Satisfactory completion of MATH 30 is recommended for students   planning to take MATH 140, MATH 143, MATH 145, MATH 150, or MATH 151, while MATH 25 is sufficient for MATH 104, MATH 105, MATH 195, STAT 101 or STAT 105. Students must complete MATH 30 to remove a deficiency in the algebra   admission requirement. Topics include signed numbers, polynomials, rational and radical   expressions, exponential and logarithmic expressions, and equations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "High School Algebra",
    "dept": "MATH",
    "num": "025",
    "desc": "\nStudents should initially enroll in MATH 10.  See description of MATH 10.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "High School Algebra",
    "dept": "MATH",
    "num": "030",
    "desc": "\nStudents should initially enroll in MATH 10.  See description of MATH 10.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Orientation in Mathematics",
    "dept": "MATH",
    "num": "101",
    "desc": "\nFor new majors. Campus resources and opportunities available to students. Careers and programs of study in mathematics.  Mathematical reasoning, culture and resources. Description of main branches of mathematics.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Probability",
    "dept": "MATH",
    "num": "104",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of high school geometry\nPermutations, combinations, probability, expected value, and applications.\n  Either MATH 104 or MATH 150 may be counted toward graduation, but not both.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Mathematical Ideas",
    "dept": "MATH",
    "num": "105",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of high school geometry.\nIntroduction to the use of basic mathematics to solve real-world problems in the areas of voting issues, measuring power in situations where people have different numbers of votes, apportionment, fair division, and elementary game theory. No prior background in politics or history is necessary for this course.\n",
    "credits": "3"
  },
  {
    "course_name": "Discovering Mathematics",
    "dept": "MATH",
    "num": "106",
    "desc": "\nInquiry-based approach to mathematics, emphasizing the art, history, and beauty of the subject. Typical topics are mathematics from art, music, puzzles, patterns, and reasoning.\n",
    "credits": "3"
  },
  {
    "course_name": "College Algebra",
    "dept": "MATH",
    "num": "140",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of high school geometry; or MATH 30.\nCoordinate geometry, quadratic and polynomial equations, functions, graphing, rational functions, exponential and logarithmic functions, inverse functions, quadratic inequalities, systems of linear equations. Prepares students for MATH 160.\n  Students in the College of Liberal Arts and Sciences may not count MATH 140 toward the General Education Requirements.",
    "credits": "3"
  },
  {
    "course_name": "Preparation for Calculus",
    "dept": "MATH",
    "num": "143",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of high school geometry; or MATH 140.\nPreparation for MATH 160, MATH 165, and MATH 181. Functions, graphing, basic trigonometry, logarithms, exponentials. Emphasis on co-variational reasoning. Students in the College of Liberal Arts and Sciences may not count MATH 143 toward General Education Requirements.\n  Only one of MATH 143 and MATH 145 may count toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Applied Trigonometry",
    "dept": "MATH",
    "num": "145",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of high school geometry; or minimum of C- in MATH 140.\nMathematical ideas regarding the conception of space.  General trigonometry, with an emphasis on the calculation of lengths, areas, and angles.  The Law of Sines and the Law of Cosines.  Polar, cylindrical, and spherical coordinate systems.  Conic sections and quadric surfaces.\n  Students in the College of Liberal Arts and Sciences may not count MATH 145 toward the General Education Requirements.  Only one of MATH 143 and MATH 145 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Discrete Mathematics for Business and Social Sciences",
    "dept": "MATH",
    "num": "150",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of high school geometry\nLinear equations and inequalities, matrix algebra, linear programming, discrete probability.\n  Either MATH 104 or MATH 150 may be counted toward graduation, but not both.",
    "credits": "3"
  },
  {
    "course_name": "Calculus for Business and Social Sciences",
    "dept": "MATH",
    "num": "151",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of high school geometry\nDifferential calculus, applications to max-min problems, integral calculus and applications. Will not serve as prerequisite for MATH 265 or MATH 266.\n  Only one of MATH 151, MATH 160, the sequence MATH 165-MATH 166, or  MATH 181 may be counted towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Survey of Calculus",
    "dept": "MATH",
    "num": "160",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of geometry; or minimum of C- in MATH 140; or minimum of C- in MATH 143\nAnalytic geometry, derivatives and integrals of elementary functions, simple differential equations, and applications. Will not serve as a prerequisite for MATH 265 or MATH 266.\n  Only one of MATH 151, MATH 160, the sequence MATH 165-MATH 166, or MATH 181 may be counted towards graduation.",
    "credits": "4"
  },
  {
    "course_name": "Calculus I",
    "dept": "MATH",
    "num": "165",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of geometry, 1 semester of trigonometry; or minimum of C- in MATH 143\nDifferential calculus, applications of the derivative, introduction to integral calculus.\n  Only one of MATH 151 or MATH 160 or the sequence MATH 165-MATH 166, or MATH 181 may be counted towards graduation.",
    "credits": "4"
  },
  {
    "course_name": "Calculus II",
    "dept": "MATH",
    "num": "166",
    "desc": "Prereq: Minimum of C- in MATH 165 or high math placement scores\nIntegral calculus, applications of the integral, infinite series, parametric curves and polar coordinates.\n  Only one of MATH 151, MATH 160, the sequence MATH 165-MATH 166, or MATH 181 may be counted towards graduation.",
    "credits": "4"
  },
  {
    "course_name": "Calculus II, Honors",
    "dept": "MATH",
    "num": "166H",
    "desc": "Prereq: Permission of instructor and MATH 165 or high math placement scores\nIntegral calculus, applications of the integral, infinite series, parametric curves, and polar coordinates.  Additional material of a theoretical, conceptual, computational, or modeling nature. Some of the work may require more ingenuity than is required for MATH 166. Preference will be given to students in the University Honors Program.\n  Only one of MATH 151 or MATH 160, the sequence MATH 165-MATH 166, or MATH 181 may be counted towards graduation.",
    "credits": "4"
  },
  {
    "course_name": "Calculus and Mathematical Modeling for the Life Sciences",
    "dept": "MATH",
    "num": "181",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years of high school algebra, 1 year of high school geometry, 1 semester of trigonometry; or minimum of C- in MATH 143\nExponential and logarithm functions, difference equations, derivatives, and applications of the derivative.  Examples taken from biology.\n  Only one of MATH 151, MATH 160, the sequence MATH 165-MATH 166, or MATH 181 may be counted towards graduation.",
    "credits": "4"
  },
  {
    "course_name": "Mathematics for Elementary Education I",
    "dept": "MATH",
    "num": "195",
    "desc": "Prereq: Satisfactory performance on placement assessment, 2 years high school algebra, 1 year of high school geometry, enrollment in elementary education or early childhood education\nWhole number operations through analysis of properties, theoretical and hands-on models, mathematical analysis of elementary students’ thinking; standard and non-standard algorithms; structure of the decimal system; linear measurement; two- and three-dimensional measurement, shapes and spatial sense; number theory; algebra as it relates to elementary curricula/teaching profession.\n  Students in the College of Liberal Arts and Sciences may not count MATH 195 toward General Education Requirements.",
    "credits": "3"
  },
  {
    "course_name": "Mathematics for Elementary Education II",
    "dept": "MATH",
    "num": "196",
    "desc": "Prereq: Minimum of C- in MATH 195 and enrollment in elementary education or early childhood education.\nInteger, fraction and decimal operations through analysis of properties, theoretical and hands-on models, mathematical analysis of elementary students’ thinking; standard and non-standard algorithms; continuation of two- and three-dimensional measurement, shapes and spatial sense; probability and statistics; proportional reasoning; algebra as it relates to elementary curricula/teaching profession.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Proofs",
    "dept": "MATH",
    "num": "201",
    "desc": "Prereq: MATH 166 or MATH 166H\nTransition to advanced mathematics.  Communicating mathematics.  Logical arguments; techniques of proofs regarding sets, numbers (natural and real), functions, relations, and limits.\n",
    "credits": "3"
  },
  {
    "course_name": "Career Development in Math and Statistics",
    "dept": "MATH",
    "num": "202",
    "desc": "\nCareer development in the mathematics and statistics disciplines with an emphasis on contemporary social issues.   Presentations by professionals in STEM fields about occupations, decision-making strategies, and career goal implementation; development of job searching, resume writing, negotiating, and interviewing techniques.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Matrices and Linear Algebra",
    "dept": "MATH",
    "num": "207",
    "desc": "Prereq: 2 semesters of calculus\nSystems of linear equations, determinants, vector spaces, linear transformations,   orthogonality, least-squares methods, eigenvalues and eigenvectors. Emphasis on   applications and techniques.\n  Only one of MATH 207 and  MATH 317 may be counted toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Discrete Computational Structures",
    "dept": "MATH",
    "num": "230",
    "desc": "Prereq: Minimum of C- in COM S 227 and MATH 165; ENGL 150\nConcepts in discrete mathematics as applied to computer science. Logic, set theory, functions, relations, combinatorics, discrete probability, graph theory and number theory. Proof techniques, induction and recursion.\n",
    "credits": "3"
  },
  {
    "course_name": "Mathematics of Investment and Credit",
    "dept": "MATH",
    "num": "240",
    "desc": "Prereq: MATH 166\nInterest rates, time value of money, annuities. Loans, bonds, yield rates. Term structure of interest rates, asset and liability management. Duration, convexity, immunization.\n",
    "credits": "3"
  },
  {
    "course_name": "Calculus III",
    "dept": "MATH",
    "num": "265",
    "desc": "Prereq: Minimum of C- in MATH 166 or MATH 166H\nAnalytic geometry and vectors, differential calculus of functions of several variables, multiple   integrals, vector calculus.\n",
    "credits": "4"
  },
  {
    "course_name": "Calculus III, Honors",
    "dept": "MATH",
    "num": "265H",
    "desc": "Prereq: Permission of the instructor; and MATH 166 or MATH 166H\nAnalytic geometry and vectors, differential calculus of functions of several variables, multiple integrals, vector calculus. Additional material of a theoretical, conceptual, computational, or modeling nature. Some of the work may require more ingenuity than is required in MATH 265. Preference will be given to students in the University Honors Program.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Differential Equations",
    "dept": "MATH",
    "num": "266",
    "desc": "Prereq: Minimum of C- in MATH 166 or MATH 166H\nSolution methods for ordinary differential equations. First order equations, linear equations, constant coefficient   equations. Eigenvalue methods for systems of first order linear equations. Introduction to stability and phase   plane analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Elementary Differential Equations and Laplace Transforms",
    "dept": "MATH",
    "num": "267",
    "desc": "Prereq: Minimum of C- in MATH 166 or MATH 166H\nSame as MATH 266 but also including Laplace transforms and power series solutions to ordinary differential equations.\n",
    "credits": "4"
  },
  {
    "course_name": "Laplace Transforms",
    "dept": "MATH",
    "num": "268",
    "desc": "Prereq: MATH 266\nLaplace transforms and power series solutions to ordinary differential equations.\n  Together, MATH 266 and MATH 268 are the same as MATH 267.",
    "credits": "1"
  },
  {
    "course_name": "Systems of Differential Equations",
    "dept": "MATH",
    "num": "269",
    "desc": "Prereq: Familiarity with ordinary differential equations of first and second order, permission of department.\nSystems portion of MATH 266 and MATH 267:  Eigenvalue methods for systems of first order linear equations.  Introduction to stability and phase plane analysis.  For students supplementing transfer courses in differential equations in order to earn credit in MATH 266 or 267.\n  Students with credit in MATH 266 or MATH 267 may not earn credit in MATH 269.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "MATH",
    "num": "290",
    "desc": "Prereq: Permission of the instructor.\nIndependent study.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "MATH",
    "num": "290H",
    "desc": "Prereq: Permission of the instructor.\nIndependent study.\n",
    "credits": "1"
  },
  {
    "course_name": "Intermediate Topics for School Mathematics",
    "dept": "MATH",
    "num": "297",
    "desc": "Prereq: Enrollment in elementary education and minimum of C- in MATH 196\nMathematical reasoning and topics in Euclidean and non-Euclidean geometry, including transformations, congruence, and similarity; exploration of probability with simulations; linearity and connections to Calculus; fractals and fractal dimension.\n",
    "credits": "3"
  },
  {
    "course_name": "Abstract Algebra I",
    "dept": "MATH",
    "num": "301",
    "desc": "Prereq: MATH 166 or MATH 166H, MATH 317 or MATH 407, and grade of C- or better in MATH 201\nBasic properties of integers, divisibility and unique factorization. Polynomial rings over a field. Congruence. Introduction to abstract rings, homomorphisms, ideals. Roots and irreducibility of polynomials. Emphasis on proofs.\n",
    "credits": "3"
  },
  {
    "course_name": "Abstract Algebra II",
    "dept": "MATH",
    "num": "302",
    "desc": "Prereq: MATH 301\nTopics chosen from:  Advanced group theory, theory of rings and fields, factorization theory in integral domains, Galois theory.  Emphasis on writing proofs.\n",
    "credits": "3"
  },
  {
    "course_name": "Combinatorics",
    "dept": "MATH",
    "num": "304",
    "desc": "Prereq: MATH 166 or MATH 166H;  MATH 201 or experience with proofs\nEnumeration strategies involving permutations, combinations, partitions, binomial coefficients,  inclusion-exclusion principle, recurrence relations, generating functions. Additional  topics selected from probability, algebraic combinatorics, and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Graph Theory",
    "dept": "MATH",
    "num": "314",
    "desc": "Prereq: MATH 166 or MATH 166H; MATH 201 or experience with proofs\nStructure and extremal properties of graphs. Topics are selected from: trees, networks,   colorings, paths and cycles, connectivity, planarity, directed graphs, matchings, Ramsey theory, forbidden structures,   enumeration, applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory of Linear Algebra",
    "dept": "MATH",
    "num": "317",
    "desc": "Prereq: Credit or enrollment in MATH 201\nSystems of linear equations, determinants, vector spaces, inner product spaces, linear   transformations, eigenvalues and eigenvectors. Emphasis on writing proofs and results.\n  Only one of MATH 207 and MATH 317 may be counted toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Topology",
    "dept": "MATH",
    "num": "331",
    "desc": "Prereq: MATH 201; MATH 301, 317, 414, or 435.\nSet theory, metric spaces, topological spaces, continuity, connectedness, homeomorphisms, compactness, and topological invariants.  Examples from surfaces,  knots, and various abstract objects.  Emphasis on writing proofs.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the Theory of Probability and Statistics I",
    "dept": "MATH",
    "num": "341",
    "desc": "Prereq: MATH 265 (or MATH 265H)\nProbability; distribution functions and their properties; classical discrete and continuous distribution functions; multivariate probability distributions and their properties; moment generating functions; transformations of random variables; simulation of random variables and use of the R statistical package.\n  Credit for both STAT 341 and STAT 447 may not be applied toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Introduction to the Theory of Probability and Statistics II",
    "dept": "MATH",
    "num": "342",
    "desc": "Prereq: STAT 201 or equivalent; STAT 341; MATH 207 or MATH 317\nSampling distributions; confidence intervals and hypothesis testing; theory of estimation and hypothesis tests; linear model theory; resampling methods; introduction to Bayesian inference; use of the R statistical package for simulation and data analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "Number Theory",
    "dept": "MATH",
    "num": "350",
    "desc": "Prereq: MATH 201 or COM S 230\nDivisibility, integer representations, primes and divisors, linear diophantine equations, congruences, and multiplicative functions. Applications to cryptography. Additional topics, chosen at the discretion of the instructor.\n",
    "credits": "3"
  },
  {
    "course_name": "Complex Variables with Applications",
    "dept": "MATH",
    "num": "365",
    "desc": "Prereq: MATH 265\nFunctions of a complex variable, including differentiation, integration and series expansions,   residues, evaluation of integrals, conformal mapping.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Scientific Computing",
    "dept": "MATH",
    "num": "373",
    "desc": "Prereq: MATH 265\nVector and matrix programming and graphing in MATLAB for scientific applications. Polynomial interpolation and approximation. Systems of linear equations and numerical linear algebra. Numerical differentiation and integration. Newton methods for solving nonlinear equations and optimization in one and several variables. Fast Fourier transform.  Emphasis on effective use of mathematical software and understanding of its strengths and limitations.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Partial Differential Equations",
    "dept": "MATH",
    "num": "385",
    "desc": "Prereq: MATH 265 and one of MATH 266, MATH 267\nMethod of separation of variables for linear partial differential equations, including heat equation, Poisson equation, and wave equation.  Topics from Fourier series, Sturm-Liouville theory, Bessel functions, spherical harmonics, and method of characteristics.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Secondary Mathematics Using University Mathematics",
    "dept": "MATH",
    "num": "397",
    "desc": "Prereq: MATH 201, MATH 301\nCoursework in university mathematics including calculus, abstract algebra, discrete mathematics, geometry, and other topics as it relates to teaching mathematics in grades 5-12.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "MATH",
    "num": "398",
    "desc": "Prereq: Permission of the department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior   to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Applied Linear Algebra",
    "dept": "MATH",
    "num": "407",
    "desc": "Prereq: MATH 317; or MATH 207 and experience writing proofs\nAdvanced topics in applied linear algebra including eigenvalues, eigenvalue localization, singular value decomposition, symmetric and Hermitian matrices, nonnegative and stochastic matrices, matrix norms, canonical forms, matrix functions. Applications to mathematical and physical sciences, engineering, and other fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis I",
    "dept": "MATH",
    "num": "414",
    "desc": "Prereq: Minimum of C- in MATH 201\nA rigorous development of calculus of functions of one real variable:  real number properties and topology, limits, continuity, differentiation, integration, series.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis II",
    "dept": "MATH",
    "num": "415",
    "desc": "Prereq: MATH 414; MATH 265; and MATH 317 or MATH 407\nSequences and series of functions of a real variable, uniform convergence, power series, metric spaces, calculus of functions of two or more real variables.\n",
    "credits": "3"
  },
  {
    "course_name": "Logic for Mathematics and Computer Science",
    "dept": "MATH",
    "num": "421",
    "desc": "Prereq: MATH 301 or MATH 207 or MATH 317 or COM S 230\nPropositional and predicate logic.  Topics selected from Horn logic, equational logic,   resolution and unification, foundations of logic programming, reasoning about programs, program specification and verification, model checking and binary decision diagrams, temporal logic and modal logic.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to High Performance Computing",
    "dept": "MATH",
    "num": "424",
    "desc": "Prereq: MATH 265; MATH 207 or MATH 317; or permission of instructor.\nUnix, serial programming of scientific applications, OpenMP for shared-memory parallelization. No Unix, Fortran or C experience required.\n",
    "credits": "3"
  },
  {
    "course_name": "Geometry I",
    "dept": "MATH",
    "num": "435",
    "desc": "Prereq: MATH 201; MATH 207 or MATH 317\nEuclidean geometry of triangles, circles, and parallelograms, studied from several points of view, chosen from: synthetic, analytic, axiomatic, transformational, complex numbers, or vector methods.  Possible and impossible constructions with compass and straightedge.\n",
    "credits": "3"
  },
  {
    "course_name": "Geometry II",
    "dept": "MATH",
    "num": "436",
    "desc": "Prereq: MATH 201;  MATH 207 or MATH 317\nFoundations of Euclidean geometry and the axiomatic method, including the use of models.  The history, logical consistency, and basic theorems of non-Euclidean geometries, such as hyperbolic, elliptic, and projective geometry.\n",
    "credits": "3"
  },
  {
    "course_name": "Life Contingencies I",
    "dept": "MATH",
    "num": "441",
    "desc": "Prereq: MATH 240X, STAT 341\nTopics in life insurance for the Actuarial Sciences I: single life annuities, benefits premiums and reserves.\n",
    "credits": "3"
  },
  {
    "course_name": "Life Contingencies II",
    "dept": "MATH",
    "num": "442",
    "desc": "Prereq: MATH 441\nTopics in life insurance for the Actuarial Sciences II: multiple life functions, multiple decrement models, pension plan valuation, insurance models, applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical Methods for Differential Equations",
    "dept": "MATH",
    "num": "481",
    "desc": "Prereq: MATH 265 and either MATH 266 or MATH 267\nFirst order Euler method, high order Runge-Kutta methods, and multistep methods for solving ordinary differential equations. Finite difference and finite element methods for solving partial differential equations. Local truncation error, stability, and convergence for finite difference method.  Numerical solution space, polynomial approximation, and error estimate for finite element method.  Computer programming required.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "MATH",
    "num": "490",
    "desc": "Prereq: Permission of instructor.\n  No more than 9 credits of Math 490 or Math 490H may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "MATH",
    "num": "490H",
    "desc": "Prereq: Permission of the instructor.\n  No more than 9 credits of Math 490 or 490H may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Thesis",
    "dept": "MATH",
    "num": "491",
    "desc": "\nWriting and presenting a formal mathematics paper. Upon approval by the department, the paper will satisfy the departmental advanced English requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Undergraduate Seminar",
    "dept": "MATH",
    "num": "492",
    "desc": "Prereq: MATH 317 or MATH 407\nIntroduction to independent mathematical thought, with emphasis on oral communication of an advanced topic.  Seminar content varies.\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics",
    "dept": "MATH",
    "num": "495",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "arr"
  },
  {
    "course_name": "Teaching Secondary School Mathematics",
    "dept": "MATH",
    "num": "497",
    "desc": "Prereq: 15 credits in college mathematics.  If in a teacher licensure program, concurrent enrollment in EDUC 426 or EDUC 526.\nDevelop an understanding of instructional planning, lesson implementation, and assessment in grades 5-12 mathematics, with a focus on reform-based mathematics, equity, and conceptual understanding.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Real Analysis",
    "dept": "MATH",
    "num": "501",
    "desc": "Prereq: MATH 265 and (MATH 207 or MATH 317)\nA development of the real numbers. Study of metric spaces, completeness, compactness,   sequences, and continuity of functions. Differentiation and integration of real-valued   functions, sequences of functions, limits and convergence, equicontinuity.\n",
    "credits": "3"
  },
  {
    "course_name": "Topology",
    "dept": "MATH",
    "num": "502",
    "desc": "Prereq: MATH 414 or MATH 501\nIntroduction to general topology. Topological spaces, continuous functions, connectedness, compactness. Topics selected from countability and separation axioms, metrization, and complete metric spaces.   Topics in algebraic topology.\n",
    "credits": "3"
  },
  {
    "course_name": "Abstract Algebra I",
    "dept": "MATH",
    "num": "504",
    "desc": "Prereq: MATH 302\nAlgebraic systems and their morphisms, with emphasis on groups and rings.\n",
    "credits": "3"
  },
  {
    "course_name": "Abstract Algebra II",
    "dept": "MATH",
    "num": "505",
    "desc": "Prereq: MATH 504\nContinuation of MATH 504.  Algebraic systems and their morphisms, with emphasis on modules and fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Linear Algebra",
    "dept": "MATH",
    "num": "507",
    "desc": "Prereq: MATH 317; or MATH 207 and experience writing proofs\nAdvanced topics in applied linear algebra including eigenvalues, eigenvalue localization, singular value decomposition, symmetric and Hermitian matrices, nonnegative and stochastic matrices, matrix norms, canonical forms, matrix functions. Applications to mathematical and physical sciences, engineering, and other fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Linear Algebra",
    "dept": "MATH",
    "num": "510",
    "desc": "Prereq: MATH 317 or MATH 407 or (MATH 207 and one of MATH 301 or MATH 414)\nAdvanced topics in linear algebra including canonical forms; unitary, normal, Hermitian and   positive-definite matrices; variational characterizations of eigenvalues.\n",
    "credits": "3"
  },
  {
    "course_name": "Functions of a Single Complex Variable",
    "dept": "MATH",
    "num": "511",
    "desc": "Prereq: MATH 414  or MATH 501\nTheory of analytic functions, integration, topology of the extended complex plane,   singularities and residue theory, maximum principle, conformal mapping, meromorphic functions, argument principle.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Analysis I",
    "dept": "MATH",
    "num": "515",
    "desc": "Prereq: MATH 414 or MATH 501\nLebesgue measure and Lebesgue integral, one variable differentiation theory, Fubini and Tonelli theorems in R^n, Lp spaces.\n",
    "credits": "3"
  },
  {
    "course_name": "Real Analysis II",
    "dept": "MATH",
    "num": "516",
    "desc": "Prereq: MATH 515\nMetric spaces, topological spaces, compactness, abstract theory of measure and integral, differentiation of measures, Banach spaces.\n",
    "credits": "3"
  },
  {
    "course_name": "Finite Difference Methods",
    "dept": "MATH",
    "num": "517",
    "desc": "Prereq: MATH 481 or MATH 561\nFinite difference methods for partial differential equations. Methods for elliptic equations; explicit and implicit methods for parabolic and hyperbolic equations; stability, accuracy, and convergence theory, including von Neumann analysis, modified equations, and the Courant-Friedrichs-Lewy condition.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Applied Mathematics I",
    "dept": "MATH",
    "num": "519",
    "desc": "Prereq: MATH 414 or MATH 501\nTechniques of classical and functional analysis with applications to  differential   equations and integral equations.  Vector spaces,   metric spaces, Hilbert and Banach spaces, Sobolev spaces and other function spaces, contraction mapping theorem, distributions,  Fourier series and Fourier transform.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Applied Mathematics II",
    "dept": "MATH",
    "num": "520",
    "desc": "Prereq: MATH 519\nContinuation of MATH 519.  Linear operators, spectral theory of differential and integral operators, Green's functions and boundary value problems, weak solutions of partial differential equations and variational methods, calculus in Banach spaces and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical Analysis of High Performance Computing",
    "dept": "MATH",
    "num": "525",
    "desc": "Prereq: CPR E 308 or MATH 481; experience in scientific programming; knowledge of FORTRAN or C\nIntroduction to parallelization techniques and numerical methods for distributed memory high performance computers. A semester project in an area related to each student’s research interests is required.\n",
    "credits": "3"
  },
  {
    "course_name": "Cryptography",
    "dept": "MATH",
    "num": "533",
    "desc": "Prereq: MATH 301 or CPR E 310 or COM S 230\nBasic concepts of secure communication, DES and AES, public-key cryptosystems, elliptic curves, hash algorithms, digital signatures, applications. Relevant material on number theory and finite fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Steganography and Digital Image Forensics",
    "dept": "MATH",
    "num": "535",
    "desc": "Prereq: E E 524 or MATH 317 or MATH 407 or COM S 230\nBasic principles of covert communication, steganalysis, and forensic analysis for digital images. Steganographic security and   capacity, matrix embedding, blind attacks, image forensic detection and device identification techniques. Related material on coding   theory, statistics, image processing, pattern recognition.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Mathematics Education",
    "dept": "MATH",
    "num": "540",
    "desc": "Prereq: Enrollment in the Master of School Mathematics program or professional studies in education\nResearch studies in mathematics learning and teaching, exemplary practices in mathematics education, and current state and   national trends in the mathematics curriculum in grades K-12.  Students in MSM take each of 540A, 540B, and 540C.  Topics are offered on a 3-year cycle. A. Assessment, equity, and teaching of statistics.  Offered SS 2017. B. Geometry and discrete mathematics, and problem solving.  Offered SS 2018. C. Teaching of analysis, algebra, and the use of technology.  Offered SS 2016.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Mathematics Education: Assessment, equity, and teaching of statistics.",
    "dept": "MATH",
    "num": "540A",
    "desc": "Prereq: Enrollment in the Master of School Mathematics program or professional studies in education\nResearch studies in mathematics learning and teaching, exemplary practices in mathematics education, and current state and   national trends in the mathematics curriculum in grades K-12.  Topics are offered on a 3-year cycle.  Offered SS 2017.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Mathematics Education: Geometry and discrete mathematics, and problem solving.",
    "dept": "MATH",
    "num": "540B",
    "desc": "Prereq: Enrollment in the Master of School Mathematics program or professional studies in education\nResearch studies in mathematics learning and teaching, exemplary practices in mathematics education, and current state and national trends in the mathematics curriculum in grades K-12.  Offered on a 3-year cycle.  Offered SS 2018.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Mathematics Education: Teaching of analysis, algebra, and the use of technology.",
    "dept": "MATH",
    "num": "540C",
    "desc": "Prereq: Enrollment in the Master of School Mathematics program or professional studies in education\nResearch studies in mathematics learning and teaching, exemplary practices in mathematics education, and current state and   national trends in the mathematics curriculum in grades K-12.  Topics are offered on a 3-year cycle.  Offered SS  2016.\n",
    "credits": "1"
  },
  {
    "course_name": "Intermediate Calculus",
    "dept": "MATH",
    "num": "545",
    "desc": "Prereq: 3 semesters of calculus and enrollment in the master of school mathematics program\nOffered on a 3-year cycle, offered SS. 2016. The fundamental concepts of calculus which are critical to the effective understanding of the material in first year calculus.   Emphasis is on a constructivist approach to learning, cooperative groups, problem solving, and use of technology.\n",
    "credits": "4"
  },
  {
    "course_name": "Algorithms in Analysis and  Their Computer Implementation",
    "dept": "MATH",
    "num": "546",
    "desc": "Prereq: 3 semesters in calculus or concurrent enrollment in 545 and enrollment in the master of  school mathematics program\nOffered on a 3- year cycle, offered SS.  2016. The use of technology in secondary mathematics with an emphasis on the exploration, creation, and implementation of algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Discrete Mathematics and Applications",
    "dept": "MATH",
    "num": "547",
    "desc": "Prereq: Enrollment in the master of school mathematics program\nOffered on a 3-year cycle, offered SS. 2018. Applications of graph theory, game theory, voting theory, recursion,   combinatorics, and algebraic structures.  Issues in integrating   discrete topics into the secondary curriculum. Use of the computer to explore discrete mathematics.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Geometry",
    "dept": "MATH",
    "num": "549",
    "desc": "Prereq: MATH 435 or equivalent and enrollment in the master of school mathematics program\nOffered on a 3-year cycle, offered SS. 2018. A study of geometry with emphasis on metrics,  the group of isometries, and the group   of similarities. Specific spaces studied normally include the Euclidean plane, the 2-sphere,  projective 2-space, and hyperbolic   geometry.   Emphasis on analytical methods. Incorporation of geometry software.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Stochastic Processes",
    "dept": "MATH",
    "num": "554",
    "desc": "Prereq: STAT 542\nMarkov chains on discrete spaces in discrete and continuous time (random walks, Poisson   processes, birth and death processes) and their long-term behavior. Optional topics may include branching processes, renewal theory, introduction to Brownian motion.\n",
    "credits": "3"
  },
  {
    "course_name": "Ordinary Differential Equations and Dynamical Systems",
    "dept": "MATH",
    "num": "557",
    "desc": "Prereq: MATH 415 or MATH 501\nThe initial-value problem, existence and uniqueness theorems, continuous dependence on   parameters, linear systems, stability and   asymptotic behavior of solutions, linearization,   dynamical systems, bifurcations, and chaotic behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical Analysis I",
    "dept": "MATH",
    "num": "561",
    "desc": "Prereq: MATH 414 or MATH 501\nApproximation theory, including polynomial interpolation, spline interpolation and best approximation; numerical differentiation and integration; numerical methods for ordinary differential equations.\n",
    "credits": "3"
  },
  {
    "course_name": "Numerical Analysis II",
    "dept": "MATH",
    "num": "562",
    "desc": "Prereq: MATH 317\nNumerical linear algebra including LU factorization, QR factorization, linear least squares, singular value decomposition, eigenvalue problems, and iterative methods for large linear systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Continuous Optimization",
    "dept": "MATH",
    "num": "565",
    "desc": "Prereq: MATH 265 and one of MATH 317, 507, 510\nTheory and methods for constrained and unconstrained optimization. Steepest-descent, conjugate gradient, Newton and quasi-Newton, line search and trust-region, first and second order necessary and sufficient conditions, linear, quadratic and general nonlinear programming.\n",
    "credits": "3"
  },
  {
    "course_name": "Discrete Optimization",
    "dept": "MATH",
    "num": "566",
    "desc": "Prereq: MATH 317 or MATH 507 or MATH 510\nAlgorithms for linear programming, integer and combinatorial optimization. Linear programming, duality theory, simplex algorithm; the solution of the shortest-path, minimum spanning tree, max-flow/min-cut, minimum cost flow, maximum matching, and traveling salesman problems; integer linear programming, branch-and-bound, local and global search algorithms; matroids and greedy algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Graph Theory",
    "dept": "MATH",
    "num": "567",
    "desc": "Prereq: MATH 317 or MATH 507 or MATH 510\nStructural theory of graphs. Topics include basic structures (trees, paths, cycles and matchings), networks, colorings, connectivity, topological graph theory, Ramsey and Turan theory, spectral graph theory, introduction to probabilistic methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Enumerative Combinatorics and Ordered Sets",
    "dept": "MATH",
    "num": "568",
    "desc": "Prereq: MATH 302 or MATH 504\nEnumeration methods. Generating functions and sieve methods. Partially ordered sets, lattices, and Moebius inversion. Extremal set theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Linear Systems",
    "dept": "MATH",
    "num": "577",
    "desc": "Prereq: E E 324 or AER E 331 or MATH 415; and MATH 207\nLinear algebra review. Least square method and singular value decomposition. State space modeling of linear continuous-time systems. Solution of linear systems. Controllability and observability. Canonical description of linear equations. Stability of linear systems. State feedback and pole placements. Observer design for linear systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonlinear Systems",
    "dept": "MATH",
    "num": "578",
    "desc": "Prereq: E E 577\nLinear vs nonlinear systems. Phase plane analysis. Bifurcation and center manifold theory. Lyapunov stability. Absolute stability of feedback systems. Input-output stability. Passivity theory and feedback linearization. Nonlinear control design techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "MATH",
    "num": "590",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Orientation for Mathematics Graduate Students I",
    "dept": "MATH",
    "num": "591",
    "desc": "\nFall semester orientation seminar. Required for graduate students in Mathematics and Applied Mathematics. Topics include teaching at the university level and communication of mathematics.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Orientation for Mathematics Graduate Students II",
    "dept": "MATH",
    "num": "592",
    "desc": "\nSpring semester orientation seminar. Required for graduate students in Mathematics and Applied Mathematics. Topics include   teaching at the university level and communication of mathematics.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Special Topics",
    "dept": "MATH",
    "num": "595",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "MATH",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Mathematical Logic",
    "dept": "MATH",
    "num": "601",
    "desc": "Prereq: MATH 504\nModel theory of propositional and predicate logic, the Soundness Theorem, the Compactness Theorem, the Goedel-Henkin Completeness Theorem, the Incompleteness Theorem, computability theory.  As time permits: modal and temporal logic, set theory (the continuum hypothesis).  Emphasis on the relationship between `provable' and `true' and the relationship between `computable' and `definable'.\n",
    "credits": "3"
  },
  {
    "course_name": "Design Theory and Association Schemes",
    "dept": "MATH",
    "num": "605",
    "desc": "Prereq: MATH 504\nCombinatorial designs and algebraic codes. Construction methods including finite fields.   Error-correcting codes. Adjacency matrices and algebraic combinatorics.\n",
    "credits": "3"
  },
  {
    "course_name": "Extremal Graph Theory",
    "dept": "MATH",
    "num": "608",
    "desc": "Prereq: MATH 567\nStudy of extremal graph problems and methods. Topics include probabilistic methods, generalizations of Turan’s theorem, Szemeredi's regularity lemma, random graph theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar",
    "dept": "MATH",
    "num": "610",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "General Theory of Algebraic Structures I",
    "dept": "MATH",
    "num": "615",
    "desc": "Prereq: MATH 504\nFirst semester of full-year course. Subalgebras, homomorphisms, congruence relations,   and direct products. Lattices and closure   operators. Varieties and quasivarieties of   algebras, free algebras, Birkhoff's theorems, clones, Mal'cev conditions. Advanced topics.\n",
    "credits": "3"
  },
  {
    "course_name": "General Theory of Algebraic Structures II",
    "dept": "MATH",
    "num": "616",
    "desc": "Prereq: MATH 615\nContinuation of MATH 615.\n",
    "credits": "3"
  },
  {
    "course_name": "Category Theory",
    "dept": "MATH",
    "num": "617",
    "desc": "Prereq: MATH 504\nCategories and functors and their applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Representation Theory",
    "dept": "MATH",
    "num": "618",
    "desc": "Prereq: MATH 504\nRepresentations of algebraic structures.  Content varies by semester.\n",
    "credits": "3"
  },
  {
    "course_name": "Manifolds, Tensors and Differential Geometry",
    "dept": "MATH",
    "num": "624",
    "desc": "Prereq: MATH 501 or MATH 515\nTopics selected from: Geometry of curves and surfaces. Manifolds, coordinate systems.  Tangent and cotangent vectors, vector fields.  Tensors, differential forms, Riemannian   metrics. Connections, covariant differentiation,   curvature tensors.  Applications to physics and engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Harmonic Analysis",
    "dept": "MATH",
    "num": "631",
    "desc": "Prereq: MATH 515\nFourier Series on an interval, approximate identities and summation, Gibb's phenomenon, Fourier transform on the line, uncertainty principle. Additional topics may include distributions, Hardy-Littlewood maximal function, boundedness of singular integral operators, arithmetic combinatorics, wavelet theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Functional Analysis",
    "dept": "MATH",
    "num": "633",
    "desc": "Prereq: MATH 515\nFundamental theory of normed linear spaces and algebras, such as topology and continuity, duality and spectral theory,   emphasizing aspects that provide a framework for the study of the spectrum of an operator, analytic function theory, and modern operator theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Probability Theory",
    "dept": "MATH",
    "num": "641",
    "desc": "Prereq: MATH 414 or MATH 501 or equivalent course.\nSequences and set theory; Lebesgue measure, measurable functions. Absolute continuity of functions, integrability and the fundamental theorem of Lebesgue integration. General measure spaces, probability measure, extension theorem and construction of Lebesgue-Stieljes measures on Euclidean spaces. Measurable transformations and random variables, induced measures and probability distributions. General integration and expectation, Lp-spaces and integral inequalities. Uniform integrability and absolute continuity of measures. Probability densities and the Radon-Nikodym theorem. Product spaces and Fubini-Tonelli theorems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Probability Theory",
    "dept": "MATH",
    "num": "642",
    "desc": "Prereq: STAT 641, or STAT 543 and MATH 515.\nProbability spaces and random variables. Kolmogorov's consistency theorem. Independence, Borel-Cantelli lemmas and Kolmogorov's 0 - 1 Law. Comparing types of convergence for random variables. Sums of independent random variables, empirical distributions, weak and strong laws of large numbers. Convergence in distribution and its characterizations, tightness, characteristic functions, central limit theorems and Lindeberg-Feller conditions. Conditional probability and expectation. Discrete parameter martingales and their properties and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Stochastic Processes",
    "dept": "MATH",
    "num": "645",
    "desc": "\nWeak convergence. Random walks and Brownian motion. Martingales. Stochastic integration and Ito's Formula. Stochastic differential   equations and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Mathematical Modeling of Complex Physical Systems",
    "dept": "MATH",
    "num": "646",
    "desc": "\nModeling of the dynamics of complex systems on multiple scales: Classical and dissipative molecular dynamics, stochastic modeling and Monte-Carlo simulation; coarse grained nonlinear dynamics, interface propagation and spatial pattern formation.\n",
    "credits": "3"
  },
  {
    "course_name": "Partial Differential Equations I",
    "dept": "MATH",
    "num": "655",
    "desc": "Prereq: MATH 515 or MATH 519\nStudy of model problems of elliptic, parabolic and hyperbolic types, first order equations, conservation laws, transform methods, introduction to linear partial differential equations of arbitrary order, fundamental solutions.\n",
    "credits": "3"
  },
  {
    "course_name": "Partial Differential Equations II",
    "dept": "MATH",
    "num": "656",
    "desc": "Prereq: MATH 655\nSobolev spaces, general theory of second order linear elliptic, parabolic and hyperbolic partial differential equations, first order linear hyperbolic systems, variational methods, fixed point methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Finite Element Methods",
    "dept": "MATH",
    "num": "666",
    "desc": "Prereq: MATH 516 or MATH 520 or MATH 561 or MATH 656\nWeak and variational formulations of elliptic problems; weak derivatives and Sobolev spaces; Lax-Milgram theorem, Bramble-Hilbert lemma; examples of finite element spaces; polynomial approximation theory; error estimates for finite element methods; implementation issues; mixed finite element methods for Stokes problems; applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Methods for Hyperbolic Partial Differential Equations (PDE)",
    "dept": "MATH",
    "num": "667",
    "desc": "Prereq: MATH 561, MATH 562\nMathematical theory of weak/entropy solutions of nonlinear hyperbolic conservation laws; shock speed and Riemann problems; numerical methods for scalar equations and systems including Euler equations; conservative methods; approximate Riemann solvers; total variation stability; DG method.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "MATH",
    "num": "680",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Algebra",
    "dept": "MATH",
    "num": "680A",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Analysis",
    "dept": "MATH",
    "num": "680B",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Applied Mathematics",
    "dept": "MATH",
    "num": "680C",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Combinatorics",
    "dept": "MATH",
    "num": "680D",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Differential Equations",
    "dept": "MATH",
    "num": "680E",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Linear Algebra",
    "dept": "MATH",
    "num": "680F",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Logic and Foundations",
    "dept": "MATH",
    "num": "680G",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Number Theory",
    "dept": "MATH",
    "num": "680H",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Numerical Analysis",
    "dept": "MATH",
    "num": "680I",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Optimization",
    "dept": "MATH",
    "num": "680J",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Probability",
    "dept": "MATH",
    "num": "680K",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics: Topology",
    "dept": "MATH",
    "num": "680L",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "MATH",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Mechanical Engineering Problem Solving with Computer Applications",
    "dept": "M E",
    "num": "160",
    "desc": "Prereq: M E majors only. MATH 142 or MATH 143 or MATH 145; credit or enrollment in MATH 165.\nIntroduction to the field of Mechanical Engineering through problem-solving in a range of topics including statics, mechanics of materials and thermo-fluids. Techniques to professionally present and communicate solutions. Use of MATLAB computer programming to aid problem solving, including curve fitting and graphing.\n  Only one of M E 160, ENGR 160, Aer E 160, C E 160, CPR E 185, E E 185, S E 185 and I E 148 may count towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Engineering Graphics and Introductory Design",
    "dept": "M E",
    "num": "170",
    "desc": "Prereq: Satisfactory scores on mathematics placement assessments; credit or enrollment in MATH 142 or MATH 143 or MATH 145\nIntegration of fundamental graphics, computer modeling, and engineering design. Applications of multiview drawings and dimensioning. Techniques for visualizing, analyzing, and communicating 3-D geometries. Application of the design process including written and oral reports. Freehand and computer methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Learning Communities",
    "dept": "M E",
    "num": "190",
    "desc": "\nEnrollment in M E learning communities.\n",
    "credits": "1"
  },
  {
    "course_name": "Mechanical Engineering - Professional Planning",
    "dept": "M E",
    "num": "202",
    "desc": "Prereq: Credit or Enrollment in M E 231\nPreparation for a career in mechanical engineering; discussion of opportunities for leadership, undergraduate research, experiential learning.\n",
    "credits": "R"
  },
  {
    "course_name": "Globalization and Sustainability",
    "dept": "M E",
    "num": "220",
    "desc": "\nAn introduction to understanding the key global issues in sustainability. Focuses on interconnected roles of energy, materials, human resources, economics, and technology in building and maintaining sustainable systems. Applications discussed will include challenges in both the developed and developing world and will examine the role of technology in a resource-constrained world.\n  Cannot be used for technical elective credit in any engineering department.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Thermodynamics I",
    "dept": "M E",
    "num": "231",
    "desc": "Prereq: MATH 166, CHEM 167, PHYS 221\nFundamental concepts based on zeroth, first and second laws of thermodynamics. Properties and processes for ideal gases and solid-liquid-vapor phases of pure substances. Applications to vapor power cycles.\n  Credit for either M E 231 or 330, but not both, may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Mechanical Engineering Design",
    "dept": "M E",
    "num": "270",
    "desc": "Prereq: M E 160 or equivalent, M E 170 or equivalent, PHYS 221\nOverview of mechanical engineering design with applications to thermal and mechanical systems. Introduction to current design practices used in industry. Semester-long team project focused on addressing societal needs. Past projects include designing human powered charging systems and products for developing nations.\n",
    "credits": "3"
  },
  {
    "course_name": "Manufacturing Engineering",
    "dept": "M E",
    "num": "324",
    "desc": "Prereq: M E 270, E M 324, MAT E 273 and M E 324L\nFundamentals of manufacturing processes including forming, machining, casting and welding with emphasis on design considerations in manufacturing. Mechanical behavior of metallic materials. Modern manufacturing practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Manufacturing Engineering Laboratory",
    "dept": "M E",
    "num": "324L",
    "desc": "Prereq: M E 270, MAT E 273\nLaboratory exercises in metrology, mechanical testing (tensile/compression and hardness tests), computer aided design (CAD), machining operations, metal welding, metal casting, and bulk/sheet metal forming.\n",
    "credits": "1"
  },
  {
    "course_name": "Mechanical Component Design",
    "dept": "M E",
    "num": "325",
    "desc": "Prereq: M E 170, E M 324, and STAT 305\nPhilosophy of design and design methodology. Consideration of stresses and failure models useful for static and fatigue loading. Analysis, selection and synthesis of machine elements.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Thermodynamics II",
    "dept": "M E",
    "num": "332",
    "desc": "Prereq: M E 231\nGas power cycles. Fundamentals of gas mixtures, psychrometry, and thermochemistry. Applications to one-dimensional compressible flow, refrigeration, air conditioning and combustion processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Fluid Flow",
    "dept": "M E",
    "num": "335",
    "desc": "Prereq: M E 345, MATH 265, MATH 266 or MATH 267, credit or enrollment in M E 332.\nIncompressible and compressible fluid flow fundamentals. Dimensional analysis and similitude. Internal and external flow applications. Lab experiments emphasizing concepts in thermodynamics and fluid flow. Written reports are required.\n",
    "credits": "4"
  },
  {
    "course_name": "Engineering Dynamics",
    "dept": "M E",
    "num": "345",
    "desc": "Prereq: E M 274, credit or enrollment in MATH 266 or MATH 267\nParticle and rigid body kinematics, Newton's laws of motion, kinetics of plane motion, rigid body problems using work-energy, linear, and angular impulse-momentum principles, vibrations.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Measurements",
    "dept": "M E",
    "num": "370",
    "desc": "Prereq: E E 442, STAT 305\nFundamentals of design, selection, and operation of components of measuring systems. Measurement processes, data acquisition systems, analysis of data, and propagation of measurement uncertainty.\n",
    "credits": "3"
  },
  {
    "course_name": "Summer Internship",
    "dept": "M E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education (Co-op).",
    "dept": "M E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period. One semester per academic or calendar year. Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Human Centered Design, Pre-Departure Course.",
    "dept": "M E",
    "num": "401",
    "desc": "Prereq: Acceptance into Study Abroad Program.\nA pre-departure course for M E 402. Safety and health issues while on site; travel logistics; required travel documents and deadlines; cultural norms.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Field Engineering: Human Centered Design Concepts.",
    "dept": "M E",
    "num": "402",
    "desc": "Prereq: M E 401\nDesign methodology and field engineering principles for use in engineering problem solving in developing nations; application of principals will be on site. Awareness of culture, use of local artisans, crafts people and engineers will be emphasized for the purpose of ensuring sustainable and appropriate technology.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Engineering Applications of Mechatronics",
    "dept": "M E",
    "num": "410",
    "desc": "Prereq: E E 442, E E 448, credit or enrollment in M E 421\nFundamentals of sensor characterization, signal conditioning and motion control, coupled with concepts of embedded computer control. Digital and analog components used for interfacing with computer controlled systems. Mechanical system analysis combined with various control approaches. Focus on automation of hydraulic actuation processes. Laboratory experiences provide hands-on development of mechanical systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Automatic Controls",
    "dept": "M E",
    "num": "411",
    "desc": "Prereq: M E 421\nMethods and principles of automatic control. Pneumatic, hydraulic, and electrical systems. Representative applications of automatic control systems. Mathematical analysis of control systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Ethical Responsibilities of a Practicing Engineer",
    "dept": "M E",
    "num": "412",
    "desc": "Prereq: Credit or enrollment in M E 325\nThe study of ethics in engineering design and the engineering profession. A comprehensive look at when ethical decisions must be made and an approach to make them. The approach takes into account moral, legal, technical, experiential, and standards to aid in ethical decision making. Each area will be studied through lectures, debates, guest speakers, class discussion, and case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Fluid Power Engineering",
    "dept": "M E",
    "num": "413",
    "desc": "Prereq: Credit or enrollment in E M 378 or M E 335, A B E 216 or M E 270\nProperties of hydraulic fluids. Performance parameters of fixed and variable displacement pumps and motors. Hydraulic circuits and systems. Hydrostatic transmissions. Characteristics of control valves. Analysis and design of hydraulic systems for power and control functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Systems Design",
    "dept": "M E",
    "num": "415",
    "desc": "Prereq: M E 324, M E 325\nMechanical Engineering Capstone Design course. Team approach to solving design problems involving mechanical systems.  Teams will use current design practices they will encounter in industry.  Document decisions concerning form and function, material specification, manufacturing methods, safety, cost, and conformance with codes and standards. Solution description includes oral and written reports.  Projects often worked with industry sponsors.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanism Design and Analysis",
    "dept": "M E",
    "num": "416",
    "desc": "Prereq: M E 325\nAn introduction to the design and analysis of mechanisms and the use of prescribed design methodologies to identify design requirements and achieve desired motion profiles. Topics include fundamental mechanism kinematics; graphical and analytical mechanism synthesis methods; velocity and acceleration analysis; and the design of linkages, cams and gear trains. Significant amount of team-based problem solving and the development of physical and computational models to assist in the design process.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Machine Design",
    "dept": "M E",
    "num": "417",
    "desc": "Prereq: M E 325, MAT E 273\nStress life, strain life, and fracture mechanics approaches to fatigue life and design with metals, polymers and ceramics.  Introduction to material selection in design of machine components.  Thermal and structural considerations in design of machine components and hybrid materials.  Course project and relevant literature review required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Considerations in Robotics",
    "dept": "M E",
    "num": "418",
    "desc": "Prereq: Credit or enrollment in M E 421\nThree dimensional kinematics, dynamics, and control of robot manipulators, hardware elements and sensors. Laboratory experiments using industrial robots.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer-Aided Design",
    "dept": "M E",
    "num": "419",
    "desc": "Prereq: M E 325\nTheory and applications of computer- aided design. Computer graphics programming, solid modeling, assembly modeling, and finite element modeling. Mechanical simulation, process engineering, rapid prototyping and manufacturing integration.\n",
    "credits": "3"
  },
  {
    "course_name": "System Dynamics and Control",
    "dept": "M E",
    "num": "421",
    "desc": "Prereq: E E 442, E E 448, M E 345, MATH 267\nModeling and simulation of mechanical, electrical, fluid, and/or thermal systems.  Development of equations of motion and dynamic response characteristics in time and frequency domains.  Fundamentals of classical control applications, including mathematical analysis and design for closed loop control systems.  Introduction to computer interfacing for simulation, data acquisition, and control.  Laboratory exercises for hands-on system investigation and control implementation.\n",
    "credits": "4"
  },
  {
    "course_name": "Optimization Methods for Complex Designs",
    "dept": "M E",
    "num": "425",
    "desc": "Prereq: M E 160, MATH 265\nOptimization involves finding the 'best' according to specified criteria. Review of a range of optimization methods from traditional nonlinear to modern evolutionary methods such as Genetic algorithms. Examination of how these methods can be used to solve a wide variety of design problems across disciplines, including mechanical systems design, biomedical device design, biomedical imaging, and interaction with digital medical data. Students will gain knowledge of numerical optimization algorithms and sufficient understanding of the strengths and weaknesses of these algorithms to apply them appropriately in engineering design. Experience includes code writing and off-the-shelf routines. Numerous case-studies of real-world situations in which problems were modeled and solved using advanced optimization techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Vehicle Dynamics and Suspension Design",
    "dept": "M E",
    "num": "427",
    "desc": "Prereq: MATH 265, MATH 267, and E M 345\nAnalysis and evaluation of the performance of cars, trucks and other surface vehicles. Computer simulation of ride, braking, and directional response.  Considerations in the design and fabrication of suspension systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Alternative Energy",
    "dept": "M E",
    "num": "433",
    "desc": "Prereq: PHYS 221/PHYS 222 and CHEM 167\nBasic principles, performance, and cost analysis of alternative energy systems including biofuels, bioenergy, wind, solar, fuel cells, storage and other alternative energy systems. Performance analysis and operating principles of systems and components, and economic analysis for system design and operation will be taught. Emphasis is on alternative energy technologies needed to meet our future energy needs at various scales ranging from household to city to national levels.\n",
    "credits": "3"
  },
  {
    "course_name": "Heat Transfer",
    "dept": "M E",
    "num": "436",
    "desc": "Prereq: M E 335\nHeat transfer by conduction, convection, and radiation. Similarity concepts in heat, mass, and momentum transfer. Methods for determination of heat transfer coefficients. Combined modes of heat transfer. Heat exchangers. Lab experiments emphasizing concepts in thermodynamics and heat transfer. Written reports are required.\n",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Combustion Engineering",
    "dept": "M E",
    "num": "437",
    "desc": "Prereq: Credit in M E 332 or equivalent and credit or enrollment in M E 335 or equivalent.\nIntroduction to the fundamentals of combustion and the analysis of combustion systems for gaseous, liquid, and solid fuels-including biomass fuels. Combustion fundamentals are applied to the analysis of engines; turbines, biomass cookstoves; suspension, fixed-bed, and fluidized-bed furnaces; and other combustion devices.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Heating, Ventilating, and Air Conditioning",
    "dept": "M E",
    "num": "441",
    "desc": "Prereq: Credit or enrollment in M E 436\nSpace conditioning and moist air processes. Application of thermodynamics, heat transfer, and fluid flow principles to the analysis of heating, ventilating, and air conditioning components and systems. Performance and specification of components and systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Heating and Air Conditioning Design",
    "dept": "M E",
    "num": "442",
    "desc": "Prereq: M E 441 or with Instructor Permission\nDesign criteria and assessment of building environment and energy requirements. Design of heating, ventilating, and air conditioning systems. System control and economic analysis. Oral and written reports required.\n",
    "credits": "3"
  },
  {
    "course_name": "Elements and Performance of Power Plants",
    "dept": "M E",
    "num": "444",
    "desc": "Prereq: M E 332, credit or enrollment in M E 335\nBasic principles, thermodynamics, engineering analysis of power plant systems. Topics include existing power plant technologies, the advanced energyplex systems of the future, societal impacts of power production, and environmental and regulatory concerns.\n",
    "credits": "3"
  },
  {
    "course_name": "Fluid Dynamics of Turbomachinery",
    "dept": "M E",
    "num": "448",
    "desc": "Prereq: AER E 311 or M E 335\nApplications of principles of fluid mechanics and thermodynamics in performance analysis and design of turbomachines. Conceptual and preliminary design of axial and radial flow compressors and turbines using velocity triangles and through-flow approaches.\n",
    "credits": "3"
  },
  {
    "course_name": "Internal Combustion Engines",
    "dept": "M E",
    "num": "449",
    "desc": "Prereq: M E 335\nBasic principles, thermodynamics, combustion, and exhaust emissions of spark-ignition and compression-ignition engines. Laboratory determination of fuel properties and engine performance. Effects of engine components and operating conditions on performance. Written reports required.\n",
    "credits": "3"
  },
  {
    "course_name": "Engineering Acoustics",
    "dept": "M E",
    "num": "451",
    "desc": "Prereq: PHYS 221 and MATH 266 or MATH 267\nThe basics of acoustic wave propagation in fluids with an emphasis on sound propagation in air. Topics include transmission and reflection of sound at a boundary; role of acoustic sources in directing sound fields; diffraction of sound around solid objects; reverberation of sound in a room; and the measurement of sound fields.\n",
    "credits": "3"
  },
  {
    "course_name": "Machine Vision",
    "dept": "M E",
    "num": "456",
    "desc": "Prereq: MATH 317, M E 421 or permission of instructor\nPractical imaging processing techniques, geometric optics, and mathematics behind machine vision, as well as the most advanced 3D vision techniques. Experience with practical vision system development and analysis. Assignments include individual bi-weekly homework; weekly readings and lectures; and a semester-long research project on design and experiment vision systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design",
    "dept": "M E",
    "num": "466",
    "desc": "Prereq: Student must be within two semesters of graduation; permission of instructor.\nApplication of team design concepts to projects of a multidisciplinary nature. Concurrent treatment of design, manufacturing, and life cycle considerations. Application of design tools such as CAD, CAM, and FEM. Design methodologies, project scheduling, cost estimating, quality control, manufacturing processes. Development of a prototype and appropriate documentation in the form of written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Multidisciplinary Engineering Design II",
    "dept": "M E",
    "num": "467",
    "desc": "Prereq: Student must be within two semesters of graduation or receive permission of instructor.\nBuild and test of a conceptual design. Detail design, manufacturability, test criteria and procedures. Application of design tools such as CAD and CAM and manufacturing techniques such as rapid prototyping. Development and testing of a full-scale prototype with appropriate documentation in the form of design journals, written reports, oral presentations and computer models and engineering drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Modeling and Simulation",
    "dept": "M E",
    "num": "475",
    "desc": "Prereq: M E 421, credit or enrollment in M E 436\nIntroduction to computer solution techniques required to simulate flow, thermal, and mechanical systems. Methods of solving ordinary and partial differential equations and systems of algebraic equations; interpolation, numerical integration; finite difference and finite element methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainability Science for Engineering Design",
    "dept": "M E",
    "num": "479",
    "desc": "Prereq: Any engineering design course\nScientific principles and quantitative methods concerning sustainability. Analysis of environmental issues associated with engineering design and product manufacturing in an economic and social context. Heuristic and analytical methods for assessing the sustainability of existing or potential product/service designs. Application to a design problem in teams.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology, Globalization and Culture",
    "dept": "M E",
    "num": "484",
    "desc": "Prereq: junior or senior classification for M E 484; graduate classification for M E 584\nCross-disciplinary examination of the present and future impact of globalization with a focus on preparing students for leadership roles in diverse professional, social, and cultural contexts.  Facilitate an understanding of the threats and opportunities inherent in the globalization process as they are perceived by practicing professionals and articulated in debates on globalization. Use of a digital forum for presenting and analyzing globalization issues by on-campus and off-campus specialists.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Appropriate Technology Design",
    "dept": "M E",
    "num": "486",
    "desc": "Prereq: M E 231,M E 270, enrollment in M E 335; or permission of instructor.\nHands-on design experience utilizing knowledge acquired in core mechanical engineering courses. Emphasis with engineering problem formulation and solution, oral and written communication, team decision-making and ethical conduct. Design projects include engineering considerations in appropriate technology which have multidisciplinary components in economics and sociology.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "M E",
    "num": "490",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of students and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "M E",
    "num": "490H",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of students and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Thermodynamics and Energy Utilization",
    "dept": "M E",
    "num": "490J",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of students and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Nuclear Engineering",
    "dept": "M E",
    "num": "490M",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of students and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Design and Optimization",
    "dept": "M E",
    "num": "490O",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of student and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Dynamic Systems and Controls",
    "dept": "M E",
    "num": "490P",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of student and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Materials Processing and Mechanics",
    "dept": "M E",
    "num": "490Q",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of student and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Thermo-fluids",
    "dept": "M E",
    "num": "490R",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of student and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Emerging Areas",
    "dept": "M E",
    "num": "490S",
    "desc": "Prereq: Senior classification\nInvestigation of topics holding special interest of student and faculty. Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Laboratory Makeup",
    "dept": "M E",
    "num": "490Z",
    "desc": "Prereq: Department permission\nThis section is designed specifically for transfer and study abroad students who need to make up a lab to fulfill course requirements.\n",
    "credits": "1"
  },
  {
    "course_name": "Economics and Policy of Engineered Energy Systems",
    "dept": "M E",
    "num": "510",
    "desc": "Prereq: Graduate standing.\nEconomics and policy for U.S. energy systems, with an emphasis on connections to engineering. Topics include: economic analysis of conventional energy commodity markets and technologies, deregulated electricity markets, and emerging energy technologies; demand forecasting; economic and environmental policy in energy; integrated assessment; and semester-specific contemporary issues.\n  Economics majors may not apply this course towards graduation.",
    "credits": "3"
  },
  {
    "course_name": "Advanced Control Design",
    "dept": "M E",
    "num": "511",
    "desc": "Prereq: M E 411\nApplication of control design methods using continuous, discrete, and frequency-based models. Approaches include classical, pole assignment, model reference, internal model, and adaptive control methods. Mechanical design projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Machine Design",
    "dept": "M E",
    "num": "517",
    "desc": "Prereq: M E 325, MAT E 273\nStress life, strain life, and fracture mechanics approaches to fatigue life and design with metals, polymers and ceramics.  Introduction to material selection in design of machine components.  Thermal and structural considerations in design of machine components and hybrid materials.  Course project and relevant literature review required for graduate credit.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Considerations in Robotics",
    "dept": "M E",
    "num": "518",
    "desc": "Prereq: Credit or enrollment in M E 421\nThree dimensional kinematics, dynamics, and control of robot manipulators, hardware elements and sensors. Laboratory experiments using industrial robots.\n",
    "credits": "3"
  },
  {
    "course_name": "Material and Manufacturing Considerations in Design",
    "dept": "M E",
    "num": "520",
    "desc": "Prereq: M E 324, M E 325\nIntegration of materials, design and manufacturing. Materials selection. Design for assembly and manufacturing (DFMA). Design and redesign to facilitate cost-effective manufacturing using material selection and DFMA software.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanical Behavior and Manufacturing of Polymers and Composites",
    "dept": "M E",
    "num": "521",
    "desc": "Prereq: M E 324 or MAT E 272 and E M 324\nEffect of chemical structure and morphology on properties. Linear viscoelasticity, damping and stress relaxation phenomena. Structure and mechanics of filler and fiber reinforced composites. Mechanical properties and failure mechanisms. Material selection and designing with polymers. Processing of polymer and composite parts.\n",
    "credits": "3"
  },
  {
    "course_name": "Optimization Methods for Complex Designs",
    "dept": "M E",
    "num": "525",
    "desc": "Prereq: M E 160, MATH 265\nOptimization involves finding the 'best' according to specified criteria. Review of a range of optimization methods from traditional nonlinear to modern evolutionary methods such as Genetic algorithms. Examination of how these methods can be used to solve a wide variety of design problems across disciplines, including mechanical systems design, biomedical device design, biomedical imaging, and interaction with digital medical data. Students will gain knowledge of numerical optimization algorithms and sufficient understanding of the strengths and weaknesses of these algorithms to apply them appropriately in engineering design. Experience includes code writing and off-the-shelf routines. Numerous case-studies of real-world situations in which problems were modeled and solved using advanced optimization techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanics of Machining and Finishing Processes",
    "dept": "M E",
    "num": "527",
    "desc": "Prereq: M E 324\nMechanics of material removal for ductile materials. Shear zone theory. Oblique cutting. Heat transfer in machining. Milling and grinding. Mechanics of material removal for brittle materials. Optimal selection and design of cutting parameters. Control of machining processes. Principles of precision finishing. Design considerations for machining and finishing processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Micro/Nanomanufacturing",
    "dept": "M E",
    "num": "528",
    "desc": "Prereq: M E 324\nConcepts and applications of micro/nanotechnology appropriate to the manufacturing field.  An overview of micro/nano-fabrication techniques including mechanical, EDM, laser and lithography.  MEMS device fabrication. Scaling laws. Top down and bottom up approaches of nanomanufacturing.  Experimental or theoretical project leading to potential submission of a manuscript for journal or conference.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Thermodynamics",
    "dept": "M E",
    "num": "530",
    "desc": "Prereq: M E 332\nFundamentals of thermodynamics from the classical viewpoint with emphasis on the use of the first and second laws for analysis of thermal systems. Generalized thermodynamic relationships. Computer applications of thermodynamic properties and system analysis. Selected topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Energy Systems and Analysis",
    "dept": "M E",
    "num": "531",
    "desc": "Prereq: any undergraduate thermodynamics course; mathematics through differential equations\nIntroduction to energy systems including economic and thermodynamic principles. Various production systems will be analyzed. Application to transportation and building systems will be emphasized. Sustainability, climate change and other current energy system topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Compressible Fluid Flow",
    "dept": "M E",
    "num": "532",
    "desc": "Prereq: AER E 310, 311 or equivalent\nThermodynamics of compressible flow. Viscous and inviscid compressible flow equations. One dimensional steady flow; isentropic flow, shocks, expansions. Multidimensional compressible flow aspects. Linear and nonlinear wave analysis and method of characteristics. Subsonic, transonic, supersonic and hypersonic flows.\n",
    "credits": "3"
  },
  {
    "course_name": "Thermochemical Processing of Biomass",
    "dept": "M E",
    "num": "535",
    "desc": "Prereq: Undergraduate course work in thermodynamics and transport phenomena\nIntroduction to thermal and catalytic processes for the conversion of biomass to biofuels and other biobased products. Topics include gasification, fast pyrolysis, hydrothermal processing, syngas to synfuels, and bio-oil upgrading. Application of thermodynamics, heat transfer, and fluid dynamics to bioenergy and biofuels.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Heat Transfer",
    "dept": "M E",
    "num": "536",
    "desc": "Prereq: M E 436\nAdvanced treatment of heat transmission by conduction, convection, and radiation.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Fluid Flow",
    "dept": "M E",
    "num": "538",
    "desc": "Prereq: Credit or enrollment in M E 436\nDetailed analysis of incompressible/compressible, viscous/inviscid, laminar/turbulent, and developing fluid flows on a particle/point control volume basis.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Combustion",
    "dept": "M E",
    "num": "542",
    "desc": "Prereq: M E 332 or CH E 381\nThermochemistry and transport theory applied to combustion. Gas phase equilibrium. Energy balances. Reaction kinetics. Flame temperatures, speed, ignition, and extinction. Premixed and diffusion flames. Combustion aerodynamics. Mechanisms of air pollution.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Random Vibrations and Nonlinear Dynamics",
    "dept": "M E",
    "num": "543",
    "desc": "\nVibrations of continuous systems. Nonlinear vibration phenomena, perturbation expansions; methods of multiple time scales and slowly-varying amplitude and phase. Characteristics of random vibrations; random processes, probability distributions, spectral density and its significance, the normal or Gaussian random process. Transmission of random vibration, response of simple single and two-degree-of-freedom systems to stationary random excitation. Fatigue failure due to random excitation.\n",
    "credits": "3"
  },
  {
    "course_name": "Thermal Systems Design",
    "dept": "M E",
    "num": "545",
    "desc": "Prereq: M E 436\nIntegrating thermodynamics, fluid mechanics, and heat transfer to model thermal equipment and to simulate thermal systems. Second law and parametric analysis; cost estimation, life cycle analysis and optimization. Some computer programming required.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Fluid Mechanics and Heat Transfer I",
    "dept": "M E",
    "num": "546",
    "desc": "Prereq: AER E 310 or M E 335, and programming experience\nBasic concepts of discretization, consistency, and stability. Explicit and implicit methods for ordinary differential equations. Methods for each type of partial differential equation.  Iterative solution methods; curvilinear grids. Students will program basic algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Fluid Mechanics and Heat Transfer II",
    "dept": "M E",
    "num": "547",
    "desc": "Prereq: AER E 546 or equivalent\nApplication of computational methods to current problems in fluid mechanics and heat transfer. Methods for solving the Navier-Stokes and reduced equation sets such as the Euler, boundary layer, and parabolized forms of the conservation equations. Introduction to relevant aspects of grid generation and turbulence modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Biosensors:  Fundamentals and Applications",
    "dept": "M E",
    "num": "550",
    "desc": "Prereq: Graduate status. Recommend a basic background in engineering and one or more introductory biology courses.\n3 credits (Spring, 2016)  Extensive overview of biosensors including biological/biomedical microelectromechanical (Bio-MEMs) systems and bioanalytical devices with an introduction to fundamental principles, detection methods, and miniaturization techniques. Fundamental biosensor theory including biorecognition, transduction, signal acquisition, and post processing/data analysis will be discussed.  Distinct sensing modalities (e.g., electrochemical, optical, thermal and mass based), biorecognition agents (e.g., enzymes, antibodies, aptamers, whole cells/tissues, genetically engineered proteins) and advanced transduction materials (e.g., carbon nanotubes, graphene, quantum/carbon dots, and polymers/hydrogels) and their use in the context of specific applications (e.g., biomedical, environmental, food safety) will be reviewed in detail. Additionally, students will design a theoretical biosensor and present their design in a written proposal and oral presentation.\n  None",
    "credits": "3"
  },
  {
    "course_name": "Advanced Acoustics",
    "dept": "M E",
    "num": "552",
    "desc": "Prereq: E M 451\nTheoretical acoustics: wave propagation in fluids; acoustic radiation, diffraction and scattering; nonlinear acoustics; radiation force; cavitation; and ray acoustics.\n",
    "credits": "3"
  },
  {
    "course_name": "Machine Vision",
    "dept": "M E",
    "num": "556",
    "desc": "Prereq: MATH 317, M E 421 or permission of instructor\nPractical imaging processing techniques, geometric optics, and mathematics behind machine vision, as well as the most advanced 3D vision techniques. Experience with practical vision system development and analysis. Assignments include individual bi-weekly homework; weekly readings and lectures; and a semester-long research project on design and experiment vision systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Graphics and Geometric Modeling",
    "dept": "M E",
    "num": "557",
    "desc": "Prereq: M E 421, programming experience in C\nFundamentals of computer graphics technology. Data structures. Parametric curve and surface modeling. Solid model representations. Applications in engineering design, analysis, and manufacturing.\n",
    "credits": "3"
  },
  {
    "course_name": "Scanning Probe Microscopy",
    "dept": "M E",
    "num": "561",
    "desc": "Prereq: First year physics, chemistry\nIntroduction to the scanning probe microscope (SPM, also known as atomic force microscope or AFM) and associated measurement techniques. Overview or instrumentation system, basic principles of operation, probe-sample interaction and various operational modes to obtain micro/nanoscale structure and force spectroscopy of material surfaces. Examples of SPM significance and applications in science and engineering research, nanotechnology and other industries. Laboratory work involving use of a scanning probe microscope system is an integral part of the course.\n",
    "credits": "3"
  },
  {
    "course_name": "Micro and Nanoscale Mechanics",
    "dept": "M E",
    "num": "563",
    "desc": "Prereq: E M 324 and M E 325\nReview of Fundamentals: (Elasticity, Electromagnetism, Mechanical response), Mechanics of thermally, electrostatically and magnetically actuated microsystems, Mechanics and design of nanostructured materials, mechanics of surface stress engineering and its implications to sensors and thin film structures.\n",
    "credits": "3"
  },
  {
    "course_name": "Fracture and Fatigue",
    "dept": "M E",
    "num": "564",
    "desc": "Prereq: E M 324 and either MAT E 216 or MAT E 273 or MAT E 392. Undergraduates: Permission of instructor\nMaterials and mechanics approach to fracture and fatigue. Fracture mechanics, brittle and ductile fracture, fracture and fatigue characteristics, fracture of thin films and layered structures. Fracture and fatigue tests, mechanics and materials designed to avoid fracture or fatigue.\n",
    "credits": "3"
  },
  {
    "course_name": "Phase Transformation in Elastic Materials",
    "dept": "M E",
    "num": "566",
    "desc": "Prereq: EM 510 or EM 516 or EM 514\nContinuum thermodynamics and kinetics approaches to phase transformations.  Phase field approach to stress- and temperature-induced martensitic transformations and twinning at the nanoscale. Nucleation and growth. Nanostructural evaluation. Analytical and numerical solutions. Surface stresses and energy. Surface-induced phase transformations. Large Strain formulation.\n",
    "credits": "3"
  },
  {
    "course_name": "Random Signal Analysis and Kalman Filtering",
    "dept": "M E",
    "num": "573",
    "desc": "Prereq: E E 324 or AER E 331 or M E 370 or M E 411 or MATH 341\nElementary notions of probability. Random processes. Autocorrelation and spectral functions. Estimation of spectrum from finite data. Response of linear systems to random inputs. Discrete and continuous Kalman filter theory and applications. Smoothing and prediction. Linearization of nonlinear dynamics.\n",
    "credits": "3"
  },
  {
    "course_name": "Optimal Control",
    "dept": "M E",
    "num": "574",
    "desc": "Prereq: E E 577\nThe optimal control problem. Variational approach. Pontryagin's principle, Hamilton-Jacobi equation. Dynamic programming. Time-optimal, minimum fuel, minimum energy control systems. The regulator problem. Structures and properties of optimal controls.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Robust Control",
    "dept": "M E",
    "num": "575",
    "desc": "Prereq: E E 577\nIntroduction to modern robust control. Model and signal uncertainty in control systems. Uncertainty description. Stability and performance robustness to uncertainty. Solutions to the H2, Hoo, and l1 control problems. Tools for robustness analysis and synthesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Digital Feedback Control Systems",
    "dept": "M E",
    "num": "576",
    "desc": "Prereq: E E 475 or AER E 432 or M E 411 or MATH 415; and MATH 267\nSampled data, discrete data, and the z-transform. Design of digital control systems using transform methods: root locus, frequency response and direct design methods. Design using state-space methods. Controllability, observability, pole placement, state estimators. Digital filters in control systems. Microcomputer implementation of digital filters. Finite wordlength effects. Linear quadratic optimal control in digital control systems. Simulation of digital control systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Linear Systems",
    "dept": "M E",
    "num": "577",
    "desc": "Prereq: E E 324 or AER E 331 or MATH 415; and MATH 207\nLinear algebra review. Least square method and singular value decomposition. State space modeling of linear continuous-time systems. Solution of linear systems. Controllability and observability. Canonical description of linear equations. Stability of linear systems. State feedback and pole placements. Observer design for linear systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonlinear Systems",
    "dept": "M E",
    "num": "578",
    "desc": "Prereq: E E 577\nLinear vs nonlinear systems. Phase plane analysis. Bifurcation and center manifold theory. Lyapunov stability. Absolute stability of feedback systems. Input-output stability. Passivity theory and feedback linearization. Nonlinear control design techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Virtual Environments, Virtual Worlds, and Application",
    "dept": "M E",
    "num": "580",
    "desc": "Prereq: Senior or Graduate status.\nA systematic introduction to the underpinnings of Virtual Environments (VE), Virtual Worlds, advanced displays and immersive technologies; and an overview of some of the applications areas particularly virtual engineering.\n",
    "credits": "3"
  },
  {
    "course_name": "Technology, Globalization and Culture",
    "dept": "M E",
    "num": "584",
    "desc": "Prereq: junior or senior classification for M E 484; graduate classification for M E 584\nCross-disciplinary examination of the present and future impact of globalization with a focus on preparing students for leadership roles in diverse professional, social, and cultural contexts.  Facilitate an understanding of the threats and opportunities inherent in the globalization process as they are perceived by practicing professionals and articulated in debates on globalization. Use of a digital forum for presenting and analyzing globalization issues by on-campus and off-campus specialists.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Predictive Plant Phenomics",
    "dept": "M E",
    "num": "585",
    "desc": "Prereq: Acceptance into the P3 program or instructor permission.\nPrinciples of engineering, data analysis, and plant sciences and their interplay applied to predictive plant phenomics.  Transport phenomena, sensor design, image analysis, graph models, network data analysis, fundamentals of genomics and phenomics.  Multidisciplinary laboratory exercises.\n  None",
    "credits": "4"
  },
  {
    "course_name": "Special Topics",
    "dept": "M E",
    "num": "590",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Independent Literature Investigation",
    "dept": "M E",
    "num": "590Q",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Biological and Nanoscale Sciences",
    "dept": "M E",
    "num": "590T",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Complex Fluid Systems",
    "dept": "M E",
    "num": "590U",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Clean Energy Technologies",
    "dept": "M E",
    "num": "590V",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Design and Manufacturing Innovation",
    "dept": "M E",
    "num": "590W",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Simulation and Visualization",
    "dept": "M E",
    "num": "590Z",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "M E",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar",
    "dept": "M E",
    "num": "600",
    "desc": "\n(1-0).\n",
    "credits": "R"
  },
  {
    "course_name": "Surface Modeling",
    "dept": "M E",
    "num": "625",
    "desc": "Prereq: M E 557, programming experience in C\nTheory and implementation of contemporary parametric sculptured surface modeling technology. Non-uniform rational B-spline (NURBS) curves and surfaces. Fundamental computational algorithms. Construction techniques. Advanced modeling topics. Computer projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Multiphase Flow",
    "dept": "M E",
    "num": "632",
    "desc": "Prereq: M E 538\nSingle particle, mutliparticle and two-phase fluid flow phenomena (gas-solid, liquid-solid and gas-liquid mixtures); particle interactions, transport phenomena, wall effects; bubbles, equations of multiphase flow. Dense phase (fluidized and packed beds) and ducted flows; momentum, heat and mass transfer. Computer solutions.\n",
    "credits": "3"
  },
  {
    "course_name": "Convection Heat Transfer",
    "dept": "M E",
    "num": "637",
    "desc": "Prereq: M E 436\nConvection heat transfer to internal or external flows under laminar or turbulent conditions. Dimensionless parameters. Classical solutions of Newtonian viscous flows. Forced and free convection. Special topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Radiation Heat Transfer",
    "dept": "M E",
    "num": "638",
    "desc": "Prereq: M E 436\nTechniques for analysis of radiation in enclosures. Radiative properties of surfaces. Radiative transfer in participating media. Combined modes of transfer. Approximate methods of analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Computational Fluid Dynamics",
    "dept": "M E",
    "num": "647",
    "desc": "Prereq: AER E 547\nAn examination of current methods in computational fluid dynamics. Differencing strategies. Advanced solution algorithms for unstructured meshes.  Grid generation. Construction of higher-order CFD algorithms. Parallel computing. Current applications. Use of state of the art CFD codes.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "M E",
    "num": "690",
    "desc": "\nInvestigation of advanced topics of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Advanced Machine Design",
    "dept": "M E",
    "num": "690G",
    "desc": "\nInvestigation of advanced topics of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Engineering Computation",
    "dept": "M E",
    "num": "690O",
    "desc": "\nInvestigation of advanced topics of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Independent Literature Investigation",
    "dept": "M E",
    "num": "690Q",
    "desc": "\nInvestigation of advanced topics of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Biological and Nanoscale Sciences",
    "dept": "M E",
    "num": "690T",
    "desc": "\nInvestigation of Special Topics: Biological and Nanoscale Sciences of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Complex Fluid Systems",
    "dept": "M E",
    "num": "690U",
    "desc": "\nInvestigation of Special Topics: Complex Fluid Systems of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Clean Energy Technologies",
    "dept": "M E",
    "num": "690V",
    "desc": "\nInvestigation of Special Topics: Clean Energy Technologies of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Design and Manufacturing Innovation",
    "dept": "M E",
    "num": "690W",
    "desc": "\nInvestigation of Design & Manufacturing Innovation of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Topics: Simulation and Visualization",
    "dept": "M E",
    "num": "690Z",
    "desc": "\nInvestigation of Special Topics: Simulation and Visualization of special interest to graduate students in mechanical engineering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Engineering Internship",
    "dept": "M E",
    "num": "697",
    "desc": "Prereq: Permission of Director of Graduate Education, graduate classification\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "M E",
    "num": "699",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Severe and Hazardous Weather",
    "dept": "MTEOR",
    "num": "107",
    "desc": "\nUnderstanding of atmospheric processes that play a role in creating severe and hazardous weather. Focus on thunderstorms, tornadoes, hurricanes, floods, blizzards, ice storms, and temperature extremes. Impacts on lives and property.\n",
    "credits": "1"
  },
  {
    "course_name": "Synoptic Applications",
    "dept": "MTEOR",
    "num": "111",
    "desc": "Prereq: Credit or enrollment in MATH 165\nCurrent weather discussions and introduction to synoptic-scale interpretation of meteorology. Application and use of calculus in meteorology. Course restricted to majors. Others with permission of instructor.\n",
    "credits": "1"
  },
  {
    "course_name": "Geoscience Orientation",
    "dept": "MTEOR",
    "num": "112",
    "desc": "\nOrientation course for students enrolled in the Earth, Wind and Fire Learning Community. Provides an introduction to Iowa State University and meteorology, geology, and Earth science programs for students enrolled in the department's learning community. Activities include academic and social activities, talks and presentations on academic success, resume writing, and study abroad, as well as research talks by faculty members.\n",
    "credits": "1"
  },
  {
    "course_name": "Spring Geoscience Orientation for Earth, Wind and Fire Learning Community",
    "dept": "MTEOR",
    "num": "113",
    "desc": "\nSpring orientation course for students enrolled in the \"Earth, Wind and Fire\" Learning Community.  Develop and apply quantitative, data-analysis, management, and communication skills on an authentic research project in a team to focus on professionalism and resilience.  Introduction to interview strategies and the importance of creating a professional image on social media. Academic and social events, plus two field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Water Resources of the World",
    "dept": "MTEOR",
    "num": "160",
    "desc": "\nStudy of the occurrence, history, development, and management of world water resources.  Basic hydrologic principles including climate, surface water, groundwater, and water quality.  Historical and current perspectives on water policy, use, and the role of water in society and the environment.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introductory Seminar",
    "dept": "MTEOR",
    "num": "201",
    "desc": "Prereq: Credit or enrollment in PHYS 221\nAn overview of the atmospheric sciences, the meteorology program at Iowa State, and the major research journals used in the discipline.\n",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Weather and Climate",
    "dept": "MTEOR",
    "num": "206",
    "desc": "\nBasic concepts in weather and climate, including atmospheric measurements, radiation, stability, precipitation, winds, fronts, forecasting, and severe weather. Applied topics include global warming, ozone depletion, world climates and weather safety.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Meteorology I",
    "dept": "MTEOR",
    "num": "227",
    "desc": "Prereq: Credit or concurrent enrollment in MTEOR 206, credit or concurrent enrollment in PHYS 221\nAn introduction to computer programming using FORTRAN with focus on meteorological applications. Emphasis on basics of good programming techniques and style through extensive practice in top-down design, writing, running, and debugging small programs. Topics include operations and functions, selective execution, repetitive execution, arrays, input/output, file processing, and subprograms.  This course is designed for majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Scientific Balloon Engineering and Operations",
    "dept": "MTEOR",
    "num": "265",
    "desc": "\nEngineering aspects of scientific balloon flights. Integration of science mission objectives with engineering requirements. Operations team certification. FAA and FCC regulations, communications, and command systems. Flight path prediction and control.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "MTEOR",
    "num": "290",
    "desc": "Prereq: Permission of instructor\nIndependent study for freshman and sophomore students.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "MTEOR",
    "num": "298",
    "desc": "Prereq: Permission of the department cooperative education coordinator; sophomore classification\nRequired of all cooperative education students. Students must register for this course prior to commencing the work period.\n",
    "credits": "R"
  },
  {
    "course_name": "General Meteorology",
    "dept": "MTEOR",
    "num": "301",
    "desc": "Prereq: MATH 166, credit or enrollment in PHYS 222\nGlobal distribution of temperature, wind, and atmospheric constituents; atmospheric thermodynamics, radiative transfer, global energy balance, storms and clouds, introductory dynamics.\n",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Synoptic Meteorology",
    "dept": "MTEOR",
    "num": "311",
    "desc": "Prereq: MTEOR 301\nConcepts of weather map plotting and analysis. Introduction to forecasting and to the use of real-time UNIDATA computer products.\n",
    "credits": "2"
  },
  {
    "course_name": "Meteorology Internship",
    "dept": "MTEOR",
    "num": "321",
    "desc": "Prereq: MTEOR 311; junior or senior standing; permission of co-op program coordinator; acceptance by sponsoring agency\nSupervised practical experience in a professional meteorological agency. Experiences may include providing weather information for radio, TV, utilities, government agencies, construction, or agribusiness.\n",
    "credits": "1"
  },
  {
    "course_name": "Energy and the Environment",
    "dept": "MTEOR",
    "num": "324",
    "desc": "Prereq: CHEM 163 or CHEM 177, MATH 140\nExploration of the origin of Earth’s energy resources and the environmental and climatic impacts of energy acquisition and consumption. Renewable and non-renewable energy resources within an Earth-system context. Various environmentally-relevant topics such as water quality and availability, habitat destruction, greenhouse-gas emissions, and health and safety hazards to wildlife and human communities.\n",
    "credits": "3"
  },
  {
    "course_name": "Atmospheric Physics I",
    "dept": "MTEOR",
    "num": "341",
    "desc": "Prereq: PHYS 222, credit or enrollment in MATH 266, MTEOR 301.\nBasic laws of thermodynamics, thermodynamics of water vapor, mixtures of gases, stability, hydrostatics, cloud physics.\n",
    "credits": "3"
  },
  {
    "course_name": "Atmospheric Physics II",
    "dept": "MTEOR",
    "num": "342",
    "desc": "Prereq: MTEOR 341\nPrecipitation physics, radar, atmospheric radiation, atmospheric optics, atmospheric electricity.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "MTEOR",
    "num": "398",
    "desc": "Prereq: Permission of the department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing the work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Watershed Hydrology",
    "dept": "MTEOR",
    "num": "402",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nExamination of watersheds as systems, emphasizing the surface components of the hydrologic cycle.  Combines qualitative understanding of hydrological processes and uncertainty with quantitative representation.  Laboratory emphasizes field investigation and measurement of watershed processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Change",
    "dept": "MTEOR",
    "num": "404",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nRecent changes in global biogeochemical cycles and climate; models of future changes in the climate system; impacts of global change on agriculture, water resources and human health; ethical issues of global environmental change.  Also offered online Alt. F, even-numbered years.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biophysics",
    "dept": "MTEOR",
    "num": "405",
    "desc": "Prereq: MATH 165 and some exposure to computer programming (any language)\nThe movement of energy and mass among the soil, vegetation, and atmosphere.  The heat and water budget of humans, other animals, plants, and plant communities.  Relevance to weather and climate, the effect of climate change on organisms, and remote sensing.\n",
    "credits": "3"
  },
  {
    "course_name": "World Climates",
    "dept": "MTEOR",
    "num": "406",
    "desc": "Prereq: AGRON 206/MTEOR 206\nDistribution and causes of different climates around the world. Effects of climate and climate variations on human activities including society, economy and agriculture. Current issues such as climate change and international efforts to assess and mitigate the consequences of a changing climate.  Semester project and in-class presentation required.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Mesoscale Meteorology",
    "dept": "MTEOR",
    "num": "407",
    "desc": "Prereq: MATH 166 and MTEOR 443\nPhysical nature and practical consequences of mesoscale atmospheric phenomena. Mesoscale convective systems, fronts, terrain-forced circulations. Observation, analysis, and prediction of mesoscale atmospheric structure.\n",
    "credits": "3"
  },
  {
    "course_name": "Synoptic Meteorology",
    "dept": "MTEOR",
    "num": "411",
    "desc": "Prereq: MTEOR 311, Credit or enrollment in MTEOR 454\nCurrent weather forecasting and discussion. Applications of atmospheric physics and dynamics in real-time weather situations. Use of UNIDATA computer products.\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrologic Modeling and Analysis",
    "dept": "MTEOR",
    "num": "416",
    "desc": "Prereq: Four courses in Earth science, meteorology, or engineering; junior standing\nStudy of the basic principles of hydrologic modeling, including rainfall-runoff analysis, lumped and distributed modeling, conceptual and physical models, parameter estimation and sensitivity analysis, input and validation data, uncertainty analysis, and the use of models in surface water hydrology. A range of common models are applied to study hydrologic topics such as flood forecasting and land use change impacts. Previous experience with Matlab or other programming language is needed.\n",
    "credits": "3"
  },
  {
    "course_name": "Mesoscale Forecasting Laboratory",
    "dept": "MTEOR",
    "num": "417",
    "desc": "Prereq: Credit or enrollment in MTEOR 411\nReal-time computer analysis of current weather, with emphasis on small-scale features. Studies of severe weather, lake-effect snow, CSI, cold-air damming.\n",
    "credits": "3"
  },
  {
    "course_name": "Instrumentation and Measurements",
    "dept": "MTEOR",
    "num": "432",
    "desc": "Prereq: Credit or enrollment in MATH 266, PHYS 222\nPrinciples of meteorological sensing and data analysis. Thermometry, barometry, hygrometry, anemometry, precipitation measurements, radiometry, radar, remote sensing, visibility, and cloud height. Calibration and measurement uncertainties. Digital signal processing. Field trip to the National Weather Service. Labs emphasize dataloggers and modern weather stations.\n",
    "credits": "3"
  },
  {
    "course_name": "Radar Applications in Meteorology",
    "dept": "MTEOR",
    "num": "435",
    "desc": "Prereq: Credit or enrollment in MTEOR 341\nFundamentals of radar meteorology with emphasis on applications. Topics presented include theory of radar, engineering principles, Doppler radar, polarimetric radar, and applications to remote sensing of clouds and precipitation.\n",
    "credits": "3"
  },
  {
    "course_name": "Dynamic Meteorology I",
    "dept": "MTEOR",
    "num": "443",
    "desc": "Prereq: MTEOR 341\nConservation laws, governing equations, circulation and vorticity. Development of quasi-geostrophic theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Climate Modeling",
    "dept": "MTEOR",
    "num": "452",
    "desc": "Prereq: MTEOR 301\nDeveloping and working with climate models based on fundamental physical principles that govern the climate systems of the Earth and other planets. Emphasis on coupled, nonlinear-system interactions of physical processes such as circulation dynamics, radiative transfer, and cloud/precipitation physics, starting with fairly simple 0- and 1-dimensional analytical and numerical models based on energy, mass, and momentum conservation. Observational study of seasonally evolving weather patterns that form climates around the world.\n",
    "credits": "3"
  },
  {
    "course_name": "Dynamic Meteorology II",
    "dept": "MTEOR",
    "num": "454",
    "desc": "Prereq: MTEOR 443\nPlanetary boundary layer, linear perturbation theory, atmospheric wave motions, baroclinic and convective instability, mesoscale circulations.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Geostatistics for Geoscientists",
    "dept": "MTEOR",
    "num": "468",
    "desc": "Prereq: GEOL 452, C R P 351, C R P 452, NREM 345, or NREM 446\nIntroduction to geospatial data collection, analysis, interpretation, and presentation. Geospatial techniques including geographic information systems (GIS), remote sensing (RS), and global positioning systems (GPS). Study of applied geostatistical analysis (e.g., interpolation and spatial regression).\n",
    "credits": "3"
  },
  {
    "course_name": "History of Modern Meteorology",
    "dept": "MTEOR",
    "num": "471",
    "desc": "Prereq: MTEOR 341, MTEOR 342, MTEOR 411, MTEOR 443, MTEOR 452\nDevelopment of meteorological theories and numerical weather prediction, discoveries of important meteorological phenomena, and impact of weather and climate on important historical events.\n",
    "credits": "1"
  },
  {
    "course_name": "Survey of Remote Sensing Technologies",
    "dept": "MTEOR",
    "num": "489",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nElectromagnetic-radiation principles, active and passive sensors, multispectral and hyperspectral sensors, imaging radar, SAR, thermal imaging, lidar. Examples of applications. Also offered online S.\n",
    "credits": "3"
  },
  {
    "course_name": "Satellite Remote Sensing Laboratory",
    "dept": "MTEOR",
    "num": "489L",
    "desc": "Prereq: Completion or concurrent enrollment in MTEOR/GEOL/NREM/EE 489/589\nProcessing and analysis of satellite sensor data (optical and radar). Provides practical applications in an environmental context.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "MTEOR",
    "num": "490",
    "desc": "Prereq: 6 credits in meteorology, permission of instructor\n  No more than 9 credits in Mteor 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Synoptic Meteorology.",
    "dept": "MTEOR",
    "num": "490A",
    "desc": "Prereq: 6 credits in meteorology, permission of instructor\n  No more than 9 credits in Mteor 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Dynamic Meteorology.",
    "dept": "MTEOR",
    "num": "490B",
    "desc": "Prereq: 6 credits in meteorology, permission of instructor\n  No more than 9 credits in Mteor 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Physical Meteorology.",
    "dept": "MTEOR",
    "num": "490C",
    "desc": "Prereq: 6 credits in meteorology, permission of instructor\n  No more than 9 credits in Mteor 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Instrumentation.",
    "dept": "MTEOR",
    "num": "490D",
    "desc": "Prereq: 6 credits in meteorology, permission of instructor\n  No more than 9 credits in Mteor 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Hydrology.",
    "dept": "MTEOR",
    "num": "490E",
    "desc": "Prereq: 6 credits in meteorology, permission of instructor\n  No more than 9 credits in Mteor 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "MTEOR",
    "num": "498",
    "desc": "Prereq: Permission of the department cooperative education coordinator; senior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Senior Research",
    "dept": "MTEOR",
    "num": "499",
    "desc": "\nRequired of all senior meteorology majors. Research projects in collaboration with faculty. Written and oral presentations of results at the end of the semester.\n",
    "credits": "2"
  },
  {
    "course_name": "Watershed Hydrology",
    "dept": "MTEOR",
    "num": "502",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nExamination of watersheds as systems, emphasizing the surface components of the hydrologic cycle.  Combines qualitative understanding of hydrological processes and uncertainty with quantitative representation.  Laboratory emphasizes field investigation and measurement of watershed processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Change",
    "dept": "MTEOR",
    "num": "504",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nRecent changes in global biogeochemical cycles and climate; models of future changes in the climate system; impacts of global change on agriculture, water resources and human health; ethical issues of global environmental change.  Also offered online Alt. F, even-numbered years.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Biophysics",
    "dept": "MTEOR",
    "num": "505",
    "desc": "Prereq: MATH 165 and some exposure to computer programming (any language)\nThe movement of energy and mass among the soil, vegetation, and atmosphere.  The heat and water budget of humans, other animals, plants, and plant communities.  Relevance to weather and climate, the effect of climate change on organisms, and remote sensing.\n",
    "credits": "3"
  },
  {
    "course_name": "Mesoscale Meteorology",
    "dept": "MTEOR",
    "num": "507",
    "desc": "Prereq: MATH 166 and MTEOR 443\nGallus. The physical nature and practical consequences of mesoscale atmospheric phenomena. Mesoscale convective systems, fronts, terrain-forced circulations. Observation, analysis, and prediction of mesoscale atmospheric structure. Semester project and in-class presentation required.\n",
    "credits": "3"
  },
  {
    "course_name": "Synoptic Meteorology",
    "dept": "MTEOR",
    "num": "511",
    "desc": "Prereq: MTEOR 311, Credit or enrollment in MTEOR 454\nCurrent weather forecasting and discussion. Applications of atmospheric physics and dynamics in real-time weather situations. Use of UNIDATA computer products.\n",
    "credits": "3"
  },
  {
    "course_name": "Hydrologic Modeling and Analysis",
    "dept": "MTEOR",
    "num": "516",
    "desc": "Prereq: Four courses in Earth science, meteorology, or engineering; junior standing\nStudy of the basic principles of hydrologic modeling, including rainfall-runoff analysis, lumped and distributed modeling, conceptual and physical models, parameter estimation and sensitivity analysis, input and validation data, uncertainty analysis, and the use of models in surface water hydrology. A range of common models are applied to study hydrologic topics such as flood forecasting and land use change impacts. Previous experience with Matlab or other programming language is needed.\n",
    "credits": "3"
  },
  {
    "course_name": "Microwave Remote Sensing",
    "dept": "MTEOR",
    "num": "518",
    "desc": "Prereq: MATH 265\nMicrowave remote sensing of Earth's surface and atmosphere using satellite-based or ground-based instruments. Specific examples include remote sensing of atmospheric temperature and water vapor, precipitation, ocean salinity, and soil moisture.\n",
    "credits": "3"
  },
  {
    "course_name": "Physical Meteorology",
    "dept": "MTEOR",
    "num": "542",
    "desc": "Prereq: MTEOR 342, MATH 266, PHYS 222\nPlanetary atmospheres, radiative equilibrium models, radiative transfer, the upper atmosphere, remote sounding from satellites.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Dynamic Meteorology I",
    "dept": "MTEOR",
    "num": "543",
    "desc": "Prereq: MTEOR 455\nThe first half of a two semester sequence. Governing equations, scale analysis, simple types of wave motion in the atmosphere, instability theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Dynamic Meteorology II",
    "dept": "MTEOR",
    "num": "544",
    "desc": "Prereq: MTEOR 543\nContinuation of 543. General circulation and dynamics of zonally symmetric circulations, atmospheric energetics, nonlinear dynamics of planetary waves.\n",
    "credits": "3"
  },
  {
    "course_name": "Climate Modeling",
    "dept": "MTEOR",
    "num": "552",
    "desc": "Prereq: MTEOR 301\nDeveloping and working with climate models based on fundamental physical principles that govern the climate systems of the Earth and other planets. Emphasis on coupled, nonlinear-system interactions of physical processes such as circulation dynamics, radiative transfer, and cloud/precipitation physics, starting with fairly simple 0- and 1-dimensional analytical and numerical models based on energy, mass, and momentum conservation. Observational study of seasonally evolving weather patterns that form climates around the world.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Geostatistics for Geoscientists",
    "dept": "MTEOR",
    "num": "568",
    "desc": "Prereq: GEOL 452, C R P 351, C R P 452, NREM 345, or NREM 446\nIntroduction to geospatial data collection, analysis, interpretation, and presentation. Geospatial techniques including geographic information systems (GIS), remote sensing (RS), and global positioning systems (GPS). Study of applied geostatistical analysis (e.g., interpolation and spatial regression).\n",
    "credits": "3"
  },
  {
    "course_name": "History of Modern Meteorology",
    "dept": "MTEOR",
    "num": "571",
    "desc": "Prereq: MTEOR 341, MTEOR 342, MTEOR 411, MTEOR 443, MTEOR 452\nDevelopment of meteorological theories and numerical weather prediction, discoveries of important meteorological phenomena, and impact of weather and climate on important historical events.\n",
    "credits": "1"
  },
  {
    "course_name": "Survey of Remote Sensing Technologies",
    "dept": "MTEOR",
    "num": "589",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nElectromagnetic-radiation principles, active and passive sensors, multispectral and hyperspectral sensors, imaging radar, SAR, thermal imaging, lidar. Examples of applications. Also offered online S.\n",
    "credits": "3"
  },
  {
    "course_name": "Satellite Remote Sensing Laboratory",
    "dept": "MTEOR",
    "num": "589L",
    "desc": "Prereq: Completion or concurrent enrollment in MTEOR/GEOL/NREM/EE 489/589\nProcessing and analysis of satellite sensor data (optical and radar). Provides practical applications in an environmental context.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "MTEOR",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Boundary-layer Meteorology",
    "dept": "MTEOR",
    "num": "590A",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Tropical Meteorology",
    "dept": "MTEOR",
    "num": "590B",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Mesoscale Meteorology",
    "dept": "MTEOR",
    "num": "590C",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Global Climate Systems",
    "dept": "MTEOR",
    "num": "590D",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Climate Modeling",
    "dept": "MTEOR",
    "num": "590E",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Numerical Weather Prediction",
    "dept": "MTEOR",
    "num": "590F",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Satellite Observations",
    "dept": "MTEOR",
    "num": "590G",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Statistical Methods in Meteorology",
    "dept": "MTEOR",
    "num": "590H",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Field Observations",
    "dept": "MTEOR",
    "num": "590I",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Low Frequency Modes",
    "dept": "MTEOR",
    "num": "590J",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Cloud Physics",
    "dept": "MTEOR",
    "num": "590K",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Atmospheric Radiation",
    "dept": "MTEOR",
    "num": "590L",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Hydrology",
    "dept": "MTEOR",
    "num": "590M",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Geophysical Fluid Dynamics",
    "dept": "MTEOR",
    "num": "590N",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Radar Meteorology",
    "dept": "MTEOR",
    "num": "590O",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Seminar",
    "dept": "MTEOR",
    "num": "595",
    "desc": "Prereq: Senior or graduate classification\nWeekly seminar on topics of current research interest. All students seeking a graduate degree must enroll during each semester of residence. Students pursuing a non-thesis option for the M.S. in Earth Science must enroll for one semester.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Graduate Seminar: Presentation Required",
    "dept": "MTEOR",
    "num": "595A",
    "desc": "Prereq: Senior or graduate classification\nWeekly seminar on topics of current research interest. All students seeking a graduate degree must enroll during each semester of residence. Students pursuing a non-thesis option for the M.S. in Earth Science must enroll for one semester.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Graduate Seminar: Attendance Only",
    "dept": "MTEOR",
    "num": "595B",
    "desc": "Prereq: Senior or graduate classification\nAttendance only. Weekly seminar on topics of current research interest. All students seeking a graduate degree must enroll during each semester of residence. Students pursuing a non-thesis option for the M.S. in Earth Science must enroll for one semester.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Boundary-Layer Meteorology",
    "dept": "MTEOR",
    "num": "605",
    "desc": "Prereq: MTEOR 443 or equivalent-level course in engineering fluids\nAtmospheric boundary-layer structure and dynamics. Diurnal and seasonal variations, turbulent fluxes and turbulence kinetic energy. Measurements and empirical relations for wind and temperature near the ground. Numerical simulation and applications to wind energy.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "MTEOR",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Microbial World",
    "dept": "MICRO",
    "num": "101",
    "desc": "Prereq: High school biology or equivalent\nIntroduction to the importance of viruses, bacteria, fungi, archaea and parasites both to humans and to the biosphere. Topics include past and present microbial impact on humans and society, ecology and diversity of microbes, biotechnology and microbial impact on the biosphere.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional and Educational Preparation in Microbiology",
    "dept": "MICRO",
    "num": "110",
    "desc": "\nAn introduction to curriculum and research opportunities in microbiology at Iowa State.  Topics include: easing the transition to life as a university student, development of specific goals, strengthening interpersonal communication, professional portfolio creation and resume building.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Microbiology",
    "dept": "MICRO",
    "num": "201",
    "desc": "Prereq: One semester of college-level biology\nSelected topics in microbiology with emphasis on the relationship of microorganisms to human and animal health, agricultural technology, and the environment. With written petition to the chair of the supervisory committee, students who obtain a grade of B or better may substitute 201 for MICRO 302 in advanced courses.\n",
    "credits": "2"
  },
  {
    "course_name": "Introductory Microbiology Laboratory",
    "dept": "MICRO",
    "num": "201L",
    "desc": "Prereq: Credit or enrollment in MICRO 201 or MICRO 302\nBasic microbiology laboratory techniques for non-microbiology majors.\n  Credit for either Micro 201L or 302L, but not both, may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Biology of Microorganisms",
    "dept": "MICRO",
    "num": "302",
    "desc": "Prereq: BIOL 211, credit or enrollment in BIOL 212; 1 semester of chemistry\nBasic cell biology, physiology, metabolism, genetics and ecology of microorganisms, with an emphasis on  prokaryotes and viruses, as well as the roles of microorganisms in the environment, disease, agriculture, and industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbiology Laboratory",
    "dept": "MICRO",
    "num": "302L",
    "desc": "Prereq: Credit or enrollment in MICRO 302\nBasic microbiology laboratory techniques for majors in microbiology, biological sciences and related fields.\n  Credit for either Micro 201L or 302L, but not both, may be applied toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Medical Microbiology",
    "dept": "MICRO",
    "num": "310",
    "desc": "Prereq: MICRO 302 (or MICRO 201 if a B or better was obtained)\nStudy of infection by bacterial and viral pathogenic agents of humans with an overview of immune responses in controlling disease.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Microbiology Laboratory",
    "dept": "MICRO",
    "num": "310L",
    "desc": "Prereq: MICRO 201 or MICRO 302; MICRO 201L or MICRO 302L; credit or enrollment in MICRO 310\nMicrobiological tools and techniques to isolate, identify, and characterize medically significant microorganisms in relation to human diseases. Emphasis on the virulence factors of pathogenic organisms as compared to the normal flora.\n",
    "credits": "1"
  },
  {
    "course_name": "Molecular and Cellular Bacteriology",
    "dept": "MICRO",
    "num": "320",
    "desc": "Prereq: MICRO 302, BIOL 313, credit or enrollment in CHEM 332\nA systems perspective of bacterial growth, survival, and cellular differentiation by integrating physiological and genetic principles. Emphasis is on prokaryotes although unicellular eukaryotes are also discussed. Topics include the structure, function, and assembly of cell components, molecular and genomic techniques, bioenergetics and metabolism, regulation of gene expression, genetic adaptation, stress tolerance, biofilms, and cell-cell interactions and communications.\n",
    "credits": "4"
  },
  {
    "course_name": "Introductory Parasitology",
    "dept": "MICRO",
    "num": "353",
    "desc": "Prereq: BIOL 212\nBiology and host-parasite relationships of major groups of animal parasites, and techniques of diagnosing and studying parasites.\n",
    "credits": "3"
  },
  {
    "course_name": "Insects and Our Health",
    "dept": "MICRO",
    "num": "374",
    "desc": "Prereq: 3 credits in biological sciences\nIdentification, biology, and significance of insects and arthropods that affect the health of humans and animals, particularly those that are vectors of disease.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Insects and Our Health Laboratory",
    "dept": "MICRO",
    "num": "374L",
    "desc": "Prereq: Credit or enrollment in ENT 374\nLaboratory and field techniques for studying medical or public health entomology, including: collection, identification and maintenance of medically significant arthropods and experimental design and execution related to the biology of arthropods or arthropod-pathogen interactions.\n",
    "credits": "1"
  },
  {
    "course_name": "Microbial Genetics and Genomics",
    "dept": "MICRO",
    "num": "402",
    "desc": "Prereq: MICRO 302, BIOL 313\nThe fundamental concepts of bacterial and bacteriophage genetics including mutagenesis, mechanisms of vertical and horizontal genetic information transfer and gene regulation are covered, along with genetic and genomic-based approaches to study these and other cellular processes of microorganisms.  Review and discussion of research literature to examine experimental design, methodology, and interpretation of both historical and contemporary relevance to microbial genetics and genomics.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbiological Safety of Foods of Animal Origins",
    "dept": "MICRO",
    "num": "407",
    "desc": "Prereq: MICRO 420\nExamination of the various factors in the production of foods, from production through processing, distribution and final consumption which contribute to the overall microbiological safety of the food. Upon successful completion of this class, the student will receive both the Preventive Controls for Human Foods certificate (FDA program) and the International HACCP Alliance certificate (USDA-FSIS program).\n",
    "credits": "3"
  },
  {
    "course_name": "Virology",
    "dept": "MICRO",
    "num": "408",
    "desc": "Prereq: BIOL 313 or BBMB 301. BIOL 314 recommended\nThe molecular virology and epidemiology of human, animal, plant and insect viruses.\n",
    "credits": "3"
  },
  {
    "course_name": "Foodborne Hazards",
    "dept": "MICRO",
    "num": "419",
    "desc": "Prereq: MICRO 201 or MICRO 302, a course in biochemistry\nPathogenesis of human microbiological foodborne infections and intoxications, principles of toxicology, major classes of toxicants in the food supply, governmental regulation of foodborne hazards. Assessed service learning component.\n  Only one of FS HN 419 and FS HN 519 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Food Microbiology",
    "dept": "MICRO",
    "num": "420",
    "desc": "Prereq: MICRO 201 or MICRO 302\nEffects of microbial growth in foods. Methods to control, detect, and enumerate microorganisms in food and water. Foodborne infections and intoxications.\n",
    "credits": "3"
  },
  {
    "course_name": "Food Microbiology Laboratory",
    "dept": "MICRO",
    "num": "421",
    "desc": "Prereq: MICRO 201 or MICRO 302; MICRO 201L or MICRO 302L. Credit or enrollment in FS HN/MICRO 420\nStandard techniques used for the microbiological examination of foods. Independent and group projects on student-generated questions in food microbiology. Emphasis on oral and written communication and group interaction.\n",
    "credits": "3"
  },
  {
    "course_name": "Procaryotic Diversity and Ecology",
    "dept": "MICRO",
    "num": "430",
    "desc": "Prereq: MICRO 302, MICRO 302L\nSurvey of the diverse groups of procaryotes emphasizing important and distinguishing metabolic, phylogenetic, morphological, and ecological features of members of those groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Microbial Physiology, Diversity, and Genetics",
    "dept": "MICRO",
    "num": "440",
    "desc": "Prereq: MICRO 302, MICRO 302L, CHEM 332, BIOL 313L\nFundamental techniques and theory for studying the cellular mechanisms, genetic processes and diversity of microbial life. Experimental   techniques will include isolation and physiological characterization of bacteria that inhabit different environments as well as an emphasis on genetic and molecular techniques to understand antibiotic resistance processes and mechanisms. Also included are   techniques for phylogenetic characterization, measuring gene expression, and genetic manipulation of bacteria. Essential components for the effective communication of scientific results are also emphasized.\n",
    "credits": "4"
  },
  {
    "course_name": "Undergraduate Capstone Colloquium",
    "dept": "MICRO",
    "num": "450",
    "desc": "Prereq: SP CM 212 and senior standing in Microbiology\nRequired of all undergraduate majors in microbiology. Students demonstrate mastery of core courses in microbiology through discussion of current literature in microbiology and immunology, issues in scientific conduct, and bioethics in microbiology. Students present current papers in a journal club format and gain experience in writing and reviewing grant proposals.\n",
    "credits": "2"
  },
  {
    "course_name": "Survey in Microbiology",
    "dept": "MICRO",
    "num": "451",
    "desc": "Prereq: Junior or Senior standing in Microbiology\nPreparations for graduation. Topics include job search strategies, career information, mock interviews, graduate and professional school application processes and guidelines as well as outcomes assessment activities.\n",
    "credits": "R"
  },
  {
    "course_name": "Principles of Mycology",
    "dept": "MICRO",
    "num": "456",
    "desc": "Prereq: 10 credits in biological sciences\nMorphology, diversity, and ecology of fungi; their relation to agriculture, industry, and human health.\n",
    "credits": "3"
  },
  {
    "course_name": "Immunology",
    "dept": "MICRO",
    "num": "475",
    "desc": "Prereq: MICRO 310\nAn examination of humoral and cellular immune function as well as the interaction of the cells and factors of the immune system that result in health and disease. MICRO 475L optional.\n  Credit for either Micro 475 or V MPM 520, but not both, may be applied to graduation.",
    "credits": "3"
  },
  {
    "course_name": "Immunology Laboratory",
    "dept": "MICRO",
    "num": "475L",
    "desc": "Prereq: Credit or enrollment in MICRO 310 or MICRO 475 or MICRO 575\nTechniques in primary culture and tumor cell growth, measures of lymphocyte function, serological techniques and flow cytometry. Half semester course.\n",
    "credits": "1"
  },
  {
    "course_name": "Bacterial-Plant Interactions",
    "dept": "MICRO",
    "num": "477",
    "desc": "Prereq: 3 credits in microbiology or plant pathology\nOverview of plant-associated bacteria including their ecology, diversity, and the physiological and molecular mechanisms involved with their interactions with plants. The course covers bacterial plant pathogens and pathogenesis, nitrogen fixation and plant symbioses, biological control and plant growth promotion, bacterial disease diagnosis and management, and approaches to the study of microbial communities in the rhizosphere and on leaves.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil and Environmental Microbiology",
    "dept": "MICRO",
    "num": "485",
    "desc": "Prereq: AGRON 182 or equivalent; MICRO 201 and MICRO 201L recommended\nThe living organisms in the soil and what they do. Emphasis on soil biota composition, the carbon cycle and bioremediation, soil-plant-microbial relationships, and environmental issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "MICRO",
    "num": "487",
    "desc": "Prereq: Six credits in biology and 6 credits in chemistry\nIntroduction to major functional groups of autotrophic and heterotrophic microorganisms and their roles in natural and environmental systems. Consequences of microbial activity on water chemistry, weathering, and precipitation/dissolution reactions will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "MICRO",
    "num": "490",
    "desc": "Prereq: A minimum of 6 credits of 300-level or above coursework in microbiology, permission of instructor\n  A maximum of 6 credits of Micro 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Laboratory Research",
    "dept": "MICRO",
    "num": "490A",
    "desc": "Prereq: A minimum of 6 credits of 300-level or above coursework in microbiology, permission of instructor\n  A maximum of 6 credits of Micro 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Literature Review",
    "dept": "MICRO",
    "num": "490B",
    "desc": "Prereq: A minimum of 6 credits of 300-level or above coursework in microbiology, permission of instructor\n  A maximum of 6 credits of Micro 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Instructional Assistant",
    "dept": "MICRO",
    "num": "490C",
    "desc": "Prereq: A minimum of 6 credits of 300-level or above coursework in microbiology, permission of instructor\n  A maximum of 6 credits of Micro 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: General",
    "dept": "MICRO",
    "num": "490G",
    "desc": "Prereq: A minimum of 6 credits of 300-level or above coursework in microbiology, permission of instructor\n  A maximum of 6 credits of Micro 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "MICRO",
    "num": "490H",
    "desc": "Prereq: A minimum of 6 credits of 300-level or above coursework in microbiology, permission of instructor\n  A maximum of 6 credits of Micro 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Internship",
    "dept": "MICRO",
    "num": "495",
    "desc": "Prereq: At least 6 credits of 300-level or above coursework in microbiology, approval of academic adviser\nParticipation in the Cooperative Extension Intern Program or an equivalent work experience. Written report of activities required.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Microbial Genetics and Genomics",
    "dept": "MICRO",
    "num": "502",
    "desc": "Prereq: MICRO 302, BIOL 313\nThe fundamental concepts of bacterial and bacteriophage genetics including mutagenesis, mechanisms of vertical and horizontal genetic information transfer and gene regulation are covered, along with genetic and genomic-based approaches to study these and other cellular processes of microorganisms.  Review and discussion of research literature to examine experimental design, methodology, and interpretation of both historical and contemporary relevance to microbial genetics and genomics.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbiological Safety of Foods of Animal Origins",
    "dept": "MICRO",
    "num": "507",
    "desc": "Prereq: MICRO 420\nExamination of the various factors in the production of foods, from production through processing, distribution and final consumption which contribute to the overall microbiological safety of the food. Upon successful completion of this class, the student will receive both the Preventive Controls for Human Foods certificate (FDA program) and the International HACCP Alliance certificate (USDA-FSIS program).\n",
    "credits": "3"
  },
  {
    "course_name": "Plant Virology",
    "dept": "MICRO",
    "num": "509",
    "desc": "Prereq: BIOL 313 or BBMB 301. BIOL 314 recommended.\nTaxonomy, molecular mechanisms, host-interactions, vector transmission, epidemiology, detection, control and exploitation of plant viruses.  Course will consist of a mixture of lectures, and student-led presentations using primary literature.\n",
    "credits": "2"
  },
  {
    "course_name": "Gut Microbiome: Implications for Health and Diseases",
    "dept": "MICRO",
    "num": "517",
    "desc": "Prereq: Basic Knowledge in microbiology\nExplore current research on gut microbiome including modern tools used to study the gut microbiome. Examine the linkages between gut microbiome and health status, diseases, and manipulation of gut microbiome to improve health.\n",
    "credits": "3"
  },
  {
    "course_name": "Intestinal Microbiology",
    "dept": "MICRO",
    "num": "525",
    "desc": "Prereq: MICRO 302, BIOL 313\nOverview of commensal microbiota in the health and well-being of vertebrates. Topics include diversity of intestinal structure, microbial diversity/function, innate immune development, community interactions and metabolic diseases associated with alterations of the intestinal microbiome.\n",
    "credits": "3"
  },
  {
    "course_name": "Procaryotic Diversity and Ecology",
    "dept": "MICRO",
    "num": "530",
    "desc": "Prereq: MICRO 302, MICRO 302L\nSurvey of the diverse groups of procaryotes emphasizing important and distinguishing metabolic, phylogenetic, morphological, and ecological features of members of those groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Livestock Immunogenetics",
    "dept": "MICRO",
    "num": "540",
    "desc": "Prereq: AN S 561 or MICRO 575 or V MPM 520\nBasic concepts and contemporary topics in genetic regulation of livestock immune response and disease resistance.\n",
    "credits": "2"
  },
  {
    "course_name": "Microbial Diversity and Phylogeny",
    "dept": "MICRO",
    "num": "551",
    "desc": "Prereq: MICRO 302, BIOL 313\nComparisons among the three kingdoms of life (Bacterica, Archaea, and Eukarya). Topics will include metabolism, adaptation, methods of phylogenetic analysis, and comparative genomics.\n",
    "credits": "1"
  },
  {
    "course_name": "Bacterial Molecular Genetics and Physiology",
    "dept": "MICRO",
    "num": "552",
    "desc": "Prereq: MICRO 302, BIOL 313\nReview of genetics and selected physiological topics of model bacteria.\n",
    "credits": "1"
  },
  {
    "course_name": "Pathogenic Microorganisms",
    "dept": "MICRO",
    "num": "553",
    "desc": "Prereq: MICRO 302, BIOL 313\nReview and contrast/comparison of common bacterial pathogens of plants and animals and their mechanisms of virulence, including   toxins, protein secretion, host invasion and iron acquisition strategies. An overview of eukaryotic cell biology that is relevant to   pathogenesis will also be included.\n",
    "credits": "1"
  },
  {
    "course_name": "Virology",
    "dept": "MICRO",
    "num": "554",
    "desc": "Prereq: MICRO 302, BIOL 313\nIntroduction to virus life cycles including entry, gene expression strategies, replication, and mechanisms to modify and overcome   host defenses.  The roles of specific viruses and sub-viral agents in animal and plant disease will also be included.\n",
    "credits": "1"
  },
  {
    "course_name": "Fungal Biology",
    "dept": "MICRO",
    "num": "555",
    "desc": "Prereq: GEN 313 or GEN 320 or equivalent.\nEcology, genetics, physiology and diversity of fungi, from yeasts to mushrooms, and their importance in human affairs.\n",
    "credits": "1"
  },
  {
    "course_name": "Ecology of Microorganisms",
    "dept": "MICRO",
    "num": "556",
    "desc": "Prereq: MICRO 302, BIOL 313\nThe study of microorganisms in their natural environments, with a focus on terrestrial and aquatic ecosystems, including eukaryotic hosts; interactions within biofilms and communities, including intercellular communication and symbioses; microbial adaptations to extreme environments; and metagemomic, genomic, molecular and microscopy techniques for the study of microbes in natural systems.\n",
    "credits": "1"
  },
  {
    "course_name": "Immunology",
    "dept": "MICRO",
    "num": "575",
    "desc": "Prereq: MICRO 310\nAn examination of humoral and cellular immune function as well as the interaction of the cells and factors of the immune system that result in health and disease. MICRO 475L optional.\n  Credit for either Micro 575 or V MPM 520, but not both, may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Bacterial-Plant Interactions",
    "dept": "MICRO",
    "num": "577",
    "desc": "Prereq: 3 credits in microbiology or plant pathology\nOverview of plant-associated bacteria including their ecology, diversity, and the physiological and molecular mechanisms involved with their interactions with plants. The course covers bacterial plant pathogens and pathogenesis, nitrogen fixation and plant symbioses, biological control and plant growth promotion, bacterial disease diagnosis and management, and approaches to the study of microbial communities in the rhizosphere and on leaves.\n",
    "credits": "3"
  },
  {
    "course_name": "Soil and Environmental Microbiology",
    "dept": "MICRO",
    "num": "585",
    "desc": "Prereq: AGRON 182 or equivalent; MICRO 201 and MICRO 201L recommended\nThe living organisms in the soil and what they do. Emphasis on soil biota composition, the carbon cycle and bioremediation, soil-plant-microbial relationships, and environmental issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Bacteriology",
    "dept": "MICRO",
    "num": "586",
    "desc": "Prereq: 310\nBacteria associated with diseases of vertebrates, including virulence factors and interaction of host responses.\n",
    "credits": "4"
  },
  {
    "course_name": "Microbial Ecology",
    "dept": "MICRO",
    "num": "587",
    "desc": "Prereq: Six credits in biology and 6 credits in chemistry\nIntroduction to major functional groups of autotrophic and heterotrophic microorganisms and their roles in natural and environmental systems. Consequences of microbial activity on water chemistry, weathering, and precipitation/dissolution reactions will be emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "MICRO",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "MICRO",
    "num": "604",
    "desc": "\nCourse will expose students to the breadth of subdisciplines within microbiology, offer opportunities for direct interaction between the students and the faculty members within the Interdepartmental Microbiology Graduate Program, and promote interactions among the students within the program.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Molecular Virology",
    "dept": "MICRO",
    "num": "608",
    "desc": "Prereq: BBMB 405 or GDCB 511\nAdvanced study of virus host-cell interactions. Molecular mechanisms of viral replication and pathogenesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Immunology",
    "dept": "MICRO",
    "num": "615",
    "desc": "Prereq: BBMB 405 or BBMB 506 and BBMB 507\nCurrent topics in molecular aspects of immunology: T and B cell receptors; major histocompatibility complex; antibody structure; immunosuppressive drugs and viruses; and intracellular signaling pathways leading to expression of genes that control and activate immune function.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanisms of Bacterial Pathogenesis",
    "dept": "MICRO",
    "num": "625",
    "desc": "Prereq: Credit in Biochemistry and Microbiology\nReview of current concepts in specific areas of microbial pathogenesis including the genetic basis for bacterial disease, genetic regulation and control of virulence factors and their mechanisms of action, and host-pathogen interactions at the cellular and molecular levels. The application of microbial genetics to understanding pathogenesis will be included.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Food Microbiology",
    "dept": "MICRO",
    "num": "626",
    "desc": "Prereq: FS HN 420 or FS HN 421 or FS HN 504\nTopics of current interest in food microbiology, including new foodborne pathogens, rapid identification methods, effect of food properties and new preservation techniques on microbial growth, and mode of action of antimicrobials.\n",
    "credits": "3"
  },
  {
    "course_name": "Rapid Methods in Food Microbiology",
    "dept": "MICRO",
    "num": "627",
    "desc": "Prereq: FS HN 420 or FS HN 421 or FS HN 504\nProvides an overview of rapid microbial detection methods for use in foods. Topics include historical aspects of rapid microbial detection, basic categories of rapid tests (phenotypic, genotypic, whole cell, etc.), existing commercial test formats and kits, automation in testing, sample preparation and \"next generation\" testing formats now in development.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Soil Biochemistry",
    "dept": "MICRO",
    "num": "685",
    "desc": "Prereq: AGRON 585\nChemistry of soil organic matter and biochemical transformations brought about by microorganisms and enzymes in soils.\n",
    "credits": "2"
  },
  {
    "course_name": "Current Topics",
    "dept": "MICRO",
    "num": "690",
    "desc": "Prereq: Permission of instructor\nColloquia or advanced study of specific topics in a specialized field.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics: Microbiology",
    "dept": "MICRO",
    "num": "690A",
    "desc": "Prereq: Permission of instructor\nColloquia or advanced study of specific topics in a specialized field.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics: Immunology",
    "dept": "MICRO",
    "num": "690B",
    "desc": "Prereq: Permission of instructor\nColloquia or advanced study of specific topics in a specialized field.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics: Infectious Diseases",
    "dept": "MICRO",
    "num": "690C",
    "desc": "Prereq: Permission of instructor\nColloquia or advanced study of specific topics in a specialized field.\n",
    "credits": "1"
  },
  {
    "course_name": "Molecular Biology of Plant-Pathogen Interactions",
    "dept": "MICRO",
    "num": "692",
    "desc": "Prereq: PL P 506 or BBMB 405 or GEN 411 or MICRO 402 or strong background in molecular biology\nSeminal and current research in molecular and physiological aspects of plant interactions with pathogens,     including mechanisms of pathogenesis, host-pathogen recognition and host defense, with an emphasis on critical evaluation of     primary literature.  Students also complete a research proposal writing and peer review exercise.\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Research Rotation",
    "dept": "MICRO",
    "num": "697",
    "desc": "\nGraduate research projects performed under the supervision of selected faculty members in the Interdepartmental Microbiology major.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Molecular, Cellular, and Developmental Biology",
    "dept": "MICRO",
    "num": "698",
    "desc": "\nStudent and faculty presentations.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "MICRO",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to Military Science",
    "dept": "M S",
    "num": "101",
    "desc": "Prereq: Concurrent enrollment in M S 101L required\nExamines the role of a Cadet in the Army Reserve Officer Training Corps and a Lieutenant in the United States Army. The course explores a military culture whose ultimate success is determined by the character and proficiency of its' leaders. Instruction introduces students to the cultural heritage and history of the U.S. Army. Students will begin to understand the structure of the U.S. Army and how it functions as an organization and institution. The curriculum promotes the development of students' communication skills to enhance their ability to transmit ideas. The class examines how the Army's cultural values drive the development of leadership in the Officer Corps. Hands-on activities enable students to gain insight on the skills and abilities required of cadets and officers interacting with civilians and soldiers.\n",
    "credits": "1"
  },
  {
    "course_name": "Basic Leadership Laboratory I",
    "dept": "M S",
    "num": "101L",
    "desc": "Prereq: Concurrent enrollment in M S 101 required\nUses basic military training, missions and scenarios to provide a hands-on method of developing confidence and leadership skills. Students observe and participate in the rotation through various levels of leadership positions at the platoon and squad level within the Army command structure. This concept provides a constant learning environment as they learn to communicate effectively and work as a team while assigned to positions at various levels within the organization. Marching, rifle firing, and tactical patrolling; students gain confidence through rappelling and construction/use of rope bridges; and increase professional knowledge in areas such as first aid, water survival, personal physical fitness, and land navigation. Teaching locations include the ISU Armory, Camp Dodge (National Guard Facility), Pammel Woods (ISU campus), and ISU fitness centers. Full participation in all events will be determined based on students' physical and medical eligibility.\n",
    "credits": "1"
  },
  {
    "course_name": "Structure and Function of the U.S. Army",
    "dept": "M S",
    "num": "102",
    "desc": "Prereq: Concurrent enrollment in M S 102L required\nInstructs students on the fundamental skills and proficiencies required of Cadets in the Army Reserve Officer Training Corps and Officers in the United States Army. Allows students to explore the Army culture whose ultimate success is determined by the character and proficiency of its' leaders. Students will gain an insight to the effects of human behavior and communication on the function of the Army's basic unit structures. Special focus is given to the emphasis the Army puts on the development and character of the leader and how that affects the culture and operation of the Army as an institution. Students will develop an understanding of the role that morals and ethics play in becoming an Army Officer and leading American Soldiers. Introduction to basic officer/soldier skills will elucidate the complex role of the Officer in the modern Army.\n",
    "credits": "1"
  },
  {
    "course_name": "Basic Leadership Laboratory II",
    "dept": "M S",
    "num": "102L",
    "desc": "Prereq: Concurrent enrollment in M S 102 required\nUses basic military training, missions and scenarios to provide a hands-on method of developing confidence and leadership skills. Rotation through various levels of leadership positions at the platoon and squad level within the Army command structure. Provides a constant learning environment as they learn to communicate effectively and work as a team while assigned to positions at various levels within the organization. Students also learn various military tasks such as marching, rifle firing, and tactical patrolling; gain confidence through rappelling and construction/use of rope bridges; and increase professional knowledge in areas such as first aid, water survival, personal physical fitness, and land navigation. Teaching locations include the ISU Armory, Camp Dodge (National Guard Facility), Pammel Woods (ISU campus), and ISU fitness centers. Full participation in all events will be determined based on students' physical and medical eligibility.\n",
    "credits": "1"
  },
  {
    "course_name": "Army Physical Readiness",
    "dept": "M S",
    "num": "150",
    "desc": "\nThis lab is designed to use basic military skills and instruction to develop confidence, leadership, and physical fitness.  The team approach is utilized in the instruction and application of Army physical fitness requirements.  Students will learn various Army physical fitness techniques as well as how to conduct physical fitness sessions.  Teaching locations include Lied Recreation Center, Beyer Hall, State Gym as well as around campus.  Full participation in all events will be determined based on students physical and medical eligibility.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles of Leadership and Communication Skills",
    "dept": "M S",
    "num": "201",
    "desc": "Prereq: Concurrent enrollment in M S 201L required\nExplores the development of leadership and communication skills by understanding and studying the principles, traits, and dynamics of leadership and effective communication techniques. These include; leadership dimensions, human behavior, time management skills, stress management, values and ethics, decision making process, problem solving skills, team building exercises, communication techniques, briefing skills, delegating, nutrition, fitness, and counseling. Leadership assessment programs, role playing, active class participation, speeches, country briefs, and video clips are used to enhance and reinforce the instruction.\n",
    "credits": "2"
  },
  {
    "course_name": "Basic Leadership Laboratory III",
    "dept": "M S",
    "num": "201L",
    "desc": "Prereq: Concurrent enrollment in M S 201 required\nUses basic military training, missions and scenarios to provide a hands-on method of developing confidence and leadership skills. Students observe and participate in the rotation through various levels of leadership positions at the platoon and squad level within the Army command structure. Learn to communicate effectively and work as a team while assigned to positions at various levels within the organization. Students also learn various military tasks such as marching, rifle firing, and tactical patrolling; gain confidence through rappelling and construction/use of rope bridges; and increase professional knowledge in areas such as first aid, water survival, personal physical fitness, and land navigation. Teaching locations include the ISU Armory, Camp Dodge (National Guard Facility), Pammel Woods (ISU campus), and ISU fitness centers. Full participation in all events will be determined based on students' physical and medical eligibility.\n",
    "credits": "1"
  },
  {
    "course_name": "Map Reading and Land Navigation",
    "dept": "M S",
    "num": "202",
    "desc": "Prereq: Concurrent enrollment in M S 202L required\nClass focuses on the characteristics and features of the earth's land mass and how to apply different methods of conducting navigation on land. These methods include; by use of topographical maps, compasses, aerial photographs, military maps, symbols, and all their practical application. These navigation techniques are used in class in conjunction with patrolling techniques and squad movement exercises. Students will utilize verbal and non-verbal communication, communication techniques, and briefing techniques during this class. Students are also assigned to read one professional book from the Army Reading List and complete a written review of the book in the Army writing style.\n",
    "credits": "2"
  },
  {
    "course_name": "Basic Leadership Laboratory IV",
    "dept": "M S",
    "num": "202L",
    "desc": "Prereq: Concurrent enrollment in M S 202 required\nUses basic military training, missions and scenarios to provide a hands-on method of developing confidence and leadership skills. Students observe and participate in the rotation through various levels of leadership positions at the platoon and squad level within the Army command structure. Learn to communicate effectively and work as a team while assigned to positions at various levels within the organization. Students also learn various military tasks such as marching, rifle firing, and tactical patrolling; gain confidence through rappelling and construction/use of rope bridges; and increase professional knowledge in areas such as first aid, water survival, personal physical fitness, and land navigation. Teaching locations include the ISU Armory, Camp Dodge (National Guard Facility), Pammel Woods (ISU campus), and ISU fitness centers. Full participation in all events will be determined based on students' physical and medical eligibility.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Army Physical Readiness I",
    "dept": "M S",
    "num": "250",
    "desc": "Prereq: Successfully complete M S 150 and permission of Department Chair\nStudents learn to plan and conduct physical fitness sessions, following Army physical fitness readiness requirements.  Development of physical fitness plan and leadership of training sessions.  Participation determined by students' physical and medical eligibility.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Army Physical Readiness II",
    "dept": "M S",
    "num": "251",
    "desc": "Prereq: Successfully complete M S 150 and M S 250\nStudents learn to plan and conduct physical fitness sessions, following Army physical fitness readiness requirements.  Development of physical fitness plan, and leadership of training sessions.  Participation determined by students' physical and medical eligibility.\n",
    "credits": "2"
  },
  {
    "course_name": "Independent Study: Basic Military Study",
    "dept": "M S",
    "num": "290",
    "desc": "Prereq: Permission of the Chair of Military Science Department\nInvestigation of an approved topic.  Must result in a professional journal-worthy paper on ethics, current military issues, interpersonal communications, or leadership development.\n",
    "credits": "1"
  },
  {
    "course_name": "Methods of Instructing Military Skills",
    "dept": "M S",
    "num": "301",
    "desc": "Prereq: Completion of the basic Military Science program, concurrent enrollment in M S 301L, and permission of the Chair of the Military Science Department\nDevelops student's proficiency in analyzing, planning, and executing complex operations within a military organizational structure. Students are given situational opportunities and then measured on their leadership abilities through systematic feedback. Student's evaluations are based on sixteen leadership dimensions within the realms of values, attributes, skills, and actions. Students develop an understanding of human cultural heritage and history, as it pertains to the armed forces.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Leadership Laboratory I",
    "dept": "M S",
    "num": "301L",
    "desc": "Prereq: Completion of the basic program, concurrent enrollment in M S 301 and permission of the Chair of the Military Science Department\nThe lab compliments M S 301 by providing opportunities to practice the lessons from class. On-the-job training and evaluation provided by the ROTC cadre. Developing training programs, structuring laboratories, presenting classes, planning various events, and accepting responsibility for the leadership labs. Participating in the Water Survival test, Army Physical Fitness test and the Land Navigation test are required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Leadership",
    "dept": "M S",
    "num": "302",
    "desc": "Prereq: Completion of the basic Military Science program, concurrent enrollment in M S 302L and permission of the Chair of the Military Science Department\nPrepares students to attend the Leadership Develop and Assessment Course at Fort Lewis, Washington in which they will be assigned specific and situational tasks to accomplish by providing purpose, motivation, and direction to fellow students across the nation. Students will learn how to identify sixteen leadership dimensions in the under classmen and provide specific feedback on their leadership behaviors. Students will develop their oral communication skills about the plans developed by the class, through small group presentation settings. Students will develop methods of studying human behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Leadership Laboratory II",
    "dept": "M S",
    "num": "302L",
    "desc": "Prereq: Completion of the basic program, concurrent enrollment in M S 302 and permission of the Chair of the Military Science Department\nThe lab compliments M S 302 by providing opportunities to practice the lessons from class. On-the-job training and evaluation provided by the ROTC cadre. Developing training programs, structuring laboratories, presenting classes, planning various events, and accepting responsibility for the leadership labs. Participating in the Water Survial Test, Army Physical Fitness Test and the Land Navigation test required.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: The Military Team",
    "dept": "M S",
    "num": "401",
    "desc": "Prereq: Completion of the basic program, concurrent enrollment in M S 401L and permission of the Chair of the Military Science Department\nDevelops student proficiency in analyzing and evaluating leadership behaviors, such as values, attributes, skills, and actions. Students are given situational opportunities to assess leadership and provide feedback to other students placed in leadership roles. Students will be measured by their ability to both give and receive systematic and specific feedback on leadership behaviors. Students will develop their ability to communicate thoughts and ideas orally through small group presentations and group discussions. Students will supervise and evaluate the planning and execution of complex operations within a military organizational structure.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Leadership Laboratory III",
    "dept": "M S",
    "num": "401L",
    "desc": "Prereq: Completion of the basic program, concurrent enrollment in M S 401 and permission of the Chair of the Military Science Department\nThe lab compliments the instruction from class by demonstrating the indelible link between personal values and successful leadership. On-the-job training and evaluation provided by the ROTC cadre. Developing training programs, structuring laboratories, presenting classes, planning various events, and accepting responsibility for the leadership labs.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: The Professional Military Officer",
    "dept": "M S",
    "num": "402",
    "desc": "Prereq: Completion of the basic program, concurrent enrollment in M S 402L and permission of the Chair of the Military Science Department\nExplores the dynamics of leading in the complex situations of current military operations in a contemporary world. Students will examine the differences in customs, courtesies and operational principles in the face of international terrorism. Students will also explore aspects of interaction with nongovernmental organizations, civilians and media in a war zone and foreign national governments. The course uses case studies, scenarios, and practical exercises, which prepare the student to face complex ethical and practical demands of leading soldiers within a multifaceted military organizational structure.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Leadership Laboratory IV",
    "dept": "M S",
    "num": "402L",
    "desc": "Prereq: Completion of the basic program, concurrent enrollment in M S 402 and permission of the Chair of the Military Science Department\nThe lab compliments the instruction from class by demonstrating the indelible link between personal values and successful leadership. On-the-job training and evaluation provided by the ROTC cadre. Developing training programs, structuring laboratories, presenting classes, planning various events, and accepting responsibility for the leadership labs.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Advanced Military Study",
    "dept": "M S",
    "num": "490",
    "desc": "Prereq: M S 301, M S 302, M S 401 and M S 402 and permission of the Chair of the Military Science Department\nInvestigation of an approved topic. Must result in a professional journal-worthy paper on ethics, current military issues, interpersonal communications, or leadership development.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Molecular Genetics",
    "dept": "MCDB",
    "num": "511",
    "desc": "Prereq: BIOL 313 and BBMB 405\nMechanisms of molecular genetic processes in eukaryotes and prokaryotes, including DNA replication and repair, transcription, translation and regulation of gene expression. Critical evaluation and discussion of current primary literature, methodologies and experimental data.\n",
    "credits": "3"
  },
  {
    "course_name": "Advances in Molecular Cell Biology",
    "dept": "MCDB",
    "num": "528",
    "desc": "Prereq: Courses in general cell biology and biochemistry\nCell biological processes including cell signaling, cell division, intracellular trafficking, biogenesis of organelles, cell adhesion and motility.\n",
    "credits": "3"
  },
  {
    "course_name": "Advances in Developmental Biology",
    "dept": "MCDB",
    "num": "533",
    "desc": "Prereq: BIOL 314 or BIOL 423\nFundamental principles in multicellular development. Emphasis on cellular and molecular regulation of developmental processes, and experimental approaches as illustrated in the current literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Plant Molecular, Cell and Developmental Biology",
    "dept": "MCDB",
    "num": "545",
    "desc": "Prereq: BIOL 313, BIOL 314, BIOL 330 or BBMB 405\nPlant nuclear and organelle genomes; regulation of gene expression; hormone signaling; organization, function, and development of plant cells and subcellular structures; regulation of plant growth and development.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "MCDB",
    "num": "590",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Biochemistry of Gene Expression in Eucaryotes",
    "dept": "MCDB",
    "num": "676",
    "desc": "Prereq: BBMB 404 and BBMB 504; and BBMB 506 and BBMB 507; or BBMB 405 or BBMB 505 and  or GDCB 511\nAnalysis of the biochemical processes involved in expression of eucaryotic genes and the regulation thereof, including RNA polymerase, transcriptional regulatory proteins, enhancers and silencers, chromosome structure, termination, RNA processing, RNA transport, RNA turnover, small RNAs, translational regulation, protein turnover.\n",
    "credits": "2"
  },
  {
    "course_name": "Graduate Research Rotation",
    "dept": "MCDB",
    "num": "697",
    "desc": "\nGraduate research projects performed under the supervision of selected faculty members in the molecular, cellular, and developmental biology program.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Molecular, Cellular, and Developmental Biology",
    "dept": "MCDB",
    "num": "698",
    "desc": "\nStudent and faculty presentations.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "MCDB",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Fundamentals of Music",
    "dept": "MUSIC",
    "num": "101",
    "desc": "Prereq: Ability to read elementary musical notation\nNotation, recognition, execution and analysis of scales, intervals, triads, and rhythm; key signatures; time signatures; transposition.   Open to non-majors only.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Music Listening",
    "dept": "MUSIC",
    "num": "102",
    "desc": "\nExpansion of the music listening experiences for the general student through greater awareness of differences in techniques of listening, performance media, and materials of the art. The course focuses on the elements of music: rhythm, melody, harmony, form, and style, and how these elements are used in musics of different cultures and time periods. Ability to read or perform music not required.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Basic Musicianship",
    "dept": "MUSIC",
    "num": "105",
    "desc": "Prereq: Performing arts major status or permission of instructor.\nBeginning keyboard techniques, sight-reading, and ear training. Basic materials of music: notation, scales, intervals, key signatures,   time signatures, rhythm, and harmony.\n",
    "credits": "3"
  },
  {
    "course_name": "Wind Ensemble",
    "dept": "MUSIC",
    "num": "111",
    "desc": "Prereq: Open to all students by audition\nEmphasis on significant extended compositions for wind and percussion instruments. Performances include formal concerts on campus and the annual tour.\n",
    "credits": "1"
  },
  {
    "course_name": "Concert Band",
    "dept": "MUSIC",
    "num": "112",
    "desc": "Prereq: Open to all students who have performed on a wind or percussion instrument in high school band or orchestra\nRepertoire includes the broad spectrum of band music. Two concerts are presented each semester.\n",
    "credits": "1"
  },
  {
    "course_name": "Jazz Ensemble",
    "dept": "MUSIC",
    "num": "113",
    "desc": "Prereq: Open to all students by audition\nDesigned to explore various styles and trends in contemporary jazz.\n",
    "credits": "1"
  },
  {
    "course_name": "Marching and Pep Bands",
    "dept": "MUSIC",
    "num": "114",
    "desc": "\nPerformances at athletic events.\n",
    "credits": "1"
  },
  {
    "course_name": "Marching and Pep Bands: Marching Band",
    "dept": "MUSIC",
    "num": "114A",
    "desc": "\nMembership determined by audition and band application. Auditions held for woodwind, brass, percussion, flag, and twirler positions. Presentation of pre-game and half time shows at each home football game; additional performances are also scheduled on and off campus. Audition information is listed on the band website (www.music.iastate.edu/org/marching).\n  Students may not be concurrently enrolled in MUSIC 114A and 114C.",
    "credits": "1"
  },
  {
    "course_name": "Marching and Pep Bands: Pep Band",
    "dept": "MUSIC",
    "num": "114B",
    "desc": "Prereq: Students selected by audition from members of MUSIC 114A.\nPerformances at basketball games.\n",
    "credits": "1"
  },
  {
    "course_name": "Marching and Pep Bands: Pep Band for Wrestling and Soccer",
    "dept": "MUSIC",
    "num": "114C",
    "desc": "Prereq: Students selected by audition.\nPerformances at wrestling and women’s soccer games.\n  Students may not be concurrently enrolled in MUSIC 114A and 114C.",
    "credits": "1"
  },
  {
    "course_name": "Symphonic Band",
    "dept": "MUSIC",
    "num": "115",
    "desc": "Prereq: Open to all students by audition\nStresses high quality wind literature. Performances include formal concerts on campus.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors",
    "dept": "MUSIC",
    "num": "118",
    "desc": "Prereq: Audition, permission of instructor\nApplied music for the general student.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Voice",
    "dept": "MUSIC",
    "num": "118A",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors.\n  Will not satisfy applied music requirements for music majors.",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Piano",
    "dept": "MUSIC",
    "num": "118B",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors.\n  Will not satisfy applied music   requirements for music majors.",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Organ",
    "dept": "MUSIC",
    "num": "118C",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Strings",
    "dept": "MUSIC",
    "num": "118D",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Carillon",
    "dept": "MUSIC",
    "num": "118E",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Woodwinds",
    "dept": "MUSIC",
    "num": "118F",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Brass",
    "dept": "MUSIC",
    "num": "118G",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors.\n  Will not satisfy applied music requirements for music majors.",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Percussion",
    "dept": "MUSIC",
    "num": "118I",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors.\n  Will not satisfy applied music requirements for music majors.",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Harpsichord",
    "dept": "MUSIC",
    "num": "118K",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors.\n  Will not satisfy applied music requirements for music majors.",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors",
    "dept": "MUSIC",
    "num": "119",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\nApplied music for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Voice",
    "dept": "MUSIC",
    "num": "119A",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Piano",
    "dept": "MUSIC",
    "num": "119B",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Organ",
    "dept": "MUSIC",
    "num": "119C",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Strings",
    "dept": "MUSIC",
    "num": "119D",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Carillon",
    "dept": "MUSIC",
    "num": "119E",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Woodwinds",
    "dept": "MUSIC",
    "num": "119F",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Brass",
    "dept": "MUSIC",
    "num": "119G",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Percussion",
    "dept": "MUSIC",
    "num": "119I",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music for Majors: Harpsichord",
    "dept": "MUSIC",
    "num": "119K",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Music Literature and Styles",
    "dept": "MUSIC",
    "num": "120",
    "desc": "Prereq: MUSIC 224; music major status or permission of instructor\nDirected studies via aural analysis for music majors with emphasis on the materials of music, form and aesthetic issues. Introduction to style and literature of the major performance media in context of historical chronology. Fundamentals of score reading and performance terminology.\n  Only one of Music 120 and 302 can count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Class Study in Piano I",
    "dept": "MUSIC",
    "num": "127",
    "desc": "Prereq: Music major status or permission of instructor\nBeginning keyboard technique,  transposition, harmonization, ensemble and solo repertory, and sight-reading skills.\n",
    "credits": "1"
  },
  {
    "course_name": "Class Study in Piano II",
    "dept": "MUSIC",
    "num": "128",
    "desc": "Prereq: MUSIC 127 or permission of instructor\nContinuation of beginning keyboard technique,  transposition, harmonization, ensemble and solo repertory, and sight-reading   skills.\n",
    "credits": "1"
  },
  {
    "course_name": "Lyrica Women's Choir",
    "dept": "MUSIC",
    "num": "141",
    "desc": "Prereq: Open to all female students by audition\nLarge chorus; emphasis on fundamental vocal and choral skills, wide variety of literature. Campus concerts each semester.\n",
    "credits": "1"
  },
  {
    "course_name": "Oratorio Chorus",
    "dept": "MUSIC",
    "num": "151",
    "desc": "Prereq: Open to all students by audition\nAdvanced skills required, high quality literature. Campus concerts each semester, some concerts in conjunction with orchestras. Men's and women's choirs separately and in combination.\n",
    "credits": "1"
  },
  {
    "course_name": "Oratorio Chorus: Cantamus Women's Choir",
    "dept": "MUSIC",
    "num": "151A",
    "desc": "Prereq: Open to all students by audition\nAdvanced skills required, high quality literature. Campus concerts each semester, some concerts in conjunction with orchestras. Men's and women's choirs separately and in combination.\n",
    "credits": "1"
  },
  {
    "course_name": "Oratorio Chorus: Statesmen Men's Choir",
    "dept": "MUSIC",
    "num": "151B",
    "desc": "Prereq: Open to all students by audition\nAdvanced skills required, high quality literature. Campus concerts each semester, some concerts in conjunction with orchestras. Men's and women's choirs separately and in combination.\n",
    "credits": "1"
  },
  {
    "course_name": "Iowa State Singers",
    "dept": "MUSIC",
    "num": "161",
    "desc": "Prereq: Open to all students by audition\nConcert choir specializing in performance of advanced music literature, Renaissance through contemporary. Campus concerts, annual spring tour.\n",
    "credits": "1"
  },
  {
    "course_name": "Symphony Orchestra",
    "dept": "MUSIC",
    "num": "181",
    "desc": "Prereq: Open to all students by audition\nReading, preparation, and performance of standard repertoire. Five or six concerts annually plus occasional off-campus appearances.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors",
    "dept": "MUSIC",
    "num": "219",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\nApplied music for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Voice",
    "dept": "MUSIC",
    "num": "219A",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Piano",
    "dept": "MUSIC",
    "num": "219B",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Organ",
    "dept": "MUSIC",
    "num": "219C",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Strings",
    "dept": "MUSIC",
    "num": "219D",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Carillon",
    "dept": "MUSIC",
    "num": "219E",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Woodwinds",
    "dept": "MUSIC",
    "num": "219F",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Brass",
    "dept": "MUSIC",
    "num": "219G",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Percussion",
    "dept": "MUSIC",
    "num": "219I",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Harpsichord",
    "dept": "MUSIC",
    "num": "219K",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Music Theory I",
    "dept": "MUSIC",
    "num": "224",
    "desc": "Prereq: MUSIC 101, permission of instructor, or passing grade on the Fundamentals placement exam.\nTwo-voice species counterpoint as an introduction to voice-leading principles.  Application of diatonic harmony in analysis and four-part writing. Introduction to notation software and other technologies used in the study of music.\n",
    "credits": "4"
  },
  {
    "course_name": "Aural Theory I",
    "dept": "MUSIC",
    "num": "225",
    "desc": "Prereq: Music major status or permission of instructor; credit or enrollment in MUSIC 224\nAural discrimination of intervals, rhythms and patterns, as demonstrated by proficiency in ear training, sight singing, and related musicianship skills.\n",
    "credits": "1"
  },
  {
    "course_name": "Class Study in Piano III",
    "dept": "MUSIC",
    "num": "227",
    "desc": "Prereq: MUSIC 128 or permission of instructor\nIntermediate keyboard technique, transposition, harmonization, improvisation, repertory, and sight-reading skills. Introduction to   score reading, hymn playing, and accompanying at the piano.\n",
    "credits": "1"
  },
  {
    "course_name": "Class Study in Piano IV",
    "dept": "MUSIC",
    "num": "228",
    "desc": "Prereq: MUSIC 227 or permission of instructor\nContinuation of intermediate keyboard technique, transposition, harmonization, improvisation,  repertory, score reading, hymn   playing, and accompanying at the piano.\n",
    "credits": "1"
  },
  {
    "course_name": "Music Theory II",
    "dept": "MUSIC",
    "num": "234",
    "desc": "Prereq: MUSIC 224; concurrent enrollment in MUSIC 235 recommended\nHarmonic and melodic materials of tonal music including chromatic secondary function chords and modulation techniques.  Application of these materials in analysis, part writing, and composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Aural Theory II",
    "dept": "MUSIC",
    "num": "235",
    "desc": "Prereq: MUSIC 225; credit or enrollment in MUSIC 234\nDevelopment of sight singing, ear training, and related musicianship skills with emphasis on diatonic harmonic and melodic materials as well as rhythm.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Creative Digital Music",
    "dept": "MUSIC",
    "num": "246",
    "desc": "Prereq: MUSIC 101, MUSIC 105, or MUSIC 224, or permission of instructor\nIntroduction to audio and MIDI software used in creating digital music. Includes fundamentals of audio waveform editing, processing, and mixing, MIDI data structures, practical projects in musical composition using a digital audio workstation.\n",
    "credits": "2"
  },
  {
    "course_name": "Technology in Music Instruction",
    "dept": "MUSIC",
    "num": "248",
    "desc": "Prereq: MUSIC 224 and MUSIC 225\nIntroduction to computer software applications used in musical arrangements and presentations, practical   introduction to audio   and   MIDI technologies in lab-based music instruction, basic recording/sound reinforcement and music website   management.   Intended   for Music Education Majors.\n",
    "credits": "2"
  },
  {
    "course_name": "Music in Elementary Education",
    "dept": "MUSIC",
    "num": "265",
    "desc": "Prereq: HD FS 102 or PSYCH 230\nExperiencing and understanding the fundamentals of music through singing, playing classroom instruments, body movement, reading notation, listening, and creative activities. Developing lesson plan strategies and sequence, exploring multicultural musics, integrating music with other subjects in the elementary classroom, and evaluating aspects of musical learning.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Music Education",
    "dept": "MUSIC",
    "num": "266",
    "desc": "Prereq: Concurrent enrollment in MUSIC 280K\nRequired for first-year majors in music education. Historical, philosophical, and social foundations of music education; music curricula overview including goals of the music program, and contemporary and international curriculum development; psychology of teaching music including discipline techniques. Preparation for required observations in area schools.\n",
    "credits": "2"
  },
  {
    "course_name": "Pre-Student Teaching Experience I: Music",
    "dept": "MUSIC",
    "num": "280K",
    "desc": "\nPre-student teaching experience in music in school settings.  Permission of Music coordinator required prior to enrollment. Clinical Experience Level 1.\n  Offered on a satisfactory-fail basis only.  EDUC 280 may be taken more than once for credit toward graduation.",
    "credits": "0"
  },
  {
    "course_name": "Special Problems",
    "dept": "MUSIC",
    "num": "290",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent study.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems: Education",
    "dept": "MUSIC",
    "num": "290A",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent study in music education.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems: Theory",
    "dept": "MUSIC",
    "num": "290B",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent stud in music theory.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems: Composition",
    "dept": "MUSIC",
    "num": "290C",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent study in music composition.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems: History",
    "dept": "MUSIC",
    "num": "290D",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent study in music history.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems: Literature",
    "dept": "MUSIC",
    "num": "290E",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent study in music literature.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems: Applied Music",
    "dept": "MUSIC",
    "num": "290F",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent study in applied music.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems: Conducting",
    "dept": "MUSIC",
    "num": "290G",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent study in conducting.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems, Honors",
    "dept": "MUSIC",
    "num": "290H",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent honors project in music.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Problems: Business",
    "dept": "MUSIC",
    "num": "290J",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent study in music business.\n",
    "credits": "arr"
  },
  {
    "course_name": "Opera Studio",
    "dept": "MUSIC",
    "num": "301",
    "desc": "Prereq: Permission of instructor\nStudy of selected opera scenes, chamber operas, and works from contemporary and classical music  theater. Basic stagecraft, role interpretation, production.\n",
    "credits": "1"
  },
  {
    "course_name": "Opera Studio: Opera/Operetta",
    "dept": "MUSIC",
    "num": "301A",
    "desc": "Prereq: Permission of instructor\nStudy of selected opera scenes and chamber operas. Basic stagecraft, role interpretation, production.\n",
    "credits": "1"
  },
  {
    "course_name": "Opera Studio: Music Theater",
    "dept": "MUSIC",
    "num": "301B",
    "desc": "Prereq: Permission of instructor\nStudy of selected works from contemporary and classical music  theater. Basic stagecraft, role interpretation, production.\n",
    "credits": "1"
  },
  {
    "course_name": "Masterpieces of Music and Art in Western Culture.",
    "dept": "MUSIC",
    "num": "302",
    "desc": "Prereq: MUSIC 102\nExploration of several great works of classical music in light of the artistic culture in which they were composed; and trends in musical styles as well as individual composers’ personalities over history through listening and discussion. Some concert attendance is required outside of class. An ability to read music is not required, but is recommended. Non-majors only.\n  Only one of Music 120 and 302 can count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "History of American Rock 'n'  Roll",
    "dept": "MUSIC",
    "num": "304",
    "desc": "Prereq: MUSIC 101, MUSIC 102, MUSIC 224, or MUSIC 225\nRock 'n' Roll from the mid 1950s through the 1990s, focusing on the development of rock styles from its roots in blues, folk, country, and pop. Expansion of listening experience through study of song forms, musical instruments of rock, and the socio-political significance of song lyrics. Examinations, research paper or in class presentation required. Ability to read or perform music not required.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Music: Non-majors",
    "dept": "MUSIC",
    "num": "318",
    "desc": "Prereq: Audition, permission of instructor\nApplied music for students other than music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Voice",
    "dept": "MUSIC",
    "num": "318A",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Piano",
    "dept": "MUSIC",
    "num": "318B",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Organ",
    "dept": "MUSIC",
    "num": "318C",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Strings",
    "dept": "MUSIC",
    "num": "318D",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Carillon",
    "dept": "MUSIC",
    "num": "318E",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Woodwinds",
    "dept": "MUSIC",
    "num": "318F",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Brass",
    "dept": "MUSIC",
    "num": "318G",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Percussion",
    "dept": "MUSIC",
    "num": "318I",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Non-majors: Harpsichord",
    "dept": "MUSIC",
    "num": "318K",
    "desc": "Prereq: Audition, permission of instructor\n(.5-0) for 1 cr. (1-0) for 2 cr. Applied music for the general student. Open only to non-majors. Will not satisfy applied music   requirements for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors",
    "dept": "MUSIC",
    "num": "319",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\nApplied music for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Voice",
    "dept": "MUSIC",
    "num": "319A",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Piano",
    "dept": "MUSIC",
    "num": "319B",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Organ",
    "dept": "MUSIC",
    "num": "319C",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Strings",
    "dept": "MUSIC",
    "num": "319D",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Carillon",
    "dept": "MUSIC",
    "num": "319E",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Woodwinds",
    "dept": "MUSIC",
    "num": "319F",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Brass",
    "dept": "MUSIC",
    "num": "319G",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Percussion",
    "dept": "MUSIC",
    "num": "319I",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Majors: Harpsichord",
    "dept": "MUSIC",
    "num": "319K",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble",
    "dept": "MUSIC",
    "num": "321",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in chamber music ensembles that demand high proficiency.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble: Voice",
    "dept": "MUSIC",
    "num": "321A",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in ensembles that demand high proficiency. Open to a limited number of undergraduate and graduate students.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble: Piano",
    "dept": "MUSIC",
    "num": "321B",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in ensembles that demand high proficiency. Open to a limited number of undergraduate and graduate students.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble: Organ",
    "dept": "MUSIC",
    "num": "321C",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in ensembles that demand high proficiency. Open to a limited number of undergraduate and graduate students.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble: Strings",
    "dept": "MUSIC",
    "num": "321D",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in ensembles that demand high proficiency. Open to a limited number of undergraduate and graduate students.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble: Woodwinds",
    "dept": "MUSIC",
    "num": "321F",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in ensembles that demand high proficiency. Open to a limited number of undergraduate and graduate students.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble: Brass",
    "dept": "MUSIC",
    "num": "321G",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in ensembles that demand high proficiency. Open to a limited number of undergraduate and graduate students.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble: Percussion",
    "dept": "MUSIC",
    "num": "321I",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in ensembles that demand high proficiency. Open to a limited number of undergraduate and graduate students.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ensemble: Mixed instruments/voice",
    "dept": "MUSIC",
    "num": "321J",
    "desc": "Prereq: Advanced proficiency and performing ability, permission of instructor\nPerformance in ensembles that demand high proficiency. Open to a limited number of undergraduate and graduate students.\n",
    "credits": "1"
  },
  {
    "course_name": "English and Italian Diction for Singing",
    "dept": "MUSIC",
    "num": "324",
    "desc": "Prereq: Credit or enrollment in MUSIC 118A or MUSIC 119A\nThe international phonetic alphabet and its application to correct pronunciation of English and Italian in singing.\n",
    "credits": "2"
  },
  {
    "course_name": "French and German Diction for Singing",
    "dept": "MUSIC",
    "num": "325",
    "desc": "Prereq: Credit or enrollment in MUSIC 118A or MUSIC 119A\nThe international phonetic alphabet and its application to correct pronunciation of French and German in singing.\n",
    "credits": "2"
  },
  {
    "course_name": "Functional Piano",
    "dept": "MUSIC",
    "num": "327",
    "desc": "\nEmphasis on sight reading, three and four-part score reading, improvisation, accompanying, and advanced harmonization.\n",
    "credits": "2"
  },
  {
    "course_name": "Functional Piano: Keyboard majors.",
    "dept": "MUSIC",
    "num": "327A",
    "desc": "Prereq: MUSIC 228 or permission of instructor\nEmphasis on sight reading, three and four-part score reading, improvisation, accompanying, and advanced harmonization.\n",
    "credits": "2"
  },
  {
    "course_name": "Functional Piano: Voice Majors",
    "dept": "MUSIC",
    "num": "327B",
    "desc": "Prereq: MUSIC 228 or permission of instructor\nEmphasis on sight reading, three and four-part score reading, improvisation, accompanying, and advanced harmonization.\n",
    "credits": "2"
  },
  {
    "course_name": "Music Theory III",
    "dept": "MUSIC",
    "num": "334",
    "desc": "Prereq: MUSIC 234; concurrent enrollment in 335 recommended\nCharacteristics of common practice chromatic harmony and analytical techniques addressing stylistic practices of music since 1900. Application of these materials to analysis, part writing, and composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Aural Theory III",
    "dept": "MUSIC",
    "num": "335",
    "desc": "Prereq: MUSIC 235; credit or enrollment in 334\nDevelopment of sight singing, ear training, and related musical skills with emphasis on melodic, harmonic and rhythmic materials from the eighteenth and nineteenth centuries.\n",
    "credits": "1"
  },
  {
    "course_name": "Music Theory IV",
    "dept": "MUSIC",
    "num": "344",
    "desc": "Prereq: MUSIC 334; concurrent enrollment in MUSIC 345 recommended\nImprovisation on existing materials in a variety of styles and arranging for vocal and instrumental ensembles while learning the characteristics of each instrument including voice.\n",
    "credits": "3"
  },
  {
    "course_name": "Aural Theory IV",
    "dept": "MUSIC",
    "num": "345",
    "desc": "Prereq: MUSIC 335; credit or enrollment in MUSIC 344\nDevelopment of sight singing, ear training, and related musical skills with emphasis on melodic, harmonic and rhythmic materials from the nineteenth and twentieth centuries.\n",
    "credits": "1"
  },
  {
    "course_name": "Computer Music Programming Design",
    "dept": "MUSIC",
    "num": "346",
    "desc": "Prereq: MUSIC 246 or permission of instructor\nProgramming and interface design for creative musical applications. Includes computer generation of music data, advanced MIDI data processing, practical projects in musical composition and performance using a visual programming language.\n",
    "credits": "3"
  },
  {
    "course_name": "Instrumental Techniques: Strings",
    "dept": "MUSIC",
    "num": "350",
    "desc": "Prereq: Instrumental music education majors: concurrent enrollment in MUSIC 358B or MUSIC 358C. Limited to music majors\nTechniques and skills required for teaching of instruments. Examination of materials for school use. Intended for instrumental     music education students.\n",
    "credits": "1"
  },
  {
    "course_name": "Instrumental Techniques: Clarinet, Flute, Saxophone",
    "dept": "MUSIC",
    "num": "351",
    "desc": "Prereq: Instrumental music education majors: concurrent enrollment in MUSIC 358B or MUSIC 358C. Limited to music majors\nTechniques and skills required for teaching of instruments. Examination of materials for school use. Intended for instrumental     music education students.\n",
    "credits": "2"
  },
  {
    "course_name": "Instrumental Techniques: Oboe, Bassoon",
    "dept": "MUSIC",
    "num": "352",
    "desc": "Prereq: MUSIC 351 or permission of instructor. Instrumental music education majors: concurrent enrollment in MUSIC 358B or MUSIC 358C. Limited to music majors\nTechniques and skills required for teaching of instruments. Examination of materials for school use.   Intended for instrumental   music education students.\n",
    "credits": "1"
  },
  {
    "course_name": "Instrumental Techniques: Trumpet, Horn",
    "dept": "MUSIC",
    "num": "353",
    "desc": "Prereq: Instrumental music education majors: concurrent enrollment in MUSIC 358B or MUSIC 358C. Limited to music majors\nTechniques and skills required for teaching of instruments. Examination of materials for school use. Intended for instrumental     music education students.\n",
    "credits": "1"
  },
  {
    "course_name": "Instrumental Techniques: Trombone, Baritone, Tuba",
    "dept": "MUSIC",
    "num": "354",
    "desc": "Prereq: MUSIC 353 or permission of instructor. Instrumental music education majors: concurrent enrollment in MUSIC 358B or MUSIC 358C. Limited to music majors\nTechniques and skills required for teaching of instruments. Examination of materials for school use. Intended for instrumental     music education students.\n",
    "credits": "1"
  },
  {
    "course_name": "Instrumental Techniques: Percussion",
    "dept": "MUSIC",
    "num": "355",
    "desc": "Prereq: Instrumental music education majors: concurrent enrollment in MUSIC 358B or MUSIC 358C. Limited to music majors\nTechniques and skills required to teach percussion instruments in the schools. Techniques for performing and teaching snare drum,     keyboard percussion instruments, timpani, band and orchestral hand instruments, drum set, and Latin percussion. Intended for     instrumental music education students.\n",
    "credits": "1"
  },
  {
    "course_name": "Lab Ensemble",
    "dept": "MUSIC",
    "num": "358",
    "desc": "\nReview and selection of appropriate literature for ensembles of differing levels and abilities; conducting and rehearsal experience. Intended for music education students.\n",
    "credits": "R"
  },
  {
    "course_name": "Lab Ensemble: Choral",
    "dept": "MUSIC",
    "num": "358A",
    "desc": "\nSight singing, conducting, and accompanying experience in conjunction with 362A. Required of all vocal music education majors every semester offered.\n",
    "credits": "R"
  },
  {
    "course_name": "Lab Ensemble: Instrumental",
    "dept": "MUSIC",
    "num": "358B",
    "desc": "\nPerformance on secondary instruments. Includes experiences with wind instruments and percussion techniques. Required of all instrumental music education majors. Offered on a satisfactory-fail basis only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Lab Ensemble: Orchestral",
    "dept": "MUSIC",
    "num": "358C",
    "desc": "\nPerformance on secondary instruments. Includes experiences with string techniques. Required of all instrumental music education majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Voice Pedagogy",
    "dept": "MUSIC",
    "num": "360",
    "desc": "Prereq: MUSIC 319A or vocal proficiency examination\nPhysical, acoustical, and musical properties of the vocal instrument, including a survey of important texts and articles on singing and   voice production.\n",
    "credits": "2"
  },
  {
    "course_name": "Conducting I",
    "dept": "MUSIC",
    "num": "361",
    "desc": "Prereq: MUSIC 234, MUSIC 235, Music major status or permission of instructor\nIntroduction to conducting; score reading and analysis. Conveying musical ideas through appropriate gestures. Leadership role of the conductor.\n",
    "credits": "2"
  },
  {
    "course_name": "Conducting II",
    "dept": "MUSIC",
    "num": "362",
    "desc": "\n",
    "credits": "2"
  },
  {
    "course_name": "Conducting II: Choral Conducting Techniques",
    "dept": "MUSIC",
    "num": "362A",
    "desc": "Prereq: Music major status or permission of instructor; MUSIC 361; concurrent enrollment in MUSIC 358A and MUSIC 141, MUSIC 151, or MUSIC 161.\nAdvanced baton technique, score preparation and interpretation of choral repertoire.\n",
    "credits": "2"
  },
  {
    "course_name": "Conducting II: Instrumental Conducting Techniques",
    "dept": "MUSIC",
    "num": "362B",
    "desc": "Prereq: Music major status or permission of instructor; MUSIC 361; concurrent enrollment in MUSIC 358B\nAdvanced baton technique. Score preparation. Specific problems of large instrumental ensembles.\n",
    "credits": "2"
  },
  {
    "course_name": "Methods of Music Education",
    "dept": "MUSIC",
    "num": "366",
    "desc": "Prereq: Concurrent enrollment (1 cr.) in MUSIC 480K and SP ED 401; MUSIC 266 and admission into teacher education.\nMusic education strategies and materials including development of appropriate objectives and plans for general music classes utilizing traditional and multicultural musics, evaluating musical learning; overview of Orff Schulwerk, Kodaly, and Dalcroze approaches; music in special education; required teaching in lab settings and observations in area schools.\n",
    "credits": "2"
  },
  {
    "course_name": "Choral Literature",
    "dept": "MUSIC",
    "num": "367",
    "desc": "Prereq: MUSIC 361 recommended\nOverview of choral repertoire from the sixteenth century to the present, including accessible works for the young conductor.\n",
    "credits": "2"
  },
  {
    "course_name": "Marching Band and Jazz Ensemble Techniques",
    "dept": "MUSIC",
    "num": "368",
    "desc": "Prereq: Credit or enrollment in MUSIC 362B recommended\nTechniques and materials for teaching marching band in the high school; philosophy, computer assisted drill design, music analysis, band set up, and other related skills. Jazz style, articulation, phrasing, materials and teaching techniques for secondary school jazz ensembles.\n",
    "credits": "2"
  },
  {
    "course_name": "String Pedagogy",
    "dept": "MUSIC",
    "num": "369",
    "desc": "Prereq: MUSIC 319D or MUSIC 350\nPractical examination of current teaching methods and materials. Intended for string instrumental music education majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Instrumental Methods for Vocalists",
    "dept": "MUSIC",
    "num": "374",
    "desc": "Prereq: Music major status, MUSIC 280K, MUSIC 266 and admission into teacher education.\nTechniques and skills required to teach instrumental music in K-12 schools. Introduction of instruments, score reading and transposition, rehearsal techniques, literature, resources and other related skills. Intended for vocal music education majors and required for Iowa teaching license.\n",
    "credits": "1"
  },
  {
    "course_name": "Choral Methods for Instrumentalists",
    "dept": "MUSIC",
    "num": "375",
    "desc": "Prereq: Music major status, MUSIC 280K, MUSIC 266 and admission into teacher education.\nTechniques and skills required to teach vocal/choral music in K-12 schools. Vocal production and health, rehearsal techniques, repertoire, resources and other related skills. Intended for instrumental music education majors and required for Iowa teaching license.\n",
    "credits": "1"
  },
  {
    "course_name": "History of Music I",
    "dept": "MUSIC",
    "num": "383",
    "desc": "Prereq: MUSIC 120; music major status or permission of instructor\nHistory of the stylistic and cultural development of music: Middle Ages through Baroque.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Music II",
    "dept": "MUSIC",
    "num": "384",
    "desc": "Prereq: MUSIC 383; music major status or permission of instructor\nHistory of the stylistic and cultural development of music: Classical through contemporary music.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music",
    "dept": "MUSIC",
    "num": "415",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Voice",
    "dept": "MUSIC",
    "num": "415A",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Piano",
    "dept": "MUSIC",
    "num": "415B",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Organ",
    "dept": "MUSIC",
    "num": "415C",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Strings",
    "dept": "MUSIC",
    "num": "415D",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Carillon",
    "dept": "MUSIC",
    "num": "415E",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Woodwinds",
    "dept": "MUSIC",
    "num": "415F",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Brass",
    "dept": "MUSIC",
    "num": "415G",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Percussion",
    "dept": "MUSIC",
    "num": "415I",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Literature and Pedagogy in Applied Music: Jazz Pedagogy and Performance",
    "dept": "MUSIC",
    "num": "415J",
    "desc": "Prereq: Permission of instructor\nIncludes experience in technology relative to the particular discipline.\n",
    "credits": "1"
  },
  {
    "course_name": "Student Teaching",
    "dept": "MUSIC",
    "num": "417",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "8"
  },
  {
    "course_name": "Student Teaching: Music-Elementary",
    "dept": "MUSIC",
    "num": "417R",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Music-Secondary",
    "dept": "MUSIC",
    "num": "417S",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Applied Music: Majors",
    "dept": "MUSIC",
    "num": "419",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\nApplied music for music majors.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Voice",
    "dept": "MUSIC",
    "num": "419A",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Piano",
    "dept": "MUSIC",
    "num": "419B",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Organ",
    "dept": "MUSIC",
    "num": "419C",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Strings",
    "dept": "MUSIC",
    "num": "419D",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Carillon",
    "dept": "MUSIC",
    "num": "419E",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Woodwinds",
    "dept": "MUSIC",
    "num": "419F",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Brass",
    "dept": "MUSIC",
    "num": "419G",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Percussion",
    "dept": "MUSIC",
    "num": "419I",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Music: Harpsichord",
    "dept": "MUSIC",
    "num": "419K",
    "desc": "Prereq: Audition, permission of instructor; restricted to music majors\n(.5-2) for 1 cr. (1-2) for 2-3 cr. Minimum weekly practice of 5 hours per credit is expected. Weekly seminar required.\n",
    "credits": "1"
  },
  {
    "course_name": "Junior/Senior Recital",
    "dept": "MUSIC",
    "num": "420",
    "desc": "Prereq: Advanced performing ability, permission of instructor, concurrent registration in MUSIC 319 or 419.\nPerformance of advanced repertory in a public concert. Preparation of program notes.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Applied Theory: Improvising and Arranging",
    "dept": "MUSIC",
    "num": "434",
    "desc": "Prereq: MUSIC 344 and MUSIC 345\nPractical uses for music theory. Emphasis on arranging for vocal and instrumental ensembles and creating improvisations on existing materials in a variety of styles.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Music Theory",
    "dept": "MUSIC",
    "num": "440",
    "desc": "Prereq: MUSIC 344, MUSIC 345\nVarious topics in music theory including analysis, counterpoint, arranging, pedagogy, and psychology of music. Content will vary.   Contact the Department of Music for the current year offering.\n",
    "credits": "3"
  },
  {
    "course_name": "Sound Synthesis Design for Electronic Music",
    "dept": "MUSIC",
    "num": "446",
    "desc": "Prereq: MUSIC 246 or permission of instructor\nDigital sound synthesis structures for creative musical applications. Includes modular sound synthesis techniques, software synthesizer design, and practical projects in electronic music composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Instrumental Administration, Materials, and Methods",
    "dept": "MUSIC",
    "num": "464",
    "desc": "Prereq: Credit or enrollment in MUSIC 362B recommended\nInstructional materials and methods appropriate for teaching instrumental music in elementary, middle school, and high school   music programs. Required observations in area schools. Intended for instrumental music education students.\n",
    "credits": "2"
  },
  {
    "course_name": "Choral Materials and Methods",
    "dept": "MUSIC",
    "num": "465",
    "desc": "Prereq: Concurrent enrollment in MUSIC 358A and MUSIC 141, MUSIC 151, or MUSIC 161\nInstructional materials and methods appropriate for teaching choral music in the secondary school. Emphasis on pedagogy and   rehearsal techniques. Required observations in area schools. Intended for vocal music education students.\n",
    "credits": "2"
  },
  {
    "course_name": "Program Development and Evaluation in Music Education",
    "dept": "MUSIC",
    "num": "466",
    "desc": "Prereq: Continuation Examination passed; MUSIC 362, MUSIC 366, concurrent enrollment (1 cr.) in MUSIC 480K\nDeveloping a rationale for music education; music program development; evaluation of music curricula, programs and facilities;   professional growth of the teacher; preparation for student teaching and the job market. Required observations in area schools.\n",
    "credits": "2"
  },
  {
    "course_name": "History of American Music",
    "dept": "MUSIC",
    "num": "472",
    "desc": "Prereq: Ability to read music; 9 credits from music, American literature, American history, art history\nHistory and development of the sacred and secular music in North America from approximately 1600 to the   present, exploring the   diverse cultural backgrounds that have contributed to the variety of contemporary musical styles.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Music of the Baroque and  Classical Eras",
    "dept": "MUSIC",
    "num": "473",
    "desc": "Prereq: MUSIC 383, MUSIC 384\nDetailed topic-based study of major composers and compositions from 1600 to the present with a strong research component.\n",
    "credits": "3"
  },
  {
    "course_name": "Music of the Romantic Era",
    "dept": "MUSIC",
    "num": "475",
    "desc": "Prereq: MUSIC 383, MUSIC 384\nOffered F. 2012. Detailed survey of instrumental, vocal, choral, and keyboard music from 1825 to 1910.\n",
    "credits": "3"
  },
  {
    "course_name": "Music of the Twentieth Century",
    "dept": "MUSIC",
    "num": "476",
    "desc": "Prereq: MUSIC 383, MUSIC 384\nOffered S 2013. Detailed survey of instrumental, vocal, choral, and keyboard music from 1900 to the present.\n",
    "credits": "3"
  },
  {
    "course_name": "Pre-Student Teaching Experience III",
    "dept": "MUSIC",
    "num": "480",
    "desc": "Prereq: Admission to Teacher Education\nObservation and participation in a variety of school settings after admission to the teacher education program. Permission of area coordinator required prior to enrollment. (S/F grading may be used in some offerings of some sections.).\n",
    "credits": "0"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: Music",
    "dept": "MUSIC",
    "num": "480K",
    "desc": "Prereq: Admission to teacher education\nParticipation in a K-12 school setting. Permission of Music coordinator required prior to enrollment. Clinical Experience Level 2.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "MUSIC",
    "num": "490",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Education",
    "dept": "MUSIC",
    "num": "490A",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\nIndependent Study in Music.\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Theory",
    "dept": "MUSIC",
    "num": "490B",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Composition",
    "dept": "MUSIC",
    "num": "490C",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: History",
    "dept": "MUSIC",
    "num": "490D",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Literature",
    "dept": "MUSIC",
    "num": "490E",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Applied Music",
    "dept": "MUSIC",
    "num": "490F",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Conducting",
    "dept": "MUSIC",
    "num": "490G",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "MUSIC",
    "num": "490H",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Electronic Music",
    "dept": "MUSIC",
    "num": "490I",
    "desc": "Prereq: Permission of instructor; 12 credits in music, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Music-Elementary",
    "dept": "MUSIC",
    "num": "517R",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Student Teaching: Music-Secondary",
    "dept": "MUSIC",
    "num": "517S",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics",
    "dept": "MUSIC",
    "num": "590",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Education",
    "dept": "MUSIC",
    "num": "590A",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Theory",
    "dept": "MUSIC",
    "num": "590B",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Composition",
    "dept": "MUSIC",
    "num": "590C",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: History",
    "dept": "MUSIC",
    "num": "590D",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Literature",
    "dept": "MUSIC",
    "num": "590E",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Applied Music",
    "dept": "MUSIC",
    "num": "590F",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Conducting",
    "dept": "MUSIC",
    "num": "590G",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Electronic Music",
    "dept": "MUSIC",
    "num": "590I",
    "desc": "Prereq: Permission of instructor, approval of department head\n",
    "credits": "arr"
  },
  {
    "course_name": "Practical Work Experience",
    "dept": "NREM",
    "num": "104",
    "desc": "\nThree months of relevant work experience in natural resources, animal ecology, or forestry. Study at a summer biological station may be applicable. See adviser for specific requirements and approval process.\n",
    "credits": "R"
  },
  {
    "course_name": "Orientation in Natural Resource Ecology and Management",
    "dept": "NREM",
    "num": "110",
    "desc": "\nOrientation to the University and to the Department of Natural Resource Ecology and Management.  Discussion of departmental learning outcomes, strategies for academic success and academic planning.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "NREM Transitions Learning Community Seminar",
    "dept": "NREM",
    "num": "111",
    "desc": "\nEnrollment limited to members of the NREM Transitions Learning Community.  Designed to assist new transfer students and continuing sophomore students with their transition to the academic expectations and professional development aspects of the natural resource program.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Renewable Resources",
    "dept": "NREM",
    "num": "120",
    "desc": "\nOverview of soil, water, plants, and animals as renewable natural resources in an ecosystem context. History and organization of resource management. Concepts of integrated resource management.\n",
    "credits": "3"
  },
  {
    "course_name": "Natural Resources and Agriculture",
    "dept": "NREM",
    "num": "130",
    "desc": "\nSurvey of the ecology and management of fish, forest, and wildlife resources in areas of intensive agriculture, with emphasis on Iowa. Conservation and management practices for private agricultural lands. Designed for nonmajors.\n",
    "credits": "3"
  },
  {
    "course_name": "Artistry in Wood",
    "dept": "NREM",
    "num": "181",
    "desc": "\nA survey of the artistry of wood as appreciated in spatial scale from microscopic anatomy to engineered wood structures. Anatomical and physical properties that render wood as a medium for artistic expression. The works of local artists, designers and engineers will be featured. The University Museums collection and Art on Campus will be explored.\n",
    "credits": "1"
  },
  {
    "course_name": "Natural Resource Management under the North American Model of Conservation",
    "dept": "NREM",
    "num": "207",
    "desc": "\nIntroduction to North American model of conservation, current funding for natural resource management, role of hunting and angling in the North American model, critique and refinement of the model for the 21st century, and introduction to natural resource leadership, and outdoor skills and recreation.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Careers in Natural Resources",
    "dept": "NREM",
    "num": "211",
    "desc": "Prereq: Sophomore classification\nCareer planning exploration in natural resources.  Discussion of the job application process, including techniques for successful interviewing and development of an effective resume.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Problem Solving in Natural Resources",
    "dept": "NREM",
    "num": "240",
    "desc": "Prereq: STAT 101 or STAT 104, or permission from the instructor\nApplied quantitative problem-solving skills for natural resource management. Focus on group and individual exercises, with practical problems in geography, hydrology, forestry and ecology. Laboratory includes field data collection and computer data processing and modeling.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations in Natural Resource Policy and History",
    "dept": "NREM",
    "num": "270",
    "desc": "\nThe development of natural resource conservation philosophy and policy from the Colonial Era to the present. North American wildlife, forestry, and environmental policy; national parks and other protected lands; federal and state agencies.  Relationship to cultural contexts, including urban reform and American planning movement. Discussion of common pool resources, public and private lands.\n",
    "credits": "3"
  },
  {
    "course_name": "Natural Resource Ecology and Soils",
    "dept": "NREM",
    "num": "301",
    "desc": "Prereq: BIOL 211, BIOL 211L; FOR 201 or a second course in biology\nEffects of environmental factors on ecosystem structure and function using forest, prairie and agricultural ecosystems as models. Special emphasis is given to soil-forming factors and the role of soil in nutrient and water cycling and ecosystem dynamics.  Additional emphasis is given to human influences on natural ecosystems and the role of perennial plant communities in agricultural landscapes.\n",
    "credits": "4"
  },
  {
    "course_name": "Internship",
    "dept": "NREM",
    "num": "303",
    "desc": "Prereq: Permission of department mentor and sophomore standing\nPlacement with county conservation boards, camps, zoos, parks, etc., for experience as interpreters, rangers, and technicians.\n",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Internships",
    "dept": "NREM",
    "num": "303I",
    "desc": "Prereq: Permission of instructor and sophomore standing\nPlacement with county conservation boards, camps, parks, etc. for experience as interpreters, rangers, and technicians.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "NREM",
    "num": "305",
    "desc": "Prereq: Permission of instructor\nCurrent topics in natural resources or related issues.\n",
    "credits": "1"
  },
  {
    "course_name": "Genetics for Natural Resource Managers.",
    "dept": "NREM",
    "num": "315",
    "desc": "Prereq: Prereq: BIOL 211 and 212.\nIntroduction into how genetic techniques and technologies can aid the management of the earth's biotic resources. Topics include an overview of DNA structure, function and inheritance; tools and techniques for measuring genetic diversity; genetic management of wild and captive populations: DNA forensics as management tool. The goal of this course is to prepare managers/biologists to interpret genetic data as they relate to natural resource conservation.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Interpretation",
    "dept": "NREM",
    "num": "330",
    "desc": "Prereq: 6 credits in biological sciences\nHistory, objectives, forms, and techniques of interpretation in the settings of county, state, national parks, and zoos. Principles of effective communication as they apply to natural resource fields including wildlife management, forestry, and wildlife rehabilitation. Planning and use of effective communications and outreach campaigns to manage and conserve natural resources.\n",
    "credits": "3"
  },
  {
    "course_name": "Fisheries Techniques",
    "dept": "NREM",
    "num": "333",
    "desc": "Prereq: BIOL 212\nIntroduction to techniques used in the collection and interpretation of fish population data in the field and in the lab.  Course objectives include an understanding of population survey methodology and improving student critical thinking and teamwork skills. Laboratory focuses on field trips and hands-on sampling experience.\n",
    "credits": "2"
  },
  {
    "course_name": "Natural Resource Photogrammetry and Geographic Information Systems",
    "dept": "NREM",
    "num": "345",
    "desc": "Prereq: Junior classification\nMeasurement and interpretation of aerial photos in resource management. Introduction to Geographic Information Systems (GIS) using ArcGIS including digitizing, development and query of attribute tables, georeferencing, and use of multiple GIS layers in simple spatial analyses.\n",
    "credits": "3"
  },
  {
    "course_name": "Midwestern Prairie Plants",
    "dept": "NREM",
    "num": "357",
    "desc": "\nOffered 1st half semester only.  Survey of the major plant families, genera, and representative species of Midwestern prairies with emphasis on plant identification. Prairie management for multiple species of plants and wildlife.\n",
    "credits": "1"
  },
  {
    "course_name": "Forest Herbaceous Layer: Ecology and Identification.",
    "dept": "NREM",
    "num": "358",
    "desc": "Prereq: BIOL 212\nSurvey of the major plant families, general, and representative species of the forest herbaceous layer. Functional ecology and restoration.\n",
    "credits": "1"
  },
  {
    "course_name": "Field Ecology Research and Teaching",
    "dept": "NREM",
    "num": "380",
    "desc": "Prereq: Completion or current enrollment in A ECL/BIOL/ENSCI 312 or NREM 301; or eligibility for admission into Elementary Education program\nStudents work in teams to conduct ecological research projects at a local field site, and develop related teaching modules/lesson plans.  Research and teaching activity objectives, methods, and results are shared with diverse audiences as presentations, written reports, and web-based documents, and used to engage K-12 students and community members via field days and visits to schools and other institutions.\n",
    "credits": "3"
  },
  {
    "course_name": "Natural Resource Policy",
    "dept": "NREM",
    "num": "385",
    "desc": "Prereq: Graduate classification or permission of instructor\nDevelopment, theory and practice of natural resource policy. Integrative approach with topical policy studies in North American wildlife, forestry, and water.  Policy formation, the role of science, introduction to federal law compliance.\n",
    "credits": "3"
  },
  {
    "course_name": "Fire Ecology and Management",
    "dept": "NREM",
    "num": "390",
    "desc": "\nCharacteristics and role of fire in forest ecosystems. Major topics covered include fuels, fire weather, fire behavior, fire danger rating systems, fire control, prescribed burning, and fire dynamics in major ecosystem types.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Hydrology",
    "dept": "NREM",
    "num": "402",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nExamination of watersheds as systems, emphasizing the surface components of the hydrologic cycle.  Combines qualitative understanding of hydrological processes and uncertainty with quantitative representation.  Laboratory emphasizes field investigation and measurement of watershed processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Watershed Management",
    "dept": "NREM",
    "num": "407",
    "desc": "Prereq: A course in general biology\nManaging human impacts on the hydrologic cycle. Field and watershed level best management practices for modifying the impacts on water quality, quantity and timing are discussed. Field project includes developing a management plan using landscape buffers.\n",
    "credits": "4"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "NREM",
    "num": "408I",
    "desc": "Prereq: Courses in ecology, chemistry, and physics\nAnalysis of aquatic ecosystems; emphasis on basic ecological principles; ecological theories tested in the field; identification of common plants and animals.\n",
    "credits": "4"
  },
  {
    "course_name": "Integrating GPS and GIS for Natural Resource Management",
    "dept": "NREM",
    "num": "446",
    "desc": "Prereq: 12 credits in student's major at 300 level or above, NREM 345 or equivalent experience with ArcGIS\nEmphasis on the use of GPS as a data collection tool for GIS. Basic theory of GPS. Use of Global Positioning System technology for spatial data collection and navigation. Post-processing and real-time correction of GPS data. GPS data transfer to GIS for mapping applications. Use of GIS to construct waypoints for use in GPS navigation.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Management",
    "dept": "NREM",
    "num": "452",
    "desc": "Prereq: Senior classification, and NREM 120 or its equivalent\nPrinciples of planning, regulating, and decision-making associated with public and private lands, with consideration of forest, grassland, wetland, and freshwater aquatic ecosystems.  Integrated natural resources management within ecological, social, economic and policy constraints.\n",
    "credits": "3"
  },
  {
    "course_name": "Controversies in Natural  Resource Management",
    "dept": "NREM",
    "num": "460",
    "desc": "Prereq: NREM 120, and A ECL 312 or NREM 301, and Junior classification\nAnalysis of controversial natural resource issues using a case approach that considers uncertainty and adequacy of information and scientific understanding. Ecological, social, political, economic, and ethical implications of issues will be analyzed.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Change and Conservation",
    "dept": "NREM",
    "num": "465",
    "desc": "Prereq: L A 202\nExploration of issues in landscape ecology and conservation biology relevant to landscape change, design, and planning. Examination of foundational principles and their applications across a continuum of land uses, from wilderness to urban areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Service Management",
    "dept": "NREM",
    "num": "466",
    "desc": "Prereq: permission of instructor\nLand use and conservation techniques for improving ecosystem services including: pollination of crops, biological control of pests, prevention of erosion and water quality improvement.\n",
    "credits": "3"
  },
  {
    "course_name": "Agroforestry Systems; Local and Global Perspectives",
    "dept": "NREM",
    "num": "471",
    "desc": "Prereq: 6 credits in biological science at 300 level or above\nConcepts of sustainable land use, agroecological dynamics, and component interactions of agroforestry systems. Agroforestry systems in temperate and tropical regions. Design and evaluation techniques for agroforestry systems. Ecological, socioeconomic and political aspects of agroforestry.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Seminar",
    "dept": "NREM",
    "num": "485",
    "desc": "Prereq: Junior or Senior classification in Animal Ecology or Forestry majors (instructor may grant permission for students in other majors to register for course)\nWeekly seminars on current research topics in natural resource ecology and management. Style and best practice in oral research communication. Skills and principles for evaluating research merit and quality of technical communication.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Survey of Remote Sensing Technologies",
    "dept": "NREM",
    "num": "489",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nElectromagnetic-radiation principles, active and passive sensors, multispectral and hyperspectral sensors, imaging radar, SAR, thermal imaging, lidar. Examples of applications. Also offered online S.\n",
    "credits": "3"
  },
  {
    "course_name": "Satellite Remote Sensing Laboratory",
    "dept": "NREM",
    "num": "489L",
    "desc": "Prereq: Completion or concurrent enrollment in MTEOR/GEOL/NREM/EE 489/589\nProcessing and analysis of satellite sensor data (optical and radar). Provides practical applications in an environmental context.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "NREM",
    "num": "490",
    "desc": "Prereq: Junior or senior classification,  permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Animal Ecology",
    "dept": "NREM",
    "num": "490A",
    "desc": "Prereq: Junior or senior classification,  permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Forestry",
    "dept": "NREM",
    "num": "490B",
    "desc": "Prereq: Junior or senior classification,  permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Entrepreneurship",
    "dept": "NREM",
    "num": "490E",
    "desc": "Prereq: Junior or senior classification,  permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors Program",
    "dept": "NREM",
    "num": "490H",
    "desc": "Prereq: Junior or senior classification,  permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Iowa Lakeside Laboratory",
    "dept": "NREM",
    "num": "490I",
    "desc": "Prereq: 8 credits in biology and permission of instructor\nResearch opportunities for undergraduate students in the biological sciences.\n  No more than 9 credits in Biol 490 may be counted toward graduation and of those, only 6 credits may be applied to the major.",
    "credits": "1"
  },
  {
    "course_name": "Travel Course",
    "dept": "NREM",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study ecological and management topics in varied environments. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "Travel Course: International",
    "dept": "NREM",
    "num": "496A",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study ecological and management topics in varied environments. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Travel Course: Domestic",
    "dept": "NREM",
    "num": "496B",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study ecological and management topics in varied environments. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "NREM",
    "num": "498",
    "desc": "Prereq: Permission of departmental chair\nRequired of all cooperative education students. Students must register prior to commencing each work period.\n",
    "credits": "1"
  },
  {
    "course_name": "Watershed Hydrology",
    "dept": "NREM",
    "num": "502",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering; junior standing\nExamination of watersheds as systems, emphasizing the surface components of the hydrologic cycle.  Combines qualitative understanding of hydrological processes and uncertainty with quantitative representation.  Laboratory emphasizes field investigation and measurement of watershed processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Forest Landscapes, Wildlife, and Silviculture",
    "dept": "NREM",
    "num": "504",
    "desc": "Prereq: Permission of instructor\nDesired forest habitat conditions for fish and wildlife. Silvicultural approaches to protecting/improving such habitats. Focus on key forest elements related to animal species, groups and overall diversity. The lab focuses on team observations and discussions of diverse habitats including one weekend field trip.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar",
    "dept": "NREM",
    "num": "505",
    "desc": "Prereq: Permission of instructor or graduate classification\nCurrent topics in natural resources research and management.\n",
    "credits": "1"
  },
  {
    "course_name": "Watershed Management",
    "dept": "NREM",
    "num": "507",
    "desc": "Prereq: A course in general biology\nManaging human impacts on the hydrologic cycle. Field and watershed level best management practices for modifying the impacts on water quality, quantity and timing are discussed. Field project includes developing a management plan using landscape buffers.\n",
    "credits": "4"
  },
  {
    "course_name": "Aquatic Ecology",
    "dept": "NREM",
    "num": "508I",
    "desc": "Prereq: Courses in ecology, chemistry, and physics\nAnalysis of aquatic ecosystems; emphasis on basic ecological principles; ecological theories tested in the field; identification of common plants and animals.\n",
    "credits": "4"
  },
  {
    "course_name": "Erosion and Sediment Transport",
    "dept": "NREM",
    "num": "533",
    "desc": "Prereq: C E 372 or GEOL/ENSCI/MTEOR 402, MATH 166 or equivalent\nSoil erosion processes, soil loss equations and their application to conservation planning, sediment properties, initiation of sediment motion and over land flow, flow in alluvial channels and theory of sediment transport, channel stability, reservoir sedimentation, wind erosion, BMPs for controlling erosion.\n",
    "credits": "3"
  },
  {
    "course_name": "Restoration Ecology",
    "dept": "NREM",
    "num": "535",
    "desc": "Prereq: BIOL 366 or BIOL 474 or graduate standing\nTheory and practice of restoring animal and plant diversity, structure and function of disturbed ecosystems. Restored freshwater wetlands, forests, prairies and reintroduced species populations will be used as case studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "NREM",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "NREM",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "NREM",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "NREM",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "NREM",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "NREM",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "NREM",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "NREM",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Integrating GPS and GIS for Natural Resource Management",
    "dept": "NREM",
    "num": "546",
    "desc": "Prereq: 12 credits in student's major at 300 level or above, NREM 345 or equivalent experience with ArcGIS\nEmphasis on the use of GPS as a data collection tool for GIS. Basic theory of GPS. Use of Global Positioning System technology for spatial data collection and navigation. Post-processing and real-time correction of GPS data. GPS data transfer to GIS for mapping applications. Use of GIS to construct waypoints for use in GPS navigation.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Management",
    "dept": "NREM",
    "num": "552",
    "desc": "Prereq: Senior classification, and NREM 120 or its equivalent\nPrinciples of planning, regulating, and decision-making associated with public and private lands, with consideration of forest, grassland, wetland, and freshwater aquatic ecosystems.  Integrated natural resources management within ecological, social, economic and policy constraints.\n",
    "credits": "3"
  },
  {
    "course_name": "Landscape Change and Conservation",
    "dept": "NREM",
    "num": "565",
    "desc": "Prereq: L A 202\nExploration of issues in landscape ecology and conservation biology relevant to landscape change, design, and planning. Examination of foundational principles and their applications across a continuum of land uses, from wilderness to urban areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecosystem Service Management",
    "dept": "NREM",
    "num": "566",
    "desc": "Prereq: permission of instructor\nLand use and conservation techniques for improving ecosystem services including: pollination of crops, biological control of pests, prevention of erosion and water quality improvement.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Decision-making in Natural Resource Allocation",
    "dept": "NREM",
    "num": "570",
    "desc": "Prereq: FOR 451 or two courses in economics\nAnalytical approach to economic aspects of forest resource management problems. Theory and application of economic decision-making criteria to traditional and modern forest resource management issues. Current problems in the allocation of forest resources.\n",
    "credits": "3"
  },
  {
    "course_name": "Agroforestry Systems",
    "dept": "NREM",
    "num": "571",
    "desc": "Prereq: 6 credits in biological science at 300 level or above\nConcepts of sustainable land use, agroecological dynamics, and component interactions of agroforestry systems. Agroforestry systems in temperate and tropical regions. Design and evaluation techniques for agroforestry systems. Ecological, socioeconomic and political aspects of agroforestry.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Orientation",
    "dept": "NREM",
    "num": "580",
    "desc": "Prereq: 20 credits in biological sciences and a course in statistics\nResearch design, proposal preparation, and technical writing.\n",
    "credits": "2"
  },
  {
    "course_name": "Natural Resource Policy",
    "dept": "NREM",
    "num": "585",
    "desc": "Prereq: Graduate classification or permission of instructor\nDevelopment, theory and practice of natural resource policy. Integrative approach with topical policy studies in North American wildlife, forestry, and water.  Policy formation, the role of science, introduction to federal law compliance.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey of Remote Sensing Technologies",
    "dept": "NREM",
    "num": "589",
    "desc": "Prereq: Four courses in physical or biological sciences or engineering\nElectromagnetic-radiation principles, active and passive sensors, multispectral and hyperspectral sensors, imaging radar, SAR, thermal imaging, lidar. Examples of applications. Also offered online S.\n",
    "credits": "3"
  },
  {
    "course_name": "Satellite Remote Sensing Laboratory",
    "dept": "NREM",
    "num": "589L",
    "desc": "Prereq: Completion or concurrent enrollment in MTEOR/GEOL/NREM/EE 489/589\nProcessing and analysis of satellite sensor data (optical and radar). Provides practical applications in an environmental context.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "NREM",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Animal Ecology",
    "dept": "NREM",
    "num": "590A",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Forestry",
    "dept": "NREM",
    "num": "590B",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop",
    "dept": "NREM",
    "num": "593",
    "desc": "Prereq: Graduate classification\n",
    "credits": "1"
  },
  {
    "course_name": "Travel Course",
    "dept": "NREM",
    "num": "596",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study ecological topics in varied environments. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "Travel Course: International",
    "dept": "NREM",
    "num": "596A",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study ecological and management topics in varied environments. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Travel Course: Domestic",
    "dept": "NREM",
    "num": "596B",
    "desc": "Prereq: Permission of instructor\nLimited enrollment. Extended field trips to study ecological and management topics in varied environments. Location and duration of trips will vary. Pre-trip sessions arranged. Trip expenses paid by students.\n",
    "credits": "1"
  },
  {
    "course_name": "Natural Resource Ecology and Management Teaching Practicum",
    "dept": "NREM",
    "num": "598",
    "desc": "Prereq: Graduate classification as M.S. candidate in a NREM major and permission of instructor.\nGraduate student experience in teaching.  Student must plan and present at least one unit of subject matter in a course or extension workshop.  Teaching practicum must be documented by the student and approved by the student’s POS committee.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "NREM",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar",
    "dept": "NREM",
    "num": "600",
    "desc": "\nCurrent topics in natural resources research and management.\n",
    "credits": "1"
  },
  {
    "course_name": "Natural Resource Ecology and Management Teaching Practicum",
    "dept": "NREM",
    "num": "698",
    "desc": "Prereq: Graduate classification as a Ph.D. candidate in a NREM major and permission of instructor.\nGraduate student experience in teaching.  Student must plan and present substantive subject matter for a minimum of three weeks in lecture and/or laboratory formats, or a series of extension seminars/workshops.  Teaching practicum must be documented by the student and approved by the student’s POS committee.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "NREM",
    "num": "699",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Naval Science",
    "dept": "N S",
    "num": "111",
    "desc": "\nIntroduction to the organization, regulations, and capabilities of the US Navy, with emphasis on mission and principal warfare components.\n",
    "credits": "3"
  },
  {
    "course_name": "Seapower and Maritime Affairs",
    "dept": "N S",
    "num": "212",
    "desc": "\nAn historical survey of sea power in terms of national domestic environments, foreign policy, and the evolution of maritime forces with trends in technology, doctrine, and tactics.  The student will develop an understanding of the role the US Navy has played in the nation's history, both in peace and war.  Naval events, forces and policies will be studied as elements in the shaping of the national consciousness and sense of purpose.  Course content will include the development of the concept of sea power, the role of various warfare components of the Navy, the implementation of sea power as an instrument of national policy, the evolution of naval tactics, and the influence of maritime affairs around the world.\n",
    "credits": "3"
  },
  {
    "course_name": "Leadership and Management",
    "dept": "N S",
    "num": "220",
    "desc": "\nIntroduction to the basic concepts of management and organization, their application to operations and personnel management. Experiential approach to learning principles of leadership and management by examining various management theories and their applications. Skills are developed in the areas of communication, counseling, control, direction, management, and leadership through active guided participation.\n",
    "credits": "3"
  },
  {
    "course_name": "Navigation",
    "dept": "N S",
    "num": "230",
    "desc": "Prereq: Sophomore classification\nStudy of the fundamentals of marine navigation used by ships at sea; includes practical exercises in piloting using visual and electronic means.  In-depth discussion of laws that govern conduct of vessels in national and international waters.  Course is supplemented with review and analysis of case studies involving actual navigation incidents.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Maneuver Warfare",
    "dept": "N S",
    "num": "240",
    "desc": "\nConcepts, definition, and need for maneuver warfare and expeditionary operations. US Marine Corps case studies of specific battles, development, and implementation. Structure, operation and capabilities of the Marine expeditionary unit, Marine air-ground task force and expeditionary strike group, Discussion and incorporation of leadership traits and principles.\n",
    "credits": "3"
  },
  {
    "course_name": "Naval Ship Systems I (Engineering)",
    "dept": "N S",
    "num": "320",
    "desc": "Prereq: PHYS 221, sophomore classification\nAn introduction to naval engineering with emphasis on the equipment and machinery involved in the conversion of energy for propulsion and other purposes aboard the major ship types of the U.S. fleet. Basic concepts of the theory and design of steam, gas turbine, diesel, and nuclear propulsion. Introduction to ship design, stability, hydrodynamic forces, compartmentalization, electrical and auxiliary systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Evolution of Warfare",
    "dept": "N S",
    "num": "321",
    "desc": "Prereq: Sophomore classification\nEvolution of warfare from 3500 B.C. to contemporary times; analysis of the impact of historical precedents on modern military thought and action; emphasis on the historical development of military tactics, strategy, and technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Naval Ship Systems II (Weapons)",
    "dept": "N S",
    "num": "330",
    "desc": "Prereq: PHYS 221, sophomore classification\nIntroduction to the theory and principles of operation of naval weapon systems. Included coverage of types of weapons and fire control systems, capabilities and limitations; theory of target acquisition, identification and tracking; basics of naval ordnance.\n",
    "credits": "3"
  },
  {
    "course_name": "Naval Operations and Seamanship",
    "dept": "N S",
    "num": "410",
    "desc": "Prereq: N S 230; senior classification\nStudy of tactical naval operations; employs practical use of maneuvering boards together with shiphandling principles to arrive at tactical shipboard maneuvering solutions. Study also of naval command and control, communications, and the Naval Warfare Doctrine.\n",
    "credits": "3"
  },
  {
    "course_name": "Leadership and Ethics",
    "dept": "N S",
    "num": "412",
    "desc": "Prereq: Requirements for NROTC students - N S 111, N S 212 or HIST 389, N S 220, N S 230, N S 320, N S 330 and N S 410\nBasic background concerning the duties and responsibilities of the junior naval officer and division officer in the areas of integrity and ethics, human resources management, personnel management, material management, and the administration of discipline. Preparation for responsibilities encountered immediately upon commissioning.\n",
    "credits": "3"
  },
  {
    "course_name": "Senior Naval Science Seminar",
    "dept": "N S",
    "num": "440",
    "desc": "Prereq: Senior classification\nCurrent leadership issues in the US Navy which will challenge the newly commissioned officer. Opportunities to analyze, provide solutions, and discuss actions related to a variety of real world situations.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "N S",
    "num": "490",
    "desc": "Prereq: Senior classification and prior approval of Naval Science Department Chair, 6 credits in Naval Science\n  No more than 9 credits of N S 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Cellular, Molecular and Developmental Neuroscience",
    "dept": "NEURO",
    "num": "556",
    "desc": "Prereq: BIOL 335 or BIOL 436; physics recommended\nFundamental principles of neuroscience including cellular and molecular neuroscience, nervous system development, sensory, motor and regulatory systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Neuroscience Techniques",
    "dept": "NEURO",
    "num": "557",
    "desc": "Prereq: NEURO 556 or equivalent course\nResearch methods and techniques; lectures, laboratory exercises and/or demonstrations representing individual faculty specialties.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Topics in Neuroscience",
    "dept": "NEURO",
    "num": "661",
    "desc": "Prereq: NEURO 556 (or comparable course) or permission of instructor\nTopics may include molecular and cellular neuroscience, neurodevelopment, neuroplasticity, neurodegenerative diseases, cognitive neuroscience, sensory biology, neural integration, membrane biophysics, neuroethology, techniques in neurobiology and behavior.\n",
    "credits": "2"
  },
  {
    "course_name": "Journal Club in Neuroscience",
    "dept": "NEURO",
    "num": "690",
    "desc": "Prereq: NEURO 556\nStudents are required to attend and make at least one presentation at a weekly journal club focusing on current topics.\n",
    "credits": "1"
  },
  {
    "course_name": "Neuroscience Seminar",
    "dept": "NEURO",
    "num": "696",
    "desc": "Prereq: NEURO 556\nPresentations and discussion of research by students, faculty, and visiting scholars.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "NEURO",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Nuclear Radiation Theory and Engineering",
    "dept": "NUC E",
    "num": "401",
    "desc": "Prereq: PHYS 222, MATH 266 or MATH 267\nAtomic and nuclear physics. Radioactivity and reaction rates. Cross sections. Introduction to neutron diffusion theory. Engineering applications of radiation theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Nuclear Reactor Engineering",
    "dept": "NUC E",
    "num": "402",
    "desc": "Prereq: NUC E 401, permission of Nuclear Engineering program director\nWWW only. Fission and chain reactions. Neutron diffusion and moderation. Reactor equations. Fermi Age theory. Multigroup and multiregional analysis. Contact Nuclear Engineering program director for enrollment information.\n",
    "credits": "3"
  },
  {
    "course_name": "Radiation Protection and Shielding",
    "dept": "NUC E",
    "num": "405",
    "desc": "Prereq: NUC E 401, permission of Nuclear Engineering program director\nWWW only. Basic principles and concepts of radiation protection and design: dosimetric units and response functions, hazards of radiation dose, radiation sources, basic methods for dose evaluation, and shielding design techniques for photons and neurons.\n",
    "credits": "3"
  },
  {
    "course_name": "Nuclear Reactor Theory",
    "dept": "NUC E",
    "num": "410",
    "desc": "Prereq: NUC E 401, permission of Nuclear Engineering program director\nWWW only. An introduction to neutron diffusion theory, neutron moderation, conditions for criticality of nuclear reactors.\n",
    "credits": "3"
  },
  {
    "course_name": "Nuclear Criticality Safety",
    "dept": "NUC E",
    "num": "421",
    "desc": "Prereq: NUC E 401\nNomenclature, theory, and practice of nuclear criticality safety. Review of nuclear criticality accidents, analytical methods used in criticality analysis, review of standards and regulations, and developing criticality safety evaluations.\n",
    "credits": "3"
  },
  {
    "course_name": "Nuclear Energy and Society",
    "dept": "NUC E",
    "num": "430",
    "desc": "Prereq: NUC E 401\nThe relationship between nuclear energy and society is examined from the perspective of significant events in the commercial nuclear power industry. Event analysis includes differences and similarities of technologies along with environmental impact. Political, social, media and regulatory responses for each event are discussed along with the impact on future plant design.\n",
    "credits": "3"
  },
  {
    "course_name": "Probabilistic Risk Assessment",
    "dept": "NUC E",
    "num": "441",
    "desc": "Prereq: STAT 305 or equivalent\nMethods for analysis of nuclear power systems. Fault tree and event tree analysis methods. Mathematical basics for dealing with reliability data, theory, and analysis. Case studies of accidents in nuclear power systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Radiation Detection, Measurement and Simulation",
    "dept": "NUC E",
    "num": "461",
    "desc": "Prereq: NUC E 401\nPrinciples of nuclear radiation safety and detection. Radiation energy spectroscopy. Counting statistics and error analysis. Monte Carlo simulation of radiation transport. Detection system performance parameters. Design projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "NUC E",
    "num": "490",
    "desc": "Prereq: Junior Classification\nInvestigation of nuclear engineering topics.  Election of course and topic must be approved in advance by supervising faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Orientation to BSN Nursing",
    "dept": "NRS",
    "num": "250",
    "desc": "Prereq: Admission to the RN-BSN program.\nPrepares the learner for the academic experience. Topics will include an introduction to learner-centered instruction, support services, communication, time management, and evaluation and assessment methods. Requirements of all nursing courses such as APA formatting and citation of sources will also be included. BSN students will successfully complete orientation prior to or concurrent with their first nursing course.\n",
    "credits": "1"
  },
  {
    "course_name": "Essential Concepts for Professional Nursing Practice",
    "dept": "NRS",
    "num": "320",
    "desc": "Prereq: Admission to the RN-BSN program.\nExploration of the philosophical, conceptual, and theoretical bases for baccalaureate nursing practice. Key concepts impacting the nursing profession and healthcare are examined from both historical and contemporary perspectives. Topics include professional role development, interprofessional collaboration and teamwork, quality and safety, effective communication, and provision of culturally competent and patient-centered care.\n",
    "credits": "3"
  },
  {
    "course_name": "Nursing Research and Evidence-Based Practice",
    "dept": "NRS",
    "num": "340",
    "desc": "Prereq: Admission to the RN-BSN program.\nIntroduction to the critical thought processes and methods used in nursing research. Basic concepts and terminology of research methodology and analysis are presented. Theory as a basis for research is examined. Students are given the opportunity to interpret and evaluate nursing research. Strategies for implementation of evidence based nursing practice to support quality and transformation in health care are explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Issues in Nursing and Healthcare",
    "dept": "NRS",
    "num": "360",
    "desc": "Prereq: Admission to the RN-BSN program.\nExploration of professional issues in contemporary nursing through published research, professional standards, literature and narrative evidence, with consideration of legal/ethical influences. Discussion of the change agent process and personal empowerment will be applied to resolution of issues.  Emphasis on analysis, sources of credible information, advocacy and empowerment.\n",
    "credits": "2"
  },
  {
    "course_name": "Promoting a Culture of Health and Wellness",
    "dept": "NRS",
    "num": "420",
    "desc": "Prereq: Admission to the RN-BSN program or permission of instructor.\nHealth promotion and illness prevention across the lifespan are examined in the context of the theoretical foundations, historical and contemporary practice and patient-centered care. Specific and evidence-based guidelines for supporting or improving health and well-being are explored and considered for both care recipients and care givers. Attention is given to the roles of the health care provider and care recipient in screening, communication, and counseling. The use of complementary or alternative therapeutics in assisting clients to achieve goals of health, healing and wellness is explored, as are spiritual and cultural beliefs and practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Population and Community Health Nursing",
    "dept": "NRS",
    "num": "440",
    "desc": "Prereq: NRS 340 and NRS 420\nUsing nursing process and an evidence-based framework, the student will explore epidemiology and genetics; health promotion and disease prevention within population groups; community assessment and intervention; and factors influencing health services access and delivery in the United States and globally. Individual and family case management, community wellness, healthcare access, health literacy and health education will be considered. This course includes project and simulation based practicum experiences.\n",
    "credits": "4"
  },
  {
    "course_name": "Nursing Leadership and Management",
    "dept": "NRS",
    "num": "460",
    "desc": "Prereq: NRS 320 and NRS 340\nExplores the knowledge and skills needed to implement leadership and management roles in various health care settings. Current theories of management, leadership and change are examined and related to nursing practice. Includes effective communication and relationship skills, organizational structure, information management, financial management, quality and outcomes measurement, and teamwork.\n",
    "credits": "3"
  },
  {
    "course_name": "Concepts Capstone",
    "dept": "NRS",
    "num": "470",
    "desc": "Prereq: NRS 440 and NRS 460\nEnables the student to further develop leadership abilities, communication, critical thinking, and decision-making skills with a focus on health promotion, quality improvement, or care management.  The student develops specific learning goals for the practicum based on individualized professional goals. Each student completes 45 practicum hours in a domestic or global setting.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study: Transition into Professional Practice",
    "dept": "NRS",
    "num": "490",
    "desc": "Prereq: Admission to the RN-BSN program and permission of Director of Nursing Education.\nIndependent work in RN role transition of the new graduate nurse.\n  A maximum of 4 credits of NRS 490 may be used toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Biochemical and Physiological Basis of Nutrition: Macronutrients and Micronutrients",
    "dept": "NUTRS",
    "num": "501",
    "desc": "Prereq: Credit or enrollment in BBMB 404 or BBMB 420\nIntegration of the molecular, cellular, and physiologic aspects of energy, macronutrient, and micronutrient metabolism in mammalian systems. Survey course that includes interactions among nutrients (dietary carbohydrate, fiber, lipid, protein, vitamins, and minerals) and non-nutrients, metabolic consequences of nutrient deficiencies or excesses, relevant polymorphisms, and major research methodologies.\n",
    "credits": "4"
  },
  {
    "course_name": "Biology of Adipose Tissue",
    "dept": "NUTRS",
    "num": "503",
    "desc": "Prereq: Undergraduate: consent of instructor; Graduate: NUTRS 501\nPrinciples regarding the development of adipose tissue and its role in energy balance, and will focus considerably on endocrine and immune actions of the adipocyte.  Course material will be in lecture format, including handouts and selected journal articles.  Students will be asked to lead critical discussions of key research findings as summary material for a given topic.  Species differences will be highlighted, particularly as they relate to research models.\n",
    "credits": "2"
  },
  {
    "course_name": "Nutrition and Epigenetic Regulation of Gene Expression",
    "dept": "NUTRS",
    "num": "504",
    "desc": "Prereq: graduate standing; undergraduate with consent of instructor\nDiscussion of epigenetic regulation of gene expression and the role that nutrition plays in this process.  Examination of current research literature to understand how different nutrients and physiological states influence epigenetics, as well as, the research methodology used to address these relations.\n",
    "credits": "1"
  },
  {
    "course_name": "Short Course",
    "dept": "NUTRS",
    "num": "505",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Diet and Cancer Prevention",
    "dept": "NUTRS",
    "num": "506",
    "desc": "Prereq: BBMB 404 and BBMB 405 or BBMB 420\nPrinciples of cancer biology and cancer etiology will be integrated with the impacts of diet on cancer development and prevention.  Contributions of research with humans, animals, cultured cells and cell free systems will be included.  The importance of dietary contaminants, macronutrients and micronutrients will be examined with an emphasis on the strength of the evidence and mechanisms of action.\n",
    "credits": "1"
  },
  {
    "course_name": "Digestive Physiology and Metabolism of Non Ruminants",
    "dept": "NUTRS",
    "num": "518",
    "desc": "Prereq: AN S 419 or NUTRS 501\nDigestion and metabolism of nutrients. Nutritional requirements and current research and feeding programs for poultry and swine.\n",
    "credits": "3"
  },
  {
    "course_name": "Digestive Physiology and Metabolism of Ruminants",
    "dept": "NUTRS",
    "num": "520",
    "desc": "Prereq: AN S 419 or NUTRS 501\nDigestive physiology and nutrient metabolism in ruminant and preruminant animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "NUTRS",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "NUTRS",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "NUTRS",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "NUTRS",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "NUTRS",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "NUTRS",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "NUTRS",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "NUTRS",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Vertebrate Physiology I",
    "dept": "NUTRS",
    "num": "549",
    "desc": "Prereq: recommended: an undergraduate physiology course and a biochemistry course\nOverview of mammalian physiology. Cell biology, endocrinology, cardiovascular, respiratory, immune, digestive, skeletal muscle and reproductive systems.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Vertebrate Physiology II",
    "dept": "NUTRS",
    "num": "552",
    "desc": "Prereq: BIOL 335; credit or enrollment in BBMB 404 or BBMB 420\nCardiovascular, renal, respiratory, and digestive physiology.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Nutrition and Disease I",
    "dept": "NUTRS",
    "num": "561",
    "desc": "Prereq: FS HN 360, FS HN 361, FS HN 367, BIOL 256 and 256L or BIOL 306 or BIOL 335\n(Dual listed with FS HN 461.) Pathophysiology of selected chronic disease states and their associated medical problems. Specific attention will be directed to medical nutrition needs of patients in the treatment of each disease state.\n",
    "credits": "4"
  },
  {
    "course_name": "Assessment of Nutritional Status",
    "dept": "NUTRS",
    "num": "562",
    "desc": "Prereq: FS HN 461/NUTRS 561 or NUTRS 501\nOverview and practical applications of methods for assessing nutritional status, including: theoretical framework of nutritional health and disease, dietary intake, biochemical indices, clinical examination, and body composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Community Nutrition",
    "dept": "NUTRS",
    "num": "563",
    "desc": "Prereq: FS HN 265 or FS HN 360; FS HN 366 recommended\nDual listed with FS HN 463. Survey of current public health nutrition problems among nutritionally vulnerable individuals and groups. Discussion of the multidimensional nature of those problems and of community programs addressing them. Grant writing as a means for funding community nutrition program development. Significant emphasis on written and oral communication at the lay and professional level. Field trip.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Nutrition and Disease II",
    "dept": "NUTRS",
    "num": "564",
    "desc": "Prereq: FS HN 360, FS HN 461, or NUTRS 561.\n(Dual listed with FS HN 464.) Pathophysiology of selected acute and chronic disease states and their associated medical problems. Specific attention will be directed to medical nutrition needs of patients in the treatment of each disease state.\n",
    "credits": "3"
  },
  {
    "course_name": "Nutritional Aspects of Oncology",
    "dept": "NUTRS",
    "num": "597",
    "desc": "Prereq: B.S. in nutrition, dietetics, biology, or related discipline.\nUnderstanding of basic cancer biology and methodology used to study nutrition and cancer relationships. Using current research as a basis, the role of nutrition in specific cancers will be explored. Students will learn about sources of information for cancer prevention programs, and how to apply this information to clinical patient management.\n",
    "credits": "3"
  },
  {
    "course_name": "Vitamins and Minerals",
    "dept": "NUTRS",
    "num": "618",
    "desc": "Prereq: Biochemistry, physiology, basic nutrition\nUnderstanding molecular aspects of vitamin and mineral metabolism and homeostasis in humans and animals.  An in-depth examination of the chemistry of vitamins and minerals, including genetic mutations, proteins involved in absorption and excretion, and their necessity in biological processes.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Nutrition and Metabolism - Protein",
    "dept": "NUTRS",
    "num": "619",
    "desc": "Prereq: BBMB 405\nDigestion, absorption, and intermediary metabolism of amino acids and protein. Regulation of protein synthesis and degradation. Integration of cellular biochemistry and physiology of mammalian protein metabolism.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Nutrition and Metabolism - Energy",
    "dept": "NUTRS",
    "num": "620",
    "desc": "Prereq: BBMB 405\nEnergy constituents of feedstuffs and energy needs of animals as related to cellular biochemistry and physiology. Interpretations of classical and current research.\n",
    "credits": "2"
  },
  {
    "course_name": "Modern Views of Nutrition",
    "dept": "NUTRS",
    "num": "680",
    "desc": "\nCurrent concepts in nutrition and related fields. Required for all graduate students in nutrition.\n",
    "credits": "R"
  },
  {
    "course_name": "Special Problems",
    "dept": "NUTRS",
    "num": "690",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Grant Proposal Writing",
    "dept": "NUTRS",
    "num": "695",
    "desc": "Prereq: 3 credits of graduate course work in food science and/or nutritional sciences\nGrant proposal preparation experiences including writing and critiquing of proposals and budget planning. Formation of grant writing teams in food science and/or nutritional sciences. Discussion of the role of successful grant writing in career development.\n",
    "credits": "1"
  },
  {
    "course_name": "Research in Nutritional Sciences",
    "dept": "NUTRS",
    "num": "699",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Tropical Biology: An Ecological Approach",
    "dept": "OTS",
    "num": "510",
    "desc": "\nThis course is designed for students in the early stages of graduate study in biology or a related field, with the goal of training graduate students in research methods by providing intensive field experience in diverse tropical ecosystems.\n",
    "credits": "8"
  },
  {
    "course_name": "Topics in Tropical Biology",
    "dept": "OTS",
    "num": "515",
    "desc": "\nThis course is designated for students enrolled in graduate course offerings through OTS (excluding OTS 510). Examples of graduate courses offered by OTS include Tropical Plant Systematics, Tropical Ecology and Conservation, Molecular Methods in Tropical Ecology, and Tropical Agroecology.\n",
    "credits": "1"
  },
  {
    "course_name": "Issues in the Performing Arts",
    "dept": "PERF",
    "num": "105",
    "desc": "\nCross-disciplinary analysis and discussion of topics in the performing arts. Six semesters required of performing arts majors.\n",
    "credits": "R"
  },
  {
    "course_name": "Performing Arts Internship",
    "dept": "PERF",
    "num": "310",
    "desc": "\nRequired of performing arts majors. A job or internship with a professional or semi-professional performing arts organization.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Performing Arts Seminar",
    "dept": "PERF",
    "num": "401",
    "desc": "\nIntensive collaborative study and practice of topics in music, dance and theatre. Required of performing arts majors.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Philosophy",
    "dept": "PHIL",
    "num": "201",
    "desc": "\nIt has been rumored that the unexamined life is not worth living. Philosophy is an attempt to begin examining life by considering such questions as: What makes us human? What is the world ultimately like? How should we relate to other people? Is there a god? How can we know anything about these questions? Understanding questions of this kind and proposed answers to them is what this course is all about.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Logic and Scientific Reasoning",
    "dept": "PHIL",
    "num": "206",
    "desc": "\nBasic principles of critical reasoning and argument evaluation. A consideration of basic forms of argumentation in science and everyday life. Application to contemporary issues and controversies.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Symbolic Logic",
    "dept": "PHIL",
    "num": "207",
    "desc": "\nIntroduction to fundamental logical concepts and logical symbolism. Development of natural deduction through first order predicate logic with identity. Applications to arguments in ordinary English and to philosophical issues. Linguistics majors should take LING/PHIL 207 as early as possible.\n",
    "credits": "3"
  },
  {
    "course_name": "Moral Theory and Practice",
    "dept": "PHIL",
    "num": "230",
    "desc": "\nInvestigation of moral issues in the context of major ethical theories of value and obligation; e.g., punishment, abortion, economic justice, job discrimination, world hunger, and sexual morality. Emphasis on critical reasoning and argument analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Ethical Issues in A Diverse Society",
    "dept": "PHIL",
    "num": "235",
    "desc": "\nThis course will examine a range of arguments on diversity issues. Topics will include: the social status of women, the moral status of sexuality and homosexuality, the nature and role of racism in contemporary society, the relationship between biology, gender roles and social status, and various proposals for change from a variety of political perspectives.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Ancient Philosophy",
    "dept": "PHIL",
    "num": "310",
    "desc": "Prereq: PHIL 201\nSurvey of ancient Greek philosophy, focusing on the pre-Socratics, Plato, and Aristotle. Questions concerning being, knowledge, language, and the good life are treated in depth.\n",
    "credits": "3"
  },
  {
    "course_name": "17th Century Philosophy",
    "dept": "PHIL",
    "num": "314",
    "desc": "Prereq: PHIL 201\nReadings from philosophers such as Hobbes, Descartes, Spinoza, Leibniz, and Locke. Changing conceptions of knowledge, self, and deities in response to Galileo's new science and post-reformation challenge to ecclesiastical authority.\n",
    "credits": "3"
  },
  {
    "course_name": "18th Century Philosophy",
    "dept": "PHIL",
    "num": "315",
    "desc": "Prereq: PHIL 201\nReadings from philosophers such as Berkeley, Hume, and Kant. Development of Enlightenment thought. Issues include idealism, causation, freedom, and knowledge regarding science, ethics, and deities.\n",
    "credits": "3"
  },
  {
    "course_name": "19th Century Continental Philosophy",
    "dept": "PHIL",
    "num": "316",
    "desc": "Prereq: PHIL 201\nThe thought of Hegel, Marx, Nietzsche, and their contemporaries. Various perspectives on the philosophy of history, the nature of reason and subjectivity, the contrast between dialectical and nondialectical philosophy, and the relationship between philosophy and society.\n",
    "credits": "3"
  },
  {
    "course_name": "20th and 21st Century Continental Philosophy",
    "dept": "PHIL",
    "num": "317",
    "desc": "Prereq: PHIL 201\nMajor movements of 20th and 21st century thought, such as Phenomenology, Critical Theory, Post-structuralism, Postmodernism, and Feminism. Issues include the assumptions and limits of Western metaphysics, the nature of reason, the relationship between language and power.\n",
    "credits": "3"
  },
  {
    "course_name": "20th and 21st Century Anglo-American Philosophy",
    "dept": "PHIL",
    "num": "318",
    "desc": "Prereq: 6 credits in philosophy, including PHIL 201.\nMajor movements in recent and contemporary philosophy such as realism, logical positivism, ordinary language philosophy, and naturalism. Russell, Wittgenstein, Quine and other leading figures. Topics include knowledge of the material world, mind, language, values, and philosophical method.\n",
    "credits": "3"
  },
  {
    "course_name": "Existentialism",
    "dept": "PHIL",
    "num": "320",
    "desc": "Prereq: PHIL 201\nHistory, development and forms of existential thought. Consciousness, free will, authenticity and bad faith. Readings of major figures in existentialism, such as Kierkegaard, Nietzsche, Dostoevsky, Heidegger, Sartre, and de Beauvoir.\n",
    "credits": "3"
  },
  {
    "course_name": "Ethical Theory",
    "dept": "PHIL",
    "num": "330",
    "desc": "Prereq: PHIL 201 or PHIL 230\nStudy of major theories of morality and the good life.  Includes such topics as moral psychology, practical reasoning, and virtue theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Moral Problems in Medicine",
    "dept": "PHIL",
    "num": "331",
    "desc": "Prereq: PHIL 230 or junior classification\nIn-depth study of some of the central moral problems arising in medicine, e.g., abortion, euthanasia, patients' rights, health care professionals' duties and responsibilities, allocation of medical resources. Major moral theories will be examined and applied.\n",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Law",
    "dept": "PHIL",
    "num": "332",
    "desc": "Prereq: PHIL 201 or PHIL 230\nExtent of our obligation to obey the law; what constitutes just punishment; how much of the immoral should be made illegal? Relation of these questions to major theories of law and the state. Discussion of such concepts as coercion, equality, and responsibility.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Ethics",
    "dept": "PHIL",
    "num": "334",
    "desc": "Prereq: 3 credits in philosophy or junior classification\nThorough study of some of the central moral issues arising in connection with human impact on the environment, e.g., human overpopulation, species extinction, forest and wilderness management, pollution. Several world views of the proper relationship between human beings and nature will be explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Social and Political Philosophy",
    "dept": "PHIL",
    "num": "335",
    "desc": "Prereq: PHIL 201 or PHIL 230\nFoundations of social and political life. The basis of political organization, the nature of social and political institutions, rights and authority, justice. Original texts.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioethics and Biotechnology",
    "dept": "PHIL",
    "num": "336",
    "desc": "Prereq: PHIL 201 or PHIL 230 or PHIL 235\nIn-depth study of some central moral issues in the life sciences, e.g., genetic screening and testing, genetically engineered plants and animals, risk analysis, biotechnology patents, research ethics, biodiversity, the impact of biotechnology on society and the environment. Major moral theories will be discussed and applied. (PHIL 336 contains almost no similarities to PHIL 331.).\n",
    "credits": "3"
  },
  {
    "course_name": "Feminist Philosophy",
    "dept": "PHIL",
    "num": "338",
    "desc": "Prereq: 3 credits in philosophy or women's studies recommended\nA critical, theoretical examination of the oppression of women, especially as it relates to issues of race, class, and sexual orientation. How concepts such as sex and gender, self and other, nature and nurture, complicate our understanding of what it means to be a woman. Historical and contemporary feminist philosophers addressing topics such as violence, sexuality, pornography, political power, family structure and women's paid and unpaid labor.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Liberty and Law in America",
    "dept": "PHIL",
    "num": "339",
    "desc": "Prereq: Sophomore status\nCompeting conceptions of liberty in American political thought. Debates about how liberty should be protected by the law, in fields such as health care, drugs, property, speech, religion, and sex.\n",
    "credits": "3"
  },
  {
    "course_name": "Aesthetics",
    "dept": "PHIL",
    "num": "340",
    "desc": "Prereq: PHIL 201 or PHIL 230\nIs liking all there is to appreciating works of art or natural beauty? We will examine our appreciative experiences, talk about such experiences (e.g., art criticism), and what makes them valuable. Do the different arts have common values? How are their differences important?.\n",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Technology",
    "dept": "PHIL",
    "num": "343",
    "desc": "Prereq: 6 credits of social science or T SC 341 and 3 credits of social science\nMoral and other philosophical problems related to developments in technology.  Topics may include conditions under which technological innovations contribute to human emancipation, relationship of technology and democracy, utility and limits of technical rationality, and problems of ensuring that benefits of technological advance are communally shared. Topics discussed with reference to such issues as contemporary developments in microelectronics, technology transfer to the Third World, etc.\n",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Religion",
    "dept": "PHIL",
    "num": "350",
    "desc": "Prereq: 6 credits in philosophy\nThe value and truth of religious life and belief. Mystical experience; religious faith and language; arguments for God's existence; the problem of evil; miracles; and religion and morality. Historical and contemporary readings.\n",
    "credits": "3"
  },
  {
    "course_name": "Buddhism",
    "dept": "PHIL",
    "num": "353",
    "desc": "Prereq: PHIL 201 or PHIL 230.\nCentral Buddhist positions and arguments on topics such as personal and social ethics, moral psychology, metaphysics, and the relationship between Buddhist thought and the sciences. Differences between Buddhist and Western approaches to philosophy.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Metaphysics: God, Minds, and Matter",
    "dept": "PHIL",
    "num": "364",
    "desc": "Prereq: 6 credits in philosophy, including PHIL 201.\nA survey of classical and contemporary views on some basic metaphysical issues. Issues discussed include: Does God exist? Do you have a mind and, if so, how does it relate to your body? What is the nature of cause and effect? Do objects have any essential properties? How can we account for properties objects have in common?.\n",
    "credits": "3"
  },
  {
    "course_name": "Truth, Belief and Reason",
    "dept": "PHIL",
    "num": "366",
    "desc": "Prereq: 6 credits in philosophy including PHIL 201, or instructor permission.\nThis course focuses on significant topics in theory of knowledge, including the value of true beliefs, the role of sense experience in supporting our theoretical views, and the place of reason in human nature. Historical and contemporary views will be considered.\n",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Science",
    "dept": "PHIL",
    "num": "380",
    "desc": "Prereq: PHIL 201 or 6 credits in a science\nIntroduction to the philosophy of science. A variety of basic problems common to the natural and social sciences: the nature of explanation, the structure of theories, the unity of science, and the distinction between science and nonscience.\n",
    "credits": "3"
  },
  {
    "course_name": "History and Philosophy of the Scientific Revolution.",
    "dept": "PHIL",
    "num": "382",
    "desc": "\nThe emergence of empirical science as the authoritative methodology for production of knowledge about the natural world in the period between Copernicus and Kant. Scientific progress achieved during the period, including the work of Galileo, Descartes, and Newton. The re-shaping of epistemology in the Western intellectual tradition. Implications for philosophy and historiography.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "PHIL",
    "num": "398",
    "desc": "Prereq: Permission of the department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Value Theory",
    "dept": "PHIL",
    "num": "430",
    "desc": "Prereq: PHIL 230\nTheoretical and normative issues in ethics, aesthetics, religious thought, or political philosophy. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Agency and Free Will",
    "dept": "PHIL",
    "num": "450",
    "desc": "Prereq: 3 credits in philosophy; PHIL 207 strongly encouraged\nPersonal identity, agency, free will, moral responsibility, causation, future contingents,   and time will be discussed. What makes a person the same person over time?  Do humans   have free will?  Are we not morally responsible if our actions are inevitable consequences   of the past and the laws of nature?  What distinguishes causes from non-causes?  Are   there facts about the future?.\n",
    "credits": "3"
  },
  {
    "course_name": "Brains, Minds, and Computers",
    "dept": "PHIL",
    "num": "465",
    "desc": "Prereq: 6 credits in philosophy\nExamination of concepts such as computability, intelligence, programming, and free will; and of arguments about whether any human capacity is forever beyond realization in a machine.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Epistemology",
    "dept": "PHIL",
    "num": "466",
    "desc": "Prereq: 6 credits in philosophy\nTopics in epistemology. Possible topics include skepticism about the external world, the extent of a priori knowledge, rival accounts of moral knowledge, feminist perspectives on the theory of knowledge, and the value of true belief. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Physics",
    "dept": "PHIL",
    "num": "485",
    "desc": "Prereq: 3 credits in Philosophy or 3 credits in Physics\nS. Conceptual and philosophical issues relating to the interpretation of theories in classical and modern physics. May include one or more of the following topics: the relationship between mathematics and the physical world; Newtonian physics (determinism and predictability); thermodynamics and statistical physics (the nature of probability; entropy and the direction of time); relativistic physics (indeterminism; realism and nonlocality; consciousness and the role of the observer).\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "PHIL",
    "num": "490",
    "desc": "Prereq: 6 credits in philosophy; permission of instructor, approval of chair.\nGuided reading and research on special topics selected to meet needs of advanced students.\n  No more than 9 credits of Phil 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "PHIL",
    "num": "490H",
    "desc": "Prereq: 6 credits in philosophy; permission of instructor, approval of chair.\nGuided reading and research on special topics selected to meet needs of advanced students.\n  No more than 9 credits of Phil 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Graduating Senior Survey",
    "dept": "PHIL",
    "num": "492",
    "desc": "Prereq: Graduating senior\nFinal presentation for graduation and the future. Outcomes assessment activities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Contemporary Political Philosophy",
    "dept": "PHIL",
    "num": "535",
    "desc": "Prereq: 6 credits of philosophy or political science\nExamination of theories of justice proposed by contemporary political philosophers. Analysis of the philosophical foundations of perspectives such as liberalism, libertarianism, communitarianism, socialism, feminism. Normative assessments of socio-political institutions.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Philosophy",
    "dept": "PHIL",
    "num": "590",
    "desc": "Prereq: Permission of instructor, 9 credits in philosophy\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Philosophy: History of Philosophy",
    "dept": "PHIL",
    "num": "590A",
    "desc": "Prereq: Permission of instructor, 9 credits in philosophy\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Philosophy: Epistemology and Metaphysics",
    "dept": "PHIL",
    "num": "590B",
    "desc": "Prereq: Permission of instructor, 9 credits in philosophy\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Philosophy: Value Theory",
    "dept": "PHIL",
    "num": "590C",
    "desc": "Prereq: Permission of instructor, 9 credits in philosophy\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Philosophy: Logic and Philosophy of Science",
    "dept": "PHIL",
    "num": "590D",
    "desc": "Prereq: Permission of instructor, 9 credits in philosophy\n",
    "credits": "2"
  },
  {
    "course_name": "Summer Bioethics Workshop for Teachers",
    "dept": "PHIL",
    "num": "593",
    "desc": "\nTopics include moral theory, pedagogical issues in teaching bioethics, and substantive current issues in bioethics.\n",
    "credits": "2"
  },
  {
    "course_name": "Preparation for Introductory Physics",
    "dept": "PHYS",
    "num": "050",
    "desc": "Prereq: 1 year high school algebra\nAn in‐depth active learning experience designed to impart the fundamental concepts and principles of physics, with an emphasis on applied mathematical techniques and logical thinking.  For students intending to enroll in classical physics (PHYS 221/222) who have not taken high school physics, who have not had a high school college preparatory physics course, or who need a review of physics problem solving and physics concepts.\n  Credit for Phys 50 does not count toward graduation.",
    "credits": "0"
  },
  {
    "course_name": "Physics for the Nonscientist",
    "dept": "PHYS",
    "num": "101",
    "desc": "\nSurvey of the principal areas of both classical and modern physics. Emphasis on the nature of the physical universe and the application of physical principles to life in the modern world.\n  Not suitable to meet a general physics requirement for natural science majors.",
    "credits": "3"
  },
  {
    "course_name": "Physical Sciences for Elementary Education",
    "dept": "PHYS",
    "num": "102L",
    "desc": "Prereq: MATH 195 or MATH 140\nPhysical science principles for future elementary teachers.  Emphasis on experiments that address current elementary science education standards and that are appropriate for their future students to do, such as measurements of mass, length, time, light from atoms, charge and current, motion due to forces, energy and work, heat, waves, optics, building bridges and making musical instruments, studying states of matter and chemical reactions.\n",
    "credits": "3"
  },
  {
    "course_name": "General Physics",
    "dept": "PHYS",
    "num": "111",
    "desc": "Prereq: 1 1/2 years of high school algebra, 1 year of geometry, 1 semester of trigonometry\nGeneral background in physical concepts, principles, and methods for those who do not plan advanced study in physics or engineering. Mechanics, fluids, heat and thermodynamics, vibrations, waves, sound.\n",
    "credits": "5"
  },
  {
    "course_name": "General Physics",
    "dept": "PHYS",
    "num": "112",
    "desc": "Prereq: PHYS 111\nGeneral background in physical concepts, principles, and methods for those who do not plan advanced study in physics or engineering. Electricity and magnetism, ray and wave optics, topics in modern physics.\n",
    "credits": "5"
  },
  {
    "course_name": "Physics for the Life Sciences",
    "dept": "PHYS",
    "num": "115",
    "desc": "Prereq: high school: 1 1/2 yr. algebra, 1 yr. geometry, 1 semester trigonometry\nEmphasis on basic physics principles applied to biological problems. Topics include mechanics, fluids, thermodynamics, heat, light, sound, electricity and magnetism. A coordinated laboratory, Physics 115 laboratory is available.\n",
    "credits": "4"
  },
  {
    "course_name": "Laboratory in Physics for the Life Sciences",
    "dept": "PHYS",
    "num": "115L",
    "desc": "Prereq: Credit or enrollment in PHYS 115\nExperiments related to the elementary topics of physics for the life sciences. Mechanics, fluids, thermodynamics, heat, light, sound, electricity and magnetism.\n",
    "credits": "1"
  },
  {
    "course_name": "Physics of Music",
    "dept": "PHYS",
    "num": "198",
    "desc": "\nIntroductory level course on sound for nonphysics majors. Properties of pure tones and harmonics; human perception of sound; room acoustics; scales; production, and analysis of musical by voice, string, woodwind, brass, and percussion instruments.\n  Not suitable to meet a general physics requirement for natural science majors",
    "credits": "3"
  },
  {
    "course_name": "Introductory Seminar",
    "dept": "PHYS",
    "num": "199",
    "desc": "\n(1-1) Gain experience in key skills that physicists/astronomers use routinely, but are rarely explicitly taught in formal courses. Participate in faculty-led discussions on frontier areas and careers.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Classical Physics I",
    "dept": "PHYS",
    "num": "221",
    "desc": "Prereq: Proficiency in algebra, trigonometry, vector manipulation, and topics covered in MATH 165, and credit or enrollment in MATH 166.\nFor engineering and science majors. 3 hours of lecture each week plus 3 recitations and 1 laboratory every 2 weeks. Elementary mechanics including kinematics and dynamics of particles, work and energy, linear and angular momentum, conservation laws, rotational motion, oscillations, gravitation. Heat, thermodynamics, kinetic theory of gases; waves and sound.\n",
    "credits": "5"
  },
  {
    "course_name": "Introduction to Classical Physics I: Honors",
    "dept": "PHYS",
    "num": "221H",
    "desc": "Prereq: Proficiency in algebra, trigonometry, vector manipulation, and topics covered in MATH 165, and credit or enrollment in MATH 166.\nFor engineering and science majors. 3 hours of lecture each week plus 3 recitations and 1 laboratory every 2 weeks. Elementary mechanics including kinematics and dynamics of particles, work and energy, linear and angular momentum, conservation laws, rotational motion, oscillations, gravitation. Heat, thermodynamics, kinetic theory of gases; waves and sound.\n",
    "credits": "5"
  },
  {
    "course_name": "Introduction to Classical Physics II",
    "dept": "PHYS",
    "num": "222",
    "desc": "Prereq: PHYS 221 OR PHYS 241, MATH 166\n3 hours of lecture each week plus 1 recitation and 1 laboratory each week. Fluid dynamics. Electric forces and fields.  Electrical currents; DC circuits.  Magnetic forces and fields: LR, LC, LCR circuits; Maxwell's equations; wave optics.\n",
    "credits": "5"
  },
  {
    "course_name": "Introduction to Classical Physics II: Honors",
    "dept": "PHYS",
    "num": "222H",
    "desc": "Prereq: PHYS 221 OR PHYS 241, MATH 166\n3 hours of lecture each week plus 1 recitation and 1 laboratory each week. Fluid dynamics. Electric forces and fields.  Electrical currents; DC circuits.  Magnetic forces and fields: LR, LC, LCR circuits; Maxwell's equations; wave optics.\n",
    "credits": "5"
  },
  {
    "course_name": "Principles and Symmetries in Classical Physics I",
    "dept": "PHYS",
    "num": "241",
    "desc": "Prereq: Proficiency in algebra, trigonometry, vector manipulation, and topics covered in MATH 165, and credit or enrollment in MATH 166.\nCovers all of mechanics; Kinematics and dynamics of particles, work and energy, linear and angular momentum, conservation laws, rotational motion, oscillations, gravitation, and extremum principles.  Topics in kinetic theory, thermodynamics, waves and sound.\n",
    "credits": "5"
  },
  {
    "course_name": "Principles and Symmetries in Classical Physics I, Honors.",
    "dept": "PHYS",
    "num": "241H",
    "desc": "Prereq: Proficiency in algebra, trigonometry, vector manipulation, and topics covered in MATH 165, and credit or enrollment in MATH 166.\nCovers all of mechanics; Kinematics and dynamics of particles, work and energy, linear and angular momentum, conservation laws, rotational motion, oscillations, gravitation, and extremum principles.  Topics in kinetic theory, thermodynamics, waves and sound.\n",
    "credits": "5"
  },
  {
    "course_name": "Principles and Symmetries in Classical Physics II",
    "dept": "PHYS",
    "num": "242",
    "desc": "Prereq: PHYS 221 or PHYS 241, credit or enrollment in MATH 166\nFluid dynamics, electrostatics, potentials and fields, currents, fields of moving charges, the magnetic field, electromagnetic induction, DC and AC circuits, Maxwell's equations and electromagnetic waves, electric and magnetic fields in matter.  Topics in optics and special relativity.\n",
    "credits": "5"
  },
  {
    "course_name": "Principles and Symmetries in Classical Physics II, Honors (Spring).",
    "dept": "PHYS",
    "num": "242H",
    "desc": "Prereq: PHYS 221 or PHYS 241, credit or enrollment in MATH 166\nFluid dynamics, electrostatics, potentials and fields, currents, fields of moving charges, the magnetic field, electromagnetic induction, DC and AC circuits, Maxwell's equations and electromagnetic waves, electric and magnetic fields in matter.  Topics in optics and special relativity.\n",
    "credits": "5"
  },
  {
    "course_name": "Independent Study",
    "dept": "PHYS",
    "num": "290",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "PHYS",
    "num": "298",
    "desc": "Prereq: Permission of the department cooperative education coordinator; sophomore classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "The Challenge of Contemporary Physics",
    "dept": "PHYS",
    "num": "302",
    "desc": "Prereq: Sophomore classification\nA largely nonmathematical but intellectually challenging exploration of physics, which assumes no previous work in the field. Selected material from classical and modern physics establishes the conceptual framework for the study of major areas of contemporary physics, culminating in the discussion of topics at the frontier of present knowledge. Topics vary yearly and may include quarks, lasers, superconductivity, fission and fusion, solid state devices, gravitational waves, string theory, facilities, left handed materials, and quantum computing.\n  Not suitable to meet a general physics requirement for natural science majors.",
    "credits": "3"
  },
  {
    "course_name": "Thermal Physics",
    "dept": "PHYS",
    "num": "304",
    "desc": "Prereq: PHYS 222 or PHYS 242, MATH 266 or MATH 267\nConcepts of temperature, entropy, and other characteristic thermodynamic functions, with application to macroscopic properties of matter. The laws of thermodynamics. Introduction to statistical mechanics, including quantum statistics. Application to black body radiation, crystalline vibrations, magnetic ions in solids, electronic heat capacity of metals. Phase transformations and chemical reactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Physics of Wave Motion",
    "dept": "PHYS",
    "num": "306",
    "desc": "Prereq: PHYS 222 or PHYS 242, credit or enrollment in MATH 267\nOscillating systems including damped and forced oscillations; fluids, geometric optics, water waves, the wave equation, Fourier and Laplace transforms, non-uniform media, cylindrical and spherical waves, polarization, interference and diffraction, transmission lines, non-linear waves.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Instrumentation for Experimental Physics",
    "dept": "PHYS",
    "num": "310",
    "desc": "Prereq: PHYS 222 or PHYS 242; MATH 166\nCommon electrical instruments; power supplies; transducers; passive and active devices, analog integrated circuits, including filters and amplifiers; digital integrated circuits; signal transmission and enhancement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Laboratory",
    "dept": "PHYS",
    "num": "311",
    "desc": "Prereq: PHYS 322\nExperiments in classical and modern physics performed independently by each student.\n",
    "credits": "1"
  },
  {
    "course_name": "Intermediate Laboratory for Secondary Physics Teachers",
    "dept": "PHYS",
    "num": "311T",
    "desc": "Prereq: PHYS 112 or PHYS 222 or PHYS 242\nExperiments in classical and modern physics performed independently by each student. For students preparing for a career in high school teaching.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Modern Physics I",
    "dept": "PHYS",
    "num": "321",
    "desc": "Prereq: PHYS 222 or PHYS 242, credit or enrollment in MATH 266 or MATH 267\nQuantum nature of matter: photons, de Broglie's postulate: wave-like properties of matter; Bohr's model of hydrogen atom; Schrodinger equations in one dimension: energy quantization; detailed solutions for potential steps, barriers and wells; one-electron atoms, spin and magnetic interactions; ground states, optical and x-ray excitations of multi-electron atoms.\n",
    "credits": "3"
  },
  {
    "course_name": "Introductory Laboratory in Modern Physics I",
    "dept": "PHYS",
    "num": "321L",
    "desc": "Prereq: Credit or enrollment in PHYS 321\nExperiments related to the foundations of modern physics. The dual wave and particle character of electrons and photons, statistics, interferometry and x-ray spectroscopy.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Modern Physics II",
    "dept": "PHYS",
    "num": "322",
    "desc": "Prereq: PHYS 321\nQuantum statistics; lasers; physics of molecules. Properties of solids, including electron band structure, superconductivity and magnetism. Nuclear physics, including nuclear sizes and masses, stability, decay modes, reactions, fission and fusion. Elementary particles, including strangeness, charm, and quarks. Fundamental forces of nature.\n",
    "credits": "3"
  },
  {
    "course_name": "Introductory Laboratory in Modern Physics II",
    "dept": "PHYS",
    "num": "322L",
    "desc": "Prereq: Credit or enrollment in PHYS 322\nExperiments related to the foundations of modern physics. Radioactive decay, elementary particles, Hall effect, quantization, spectroscopy, statistics and instrumentation.\n",
    "credits": "1"
  },
  {
    "course_name": "Classical Mechanics",
    "dept": "PHYS",
    "num": "361",
    "desc": "Prereq: PHYS 222 or PHYS 242, MATH 265, credit or enrollment in MATH 266 or MATH 267\nNewtonian mechanics including forced oscillations, central forces and orbital motion, collisions, moving frames of reference, Lagrange's equations.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Mechanics",
    "dept": "PHYS",
    "num": "362",
    "desc": "Prereq: PHYS 361\nRigid body motion; small oscillations, normal modes. Special relativity including length contraction, time dilation, simultaneity, Lorentz transformation, 4-vector covariant formalism, relativistic mechanics.\n",
    "credits": "3"
  },
  {
    "course_name": "Electricity and Magnetism I",
    "dept": "PHYS",
    "num": "364",
    "desc": "Prereq: PHYS 222 or PHYS 242, MATH 266 or MATH 267\nStatic electric and magnetic fields, potential theory; electromagnetism, Maxwell's equations.\n",
    "credits": "3"
  },
  {
    "course_name": "Electricity and Magnetism II",
    "dept": "PHYS",
    "num": "365",
    "desc": "Prereq: PHYS 364, MATH 385\nRelativistic electromagnetic theory; radiation and propagation of electromagnetic waves; interaction with matter.\n",
    "credits": "3"
  },
  {
    "course_name": "Junior Seminar",
    "dept": "PHYS",
    "num": "389",
    "desc": "\nRecommended for all junior physics majors. Career opportunities: graduate school programs and application, job placement, alternative careers, basic skills needed for the job market competition.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "PHYS",
    "num": "398",
    "desc": "Prereq: Permission of the department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Seminar on Secondary School Physics",
    "dept": "PHYS",
    "num": "399",
    "desc": "Prereq: Permission of instructor\nReview of materials and curricula for secondary school physics presented and discussed by members of the class. Required for approval to teach physics in secondary schools.\n",
    "credits": "1"
  },
  {
    "course_name": "Ultrafast Laser Science and Spectroscopy",
    "dept": "PHYS",
    "num": "421",
    "desc": "Prereq: PHYS 321, PHYS 365, or equivalent with permission of instructor\nIntroduction to ultrafast lasers, nonlinear optics, and their applications.  Topics selected from: basic optics, atom-photon interactions, electrodynamics of condensed matter, laser physics, ultrafast and nonlinear optics, ultrashort pulse generation, broadband pulse generation, time-resolved spectroscopy and instrumentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular and Cell Biophysics",
    "dept": "PHYS",
    "num": "432",
    "desc": "Prereq: PHYS 304 or CHEM 325.\nQuantitative description of biological systems using basic physical laws, including a brief discussion of a variety of biophysical techniques.  Topics include:  thermodynamics, chemical equilibrium, gene expression, structure and physical properties of nucleic acids and proteins, folding of nucleic acids and proteins, chemical kinetics, catalysis, allosteric enzymes, cell membrane structure and physical properties, and machines in cell membranes.\n",
    "credits": "3"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "PHYS",
    "num": "450",
    "desc": "Prereq: Permission of instructor\nTheoretical research under supervision of physics faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "PHYS",
    "num": "450L",
    "desc": "Prereq: PHYS 311, permission of instructor\nLaboratory project under supervision of physics faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Physics of Biomolecules",
    "dept": "PHYS",
    "num": "461",
    "desc": "Prereq: PHYS 304 or CHEM 325, BBMB 301, or permission of instructor\nCell and Molecular Biophysics.  Physical techniques used to characterize the structure, dynamics and properties of biomolecules with emphasis on single molecule techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Physics Laboratory",
    "dept": "PHYS",
    "num": "470L",
    "desc": "Prereq: PHYS 322 and permission of instructor\nStudies in modern experimental techniques via experimentation and simulation in various areas of applied physics, e.g. superconductivity, optical spectroscopy, nuclear magnetic resonance, electron spin resonance, x-ray diffraction, and computation of electronic and structural properties of matter.\n",
    "credits": "2"
  },
  {
    "course_name": "Quantum Mechanics I",
    "dept": "PHYS",
    "num": "480",
    "desc": "Prereq: PHYS 322, MATH 385\nFirst semester of a full-year course. A systematic development of the formalism and applications of quantum mechanics. Solutions to the time independent Schrodinger equation for various one-dimensional potentials including the harmonic oscillator; operator methods; Heisenberg picture; angular momentum; the hydrogen atom; spin; symmetry properties.\n",
    "credits": "3"
  },
  {
    "course_name": "Quantum Mechanics II",
    "dept": "PHYS",
    "num": "481",
    "desc": "Prereq: PHYS 480\nContinuation of 480. Addition of angular momentum; charged particles in electromagnetic fields; time-independent perturbation theory; variational principles; WKB approximation; interaction picture; time-dependent perturbation theory; adiabatic approximation; scattering; selected topics in radiation theory; quantum paradoxes.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "PHYS",
    "num": "490",
    "desc": "Prereq: 6 credits in physics, permission of instructor\n  No more than 9 credits of Phys 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study, Honors",
    "dept": "PHYS",
    "num": "490H",
    "desc": "Prereq: 6 credits in physics, permission of instructor\n  No more than 9 credits of Phys 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Modern Optics",
    "dept": "PHYS",
    "num": "496",
    "desc": "Prereq: Credit or enrollment in PHYS 322, PHYS 365, and PHYS 480\nReview of wave and electromagnetic theory; topics selected from: reflection/refraction, interference, geometrical optics, Fourier analysis, dispersion, coherence, Fraunhofer and Fresnel diffraction, holography, quantum optics, nonlinear optics.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "PHYS",
    "num": "498",
    "desc": "Prereq: Permission of the department cooperative education coordinator; senior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Oral Communication of Physics Seminar",
    "dept": "PHYS",
    "num": "501",
    "desc": "\nA practical introduction to communication methods in physics and astronomy classrooms and professional settings. For graduate physics majors only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introductory Research Seminar",
    "dept": "PHYS",
    "num": "502",
    "desc": "\n(1-1) Discussion by research staff of their research areas, expected thesis research work, and opportunities in the field. For graduate physics majors only.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Condensed Matter Physics I",
    "dept": "PHYS",
    "num": "511",
    "desc": "Prereq: PHYS 304, credit or enrollment in PHYS 481\nFirst semester of a full-year course. Free electron model; crystal symmetry; band theory of solids; transport properties; Fermi surface; phonons; semiconductors; crystal surfaces; magnetism; superconductivity.\n",
    "credits": "3"
  },
  {
    "course_name": "Condensed Matter Physics II",
    "dept": "PHYS",
    "num": "512",
    "desc": "Prereq: PHYS 511\nContinuation of 511. Free electron model; crystal symmetry; band theory of solids; transport properties; Fermi surface; phonons; semiconductors; crystal surfaces; magnetism; superconductivity.\n",
    "credits": "3"
  },
  {
    "course_name": "Ultrafast Laser Science and Spectroscopy",
    "dept": "PHYS",
    "num": "521",
    "desc": "Prereq: PHYS 321, PHYS 365, or equivalent with permission of instructor\nIntroduction to ultrafast lasers, nonlinear optics, and their applications.  Topics selected from: basic optics, atom-photon interactions, electrodynamics of condensed matter, laser physics, ultrafast and nonlinear optics, ultrashort pulse generation, broadband pulse generation, time-resolved spectroscopy and instrumentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Particle and Nuclear Physics",
    "dept": "PHYS",
    "num": "526",
    "desc": "Prereq: Credit or enrollment in PHYS 481\nBasic properties and structures of nuclei, hadrons, and elementary particles; weak and strong interactions; the Standard Model; accelerators and detectors; nuclear models; nuclear decay and stability; nuclear astrophysics; the Higgs mechanism; the CKM matrix; running coupling constants; relativistic heavy-ion collisions; selected topics beyond the standard model such as SUSY and grand unification.\n",
    "credits": "4"
  },
  {
    "course_name": "Mathematical Methods for the Physical Sciences",
    "dept": "PHYS",
    "num": "528",
    "desc": "Prereq: MATH 266 or MATH 267\nFast-paced coverage of mathematical techniques needed for advanced analysis in the physical sciences, particularly for quantum mechanics and electrodynamics. Linear vector spaces and operators.  Linear differential equations for time-evolution and steady-state problems, Green's functions and propagators, Sturm-Liouville problems. Functions of a complex variable, calculus of residues, series expansions, integral transforms and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Mechanics",
    "dept": "PHYS",
    "num": "531",
    "desc": "Prereq: PHYS 304 and credit or enrollment in PHYS 481, credit or enrollment in MATH 365 or PHYS 528\nThermodynamic properties of systems of many particles obeying Boltzmann, Fermi-Dirac, and Bose-Einstein statistics; microcanonical, canonical, and grand canonical ensembles and their application to physical problems; density matrices; introduction to phase transitions; renormalization group theory; kinetic theory and fluctuations.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular and Cell Biophysics",
    "dept": "PHYS",
    "num": "532",
    "desc": "Prereq: PHYS 304 or CHEM 325.\nQuantitative description of biological systems using basic physical laws, including a brief discussion of a variety of biophysical techniques.  Topics include:  thermodynamics, chemical equilibrium, gene expression, structure and physical properties of nucleic acids and proteins, folding of nucleic acids and proteins, chemical kinetics, catalysis, allosteric enzymes, cell membrane structure and physical properties, and machines in cell membranes.\n",
    "credits": "3"
  },
  {
    "course_name": "Symmetry and Group Theory in Physics",
    "dept": "PHYS",
    "num": "534",
    "desc": "Prereq: Credit or enrollment in PHYS 481\nTheory of groups and group representations; introduction to both point and continuous groups, and their applications in physics.\n",
    "credits": "3"
  },
  {
    "course_name": "Physics of Semiconductors",
    "dept": "PHYS",
    "num": "535",
    "desc": "Prereq: E E 311 and E E 332\nBasic elements of quantum theory, Fermi statistics, motion of electrons in periodic structures, crystal structure, energy bands, equilibrium carrier concentration and doping, excess carriers and recombination, carrier transport at low and high fields, space charge limited current, photo-conductivity in solids, phonons, optical properties, amorphous semiconductors, heterostructures, and surface effects. Laboratory experiments on optical properties, carrier lifetimes, mobility, defect density, doping density, photo-conductivity, diffusion length of carriers.\n",
    "credits": "4"
  },
  {
    "course_name": "Physics of Semiconductor Devices",
    "dept": "PHYS",
    "num": "536",
    "desc": "Prereq: E E 535\nP-n junctions, band-bending theory, tunneling phenomena, Schottky barriers, heterojunctions, bipolar transistors, field-effect transistors, negative-resistance devices and optoelectronic devices.\n",
    "credits": "3"
  },
  {
    "course_name": "General Relativity",
    "dept": "PHYS",
    "num": "541",
    "desc": "Prereq: PHYS 362, MATH 207 or MATH 317\nTensor analysis and differential geometry developed and used to formulate Einstein field equations. Schwarzschild and Kerr solutions. Other advanced topics may include gravitational radiation, particle production by gravitational fields, alternate gravitational theories, attempts at unified field theories, cosmology.\n",
    "credits": "3"
  },
  {
    "course_name": "Computational Physics",
    "dept": "PHYS",
    "num": "551",
    "desc": "Prereq: PHYS 365, credit or enrollment in PHYS 481\nUse of modern computational techniques to analyze topics in classical and modern physics.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "Physics of Biomolecules",
    "dept": "PHYS",
    "num": "561",
    "desc": "Prereq: PHYS 304 or CHEM 325, BBMB 301, or permission of instructor\nCell and Molecular Biophysics.  Physical techniques used to characterize the structure, dynamics and properties of biomolecules with emphasis on single molecule techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Classical Mechanics",
    "dept": "PHYS",
    "num": "564",
    "desc": "Prereq: PHYS 362, PHYS 528\nVariational principles, Lagrange's equations, Hamilton's canonical equations, canonical transformations, Hamilton-Jacobi theory, infinitesimal transformations, classical field theory, canonical perturbation theory, classical chaos.\n",
    "credits": "3"
  },
  {
    "course_name": "Electricity and Magnetism I",
    "dept": "PHYS",
    "num": "571",
    "desc": "Prereq: PHYS 365, PHYS 528\nElectrostatics, magnetostatics, boundary value problems, Maxwell's equations, wave phenomena in macroscopic media, wave guides.\n",
    "credits": "3"
  },
  {
    "course_name": "Electricity and Magnetism II",
    "dept": "PHYS",
    "num": "572",
    "desc": "Prereq: PHYS 571\nSpecial theory of relativity, least action and motion of charged particles in electromagnetic fields, radiation, collisions between charged particles, multipole fields, radiation damping.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "PHYS",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "arr"
  },
  {
    "course_name": "Nuclear Physics",
    "dept": "PHYS",
    "num": "590A",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "arr"
  },
  {
    "course_name": "Condensed Matter Physics",
    "dept": "PHYS",
    "num": "590B",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "arr"
  },
  {
    "course_name": "High Energy Physics",
    "dept": "PHYS",
    "num": "590C",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "arr"
  },
  {
    "course_name": "Physics",
    "dept": "PHYS",
    "num": "590D",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "arr"
  },
  {
    "course_name": "Applied Physics",
    "dept": "PHYS",
    "num": "590E",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "arr"
  },
  {
    "course_name": "Biophysics",
    "dept": "PHYS",
    "num": "590F",
    "desc": "Prereq: Permission of instructor\nTopics of current interest.\n",
    "credits": "arr"
  },
  {
    "course_name": "Quantum Physics I",
    "dept": "PHYS",
    "num": "591",
    "desc": "Prereq: PHYS 481\nFirst semester of a full-year course. Postulates of quantum mechanics; time-dependent and time-independent Schrodinger equations for one-,two-, and three-dimensional systems; theory of angular momentum; Rayleigh-Schrodinger time-independent perturbation theory.\n",
    "credits": "4"
  },
  {
    "course_name": "Quantum Physics II",
    "dept": "PHYS",
    "num": "592",
    "desc": "Prereq: PHYS 591\nContinuation of 591. Variational theorem and WKB method; time-dependent perturbation theory and 2nd quantization of the EM field in Coulomb gauge; method of partial waves and Born approximation for scattering by central potentials; identical particles and symmetry; Dirac and Klein-Gordon equation for free particles; path integral formalism.\n",
    "credits": "4"
  },
  {
    "course_name": "Creative Component",
    "dept": "PHYS",
    "num": "599",
    "desc": "Prereq: Permission of instructor\nIndividually directed study of research-level problems for students electing the nonthesis M.S. degree option.\n",
    "credits": "arr"
  },
  {
    "course_name": "Quantum Theory of Condensed Matter",
    "dept": "PHYS",
    "num": "611",
    "desc": "Prereq: PHYS 512 and PHYS 681 or permission of instructor.\nQuasiparticles in condensed matter: phonons, magnons, photons, electrons. Quantum theory of interacting many body systems: Green's functions and diagrammatic techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Nuclear Physics",
    "dept": "PHYS",
    "num": "624",
    "desc": "Prereq: PHYS 526 and PHYS 592\nMicroscopic few-body and many-body theory; theory of effective Hamiltonians; relativistic nuclear physics; nuclear effects in hadron-nucleus, lepton-nucleus, and nucleus-nucleus reactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Physics of Strong Interactions",
    "dept": "PHYS",
    "num": "625",
    "desc": "Prereq: PHYS 681\nQuark model; Quantum Chromodynamics IQCD); perturbation methods for QCD; effective field theories for pions and nucleons; finite temperature field theories; quark-gluon plasma; phase transitions in QCD.\n",
    "credits": "3"
  },
  {
    "course_name": "Elementary Particle Physics I",
    "dept": "PHYS",
    "num": "637",
    "desc": "Prereq: PHYS 526 and PHYS 592\nFirst semester of a full year course. Properties of leptons, bosons, and quarks and their interactions; quantum chromodynamics, Glashow-Weinberg-Salam model, grand unification theories, supersymmetry; modern theoretical techniques and tests of the Standard Model.\n",
    "credits": "3"
  },
  {
    "course_name": "Elementary Particle Physics II",
    "dept": "PHYS",
    "num": "638",
    "desc": "Prereq: PHYS 637\nContinuation of 637. Properties of leptons, bosons, and quarks and their interactions; quantum chromodynamics, Glashow-Weinberg-Salam model, grand unification theories, supersymmetry, and superstring theory; modern theoretical techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Mathematical Modeling of Complex Physical Systems",
    "dept": "PHYS",
    "num": "646",
    "desc": "\nModeling of the dynamics of complex systems on multiple scales: Classical and dissipative molecular dynamics, stochastic modeling and Monte-Carlo simulation; coarse grained nonlinear dynamics, interface propagation and spatial pattern formation.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Seminar",
    "dept": "PHYS",
    "num": "650",
    "desc": "\nTopics of current interest.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Nuclear Physics",
    "dept": "PHYS",
    "num": "650A",
    "desc": "\nTopics of current interest.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Condensed Matter Physics",
    "dept": "PHYS",
    "num": "650B",
    "desc": "\nTopics of current interest.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "High Energy Physics",
    "dept": "PHYS",
    "num": "650C",
    "desc": "\nTopics of current interest.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Physics",
    "dept": "PHYS",
    "num": "650D",
    "desc": "\nTopics of current interest.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Applied Physics",
    "dept": "PHYS",
    "num": "650E",
    "desc": "\nTopics of current interest.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Biophysics",
    "dept": "PHYS",
    "num": "650F",
    "desc": "\nTopics of current interest.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Topics in Physics",
    "dept": "PHYS",
    "num": "660",
    "desc": "\nCourses on advanced topics and recent developments.\n",
    "credits": "1"
  },
  {
    "course_name": "Condensed Matter Physics",
    "dept": "PHYS",
    "num": "660B",
    "desc": "\nCourses on advanced topics and recent developments.\n",
    "credits": "1"
  },
  {
    "course_name": "High Energy Physics",
    "dept": "PHYS",
    "num": "660C",
    "desc": "\nCourses on advanced topics and recent developments.\n",
    "credits": "1"
  },
  {
    "course_name": "Physics",
    "dept": "PHYS",
    "num": "660D",
    "desc": "\nCourses on advanced topics and recent developments.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Physics",
    "dept": "PHYS",
    "num": "660E",
    "desc": "\nCourses on advanced topics and recent developments.\n",
    "credits": "1"
  },
  {
    "course_name": "Biophysics",
    "dept": "PHYS",
    "num": "660F",
    "desc": "\nCourses on advanced topics and recent developments.\n",
    "credits": "1"
  },
  {
    "course_name": "Quantum Field Theory I",
    "dept": "PHYS",
    "num": "681",
    "desc": "Prereq: PHYS 564, PHYS 572, PHYS 592\nQuantization of fields (canonical and path integral); Feynman rules; introduction to gauge theories; Quantum Electrodynamics; radiative corrections; renormalization and renormalization group.\n",
    "credits": "3"
  },
  {
    "course_name": "Quantum Field Theory II",
    "dept": "PHYS",
    "num": "682",
    "desc": "Prereq: PHYS 681\nContinuation of 681. Systematics of renormalization; renormalization group methods; symmetries; spontaneous symmetry breaking; non-abelian gauge theories; the Standard Model and beyond; special topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "PHYS",
    "num": "699",
    "desc": "Prereq: Instructor permission required.\nGraduate research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Plant Metabolism",
    "dept": "PLBIO",
    "num": "513",
    "desc": "Prereq: BIOL 330, PHYS 111, CHEM 331; one semester of biochemistry recommended\nPhotosynthesis, respiration, and other aspects of plant metabolism.\n",
    "credits": "2"
  },
  {
    "course_name": "Plant Molecular, Cell and Developmental Biology",
    "dept": "PLBIO",
    "num": "545",
    "desc": "Prereq: BIOL 313, BIOL 314, BIOL 330 or BBMB 405\nPlant nuclear and organelle genomes; regulation of gene expression; hormone signaling; organization, function, and development of plant cells and subcellular structures; regulation of plant growth and development.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Seminar",
    "dept": "PLBIO",
    "num": "696",
    "desc": "\nResearch seminars by faculty and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "PLBIO",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Principles of Plant Pathology",
    "dept": "PL P",
    "num": "408",
    "desc": "Prereq: 8 credits in life sciences, including BIOL 211 or 212.\nBraun. Principles underlying the nature, diagnosis, and management of plant diseases. Laboratory complements lecture topics and provides experience in plant disease diagnosis.\n",
    "credits": "3"
  },
  {
    "course_name": "Forest Insects and Diseases",
    "dept": "PL P",
    "num": "416",
    "desc": "Prereq: 8 credits in biological sciences, including BIOL 211 or equivalent.\nNature of insects and pathogens of forest and shade trees; their role in the dynamics of natural and     managed forest ecosystems; and the management of indigenous and exotic pests.\n",
    "credits": "3"
  },
  {
    "course_name": "Forest Insects and Diseases Laboratory",
    "dept": "PL P",
    "num": "416L",
    "desc": "Prereq: 8 credits in biological sciences, including BIOL 211 or equivalent. Credit or enrollment in PL P 416.\nLaboratory experience working with insect and fungal pests of trees.\n",
    "credits": "1"
  },
  {
    "course_name": "Integrated Management of Diseases and Insect Pests of Turfgrasses",
    "dept": "PL P",
    "num": "452",
    "desc": "Prereq: HORT 351\nIdentification and biology of important diseases and insect pests of turfgrasses. Development of integrated pest management programs in various turfgrass environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Bacterial-Plant Interactions",
    "dept": "PL P",
    "num": "477",
    "desc": "Prereq: 3 credits in microbiology or plant pathology\nOverview of plant-associated bacteria including their ecology, diversity, and the physiological and molecular mechanisms involved with their interactions with plants. The course covers bacterial plant pathogens and pathogenesis, nitrogen fixation and plant symbioses, biological control and plant growth promotion, bacterial disease diagnosis and management, and approaches to the study of microbial communities in the rhizosphere and on leaves.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "PL P",
    "num": "490",
    "desc": "Prereq: Junior or senior classification, 7 credits in biological sciences, permission of instructor\n  A maximum of 6 credits of Pl P 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Plant Pathology",
    "dept": "PL P",
    "num": "490A",
    "desc": "Prereq: Junior or senior classification, 7 credits in biological sciences, permission of instructor\n  A maximum of 6 credits of Pl P 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "PL P",
    "num": "490H",
    "desc": "Prereq: Junior or senior classification, 7 credits in biological sciences, permission of instructor\n  A maximum of 6 credits of Pl P 490 may be used toward the total of 128 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Seed Pathology",
    "dept": "PL P",
    "num": "494",
    "desc": "Prereq: PL P 408\nSignificance of biotic and abiotic diseases that affect the production and utilization of seeds, during each phase of the seed life cycle: growing, harvesting, conditioning, storing, and planting seed. Mechanisms of seed infection and seed-to-seedling transmission are considered for fungi, bacteria, viruses/viroids, and nematodes. Aspects of epidemiology, management, and host-pathogen relationships are discussed. Emphases include the role of seed health testing in the global seed industry for quality control and phytosanitary certification, as well as the use of seed treatments to manage seedborne and soilborne pathogens and pests. Concurrent enrollment in PL P 494L/594L (Seed Pathology Laboratory) is strongly encouraged (on-campus students only).\n  Credit may not be obtained for both Pl P 494/594 and STB/Pl P 592.",
    "credits": "2"
  },
  {
    "course_name": "Seed Pathology Laboratory",
    "dept": "PL P",
    "num": "494L",
    "desc": "Prereq: PL P 408\nLaboratory in seed pathology. Seed health testing methods; effects of seed treatments and seed conditioning on seedborne pathogens.\n",
    "credits": "1"
  },
  {
    "course_name": "Plant-Pathogen Interactions",
    "dept": "PL P",
    "num": "506",
    "desc": "Prereq: PL P 408 or PL P 416, BIOL 313\nBaum, Whitham. Introduction to mechanisms of plant-parasite interaction. Genetics and molecular genetics of plant disease resistance and pathogenicity.\n",
    "credits": "2"
  },
  {
    "course_name": "Principles of Plant Pathology",
    "dept": "PL P",
    "num": "508",
    "desc": "Prereq: 8 credits in life sciences, including BIOL 211 or 212.\nBraun. Principles underlying the nature, diagnosis, and management of plant diseases. Laboratory complements lecture topics and provides experience in plant disease diagnosis.\n",
    "credits": "3"
  },
  {
    "course_name": "Plant Virology",
    "dept": "PL P",
    "num": "509",
    "desc": "Prereq: BIOL 313 or BBMB 301. BIOL 314 recommended.\nTaxonomy, molecular mechanisms, host-interactions, vector transmission, epidemiology, detection, control and exploitation of plant viruses.  Course will consist of a mixture of lectures, and student-led presentations using primary literature.\n",
    "credits": "2"
  },
  {
    "course_name": "Integrated Management of  Tropical Crops",
    "dept": "PL P",
    "num": "511",
    "desc": "Prereq: PL P 408 or PL P 416 or ENT 370 or ENT 376 or HORT 221\nApplications of Integrated Crop Management principles (including plant pathology, entomology, and horticulture) to tropical cropping systems. Familiarization with a variety of tropical agroecosystems and Costa Rican culture is followed by 10-day tour of Costa Rican agriculture during spring break, then writeup of individual projects.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Lifestyles of plant pathogenic fungi and oomycetes.",
    "dept": "PL P",
    "num": "512",
    "desc": "Prereq: PL P 408 or MICRO 456 or equivalent.\nExploration of the major groups of plant pathogenic fungi and oomycetes, focusing on the diseases they cause as well as pathogen ecology, diagnosis, crop resistance, and fungicide resistance.\n",
    "credits": "2"
  },
  {
    "course_name": "Ecologically Based Pest Management Strategies",
    "dept": "PL P",
    "num": "530",
    "desc": "\nDurable, least-toxic strategies for managing weeds, pathogens, and insect pests, with emphasis on underlying ecological processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecology and Epidemiology of Plant Diseases",
    "dept": "PL P",
    "num": "543",
    "desc": "Prereq: PL P 408 or PL P 416\nNutter. Theory and practice related to the ecology and epidemiology of plant disease epidemics.  Interactions among host and   pathogen populations as affected by the environment are quantified with respect to time and space.  Analysis of ecological and   host and pathogen genetic factors that alter the course of plant disease epidemics.  Risk assessment theory, disease forecasting,   and modeling the impact of biotic plant stresses on yield and quality are also emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Integrated Management of Diseases and Insect Pests of Turfgrasses",
    "dept": "PL P",
    "num": "552",
    "desc": "Prereq: HORT 351\nIdentification and biology of important diseases and insect pests of turfgrasses. Development of integrated pest management programs in various turfgrass environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Plant Nematology",
    "dept": "PL P",
    "num": "574",
    "desc": "Prereq: 8 credits  in biological sciences, including BIOL 211 or equivalent\nMorphology, anatomy, identification, management, and life cycles of common plant-parasitic nematodes; host parasite interactions; recent advances in plant nematology.\n",
    "credits": "2"
  },
  {
    "course_name": "Laboratory Techniques in Plant Nematology",
    "dept": "PL P",
    "num": "574L",
    "desc": "Prereq: 8 credits  in biological sciences, including BIOL 211 or equivalent. Must also be registered for PL P 574.\nPractical skills of sample collection, processing, extraction, and identification of plant-parasitic nematodes from soil and roots; other techniques will be discussed.\n",
    "credits": "1"
  },
  {
    "course_name": "Bacterial-Plant Interactions",
    "dept": "PL P",
    "num": "577",
    "desc": "Prereq: 3 credits in microbiology or plant pathology\nOverview of plant-associated bacteria including their ecology, diversity, and the physiological and molecular mechanisms involved with their interactions with plants. The course covers bacterial plant pathogens and pathogenesis, nitrogen fixation and plant symbioses, biological control and plant growth promotion, bacterial disease diagnosis and management, and approaches to the study of microbial communities in the rhizosphere and on leaves.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "PL P",
    "num": "590",
    "desc": "Prereq: 10 credits in biological sciences, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Seed Health Management",
    "dept": "PL P",
    "num": "592",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nOccurrence and management of diseases during seed production, harvest, conditioning, storage, and planting. Emphasis     on epidemiology, disease management in the field, seed treatment, effects of conditioning on seed health, and seed health testing.\n  Credit may not be obtained for both Pl P/STB 592 and Pl P 594.",
    "credits": "2"
  },
  {
    "course_name": "Seed Pathology",
    "dept": "PL P",
    "num": "594",
    "desc": "Prereq: PL P 408\nSignificance of biotic and abiotic diseases that affect the production and utilization of seeds, during each phase of the seed life cycle: growing, harvesting, conditioning, storing, and planting seed. Mechanisms of seed infection and seed-to-seedling transmission are considered for fungi, bacteria, viruses/viroids, and nematodes. Aspects of epidemiology, management, and host-pathogen relationships are discussed. Emphases include the role of seed health testing in the global seed industry for quality control and phytosanitary certification, as well as the use of seed treatments to manage seedborne and soilborne pathogens and pests. Concurrent enrollment in PL P 494L/594L (Seed Pathology Laboratory) is strongly encouraged (on-campus students only).\n  Credit may not be obtained for both Pl P 494/594 and STB/Pl P 592.",
    "credits": "2"
  },
  {
    "course_name": "Seed Pathology Laboratory",
    "dept": "PL P",
    "num": "594L",
    "desc": "Prereq: PL P 408\nLaboratory in seed pathology. Seed health testing methods; effects of seed treatments and seed conditioning on seedborne pathogens.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "PL P",
    "num": "599",
    "desc": "Prereq: For non-thesis Master of Science students.\nIndependent study related to the student's area of specialization and approved by the student's major professor.\n",
    "credits": "arr"
  },
  {
    "course_name": "Molecular Virology",
    "dept": "PL P",
    "num": "608",
    "desc": "Prereq: BBMB 405 or GDCB 511\nAdvanced study of virus host-cell interactions. Molecular mechanisms of viral replication and pathogenesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Improving Professional Presentation Skills",
    "dept": "PL P",
    "num": "628",
    "desc": "Prereq: Graduate student status.\nSkill building to improve oral presentation fundamentals for graduate students in biological sciences. Principles and guidance in both personal speaking style and maximizing impact of presentation software. In-depth lectures and class discussions on all aspects of presentation skills. Video and anonymous peer review of individual speeches.\n",
    "credits": "2"
  },
  {
    "course_name": "Field Plant Pathology",
    "dept": "PL P",
    "num": "691",
    "desc": "Prereq: PL P 408 or PL P 416\nDiagnosis of plant diseases, plant disease assessment methods, and the integration of disease management into commercial crop production practices. Objectives are to familiarize students with common diseases of Midwest crops and landscape plants, and to provide experience in disease diagnosis. Field trips include commercial operations, agricultural research facilities, and ornamental plantings.\n",
    "credits": "2"
  },
  {
    "course_name": "Molecular Biology of Plant-Pathogen Interactions",
    "dept": "PL P",
    "num": "692",
    "desc": "Prereq: PL P 506 or BBMB 405 or GEN 411 or MICRO 402 or strong background in molecular biology\nSeminal and current research in molecular and physiological aspects of plant interactions with pathogens,     including mechanisms of pathogenesis, host-pathogen recognition and host defense, with an emphasis on critical evaluation of     primary literature.  Students also complete a research proposal writing and peer review exercise.\n",
    "credits": "3"
  },
  {
    "course_name": "Colloquium in Plant Pathology",
    "dept": "PL P",
    "num": "694",
    "desc": "Prereq: PL P 408 or PL P 416, permission of instructor\nAdvanced topics in plant pathology, including biological control, cultural control, resistance gene deployment, genetic   engineering for disease resistance, chemical control, integrated pest management, emerging diseases, fungal genetics, insect   vector biology, professional communications, etc.\n",
    "credits": "2"
  },
  {
    "course_name": "Seminar",
    "dept": "PL P",
    "num": "698",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Thesis and Dissertation Research",
    "dept": "PL P",
    "num": "699",
    "desc": "\nF.S.SS.\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to Political Science",
    "dept": "POL S",
    "num": "101",
    "desc": "\nIntroduction to the discipline and sub-fields of Political Science; analytical thinking and research skills relevant to political science.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to American Government",
    "dept": "POL S",
    "num": "215",
    "desc": "\nFundamentals of American democracy; constitutionalism; federalism; rights and duties of citizens; executive, legislative, and judicial branches of government; elections, public opinion, interest groups, and political parties.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Ethics and Politics",
    "dept": "POL S",
    "num": "235",
    "desc": "\nMoral controversies surrounding political issues such as violence, deception, corruption, civil disobedience, democracy, justice, equality, and freedom. Political applications of classic and contemporary texts.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Comparative Government and Politics",
    "dept": "POL S",
    "num": "241",
    "desc": "\nInteractions between governments and citizens in countries outside the US. Causes of democracy, dictatorship, and economic and social development.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to International Politics",
    "dept": "POL S",
    "num": "251",
    "desc": "\nDynamics of interstate relations pertaining to nationalism, the nation state; peace and war; foreign policy making; the national interest; military capability and strategy; case studies of transnational issues, such as population, food, energy, and terrorism.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "POL S",
    "num": "298",
    "desc": "Prereq: Permission of department cooperative education coordinator; sophomore classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Introduction to Empirical Political Science Research",
    "dept": "POL S",
    "num": "301",
    "desc": "Prereq: POL S 101\nTechniques of quantitative and qualitative political research and analysis. Development and analysis of concepts and theories. Methods of data collection, research design, and critical thinking. Applications of statistics to political research.\n",
    "credits": "3"
  },
  {
    "course_name": "Comparative Political Behavior",
    "dept": "POL S",
    "num": "305",
    "desc": "Prereq: Sophomore classification or six credits in political science\nPolitical attitudes and behaviors of citizens in democracies, both in the US and cross-nationally. Citizens' traits and their relationship to democracy.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Opinion and Voting Behavior",
    "dept": "POL S",
    "num": "306",
    "desc": "Prereq: 6 credits in political science or sophomore classification\nThe formation of political opinions and attitudes, political participation, and voting behavior of the general public, and their influences on American politics; polling as a means of assessing public opinions and behaviors.\n",
    "credits": "3"
  },
  {
    "course_name": "State and Local Government",
    "dept": "POL S",
    "num": "310",
    "desc": "Prereq: 3 credits in political science\nRole of state and local governments in the American federal system. Structures of participation: political parties, elections, interest groups. Major governmental institutions: legislative, executive, and judicial. Structure and functions of local governments.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in American Government and Politics",
    "dept": "POL S",
    "num": "312",
    "desc": "\nHalf-semester courses on selected topical issues in American government and politics.\n  A topic may not be taken more than once.",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Theory and Methods",
    "dept": "POL S",
    "num": "313",
    "desc": "\nHalf-semester course on selected topical issues in theory and methods in political science.\n  A topic may not be taken more than once.",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Comparative Politics",
    "dept": "POL S",
    "num": "314",
    "desc": "\nHalf-semester course on selected topical issues in comparative politics.\n  A topic may not be taken more than once.",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in International Relations",
    "dept": "POL S",
    "num": "315",
    "desc": "\nHalf-semester course on selected topical issues in international relations.\n  A topic may not be taken more than once.\nMeets International Perspectives Requirement.\n",
    "credits": "2"
  },
  {
    "course_name": "Campaigns and Elections",
    "dept": "POL S",
    "num": "318",
    "desc": "\nMethods and techniques of political campaigns in general elections. Supervised participation in candidate and political party campaign activities required.\n",
    "credits": "3"
  },
  {
    "course_name": "Law and Politics",
    "dept": "POL S",
    "num": "319",
    "desc": "Prereq: Sophomore standing; POL S 215 recommended\nAmerican judicial system and controversies spanning law and politics.  Potential topics include statutory construction, judicial review, proper role of the judiciary, vagueness and ambiguity in law, competing constitutional philosophies, executive branch concerns, and relative power of different branches.\n",
    "credits": "3"
  },
  {
    "course_name": "American Judicial Process",
    "dept": "POL S",
    "num": "320",
    "desc": "Prereq: POL S 215\nAn overview of the American judicial process.  Emphasis on specific topics such as application of constitutional rights to the states (particularly the Fourth, Fifth, Sixth, and Fourteenth Amendments), mechanics of judicial opinions, constitutional philosophies of Supreme Court Justices, decisions of first impression, and the value and scope of precedent.\n",
    "credits": "3"
  },
  {
    "course_name": "Democracy and Diversity in America",
    "dept": "POL S",
    "num": "333",
    "desc": "Prereq: Sophomore classification.\nCompeting American conceptions of democracy as strategies for responding to the racial, religious, ethnic, gender, and economic diversity of America.  Contemporary debates about topics such as immigration, affirmative action, multicultural education, religion, and minority representation.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Politics and Society",
    "dept": "POL S",
    "num": "334",
    "desc": "Prereq: A course in political science or sociology\nThe relationship between politics and society with emphasis on American society. Discussion of theories of inequality, power, social movements, elites, ruling classes, democracy, and capitalism.\n",
    "credits": "3"
  },
  {
    "course_name": "Science, Technology, and Public Policy",
    "dept": "POL S",
    "num": "335",
    "desc": "\nExamines the history and political dynamics of public science and technology policies. Examines differences in political and technological orientations. Assessment of the roles of politics, media, engineering, science, and private business in the formation public policies that put heavy reliance on or seek to advance science and technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Liberty and Law in America",
    "dept": "POL S",
    "num": "339",
    "desc": "Prereq: Sophomore status\nCompeting conceptions of liberty in American political thought. Debates about how liberty should be protected by the law, in fields such as health care, drugs, property, speech, religion, and sex.\n",
    "credits": "3"
  },
  {
    "course_name": "Politics of Developing Areas",
    "dept": "POL S",
    "num": "340",
    "desc": "\nEconomic and political development as they relate to the political process of developing states. Impact of social and technological change on political systems of developing areas.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Chinese Politics",
    "dept": "POL S",
    "num": "342",
    "desc": "\nLegacies of Imperial China, the origins of the Chinese Civil War, and the causes and consequences of the reform era.  Issues of contemporary China, including economic transformation, the structure of the Party/state, the environment, the media and other topics.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Government and Politics",
    "dept": "POL S",
    "num": "343",
    "desc": "\nPolitical institutions, processes, and contemporary issues. Selected countries examined intensively to illustrate generalizations. Role of parties, military, church, human rights, women, environmental issues, interest groups, ideology, and globalization.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Policy",
    "dept": "POL S",
    "num": "344",
    "desc": "\nHow agendas come to be set in public policy, theories describing the policy-making process, forces molding policy choices and the impact of such choices.\n",
    "credits": "3"
  },
  {
    "course_name": "European Politics",
    "dept": "POL S",
    "num": "346",
    "desc": "\nComparative study of political institutions of Europe and the European Union; emphasis on parties, elections, and governmental structures. Substance and process of public policies in selected problem areas.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "British Government and Politics",
    "dept": "POL S",
    "num": "348",
    "desc": "Prereq: POL S 215 or POL S 241\nPolitical institutions and processes in Great Britain and Northern Ireland; emphasis on Parliament, executive and monarchy, and public policies, including devotion.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Politics of Russia and Eastern Europe",
    "dept": "POL S",
    "num": "349",
    "desc": "\nNation-states of Central and Eastern Europe. Comparison of European communist systems and the revolutionary conflict leading to the dissolution of communist Europe. Political analysis of post-communist Russian and Eastern European nation-states and their economic, cultural and social variations.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Politics of the Middle East",
    "dept": "POL S",
    "num": "350",
    "desc": "\nIntroduction to the Middle East as a region and to issues of political importance to the Middle East and its place in the world. Topics covered include political Islam, regional conflicts and alliances, local leaders, political economy, democracy, and human rights.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Immigration Policy",
    "dept": "POL S",
    "num": "353",
    "desc": "\nPolitical, economic, and social factors that affect immigration policy. Systematic analysis and implications of different types of immigration policies in countries sending and receiving immigrants. Policies regarding incorporation of migrants into, and effects of migrants on, American society.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "War and the Politics of Humanitarianism",
    "dept": "POL S",
    "num": "354",
    "desc": "Prereq: POL S 235, POL S 251, Anthr 210, or ANTHR 230\nHumanitarianism as a system of thought and a system of intervention in conflict and post-conflict situations. Role of humanitarian organizations and actors in addressing human suffering caused by conflict or war. Military action as a form of humanitarian intervention.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "War and Politics",
    "dept": "POL S",
    "num": "355",
    "desc": "Prereq: None\nTheoretical relationship among politics, strategy, and war.  Evolution of war, the relationship between technology and conflict, and the changing causes and nature of global violence.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Theories of International Politics",
    "dept": "POL S",
    "num": "356",
    "desc": "\nIntroduction to essential theoretical concepts and approaches, both classical and contemporary on world politics including realism, empiricism, liberalism, and postpositivism; for example, war and conflict, peace and cooperation, political economy, crisis decision-making, systemic theory, dependence and interdependence.\n",
    "credits": "3"
  },
  {
    "course_name": "International Security Policy",
    "dept": "POL S",
    "num": "357",
    "desc": "\nMajor theoretical approaches in security policy: strategy and deterrence, game theory, bargaining theory, compellence, coercive diplomacy, and crisis diplomacy. Illustration of these approaches through historical and contemporary cases.\n",
    "credits": "3"
  },
  {
    "course_name": "United States Foreign Policy",
    "dept": "POL S",
    "num": "358",
    "desc": "Prereq: POL S 215 or POL S 251, or HIST 467 or HIST 470 or HIST 471\nU.S. foreign policy since World War II with emphasis on changing American values in foreign policy, the role of the President, Congress, and the bureaucracy in policy making, and a survey of current foreign policy issues and problems.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in American Foreign Policy",
    "dept": "POL S",
    "num": "359",
    "desc": "Prereq: POL S 215, POL S 251, or POL S 358\nExamination of contemporary U.S. foreign policy issues (e.g., U.S. policy in the Middle East; defense budgeting in the post-Cold War era; conventional and nuclear arms control policy). The course will explore alternate methods to analyze policy, survey the evolution of each issue, and discuss different policy alternatives.\n",
    "credits": "3"
  },
  {
    "course_name": "American Institutions:  Congress",
    "dept": "POL S",
    "num": "360",
    "desc": "Prereq: POL S 215\nTheory and practice of representation and deliberation in the legislative branch of the republic; operations of Congress in terms of its committees, leadership, legislative and oversight processes, partisan politics, electoral campaigns, service to local and special electoral campaigns, service to local and special interests, and interactions with the President.\n",
    "credits": "3"
  },
  {
    "course_name": "American Institutions:  The Presidency",
    "dept": "POL S",
    "num": "361",
    "desc": "Prereq: POL S 215\nCreation and historical development of the office of chief executive; character and behavior of past chief executives; selection and control; powers, roles, functions; executive staff; relations with Congress, press, public opinion.\n",
    "credits": "3"
  },
  {
    "course_name": "The Judiciary",
    "dept": "POL S",
    "num": "362",
    "desc": "\nJudicial review, federal common law, judicial confirmation, strict construction of the Constitution, and qualifications to serving on Courts; judicial activism and the infusion of politics into courts.\n",
    "credits": "3"
  },
  {
    "course_name": "American Institutions:  Media",
    "dept": "POL S",
    "num": "363",
    "desc": "Prereq: Sophomore standing\nInfluence of mass media organizations, forms, techniques, and technologies on the practices and expectations of American politics. Role of media in the political process, including promoting or discouraging political participation. Politics of traditional journalism, devices of propaganda, effects of campaign advertising, and media spectacles.\n",
    "credits": "3"
  },
  {
    "course_name": "Political Parties and Interest Groups",
    "dept": "POL S",
    "num": "364",
    "desc": "Prereq: POL S 215; sophomore classification\nNature of political parties and interest groups, their relation to each other, and their effects on American politics.  Topics include party identification, party organization and mobilization, factionalism, lobbying, campaign contributions and financing, and the effects of special interests on public law.\n",
    "credits": "3"
  },
  {
    "course_name": "Religion and Politics",
    "dept": "POL S",
    "num": "370",
    "desc": "Prereq: Sophomore classification.\nThe interaction of religion and politics in the U.S. from both an historical and contemporary perspective, as well   as the role of religion in politics internationally.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Organizations and Leadership",
    "dept": "POL S",
    "num": "371",
    "desc": "Prereq: Sophomore classification\nA survey of the historic and contemporary administrative realities that contribute to the unique challenges of public governance at the administrative and managerial levels of international, national, state, and local government. This introductory course explores the essential issues and competencies involved in the efficient, effective, and ethical provision of public goods and services. Critical topics addressed in the course include crisis management, intergovernmental relations, social equity, public-private partnerships, and privatization.\n",
    "credits": "3"
  },
  {
    "course_name": "International Political Economy",
    "dept": "POL S",
    "num": "381",
    "desc": "\nTheoretical perspectives on international political economy. Exploration of specific issues such as the changing international trade regime, international finance, exchange rates and monetary policy, and development under conditions of globalization.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Politics and Policies",
    "dept": "POL S",
    "num": "383",
    "desc": "Prereq: sophomore classification\nMajor ideologies' relations to conservation and ecology. Processes, participants, and institutions involved in state, national, and global environmental policymaking. Case studies of environmental controversies and proposals for policy reform.\n",
    "credits": "3"
  },
  {
    "course_name": "Women in Politics",
    "dept": "POL S",
    "num": "385",
    "desc": "\nEntry and participation of women in politics in the United States and other countries. Contemporary issues and strategies for change through the political process.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Writing in Political Science",
    "dept": "POL S",
    "num": "395",
    "desc": "\nTaken in conjunction with 300- or 400-level Political Science courses.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "International Study and Travel",
    "dept": "POL S",
    "num": "397",
    "desc": "Prereq: Permission of instructor.\nSupervised study in an aspect of discipline while traveling or located in a foreign country.\n\nMeets International Perspectives Requirement.\n",
    "credits": "arr"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "POL S",
    "num": "398",
    "desc": "Prereq: Permission of department cooperative education coordinator; junior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Legal Analysis",
    "dept": "POL S",
    "num": "402",
    "desc": "Prereq: Junior classification or permission of instructor.\nIntroduction to the style of legal analysis traditionally used in American law schools to teach law and prepare for legal practice. Topics include case briefing, legal citation, application of legal doctrines, and adversarial argument.\n",
    "credits": "3"
  },
  {
    "course_name": "Proseminar in Public Policy",
    "dept": "POL S",
    "num": "407",
    "desc": "Prereq: Six credits in political science or graduate standing\nAn overview of the major theoretical approaches and empirical methods relevant to the study of public policy. Emphasis is placed on agenda setting, policy formation, policy sustainability, and policy analysis. Seminal writings by leading scholars will be reviewed. Leading quantitative and qualitative methodological tools for analyzing policy are presented.\n",
    "credits": "3"
  },
  {
    "course_name": "Political Game Theory",
    "dept": "POL S",
    "num": "409",
    "desc": "Prereq: ECON 101\nApplication of economics to political science in the study of nonmarket decision-making. Behavior of bureaucrats, elected officials, and voters. Market failure, collective action, representative democracies, direct democracies, logrolling, voter paradoxes, and game theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Intergovernmental Relations",
    "dept": "POL S",
    "num": "413",
    "desc": "Prereq: 6 credits in POL S\nTheories and practices of the American federal system. Politics and policy making among federal, state, and local governments.\n",
    "credits": "3"
  },
  {
    "course_name": "Campaign Rhetoric",
    "dept": "POL S",
    "num": "417",
    "desc": "Prereq: SP CM 212\nBackgrounds of candidates for state and national elections; selected speeches and issues; persuasive strategies and techniques of individual speakers.\n",
    "credits": "3"
  },
  {
    "course_name": "Constitutional Law",
    "dept": "POL S",
    "num": "420",
    "desc": "Prereq: POL S 215; junior classification\nDevelopment of the United States Constitution through judicial action; influence of public law and judicial interpretations upon American government and society.\n",
    "credits": "3"
  },
  {
    "course_name": "Constitutional Freedoms",
    "dept": "POL S",
    "num": "421",
    "desc": "Prereq: POL S 320 or POL S 420\nLeading Supreme Court cases interpreting the Bill of Rights and the Fourteenth Amendment. Emphasis on religion, speech, privacy, due process, and equal protection.\n",
    "credits": "3"
  },
  {
    "course_name": "International Law",
    "dept": "POL S",
    "num": "422",
    "desc": "Prereq: POL S 215 or POL S 251; junior classification\nLegal aspects of international activities: state jurisdiction over territories and subjects, law of the sea, use of force, and judicial settlement of international disputes.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Western Political Thought",
    "dept": "POL S",
    "num": "430",
    "desc": "Prereq: 6 credits in political science, philosophy, or European history\nStudy of original texts in political thought ranging from the classical period to the renaissance. Topics such as justice, freedom, virtue, the allocation of political power, the meaning of democracy, human nature, and natural law.\n",
    "credits": "3"
  },
  {
    "course_name": "Modern Political Thought",
    "dept": "POL S",
    "num": "431",
    "desc": "Prereq: 6 credits in political science, philosophy, or European history\nStudy of original texts in political thought ranging from the Reformation to the French Revolution and its aftermath. Topics such as justice, freedom, rights, democracy, toleration, property, power, skepticism, and normative views of international politics.\n",
    "credits": "3"
  },
  {
    "course_name": "The Policy and Politics of Coastal Areas",
    "dept": "POL S",
    "num": "442",
    "desc": "\nExploration of political implications of coastal policy. Issues include: \"Carrying capacity,\" zoning, regulation of human development activities, trade-offs between conservation and jobs, the quality of coastal lifestyle, ways in which citizens participate in policy for coastal areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Comparative Foreign Policy",
    "dept": "POL S",
    "num": "452",
    "desc": "Prereq: POL S 251\nTheoretical approaches to understanding foreign policy making and behavior through case studies of selected nations.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "International Organization",
    "dept": "POL S",
    "num": "453",
    "desc": "Prereq: POL S 251\nSources of international order in a variety of substantive areas such as international security, international trade and finance, the environment, and human rights: distribution of power, institutions, international law, and norms.\n",
    "credits": "3"
  },
  {
    "course_name": "American Political Institutions",
    "dept": "POL S",
    "num": "460",
    "desc": "Prereq: 6 credits in American government\nExamination of policy-making and governance in a separation of powers system. Interaction between the chief executive, the legislature, administrative agencies, and the public. How political and legal forces affect policy makers and are reflected in public policies and programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Management in the Public Sector",
    "dept": "POL S",
    "num": "475",
    "desc": "Prereq: POL S 371\nLiterature and research on organizational behavior and management theory with emphasis on applied aspects of managing contemporary public-sector organizations. Distinctions between public and private organizations, leadership, productivity, employee motivation, organizational structure, and organizational change.\n",
    "credits": "3"
  },
  {
    "course_name": "Government, Business, and Society",
    "dept": "POL S",
    "num": "477",
    "desc": "Prereq: 6 credits of POL S\nDiverse perspectives on the changing roles and relationships of business, government, and society for more effective policy decisions on corporate affairs. The changing economy; transformation of workplace and community conditions; consumerism; social responsibilities of businesses; economic policies and regulations; politics in the business-government relationship.\n",
    "credits": "3"
  },
  {
    "course_name": "Ethics and Public Policy",
    "dept": "POL S",
    "num": "480",
    "desc": "Prereq: 6 credits in political science\nStudy of decision making approaches and application to case studies.  Topics such as the different roles of public officials, proper scope and use of administrative discretion, and the admissibility of religious, political, and philosophical commitments in governmental decision making.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Democracy",
    "dept": "POL S",
    "num": "487",
    "desc": "Prereq: Sophomore standing\nImpact of computers and the Internet on politics and policy.  Positive and negative effects of information technology (IT) on selected topics such as hacking, cybercrime, cyberterrorism, cyberwarfare, privacy, civic participation, the sense of community, virtual cities, interest group behavior, viral media, campaigns, elections, and voting.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "POL S",
    "num": "490",
    "desc": "Prereq: 6 credits in political science\nSpecial studies in the political institutions, processes and policies of American, foreign, and international governments. Also, studies in traditional and behavioral political theory. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  No more than 9 credits of Pol S 490 may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: American Government and Politics",
    "dept": "POL S",
    "num": "490A",
    "desc": "Prereq: 6 credits in political science\nSpecial studies in the political institutions, processes and policies of American, foreign, and international governments. Also, studies in traditional and behavioral political theory. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  No more than 9 credits of Pol S 490 may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Theory and Method",
    "dept": "POL S",
    "num": "490B",
    "desc": "Prereq: 6 credits in political science\nSpecial studies in the political institutions, processes and policies of American, foreign, and international governments. Also, studies in traditional and behavioral political theory. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  No more than 9 credits of Pol S 490 may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Comparative Politics",
    "dept": "POL S",
    "num": "490C",
    "desc": "Prereq: 6 credits in political science\nSpecial studies in the political institutions, processes and policies of American, foreign, and international governments. Also, studies in traditional and behavioral political theory. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  No more than 9 credits of Pol S 490 may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: International Relations",
    "dept": "POL S",
    "num": "490D",
    "desc": "Prereq: 6 credits in political science\nSpecial studies in the political institutions, processes and policies of American, foreign, and international governments. Also, studies in traditional and behavioral political theory. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  No more than 9 credits of Pol S 490 may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Extended credit",
    "dept": "POL S",
    "num": "490E",
    "desc": "Prereq: 6 credits in political science\nExtra study for any 300-Special studies in the political institutions, processes and policies of American, foreign, and international governments. Also, studies in traditional and behavioral political theory. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  No more than 9 credits of Pol S 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "POL S",
    "num": "490H",
    "desc": "Prereq: 6 credits in political science\nSpecial studies in the political institutions, processes and policies of American, foreign, and international governments. Also, studies in traditional and behavioral political theory. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  No more than 9 credits of Pol S 490 may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Senior Thesis",
    "dept": "POL S",
    "num": "491",
    "desc": "Prereq: 21 credits of POL S and permission of instructor\nWritten under the supervision of a Political Science faculty advisor.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Internship in Political Science",
    "dept": "POL S",
    "num": "496",
    "desc": "Prereq: 12 credits in political science and permission of instructor\nUndergraduate teaching experience through assisting an instructor with an introductory course in political science. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Research Internship in Political Science",
    "dept": "POL S",
    "num": "497",
    "desc": "Prereq: 12 credits in political science and permission of instructor\nUndergraduate research experience through assisting on a scholarly project with an instructor in political science. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "POL S",
    "num": "498",
    "desc": "Prereq: Permission of department cooperative education coordinator; senior classification\nRequired of all cooperative education students. Students must register for this course prior to commencing each work period.\n",
    "credits": "R"
  },
  {
    "course_name": "Internship in Political Science",
    "dept": "POL S",
    "num": "499",
    "desc": "Prereq: 6 credits in political science; junior or senior classification; and permission of internship coordinator\nWork experience with a specific nongovernmental or governmental agency at the local, state, national, or international level, combined with academic work under faculty supervision. Use of credit in Pol S major and minor is limited. See Undergraduate Study for information.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Political Analysis and Research",
    "dept": "POL S",
    "num": "502",
    "desc": "Prereq: 6 credits in political science\nScope and methods of political science. Introduction to theoretical approaches and analytical reasoning in political science. Relationship of theory and data. Research design.\n",
    "credits": "3"
  },
  {
    "course_name": "Proseminar in International Politics",
    "dept": "POL S",
    "num": "504",
    "desc": "Prereq: 6 credits in political science or graduate standing\nOverview of major theoretical and empirical works in the study of international politics and foreign policy. Realism, liberalism, and constructivism; conflict, alliances, and international economic relations.\n",
    "credits": "3"
  },
  {
    "course_name": "Proseminar in Comparative Politics",
    "dept": "POL S",
    "num": "505",
    "desc": "Prereq: 6 credits in political science or graduate standing\nFoundations of comparative politics, the study of different political regimes. Political behavior, development, causes and consequences of democracy and authoritarianism. Contrasting research methods and designs.\n",
    "credits": "3"
  },
  {
    "course_name": "Proseminar in American Politics",
    "dept": "POL S",
    "num": "506",
    "desc": "Prereq: 6 credits in political science or graduate standing\nMajor theories and research on American government and politics. Modern democratic theory, institutional performance, and mass political behavior. Research methodologies including normative theory, behavioralism, and rational choice analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Proseminar in Public Policy",
    "dept": "POL S",
    "num": "507",
    "desc": "Prereq: Six credits in political science or graduate standing\nAn overview of the major theoretical approaches and empirical methods relevant to the study of public policy. Emphasis is placed on agenda setting, policy formation, policy sustainability, and policy analysis. Seminal writings by leading scholars will be reviewed. Leading quantitative and qualitative methodological tools for analyzing policy are presented.\n",
    "credits": "3"
  },
  {
    "course_name": "Political Game Theory",
    "dept": "POL S",
    "num": "509",
    "desc": "Prereq: ECON 101\nApplication of economics to political science in the study of nonmarket decision-making. Behavior of bureaucrats, elected officials, and voters. Market failure, collective action, representative democracies, direct democracies, logrolling, voter paradoxes, and game theory.\n",
    "credits": "3"
  },
  {
    "course_name": "State Government and Politics",
    "dept": "POL S",
    "num": "510",
    "desc": "Prereq: POL S 310\nComparative analysis of state political systems.  Role of interest groups, political parties, legislatures, courts, and governors in state politics.  Possible determinants of public policy outputs at the state level.\n",
    "credits": "3"
  },
  {
    "course_name": "Intergovernmental Relations",
    "dept": "POL S",
    "num": "513",
    "desc": "Prereq: 6 credits in POL S\nTheories and practices of the American federal system. Politics and policy making among federal, state, and local governments.\n",
    "credits": "3"
  },
  {
    "course_name": "Biorenewables Law and Policy",
    "dept": "POL S",
    "num": "515",
    "desc": "\nEvaluation of the biorenewables field as it relates to the areas of law and policy. Primary emphasis on the following topics: concerns that motivated the development and expansion of the biorenewables field, a history of the interactions between biorenewable pathways. U.S. law and policy and controversies that have arisen from these interactions and their effects.\n",
    "credits": "3"
  },
  {
    "course_name": "International Biorenewables Law & Policy",
    "dept": "POL S",
    "num": "516",
    "desc": "\nEvaluation of the international biorenewables field as it relates to the areas of law and policy. Primary emphasis on the following topics: concerns that motivated the development and expansion of the field by adopting countries, a history of the interactions between biorenewable pathways. Law and policy in adopting countries and international controversies that have arisen from these interactions and their effects.\n",
    "credits": "3"
  },
  {
    "course_name": "International Law",
    "dept": "POL S",
    "num": "522",
    "desc": "Prereq: POL S 215 or POL S 251; junior classification\nLegal aspects of international activities: state jurisdiction over territories and subjects, law of the sea, use of force, and judicial settlement of international disputes.\n",
    "credits": "3"
  },
  {
    "course_name": "Mass Political Behavior",
    "dept": "POL S",
    "num": "525",
    "desc": "Prereq: 6 credits in Political Science or graduate standing\nAn in-depth survey of the theoretical, empirical, and methodological works concerning mass political behavior in the United States. Substantive topics include political attitudes and ideologies, public opinion and voting behavior, and political psychology. Methods for studying mass behavior include survey research and experimental approaches.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Western Political Thought",
    "dept": "POL S",
    "num": "530",
    "desc": "Prereq: 6 credits in political science, philosophy, or European history\nStudy of original texts in political thought ranging from the classical period to the renaissance. Topics such as justice, freedom, virtue, the allocation of political power, the meaning of democracy, human nature, and natural law.\n",
    "credits": "3"
  },
  {
    "course_name": "Modern Political Thought",
    "dept": "POL S",
    "num": "531",
    "desc": "Prereq: 6 credits in political science, philosophy, or European history\nStudy of original texts in political thought ranging from the Reformation to the French Revolution and its aftermath. Topics such as justice, freedom, rights, democracy, toleration, property, power, skepticism, and normative views of international politics.\n",
    "credits": "3"
  },
  {
    "course_name": "E-goverment and Information Policy",
    "dept": "POL S",
    "num": "533",
    "desc": "\nLegal and policy context of E-government development.  Legal and regulatory policies on information management in governments, public policies that use information technologies to address economic and social concerns, and impacts on citizens and governmental organizations.\n",
    "credits": "3"
  },
  {
    "course_name": "Legal and Ethical Issues in Information Assurance",
    "dept": "POL S",
    "num": "534",
    "desc": "Prereq: Graduate classification; CPR E 531 or INFAS 531\nLegal and ethical issues in computer security. State and local codes and regulations. Privacy issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Political Philosophy",
    "dept": "POL S",
    "num": "535",
    "desc": "Prereq: 6 credits of philosophy or political science\nExamination of theories of justice proposed by contemporary political philosophers. Analysis of the philosophical foundations of perspectives such as liberalism, libertarianism, communitarianism, socialism, feminism. Normative assessments of socio-political institutions.\n",
    "credits": "3"
  },
  {
    "course_name": "The Policy and Politics of Coastal Areas",
    "dept": "POL S",
    "num": "542",
    "desc": "\nExploration of political implications of coastal policy. Issues include: \"Carrying capacity,\" zoning, regulation of human development activities, tradeoffs between conservation and jobs, the quality of coastal lifestyle, and ways in which citizens participate in policy for coastal areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Comparative Public Policy",
    "dept": "POL S",
    "num": "544",
    "desc": "Prereq: 6 credits in political science\nHow, why and to what effect governments deal with substantive policy problems differently.  Environmental factors, ideologies, cultures, domestic policy making processes, and interest groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Comparative Foreign Policy",
    "dept": "POL S",
    "num": "552",
    "desc": "Prereq: POL S 251\nTheoretical approaches to understanding foreign policy making and behavior through case studies of selected nations.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "International Organization",
    "dept": "POL S",
    "num": "553",
    "desc": "Prereq: POL S 251\nSources of international order in a variety of substantive areas such as international security, international trade and finance, the environment, and human rights: distribution of power, institutions, international law, and norms.\n",
    "credits": "3"
  },
  {
    "course_name": "American Political Institutions",
    "dept": "POL S",
    "num": "560",
    "desc": "Prereq: 6 credits in American government\nExamination of policy-making and governance in a separation of powers system. Interaction between the chief executive, the legislature, administrative agencies, and the public. How political and legal forces affect policy makers and are reflected in public policies and programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Public Administration",
    "dept": "POL S",
    "num": "569",
    "desc": "Prereq: Graduate classification\nSocial, political, intellectual, and environmental factors contributing to the historical development and central issues of American Public Administration. Exploration of classic and contemporary texts of public administration emphasizing constitutional and civic roles of public servants, administrative responsibility in democratic governance and justice, and essential frameworks to identify managerial skills, perspectives, and resources for effective, equitable public service.\n",
    "credits": "3"
  },
  {
    "course_name": "Politics and Management of Nonprofit Organizations",
    "dept": "POL S",
    "num": "570",
    "desc": "Prereq: Graduate classification\nDiscussion of contemporary issues and perspectives shaping the policy development and management of national and international nonprofit organizations. Topics include an historic overview of nonprofit and philanthropic perspectives; exploration of nonprofit organization roles in public service provision; review of the legal framework influencing nonprofit governance; and consideration of capacity building issues such as strategic planning, board development, fundraising, human resources, and volunteer management.\n",
    "credits": "3"
  },
  {
    "course_name": "Organizational Theory in the Public Sector",
    "dept": "POL S",
    "num": "571",
    "desc": "Prereq: Graduate classification\nMajor theories of administrative organization, including motivations of administrators and organizations, comparisons of organizational arrangements, factors affecting organizational arrangements, and formal and informal decision-making structures.\n",
    "credits": "3"
  },
  {
    "course_name": "Public  Finance and Budgeting",
    "dept": "POL S",
    "num": "572",
    "desc": "Prereq: Graduate classification\nFiscal role of government in a mixed economy; evaluation of sources of public revenue and credit; administrative, political, and institutional aspects of the budget and the budgetary process; alternative budget formats; skills required to analyze public revenue and spending. Spreadsheet use required.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Personnel Administration",
    "dept": "POL S",
    "num": "573",
    "desc": "Prereq: Graduate classification\nHistory and development of high-performance personnel administration in the public and nonprofit sectors regarding strategic planning, employee rights and responsibilities, performance assessment, collective bargaining, and civil-service systems. Basic competencies in the essential human resource management tools in recruitment, retention, employee development, compensation, discipline, and conflict resolution.\n",
    "credits": "3"
  },
  {
    "course_name": "Policy and Program Evaluation",
    "dept": "POL S",
    "num": "574",
    "desc": "Prereq: Graduate classification or 6 credits of political science\nIntegration, application, and utilization of public administration and public policy concepts in the interpretation of results and effectiveness of public programs and the prediction of consequences for policymakers and administrators.\n",
    "credits": "3"
  },
  {
    "course_name": "Management in the Public Sector",
    "dept": "POL S",
    "num": "575",
    "desc": "Prereq: POL S 371\nLiterature and research on organizational behavior and management theory with emphasis on applied aspects of managing contemporary public-sector organizations. Distinctions between public and private organizations, leadership, productivity, employee motivation, organizational structure, and organizational change.\n",
    "credits": "3"
  },
  {
    "course_name": "Government, Business, and Society",
    "dept": "POL S",
    "num": "577",
    "desc": "Prereq: 6 credits of POL S\nDiverse perspectives on the changing roles and relationships of business, government, and society for more effective policy decisions on corporate affairs. The changing economy; transformation of workplace and community conditions; consumerism; social responsibilities of businesses; economic policies and regulations; politics in the business-government relationship.\n",
    "credits": "3"
  },
  {
    "course_name": "Ethics and Public Policy",
    "dept": "POL S",
    "num": "580",
    "desc": "Prereq: 6 credits in political science\nStudy of decision making approaches and application to case studies.  Topics such as the different roles of public officials, proper scope and use of administrative discretion, and the admissibility of religious, political, and philosophical commitments in governmental decision making.\n",
    "credits": "3"
  },
  {
    "course_name": "International Political Economy",
    "dept": "POL S",
    "num": "581",
    "desc": "Prereq: 6 credits in political science\nPolicy and politics surrounding trade, exchange-rate, and finance. Role of international actors in economic development; international organizations such as the World Trade Organization, International Monetary Fund, and World bank; globalization.\n",
    "credits": "3"
  },
  {
    "course_name": "Electronic Democracy",
    "dept": "POL S",
    "num": "587",
    "desc": "Prereq: Sophomore standing\nImpact of computers and the Internet on politics and policy.  Positive and negative effects of information technology (IT) on selected topics such as hacking, cybercrime, cyberterrorism, cyberwarfare, privacy, civic participation, the sense of community, virtual cities, interest group behavior, viral media, campaigns, elections, and voting.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "POL S",
    "num": "590",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: American Political Institutions",
    "dept": "POL S",
    "num": "590A",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Public Law",
    "dept": "POL S",
    "num": "590B",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Political Theory and Methodology",
    "dept": "POL S",
    "num": "590C",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Comparative Government",
    "dept": "POL S",
    "num": "590D",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: International Relations",
    "dept": "POL S",
    "num": "590E",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Policy Process",
    "dept": "POL S",
    "num": "590F",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Public Administration and Public Policy",
    "dept": "POL S",
    "num": "590G",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Internship",
    "dept": "POL S",
    "num": "590I",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics: Teaching Preparation",
    "dept": "POL S",
    "num": "590T",
    "desc": "Prereq: 15 credits in political science, written permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Graduate Student Internship",
    "dept": "POL S",
    "num": "598",
    "desc": "Prereq: 15 credits in political science, permission of the instructor\nSupervised internship with administrative agencies, legislative organizations, judicial branch offices, and nonprofit groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "POL S",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Graduate Seminars",
    "dept": "POL S",
    "num": "610",
    "desc": "Prereq: 15 credits in political science\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminars: American Political Institutions",
    "dept": "POL S",
    "num": "610A",
    "desc": "Prereq: 15 credits in political science\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminars: Public Law",
    "dept": "POL S",
    "num": "610B",
    "desc": "Prereq: 15 credits in political science\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminars: Political Theory and Methodology",
    "dept": "POL S",
    "num": "610C",
    "desc": "Prereq: 15 credits in political science\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminars: Comparative Government",
    "dept": "POL S",
    "num": "610D",
    "desc": "Prereq: 15 credits in political science\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminars: International Relations",
    "dept": "POL S",
    "num": "610E",
    "desc": "Prereq: 15 credits in political science\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminars: Policy Process",
    "dept": "POL S",
    "num": "610F",
    "desc": "Prereq: 15 credits in political science\n",
    "credits": "3"
  },
  {
    "course_name": "Graduate Seminars: Public Administration and Public Policy",
    "dept": "POL S",
    "num": "610G",
    "desc": "Prereq: 15 credits in political science\n",
    "credits": "3"
  },
  {
    "course_name": "Thesis",
    "dept": "POL S",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Elementary Portuguese I",
    "dept": "PORT",
    "num": "101",
    "desc": "\nAn introduction to the Portuguese language through the communicative approach within the context of Luso-Brazilian culture.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Portuguese II",
    "dept": "PORT",
    "num": "102",
    "desc": "Prereq: PORT 101\nAn introduction to the Portuguese language through the communicative approach within the context of Luso-Brazilian culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Portuguese, Accelerated I",
    "dept": "PORT",
    "num": "111",
    "desc": "Prereq: Four semesters of college Spanish or the equivalent. Students with four semesters at the college level or the equivalent of another Romance language may be admitted by permission of the instructor\nAn introduction to the Portuguese language through the communicative approach within the context of Luso-Brazilian culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Elementary Portuguese, Accelerated II",
    "dept": "PORT",
    "num": "112",
    "desc": "Prereq: PORT 111\nAn introduction to the Portuguese language through the communicative approach within the context of Luso-Brazilian culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Brazil Today",
    "dept": "PORT",
    "num": "375",
    "desc": "Prereq: None\nA survey of social, political, economic, and cultural topics relevant to contemporary Brazil. Includes an introduction to Portuguese language.\n  None\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Psychology",
    "dept": "PSYCH",
    "num": "101",
    "desc": "\nFundamental psychological concepts derived from the application of the scientific method to the study of behavior and mental processes. Applications of psychology.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Introductory Psychology",
    "dept": "PSYCH",
    "num": "102",
    "desc": "Prereq: Credit or enrollment in PSYCH 101\nLaboratory to accompany 101.\n",
    "credits": "1"
  },
  {
    "course_name": "Orientation to Psychology",
    "dept": "PSYCH",
    "num": "111",
    "desc": "\nProgram requirements and degree/career options. Required of psychology majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Psychology Learning Community Seminar",
    "dept": "PSYCH",
    "num": "112",
    "desc": "Prereq: Participation in Freshman Learning Community\nTopics include orientation to academic program requirements, career awareness, strategies for successful transition to college, connections with other disciplines, and applying psychology via service learning opportunities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Academic Learning Skills",
    "dept": "PSYCH",
    "num": "131",
    "desc": "\nEvidence-based approach to learning and applying academic skills such as time management, note-taking, reading, test preparation, goal setting and motivation, and well-being. Hybrid course structured in a team-based learning format.\n",
    "credits": "1"
  },
  {
    "course_name": "Developmental Psychology",
    "dept": "PSYCH",
    "num": "230",
    "desc": "\nLife-span development of physical traits, cognition, intelligence, language, social and emotional behavior, personality, and adjustment.\n",
    "credits": "3"
  },
  {
    "course_name": "Psychology of the Workplace",
    "dept": "PSYCH",
    "num": "250",
    "desc": "\nSurvey of theories and research methods of psychology applied to the workplace. Consideration of employee selection, training, performance evaluation, leadership, work groups, employee motivation, job attitudes and behaviors, organizational culture, organizational development, human factors, and job design from the scientist-practitioner approach.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Psychology",
    "dept": "PSYCH",
    "num": "280",
    "desc": "\nIndividual human behavior in social contexts. Emphasis on social judgments and decisions, attitudes, perceptions of others, social influence, aggression, stereotypes, and helping.\n",
    "credits": "3"
  },
  {
    "course_name": "Introductory Research Experience",
    "dept": "PSYCH",
    "num": "291",
    "desc": "Prereq: PSYCH 101, sophomore classification, and permission of intructor.\nBeginning level supervised research experience in a faculty laboratory.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research Design and Methodology",
    "dept": "PSYCH",
    "num": "301",
    "desc": "Prereq: STAT 101; 1 course in psychology\nOverview of the principal research techniques used in psychology with an emphasis on the statistical analysis of psychological data.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Psychology",
    "dept": "PSYCH",
    "num": "302",
    "desc": "Prereq: PSYCH 301, ENGL 250\nDiscussion of and experience in designing research studies, collecting and analyzing data, and preparing research reports in psychology.\n",
    "credits": "3"
  },
  {
    "course_name": "Brain and Behavior",
    "dept": "PSYCH",
    "num": "310",
    "desc": "Prereq: PSYCH 101\nSurvey of basic concepts in the neurosciences with emphasis on brain mechanisms mediating sensory processes, arousal, motivation, learning, and abnormal behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Sensation and Perception",
    "dept": "PSYCH",
    "num": "312",
    "desc": "Prereq: PSYCH 101\nSurvey of the physiology and psychology of human sensory systems including vision, audition, smell, taste, the skin senses, and the vestibular senses.\n",
    "credits": "3"
  },
  {
    "course_name": "Learning and Memory",
    "dept": "PSYCH",
    "num": "313",
    "desc": "Prereq: PSYCH 101\nSurvey of fundamental concepts and theories related to learning and memory derived from human and animal research.\n",
    "credits": "3"
  },
  {
    "course_name": "Motivation",
    "dept": "PSYCH",
    "num": "314",
    "desc": "Prereq: PSYCH 101\nTheory and research on motivation at biological, environmental, and psychological levels. Topics include emotion, eating, sex, music, addictions, incentives, goal performance, personality, coping, self-determination and purpose.\n",
    "credits": "3"
  },
  {
    "course_name": "Drugs and Behavior",
    "dept": "PSYCH",
    "num": "315",
    "desc": "Prereq: PSYCH 101\nBiologically based examination of the effects of drugs on behavior and social interactions, including recreational drugs and drugs used in the treatment of psychiatric and neurological disorders.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Psychology",
    "dept": "PSYCH",
    "num": "316",
    "desc": "Prereq: PSYCH 101\nOverview of human cognition, including sensation and perception, attention, memory, language, and judgment and decision making.\n",
    "credits": "3"
  },
  {
    "course_name": "Sleep and Dreams",
    "dept": "PSYCH",
    "num": "320",
    "desc": "Prereq: PSYCH 101\nScientific study of sleep and dreams including basic biological and psychological aspects of sleep-wake cycles, the nature and function of dreams, and the role of sleep in human behavior, performance, and well-being. Sleep problems and their social consequences.\n",
    "credits": "3"
  },
  {
    "course_name": "Educational Psychology",
    "dept": "PSYCH",
    "num": "333",
    "desc": "Prereq: PSYCH 230 or HD FS 102, application to the teacher education program or major in psychology\nPsychological theories relevant to student development, learning, and motivation. Review of assessment principles and practices. Implications of theory for teaching children and for assessing learning in K-12 educational settings, with an emphasis on grades 5 – 12.\n",
    "credits": "3"
  },
  {
    "course_name": "Abnormal Psychology of Children and Adolescents",
    "dept": "PSYCH",
    "num": "335",
    "desc": "Prereq: PSYCH 101; PSYCH 230 or HDFS 102\nPsychopathology of children and adolescents,including childhood depression and anxiety disorders. Consideration of multiple probable causes and corresponding therapies.\n",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Women",
    "dept": "PSYCH",
    "num": "346",
    "desc": "Prereq: 2 courses in psychology including PSYCH 101\nSurvey of theory and research related to major biological, interpersonal, and cultural issues affecting girls' and women's psychological development and behavior.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "U.S. Latino/a Psychology",
    "dept": "PSYCH",
    "num": "347",
    "desc": "Prereq: Two courses in Psychology including PSYCH 101\nHistorical, political, and social contexts of psychological and mental health constructs in terms of their validity and utility for use with Latino/a people in the U.S.  Unique aspects of psychological functioning particular to Latino/a people in the U.S.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Religion",
    "dept": "PSYCH",
    "num": "348",
    "desc": "Prereq: Nine credits in psychology\nSurvey of psychological theory and research investigating religious and spiritual attitudes, beliefs and practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Factors in Technology",
    "dept": "PSYCH",
    "num": "350",
    "desc": "Prereq: PSYCH 101; junior classification\nUnderstanding human behavior and cognition in the context of modern technologies.  Focus on emergent interactive technologies, human computer interaction, user centered design, usability analysis, and usability testing.\n",
    "credits": "3"
  },
  {
    "course_name": "Personality Psychology",
    "dept": "PSYCH",
    "num": "360",
    "desc": "Prereq: PSYCH 101\nHistorical and contemporary theory and research on development and expression of personality with a focus on normal functioning.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Cognition",
    "dept": "PSYCH",
    "num": "380",
    "desc": "Prereq: PSYCH 101 or PSYCH 280\nHow people understand themselves and others, including attitude formation and change, attribution, impression formation, social categories and schemas, the self, stereotypes, and prejudice.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Psychology of Small Group Behavior",
    "dept": "PSYCH",
    "num": "381",
    "desc": "Prereq: SOC 305 or PSYCH 280\nA survey of small group theory and research from an interdisciplinary, social psychological perspective.\n",
    "credits": "3"
  },
  {
    "course_name": "Psychology and Law",
    "dept": "PSYCH",
    "num": "383",
    "desc": "Prereq: PSYCH 101 or PSYCH 280\nSurvey of topics in the interface between psychology and the legal system including but not limited to Miranda warning, confessions, police interrogation, lie detection, juries, eyewitness identification, false memories, and the death penalty.\n",
    "credits": "3"
  },
  {
    "course_name": "Media Psychology",
    "dept": "PSYCH",
    "num": "386",
    "desc": "Prereq: PSYCH 101 or PSYCH 230 or PSYCH 280\nTheories and research on the psychological mechanisms (e.g., attitudes, perceptions, emotions, arousal) by which media influence children and adults. Topics include media violence, educational media, advertising, music, video games, media literacy, and ratings.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Psychology",
    "dept": "PSYCH",
    "num": "405",
    "desc": "Prereq: 4 courses in psychology\nOrigins of psychology in philosophy, physiology, medicine and religion. Development as a scientific discipline during the nineteenth and twentieth centuries. Historical overview of clinical practice and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Behavioral Neurology",
    "dept": "PSYCH",
    "num": "410",
    "desc": "Prereq: PSYCH 101; PSYCH 310 or equivalent.\nExamination of the neuroanatomical foundation of cognition, affect, and action from a neurological perspective. Focus on basic and applied research with neurological patients.\n",
    "credits": "3"
  },
  {
    "course_name": "Evolutionary Psychology",
    "dept": "PSYCH",
    "num": "411",
    "desc": "Prereq: Junior classification, three courses in psychology; one course in biology\nExamination of the application of the principles of evolutionary biology to the understanding of human behavior.  Evolutionary perspectives on brain development, cognition, language, mating behavior, sex differences, altruism, artistic behavior, and criminal behavior are explored.  Arguments by those critical of the evolutionary approach to psychology are also examined.\n",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Language",
    "dept": "PSYCH",
    "num": "413",
    "desc": "Prereq: PSYCH 101\nIntroduction to psycholinguistics. Topics may include origin of language, speech perception, language comprehension, reading, bilingualism, brain bases of language, and computational modeling of language processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Counseling Theories and Techniques",
    "dept": "PSYCH",
    "num": "422",
    "desc": "Prereq: 3 courses in psychology\nOverview of the major counseling theories and techniques, with emphasis on the key concepts of each theory, the role of the counselor, therapeutic goals, and the main techniques derived from each theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Counseling Theory and Techniques",
    "dept": "PSYCH",
    "num": "422L",
    "desc": "Prereq: Three classes in psychology and credit or enrollment in PSYCH 422.\nLearn basic counseling skills such as active listening, reflecting feelings, empathy, confrontation, immediacy and self-disclosure.  Supervised practice using basic counseling skills.\n",
    "credits": "1"
  },
  {
    "course_name": "Psychological Measurement I",
    "dept": "PSYCH",
    "num": "440",
    "desc": "Prereq: PSYCH 301 and 9 credits in psychology, STAT 101\nPrinciples of psychological measurement, including concepts of reliability and validity; interpretation of scores; factors influencing performance; construction and use of measures of ability, achievement, and personality.\n",
    "credits": "3"
  },
  {
    "course_name": "Industrial Psychology",
    "dept": "PSYCH",
    "num": "450",
    "desc": "Prereq: 2 courses in psychology including PSYCH 101, STAT 101\nTheory, content and methods of industrial psychology related to the effective operation of organizations.  Application of psychology principles to topics including different approaches used to select employees, how to conduct performance appraisals, and how to train and keep employees safe. Work attitudes and behaviors of employees as well as relevant legal issues. Statistics including regression and correlation are used.\n",
    "credits": "3"
  },
  {
    "course_name": "Abnormal Psychology",
    "dept": "PSYCH",
    "num": "460",
    "desc": "Prereq: 3 courses in psychology including PSYCH 101\nDescription of major forms of psychopathology including anxiety, mood disorders, personality disorders, substance abuse, and schizophrenia. Coverage of research examining causes, development, and clinical issues concerning psychopathology.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Psychology",
    "dept": "PSYCH",
    "num": "470",
    "desc": "Prereq: 12 credits in psychology\nCurrent topics in psychological research and practice in the following areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Psychology: Counseling",
    "dept": "PSYCH",
    "num": "470A",
    "desc": "Prereq: 12 credits in psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Psychology: Experimental",
    "dept": "PSYCH",
    "num": "470B",
    "desc": "Prereq: 12 credits in psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Psychology: Individual Differences",
    "dept": "PSYCH",
    "num": "470C",
    "desc": "Prereq: 12 credits in psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Psychology: Social",
    "dept": "PSYCH",
    "num": "470D",
    "desc": "Prereq: 12 credits in psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Psychology of Close Relationships",
    "dept": "PSYCH",
    "num": "484",
    "desc": "Prereq: 9 credits in psychology including PSYCH 280\nTheories and research concerning the functions, development, and deterioration of close relationships. Influence of psychological processes on friendship, romantic, marital, and family relationships. Topics include mate selection, interdependence, trust and commitment, power and dominance in relationships, sexuality, divorce, gender roles, and family interaction.\n",
    "credits": "3"
  },
  {
    "course_name": "Health Psychology",
    "dept": "PSYCH",
    "num": "485",
    "desc": "Prereq: Junior classification, 6 credits in psychology\nApplication of psychological theory and research methods to issues in physical health. Psychological factors in illness prevention, health maintenance, treatment of illness, recovery from injury and illness, and adjustment to chronic illness.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Aggression",
    "dept": "PSYCH",
    "num": "487",
    "desc": "Prereq: PSYCH 230 or PSYCH 280; PSYCH 301; PSYCH 313, PSYCH 316, PSYCH 318, PSYCH 360, or PSYCH 380\nTheory and research on development and occurrence of human aggression; implications for prevention and treatment.\n",
    "credits": "3"
  },
  {
    "course_name": "Cultural Psychology",
    "dept": "PSYCH",
    "num": "488",
    "desc": "Prereq: PSYCH 280 and PSYCH 301; junior classification\nExamination of the ways that cultural beliefs, values, and affordances shape cognitive, developmental, social and other psychological phenomena, as well as the forces that shape and change culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "PSYCH",
    "num": "490",
    "desc": "Prereq: Junior classification, 6 credits in psychology, and permission of instructor\nSupervised reading in an area of psychology. Writing requirement.\n  No more than 9 credits of Psych 490 may be counted toward a degree in psychology.",
    "credits": "1"
  },
  {
    "course_name": "Research Practicum",
    "dept": "PSYCH",
    "num": "491",
    "desc": "Prereq: Junior classification, permission of instructor, and credit or enrollment in PSYCH 301\nSupervised research in an area of psychology. Primarily for students intending to pursue graduate education.\n  No more than 9 credits of Psych 491 may be counted toward a degree in psychology.",
    "credits": "arr"
  },
  {
    "course_name": "Fieldwork Practicum",
    "dept": "PSYCH",
    "num": "492",
    "desc": "Prereq: Junior classification, 12 credits in psychology, and permission of instructor\nSupervised fieldwork in one of the following applied psychology settings.\n  Offered on a satisfactory-fail basis only.  No more than 9 credits of Psych 492 may be counted toward a degree in psychology.",
    "credits": "arr"
  },
  {
    "course_name": "Fieldwork Practicum: Human Services",
    "dept": "PSYCH",
    "num": "492A",
    "desc": "Prereq: Junior classification, 12 credits in psychology and permission of instructor\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Fieldwork Practicum: I/O Psychology",
    "dept": "PSYCH",
    "num": "492B",
    "desc": "Prereq: Junior classification, 12 credits in psychology including PSYCH 450 or PSYCH 250 and enrollment in PSYCH 450, and permission of instructor.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Foundations of Behavioral Research",
    "dept": "PSYCH",
    "num": "501",
    "desc": "Prereq: STAT 401 or equivalent\nEthical issues, research design, sampling design, measurement issues, power and precision analysis, interpretation of statistical results in non-experimental, quasi-experimental, and experimental research, use of statistical packages.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Psychology",
    "dept": "PSYCH",
    "num": "505",
    "desc": "Prereq: 4 courses in psychology\nOrigins of psychology in philosophy, physiology, medicine and religion. Development as a scientific discipline during the nineteenth and twentieth centuries. Historical overview of clinical practice and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods in Applied Psychology",
    "dept": "PSYCH",
    "num": "508",
    "desc": "Prereq: PSYCH 440 and PSYCH 501 or STAT 401\nMethods and issues in applied psychological research. Role of theory in research, fidelity of measurement, selection of subjects, sampling, ethical issues, experimenter bias, data collection methods, power analysis, and professional standards for writing research articles. Emphasis on research methodological issues, not statistical issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Behavioral Neurology",
    "dept": "PSYCH",
    "num": "510",
    "desc": "Prereq: PSYCH 101; PSYCH 310 or equivalent.\nExamination of the neuroanatomical foundation of cognition, affect, and action from a neurological perspective. Focus on basic and applied research with neurological patients.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Cognition",
    "dept": "PSYCH",
    "num": "516",
    "desc": "Prereq: PSYCH 316\nTheoretical models and empirical research in human cognition including perception, attention, memory, concepts/categorization, imagery, and judgment and decision making.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Neuropsychology",
    "dept": "PSYCH",
    "num": "519",
    "desc": "Prereq: PSYCH 310 and PSYCH 316 or PSYCH 313; graduate classification or permission of instructor\nPsychological models and related neurological substrates underlying cognition in normal and brain-damaged individuals.\n",
    "credits": "3"
  },
  {
    "course_name": "Cognitive Psychology of Human Computer Interaction",
    "dept": "PSYCH",
    "num": "521",
    "desc": "Prereq: Graduate classification or instructor approval\nBiological, behavioral, perceptual, cognitive and social issues relevant to human computer interactions.\n",
    "credits": "3"
  },
  {
    "course_name": "Scientific Methods in Human Computer Interaction",
    "dept": "PSYCH",
    "num": "522",
    "desc": "Prereq: PSYCH 521 and STAT 101 or equivalent\nBasics of hypothesis testing, experimental design, analysis and interpretation of data, and the ethical principles of human research as they apply to research in human computer interaction.\n",
    "credits": "3"
  },
  {
    "course_name": "Theories of Learning",
    "dept": "PSYCH",
    "num": "533",
    "desc": "\nMajor theories of learning and cognition in educational settings. Emphasis on behavioral, cognitive, constructivist, and sociocultural theories and their implications for educational policy and practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Developmental Disabilities",
    "dept": "PSYCH",
    "num": "538",
    "desc": "Prereq: 9 credits in human development and family studies or psychology or permission of instructor\nTheories, research, and current issues regarding the intersection of development and disabilities. Investigation of interventions with individuals and families. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Psychological Measurement",
    "dept": "PSYCH",
    "num": "542",
    "desc": "Prereq: PSYCH 440\nPrinciples of psychological measurement, including concepts of reliability and validity; interpretation of scores; factors influencing performance; test construction and use of measures of intelligence, ability, achievement, vocational interest, and personality. Ethical and multicultural issues in measurement.\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Assessment",
    "dept": "PSYCH",
    "num": "544",
    "desc": "Prereq: PSYCH 542 and admission into the PhD program in counseling psychology\nSupervised practice in integration of clinical interviewing, behavioral observation, and administration, scoring, and interpreting individual tests of cognitive function.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Personality Psychology",
    "dept": "PSYCH",
    "num": "560",
    "desc": "Prereq: 4 courses in psychology, including PSYCH 360\nAdvanced analysis of contemporary theory and research on personality measurement, development, heritability, and social expression.\n",
    "credits": "3"
  },
  {
    "course_name": "Psychopathology and Behavior Deviations",
    "dept": "PSYCH",
    "num": "561",
    "desc": "Prereq: PSYCH 460\nExamination of DSM and research based perspectives pertinent to the major forms of adult psychopathology including: anxiety, mood, psychotic, personality and other disorders.  Coverage of research examining causes, development, and clinical issues concerning adult psychopathology.\n",
    "credits": "3"
  },
  {
    "course_name": "Personality Assessment",
    "dept": "PSYCH",
    "num": "562",
    "desc": "Prereq: PSYCH 360, PSYCH 440, PSYCH 542, and PSYCH 501 or STAT 401 and admission to the PhD program in counseling psychology\nPrinciples, concepts, and methods of personality assessment. Though not a practicum course, exposure is given to a variety of objective, projective, and situational tests.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Social Psychology: Psychological Perspectives",
    "dept": "PSYCH",
    "num": "580",
    "desc": "Prereq: 4 courses in psychology, including PSYCH 280\nCurrent theories, methods, and research in social psychology with an emphasis on cognitive and interpersonal processes such as attribution, social cognition, attitude change, attraction, aggression, and social comparison.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "PSYCH",
    "num": "590",
    "desc": "Prereq: 12 credits in psychology, and permission of instructor\nGuided reading on special topics or individual research projects in the following areas.\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Counseling",
    "dept": "PSYCH",
    "num": "590A",
    "desc": "Prereq: 12 credits in psychology, and permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Cognitive",
    "dept": "PSYCH",
    "num": "590Q",
    "desc": "Prereq: 12 credits in psychology, and permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Social",
    "dept": "PSYCH",
    "num": "590R",
    "desc": "Prereq: 12 credits in psychology, and permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: General",
    "dept": "PSYCH",
    "num": "590Z",
    "desc": "Prereq: 12 credits in psychology, and permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Psychology",
    "dept": "PSYCH",
    "num": "592",
    "desc": "Prereq: 12 hours in psychology or graduate classification.\nSeminar in the following areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Psychology: Developmental",
    "dept": "PSYCH",
    "num": "592C",
    "desc": "Prereq: 12 hours in psychology or graduate classification.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Psychology: Research Methods and Psychometrics",
    "dept": "PSYCH",
    "num": "592P",
    "desc": "Prereq: 12 hours in psychology or graduate classification.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Psychology: General",
    "dept": "PSYCH",
    "num": "592Z",
    "desc": "Prereq: 12 hours in psychology or graduate classification.\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods",
    "dept": "PSYCH",
    "num": "594",
    "desc": "Prereq: PSYCH 501 or equivalent\nSpecialized quantitative methods for social and behavioral research problems in the following areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Classical psychometric theory",
    "dept": "PSYCH",
    "num": "594A",
    "desc": "Prereq: PSYCH 501 or equivalent\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Modern psychometric methods",
    "dept": "PSYCH",
    "num": "594B",
    "desc": "Prereq: PSYCH 501 or equivalent\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Construct validation",
    "dept": "PSYCH",
    "num": "594C",
    "desc": "Prereq: PSYCH 501 or equivalent\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Multi-dimensional scaling",
    "dept": "PSYCH",
    "num": "594D",
    "desc": "Prereq: PSYCH 501 or equivalent\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Cluster Analysis",
    "dept": "PSYCH",
    "num": "594E",
    "desc": "Prereq: PSYCH 501 or equivalent\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Meta-analysis",
    "dept": "PSYCH",
    "num": "594F",
    "desc": "Prereq: PSYCH 501 or equivalent\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Longitudinal analysis",
    "dept": "PSYCH",
    "num": "594G",
    "desc": "Prereq: PSYCH 501 or equivalent\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Focus Groups",
    "dept": "PSYCH",
    "num": "594I",
    "desc": "Prereq: PSYCH 501or equivalent\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Mediation and Moderation",
    "dept": "PSYCH",
    "num": "594K",
    "desc": "Prereq: PSYCH 501 or equivalent\nSpecialized quantitative methods for social and behavioral research problems.\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Missing Data",
    "dept": "PSYCH",
    "num": "594L",
    "desc": "Prereq: PSYCH 501 or equivalent.\nSpecialized quantitative methods for social and behavioral research problems.\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Behavioral Methods: Power Analysis",
    "dept": "PSYCH",
    "num": "594M",
    "desc": "Prereq: PSYCH 501 or equivalent\nSpecialized quantitative methods for social and behavioral research problems.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Social Psychology",
    "dept": "PSYCH",
    "num": "595",
    "desc": "Prereq: 12 credits in Psychology\nSeminar in the following areas in social psychology.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Social Psychology: Social Cognition",
    "dept": "PSYCH",
    "num": "595A",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Social Psychology: Aggression",
    "dept": "PSYCH",
    "num": "595B",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Social Psychology: Culture",
    "dept": "PSYCH",
    "num": "595C",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Social Psychology: Attitudes and Attitude Change",
    "dept": "PSYCH",
    "num": "595D",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Social Psychology: Psychology and Law",
    "dept": "PSYCH",
    "num": "595E",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Social Psychology: Close Relationships",
    "dept": "PSYCH",
    "num": "595G",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Social Psychology: General",
    "dept": "PSYCH",
    "num": "595I",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Counseling Psychology",
    "dept": "PSYCH",
    "num": "596",
    "desc": "Prereq: 12 credits in Psychology\nSeminar in the following areas in counseling psychology.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Counseling Psychology: Supervision",
    "dept": "PSYCH",
    "num": "596A",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Counseling Psychology: Research",
    "dept": "PSYCH",
    "num": "596B",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Counseling Psychology: Multicultural",
    "dept": "PSYCH",
    "num": "596C",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Counseling Psychology: Professional Issues and Ethics",
    "dept": "PSYCH",
    "num": "596D",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Counseling Psychology: General",
    "dept": "PSYCH",
    "num": "596E",
    "desc": "Prereq: 12 credits in Psychology\n",
    "credits": "arr"
  },
  {
    "course_name": "Internship in Psychology",
    "dept": "PSYCH",
    "num": "597",
    "desc": "Prereq: M.S. degree candidacy; permission of instructor\nFull-time, non-clinical, supervised experience in a setting relevant to psychology. Intended for master's degree level internships.\n",
    "credits": "R"
  },
  {
    "course_name": "Seminar in Cognitive Psychology",
    "dept": "PSYCH",
    "num": "598",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401.\nSeminar in the following areas in cognitive psychology.\n",
    "credits": "0"
  },
  {
    "course_name": "Seminar in Cognitive Psychology: Attention and Perception",
    "dept": "PSYCH",
    "num": "598A",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Cognitive Psychology: Memory",
    "dept": "PSYCH",
    "num": "598B",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Cognitive Psychology: Cognitive Neuroscience",
    "dept": "PSYCH",
    "num": "598C",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Cognitive Psychology: Judgment and Decision Making",
    "dept": "PSYCH",
    "num": "598D",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Cognitive Psychology: Evolution",
    "dept": "PSYCH",
    "num": "598E",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Cognitive Psychology: Language",
    "dept": "PSYCH",
    "num": "598F",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Cognitive Psychology: Applied",
    "dept": "PSYCH",
    "num": "598G",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar in Cognitive Psychology: General",
    "dept": "PSYCH",
    "num": "598I",
    "desc": "Prereq: PSYCH 516, PSYCH 501 or STAT 401\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component",
    "dept": "PSYCH",
    "num": "599",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Multi-level Modeling",
    "dept": "PSYCH",
    "num": "605",
    "desc": "Prereq: HD FS 503 and HD FS 505 or STAT 404 or permission of instructor\nRationale for and interpretation of random coefficient models. Strategies for the analysis of multi-level and panel data including models for random intercepts, random slopes, and growth curves.\n",
    "credits": "3"
  },
  {
    "course_name": "Psychological Counseling -Theory and Process",
    "dept": "PSYCH",
    "num": "621",
    "desc": "Prereq: 3 courses in psychology and permission of instructor\nOverview of major counseling theories with emphases upon: key concepts of theories, the role of the counselor, and applications of theory in fostering client change.\n",
    "credits": "3"
  },
  {
    "course_name": "Psychological Counseling -Theory and Process: Techniques in Counseling",
    "dept": "PSYCH",
    "num": "621L",
    "desc": "Prereq: permission of instructor required\nDevelopment of basic counseling skills and techniques through observation, role-playing, case studies, and supervised counseling sessions.\n",
    "credits": "3"
  },
  {
    "course_name": "Vocational Behavior",
    "dept": "PSYCH",
    "num": "623",
    "desc": "Prereq: 3 courses in psychology or graduate classification\nTheoretical views, research, and issues in career development through the life span. Methods of career counseling, including appraisal interviewing, assessment, test interpretation, and use of information sources.\n",
    "credits": "3"
  },
  {
    "course_name": "Group Counseling",
    "dept": "PSYCH",
    "num": "626",
    "desc": "Prereq: Graduate classification\nTheory, research, ethical issues, and therapeutic considerations relevant to group counseling. Participation in lab exercises for development of group counseling skills and observation of ongoing groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching of Psychology",
    "dept": "PSYCH",
    "num": "633",
    "desc": "Prereq: Enrollment in doctoral degree program in psychology and permission of instructor\nOrientation to teaching of psychology at college level: academic issues and problems, instructional and evaluative techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Practicum in Psychology",
    "dept": "PSYCH",
    "num": "691",
    "desc": "Prereq: Prereg: Permission of instructor\nSupervised practice and experience in the following fields of specialization in applied psychology.\n",
    "credits": "arr"
  },
  {
    "course_name": "Practicum in Psychology: Counseling (Beginning)",
    "dept": "PSYCH",
    "num": "691A",
    "desc": "Prereq: PSYCH 621L\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Psychology: Counseling (Intermediate)",
    "dept": "PSYCH",
    "num": "691B",
    "desc": "Prereq: Permission of instructor, PSYCH 691A\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Psychology: Counseling (Advanced)",
    "dept": "PSYCH",
    "num": "691C",
    "desc": "Prereq: Permission of instructor, PSYCH 691A, PSYCH 691B\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Psychology: Counseling (Advanced External Practicum)",
    "dept": "PSYCH",
    "num": "691D",
    "desc": "Prereq: Permission of instructor, PSYCH 691A, PSYCH 691B\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Psychology: Group Counseling",
    "dept": "PSYCH",
    "num": "691G",
    "desc": "Prereq: Prereg: Permission of instructor, PSYCH 626, PSYCH 691A\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Psychology: Supervision",
    "dept": "PSYCH",
    "num": "691S",
    "desc": "Prereq: Permission of instructor, PSYCH 592A, PSYCH 621L\n",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Psychology: Teaching",
    "dept": "PSYCH",
    "num": "691T",
    "desc": "Prereq: Permission of instructor,PSYCH 633\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Practicum in Psychology: General",
    "dept": "PSYCH",
    "num": "691Z",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar",
    "dept": "PSYCH",
    "num": "692",
    "desc": "Prereq: Permission of instructor\nResearch seminar in the following areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar: Counseling",
    "dept": "PSYCH",
    "num": "692A",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar: Cognitive",
    "dept": "PSYCH",
    "num": "692Q",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar: Social",
    "dept": "PSYCH",
    "num": "692R",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Research Seminar: General",
    "dept": "PSYCH",
    "num": "692Z",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Internship in Counseling Psychology",
    "dept": "PSYCH",
    "num": "697",
    "desc": "Prereq: Ph.D. candidacy in the Counseling Psychology program, approved dissertation proposal, and permission of instructor\nFull time supervised predoctoral internship experience in a setting relevant to counseling psychology.\n",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "PSYCH",
    "num": "699",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Principles of Public Relations",
    "dept": "P R",
    "num": "220",
    "desc": "\nIntroduction to public relations in business, government and non-profit organizations; functions, processes, and management; ethics, public opinion and theory.\n",
    "credits": "3"
  },
  {
    "course_name": "Research and Strategic Planning for Advertising and Public Relations",
    "dept": "P R",
    "num": "301",
    "desc": "Prereq: ADVRT 230 or P R 220\nThe use of primary and secondary research for situations, organizations and the public.  Formation and development of strategic plans for public relations and advertising students.\n",
    "credits": "3"
  },
  {
    "course_name": "Publicity Methods",
    "dept": "P R",
    "num": "305",
    "desc": "Prereq: ENGL 250, Sophomore classification\nCommunication and publicity fundamentals and the use of media for publicity purposes. Not available to Greenlee School majors.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Relations Writing",
    "dept": "P R",
    "num": "321",
    "desc": "Prereq: JL MC 110 and minimum of C+ in JL MC 201; ADVRT/P R 301 credit or concurrent enrollment.\nDeveloping and writing public relations materials with an emphasis on media relations and news. Techniques addressed include media kits, brochures, newsletters, digital media and speeches.\n",
    "credits": "3"
  },
  {
    "course_name": "Professional Skills Development",
    "dept": "P R",
    "num": "390",
    "desc": "Prereq: Minimum of C+ in JL MC 201; other vary by topic. Instructor permission for non-majors.\nCheck with Greenlee School for course availability.\n",
    "credits": "1"
  },
  {
    "course_name": "Crisis Communication",
    "dept": "P R",
    "num": "420",
    "desc": "Prereq: P R 220\nPublic relations strategies and tactics for crisis situations to protect and recover an organization's reputation: public behavior in crisis, crisis assessment, crisis communication plan, media training for leaders and spokespersons, apology strategy, corporate social responsibility, rumor in social media and reputation management.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Relations Campaigns",
    "dept": "P R",
    "num": "424",
    "desc": "Prereq: Minimum of C+ in P R 321; ADVRT/P R 301.\nDeveloping public relations and public information campaigns for business and social institutions.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study in Communication",
    "dept": "P R",
    "num": "490",
    "desc": "Prereq: Junior classification and contract with supervising professor to register.\nProjects during which students may study problems associated with a medium, a professional specialization, a philosophical or practical concern, a reportorial method or writing technique, or a special topic in their field. Credit is not given for working on student or professional media without an accompanying research component.\n  No more than 3 credits of ADVRT/JLMC/PR 490 may be used toward a degree in the Greenlee School.",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics in Communication",
    "dept": "P R",
    "num": "497",
    "desc": "Prereq: Junior classification. See Schedule of Classes for possible pre-requisites.\nSeminars or one-time classes on topics of relevance to students in communication.\n",
    "credits": "1"
  },
  {
    "course_name": "Professional Media Internship",
    "dept": "P R",
    "num": "499",
    "desc": "Prereq: JL MC majors: JL MC 110 and minimum of C+ in JL MC 202 or JL MC 206 or P R 321; ADVRT majors: JL MC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JL MC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nRequired of all Greenlee School majors. A 400-hour (for 3 credits) internship in the student's journalism and mass communication or advertising or public relations specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Professional Media Internship: Required",
    "dept": "P R",
    "num": "499A",
    "desc": "Prereq: JL MC majors: JLMC 110 and minimum of C+ in JL MC 302 or JL MC 306; ADVRT majors: JLMC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JLMC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nInitial, required internship. A 400-hour (for 3 credits) internship in the student's specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "3"
  },
  {
    "course_name": "Professional Media Internship: Optional",
    "dept": "P R",
    "num": "499B",
    "desc": "Prereq: JL MC majors: JLMC 110 and minimum of C+ in JL MC 302 or JL MC 306; ADVRT majors: JLMC 110 and minimum of C+ in JL MC 201 and ADVRT 301; P R majors: JLMC 110, PR 301 and minimum of C+ in P R 321. All students, formal faculty adviser approval.\nOptional internship in the student's specialization. Assessment based on employer evaluations, student reports and faculty reviews. Available only to Greenlee School majors.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to World Religions",
    "dept": "RELIG",
    "num": "205",
    "desc": "\nAn introduction to the academic study of religions, including myths, beliefs, rituals, values, social forms. Examples chosen from oral cultures and major religions of the world.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Religion in America",
    "dept": "RELIG",
    "num": "210",
    "desc": "\nIntroductory study of the major beliefs, practices, and institutions of American Judaism, Catholicism, Protestantism, and Islam with emphasis on the diversity of religion in America, and attention to issues of gender, race, and class.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the Bible",
    "dept": "RELIG",
    "num": "220",
    "desc": "\nBasic overview of the contents of the Old and New Testament in light of their ancient socio-historical background, and with attention to a variety of interpretations and relevance to modern American society.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Christianity: Beginnings to the Reformation",
    "dept": "RELIG",
    "num": "242",
    "desc": "\nA survey of the major historical developments in Christian thought and practice that shaped Christianity from the time of Jesus through the late medieval period.  Attention given to significant persons and major events, including those involving relations with Judaism and Islam.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Christianity: The Reformation to the Present",
    "dept": "RELIG",
    "num": "243",
    "desc": "\nA survey of the major events, issues, and persons that contributed to the Protestant Reformation, the Catholic Counter-Reformation, and the proliferation of Christian denominations.  Attention to selected responses of churches to major sixteenth-early twenty-first century developments.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Catholicism",
    "dept": "RELIG",
    "num": "280",
    "desc": "\nAn explanation of the beliefs, spirit, and practices of Roman Catholicism, including its understanding of God, sacramentality, the human person, and community, and its relationship to other forms of Christianity and other world religions.\n",
    "credits": "3"
  },
  {
    "course_name": "Old Testament",
    "dept": "RELIG",
    "num": "321",
    "desc": "\nAn in-depth study of the literature and religion of ancient Israel in light of recent archaeological discoveries, research about the ancient Near East, and a variety of interpretations.\n",
    "credits": "3"
  },
  {
    "course_name": "New Testament",
    "dept": "RELIG",
    "num": "322",
    "desc": "\nA detailed survey of the sacred scriptures of Christianity in light of recent archaeological discoveries and historical research about their Greco-Roman and Jewish background.\n",
    "credits": "3"
  },
  {
    "course_name": "Christianity and Science",
    "dept": "RELIG",
    "num": "324",
    "desc": "Prereq: BIOL 101, or another science course taught at ISU\nExamines major challenges to Christianity's understandings of creation posed by the sciences; attention given to the relations of Christianity and science, and to Christianity’s responses to ecological issues.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Judaism",
    "dept": "RELIG",
    "num": "333",
    "desc": "\nAn introduction to basic Judaism. Special attention is given to Jewish sacred texts, rituals, social practices, and modern forms.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "African American Religious Experience",
    "dept": "RELIG",
    "num": "334",
    "desc": "Prereq: Prior course work in Religious Studies or African American Studies recommended\nExamination of African-American experience from the perspective of black religion with attention to political, economic, social, theological and artistic expressions, including music, that serve the life of African-American communities.”.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women and Religion",
    "dept": "RELIG",
    "num": "336",
    "desc": "Prereq: RELIG 205, RELIG 210 or WGS 201 recommended\nExamines the status of women in various religions, feminist critiques of religious structures and belief systems, and contemporary women's spirituality movements.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Magic, Witchcraft, and Religion",
    "dept": "RELIG",
    "num": "340",
    "desc": "Prereq: ANTHR 201 or ANTHR 306\nSurvey of global religious belief and practice from an anthropological perspective. Emphasis on myth and ritual, shamanism, magic,   witchcraft, beliefs in spirits, conceptions of the soul, mind and body relationships, and healing and therapeutic practices. Discussion   of religious response to dramatic political and social change; effects of globalization on religious practice.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Religion and U.S. Latino/a Literature",
    "dept": "RELIG",
    "num": "342",
    "desc": "\nA study of the religious behavior and attitudes expressed in the literature of Mexican Americans, Puerto Ricans, Cuban Americans and other groups of people living in the U.S. who trace their ancestry to the Spanish-speaking countries of Latin America.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Religion",
    "dept": "RELIG",
    "num": "348",
    "desc": "Prereq: Nine credits in psychology\nSurvey of psychological theory and research investigating religious and spiritual attitudes, beliefs and practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Philosophy of Religion",
    "dept": "RELIG",
    "num": "350",
    "desc": "Prereq: 6 credits in philosophy\nThe value and truth of religious life and belief. Mystical experience; religious faith and language; arguments for God's existence; the problem of evil; miracles; and religion and morality. Historical and contemporary readings.\n",
    "credits": "3"
  },
  {
    "course_name": "Religious Traditions of India",
    "dept": "RELIG",
    "num": "352",
    "desc": "Prereq: Credit in RELIG 205 or equivalent.\nStudy of texts, practices, beliefs, historical development, and mutual influence of a variety of the religious traditions of India. Emphasis on Vedic religion and the diversity of traditions of Classical Hinduism;  survey of Buddhist, Jain, Sikh, and South Asian Islamic traditions. Meets International Perspectives Requirement.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Buddhism",
    "dept": "RELIG",
    "num": "353",
    "desc": "Prereq: PHIL 201 or PHIL 230.\nCentral Buddhist positions and arguments on topics such as personal and social ethics, moral psychology, metaphysics, and the relationship between Buddhist thought and the sciences. Differences between Buddhist and Western approaches to philosophy.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Islam",
    "dept": "RELIG",
    "num": "358",
    "desc": "\nAn introduction to Islamic religion, culture, and society from 700 to the present.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Religious Ethics",
    "dept": "RELIG",
    "num": "360",
    "desc": "\nInvestigates different religious ethical theories and traditions of reasoning about practical moral issues (e.g., abortion, the just distribution of wealth, environmental ethics). Explores in detail the relationship between religious beliefs and moral practice.\n",
    "credits": "3"
  },
  {
    "course_name": "Christianity in the Roman Empire",
    "dept": "RELIG",
    "num": "367",
    "desc": "\nAn historical introduction to the rise of Christianity in the Roman empire, with special attention to the impact of Greco-Roman culture on the thought and practice of Christians and the interaction of early Christians with their contemporaries.\n",
    "credits": "3"
  },
  {
    "course_name": "Religions of Ancient Greece and Rome",
    "dept": "RELIG",
    "num": "368",
    "desc": "\nNature, origins and development of religious beliefs and practices in ancient Greece and Rome from earliest times up to the rise of Christianity. Roles of divinities and rituals in lives of individuals and families and the governing of city-states and empires. Emphasis on historical contexts of the Graeco-Roman world and influences of neighboring cultures in Africa and Asia.\n  None.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Religion and Politics",
    "dept": "RELIG",
    "num": "370",
    "desc": "Prereq: Sophomore classification.\nThe interaction of religion and politics in the U.S. from both an historical and contemporary perspective, as well   as the role of religion in politics internationally.\n",
    "credits": "3"
  },
  {
    "course_name": "Catholic Social Thought",
    "dept": "RELIG",
    "num": "380",
    "desc": "\nExamines biblical roots of and major developments in Catholic social thought.  Contemporary issues such as human rights, economic justice, the environment, and war and peace will be treated using principles of Catholic ethics, social analysis, official church documents, and contributions of notable theologians and activists.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Religion and Ecology",
    "dept": "RELIG",
    "num": "384",
    "desc": "\nIntroduction to concepts of religion and ecology as they appear in different religious traditions, from both a historical and contemporary perspective. Special attention to religious response to contemporary environmental issues.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Goddess Religions",
    "dept": "RELIG",
    "num": "439",
    "desc": "Prereq: RELIG 205 recommended\nExploration of the foundational myths of Goddess spirituality, including historical and cross-cultural female images of the divine and their modern usage by American women.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar: Issues in the Study of Religion",
    "dept": "RELIG",
    "num": "475",
    "desc": "Prereq: 6 credits in religious studies\nTopic changes each time offered. Closed to freshmen. Sophomores must have approval of instructor.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory and Method in Religious Studies",
    "dept": "RELIG",
    "num": "485",
    "desc": "Prereq: 6 credits in Religious Studies or permission of instructor\nExamines the variety of theories and methods employed in the study of religion. Application of these methods to various religions of the world.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "RELIG",
    "num": "490",
    "desc": "Prereq: 6 credits in religious studies and permission of instructor, approval of chairman.\nGuided reading and research on special topics selected to meet the needs of advanced students.\n  No more than 9 credits of Relig 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "RELIG",
    "num": "490H",
    "desc": "Prereq: 6 credits in religious studies and permission of instructor, approval of chairman.\nGuided reading and research on special topics selected to meet the needs of advanced students.\n  No more than 9 credits of Relig 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Senior Thesis",
    "dept": "RELIG",
    "num": "491",
    "desc": "\nWritten under the supervision of a Religious Studies faculty advisor.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Studies in Religious Research Languages",
    "dept": "RELIG",
    "num": "494",
    "desc": "Prereq: 6 credits in Religious Studies and permission of instructor\n",
    "credits": "2"
  },
  {
    "course_name": "Magic, Witchcraft, and Religion",
    "dept": "RELIG",
    "num": "540",
    "desc": "Prereq: ANTHR 201 or ANTHR 306\nSurvey of global religious belief and practice from an anthropological perspective. Emphasis on myth and ritual, shamanism, magic,   witchcraft, beliefs in spirits, conceptions of the soul, mind and body relationships, and healing and therapeutic practices. Discussion   of religious response to dramatic political and social change; effects of globalization on religious practice.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Religious Studies",
    "dept": "RELIG",
    "num": "590",
    "desc": "Prereq: Permission of instructor, 9 credits in religious studies\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Educational Research",
    "dept": "RESEV",
    "num": "550",
    "desc": "\nUnderstanding the nature of quantitative and qualitative research; reviewing the literature; developing research problems and questions; research designs; data collection and analysis issues; evaluating research studies.\n",
    "credits": "3"
  },
  {
    "course_name": "Basic Educational Statistics",
    "dept": "RESEV",
    "num": "552",
    "desc": "\nStatistical concepts and procedures for analyzing educational data; descriptive statistics, correlation, t tests, and chi square with computer applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Educational Statistics",
    "dept": "RESEV",
    "num": "553",
    "desc": "Prereq: RESEV 552 or STAT 401 or STAT 587\nA continuation of statistical concepts and procedures for analyzing educational data, using multiple regression and logistic regression.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Research Methods",
    "dept": "RESEV",
    "num": "554",
    "desc": "Prereq: RESEV 553 or STAT 404\nIntermediate quantitative research methodology in preparation for carrying out thesis and dissertation research, with an emphasis on the estimation of causal effects using observational data.\n",
    "credits": "3"
  },
  {
    "course_name": "Surveys in Educational Research",
    "dept": "RESEV",
    "num": "570",
    "desc": "Prereq: RESEV 552 or equivalent\nExamination of survey design and administration in educational research. Designing surveys; developing, evaluating, and asking survey questions; survey sampling; measuring survey reliability and validity; administering mail and web surveys; decreasing survey nonresponse; conducting post-collection survey data processing; conducting survey research with integrity.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Qualitative Research Methodology",
    "dept": "RESEV",
    "num": "580",
    "desc": "\nQualitative research in the human sciences, emphasizing education; principles of qualitative inquiry, including theoretical foundations, research design, and fieldwork.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "RESEV",
    "num": "590",
    "desc": "Prereq: Graduate standing\nGuided reading and in research and evaluation study on special topic.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience",
    "dept": "RESEV",
    "num": "591",
    "desc": "Prereq: RESEV 553 or RESEV 680\nSupervised on the job field experience.\n",
    "credits": "2"
  },
  {
    "course_name": "Workshop",
    "dept": "RESEV",
    "num": "593",
    "desc": "Prereq: Graduate standing\nIntensive, concentrated exposure to a special educational research or evaluation problem.\n",
    "credits": "1"
  },
  {
    "course_name": "Program Assessment and Evaluation",
    "dept": "RESEV",
    "num": "597",
    "desc": "Prereq: RESEV 550\nEvaluation models and professional standards. Techniques of evaluating educational programs. Emphasis on both theory and practical applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Educational Inquiry",
    "dept": "RESEV",
    "num": "601",
    "desc": "Prereq: Admission to a doctoral program.\nRequired course for all School of Education PhD students that introduces students into the community of educational scholars with a focus on: 1) the history of education as an academic field of study; (2) the philosophical underpinnings of social scientific and educational inquiry; and (3) the contemporary methodological landscape of the field of education.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Qualitative Inquiry in Education",
    "dept": "RESEV",
    "num": "603",
    "desc": "Prereq: RESEV 601\nFocus on the nature of qualitative research, including the ways in which knowledge is produced through qualitative methodologies, the theoretical and epistemological underpinnings of qualitative research, the importance of theoretical and/or conceptual frameworks in qualitative research, and the various methodological approaches to qualitative research.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Topics in Research and Evaluation",
    "dept": "RESEV",
    "num": "615",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "College Access in Policy, Practice, and Research",
    "dept": "RESEV",
    "num": "620",
    "desc": "\nExploration of the plurality of frameworks used to conceptualize college access as a social problem (for research, policy, and practice). Development of application of understandings of college access frameworks to policy, practice, and research.\n",
    "credits": "1"
  },
  {
    "course_name": "Critical Qualitative Research",
    "dept": "RESEV",
    "num": "680",
    "desc": "Prereq: one course in qualitative research\nFeminist, indigenous, critical, queer, and other perspectives are used to raise important questions about qualitative research and help us rethink dilemmas of voice, appropriation, collaboration, and difference, and consider ethical and political issues that arise when engaging in research. Readings and assignments will concentrate on reciprocity, reflexivity, decolonization of research methods, and the necessity of engaging in culturally responsive and ethically informed research, particularly when working with colonized or marginalized communities, and when we aim to produce knowledge in the service of social justice and social change.\n",
    "credits": "3"
  },
  {
    "course_name": "Analytical Approaches in Qualitative Inquiry",
    "dept": "RESEV",
    "num": "681",
    "desc": "Prereq: RESEV 580 or equivalent\nConceptions of data and analysis in qualitative methodologies; focus on applied topics in qualitative data analysis, such as narrative analysis, ethnographic analysis, life history analysis, postmodern analyses, discourse analysis, arts-based analytical strategies, constructing data; combination format of reading and discussion seminars and classroom workshops focusing on individual research projects (not for thesis or dissertation).\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Special Topics",
    "dept": "RESEV",
    "num": "690",
    "desc": "Prereq: Graduate standing\nGuided reading and/or study on special topics of an advanced nature.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "RESEV",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Elementary Russian I",
    "dept": "RUS",
    "num": "101",
    "desc": "\nIntroduction to the Russian language, grammar and syntax. Practice in the four basic skills (listening, speaking, reading, and writing) within the context of Russian culture.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Russian II",
    "dept": "RUS",
    "num": "102",
    "desc": "Prereq: RUS 101\nIntroduction to the Russian language, grammar and syntax. Practice in the four basic skills (listening, speaking, reading, and writing) within the context of Russian culture.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Russian I",
    "dept": "RUS",
    "num": "201",
    "desc": "Prereq: RUS 102\nThorough review of grammar and growth of vocabulary. Selected readings. Continued use of the four basic skills.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Russian II",
    "dept": "RUS",
    "num": "202",
    "desc": "Prereq: RUS 201\nThorough review of grammar and growth of vocabulary. Selected readings. Continued use of the four basic skills.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Composition and Conversation",
    "dept": "RUS",
    "num": "301",
    "desc": "Prereq: RUS 202\nThorough study of the Russian language, with emphasis on strengthening proficiency in writing, speaking, reading, and listening. Increased focus on syntax and word formation.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Russian for Global Professionals",
    "dept": "RUS",
    "num": "304",
    "desc": "Prereq: RUS 102\nCommunication in business and professional contexts in Russian-speaking countries. Development of effective communication strategies and project management in the workplace. Cultural contexts of business and professional practice.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Reading Russian Literary and Cultural Texts",
    "dept": "RUS",
    "num": "314",
    "desc": "Prereq: RUS 102\nSelected readings in Russian literature and culture. Emphasis on techniques of reading and analysis of literary and cultural texts.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Russian Studies in English Translation",
    "dept": "RUS",
    "num": "370",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Readings, discussions, and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Russian Studies in English Translation: Topics in Russian Literature",
    "dept": "RUS",
    "num": "370A",
    "desc": "\nFocus on Russian literature. Topics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Readings, discussions, and papers in English.\n",
    "credits": "3"
  },
  {
    "course_name": "Russian Studies in English Translation: Russian Fairy Tales",
    "dept": "RUS",
    "num": "370B",
    "desc": "\nFocus on Russian fairy tales. Topics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Readings, discussions, and papers in English.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation: Russian Topics on Women or Feminism",
    "dept": "RUS",
    "num": "370R",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Readings, discussions, and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Russia Today",
    "dept": "RUS",
    "num": "375",
    "desc": "\nA survey of social, political, economic, and cultural topics relevant to contemporary Russia.  Readings, discussions and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Russian Film Studies in English",
    "dept": "RUS",
    "num": "378",
    "desc": "\nAnalysis and interpretation of cinema in Russia and the Soviet Union. Topics vary according to faculty interest. Film directors, genres, movements, historical survey, aesthetics, and cinematography. Readings, discussions and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad",
    "dept": "RUS",
    "num": "395",
    "desc": "\nSupervised instruction in language and culture of Russia; formal class instruction at level appropriate to student's training, augmented by practical living experience.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "RUS",
    "num": "490",
    "desc": "Prereq: 6 credits in Russian and permission of department chair\nDesigned to meet the needs of students who seek work in areas other than those in which courses are offered, or who desire to integrate a study of literature or language with special problems in major fields.\n  No more than 9 credits of Rus 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Internship in Russian",
    "dept": "RUS",
    "num": "499",
    "desc": "Prereq: 9 credits of Russian at the 300 level; permission of advisor and WLC Internship Coordinator\nWork experience using Russian language skills in the public or private sector combined with academic work under faculty supervision. Available only to minors.\n  No more than 3 credits may be applied to the minor.",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Russian",
    "dept": "RUS",
    "num": "590",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Russian\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Russian: Literature or Literary Criticism",
    "dept": "RUS",
    "num": "590A",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Russian\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Russian: Linguistics",
    "dept": "RUS",
    "num": "590B",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Russian\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Russian: Language Pedagogy",
    "dept": "RUS",
    "num": "590C",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Russian\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics in Russian: Civilization",
    "dept": "RUS",
    "num": "590D",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Russian\n",
    "credits": "2"
  },
  {
    "course_name": "Strategic Management",
    "dept": "STB",
    "num": "501",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nCritical analysis of current practice and case studies in strategic management with an emphasis on integrative decision making.  Strategy formulation and implementation will be investigated in the context of complex business environments.\n",
    "credits": "2"
  },
  {
    "course_name": "Information Systems",
    "dept": "STB",
    "num": "503",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nIntroduction to a broad variety of information systems (IS) topics, including current and emerging developments in information technology (IT), IT strategy in the context of corporate strategy, and IS planning and development of enterprise architectures.  Cases, reading, and discussions highlight the techniques and tactics used by managers to cope with strategic issues within an increasingly technical and data-driven competitive environment.\n",
    "credits": "2"
  },
  {
    "course_name": "Marketing and Logistics",
    "dept": "STB",
    "num": "504",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nIntegration of the business functions concerned with the marketing and movement of goods along the supply chain with the primary goal of creating value for the ultimate customer. Coordination of marketing, production, and logistics activities within the firm and with outside suppliers and customers in the supply chain.\n",
    "credits": "3"
  },
  {
    "course_name": "Organizational Behavior",
    "dept": "STB",
    "num": "507",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nUnderstanding human behavior in organizations, and the nature of organizations from a managerial perspective.  Special emphasis on how individual differences, such as perceptions, personality, and motivation, influence individual and group behavior in organizations and on how behavior can be influenced by job design, leadership, groups, and the structure of organizations.\n",
    "credits": "2"
  },
  {
    "course_name": "Accounting and Finance",
    "dept": "STB",
    "num": "508",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nSurvey of fundamental topics in accounting and finance.  Financial statement reporting and analysis for agriculture firms, corporate governance issues related to financial reporting, (e.g., Sarbanes-Oxley). Basic tools and techniques used in financial management, including stock and bond valuation. How to assess and use capital budgeting methods to evaluate proposed firm investments.\n",
    "credits": "3"
  },
  {
    "course_name": "Seed Trade, Policy and Regulation",
    "dept": "STB",
    "num": "509",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nCultural, financial, economic, political, legal/regulatory environments shaping an organization's international business strategy.  Topics include entry (and repatriation) of people, firms, goods, services, and capital. Special attention to the institutions of seed regulation and policy. Ethical issues facing managers operating in an international context.\n",
    "credits": "3"
  },
  {
    "course_name": "Crop Improvement",
    "dept": "STB",
    "num": "510",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nA study of the basic principles and methods in the genetic improvement of crop plants. Methods used in manipulating genomes through the use of biotechnology. Methods of cultivar development.  Quantitative procedures for describing response to selection. Analysis of the relationship of reproductive characters and growth characteristics to response to selection.\n",
    "credits": "3"
  },
  {
    "course_name": "Seed and Variety, Testing and Technology",
    "dept": "STB",
    "num": "534",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nThe components of seed quality and how they are assessed in the laboratory, including traits derived from modern biotechnology. The impact of new technologies on seed quality testing. Variety maintenance procedures and breeder seed. Variety identification: phenotype and grow-out trials, isozyme testing, and DNA marker testing. Procedures for evaluating varieties. The variance tests appropriate for fixed effects analysis of variance. Statistical inference and stratification for yield trials. Use of strip plot testing.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to the Seed Industry",
    "dept": "STB",
    "num": "535",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nAn analysis of the defining characteristics of the seed industry and introduction to the Master in Seed Technology and Business curriculum. The tasks of crop improvement and seed production will be analytically related to basic management functions and classifications of management activities. Management tasks and roles will be analyzed and related to the public policy issues that shape the seed industry. Current issues in the seed industry including ethical and economical approaches to biotechnology, intellectual property, and corporate responsibility will be discussed.\n",
    "credits": "1"
  },
  {
    "course_name": "Quantitative Methods for Seed",
    "dept": "STB",
    "num": "536",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nQuantitative Methods for analyzing and interpreting agronomic and business information for the seed industry. Principles of experimental design and hypothesis testing, regression, correlation, analysis of variance, and graphical representation of data. Use of spreadsheets and statistical software for manipulating, analyzing and presenting data.\n",
    "credits": "2"
  },
  {
    "course_name": "Seed Conditioning and Storage",
    "dept": "STB",
    "num": "539",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nThe technical operations which may be carried out on a seed lot from harvest until it is ready for marketing and use. The opportunities for quality improvement and the risks of deterioration which are present during that time. Analysis of the costs of and benefits of operations. Evaluation of equipment based on benefits to the customer and producer. Interpretation of the role of the conditioning plant and store as a focal points within the overall operations of a seed company.\n",
    "credits": "2"
  },
  {
    "course_name": "Seed Physiology",
    "dept": "STB",
    "num": "543",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nBrief introduction to plant physiology.  Physiological aspects of seed development, maturation, longevity, dormancy and germination.  Links between physiology and seed quality.\n",
    "credits": "2"
  },
  {
    "course_name": "Seed Production",
    "dept": "STB",
    "num": "547",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nSurvey of crop production; including management of soil fertility, planting dates, populations, weed control, and insect control. Analysis of the principles of seed multiplication and the key practices which are used to ensure high quality in the products. Field inspection procedures and production aspects that differ from other crop production. Foundation seed production. Analysis of the typical organization of field production tasks. Survey of the differences in seed production strategies between crops and the impact of these differences on seed production.\n",
    "credits": "2"
  },
  {
    "course_name": "Seed Health Management",
    "dept": "STB",
    "num": "592",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nOccurrence and management of diseases during seed production, harvest, conditioning, storage, and planting. Emphasis     on epidemiology, disease management in the field, seed treatment, effects of conditioning on seed health, and seed health testing.\n  Credit may not be obtained for both Pl P/STB 592 and Pl P 594.",
    "credits": "2"
  },
  {
    "course_name": "Seed Quality, Production, and Research Management",
    "dept": "STB",
    "num": "595",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nAdvanced survey of the organization, staff capabilities and management characteristics typical in seed production and crop improvement in seed enterprises. Analysis of the use of quality information in the management of seed operations and sales. Process management applications for seed.  Production planning for existing capacity.  Analysis of the manager's tasks in the annual cycle and how the tasks of these managers relate to the general categories of business management roles. Difference in management strategies used with different situations and groups of employees.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "STB",
    "num": "599",
    "desc": "Prereq: Admission to the Graduate Program in Seed Technology and Business or approval of instructor must be obtained.\nA written report based on research, library readings, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "2"
  },
  {
    "course_name": "Orientation to Public Service and Administration in Agriculture",
    "dept": "SOC",
    "num": "110",
    "desc": "\nSurvey of public service and administration in agriculture. Exploration of career tracks and career planning. Recommended during first semester of freshman year or as soon as possible after transfer into the department.\n",
    "credits": "R"
  },
  {
    "course_name": "Orientation to Sociology",
    "dept": "SOC",
    "num": "115",
    "desc": "\nOrientation to sociology. A familiarization with University and LAS College requirements and procedures. Occupational tracks and career options open to sociology; introduction to career planning. Recommended during first semester of freshman year, or as soon as possible after transfer into the department.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Sociology",
    "dept": "SOC",
    "num": "134",
    "desc": "\nSocial interaction and group behavior with emphasis on the scientific study of contemporary U.S. society, including issues relating to socialization, inequality, and changing rural and urban communities. Analysis of relationships among the institutions of family, religion, political participation, work, and leisure.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Sociology: Honors.",
    "dept": "SOC",
    "num": "134H",
    "desc": "\nSocial interaction and group behavior with emphasis on the scientific study of contemporary U.S. society, including issues relating to socialization, inequality, and changing rural and urban communities. Analysis of relationships among the institutions of family, religion, political participation, work, and leisure.\n",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Intimate Relationships",
    "dept": "SOC",
    "num": "219",
    "desc": "Prereq: SOC 134\nAnalysis of intimate relationships among couples using a sociological perspective. Attention is given to singlehood; dating and courtship; sexuality; mate selection, cohabitation, and marriage. Relationship quality, communication, conflict and dissolution of these types of relationship will also be explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Globalization and Sustainability",
    "dept": "SOC",
    "num": "220",
    "desc": "\nAn introduction to understanding the key global issues in sustainability. Focuses on interconnected roles of energy, materials, human resources, economics, and technology in building and maintaining sustainable systems. Applications discussed will include challenges in both the developed and developing world and will examine the role of technology in a resource-constrained world.\n  Cannot be used for technical elective credit in any engineering department.\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Rural Society in Transition",
    "dept": "SOC",
    "num": "230",
    "desc": "\nIntroduction to the causes and consequences of social and economic change affecting rural people and places. Uses a sociological perspective to examine social structures, social change, and social relationships within rural society. Topics include community, population change, inequality, rural economy, structure of agriculture, social and environmental impacts of resource extraction.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Problems and American Values",
    "dept": "SOC",
    "num": "235",
    "desc": "Prereq: SOC 134\nSociological concepts, theories and methods to analyze the causes and consequences of social problems.  Social problems discussed may include crime, substance abuse, income inequalities, discrimination, poverty, race relations, health care, family issues, and the environment.  How American culture and values shape societal conditions, public discourse and policy.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Youth and Crime",
    "dept": "SOC",
    "num": "241",
    "desc": "\nAn examination of delinquency that focuses on the relationship between youth as victims and as offenders, social and etiological features of delinquency, the role of the criminal justice system, delinquents' rights, and traditional and alternative ways of dealing with juvenile crime.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Methods for the Social Sciences",
    "dept": "SOC",
    "num": "302",
    "desc": "Prereq: SOC 134; STAT 101; or concurrent enrollment in STAT 101\nIntroduction to the principal research methods used in sociology, including survey research, interviewing, content analysis, experiments, ethnographies, focus groups, historical analysis, and analysis of secondary data.  Instruction on sampling and the principles of validity and reliability underlying quantitative and qualitative methods.  Training in data analysis using statistical software packages.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Psychology: A Sociological Perspective",
    "dept": "SOC",
    "num": "305",
    "desc": "Prereq: SOC 134\nExamination of human behavior in a social environment with emphasis on development of the self, interpersonal relations, attitudes, and small groups.\n",
    "credits": "3"
  },
  {
    "course_name": "Community",
    "dept": "SOC",
    "num": "310",
    "desc": "Prereq: SOC 134\nAnalysis of evolving theory and research of community as an ideal type, an ecological system, a political economy, and an interactional field; examination of the impact of economic, cultural, social and political infrastructures on community power structures and change processes in a global era.\n",
    "credits": "3"
  },
  {
    "course_name": "Transition in Agriculture",
    "dept": "SOC",
    "num": "325",
    "desc": "\nThe impacts of agricultural changes on farm families, rural communities, and consumers.  Past, present, and future trends in family farms and their social implications.\n",
    "credits": "3"
  },
  {
    "course_name": "Sex and Gender in Society",
    "dept": "SOC",
    "num": "327",
    "desc": "Prereq: SOC 134\nHow the biological fact of sex is transformed into a system of gender stratification. The demographics and social positions of women and men in the family, education, media, politics, and the economy. Theories of the social-psychological and sociological bases for behavior and attitudes of women and men. The relationship between gender, class, and race.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Masculinities and Manhood",
    "dept": "SOC",
    "num": "328",
    "desc": "Prereq: SOC 134 or WGS 201\nExamination of socially constructed and idealized images of manhood, the nature of social hierarchies and relations constructed on the basis of imagery, ideologies, and norms of masculinity. Theories on gender (sociological, psychological, and biological). Particular attention given to theory and research on gender variations among men by race, class, ethnicity, sexual orientation, physical ability and age.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Ethnic and Race Relations",
    "dept": "SOC",
    "num": "330",
    "desc": "Prereq: SOC 134\nAnalysis of ethnic and race relations, particularly in America; emphasis on the sociology and psychology of race and ethnic relations.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Social Class and Inequality",
    "dept": "SOC",
    "num": "331",
    "desc": "Prereq: SOC 134\nSocial stratification and processes resulting in social and economic inequalities; implications of status, class, and poverty for people of different races, ethnicities, and gender.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "The Latino/Latina Experience in U.S. Society",
    "dept": "SOC",
    "num": "332",
    "desc": "Prereq: SOC 134\nExamination of the social, historical, economic and political experience of varied Latino ethnic groups in the U.S. - primarily focusing on Mexican, Puerto Ricans, and Cubans.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Politics and Society",
    "dept": "SOC",
    "num": "334",
    "desc": "Prereq: A course in political science or sociology\nThe relationship between politics and society with emphasis on American society. Discussion of theories of inequality, power, social movements, elites, ruling classes, democracy, and capitalism.\n",
    "credits": "3"
  },
  {
    "course_name": "Deviant and Criminal Behavior",
    "dept": "SOC",
    "num": "340",
    "desc": "Prereq: SOC 134 or CJ ST 240\nTheory and research on the etiology of types of social deviance; issues relating to crime, antisocial behavior and social policies designed to control deviant behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Population and Society",
    "dept": "SOC",
    "num": "345",
    "desc": "Prereq: SOC 134\nHuman population growth and structure; impact on food, environment, and resources; gender issues; trends of births, deaths, and migration; projecting future population; population policies and laws; comparison of the United States with other societies throughout the world.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Poverty, Resources and Sustainable Development",
    "dept": "SOC",
    "num": "348",
    "desc": "Prereq: SOC 134\nTrends in hunger, poverty, resource use and development.  Assessment of theories, policies, and programs to promote sustainable livelihoods, resource management, and development at local and national levels. Examine solutions through institutional efforts and grassroots social movements.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Ethics in Agriculture",
    "dept": "SOC",
    "num": "362",
    "desc": "Prereq: ECON 101 or SOC 134, junior or senior status in the College of Agriculture\nIdentify major ethical issues and dilemmas in the conduct of agricultural and agribusiness management and decision making. Discuss and debate proper ethical behavior in these issues and situations and the relationship between business and personal ethical behavior.\n",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Work",
    "dept": "SOC",
    "num": "380",
    "desc": "Prereq: SOC 134\nInequalities (gender, race, class) related to jobs, occupations, firms, and industries. Satisfactions, rewards, alienation, discrimination, and other topics of importance to workers are examined.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Psychology of Small Group Behavior",
    "dept": "SOC",
    "num": "381",
    "desc": "Prereq: SOC 305 or PSYCH 280\nA survey of small group theory and research from an interdisciplinary, social psychological perspective.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Sociology",
    "dept": "SOC",
    "num": "382",
    "desc": "Prereq: SOC 134 or 3 credits of ENV S\nEnvironment-society relations; social construction of nature and the environment; social and environmental impacts of resource extraction, production, and consumption; environmental inequality; environmental mobilization and movements; U.S. and international examples.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Sociological Theories",
    "dept": "SOC",
    "num": "401",
    "desc": "Prereq: 9 credits in sociology\nBoth historical and modern social theories as applied to understanding and researching the social world.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Change in Developing Countries",
    "dept": "SOC",
    "num": "411",
    "desc": "Prereq: SOC 134 plus 3 credits in social sciences\nSocial change and development in developing countries; international interdependence; causes and consequences of persistent problems in agriculture, city growth, employment, gender equality, basic needs; local and worldwide efforts to foster social change and international development.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Dynamics of Social Change",
    "dept": "SOC",
    "num": "415",
    "desc": "Prereq: SOC 134 plus 3 credits in social sciences\nExamination of public responses to complex and controversial innovations, such as environmentalism, feminism, stem-cell research, same-sex marriage, large-scale hog lots, and others.  Strategies for gaining adoption/rejection of controversial innovations. Applications to topics in agriculture, development, business, and marketing.\n  Credit for only Soc 415 or 515 may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Criminal and Juvenile Justice Practicum",
    "dept": "SOC",
    "num": "460",
    "desc": "Prereq: Junior or senior classification; permission of criminal justice studies coordinator; major or minor in criminal justice or sociology\nStudy of the criminal and juvenile justice systems and social control processes. Supervised placement in a police department, prosecutor's office, court, probation and parole department, penitentiary, juvenile correctional institution, community-based rehabilitation program, or related agency. Assessed service learning component.\n  Offered on a satisfactory-fail basis only.  No more than a total of 9 credits of 460 can be counted toward graduation. No credits in Soc 460 may be used to satisfy minimum sociology requirements for sociology majors.",
    "credits": "3"
  },
  {
    "course_name": "Strategies for Community Engagement",
    "dept": "SOC",
    "num": "464",
    "desc": "Prereq: 6 credits in sociology\nProject-focused engagement in community issues and initiatives.  A broad range of strategies will be addressed, including popular education, applied research, network analysis and mapping, policy focused work, action research, curriculum development, community organizing, and organizational development.\n",
    "credits": "3"
  },
  {
    "course_name": "Sociology of the Family",
    "dept": "SOC",
    "num": "485",
    "desc": "Prereq: 6 credits in sociology\nThe contemporary family in developing, industrial, and post-industrial societies. Effects of modernization, cultural change, and family policies on family dynamics, structures, and functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "SOC",
    "num": "490",
    "desc": "Prereq: 6 credits in sociology and permission of instructor\n  Students in the College of Agriculture must be of junior or senior classification and may use no more than 6 credits of Soc 490 toward the total of 128 credits required for graduation. Students in the College of Liberal Arts and Sciences may count no more than 9 credits of 490 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: General Sociology",
    "dept": "SOC",
    "num": "490A",
    "desc": "Prereq: 6 credits in sociology and permission of instructor\n  Students in the College of Agriculture must be of junior or senior classification and may use no more than 6 credits of Soc 490 toward the total of 128 credits required for graduation. Students in the College of Liberal Arts and Sciences may count no more than 9 credits of 490 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Rural Sociology",
    "dept": "SOC",
    "num": "490B",
    "desc": "Prereq: 6 credits in sociology and permission of instructor\n  Students in the College of Agriculture must be of junior or senior classification and may use no more than 6 credits of Soc 490 toward the total of 128 credits required for graduation. Students in the College of Liberal Arts and Sciences may count no more than 9 credits of 490 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Senior Seminar",
    "dept": "SOC",
    "num": "490E",
    "desc": "Prereq: 6 credits in sociology and permission of instructor\n  Students in the College of Agriculture must be of junior or senior classification and may use no more than 6 credits of Soc 490 toward the total of 128 credits required for graduation. Students in the College of Liberal Arts and Sciences may count no more than 9 credits of 490 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "SOC",
    "num": "490H",
    "desc": "Prereq: 6 credits in sociology and permission of instructor\n  Students in the College of Agriculture must be of junior or senior classification and may use no more than 6 credits of Soc 490 toward the total of 128 credits required for graduation. Students in the College of Liberal Arts and Sciences may count no more than 9 credits of 490 toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Classical Sociological Theory",
    "dept": "SOC",
    "num": "506",
    "desc": "Prereq: SOC 401 or SOC 505\nThe origins of the canonical works of sociology in the mid-Industrial Revolution period including Karl Marx, Max Weber, Emile Durkheim and others.\n",
    "credits": "3"
  },
  {
    "course_name": "Agroecosystems Analysis",
    "dept": "SOC",
    "num": "509",
    "desc": "Prereq: Senior or above classification; permission of instructor\nExperiential, interdisciplinary examination of Midwestern agricultural and food systems, emphasizing both field visits and classroom activities. Focus on understanding multiple elements, perspectives (agronomic, economic, ecological, social, etc.), and scales of operation.\n",
    "credits": "4"
  },
  {
    "course_name": "Research Methodology for the Social Sciences",
    "dept": "SOC",
    "num": "511",
    "desc": "Prereq: SOC 302 and STAT 401\nCovers the philosophy and the techniques of research methods in sociology and other social sciences, including the ethics and politics of social science, validity issues, conceptualization and operationalization, sampling strategies, appropriate research designs for different questions, survey construction, and various data collection and analysis techniques.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Multivariate Statistics for Social and Behavioral Research",
    "dept": "SOC",
    "num": "512",
    "desc": "Prereq: STAT 404 or with instructor's permission\nApplied techniques of multivariate analysis includng cluster analysis, principal components and factor analysis, multivariate analysis of variance and covariance binomial and multinomial regression, multi-level random coefficient models, and spatial regression. Conceptual and mathematical grounding for nonstatisticians. Instruction in Mplus and SAS.\n",
    "credits": "3"
  },
  {
    "course_name": "Qualitative Research Methods",
    "dept": "SOC",
    "num": "513",
    "desc": "Prereq: SOC 511\nApplied qualitative research methods in sociology. Design and implementation of a course-based research project including data collection, analysis, and presentation of results. Qualitative data gathering techniques using observational, historical, in-depth interviewing or content analysis approaches. Laboratory emphasis on completion of data gathering, analysis, and report writing.\n",
    "credits": "3"
  },
  {
    "course_name": "Social Psychology: A Sociological Perspective",
    "dept": "SOC",
    "num": "520",
    "desc": "Prereq: SOC 305 or PSYCH 280\nExamination of cognitive, symbolic interaction, exchange, role-reference group, and dramaturgical approaches. Assessment of contemporary issues in social psychology.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Psychology",
    "dept": "SOC",
    "num": "525",
    "desc": "Prereq: SOC 305 or PSYCH 280\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Psychology: Small Groups",
    "dept": "SOC",
    "num": "525A",
    "desc": "Prereq: SOC 305 or PSYCH 280\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Psychology: Attitudes and Attitude Change",
    "dept": "SOC",
    "num": "525B",
    "desc": "Prereq: SOC 305 or PSYCH 280\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Psychology: Symbolic interactionism",
    "dept": "SOC",
    "num": "525C",
    "desc": "Prereq: SOC 305 or PSYCH 280\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Psychology: Self and Identity",
    "dept": "SOC",
    "num": "525D",
    "desc": "Prereq: SOC 305 or PSYCH 280\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Inequality",
    "dept": "SOC",
    "num": "527",
    "desc": "Prereq: 6 credits in sociology\nAnalysis of racial and ethnic inequality in the United States and the world; focus on the implications of the changing world social and economic order for differences in racial and ethnic groups relative to wealth, status, and power; a critical examination of majority-group domination of minority groups in various societies.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Inequality: Sociology of Race and Ethnicity",
    "dept": "SOC",
    "num": "527A",
    "desc": "Prereq: 6 credits in sociology\nAnalysis of racial and ethnic inequality in the United States and the world; focus on the implications of the changing world social and economic order for differences in racial and ethnic groups relative to wealth, status, and power; a critical examination of majority-group domination of minority groups in various societies.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Inequality: Sociology of Gender",
    "dept": "SOC",
    "num": "527B",
    "desc": "Prereq: 6 credits in sociology\nAnalysis of racial and ethnic inequality in the United States and the world; focus on the implications of the changing world social and economic order for differences in racial and ethnic groups relative to wealth, status, and power; a critical examination of majority-group domination of minority groups in various societies.\n",
    "credits": "3"
  },
  {
    "course_name": "Rural Development and Community",
    "dept": "SOC",
    "num": "533",
    "desc": "Prereq: SOC 511 or equivalent\nLinkages between socioeconomic development, space, and community in local and global contexts.  Focus on economic, social, cultural, environmental, and spatial dimensions of communities. Presentation of conceptual models.  Applications using data and methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Race, Class and Gender Inequality",
    "dept": "SOC",
    "num": "534",
    "desc": "Prereq: 6 credits in sociology\nCritical examination of the causes and consequences of social stratification and inequality; classical theories, contemporary frameworks, and recent empirical studies; international stratification patterns.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategies for Community Engagement in Food and Farming Systems",
    "dept": "SOC",
    "num": "536",
    "desc": "Prereq: 6 credits in sociology\nProject-focused community practice using diverse approaches and perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Comparative Social Change",
    "dept": "SOC",
    "num": "540",
    "desc": "Prereq: 6 graduate credits in sociology\nContemporary theories of social change, modernization, dependency, and development are critically examined; methodological issues identified; supporting research explored; applicability of theoretical models, concepts, and strategies to current national and international needs are evaluated.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Change and Development",
    "dept": "SOC",
    "num": "543",
    "desc": "Prereq: 6 credits in sociology\nSeminar in social change and development.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Change and Development: Strategies of Community Engagement",
    "dept": "SOC",
    "num": "543A",
    "desc": "Prereq: 6 credits in sociology\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Change and Development: Sociology of Adoption and Diffusion",
    "dept": "SOC",
    "num": "543B",
    "desc": "Prereq: 6 credits in sociology\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Social Change and Development: Technological Innovation, Social Change and Development",
    "dept": "SOC",
    "num": "543C",
    "desc": "Prereq: 6 credits in sociology\n",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Food and Agricultural Systems",
    "dept": "SOC",
    "num": "544",
    "desc": "Prereq: 6 credits in sociology\nSocial organization of food and fiber production, processing, and distribution systems. Sociological comparison of conventional and alternative production systems; gender roles in agriculture and food systems; local, national and global food systems; perspectives on food and agricultural research and policy.\n",
    "credits": "3"
  },
  {
    "course_name": "Sociology of the Environment",
    "dept": "SOC",
    "num": "549",
    "desc": "Prereq: 6 credits in sociology\nSocial causes and social consequences of environmental problems. Interrelationship between social inequality and environmental inequality. Social construction and social experience of the environment. Contemporary developments in the social theory of the environment. International and domestic implications.\n",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Economic Life",
    "dept": "SOC",
    "num": "550",
    "desc": "Prereq: 6 credits in sociology\nSocial construction of economic activity in non-industrial and industrial societies with special attention on variations of industrial societies (capitalism and socialism), economic globalization, and economic development. Interaction of economic systems with human values, ideology, organizations, work and individual welfare.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Economy, Organization, and Work",
    "dept": "SOC",
    "num": "551",
    "desc": "Prereq: 6 credits in sociology\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Economy, Organization, and Work: Complex Organizations",
    "dept": "SOC",
    "num": "551B",
    "desc": "Prereq: 6 credits in sociology\n",
    "credits": "3"
  },
  {
    "course_name": "Current Issues in Crime and Justice",
    "dept": "SOC",
    "num": "584",
    "desc": "Prereq: 6 credits in sociology\nDiscussion of current research and theory in crime and delinquency; topics include the purpose and role of law in social life; emerging theoretical directions in criminology; recent work on specific forms of criminality; controversies in the criminal justice system.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "SOC",
    "num": "590",
    "desc": "Prereq: 6 credits in sociology; senior or graduate classification\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: General Sociology",
    "dept": "SOC",
    "num": "590A",
    "desc": "Prereq: 6 credits in sociology; senior or graduate classification\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Rural Sociology",
    "dept": "SOC",
    "num": "590B",
    "desc": "Prereq: 6 credits in sociology; senior or graduate classification\n",
    "credits": "1"
  },
  {
    "course_name": "Orientation to Sociology",
    "dept": "SOC",
    "num": "591",
    "desc": "Prereq: Formal admission into the sociology graduate program\nIntroduction to the department, current graduate student policies at department and university levels, departmental administrative procedures. Required of graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Research for Master's Thesis",
    "dept": "SOC",
    "num": "599",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research for Master's Thesis: General Sociology",
    "dept": "SOC",
    "num": "599A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Research for Master's Thesis: Rural Sociology",
    "dept": "SOC",
    "num": "599B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Contemporary Sociological Theory",
    "dept": "SOC",
    "num": "607",
    "desc": "Prereq: 6 graduate credits in sociology\nProvides a review of modern sociological thought, issues, and controversies as they affect current research and discourse in the discipline.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Sustainable Agriculture",
    "dept": "SOC",
    "num": "610",
    "desc": "Prereq: Graduate classification, permission of instructor\nHistorical, biophysical, socioeconomic, and ethical dimensions of agricultural sustainability. Strategies for evaluating existing and emerging agricultural systems in terms of the core concepts of sustainability and their theoretical contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Structural Equation Models for Social and Behavioral Research",
    "dept": "SOC",
    "num": "613",
    "desc": "Prereq: SOC 512 and STAT 404, or with instructors permission.\nSpecification, identification, and interpretation of structural equation models. Techniques include structural or  path models, measurement or confirmatory factor models, structural models with latent variables, and multi-level structural models. Conceptual and mathematical grounding for non-statisticians. Instruction in AMOS, MPLUS, and SAS.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology",
    "dept": "SOC",
    "num": "698",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Community Studies and Development",
    "dept": "SOC",
    "num": "698L",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Criminology",
    "dept": "SOC",
    "num": "698M",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: The Economy, Organizations, and Work",
    "dept": "SOC",
    "num": "698N",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Food Systems, Agriculture, and the Environment",
    "dept": "SOC",
    "num": "698O",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Methodology",
    "dept": "SOC",
    "num": "698P",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Social Change and Development",
    "dept": "SOC",
    "num": "698Q",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Social Inequality",
    "dept": "SOC",
    "num": "698R",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Social Psychology",
    "dept": "SOC",
    "num": "698S",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Sociology of Families",
    "dept": "SOC",
    "num": "698T",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Seminars in Sociology: Theory",
    "dept": "SOC",
    "num": "698U",
    "desc": "\n",
    "credits": "3"
  },
  {
    "course_name": "Dissertation Research",
    "dept": "SOC",
    "num": "699",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Dissertation Research: General Sociology",
    "dept": "SOC",
    "num": "699A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Dissertation Research: Rural Sociology",
    "dept": "SOC",
    "num": "699B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Software Engineering Orientation",
    "dept": "S E",
    "num": "101",
    "desc": "\nIntroduction to the procedures, policies, and resources of Iowa State University and the Software Engineering Program.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Careers in Software Engineering",
    "dept": "S E",
    "num": "166",
    "desc": "\nOverview of the nature and scope of the software engineering profession, relationship of coursework to careers, and program of study planning.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Problem Solving in Software Engineering",
    "dept": "S E",
    "num": "185",
    "desc": "Prereq: MATH 143 or satisfactory scores on mathematics placement examinations; credit or enrollment in MATH 165\nIntroduction to software engineering and computer programming. Systematic thinking process for problem solving in the context of software engineering. Group problem solving. Solving software engineering problems and presenting solutions through computer programs, written documents and oral presentations. Introduction to principles of programming, software design, and extensive practice in design, writing, running, debugging, and reasoning about programs.\n  Only one of ENGR 160, A B E 160, AER E 160, C E 160, CH E 160, CPR E 185, E E 185, I E 148, M E 160, and S E 185 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Software Development Practices",
    "dept": "S E",
    "num": "309",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165\nA practical introduction to methods for managing software development. Process models, requirements analysis, structured and object-oriented design, coding, testing, maintenance, cost and schedule estimation, metrics. Programming projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Construction of User Interfaces",
    "dept": "S E",
    "num": "319",
    "desc": "Prereq: COM S 228\nOverview of user interface design. Evaluation and testing of user interfaces.  Review of principles of object orientation, object oriented design and analysis using UML in the context of user interface design. Design of windows, menus and commands. Developing Web and Windows-based user-interfaces. Event-driven programming. Introduction to Frameworks and APIs for the construction of user interfaces.\n",
    "credits": "3"
  },
  {
    "course_name": "Software Project Management",
    "dept": "S E",
    "num": "329",
    "desc": "Prereq: COM S 309\nProcess-based software development. Capability Maturity Model (CMM). Project planning, cost estimation, and scheduling. Project management tools. Factors influencing productivity and success. Productivity metrics. Analysis of options and risks. Version control and configuration management. Inspections and reviews. Managing the testing process. Software quality metrics. Modern software engineering techniques and practices.\n",
    "credits": "3"
  },
  {
    "course_name": "Software Architecture and Design",
    "dept": "S E",
    "num": "339",
    "desc": "Prereq: S E 319\nModeling and design of software at the architectural level. Architectural styles. Basics of model-driven architecture. Object-oriented design and analysis. Iterative development and unified process. Design patterns. Design by contract. Component based design. Product families. Measurement theory and appropriate use of metrics in design. Designing for qualities such as performance, safety, security, reliability, reusability, etc. Analysis and evaluation of software architectures. Introduction to architecture definition languages. Basics of software evolution, reengineering, and reverse engineering. Case studies. Introduction to distributed system software.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Programming Languages",
    "dept": "S E",
    "num": "342",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165; COM S 230 or CPR E 310\nStudy of concepts in programming languages, especially functional programming concepts. Overview of major programming paradigms, their relationship, and tradeoffs among paradigms enabling sound choices of programming language for application-specific development. Programming projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Object-Oriented Analysis and Design",
    "dept": "S E",
    "num": "362",
    "desc": "Prereq: Minimum of C- in COM S 228 and MATH 165; ENGL 250\nObject-oriented requirements analysis and systems design. Design notations such as the Unified Modeling Language. Design Patterns.  Group design and programming with large programming projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Summer Internship",
    "dept": "S E",
    "num": "396",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period of at least 10 weeks during the summer. Students must register for this course prior to commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Cooperative Education (Co-op)",
    "dept": "S E",
    "num": "398",
    "desc": "Prereq: Permission of department and Engineering Career Services\nProfessional work period. One semester per academic or calendar year. Students must register for this course before commencing work.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Software Requirements Engineering",
    "dept": "S E",
    "num": "409",
    "desc": "Prereq: COM S 309; for graduate credit: graduate standing or permission of instructor\nThe requirements engineering process including elicitation, requirements analysis fundamentals, requirements specification and communication, and requirements evaluation.  Modeling of functional and nonfunctional requirements, traceability, and requirements change management. Case studies and software projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Formal Methods in Software Engineering",
    "dept": "S E",
    "num": "412",
    "desc": "Prereq: COM S 311, STAT 330; for graduate credit: graduate standing or permission of instructor\nA study of formal techniques for model-based specification and verification of software systems. Topics include logics, formalisms, graph theory, numerical computations, algorithms and tools for automatic analysis of systems. Graduate credit requires in-\u00addepth study of concepts.\n",
    "credits": "3"
  },
  {
    "course_name": "Software Evolution and Maintenance",
    "dept": "S E",
    "num": "416",
    "desc": "Prereq: COM S 309\nPractical importance of software evolution and maintenance, systematic defect analysis and debugging techniques, tracing and understanding large software, impact analysis, program migration and transformation, refactoring, tools for software evolution and maintenance, experimental studies and quantitative measurements of software evolution. Written reports and oral presentation.\n",
    "credits": "3"
  },
  {
    "course_name": "Software Testing",
    "dept": "S E",
    "num": "417",
    "desc": "Prereq: COM S 309; COM S 230 or CPR E 310; ENGL 250, SP CM 212\nAn introduction to software testing principles and techniques. Test models, test design, test adequacy criteria; regression, integration, and system testing; and software testing tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Software Tools for Large Scale Data Analysis",
    "dept": "S E",
    "num": "419",
    "desc": "Prereq: CPR E 308 or COM S 352, COM S 309\nSoftware tools for managing and manipulating large volumes of data, external memory processing, large scale parallelism, and stream processing, data interchange formats. Weekly programming labs that involve the use of a parallel computing cluster.\n",
    "credits": "4"
  },
  {
    "course_name": "Software Analysis and Verification for Safety and Security",
    "dept": "S E",
    "num": "421",
    "desc": "Prereq: COM S 309; CPR E 310 or COM S 230\nSignificance of software safety and security; various facets of security in cyber-physical and computer systems; threat modeling for software safety and security; and categorization of software vulnerabilities. Software analysis and verification: mathematical foundations, data structures and algorithms, program comprehension, analysis, and verification tools; automated vs. human-on-the-loop approach to analysis and verification; and practical considerations of efficiency, accuracy, robustness, and scalability of analysis and verification. Cases studies with application and systems software; evolving landscape of software security threats and mitigation techniques. Understanding large software, implementing software analysis and verification algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "S E",
    "num": "490",
    "desc": "Prereq: Senior classification in software engineering\nInvestigation of an approved topic.\n",
    "credits": "arr"
  },
  {
    "course_name": "Senior Design Project I and Professionalism",
    "dept": "S E",
    "num": "491",
    "desc": "Prereq: S E 329 and S E 339, CPR E 308 or COM S 352, ENGL 309 or ENGL 314\nPreparing for entry to the workplace. Selected professional topics. Use of technical writing skills in developing project plan and design report; project poster. First of two-semester team-oriented, project design and implementation experience.\n",
    "credits": "3"
  },
  {
    "course_name": "Senior Design Project II",
    "dept": "S E",
    "num": "492",
    "desc": "Prereq: S E 491\nSecond semester of a team design project experience. Emphasis on the successful implementation and demonstration of the design completed in S E 491 and the evaluation of project results. Technical writing of final project report; oral presentation of project achievements.\n",
    "credits": "2"
  },
  {
    "course_name": "Software Engineering Portfolio Development",
    "dept": "S E",
    "num": "494",
    "desc": "Prereq: Credit or enrollment in S E 491\nPortfolio assessment for Software Engineers. Guidelines and Advice to improve software engineering portfolios and to better use portfolios as a tool to enhance career opportunities.\n",
    "credits": "R"
  },
  {
    "course_name": "Accelerated Spanish Review",
    "dept": "SPAN",
    "num": "097",
    "desc": "Prereq: Two years but less than three years of high-school Spanish\nFor students who require additional review at the first year (101-102) level. Course components include a compact review of 101 and the essential elements of 102. Course completed with a passing grade fulfills the LAS foreign language requirement. Not recommended for students who wish to continue language at the second year (201-202) level without completing 102.\n",
    "credits": "0"
  },
  {
    "course_name": "Elementary Spanish I",
    "dept": "SPAN",
    "num": "101",
    "desc": "\nA communicative approach to grammar and vocabulary within the context of Hispanic culture. For students whose native language is not Spanish.\n",
    "credits": "4"
  },
  {
    "course_name": "Elementary Spanish II",
    "dept": "SPAN",
    "num": "102",
    "desc": "Prereq: SPAN 101, SPAN 97 or placement by departmental exam\nContinuation of Spanish 101. A communicative approach to grammar and vocabulary within the context of Hispanic culture. For students whose native language is not Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Study Abroad",
    "dept": "SPAN",
    "num": "195",
    "desc": "\nSupervised instruction in Spanish and Hispanic culture; formal class instruction at level appropriate to student's training, augmented by practical living experience. Taught in Spanish. Consult the department regarding equivalency with SPAN 101 or 102.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Intermediate Spanish I",
    "dept": "SPAN",
    "num": "201",
    "desc": "Prereq: SPAN 102 or placement by departmental exam\nIntensive review of basic grammar and conversation. For students whose native language is not Spanish. Practice in oral and written communication. Development of fluency with idiomatic expressions. Selected readings on culture and literature.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Spanish II",
    "dept": "SPAN",
    "num": "202",
    "desc": "Prereq: SPAN 201 or placement by departmental exam\nContinuation of Spanish 201. Intensive review of basic grammar. Practice in oral and written communication. Development of fluency with idiomatic expressions. Selected readings on culture and literature. For students whose native language is not Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Study Abroad",
    "dept": "SPAN",
    "num": "295",
    "desc": "Prereq: SPAN 102 or equivalent\nSupervised instruction in Spanish and Hispanic culture; formal class instruction at level appropriate to student's training, augmented by practical living experience. Taught in Spanish. Consult the department regarding equivalency with SPAN 201 or 202.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Intensive Intermediate Spanish",
    "dept": "SPAN",
    "num": "297",
    "desc": "Prereq: 4 years of high school Spanish, two years of Spanish at a community college, Spanish 201, or equivalent by placement\nBridge course between 200- and 300-level Spanish courses that focuses on application of advanced grammatical concepts within the context of Hispanic culture. Accelerated review of SPAN 201 and SPAN 202 designed for students who want to continue at the 300 level.  Taught in Spanish for students whose native language is not Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "4"
  },
  {
    "course_name": "Spanish Conversation and Composition",
    "dept": "SPAN",
    "num": "303",
    "desc": "Prereq: SPAN 202 or placement by departmental exam\nIntensive oral practice and improvement of oral proficiency. Application of specific grammatical concepts for development of conversational and writing skills within the context of Hispanic culture. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Spanish Conversation and Composition: through Culture",
    "dept": "SPAN",
    "num": "303A",
    "desc": "Prereq: SPAN 202 or placement by departmental exam\nIntensive oral practice and improvement of oral proficiency. Application of specific grammatical concepts for development of conversational and writing skills within the context of Hispanic culture. Taught in Spanish. For students whose native language is not Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Spanish Conversation and Composition: for Professionals",
    "dept": "SPAN",
    "num": "303B",
    "desc": "Prereq: SPAN 202 or placement by departmental exam\nIntensive oral practice and improvement of oral proficiency. Application of specific grammatical concepts for development of conversational and writing skills within the context of Hispanic culture. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Spanish for Global Professionals",
    "dept": "SPAN",
    "num": "304",
    "desc": "Prereq: SPAN 202 or placement by departmental exam (SPAN 303B recommended)\nIntroduction to professional communication within a cultural context. Grammar review as needed. Individual projects will focus on special interests. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Textual and Media Analyses",
    "dept": "SPAN",
    "num": "314",
    "desc": "Prereq: SPAN 303A or 303B\nCritical reading of Hispanic cultural texts. Presentation of techniques and terminology of textual criticism. Study of basic genres and media-generated artifacts and literary texts. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Spanish Civilization",
    "dept": "SPAN",
    "num": "321",
    "desc": "Prereq: One course at the 300 level\nA survey of the social, political, religious, and cultural history of Spain. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Civilization",
    "dept": "SPAN",
    "num": "322",
    "desc": "Prereq: One course at the 300 level\nA survey of the social, political, religious, and cultural history of Spanish America. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Spain Today",
    "dept": "SPAN",
    "num": "323",
    "desc": "Prereq: One course at the 300 level\nA survey of social, political, economic, and cultural topics relevant to contemporary Spain. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin America Today",
    "dept": "SPAN",
    "num": "324",
    "desc": "Prereq: One course at the 300 level\nA survey of social, political, economic, and cultural topics relevant to contemporary Latin America. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Hispanic Art or Film",
    "dept": "SPAN",
    "num": "326",
    "desc": "Prereq: One course at the 300 level\nSurvey of major currents and figures in Spanish and Latin American art and/or film. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Spanish Literature",
    "dept": "SPAN",
    "num": "330",
    "desc": "Prereq: SPAN 314\nIntroduction to Spanish literature from the earliest times through the present; techniques of literary criticism. Lectures, discussion, and analysis of individual selections in Spanish. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Latin American Literature",
    "dept": "SPAN",
    "num": "332",
    "desc": "Prereq: SPAN 314\nIntroduction to Latin American literature from the earliest times to the present; techniques of literary criticism. Lectures, discussion, and analysis of individual selections in Spanish. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish-English Translation",
    "dept": "SPAN",
    "num": "351",
    "desc": "Prereq: SPAN 303A or SPAN 303B or SPAN 304\nIntroduction to the theory, methods, techniques, and problems of translation. Consideration of material from business, literature, and the social sciences. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish Phonology",
    "dept": "SPAN",
    "num": "352",
    "desc": "Prereq: SPAN 303A or SPAN 303B or SPAN 304\nAn introductory study of the articulation, classification, distribution, and regional variations of the sounds of the Spanish language. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish-English Interpretation",
    "dept": "SPAN",
    "num": "354",
    "desc": "Prereq: SPAN 351\nIntroduction to the theory, methods, techniques, and problems of consecutive and simultaneous interpretation.  Consideration of material from business, agriculture, law, design, medicine, literature, advertisement, and sports. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Hispanic Topics in English Translation",
    "dept": "SPAN",
    "num": "370",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Readings, discussions, and papers in English. May not be counted as a prerequisite.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Hispanic Topics in English Translation: Agriculture",
    "dept": "SPAN",
    "num": "370A",
    "desc": "\nTopics vary according to faculty interest.  Knowledge and understanding of major cultural, ethical, sociopolitical and economic issues directly related to agriculture and agribusiness in Latin America, Spain, and/or Equatorial Guinea. Readings, discussions, and papers in English. May not be counted as a prerequisite.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation: Hispanic Topics on Women or Feminism",
    "dept": "SPAN",
    "num": "370S",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Readings, discussions, and papers in English. May not be counted as a prerequisite.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Study Abroad",
    "dept": "SPAN",
    "num": "395",
    "desc": "Prereq: 2 years university-level Spanish or equivalent\nSupervised instruction in Spanish and Hispanic culture; formal class instruction at level appropriate to students' training, enhanced by practical living experience.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Composition and Grammar",
    "dept": "SPAN",
    "num": "401",
    "desc": "Prereq: SPAN 314 and one course at the 320-level or above\nAdvanced study of Spanish grammar and syntax. Students' writing of compositions incorporates an advanced understanding of grammar, syntax, and principles of organization of thought and ideas. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on the Literatures and Cultures of Spain",
    "dept": "SPAN",
    "num": "440",
    "desc": "Prereq: SPAN 330, SPAN 331, SPAN 332, or SPAN 333. (Recommended SPAN 330 and SPAN 331)\nDiscussion and analysis of selected topics in Spanish literature and culture from the Middle Ages to the Present. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on Cervantes and the Golden Age",
    "dept": "SPAN",
    "num": "441",
    "desc": "Prereq: SPAN 330, SPAN 331, SPAN 332, or SPAN 333. (SPAN 330 recommended)\nDiscussion and analysis of selected works of Cervantes within the social and cultural context of the Golden Age. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on the Literatures and Cultures of Latin America",
    "dept": "SPAN",
    "num": "445",
    "desc": "Prereq: SPAN 330, SPAN 331, SPAN 332, SPAN or SPAN 333. (SPAN 332 and SPAN 333 recommended)\nDiscussion and analysis of selected topics in Latin American literature and culture from Pre-Colonial times to the Present. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Contrastive Analysis of Spanish/ English for Translators",
    "dept": "SPAN",
    "num": "462",
    "desc": "Prereq: SPAN 351\nLinguistic study of the major differences between the Spanish and English grammatical systems and their applications in the translation of Spanish to English. Taught in Spanish.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Spanish Linguistics",
    "dept": "SPAN",
    "num": "463",
    "desc": "Prereq: SPAN 352\nStudy of various topics related to the Spanish language. Topics may include bilingualism, historical linguistics and dialectology, Spanish in the U.S., language assessment, computer-assisted language learning and instruction, and second language acquisition. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "SPAN",
    "num": "490",
    "desc": "Prereq: 6 credits in Spanish and permission of department chair\nDesigned to meet the needs of students in areas other than those in which courses are offered, or who desire to integrate a study of literature or language with special problems in major fields.\n  No more than 6 credits in Span 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Internship in Spanish",
    "dept": "SPAN",
    "num": "499",
    "desc": "Prereq: 9 credits of Spanish at the 300 level; permission of advisor and WLC Internship Coordinator\nWork experience using Spanish language skills in the public or private sector, combined with academic work under faculty supervision.\n  Up to 3 credits may apply toward the major. Available only to majors and minors.",
    "credits": "1"
  },
  {
    "course_name": "Advanced Composition and Grammar",
    "dept": "SPAN",
    "num": "501",
    "desc": "Prereq: SPAN 314 and one course at the 320-level or above\nAdvanced study of Spanish grammar and syntax. Students' writing of compositions incorporates an advanced understanding of grammar, syntax, and principles of organization of thought and ideas. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Hispanic Art or Film",
    "dept": "SPAN",
    "num": "526",
    "desc": "Prereq: 6 credits in Spanish literature or culture at 400 level\nSurvey of major currents and figures in Spanish and Latin American art and/or film.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on the Literatures and Cultures of Spain",
    "dept": "SPAN",
    "num": "540",
    "desc": "Prereq: SPAN 330, SPAN 331, SPAN 332, or SPAN 333. (Recommended SPAN 330 and SPAN 331)\nDiscussion and analysis of selected topics in Spanish literature and culture from the Middle Ages to the Present. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on Cervantes and the Golden Age",
    "dept": "SPAN",
    "num": "541",
    "desc": "Prereq: SPAN 330, SPAN 331, SPAN 332, or SPAN 333. (SPAN 330 recommended)\nDiscussion and analysis of selected works of Cervantes within the social and cultural context of the Golden Age. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on the Literatures and Cultures of Latin America",
    "dept": "SPAN",
    "num": "545",
    "desc": "Prereq: SPAN 330, SPAN 331, SPAN 332, SPAN or SPAN 333. (SPAN 332 and SPAN 333 recommended)\nDiscussion and analysis of selected topics in Latin American literature and culture from Pre-Colonial times to the Present. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Spanish-English Interpretation",
    "dept": "SPAN",
    "num": "554",
    "desc": "Prereq: SPAN 351\nIntroduction to the theory, methods, techniques, and problems of consecutive and simultaneous interpretation.  Consideration of material from business, agriculture, law, design, medicine, literature, advertisement, and sports. Taught in Spanish.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Spanish",
    "dept": "SPAN",
    "num": "590",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Spanish\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Spanish: Literature or Literary Criticism",
    "dept": "SPAN",
    "num": "590A",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Spanish\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Spanish: Linguistics",
    "dept": "SPAN",
    "num": "590B",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Spanish\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Spanish: Language Pedagogy",
    "dept": "SPAN",
    "num": "590C",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Spanish\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Spanish: Civilization",
    "dept": "SPAN",
    "num": "590D",
    "desc": "Prereq: Permission of instructor; 6 credits of 400 level Spanish\n",
    "credits": "1"
  },
  {
    "course_name": "Education of the Exceptional Learner in a Diverse Society",
    "dept": "SP ED",
    "num": "250",
    "desc": "Prereq: EDUC 204 or EDUC 205\nAn overview of students with diverse learning needs, including students with disabilities, English Learners, students who are at risk, and gifted learners. Emphasis is on early identification; educational programming and implications; and legal foundations.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Instruction for Students with Mild/Moderate Disabilities",
    "dept": "SP ED",
    "num": "330",
    "desc": "Prereq: SP ED 250, concurrent enrollment in EDUC 280I, EDUC 377\nEducational services and programming for students with mild/moderate disabilities examined from an historical perspective. Current trends, issues, impact of federal and state laws, and identification procedures. Characteristics of students with mild/moderate disabilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Exceptional Learners in the General Classroom",
    "dept": "SP ED",
    "num": "334",
    "desc": "Prereq: Concurrent enrollment in SP ED 330\nEvidence-based strategies for inclusive education. Emphasis on principles of behavior, classroom management, differentiation, and accommodations.\n",
    "credits": "3"
  },
  {
    "course_name": "Classroom Assessment for Special Education",
    "dept": "SP ED",
    "num": "365",
    "desc": "Prereq: SP ED 330; EDUC 377\nFormal and informal academic and behavioral assessment. Determination of special education needs. Planning, adaptation, and formative evaluation of instructional programs for students with mild/moderate disabilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Secondary Students with Exceptionalities in General Education",
    "dept": "SP ED",
    "num": "401",
    "desc": "\nCharacteristics and needs of youth with exceptionalities, including appropriate service delivery options. Emphasis on legal foundations, co-teaching models, differentiated instruction, accommodations for instruction and assessment, and collaboration among professionals and parents.\n",
    "credits": "3"
  },
  {
    "course_name": "Assessment and Instructional Methods in Inclusive Primary Settings (K-3)",
    "dept": "SP ED",
    "num": "405",
    "desc": "Prereq: SP ED 250 (or equivalent), EDUC 377, EDUC 438; admission to teacher education; concurrent enrollment in SP ED 458, EDUC 433, EDUC 439, EDUC 468I.\nExamination and application of strategies to determine special educational needs, planning and evaluating instructional programs, and monitoring student progress. Evidence-based instructional strategies in academic and social areas that support learning of students with diverse learning needs. Emphasis on accommodations and alternative teaching strategies to meet individual student needs. Concurrent enrollment in SP ED 458, EDUC 433, EDUC 439, EDUC 468I.\n",
    "credits": "4"
  },
  {
    "course_name": "Supervised Student Teaching",
    "dept": "SP ED",
    "num": "416",
    "desc": "Prereq: Full admission to teacher education, senior classification, elementary education major; SP ED 330, SP ED 334, SP ED 365, SP ED 436, SP ED 439, EDUC 280I, EDUC 452\nReservation required.\n",
    "credits": "arr"
  },
  {
    "course_name": "Instructional Methods for Students with Mild/Moderate Disabilities",
    "dept": "SP ED",
    "num": "436",
    "desc": "Prereq: EDUC 245, concurrent enrollment in SP ED 365\nEvidence-based instructional strategies in academic areas, as well as class, group, and individual behavior management for elementary students with mild/moderate disabilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: Mild/Moderate Disabilities in Primary Grades (K-3)",
    "dept": "SP ED",
    "num": "458",
    "desc": "Prereq: EDUC 377, EDUC 438; admission to teacher education\nObservation and involvement with students with mild/moderate disabilities in the primary grades (K-3). Concurrent enrollment in SP ED 405.  Half a day of time needed. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Pre-Student Teaching Experience III: Mild/Moderate Disabilities",
    "dept": "SP ED",
    "num": "459",
    "desc": "Prereq: SP ED 330, SP ED 334, SP ED 365, SP ED 436; admission to teacher education.\nObservation and involvement with students with mild/moderate disabilities in school settings. Concurrent enrollment in SP ED 460. 1/2 day of time needed. Clinical Experience Level 3.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Special Education Seminar",
    "dept": "SP ED",
    "num": "460",
    "desc": "Prereq: SP ED 436, concurrent enrollment in SP ED 459\nApplication of evidence-based instructional strategies/techniques in academic and behavioral areas with students who have mild/moderate disabilities.  Discussion of professional practices.\n",
    "credits": "1"
  },
  {
    "course_name": "Collaborative Partnerships in Special Education",
    "dept": "SP ED",
    "num": "464",
    "desc": "Prereq: SP ED 365, SP ED 436\nCollaborative skills used in education of students with mild/moderate disabilities.  Includes collaboration between general and special education teachers, parents, paraeducators, and other education professionals and agencies.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "SP ED",
    "num": "490",
    "desc": "Prereq: 12 credits in Elementary Education\nTopics vary.\n",
    "credits": "1"
  },
  {
    "course_name": "Teaching Secondary Students with Exceptionalities in General Education",
    "dept": "SP ED",
    "num": "501",
    "desc": "Prereq: Baccalaureate degree\nCharacteristics and needs of exceptional children/youth, including appropriate service delivery options. Emphasis on legal foundations, co-teaching models, differentiated instruction, accommodations for instruction and assessment, and collaboration among professionals and parents.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations in Mild/Moderate Disabilities",
    "dept": "SP ED",
    "num": "510",
    "desc": "Prereq: SP ED 501 or equivalent\nHistorical and legal foundations for special education. Characteristics, prevalence, and etiology of mild/moderate disabilities. Historical and contemporary models of programming for students with disabilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Behavior Disorders and Learning Disabilities",
    "dept": "SP ED",
    "num": "511",
    "desc": "Prereq: SP ED 501 or equivalent\nTheory, characteristics, and special education service delivery models to students with moderate/severe behavior/learning disabilities in the public schools and residential settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Assessment of Children and Youth with Disabilities",
    "dept": "SP ED",
    "num": "515",
    "desc": "Prereq: SP ED 510 or SP ED 511\nFormal and informal methods of assessment for identification/eligibility, IEP development, and progress monitoring. Formative evaluation of academic and behavioral skills, including curriculum-based measurement and functional behavioral assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Review",
    "dept": "SP ED",
    "num": "517",
    "desc": "Prereq: RESEV 550, SP ED 515\nCritical review of recent research in education and related behavioral sciences as applied to education of students with disabilities. Examination of multiple research methodologies.\n",
    "credits": "2"
  },
  {
    "course_name": "Evidence-based Practices for Mild/Moderate Disabilities",
    "dept": "SP ED",
    "num": "520",
    "desc": "Prereq: SP ED 510, SP ED 515\nEvidence-based strategies for meeting the academic and behavioral needs of students with mild/moderate disabilities, including instructional and behavior management strategies appropriate for students with mild or moderate disabilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Evidence-based Practices in Behavior Disorders",
    "dept": "SP ED",
    "num": "530",
    "desc": "Prereq: SP ED 511, SP ED 515\nCurrent research on evidence-based interventions designed to improve the behavior and social skills of students with moderate/severe behavior disorders. Particular emphasis on positive behavioral supports and behavior change strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Evidence-based Practices in Learning Disabilities",
    "dept": "SP ED",
    "num": "540",
    "desc": "Prereq: SP ED 511, SP ED 515\nCurrent research on evidence-based interventions designed to improve the academic performance of students with moderate/severe learning disabilities. Particular emphasis on methods for improving reading, written expression, and mathematics, as well as performance in content-area instruction.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Adolescent Readers with Reading Difficulties",
    "dept": "SP ED",
    "num": "553",
    "desc": "Prereq: Teaching license or senior status\nInstructional strategies for enhancing the fluency, vocabulary and comprehension of adolescents with reading difficulties. Attention to content-area reading materials and strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Career Education and Transition for Youth with Disabilities",
    "dept": "SP ED",
    "num": "555",
    "desc": "Prereq: SP ED 510 or SP ED 511\nExamination of the academic, personal, social, employability, and daily living skills needed for a satisfactory adult life. Exploration of curricula, programs, and services to meet these needs.\n",
    "credits": "3"
  },
  {
    "course_name": "Classroom Management/Behavior Support",
    "dept": "SP ED",
    "num": "560",
    "desc": "Prereq: Teaching license\nEmphasis on positive behavioral supports and understanding behavior and its context through a functional behavioral approach. Design and development of carefully planned behavioral intervention programs for groups and individual students in general and special education settings.\n",
    "credits": "3"
  },
  {
    "course_name": "Collaborative Consultation",
    "dept": "SP ED",
    "num": "564",
    "desc": "Prereq: SP ED 515, SP ED 520 or SP ED 530 or SP ED 540\nCharacteristics and methods to promote effective collaboration and/or consultation with families, paraprofessionals, other school personnel, and representatives of other agencies. Role of consultants/collaborators in various settings. Includes specific attention to IEP development as a collaborative process.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Mathematics to Struggling Secondary Learners",
    "dept": "SP ED",
    "num": "567",
    "desc": "Prereq: Secondary teaching experience\nInstructional methods and assessment techniques for secondary students struggling to learn mathematics.  Particular emphasis on current research, practices, and trends in mathematics interventions for at-risk students and students with disabilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Systems-level Supports for Youth with Behavior and Learning Disabilities",
    "dept": "SP ED",
    "num": "570",
    "desc": "Prereq: SP ED 511\nOverview of support systems (education, juvenile justice, mental health, communities) that serve students with special education needs.  Working with and supporting families.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "SP ED",
    "num": "590",
    "desc": "Prereq: 6 credits in Education\nTopics vary.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience",
    "dept": "SP ED",
    "num": "591",
    "desc": "Prereq: 15 graduate credits in special area, admission to the graduate program in special education\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Mild/Moderate Disabilities, K-8",
    "dept": "SP ED",
    "num": "591G",
    "desc": "Prereq: 15 graduate credits in special area, admission to the graduate program in special education\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Mild/Moderate Disabilities, 5-12",
    "dept": "SP ED",
    "num": "591H",
    "desc": "Prereq: 15 graduate credits in special area, admission to the graduate program in special education\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Behavior Disorders/Learning Disabilities, Ages 5-21",
    "dept": "SP ED",
    "num": "591K",
    "desc": "Prereq: 15 graduate credits in special area, admission to the graduate program in special education\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Supervised Field Experience: Special Education, Non-licensure",
    "dept": "SP ED",
    "num": "591L",
    "desc": "Prereq: 15 graduate credits in special area, admission to the graduate program in special education\nSupervised on-the-job field experience in special areas.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "SP ED",
    "num": "599",
    "desc": "Prereq: 15 credits in education\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "SP ED",
    "num": "615",
    "desc": "\nSelected topics in special education. Analysis of current special education research. Evaluation of impact upon the profession. Implications for additional research.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "SP ED",
    "num": "699",
    "desc": "Prereq: 15 credits in education\n",
    "credits": "arr"
  },
  {
    "course_name": "Listening",
    "dept": "SP CM",
    "num": "110",
    "desc": "\nTheory, principles, and competency development in comprehensive, therapeutic, critical, consumer, and appreciative listening. The   impact of listening in relationships and partnerships.\n",
    "credits": "3"
  },
  {
    "course_name": "Fundamentals of Public Speaking",
    "dept": "SP CM",
    "num": "212",
    "desc": "\nTheory and practice of basic speech communication principles applied to public speaking. Practice in the preparation and delivery of extemporaneous speeches.\n",
    "credits": "3"
  },
  {
    "course_name": "America Speaks: Great Speakers and Speeches in US History",
    "dept": "SP CM",
    "num": "216",
    "desc": "\nSurvey of great speeches examined within their political and cultural contexts. Analysis of the rhetorical strategies of diverse speakers with an emphasis on texts from social movements in the United States.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis of Popular Culture Texts",
    "dept": "SP CM",
    "num": "275",
    "desc": "Prereq: Credit in or equivalent of 250\nAnalysis of how information and entertainment forms persuade and manipulate audiences. Study of several forms that may include newspapers, speeches, television, film, advertising, fiction, and magazines. Special attention to verbal and visual devices.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Projects",
    "dept": "SP CM",
    "num": "290",
    "desc": "Prereq: 3 credits in speech communication; permission of program director\n",
    "credits": "1"
  },
  {
    "course_name": "Language, Thought and Action",
    "dept": "SP CM",
    "num": "305",
    "desc": "Prereq: ENGL 250\nThe study of symbolic processes and how meaning is conveyed in words, sentences, and utterances; discussion of modern theories of meaning; and an exploration of relationships among language, thought and action.\n",
    "credits": "3"
  },
  {
    "course_name": "Business and Professional Speaking",
    "dept": "SP CM",
    "num": "312",
    "desc": "Prereq: SP CM 212\nTheory, principles, and competency development in the creation of coherent, articulate business and professional oral   presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication in Classrooms and Workshops",
    "dept": "SP CM",
    "num": "313",
    "desc": "Prereq: SP CM 212\nPrinciples of communicating information: training in classroom and workshop-oriented communication activities; use of recording   for analysis of presentations.\n",
    "credits": "3"
  },
  {
    "course_name": "Argumentation, Debate, and Critical Thinking",
    "dept": "SP CM",
    "num": "322",
    "desc": "Prereq: SP CM 212\nPractice in preparing and presenting arguments and debates; emphasis on critical thinking and ethical and logical duties of the   advocate; analysis, evidence, reasoning, attack, defense, research, case construction, and judging.\n",
    "credits": "3"
  },
  {
    "course_name": "Gender and Communication",
    "dept": "SP CM",
    "num": "323",
    "desc": "\nExamination of how understanding and enactment of gender identity is shaped by communication. Verbal and nonverbal communication across various contexts including personal relationships and the media.  Explores discourse of social movements aiming to transform cultural definitions of gender.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Legal Communication",
    "dept": "SP CM",
    "num": "324",
    "desc": "Prereq: SP CM 212\nSpeech communication in the legal system inside and outside the trial process: interviewing and counseling, negotiating and   bargaining, voir dire, opening statements, examination of witnesses, closing arguments, judge's instructions, jury behavior, and   appellate advocacy.\n",
    "credits": "3"
  },
  {
    "course_name": "Persuasion and Social Influence",
    "dept": "SP CM",
    "num": "327",
    "desc": "Prereq: SP CM 212\nExamination of persuasive theories, strategies and research in persuasion. Emphasis on application and analysis; logical, emotional, and ethical proofs.\n",
    "credits": "3"
  },
  {
    "course_name": "Rhetorical Traditions",
    "dept": "SP CM",
    "num": "350",
    "desc": "Prereq: ENGL 250\nIdeas about the relationship between rhetoric and society in contemporary and historical contexts. An exploration of classical and contemporary rhetorical theories in relation to selected topics that may include politics, gender, race, ethics, education, science, or technology.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar",
    "dept": "SP CM",
    "num": "404",
    "desc": "Prereq: Junior or above classification\nSeminar on topics central to the field of speech communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Speech Communication",
    "dept": "SP CM",
    "num": "404A",
    "desc": "Prereq: 15 credits in speech communication\n",
    "credits": "3"
  },
  {
    "course_name": "Speech Education",
    "dept": "SP CM",
    "num": "404B",
    "desc": "Prereq: 15 credits in speech communication\n",
    "credits": "3"
  },
  {
    "course_name": "Rhetorical Criticism",
    "dept": "SP CM",
    "num": "412",
    "desc": "Prereq: SP CM 212 and 6 credits in speech communication\nDevelopment of rhetorical theory and practice from Corax to modern times. Application of principles of criticism to current public speaking practices.\n",
    "credits": "3"
  },
  {
    "course_name": "History of American Public Address",
    "dept": "SP CM",
    "num": "416",
    "desc": "Prereq: SP CM 212\nRelationship between public discourse and social change; selected speakers and discourse as linked with political or historical   events.\n",
    "credits": "3"
  },
  {
    "course_name": "Campaign Rhetoric",
    "dept": "SP CM",
    "num": "417",
    "desc": "Prereq: SP CM 212\nBackgrounds of candidates for state and national elections; selected speeches and issues; persuasive strategies and techniques of individual speakers.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "SP CM",
    "num": "490",
    "desc": "Prereq: 18 credits in speech communication, junior classification, permission of program director\nOnly one independent study enrollment is permitted within the department per semester.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Directing Speech Activities",
    "dept": "SP CM",
    "num": "495A",
    "desc": "Prereq: C I 301; 9 credits in speech communication; minimum GPA of 2.5 in speech communication courses\nProblems, methods, and materials related to directing speech activities in secondary schools.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Teaching Speech",
    "dept": "SP CM",
    "num": "495B",
    "desc": "Prereq: C I 301; 9 credits in speech communication; minimum GPA of 2.5 in speech communication courses\nProblems, methods, and materials related to teaching speech, theatre, and media in secondary schools.\n",
    "credits": "3"
  },
  {
    "course_name": "Capstone Seminar",
    "dept": "SP CM",
    "num": "497",
    "desc": "Prereq: 15 credits in speech communication; junior or senior classification\nStudents synthesize relevant theory and research about contemporary communication practice; demonstrate potential to  become leaders in public/professional communication contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Communication Internship",
    "dept": "SP CM",
    "num": "499",
    "desc": "Prereq: 18 credits in speech communication courses, other courses deemed appropriate by faculty adviser; 2nd semester junior or senior standing; minimum GPA of 2.5 and minimum GPA of 3.0 in speech communication courses; and permission of the internship committee\nApplications should be submitted in the term prior to the term in which the internship is desired. Supervised application of speech communication in professional settings.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "SP CM",
    "num": "504",
    "desc": "Prereq: Junior or above classification\nSeminar on topics central to the field of speech communication.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar: Speech Communication",
    "dept": "SP CM",
    "num": "504A",
    "desc": "Prereq: Graduate classification\nTopics may include the following.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar: Speech Education",
    "dept": "SP CM",
    "num": "504B",
    "desc": "Prereq: Graduate classification\nTopics may include the following.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Fundamentals of Public Speaking",
    "dept": "SP CM",
    "num": "513",
    "desc": "Prereq: Permission of instructor\nIntroduction to the teaching of public speaking.  Exploration of pedagogical theory and methods related to SP CM 212 objectives, pedagogical approaches, lesson planning, assignment development, and evaluation of student projects. Required of all new teaching assistants teaching SP CM 212.\n",
    "credits": "3"
  },
  {
    "course_name": "The History of Rhetorical Theory I: From Plato to Bacon",
    "dept": "SP CM",
    "num": "547",
    "desc": "Prereq: 6 credits in English\nRhetorical theory from the classical period of ancient Greece and Rome through the Middle Ages to the early Renaissance; attention to its relation to the nature of knowledge, communication, practice, and pedagogy.\n",
    "credits": "3"
  },
  {
    "course_name": "The History of Rhetorical Theory II: From Bacon to the Present",
    "dept": "SP CM",
    "num": "548",
    "desc": "Prereq: 6 credits in English\nRhetorical theory from the early modern period (Bacon, Descartes, and Locke) to the present; attention to its relation to the nature of knowledge, communication practice, and pedagogy.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "SP CM",
    "num": "590",
    "desc": "Prereq: Permission of program chair\n",
    "credits": "1"
  },
  {
    "course_name": "Core Studies in Rhetoric, Composition, and Professional Communication",
    "dept": "SP CM",
    "num": "592",
    "desc": "Prereq: 12 credits in rhetoric, linguistics, or literature, excluding ENGL 150 and ENGL 250\nSeminar on topics central to the fields of rhetoric and professional communication or composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Core Studies: Rhetoric",
    "dept": "SP CM",
    "num": "592A",
    "desc": "Prereq: 12 credits in rhetoric, linguistics, or literature, excluding ENGL 150 and ENGL 250\nSeminar on topics central to the fields of rhetoric and professional communication or composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Core Studies: Composition",
    "dept": "SP CM",
    "num": "592B",
    "desc": "Prereq: 12 credits in rhetoric, linguistics, or literature, excluding ENGL 150 and ENGL 250\nSeminar on topics central to the fields of rhetoric and professional communication or composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Core Studies: Professional Communication",
    "dept": "SP CM",
    "num": "592C",
    "desc": "Prereq: 12 credits in rhetoric, linguistics, or literature, excluding ENGL 150 and ENGL 250\nSeminar on topics central to the fields of rhetoric and professional communication or composition.\n",
    "credits": "3"
  },
  {
    "course_name": "Orientation in Statistics",
    "dept": "STAT",
    "num": "100",
    "desc": "\nOpportunities, challenges, and the scope of the curriculum in statistics. For students planning or considering a career in this area.\n",
    "credits": "R"
  },
  {
    "course_name": "Principles of Statistics",
    "dept": "STAT",
    "num": "101",
    "desc": "Prereq: 1 1/2 years of high school algebra\nStatistical concepts in modern society; descriptive statistics and graphical displays of data; the normal distribution; data collection (sampling and designing experiments); elementary probability; elements of statistical inference; estimation and hypothesis testing; linear regression and correlation; contingency tables.\n  Credit for only one of the following courses may be applied toward graduation: STAT 101, STAT 104, STAT 105, STAT 201, or STAT 226.",
    "credits": "4"
  },
  {
    "course_name": "Introduction to Statistics",
    "dept": "STAT",
    "num": "104",
    "desc": "Prereq: 1 1/2 years of high school algebra\nStatistical concepts and their use in science; collecting, organizing and drawing conclusions from data; elementary probability; binomial and normal distributions; regression; estimation and hypothesis testing. For students in the agricultural and biological sciences.\n  Credit for only one of the following courses may be applied toward graduation: STAT 101, STAT 104, STAT 105, STAT 201, or STAT 226.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Statistics for Engineers",
    "dept": "STAT",
    "num": "105",
    "desc": "Prereq: MATH 165\nStatistical concepts with emphasis on engineering applications. Data collection; descriptive statistics; probability distributions and their properties; elements of statistical inference; regression; statistical quality control charts; use of statistical software.\n  Credit for only one of the following courses may be applied toward graduation: STAT 101, STAT 104, STAT 105, STAT 201, or STAT 226. Credit for both STAT 105 and STAT 305 may not be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Statistical Concepts and Methods",
    "dept": "STAT",
    "num": "201",
    "desc": "Prereq: Credit or enrollment in MATH 165\nStatistical thinking and applications of statistical concepts and methods in modern society. Display and summary of categorical and numerical data. Exploring relationships between variables, association, correlation, and regression. Observational studies and experiments. Probability concepts, random variables, discrete and continuous distributions. Elements of statistical inference; estimation and hypothesis testing.\n  Credit for only one of the following courses may be applied toward graduation: STAT 101, STAT 104, STAT 105, STAT 201, or STAT 226.",
    "credits": "4"
  },
  {
    "course_name": "Career Development in Math and Statistics",
    "dept": "STAT",
    "num": "202",
    "desc": "\nCareer development in the mathematics and statistics disciplines with an emphasis on contemporary social issues.   Presentations by professionals in STEM fields about occupations, decision-making strategies, and career goal implementation; development of job searching, resume writing, negotiating, and interviewing techniques.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Business Statistics I",
    "dept": "STAT",
    "num": "226",
    "desc": "Prereq: MATH 150 or MATH 165\nObtaining, organizing, and presenting statistical data; measures of location and dispersion; the Normal distribution; sampling and sampling distribution of the sample mean; elements of statistical inference; confidence intervals and hypothesis testing for the mean; describing bivariate relationships and inference for simple linear regression analysis; use of computers to visualize and analyze data.\n  Credit for only one of the following courses may be applied toward graduation: STAT 101, STAT 104, STAT 105, STAT 201, or STAT 226.",
    "credits": "3"
  },
  {
    "course_name": "Probability and Statistical Inference for Engineers",
    "dept": "STAT",
    "num": "231",
    "desc": "Prereq: Credit or enrollment in MATH 265 (or MATH 265H)\nEmphasis on engineering applications. Basic probability; random variables and probability distributions; joint and sampling distributions. Descriptive statistics; confidence intervals; hypothesis testing; simple linear regression; multiple linear regression; one way analysis of variance; use of statistical software.\n",
    "credits": "4"
  },
  {
    "course_name": "Intermediate Statistical Concepts and Methods",
    "dept": "STAT",
    "num": "301",
    "desc": "Prereq: STAT 101 or STAT 104 or STAT 105 or STAT 201\nStatistical concepts and methods used in the analysis of observational data. Analysis of single sample, two sample and paired sample data. Simple and multiple linear regression including polynomial regression and use of indicator variables. Model building and analysis of residuals. Introduction to one-way ANOVA, tests of independence for contingency tables, and logistic regression.\n  Credit for only one of the following courses may be applied toward graduation: STAT 301, STAT 326, or STAT 401",
    "credits": "4"
  },
  {
    "course_name": "Engineering Statistics",
    "dept": "STAT",
    "num": "305",
    "desc": "Prereq: MATH 165\nStatistics for engineering problem solving. Principles of engineering data collection; descriptive statistics; elementary probability distributions; principles of experimentation; confidence intervals and significance tests; one-, two-, and multi-sample studies; regression analysis; use of statistical software.\n  Credit for both Stat 105 and 305 may not be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Probabilistic Methods for Electrical Engineers",
    "dept": "STAT",
    "num": "322",
    "desc": "Prereq: E E 224\nIntroduction to probability with applications to electrical engineering. Sets and events, probability space, conditional probability, total probability and Bayes' rule. Discrete and continuous random variables, cumulative distribution function, probability mass and density functions, expectation, moments, moment generating functions, multiple random variables, functions of random variables. Elements of statistics, hypothesis testing, confidence intervals, least squares. Introduction to random processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Business Statistics II",
    "dept": "STAT",
    "num": "326",
    "desc": "Prereq: STAT 226\nMultiple regression analysis; regression diagnostics; model building; applications in analysis of variance and time series; random variables; distributions; conditional probability; statistical process control methods; use of computers to visualize and analyze data.\n  Credit for only one of the following courses may be applied toward graduation: STAT 301, STAT 326 or STAT 401.",
    "credits": "3"
  },
  {
    "course_name": "Probability and Statistics for Computer Science",
    "dept": "STAT",
    "num": "330",
    "desc": "Prereq: MATH 166\nTopics from probability and statistics applicable to computer science. Basic probability; Random variables and their distributions; Stochastic processes including Markov chains; Queuing models; Basic statistical inference; Introduction to regression.\n",
    "credits": "3"
  },
  {
    "course_name": "Visual Communication of Quantitative Information",
    "dept": "STAT",
    "num": "332",
    "desc": "Prereq: STAT 101, STAT 104, STAT 201 or STAT 226; ENGL 250\nCommunicating quantitative information using visual displays; visualizing data; interactive and dynamic data displays; evaluating current examples in the media; color, perception, and representation in graphs; interpreting data displays.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to the Theory of Probability and Statistics I",
    "dept": "STAT",
    "num": "341",
    "desc": "Prereq: MATH 265 (or MATH 265H)\nProbability; distribution functions and their properties; classical discrete and continuous distribution functions; multivariate probability distributions and their properties; moment generating functions; transformations of random variables; simulation of random variables and use of the R statistical package.\n  Credit for both STAT 341 and STAT 447 may not be applied toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Introduction to the Theory of Probability and Statistics II",
    "dept": "STAT",
    "num": "342",
    "desc": "Prereq: STAT 201 or equivalent; STAT 341; MATH 207 or MATH 317\nSampling distributions; confidence intervals and hypothesis testing; theory of estimation and hypothesis tests; linear model theory; resampling methods; introduction to Bayesian inference; use of the R statistical package for simulation and data analysis.\n",
    "credits": "4"
  },
  {
    "course_name": "Probability and Statistical Theory for Data Science",
    "dept": "STAT",
    "num": "347",
    "desc": "Prereq: MATH 207 or 317; MATH 265; STAT 301 or 326\nIntroduction to probability; distribution functions and their properties; classical discrete and continuous distributions; sampling distributions; theory of estimation; theory of inference; use of R statistical package for simulation and data analysis.\n  Credit for both STAT 341 and STAT 347 may not be applied toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Statistical Quality Assurance",
    "dept": "STAT",
    "num": "361",
    "desc": "Prereq: STAT 231, STAT 301, STAT 326 or STAT 401\nStatistical methods for process improvement. Simple quality assurance principles and tools.  Measurement system precision and accuracy assessment. Control charts. Process capability assessment. Experimental design and analysis for process improvement. Significant external project in process improvement.\n",
    "credits": "3"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "STAT",
    "num": "398",
    "desc": "Prereq: Permission of department chair\nOff-campus work periods for undergraduate students in a field of statistics.\n",
    "credits": "R"
  },
  {
    "course_name": "Statistical Design and the Analysis of Experiments",
    "dept": "STAT",
    "num": "402",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401\nThe role of statistics in research and the principles of experimental design. Concepts of experimental and observational units, randomization, replication, blocking, subdividing and repeatedly measuring experimental units; factorial treatment designs and confounding; common designs including randomized complete block design, Latin square design, split-plot design, and analysis of data from such common designs; extensions of the analysis of variance to cover variance components. Determining sample size.\n",
    "credits": "3"
  },
  {
    "course_name": "Regression for Social and Behavioral Research",
    "dept": "STAT",
    "num": "404",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401\nApplications of generalized linear regression models to social science data. Assumptions of regression; diagnostics and transformations; analysis of variance and covariance; logistic, multinomial and Poisson regression.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Methods for Spatial Data",
    "dept": "STAT",
    "num": "406",
    "desc": "Prereq: Six hours of statistics at the 400-level\nThe analysis of spatial data; geostatistical methods, mapping and spatial prediction; methods for areal data; models and methods for spatial point processes. Emphasis on application and practical use of spatial statistical analysis. Use of R and R packages for spatial data analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Multivariate Analysis",
    "dept": "STAT",
    "num": "407",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401, knowledge of matrix algebra\nTechniques for displaying and analyzing multivariate data including plotting high-dimensional data using interactive graphics; comparing group mean vectors using Hotelling's T2; multivariate analysis of variance;  reducing variable dimension with principal components; identifying factors with exploratory factor analysis; grouping observations with multidimensional scaling and cluster analysis; and classification using discriminant analysis, logistic regression, classification trees, and random forests. Introduction to the R statistical software package.\n",
    "credits": "3"
  },
  {
    "course_name": "Survey Sampling Techniques",
    "dept": "STAT",
    "num": "421",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401; STAT 341\nConcepts of sample surveys and the survey process; methods of designing sample surveys, including: simple random, stratified, systematic, probability proportional to size, and multistage sampling designs; methods of analyzing sample surveys including ratio, regression, domain estimation and nonresponse.\n",
    "credits": "3"
  },
  {
    "course_name": "Empirical Methods for the Computational Sciences",
    "dept": "STAT",
    "num": "430",
    "desc": "Prereq: STAT 330 or an equivalent course, MATH 166, knowledge of linear algebra.\nStatistical methods for research involving computers; exploratory data analysis; selected topics from analysis of designed experiments - analysis of variance, hypothesis testing, interaction among variables; linear regression, logistic regression, Poisson regression; parameter estimation, prediction, confidence regions, dimension reduction techniques, model diagnostics and sensitivity analysis; Markov chains and processes; simulation techniques and bootstrap methods; applications to computer science, bioinformatics, computer engineering - programs, models and systems as objects of empirical study; communicating results of empirical studies. Statistical software: R.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Probability Models",
    "dept": "STAT",
    "num": "432",
    "desc": "Prereq: STAT 231 or STAT 341 or STAT 447\nProbabilistic models in biological, engineering and the physical sciences.  Markov chains; Poisson, birth-and-death, renewal, branching and queuing processes; applications to bioinformatics and other quantitative problems.\n",
    "credits": "3"
  },
  {
    "course_name": "Bayesian Data Analysis",
    "dept": "STAT",
    "num": "444",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401; STAT 342 or STAT 447.\nProbability models and prior distributions; updating priors through the likelihood function.  Computational and simulation-based methods for deriving posterior distributions and for estimating parameters.  Basic statistical and hierarchical models.  Model adequacy and posterior predictive checks.  Markov Chain Monte Carlo methods and introduction to WinBUGS or similar software.  Emphasis on applications and examples from the social, biological and physical sciences.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Time Series",
    "dept": "STAT",
    "num": "451",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401\nMethods for analyzing data collected over time; review of multiple regression analysis. Elementary forecasting methods: moving averages and exponential smoothing. Autoregressive-moving average (Box-Jenkins) models: identification, estimation, diagnostic checking, and forecasting. Transfer function models and intervention analysis.  Introduction to multivariate time series methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Categorical Data Analysis",
    "dept": "STAT",
    "num": "457",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401\nStatistical methods for the analysis of categorical data: graphical summaries, estimation and inference for proportions, sample size determination, chi-square tests, measures of relative risk, odds and association, analysis of paired data and measures of agreement, logistic regression models, log-linear models.\n",
    "credits": "3"
  },
  {
    "course_name": "Computer Processing of Statistical Data",
    "dept": "STAT",
    "num": "479",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401\nStructure, content and programming aspects of modern statistical software packages.  Advanced techniques for data management, graphics, exploratory data analysis, and generalized linear models.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Computing Applications",
    "dept": "STAT",
    "num": "480",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401\nModern statistical computing. Topics may include: data management; spread sheets; verifying data accuracy; transferring data between software packages; data and graphical analysis with statistical software packages; algorithmic programming concepts and applications; simulation studies and resampling methods; software reliability; statistical modeling and machine learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "STAT",
    "num": "490",
    "desc": "Prereq: 10 credits in statistics\n  No more than 9 credits in Stat 490 may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "STAT",
    "num": "490H",
    "desc": "Prereq: 10 credits in statistics\n  No more than 9 credits in Stat 490 may be counted toward graduation.",
    "credits": "arr"
  },
  {
    "course_name": "Statistical Methods I",
    "dept": "STAT",
    "num": "500",
    "desc": "Prereq: STAT 447 or current enrollment in STAT 542; knowledge of matrix algebra.\nAnalysis of data from designed experiments and observational studies. Randomization-based inference; inference on group means; nonparametric bootstrap; pairing/blocking and other uses of restricted randomization. Use of linear models to analyze data; least squares estimation; estimability; sampling distributions of estimators; general linear tests; inference for parameters and contrasts. Model assessment and diagnostics; remedial measures; alternative approaches based on ranks.\n",
    "credits": "4"
  },
  {
    "course_name": "Multivariate Statistical Methods",
    "dept": "STAT",
    "num": "501",
    "desc": "Prereq: STAT 500; STAT 542; STAT 579 or equivalent; knowledge of matrix algebra.\nStatistical methods for analyzing and displaying multivariate data; the multivariate normal distribution; inference in multivariate populations, simultaneous analysis of multiple responses, multivariate analysis of variance; summarizing high dimensional data with principal components, factor analysis, canonical correlations, classification methods, clustering, multidimensional scaling; introduction to basic nonparametric multivariate methods.  Statistical software: SAS or R.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Modern Multivariate Statistical Learning",
    "dept": "STAT",
    "num": "502",
    "desc": "Prereq: STAT 500, STAT 542, STAT 579.\nA Statistics-MS-level introduction to Modern Multivariate Statistical Learning. Theory-based methods for modern data mining and machine learning, inference and prediction. Variance-bias trade-offs and choice of predictors; linear methods of prediction; basis expansions; smoothing, regularization, kernel smoothing methods; neural networks and radial basis function networks; bootstrapping, model averaging, and stacking; linear and quadratic methods of classification; support vector machines; trees and random forests; boosting; prototype methods; unsupervised learning including clustering, principal components, and multi-dimensional scaling; kernel mechanics. Substantial use of R packages implementing these methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Exploratory Methods and Data Mining",
    "dept": "STAT",
    "num": "503",
    "desc": "Prereq: STAT 301 or STAT 326 or STAT 401; STAT 341 or STAT 447 or STAT 542; STAT 480 or STAT 579\nApproaches to finding the unexpected in data; exploratory data analysis; pattern recognition; dimension reduction; supervised and unsupervised classification; interactive and dynamic graphical methods; computer-intensive statistical techniques for large or high dimensional data and visual inference. Emphasis is on problem solving, topical problems, and learning how so-called black-box methods actually work.\n",
    "credits": "3"
  },
  {
    "course_name": "Environmental Statistics",
    "dept": "STAT",
    "num": "505",
    "desc": "Prereq: STAT 341 or STAT 447; STAT 401\nStatistical methods and models for environmental applications.  Emphasis on environmental toxicology.  Analysis of data with below detection-limit values.  Dose-response curve modeling, including overdispersion and estimation of safe doses. Trend analysis; analysis of autocorrelated data.  Equivalence testing.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Methods for Spatial Data",
    "dept": "STAT",
    "num": "506",
    "desc": "Prereq: STAT 447 or STAT 542\nThe analysis of spatial data; geostatistical methods and spatial prediction; discrete index random fields and Markkov random field models; models for spatial point processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Methods II",
    "dept": "STAT",
    "num": "510",
    "desc": "Prereq: STAT 500, STAT 447 or credit/enrollment in STAT 543\nLinear models and analysis of variance for multifactor experiments with balanced and unbalanced data. Likelihood analysis for general linear models and models with non-normal random components; linear model results in the context of likelihood; linear mixed models and their application; estimation, inference, and prediction. Introduction to generalized linear models and generalized linear mixed models. Case studies of applications including problem formulation, exploratory analysis, model development, estimation and inference, and model assessment.\n",
    "credits": "3"
  },
  {
    "course_name": "Design of Experiments",
    "dept": "STAT",
    "num": "512",
    "desc": "Prereq: STAT 510\nBasic techniques of experimental design developed in the context of the general linear model;   completely randomized, randomized complete block, and Latin Square designs; factorial experiments,   confounding, fractional replication; split-plot and incomplete block designs.\n",
    "credits": "3"
  },
  {
    "course_name": "Response Surface Methodology",
    "dept": "STAT",
    "num": "513",
    "desc": "Prereq: STAT 402 or STAT 512, knowledge of elementary matrix theory and matrix formulation of regression\nAnalysis techniques for locating optimum and near-optimum operating conditions: standard experimental designs for first- and second-order response surface models; design performance criteria; use of data transformations; mixture experiments; optimization for multiple-response problems. Requires use of statistical software with matrix functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory and Applications of Nonlinear Models",
    "dept": "STAT",
    "num": "515",
    "desc": "Prereq: STAT 447 or STAT 543; STAT 510\nConstruction of nonlinear statistical models; random and systematic model components, additive error nonlinear regression with constant and non-constant error variances, generalized linear models, transform both sides models. Iterative algorithms for estimation and asymptotic inference. Basic random parameter models, beta-binomial and gamma-Poisson mixtures. Requires use of instructor-supplied and student-written R functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Design and Analysis of Gene Expression Experiments",
    "dept": "STAT",
    "num": "516",
    "desc": "Prereq: STAT 500; STAT 447 or STAT 542\nIntroduction to high-throughput technologies for gene expression studies (especially RNA-sequencing technology):  the role of blocking, randomization, and biological and technical replication in the design of gene expression experiments; normalization methods; methods for identifying differentially expressed genes including mixed linear model analysis, generalized linear model analysis, generalized linear mixed model analysis, quasi-likelihood methods, and empirical Bayes analysis; procedures for controlling false discovery rate for multiple testing; clustering problems for gene expression data; testing gene categories; emphasis on current research topics for statistical analysis of high dimensional gene expression data.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Methods III",
    "dept": "STAT",
    "num": "520",
    "desc": "Prereq: STAT 510, STAT 447 or STAT 543\nNonlinear regression; generalized least squares; asymptotic inference. Generalized linear models; exponential dispersion families; maximum likelihood and inference. Designing Monte Carlo studies; bootstrap; cross-validation. Fundamentals of Bayesian analysis; data models, priors and posteriors; posterior prediction; credible intervals; Bayes Factors; types of priors; simulation of posteriors; introduction to hierarchical models and Markov Chain Monte Carlo methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory and Applications of Sample Surveys",
    "dept": "STAT",
    "num": "521",
    "desc": "Prereq: STAT 401; STAT 447 or STAT 542\nPractical aspects and basic theory of design and estimation in sample surveys for finite populations. Simple random, systematic, stratified, cluster multistage and unequal-probability sampling. Horvitz-Thompson estimation of totals and functions of totals: means, proportions, regression coefficients. Linearization technique for variance estimation. Model-assisted ratio and regression estimation. Two-phase sampling and sampling on two occasions. Non-response effects. Imputation.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Applied Survey Sampling",
    "dept": "STAT",
    "num": "522",
    "desc": "Prereq: STAT 521 or both STAT 421 and STAT 447\nAdvanced topics in survey sampling and methodology: clustering and stratification in practice, adjustments and imputation for missing data, variance estimation in complex surveys, methods of panel and/or longitudinal surveys, procedures to increase response rates, and computing. Examples are taken from large, well-known surveys in various subject areas. Prior exposure to mathematical statistics, probability, and at least one course in survey sampling theory is assumed.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Methods for Mathematics Teachers",
    "dept": "STAT",
    "num": "525",
    "desc": "Prereq: STAT 341 or equivalent\nDescriptive statistics; data collection through experimentation and sampling; univariate statistical inference; contingency tables; design of experiments and ANOVA; simple linear regression; logistic regression; multiple linear regression; statistics pedagogy. (Offered on a 3-year cycle; offered SS 2017.).\n  May not be used for graduate credit in the Statistics program. Credit in STAT 410 or STAT 525, but not both, may be applied toward graduation.",
    "credits": "6"
  },
  {
    "course_name": "Applied Statistical Modeling",
    "dept": "STAT",
    "num": "526",
    "desc": "Prereq: Admission to Master of Business Analytics program\nProbability concepts and distributions used in statistical decision-making for business applications.  Least-squares and maximum likelihood estimation, sampling distributions of estimators, formal statistical inference, analysis of variance, multiple regression models and strategies for model selection, logistic regression, and Poisson regression.  Applications implemented with the R statistical package.  Simulations used to investigate properties of inferential procedures and to assist in data analysis.\n  May not be used for graduate credit in the Statistics program.",
    "credits": "3"
  },
  {
    "course_name": "Visual Business Analytics",
    "dept": "STAT",
    "num": "528",
    "desc": "Prereq: Admission to the Master of Business Analytics Program\nTypes of data displays; numerical and visual summaries of data; data structures for data displays; data vs info graphics; good practices of displaying data; human perception and cognition in data displays; graphics as tools of data exploration; graphical diagnostics of statistical models and machine learning procedures; strategies and techniques for data visualizations; basics of reproducibility and repeatability; web-based interactive applets for visual presentation of data and results; programming in R.\n  May not be used for graduate credit in the Statistics program.",
    "credits": "3"
  },
  {
    "course_name": "Quality Control and Engineering Statistics",
    "dept": "STAT",
    "num": "531",
    "desc": "Prereq: STAT 401; STAT 342 or STAT 447\nStatistical methods and theory applicable to problems of industrial process monitoring and improvement. Statistical issues in industrial measurement; Shewhart, CUSUM, and other control charts; feedback control; process characterization studies; estimation of product and process characteristics; acceptance sampling, continuous sampling and sequential sampling; economic and decision theoretic arguments in industrial statistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Reliability",
    "dept": "STAT",
    "num": "533",
    "desc": "Prereq: STAT 342 or STAT 432 or STAT 447\nProbabilistic modeling and inference in engineering reliability; lifetime models, product limit estimator, probability plotting, maximum likelihood estimation for censored data, Bayesian methods in reliability, system reliability models, competing risk analysis, acceleration models and analysis of accelerated test data; analysis of recurrence and degradation data; planning studies to obtain reliability data.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecological Statistics",
    "dept": "STAT",
    "num": "534",
    "desc": "Prereq: STAT 447 or STAT 542\nStatistical methods for non-standard problems, illustrated using questions and data from ecological field studies.  Estimation of abundance and survival from mark-recapture studies, deterministic and stochastic matrix models of population trends, integral projection models, and hierarchical modeling, especially of population dynamics. Additional topics vary based on student interest.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Genetics",
    "dept": "STAT",
    "num": "536",
    "desc": "Prereq: STAT 401, STAT 447; GEN 320 or BIOL 313\nStatistical models and methods for genetics covering models of population processes: selection, mutation, migration, population structure, and linkage disequilibrium, and inference techniques: genetic mapping, linkage analysis, and quantitative trait analysis. Applications include genetic map construction, gene mapping, genome-wide association studies (GWAS), inference about population structure, phylogenetic tree construction, and forensic and paternity identification.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory of Probability and Statistics I",
    "dept": "STAT",
    "num": "542",
    "desc": "Prereq: MATH 414.\nSample spaces, basic probability results, conditional probability. Random variables, univariate distributions, moment generating functions. Joint distributions, conditional distributions and independence, correlation and covariance. Probability laws and transformations. Introduction to the multivariate normal distribution. Sampling distributions, normal theory, sums and order statistics. Convergence concepts, the law of large numbers, the central limit theorem and delta method. Basics of stochastic simulation.\n",
    "credits": "4"
  },
  {
    "course_name": "Theory of Probability and Statistics II",
    "dept": "STAT",
    "num": "543",
    "desc": "Prereq: STAT 542.\nPoint estimation including method of moments, maximum likelihood and Bayes. Properties of point estimators, mean squared error, unbiasedness, consistency, loss functions. Large sample properties of maximum likelihood estimators. Exponential families, sufficiency, completeness, ancilarity, Basu's theorem. Hypothesis tests, Neyman-Pearson lemma, uniformly most powerful tests, likelihood ratio tests, Bayes tests. Interval estimation, inverting tests, pivotal quantities. Nonparametric theory, bootstrap.\n",
    "credits": "3"
  },
  {
    "course_name": "Bayesian Statistics",
    "dept": "STAT",
    "num": "544",
    "desc": "Prereq: Credit or concurrent enrollment in STAT 543\nSpecification of probability models; subjective, conjugate, and noninformative prior distributions; hierarchical models; analytical and computational techniques for obtaining posterior distributions; model checking, model selection, diagnostics; comparison of Bayesian and traditional methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Nonparametric Methods in Statistics",
    "dept": "STAT",
    "num": "546",
    "desc": "Prereq: STAT 510, STAT 542\nOverview of parametric versus nonparametric methods of inference; introduction to rank-based tests and/or nonparametric smoothing methods for estimating density and regression functions; smoothing parameter selection; applications to semiparametric models and goodness-of-fit tests of a parametric model.\n",
    "credits": "3"
  },
  {
    "course_name": "Functional Data Analysis",
    "dept": "STAT",
    "num": "547",
    "desc": "Prereq: STAT 543, STAT 510\nTheory and methods for analyzing functional data, which are high dimensional data resulted from discrete, error-contaminated measurements on smooth curves and images. The topics include kernel and spline smoothing, basis expansion, semiparametric regression, functional analysis of variance, covariance modeling and estimation, functional principal component analysis, functional generalization linear models, joint modeling, dimension reduction, classification and clustering functional data.\n",
    "credits": "3"
  },
  {
    "course_name": "Time Series Analysis",
    "dept": "STAT",
    "num": "551",
    "desc": "Prereq: STAT 447 or STAT 542\nConcepts of trend and dependence in time series data; stationarity   and basic model structures for dealing with temporal dependence;   moving average and autoregressive error structures; analysis in   the time domain and the frequency domain; parameter estimation,   prediction and forecasting; identification of appropriate model   structure for actual data and model assessment techniques. Possible   extended topics include dynamic models and linear filters.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Stochastic Processes",
    "dept": "STAT",
    "num": "554",
    "desc": "Prereq: STAT 542\nMarkov chains on discrete spaces in discrete and continuous time (random walks, Poisson   processes, birth and death processes) and their long-term behavior. Optional topics may include branching processes, renewal theory, introduction to Brownian motion.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Methods for Counts and Proportions",
    "dept": "STAT",
    "num": "557",
    "desc": "Prereq: STAT 500 or STAT 401; STAT 543 or STAT 447\nStatistical methods for analyzing simple random samples when outcomes are counts or proportions; measures of association and relative risk, chi-squared tests, loglinear models, logistic regression and other generalized linear models, tree-based methods. Maximum likelihood estimation and large sample theory. Extensions to longitudinal studies and complex survey designs, models with fixed and random effects. Use of statistical software: SAS or R.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Biostatistics and Epidemiology",
    "dept": "STAT",
    "num": "565",
    "desc": "Prereq: STAT 500 or STAT 401; STAT 543 or STAT 447\nStatistical methods commonly used in epidemiology and human and animal health studies.  Overview of cohort studies, case-control studies and randomized clinical trials.  Topics include inference procedures for disease risk factors, analysis of time-to-event and survival data, analysis of longitudinal studies of disease progression and health status, diagnostic test evaluation, and meta-analysis.  Examples will come from recent studies of physical and mental health, nutrition and disease progression in human and animal populations. Use of statistical software: SAS or R.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics II (Statistical Bioinformatics)",
    "dept": "STAT",
    "num": "568",
    "desc": "Prereq: BCB 567 or (BIOL 315 and STAT 430), credit or enrollment in GEN 409\nStatistical models for sequence data, including applications in genome annotation, motif discovery, variant discovery, molecular phylogeny, gene expression analysis, and metagenomics.  Statistical topics include model building, inference, hypothesis testing, and simple experimental design, including for big data/complex models.\n",
    "credits": "3"
  },
  {
    "course_name": "Bioinformatics IV (Systems Biology)",
    "dept": "STAT",
    "num": "570",
    "desc": "Prereq: BCB 567 or COM S 311, COM S 228, GEN 409, STAT 430\nAlgorithmic and statistical approaches in computational functional genomics and systems biology. Analysis of high throughput biological data obtained using system-wide measurements. Topological analysis, module discovery, and comparative analysis of gene and protein networks. Modeling, analysis, and inference of transcriptional regulatory networks, protein-protein interaction networks, and metabolic networks. Dynamic systems and whole-cell models. Ontology-driven, network based, and probabilistic approaches to information integration.\n",
    "credits": "3"
  },
  {
    "course_name": "An Introduction to R",
    "dept": "STAT",
    "num": "579",
    "desc": "Prereq: Enrollment in STAT 500\nAn introduction to the logic of programming, numerical algorithms, and graphics. The R statistical programming  environment will be used to demonstrate how data can be stored, manipulated, plotted,  and analyzed using both built-in functions and user extensions. Concepts  of modularization, looping, vectorization, conditional execution, and  function construction will be emphasized.\n",
    "credits": "1"
  },
  {
    "course_name": "Statistical Computing",
    "dept": "STAT",
    "num": "580",
    "desc": "Prereq: STAT 579; STAT 447 or STAT 542\nIntroduction to scientific computing for statistics using tools and concepts in R: programming tools, modern programming methodologies, modularization, design of statistical algorithms. Introduction to C programming for efficiency; interfacing R with C. Building statistical libraries. Use of algorithms in modern subroutine packages, optimization and integration. Implementation of simulation methods; inversion of probability integral transform, rejection sampling, importance sampling. Monte Carlo integration.\n",
    "credits": "3"
  },
  {
    "course_name": "Analysis of Gene Expression Data for the Biological Sciences",
    "dept": "STAT",
    "num": "581",
    "desc": "Prereq: STAT 401 or STAT 587\nIntroduction to high-throughput technologies for gene expression studies (especially RNA-sequencing technology):  the role of blocking, randomization, and biological and technical replication in the design of gene expression experiments; normalization methods; methods for identifying differentially expressed genes including mixed linear model analysis, generalized linear model analysis, generalized linear mixed model analysis, quasi-likelihood methods, empirical Bayes analysis, and resampling based approaches; procedures for controlling false discovery rate for multiple testing; clustering and classification problems for gene expression data; testing gene categories; emphasis on practical use of methods.\n  May not be used for graduate credit in the Statistics MS and PhD degree programs. Credit in  STAT 416 or STAT 581, but not both, may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Data Technologies for Statistical Analysis.",
    "dept": "STAT",
    "num": "585",
    "desc": "Prereq: STAT 579.\nIntroduction to computational methods for data analysis. Accessing and managing data formats: flat files, databases, web technologies based on mark-up languages (SML, KML, HTML), netCDF. Elements of text processing: regular expressions for cleaning data. Working with massive data, handling missing data, scaled computing. Efficient programming, reproducible code.\n",
    "credits": "3"
  },
  {
    "course_name": "Statistical Methods for Research Workers",
    "dept": "STAT",
    "num": "587",
    "desc": "Prereq: An applied statistics course at the undergraduate level, such as STAT 101, 104, 105, 201, or 226. Students without an equivalent course should contact the department.\nA first course in statistics for graduate students from the applied sciences.   Principles of data analysis and scientific inference, including estimation,  hypothesis testing, and the construction of interval estimates.   Statistical concepts and models, including group comparison, blocking, and linear regression.   Different sections are designed for students in various disciplines, and additional methods  covered may depend on the target audience.  Topics covered may include  basic experimental designs and analysis of variance for those designs,  analysis of categorical data, logistic and log-linear regression, likelihood-based inference,  and the use of simulation. Equivalent to STAT 401 in previous catalogs.\n  May not be used for graduate credit in the Statistics MS and PhD degree programs. Credit in STAT 401 or STAT 587, but not both, may be applied toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Statistical Theory for Research Workers",
    "dept": "STAT",
    "num": "588",
    "desc": "Prereq: MATH 151 and permission of instructor, or MATH 265\nProvides an introduction to the theoretical basis of fundamental statistical methods  for graduate students in the applied sciences.  Probability and probability distributions,  moments and moment generating functions, conditional expectation, and transformation of random variables.   Estimation based on loss functions, maximum likelihood, and properties of estimators.   Sampling distributions, exact and asymptotic results, and the development of intervals.   Principles of Bayesian analysis, inference from posterior distributions, and optimal prediction.   Uses simulation to verify and extend theoretical results. Equivalent to STAT 447 in previous catalogs.\n  May not be used for graduate credit in the Statistics MS and PhD degree programs. Credit in STAT 447 or STAT 588, but not both, may be applied toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Special Topics",
    "dept": "STAT",
    "num": "590",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Theory",
    "dept": "STAT",
    "num": "590A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Methods",
    "dept": "STAT",
    "num": "590B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Design of Experiments",
    "dept": "STAT",
    "num": "590C",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Sample Surveys",
    "dept": "STAT",
    "num": "590D",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Statistics Education",
    "dept": "STAT",
    "num": "590E",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Special Topics: Statistical Computing and Graphics",
    "dept": "STAT",
    "num": "590F",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Cooperative Education",
    "dept": "STAT",
    "num": "598",
    "desc": "Prereq: Permission of the department chair\nOff-campus work periods for graduate students in a field of statistics.\n",
    "credits": "R"
  },
  {
    "course_name": "Creative Component",
    "dept": "STAT",
    "num": "599",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Statistical Methods",
    "dept": "STAT",
    "num": "601",
    "desc": "Prereq: STAT 520, STAT 543 and MATH 414 or enrollment in STAT 641\nMethods of constructing complex models including adding parameters to existing structures, incorporating stochastic processes and latent variables. Use of modified likelihood functions; quasi-likelihoods; profiles; composite likelihoods. Asymptotic normality as a basis of inference; Godambe information. Sample reuse; block bootstrap; resampling with dependence. Simulation for model assessment. Issues in Bayesian analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Modern Multivariate Statistical Learning",
    "dept": "STAT",
    "num": "602",
    "desc": "Prereq: STAT 520, STAT 543, STAT 579\nStatistical theory and methods for modern data mining and machine learning, inference, and prediction.  Variance-bias trade-offs and choice of predictors;  linear methods of prediction; basis expansions; smoothing, regularization, and reproducing kernel  Hilbert spaces;  kernel smoothing methods; neural networks and radial basis function networks; bootstrapping, model averaging, and stacking; linear and quadratic methods of classification; support vector machines; trees and random forests; boosting; prototype methods; unsupervised learning including clustering, principal components, and multi-dimensional scaling; kernel mechanics.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Spatial Statistics",
    "dept": "STAT",
    "num": "606",
    "desc": "Prereq: STAT 506, STAT 543\nConsideration of advanced topics in spatial statistics, including areas of recent development in modern spatial statistics. Topics may include spatial sampling design; spatial Markov random fields; non-Gaussian spatial models, including spatial generalized linear mixed effects model; spatial Bayesian hierarchical models, simulation of random fields; spatial-temporal process models; non-stationary process models; multivariate spatial process models; spectral methods for spatial data; computational methods for large spatial data, spatial models for stream networks. Use of R to analyze various real spatial data.\n",
    "credits": "3"
  },
  {
    "course_name": "Theory and Applications of Linear Models",
    "dept": "STAT",
    "num": "611",
    "desc": "Prereq: STAT 510; STAT 542 or STAT 447; a course in matrix algebra\nMatrix preliminaries, estimability, theory of least squares and of best linear unbiased estimation, analysis of variance and covariance, distribution of quadratic forms, extension of theory to mixed and random models, inference for variance components.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Design of Experiments",
    "dept": "STAT",
    "num": "612",
    "desc": "Prereq: STAT 512\nGeneral theory of factorial experiments.  Design optimality criteria, approximate design and general   equivalence theory, computational approaches to constructing optimal designs for linear models, and   extensions to nonlinear models. Advanced topics of current interest in the design of experiments,   including one or more of: distance based design criteria and construction of spatial process models,   screening design strategies for high-dimensional problems, and design problems associated with   computational experiments.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Bayesian Methods",
    "dept": "STAT",
    "num": "615",
    "desc": "Prereq: STAT 544 and STAT 601\nComplex hierarchical and multilevel models, dynamic linear and generalized linear models, spatial models.  Bayesian nonparametric methods. Specialized Markov chain Monte Carlo algorithms and practical approaches to increasing mixing and speed convergence.  Summarizing posterior distributions, and issues in inference.  Model assessment, model selection, and model averaging.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Theory of Survey Statistics",
    "dept": "STAT",
    "num": "621",
    "desc": "Prereq: STAT 521\nAdvanced topics of current interest in the design of surveys and analysis of survey data, including: asymptotic theory for design and model-based estimators, use of auxiliary information in estimation, variance estimation techniques, small area estimation, non-response modeling and imputation.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Probability Theory",
    "dept": "STAT",
    "num": "641",
    "desc": "Prereq: MATH 414 or MATH 501 or equivalent course.\nSequences and set theory; Lebesgue measure, measurable functions. Absolute continuity of functions, integrability and the fundamental theorem of Lebesgue integration. General measure spaces, probability measure, extension theorem and construction of Lebesgue-Stieljes measures on Euclidean spaces. Measurable transformations and random variables, induced measures and probability distributions. General integration and expectation, Lp-spaces and integral inequalities. Uniform integrability and absolute continuity of measures. Probability densities and the Radon-Nikodym theorem. Product spaces and Fubini-Tonelli theorems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Probability Theory",
    "dept": "STAT",
    "num": "642",
    "desc": "Prereq: STAT 641, or STAT 543 and MATH 515.\nProbability spaces and random variables. Kolmogorov's consistency theorem. Independence, Borel-Cantelli lemmas and Kolmogorov's 0 - 1 Law. Comparing types of convergence for random variables. Sums of independent random variables, empirical distributions, weak and strong laws of large numbers. Convergence in distribution and its characterizations, tightness, characteristic functions, central limit theorems and Lindeberg-Feller conditions. Conditional probability and expectation. Discrete parameter martingales and their properties and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced  Theory of Statistical Inference",
    "dept": "STAT",
    "num": "643",
    "desc": "Prereq: STAT 543, STAT 642\nSufficiency and related concepts, completeness, exponential families and statistical information. Elements of decision theory, decision rules, invariance and Bayes rule. Maximum likelihood and asymptotic inference. Generalized estimating equations and estimating functions, M-estimation, U-statistics. Likelihood ratio tests, simple and composite hypotheses, multiple testing. Bayesian inference. Nonparametric inference, bootstrap, empirical likelihood, and tests for nonparametric models.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Bayesian Theory",
    "dept": "STAT",
    "num": "644",
    "desc": "Prereq: STAT 544 and STAT 642\nExchangeability, parametric models, consistency and asymptotic normality of posterior distributions, posterior robustness, selection of priors using formal rules, improper priors and posterior propriety, Bayes factors, model selection, MCMC theory, irreducibility, Harris recurrence, regeneration, minorization and drift conditions, ergodicity, central limit theorems, Gibbs samplers, Metropolis Hastings samplers, techniques for speeding up convergence of certain MCMC algorithms.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Stochastic Processes",
    "dept": "STAT",
    "num": "645",
    "desc": "\nWeak convergence. Random walks and Brownian motion. Martingales. Stochastic integration and Ito's Formula. Stochastic differential equations and applications.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Multivariate Analysis",
    "dept": "STAT",
    "num": "647",
    "desc": "Prereq: STAT 543, knowledge of matrix algebra\nMultivariate normal distribution, estimation of the mean vector and the covariance matrix, multiple and partial correlation, Hotelling's T2 statistic, Wishart distribution, multivariate regression, principle components, discriminant analysis, high dimensional data analysis, latent variables.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar on Theory of Statistics and Probability",
    "dept": "STAT",
    "num": "648",
    "desc": "Prereq: STAT 543.\nSeminar topics change with each offering.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Time Series",
    "dept": "STAT",
    "num": "651",
    "desc": "Prereq: STAT 551, STAT 642\nStationary and nonstationary time series models, including   ARMA, ARCH, and GARCH.  Covariance and spectral representation   of time series. Fourier and periodogram analyses. Predictions.   CLT for mixing processes. Estimation and distribution theory.   Long range dependence.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Statistical Computing",
    "dept": "STAT",
    "num": "680",
    "desc": "Prereq: STAT 543 and STAT 580\nNormal approximations to likelihoods. The delta-method and propagation of errors. Topics in the use of the E-M algorithm including; its use in the exponential family, computation of standard errors, acceleration. Resampling methods: brief theory and application of the jackknife and the bootstrap. Randomization tests. Stochastic simulation: Markov Chain, Monte Carlo, Gibbs' sampling, Hastings-Metropolis algorithms, critical slowing-down and remedies, auxiliary variables, simulated tempering, reversible-jump MCMC and multi-grid methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Special Topics",
    "dept": "STAT",
    "num": "690",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Theory",
    "dept": "STAT",
    "num": "690A",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Methods",
    "dept": "STAT",
    "num": "690B",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Design of Experiments",
    "dept": "STAT",
    "num": "690C",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Sample Surveys",
    "dept": "STAT",
    "num": "690D",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Statistical Computing",
    "dept": "STAT",
    "num": "690E",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Special Topics: Graphics",
    "dept": "STAT",
    "num": "690F",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "arr"
  },
  {
    "course_name": "Research",
    "dept": "STAT",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Supply Chain Management",
    "dept": "SCM",
    "num": "301",
    "desc": "Prereq: ECON 101 and STAT 226\nVarious supply chain activities and integration of supply chain management with supply and demand, both within and between firms. Exposure to a wide range of supply chain management terminology, analytical tools, and theories related to four key elements of supply chain management:  purchasing, operations, distribution, and integration. Specific topics include strategic sourcing, supply management, demand forecasting, resource planning, inventory management, process management, logistics, location analysis, process integration, and performance measurement.\n",
    "credits": "3"
  },
  {
    "course_name": "Project Management",
    "dept": "SCM",
    "num": "340",
    "desc": "Prereq: credit or enrollment in MIS 301\nEquips students to support team activities in the general project management environment and better manage their careers. Practical experience using project management techniques and tools. Course topics include project initiation and execution, risk assessment, estimating and contracts, planning, human factors, and standard methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Process Management, Analysis, and Improvement",
    "dept": "SCM",
    "num": "424",
    "desc": "Prereq: SCM 301\nThe design, analysis, and management of production processes to improve performance. Performance measures and their relationships; process design and evaluation; and managerial levers for improving and controlling process performance.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Operations Management",
    "dept": "SCM",
    "num": "428",
    "desc": "Prereq: SCM 301\nIn-depth analysis of current issues, problems, and systems in operations management with emphasis on new theoretical and methodological developments. Topics may include in different semesters, supply chain management, productivity and quality improvement, management of technology and innovation, information technology in operations management, quick response manufacturing, and service operations management.\n",
    "credits": "3"
  },
  {
    "course_name": "Supply Chain Information Systems",
    "dept": "SCM",
    "num": "440",
    "desc": "Prereq: MIS 301, SCM 301\nInternal and inter-organizational information systems necessary for a supply chain to achieve competitive advantage. Topics include: design, development, implementation, and maintenance of supply chain information systems; enterprise resource planning; advanced planning and scheduling, manufacturing execution systems; and the interface between manufacturing planning and control processes, logistics processes, and the information system.\n",
    "credits": "3"
  },
  {
    "course_name": "Enterprise Resource Planning Systems in Supply Chain",
    "dept": "SCM",
    "num": "450",
    "desc": "Prereq: SCM 301, MIS 301 or I E 148, I E 341\nExamination of the role of enterprise resource planning systems (ERP) in the supply chain. Hands-on experience with a major software application in use by many corporations to manage and improve the efficiency of their supply chains and operations. Students will develop a more process-centric perspective about how a supply chain operates and how ERP enables and supports such operations.\n",
    "credits": "3"
  },
  {
    "course_name": "Supply Chain Planning and Control",
    "dept": "SCM",
    "num": "453",
    "desc": "Prereq: SCM 301\nSupply chain planning and control is the process which synchronizes demand with manufacturing and distribution. This course will cover sales and operations planning with emphasis on forecasting, master scheduling, materials requirements planning, inventory management and demand planning. Linking business plans and information systems for integration and distribution channels are also covered.\n",
    "credits": "3"
  },
  {
    "course_name": "Decision Tools for Logistics and Operations Management",
    "dept": "SCM",
    "num": "460",
    "desc": "Prereq: SCM 301\nTechnical tools and skills required for problem solving and decision making in logistics and operations management. Transportation and network planning, inventory decision making, facility location planning, vehicle routing, scheduling, and production planning. Quantitative tools include linear and integer programming, non-linear programming, and simulation. Emphasis on the use of PC-based spreadsheet programs.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Transportation",
    "dept": "SCM",
    "num": "461",
    "desc": "Prereq: SCM 301\nEconomic, operating, and service characteristics of the various modes of transportation, with a special emphasis on freight transportation. Factors that influence transport demand, costs, market structures, carrier pricing, and carrier operating and service characteristics and their influence on other supply chain costs and supply chain performance.\n",
    "credits": "3"
  },
  {
    "course_name": "Transportation Carrier Management",
    "dept": "SCM",
    "num": "462",
    "desc": "Prereq: Credit or enrollment in SCM 461\nAnalysis of transport users' requirements. Carrier management problems involving ownership and mergers, routes, competition, labor, and other decision areas.\n",
    "credits": "3"
  },
  {
    "course_name": "Global Trade Management",
    "dept": "SCM",
    "num": "466",
    "desc": "Prereq: SCM 301\nLogistics systems and legal framework for the international movement of goods. Operational characteristics of providers of exporting and importing services. The effects of government trade policies on global logistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Supply Chain Management",
    "dept": "SCM",
    "num": "471",
    "desc": "Prereq: SCM 301\nThe global nature of a supply chain causes many sustainability issues.  This course will consider how supply chain design and execution affect sustainability.  Some discussion of governmental policy will be included.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Purchasing and Supply Management",
    "dept": "SCM",
    "num": "486",
    "desc": "Prereq: SCM 301\nSourcing strategies, concepts, tools and dynamics in the context of the integrated supply chain. Make or buy decision, supplier evaluation and selection, global sourcing, the total cost of ownership, contracts and legal terms, negotiation, purchasing ethics, and information systems requirements.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "SCM",
    "num": "490",
    "desc": "Prereq: SCM 301, senior classification, permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "International Live Case and Study Tour",
    "dept": "SCM",
    "num": "491",
    "desc": "Prereq: SCM 301\nStudents follow supply chain of major firm from overseas manufacturer to domestic point-of-sale.  Students are expected to complete projects and present findings to senior leadership.\n",
    "credits": "3"
  },
  {
    "course_name": "Case Practicum",
    "dept": "SCM",
    "num": "495",
    "desc": "Prereq: SCM 301\nStudents explore different practical scenarios related supply chain projects and cases. Students acquire necessary skills and knowledge to solve practical issues associated with presented cases and problems. Students compete at different venues around the country.\n",
    "credits": "3"
  },
  {
    "course_name": "Supply Chain Management",
    "dept": "SCM",
    "num": "501",
    "desc": "Prereq: Enrollment in MBA program or departmental permission\nIntroduction to supply chain management including aspects of operations, logistics and global supply chain strategy development. Topic areas include lean manufacturing and value stream mapping; supplier development and measurement; sustainable supply chain operations; process measurement, management and improvement; supply chain risk and uncertainty; visibility and integration in the supply chain; and inventory control.\n",
    "credits": "3"
  },
  {
    "course_name": "Biorenewables Supply Chain Management",
    "dept": "SCM",
    "num": "513",
    "desc": "Prereq: Graduate Standing or Qualified Undergraduate with Instructor Permission\nEvaluation of supply chain logistics related to the field of biorenewables. Unique challenges associated with the biorenewables supply chain are emphasized and examined: cost analysis, market demand & prices, life cycle analysis, environmental impacts, as well as the technological, social, and political factors related to society.\n",
    "credits": "3"
  },
  {
    "course_name": "Decision Models for Supply Chain Management",
    "dept": "SCM",
    "num": "520",
    "desc": "Prereq: SCM 501 or permission of instructor\nThe application of decision models for supply chain management. Topics include business applications of decision theory, inventory theory, business forecasting, optimization models, transportation and network models, routing problems, and project management.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Process Analysis and Improvement",
    "dept": "SCM",
    "num": "524",
    "desc": "Prereq: SCM 501 or permission of instructor\nAnalysis, management, and improvement of the business processes used to produce and deliver products and services that satisfy customer needs.  Process attributes that managers can control to influence the key operational performance measures of throughput time, inventory, cost, quality, and flexibility are discussed.  Topics such as theory of constraints, lean production, and six sigma are included.\n",
    "credits": "3"
  },
  {
    "course_name": "Supply Chain Planning and Control",
    "dept": "SCM",
    "num": "553",
    "desc": "Prereq: SCM 501 or permission of instructor\nSupply chain planning and control is the process which synchronizes demand with manufacturing and distribution. Sales and operations planning with emphasis on forecasting, master scheduling, materials requirements planning, inventory management and demand planning. Linking business plans and information systems for integration and distribution channels are also covered. Emphasis on the strategic advantages of linking business plans and demand forecasts.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategic Logistics Management",
    "dept": "SCM",
    "num": "560",
    "desc": "Prereq: SCM 501 or permission of instructor\nPositions logistics vis-a-vis supply chain management (SCM). Presents different perspectives on SCM vs. logistics. Describes primary logistics functions: transportation, warehousing, facility location, customer service, order processing, inventory management and packaging. Benefits of and obstacles to the integration of these functions.\n",
    "credits": "3"
  },
  {
    "course_name": "Transportation Management and Policy",
    "dept": "SCM",
    "num": "561",
    "desc": "Prereq: SCM 501 or permission of instructor\nAnalysis of contemporary issues and strategies in transportation management and policy. Emphasis on evaluation of the impacts of transportation policies, new technologies, and strategic carrier and shipper management practices on the freight transportation industry and logistics systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Purchasing and Supply Management",
    "dept": "SCM",
    "num": "563",
    "desc": "Prereq: SCM 501 or permission of instructor\nMechanics, procedures and tools used in purchasing. Recruiting, selecting, developing and managing supply chain partners in order to achieve competitive advantage via superior supply chain management. Factors and information needs for making supply management decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "SCM",
    "num": "590",
    "desc": "Prereq: Graduate classification and permission of instructor\nFor students who wish to do individual research in a particular area of supply chain management.\n",
    "credits": "1"
  },
  {
    "course_name": "Theoretical Foundations of Supply Chain Management",
    "dept": "SCM",
    "num": "601",
    "desc": "Prereq: MGMT 601 or permission of instructor\nAn overview of the development of supply chain management (SCM) theory, including review of seminal articles in logistics, operations, and purchasing management and theories from allied disciplines (e.g., economics, marketing, sociology, strategic management). Analysis of trends in SCM research topics and methodologies.  Identification of emerging and future areas for research and theory development.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Supply Chain Strategy",
    "dept": "SCM",
    "num": "602",
    "desc": "Prereq: SCM 601 or concurrent enrollment\nReview of research literature on supply chain strategy, including the impact of technology, global economic and social factors, and intra- and inter-organizational integration on supply chain strategy formation.  The role of SCM in overall corporate strategy and the impact of SCM on firm performance will also be addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Purchasing",
    "dept": "SCM",
    "num": "603",
    "desc": "Prereq: SCM 601 or concurrent enrollment\nReview of classic purchasing theories.  Discussion of contemporary supply management strategy; the role of supply management and its relationship with other functional areas; its impact on logistics and transportation issues; management of supply uncertainties.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Logistics Management",
    "dept": "SCM",
    "num": "604",
    "desc": "Prereq: SCM 601 or concurrent enrollment\nIntegration of network, economic, and systems theory in the design, management, and control of logistics systems in the context of integrated supply chain management.  Functional areas addressed include transportation, inventory order fulfillment, distribution, and warehousing.  Facility location analysis will also be covered.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Operations Management",
    "dept": "SCM",
    "num": "605",
    "desc": "Prereq: SCM 601 or concurrent enrollment\nReview of the research literature on methods of organizing, planning, controlling, and improving manufacturing systems to achieve the desired performance objectives related to cost, quality, speed, and flexibility. The relationship between the performance of the manufacturing system and the performance of the supply chain system will also be discussed.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in SCM",
    "dept": "SCM",
    "num": "609",
    "desc": "Prereq: SCM 601 or permission of instructor.\nReview of current issues in SCM.  Provides opportunities to read and discuss research articles that made important contributions in SCM literature.\n",
    "credits": "3"
  },
  {
    "course_name": "Research Practicum I",
    "dept": "SCM",
    "num": "650",
    "desc": "Prereq: enrollment in the PhD program\nPreparation of a research manuscript to be submitted to a peer-reviewed academic journal. Students will work with a faculty mentor on a research project.\n",
    "credits": "1"
  },
  {
    "course_name": "Research Practicum II",
    "dept": "SCM",
    "num": "651",
    "desc": "Prereq: enrollment in the PhD program\nPreparation of a second research manuscript to be submitted to a peer-reviewed academic journal. Although students work under the supervision of a faculty mentor, the students will take independent responsibility for the research project.\n",
    "credits": "1"
  },
  {
    "course_name": "Dissertation",
    "dept": "SCM",
    "num": "699",
    "desc": "Prereq: Graduate classification, permission of dissertation supervisor\nResearch.\n",
    "credits": "12"
  },
  {
    "course_name": "Agroecosystems Analysis",
    "dept": "SUSAG",
    "num": "509",
    "desc": "Prereq: Senior or above classification; permission of instructor\nExperiential, interdisciplinary examination of Midwestern agricultural and food systems, emphasizing both field visits and classroom activities. Focus on understanding multiple elements, perspectives (agronomic, economic, ecological, social, etc.), and scales of operation.\n",
    "credits": "4"
  },
  {
    "course_name": "Integrated Crop and Livestock Production Systems",
    "dept": "SUSAG",
    "num": "515",
    "desc": "Prereq: SUSAG 509\nMethods to maintain productivity and minimize the negative ecological effects of agricultural systems by understanding nutrient cycles, managing manure and crop residue, and utilizing multispecies interactions. Crop and livestock production within landscapes and watersheds is also considered. Course includes a significant field component, with student teams analyzing Iowa farms.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecologically Based Pest Management Strategies",
    "dept": "SUSAG",
    "num": "530",
    "desc": "\nDurable, least-toxic strategies for managing weeds, pathogens, and insect pests, with emphasis on underlying ecological processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Strategies for Diversified Food and Farming Systems",
    "dept": "SUSAG",
    "num": "546",
    "desc": "Prereq: SUSAG 509\nProject-focused engagement in food and farming systems using tools and perspectives drawn from multiple disciplines. Includes a field component.\n",
    "credits": "3"
  },
  {
    "course_name": "Agroforestry Systems",
    "dept": "SUSAG",
    "num": "571",
    "desc": "Prereq: 6 credits in biological science at 300 level or above\nConcepts of sustainable land use, agroecological dynamics, and component interactions of agroforestry systems. Agroforestry systems in temperate and tropical regions. Design and evaluation techniques for agroforestry systems. Ecological, socioeconomic and political aspects of agroforestry.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Organic Agricultural Theory and Practice",
    "dept": "SUSAG",
    "num": "584",
    "desc": "Prereq: 9 cr. in biological or physical sciences\nUnderstanding of the historical origins and ecological theories underpinning the practices involved in organic agriculture. Interdisciplinary examination of crop and livestock production and socio-economic processes and policies in organic agriculture from researcher and producer perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "SUSAG",
    "num": "590",
    "desc": "Prereq: Graduate classification, permission of instructor\nFor students wishing to conduct in-depth study of a particular topic in sustainable agriculture.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "SUSAG",
    "num": "599",
    "desc": "\nPre-enrollment contract required. For MS students pursuing the non-thesis degree option. Final product is a creative component.\n",
    "credits": "arr"
  },
  {
    "course_name": "Sustainable Agriculture Colloquium",
    "dept": "SUSAG",
    "num": "600",
    "desc": "\nWeekly seminar for graduate students in the Sustainable Agriculture program.\n",
    "credits": "1"
  },
  {
    "course_name": "Foundations of Sustainable Agriculture",
    "dept": "SUSAG",
    "num": "610",
    "desc": "Prereq: Graduate classification, permission of instructor\nHistorical, biophysical, socioeconomic, and ethical dimensions of agricultural sustainability. Strategies for evaluating existing and emerging agricultural systems in terms of the core concepts of sustainability and their theoretical contexts.\n",
    "credits": "3"
  },
  {
    "course_name": "Research",
    "dept": "SUSAG",
    "num": "699",
    "desc": "\nMS and PhD thesis and dissertation research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Sustainable Design Studio I",
    "dept": "SUS E",
    "num": "501",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission\nExploring the challenges faced in implementing social, environmental, and economic sustainable solutions, this studio engages students in an interdisciplinary, team-oriented and project-based learning environment. Projects will include theoretical investigations and applications of an interdisciplinary design process through brief readings and discussions.\n",
    "credits": "6"
  },
  {
    "course_name": "Sustainable Design Studio II",
    "dept": "SUS E",
    "num": "502",
    "desc": "Prereq: SUS E 501, SUS E 512, SUS E 531\nThis advanced studio provides a community-based context for an interdisciplinary design team to work on a variety of faculty-directed projects including funded, basic, and applied research.  Coursework addresses sustainable design at multiple scales, engaging both systems and artifacts.  Field trips.\n",
    "credits": "5"
  },
  {
    "course_name": "Sustainable Design Colloquium I",
    "dept": "SUS E",
    "num": "511",
    "desc": "Prereq: Admission to MDSE program\nStudy and discuss practices of sustainable design and design research.  Investigate responsibilities, roles, technologies and methods for studying and advancing the art and science of designing sustainable environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Sustainable Design Colloquium II",
    "dept": "SUS E",
    "num": "512",
    "desc": "Prereq: SUS E 511\nA graduate student-led seminar designed to foster the knowledge and skills to support innovation, entrepreneurship, and leadership in the field of sustainable design.  Invitation of outside speakers.\n",
    "credits": "1"
  },
  {
    "course_name": "Sustainable Design Colloquium III",
    "dept": "SUS E",
    "num": "513",
    "desc": "Prereq: SUS E 540, SUS E 502\nResearch expands and integrates findings from the prerequisite courses. Students develop independently-defined research to produce a comprehensive and conclusive written document.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundation of Sustainable Design",
    "dept": "SUS E",
    "num": "521",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission.\nIntroduction to the broad frameworks and tools for implementing sustainability among a variety of environments, industries, and enterprises.  Investigates the role and opportunity for sustainable design strategies.\n",
    "credits": "3"
  },
  {
    "course_name": "Human Dimensions of Sustainability",
    "dept": "SUS E",
    "num": "531",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission.\nThis seminar provides students from multiple disciplines with a grounding in designers' interactions with clients, consumers, communities, cultures, and biospheres.  Through a review of literature and the production of new case studies in sustainable design, students discover and represent conditions in which products of design operate across scales, markets, social conditions, geographic domains, academic disciplines, and zones of professional responsibility.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods for Sustainable Design",
    "dept": "SUS E",
    "num": "540",
    "desc": "Prereq: senior or graduate standing.\nOverview of qualitative, quantitative and design research methods. In-depth application of methods relevant to capstone project proposal development (SUS E 502). Proposal must address research questions, articulation of research methods and preliminary findings grounded within contemporary theoretical discourse on Sustainable Environments.\n",
    "credits": "3"
  },
  {
    "course_name": "Making Resilient Environments",
    "dept": "SUS E",
    "num": "550",
    "desc": "Prereq: senior or graduate standing.\nMajor theories and ideas revolving around the concept of resilience.  Assessing the social and political processes associated with policy making for resilience. Application of the concept of resilience in order to understand and evaluate environments. Evaluate the different approaches toward resilience and develop an understanding of the relationship between sustainability and resilience. Case studies of communities that proactively prepare for, absorb, recorver from, and adapt to actual or potential future adverse events.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Technology",
    "dept": "TSM",
    "num": "110",
    "desc": "Prereq: AST or I Tec majors only or permission of instructor\nTeam-oriented introduction to agricultural systems technology and industrial technology. Internships, careers, competencies, academic success strategies, transition to academic life.\n",
    "credits": "1"
  },
  {
    "course_name": "Experiencing Technology",
    "dept": "TSM",
    "num": "111",
    "desc": "Prereq: AST or I Tec majors only or permission of instructor\nLaboratory-based, team-oriented experiences in a spectrum of topics common to the practice of technology. Internships, competencies, industry visits.\n",
    "credits": "1"
  },
  {
    "course_name": "Developing Responsible Learners and Effective Leaders",
    "dept": "TSM",
    "num": "114",
    "desc": "Prereq: NREM 112\nFocus on team and community. Application of fundamentals of human learning; evidence of development as a responsible learner; intentional mental processing as a habit of mind; planning and facilitating learning opportunities for others; responsibility of the individual to the community and the world; leading from within; holding self and others accountable for growth and development as learners and leaders.\n",
    "credits": "2"
  },
  {
    "course_name": "Solving Technology Problems",
    "dept": "TSM",
    "num": "115",
    "desc": "Prereq: Credit or enrollment for credit in MATH 140 or higher\nSolving technology problems and presenting solutions through data analysis and technical report writing. Problem solving cycle, unit conversion, unit factor method, SI units, significant digits, graphing, curve fitting and computer programming. Use of modern hardware and software tools for applied data-driven problem solving.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Design in Technology",
    "dept": "TSM",
    "num": "116",
    "desc": "\nUse of  parametric solid modeling software to create three dimensional solid models and document parts and assemblies. Includes national and international standards for documentation, design projects, and teamwork. Rapid prototyping design creation, 3D printing, assemblies, rendering, and detailing technical drawings.\n",
    "credits": "3"
  },
  {
    "course_name": "Preparing for Workplace Seminar",
    "dept": "TSM",
    "num": "201",
    "desc": "Prereq: Prereq: Sophomore classification in AE, AST, BSE, or I TEC\n8 week course. Professionalism in the context of the engineering/technical workplace. Development and demonstration of key workplace competencies: teamwork, initiative, communication, and engineering/technical knowledge. Resumes; Cover Letters; Behavioral Based Interviewing; Industry Speakers; Preparation for internships experiences.\n",
    "credits": "1"
  },
  {
    "course_name": "Fundamentals of Technology",
    "dept": "TSM",
    "num": "210",
    "desc": "Prereq: TSM 115 or equivalent; and MATH 140 or higher\nIntroduction to problem solving related to fundamental agricultural and/or industrial technology systems and mathematical tools needed for data analysis. Basic laws of energy, force, and mass applied to technology systems such as: mechanical power transmission; heating, ventilation and air conditioning; electrical circuits. Introduction to engineering economics: using the time value of money to make economic decisions.\n",
    "credits": "3"
  },
  {
    "course_name": "Managing Technology Projects",
    "dept": "TSM",
    "num": "214",
    "desc": "Prereq: TSM 201 or A B E 201; and sophomore classification in A E, AST, BSE, or ITEC.\n8 week course. Introduction to project management principles. Use of project management in technology-based projects for academic, industry, and personal use.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Technical Graphics, Interpretation, and CAD",
    "dept": "TSM",
    "num": "216",
    "desc": "Prereq: TSM 116\nAdvanced computer-aided-design topics incorporating 3D design and documentation used in manufacturing settings. Topics include: geometric dimensioning and tolerancing, weldments, sheet metal parts, advanced visualization, feature based design of parts and assemblies.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Manufacturing Processes for Metals",
    "dept": "TSM",
    "num": "240",
    "desc": "Prereq: MATH 145\nA study of selected materials and related processes used in metals manufacturing. Lecture and laboratory activities focus on materials, properties, and processes.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Manufacturing Processes for Plastics",
    "dept": "TSM",
    "num": "241",
    "desc": "Prereq: MATH 145\nA study of selected materials and related processes used in plastics manufacturing. Lecture and laboratory activities focus on materials, properties, and processes.\n",
    "credits": "2"
  },
  {
    "course_name": "Principles of Injury Prevention and Safety",
    "dept": "TSM",
    "num": "270",
    "desc": "\nBasic foundations of injury causation and prevention from a personal perspective in home, motor vehicle, and the public environment, and a management perspective within the work environment. Offered online only.\n",
    "credits": "3"
  },
  {
    "course_name": "Total Quality Improvement",
    "dept": "TSM",
    "num": "310",
    "desc": "Prereq: STAT 101 or STAT 104, junior classification\nIntroduction to the fundamental concepts of TQM - Deming style of management, statistical studies to understand the behavior of products, processes, or services, and how to define and document processes and customer focus.  Introduction to continuous improvement tools and methods -  emphasis on team work and problem solving skills.\n",
    "credits": "3"
  },
  {
    "course_name": "Preservation of Grain Quality",
    "dept": "TSM",
    "num": "322",
    "desc": "Prereq: MATH 140 or higher\nPrinciples and management for grain quality preservation. Quality measurement. Drying and storage. Fans and airflow through grain. Handling methods.\n",
    "credits": "3"
  },
  {
    "course_name": "Preservation of Grain Quality Laboratory",
    "dept": "TSM",
    "num": "322L",
    "desc": "Prereq: Credit or enrollment for credit in TSM 322\nHands-on experiences in the principles and management for grain quality preservation. Quality measurement. Drying and storage. Fans and airflow through grain. Handling methods. System planning. Industry tour.\n",
    "credits": "1"
  },
  {
    "course_name": "Soil and Water Conservation Management",
    "dept": "TSM",
    "num": "324",
    "desc": "Prereq: MATH 140 or MATH 151\nIntroduction to engineering and conservation principles applied to the planning of erosion control systems, water control structures, water quality management, and drainage and irrigation  systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Biorenewable Systems",
    "dept": "TSM",
    "num": "325",
    "desc": "Prereq: CHEM 163 or higher; MATH 140 or higher\nConverting biorenewable resources into bioenergy and biobased products. Biorenewable concepts as they relate to drivers of change, feedstock production, processes, products, co-products, economics, and transportation/logistics.\n",
    "credits": "3"
  },
  {
    "course_name": "Animal Production Systems",
    "dept": "TSM",
    "num": "327",
    "desc": "Prereq: TSM 210\nConfined animal feeding operations. Environmental controls for animal production. Response of animals to the environment. Heat and moisture balance in animal housing. Ventilation, water, feed handling, air pollution, odor and waste management systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Agricultural Machinery and Power Management",
    "dept": "TSM",
    "num": "330",
    "desc": "Prereq: MATH 145 or MATH 151; and TSM 210\nSelection, sizing, and operational principles of tractors and machinery systems. Cost analysis and computer techniques applied to planning and management of agricultural machine systems. Principles, operation, and application of agricultural machinery.\n",
    "credits": "3"
  },
  {
    "course_name": "Tractor Power",
    "dept": "TSM",
    "num": "335",
    "desc": "Prereq: TSM 210, MATH 145\nTheory and construction of tractor engines, mechanical power trains and hydraulic systems. Introduction to traction, chassis mechanics, and hydraulic power.\n",
    "credits": "4"
  },
  {
    "course_name": "Fluid Power Systems Technology",
    "dept": "TSM",
    "num": "337",
    "desc": "Prereq: TSM 210\nFundamental fluid power principles. Fluid properties. Function and performance of components such as pumps, valves, actuators, hydrostatic transmission. Analysis of fluid power circuits and systems. Introduction to electrohydraulics. Simulation of hydraulic systems with software. Course includes lab using fluid power trainers.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Automated Manufacturing Processes",
    "dept": "TSM",
    "num": "340",
    "desc": "Prereq: TSM 210, TSM 216, TSM 240, MATH 151\nNC programming operations for CNC mills and lathes. Transfer of parts descriptions into detailed process plans, tool selection, and NC codes. Computer assisted CAD/CAM NC programming for 2D/3D machining and machining of student programmed NC code in lab.\n",
    "credits": "3"
  },
  {
    "course_name": "Electrical Power Systems and Electronics for Agriculture and Industry",
    "dept": "TSM",
    "num": "363",
    "desc": "Prereq: TSM 210, MATH 145\nFundamental electrical power theory and applications, code requirements, and safety considerations. Single-phase and three-phase circuits design, analysis, and safety; electric motor performance characteristics; motor controls; electrical conductor and safety equipment selection; lighting system technology and design; and electric power usage. Emphasis on agricultural and industrial applications.\n",
    "credits": "4"
  },
  {
    "course_name": "Occupational Safety",
    "dept": "TSM",
    "num": "370",
    "desc": "Prereq: TSM 270, junior standing\nIdentifies safety and health risks in industrial work environments. Focus on how managers and supervisors meet their responsibilities for providing a safe workplace for their employees. Includes the identification and remediation of workplace hazards.\n",
    "credits": "3"
  },
  {
    "course_name": "Occupational Safety Management",
    "dept": "TSM",
    "num": "371",
    "desc": "\nIntroduction to occupational safety and health administration and management. Focus on development and management of safety programs and obtaining employee involvement in occupational safety programs.\n",
    "credits": "2"
  },
  {
    "course_name": "Legal Aspects of Occupational Safety and Health",
    "dept": "TSM",
    "num": "372",
    "desc": "Prereq: TSM 371\nA review of the common legal issues facing safety practitioners in the workplace.  Includes OSHA, EPA and DOT regulations; workers' compensation, as well as common liability issues.\n",
    "credits": "2"
  },
  {
    "course_name": "Fire Protection and Prevention",
    "dept": "TSM",
    "num": "376",
    "desc": "\nAn overview of the current problems and technology in the fields of fire protection and fire prevention, with emphasis on industrial needs, focusing on the individual with industrial safety responsibilities.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Technology",
    "dept": "TSM",
    "num": "393",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Agriculture and Biosystems Management",
    "dept": "TSM",
    "num": "393A",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Machine Systems",
    "dept": "TSM",
    "num": "393B",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Manufacturing",
    "dept": "TSM",
    "num": "393C",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Occupational Safety",
    "dept": "TSM",
    "num": "393D",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Chemical Application Systems",
    "dept": "TSM",
    "num": "393E",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Agricultural Safety and Health",
    "dept": "TSM",
    "num": "393F",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Electronic Integration for Agriculture and Production Systems",
    "dept": "TSM",
    "num": "393G",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Irrigation Systems Management",
    "dept": "TSM",
    "num": "393I",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Topics in Technology: Machinery Management Using Precision Agriculture Technology",
    "dept": "TSM",
    "num": "393J",
    "desc": "\nOffered as demand warrants. Web-based instruction.\n",
    "credits": "1"
  },
  {
    "course_name": "Internship in Technology",
    "dept": "TSM",
    "num": "397",
    "desc": "Prereq: At least 45 credits of coursework, AST or I Tec major, and approval of internship coordinator\nA supervised work experience in an approved learning setting with application to technology practices and principles. Reporting during work experience and self and employer evaluation required.  Minimum GPA requirement.\n",
    "credits": "R"
  },
  {
    "course_name": "Work Experience in Technology",
    "dept": "TSM",
    "num": "399",
    "desc": "Prereq: TSM 397 in the preceding semester and approval of internship coordinator\nWritten reports and reflection on work experience.\n  A maximum of 4 credits of TSM 399 maybe be used toward the total credits required for graduation.",
    "credits": "2"
  },
  {
    "course_name": "Applied Project Management in Technology",
    "dept": "TSM",
    "num": "415",
    "desc": "Prereq: Senior classification with less than 32 credits remaining; TSM 214; and credit or enrollment for credit in TSM 310.\nImplementation of project management principles using case studies and teamwork; problem definition in a technology context; development of charter for technology capstone project.\n",
    "credits": "2"
  },
  {
    "course_name": "Technology Capstone",
    "dept": "TSM",
    "num": "416",
    "desc": "Prereq: TSM 415 in previous semester\nApplication of project management tools to a technology capstone project; development and evaluation of potential project solutions using tools from the technology curriculum; problem resolution emphasizing communication, critical analysis, and planning techniques; presentation of project through oral presentation and written reports with input from client, faculty, and other stakeholders.\n",
    "credits": "3"
  },
  {
    "course_name": "Precision Agriculture",
    "dept": "TSM",
    "num": "433",
    "desc": "Prereq: Junior standing.\nGeographic information systems (GIS) and global positioning systems (GPS). Hardware systems for precision farming emphasized. Autosteering and automatic implement control systems. Collection and management of yield data. Sampling strategies for precision farming. Introduction to building fertilizer prescriptions and recommendations. Economic benefits of precision farming systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Cellular Lean Manufacturing Systems",
    "dept": "TSM",
    "num": "440",
    "desc": "Prereq: TSM 310\nIntroduction to lean tools and techniques that reduce costs and improve business performance: JIT, VSM, SMED, Kaizen, Standard Work, Cycle Time Reduction, Takt Time, A3, etc.  Emphasis on lean thinking and competency development through application: simulations, case studies, industry guests and mentors, teamwork and industry-related lean projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Statics and Strength of Materials for Technology",
    "dept": "TSM",
    "num": "443",
    "desc": "Prereq: PHYS 111; and MATH 145 or MATH 151\nApplication of standard analytic and computer based techniques of solving problems related to force and moments. The properties of materials and how to select appropriate materials for a particular design is reviewed.\n",
    "credits": "3"
  },
  {
    "course_name": "Facility Planning",
    "dept": "TSM",
    "num": "444",
    "desc": "Prereq: TSM 216; TSM 240; and STAT 101 or STAT 104\nFundamental principles and practices in designing, evaluating, and organizing new or existing facilities. Emphasis on AutoCAD-based facility design and  production flow analysis, activity relationship analysis, lighting analysis, time studies, materials handling, supporting services design, and optimal facility location analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Feed Processing and Technology",
    "dept": "TSM",
    "num": "455",
    "desc": "Prereq: Junior classification\nIntroduction to formula feed manufacturing and the animal feed industry. Overview of feed ingredients and formulation, understanding and operation of feed production processing equipment including principles of conveying, grinding, mixing, conditioning, pelleting, and other processing techniques, and the formulation of concentrates, premixes, and rations. Students will become knowledgeable about the manufacturing of various animal feed types such as pelleted and extruded feed, aqua (fish) feed, liquid feeds, poured and pressed blocks, steam flaked feed, and pet food, and their effect on animal performance and health.\n",
    "credits": "3"
  },
  {
    "course_name": "Feed Safety, Ingredient Quality and Analytics",
    "dept": "TSM",
    "num": "457",
    "desc": "Prereq: Junior classification\nConcepts of feed and grain safety and quality, including hazards and risks associated with common feeds and feed ingredients. Methods to monitor, manage, and mitigate hazards and risks in the context of feed and grain industries. Government regulations applicable to feed and grain safety. Differences between safety and quality factors, how they are measured and then used for decision-making (marketing, processing, or safe-use).\n",
    "credits": "3"
  },
  {
    "course_name": "Automation Systems",
    "dept": "TSM",
    "num": "465",
    "desc": "Prereq: TSM 363\nTheory and applications of automation systems. Emphasizes features, capabilities, design and programming skills of Programmable Logic Controller (PLC) based industrial control systems. Introduction to industrial robots and sensors.\n",
    "credits": "3"
  },
  {
    "course_name": "Industrial Hygiene:  Physical, Chemical, and Biological Hazards",
    "dept": "TSM",
    "num": "470",
    "desc": "Prereq: MATH 151 or higher\nA qualitative and quantitative introduction to health effects of chemical, biological, and physical hazards in a workplace.\n",
    "credits": "3"
  },
  {
    "course_name": "Safety Laboratory",
    "dept": "TSM",
    "num": "471",
    "desc": "Prereq: Credit or enrollment for credit in TSM 470\nIntroduction to equipment, methods, and strategies to measure, evaluate, control, and research hazards and risk in the workplaces.\n",
    "credits": "1"
  },
  {
    "course_name": "Risk Analysis and Management",
    "dept": "TSM",
    "num": "477",
    "desc": "Prereq: MATH 151; and STAT 101 or STAT 104\nRisk analysis and management focuses on developing a risk oriented pattern of thinking that is appropriate for today's complex world. The tools that will be gained in this course will be helpful in recognizing, understanding, and analyzing hazards and risks in modern complex systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "TSM",
    "num": "490",
    "desc": "Prereq: Junior or senior classification, permission of instructor, and completion of an independent study contract and approval by department\n  A maximum of 4 credits of TSM 490 may be used toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Honors",
    "dept": "TSM",
    "num": "490H",
    "desc": "Prereq: Junior or senior classification, permission of instructor, and completion of an independent study contract and approval by department\n  A maximum of 4 credits of TSM 490 may be used toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Manufacturing",
    "dept": "TSM",
    "num": "490I",
    "desc": "Prereq: Junior or senior classification, permission of instructor, and completion of an independent study contract and approval by department\n  A maximum of 4 credits of TSM 490 may be used toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Agriculture and Biosystems Management",
    "dept": "TSM",
    "num": "490J",
    "desc": "Prereq: Junior or senior classification, permission of instructor, and completion of an independent study contract and approval by department\n  A maximum of 4 credits of TSM 490 may be used toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Machine Systems",
    "dept": "TSM",
    "num": "490M",
    "desc": "Prereq: Junior or senior classification, permission of instructor, and completion of an independent study contract and approval by department\n  A maximum of 4 credits of TSM 490 may be used toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study: Occupational Safety",
    "dept": "TSM",
    "num": "490O",
    "desc": "Prereq: Junior or senior classification, permission of instructor, and completion of an independent study contract and approval by department\n  A maximum of 4 credits of TSM 490 may be used toward the total credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Technology",
    "dept": "TSM",
    "num": "493",
    "desc": "\nOffered as demand warrants.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Technology: Agriculture and Biosystems Management",
    "dept": "TSM",
    "num": "493A",
    "desc": "\nOffered as demand warrants.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Technology: Machine Systems",
    "dept": "TSM",
    "num": "493B",
    "desc": "\nOffered as demand warrants.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Technology: Manufacturing",
    "dept": "TSM",
    "num": "493C",
    "desc": "\nOffered as demand warrants.\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Technology: Occupational Safety",
    "dept": "TSM",
    "num": "493D",
    "desc": "\nOffered as demand warrants.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural and Biosystems Engineering Department Study Abroad Preparation or Follow-up",
    "dept": "TSM",
    "num": "495",
    "desc": "Prereq: Permission of instructor\nPreparation for, or follow-up of, study abroad experience (496). For preparation, course focuses on understanding the tour destination through readings, discussions, and research on topics such as the regional industries, climate, crops, culture, economics, food, geography, government, history, natural resources, and public policies. For follow-up, course focuses on presentations by students, report writing, and reflection. Students enrolled in this course intend to register for 496 the following term or have had taken 496 the previous term.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Agricultural and Biosystems Engineering Department Study Abroad",
    "dept": "TSM",
    "num": "496",
    "desc": "Prereq: Permission of instructor\nTour and study at international sites relevant to disciplines of industrial technology, biological systems engineering, agricultural systems technology, and agricultural engineering. Location and duration of tours will vary. Trip expenses paid by students. Pre-trip preparation and/or post-trip reflection and reports arranged through 495.\n\nMeets International Perspectives Requirement.\n",
    "credits": "1"
  },
  {
    "course_name": "Precision Agriculture",
    "dept": "TSM",
    "num": "533",
    "desc": "Prereq: Junior standing.\nGeographic information systems (GIS) and global positioning systems (GPS). Hardware systems for precision farming emphasized. Autosteering and automatic implement control systems. Collection and management of yield data. Sampling strategies for precision farming. Introduction to building fertilizer prescriptions and recommendations. Economic benefits of precision farming systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Design and Manufacturing",
    "dept": "TSM",
    "num": "540",
    "desc": "Prereq: Permission of instructor\nApplication of six sigma philosophy to advance product design and process control. Application of value steam mapping to the existing manufacturing system to develop future continuous improvement plans. Application of Taguchi Parameter design methodologies for optimizing the performance of manufacturing processes. Application of Taguchi Tolerance Design methodologies for product design.\n",
    "credits": "3"
  },
  {
    "course_name": "Feed Processing and Technology",
    "dept": "TSM",
    "num": "555",
    "desc": "Prereq: Junior classification\nIntroduction to formula feed manufacturing and the animal feed industry. Overview of feed ingredients and formulation, understanding and operation of feed production processing equipment including principles of conveying, grinding, mixing, conditioning, pelleting, and other processing techniques, and the formulation of concentrates, premixes, and rations. Students will become knowledgeable about the manufacturing of various animal feed types such as pelleted and extruded feed, aqua (fish) feed, liquid feeds, poured and pressed blocks, steam flaked feed, and pet food, and their effect on animal performance and health.\n",
    "credits": "3"
  },
  {
    "course_name": "Feed Safety, Ingredient Quality and Analytics",
    "dept": "TSM",
    "num": "557",
    "desc": "Prereq: Junior classification\nConcepts of feed and grain safety and quality, including hazards and risks associated with common feeds and feed ingredients. Methods to monitor, manage, and mitigate hazards and risks in the context of feed and grain industries. Government regulations applicable to feed and grain safety. Differences between safety and quality factors, how they are measured and then used for decision-making (marketing, processing, or safe-use).\n",
    "credits": "3"
  },
  {
    "course_name": "Safety and Public Health Issues in Modern Society",
    "dept": "TSM",
    "num": "575",
    "desc": "\nExploration and analysis of current safety and public health issues impacting society. The focus will be on topics that impact individuals in work, public, and home environments.\n",
    "credits": "2"
  },
  {
    "course_name": "Risk Analysis and Management",
    "dept": "TSM",
    "num": "577",
    "desc": "Prereq: MATH 151; and STAT 101 or STAT 104\nRisk analysis and management focuses on developing a risk oriented pattern of thinking that is appropriate for today's complex world. The tools that will be gained in this course will be helpful in recognizing, understanding, and analyzing hazards and risks in modern complex systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics in Technology",
    "dept": "TSM",
    "num": "590",
    "desc": "Prereq: Graduate classification in industrial and agricultural technology, permission of instructor, and completion of an independent study contract approved by major professor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Technology: Agriculture and Biosystems Management",
    "dept": "TSM",
    "num": "590A",
    "desc": "Prereq: Graduate classification in industrial and agricultural technology, permission of instructor, and completion of an independent study contract approved by major professor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Technology: Machine Systems",
    "dept": "TSM",
    "num": "590B",
    "desc": "Prereq: Graduate classification in industrial and agricultural technology, permission of instructor, and completion of an independent study contract approved by major professor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Technology: Manufacturing",
    "dept": "TSM",
    "num": "590C",
    "desc": "Prereq: Graduate classification in industrial and agricultural technology, permission of instructor, and completion of an independent study contract approved by major professor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics in Technology: Occupational Safety",
    "dept": "TSM",
    "num": "590D",
    "desc": "Prereq: Graduate classification in industrial and agricultural technology, permission of instructor, and completion of an independent study contract approved by major professor\n",
    "credits": "1"
  },
  {
    "course_name": "Workshop in Technology",
    "dept": "TSM",
    "num": "593",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "TSM",
    "num": "599",
    "desc": "\nA discipline-related problem to be identified and completed under the direction of the program adviser. Three credits required for all nonthesis master's degree students.\n",
    "credits": "1"
  },
  {
    "course_name": "Graduate Seminar",
    "dept": "TSM",
    "num": "601",
    "desc": "\nKeys to starting a successful graduate research project.  Effective literature review, formulating research questions, and setting goals.  Practicing effectively communicating research and science.  Effective strategies for scholarly writing, responding to feedback, peer-reviewing, successful publishing in journals, and curating scholarly output.\n",
    "credits": "1"
  },
  {
    "course_name": "Program and Learner Evaluation",
    "dept": "TSM",
    "num": "652",
    "desc": "Prereq: STAT 401 or equivalent\nTechniques for evaluating learners, facilities, programs, and staff utilizing theories for developing measurement instruments. Outcomes assessment is emphasized.\n",
    "credits": "3"
  },
  {
    "course_name": "Academic Leadership in Technology and Engineering",
    "dept": "TSM",
    "num": "655",
    "desc": "Prereq: Permission of instructor\nA definition of the faculty role in technology and engineering disciplines, including strategies for dealing with programs, personnel, and constituencies are presented. Leadership skills involving team formation, team operation, and conflict resolution are addressed.\n",
    "credits": "3"
  },
  {
    "course_name": "Curriculum Development in Technology and Engineering",
    "dept": "TSM",
    "num": "657",
    "desc": "Prereq: Permission of instructor\nBasic concepts, trends, practices, and factors influencing curriculum development, techniques, organization and procedures. Emphasis will be given to course development using the backward design process.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching Practicum",
    "dept": "TSM",
    "num": "694",
    "desc": "Prereq: Graduate classification and permission of instructor\nGraduate student experience in the agricultural and biosystems engineering departmental teaching program.\n",
    "credits": "1"
  },
  {
    "course_name": "Internship in Technology",
    "dept": "TSM",
    "num": "697",
    "desc": "Prereq: permission of major professor and approval by department chair, graduate classification\nOne semester and one summer maximum per academic year professional work period.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Research",
    "dept": "TSM",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Introduction to the Performing Arts",
    "dept": "THTRE",
    "num": "106",
    "desc": "\nAn audience oriented, broad-based, team-taught survey of the performing arts which emphasizes theatre and includes segments on television, radio, film, dance, and music.\n",
    "credits": "3"
  },
  {
    "course_name": "Theatre and Society",
    "dept": "THTRE",
    "num": "110",
    "desc": "\nAn introduction to Theatre focusing on its relationship with society throughout history.\n",
    "credits": "3"
  },
  {
    "course_name": "The Actor's Voice",
    "dept": "THTRE",
    "num": "151",
    "desc": "\nStudy and practice of fundamentals of vocal production: breathing, quality, articulation, projection, and expressiveness for the performing artist.\n",
    "credits": "3"
  },
  {
    "course_name": "Concert and Theatre Dance",
    "dept": "THTRE",
    "num": "224",
    "desc": "Prereq: By audition only\nChoreography, rehearsal, and performance in campus dance concerts and/or musical theatre productions.\n  Offered on a satisfactory-fail basis only.",
    "credits": "0"
  },
  {
    "course_name": "Theatre Practicum",
    "dept": "THTRE",
    "num": "250",
    "desc": "Prereq: Permission of instructor\nPractice in various aspects of technical theatre production.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Acting I",
    "dept": "THTRE",
    "num": "251",
    "desc": "\nTheory and practice in fundamentals of acting.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Theatrical Production",
    "dept": "THTRE",
    "num": "255",
    "desc": "\nStandard structure and procedures, historical overview of performing arts production including the design and creation of scenery, costumes and lighting.\n",
    "credits": "4"
  },
  {
    "course_name": "Script Analysis",
    "dept": "THTRE",
    "num": "263",
    "desc": "\nTheory, analysis, and interpretation of play scripts for production.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Projects",
    "dept": "THTRE",
    "num": "290",
    "desc": "Prereq: 3 credits in theatre; permission of instructor; approval of written proposal\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Writing: Playwriting",
    "dept": "THTRE",
    "num": "316",
    "desc": "Prereq: ENGL 250, not open to freshmen\nProgresses from production of scenes to fully developed one-act plays. Emphasis on action, staging, writing, analytical reading, workshop criticism, and individual conferences.\n",
    "credits": "3"
  },
  {
    "course_name": "Acting II",
    "dept": "THTRE",
    "num": "351",
    "desc": "Prereq: THTRE 251, DANCE 120 recommended\nTheory and practice of techniques of acting with emphasis on character and scene analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Musical Theatre I",
    "dept": "THTRE",
    "num": "354",
    "desc": "Prereq: THTRE 251 or MUSIC 232 or 3 credits in Dance\nTheory, history and practice of musical theatre techniques. Designed to develop the musical theatre performance skills of singers, dancers, and actors.\n",
    "credits": "3"
  },
  {
    "course_name": "Musical Theatre II",
    "dept": "THTRE",
    "num": "355",
    "desc": "Prereq: THTRE 354\nTheory, history and practice of musical theatre techniques. Designed to develop the musical theatre performance skills of singers, dancers, and actors.\n",
    "credits": "3"
  },
  {
    "course_name": "Stage Make-up",
    "dept": "THTRE",
    "num": "357",
    "desc": "\nTheory and practice of make-up and hair-styling techniques for the performing arts: Theatre, Opera, Dance, Television and Film. Lab required.\n",
    "credits": "2"
  },
  {
    "course_name": "Oral Interpretation",
    "dept": "THTRE",
    "num": "358",
    "desc": "\nPrinciples of oral interpretation: practice in analysis, in reading aloud of literary selections, and in reader's theatre.\n",
    "credits": "3"
  },
  {
    "course_name": "Stagecraft",
    "dept": "THTRE",
    "num": "360",
    "desc": "Prereq: THTRE 255\nTools, materials, and techniques of planning, constructing and painting of performing arts scenography. Basic principles of lighting technology. Technical drawing for performing arts production.\n",
    "credits": "4"
  },
  {
    "course_name": "Theatrical Design I",
    "dept": "THTRE",
    "num": "365",
    "desc": "Prereq: THTRE 255\nAn exploration of the elements, principles and art of theatrical design.\n",
    "credits": "3"
  },
  {
    "course_name": "Theatrical Design II",
    "dept": "THTRE",
    "num": "366",
    "desc": "Prereq: THTRE 365\nIntensive application of the principles introduced in 365. In-depth study and practice of the graphic skills of rendering and drafting.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop",
    "dept": "THTRE",
    "num": "393",
    "desc": "Prereq: THTRE 365\nStudies in Theatre Design and Production.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Costume Design",
    "dept": "THTRE",
    "num": "393A",
    "desc": "Prereq: THTRE 365\nSpecial topics related to costume design.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Scenic Design",
    "dept": "THTRE",
    "num": "393B",
    "desc": "Prereq: THTRE 365\nSpecial topics related to scenic design.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Lighting Design",
    "dept": "THTRE",
    "num": "393C",
    "desc": "Prereq: THTRE 365\nSpecial topics in lighting design.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Sound Design",
    "dept": "THTRE",
    "num": "393D",
    "desc": "Prereq: THTRE 365\nSpecial topics in sound design.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Stagecraft",
    "dept": "THTRE",
    "num": "393E",
    "desc": "Prereq: THTRE 365\nSpecial topics in stagecraft.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Costume Draping and Patterning",
    "dept": "THTRE",
    "num": "393F",
    "desc": "Prereq: THTRE 365\nSpecial topics in costume draping and patterning.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Advanced Makeup",
    "dept": "THTRE",
    "num": "393G",
    "desc": "Prereq: THTRE 365\nSpecial topics related to advanced makeup.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Stage Management",
    "dept": "THTRE",
    "num": "393I",
    "desc": "Prereq: THTRE 365\nSpecial topics related to stage management.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Technical Direction",
    "dept": "THTRE",
    "num": "393J",
    "desc": "Prereq: THTRE 365\nSpecial topics related to technical direction.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in Theatre Design and Production Workshop: Arts Management",
    "dept": "THTRE",
    "num": "393K",
    "desc": "Prereq: THTRE 365\nSpecial topics related to Arts Management.\n",
    "credits": "3"
  },
  {
    "course_name": "Acting III",
    "dept": "THTRE",
    "num": "451",
    "desc": "Prereq: THTRE 351 and permission of instructor\nAnalysis and practice of period scenes.\n",
    "credits": "3"
  },
  {
    "course_name": "Directing I",
    "dept": "THTRE",
    "num": "455",
    "desc": "Prereq: THTRE 255; THTRE 263; THTRE 251 recommended\nTheory, techniques, and practice of directing.\n",
    "credits": "3"
  },
  {
    "course_name": "Directing II",
    "dept": "THTRE",
    "num": "456",
    "desc": "Prereq: THTRE 455\nPractical and theoretical experience in directing the stage play.\n",
    "credits": "3"
  },
  {
    "course_name": "Theatrical Design Studio",
    "dept": "THTRE",
    "num": "461",
    "desc": "Prereq: Permission of instructor\nFocuses on the art and craft of specific areas of theatrical design. Each semester the student will focus on one or two of the following: scenic, costume, or lighting design.\n",
    "credits": "4"
  },
  {
    "course_name": "History of Theatre I",
    "dept": "THTRE",
    "num": "465",
    "desc": "Prereq: HIST 201 or equivalent\nTheatre history from ancient times to 1800.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Theatre II",
    "dept": "THTRE",
    "num": "466",
    "desc": "Prereq: THTRE 465\nTheatre history from 1800 to present.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Theatre Practicum",
    "dept": "THTRE",
    "num": "469",
    "desc": "Prereq: 9 credits in theatre courses; junior classification\nPracticum in production with ISU Theatre, with opportunities for specialization within various areas. Required: Approval of written proposal.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "THTRE",
    "num": "490",
    "desc": "Prereq: 9 credits in theatre, approved written proposal, junior classification\nOnly one independent study enrollment within the department is permitted per semester.\n  No more than 9 credits in Thtre 490 may be counted toward graduation.",
    "credits": "1"
  },
  {
    "course_name": "Theatre Internship",
    "dept": "THTRE",
    "num": "499",
    "desc": "Prereq: 18 credits in THTRE, other courses deemed appropriate by faculty adviser; 2nd semester junior or senior standing; minimum GPA of 2.5  and minimum GPA of 3.0 in THTRE courses\nSupervised application of theatre in professional settings.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar",
    "dept": "THTRE",
    "num": "504",
    "desc": "Prereq: 9 credits in theatre\nTopics may include the following:.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Musical Theatre",
    "dept": "THTRE",
    "num": "504A",
    "desc": "Prereq: 9 credits in theatre\nTopics may include the following:.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Acting Techniques",
    "dept": "THTRE",
    "num": "504B",
    "desc": "Prereq: 9 credits in theatre\nTopics may include the following:.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Acting Styles",
    "dept": "THTRE",
    "num": "504C",
    "desc": "Prereq: 9 credits in theatre\nTopics may include the following:.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Design and Technical Theatre",
    "dept": "THTRE",
    "num": "504D",
    "desc": "Prereq: 9 credits in theatre\nTopics may include the following:.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar: Arts Management",
    "dept": "THTRE",
    "num": "504E",
    "desc": "Prereq: 9 credits in theatre\nTopics may include the following:.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "THTRE",
    "num": "590",
    "desc": "Prereq: Approved written proposal\n",
    "credits": "1"
  },
  {
    "course_name": "General Pharmacology",
    "dept": "TOX",
    "num": "354",
    "desc": "Prereq: B M S 549 and B M S 552; BBMB 404, BBMB 405\nGeneral principles; drug disposition; drugs acting on the nervous, cardiovascular, renal, gastrointestinal, and endocrine systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Toxicology",
    "dept": "TOX",
    "num": "401",
    "desc": "Prereq: BBMB 404 or equivalent\nPrinciples of toxicology governing entry, fate, and effects of toxicants on living systems. Includes toxicokinetics and foreign compound metabolism relative to toxification or detoxification. Fundamentals of foreign compound effects on metabolism, physiology, and morphology of different cell types, tissues, and organ systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Foodborne Hazards",
    "dept": "TOX",
    "num": "419",
    "desc": "Prereq: MICRO 201 or MICRO 302, a course in biochemistry\nPathogenesis of human microbiological foodborne infections and intoxications, principles of toxicology, major classes of toxicants in the food supply, governmental regulation of foodborne hazards. Assessed service learning component.\n  Only one of FS HN 419 and FS HN 519 may count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Food Microbiology",
    "dept": "TOX",
    "num": "420",
    "desc": "Prereq: MICRO 201 or MICRO 302\nEffects of microbial growth in foods. Methods to control, detect, and enumerate microorganisms in food and water. Foodborne infections and intoxications.\n",
    "credits": "3"
  },
  {
    "course_name": "Veterinary Toxicology",
    "dept": "TOX",
    "num": "426",
    "desc": "Prereq: Third year classification in veterinary medicine\nStudy of toxicological diseases of animals emphasizing clinical recognition, circumstances of poisoning, differential diagnosis with clinical and laboratory data, therapeutic procedures, preventive management and public health implications. Supplemented with case-based materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Foodborne Toxicants",
    "dept": "TOX",
    "num": "429",
    "desc": "Prereq: A course in biochemistry\nMechanisms of action, metabolism, sources, remediation or detoxification, risk assessment of major foodborne toxicants of current interest, design of HACCP plans for use in food industries targeting foodborne toxicants. Taught online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Independent Study",
    "dept": "TOX",
    "num": "490",
    "desc": "Prereq: Permission of instructor is required prior to registration.\nIndependent study with a faculty mentor.  Intended for students enrolled in the Pharmacology and Toxicology minor.\n  Students in the Pharmacology and Toxicology minor may use no more than 9 credits of university-wide 490 credits towards the total of 120 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Undergraduate Research",
    "dept": "TOX",
    "num": "499",
    "desc": "Prereq: Permission of instructor is required prior to registration.\nIndependent research under faculty guidance.  Intended for students enrolled in the Pharmacology and Toxicology minor.\n  Offered on a satisfactory-fail basis only.  Students may use no more than 9 credits of university-wide 499 credits towards the total of 120 credits required for graduation.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Toxicology",
    "dept": "TOX",
    "num": "501",
    "desc": "Prereq: BBMB 404 or equivalent\nPrinciples of toxicology governing entry, fate, and effects of toxicants on living systems. Includes toxicokinetics and foreign compound metabolism relative to toxification or detoxification. Fundamentals of foreign compound effects on metabolism, physiology, and morphology of different cell types, tissues, and organ systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Toxicology Methods",
    "dept": "TOX",
    "num": "502",
    "desc": "Prereq: TOX 501\nProvides demonstrations or laboratory experience in the application of methods used in toxicology, including safety procedures, calculation and data analysis, teratologic and morphologic evaluation, cellular/molecular toxicological techniques, electrophysiologic measures, in vitro enzyme induction/biotransformation, neural and behavioral toxicology testing.\n",
    "credits": "3"
  },
  {
    "course_name": "Toxicology Seminar",
    "dept": "TOX",
    "num": "504",
    "desc": "Prereq: Permission of instructor required\nPresentation of a seminar about a current topic in toxicology as part of a weekly series of seminars by graduate students, faculty, and guest lecturers from off campus.  Graduate student speakers will meet with the instructor at least one week prior to their formal presentation.\n",
    "credits": "1"
  },
  {
    "course_name": "Diet and Cancer Prevention",
    "dept": "TOX",
    "num": "506",
    "desc": "Prereq: BBMB 404 and BBMB 405 or BBMB 420\nPrinciples of cancer biology and cancer etiology will be integrated with the impacts of diet on cancer development and prevention.  Contributions of research with humans, animals, cultured cells and cell free systems will be included.  The importance of dietary contaminants, macronutrients and micronutrients will be examined with an emphasis on the strength of the evidence and mechanisms of action.\n",
    "credits": "1"
  },
  {
    "course_name": "Regulatory Toxicology",
    "dept": "TOX",
    "num": "515",
    "desc": "Prereq: BBMB 404 or FSHN 403\nSurvey of approaches used by toxicologists in government and industry for generating, enforcing and complying with laws and regulations. Regulatory policies and decision making. Toxicological risk assessment and risk analysis.\n",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Toxicology",
    "dept": "TOX",
    "num": "526",
    "desc": "Prereq: Third year classification in veterinary medicine\nStudy of toxicological diseases of animals emphasizing clinical recognition, circumstances of poisoning, differential diagnosis with clinical and laboratory data, therapeutic procedures, preventive management and public health implications. Supplemented with case-based materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Foodborne Toxicants",
    "dept": "TOX",
    "num": "529",
    "desc": "Prereq: A course in biochemistry; enrollment in GP-IDEA Food Safety and Defense Graduate Certificate or permission of instructor.\nMechanisms of action, metabolism, sources, remediation/detoxification, risk assessment of major foodborne toxicants of current interest, design of HAACP plans for use in food industries targeting foodborne toxicants, discussion of toxicants from a food defense perspective.  Offered online only.\n",
    "credits": "2"
  },
  {
    "course_name": "Clinical and Diagnostic Toxicology",
    "dept": "TOX",
    "num": "546",
    "desc": "Prereq: D.V.M. degree or VDPAM 526\nAdvanced study of current problems and issues in toxicology. Emphasis on problem solving utilizing clinical, epidemiological, and laboratory resources.\n",
    "credits": "1"
  },
  {
    "course_name": "Pesticides in the Environment",
    "dept": "TOX",
    "num": "550",
    "desc": "Prereq: 9 credits of biological sciences\nFate and significance of pesticides in soil, water, plants, animals, and the atmosphere.\n",
    "credits": "3"
  },
  {
    "course_name": "General Pharmacology",
    "dept": "TOX",
    "num": "554",
    "desc": "Prereq: B M S 549 and B M S 552; BBMB 404, BBMB 405\nGeneral principles; drug disposition; drugs acting on the nervous, cardiovascular, renal, gastrointestinal, and endocrine systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Biostatistics and Epidemiology",
    "dept": "TOX",
    "num": "565",
    "desc": "Prereq: STAT 500 or STAT 401; STAT 543 or STAT 447\nStatistical methods commonly used in epidemiology and human and animal health studies.  Overview of cohort studies, case-control studies and randomized clinical trials.  Topics include inference procedures for disease risk factors, analysis of time-to-event and survival data, analysis of longitudinal studies of disease progression and health status, diagnostic test evaluation, and meta-analysis.  Examples will come from recent studies of physical and mental health, nutrition and disease progression in human and animal populations. Use of statistical software: SAS or R.\n",
    "credits": "3"
  },
  {
    "course_name": "Risk Assessment for Food, Agriculture and Veterinary Medicine",
    "dept": "TOX",
    "num": "570",
    "desc": "Prereq: Statistics 300-level or higher.\nRisk assessment principles as applied to biological systems. Exposure and effects characterization in human and animal health and ecological risk assessment. Risk analysis frameworks and regulatory decision-making. Introduction to quantitative methods for risk assessment using epidemiological and distributional analysis. Uncertainty analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Cell Biology",
    "dept": "TOX",
    "num": "575",
    "desc": "Prereq: 10 credits in biological science and permission of instructor\nA multi-instructor course covering major topics in cell structure and function, including: universal features of prokaryotic and eukaryotic cells, types of utilization and conversion of energy, genetic control of cell shape and functionality, internal organization of cells, communication between cells and their environment, development of multicellular systems. Students have to write a term paper.\n",
    "credits": "3"
  },
  {
    "course_name": "Special  Topics",
    "dept": "TOX",
    "num": "590",
    "desc": "\nContact individual faculty for special projects or topics. Graded.\n",
    "credits": "arr"
  },
  {
    "course_name": "Advanced Food Microbiology",
    "dept": "TOX",
    "num": "626",
    "desc": "Prereq: FS HN 420 or FS HN 421 or FS HN 504\nTopics of current interest in food microbiology, including new foodborne pathogens, rapid identification methods, effect of food properties and new preservation techniques on microbial growth, and mode of action of antimicrobials.\n",
    "credits": "3"
  },
  {
    "course_name": "Rapid Methods in Food Microbiology",
    "dept": "TOX",
    "num": "627",
    "desc": "Prereq: FS HN 420 or FS HN 421 or FS HN 504\nProvides an overview of rapid microbial detection methods for use in foods. Topics include historical aspects of rapid microbial detection, basic categories of rapid tests (phenotypic, genotypic, whole cell, etc.), existing commercial test formats and kits, automation in testing, sample preparation and \"next generation\" testing formats now in development.\n",
    "credits": "2"
  },
  {
    "course_name": "Cellular and Molecular Pathology II",
    "dept": "TOX",
    "num": "656",
    "desc": "Prereq: Graduate course in biochemistry, genetics, or cell biology\nCellular and molecular mechanisms of carcinogenesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Insecticide Toxicology",
    "dept": "TOX",
    "num": "675",
    "desc": "Prereq: ENT 555 or TOX 501\nPrinciples of insecticide toxicology; classification, mode of action, metabolism, and environmental effects of insecticides.\n",
    "credits": "3"
  },
  {
    "course_name": "Current Topics in Toxicology",
    "dept": "TOX",
    "num": "689",
    "desc": "\nLecture and discussion participation on current topics in toxicology.  An 80% attendance is expected to satisfactorily complete the course.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Graduate Research Rotation",
    "dept": "TOX",
    "num": "697",
    "desc": "Prereq: Admission to Toxicology graduate program\nGraduate research projects performed under the supervision of selected faculty members in the graduate Toxicology major.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "TOX",
    "num": "699",
    "desc": "\nResearch.\n",
    "credits": "arr"
  },
  {
    "course_name": "Economic Analysis of Transportation Investments",
    "dept": "TRANS",
    "num": "555",
    "desc": "Prereq: C E 350 or C E 355\nApplication of economic analysis methodologies to evaluate transportation projects. Multi-modal approaches to evaluate impacts of transportation investments and maximize economic efficiency while considering equity and other social issues related to investment options.\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "TRANS",
    "num": "599",
    "desc": "Prereq: Pre-enrollment contract required\nAdvanced topic for creative component report in lieu of thesis.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Transportation Planning",
    "dept": "TRANS",
    "num": "691",
    "desc": "\nProvides an overview of current transportation issues; speakers provide seminars on a variety of timely transportation topics.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "TRANS",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "First Year Seminar I",
    "dept": "U ST",
    "num": "101",
    "desc": "Prereq: Acceptance/participation in appropriate learning community or special program.\nOrientation to the university focusing on student transition, acclimation to university, exposure to campus resources, and student success strategies.  Exploration of topical issues associated with specific learning community or program focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "First Year Seminar I: Hixson Scholars",
    "dept": "U ST",
    "num": "101A",
    "desc": "Prereq: Acceptance/participation in appropriate learning community or special program.\nOrientation to the university focusing on student transition, acclimation to university, exposure to campus resources, and student success strategies.  Exploration of topical issues associated with specific learning community or program focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "First Year Seminar I: MVP Award",
    "dept": "U ST",
    "num": "101B",
    "desc": "Prereq: Acceptance/participation in appropriate learning community or special program.\nOrientation to the university focusing on student transition, acclimation to university, exposure to campus resources, and student success strategies.  Exploration of topical issues associated with specific learning community or program focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "First Year Seminar I: Science Bound",
    "dept": "U ST",
    "num": "101C",
    "desc": "Prereq: Acceptance/participation in appropriate learning community or special program.\nOrientation to the university focusing on student transition, acclimation to university, exposure to campus resources, and student success strategies.  Exploration of topical issues associated with specific learning community or program focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "First Year Seminar I: Student Athlete Experience",
    "dept": "U ST",
    "num": "101D",
    "desc": "Prereq: Acceptance/participation in appropriate learning community or special program.\nOrientation to the university focusing on student transition, acclimation to university, exposure to campus resources, and student success strategies.  Exploration of topical issues associated with specific learning community or program focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "First Year Seminar I: Academic Program for Excellence (APEX)",
    "dept": "U ST",
    "num": "101F",
    "desc": "Prereq: Acceptance/participation in appropriate learning community or special program.\nOrientation to the university focusing on student transition, acclimation to university, exposure to campus resources, and student success strategies. Exploration of topical issues associated with specific learning community or program focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "First Year Seminar II",
    "dept": "U ST",
    "num": "102",
    "desc": "Prereq: U ST 101 or instructor permission.\nAcceptance/participation in appropriate learning community.  Continued exploration of university services, strategies for student success, leadership, and acclimation to university.  Exploration of issues associated with learning community focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "First Year Seminar II: MVP Award",
    "dept": "U ST",
    "num": "102A",
    "desc": "Prereq: U ST 101 or instructor permission.\nAcceptance/participation in appropriate learning community.  Continued exploration of university services, strategies for student success, leadership, and acclimation to university.  Exploration of issues associated with learning community focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "First Year Seminar II: Science Bound",
    "dept": "U ST",
    "num": "102B",
    "desc": "Prereq: U ST 101 or instructor permission.\nAcceptance/participation in appropriate learning community.  Continued exploration of university services, strategies for student success, leadership, and acclimation to university.  Exploration of issues associated with learning community focus.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Personal Career Development",
    "dept": "U ST",
    "num": "104",
    "desc": "\nComprehensive approach to personal career development providing students with the skills and structure to make informed choices about their major and career path.  Self-exploration of interests, skills, values, and personality as related to the world of work using a variety of techniques; exploration of majors and occupations; model for major and career decision-making and career goal implementation; exposure to effective job search and interviewing skills and resources.\n",
    "credits": "2"
  },
  {
    "course_name": "Carver Academy Seminar: Freshmen",
    "dept": "U ST",
    "num": "105",
    "desc": "Prereq: Acceptance in Carver Academy Program, George Washington Carver scholarship recipient\nOrientation to the university for Carver Academy students focusing primarily on transition and acclimation to the university environment. Individual and group identity development. Life and legacy of George Washington Carver.\n  Offered on a satisfactory-fail basis only.\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "Carver Academy Seminar: Freshmen",
    "dept": "U ST",
    "num": "106",
    "desc": "Prereq: Acceptance in Carver Academy Program, George Washington Carver scholarship recipient\nIntroduction for Carver Academy students to resources at ISU to supplement classroom learning. Exploration of multicultural communities and leadership opportunities at ISU.\n  Offered on a satisfactory-fail basis only.\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "International First-Year Experience Seminar",
    "dept": "U ST",
    "num": "110",
    "desc": "\nTopics to help international students transition to the United States and academic culture, such as culture shock, classroom culture, campus and community resources, learning styles, study skills, basic immigration status and employment benefits, student health and wellness, and research and presentation skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Carver Academy Seminar: Peer Mentors",
    "dept": "U ST",
    "num": "205",
    "desc": "Prereq: U ST 106, intended primarily for sophomores\nLeadership and peer mentor training for Carver Academy students who will be serving as peer mentors in Carver Academy. Definitions and analysis of diversity in academia. Academic portfolio preparation and career exploration.\n  Offered on a satisfactory-fail basis only.\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "Science Bound Pre-Professional Seminar",
    "dept": "U ST",
    "num": "207",
    "desc": "Prereq: 102B or instructor permission\nSeminar topics prepare sophomore and upper-class students to pursue research and internship experiences in science, technology, engineering and math fields.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "U ST",
    "num": "290",
    "desc": "Prereq: Permission of the associate provost for academic programs\nIndependent study on topics of an interdisciplinary nature. Intended primarily for freshmen and sophomores.\n",
    "credits": "arr"
  },
  {
    "course_name": "McNair Program: Introduction to Research I",
    "dept": "U ST",
    "num": "301",
    "desc": "Prereq: Acceptance to the Iowa State University McNair Program\nIntroduction to academic research focusing on the initial stages of research with lessons on how to define a research idea, formulate a research question or hypothesis, gather, critique, analyze and synthetize the literature on the subject of inquiry, and understand and be able to apply a number of methodologies to gather data.\n",
    "credits": "2"
  },
  {
    "course_name": "McNair Program: Introduction to Research II",
    "dept": "U ST",
    "num": "302",
    "desc": "Prereq: U ST 301\nContinuation of research preparation focusing on methodologies and the relevance to specific research questions, data collection and analysis processes, and scientific research writing and presentation.  Lessons on how to determine appropriate methodology and design a scientific protocol, gather and analyze data, and understand findings so as to effectively report and present findings and conclusions.\n",
    "credits": "2"
  },
  {
    "course_name": "CALM Life Skills Seminar",
    "dept": "U ST",
    "num": "303",
    "desc": "Prereq: Junior or Senior classification.\nCALM After the Storm is a course designed to assist student-athletes successfully transition to life after Iowa State University and collegiate athletics.  Topics include career preparation, adulthood, life after athletics, and money management.\n  Offered on a satisfactory-fail basis only.  None",
    "credits": "1"
  },
  {
    "course_name": "Leaders Seminar I",
    "dept": "U ST",
    "num": "311",
    "desc": "\nFor students serving as peer mentor first-year seminar leaders under faculty supervision. Development of course facilitation and peer leadership skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Leaders Seminar I: Leaders in Hixson Seminar",
    "dept": "U ST",
    "num": "311A",
    "desc": "\nFor students serving as peer mentor first-year seminar leaders under faculty supervision. Development of course facilitation and peer leadership skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Leaders Seminar I: Leaders in MVP Seminar",
    "dept": "U ST",
    "num": "311B",
    "desc": "\nFor students serving as peer mentor first-year seminar leaders under faculty supervision. Development of course facilitation and peer leadership skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Leaders Seminar II",
    "dept": "U ST",
    "num": "312",
    "desc": "Prereq: U ST 311\nFor students serving as leaders in Hixson Seminar or MVP Seminar under faculty supervision. Development of course facilitation and peer leadership skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Leaders Seminar II: Leaders in Hixson Seminar",
    "dept": "U ST",
    "num": "312A",
    "desc": "Prereq: U ST 311\nFor students serving as leaders in Hixson Seminar or MVP Seminar under faculty supervision. Development of course facilitation and peer leadership skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Leaders Seminar II: Leaders in MVP Seminar",
    "dept": "U ST",
    "num": "312B",
    "desc": "Prereq: U ST 311\nFor students serving as leaders in Hixson Seminar or MVP Seminar under faculty supervision. Development of course facilitation and peer leadership skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Cyclone Aide Leaders Seminar",
    "dept": "U ST",
    "num": "315",
    "desc": "Prereq: Selection as Cyclone Aide or Cyclone Aide Adviser\nDevelopment of public speaking, group facilitation, and peer leadership skills.  Exploration of issues associated with student transition to college, university organizational structures, and processes associated with student matriculation.\n  Offered on a satisfactory-fail basis only.",
    "credits": "2"
  },
  {
    "course_name": "NCORE Scholars:  Race and Ethnicity in the U.S",
    "dept": "U ST",
    "num": "321",
    "desc": "Prereq: Selection as an NCORE Student Scholar and attendance at NCORE.\nExploration of issues of race and ethnicity in the United States.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "McNair Senior Seminar I",
    "dept": "U ST",
    "num": "401",
    "desc": "Prereq: Intended for second year McNair participants\nComprehensive approach to choosing and applying to graduate school including drafting and finalizing the personal and research essay, understanding graduate funding, preparing for the grad interview, standardized exam preparation, and conversations with faculty and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "McNair Senior Seminar II",
    "dept": "U ST",
    "num": "402",
    "desc": "Prereq: U ST 401\nContinuation of graduate school preparation focusing on transitioning, navigating the critical first year, succeeding in graduate school through to the completion of the PhD, and conversations with faculty and graduate students.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "U ST",
    "num": "490",
    "desc": "Prereq: Permission of the associate provost for academic programs\nIndependent study on topics of an interdisciplinary nature. Intended primarily for juniors and seniors.\n",
    "credits": "arr"
  },
  {
    "course_name": "Urban Design Local Studio",
    "dept": "URB D",
    "num": "501",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission\nAnalysis and observation of urban morphology, culture, and infrastructure through urban design projects set in Midwestern cities. Students learn, interpret, and propose design interventions to address urban challenges related to changing socio-political, economic, and environmental contexts. Field trips.\n",
    "credits": "6"
  },
  {
    "course_name": "Urban Design Global Studio",
    "dept": "URB D",
    "num": "502",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission.\nStudents develop proposals for urban design interventions in an international context  at multiple scales using investigation, analysis, observation, and interaction. Field trips.\n",
    "credits": "6"
  },
  {
    "course_name": "North American Urbanization",
    "dept": "URB D",
    "num": "511",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission\nFocus on the historical role of planning and urban design in the shaping of North American cities and regions, from the colonial period to the late twentieth century. Examine the legacy of planning and design by exploring the intersection of geographic space, politics, and policy. Investigate the factors and the processes that produce the built environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Urban Design Colloquium",
    "dept": "URB D",
    "num": "512",
    "desc": "Prereq: enrollment in the Urban Design program\nSpecial topics and guest speakers.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Urbanism Research",
    "dept": "URB D",
    "num": "513",
    "desc": "Prereq: URB D 502\nResearch expands and integrates discourse and design findings from various Urban Design degree courses. Students develop independently-defined research to produce a comprehensive and conclusive final document that incorporates text, visuals and/or other media.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Urban Design",
    "dept": "URB D",
    "num": "521",
    "desc": "Prereq: Graduate standing, senior classification with instructor permission.\nIntroduction to the ways that urban designers think about the city with a focus on how history, theory, and a wide range of contextual factors inform urban design practice.  Field trip.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Urban Design Practices",
    "dept": "URB D",
    "num": "522",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission.\nStudy of emerging trends and practices in urban design using a range of current media communication platforms. Course will be conducted in a combination of lecture, seminar formats. Graduate level readings, discussions, research, and development of projective scenarios.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods of Urban Design Workshop",
    "dept": "URB D",
    "num": "531",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission.\nAn exploration of contemporary urban design methods derived from significant urban projects and (re)development initiatives. Selected case studies to articulate and evaluate methods for implementing urban design goals and objectives in a variety of urbanized contexts. Case studies will build on a combination of analytical research, lectures, student presentations, and field trips.\n",
    "credits": "3"
  },
  {
    "course_name": "Urban Design Media Workshop",
    "dept": "URB D",
    "num": "532",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission.\nAn introduction to visual representation tools and techniques for generating and communicating urban design concepts, processes, and analytics. Project and exercises utilize traditional and contemporary approaches to drawing, modeling, and mapping, as well as desktop publishing tools.\n",
    "credits": "3"
  },
  {
    "course_name": "Urbanism Theory and Methods",
    "dept": "URB D",
    "num": "533",
    "desc": "Prereq: Graduate standing or senior classification with instructor permission.\nThis course examines how socio-political and economic forces shape the contemporary built environment. The course highlights various methods urban designers use to affect change and, in turn, how these impact stakeholders and communities.  Students develop critical awareness of the impact of their decision making on the city.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to U.S. Latino/a Studies",
    "dept": "US LS",
    "num": "211",
    "desc": "\nHistory and current lives of the Latino/a peoples in the United States, including Mexican, Cuban, Puerto Rican, Dominican, and South and Central Americans, as well as information specific to Iowa Latino/as, will be covered. Through readings, class discussions, writing assignments, and guest speakers, students will acquire accurate information and a solid understanding of the US Latino/a population and cultural perspectives. Elements of Latino/a culture to be covered include historical, sociological, educational, psychological, economic, and political facets.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Latin American Anthropology",
    "dept": "US LS",
    "num": "323",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Violence and Memory",
    "dept": "US LS",
    "num": "323A",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Social movements and Democracy",
    "dept": "US LS",
    "num": "323B",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Race, Class and Gender",
    "dept": "US LS",
    "num": "323C",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Regional Focus",
    "dept": "US LS",
    "num": "323D",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Anthropology: Culture and Sport.",
    "dept": "US LS",
    "num": "323E",
    "desc": "Prereq: ANTHR 201 or ANTHR 306 recommended\nExploration of key contemporary and historical issues in Latin American Anthropology; discussion of current   anthropological approaches to studying Latin American social issues in a global context. Topics vary each time offered.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Religion and U.S. Latino/a Literature",
    "dept": "US LS",
    "num": "342",
    "desc": "\nA study of the religious behavior and attitudes expressed in the literature of Mexican Americans, Puerto Ricans, Cuban Americans and other groups of people living in the U.S. who trace their ancestry to the Spanish-speaking countries of Latin America.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Latin American Government and Politics",
    "dept": "US LS",
    "num": "343",
    "desc": "\nPolitical institutions, processes, and contemporary issues. Selected countries examined intensively to illustrate generalizations. Role of parties, military, church, human rights, women, environmental issues, interest groups, ideology, and globalization.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "U.S. Latino/a Psychology",
    "dept": "US LS",
    "num": "347",
    "desc": "Prereq: Two courses in Psychology including PSYCH 101\nHistorical, political, and social contexts of psychological and mental health constructs in terms of their validity and utility for use with Latino/a people in the U.S.  Unique aspects of psychological functioning particular to Latino/a people in the U.S.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Mexican American History",
    "dept": "US LS",
    "num": "371",
    "desc": "Prereq: 3 credits of 200-level HIST at Iowa State and sophomore classification.\nHistory of the Mexican American community in the U.S. from the 1820s to the present. Topics include community development, employment, social marginalization, racism/discrimination, depression and world wars, civil rights, ethnic power and politics.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Latina/o History",
    "dept": "US LS",
    "num": "372",
    "desc": "\nHistorical and cultural heritage of Latinas/os in the United States. The histories of Mexican, Puerto Rican, Cuban, and other Latin American peoples in the U.S. emphasizing political and cultural convergence and congruencies.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Bilingualism, Bilingual Education, and U.S. Mexican Youth",
    "dept": "US LS",
    "num": "420",
    "desc": "Prereq: EDUC 405 or EDUC 406\nIntroduction to research on bilingualism and examination of the social, historical, and political contexts of bilingual education in U.S. schools.  Attention to policy environment, school program structure, mode of classroom instruction, family and community context, and attainment of bilingualism and biculturalism for U.S. Mexican youth.\n",
    "credits": "3"
  },
  {
    "course_name": "Civil Rights and Ethnic Power",
    "dept": "US LS",
    "num": "473",
    "desc": "Prereq: Sophomore classification\nComparative history of the civil rights and ethnic power movements (African American, Chicano, American Indian, Puerto Rican, among others) in the U.S. from World War II to the present. Topics include institutional foundations, leadership, gender and racial dynamics, and the convergences and divergences of these differing ethnic struggles for rights.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "US LS",
    "num": "490",
    "desc": "Prereq: permission of instructor\nIndependent study under supervision of instructor.\n  No more than 3 credits may count towards the U.S. Latino/a Studies certificate.",
    "credits": "1"
  },
  {
    "course_name": "Shelter Medicine",
    "dept": "V C S",
    "num": "305",
    "desc": "Prereq: First year classification in Veterinary Medicine or with permission of instructor\nAn elective course designed to educate the veterinary student about issues of relevance to companion animal population and shelter medicine and welfare.\n",
    "credits": "1"
  },
  {
    "course_name": "Veterinarian in Society I",
    "dept": "V C S",
    "num": "311",
    "desc": "Prereq: First-year classification in veterinary medicine\nIntroduction to the veterinary profession and the various career opportunities available.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Veterinarian in Society III",
    "dept": "V C S",
    "num": "313",
    "desc": "Prereq: Second-year classification in veterinary medicine\nA continuation of the Veterinarian in Society series. The course covers selected topics on moral and ethical issues affecting the practice of veterinary medicine.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Veterinarian in Society IV",
    "dept": "V C S",
    "num": "314",
    "desc": "Prereq: Third-year classification in veterinary medicine\nA continuation of the Veterinarian in Society series. This course will focus on helping students develop their communication, leadership, team building and conflict resolution skills.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Veterinarian in Society V",
    "dept": "V C S",
    "num": "315",
    "desc": "Prereq: Third-year classification in veterinary medicine\nA continuation of the Veterinarian in Society series. This course will emphasize veterinary law.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Clinical Foundations I",
    "dept": "V C S",
    "num": "339",
    "desc": "Prereq: First-year classification in veterinary medicine\nCanine physical examination; basic behavior, animal handling and restraint; medical record keeping.\n",
    "credits": "1"
  },
  {
    "course_name": "Grand Rounds",
    "dept": "V C S",
    "num": "385",
    "desc": "Prereq: Classification in veterinary medicine\nSeminars and case presentations on selected clinical subjects by fourth-year students of the College of Veterinary Medicine. Attendance is required for a passing grade.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Clinical Imaging",
    "dept": "V C S",
    "num": "391",
    "desc": "Prereq: First-year classification in veterinary medicine\nEvaluation of morphologic anatomy of the dog and cat utilizing clinical imaging methods - radiography, ultrasonography, computed tomography, magnetic resonance imaging and nuclear imaging. Emphasis will be placed on normal radiographic anatomy.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles of Surgery",
    "dept": "V C S",
    "num": "393",
    "desc": "Prereq: Second year classification in veterinary medicine\nGeneral principles of surgery of companion animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Surgery Laboratory",
    "dept": "V C S",
    "num": "394",
    "desc": "Prereq: Second year classification in veterinary medicine\nGeneral principles of surgery of companion animals.\n",
    "credits": "1"
  },
  {
    "course_name": "Small Animal Surgery",
    "dept": "V C S",
    "num": "395",
    "desc": "Prereq: V C S 394\nSmall animal surgery.\n",
    "credits": "2"
  },
  {
    "course_name": "Fundamentals in Equine Practice",
    "dept": "V C S",
    "num": "396",
    "desc": "Prereq: V C S 394\nThis elective course is an introduction and overview of the clinical aspects of common conditions in horses and related conditions, including pathogenesis, clinical manifestations, diagnosis, treatment and prognosis.  It is not designed to teach the student how to perform specific procedures, but rather to improve knowledge base of students interested in equine or mixed animal practice. Class will include lecture, photos, video presentations, and other formats.\n",
    "credits": "2"
  },
  {
    "course_name": "Anesthesiology",
    "dept": "V C S",
    "num": "398",
    "desc": "Prereq: Second-year classification in veterinary medicine\nAnesthetic equipment, agents and procedures, including pain management for core species.\n",
    "credits": "2"
  },
  {
    "course_name": "Ophthalmology",
    "dept": "V C S",
    "num": "399",
    "desc": "Prereq: Third year classification in veterinary medicine\nPrinciples and techniques of medical and surgical ophthalmology.\n",
    "credits": "1"
  },
  {
    "course_name": "Clinical Cardiology I",
    "dept": "V C S",
    "num": "402",
    "desc": "Prereq: Third or fourth-year classification in veterinary medicine; V  CS 444 or concurrent enrollment in V C S 444\nElective course in diagnosis and management of cardiac diseases. Emphasis on interpretation of electrocardiography.\n",
    "credits": "1"
  },
  {
    "course_name": "Pet Bird and Exotic Species Medicine",
    "dept": "V C S",
    "num": "405",
    "desc": "Prereq: third classification in veterinary medicine\nElective course in management and diseases of pet birds and exotic species.\n",
    "credits": "2"
  },
  {
    "course_name": "Feline Internal Medicine",
    "dept": "V C S",
    "num": "407",
    "desc": "Prereq: Third-year classification in veterinary medicine\nElective course in feline internal medicine.\n",
    "credits": "1"
  },
  {
    "course_name": "Oncology",
    "dept": "V C S",
    "num": "409",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nElective clinical assignment in oncology.\n",
    "credits": "2"
  },
  {
    "course_name": "Companion Animal Nutrition",
    "dept": "V C S",
    "num": "414",
    "desc": "Prereq: Third or fourth -year classification in veterinary medicine\nElective course in small animal and equine nutrition.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Small Animal Dermatology",
    "dept": "V C S",
    "num": "415",
    "desc": "Prereq: Third or Fourth-year classification in veterinary medicine\nElective course in dermatology.\n",
    "credits": "2"
  },
  {
    "course_name": "Preceptorship in Companion Animal/Equine Veterinary Medical Practice",
    "dept": "V C S",
    "num": "419",
    "desc": "Prereq: Fourth-year classification in veterinary medicine, permission of department curriculum committee\nElective course in veterinary practice under the guidance of veterinarians in approved practice settings. Maximum of 6 credits in 2 credit increments.\n",
    "credits": "2"
  },
  {
    "course_name": "Preceptorship in Companion Animal/Equine Veterinary Medical Practice: Companion Animal Practice",
    "dept": "V C S",
    "num": "419A",
    "desc": "Prereq: Fourth-year classification in veterinary medicine, permission of department curriculum committee\nElective course in veterinary practice under the guidance of veterinarians in approved practice settings. Maximum of 6 credits in 2 credit increments.\n",
    "credits": "2"
  },
  {
    "course_name": "Preceptorship in Companion Animal/Equine Veterinary Medical Practice: Equine Practice",
    "dept": "V C S",
    "num": "419B",
    "desc": "Prereq: Fourth-year classification in veterinary medicine, permission of department curriculum committee\nElective course in veterinary practice under the guidance of veterinarians in approved practice settings. Maximum of 6 credits in 2 credit increments.\n",
    "credits": "2"
  },
  {
    "course_name": "Preceptorship in Companion Animal/Equine Veterinary Medical Practice: Zoo/Exotic Animal Practice",
    "dept": "V C S",
    "num": "419C",
    "desc": "Prereq: Fourth-year classification in veterinary medicine, permission of department curriculum committee\nElective course in veterinary practice under the guidance of veterinarians in approved practice settings. Maximum of 6 credits in 2 credit increments.\n",
    "credits": "2"
  },
  {
    "course_name": "Preceptorship in Companion Animal/Equine Veterinary Medical Practice: Other",
    "dept": "V C S",
    "num": "419D",
    "desc": "Prereq: Fourth-year classification in veterinary medicine, permission of instructor-of record/V C S Department Curriculum Committee\nElective course in veterinary practice under the guidance of veterinarians in approved practice settings. Maximum of 6 credits in 2 credit increments.\n",
    "credits": "2"
  },
  {
    "course_name": "Practicum",
    "dept": "V C S",
    "num": "420",
    "desc": "Prereq: VM4 classification, permission of instructor\nExternal practical experiences in the fourth year curriculum for additional professional development of the veterinary student.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "Rotation at Blank Park Zoo",
    "dept": "V C S",
    "num": "422",
    "desc": "Prereq: Fourth-year classification in veterinary medicine and completion of V C S 405.  Enrollment by permission of instructor.\nClinical experience in husbandry, nutrition and training of exotic animals in a zoo environment. Students will get instruction and learn the application of the clinical skills required when dealing with exotic animals, including the hands-off visual examination obtaining historical and clinical information from zookeepers, and the use of immobilization drugs for patient exams. Students will learn the common medical disorders of exotic species and treatment techniques.\n",
    "credits": "4"
  },
  {
    "course_name": "Small Animal Internal Medicine",
    "dept": "V C S",
    "num": "436",
    "desc": "Prereq: Third year classification in veterinary medicine\nClinical diagnosis and treatment of diseases of small animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Small Animal Shelter Medicine",
    "dept": "V C S",
    "num": "437",
    "desc": "Prereq: Fourth year classification in Veterinary Medicine\nA 2-week elective rotation at an animal shelter/humane society that works with the public to place pets in homes. This rotation will encompass population medicine (medicine, surgery, intake, adoption, behavior and temperament, neglect and cruelty) that animal shelters deal with on a daily basis. The selected animal shelter/humane society must have a veterinarian(s) on staff and be approved by the course coordinator. More than one VCS 437 may be taken upon approval of the course coordinator.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Clinics",
    "dept": "V C S",
    "num": "440",
    "desc": "Prereq: Third-year classification in veterinary medicine\nRotating assignments through multiple sections within the Veterinary Medical Center.\n",
    "credits": "R"
  },
  {
    "course_name": "Canine Rehabilitation",
    "dept": "V C S",
    "num": "441",
    "desc": "Prereq: Fourth-year classification in veterinary medicine.\nElective clinical assignment in rehabilitation.\n",
    "credits": "2"
  },
  {
    "course_name": "Equine Lameness",
    "dept": "V C S",
    "num": "443",
    "desc": "Prereq: Second or third-year classification in veterinary medicine\nOrthopedic diseases of the equine.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Medicine",
    "dept": "V C S",
    "num": "444",
    "desc": "Prereq: Third-year classification in veterinary medicine\nClinical diagnosis and treatment of diseases of small animals.\n",
    "credits": "4"
  },
  {
    "course_name": "Equine Medicine",
    "dept": "V C S",
    "num": "445",
    "desc": "Prereq: Third-year classification in veterinary medicine\nClinical diagnosis and treatment of diseases of equine.\n",
    "credits": "2"
  },
  {
    "course_name": "Clinical Neurology",
    "dept": "V C S",
    "num": "446",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical rotation in neurology with an emphasis on neurolocalization, disease processes, use of diagnostics in medical and surgical neurology and treatment options. Exposure to neurosurgical techniques.\n",
    "credits": "2"
  },
  {
    "course_name": "Equine Veterinary Diagnostic Skills",
    "dept": "V C S",
    "num": "447",
    "desc": "Prereq: Fourth-year classification in veterinary medicine - preference to equine track student.  Limited to 16 students.\nHands on experience with equine veterinary diagnostic skills related to theriogenology, medicine, surgery, radiology, and ophthalmology.\n",
    "credits": "2"
  },
  {
    "course_name": "Diagnostic Imaging and Radiobiology",
    "dept": "V C S",
    "num": "448",
    "desc": "Prereq: Third-year classification in veterinary medicine\nEssentials of diagnostic image interpretation. Essentials of radiobiology, radiation therapy and protection from radiation.\n",
    "credits": "3"
  },
  {
    "course_name": "Junior Surgery Laboratory",
    "dept": "V C S",
    "num": "449",
    "desc": "Prereq: Third-year classification in veterinary medicine\nPre-laboratory presentations and laboratories introduce the student to anesthetic and surgical principles and techniques that can be applied to all animal species.\n",
    "credits": "3"
  },
  {
    "course_name": "Junior Surgery Laboratory: Alternative Curriculum",
    "dept": "V C S",
    "num": "449A",
    "desc": "Prereq: Third-year classification in veterinary medicine\nThis laboratory introduces the student to anesthetic and surgical principles - and techniques that can be applied to all animal species. Consists of only neutering humane society animals throughout the laboratory.\n",
    "credits": "3"
  },
  {
    "course_name": "Junior Surgery Laboratory: Traditional Curriculum",
    "dept": "V C S",
    "num": "449B",
    "desc": "Prereq: Third-year classification in veterinary medicine\nThis laboratory introduces the student to anesthetic and surgical principles and techniques that can be applied to all animal species. Provides a broader range of surgical experiences throughout the laboratory.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Junior Surgery Laboratory",
    "dept": "V C S",
    "num": "451",
    "desc": "Prereq: V C S 449\n8 weeks. Continuation of surgical laboratory experience.  Techniques and advanced principles learned are applicable to all animal species.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Junior Surgery Laboratory: Alternative Curriculum",
    "dept": "V C S",
    "num": "451A",
    "desc": "Prereq: V C S 449\n8 weeks. Continuation of surgical laboratory experience.  Techniques and advanced principles learned are applicable to all animal species. Consists of only neutering humane society animals throughout the laboratory.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Junior Surgery Laboratory: Traditional Curriculum",
    "dept": "V C S",
    "num": "451B",
    "desc": "Prereq: V C S 449\n8 weeks. Continuation of surgical laboratory experience. Techniques and advanced principles learned are applicable to all animal species. Exposure to more advanced surgical techniques with most surgical principles.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Junior Surgery Laboratory: Traditional Curriculum",
    "dept": "V C S",
    "num": "451C",
    "desc": "Prereq: V C S 449\n8 weeks. Continuation of surgical laboratory experience. Techniques and advanced principles learned are applicable to all animal species. A second repeat for students with a special interest in small animal surgery.\n",
    "credits": "2"
  },
  {
    "course_name": "Clinical Dermatology",
    "dept": "V C S",
    "num": "452",
    "desc": "Prereq: Fourth-year classification in veterinary medicine.  Must have instructor permission to repeat this course.\nStudy of clinical dermatological problems via computer-aided instruction, case simulations, and/or lectures. Clinical management of cases presented to Veterinary Medical Center.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Medicine I",
    "dept": "V C S",
    "num": "453",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in small animal medicine.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Soft Tissue Surgery",
    "dept": "V C S",
    "num": "455",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in soft tissue surgery.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Orthopedic Surgery",
    "dept": "V C S",
    "num": "456",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in orthopedic surgery.\n",
    "credits": "2"
  },
  {
    "course_name": "Equine Medicine",
    "dept": "V C S",
    "num": "457",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in equine medicine.\n",
    "credits": "2"
  },
  {
    "course_name": "Equine Surgery",
    "dept": "V C S",
    "num": "458",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in equine surgery.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Overpopulation Medicine and Surgery",
    "dept": "V C S",
    "num": "459",
    "desc": "Prereq: Fourth year classification in Veterinary Medicine\nA 2-week surgical emphasis, elective rotation at a humane society that addresses the issues facing veterinarians and non-veterinary humane society personnel who deal with small animal overpopulation issues. Each section can be taken for credit once.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Overpopulation Medicine and Surgery :Nebraska Humane Society, Omaha NE",
    "dept": "V C S",
    "num": "459A",
    "desc": "Prereq: Fourth year classification in Veterinary Medicine\nA 2-week surgical emphasis, elective rotation at a humane society that addresses the issues facing veterinarians and non-veterinary humane society personnel who deal with small animal overpopulation issues. Each section can be taken for credit once.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Overpopulation Medicine and Surgery: Animal Rescue League of Iowa, Des Moines IA",
    "dept": "V C S",
    "num": "459B",
    "desc": "Prereq: Fourth year classification in Veterinary Medicine\nA 2-week surgical emphasis, elective rotation at a humane society that addresses the issues facing veterinarians and non-veterinary humane society personnel who deal with small animal overpopulation issues. Each section can be taken for credit once.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Overpopulation Medicine and Surgery: WaySide Waifs, Kansas City MO",
    "dept": "V C S",
    "num": "459C",
    "desc": "Prereq: Fourth year classification in Veterinary Medicine\nA 2-week surgical emphasis, elective rotation at a humane society that addresses the issues facing veterinarians and non-veterinary humane society personnel who deal with small animal overpopulation issues. Each section can be taken for credit once.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Overpopulation Medicine and Surgery: Boulder Humane Society, Boulder, CO",
    "dept": "V C S",
    "num": "459D",
    "desc": "Prereq: Fourth year classification in Veterinary Medicine\nA 2-week surgical emphasis, elective rotation at a humane society that addresses the issues facing veterinarians and non-veterinary humane society personnel who deal with small animal overpopulation issues. Each section can be taken for credit once.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Overpopulation Medicine and Surgery: ASPCA Spay/Neuter Alliance, Ashville, NC",
    "dept": "V C S",
    "num": "459E",
    "desc": "Prereq: Fourth year classification in Veterinary Medicine\nA 2-week surgical emphasis, elective rotation at a humane society that addresses the issues facing veterinarians and non-veterinary humane society personnel who deal with small animal overpopulation issues. Each section can be taken for credit once.\n",
    "credits": "2"
  },
  {
    "course_name": "Radiology",
    "dept": "V C S",
    "num": "460",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in veterinary radiology.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Small Animal Internal Medicine",
    "dept": "V C S",
    "num": "461",
    "desc": "Prereq: V C S 444 and V C S 436\nA discussion of advanced topics in small animal internal medicine.\n",
    "credits": "1"
  },
  {
    "course_name": "Primary Care",
    "dept": "V C S",
    "num": "463",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical experience in hospital based general practice.\n",
    "credits": "2"
  },
  {
    "course_name": "Equine Field Services",
    "dept": "V C S",
    "num": "464",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in equine ambulatory practice.\n",
    "credits": "2"
  },
  {
    "course_name": "Farrier",
    "dept": "V C S",
    "num": "465",
    "desc": "Prereq: Fourth-year classification in veterinary medicine.\nElective clinical assignment on the principles and practices of normal and therapeutic horseshoeing and equine foot care.\n",
    "credits": "2"
  },
  {
    "course_name": "Anesthesiology",
    "dept": "V C S",
    "num": "466",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in small animal and large animal anesthesiology.\n",
    "credits": "2"
  },
  {
    "course_name": "Pain Management",
    "dept": "V C S",
    "num": "467",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nElective clinical assignment with emphasis on pain management.\n",
    "credits": "1"
  },
  {
    "course_name": "Intensive Care",
    "dept": "V C S",
    "num": "468",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment to provide supervision of hospital cases requiring intensive care and including emergency cases.\n",
    "credits": "4"
  },
  {
    "course_name": "Ophthalmology",
    "dept": "V C S",
    "num": "469",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment in ophthalmology.\n",
    "credits": "2"
  },
  {
    "course_name": "Radiology",
    "dept": "V C S",
    "num": "470",
    "desc": "Prereq: Fourth-year classification in veterinary medicine. Completion of V C S 460 Radiology is required.  Enrollment by permission of instructor.\nElective clinical assignment in veterinary radiology.\n",
    "credits": "2"
  },
  {
    "course_name": "Animal Reproduction",
    "dept": "V C S",
    "num": "471",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nElective clinical assignment in animal reproduction. Equine, Small Animal, Comparative, and Food Animal reproduction only.\n",
    "credits": "2"
  },
  {
    "course_name": "Animal Reproduction: Comparative",
    "dept": "V C S",
    "num": "471C",
    "desc": "Prereq: Fourth-year classification in veterinary medicine.\nElective comparative clinical assignment in Theriogenology with caseload management in Food Animal, Equine, Small Animal and Small Ruminants sections. Rotation through these different sections will depend on the caseload (by species)and include routine breeding management, semen collection and cryopreservation in different species, advanced laparoscopic and non-surgical procedures for insemination and embryo flushing/transfer, pregnancy diagnosis as well as management of reproductive emergencies.\n",
    "credits": "2"
  },
  {
    "course_name": "Animal Reproduction: Equine Reproduction",
    "dept": "V C S",
    "num": "471E",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nElective clinical assignment in Equine Theriogenology involving both mare and stallion breeding management, cool-shipped semen preparation and semen cryopreservation, embryo transfer, foaling of high-risk pregnant mares as well as normal mares, breeding soundness exams of the mare and stallion, treatment of retained fetal membranes and neonatal care.\n",
    "credits": "2"
  },
  {
    "course_name": "Animal Reproduction: Small Animal Reproduction",
    "dept": "V C S",
    "num": "471S",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nElective clinical assignment in Small Animal Theriogenology. Primary reproductive management in the canine involving breeding management of the bitch and stud dog, advanced surgical and non-surgical insemination using fresh or frozen semen, infertility case management for the male and female. High risk pregnancy management, whelping and neonatal care case management as required.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Surgery",
    "dept": "V C S",
    "num": "473",
    "desc": "Prereq: fourth-year classification in veterinary medicine\nClinical assignment in small animal surgery split between soft tissue surgery (one week) and  orthopedic surgery (one week).\n",
    "credits": "1"
  },
  {
    "course_name": "Small Animal Surgery: Orthopedic",
    "dept": "V C S",
    "num": "473O",
    "desc": "Prereq: fourth-year classification in veterinary medicine\nClinical assignment in small animal surgery split between soft tissue surgery (one week) and  orthopedic surgery (one week).\n",
    "credits": "1"
  },
  {
    "course_name": "Small Animal Surgery: Soft Tissue",
    "dept": "V C S",
    "num": "473S",
    "desc": "Prereq: fourth-year classification in veterinary medicine\nClinical assignment in small animal surgery split between soft tissue surgery (one week) and  orthopedic surgery (one week).\n",
    "credits": "1"
  },
  {
    "course_name": "Cardiology Rotation",
    "dept": "V C S",
    "num": "475",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nElective clinical assignment in cardiology.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Anesthesiology",
    "dept": "V C S",
    "num": "476",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nAssignments in equine, small animal, and large animal anesthesiology. Experience includes case work-up, management and recovery. Understanding of the unique physiology and potential complications of anesthetized patients. Pharmacology of commonly used drugs. Specific protocols and management for both field and general anesthesia.\n",
    "credits": "2"
  },
  {
    "course_name": "Equine Anesthesiology",
    "dept": "V C S",
    "num": "476E",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nAssignments in equine, small animal, and large animal anesthesiology. Experience includes case work-up, management and recovery. Understanding of the unique physiology and potential complications of anesthetized patients. Pharmacology of commonly used drugs. Specific protocols and management for both field and general anesthesia.\n",
    "credits": "2"
  },
  {
    "course_name": "Small Animal Anesthesiology",
    "dept": "V C S",
    "num": "476S",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nAssignments in equine, small animal, and large animal anesthesiology. Experience includes case work-up, management and recovery. Understanding of the unique physiology and potential complications of anesthetized patients. Pharmacology of commonly used drugs. Specific protocols and management for both field and general anesthesia.\n",
    "credits": "2"
  },
  {
    "course_name": "Intensive and Critical Care",
    "dept": "V C S",
    "num": "478",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nElective clinical assignment in intensive care.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Dentistry",
    "dept": "V C S",
    "num": "480",
    "desc": "Prereq: Third or Fourth-year classification in veterinary medicine\nAll aspects of veterinary dentistry, prophylaxis, endodontics, and orthodontics.  This course is an on-line course.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Equine Dentistry",
    "dept": "V C S",
    "num": "481",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nClinical rotation in equine dentistry with an emphasis on routine equine dental examinations, specialized equipment, and corrective procedures. Offered only offered for one 2-week rotation.  Enrollment is limited.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Dentistry and Oral Surgery Rotation",
    "dept": "V C S",
    "num": "482",
    "desc": "Prereq: Enrollment in 4th year of the veterinary curriculum; completion of primary care rotation or familiar with the Primary Care protocol; proof of rabies prophylaxis and a protective titer.\nBasic principles of veterinary dentistry and oral surgery.  Participation in dental cleaning and scaling of the teeth in the oral cavity; positioning and interpretation of dental radiographs; administration of regional anesthesia; and patient care and animal handling, including instructions of dental procedures and dental home care.  Opportunities may be available to practice oral surgery, extraction techniques and radiographic positioning on cadaver specimens. Interaction with clients during procedures and appointments. Opportunities to observe and assist with advanced dentistry and oral surgery procedures as the need arises. Experience in primary care rotation responsibilities.\n",
    "credits": "2"
  },
  {
    "course_name": "Independent Study",
    "dept": "V C S",
    "num": "490",
    "desc": "Prereq: Permission of Course Instructor-of-Record and Sponsoring VCS Faculty Member.\nIndependent Study in veterinary medicine focusing on basic / translational research or learning issues. Enrollment in this course is not appropriate for clinical experiences in the Veterinary Medical Center or extramural experiences in clinical veterinary practice (i.e., preceptorships).\n",
    "credits": "arr"
  },
  {
    "course_name": "Orientation for International Experience",
    "dept": "V C S",
    "num": "492",
    "desc": "Prereq: Classification in veterinary medicine\n8 weeks.  Predeparture orientation for group study abroad. Cultural considerations for the study abroad experience and a conversational language introduction. Out of class work may be assigned.\n",
    "credits": "1"
  },
  {
    "course_name": "Grand Rounds Presentations",
    "dept": "V C S",
    "num": "495",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nSeminars and case presentations on selected subjects by fourth year students of the College of Veterinary Medicine. Completion of a seminar presentation is required for graduation.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "International Preceptorship",
    "dept": "V C S",
    "num": "496",
    "desc": "Prereq: Classification in veterinary medicine.  Permission of Course Instructor-of-record and sponsoring VCS Faculty\nInternational Preceptorships and Study Abroad Group programs. Provides opportunities for students to be involved in applied clinical, production, and/or research experiences in international locations. The course consists of 40 hour per week experiential learning opportunities.\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics",
    "dept": "V C S",
    "num": "590",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Medicine",
    "dept": "V C S",
    "num": "590A",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Surgery",
    "dept": "V C S",
    "num": "590B",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Theriogenology",
    "dept": "V C S",
    "num": "590C",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Radiology",
    "dept": "V C S",
    "num": "590D",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Anesthesiology",
    "dept": "V C S",
    "num": "590E",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics - Ophthalmology",
    "dept": "V C S",
    "num": "590F",
    "desc": "\nSpecial topics in Ophthalmology.\n",
    "credits": "1"
  },
  {
    "course_name": "International Preceptorship",
    "dept": "V C S",
    "num": "596",
    "desc": "Prereq: Admission to graduate college\nInternational Preceptorships and Study Abroad Group programs. Provides opportunities for students to be involved in applied clinical, production, and/or research experiences in international locations. The course consists of 40 hour per week experiential learning opportunities.\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "V C S",
    "num": "599",
    "desc": "Prereq: Enrollment in nonthesis master's degree program\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar",
    "dept": "V C S",
    "num": "604",
    "desc": "\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Radiology",
    "dept": "V C S",
    "num": "640",
    "desc": "Prereq: V C S 448\nDetailed principles of clinical radiology with particular reference to radiographic interpretation.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced General Surgery",
    "dept": "V C S",
    "num": "671",
    "desc": "Prereq: Permission of instructor\nCourse designed to discuss and perform advanced surgical procedures in soft tissue, orthopedic and neurological surgery.  Minimally invasive surgical procedures and organ transplantation will be included.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Special Surgery",
    "dept": "V C S",
    "num": "672",
    "desc": "Prereq: Permission of instructor\nInnovative techniques in microvascular, thoracic, gastrointestinal, neurological and reconstructive surgery will be investigated.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Medicine",
    "dept": "V C S",
    "num": "676",
    "desc": "Prereq: V C S 445\nPrinciples of general medicine. A study in depth of factors that contribute to the development of clinical signs as related to the pathogenesis of disease.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Medicine",
    "dept": "V C S",
    "num": "677",
    "desc": "Prereq: V C S 445\nAn advanced study of metabolic diseases.\n",
    "credits": "2"
  },
  {
    "course_name": "Research",
    "dept": "V C S",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Medicine",
    "dept": "V C S",
    "num": "699A",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Surgery",
    "dept": "V C S",
    "num": "699B",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Theriogenology",
    "dept": "V C S",
    "num": "699C",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Anesthesiology",
    "dept": "V C S",
    "num": "699E",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Ophthalmology",
    "dept": "V C S",
    "num": "699F",
    "desc": "\nGraduate Level Research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Cardiology",
    "dept": "V C S",
    "num": "699G",
    "desc": "\nGraduate Level Research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Spanish for Veterinarians",
    "dept": "VDPAM",
    "num": "308",
    "desc": "Prereq: Classification in veterinary medicine and basic knowledge of Spanish\nThis course is designed to meet the needs of veterinary students who will practice in an environment in which the use of Spanish for accurate client communication is essential which includes much of our food animal industry in the state of Iowa.  This is not a traditional Spanish language course. To be successful, students taking the course should have a basic knowledge of Spanish pronunciation, grammar and syntax.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Production Animal Informatics",
    "dept": "VDPAM",
    "num": "309",
    "desc": "Prereq: Classification in veterinary medicine\nThe fundamentals of how clinical, diagnostic, production and financial information is obtained and used by production animal operations will be presented.  Students will acquire skills to create and use spreadsheets for manipulating and summarizing data.  They will also acquire knowledge of where to find inexpensive and readily available resources with information on how to use spreadsheets and other software.  Students will also have the opportunity to work with record keeping programs used by swine, beef and dairy operations.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Production Medicine",
    "dept": "VDPAM",
    "num": "310",
    "desc": "Prereq: Second or third year classification in veterinary medicine or permission of instructor\nThe role of the veterinarian in the management of animal health and production in populations including evaluation tools in dairy and beef cattle herds, beef feedlots and swine herds will be described.  Provides veterinary students with a starting point to understand the principles and techniques that are the basis of food-animal population health diagnosis management programs. Course available on-line, attendance is not required.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Animal Welfare",
    "dept": "VDPAM",
    "num": "312",
    "desc": "Prereq: First-year classification in veterinary medicine\nA continuation of the Veterinarian in Society series. The objective of this course is to develop knowledge of the fundamental principles of animal welfare, in terms of science, ethics and cultural components.\n",
    "credits": "1"
  },
  {
    "course_name": "Clinical Foundations",
    "dept": "VDPAM",
    "num": "340",
    "desc": "Prereq: Classification in veterinary medicine\nOne week course at Iowa State University; introduction to food supply veterinary medicine covering overviews of major animal agriculture species (beef, dairy, pork, sheep and camelid), production systems, behavior, welfare, handling and restraint, examination techniques, biosecurity, epidemiology and food safety. Visits to production units are utilized to introduce the application of clinical skills. Biosecurity: All students must follow current college policies regarding animal contact following foreign travel. Required equipment includes coveralls and rubber boots.\n",
    "credits": "1"
  },
  {
    "course_name": "Bovine Embryo Transfer and Related Technology",
    "dept": "VDPAM",
    "num": "351",
    "desc": "Prereq: Second or third year classification in veterinary medicine\nThis course will meet for two hours once each week of the Spring Semester. The first hour will be traditional lecture and the second hour will be a combination of student projects, labs and demonstrations of applied clinical procedures. Bovine embryo transfer and closely related topics such as: female reproductive physiology, estrus synchronization, semen sexing and reproductive disease will be emphasized. In addition, several class periods will be devoted to the use of ultrasound for diagnosis of reproductive and non-reproductive conditions.\n",
    "credits": "2"
  },
  {
    "course_name": "Animal Welfare Judging and Assessment",
    "dept": "VDPAM",
    "num": "365",
    "desc": "\nPreparation for competition in the Intercollegiate Animal Welfare Judging Contest. Development of critical appraisal and oral communication skills in regard to animal welfare. Animal behavior, physiology, health and performance parameters, basic husbandry, housing and preventive care will be explored for select farmed, companion and exotic species. Optional field trips.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Dairy Production Informatics",
    "dept": "VDPAM",
    "num": "402",
    "desc": "Prereq: VDPAM 309 or permission of instructor\nAdvanced coverage of concepts related to collection, manipulation, analysis and reporting of information used by dairy farms and their consultants. Hands on experience with Dairy Comp 305 and PCDart as well as other dairy management and information software.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Dairy Production Informatics: Lecture Series",
    "dept": "VDPAM",
    "num": "402A",
    "desc": "Prereq: Classification in veterinary medicine\nAdvanced coverage of concepts related to collection, manipulation, analysis and reporting of information used by dairy farms and their consultants. Hands on experience with Dairy Comp 305 and PCDart as well as other dairy management and information software.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Dairy Production Informatics: Experience I",
    "dept": "VDPAM",
    "num": "402B",
    "desc": "Prereq: VDPAM 402A\nIndependent records analysis and reporting of information used by dairy farms and their consultants. Hands on experience with Dairy Comp 305 and PCDart.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Dairy Production Informatics: Experience II",
    "dept": "VDPAM",
    "num": "402C",
    "desc": "Prereq: VDPAM 402A, VDPAM 402B\nIndependent records analysis and reporting of information used by dairy farms and their consultants. Hands on experience with Dairy Comp 305 and PCDart.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Dairy Production Informatics: Experience III",
    "dept": "VDPAM",
    "num": "402D",
    "desc": "Prereq: VDPAM 402A, VDPAM 402B, VDPAM 402C\nIndependent records analysis and reporting of information used by dairy farms and their consultants. Hands on experience with Dairy Comp 305 and PCDart.\n",
    "credits": "2"
  },
  {
    "course_name": "Evidence Based Clinical Decision Making",
    "dept": "VDPAM",
    "num": "407",
    "desc": "Prereq: Permission of instructor\nDiscussion, lectures and laboratories to assess the quality and significance of medical evidence in making informed decisions about the treatment of individual animals and animal populations.\n",
    "credits": "1"
  },
  {
    "course_name": "Poultry  Diseases",
    "dept": "VDPAM",
    "num": "408",
    "desc": "Prereq: Second or third year classification in veterinary medicine or permission of instructor\nBacterial, viral, parasitic, and nutritional diseases of domestic poultry and gamebirds; biosecurity, immunization, and management procedures to prevent poultry diseases. This course includes wet labs.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Practice Management and Organization",
    "dept": "VDPAM",
    "num": "409",
    "desc": "Prereq: Classiﬁcation in veterinary medicine\nAn A to Z introduction to proven veterinary practice management methods and strategies. The student will follow a detailed hands-on workbook describing most of the processes and procedures of day to day veterinary practice. Class content will be deliver via online modules.\n",
    "credits": "2"
  },
  {
    "course_name": "Llama Medicine",
    "dept": "VDPAM",
    "num": "410",
    "desc": "Prereq: Second or third year classification in veterinary medicine\nIntroduction to basic camelid medicine, including anatomy, behavior, restraint, handling, husbandry, herd health, common diseases, surgical conditions, and anesthesia protocols.\n",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Practice Entrepreneurship",
    "dept": "VDPAM",
    "num": "414",
    "desc": "Prereq: Classification in veterinary medicine\nFormal exposure to the entrepreneurial and business skills necessary to own and operate a successful veterinary practice or other small business opportunity. Personal finance, marketing, human resource management, general accounting, site assessment, location demographics, practice valuation, and a host of other issues which must be considered when purchasing or starting a new business are covered.  Class instruction will be delivered by successful practice and business owners with examples from real world experience.\n",
    "credits": "2"
  },
  {
    "course_name": "Bovine Reproduction Evaluation Laboratory",
    "dept": "VDPAM",
    "num": "416",
    "desc": "Prereq: Third year classification in veterinary medicine. 10 students per section.\nBovine rectal palpation techniques will be repetitively taught in 7 four- hour sessions. Students will also  learn techniques of epidural anesthesia, artificial  insemination,  pregnancy staging and ultrasonic imaging. University-owned cattle will be used.  No Wednesday section in Spring semester. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Swine Production Informatics",
    "dept": "VDPAM",
    "num": "419",
    "desc": "Prereq: VDPAM 309 or permission of instructor\nAdvanced coverage of concepts related to collection, manipulation, analysis and reporting of information used by swine production companies. A quick review of modern swine production and measures of productivity ensures students have a firm base for applying the informatics.  This course introduces students to two of the most commonly used swine record keeping systems in the industry and gives them access to actual production data to work with.  Students then learn how to generate and interpret regularly used reports and will use pivot tables and budgeting models in Excel®.  Importance of data entry and validation and how to transform data into useful knowledge are then addressed.  Fundamentals of financial information, cost-benefit analysis and using budgeting models to assess the economics of animal health interventions are then applied.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Production Animal Medicine Preceptorship",
    "dept": "VDPAM",
    "num": "420",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nAdvanced course in production animal medicine with emphasis on government, industry or veterinary practice settings. Requires 40 hours clinical experience per week. Assignments will be preceptorships with a practicing veterinarian, governmental agency and/or production unit. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Production Animal Medicine Preceptorship: Mixed Animal Practice with Food Animal Emphasis",
    "dept": "VDPAM",
    "num": "420A",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nAdvanced course in mixed animal production medicine with a food animal emphasis in veterinary practice settings. Requires 40 hours of clinical experience per week. Assignments will be preceptorships with a practicing veterinarian, governmental agency and/or production unit. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Production Animal Medicine Preceptorship: General Mixed Animal Practice",
    "dept": "VDPAM",
    "num": "420B",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nAdvanced course in production animal medicine with an emphasis on general mixed animal veterinary practice settings. Requires forty hours clinical experience per week. Assignments will be preceptorships with a practicing veterinarian, governmental agency and/or production unit. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Applied Production Animal Medicine Preceptorship: Government Agency or Food Processing Company",
    "dept": "VDPAM",
    "num": "420C",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nAdvanced course in production animal medicine with emphasis on government agency or food processing company in veterinary practice settings. Forty hours clinical experience per week. Assignments will be preceptorships with a governmental agency and/or production unit. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center",
    "dept": "VDPAM",
    "num": "421",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThe Great Plains Veterinary Education Center (GPVEC), located on the US Meat Animal Research Center (USMARAC) near Clay Center, Nebraska offers one week clinical training in production animal medicine species. All sections will be held at GPVEC. Students need to provide their own transportation to the site and overnight stays at or near GPVEC are required.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Calving",
    "dept": "VDPAM",
    "num": "421A",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThe Calving Elective provides an opportunity to expand knowledge and experience in all phases of calving management. The program is structured around normal calving operations at USMARC including night calving. Activities that take place during the Calving Elective including the diagnosis, treatment, and management of many commonly encountered conditions in the dam and calf, necropsies, and daily discussions.  Participation in a caesarian section is not guaranteed.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Bull Breeding Soundness",
    "dept": "VDPAM",
    "num": "421B",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThe Bull Breeding Soundness Examination Elective involves training in all phases of the bull fertility examination as recommended by the Society for Theriogenology.  Chuteside, hand-on experience is the primary training technique for this elective with informal discussions held during the performance of breeding soundness examinations on 350 or more bulls.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Feedlot Management",
    "dept": "VDPAM",
    "num": "421D",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nEvaluation of production techniques and production efficiency including ration and feeding management, health management program development and evaluation, environmental management, quality assurance, feedlot necropsy and microbiology techniques, and break even analysis. Approaches to solve seasonal health problems within the management objectives for different feed yards are the strong emphasis of this elective. Students may have the opportunity to follow cattle to a packing plant to learn the methods for tracking animals into the food chain, identifying production problems that are not diagnosable at the feedlot level, and monitoring beef quality assurance. Biosecurity activities will be emphasized and practiced.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Weaning Management",
    "dept": "VDPAM",
    "num": "421E",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThis is a hands-on elective in which students participate in the weaning management at the USMARC.  Students will be involved with processing, feeding, finding, and treating sick calves. Additionally, students will be introduced to developing weaning rations and managing feed delivery. Students will also learn how to develop vaccination and treatment protocols and each student will have as an objective the development of their own vaccination and treatment protocol template. As time allows, students will visit commercial feed yards and cover production management topics.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Pregnancy Examination",
    "dept": "VDPAM",
    "num": "421F",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThe Pregnancy Examination Elective involves rectal examinations for pregnancy, chuteside data collection and data entry into the CowCalf5 computer software program to evaluate the reproductive performance of the herd. This elective is designed for students who have some palpation experience and are interested in honing their skills. Pregnancy Examination occurs during yearly fall herd work at the USMARC, therefore, speed and accuracy will be stressed, rather than basic technique.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Lambing",
    "dept": "VDPAM",
    "num": "421J",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThe Lambing Elective involves students working with the USMARC lambing crew and GPVEC faculty in observations, assistance with delivery when necessary, and routine lambing duties. Students will work with veterinary personnel in sheep necropsy and health surveillance. Self-study material will be provided covering topics such as pre-breeding and breeding, pregnancy diagnosis, pregnant ewe management, pre- lambing ewe/lambing management, feeder lamb health and nutrition management, and replacement ewe and ram management.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Equine Dentistry",
    "dept": "VDPAM",
    "num": "421K",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site\nThe Equine Dentistry Elective provides the opportunity for students to expand their knowledge and experience related to equine dentistry. The rotation consists of lectures on topics relevant to equine dental care and hands-on laboratories during which students practice routine dental care procedures on USMARC horses. Equine Dentistry will involve both lecture and lab time at about equal shares.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Gomer Bull Surgery",
    "dept": "VDPAM",
    "num": "421P",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThe Gomer Bull Surgery Elective is designed to give students interested in food animal surgery an opportunity to practice their surgical skills by performing penile translocations and epididymectomies on USMARC teaser bull candidates. Lectures specific to gomer bull surgery as well as other topics related to food animal surgery will be presented during this elective.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Swine Husbandry",
    "dept": "VDPAM",
    "num": "421Q",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThis elective provides students the opportunity to gain hands-on experience related to the daily activities of an intensively managed confinement swine unit.   Rotation participants will work closely with USMARC Swine Unit personnel as they complete their daily routines in the farrowing and breeding areas of the USMARC Swine Unit and will participate in piglet delivery, neonatal pig processing, artificial and natural breeding, necropsies, and other activities as they arise.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Sheep Weaning Management",
    "dept": "VDPAM",
    "num": "421R",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThis elective provides the opportunity for students to develop their skills in the area of health and nutritional management of sheep immediately before and after weaning.   The rotation consists of lectures on pre- and post-weaning nutrition, clinical parasitology, and prevention and control of common ovine infectious diseases.  Hands-on experience during the week will take place at the USMARC Sheep Unit and will consist of walk-through and hand-on examinations of recently weaned lambs, treatment of sick lambs, inspection of weaning pen environment, investigation of herd outbreaks, and post mortem examination of all sheep mortalities.\n",
    "credits": "1"
  },
  {
    "course_name": "Great Plains Veterinary Educational Center: Ultrasound Pregnancy Examination",
    "dept": "VDPAM",
    "num": "421S",
    "desc": "Prereq: Fourth year classification in veterinary medicine; ability to provide own transportation to each site.\nThe Ultrasound Pregnancy Examination Elective involves transrectal ultrasonographic examinations for pregnancy, chuteside data collection and data entry into the CowCalf5 computer software program to evaluate the reproductive performance of the herd. This elective is designed for students who have some ultrasound experience and are interested in honing their skills. This elective occurs during yearly fall herd work at the USMARC, therefore, speed and accuracy will be stressed, rather than basic technique. Didactic instruction may include several topics in cow herd health, nutrition, management and reproductive decision making.\n",
    "credits": "1"
  },
  {
    "course_name": "Beef Cattle Calving",
    "dept": "VDPAM",
    "num": "422",
    "desc": "Prereq: VDPAM 310; fourth year classification in veterinary medicine\nThis elective provides students opportunity to assist cow-calf operations with calving in Nebraska, South Dakota or other locations. These operations typically calve 300-1,000 head each spring. Calving experience is not required, but a good understanding of working around cattle is necessary. Students will be actively participating in the day to day, normal calving routine including detecting and sorting off “springers”, calf “watch”, detecting when intervention is needed and assisting delivery, caring for and monitoring newborns and dams for good health and early disease detection, tagging/processing new calves, treating calves needing intervention and performing other routine calving chores. Students need to provide their own transportation to the site and overnight stays at or near the production sites are required. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Toxicology",
    "dept": "VDPAM",
    "num": "426",
    "desc": "Prereq: Third year classification in veterinary medicine\nStudy of toxicological diseases of animals emphasizing clinical recognition, circumstances of poisoning, differential diagnosis with clinical and laboratory data, therapeutic procedures, preventive management and public health implications. Supplemented with case-based materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Epidemiology and Population Health",
    "dept": "VDPAM",
    "num": "428",
    "desc": "\nEpidemiology of disease in populations. Disease causality, observational study design and approaches to epidemiologic investigations. This course is available on campus and by distance.\n",
    "credits": "3"
  },
  {
    "course_name": "Beef Records Analysis",
    "dept": "VDPAM",
    "num": "436",
    "desc": "Prereq: First, second or third year classification in veterinary medicine, or permission of instructor\nLectures will emphasize current production and evaluation techniques for beef cow/calf operations and students will learn to conduct and critically assess production and financial data using a standardized approach.  Lab activities will allow students an opportunity to work with individual beef cattle producers to identify areas for improving profitability, health, and sustainability.  Each semester's content builds on the material from the previous semester. Enrolling in the class for multiple semesters will be encouraged.\n",
    "credits": "1"
  },
  {
    "course_name": "Beef Records Analysis: Introduction",
    "dept": "VDPAM",
    "num": "436A",
    "desc": "Prereq: First, second or third year classification in veterinary medicine, or special permission of instructor\nLectures will emphasize current production and evaluation techniques for beef cow/calf operations and students will learn to conduct and critically assess production and financial data using a standardized approach.  Lab activities will allow students an opportunity to work with individual beef cattle producers to identify areas for improving profitability, health, and sustainability.\n",
    "credits": "1"
  },
  {
    "course_name": "Beef Records Analysis: Herd Management",
    "dept": "VDPAM",
    "num": "436B",
    "desc": "Prereq: First, second or third year classification in veterinary medicine, or special permission of instructor, VDPAM 436A\nLectures will emphasize current production and evaluation techniques for beef cow/calf operations and students will learn to conduct and critically assess production and financial data using a standardized approach.  Lab activities will allow students an opportunity to work with individual beef cattle producers to identify areas for improving profitability, health, and sustainability.\n",
    "credits": "1"
  },
  {
    "course_name": "Beef Records Analysis: Cow/Calf Preventive Medicine",
    "dept": "VDPAM",
    "num": "436C",
    "desc": "Prereq: Second or third year classification in veterinary medicine, or special permission of instructor, VDPAM 436A, VDPAM 436B\nLectures will emphasize current production and evaluation techniques for beef cow/calf operations and students will learn to conduct and critically assess production and financial data using a standardized approach.  Lab activities will allow students an opportunity to work with individual beef cattle producers to identify areas for improving profitability, health, and sustainability.\n",
    "credits": "1"
  },
  {
    "course_name": "Beef Records Analysis: Feedlot Production Medicine",
    "dept": "VDPAM",
    "num": "436D",
    "desc": "Prereq: Second or third year classification in veterinary medicine, or special permission of instructor, VDPAM 436A, VDPAM 436B, VDPAM 436C\nLectures will emphasize current production and evaluation techniques for feedlot production and students will develop a standard treatment protocol book. Topics include respiratory disease, receiving programs, nutrition, cattle handling and environmental issues.\n",
    "credits": "1"
  },
  {
    "course_name": "Production Animal Clinical Medicine",
    "dept": "VDPAM",
    "num": "445",
    "desc": "Prereq: Third year classification in veterinary medicine\nClinical diagnosis and treatment of diseases of swine, beef and dairy cattle, and small ruminants.\n",
    "credits": "3"
  },
  {
    "course_name": "Disturbances of Reproduction",
    "dept": "VDPAM",
    "num": "450",
    "desc": "Prereq: Third year classification in veterinary medicine\nGeneral principles of normal reproductive functions in addition to environment, management and diseases causing disturbances in reproduction. Cattle, Swine, Equine, Small Ruminant, and Small Animal species will be covered.\n",
    "credits": "4"
  },
  {
    "course_name": "Clinical Embryo Transfer",
    "dept": "VDPAM",
    "num": "451",
    "desc": "Prereq: VDPAM 351; Fourth year classification in veterinary medicine\nElective clinical assignment in techniques of embryo transfer. Primary species studied will be bovine but equine and small ruminant embryo transfer will be covered during discussions. Enrollment is limited to four students per two week session. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Diagnostic Laboratory Practicum",
    "dept": "VDPAM",
    "num": "455",
    "desc": "Prereq: VDPAM 310; Fourth year classification in veterinary medicine\nPractical experience and training in necropsy, recognition of gross lesions, diagnostic sample collection and test selection for the diagnosis of infectious, toxic, nutritional and metabolic diseases through exposure to diagnostic cases submitted to the ISU Veterinary Diagnostic Laboratory. The VDL accepts cases from all species; however, this course predominantly consists of porcine and bovine cases.\n",
    "credits": "1"
  },
  {
    "course_name": "Veterinary Diagnostic Lab Methods & Applications",
    "dept": "VDPAM",
    "num": "456",
    "desc": "Prereq: Second or third year classification in veterinary medicine\nStrengths and weaknesses of various testing technologies, how to choose appropriate tests and technologies, sampling strategies in diseased and non-diseased populations and interpretation and integration of results of tests to achieve an accurate diagnosis are discussed.\n",
    "credits": "1"
  },
  {
    "course_name": "Feedlot Production Medicine",
    "dept": "VDPAM",
    "num": "463",
    "desc": "Prereq: VDPAM 310: concurrent enrollment in VDPAM 421D.\nOne-week VM4 elective focusing on Midwestern feedlot production. Addresses feedlot production practices common to Iowa and surrounding states, including feeding cattle on concrete or under roofs. Activities include participation and visitation to representative feedlots in Iowa.\n",
    "credits": "1"
  },
  {
    "course_name": "Animal Welfare Clinical Rotation",
    "dept": "VDPAM",
    "num": "465",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nTwo-week course for senior veterinary students to gain skills for collecting and interpreting animal welfare data, aid clients with identifying and achieving welfare goals, and assisting law enforcement with animal cruelty response. Field trips to food animal and companion animal facilities are mandatory.\n",
    "credits": "2"
  },
  {
    "course_name": "Theriogenology: Food Animal",
    "dept": "VDPAM",
    "num": "471",
    "desc": "Prereq: Fourth year classification in veterinary medicine.\nElective clinical assignment in Food Animal Theriogenology involving male  and female breeding soundness exams, dystocia management, advanced diagnostic and surgical procedures, surgical and nonsurgical insemination programs in small  ruminants, and semen cryopreservation. Medical  and surgical correction of reproductive disorders in cattle, swine and small  ruminants. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Food Animal and Camelid Field Service",
    "dept": "VDPAM",
    "num": "476",
    "desc": "Prereq: VDPAM 310; Fourth year classification in Veterinary Medicine\nStudents will assist university veterinarians in delivering health care and production management services to the ISU livestock farms and other livestock farms in the local area. Focus will be on delivery of individual animal care and herd health. Focus on the establishment of best practices for herd management of production systems at the university and in the region. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Food Animal and Camelid Medicine and Surgery",
    "dept": "VDPAM",
    "num": "477",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nClinical assignment focused on the management of food animal and camelid medicine and surgery cases. Specific instruction in clinical evaluation of cases coupled with appropriate diagnostic testing and therapeutic intervention will be emphasized. Additional instruction will be provided in disease prevention, intensive care and management of food animal and camelid species. Particular emphasis will be placed on appropriate on-label and extra-label drug usage in food animal species. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Applied Swine Production Medicine Preceptorship",
    "dept": "VDPAM",
    "num": "479",
    "desc": "Prereq: VDPAM 310; Fourth year classification in Veterinary Medicine\nPreceptorship course in swine production medicine with emphasis on herd management, production analysis, and problem solving. Forty hours clinical experience per week. Assignments will be preceptorships with a practicing veterinarian and/or a production unit. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Swine Production Medicine",
    "dept": "VDPAM",
    "num": "480",
    "desc": "Prereq: VDPAM 310; Fourth year classification in Veterinary Medicine or permission of instructor\nTwo week clinical rotation in swine production medicine.  Students will be assigned to take the lead in investigating field based client cases with supervision of the instructors.  Development of critical thinking skills that will allow students to apply concepts of herd management, production analysis, economic analysis, and disease prevention in addressing client cases.  Variable amounts of travel to farm sites will be required with the potential for rare overnight stays. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Cow/Calf Production Medicine",
    "dept": "VDPAM",
    "num": "481",
    "desc": "Prereq: Completion of two semesters of VDPAM 436 or UNL equivalent (V MED 596 Cattle Production), fourth year classification in veterinary medicine\nTwo-week senior elective that will focus on the economics of animal disease in cow/calf operations. Evidence based medicine and epidemiological principles will be used in investigation of disease outbreaks. Extensive partial budgeting used. Students will complete at least two disease investigations involving outbreaks in commercial cow/calf operations and communicate their findings to the class, the herd owner, and local practitioner. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Applied Beef Production Medicine Preceptorship",
    "dept": "VDPAM",
    "num": "482",
    "desc": "Prereq: VDPAM 310; Fourth year classification in veterinary medicine\nAdvanced course in beef production medicine with emphasis on herd management, production analysis, and problem solving. Forty hours clinical experience per week. Assignments will include preceptorships with a practicing veterinarian and/or a production unit. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Beef Production Medicine",
    "dept": "VDPAM",
    "num": "483",
    "desc": "Prereq: VDPAM 310; fourth year classification in veterinary medicine\nTwo week advanced clinical rotation in beef production medicine. Fifteen hours recitation/discussion and 20 hours clinical experience per week. This course is designed to expose students to cow-calf and feedlot production concepts. The activities scheduled for the rotation depend greatly on the time of year. Whenever possible, the class incorporates field trips. Students should anticipate that travel, including overnight stays, may be required. These field trips can vary in length from several hours to several days and may include weekends. Typically, 3-4 days of the rotation are spent at the Great Plains Veterinary Education Center, Clay Center, NE. Students should, therefore, plan accordingly and contact the instructor, immediately, if they anticipate a conflict. Students should not schedule Grand Rounds during this rotation. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Dairy Production Medicine",
    "dept": "VDPAM",
    "num": "484",
    "desc": "Prereq: VDPAM 310; fourth year classification in veterinary medicine\nTwo week course in dairy production medicine combining class time with multiple on-farm visits to learn various management aspects (DHIA, DC305 & PC Dart record analysis, calf rearing through lactating cows, reproduction programs, udder health and milk quality, biosecurity, welfare, nutrition and cow comfort) for a wide variety of dairy operations. Students will learn the latest in dairy management by reviewing current topic articles and gain experience in farm evaluation through a group project. Fifteen hours recitation/discussion and 20 hours clinical experience per week. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Applied Dairy Production Medicine Preceptorship",
    "dept": "VDPAM",
    "num": "485",
    "desc": "Prereq: VDPAM 310; fourth year classification in veterinary medicine\nAdvanced course in dairy production medicine with emphasis on herd management, production analysis, and problem solving. Forty hours clinical experience per week. Assignments will include preceptorships with a practicing veterinarian and/or a production unit. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Small Ruminant Production Medicine",
    "dept": "VDPAM",
    "num": "486",
    "desc": "Prereq: Third year classification in veterinary medicine or permission of instructor.\nSurvey of small ruminant production systems, common management practices, and disease processes of small ruminants.  This course is intended to give the student a background in small ruminant medicine. Herd health, disease monitoring and prevention, and typical management systems will be emphasized in lecture.\n",
    "credits": "1"
  },
  {
    "course_name": "Livestock Disease Prevention",
    "dept": "VDPAM",
    "num": "487",
    "desc": "\nThe course is designed for both the pre-veterinary and animal science majors who have an interest in production animal health, disease prevention methods, epidemiology of economically important agents, and the ecology of currently important pathogens found in North American livestock industries. It will focus on disease prevention principles for individuals and large production population systems.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Clinical Microbiology",
    "dept": "VDPAM",
    "num": "488",
    "desc": "Prereq: Fourth year classification in veterinary medicine\nApplication of microbiological procedures to the diagnosis of infectious diseases.\n",
    "credits": "1"
  },
  {
    "course_name": "Issues in Food Safety",
    "dept": "VDPAM",
    "num": "489",
    "desc": "Prereq: Credit or enrollment in FS HN 101 or FS HN 272 or HSP M 233; FS HN 419 or FS HN 420; FS HN 403\nCapstone seminar for the food safety minor. Case discussions and independent projects about safety issues in the food system from a multidisciplinary perspective.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "VDPAM",
    "num": "490",
    "desc": "Prereq: Permission of department chair\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Ruminant Nutrition",
    "dept": "VDPAM",
    "num": "491",
    "desc": "\nFocus on dairy nutrition and balancing rations from the calf to the adult, lactating cow. Introduction to different feedstuffs and forage varieties to determine those that are best suited to bovine diets. This course starts the week immediately prior to the start of the fall semester and continues throughout the fall semester. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Dairy Production Medicine",
    "dept": "VDPAM",
    "num": "494",
    "desc": "Prereq: VDPAM 484 or permission of instructor\nAdvanced course in investigating dairy herd problems relating to milk quality or nutrition.  Milk quality and nutrition troubleshooting will be taught through the combination of lecture and on-farm investigations. Students will combine lecture knowledge, data acquired from on-farm investigations and record analysis to generate management plans. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Small Ruminant Production Medicine",
    "dept": "VDPAM",
    "num": "495",
    "desc": "Prereq: VDPAM 486, fourth year classification in veterinary medicine, or permission of instructor\nTwo week clinical rotation in small ruminant production medicine. Field trips (including overnight stays) will be incorporated when possible. Topics to be covered include small ruminant industries (milk, meat, and fiber), milk quality, nutrition, reproduction, and disease management of small ruminants. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "International Preceptorship",
    "dept": "VDPAM",
    "num": "496",
    "desc": "Prereq: Second, third or fourth year classification in veterinary medicine\nInternational Preceptorships and Study Abroad Group programs. This course will provide opportunities for students to be involved in applied clinical, production, and/or research experiences in international locations. The course consists of 40 hour per week experiential learning opportunities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Evidence Based Clinical Decision Making",
    "dept": "VDPAM",
    "num": "507",
    "desc": "Prereq: Permission of instructor\nDiscussion, lectures and laboratories to assess the quality and significance of medical evidence in making informed decisions about the treatment of individual animals and animal populations.\n",
    "credits": "1"
  },
  {
    "course_name": "Poultry  Diseases",
    "dept": "VDPAM",
    "num": "508",
    "desc": "Prereq: Second or third year classification in veterinary medicine or permission of instructor\nBacterial, viral, parasitic, and nutritional diseases of domestic poultry and gamebirds; biosecurity, immunization, and management procedures to prevent poultry diseases. This course includes wet labs.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Practice Entrepreneurship",
    "dept": "VDPAM",
    "num": "514",
    "desc": "Prereq: Classification in veterinary medicine\nFormal exposure to the entrepreneurial and business skills necessary to own and operate a successful veterinary practice or other small business opportunity. Personal finance, marketing, human resource management, general accounting, site assessment, location demographics, practice valuation, and a host of other issues which must be considered when purchasing or starting a new business are covered.  Class instruction will be delivered by successful practice and business owners with examples from real world experience.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Toxicology",
    "dept": "VDPAM",
    "num": "526",
    "desc": "Prereq: Third year classification in veterinary medicine\nStudy of toxicological diseases of animals emphasizing clinical recognition, circumstances of poisoning, differential diagnosis with clinical and laboratory data, therapeutic procedures, preventive management and public health implications. Supplemented with case-based materials.\n",
    "credits": "3"
  },
  {
    "course_name": "Applied Statistical Methods in Population Studies",
    "dept": "VDPAM",
    "num": "527",
    "desc": "Prereq: STAT 401\nANOVA, Linear Regression, Model Selection, Mixed Models,  ANCOVA, Repeated Measurement Analysis, MANOVA, Nonparametric Methods, Diagnostic Test Evaluation, ROC Curve Analysis, Generalized Linear Models,  Logistic  Regression, Survival Analysis, Cox Proportional Hazards Regression, Count Data Analyses. This course is available on campus and by distance.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Epidemiology and Population Health",
    "dept": "VDPAM",
    "num": "528",
    "desc": "\nEpidemiology of disease in populations. Disease causality, observational study design and approaches to epidemiologic investigations. This course is available on campus and by distance.\n",
    "credits": "3"
  },
  {
    "course_name": "Epidemiological Methods in Population Research",
    "dept": "VDPAM",
    "num": "529",
    "desc": "Prereq: STAT 587, VDPAM 528\nDesigning, conducting, analyzing and interpreting outcomes from field-based studies, including cross-sectional, case-control, cohort, and clinical trials  with categorical outcomes. This course is available on campus and by distance.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "VDPAM",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "VDPAM",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Protein",
    "dept": "VDPAM",
    "num": "542B",
    "desc": "Prereq: Graduate classification\nTechniques. Includes: fermentation, protein isolation, protein purification, SDS-PAGE, Western blotting, NMR, confocal microscopy and laser microdissection, Immunophenotyping, and monoclonal antibody production. Sessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "VDPAM",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "VDPAM",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "VDPAM",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "VDPAM",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "VDPAM",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Clinical and Diagnostic Toxicology",
    "dept": "VDPAM",
    "num": "546",
    "desc": "Prereq: D.V.M. degree or VDPAM 526\nAdvanced study of current problems and issues in toxicology. Emphasis on problem solving utilizing clinical, epidemiological, and laboratory resources.\n",
    "credits": "1"
  },
  {
    "course_name": "Advanced Veterinary Diagnostic Medicine",
    "dept": "VDPAM",
    "num": "551",
    "desc": "Prereq: VDPAM 455\nLaboratory diagnosis of animal diseases with emphasis on gross and microscopic lesion description. Caseload is focused heavily on infectious diseases of food animals.\n",
    "credits": "1"
  },
  {
    "course_name": "Risk Assessment for Food, Agriculture and Veterinary Medicine",
    "dept": "VDPAM",
    "num": "570",
    "desc": "Prereq: Statistics 300-level or higher.\nRisk assessment principles as applied to biological systems. Exposure and effects characterization in human and animal health and ecological risk assessment. Risk analysis frameworks and regulatory decision-making. Introduction to quantitative methods for risk assessment using epidemiological and distributional analysis. Uncertainty analysis.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Cow/Calf Production Medicine",
    "dept": "VDPAM",
    "num": "581",
    "desc": "Prereq: Completion of two semesters of VDPAM 436 or UNL equivalent (V MED 596 Cattle Production), fourth year classification in veterinary medicine\nTwo-week senior elective that will focus on the economics of animal disease in cow/calf operations. Evidence based medicine and epidemiological principles will be used in investigation of disease outbreaks. Extensive partial budgeting used. Students will complete at least two disease investigations involving outbreaks in commercial cow/calf operations and communicate their findings to the class, the herd owner, and local practitioner. Biosecurity: All students must follow current College policies regarding animal contact following foreign travel.\n",
    "credits": "2"
  },
  {
    "course_name": "Special Topics",
    "dept": "VDPAM",
    "num": "590",
    "desc": "Prereq: Permission of instructor\nTopics in medicine, surgery, theriogenology; beef, swine, dairy, or sheep production medicine.\n",
    "credits": "1"
  },
  {
    "course_name": "International Preceptorship",
    "dept": "VDPAM",
    "num": "596",
    "desc": "Prereq: Second, third or fourth year classification in veterinary medicine\nInternational Preceptorships and Study Abroad Group programs. This course will provide opportunities for students to be involved in applied clinical, production, and/or research experiences in international locations. The course consists of 40 hour per week experiential learning opportunities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "VDPAM",
    "num": "599",
    "desc": "Prereq: Enrollment in nonthesis master's degree program\n",
    "credits": "arr"
  },
  {
    "course_name": "Swine Diagnostic Medicine",
    "dept": "VDPAM",
    "num": "650",
    "desc": "Prereq: Permission of instructor\nA detailed study of swine diseases emphasizing the pathogenesis and diagnosis of swine respiratory, enteric, reproduction, metabolic, and septicemic diseases. Course activities include interpretation of diagnostic case reports and development of diagnostic plans for specific disease objectives.\n",
    "credits": "4"
  },
  {
    "course_name": "Comparative Antimicrobial Clinical Pharmacology",
    "dept": "VDPAM",
    "num": "654",
    "desc": "Prereq: Graduate student, resident, or intern in College of Veterinary Medicine\nInitial antimicrobial selection for infectious diseases of domestic animals. The antimicrobial drug groups will be examined, stressing pharmacokinetics, minimal inhibitory concentrations, and the use of these parameters to select appropriate compounds and dosages for maximum efficacy.\n",
    "credits": "2"
  },
  {
    "course_name": "Advanced Swine Production Medicine",
    "dept": "VDPAM",
    "num": "655",
    "desc": "Prereq: Permission of instructor\nDetailed overview of applied techniques used in swine production medicine; production modeling and record analysis, facility design and management, analysis of competing intervention options, design and evaluation of therapeutic and vaccination strategies, quality control procedures and food safety. Course activities include interpretation of diagnostic case reports and development of diagnostic plans for specific disease objectives.\n",
    "credits": "4"
  },
  {
    "course_name": "Research",
    "dept": "VDPAM",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Case Study IV",
    "dept": "V MPM",
    "num": "378",
    "desc": "Prereq: Second-year classification in veterinary medicine\nCase-based applied learning that relates to the basic science courses. Emphasis on early integration of basic and clinical science concepts.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Immunology",
    "dept": "V MPM",
    "num": "380",
    "desc": "Prereq: First-year classification in veterinary medicine\nStructure and function of the immune system in animals.\n",
    "credits": "2"
  },
  {
    "course_name": "Veterinary Microbiology",
    "dept": "V MPM",
    "num": "386",
    "desc": "Prereq: Second-year classification in veterinary medicine\nBacteria and fungi of veterinary importance with emphasis on mechanisms of disease production and laboratory diagnostic procedures.\n",
    "credits": "5"
  },
  {
    "course_name": "Veterinary Virology",
    "dept": "V MPM",
    "num": "387",
    "desc": "Prereq: Second-year classification in veterinary medicine\nBasic principles of animal virology. Pathogenesis of viral infections. The nature and ecology of viruses of veterinary and zoonotic importance.\n",
    "credits": "3"
  },
  {
    "course_name": "Public Health and the Role of the Veterinary Profession",
    "dept": "V MPM",
    "num": "388",
    "desc": "Prereq: Second-year classification in veterinary medicine\nFundamental epidemiology, zoonotic diseases, occupational health, food safety, other public health topics.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Veterinary History",
    "dept": "V MPM",
    "num": "390",
    "desc": "\nAn overview of the history of veterinary medicine focused primarily on disease-specific events.  A review of the historical aspects of the veterinary profession's accomplishments in the discovery of the etiological origins of disease and their subsequent control will provide students with insights that are applicable to understanding and solving today's animal and human health challenges.\n",
    "credits": "1"
  },
  {
    "course_name": "Principles of Epidemiology and Population Health",
    "dept": "V MPM",
    "num": "428",
    "desc": "\nEpidemiology of disease in populations. Disease causality, observational study design and approaches to epidemiologic investigations. This course is available on campus and by distance.\n",
    "credits": "3"
  },
  {
    "course_name": "Infectious Diseases and Preventive Medicine",
    "dept": "V MPM",
    "num": "437",
    "desc": "Prereq: Third-year classification in veterinary medicine\nEtiology, epidemiology, laboratory diagnosis, regulatory control and preventive medicine aspects of the infectious diseases of swine, sheep, goats, cattle and horses.\n",
    "credits": "3"
  },
  {
    "course_name": "Laboratory in Public Health",
    "dept": "V MPM",
    "num": "486",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nDiscussions, lectures, exercises and field trips related to veterinary public health.\n",
    "credits": "2"
  },
  {
    "course_name": "Independent Study",
    "dept": "V MPM",
    "num": "490",
    "desc": "Prereq: Permission of instructor and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "CDC Epidemiology  Elective Preceptorship",
    "dept": "V MPM",
    "num": "491",
    "desc": "Prereq: Written permission of instructor\nIntroduction to preventive medicine, public health and the principles of applied epidemiology within the working atmosphere of the Centers for Disease Control and Prevention.\n",
    "credits": "6"
  },
  {
    "course_name": "International Preceptorship",
    "dept": "V MPM",
    "num": "496",
    "desc": "Prereq: Second-year classification in veterinary medicine\nInternational Preceptorships and Study Abroad group programs. This course will provide opportunities for students to be involved in applied clinical, production, and/or research experiences in international locations. The course consists of 40 hour per week experiential learning opportunities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Basic Principles of Microbiology",
    "dept": "V MPM",
    "num": "501",
    "desc": "\nThe general principles of bacteriology, immunology and virology will be discussed.  The structure and function of bacteria and viruses, the mechanisms of pathogenesis, and the host response to infectious agents will be reviewed. Vaccines, their failures, and new developments in vaccine development will be explored.\n",
    "credits": "3"
  },
  {
    "course_name": "Microbial Genetics and Genomics",
    "dept": "V MPM",
    "num": "502",
    "desc": "Prereq: MICRO 302, BIOL 313\nThe fundamental concepts of bacterial and bacteriophage genetics including mutagenesis, mechanisms of both vertical and     horizontal genetic information transfer, gene regulation, and genetic approaches to study complex cellular processes. Review and     discussion of research literature to examine experimental design, methodology, and interpretation of both historical and     contemporary relevance to microbial genetics.\n",
    "credits": "3"
  },
  {
    "course_name": "Gut Microbiome: Implications for Health and Diseases",
    "dept": "V MPM",
    "num": "517",
    "desc": "Prereq: Basic Knowledge in microbiology\nExplore current research on gut microbiome including modern tools used to study the gut microbiome. Examine the linkages between gut microbiome and health status, diseases, and manipulation of gut microbiome to improve health.\n",
    "credits": "3"
  },
  {
    "course_name": "Medical Immunology I",
    "dept": "V MPM",
    "num": "520",
    "desc": "Prereq: MICRO 310 or V MPM 386, 3 credits in biochemistry\nNature of the immune system and its role in health and disease.\n  Credit for either V MPM 520 or 575, but not both may be applied toward graduation.",
    "credits": "4"
  },
  {
    "course_name": "Intestinal Microbiology",
    "dept": "V MPM",
    "num": "525",
    "desc": "Prereq: MICRO 302, BIOL 313\nOverview of commensal microbiota in the health and well-being of vertebrates. Topics include diversity of intestinal structure, microbial diversity/function, innate immune development, community interactions and metabolic diseases associated with alterations of the intestinal microbiome.\n",
    "credits": "3"
  },
  {
    "course_name": "Principles of Epidemiology and Population Health",
    "dept": "V MPM",
    "num": "528",
    "desc": "\nEpidemiology of disease in populations. Disease causality, observational study design and approaches to epidemiologic investigations. This course is available on campus and by distance.\n",
    "credits": "3"
  },
  {
    "course_name": "Zoonoses and Environmental Health",
    "dept": "V MPM",
    "num": "536",
    "desc": "Prereq: V MPM 386, VMPM 387 and V MPM 388 or equivalent or permission of instructor\nPathogensis and control of zoonotic diseases. Factors influencing transmission and survival of pathogenic microorganisms in the environment.\n",
    "credits": "3"
  },
  {
    "course_name": "Livestock Immunogenetics",
    "dept": "V MPM",
    "num": "540",
    "desc": "Prereq: AN S 561 or MICRO 575 or V MPM 520\nBasic concepts and contemporary topics in genetic regulation of livestock immune response and disease resistance.\n",
    "credits": "2"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques",
    "dept": "V MPM",
    "num": "542",
    "desc": "\nSessions in basic molecular biology techniques and related procedures.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: DNA Techniques",
    "dept": "V MPM",
    "num": "542A",
    "desc": "\nIncludes genetic engineering procedures, sequencing, PCR, and genotyping.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Cell Techniques",
    "dept": "V MPM",
    "num": "542C",
    "desc": "\nIncludes: immunophenotyping, ELISA, flow cytometry, microscopic techniques, image analysis, confocal, multiphoton and laser capture microdissection.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Plant Transformation",
    "dept": "V MPM",
    "num": "542D",
    "desc": "\nIncludes: Agrobacterium and particle gun-mediated transformation of tobacco, Arabidopsis, and maize, and analysis of tranformants.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Proteomics",
    "dept": "V MPM",
    "num": "542E",
    "desc": "\nIncludes: two-dimensional electrophoresis, laser scanning, mass spectrometry, and database searching.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Metabolomics",
    "dept": "V MPM",
    "num": "542F",
    "desc": "\nIncludes: metabolomics and the techniques involved in metabolite profiling. For non-chemistry majoring students who are seeking analytical aspects into their biological research projects.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Molecular Biology Techniques: Genomic",
    "dept": "V MPM",
    "num": "542G",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Immunology",
    "dept": "V MPM",
    "num": "575",
    "desc": "Prereq: MICRO 310\nAn examination of humoral and cellular immune function as well as the interaction of the cells and factors of the immune system that result in health and disease. MICRO 475L optional.\n  Credit for either Micro 575 or V MPM 520, but not both, may be applied toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "Medical Bacteriology",
    "dept": "V MPM",
    "num": "586",
    "desc": "Prereq: Permission of instructor\nBacteria associated with diseases of vertebrates, including virulence factors and interaction of host responses.\n",
    "credits": "4"
  },
  {
    "course_name": "Medical Bacteriology Laboratory",
    "dept": "V MPM",
    "num": "586L",
    "desc": "Prereq: credit or enrollment in V MPM 586 or V MPM 625\nProcedures used in isolation and identification of pathogenic bacteria, including molecular and genetic techniques used in research.\n",
    "credits": "2"
  },
  {
    "course_name": "Animal Virology",
    "dept": "V MPM",
    "num": "587",
    "desc": "Prereq: Permission of instructor\nPrinciples of animal virology. Biology of viruses associated with diseases of veterinary importance, including mechanisms of pathogenesis.\n",
    "credits": "4"
  },
  {
    "course_name": "Special Topics",
    "dept": "V MPM",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Creative Component",
    "dept": "V MPM",
    "num": "599",
    "desc": "Prereq: Nonthesis M.S. Option only\nA written report based on laboratory research, library reading, or topics related to the student's area of specialization and approved by the student's advisory committee.\n",
    "credits": "arr"
  },
  {
    "course_name": "Seminar",
    "dept": "V MPM",
    "num": "604",
    "desc": "\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Molecular Virology",
    "dept": "V MPM",
    "num": "608",
    "desc": "Prereq: BBMB 405 or GDCB 511\nAdvanced study of virus host-cell interactions. Molecular mechanisms of viral replication and pathogenesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Molecular Immunology",
    "dept": "V MPM",
    "num": "615",
    "desc": "Prereq: BBMB 405 or BBMB 506 and BBMB 507\nCurrent topics in molecular aspects of immunology: T and B cell receptors; major histocompatibility complex; antibody structure; immunosuppressive drugs and viruses; and intracellular signaling pathways leading to expression of genes that control and activate immune function.\n",
    "credits": "3"
  },
  {
    "course_name": "Mechanisms of Bacterial Pathogenesis",
    "dept": "V MPM",
    "num": "625",
    "desc": "Prereq: Credit in Biochemistry and Microbiology\nReview of current concepts in specific areas of microbial pathogenesis including the genetic basis for bacterial disease, genetic regulation and control of virulence factors and their mechanisms of action, and host-pathogen interactions at the cellular and molecular levels. The application of microbial genetics to understanding pathogenesis will be included.\n",
    "credits": "4"
  },
  {
    "course_name": "Advanced Topics in Cellular Immunology",
    "dept": "V MPM",
    "num": "629",
    "desc": "Prereq: V MPM 520 or V MPM 575\nCurrent topics and literature in cellular immunology. Topics include thymocyte development and selection, T cell interactions with antigen presenting cells, and lymphocyte effector functions.\n",
    "credits": "2"
  },
  {
    "course_name": "Pathogenesis of Persistent Infections",
    "dept": "V MPM",
    "num": "660",
    "desc": "Prereq: Permission of instructor\nStudy of current knowledge related to host pathogen interactions during persistent and chronic infections by bacteria, viruses and parasites.\n",
    "credits": "2"
  },
  {
    "course_name": "Current Topics",
    "dept": "V MPM",
    "num": "690",
    "desc": "Prereq: Permission of instructor\nColloquia or advanced study of specific topics in a specialized field.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics: Immunology",
    "dept": "V MPM",
    "num": "690A",
    "desc": "Prereq: Permission of instructor\nColloquia or advanced study of specific topics in a specialized field.\n",
    "credits": "1"
  },
  {
    "course_name": "Current Topics: Infectious Diseases",
    "dept": "V MPM",
    "num": "690B",
    "desc": "Prereq: Permission of instructor\nColloquia or advanced study of specific topics in a specialized field.\n",
    "credits": "1"
  },
  {
    "course_name": "Seminar in Molecular, Cellular, and Developmental Biology",
    "dept": "V MPM",
    "num": "698",
    "desc": "\nStudent and faculty presentations.\n",
    "credits": "1"
  },
  {
    "course_name": "Research",
    "dept": "V MPM",
    "num": "699",
    "desc": "\n",
    "credits": "arr"
  },
  {
    "course_name": "Anatomic Pathology I",
    "dept": "V PTH",
    "num": "342",
    "desc": "Prereq: for V PTH 342, prereq: First-year classification in veterinary medicine. For V PTH 542, prereq: Graduate classification and BIOL 352 or equivalent for graduate credit, permission of instructor.\nBasic pathology with emphasis on disease in animals and introduction to diseases by system.\n",
    "credits": "3"
  },
  {
    "course_name": "Introductory Parasitology",
    "dept": "V PTH",
    "num": "353",
    "desc": "Prereq: BIOL 212\nBiology and host-parasite relationships of major groups of animal parasites, and techniques of diagnosing and studying parasites.\n",
    "credits": "3"
  },
  {
    "course_name": "Anatomic Pathology II",
    "dept": "V PTH",
    "num": "372",
    "desc": "Prereq: for V PTH 372, prereq: V PTH 342. For V PTH 572, prereq: Graduate classification and V PTH 542.\nResponse to injury by each body system.\n",
    "credits": "4"
  },
  {
    "course_name": "Veterinary Parasitology",
    "dept": "V PTH",
    "num": "376",
    "desc": "Prereq: For V PTH 376, prereq: Second-year classification in veterinary medicine. For V PTH 576, prereq: Graduate classification and V PTH 542.\nParasitic diseases of domestic animals and their control.\n",
    "credits": "4"
  },
  {
    "course_name": "Case Study III",
    "dept": "V PTH",
    "num": "377",
    "desc": "Prereq: Second-year classification in veterinary medicine\nClinical applications of the basic sciences taught concurrently in the fall semester of the second year curriculum in veterinary medicine.\n",
    "credits": "2"
  },
  {
    "course_name": "Basics of Medical Terminology",
    "dept": "V PTH",
    "num": "401",
    "desc": "\nDiscussion of prefixes, suffixes, and roots (mostly from Latin and Greek) that comprise medical terms.\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Pathology",
    "dept": "V PTH",
    "num": "402",
    "desc": "Prereq: BIOL 211 and BIOL 212 with labs\nIntroductory exploration of pathology as a medical discipline. This includes study of disease mechanisms via an introduction to general pathology topics (cell degeneration, necrosis, disturbances of growth, disturbances of blood flow, inflammation, neoplasia) and organ system-specific response to injury.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Veterinary Cytology and Laboratory Techniques",
    "dept": "V PTH",
    "num": "409",
    "desc": "Prereq: Third-year classification in veterinary medicine\nDescription, interpretation, and techniques for cellular preparations from tissues and body fluids.\n",
    "credits": "1"
  },
  {
    "course_name": "Clinical Pathology",
    "dept": "V PTH",
    "num": "425",
    "desc": "Prereq: V PTH 372\nPrinciples of clinical hematology, clinical chemistry, and urinalysis in domestic animals.\n",
    "credits": "4"
  },
  {
    "course_name": "Necropsy Laboratory Practicum",
    "dept": "V PTH",
    "num": "456",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nPracticum in postmortem examination and diagnosis.\n",
    "credits": "1"
  },
  {
    "course_name": "Clinical Pathology Laboratory Practicum",
    "dept": "V PTH",
    "num": "457",
    "desc": "Prereq: Fourth-year classification in veterinary medicine\nMethodology in clinical chemistry, hematology and cytology; practice in interpretation of laboratory data.\n",
    "credits": "1"
  },
  {
    "course_name": "Independent Study",
    "dept": "V PTH",
    "num": "490",
    "desc": "Prereq: Permission of instructor and department chair\n",
    "credits": "arr"
  },
  {
    "course_name": "Orientation for International Experience",
    "dept": "V PTH",
    "num": "492",
    "desc": "Prereq: Classification in veterinary medicine\n8 weeks. Predeparture orientation for group study abroad. Cultural considerations for the study abroad experience and a conversational language introduction. Out of class work will be assigned.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Clinical Competency Skills Checklist/Remediation",
    "dept": "V PTH",
    "num": "495",
    "desc": "Prereq: 4th year classification in Veterinary Medicine\nIn order to graduate, all 4th year veterinary students are required to complete a checklist of clinical procedures and complete any assigned remediation (based on evaluation in core clinical rotations). These requirements are tied to the college's AVMA COE accreditation, and this course is used to document completion of those requirements.\n  Offered on a satisfactory-fail basis only.",
    "credits": "R"
  },
  {
    "course_name": "International Preceptorship",
    "dept": "V PTH",
    "num": "496",
    "desc": "Prereq: Second-year classification in veterinary medicine\nInternational Preceptorships and Study Abroad Group programs. This course will provide opportunities for students to be involved in applied clinical, production, and/or research experience in international locations. The course consists of 40 hour per week experiential learning opportunities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Principles of Pathology",
    "dept": "V PTH",
    "num": "503",
    "desc": "Prereq: Graduate classification; permission of instructor\nIntroductory exploration of pathology as a medical discipline. This includes study of disease mechanisms via an introduction to general pathology topics (cell degeneration, necrosis, disturbances of growth, disturbances of blood flow, inflammation, neoplasia) and organ system-specific response to injury.\n",
    "credits": "3"
  },
  {
    "course_name": "Teaching and Learning in Veterinary Medical Education",
    "dept": "V PTH",
    "num": "530",
    "desc": "\nStudy of principles of teaching and learning as they relate to veterinary medical education. These include: theories of learning, analyzing content/learners/context, identifying goals, identifying appropriate instructional strategies (specific to medical education), matching assessment processes to goals and strategies, common curricular approaches and decision-making processes in medical education, and the scholarship of teaching and learning for veterinary medical educators.\n",
    "credits": "3"
  },
  {
    "course_name": "Anatomic Pathology I",
    "dept": "V PTH",
    "num": "542",
    "desc": "Prereq: for V PTH 342, prereq: First-year classification in veterinary medicine. For V PTH 542, prereq: Graduate classification and BIOL 352 or equivalent for graduate credit, permission of instructor.\nBasic pathology with emphasis on disease in animals and introduction to diseases by system.\n",
    "credits": "3"
  },
  {
    "course_name": "Diagnostic Parasitology Laboratory",
    "dept": "V PTH",
    "num": "548",
    "desc": "Prereq: V PTH 376 or V PTH 576\nContact hours are (0-3 to 0-9). A laboratory experience in the technical and applied aspects of veterinary parasitology.\n",
    "credits": "1"
  },
  {
    "course_name": "Clinical Pathology Laboratory",
    "dept": "V PTH",
    "num": "549",
    "desc": "Prereq: V PTH 457; permission of instructor\nLaboratory procedures and clinical interpretations with emphasis on hematology, cytology, and clinical chemistry.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Surgical Pathology Laboratory",
    "dept": "V PTH",
    "num": "550",
    "desc": "Prereq: V PTH 570 or V PTH 571; permission of instructor\nContact hours are (0-3 to 0-9). Diagnosis of lesions in biopsy specimens; classification of neoplasms. Course includes rotation through departmental biopsy service and review of selected cases from departmental archives.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Postmortem Pathology Laboratory",
    "dept": "V PTH",
    "num": "551",
    "desc": "Prereq: V PTH 542; permission of instructor\nContact hours are (0-3 to 0-9). Necropsy techniques of animals with emphasis on gross and microscopic lesions and diagnosis.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Ethics in Scientific Research and Writing",
    "dept": "V PTH",
    "num": "554",
    "desc": "Prereq: Graduate classification\nEthical conduct in biomedical research, criticism, writing, and adherence to regulations.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Systemic Pathology I",
    "dept": "V PTH",
    "num": "570",
    "desc": "Prereq: V PTH 342 or V PTH 542; permission of instructor\nPathology of the respiratory, reproductive, endocrine, musculoskeletal, and cardiovascular systems. Emphasis on pathogenesis and anatomic pathology correlated with interpretive clinical pathology where appropriate.\n",
    "credits": "4"
  },
  {
    "course_name": "Systemic Pathology II",
    "dept": "V PTH",
    "num": "571",
    "desc": "Prereq: V PTH 342 or V PTH 542; permission of instructor\nPathology of the integumentary, urinary, digestive, lymphoid, and nervous systems and special senses. Emphasis on pathogenesis and anatomic pathology correlated with interpretive clinical pathology where appropriate.\n",
    "credits": "4"
  },
  {
    "course_name": "Anatomic Pathology II",
    "dept": "V PTH",
    "num": "572",
    "desc": "Prereq: for V PTH 372, prereq: V PTH 342. For V PTH 572, prereq: Graduate classification and V PTH 542.\nResponse to injury by each body system.\n",
    "credits": "4"
  },
  {
    "course_name": "Veterinary Parasitology",
    "dept": "V PTH",
    "num": "576",
    "desc": "Prereq: For V PTH 376, prereq: Second-year classification in veterinary medicine. For V PTH 576, prereq: Graduate classification and V PTH 542.\nParasitic diseases of domestic animals and their control.\n",
    "credits": "4"
  },
  {
    "course_name": "Special Topics",
    "dept": "V PTH",
    "num": "590",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Veterinary Pathology",
    "dept": "V PTH",
    "num": "590A",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Veterinary Parasitology",
    "dept": "V PTH",
    "num": "590B",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Veterinary Toxicology",
    "dept": "V PTH",
    "num": "590C",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Veterinary Clinical Pathology",
    "dept": "V PTH",
    "num": "590D",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "Special Topics: Other",
    "dept": "V PTH",
    "num": "590E",
    "desc": "Prereq: Permission of instructor\n",
    "credits": "1"
  },
  {
    "course_name": "International Preceptorship",
    "dept": "V PTH",
    "num": "596",
    "desc": "Prereq: Admission to graduate college\nInternational Preceptorships and Study Abroad Group programs. This course will provide opportunities for students to be involved in applied clinical, production, and/or research experiences in international locations. The course consists of 40 hour per week experiential learning opportunities.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Creative Component Research",
    "dept": "V PTH",
    "num": "599",
    "desc": "\nCourse for departmental graduate research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component Research: Veterinary Pathology",
    "dept": "V PTH",
    "num": "599A",
    "desc": "\nCourse for departmental graduate research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component Research: Veterinary Parasitology",
    "dept": "V PTH",
    "num": "599B",
    "desc": "\nCourse for departmental graduate research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component Research: Veterinary Toxicology",
    "dept": "V PTH",
    "num": "599C",
    "desc": "\nCourse for departmental graduate research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Creative Component Research: Veterinary Clinical Pathology",
    "dept": "V PTH",
    "num": "599D",
    "desc": "\nCourse for departmental graduate research.\n",
    "credits": "arr"
  },
  {
    "course_name": "Pathology Case Seminar",
    "dept": "V PTH",
    "num": "604",
    "desc": "Prereq: permission of instructor\nDescription and interpretation of microscopic lesions and clinical pathology data collected from cases of natural and experimental disease.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Current Topics Seminar",
    "dept": "V PTH",
    "num": "605",
    "desc": "\nA seminar of graduate research at the time of thesis or dissertation defense.\n",
    "credits": "1"
  },
  {
    "course_name": "Diagnostic Interpretation",
    "dept": "V PTH",
    "num": "606",
    "desc": "Prereq: permission of instructor\nA comprehensive examination in the diagnostic description and interpretation of case materials relevant to veterinary pathology and areas of specialization for the graduate degree preliminary examination.\n",
    "credits": "R"
  },
  {
    "course_name": "Diagnostic Interpretation: Veterinary Pathology",
    "dept": "V PTH",
    "num": "606A",
    "desc": "Prereq: permission of instructor\nA comprehensive examination in the diagnostic description and interpretation of case materials relevant to veterinary pathology and areas of specialization for the graduate degree preliminary examination.\n",
    "credits": "R"
  },
  {
    "course_name": "Diagnostic Interpretation: Veterinary Parasitology",
    "dept": "V PTH",
    "num": "606B",
    "desc": "Prereq: permission of instructor\nA comprehensive examination in the diagnostic description and interpretation of case materials relevant to veterinary pathology and areas of specialization for the graduate degree preliminary examination.\n",
    "credits": "R"
  },
  {
    "course_name": "Diagnostic Interpretation: Veterinary Toxicology",
    "dept": "V PTH",
    "num": "606C",
    "desc": "Prereq: permission of instructor\nA comprehensive examination in the diagnostic description and interpretation of case materials relevant to veterinary pathology and areas of specialization for the graduate degree preliminary examination.\n",
    "credits": "R"
  },
  {
    "course_name": "Diagnostic Interpretation: Veterinary Clinical Pathology",
    "dept": "V PTH",
    "num": "606D",
    "desc": "Prereq: permission of instructor\nA comprehensive examination in the diagnostic description and interpretation of case materials relevant to veterinary pathology and areas of specialization for the graduate degree preliminary examination.\n",
    "credits": "R"
  },
  {
    "course_name": "Pathologic Hematology",
    "dept": "V PTH",
    "num": "652",
    "desc": "Prereq: V PTH 425; permission of instructor\nPathologic changes in blood constituents of domestic animals.\n",
    "credits": "3"
  },
  {
    "course_name": "Cellular and Molecular Pathology I",
    "dept": "V PTH",
    "num": "655",
    "desc": "Prereq: Graduate course in biochemistry, genetics, or cell biology\nCellular and molecular mechanisms of cell injury, cellular responses to injury, and inflammation.\n",
    "credits": "3"
  },
  {
    "course_name": "Cellular and Molecular Pathology II",
    "dept": "V PTH",
    "num": "656",
    "desc": "Prereq: Graduate course in biochemistry, genetics, or cell biology\nCellular and molecular mechanisms of carcinogenesis.\n",
    "credits": "3"
  },
  {
    "course_name": "Pathogenesis of Persistent Infections",
    "dept": "V PTH",
    "num": "660",
    "desc": "Prereq: Permission of instructor\nStudy of current knowledge related to host pathogen interactions during persistent and chronic infections by bacteria, viruses and parasites.\n",
    "credits": "2"
  },
  {
    "course_name": "Comparative Immunology and Infectious Disease",
    "dept": "V PTH",
    "num": "661",
    "desc": "Prereq: Graduate level Immunology or permission of instructor.\nDiscuss and define similarities and differences of varied host responses to infectious challenge. Learning will focus on comparative aspects of the host response and the unique aspects of immunity from different organisms, while highlighting molecular and mechanistic similarities of pathogen recognition, response and resolution.\n",
    "credits": "2"
  },
  {
    "course_name": "Clinical Chemistry",
    "dept": "V PTH",
    "num": "663",
    "desc": "Prereq: V PTH 425; permission of instructor\nThe pathophysiology, methodology, and clinical application of laboratory medicine.\n",
    "credits": "3"
  },
  {
    "course_name": "Histopathology of Laboratory Animals",
    "dept": "V PTH",
    "num": "679",
    "desc": "Prereq: V PTH 570 or V PTH 571; permission of instructor\nStudy of microscopic lesions in laboratory animals with emphasis on description, etiology, pathogenesis, and diagnosis.\n",
    "credits": "2"
  },
  {
    "course_name": "Research",
    "dept": "V PTH",
    "num": "699",
    "desc": "\nCourse restricted to graduate program within the department.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Veterinary Pathology",
    "dept": "V PTH",
    "num": "699A",
    "desc": "\nCourse restricted to graduate program within the department.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Veterinary Parasitology",
    "dept": "V PTH",
    "num": "699B",
    "desc": "\nCourse restricted to graduate program within the department.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Veterinary Toxicology",
    "dept": "V PTH",
    "num": "699C",
    "desc": "\nCourse restricted to graduate program within the department.\n",
    "credits": "arr"
  },
  {
    "course_name": "Research: Veterinary Clinical Pathology",
    "dept": "V PTH",
    "num": "699D",
    "desc": "\nCourse restricted to graduate program within the department.\n",
    "credits": "arr"
  },
  {
    "course_name": "Wind Energy Resources",
    "dept": "WESEP",
    "num": "501",
    "desc": "Prereq: Graduate standing\nForecasting, wind measurement and analysis, site placement, aerodynamic principles associated with blade design, power generation technologies, power electronic topologies used in wind energy conversion, collection circuits, and grid operation with high wind penetration.\n",
    "credits": "3"
  },
  {
    "course_name": "Wind Energy Systems",
    "dept": "WESEP",
    "num": "502",
    "desc": "Prereq: Graduate standing\nSystems approach to wind turbine design, manufacturing, installation, integrated with wind economics and policy issues. Topics include manufacturing practices used to produce wind turbines, construction practices, sensing and inspection technologies used in monitoring wind farm health, and the impact of policy making on the wind energy industry.\n",
    "credits": "3"
  },
  {
    "course_name": "Wind Energy System Design",
    "dept": "WESEP",
    "num": "511",
    "desc": "Prereq: WESEP 501 and WESEP 502\nAdvanced design, control, and operation of wind plants. Topics include electromechanical energy conversion systems, aerodynamic and aeroelastic loads, optimal control of wind farms, life cycle management strategies, tall tower design, and prediction of component residual life.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "WESEP",
    "num": "590",
    "desc": "\nAdvanced study of a research topic in the field of wind energy, science, engineering, and policy.\n",
    "credits": "1"
  },
  {
    "course_name": "Wind Energy Real-Time Research Collaborative Seminar",
    "dept": "WESEP",
    "num": "594",
    "desc": "Prereq: Graduate standing\nIdentifying current wind energy research issues and conducting components of the research cycle in real-time, including proposal development, investigation/analysis/discovery, publication and presentation, ethical behavior, and leadership.\n",
    "credits": "1"
  },
  {
    "course_name": "Gender Justice",
    "dept": "WGS",
    "num": "160",
    "desc": "\nHalf semester course. Examines the socialization process in the United States and how our perspectives are formed. An introduction to patriarchy, sexism, and ally development are explored. Skills to enhance communication and understanding among women and men will be developed.\n  Offered on a satisfactory-fail basis only.\nMeets U.S. Diversity Requirement\n",
    "credits": "1"
  },
  {
    "course_name": "Introduction to Women's and Gender Studies",
    "dept": "WGS",
    "num": "201",
    "desc": "\nIntroduction to the interdisciplinary field of Women's and Gender Studies. Contemporary status of women in the U.S. and worldwide from social, economic, historical, political, philosophical and literary perspectives. Analysis of intersection of gender, race, class, and sexuality. Subject matter includes work, health, sexuality, and violence. Foundation for the other courses in the program.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Lesbian Studies",
    "dept": "WGS",
    "num": "203",
    "desc": "\nStudy of contemporary and historic lesbian cultures and communities from a US and international perspective.  Addresses issues of race, class, gender and sexuality as they intersect with the formation of lesbian identities.  Explores who identifies as lesbian and how that dis/enables political resistance and formation of community.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Queer Studies",
    "dept": "WGS",
    "num": "205",
    "desc": "Prereq: ENGL 150\nInterdisciplinary study of issues relating to lesbian, gay, bisexual, transgender, and queer identities in the U.S.  Attention will be given to race and socioeconomic class.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Gender and Sexuality in American Pop Culture",
    "dept": "WGS",
    "num": "210",
    "desc": "\nIntroduction to research and theory examining the ways gender and sexuality are conveyed through popular culture texts. Analysis of codes and their influence on the development of identities that shape how we view the world. Discussion of intersectional topics including race and class.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "International Perspectives on Women and Gender",
    "dept": "WGS",
    "num": "301",
    "desc": "Prereq: WGS 201 or 3 credits in WGS at the 300 level or above\nStudy of women in a range of cultures, depending on faculty specialization. Special emphasis on women in development seen in postcolonial context.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Women in Science and Engineering",
    "dept": "WGS",
    "num": "307",
    "desc": "Prereq: 200 level course in science, engineering or women's studies; ENGL 250\nThe interrelationships of women and science and engineering examined from historical, sociological, philosophical, and biological perspectives. Factors contributing to under-representation; feminist critiques of science; examination of successful strategies.  Does not satisfy biology major advanced credit requirements.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Write Like a Woman",
    "dept": "WGS",
    "num": "308",
    "desc": "Prereq: ENGL 250\nWriting and reading interpretive fiction written by women. Emphasis on stories that embody a female literary life, gender-specific ways of creating characters and conflicts, analytical reading and writing, workshop criticism and shared commentaries. Includes multi-modal projects.\n",
    "credits": "3"
  },
  {
    "course_name": "Ecofeminism",
    "dept": "WGS",
    "num": "320",
    "desc": "Prereq: WGS 201 or 3 credits in WGS at the 300 level or above\nWomen's relationships with the earth, non-human nature, and other humans. The course explores the connections between society’s treatment of women and nature; origins of ecofeminism and how it relates to the science of ecology, conventional and sustainable agriculture as well as how ecofeminism relates to other branches of feminist philosophy. Evaluation and critique of modern science, technology, political systems and SOLUTIONS will be included.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Economics of Discrimination",
    "dept": "WGS",
    "num": "321",
    "desc": "Prereq: ECON 101\nEconomic theories of discrimination. Analysis of the economic problems of women and minorities in such areas as earnings, occupations, and unemployment. Public policy concerning discrimination. Poverty measurement and antipoverty programs in the U.S.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Gender and Communication",
    "dept": "WGS",
    "num": "323",
    "desc": "\nExamination of how understanding and enactment of gender identity is shaped by communication. Verbal and nonverbal communication across various contexts including personal relationships and the media.  Explores discourse of social movements aiming to transform cultural definitions of gender.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Portrayals of Gender and Sexualities in the Media",
    "dept": "WGS",
    "num": "325",
    "desc": "Prereq: Sophomore classification\nSurvey of how the media and popular culture portray gender and sexualities and the impact on individuals and society. Images of women, men, transgender as well as heterosexual, non-heterosexual and others. Studies both historical and emerging images in the media in terms of stereotypes and positive images.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Sex and Gender in Society",
    "dept": "WGS",
    "num": "327",
    "desc": "Prereq: SOC 134\nHow the biological fact of sex is transformed into a system of gender stratification. The demographics and social positions of women and men in the family, education, media, politics, and the economy. Theories of the social-psychological and sociological bases for behavior and attitudes of women and men. The relationship between gender, class, and race.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Sociology of Masculinities and Manhood",
    "dept": "WGS",
    "num": "328",
    "desc": "Prereq: SOC 134 or WGS 201\nExamination of socially constructed and idealized images of manhood, the nature of social hierarchies and relations constructed on the basis of imagery, ideologies, and norms of masculinity. Theories on gender (sociological, psychological, and biological). Particular attention given to theory and research on gender variations among men by race, class, ethnicity, sexual orientation, physical ability and age.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women and Leadership",
    "dept": "WGS",
    "num": "333",
    "desc": "Prereq: Sophomore classification\nExamination of historical and contemporary barriers to and opportunities for women's leadership in a variety of contexts, including professions and public service. Theories of women's leadership, gender differences in leadership styles, and perceptions and expectations about women's leadership. Multiple perspectives of women's leadership highlighted through lectures, readings, videos, guest speakers and group work.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women and Religion",
    "dept": "WGS",
    "num": "336",
    "desc": "Prereq: RELIG 205, RELIG 210 or WGS 201 recommended\nExamines the status of women in various religions, feminist critiques of religious structures and belief systems, and contemporary women's spirituality movements.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Feminist Philosophy",
    "dept": "WGS",
    "num": "338",
    "desc": "Prereq: 3 credits in philosophy or women's studies recommended\nA critical, theoretical examination of the oppression of women, especially as it relates to issues of race, class, and sexual orientation. How concepts such as sex and gender, self and other, nature and nurture, complicate our understanding of what it means to be a woman. Historical and contemporary feminist philosophers addressing topics such as violence, sexuality, pornography, political power, family structure and women's paid and unpaid labor.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women's Literature",
    "dept": "WGS",
    "num": "340",
    "desc": "Prereq: ENGL 250\nHistorical and thematic survey of literature by and about women. May include autobiographies, journals, letters, poetry, fiction, and drama.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Human Reproduction",
    "dept": "WGS",
    "num": "344",
    "desc": "Prereq: BIOL 212\nBiology of human reproduction, including reproductive systems, hormones, and endocrinology of pregnancy, presented from a clinically-oriented perspective. Reviews health-related conditions such as infertility, sexually-transmitted diseases, and complicated pregnancy.\n",
    "credits": "3"
  },
  {
    "course_name": "Women and Literature: Selected Topics",
    "dept": "WGS",
    "num": "345",
    "desc": "Prereq: ENGL 250\nLiterature by women and/or dealing with the images of women, e.g., study of individual authors or related schools of authors; exploration of specific themes or genres in women's literature; analysis of recurrent images of women in literature.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Psychology of Women",
    "dept": "WGS",
    "num": "346",
    "desc": "Prereq: 2 courses in psychology including PSYCH 101\nSurvey of theory and research related to major biological, interpersonal, and cultural issues affecting girls' and women's psychological development and behavior.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women of Color in the U.S",
    "dept": "WGS",
    "num": "350",
    "desc": "Prereq: 3 credits in WGS or AF AM\nEconomic, social, political and cultural roles of Women of Color in the U.S. Includes literary, philosophical, and artistic expressions. Myths and realities explored.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Gay and Lesbian Literature",
    "dept": "WGS",
    "num": "352",
    "desc": "Prereq: ENGL 250\nLiterary portrayals of gay and lesbian lives and relationships from many different genres.  Attention to changing definitions and representations of sexual orientation and gender identity over time.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation",
    "dept": "WGS",
    "num": "370",
    "desc": "\nReadings, discussions, and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation: French Topics on Women and Gender Studies",
    "dept": "WGS",
    "num": "370F",
    "desc": "\nTopics vary according to faculty interest. Readings, discussions, and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation: German Topics on Women or Feminism",
    "dept": "WGS",
    "num": "370G",
    "desc": "Prereq: Sophomore classification. For fourth credit, 6 credits in German at the 300 level\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Three credits: English, open to all students. Four credits: Required for German concentration credit, supplementary readings and compositions in German.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation: Russian Topics on Women or Feminism",
    "dept": "WGS",
    "num": "370R",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Readings, discussions, and papers in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Studies in English Translation: Hispanic Topics on Women or Feminism",
    "dept": "WGS",
    "num": "370S",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women writers, cinema, or contemporary theory. Readings, discussions, and papers in English. May not be counted as a prerequisite.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Sex, Gender, and Culture in the Ancient Mediterranean World",
    "dept": "WGS",
    "num": "374",
    "desc": "Prereq: Any one course in Cl St, W S, Latin, or Greek\nChronological and topical survey of the status of women and men, focusing on sex and gender issues in the Ancient Mediterranean world; study of constructs of the female and the feminine. Readings from ancient and modern sources.  Emphasis on ancient Greece, Rome, and Egypt.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "History of Women in Science, Technology, and Medicine",
    "dept": "WGS",
    "num": "380",
    "desc": "Prereq: Sophomore classification\nHistory of women's relationship to the fields of science, technology, and medicine, as students and professionals, consumers, subjects and patients, family members, workers and citizens. Concentrates especially on 19th and 20th century United States, concluding with an examination of current issues of special interest to women in science, technology, and medicine.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Women in Politics",
    "dept": "WGS",
    "num": "385",
    "desc": "\nEntry and participation of women in politics in the United States and other countries. Contemporary issues and strategies for change through the political process.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "History of Women in America",
    "dept": "WGS",
    "num": "386",
    "desc": "Prereq: Sophomore classification\nA survey of social, economic, and political aspects of women's role from colonial era to present; emphasis on employment, education, concepts of sexuality, and changing nature of the home.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Feminist Theories",
    "dept": "WGS",
    "num": "401",
    "desc": "Prereq: WGS 201 or 3 credits in WGS at the 300 level or above\nCurrent theories of feminism, the feminine and sexual difference. Topics in race, class, sexuality, and ethnicity as they are addressed in diverse feminisms. May include readings in lesbian, Black, postcolonial, psychoanalytic and postmodern thought.\n",
    "credits": "3"
  },
  {
    "course_name": "Feminist Research in Action",
    "dept": "WGS",
    "num": "402",
    "desc": "Prereq: WGS 201 and WGS 301\nFeminist research methods and scholarship. Class collaborates on a community research and action project to improve women's lives.\n",
    "credits": "3"
  },
  {
    "course_name": "Women, Men, and the English Language",
    "dept": "WGS",
    "num": "422",
    "desc": "Prereq: ENGL 219 or LING 219\nThe ways men and women differ in using language in varied settings and the ways in which language both creates and reflects gender divisions.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Intersections of Race, Class and Gender",
    "dept": "WGS",
    "num": "425",
    "desc": "Prereq: WGS 201 and one additional WGS course\nRace, ethnicity, class and gender distinctions and intersections lead to inequitable distributions of power, social well-being, and resources. Explores how inequities are institutionalized and how multiple identities are experienced by women in daily life.\n",
    "credits": "3"
  },
  {
    "course_name": "Gender and Consumer Culture",
    "dept": "WGS",
    "num": "430",
    "desc": "Prereq: WGS/W S 201 or 3 credits in W S / WGS at the 300 level or above\nHistorical roots of consumer culture, political economy, technology, and how the rise of the mass-market intersects with cultural ideas of gender, race, class, and sexuality. How gender, as well as personal and group identities, is formed through all forms of consumption. Examination of gendered advertising, material goods, and lifestyles created around specific acts of consumption.\n",
    "credits": "3"
  },
  {
    "course_name": "Gender, Globalization and Development",
    "dept": "WGS",
    "num": "435",
    "desc": "Prereq: WGS 301\nCross-cultural study of historical and contemporary dimensions of gender, globalization and development.  Explores the interdependence of socio-economic and political aspects of globalization using feminist postcolonial and transnational frameworks. Analyses of case studies and activism in contexts of economic livelihoods, environmental justice, and cross-border migrations.\n",
    "credits": "3"
  },
  {
    "course_name": "Goddess Religions",
    "dept": "WGS",
    "num": "439",
    "desc": "Prereq: RELIG 205 recommended\nExploration of the foundational myths of Goddess spirituality, including historical and cross-cultural female images of the divine and their modern usage by American women.\n",
    "credits": "3"
  },
  {
    "course_name": "Gender Issues in Sports",
    "dept": "WGS",
    "num": "440",
    "desc": "Prereq: W S 201 / WGS 201 or 3 credits in Women's Studies / Women's and Gender Studies at the 300 level or above\nSocial, economic, political, and cultural variables that influence and shape sports, especially for girls and women. Topics include Title IX, coaching and administrative challenges for women, media and gender, and issues related to eating disorders, homophobia, and gender identity in sport.\n",
    "credits": "3"
  },
  {
    "course_name": "Sex and Gender in Cross-cultural Perspective",
    "dept": "WGS",
    "num": "444",
    "desc": "Prereq: ANTHR 201; ANTHR 306 recommended\nCross-cultural examination of the social construction of genders out of the biological fact of sex. Emphasis on non-western societies. Topics, presented through examination of ethnographic data, will include the range of gender variation, status and roles, the institution of marriage, and symbols of gender valuation.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in Women's and Gender Studies",
    "dept": "WGS",
    "num": "450",
    "desc": "Prereq: WGS or W S 201 or 3 credits in WGS or W S at the 300 level or above\nAdvanced research and theory related to special topics and issues in women's and gender studies. Specific topics indicated in the schedule of classes.\n  A maximum of 6 credits of W S / WGS 450  can count toward graduation.",
    "credits": "3"
  },
  {
    "course_name": "History of American Sexualities",
    "dept": "WGS",
    "num": "457",
    "desc": "Prereq: Sophomore classification.\nThe social construction of American sexualities from the colonial era to the present with particular emphasis on how ideas about sex and sexuality have shaped American public life, including education, public policy, party politics, and racial justice.\n",
    "credits": "3"
  },
  {
    "course_name": "Seminar in Gender and Ethnicity",
    "dept": "WGS",
    "num": "460",
    "desc": "Prereq: Completion of 9 credits of surveys; junior classification\nSelected readings of various authors, movements, eras, or genres. Readings in criticism; required research paper.\n",
    "credits": "3"
  },
  {
    "course_name": "Research on Women and Leadership",
    "dept": "WGS",
    "num": "488",
    "desc": "\nResearch on women and leadership in selected content areas (e.g., business, education, politics and public service, and popular culture). Following an overview of quantitative and qualitative methods and critical analyses of journal articles on women and leadership, students work individually or in groups in selected content areas to write and present papers.\n",
    "credits": "3"
  },
  {
    "course_name": "Independent Study",
    "dept": "WGS",
    "num": "490",
    "desc": "Prereq: Any two courses in WGS\nIndependent study on a topic in Women's Studies.\n",
    "credits": "1"
  },
  {
    "course_name": "Internship",
    "dept": "WGS",
    "num": "491",
    "desc": "Prereq: Junior or Senior classification\nInternship designed to provide an application of Women's and Gender Studies principles and methods in a workplace. To be arranged with an internal or external employer and conducted under the supervision of a member of the Women's Studies faculty.\n",
    "credits": "1"
  },
  {
    "course_name": "Women/Gender in Art",
    "dept": "WGS",
    "num": "494",
    "desc": "\nIssues of gender related to cultural environments from the Middle Ages to contemporary times in Europe and America. Feminist movement beginning in the 1970s and specifically gender issues in art that are becoming widespread in the artistic culture.\n\nMeets U.S. Diversity Requirement\n",
    "credits": "3"
  },
  {
    "course_name": "Senior Thesis",
    "dept": "WGS",
    "num": "499",
    "desc": "Prereq: Senior classification\nSenior thesis to be independently researched and written under the supervision of a member of the Women's Studies faculty.\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Feminist Theories",
    "dept": "WGS",
    "num": "501",
    "desc": "\nAdvanced study of current theoretical developments in Women's Studies in the U.S. and around the world. Examination of the epistemological bases of feminist scholarship.\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Seminar in Feminist Research Methods",
    "dept": "WGS",
    "num": "502",
    "desc": "\nFocus on feminist interdisciplinary research methods. Analysis of contemporary issues facing feminist scholars. Students conduct original research.\n",
    "credits": "3"
  },
  {
    "course_name": "Intersections of Race, Class and Gender",
    "dept": "WGS",
    "num": "525",
    "desc": "Prereq: WGS 201 and one additional WGS course\nRace, ethnicity, class and gender distinctions and intersections lead to inequitable distributions of power, social well-being, and resources. Explores how inequities are institutionalized and how multiple identities are experienced by women in daily life.\n",
    "credits": "3"
  },
  {
    "course_name": "Gender, Globalization and Development",
    "dept": "WGS",
    "num": "535",
    "desc": "Prereq: WGS 301\nCross-cultural study of historical and contemporary dimensions of gender, globalization and development.  Explores the interdependence of socio-economic and political aspects of globalization using feminist postcolonial and transnational frameworks. Analyses of case studies and activism in contexts of economic livelihoods, environmental justice, and cross-border migrations.\n",
    "credits": "3"
  },
  {
    "course_name": "Sex and Gender in Cross-cultural Perspective",
    "dept": "WGS",
    "num": "544",
    "desc": "Prereq: ANTHR 201; ANTHR 306 recommended\nCross-cultural examination of the social construction of genders out of the biological fact of sex. Emphasis on non-western societies. Topics, presented through examination of ethnographic data, will include the range of gender variation, status and roles, the institution of marriage, and symbols of gender valuation.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Women's Literature",
    "dept": "WGS",
    "num": "545",
    "desc": "Prereq: Graduate classification or 6 credits in literature at 300 level or above\nPrimary texts by women writers; historical, thematic, formal, or theoretical approaches; secondary readings; e.g., Nineteenth-Century Women Writers; American Women's Personal Narratives; Southern Women Writers of the U.S.\n",
    "credits": "3"
  },
  {
    "course_name": "Readings Seminar in Women's History and Feminist Theory",
    "dept": "WGS",
    "num": "586",
    "desc": "Prereq: Permission of instructor\nFeminism as a movement and feminst theory from the early modern period to the present as it relates to the writing of women's history.  Analysis of intepretations of European and U.S. women's history from patriarchal and postmodernist perspectives.\n",
    "credits": "3"
  },
  {
    "course_name": "Special Topics",
    "dept": "WGS",
    "num": "590",
    "desc": "Prereq: Permission of Women's and Gender Studies Program Director\nIndependent study on a topic in Women's Studies.\n",
    "credits": "arr"
  },
  {
    "course_name": "Women/Gender in Art",
    "dept": "WGS",
    "num": "594",
    "desc": "Prereq: Graduate classification or permission of instructor\nIssues of gender related to cultural environments from the Middle Ages to contemporary times in Europe and America.  Feminist movement beginning in the 1970s and specifically gender issues in art that are becoming widespread in the artistic culture.\n",
    "credits": "3"
  },
  {
    "course_name": "Pedagogies of Dissent",
    "dept": "WGS",
    "num": "621",
    "desc": "Prereq: EL PS 620\nCritical examination of the philosophical foundations of education that seek to challenge the status quo and advance radical educational change.  Exploration of macro-level (and some micro-level) issues relevant to educational change, in relation to how they inform practices of dissent and every day social relations.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Swahili",
    "dept": "WLC",
    "num": "107",
    "desc": "Prereq: None\nBasics of grammar and vocabulary within the context of the cultures where Swahili is spoken.  For students whose native language is not Swahili. Taught in Swahili. Offered on-line.\n  No",
    "credits": "1"
  },
  {
    "course_name": "Introduction to World Languages",
    "dept": "WLC",
    "num": "119",
    "desc": "\nStudy of language diversity and the personal, social and political effects of diversity. Language families, attitudes toward language and language use, language and culture, multilingualism, foreign language learning, written codes, official languages, and language policy.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Cultures in Transition",
    "dept": "WLC",
    "num": "270",
    "desc": "\nAn interdisciplinary introduction to a world region in a state of rapid social and cultural transition. Discussion of the history, social and political institutions, arts, economy, agriculture, and environment of the new nations.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Introduction to Global Film",
    "dept": "WLC",
    "num": "278",
    "desc": "\nIntroduction to the cinema of non-English speaking regions and cultures of the world through representative subtitled films, lectures, and readings. Topics vary according to faculty interest. Emphasis on selected national cinemas and film as a mode of cultural expression as well as on diverse cultural contexts of cinema.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in World Languages and Cultures in English Translation",
    "dept": "WLC",
    "num": "370",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women's writing, cinema, or cultural studies of a non-English speaking world culture or cultures. Readings, discussion, and written work in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in World Languages and Cultures in English Translation: Global Sustainability",
    "dept": "WLC",
    "num": "370A",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women's writing, cinema, or cultural studies of a non-English speaking world culture or cultures. Readings, discussion, and written work in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in World Languages and Cultures in English Translation: Middle East",
    "dept": "WLC",
    "num": "370B",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women's writing, cinema, or cultural studies of a non-English speaking world culture or cultures. Readings, discussion, and written work in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Topics in World Languages and Cultures in English Translation: Global Urban Cultures",
    "dept": "WLC",
    "num": "370C",
    "desc": "\nTopics vary according to faculty interest. Author, genre or period study, women's writing, cinema, or cultural studies of a non-English speaking world culture or cultures. Readings, discussion, and written work in English.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Student Teaching",
    "dept": "WLC",
    "num": "417",
    "desc": "Prereq: minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in the liberal arts and sciences.\n",
    "credits": "8"
  },
  {
    "course_name": "Student Teaching: World Language",
    "dept": "WLC",
    "num": "417G",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in world languages, secondary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Technology, Globalization and Culture",
    "dept": "WLC",
    "num": "484",
    "desc": "Prereq: junior or senior classification for M E 484; graduate classification for M E 584\nCross-disciplinary examination of the present and future impact of globalization with a focus on preparing students for leadership roles in diverse professional, social, and cultural contexts.  Facilitate an understanding of the threats and opportunities inherent in the globalization process as they are perceived by practicing professionals and articulated in debates on globalization. Use of a digital forum for presenting and analyzing globalization issues by on-campus and off-campus specialists.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Elementary School World Language Instruction",
    "dept": "WLC",
    "num": "486",
    "desc": "Prereq: 25 credits in a world language\nPlanning, implementation, and assessment of standards-based, student-centered, and thematic instruction in the elementary (K-8) classroom.  Special emphasis on K-8 students' communicative skills, cultural knowledge, and content learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Methods in Secondary School World Language Instruction",
    "dept": "WLC",
    "num": "487",
    "desc": "Prereq: 25 credits in a world language, admission to the teacher education program, OPI\nTheories and principles of contemporary world language learning and teaching. Special emphasis on designing instruction and assessments for active learning.\n",
    "credits": "3"
  },
  {
    "course_name": "Experiences Abroad:  Learning to Think Globally",
    "dept": "WLC",
    "num": "491",
    "desc": "Prereq: Minimum of 3 cr. study abroad and/or internship abroad\nStudents returning from study abroad gain perspective on the personal, academic, and professional impact of their time spent abroad through readings and discussions. Students will be expected to make one presentation about the culture they experienced to an audience outside ISU.\n  Offered on a satisfactory-fail basis only.",
    "credits": "1"
  },
  {
    "course_name": "Student Teaching: World Language",
    "dept": "WLC",
    "num": "517G",
    "desc": "Prereq: Minimum GPA of 2.5; Admission to teacher education, approval of coordinator during semester before student teaching\nEvaluation of instruction, lesson planning, and teaching in world languages, secondary grades.\n",
    "credits": "arr"
  },
  {
    "course_name": "Technology, Globalization and Culture",
    "dept": "WLC",
    "num": "584",
    "desc": "Prereq: junior or senior classification for M E 484; graduate classification for M E 584\nCross-disciplinary examination of the present and future impact of globalization with a focus on preparing students for leadership roles in diverse professional, social, and cultural contexts.  Facilitate an understanding of the threats and opportunities inherent in the globalization process as they are perceived by practicing professionals and articulated in debates on globalization. Use of a digital forum for presenting and analyzing globalization issues by on-campus and off-campus specialists.\n\nMeets International Perspectives Requirement.\n",
    "credits": "3"
  },
  {
    "course_name": "Foundations of Youth Development",
    "dept": "YTH",
    "num": "501",
    "desc": "\nFundamentals of youth development and the youth development profession. Through this introduction to the field, students will explore the ethical, professional, and historical elements of youth development as it has evolved toward professionalization. (on-line course offering via Distance Education).\n",
    "credits": "1"
  },
  {
    "course_name": "Grant Development and Management",
    "dept": "YTH",
    "num": "508",
    "desc": "\nBasic Grant Development and Management will introduce students to the grant-getting process and provide an overview of what happens after a project is funded. The following topics will be covered: researching funding sources, generating cutting edge ideas, assessing needs, planning a project, establishing credibility, formulating a sustainable budget, designing an evaluation plan, managing the funded project, and disseminating project results. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Adolescents and Their Families",
    "dept": "YTH",
    "num": "510",
    "desc": "\nAdolescent development as it is related to and intertwined with family development; reciprocal influences between adolescents and their families are examined. Working with youth vis à vis the family system will be highlighted. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Community Youth Development",
    "dept": "YTH",
    "num": "520",
    "desc": "\nFocus on the national emphasis of a strength-based or asset approach to community youth development, encompassing individual development (i.e., positive youth development) and adolescent interrelationships with environments. Emphasis is placed upon research, theory, and practice applied in communities throughout the U.S. Students will explore existing models, read theoretical and applied literature, and examine current community efforts as a basis for understanding community youth development. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Youth in Cultural Contexts",
    "dept": "YTH",
    "num": "530",
    "desc": "\nExamination of the cultural context factors that affect youth from a holistic perspective within and outside the family unit. The course will provide an understanding of the cultural heritage of differing family structures and types. Students will explore the social and educational processes experienced by youth through in-depth reading, writing, discussion, critical listening, viewing of contemporary videos, and informal interviews with youth. Students will be encouraged to think critically about society and culture, gain further knowledge of how ethnic groups fit historically into society, and examine the results of how history has shaped the current cultural climate of the U.S. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Youth Professionals as Consumers of Research",
    "dept": "YTH",
    "num": "540",
    "desc": "\nThis course will help youth development professionals understand and evaluate research reports to reduce anxiety about applying research results and theories to practice. Specific emphasis will be on research and theory reports related to youth development. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Youth Policy",
    "dept": "YTH",
    "num": "550",
    "desc": "\nVarious federal and state policies designed specifically for youth. Students will examine how and why policies for youth are constructed. A guiding question that will be used to evaluate existing state and national policies is whether they contribute to, or act as, barriers to desired developmental outcomes. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Contemporary Youth Issues",
    "dept": "YTH",
    "num": "570",
    "desc": "\nIssues faced by youth today and associated risk and resiliency factors. A different topic will be presented each year, with the course rotating among participating universities. Past topics have included Youth Violence, Youth and Appearance, Adolescent Health, Global Perspectives and Volunteerism. The course may be taken more than once, as long as the content is different each time. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Administration and Program Management",
    "dept": "YTH",
    "num": "580",
    "desc": "\nThis course will introduce students to the development, administration and management of youth-serving organizations. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Program Design, Evaluation and Implementation",
    "dept": "YTH",
    "num": "585",
    "desc": "\nTheoretical, methodological, and pragmatic issues involved in conducting programs and scholarship. Overview of the program development process and outcome evaluation of children and family programs. Modes of outcome scholarship and their implications for community-based programs are discussed. Students will develop knowledge through participating in a community-based project involving the practical application of program design and evaluation methods. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Creative Component",
    "dept": "YTH",
    "num": "599",
    "desc": "\nNonthesis students creative component (e.g., a special report, capstone course, integrated field experience, annotated bibliography, research project, design, or other creative endeavor). A minimum of five credits of independent work is required on the programs of study (POS). Creative component format determined cooperation with the POS committee. (on-line course offering via Distance Education).\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  },
  {
    "course_name": "Youth Development",
    "dept": "YTH",
    "num": "634",
    "desc": "\nIntroduction to the developmental period of adolescence. The theory and research of positive youth development will be the lens through which this developmental period is examined. The course will emphasize how the developmental tasks of this life stage are influenced by (and influence) family and home, school, peers, and other contextual forces. The course will help students recognize and become familiar with the major issues and transitions adolescents face as they successfully navigate this developmental stage by critically examining the theoretical and research literature. (on-line course offering via Distance Education).\n",
    "credits": "3"
  },
  {
    "course_name": "Advanced Topics",
    "dept": "YTH",
    "num": "690",
    "desc": "Prereq: Permission of instructor.\nAdvanced topics. (on-line course offering via Distance Education).\n",
    "credits": "arr"
  },
  {
    "course_name": "Internship",
    "dept": "YTH",
    "num": "691",
    "desc": "Prereq: Permission of instructor.\nSupervised practice and experience in college teaching,  research, professional experience. On-line course offering via Distance Education.\n  Offered on a satisfactory-fail basis only.",
    "credits": "arr"
  }
]}
